// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"klemY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _root = require("./Root");
if (module.hot) module.hot.accept();
var rootContainer = document.getElementById("root");
var root = (0, _client.createRoot)(rootContainer);
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _root.Root), {}));

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","react-dom/client":"1Ib5O","./Root":"1pFrW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gJK5Y":[function(require,module,exports) {
"use strict";
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"7SajB"}],"7SajB":[function(require,module,exports) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"ktQNc"}],"ktQNc":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"ezwHw"}],"ezwHw":[function(require,module,exports) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function forEach(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"6Gp9n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_type_of", function() {
    return _type_of;
});
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lOeCi":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"1Ib5O":[function(require,module,exports) {
"use strict";
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"lyZO5"}],"lyZO5":[function(require,module,exports) {
"use strict";
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"2krTL"}],"2krTL":[function(require,module,exports) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c === "undefined" ? "undefined" : (0, _typeOf._)(c)));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function get() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function onError(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, _typeOf._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, _typeOf._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function persist() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function key(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var _$d = f, _$e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, _$d))) {
                    ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = _$d ? ue(_$d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = _$d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, _$e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = _$e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(_$d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) _$d = oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function Jf(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function useCallback(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        return Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function useState() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function useState() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function Aj() {};
Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a), ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = gl(g);
                f.call(_$a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = gl(k);
            h.call(_$a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = gl(g);
                h.call(_$a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function Hc() {
    return C;
};
Ic = function Ic(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function yb(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"@swc/helpers/_/_type_of":"6Gp9n","5393afc8c463ef07":"ktQNc","ece50e903283a22f":"5h5Rj"}],"5h5Rj":[function(require,module,exports) {
"use strict";
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"kxLMl"}],"kxLMl":[function(require,module,exports) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function S() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function S() {
        U.postMessage(null);
    };
} else S = function S() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"1pFrW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Root", function() {
    return Root;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _permafrost = require("@indico-data/permafrost");
var _indexCss = require("@indico-data/design-system/lib/index.css");
var _apolloClient = require("apollo-client");
var _apolloClientDefault = parcelHelpers.interopDefault(_apolloClient);
var _reactApollo = require("react-apollo");
var _apolloLink = require("apollo-link");
var _apolloLinkHttp = require("apollo-link-http");
var _apolloLinkRetry = require("apollo-link-retry");
var _apolloCacheInmemory = require("apollo-cache-inmemory");
var _userContext = require("./store/userContext");
var _userContextDefault = parcelHelpers.interopDefault(_userContext);
var _transformedFragmentTypesJson = require("./transformedFragmentTypes.json");
var _transformedFragmentTypesJsonDefault = parcelHelpers.interopDefault(_transformedFragmentTypesJson);
var _utils = require("@indico-data/utils");
var _appContainer = require("./AppContainer");
var _styledComponents = require("styled-components");
var fragmentMatcher = new (0, _apolloCacheInmemory.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (0, _transformedFragmentTypesJsonDefault.default)
});
var link = (0, _apolloLink.ApolloLink).from([
    new (0, _apolloLinkRetry.RetryLink)(),
    new (0, _apolloLinkHttp.HttpLink)({
        uri: "".concat(window.indico.appURLs.FogURL, "/api/graphql"),
        credentials: "include"
    })
]);
var cache = new (0, _apolloCacheInmemory.InMemoryCache)({
    fragmentMatcher: fragmentMatcher
});
var client = new (0, _apolloClientDefault.default)({
    link: link,
    cache: cache
});
var Root = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), completedFetchFeatureConfigs = _useState[0], setCompletedFetchFeatureConfigs = _useState[1];
    (0, _react.useEffect)(function() {
        function fetchAndSetFeatureConfigs() {
            return _fetchAndSetFeatureConfigs.apply(this, arguments);
        }
        function _fetchAndSetFeatureConfigs() {
            _fetchAndSetFeatureConfigs = (0, _asyncToGenerator._)(function() {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetch("".concat((0, _utils.envUtils).getApiHost(), "/feature_config.json")).then(function(response) {
                                    if (!response.ok) throw new Error("HTTP error " + response.status);
                                    return response.json();
                                }).then(function(json) {
                                    var features = json.features;
                                    window.indico.featuresConfig = (0, _objectSpread._)({}, window.indico.featuresConfig, features);
                                    console.info("feature_config.json fetched successfully");
                                }).catch(function(err) {
                                    console.error("Error fetching feature_config.json", err);
                                }).finally(function() {
                                    setCompletedFetchFeatureConfigs(true);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchAndSetFeatureConfigs.apply(this, arguments);
        }
        fetchAndSetFeatureConfigs();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "theme",
        "data-theme": "dark",
        id: "theme-root",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.GlobalStyles), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledComponents.StyleSheetManager), {
                enableVendorPrefixes: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userContextDefault.default).Provider, {
                    value: (0, _react.useReducer)((0, _userContext.UserReducer), (0, _userContext.UserContextState)),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApollo.ApolloProvider), {
                        client: client,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "app-root",
                            style: {
                                height: "100%"
                            },
                            children: completedFetchFeatureConfigs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appContainer.AppContainer), {}) : null
                        })
                    })
                })
            })
        ]
    });
};

},{"@swc/helpers/_/_async_to_generator":"5F0bU","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_ts_generator":"HrSs8","react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/permafrost":"j9IVt","@indico-data/design-system/lib/index.css":"8y6h4","apollo-client":"lgvsE","react-apollo":"fOSWr","apollo-link":"hbph2","apollo-link-http":"bpqm8","apollo-link-retry":"7nx77","apollo-cache-inmemory":"jJw1o","./store/userContext":"fgLOo","./transformedFragmentTypes.json":"cY0Es","@indico-data/utils":"47VRj","./AppContainer":"bEw7j","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5F0bU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_async_to_generator", function() {
    return _async_to_generator;
});
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6U9Ts":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_spread", function() {
    return _object_spread;
});
parcelHelpers.export(exports, "_", function() {
    return _object_spread;
});
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._define_property)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"gSu9o","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gSu9o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_define_property", function() {
    return _define_property;
});
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gML59":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_sliced_to_array", function() {
    return _sliced_to_array;
});
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._array_with_holes)(arr) || (0, _iterableToArrayLimitJs._iterable_to_array_limit)(arr, i) || (0, _unsupportedIterableToArrayJs._unsupported_iterable_to_array)(arr, i) || (0, _nonIterableRestJs._non_iterable_rest)();
}

},{"./_array_with_holes.js":"iTqyu","./_iterable_to_array_limit.js":"dtPmk","./_non_iterable_rest.js":"cPzXv","./_unsupported_iterable_to_array.js":"Ccmcf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iTqyu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_array_with_holes", function() {
    return _array_with_holes;
});
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dtPmk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_iterable_to_array_limit", function() {
    return _iterable_to_array_limit;
});
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cPzXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_non_iterable_rest", function() {
    return _non_iterable_rest;
});
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Ccmcf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_unsupported_iterable_to_array", function() {
    return _unsupported_iterable_to_array;
});
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._array_like_to_array)(o, minLen);
}

},{"./_array_like_to_array.js":"d20Yt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d20Yt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_array_like_to_array", function() {
    return _array_like_to_array;
});
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"HrSs8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
parcelHelpers.export(exports, "_ts_generator", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"eUtpo","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eUtpo":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j9IVt":[function(require,module,exports) {
// Storybook Helpers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storyTitle", function() {
    return 0, _storyTitle.storyTitle;
});
parcelHelpers.export(exports, "GlobalStyles", function() {
    return 0, _globals.GlobalStyles;
});
parcelHelpers.export(exports, "colorProperties", function() {
    return 0, _colorProperties.colorProperties;
}) ///// UI Foundations
;
// Icons
parcelHelpers.export(exports, "faIcons", function() {
    return 0, _faIcons.faIcons;
});
parcelHelpers.export(exports, "indicons", function() {
    return 0, _indicons.indicons;
});
parcelHelpers.export(exports, "partnerIcons", function() {
    return 0, _partnerIcons.partnerIcons;
}) // Buttons
;
parcelHelpers.export(exports, "Button", function() {
    return 0, _button.Button;
});
parcelHelpers.export(exports, "ControlButton", function() {
    return 0, _controlButton.ControlButton;
});
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return 0, _controlButton.controlButtonSpacing;
});
parcelHelpers.export(exports, "GenerateReport", function() {
    return 0, _generateReport.GenerateReport;
});
parcelHelpers.export(exports, "IconButton", function() {
    return 0, _iconButton.IconButton;
});
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return 0, _segmentedControlButtons.SegmentedControlButtons;
}) // Navigation
;
parcelHelpers.export(exports, "BackToLink", function() {
    return 0, _backToLink.BackToLink;
}) // Dropdowns
;
parcelHelpers.export(exports, "MultiCombobox", function() {
    return 0, _dropdowns.MultiCombobox;
});
parcelHelpers.export(exports, "useCombobox", function() {
    return 0, _dropdowns.useCombobox;
});
parcelHelpers.export(exports, "BorderSelect", function() {
    return 0, _dropdowns.BorderSelect;
});
parcelHelpers.export(exports, "Select", function() {
    return 0, _dropdowns.Select;
});
parcelHelpers.export(exports, "SingleCombobox", function() {
    return 0, _dropdowns.SingleCombobox;
});
parcelHelpers.export(exports, "Filter", function() {
    return 0, _dropdowns.Filter;
});
parcelHelpers.export(exports, "FilterSelect", function() {
    return 0, _dropdowns.FilterSelect;
}) // Fields
;
parcelHelpers.export(exports, "EditableField", function() {
    return 0, _editableField.EditableField;
});
parcelHelpers.export(exports, "NumberField", function() {
    return 0, _numberField.NumberField;
});
parcelHelpers.export(exports, "NumberFieldV2", function() {
    return 0, _numberField1.NumberField;
});
parcelHelpers.export(exports, "SearchField", function() {
    return 0, _searchField.SearchField;
});
parcelHelpers.export(exports, "TextField", function() {
    return 0, _textField.TextField;
}) // Interactive Controls
;
parcelHelpers.export(exports, "Card", function() {
    return 0, _card.Card;
});
parcelHelpers.export(exports, "CardContainer", function() {
    return 0, _cardContainer.CardContainer;
});
parcelHelpers.export(exports, "Checkbox", function() {
    return 0, _checkbox.Checkbox;
});
parcelHelpers.export(exports, "DatePicker", function() {
    return 0, _datePicker.DatePicker;
});
parcelHelpers.export(exports, "DateRangePicker", function() {
    return 0, _dateRangePicker.DateRangePicker;
}) // export { Flipper } from './components/ui-foundations/interactive-controls/Flipper/Flipper';
;
parcelHelpers.export(exports, "KabobMenu", function() {
    return 0, _kabobMenu.KabobMenu;
});
parcelHelpers.export(exports, "MenuButton", function() {
    return 0, _menuButton.MenuButton;
}) // export {
;
//   Radio,
//   RadioGroup,
// } from './components/ui-foundations/interactive-controls/RadioButtons/RadioButtons';
parcelHelpers.export(exports, "PillCheckGroup", function() {
    return 0, _pillCheckGroup.PillCheckGroup;
});
parcelHelpers.export(exports, "StyledToggle", function() {
    return 0, _toggleStyles.StyledToggle;
});
parcelHelpers.export(exports, "Toggle", function() {
    return 0, _toggle.Toggle;
});
parcelHelpers.export(exports, "Tag", function() {
    return 0, _tag.Tag;
});
parcelHelpers.export(exports, "ValidationText", function() {
    return 0, _validationText.ValidationText;
}) // Status Indicators
;
parcelHelpers.export(exports, "BarSpinner", function() {
    return 0, _barSpinner.BarSpinner;
});
parcelHelpers.export(exports, "LoadingIndicator", function() {
    return 0, _loadingIndicator.LoadingIndicator;
});
parcelHelpers.export(exports, "LoadingList", function() {
    return 0, _loadingList.LoadingList;
});
parcelHelpers.export(exports, "LoadingSpinner", function() {
    return 0, _loadingSpinner.LoadingSpinner;
});
parcelHelpers.export(exports, "PercentageRing", function() {
    return 0, _percentageRing.PercentageRing;
});
parcelHelpers.export(exports, "ProgressBar", function() {
    return 0, _progressBar.ProgressBar;
});
parcelHelpers.export(exports, "RandomLoadingMessage", function() {
    return 0, _randomLoadingMessage.RandomLoadingMessage;
});
parcelHelpers.export(exports, "StyledProgressBar", function() {
    return 0, _progressBarStyles.StyledProgressBar;
});
parcelHelpers.export(exports, "AppCrash", function() {
    return 0, _appCrash.AppCrash;
});
parcelHelpers.export(exports, "ConfirmModal", function() {
    return 0, _confirmModal.ConfirmModal;
});
parcelHelpers.export(exports, "ContentModal", function() {
    return 0, _contentModal.ContentModal;
});
parcelHelpers.export(exports, "FailSnail", function() {
    return 0, _failSnail.FailSnail;
});
parcelHelpers.export(exports, "Shrug", function() {
    return 0, _shrug.Shrug;
});
parcelHelpers.export(exports, "Toast", function() {
    return 0, _toast.Toast;
});
parcelHelpers.export(exports, "Tooltip", function() {
    return 0, _tooltip.Tooltip;
});
parcelHelpers.export(exports, "Flag", function() {
    return 0, _flag.Flag;
}) // Basic Section
;
parcelHelpers.export(exports, "Section", function() {
    return 0, _section.Section;
});
parcelHelpers.export(exports, "SectionBody", function() {
    return 0, _sectionBody.SectionBody;
});
parcelHelpers.export(exports, "SectionHeader", function() {
    return 0, _sectionHeader.SectionHeader;
});
parcelHelpers.export(exports, "SectionBlock", function() {
    return 0, _sectionBlock.SectionBlock;
});
parcelHelpers.export(exports, "SectionTable", function() {
    return 0, _sectionTable.SectionTable;
}) // Cards
;
parcelHelpers.export(exports, "WidgetCard", function() {
    return 0, _widgetCard.WidgetCard;
}) // Datavis
;
parcelHelpers.export(exports, "WidgetCardContent", function() {
    return 0, _widgetCard.WidgetCardContent;
});
parcelHelpers.export(exports, "WidgetCardHeader", function() {
    return 0, _widgetCard.WidgetCardHeader;
});
parcelHelpers.export(exports, "ChartContextMenu", function() {
    return 0, _chartContextMenu.ChartContextMenu;
});
parcelHelpers.export(exports, "ChartToolTip", function() {
    return 0, _chartToolTip.ChartToolTip;
});
parcelHelpers.export(exports, "Matrix", function() {
    return 0, _matrix.Matrix;
});
parcelHelpers.export(exports, "Bar", function() {
    return 0, _barDefault.default;
});
parcelHelpers.export(exports, "Circle", function() {
    return 0, _circle.Circle;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _line.Line;
});
parcelHelpers.export(exports, "HorizontalBarChart", function() {
    return 0, _horizontalBarChart.HorizontalBarChart;
});
parcelHelpers.export(exports, "Accordion", function() {
    return 0, _accordion.Accordion;
});
parcelHelpers.export(exports, "DragDropList", function() {
    return 0, _dragDropList.DragDropList;
});
parcelHelpers.export(exports, "OldDragDropList", function() {
    return 0, _oldDragDropList.OldDragDropList;
});
parcelHelpers.export(exports, "Icon", function() {
    return 0, _icon.Icon;
});
parcelHelpers.export(exports, "HeaderValues", function() {
    return 0, _headerValues.HeaderValues;
});
parcelHelpers.export(exports, "ListTable", function() {
    return 0, _listTable.ListTable;
});
parcelHelpers.export(exports, "LoadingAwareContainer", function() {
    return 0, _loadingAwareContainer.LoadingAwareContainer;
});
parcelHelpers.export(exports, "Logo", function() {
    return 0, _logo.Logo;
});
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _pagination.Pagination;
});
parcelHelpers.export(exports, "PaginationWithoutQuery", function() {
    return 0, _paginationWithoutQuery.PaginationWithoutQuery;
});
parcelHelpers.export(exports, "ReorderableList", function() {
    return 0, _reorderableList.ReorderableList;
});
parcelHelpers.export(exports, "ListControls", function() {
    return 0, _reorderableList.ListControls;
});
parcelHelpers.export(exports, "useListItem", function() {
    return 0, _reorderableList.useListItem;
});
parcelHelpers.export(exports, "useListControls", function() {
    return 0, _reorderableList.useListControls;
});
parcelHelpers.export(exports, "SaveCancel", function() {
    return 0, _saveCancel.SaveCancel;
});
parcelHelpers.export(exports, "StyledSaveCancel", function() {
    return 0, _saveCancelStyles.StyledSaveCancel;
});
parcelHelpers.export(exports, "TabbedContainer", function() {
    return 0, _tabbedContainer.TabbedContainer;
});
parcelHelpers.export(exports, "TabNavigation", function() {
    return 0, _tabNavigation.TabNavigation;
});
parcelHelpers.export(exports, "Table", function() {
    return 0, _table.Table;
});
parcelHelpers.export(exports, "TeamTable", function() {
    return 0, _teamTable.TeamTable;
});
parcelHelpers.export(exports, "Wizard", function() {
    return 0, _wizard.Wizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return 0, _wizard.WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return 0, _wizard.WizardSection;
});
parcelHelpers.export(exports, "StyledWizard", function() {
    return 0, _wizard.StyledWizard;
});
parcelHelpers.export(exports, "DragDropVerticalList", function() {
    return 0, _dragDropVerticalList.DragDropVerticalList;
});
parcelHelpers.export(exports, "ModalBase", function() {
    return 0, _modalBase.ModalBase;
});
parcelHelpers.export(exports, "AbstractRadio", function() {
    return 0, _radioGroup.Radio;
});
parcelHelpers.export(exports, "AbstractRadioGroup", function() {
    return 0, _radioGroup.RadioGroup;
});
parcelHelpers.export(exports, "TabbedInterface", function() {
    return 0, _tabbedInterface.TabbedInterface;
});
parcelHelpers.export(exports, "CopyableFilename", function() {
    return 0, _copyableFilename.CopyableFilename;
});
parcelHelpers.export(exports, "CopyableSelect", function() {
    return 0, _copyableSelect.CopyableSelect;
});
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return 0, _dateTimeDisplay.DateTimeDisplay;
}) // todo
;
parcelHelpers.export(exports, "AppTitle", function() {
    return 0, _appTitle.AppTitle;
}) // Form Controls
;
parcelHelpers.export(exports, "Radio", function() {
    return 0, _radioButtons.Radio;
});
parcelHelpers.export(exports, "RadioGroup", function() {
    return 0, _radioButtons.RadioGroup;
});
parcelHelpers.export(exports, "Flipper", function() {
    return 0, _flipper.Flipper;
});
parcelHelpers.export(exports, "partialTextStyles", function() {
    return _text;
});
var _storyTitle = require("./storybook-helpers/storyTitle");
// Component System Modules
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _globals = require("./styles/globals");
var _text = require("./styles/partials/text");
var _colorProperties = require("./styles/globals/color-properties");
var _faIcons = require("./components/ui-foundations/Icon/faIcons");
var _indicons = require("./components/ui-foundations/Icon/indicons");
var _partnerIcons = require("./components/ui-foundations/Icon/partnerIcons");
var _button = require("./components/ui-foundations/buttons/Button/Button");
var _controlButton = require("./components/ui-foundations/buttons/ControlButton");
var _generateReport = require("./components/ui-foundations/buttons/GenerateReport/GenerateReport");
var _iconButton = require("./components/ui-foundations/buttons/IconButton/IconButton");
var _segmentedControlButtons = require("./components/ui-foundations/buttons/SegmentedControlButtons");
var _backToLink = require("./components/ui-foundations/navigation/BackToLink");
var _dropdowns = require("./components/ui-foundations/dropdowns");
var _editableField = require("./components/ui-foundations/fields/EditableField/EditableField");
var _numberField = require("./components/ui-foundations/fields/NumberField/NumberField");
var _numberField1 = require("./components/ui-foundations/fields/NumberFieldV2/NumberField");
var _searchField = require("./components/ui-foundations/fields/SearchField/SearchField");
var _textField = require("./components/ui-foundations/fields/TextField/TextField");
var _card = require("./components/ui-foundations/cards/Card/Card");
var _cardContainer = require("./components/ui-foundations/cards/CardContainer");
var _checkbox = require("./components/ui-foundations/interactive-controls/Checkbox/Checkbox");
var _datePicker = require("./components/ui-foundations/interactive-controls/DatePicker/DatePicker");
var _dateRangePicker = require("./components/ui-foundations/interactive-controls/DateRangePicker/DateRangePicker");
var _kabobMenu = require("./components/ui-foundations/interactive-controls/KabobMenu/KabobMenu");
var _menuButton = require("./components/ui-foundations/interactive-controls/MenuButton/MenuButton");
var _pillCheckGroup = require("./components/ui-foundations/interactive-controls/PillCheckGroup");
var _toggleStyles = require("./components/ui-foundations/interactive-controls/Toggle/Toggle.styles");
var _toggle = require("./components/ui-foundations/interactive-controls/Toggle/Toggle");
var _tag = require("./components/ui-foundations/interactive-controls/Tag/Tag");
var _validationText = require("./components/ui-foundations/interactive-controls/ValidationText/ValidationText");
var _barSpinner = require("./components/ui-foundations/status-indicators/BarSpinner/BarSpinner");
var _loadingIndicator = require("./components/ui-foundations/status-indicators/LoadingIndicator/LoadingIndicator");
var _loadingList = require("./components/ui-foundations/status-indicators/LoadingList/LoadingList");
var _loadingSpinner = require("./components/ui-foundations/status-indicators/LoadingSpinner/LoadingSpinner");
var _percentageRing = require("./components/ui-foundations/status-indicators/PercentageRing/PercentageRing");
var _progressBar = require("./components/ui-foundations/status-indicators/ProgressBar/ProgressBar");
var _randomLoadingMessage = require("./components/ui-foundations/status-indicators/RandomLoadingMessage/RandomLoadingMessage");
var _progressBarStyles = require("./components/ui-foundations/status-indicators/ProgressBar/ProgressBar.styles");
var _appCrash = require("./components/ui-foundations/user-feedback/AppCrash/AppCrash");
var _confirmModal = require("./components/ui-foundations/user-feedback/ConfirmModal/ConfirmModal");
var _contentModal = require("./components/ui-foundations/user-feedback/ContentModal/ContentModal");
var _failSnail = require("./components/ui-foundations/user-feedback/FailSnail/FailSnail");
var _shrug = require("./components/ui-foundations/user-feedback/Shrug/Shrug");
var _toast = require("./components/ui-foundations/user-feedback/Toast/Toast");
var _tooltip = require("./components/ui-foundations/user-feedback/Tooltip/Tooltip");
var _flag = require("./components/ui-foundations/user-feedback/Flag/Flag");
var _section = require("./components/ui-foundations/basic-section/Section/Section");
var _sectionBody = require("./components/ui-foundations/basic-section/SectionBody/SectionBody");
var _sectionHeader = require("./components/ui-foundations/basic-section/SectionHeader/SectionHeader");
var _sectionBlock = require("./components/ui-foundations/basic-section/SectionBlock/SectionBlock");
var _sectionTable = require("./components/ui-foundations/basic-section/SectionTable/SectionTable");
var _widgetCard = require("./components/ui-foundations/cards/WidgetCard/WidgetCard");
var _chartContextMenu = require("./components/ui-foundations/datavis/ChartContextMenu/ChartContextMenu");
var _chartToolTip = require("./components/ui-foundations/datavis/ChartToolTip/ChartToolTip");
var _matrix = require("./components/ui-foundations/datavis/Matrix/Matrix");
var _bar = require("./components/ui-foundations/datavis/d3/Bar/Bar");
var _barDefault = parcelHelpers.interopDefault(_bar);
var _circle = require("./components/ui-foundations/datavis/d3/Circle/Circle");
var _line = require("./components/ui-foundations/datavis/d3/Line/Line");
var _horizontalBarChart = require("./components/ui-foundations/datavis/HorizontalBarChart/HorizontalBarChart");
var _accordion = require("./components/ui-foundations/Accordion/Accordion");
var _dragDropList = require("./components/ui-foundations/drag-n-drop/DragDropList/DragDropList");
var _oldDragDropList = require("./components/ui-foundations/drag-n-drop/OldDragDropList/OldDragDropList");
var _icon = require("./components/ui-foundations/Icon/Icon");
var _headerValues = require("./components/ui-foundations/HeaderValues");
var _listTable = require("./components/ui-foundations/ListTable");
var _loadingAwareContainer = require("./components/ui-foundations/LoadingAwareContainer/LoadingAwareContainer");
var _logo = require("./components/ui-foundations/Logo/Logo");
var _pagination = require("./components/ui-foundations/pagination-components/Pagination/Pagination");
var _paginationWithoutQuery = require("./components/ui-foundations/pagination-components/PaginationWithoutQuery/PaginationWithoutQuery");
var _reorderableList = require("./components/ui-foundations/ReorderableList");
var _saveCancel = require("./components/ui-foundations/SaveCancel/SaveCancel");
var _saveCancelStyles = require("./components/ui-foundations/SaveCancel/SaveCancel.styles");
var _tabbedContainer = require("./components/ui-foundations/TabbedContainer/TabbedContainer");
var _tabNavigation = require("./components/ui-foundations/TabNavigation/TabNavigation");
var _table = require("./components/ui-foundations/Table/Table");
var _teamTable = require("./components/ui-foundations/TeamTable/TeamTable");
var _wizard = require("./components/ui-foundations/Wizard");
var _dragDropVerticalList = require("./components/utility-components/DragDropVerticalList/DragDropVerticalList");
var _modalBase = require("./components/utility-components/ModalBase/ModalBase");
var _radioGroup = require("./components/utility-components/RadioGroup/RadioGroup");
var _tabbedInterface = require("./components/utility-components/TabbedInterface/TabbedInterface");
var _copyableFilename = require("./components/utility-components/CopyableFilename");
var _copyableSelect = require("./components/ui-foundations/dropdowns/CopyableSelect");
var _dateTimeDisplay = require("./components/utility-components/text-utilities/DateTimeDisplay");
var _appTitle = require("./components/chrome/AppTitle/AppTitle");
var _radioButtons = require("./components/form-controls/RadioButtons/RadioButtons");
var _flipper = require("./components/form-controls/Flipper/Flipper");

},{"./storybook-helpers/storyTitle":"4wrI1","./constants":"g2nxL","./styles/globals":"dK3QT","./styles/partials/text":"6IUjL","./styles/globals/color-properties":"jMbJk","./components/ui-foundations/Icon/faIcons":"2E3tr","./components/ui-foundations/Icon/indicons":"i9WOp","./components/ui-foundations/Icon/partnerIcons":"iKD0d","./components/ui-foundations/buttons/Button/Button":"7Q7WR","./components/ui-foundations/buttons/ControlButton":"kqxGP","./components/ui-foundations/buttons/GenerateReport/GenerateReport":"9khdd","./components/ui-foundations/buttons/IconButton/IconButton":"9ht8K","./components/ui-foundations/buttons/SegmentedControlButtons":"fbUkS","./components/ui-foundations/navigation/BackToLink":"fjcVP","./components/ui-foundations/dropdowns":"46Vgf","./components/ui-foundations/fields/EditableField/EditableField":"9V0Ho","./components/ui-foundations/fields/NumberField/NumberField":"86byk","./components/ui-foundations/fields/NumberFieldV2/NumberField":"lhEqK","./components/ui-foundations/fields/SearchField/SearchField":"SZt4o","./components/ui-foundations/fields/TextField/TextField":"b0cuG","./components/ui-foundations/cards/Card/Card":"406kD","./components/ui-foundations/cards/CardContainer":"7RdtM","./components/ui-foundations/interactive-controls/Checkbox/Checkbox":"aNY4G","./components/ui-foundations/interactive-controls/DatePicker/DatePicker":"q3i4H","./components/ui-foundations/interactive-controls/DateRangePicker/DateRangePicker":"4LkT8","./components/ui-foundations/interactive-controls/KabobMenu/KabobMenu":"hQNZ7","./components/ui-foundations/interactive-controls/MenuButton/MenuButton":"ioQYm","./components/ui-foundations/interactive-controls/PillCheckGroup":"kLpCO","./components/ui-foundations/interactive-controls/Toggle/Toggle.styles":"i89pr","./components/ui-foundations/interactive-controls/Toggle/Toggle":"aE1RJ","./components/ui-foundations/interactive-controls/Tag/Tag":"dxu7u","./components/ui-foundations/interactive-controls/ValidationText/ValidationText":"3HvRX","./components/ui-foundations/status-indicators/BarSpinner/BarSpinner":"bulCm","./components/ui-foundations/status-indicators/LoadingIndicator/LoadingIndicator":"7pZ91","./components/ui-foundations/status-indicators/LoadingList/LoadingList":"jnVwv","./components/ui-foundations/status-indicators/LoadingSpinner/LoadingSpinner":"g838E","./components/ui-foundations/status-indicators/PercentageRing/PercentageRing":"hY5JT","./components/ui-foundations/status-indicators/ProgressBar/ProgressBar":"c8T3M","./components/ui-foundations/status-indicators/RandomLoadingMessage/RandomLoadingMessage":"eVkf8","./components/ui-foundations/status-indicators/ProgressBar/ProgressBar.styles":"lDTHQ","./components/ui-foundations/user-feedback/AppCrash/AppCrash":"7E1rB","./components/ui-foundations/user-feedback/ConfirmModal/ConfirmModal":"kK4OR","./components/ui-foundations/user-feedback/ContentModal/ContentModal":"jv0OH","./components/ui-foundations/user-feedback/FailSnail/FailSnail":"dqTW8","./components/ui-foundations/user-feedback/Shrug/Shrug":"eZbVg","./components/ui-foundations/user-feedback/Toast/Toast":"fHUif","./components/ui-foundations/user-feedback/Tooltip/Tooltip":"frFr7","./components/ui-foundations/user-feedback/Flag/Flag":"j07ab","./components/ui-foundations/basic-section/Section/Section":"60q8g","./components/ui-foundations/basic-section/SectionBody/SectionBody":"6KdzU","./components/ui-foundations/basic-section/SectionHeader/SectionHeader":"deeNM","./components/ui-foundations/basic-section/SectionBlock/SectionBlock":"cYfyY","./components/ui-foundations/basic-section/SectionTable/SectionTable":"1C3yO","./components/ui-foundations/cards/WidgetCard/WidgetCard":"cxXo5","./components/ui-foundations/datavis/ChartContextMenu/ChartContextMenu":"gxv2p","./components/ui-foundations/datavis/ChartToolTip/ChartToolTip":"j4UCH","./components/ui-foundations/datavis/Matrix/Matrix":"9dhwA","./components/ui-foundations/datavis/d3/Bar/Bar":"fz2Lw","./components/ui-foundations/datavis/d3/Circle/Circle":"6PIUy","./components/ui-foundations/datavis/d3/Line/Line":"e1f0D","./components/ui-foundations/datavis/HorizontalBarChart/HorizontalBarChart":"hfWTr","./components/ui-foundations/Accordion/Accordion":"ck1dH","./components/ui-foundations/drag-n-drop/DragDropList/DragDropList":"Y9tlW","./components/ui-foundations/drag-n-drop/OldDragDropList/OldDragDropList":"5u3cl","./components/ui-foundations/Icon/Icon":"ad563","./components/ui-foundations/HeaderValues":"9Y645","./components/ui-foundations/ListTable":"dVujS","./components/ui-foundations/LoadingAwareContainer/LoadingAwareContainer":"fva6N","./components/ui-foundations/Logo/Logo":"iGXXw","./components/ui-foundations/pagination-components/Pagination/Pagination":"iZ9bE","./components/ui-foundations/pagination-components/PaginationWithoutQuery/PaginationWithoutQuery":"jjBSG","./components/ui-foundations/ReorderableList":"1vfn9","./components/ui-foundations/SaveCancel/SaveCancel":"ewBkF","./components/ui-foundations/SaveCancel/SaveCancel.styles":"6L5DB","./components/ui-foundations/TabbedContainer/TabbedContainer":"4rHF0","./components/ui-foundations/TabNavigation/TabNavigation":"hMYpZ","./components/ui-foundations/Table/Table":"fv8Kb","./components/ui-foundations/TeamTable/TeamTable":"lS52L","./components/ui-foundations/Wizard":"6GeRo","./components/utility-components/DragDropVerticalList/DragDropVerticalList":"knQD3","./components/utility-components/ModalBase/ModalBase":"guZ18","./components/utility-components/RadioGroup/RadioGroup":"ekzIh","./components/utility-components/TabbedInterface/TabbedInterface":"GkAW8","./components/utility-components/CopyableFilename":"3IxgU","./components/ui-foundations/dropdowns/CopyableSelect":"7ecpr","./components/utility-components/text-utilities/DateTimeDisplay":"8gV0Z","./components/chrome/AppTitle/AppTitle":"5Wpyp","./components/form-controls/RadioButtons/RadioButtons":"bsvMl","./components/form-controls/Flipper/Flipper":"3OYyz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4wrI1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storyTitle", function() {
    return storyTitle;
});
function storyTitle(base) {
    var capitalize = function(str) {
        return str.slice(0, 1).toUpperCase() + str.slice(1);
    };
    return base.split("/").filter(function(str) {
        return str.length > 0 && str !== "src" && str !== "packages" && str !== "components";
    }).map(function(str) {
        if (str.includes("-")) return str.split("-").map(function(s) {
            return capitalize(s);
        }).join(" ");
        return capitalize(str);
    }).join("/");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g2nxL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANIMATION", function() {
    return 0, _animation.animation;
});
parcelHelpers.export(exports, "BREAKPOINT", function() {
    return 0, _breakpoints.breakpoints;
});
parcelHelpers.export(exports, "MEDIA_QUERIES", function() {
    return 0, _breakpoints.mediaQueries;
});
parcelHelpers.export(exports, "TYPOGRAPHY", function() {
    return 0, _typography.typography;
});
parcelHelpers.export(exports, "FONT_SIZE", function() {
    return 0, _typography.fontSize;
});
parcelHelpers.export(exports, "PADDINGS", function() {
    return 0, _padding.padding;
});
parcelHelpers.export(exports, "SPACING", function() {
    return 0, _spacings.spacings;
});
parcelHelpers.export(exports, "MARGINS", function() {
    return 0, _margin.margin;
});
parcelHelpers.export(exports, "MATH", function() {
    return 0, _numbers.MATH;
});
parcelHelpers.export(exports, "COLORS", function() {
    return 0, _colors.allColors;
});
parcelHelpers.export(exports, "BASE_COLORS", function() {
    return 0, _colors.baseColors;
});
parcelHelpers.export(exports, "FIELD_COLORS", function() {
    return 0, _colors.fieldColors;
});
parcelHelpers.export(exports, "LAYOUT_COLORS", function() {
    return 0, _colors.layoutColors;
});
parcelHelpers.export(exports, "GRAY_COLORS", function() {
    return 0, _colors.grayColors;
});
parcelHelpers.export(exports, "FONT_COLORS", function() {
    return 0, _colors.fontColors;
});
parcelHelpers.export(exports, "BUTTON_COLORS", function() {
    return 0, _colors.buttonColors;
});
parcelHelpers.export(exports, "NEW_BUTTON_COLORS", function() {
    return 0, _colors.newButtonColors;
});
parcelHelpers.export(exports, "VIZ_COLORS", function() {
    return 0, _colors.vizColors;
});
parcelHelpers.export(exports, "VIZ_COLORS_ARRAY", function() {
    return 0, _colors.vizColorsArray;
});
var _animation = require("./animation");
var _breakpoints = require("./breakpoints");
var _typography = require("./typography");
var _padding = require("./padding");
var _spacings = require("./spacings");
var _margin = require("./margin");
var _numbers = require("./numbers");
var _colors = require("./colors");

},{"./animation":"8oVoF","./breakpoints":"7MbhA","./typography":"3kSnv","./padding":"7WkZ4","./spacings":"kYDDo","./margin":"dEkm6","./numbers":"1SCrA","./colors":"7l4eC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8oVoF":[function(require,module,exports) {
// This is used for "micro animations" - general purpose values to give the app a general feel
// By no means is this the rule for building out custom animations for various parts of the application
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animation", function() {
    return animation;
});
var animation = {
    duration: "200ms",
    timing: "ease"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7MbhA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpoints", function() {
    return breakpoints;
});
parcelHelpers.export(exports, "mediaQueries", function() {
    return mediaQueries;
});
var breakpoints = {
    mediumScreen: "600px",
    largeScreen: "900px",
    maxScreen: "1300px"
};
var mediaQueries = {
    mediumScreen: "only screen and (min-width: ".concat(breakpoints.mediumScreen, ")"),
    largeScreen: "only screen and (min-width: ".concat(breakpoints.largeScreen, ")"),
    maxScreen: "only screen and (min-width: ".concat(breakpoints.maxScreen, ")")
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3kSnv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontStack", function() {
    return fontStack;
});
parcelHelpers.export(exports, "fontFamily", function() {
    return fontFamily;
});
parcelHelpers.export(exports, "fontSize", function() {
    return fontSize;
});
parcelHelpers.export(exports, "lineHeight", function() {
    return lineHeight;
});
parcelHelpers.export(exports, "spacing", function() {
    return spacing;
});
parcelHelpers.export(exports, "ellipsis", function() {
    return ellipsis;
});
parcelHelpers.export(exports, "typography", function() {
    return typography;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var fontStack = [
    "Noto Sans",
    "-apple-system",
    "BlinkMacSystemFont",
    "Avenir Next",
    "Avenir",
    "Segoe UI",
    "Lucida Grande",
    "Helvetica Neue",
    "Helvetica",
    "Fira Sans",
    "Roboto",
    "Noto",
    "Droid Sans",
    "Cantarell",
    "Oxygen",
    "Ubuntu",
    "Franklin Gothic Medium",
    "Century Gothic",
    "Liberation Sans",
    "sans-serif"
];
var fontFamily = {
    base: fontStack.join(","),
    heading: fontStack.join(",")
};
var fontSize = {
    caption: "12px",
    base: "14px",
    subheadSmall: "16px",
    subheadLarge: "18px",
    subheadXl: "22px",
    display: "30px"
};
var lineHeight = {
    base: 1.25,
    heading: 1.2
};
var spacing = {
    base: "".concat(lineHeight.base, "em"),
    half: "".concat(lineHeight.base / 2, "em"),
    quarter: "".concat(lineHeight.base / 4, "em"),
    third: "".concat(lineHeight.base / 3, "em")
};
var ellipsis = (0, _styledComponents.css)(_templateObject());
var typography = {
    fontFamily: fontFamily,
    fontSize: fontSize,
    lineHeight: lineHeight,
    spacing: spacing,
    ellipsis: ellipsis
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9gf6S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_tagged_template_literal", function() {
    return _tagged_template_literal;
});
parcelHelpers.export(exports, "_", function() {
    return _tagged_template_literal;
});
function _tagged_template_literal(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Gjjc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerStyleSheet", function() {
    return mt;
});
parcelHelpers.export(exports, "StyleSheetConsumer", function() {
    return $e;
});
parcelHelpers.export(exports, "StyleSheetContext", function() {
    return Me;
});
parcelHelpers.export(exports, "StyleSheetManager", function() {
    return Le;
});
parcelHelpers.export(exports, "ThemeConsumer", function() {
    return Qe;
});
parcelHelpers.export(exports, "ThemeContext", function() {
    return Ke;
});
parcelHelpers.export(exports, "ThemeProvider", function() {
    return tt;
});
parcelHelpers.export(exports, "__PRIVATE__", function() {
    return yt;
});
parcelHelpers.export(exports, "createGlobalStyle", function() {
    return dt;
});
parcelHelpers.export(exports, "css", function() {
    return at;
});
parcelHelpers.export(exports, "default", function() {
    return ut;
});
parcelHelpers.export(exports, "isStyledComponent", function() {
    return se;
});
parcelHelpers.export(exports, "keyframes", function() {
    return ht;
});
parcelHelpers.export(exports, "styled", function() {
    return ut;
});
parcelHelpers.export(exports, "useTheme", function() {
    return et;
});
parcelHelpers.export(exports, "version", function() {
    return v;
});
parcelHelpers.export(exports, "withTheme", function() {
    return ft;
});
var _tslib = require("tslib");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _stylis = require("stylis");
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var process = require("50571207bc3cae02");
var f = ("undefined" != typeof process && void 0 !== process.env && undefined, "data-styled"), m = "active", y = "data-styled-version", v = "6.1.8", g = "/*!sc*/\n", S = "undefined" != typeof window && "HTMLElement" in window, w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof process && process.env, "undefined" != typeof process && process.env, false)), b = {}, E = /invalid hook call/i, N = new Set, P = function P(t, n) {
    var _$o, s, i, a, e;
}, _ = Object.freeze([]), C = Object.freeze({});
function I(e, t, n) {
    return void 0 === n && (n = C), e.theme !== n.theme && e.theme || t || n.theme;
}
var A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, D = /(^-|-$)/g;
function R(e) {
    return e.replace(O, "-").replace(D, "");
}
var T = /(a)(d)/gi, k = 52, j = function j(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > k; t = t / k | 0)n = j(t % k) + n;
    return (j(t % k) + n).replace(T, "$1-$2");
}
var V, F = 5381, M = function M(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $ = function $(e) {
    return M(F, e);
};
function z(e) {
    return x($(e) >>> 0);
}
function B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function L(e) {
    return "string" == typeof e && true;
}
var G = "function" == typeof Symbol && Symbol.for, Y = G ? Symbol.for("react.memo") : 60115, W = G ? Symbol.for("react.forward_ref") : 60112, q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, J = ((V = {})[W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, V[Y] = U, V);
function X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === Y ? U : "$$typeof" in e ? J[e.$$typeof] : q;
}
var Z = Object.defineProperty, K = Object.getOwnPropertyNames, Q = Object.getOwnPropertySymbols, ee = Object.getOwnPropertyDescriptor, te = Object.getPrototypeOf, ne = Object.prototype;
function oe(e, t, n) {
    if ("string" != typeof t) {
        if (ne) {
            var _$o = te(t);
            _$o && _$o !== ne && oe(e, _$o, n);
        }
        var r = K(t);
        Q && (r = r.concat(Q(t)));
        for(var s = X(e), i = X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in H || n && n[c] || i && c in i || s && c in s)) {
                var l = ee(t, c);
                try {
                    Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function re(e) {
    return "function" == typeof e;
}
function se(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], _$o = 1; _$o < e.length; _$o++)n += t ? t + e[_$o] : e[_$o];
    return n;
}
function ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var _$o = 0; _$o < t.length; _$o++)e[_$o] = le(e[_$o], t[_$o]);
    else if (ce(t)) for(var _$o in t)e[_$o] = le(e[_$o], t[_$o]);
    return e;
}
function ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var pe = {};
function de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], _$o = [], r = 1, s = e.length; r < s; r += 1)_$o.push(e[r]);
    return _$o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function he(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$o = n.length, r = _$o; e >= r;)if ((r <<= 1) < 0) throw he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = _$o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < _$o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$o = this.indexOfGroup(e), r = _$o + n, s = _$o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat(g);
        return t;
    }, e;
}(), me = new Map, ye = new Map, ve = 1, ge = function ge(e) {
    if (me.has(e)) return me.get(e);
    for(; ye.has(ve);)ve++;
    var t = ve++;
    return me.set(e, t), ye.set(t, e), t;
}, Se = function Se(e, t) {
    ve = t + 1, me.set(e, t), ye.set(t, e);
}, we = "style[".concat(f, "][").concat(y, '="').concat(v, '"]'), be = new RegExp("^".concat(f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Ee = function Ee(e, t, n) {
    for(var _$o, r = n.split(","), s = 0, i = r.length; s < i; s++)(_$o = r[s]) && e.registerName(t, _$o);
}, Ne = function Ne(e, t) {
    for(var n, _$o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split(g), r = [], s = 0, i = _$o.length; s < i; s++){
        var a = _$o[s].trim();
        if (a) {
            var c = a.match(be);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && (Se(u, l), Ee(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function Pe() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var _e = function _e(e) {
    var t = document.head, n = e || t, _$o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat(f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    _$o.setAttribute(f, m), _$o.setAttribute(y, v);
    var i = Pe();
    return i && _$o.setAttribute("nonce", i), n.insertBefore(_$o, s), _$o;
}, Ce = function() {
    function e(e) {
        this.element = _e(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$o = t.length; n < _$o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), Ie = function() {
    function e(e) {
        this.element = _e(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), Ae = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), Oe = S, De = {
    isServer: !S,
    useCSSOMInjection: !w
}, Re = function() {
    function e(e, n, o) {
        void 0 === e && (e = C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, De), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && S && Oe && (Oe = !1, function(e) {
            for(var _$t = document.querySelectorAll(we), _$n = 0, _$o = _$t.length; _$n < _$o; _$n++){
                var r = _$t[_$n];
                r && r.getAttribute(f) !== m && (Ne(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), ue(this, function() {
            return function(e) {
                for(var _$t = e.getTag(), _$n = _$t.length, _$o = "", r = function r(n) {
                    var r = function(e) {
                        return ye.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = _$t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat(f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), _$o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat(g);
                }, s = 0; s < _$n; s++)r(s);
                return _$o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return ge(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var _$e;
        return this.tag || (this.tag = (_$e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new Ae(n) : t ? new Ce(n) : new Ie(n);
        }(this.options), new fe(_$e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if (ge(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(ge(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup(ge(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), Te = /&/g, ke = /^\s*\/\/.*$/gm;
function je(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = je(e.children, t)), e;
    });
}
function xe(e) {
    var t, n, _$o, r = void 0 === e ? C : e, s = r.options, i = void 0 === s ? C : s, a = r.plugins, c = void 0 === a ? _ : a, l = function l(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === _stylis.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace(Te, n).replace(_$o, l));
    }), i.prefix && u.push(_stylis.prefixer), u.push(_stylis.stringify);
    var p = function p(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, _$o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace(ke, ""), l = _stylis.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = je(l, i.namespace));
        var p = [];
        return _stylis.serialize(l, _stylis.middleware(u.concat(_stylis.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || he(15), M(e, t.name);
    }, F).toString() : "", p;
}
var Ve = new Re, Fe = xe(), Me = (0, _reactDefault.default).createContext({
    shouldForwardProp: void 0,
    styleSheet: Ve,
    stylis: Fe
}), $e = Me.Consumer, ze = (0, _reactDefault.default).createContext(void 0);
function Be() {
    return (0, _react.useContext)(Me);
}
function Le(e) {
    var t = (0, _react.useState)(e.stylisPlugins), n = t[0], r = t[1], c = Be().styleSheet, l = (0, _react.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, _react.useMemo)(function() {
        return xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, _react.useEffect)(function() {
        (0, _shallowequalDefault.default)(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, _react.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, _reactDefault.default).createElement(Me.Provider, {
        value: d
    }, (0, _reactDefault.default).createElement(ze.Provider, {
        value: u
    }, e.children));
}
var Ge = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = Fe);
            var _$o = n.name + t.hash;
            e.hasNameForId(n.id, _$o) || e.insertRules(n.id, _$o, t(n.rules, _$o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, ue(this, function() {
            throw he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = Fe), this.name + e.hash;
    }, e;
}(), Ye = function Ye(e) {
    return e >= "A" && e <= "Z";
};
function We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var _$o = e[n];
        if (1 === n && "-" === _$o && "-" === e[0]) return e;
        Ye(_$o) ? t += "-" + _$o.toLowerCase() : t += _$o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var qe = function qe(e) {
    return null == e || !1 === e || "" === e;
}, He = function He1(t) {
    var n, _$o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !qe(i) && (Array.isArray(i) && i.isCss || re(i) ? r.push("".concat(We(s), ":"), i, ";") : ce(i) ? r.push.apply(r, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([
            "".concat(s, " {")
        ], He(i), !1), [
            "}"
        ], !1)) : r.push("".concat(We(s), ": ").concat((n = s, null == (_$o = i) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || n in (0, _unitlessDefault.default) || n.startsWith("--") ? String(_$o).trim() : "".concat(_$o, "px")), ";")));
    }
    return r;
};
function Ue(e, t, n, o) {
    if (qe(e)) return [];
    if (se(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if (re(e)) {
        if (!re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return Ue(r, t, n, o);
    }
    var s;
    return e instanceof Ge ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : ce(e) ? He(e) : Array.isArray(e) ? Array.prototype.concat.apply(_, e.map(function(e) {
        return Ue(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if (re(n) && !se(n)) return !1;
    }
    return !0;
}
var Xe = $(v), Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && Je(e), this.componentId = t, this.baseHash = M(Xe, t), this.baseStyle = n, Re.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) _$o = ie(_$o, this.staticRulesId);
            else {
                var r = ae(Ue(this.rules, e, t, n)), s = x(M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                _$o = ie(_$o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = ae(Ue(u, e, t, n));
                    a = M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), _$o = ie(_$o, d);
            }
        }
        return _$o;
    }, e;
}(), Ke = (0, _reactDefault.default).createContext(void 0), Qe = Ke.Consumer;
function et() {
    var e = (0, _react.useContext)(Ke);
    if (!e) throw he(18);
    return e;
}
function tt(e) {
    var n = (0, _reactDefault.default).useContext(Ke), r = (0, _react.useMemo)(function() {
        return function(e, n) {
            if (!e) throw he(14);
            if (re(e)) {
                var _$o = e(n);
                return _$o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw he(8);
            return n ? (0, _tslib.__assign)((0, _tslib.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, _reactDefault.default).createElement(Ke.Provider, {
        value: r
    }, e.children) : null;
}
var nt = {}, ot = new Set;
function rt(e, r, s) {
    var i = se(e), a = e, c = !L(e), p = r.attrs, d = void 0 === p ? _ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : R(e);
        nt[n] = (nt[n] || 0) + 1;
        var _$o = "".concat(n, "-").concat(z(v + n + nt[n]));
        return t ? "".concat(t, "-").concat(_$o) : _$o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return L(e) ? "styled.".concat(e) : "Styled(".concat(B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat(R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function w(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new Ze(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, _reactDefault.default).useContext(Ke), m = Be(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = I(r, f, c) || C, g = function(e, n, o) {
                for(var _$r, _$s = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = re(_$r = e[i]) ? _$r(_$s) : _$r;
                    for(var c in a)_$s[c] = "className" === c ? ie(_$s[c], a[c]) : "style" === c ? (0, _tslib.__assign)((0, _tslib.__assign)({}, _$s[c]), a[c]) : a[c];
                }
                return n.className && (_$s.className = ie(_$s.className, n.className)), _$s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = Be(), _$o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return _$o;
            }(a, g);
            var N = ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[L(S) && !A.has(S) ? "class" : "className"] = N, w.ref = s, (0, _react.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, _reactDefault.default).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var _$o = 0, _$r = t; _$o < _$r.length; _$o++)le(e, _$r[_$o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function st(e, t) {
    for(var n = [
        e[0]
    ], _$o = 0, r = t.length; _$o < r; _$o += 1)n.push(t[_$o], e[_$o + 1]);
    return n;
}
var it = function it(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function at(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    if (re(t) || ce(t)) return it(Ue(st(_, (0, _tslib.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? Ue(r) : it(Ue(st(r, n)));
}
function ct(n, o, r) {
    if (void 0 === r && (r = C), !o) throw he(1, o);
    var s = function s(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, at.apply(void 0, (0, _tslib.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return ct(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return ct(n, o, (0, _tslib.__assign)((0, _tslib.__assign)({}, r), e));
    }, s;
}
var lt = function lt(e) {
    return ct(rt, e);
}, ut = lt;
A.forEach(function(e) {
    ut[e] = lt(e);
});
var pt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = Je(e), Re.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o(ae(Ue(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && Re.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function dt(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = at.apply(void 0, (0, _tslib.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat(z(JSON.stringify(i))), c = new pt(i, a);
    var l = function l(e) {
        var t = Be(), _$n = (0, _reactDefault.default).useContext(Ke), r = (0, _reactDefault.default).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, _$n, t.stylis), (0, _reactDefault.default).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, _$n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            _$n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, b, o, s);
        else {
            var i = (0, _tslib.__assign)((0, _tslib.__assign)({}, n), {
                theme: I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, _reactDefault.default).memo(l);
}
function ht(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    var r = ae(at.apply(void 0, (0, _tslib.__spreadArray)([
        t
    ], n, !1))), s = z(r);
    return new Ge(s, r);
}
function ft(e) {
    var n = (0, _reactDefault.default).forwardRef(function(n, r) {
        var s = I(n, (0, _reactDefault.default).useContext(Ke), e.defaultProps);
        return (0, _reactDefault.default).createElement(e, (0, _tslib.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat(B(e), ")"), oe(n, e);
}
var mt = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString(), n = Pe(), _$o = ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat(f, '="true"'),
                "".concat(y, '="').concat(v, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(_$o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (_$e.sealed) throw he(2);
            return _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (_$e.sealed) throw he(2);
            var r = ((n = {})[f] = "", n[y] = v, n.dangerouslySetInnerHTML = {
                __html: _$e.instance.toString()
            }, n), s = Pe();
            return s && (r.nonce = s), [
                (0, _reactDefault.default).createElement("style", (0, _tslib.__assign)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new Re({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw he(2);
        return (0, _reactDefault.default).createElement(Le, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw he(3);
    }, e;
}(), yt = {
    StyleSheet: Re,
    mainSheet: Ve
};
var vt = "__sc-".concat(f, "__");

},{"50571207bc3cae02":"58KR9","tslib":"8fqB7","@emotion/is-prop-valid":"hWjjN","react":"ktQNc","shallowequal":"2HxHc","stylis":"b1BNN","@emotion/unitless":"bidPf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"58KR9":[function(require,module,exports) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = "browser";
process.browser = true;
process.env = {};
process.argv = [];
process.version = ""; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
process.cwd = function() {
    return "/";
};
process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
process.umask = function() {
    return 0;
};

},{}],"8fqB7":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return (typeof x === "undefined" ? "undefined" : (0, _typeOf._)(x)) === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, _typeOf._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

},{"@swc/helpers/_/_type_of":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hWjjN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPropValid;
});
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"1sZmP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1sZmP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoize;
});
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2HxHc":[function(require,module,exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"b1BNN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", function() {
    return f;
});
parcelHelpers.export(exports, "COMMENT", function() {
    return n;
});
parcelHelpers.export(exports, "COUNTER_STYLE", function() {
    return w;
});
parcelHelpers.export(exports, "DECLARATION", function() {
    return s;
});
parcelHelpers.export(exports, "DOCUMENT", function() {
    return v;
});
parcelHelpers.export(exports, "FONT_FACE", function() {
    return b;
});
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", function() {
    return d;
});
parcelHelpers.export(exports, "IMPORT", function() {
    return i;
});
parcelHelpers.export(exports, "KEYFRAMES", function() {
    return h;
});
parcelHelpers.export(exports, "LAYER", function() {
    return g;
});
parcelHelpers.export(exports, "MEDIA", function() {
    return u;
});
parcelHelpers.export(exports, "MOZ", function() {
    return r;
});
parcelHelpers.export(exports, "MS", function() {
    return e;
});
parcelHelpers.export(exports, "NAMESPACE", function() {
    return p;
});
parcelHelpers.export(exports, "PAGE", function() {
    return t;
});
parcelHelpers.export(exports, "RULESET", function() {
    return c;
});
parcelHelpers.export(exports, "SUPPORTS", function() {
    return l;
});
parcelHelpers.export(exports, "VIEWPORT", function() {
    return o;
});
parcelHelpers.export(exports, "WEBKIT", function() {
    return a;
});
parcelHelpers.export(exports, "abs", function() {
    return k;
});
parcelHelpers.export(exports, "alloc", function() {
    return X;
});
parcelHelpers.export(exports, "append", function() {
    return q;
});
parcelHelpers.export(exports, "assign", function() {
    return m;
});
parcelHelpers.export(exports, "caret", function() {
    return U;
});
parcelHelpers.export(exports, "char", function() {
    return P;
});
parcelHelpers.export(exports, "character", function() {
    return I;
});
parcelHelpers.export(exports, "characters", function() {
    return J;
});
parcelHelpers.export(exports, "charat", function() {
    return O;
});
parcelHelpers.export(exports, "column", function() {
    return F;
});
parcelHelpers.export(exports, "combine", function() {
    return B;
});
parcelHelpers.export(exports, "comment", function() {
    return fe;
});
parcelHelpers.export(exports, "commenter", function() {
    return ce;
});
parcelHelpers.export(exports, "compile", function() {
    return te;
});
parcelHelpers.export(exports, "copy", function() {
    return L;
});
parcelHelpers.export(exports, "dealloc", function() {
    return Y;
});
parcelHelpers.export(exports, "declaration", function() {
    return oe;
});
parcelHelpers.export(exports, "delimit", function() {
    return Z;
});
parcelHelpers.export(exports, "delimiter", function() {
    return ne;
});
parcelHelpers.export(exports, "escaping", function() {
    return ae;
});
parcelHelpers.export(exports, "filter", function() {
    return D;
});
parcelHelpers.export(exports, "from", function() {
    return $;
});
parcelHelpers.export(exports, "hash", function() {
    return x;
});
parcelHelpers.export(exports, "identifier", function() {
    return se;
});
parcelHelpers.export(exports, "indexof", function() {
    return C;
});
parcelHelpers.export(exports, "length", function() {
    return G;
});
parcelHelpers.export(exports, "lift", function() {
    return N;
});
parcelHelpers.export(exports, "line", function() {
    return E;
});
parcelHelpers.export(exports, "match", function() {
    return j;
});
parcelHelpers.export(exports, "middleware", function() {
    return he;
});
parcelHelpers.export(exports, "namespace", function() {
    return de;
});
parcelHelpers.export(exports, "next", function() {
    return R;
});
parcelHelpers.export(exports, "node", function() {
    return K;
});
parcelHelpers.export(exports, "parse", function() {
    return ue;
});
parcelHelpers.export(exports, "peek", function() {
    return T;
});
parcelHelpers.export(exports, "position", function() {
    return H;
});
parcelHelpers.export(exports, "prefix", function() {
    return le;
});
parcelHelpers.export(exports, "prefixer", function() {
    return we;
});
parcelHelpers.export(exports, "prev", function() {
    return Q;
});
parcelHelpers.export(exports, "replace", function() {
    return z;
});
parcelHelpers.export(exports, "ruleset", function() {
    return ie;
});
parcelHelpers.export(exports, "rulesheet", function() {
    return be;
});
parcelHelpers.export(exports, "serialize", function() {
    return ve;
});
parcelHelpers.export(exports, "sizeof", function() {
    return S;
});
parcelHelpers.export(exports, "slice", function() {
    return V;
});
parcelHelpers.export(exports, "stringify", function() {
    return pe;
});
parcelHelpers.export(exports, "strlen", function() {
    return M;
});
parcelHelpers.export(exports, "substr", function() {
    return A;
});
parcelHelpers.export(exports, "token", function() {
    return W;
});
parcelHelpers.export(exports, "tokenize", function() {
    return _;
});
parcelHelpers.export(exports, "tokenizer", function() {
    return re;
});
parcelHelpers.export(exports, "trim", function() {
    return y;
});
parcelHelpers.export(exports, "whitespace", function() {
    return ee;
});
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = Math.abs;
var $ = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r, a) {
    return e.indexOf(r, a);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
function D(e, r) {
    return e.filter(function(e) {
        return !j(e, r);
    });
}
var E = 1;
var F = 1;
var G = 0;
var H = 0;
var I = 0;
var J = "";
function K(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: E,
        column: F,
        length: t,
        return: "",
        siblings: u
    };
}
function L(e, r) {
    return m(K("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function N(e) {
    while(e.root)e = L(e.root, {
        children: [
            e
        ]
    });
    q(e, e.siblings);
}
function P() {
    return I;
}
function Q() {
    I = H > 0 ? O(J, --H) : 0;
    if (F--, I === 10) F = 1, E--;
    return I;
}
function R() {
    I = H < G ? O(J, H++) : 0;
    if (F++, I === 10) F = 1, E++;
    return I;
}
function T() {
    return O(J, H);
}
function U() {
    return H;
}
function V(e, r) {
    return A(J, e, r);
}
function W(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function X(e) {
    return E = F = 1, G = M(J = e), H = 0, [];
}
function Y(e) {
    return J = "", e;
}
function Z(e) {
    return y(V(H - 1, ne(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function _(e) {
    return Y(re(X(e)));
}
function ee(e) {
    while(I = T())if (I < 33) R();
    else break;
    return W(e) > 2 || W(I) > 3 ? "" : " ";
}
function re(e) {
    while(R())switch(W(I)){
        case 0:
            q(se(H - 1), e);
            break;
        case 2:
            q(Z(I), e);
            break;
        default:
            q($(I), e);
    }
    return e;
}
function ae(e, r) {
    while(--r && R())if (I < 48 || I > 102 || I > 57 && I < 65 || I > 70 && I < 97) break;
    return V(e, U() + (r < 6 && T() == 32 && R() == 32));
}
function ne(e) {
    while(R())switch(I){
        case e:
            return H;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) ne(I);
            break;
        case 40:
            if (e === 41) ne(e);
            break;
        case 92:
            R();
            break;
    }
    return H;
}
function ce(e, r) {
    while(R())if (e + I === 57) break;
    else if (e + I === 84 && T() === 47) break;
    return "/*" + V(r, H - 1) + "*" + $(e === 47 ? e : R());
}
function se(e) {
    while(!W(T()))R();
    return V(e, H);
}
function te(e) {
    return Y(ue("", null, null, null, [
        ""
    ], e = X(e), 0, [
        0
    ], e));
}
function ue(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var m = "";
    var x = c;
    var y = s;
    var j = n;
    var A = m;
    while(w)switch(h = g, g = R()){
        case 40:
            if (h != 108 && O(A, l - 1) == 58) {
                if (C(A += z(Z(g), "&", "&\f"), "&\f", k(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            A += Z(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            A += ee(h);
            break;
        case 92:
            A += ae(U() - 1, 7);
            continue;
        case 47:
            switch(T()){
                case 42:
                case 47:
                    q(fe(ce(R(), U()), r, a, i), i);
                    break;
                default:
                    A += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(A) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) A = z(A, /\f/g, "");
                    if (p > 0 && M(A) - l) q(p > 32 ? oe(A + ";", n, a, l - 1, i) : oe(z(A, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    A += ";";
                default:
                    q(j = ie(A, r, a, f, o, c, u, m, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) ue(A, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && O(A, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                ue(e, j, j, n && q(ie(e, j, j, 0, 0, c, u, m, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                ue(A, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, m = A = "", l = t;
            break;
        case 58:
            l = 1 + M(A), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && Q() == 125) continue;
            }
            switch(A += $(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (A += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(A) - 1) * d, d = 1;
                    break;
                case 64:
                    if (T() === 45) A += Z(R());
                    v = T(), o = l = M(m = A += se(U())), g++;
                    break;
                case 45:
                    if (h === 45 && M(A) == 2) b = 0;
            }
    }
    return s;
}
function ie(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = S(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var $ = 0, m = A(e, p + 1, p = k(d = u[w])), x = e; $ < b; ++$)if (x = y(d > 0 ? h[$] + " " + m : z(m, /&\f/g, h[$]))) f[g++] = x;
    return K(e, r, a, s === 0 ? c : i, f, o, l, v);
}
function fe(e, r, a, c) {
    return K(e, r, a, n, $(P()), A(e, 2, -2), 0, c);
}
function oe(e, r, a, n, c) {
    return K(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n, c);
}
function le(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span", 0) ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span", 0) ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch", 0) ? le(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function ve(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function pe(e, r, a, t) {
    switch(e.type){
        case g:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + ve(e.children, t) + "}";
        case c:
            if (!M(e.value = e.props.join(","))) return "";
    }
    return M(a = ve(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function he(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function be(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function we(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = le(n.value, n.length, u);
                return;
            case h:
                return ve([
                    L(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(u = n.props, function(c) {
                    switch(j(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            N(L(n, {
                                props: [
                                    z(c, /:(read-\w+)/, ":" + r + "$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    c
                                ]
                            }));
                            m(n, {
                                props: D(u, i)
                            });
                            break;
                        case "::placeholder":
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, ":" + r + "$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    z(c, /:(plac\w+)/, e + "input-$1")
                                ]
                            }));
                            N(L(n, {
                                props: [
                                    c
                                ]
                            }));
                            m(n, {
                                props: D(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function de(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(_(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bidPf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7WkZ4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "padding", function() {
    return padding;
});
var padding = {
    // todo -- get with mike L for other padding values as they become needed. Ideally we should create a formula.
    xs: "10px",
    sm: "15px",
    md: "20px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kYDDo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spacings", function() {
    return spacings;
});
var spacings = {
    xs: "8px",
    sm: "12px",
    md: "24px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dEkm6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "margin", function() {
    return margin;
});
var margin = {
    // todo -- get with mike L for other padding values as they become needed. Ideally we should create a formula.
    sm: "15px",
    md: "20px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1SCrA":[function(require,module,exports) {
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimalAdjust", function() {
    return decimalAdjust;
});
parcelHelpers.export(exports, "round10", function() {
    return round10;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "numberWithCommas", function() {
    return numberWithCommas;
});
parcelHelpers.export(exports, "MATH", function() {
    return MATH;
});
var decimalAdjust = function(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) return Math[type](value);
    value = +value;
    exp = +exp; // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) return NaN;
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))); // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
};
var round10 = function(value, exp) {
    return decimalAdjust("round", value, exp);
};
var clamp = function(value, min, max) {
    value = value < min ? min : value;
    value = value > max ? max : value;
    return value;
};
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var MATH = {
    decimalAdjust: decimalAdjust,
    round10: round10,
    clamp: clamp,
    numberWithCommas: numberWithCommas
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7l4eC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allColors", function() {
    return allColors;
});
parcelHelpers.export(exports, "baseColors", function() {
    return baseColors;
});
parcelHelpers.export(exports, "layoutColors", function() {
    return layoutColors;
});
parcelHelpers.export(exports, "grayColors", function() {
    return grayColors;
});
parcelHelpers.export(exports, "fontColors", function() {
    return fontColors;
});
parcelHelpers.export(exports, "buttonColors", function() {
    return buttonColors;
});
parcelHelpers.export(exports, "newButtonColors", function() {
    return newButtonColors;
});
parcelHelpers.export(exports, "vizColors", function() {
    return vizColors;
});
parcelHelpers.export(exports, "vizColorsArray", function() {
    return vizColorsArray;
});
parcelHelpers.export(exports, "fieldColors", function() {
    return fieldColors;
});
var allColors = {
    akaroa: "#cbc98f",
    alizarin: "#e72326",
    amber: "#f4c401",
    amethyst: "#8e57b3",
    aqua: "#10e4fe",
    astralBlue: "#2f7ca2",
    ateneoBlue: "#0d466a",
    avocado: "#81b12f",
    azure: "#108cf7",
    baliHai: "#8498b6",
    bermudaGrey: "#7488A4",
    biscay: "#334154",
    black: "#000",
    blackPearl: "#141B24",
    blueBayoux: "#4f5e74",
    blueMagenta: "#542f9d",
    blueRibbon: "#0b35ff",
    blueYonder: "#586fd2",
    bouqet: "#a35c9a",
    brick: "#c62828",
    brightOrange: "#f29c22",
    brown: "#785349",
    candyCorn: "#fcef4d",
    carnation: "#ff8adf",
    carrot: "#f29a2d",
    cerise: "#d52a96",
    cerulean: "#008b9e",
    chantilly: "#f7b0eb",
    charcoal: "#474b4b",
    charcoalBlue: "#334154 ",
    chartreuse: "#34ff01",
    chatamsBlue: "#2A496B",
    clay: "#283243",
    cloudBurst: "#333D4C",
    cocoaBean: "#5c1200",
    coffeeBean: "#321014",
    coolGray: "#8593B3",
    comet: "#5a6982",
    cornflower: "#2060ff",
    crimson: "#e53126",
    curiousBlue: "#178ee0",
    cyan: "#0cf",
    darkFontColor: "#0d151d",
    darkGray: "#333",
    darkPurple: "#6f3eae",
    darkRed: "#b30000",
    defaultFontColor: "#bbbfc5",
    deepTeal: "#003D27",
    dodgerBlue: "#1774ff",
    eagleGreen: "#005557",
    ebony: "#101a26",
    eggplant: "#7a0074",
    electricGreen: "#00ff0a",
    emerald: "#09c199",
    espresso: "#5a3627",
    fieldPromptError: "#fd9693",
    fieldPromptInfo: "#00bfff",
    fireEngineRed: "#c21d20",
    flamingo: "#f861b6",
    flirt: "#910870",
    forestGreen: "#1f7f1f",
    geraldine: "#fe9486",
    grannysmith: "#92e959",
    green: "#4caf50",
    goldenBrown: "#80670c",
    gunmetalBlue: "#344152",
    harlequin: "#20cb00",
    harvestGold: "#e6c079",
    hemlock: "#626740",
    imperial: "#4b0134",
    independence: "#4A5669",
    iron: "#d9dee0",
    japaneseIndigo: "#264359",
    juniper: "#6d9292",
    jungleGreen: "#087950",
    khaki: "#bba44b",
    koamaru: "#2f346a",
    korma: "#90370e",
    lavender: "#B086E3",
    lavenderRose: "#fb9fda",
    lightGray: "#eee",
    lightPurple: "#b43be4",
    lilac: "#a195d4",
    lincolnGreen: "#254600",
    magenta: "#ff15e0",
    malibu: "#68C2FB",
    mantis: "#4fa83d",
    maroon: "#ad3349",
    mauve: "#e06cfb",
    mediumGray: "#999",
    midFontColor: "#8593b3",
    midnight: "#233346",
    midnightBlue: "#1A2736",
    mint: "#3ac999",
    mintGreen: "#15b77d",
    mirage: "#182432",
    mulberry: "#5c0536",
    olive: "#807300",
    oliveBrown: "#463703",
    orange: "#ff7200",
    orchid: "#ab00ff",
    oxfordBlue: "#384558",
    pacific: "#00b5b6",
    pakistanGreen: "#006e00",
    portGore: "#394c6b",
    palm: "#1aa511",
    persian: "#1717cf",
    persianLight: "#0327ce",
    pewterBlue: "#92a8c2",
    pine: "#017074",
    pink: "#f74f8a",
    pistachio: "#aac609",
    raspberry: "#990030",
    red: "#f95359",
    reddishPink: "#CE6068",
    regalBlue: "#1D354E",
    robinsEggBlue: "#00bcd4",
    romanSilver: "#7d888d",
    salem: "#03832e",
    sanguineRed: "#68252A",
    sapGreen: "#5f7e20",
    seaGreen: "#0b8a51",
    seance: "#7f1f82",
    shiraz: "#c61021",
    sinopia: "#D14200",
    summerSky: "#36A1EA",
    spindle: "#bcc7da",
    tangerine: "#ff9900",
    teal: "#008285",
    toast: "#997862",
    trueBlue: "#066CC6",
    turquoise: "#00b5b6",
    vermilion: "#b95555",
    viking: "#59cfe0",
    violet: "#3e4eb8",
    violetBlue: "#8060d2",
    vividAzure: "#198BDC ",
    walnut: "#783f00",
    white: "#fff",
    whiteSmoke: "#f8f8f8",
    windsorTan: "#b35c00",
    yellow: "#ffca28",
    yellowOrange: "#fa3",
    zucchini: "#016422",
    get hiliteFontColor () {
        return this.white;
    },
    get lightFontColor () {
        return this.lightGray;
    },
    get borderColor () {
        return this.lightGray;
    },
    get actionColor () {
        return this.midFontColor;
    },
    get backgroundColor () {
        return this.mirage;
    }
};
/**
 * Given an array of valid color names, return an array containing their hex values as strings.
 */ function returnColorPalette(colorNames) {
    return colorNames.map(function(name) {
        return allColors[name];
    });
} // Base Colors
var baseColors = returnColorPalette([
    "curiousBlue",
    "robinsEggBlue",
    "green",
    "yellow",
    "red",
    "white",
    "black"
]);
var layoutColors = returnColorPalette([
    "ebony",
    "mirage",
    "clay",
    "oxfordBlue",
    "blueBayoux",
    "comet",
    "baliHai"
]);
var grayColors = returnColorPalette([
    "darkGray",
    "mediumGray",
    "lightGray",
    "iron"
]); // Font Colors
var fontColors = returnColorPalette([
    "darkFontColor",
    "hiliteFontColor",
    "lightFontColor",
    "defaultFontColor",
    "midFontColor"
]); // Button Palette
var buttonColors = returnColorPalette([
    "turquoise",
    "violet",
    "emerald",
    "seaGreen",
    "avocado",
    "brick",
    "pink",
    "lightPurple",
    "charcoal"
]);
var newButtonColors = returnColorPalette([
    "azure",
    "orchid",
    "tangerine",
    "palm",
    "magenta",
    "blueRibbon",
    "orange",
    "darkRed",
    "amber",
    "lilac",
    "pacific",
    "carnation",
    "brown",
    "khaki",
    "zucchini",
    "eggplant",
    //'crimson',
    "cerulean",
    "harlequin",
    "akaroa",
    "persianLight",
    "viking",
    "mauve",
    "espresso",
    "toast",
    "salem",
    "darkPurple",
    "cornflower",
    "grannysmith",
    "lavender"
]);
var vizColors = returnColorPalette([
    "aqua",
    "carrot",
    "flamingo",
    "dodgerBlue",
    "chantilly",
    "crimson",
    "candyCorn",
    "amethyst"
]);
var vizColorsArray = returnColorPalette([
    "aqua",
    "carrot",
    "flamingo",
    "green",
    "dodgerBlue",
    "chantilly",
    "crimson",
    "candyCorn",
    "amethyst",
    "baliHai"
]);
var fieldColors = returnColorPalette([
    "trueBlue",
    "eggplant",
    "sinopia",
    "forestGreen",
    "cerise",
    "persian",
    "teal",
    "violetBlue",
    "olive",
    "raspberry",
    "eagleGreen",
    "maroon",
    "brown",
    "windsorTan",
    "koamaru",
    "seance",
    "cocoaBean",
    "ateneoBlue",
    "sapGreen",
    "vermilion",
    "blueYonder",
    "korma",
    "hemlock",
    "imperial",
    "astralBlue",
    "shiraz",
    "blueMagenta",
    "flirt",
    "lincolnGreen",
    "bouqet"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dK3QT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalStyles", function() {
    return GlobalStyles;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _designSystemOverrides = require("./design-system-overrides");
var _jspreadsheetOverrides = require("./jspreadsheet-overrides");
var _colorProperties = require("./color-properties");
var _utilityClasses = require("./utility-classes");
var _forms = require("./forms");
var _buttons = require("./buttons");
var _layout = require("./layout");
var _lists = require("./lists");
var _media = require("./media");
var _tables = require("./tables");
var _typography = require("./typography");
var _marginPadding = require("./margin-padding");
var GlobalStyles = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorProperties.ColorProperties), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utilityClasses.UtilityClasses), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttons.Buttons), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _forms.Forms), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layout.Layout), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lists.Lists), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _media.Media), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tables.Tables), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _typography.Typography), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _marginPadding.MarginPadding), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _designSystemOverrides.DesignSystemOverrides), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _jspreadsheetOverrides.JspreadsheetOverrides), null));
};

},{"react":"ktQNc","./design-system-overrides":"cIBn9","./jspreadsheet-overrides":"1xya1","./color-properties":"jMbJk","./utility-classes":"kO6pJ","./forms":"f18Mm","./buttons":"4SCVg","./layout":"k8r4V","./lists":"4fZWz","./media":"3D7c7","./tables":"69syw","./typography":"epDVt","./margin-padding":"aJKOr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cIBn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesignSystemOverrides", function() {
    return DesignSystemOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n:root,\n:root [data-theme=light],\n:root [data-theme=dark] {\n    --pf-font-color: ",
        ";    \n    --pf-font-family-base: ",
        ";\n\n    .theme {\n      // Needed a bit more specificity to override the design system (dont love this but eh)\n      --pf-font-color: ",
        ";\n      --pf-font-family-base: ",
        ";\n\n      background-color: var(--app-background);\n      \n    }\n\n    .ElevatedOverlay.ReactModal__Overlay {\n      z-index: 999;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var GlobalOverrideStyles = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base);
var DesignSystemOverrides = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(GlobalOverrideStyles, null);
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react":"ktQNc","styled-components":"6Gjjc","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1xya1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JspreadsheetOverrides", function() {
    return JspreadsheetOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .theme {\n    // Jspreadsheet Theme Vars\n    --header_color: var(--pf-primary-color-200);\n    --header_color_highlighted: var(--pf-white-color);\n    --header_background: var(--pf-primary-color-950);\n    --header_background_highlighted: var(--pf-secondary-color-700);\n    --content_color: var(--pf-white-color);\n    --content_color_highlighted: red;\n    --content_background: var(--pf-primary-color-900);\n    --content_background_highlighted: red;\n    --menu_background: var(--pf-primary-color-600);\n    --menu_background_highlighted: var(--pf-primary-color-500);\n    --menu_color: var(--pf-white-color);\n    --menu_color_highlighted: var(--pf-white-color);\n    --menu_box_shadow: unset;\n    --border_color: var(--pf-tertiary-color-600);\n    --border_color_highlighted: var(--pf-secondary-color-900);\n    --content_color: var(--pf-white-color);\n    --cursor: var(--pf-secondary-color-900);\n    --active_color: red;\n\n    // Other Jspreadsheet Style Overrides\n    .jss { \n      background-color: var(--pf-primary-color-950);\n      margin: 0;\n\n      .jss_header {          \n        font-size: 14px; \n        font-weight: 600;\n        line-height: 20px;  \n        text-align: center;\n      }\n\n      tr { \n        td[data-role='cell'] {\n          text-align: left;\n        }\n      }\n    }\n \n    .jss_input.jss_focus {\n      background-color: var(--pf-secondary-color-900);\n      border: var(--pf-border-md) solid var(--pf-secondary-color-500); \n      color: var(--pf-white-color);\n    }\n\n    .jss_border_main {\n      background-color: var(--pf-secondary-color-900);\n      border: var(--pf-border-md) solid var(--pf-secondary-color-500);\n      color: var(--pf-white-color);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var JspreadsheetOverrideStyles = (0, _styledComponents.createGlobalStyle)(_templateObject());
var JspreadsheetOverrides = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(JspreadsheetOverrideStyles, null);
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react":"ktQNc","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jMbJk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorProperties", function() {
    return colorProperties;
});
parcelHelpers.export(exports, "ColorProperties", function() {
    return ColorProperties;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _colors = require("Permafrost/design-language/colors");
var _colors1 = require("../../constants/colors"); /**
                                                     * todo: this file is intended to be a placeholder to demonstrate possibilities for
                                                     *  refactoring our colors management
                                                     */ 
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  :root {\n    --app-background: ",
        ";\n    --card-background: ",
        ";\n    --menu-background: ",
        ";\n\n    --button-background-primary: ",
        ";\n\n    --focus-ring: ",
        ";\n\n    --logo-primary: ",
        ";\n    --logo-secondary: ",
        ";\n\n    --text-error: ",
        ";\n    --text-highlight: ",
        ";\n    --text-prompt: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var colorProperties = {
    appBackground: "--app-background",
    cardBackground: "--card-background",
    menuBackground: "--menu-background",
    buttonBackgroundPrimary: "--button-background-primary",
    focusRing: "--focus-ring",
    logoPrimary: "--logo-primary",
    logoSecondary: "--logo-secondary",
    textError: "--text-error",
    textHighlight: "--text-highlight",
    textPrompt: "--text-prompt"
};
var ColorProperties = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _colors1.allColors).backgroundColor, (0, _colors1.allColors).clay, (0, _colors1.allColors).ebony, (0, _colors.currentColors).indicoBlue, (0, _colors.currentColors).cyan, (0, _colors.currentColors).indicoBlue, (0, _colors1.allColors).white, (0, _colors1.allColors).fieldPromptError, (0, _colors.currentColors).orange, (0, _colors1.allColors).fieldPromptInfo);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/design-language/colors":"kN500","../../constants/colors":"7l4eC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kN500":[function(require,module,exports) {
// todo
//  intent: elsewhere in Permafrost/IPA, this object should only be referenced directly if
//  a global property is being redeclared. If a color value is needed for a CSS rule, a property
//  should be used.
//  my initial thought: a naming convention that associates each “content” color variant with
//  the background color it’s meant to appear on
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "currentColors", function() {
    return currentColors;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var brandingColors = {
    cyan: "#0cf",
    green: "#6c4",
    orange: "#fa3",
    indicoBlue: "#0070f5"
};
var currentColors = (0, _objectSpreadProps._)((0, _objectSpread._)({}, brandingColors), {
    // todo: examples; not in use
    indicoBlueApp: "#238aff",
    // *App == closest AA color for this background
    indicoBlueCard: "#469cff",
    // etc.
    indicoBlueMenu: "#0f7fff",
    indicoBlueWhite: "#0070f0" // *White == paired with pure white (this could be better-named...)
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1YBoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_spread_props", function() {
    return _object_spread_props;
});
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kO6pJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UtilityClasses", function() {
    return UtilityClasses;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .link-style {\n    text-decoration: underline;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  .spin {\n    animation: spin 2s infinite linear;\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .card-body {\n    background-color: ",
        ";\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    padding: 20px;\n    \n    hr {\n    margin: 1.25em 0;\n      border: 1px solid transparent;\n      border-bottom-color: ",
        ";\n    }\n  }\n  \n  .scrollable-vertical {\n    overflow: hidden auto;\n  \n    scrollbar-color: ",
        " transparent;\n    scrollbar-gutter: stable;\n    scrollbar-width: thin;\n  \n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: darkgrey;\n      outline: 1px solid slategrey;\n      border-radius: 20px;\n    }\n  }\n\n  .page-bottom {\n    padding-bottom: 20px;\n  }\n\n  .aria-invisible {\n    border: 0; \n    clip: rect(0 0 0 0); \n    height: 1px;  \n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var UtilityClasses = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).clay, (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).ebony, (0, _constants.COLORS).darkGray);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f18Mm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Forms", function() {
    return Forms;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _utils = require("@indico-data/utils");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\nfieldset {\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  font-weight: 600;\n  margin-bottom: ",
        ";\n  padding: 0;\n}\n\nlabel {\n  display: block;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n}\n\ninput,\nselect,\ntextarea {\n  display: block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n}\n\n[type='color'],\n[type='date'],\n[type='datetime'],\n[type='datetime-local'],\n[type='email'],\n[type='month'],\n[type='number'],\n[type='password'],\n[type='search'],\n[type='tel'],\n[type='text'],\n[type='time'],\n[type='url'],\n[type='week'],\ninput:not([type]),\ntextarea {\n  appearance: none;\n  background-color: ",
        ";\n  border: ",
        ";\n  border-radius: 2px;\n  box-shadow: ",
        ";\n  box-sizing: border-box;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  transition: border-color ",
        " ",
        ";\n  width: 100%;\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    cursor: not-allowed;\n\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  &::placeholder {\n    color: ",
        ';\n  }\n}\n\ntextarea {\n  resize: vertical;\n}\n\n[type="checkbox"],\n[type="radio"] {\n  display: inline;\n  margin-right: ',
        ';\n}\n\n[type="file"] {\n  margin-bottom: ',
        ";\n  width: 100%;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var formBoxShadow = "inset 0 0 0 rgba(#000, 0)";
var formBoxShadowFocus = formBoxShadow;
var Forms = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).clay, (0, _constants.COLORS).clay, formBoxShadow, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).spacing.third, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _utils.colorUtils).shade((0, _constants.COLORS).borderColor, 20), (0, _constants.COLORS).actionColor, formBoxShadowFocus, (0, _utils.colorUtils).shade((0, _constants.COLORS).backgroundColor, 5), (0, _constants.COLORS).lightGray, (0, _utils.colorUtils).tint((0, _constants.COLORS).defaultFontColor, 40), (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).spacing.half);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"g2nxL","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"47VRj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayUtils", function() {
    return _array;
});
parcelHelpers.export(exports, "clipboardUtils", function() {
    return _clipboard;
});
parcelHelpers.export(exports, "colorUtils", function() {
    return _color;
});
parcelHelpers.export(exports, "dateUtils", function() {
    return _date;
});
parcelHelpers.export(exports, "downloadUtils", function() {
    return _download;
});
parcelHelpers.export(exports, "easingUtils", function() {
    return _easing;
});
parcelHelpers.export(exports, "envUtils", function() {
    return _env;
});
parcelHelpers.export(exports, "fetchUtils", function() {
    return _fetch;
});
parcelHelpers.export(exports, "fileUtils", function() {
    return _files;
});
parcelHelpers.export(exports, "historyUtils", function() {
    return _history;
});
parcelHelpers.export(exports, "hookUtils", function() {
    return _hooks;
});
parcelHelpers.export(exports, "labelingUtils", function() {
    return _labeling;
});
parcelHelpers.export(exports, "numberUtils", function() {
    return _number;
});
parcelHelpers.export(exports, "objectUtils", function() {
    return _object;
});
parcelHelpers.export(exports, "stringUtils", function() {
    return _string;
});
parcelHelpers.export(exports, "urlUtils", function() {
    return _urlUtils;
});
parcelHelpers.export(exports, "utilTypes", function() {
    return _types;
});
parcelHelpers.export(exports, "validatorUtils", function() {
    return _validators;
});
parcelHelpers.export(exports, "zustandUtils", function() {
    return _zustand;
});
var _array = require("./array");
var _clipboard = require("./clipboard");
var _color = require("./color");
var _date = require("./date");
var _download = require("./download");
var _easing = require("./easing");
var _env = require("./env");
var _fetch = require("./fetch");
var _files = require("./files");
var _history = require("./history");
var _hooks = require("./hooks");
var _labeling = require("./labeling");
var _number = require("./number");
var _object = require("./object");
var _string = require("./string");
var _urlUtils = require("./url-utils");
var _validators = require("./validators");
var _zustand = require("./zustand");
var _types = require("./types");

},{"./array":"fVs5P","./clipboard":"3Ams0","./color":"l2j9z","./date":"3SdfO","./download":"K9TPk","./easing":"20UVW","./env":"iCX1d","./fetch":"jw6ys","./files":"atowU","./history":"aI0VK","./hooks":"1MmlG","./labeling":"210OC","./number":"lVXdh","./object":"87qbE","./string":"b1P0W","./url-utils":"sFJVG","./validators":"ae2ip","./zustand":"4Jm10","./types":"8Uc6P","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fVs5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reorderItem", function() {
    return reorderItem;
});
parcelHelpers.export(exports, "deleteItem", function() {
    return deleteItem;
});
parcelHelpers.export(exports, "updateItem", function() {
    return updateItem;
}) // Checks if all values are included in array - returns boolean
;
parcelHelpers.export(exports, "includesAll", function() {
    return includesAll;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function reorderItem(array, sourceIndex, destIndex) {
    if (sourceIndex === destIndex) return array;
    var items = (0, _toConsumableArray._)(array);
    var _items_splice = (0, _slicedToArray._)(items.splice(sourceIndex, 1), 1), reorderedItem = _items_splice[0];
    items.splice(destIndex, 0, reorderedItem);
    return items;
}
function deleteItem(array, targetIndex) {
    var items = (0, _toConsumableArray._)(array);
    items.splice(targetIndex, 1);
    return items;
}
function updateItem(array, targetIndex, updatedItem) {
    var items = (0, _toConsumableArray._)(array);
    items.splice(targetIndex, 1, updatedItem);
    return items;
}
function includesAll(array, values) {
    return values.every(function(v) {
        return array.includes(v);
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"94EyK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_to_consumable_array", function() {
    return _to_consumable_array;
});
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._array_without_holes)(arr) || (0, _iterableToArrayJs._iterable_to_array)(arr) || (0, _unsupportedIterableToArrayJs._unsupported_iterable_to_array)(arr) || (0, _nonIterableSpreadJs._non_iterable_spread)();
}

},{"./_array_without_holes.js":"alzjd","./_iterable_to_array.js":"3v1pg","./_non_iterable_spread.js":"ahLvp","./_unsupported_iterable_to_array.js":"Ccmcf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"alzjd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_array_without_holes", function() {
    return _array_without_holes;
});
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._array_like_to_array)(arr);
}

},{"./_array_like_to_array.js":"d20Yt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3v1pg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_iterable_to_array", function() {
    return _iterable_to_array;
});
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ahLvp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_non_iterable_spread", function() {
    return _non_iterable_spread;
});
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3Ams0":[function(require,module,exports) {
/**
 * Copies a value to the clipboard using an offscreen element and the document execCommand() method
 * compatible across all modern desktop browsers. https://caniuse.com/#feat=document-execcommand
 * @param str
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", function() {
    return copy;
});
var copy = function(str) {
    var el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    var selected;
    var selection;
    if (document.getSelection()) {
        selection = document.getSelection();
        if (selection) selected = selection.rangeCount > 0 && selection.getRangeAt(0);
    }
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    if (selected && selection) {
        selection.removeAllRanges();
        selection.addRange(selected);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l2j9z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", function() {
    return mix;
});
parcelHelpers.export(exports, "shade", function() {
    return shade;
});
parcelHelpers.export(exports, "tint", function() {
    return tint;
});
parcelHelpers.export(exports, "hexToRgb", function() {
    return hexToRgb;
});
/**
 * Takes a 3- or 6-character hex color value, and returns an object containing
 * its equivalent HSL values.
 *
 * @see {@link https://css-tricks.com/converting-color-spaces-in-javascript/}
 * @see {@link https://gist.github.com/mjackson/5311256}
 */ parcelHelpers.export(exports, "hexToHsl", function() {
    return hexToHsl;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var mix = function mix(color_1, color_2, weight) {
    function d2h(d) {
        return d.toString(16);
    }
    // convert a decimal value to hex
    function h2d(h) {
        return parseInt(h, 16);
    }
    // convert a hex value to decimal
    function s2l(hex) {
        return "".concat(hex).concat(hex);
    }
    weight = typeof weight !== "undefined" ? weight : 50; // set the weight to 50%, if that argument is omitted
    color_1 = color_1.replace(/#/g, "");
    color_2 = color_2.replace(/#/g, ""); // check if colors are shorthand or longhand - covert to longhand
    color_1 = color_1.length === 3 ? s2l(color_1) : color_1;
    color_2 = color_2.length === 3 ? s2l(color_2) : color_2;
    var color = "#";
    for(var i = 0; i <= 5; i += 2){
        // loop through each of the 3 hex pairs—red, green, and blue
        var v1 = h2d(color_1.substr(i, 2)); // extract the current pairs
        var v2 = h2d(color_2.substr(i, 2)); // combine the current pairs from each source color, according to the specified weight
        var val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));
        while(val.length < 2)val = "0" + val;
         // prepend a '0' if val results in a single digit
        color += val; // concatenate val to our new color string
    }
    return color; // PROFIT!
};
var shade = function(color, percentage) {
    return mix("#000000", color, percentage);
};
var tint = function(color, percentage) {
    return mix("#ffffff", color, percentage);
}; /**
    * Converts hex color values to rgb or rgba values if a opacity is supplied
    * @param hex
    * @returns {*}
    */ 
var hexToRgb = function(hex, opacity) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result && opacity) return "rgba(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ", ").concat(opacity, ")");
    else if (result) return "rgb(".concat(parseInt(result[1], 16), ", ").concat(parseInt(result[2], 16), ", ").concat(parseInt(result[3], 16), ")");
    return undefined;
};
function hexToHsl(hexColor) {
    var _Math, _Math1;
    // convert to 6-character hex string, if necessary
    var fullHexColor = function() {
        if (hexColor.length === 4) return "#" + hexColor.replace("#", "").split("").reduce(function(acc, char) {
            return acc += char + char;
        }, "");
        return hexColor;
    }();
    var rgbValues = {
        red: parseInt(fullHexColor.slice(1, 3), 16) / 255,
        green: parseInt(fullHexColor.slice(3, 5), 16) / 255,
        blue: parseInt(fullHexColor.slice(-2), 16) / 255
    };
    var allValues = Object.values(rgbValues);
    var channelMax = (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(allValues));
    var channelMin = (_Math1 = Math).min.apply(_Math1, (0, _toConsumableArray._)(allValues));
    var channelDelta = channelMax - channelMin;
    var hslValues = {
        hue: 0,
        saturation: 0,
        lightness: (channelMax + channelMin) / 2
    };
    if (channelDelta !== 0) {
        // calculate hue
        if (channelMax === rgbValues.red) hslValues.hue = (rgbValues.green - rgbValues.blue) / channelDelta % 6;
        else if (channelMax === rgbValues.green) hslValues.hue = (rgbValues.blue - rgbValues.red) / channelDelta + 2;
        else hslValues.hue = (rgbValues.red - rgbValues.green) / channelDelta + 4;
         // calculate saturation
        hslValues.saturation = channelDelta / (1 - Math.abs(2 * hslValues.lightness - 1));
    }
    hslValues.hue = Math.round(hslValues.hue * 60);
    hslValues.saturation = +(hslValues.saturation * 100).toFixed(0);
    hslValues.lightness = +(hslValues.lightness * 100).toFixed(0); // make negative hues positive
    if (hslValues.hue < 0) hslValues.hue += 360;
    return hslValues;
}

},{"@swc/helpers/_/_to_consumable_array":"94EyK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3SdfO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// TODO: Standardize date utilities and date format across the app (TICKET #: https://indicodata.atlassian.net/browse/UI-1003)
/**
 * Note: in order to show 30 days’ data, we need to accommodate for today, so technically
 * we need to get 29 days ago...
 */ parcelHelpers.export(exports, "getThirtyDaysAgo", function() {
    return getThirtyDaysAgo;
});
/**
 * @returns date string for the date provided, or for today.
 */ parcelHelpers.export(exports, "getToday", function() {
    return getToday;
});
parcelHelpers.export(exports, "formatDate", function() {
    return formatDate;
});
parcelHelpers.export(exports, "formatDateAndTime", function() {
    return formatDateAndTime;
});
parcelHelpers.export(exports, "formatDateAndTimeStandard", function() {
    return formatDateAndTimeStandard;
});
/**
 * @returns date string in 'yyyy-mm-dd' format
 */ parcelHelpers.export(exports, "getDateString", function() {
    return getDateString;
});
parcelHelpers.export(exports, "getDateParts", function() {
    return getDateParts;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _dateFns = require("date-fns");
function getThirtyDaysAgo(todaysDate) {
    if (todaysDate) //@ts-ignore
    return getDateString((0, _dateFns.subDays)("".concat(todaysDate, " 00:00:00"), 29));
    return getDateString((0, _dateFns.subDays)(new Date().setHours(0, 0, 0), 29));
}
function getToday(todaysDate) {
    if (todaysDate) return todaysDate;
    return getDateString(new Date(new Date().setHours(0, 0, 0)));
}
function formatDate(date) {
    return new Intl.DateTimeFormat("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric"
    }).format(date);
}
function formatDateAndTime(date) {
    return new Intl.DateTimeFormat("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    }).format(date).replace(",", "");
}
function formatDateAndTimeStandard(date) {
    return new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true
    }).format(date).replace(",", "");
}
function getDateString(date) {
    return date.toISOString().split("T")[0];
}
var getDateParts = function(date) {
    return new Intl.DateTimeFormat("en-US", {
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        year: "numeric"
    }).formatToParts(date).reduce(function(acc, part) {
        if (part.type !== "literal") return Object.assign(Object.assign({}, acc), (0, _defineProperty._)({}, part.type, (part.type === "month" || part.type === "day") && part.value.length === 1 ? "0".concat(part.value) : part.value));
        else return acc;
    }, {});
};

},{"@swc/helpers/_/_define_property":"gSu9o","date-fns":"5C5dq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5C5dq":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "addBusinessDays", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "addDays", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "addHours", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "addISOWeekYears", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "addMilliseconds", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "addMinutes", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "addMonths", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "addQuarters", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "addSeconds", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "addWeeks", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "addYears", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "areIntervalsOverlapping", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "closestIndexTo", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "closestTo", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "compareAsc", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "compareDesc", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "daysToWeeks", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "differenceInBusinessDays", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "differenceInCalendarDays", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "differenceInCalendarMonths", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "differenceInCalendarQuarters", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "differenceInCalendarWeeks", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "differenceInCalendarYears", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "differenceInDays", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "differenceInHours", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "differenceInISOWeekYears", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "differenceInMinutes", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "differenceInMonths", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "differenceInQuarters", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "differenceInSeconds", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "differenceInWeeks", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "differenceInYears", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "eachDayOfInterval", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "eachHourOfInterval", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "eachMinuteOfInterval", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "eachMonthOfInterval", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "eachQuarterOfInterval", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "eachWeekOfInterval", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "eachWeekendOfInterval", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "eachWeekendOfMonth", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "eachWeekendOfYear", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "eachYearOfInterval", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "endOfDay", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "endOfDecade", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "endOfHour", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "endOfISOWeek", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "endOfISOWeekYear", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "endOfMinute", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "endOfQuarter", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "endOfSecond", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "endOfToday", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "endOfTomorrow", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "endOfYesterday", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "formatDistance", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "formatDistanceStrict", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "formatDistanceToNow", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "formatDistanceToNowStrict", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "formatDuration", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "formatISO", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "formatISO9075", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "formatISODuration", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "formatRFC3339", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "formatRFC7231", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "formatRelative", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "fromUnixTime", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "getDate", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "getDay", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "getDayOfYear", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "getDaysInMonth", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "getDaysInYear", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "getDecade", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "getHours", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "getISODay", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "getISOWeek", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "getISOWeekYear", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "getISOWeeksInYear", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "getMilliseconds", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "getMinutes", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "getMonth", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "getQuarter", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "getSeconds", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "getTime", function() {
    return 0, _indexJsDefault92.default;
});
parcelHelpers.export(exports, "getUnixTime", function() {
    return 0, _indexJsDefault93.default;
});
parcelHelpers.export(exports, "getWeek", function() {
    return 0, _indexJsDefault94.default;
});
parcelHelpers.export(exports, "getWeekOfMonth", function() {
    return 0, _indexJsDefault95.default;
});
parcelHelpers.export(exports, "getWeekYear", function() {
    return 0, _indexJsDefault96.default;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return 0, _indexJsDefault97.default;
});
parcelHelpers.export(exports, "getYear", function() {
    return 0, _indexJsDefault98.default;
});
parcelHelpers.export(exports, "hoursToMilliseconds", function() {
    return 0, _indexJsDefault99.default;
});
parcelHelpers.export(exports, "hoursToMinutes", function() {
    return 0, _indexJsDefault100.default;
});
parcelHelpers.export(exports, "hoursToSeconds", function() {
    return 0, _indexJsDefault101.default;
});
parcelHelpers.export(exports, "intervalToDuration", function() {
    return 0, _indexJsDefault102.default;
});
parcelHelpers.export(exports, "intlFormat", function() {
    return 0, _indexJsDefault103.default;
});
parcelHelpers.export(exports, "intlFormatDistance", function() {
    return 0, _indexJsDefault104.default;
});
parcelHelpers.export(exports, "isAfter", function() {
    return 0, _indexJsDefault105.default;
});
parcelHelpers.export(exports, "isBefore", function() {
    return 0, _indexJsDefault106.default;
});
parcelHelpers.export(exports, "isDate", function() {
    return 0, _indexJsDefault107.default;
});
parcelHelpers.export(exports, "isEqual", function() {
    return 0, _indexJsDefault108.default;
});
parcelHelpers.export(exports, "isExists", function() {
    return 0, _indexJsDefault109.default;
});
parcelHelpers.export(exports, "isFirstDayOfMonth", function() {
    return 0, _indexJsDefault110.default;
});
parcelHelpers.export(exports, "isFriday", function() {
    return 0, _indexJsDefault111.default;
});
parcelHelpers.export(exports, "isFuture", function() {
    return 0, _indexJsDefault112.default;
});
parcelHelpers.export(exports, "isLastDayOfMonth", function() {
    return 0, _indexJsDefault113.default;
});
parcelHelpers.export(exports, "isLeapYear", function() {
    return 0, _indexJsDefault114.default;
});
parcelHelpers.export(exports, "isMatch", function() {
    return 0, _indexJsDefault115.default;
});
parcelHelpers.export(exports, "isMonday", function() {
    return 0, _indexJsDefault116.default;
});
parcelHelpers.export(exports, "isPast", function() {
    return 0, _indexJsDefault117.default;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return 0, _indexJsDefault118.default;
});
parcelHelpers.export(exports, "isSameHour", function() {
    return 0, _indexJsDefault119.default;
});
parcelHelpers.export(exports, "isSameISOWeek", function() {
    return 0, _indexJsDefault120.default;
});
parcelHelpers.export(exports, "isSameISOWeekYear", function() {
    return 0, _indexJsDefault121.default;
});
parcelHelpers.export(exports, "isSameMinute", function() {
    return 0, _indexJsDefault122.default;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return 0, _indexJsDefault123.default;
});
parcelHelpers.export(exports, "isSameQuarter", function() {
    return 0, _indexJsDefault124.default;
});
parcelHelpers.export(exports, "isSameSecond", function() {
    return 0, _indexJsDefault125.default;
});
parcelHelpers.export(exports, "isSameWeek", function() {
    return 0, _indexJsDefault126.default;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return 0, _indexJsDefault127.default;
});
parcelHelpers.export(exports, "isSaturday", function() {
    return 0, _indexJsDefault128.default;
});
parcelHelpers.export(exports, "isSunday", function() {
    return 0, _indexJsDefault129.default;
});
parcelHelpers.export(exports, "isThisHour", function() {
    return 0, _indexJsDefault130.default;
});
parcelHelpers.export(exports, "isThisISOWeek", function() {
    return 0, _indexJsDefault131.default;
});
parcelHelpers.export(exports, "isThisMinute", function() {
    return 0, _indexJsDefault132.default;
});
parcelHelpers.export(exports, "isThisMonth", function() {
    return 0, _indexJsDefault133.default;
});
parcelHelpers.export(exports, "isThisQuarter", function() {
    return 0, _indexJsDefault134.default;
});
parcelHelpers.export(exports, "isThisSecond", function() {
    return 0, _indexJsDefault135.default;
});
parcelHelpers.export(exports, "isThisWeek", function() {
    return 0, _indexJsDefault136.default;
});
parcelHelpers.export(exports, "isThisYear", function() {
    return 0, _indexJsDefault137.default;
});
parcelHelpers.export(exports, "isThursday", function() {
    return 0, _indexJsDefault138.default;
});
parcelHelpers.export(exports, "isToday", function() {
    return 0, _indexJsDefault139.default;
});
parcelHelpers.export(exports, "isTomorrow", function() {
    return 0, _indexJsDefault140.default;
});
parcelHelpers.export(exports, "isTuesday", function() {
    return 0, _indexJsDefault141.default;
});
parcelHelpers.export(exports, "isValid", function() {
    return 0, _indexJsDefault142.default;
});
parcelHelpers.export(exports, "isWednesday", function() {
    return 0, _indexJsDefault143.default;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return 0, _indexJsDefault144.default;
});
parcelHelpers.export(exports, "isWithinInterval", function() {
    return 0, _indexJsDefault145.default;
});
parcelHelpers.export(exports, "isYesterday", function() {
    return 0, _indexJsDefault146.default;
});
parcelHelpers.export(exports, "lastDayOfDecade", function() {
    return 0, _indexJsDefault147.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeek", function() {
    return 0, _indexJsDefault148.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeekYear", function() {
    return 0, _indexJsDefault149.default;
});
parcelHelpers.export(exports, "lastDayOfMonth", function() {
    return 0, _indexJsDefault150.default;
});
parcelHelpers.export(exports, "lastDayOfQuarter", function() {
    return 0, _indexJsDefault151.default;
});
parcelHelpers.export(exports, "lastDayOfWeek", function() {
    return 0, _indexJsDefault152.default;
});
parcelHelpers.export(exports, "lastDayOfYear", function() {
    return 0, _indexJsDefault153.default;
});
parcelHelpers.export(exports, "lightFormat", function() {
    return 0, _indexJsDefault154.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _indexJsDefault155.default;
});
parcelHelpers.export(exports, "milliseconds", function() {
    return 0, _indexJsDefault156.default;
});
parcelHelpers.export(exports, "millisecondsToHours", function() {
    return 0, _indexJsDefault157.default;
});
parcelHelpers.export(exports, "millisecondsToMinutes", function() {
    return 0, _indexJsDefault158.default;
});
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return 0, _indexJsDefault159.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _indexJsDefault160.default;
});
parcelHelpers.export(exports, "minutesToHours", function() {
    return 0, _indexJsDefault161.default;
});
parcelHelpers.export(exports, "minutesToMilliseconds", function() {
    return 0, _indexJsDefault162.default;
});
parcelHelpers.export(exports, "minutesToSeconds", function() {
    return 0, _indexJsDefault163.default;
});
parcelHelpers.export(exports, "monthsToQuarters", function() {
    return 0, _indexJsDefault164.default;
});
parcelHelpers.export(exports, "monthsToYears", function() {
    return 0, _indexJsDefault165.default;
});
parcelHelpers.export(exports, "nextDay", function() {
    return 0, _indexJsDefault166.default;
});
parcelHelpers.export(exports, "nextFriday", function() {
    return 0, _indexJsDefault167.default;
});
parcelHelpers.export(exports, "nextMonday", function() {
    return 0, _indexJsDefault168.default;
});
parcelHelpers.export(exports, "nextSaturday", function() {
    return 0, _indexJsDefault169.default;
});
parcelHelpers.export(exports, "nextSunday", function() {
    return 0, _indexJsDefault170.default;
});
parcelHelpers.export(exports, "nextThursday", function() {
    return 0, _indexJsDefault171.default;
});
parcelHelpers.export(exports, "nextTuesday", function() {
    return 0, _indexJsDefault172.default;
});
parcelHelpers.export(exports, "nextWednesday", function() {
    return 0, _indexJsDefault173.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _indexJsDefault174.default;
});
parcelHelpers.export(exports, "parseISO", function() {
    return 0, _indexJsDefault175.default;
});
parcelHelpers.export(exports, "parseJSON", function() {
    return 0, _indexJsDefault176.default;
});
parcelHelpers.export(exports, "previousDay", function() {
    return 0, _indexJsDefault177.default;
});
parcelHelpers.export(exports, "previousFriday", function() {
    return 0, _indexJsDefault178.default;
});
parcelHelpers.export(exports, "previousMonday", function() {
    return 0, _indexJsDefault179.default;
});
parcelHelpers.export(exports, "previousSaturday", function() {
    return 0, _indexJsDefault180.default;
});
parcelHelpers.export(exports, "previousSunday", function() {
    return 0, _indexJsDefault181.default;
});
parcelHelpers.export(exports, "previousThursday", function() {
    return 0, _indexJsDefault182.default;
});
parcelHelpers.export(exports, "previousTuesday", function() {
    return 0, _indexJsDefault183.default;
});
parcelHelpers.export(exports, "previousWednesday", function() {
    return 0, _indexJsDefault184.default;
});
parcelHelpers.export(exports, "quartersToMonths", function() {
    return 0, _indexJsDefault185.default;
});
parcelHelpers.export(exports, "quartersToYears", function() {
    return 0, _indexJsDefault186.default;
});
parcelHelpers.export(exports, "roundToNearestMinutes", function() {
    return 0, _indexJsDefault187.default;
});
parcelHelpers.export(exports, "secondsToHours", function() {
    return 0, _indexJsDefault188.default;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return 0, _indexJsDefault189.default;
});
parcelHelpers.export(exports, "secondsToMinutes", function() {
    return 0, _indexJsDefault190.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _indexJsDefault191.default;
});
parcelHelpers.export(exports, "setDate", function() {
    return 0, _indexJsDefault192.default;
});
parcelHelpers.export(exports, "setDay", function() {
    return 0, _indexJsDefault193.default;
});
parcelHelpers.export(exports, "setDayOfYear", function() {
    return 0, _indexJsDefault194.default;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return 0, _indexJsDefault195.default;
});
parcelHelpers.export(exports, "setHours", function() {
    return 0, _indexJsDefault196.default;
});
parcelHelpers.export(exports, "setISODay", function() {
    return 0, _indexJsDefault197.default;
});
parcelHelpers.export(exports, "setISOWeek", function() {
    return 0, _indexJsDefault198.default;
});
parcelHelpers.export(exports, "setISOWeekYear", function() {
    return 0, _indexJsDefault199.default;
});
parcelHelpers.export(exports, "setMilliseconds", function() {
    return 0, _indexJsDefault200.default;
});
parcelHelpers.export(exports, "setMinutes", function() {
    return 0, _indexJsDefault201.default;
});
parcelHelpers.export(exports, "setMonth", function() {
    return 0, _indexJsDefault202.default;
});
parcelHelpers.export(exports, "setQuarter", function() {
    return 0, _indexJsDefault203.default;
});
parcelHelpers.export(exports, "setSeconds", function() {
    return 0, _indexJsDefault204.default;
});
parcelHelpers.export(exports, "setWeek", function() {
    return 0, _indexJsDefault205.default;
});
parcelHelpers.export(exports, "setWeekYear", function() {
    return 0, _indexJsDefault206.default;
});
parcelHelpers.export(exports, "setYear", function() {
    return 0, _indexJsDefault207.default;
});
parcelHelpers.export(exports, "startOfDay", function() {
    return 0, _indexJsDefault208.default;
});
parcelHelpers.export(exports, "startOfDecade", function() {
    return 0, _indexJsDefault209.default;
});
parcelHelpers.export(exports, "startOfHour", function() {
    return 0, _indexJsDefault210.default;
});
parcelHelpers.export(exports, "startOfISOWeek", function() {
    return 0, _indexJsDefault211.default;
});
parcelHelpers.export(exports, "startOfISOWeekYear", function() {
    return 0, _indexJsDefault212.default;
});
parcelHelpers.export(exports, "startOfMinute", function() {
    return 0, _indexJsDefault213.default;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return 0, _indexJsDefault214.default;
});
parcelHelpers.export(exports, "startOfQuarter", function() {
    return 0, _indexJsDefault215.default;
});
parcelHelpers.export(exports, "startOfSecond", function() {
    return 0, _indexJsDefault216.default;
});
parcelHelpers.export(exports, "startOfToday", function() {
    return 0, _indexJsDefault217.default;
});
parcelHelpers.export(exports, "startOfTomorrow", function() {
    return 0, _indexJsDefault218.default;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return 0, _indexJsDefault219.default;
});
parcelHelpers.export(exports, "startOfWeekYear", function() {
    return 0, _indexJsDefault220.default;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return 0, _indexJsDefault221.default;
});
parcelHelpers.export(exports, "startOfYesterday", function() {
    return 0, _indexJsDefault222.default;
});
parcelHelpers.export(exports, "sub", function() {
    return 0, _indexJsDefault223.default;
});
parcelHelpers.export(exports, "subBusinessDays", function() {
    return 0, _indexJsDefault224.default;
});
parcelHelpers.export(exports, "subDays", function() {
    return 0, _indexJsDefault225.default;
});
parcelHelpers.export(exports, "subHours", function() {
    return 0, _indexJsDefault226.default;
});
parcelHelpers.export(exports, "subISOWeekYears", function() {
    return 0, _indexJsDefault227.default;
});
parcelHelpers.export(exports, "subMilliseconds", function() {
    return 0, _indexJsDefault228.default;
});
parcelHelpers.export(exports, "subMinutes", function() {
    return 0, _indexJsDefault229.default;
});
parcelHelpers.export(exports, "subMonths", function() {
    return 0, _indexJsDefault230.default;
});
parcelHelpers.export(exports, "subQuarters", function() {
    return 0, _indexJsDefault231.default;
});
parcelHelpers.export(exports, "subSeconds", function() {
    return 0, _indexJsDefault232.default;
});
parcelHelpers.export(exports, "subWeeks", function() {
    return 0, _indexJsDefault233.default;
});
parcelHelpers.export(exports, "subYears", function() {
    return 0, _indexJsDefault234.default;
});
parcelHelpers.export(exports, "toDate", function() {
    return 0, _indexJsDefault235.default;
});
parcelHelpers.export(exports, "weeksToDays", function() {
    return 0, _indexJsDefault236.default;
});
parcelHelpers.export(exports, "yearsToMonths", function() {
    return 0, _indexJsDefault237.default;
});
parcelHelpers.export(exports, "yearsToQuarters", function() {
    return 0, _indexJsDefault238.default;
});
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":"4qeKF","./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":"jnHOH","./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":"5ohnP","./addYears/index.js":"gTLL7","./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":"2peN9","./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":"960iL","./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":"2NQMZ","./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":"gOKua","./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":"lQcxt","./endOfYear/index.js":false,"./endOfYesterday/index.js":false,"./format/index.js":"eEDXQ","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":"6pJaa","./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":"k3Avt","./getWeek/index.js":"ceSxI","./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":"bkZTc","./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":"9Sl9S","./isBefore/index.js":"5wX4D","./isDate/index.js":"96OrV","./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":"1D2Bs","./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":"9aEnU","./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":"dSn4z","./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":"94xWw","./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":"3Uuhd","./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":"gvi1L","./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":"6dAh0","./parseISO/index.js":false,"./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":"e4YN4","./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":"2hnMk","./startOfDay/index.js":"6N5tx","./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":"e7svH","./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":"itpfj","./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":"b7erT","./startOfWeekYear/index.js":false,"./startOfYear/index.js":"dL29r","./startOfYesterday/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":"bTsMB","./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":false,"./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4qeKF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addDays;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"bn3Sg","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bn3Sg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toInteger;
});
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bGhwU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"8XnLL","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8XnLL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _typeof;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bga2L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return requiredArgs;
});
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hqB0a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMilliseconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"bn3Sg","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jnHOH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMonths;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"bn3Sg","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5ohnP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addWeeks;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"bn3Sg","../addDays/index.js":"4qeKF","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gTLL7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"bn3Sg","../addMonths/index.js":"jnHOH","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2peN9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarDays;
});
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"2zyBM","../startOfDay/index.js":"6N5tx","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2zyBM":[function(require,module,exports) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTimezoneOffsetInMilliseconds;
});
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6N5tx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"960iL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarMonths;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"i0vNm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarWeeks;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfWeekLeft = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, _indexJsDefault.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, _indexJsDefault1.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, _indexJsDefault1.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../startOfWeek/index.js":"b7erT","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2zyBM","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"b7erT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","../_lib/defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dsV8C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return getDefaultOptions;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return setDefaultOptions;
});
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2NQMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfISOWeek;
});
var _indexJs = require("../endOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../endOfWeek/index.js":"lQcxt","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lQcxt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfWeek;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"dsV8C","../toDate/index.js":"bGhwU","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gOKua":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eEDXQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return format;
});
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"94xWw","../subMilliseconds/index.js":"pX4GU","../toDate/index.js":"bGhwU","../_lib/format/formatters/index.js":"cOONj","../_lib/format/longFormatters/index.js":"evu3P","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2zyBM","../_lib/protectedTokens/index.js":"khSHf","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","../_lib/defaultOptions/index.js":"dsV8C","../_lib/defaultLocale/index.js":"d0nrm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"94xWw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isValid;
});
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"96OrV","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"96OrV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

},{"@babel/runtime/helpers/esm/typeof":"8XnLL","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"pX4GU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMilliseconds;
});
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"hqB0a","../_lib/requiredArgs/index.js":"bga2L","../_lib/toInteger/index.js":"bn3Sg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cOONj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"jmj3o","../../../_lib/getUTCISOWeek/index.js":"iNbeF","../../../_lib/getUTCISOWeekYear/index.js":"h4Pr6","../../../_lib/getUTCWeek/index.js":"boxKE","../../../_lib/getUTCWeekYear/index.js":"4PF3G","../../addLeadingZeros/index.js":"dt016","../lightFormatters/index.js":"kGQdX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jmj3o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCDayOfYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iNbeF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"bGhwU","../startOfUTCISOWeek/index.js":"28zSQ","../startOfUTCISOWeekYear/index.js":"btiXR","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"28zSQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"btiXR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeekYear;
});
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"h4Pr6","../startOfUTCISOWeek/index.js":"28zSQ","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"h4Pr6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","../startOfUTCISOWeek/index.js":"28zSQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"boxKE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"bGhwU","../startOfUTCWeek/index.js":"6rY4C","../startOfUTCWeekYear/index.js":"3znxD","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6rY4C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","../toInteger/index.js":"bn3Sg","../defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3znxD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeekYear;
});
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"4PF3G","../requiredArgs/index.js":"bga2L","../startOfUTCWeek/index.js":"6rY4C","../toInteger/index.js":"bn3Sg","../defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4PF3G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","../startOfUTCWeek/index.js":"6rY4C","../toInteger/index.js":"bn3Sg","../defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dt016":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addLeadingZeros;
});
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kGQdX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"dt016","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"evu3P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"khSHf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", function() {
    return isProtectedDayOfYearToken;
});
parcelHelpers.export(exports, "isProtectedWeekYearToken", function() {
    return isProtectedWeekYearToken;
});
parcelHelpers.export(exports, "throwProtectedError", function() {
    return throwProtectedError;
});
var protectedDayOfYearTokens = [
    "D",
    "DD"
];
var protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d0nrm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"lCNzB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lCNzB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: "en-US",
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jgGeh","./_lib/formatLong/index.js":"64ECZ","./_lib/formatRelative/index.js":"gnymU","./_lib/localize/index.js":"lEZ0r","./_lib/match/index.js":"14Sfs","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jgGeh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"64ECZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"bmyA3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bmyA3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildFormatLongFn;
});
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gnymU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lEZ0r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"8EYaV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8EYaV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildLocalizeFn;
});
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"14Sfs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"aT5d9","../../../_lib/buildMatchPatternFn/index.js":"5auES","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aT5d9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchFn;
});
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5auES":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchPatternFn;
});
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9reSU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDaysInMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6pJaa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"bGhwU","../startOfISOWeek/index.js":"e7svH","../startOfISOWeekYear/index.js":"2NMPS","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e7svH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"b7erT","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2NMPS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeekYear;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"iAMoo","../startOfISOWeek/index.js":"e7svH","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iAMoo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeekYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"bGhwU","../startOfISOWeek/index.js":"e7svH","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hPEU7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTime;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k3Avt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUnixTime;
});
var _indexJs = require("../getTime/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getUnixTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return Math.floor((0, _indexJsDefault.default)(dirtyDate) / 1000);
}

},{"../getTime/index.js":"hPEU7","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ceSxI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeekYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var diff = (0, _indexJsDefault.default)(date, options).getTime() - (0, _indexJsDefault1.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../startOfWeek/index.js":"b7erT","../startOfWeekYear/index.js":"huUjO","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"huUjO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfWeekYear;
});
var _indexJs = require("../getWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function startOfWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(firstWeek, options);
    return date;
}

},{"../getWeekYear/index.js":"M1ufl","../startOfWeek/index.js":"b7erT","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","../_lib/defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"M1ufl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeekYear;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function getWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../startOfWeek/index.js":"b7erT","../toDate/index.js":"bGhwU","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","../_lib/defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bkZTc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeeksInMonth;
});
var _indexJs = require("../differenceInCalendarWeeks/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../lastDayOfMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function getWeeksInMonth(date, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    return (0, _indexJsDefault.default)((0, _indexJsDefault1.default)(date), (0, _indexJsDefault2.default)(date), options) + 1;
}

},{"../differenceInCalendarWeeks/index.js":"i0vNm","../lastDayOfMonth/index.js":"3nucd","../startOfMonth/index.js":"itpfj","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3nucd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"itpfj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9Sl9S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAfter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5wX4D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isBefore;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1D2Bs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameDay;
});
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"6N5tx","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9aEnU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dSn4z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3Uuhd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return max;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"8XnLL","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gvi1L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return min;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"8XnLL","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6dAh0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parse;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"8XnLL","@babel/runtime/helpers/esm/createForOfIteratorHelper":"5B06t","../_lib/defaultLocale/index.js":"d0nrm","../subMilliseconds/index.js":"pX4GU","../toDate/index.js":"bGhwU","../_lib/assign/index.js":"f3qUu","../_lib/format/longFormatters/index.js":"evu3P","../_lib/getTimezoneOffsetInMilliseconds/index.js":"2zyBM","../_lib/protectedTokens/index.js":"khSHf","../_lib/toInteger/index.js":"bn3Sg","../_lib/requiredArgs/index.js":"bga2L","./_lib/Setter.js":"7Bpep","./_lib/parsers/index.js":"2oCHL","../_lib/defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5B06t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createForOfIteratorHelper;
});
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, _unsupportedIterableToArrayJsDefault.default)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"3xIpU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3xIpU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _unsupportedIterableToArray;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJsDefault.default)(o, minLen);
}

},{"./arrayLikeToArray.js":"7Z7Xh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Z7Xh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayLikeToArray;
});
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f3qUu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return assign;
});
function assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Bpep":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", function() {
    return Setter;
});
parcelHelpers.export(exports, "ValueSetter", function() {
    return ValueSetter;
});
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", function() {
    return DateToSystemTimezoneSetter;
});
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/defineProperty":"daOmd","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3OH7C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _assertThisInitialized;
});
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"50XNH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"kg9ht","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kg9ht":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _setPrototypeOf;
});
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hMpTf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createSuper;
});
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJsDefault.default)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJsDefault.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, result);
    };
}

},{"./getPrototypeOf.js":"jdYk1","./isNativeReflectConstruct.js":"1lPNR","./possibleConstructorReturn.js":"Ty6gP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jdYk1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _getPrototypeOf;
});
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1lPNR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isNativeReflectConstruct;
});
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Ty6gP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _possibleConstructorReturn;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeofJsDefault.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(self);
}

},{"./typeof.js":"8XnLL","./assertThisInitialized.js":"3OH7C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6xwAy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _classCallCheck;
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"h0HMR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createClass;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _toPropertyKeyJsDefault.default)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

},{"./toPropertyKey.js":"5xcQi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5xcQi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPropertyKey;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"8XnLL","./toPrimitive.js":"9YwpS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9YwpS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPrimitive;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"8XnLL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"daOmd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _defineProperty;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(obj, key, value) {
    key = (0, _toPropertyKeyJsDefault.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"./toPropertyKey.js":"5xcQi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2oCHL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", function() {
    return parsers;
});
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"hIc7Z","./YearParser.js":"8oDeX","./LocalWeekYearParser.js":"dpA92","./ISOWeekYearParser.js":"6FkNv","./ExtendedYearParser.js":"jMPJR","./QuarterParser.js":"eBTvW","./StandAloneQuarterParser.js":"fRDrt","./MonthParser.js":"lypUV","./StandAloneMonthParser.js":"2TRFY","./LocalWeekParser.js":"l1aBe","./ISOWeekParser.js":"kWpph","./DateParser.js":"lapfa","./DayOfYearParser.js":"5iV3h","./DayParser.js":"lEATn","./LocalDayParser.js":"gJfH9","./StandAloneLocalDayParser.js":"36q9V","./ISODayParser.js":"5GAzI","./AMPMParser.js":"jbEY0","./AMPMMidnightParser.js":"eow1p","./DayPeriodParser.js":"lhFRL","./Hour1to12Parser.js":"jZfG7","./Hour0to23Parser.js":"3BmaA","./Hour0To11Parser.js":"gDCW2","./Hour1To24Parser.js":"jy7Zm","./MinuteParser.js":"iQH9v","./SecondParser.js":"3daup","./FractionOfSecondParser.js":"fU5Ba","./ISOTimezoneWithZParser.js":"iEcPJ","./ISOTimezoneParser.js":"4Rx81","./TimestampSecondsParser.js":"lMuzk","./TimestampMillisecondsParser.js":"iZErn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hIc7Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", function() {
    return EraParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bI71w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/defineProperty":"daOmd","./Setter.js":"7Bpep","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8oDeX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", function() {
    return YearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2B44b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", function() {
    return mapValue;
});
parcelHelpers.export(exports, "parseNumericPattern", function() {
    return parseNumericPattern;
});
parcelHelpers.export(exports, "parseTimezonePattern", function() {
    return parseTimezonePattern;
});
parcelHelpers.export(exports, "parseAnyDigitsSigned", function() {
    return parseAnyDigitsSigned;
});
parcelHelpers.export(exports, "parseNDigits", function() {
    return parseNDigits;
});
parcelHelpers.export(exports, "parseNDigitsSigned", function() {
    return parseNDigitsSigned;
});
parcelHelpers.export(exports, "dayPeriodEnumToHours", function() {
    return dayPeriodEnumToHours;
});
parcelHelpers.export(exports, "normalizeTwoDigitYear", function() {
    return normalizeTwoDigitYear;
});
parcelHelpers.export(exports, "isLeapYearIndex", function() {
    return isLeapYearIndex;
});
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"fE10S","./constants.js":"4c6ow","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fE10S":[function(require,module,exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4c6ow":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", function() {
    return numericPatterns;
});
parcelHelpers.export(exports, "timezonePatterns", function() {
    return timezonePatterns;
});
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dpA92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", function() {
    return LocalWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","../../../_lib/getUTCWeekYear/index.js":"4PF3G","../../../_lib/startOfUTCWeek/index.js":"6rY4C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6FkNv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", function() {
    return ISOWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","../../../_lib/startOfUTCISOWeek/index.js":"28zSQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jMPJR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", function() {
    return ExtendedYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eBTvW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", function() {
    return QuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fRDrt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", function() {
    return StandAloneQuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lypUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", function() {
    return MonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../utils.js":"2B44b","../Parser.js":"bI71w","../constants.js":"4c6ow","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2TRFY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", function() {
    return StandAloneMonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l1aBe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", function() {
    return LocalWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","../../../_lib/setUTCWeek/index.js":"bNqUH","../../../_lib/startOfUTCWeek/index.js":"6rY4C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bNqUH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"bn3Sg","../../toDate/index.js":"bGhwU","../getUTCWeek/index.js":"boxKE","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kWpph":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", function() {
    return ISOWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","../../../_lib/setUTCISOWeek/index.js":"p9NuS","../../../_lib/startOfUTCISOWeek/index.js":"28zSQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"p9NuS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISOWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"bn3Sg","../../toDate/index.js":"bGhwU","../getUTCISOWeek/index.js":"iNbeF","../requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lapfa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", function() {
    return DateParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../utils.js":"2B44b","../Parser.js":"bI71w","../constants.js":"4c6ow","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5iV3h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", function() {
    return DayOfYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lEATn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", function() {
    return DayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../../../_lib/setUTCDay/index.js":"8cfnh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8cfnh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCDay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","../toInteger/index.js":"bn3Sg","../defaultOptions/index.js":"dsV8C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gJfH9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", function() {
    return LocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","../../../_lib/setUTCDay/index.js":"8cfnh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"36q9V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", function() {
    return StandAloneLocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","../../../_lib/setUTCDay/index.js":"8cfnh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5GAzI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", function() {
    return ISODayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","../../../_lib/setUTCISODay/index.js":"eOEgY","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eOEgY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISODay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"bGhwU","../requiredArgs/index.js":"bga2L","../toInteger/index.js":"bn3Sg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jbEY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", function() {
    return AMPMParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eow1p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", function() {
    return AMPMMidnightParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lhFRL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", function() {
    return DayPeriodParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jZfG7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", function() {
    return Hour1to12Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3BmaA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", function() {
    return Hour0to23Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gDCW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", function() {
    return Hour0To11Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jy7Zm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", function() {
    return Hour1To24Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iQH9v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", function() {
    return MinuteParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3daup":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", function() {
    return SecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fU5Ba":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", function() {
    return FractionOfSecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iEcPJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", function() {
    return ISOTimezoneWithZParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4Rx81":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", function() {
    return ISOTimezoneParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../constants.js":"4c6ow","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lMuzk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", function() {
    return TimestampSecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iZErn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", function() {
    return TimestampMillisecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/assertThisInitialized":"3OH7C","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/defineProperty":"daOmd","../Parser.js":"bI71w","../utils.js":"2B44b","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e4YN4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMonth;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"bn3Sg","../toDate/index.js":"bGhwU","../getDaysInMonth/index.js":"9reSU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2hnMk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setYear;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"bn3Sg","../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dL29r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"bGhwU","../_lib/requiredArgs/index.js":"bga2L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bTsMB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subDays;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"4qeKF","../_lib/requiredArgs/index.js":"bga2L","../_lib/toInteger/index.js":"bn3Sg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"K9TPk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Trigger a file download programmatically by creating and utilizing a temporary `<a>` element.
 *
 * @example
 * downloadFile('https://dev.indico.io/my-file.csv')
 */ parcelHelpers.export(exports, "downloadFile", function() {
    return downloadFile;
});
parcelHelpers.export(exports, "downloadBlobFile", function() {
    return downloadBlobFile;
});
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function downloadFile(downloadUrl, filename) {
    var linkEl = document.createElement("a");
    linkEl.setAttribute("target", "_blank");
    linkEl.setAttribute("href", downloadUrl);
    linkEl.setAttribute("download", filename !== null && filename !== void 0 ? filename : "");
    linkEl.style.display = "none";
    document.body.appendChild(linkEl);
    linkEl.click();
    document.body.removeChild(linkEl);
}
function downloadBlobFile(downloadUrl, filename) {
    return __awaiter(this, void 0, void 0, function() {
        var response, blob, blobUrl, linkEl, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(downloadUrl)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) throw new Error("Failed to fetch file");
                    return [
                        4,
                        response.blob()
                    ];
                case 2:
                    blob = _state.sent();
                    blobUrl = URL.createObjectURL(blob);
                    linkEl = document.createElement("a");
                    linkEl.setAttribute("target", "_blank");
                    linkEl.setAttribute("href", blobUrl);
                    linkEl.setAttribute("download", filename !== null && filename !== void 0 ? filename : "");
                    linkEl.style.display = "none";
                    document.body.appendChild(linkEl);
                    linkEl.click();
                    document.body.removeChild(linkEl);
                    URL.revokeObjectURL(blobUrl);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Download failed:", error);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}

},{"@swc/helpers/_/_ts_generator":"HrSs8","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"20UVW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Linear", function() {
    return Linear;
});
parcelHelpers.export(exports, "Quadratic", function() {
    return Quadratic;
});
parcelHelpers.export(exports, "Cubic", function() {
    return Cubic;
});
parcelHelpers.export(exports, "Quartic", function() {
    return Quartic;
});
parcelHelpers.export(exports, "Quintic", function() {
    return Quintic;
});
parcelHelpers.export(exports, "Sinusoidal", function() {
    return Sinusoidal;
});
parcelHelpers.export(exports, "Exponential", function() {
    return Exponential;
});
parcelHelpers.export(exports, "Circular", function() {
    return Circular;
});
parcelHelpers.export(exports, "Elastic", function() {
    return Elastic;
});
parcelHelpers.export(exports, "Back", function() {
    return Back;
});
parcelHelpers.export(exports, "Bounce", function() {
    return Bounce;
});
parcelHelpers.export(exports, "Stepped", function() {
    return Stepped;
});
var Linear = {
    None: function(k) {
        return k;
    }
};
var Quadratic = {
    /**
   * @return {number}
   */ In: function(k) {
        return k * k;
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return k * (2 - k);
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    }
};
var Cubic = {
    /**
   * @return {number}
   */ In: function(k) {
        return k * k * k;
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return --k * k * k + 1;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    }
};
var Quartic = {
    /**
   * @return {number}
   */ In: function(k) {
        return k * k * k * k;
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return 1 - --k * k * k * k;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    }
};
var Quintic = {
    /**
   * @return {number}
   */ In: function(k) {
        return k * k * k * k * k;
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return --k * k * k * k * k + 1;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    }
};
var Sinusoidal = {
    /**
   * @return {number}
   */ In: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    }
};
var Exponential = {
    /**
   * @return {number}
   */ In: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    }
};
var Circular = {
    /**
   * @return {number}
   */ In: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    }
};
var Elastic = {
    /**
   * @return {number}
   */ In: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        k *= 2;
        if (k < 1) return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
        return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
    }
};
var Back = {
    /**
   * @return {number}
   */ In: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    }
};
var Bounce = {
    /**
   * @return {number}
   */ In: function(k) {
        return 1 - this.Out(1 - k);
    },
    /**
   * @return {number}
   */ Out: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    /**
   * @return {number}
   */ InOut: function(k) {
        if (k < 0.5) return this.In(k * 2) * 0.5;
        return this.Out(k * 2 - 1) * 0.5 + 0.5;
    }
};
var Stepped = {
    steps: function(steps) {
        return function(k) {
            return (k * steps | 0) / steps;
        };
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iCX1d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDevEnv", function() {
    return isDevEnv;
});
parcelHelpers.export(exports, "isTestEnv", function() {
    return isTestEnv;
});
parcelHelpers.export(exports, "getApiHost", function() {
    return getApiHost;
});
var DEFAULT_API_HOST = "https://dev-ci.us-east-2.indico-dev.indico.io";
var isDevEnv = function() {
    var env = "production";
    return env !== "production" && env !== "test";
};
var isTestEnv = function() {
    var env = "production";
    return env === "test";
};
var getApiHost = function() {
    if (isDevEnv()) return DEFAULT_API_HOST;
    else return window.location.origin;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jw6ys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchAPI", function() {
    return fetchAPI;
});
parcelHelpers.export(exports, "getAuthJSON", function() {
    return getAuthJSON;
});
parcelHelpers.export(exports, "postAuthJSON", function() {
    return postAuthJSON;
});
parcelHelpers.export(exports, "putAuthJSON", function() {
    return putAuthJSON;
});
parcelHelpers.export(exports, "deleteAuthJSON", function() {
    return deleteAuthJSON;
});
parcelHelpers.export(exports, "getCurrentUser", function() {
    return getCurrentUser;
});
parcelHelpers.export(exports, "getCycloneJSON", function() {
    return getCycloneJSON;
});
parcelHelpers.export(exports, "postCycloneJSON", function() {
    return postCycloneJSON;
});
parcelHelpers.export(exports, "postCycloneFile", function() {
    return postCycloneFile;
});
parcelHelpers.export(exports, "putCycloneJSON", function() {
    return putCycloneJSON;
});
parcelHelpers.export(exports, "deleteCycloneJSON", function() {
    return deleteCycloneJSON;
});
parcelHelpers.export(exports, "getMoonbowJSON", function() {
    return getMoonbowJSON;
});
parcelHelpers.export(exports, "postMoonbowJSON", function() {
    return postMoonbowJSON;
});
parcelHelpers.export(exports, "putMoonbowJSON", function() {
    return putMoonbowJSON;
});
parcelHelpers.export(exports, "deleteMoonbowJSON", function() {
    return deleteMoonbowJSON;
});
parcelHelpers.export(exports, "getCrowdlabelJSON", function() {
    return getCrowdlabelJSON;
});
parcelHelpers.export(exports, "postCrowdlabelJSON", function() {
    return postCrowdlabelJSON;
});
parcelHelpers.export(exports, "putCrowdlabelJSON", function() {
    return putCrowdlabelJSON;
});
parcelHelpers.export(exports, "deleteCrowdlabelJSON", function() {
    return deleteCrowdlabelJSON;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _whatwgFetch = require("whatwg-fetch");
var _merge = require("lodash/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var headers = function() {
    return Object.assign({
        "Content-Type": "application/json",
        Accept: "application/json"
    });
};
var fetchAPI = function(endpoint) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, domain = arguments.length > 2 ? arguments[2] : void 0, formMultiPart = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var fetchConfig = (0, _mergeDefault.default)({}, {
        method: "GET",
        headers: headers(),
        credentials: "include"
    }, options);
    // In order for multipart form boundries to work, we must let the browser set this header
    if (formMultiPart) delete fetchConfig.headers["Content-Type"];
    return fetch("".concat(domain).concat(endpoint), fetchConfig).catch(function(error) {
        return Promise.reject("Server Unavailable:", error);
    }).then(function(response) {
        if (response.status === 204) // Do not attempt to parse the response for
        // no content responses
        return response;
        var contentType = response.headers.get("Content-Type") || "";
        var isJSON = contentType.indexOf("application/json") > -1;
        var promise = isJSON ? response.json() : response.blob();
        return promise.then(function(payload) {
            // Need to pass in url when a 401 is returned mainly because there is app logic
            // around redirecting the user back to where they were originally trying to go
            // after they login
            if (response.status === 401) return Promise.reject({
                status: response.status,
                url: window.location.href,
                error_type: payload.error_type
            });
            else if ([
                400,
                403,
                404,
                500,
                504,
                413
            ].indexOf(response.status) > -1) {
                /*
          400: bad request
          403: forbidden (we know who you are, but you don't have permission)
          401: bad authentication or missing auth
        */ // eslint-disable-next-line no-console
                console.log("payload:", payload); // eslint-disable-next-line no-console
                console.log("response", response);
                return Promise.reject({
                    status: response.status,
                    error_type: payload.error_type,
                    message: payload.message
                });
            }
            if (response.ok) return payload;
            else return Promise.reject("Error:", payload);
        });
    });
};
// Auth API
var authAPI = function(endpoint, options) {
    return fetchAPI(endpoint, options, (0, _getDefault.default)(window, "indico.appURLs.AuthURL"));
};
var getAuthJSON = authAPI;
var postAuthJSON = function(endpoint, XSRFToken) {
    var body = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return authAPI(endpoint, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "X-XSRFToken": XSRFToken
        }
    });
};
var putAuthJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return authAPI(endpoint, {
        method: "PUT",
        body: JSON.stringify(body)
    });
};
var deleteAuthJSON = function(endpoint, XSRFToken) {
    return authAPI(endpoint, {
        method: "DELETE",
        headers: {
            "X-XSRFToken": XSRFToken
        }
    });
};
var getCurrentUser = function() {
    return authAPI("/users/details");
}; // Sharknado
var cycloneAPI = function(endpoint, options) {
    return fetchAPI(endpoint, options, (0, _getDefault.default)(window, "indico.appURLs.CycloneURL"));
};
var cycloneMultiPartAPI = function(endpoint, options) {
    return fetchAPI(endpoint, options, (0, _getDefault.default)(window, "indico.appURLs.StorageURL"), true);
};
var getCycloneJSON = cycloneAPI;
var postCycloneJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return cycloneAPI(endpoint, {
        method: "POST",
        body: JSON.stringify(body)
    });
};
var postCycloneFile = function(endpoint, fileObj) {
    return Promise.all(fileObj.map(function(file) {
        var formData = new FormData();
        formData.append("file0", file);
        return cycloneMultiPartAPI(endpoint, {
            method: "POST",
            body: formData,
            fileFailureMeta: file
        });
    })).then(function(r) {
        return r.reduce(function(arr, fileArr) {
            var _arr;
            (_arr = arr).push.apply(_arr, (0, _toConsumableArray._)(fileArr));
            return arr;
        }, []);
    });
};
var putCycloneJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return cycloneAPI(endpoint, {
        method: "PUT",
        body: JSON.stringify(body)
    });
};
var deleteCycloneJSON = function(endpoint) {
    return cycloneAPI(endpoint, {
        method: "DELETE"
    });
}; // Moonbow
var moonbowAPI = function(endpoint, options) {
    return fetchAPI(endpoint, options, (0, _getDefault.default)(window, "indico.appURLs.MoonbowURL"));
};
var getMoonbowJSON = moonbowAPI;
var postMoonbowJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return moonbowAPI(endpoint, {
        method: "POST",
        body: JSON.stringify(body)
    });
};
var putMoonbowJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return moonbowAPI(endpoint, {
        method: "PUT",
        body: JSON.stringify(body)
    });
};
var deleteMoonbowJSON = function(endpoint) {
    return moonbowAPI(endpoint, {
        method: "DELETE"
    });
}; // Crowdlabel
var crowdlabelAPI = function(endpoint, options) {
    return fetchAPI(endpoint, options, (0, _getDefault.default)(window, "indico.appURLs.CrowdlabelURL"));
};
var getCrowdlabelJSON = crowdlabelAPI;
var postCrowdlabelJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return crowdlabelAPI(endpoint, {
        method: "POST",
        body: JSON.stringify(body)
    });
};
var putCrowdlabelJSON = function(endpoint) {
    var body = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return crowdlabelAPI(endpoint, {
        method: "PUT",
        body: JSON.stringify(body)
    });
};
var deleteCrowdlabelJSON = function(endpoint) {
    return crowdlabelAPI(endpoint, {
        method: "DELETE"
    });
};

},{"@swc/helpers/_/_to_consumable_array":"94EyK","whatwg-fetch":"leEda","lodash/merge":"ayeQR","lodash/get":"9bodu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"leEda":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Headers", function() {
    return Headers;
});
parcelHelpers.export(exports, "Request", function() {
    return Request;
});
parcelHelpers.export(exports, "Response", function() {
    return Response;
});
parcelHelpers.export(exports, "DOMException", function() {
    return DOMException;
});
parcelHelpers.export(exports, "fetch", function() {
    return fetch;
});
var global = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof global !== "undefined" && global;
var support = {
    searchParams: "URLSearchParams" in global,
    iterable: "Symbol" in global && "iterator" in Symbol,
    blob: "FileReader" in global && "Blob" in global && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in global,
    arrayBuffer: "ArrayBuffer" in global
};
function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if (support.arrayBuffer) {
    var viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError("Invalid character in header field name");
    return name.toLowerCase();
}
function normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function iteratorFor(items) {
    var iterator = {
        next: function next() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if (support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function Headers(headers) {
    this.map = {};
    if (headers instanceof Headers) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
Headers.prototype["delete"] = function(name) {
    delete this.map[normalizeName(name)];
};
Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name));
};
Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
};
Headers.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return iteratorFor(items);
};
Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return iteratorFor(items);
};
Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return iteratorFor(items);
};
if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
function consumed(body) {
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise;
}
function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) this._bodyText = "";
        else if (typeof body === "string") this._bodyText = body;
        else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if (support.arrayBuffer && support.blob && isDataView(body)) {
            this._bodyArrayBuffer = bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if (support.blob) {
        this.blob = function() {
            var rejected = consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = consumed(this);
                if (isConsumed) return isConsumed;
                if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else return this.blob().then(readBlobAsArrayBuffer);
        };
    }
    this.text = function() {
        var rejected = consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if (support.formData) this.formData = function() {
        return this.text().then(decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var methods = [
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "POST",
    "PUT"
];
function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
    if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof Request) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new Headers(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new Headers(options.headers);
    this.method = normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
Request.prototype.clone = function() {
    return new Request(this, {
        body: this._bodyInit
    });
};
function decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            headers.append(key, value);
        }
    });
    return headers;
}
Body.call(Request.prototype);
function Response(bodyInit, options) {
    if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = "statusText" in options ? options.statusText : "";
    this.headers = new Headers(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
Body.call(Response.prototype);
Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
    });
};
Response.error = function() {
    var response = new Response(null, {
        status: 0,
        statusText: ""
    });
    response.type = "error";
    return response;
};
var redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new Response(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var DOMException = global.DOMException;
try {
    new DOMException();
} catch (err) {
    DOMException = function DOMException(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    DOMException.prototype = Object.create(Error.prototype);
    DOMException.prototype.constructor = DOMException;
}
function fetch(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new Request(input, init);
        if (request.signal && request.signal.aborted) return reject(new DOMException("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new Response(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new DOMException("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && global.location.href ? global.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if (support.blob) xhr.responseType = "blob";
            else if (support.arrayBuffer && request.headers.get("Content-Type") && request.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) Object.getOwnPropertyNames(init.headers).forEach(function(name) {
            xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
        else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
fetch.polyfill = true;
if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ayeQR":[function(require,module,exports) {
var baseMerge = require("4df9f9792aa6cec5"), createAssigner = require("1a093bd17b750da8");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"4df9f9792aa6cec5":"lLrOC","1a093bd17b750da8":"6DFZ5"}],"lLrOC":[function(require,module,exports) {
var Stack = require("7d801947da180c81"), assignMergeValue = require("e7989ae028a4dc3"), baseFor = require("df7f58ebcaae4c80"), baseMergeDeep = require("f2c559c2f7ee2150"), isObject = require("b5da6ce620046bcd"), keysIn = require("61f7a6df657066e"), safeGet = require("39430d3620567324");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"7d801947da180c81":"ddAbE","e7989ae028a4dc3":"12ntE","df7f58ebcaae4c80":"8BcKE","f2c559c2f7ee2150":"3Ae5E","b5da6ce620046bcd":"lMTBq","61f7a6df657066e":"c9Yxy","39430d3620567324":"hocKX"}],"ddAbE":[function(require,module,exports) {
var ListCache = require("25700fefc7317c08"), stackClear = require("ecbe6a478b25634b"), stackDelete = require("20f8458c04af9ffc"), stackGet = require("9a6f9fa4bf7e6979"), stackHas = require("bc7ceda7bcd6ed7a"), stackSet = require("5586df6d4932b493");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"25700fefc7317c08":"kHnCw","ecbe6a478b25634b":"ivW7N","20f8458c04af9ffc":"5Zsr7","9a6f9fa4bf7e6979":"g6yPr","bc7ceda7bcd6ed7a":"8Ohqc","5586df6d4932b493":"eSBVA"}],"kHnCw":[function(require,module,exports) {
var listCacheClear = require("d474c405e559aa7b"), listCacheDelete = require("4c5031628fe230a6"), listCacheGet = require("58f1997fcbb63a9c"), listCacheHas = require("3ad19ff48500a67"), listCacheSet = require("eb86ae2ffa76e1d5");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"d474c405e559aa7b":"f9kTC","4c5031628fe230a6":"9sADa","58f1997fcbb63a9c":"hYbij","3ad19ff48500a67":"6Epjl","eb86ae2ffa76e1d5":"iBHnE"}],"f9kTC":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"9sADa":[function(require,module,exports) {
var assocIndexOf = require("1dd4645b7f683e23");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"1dd4645b7f683e23":"kxgo5"}],"kxgo5":[function(require,module,exports) {
var eq = require("bb540093df272ca6");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"bb540093df272ca6":"2ZfGW"}],"2ZfGW":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"hYbij":[function(require,module,exports) {
var assocIndexOf = require("46eeaac314d2385b");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"46eeaac314d2385b":"kxgo5"}],"6Epjl":[function(require,module,exports) {
var assocIndexOf = require("103f0de6265d6947");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"103f0de6265d6947":"kxgo5"}],"iBHnE":[function(require,module,exports) {
var assocIndexOf = require("839428b73584b324");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"839428b73584b324":"kxgo5"}],"ivW7N":[function(require,module,exports) {
var ListCache = require("1a19c2117d3c8be6");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"1a19c2117d3c8be6":"kHnCw"}],"5Zsr7":[function(require,module,exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"g6yPr":[function(require,module,exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"8Ohqc":[function(require,module,exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"eSBVA":[function(require,module,exports) {
var ListCache = require("46b181cefc42ded2"), Map = require("83bd9bdda7deef30"), MapCache = require("171e8953a87b5c93");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"46b181cefc42ded2":"kHnCw","83bd9bdda7deef30":"kbs7M","171e8953a87b5c93":"85pTo"}],"kbs7M":[function(require,module,exports) {
var getNative = require("729b50a663ba6a0f"), root = require("95e62bcfca134836");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"729b50a663ba6a0f":"c4FjT","95e62bcfca134836":"kwR0A"}],"c4FjT":[function(require,module,exports) {
var baseIsNative = require("281020b602037c8b"), getValue = require("84a3976cc8e4434d");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"281020b602037c8b":"7wqzk","84a3976cc8e4434d":"lbRt4"}],"7wqzk":[function(require,module,exports) {
var isFunction = require("321e83535782d257"), isMasked = require("b5d850e2274bfdcc"), isObject = require("ee74c1ba722ad1a5"), toSource = require("b625b57865a25863");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"321e83535782d257":"eQfSK","b5d850e2274bfdcc":"4aWxb","ee74c1ba722ad1a5":"lMTBq","b625b57865a25863":"hQ9dn"}],"eQfSK":[function(require,module,exports) {
var baseGetTag = require("89a5dffca0a9a31d"), isObject = require("80e72e5a923916b6");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"89a5dffca0a9a31d":"6xUuq","80e72e5a923916b6":"lMTBq"}],"6xUuq":[function(require,module,exports) {
var Symbol = require("f86d6750b12ddd47"), getRawTag = require("61f09dd9527017a6"), objectToString = require("78e6d88ca54ba20a");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"f86d6750b12ddd47":"ircXK","61f09dd9527017a6":"fwgXq","78e6d88ca54ba20a":"9g5Pg"}],"ircXK":[function(require,module,exports) {
var root = require("ce9f666c98b5ea56");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"ce9f666c98b5ea56":"kwR0A"}],"kwR0A":[function(require,module,exports) {
var freeGlobal = require("2808e6444106e6b");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"2808e6444106e6b":"iGLhr"}],"iGLhr":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"fwgXq":[function(require,module,exports) {
var Symbol = require("94e0f8480200df9f");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"94e0f8480200df9f":"ircXK"}],"9g5Pg":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"lMTBq":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"4aWxb":[function(require,module,exports) {
var coreJsData = require("41a1c0da8eca845d");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"41a1c0da8eca845d":"cmKS7"}],"cmKS7":[function(require,module,exports) {
var root = require("8362e8c8fa8864cb");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"8362e8c8fa8864cb":"kwR0A"}],"hQ9dn":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"lbRt4":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"85pTo":[function(require,module,exports) {
var mapCacheClear = require("bf6f579c88763758"), mapCacheDelete = require("f13ea8809aed8394"), mapCacheGet = require("daf14094d4eeb2c2"), mapCacheHas = require("bf86c85fa02ec549"), mapCacheSet = require("23c22bdf96911c50");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"bf6f579c88763758":"pKTxy","f13ea8809aed8394":"a8sF7","daf14094d4eeb2c2":"j80cA","bf86c85fa02ec549":"esBd7","23c22bdf96911c50":"f2i2Y"}],"pKTxy":[function(require,module,exports) {
var Hash = require("6e51aeaf070b9233"), ListCache = require("f6681b3b73b0bc94"), Map = require("93c5b4baa7af0406");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"6e51aeaf070b9233":"hVYO2","f6681b3b73b0bc94":"kHnCw","93c5b4baa7af0406":"kbs7M"}],"hVYO2":[function(require,module,exports) {
var hashClear = require("98d2a4ffc62bd88a"), hashDelete = require("fd2aba5f088966ac"), hashGet = require("217c11aa90fb974"), hashHas = require("3f0bd64d06bab719"), hashSet = require("8999299a73ffb310");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"98d2a4ffc62bd88a":"hNl0Z","fd2aba5f088966ac":"4LAZ5","217c11aa90fb974":"l96NR","3f0bd64d06bab719":"7LamX","8999299a73ffb310":"g7w3d"}],"hNl0Z":[function(require,module,exports) {
var nativeCreate = require("aabaedfee63d7bdc");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"aabaedfee63d7bdc":"jLMIU"}],"jLMIU":[function(require,module,exports) {
var getNative = require("c56a2bdf586a3f9a");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"c56a2bdf586a3f9a":"c4FjT"}],"4LAZ5":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"l96NR":[function(require,module,exports) {
var nativeCreate = require("2521e4fde249dc5c");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"2521e4fde249dc5c":"jLMIU"}],"7LamX":[function(require,module,exports) {
var nativeCreate = require("b300cb2ec6a34bb2");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"b300cb2ec6a34bb2":"jLMIU"}],"g7w3d":[function(require,module,exports) {
var nativeCreate = require("33783d107d0f3f2c");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"33783d107d0f3f2c":"jLMIU"}],"a8sF7":[function(require,module,exports) {
var getMapData = require("50ade918631a545b");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"50ade918631a545b":"dkjeF"}],"dkjeF":[function(require,module,exports) {
var isKeyable = require("2aaccf2377a1ff96");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"2aaccf2377a1ff96":"dySu7"}],"dySu7":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"j80cA":[function(require,module,exports) {
var getMapData = require("c5d158b4f5a174dd");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"c5d158b4f5a174dd":"dkjeF"}],"esBd7":[function(require,module,exports) {
var getMapData = require("9ef0441df32443c7");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"9ef0441df32443c7":"dkjeF"}],"f2i2Y":[function(require,module,exports) {
var getMapData = require("20fa42077d6552e7");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"20fa42077d6552e7":"dkjeF"}],"12ntE":[function(require,module,exports) {
var baseAssignValue = require("57ee2cfafe2f2c42"), eq = require("1e0b5d4e2db7febb");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"57ee2cfafe2f2c42":"k3Y4x","1e0b5d4e2db7febb":"2ZfGW"}],"k3Y4x":[function(require,module,exports) {
var defineProperty = require("4c67722b60b04e64");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"4c67722b60b04e64":"g7P6Z"}],"g7P6Z":[function(require,module,exports) {
var getNative = require("963ec4a457762e86");
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"963ec4a457762e86":"c4FjT"}],"8BcKE":[function(require,module,exports) {
var createBaseFor = require("1bd0f2042b97d118");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"1bd0f2042b97d118":"8b0hQ"}],"8b0hQ":[function(require,module,exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"3Ae5E":[function(require,module,exports) {
var assignMergeValue = require("89faa117d5b7667"), cloneBuffer = require("30a1d81a95647ca3"), cloneTypedArray = require("d68b186419a5e436"), copyArray = require("c3e88841f1e4f28c"), initCloneObject = require("a92f47ba6b3c9eba"), isArguments = require("badff88cedbb7cb7"), isArray = require("de41e7adcf4b3da2"), isArrayLikeObject = require("d5f1acf29a03c37"), isBuffer = require("97eb859638eee753"), isFunction = require("ab6ee5f4fc65649c"), isObject = require("60f131cd4b83e9a0"), isPlainObject = require("3a768d515d8faa4c"), isTypedArray = require("ec7529fcf7db759b"), safeGet = require("7dc90b9cfbea5d5b"), toPlainObject = require("db73391a27d07fdb");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"89faa117d5b7667":"12ntE","30a1d81a95647ca3":"22mLD","d68b186419a5e436":"4BOZl","c3e88841f1e4f28c":"7bn7u","a92f47ba6b3c9eba":"kIT6V","badff88cedbb7cb7":"ft7R6","de41e7adcf4b3da2":"gMJNW","d5f1acf29a03c37":"brvrL","97eb859638eee753":"eqlIb","ab6ee5f4fc65649c":"eQfSK","60f131cd4b83e9a0":"lMTBq","3a768d515d8faa4c":"3GEZB","ec7529fcf7db759b":"gzK78","7dc90b9cfbea5d5b":"hocKX","db73391a27d07fdb":"ims4J"}],"22mLD":[function(require,module,exports) {
var root = require("825f14649a622edf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"825f14649a622edf":"kwR0A"}],"4BOZl":[function(require,module,exports) {
var cloneArrayBuffer = require("50fe91c3ad45f955");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"50fe91c3ad45f955":"gqtRu"}],"gqtRu":[function(require,module,exports) {
var Uint8Array = require("3e614806169a6033");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"3e614806169a6033":"hxINO"}],"hxINO":[function(require,module,exports) {
var root = require("2ef7ff16a788d7a2");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"2ef7ff16a788d7a2":"kwR0A"}],"7bn7u":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"kIT6V":[function(require,module,exports) {
var baseCreate = require("20d25b2c6987eedd"), getPrototype = require("d5217de93b59b6a9"), isPrototype = require("e84da2acca8dbe0d");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"20d25b2c6987eedd":"9yAOr","d5217de93b59b6a9":"4WqW5","e84da2acca8dbe0d":"c3Raj"}],"9yAOr":[function(require,module,exports) {
var isObject = require("fe6e6342bb8304b5");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"fe6e6342bb8304b5":"lMTBq"}],"4WqW5":[function(require,module,exports) {
var overArg = require("352534c2bfec77ac");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"352534c2bfec77ac":"hSZ3G"}],"hSZ3G":[function(require,module,exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"c3Raj":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"ft7R6":[function(require,module,exports) {
var baseIsArguments = require("5a9512fa7146384d"), isObjectLike = require("cfd87c003c9936a");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function isArguments(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
module.exports = isArguments;

},{"5a9512fa7146384d":"dgU7v","cfd87c003c9936a":"58m9I"}],"dgU7v":[function(require,module,exports) {
var baseGetTag = require("698ddabc5cdbcc8b"), isObjectLike = require("d5aeba19967ca");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"698ddabc5cdbcc8b":"6xUuq","d5aeba19967ca":"58m9I"}],"58m9I":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"gMJNW":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"brvrL":[function(require,module,exports) {
var isArrayLike = require("56205c95a173ecd8"), isObjectLike = require("48395dbad199eeff");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"56205c95a173ecd8":"e6ZuG","48395dbad199eeff":"58m9I"}],"e6ZuG":[function(require,module,exports) {
var isFunction = require("74cee57dd0fc4b0b"), isLength = require("4c9b20281bb7e2a6");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"74cee57dd0fc4b0b":"eQfSK","4c9b20281bb7e2a6":"1WDCG"}],"1WDCG":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"eqlIb":[function(require,module,exports) {
var root = require("613191a8e5e7ca74"), stubFalse = require("17bbe49f9da85a84");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"613191a8e5e7ca74":"kwR0A","17bbe49f9da85a84":"7E6uD"}],"7E6uD":[function(require,module,exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"3GEZB":[function(require,module,exports) {
var baseGetTag = require("c9bbf3de75bf47d3"), getPrototype = require("2262e8a232a4412c"), isObjectLike = require("c8aeeaa3d5cae9fc");
/** `Object#toString` result references. */ var objectTag = "[object Object]";
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c9bbf3de75bf47d3":"6xUuq","2262e8a232a4412c":"4WqW5","c8aeeaa3d5cae9fc":"58m9I"}],"gzK78":[function(require,module,exports) {
var baseIsTypedArray = require("b4dab69a75cb6f4c"), baseUnary = require("d5fd1c79459d539f"), nodeUtil = require("1fdef52951d23865");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"b4dab69a75cb6f4c":"fT2Kg","d5fd1c79459d539f":"fwCXG","1fdef52951d23865":"7zC0T"}],"fT2Kg":[function(require,module,exports) {
var baseGetTag = require("1bbf67c0fc735306"), isLength = require("81437fab11687db5"), isObjectLike = require("7d1c73fce35256a5");
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"1bbf67c0fc735306":"6xUuq","81437fab11687db5":"1WDCG","7d1c73fce35256a5":"58m9I"}],"fwCXG":[function(require,module,exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"7zC0T":[function(require,module,exports) {
var freeGlobal = require("d51a6119a600eceb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"d51a6119a600eceb":"iGLhr"}],"hocKX":[function(require,module,exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = safeGet;

},{}],"ims4J":[function(require,module,exports) {
var copyObject = require("da0afa7ad42cdacf"), keysIn = require("3f8c05bd4da904fc");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"da0afa7ad42cdacf":"jWviF","3f8c05bd4da904fc":"c9Yxy"}],"jWviF":[function(require,module,exports) {
var assignValue = require("c27c9578ca446fdd"), baseAssignValue = require("9651e70504cc871d");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"c27c9578ca446fdd":"9GKmw","9651e70504cc871d":"k3Y4x"}],"9GKmw":[function(require,module,exports) {
var baseAssignValue = require("9ea584890dddbe2d"), eq = require("ad5b9a7489105d89");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"9ea584890dddbe2d":"k3Y4x","ad5b9a7489105d89":"2ZfGW"}],"c9Yxy":[function(require,module,exports) {
var arrayLikeKeys = require("1c438690c0dc94e6"), baseKeysIn = require("b7694e9ecb2c895a"), isArrayLike = require("71af2a3df41c2c79");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"1c438690c0dc94e6":"8powF","b7694e9ecb2c895a":"dufaA","71af2a3df41c2c79":"e6ZuG"}],"8powF":[function(require,module,exports) {
var baseTimes = require("d76457939b9ef6ba"), isArguments = require("f602e320423fd382"), isArray = require("1aa990626496033e"), isBuffer = require("44eab27b6ac60a90"), isIndex = require("6d6b732b86985cc1"), isTypedArray = require("628d1b417795b2e6");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"d76457939b9ef6ba":"kQlIP","f602e320423fd382":"ft7R6","1aa990626496033e":"gMJNW","44eab27b6ac60a90":"eqlIb","6d6b732b86985cc1":"b8Fwc","628d1b417795b2e6":"gzK78"}],"kQlIP":[function(require,module,exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"b8Fwc":[function(require,module,exports) {
/** Used as references for various `Number` constants. */ var _typeOf = require("@swc/helpers/_/_type_of");
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"dufaA":[function(require,module,exports) {
var isObject = require("c278bc51809266c3"), isPrototype = require("c5d2ea1e230c3c3f"), nativeKeysIn = require("486c62b5e4bc8406");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"c278bc51809266c3":"lMTBq","c5d2ea1e230c3c3f":"c3Raj","486c62b5e4bc8406":"g94g5"}],"g94g5":[function(require,module,exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"6DFZ5":[function(require,module,exports) {
var baseRest = require("1009bae0828c6d3b"), isIterateeCall = require("9eb6392d17310e25");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"1009bae0828c6d3b":"3MY67","9eb6392d17310e25":"7JfFP"}],"3MY67":[function(require,module,exports) {
var identity = require("52b805a2a8f15710"), overRest = require("34917a1864889759"), setToString = require("6ea2ed68d90a89cf");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
module.exports = baseRest;

},{"52b805a2a8f15710":"3yRAa","34917a1864889759":"cbTRE","6ea2ed68d90a89cf":"6BfVa"}],"3yRAa":[function(require,module,exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"cbTRE":[function(require,module,exports) {
var apply = require("b5be37cd72845cde");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"b5be37cd72845cde":"lVAn6"}],"lVAn6":[function(require,module,exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"6BfVa":[function(require,module,exports) {
var baseSetToString = require("10bc12ac21f93e3"), shortOut = require("d56e1e8f717a720");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"10bc12ac21f93e3":"a3e2x","d56e1e8f717a720":"7r61H"}],"a3e2x":[function(require,module,exports) {
var constant = require("42a9dbbc8dc7b44f"), defineProperty = require("8b3a918eadbc1da5"), identity = require("1e36a68d083b20e");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
module.exports = baseSetToString;

},{"42a9dbbc8dc7b44f":"fclJQ","8b3a918eadbc1da5":"g7P6Z","1e36a68d083b20e":"3yRAa"}],"fclJQ":[function(require,module,exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"7r61H":[function(require,module,exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"7JfFP":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var eq = require("d982b6e334f5b586"), isArrayLike = require("12d8c78e4ff4ba46"), isIndex = require("8e5ed9375fdab14e"), isObject = require("80ec1ac4818803b2");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index === "undefined" ? "undefined" : (0, _typeOf._)(index);
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"@swc/helpers/_/_type_of":"6Gp9n","d982b6e334f5b586":"2ZfGW","12d8c78e4ff4ba46":"e6ZuG","8e5ed9375fdab14e":"b8Fwc","80ec1ac4818803b2":"lMTBq"}],"9bodu":[function(require,module,exports) {
var baseGet = require("5a512bb04de895f");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"5a512bb04de895f":"9Z4OA"}],"9Z4OA":[function(require,module,exports) {
var castPath = require("38c96b6656b24a9e"), toKey = require("5e86315d7b4ec47");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"38c96b6656b24a9e":"aQ5JV","5e86315d7b4ec47":"ljcfr"}],"aQ5JV":[function(require,module,exports) {
var isArray = require("9a0824b436cc0575"), isKey = require("a13b017be267773a"), stringToPath = require("f314533e9b8a4b9f"), toString = require("ee194775de0869a8");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"9a0824b436cc0575":"gMJNW","a13b017be267773a":"6fZAC","f314533e9b8a4b9f":"aH0N8","ee194775de0869a8":"eICPV"}],"6fZAC":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var isArray = require("cbc0742fe9501f85"), isSymbol = require("2b7cc97f6c6be44a");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"@swc/helpers/_/_type_of":"6Gp9n","cbc0742fe9501f85":"gMJNW","2b7cc97f6c6be44a":"9cCFz"}],"9cCFz":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var baseGetTag = require("d76b7f9e0e1ea0b6"), isObjectLike = require("8f18bc241d2b0608");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"@swc/helpers/_/_type_of":"6Gp9n","d76b7f9e0e1ea0b6":"6xUuq","8f18bc241d2b0608":"58m9I"}],"aH0N8":[function(require,module,exports) {
var memoizeCapped = require("9cf6d797982bffd1");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"9cf6d797982bffd1":"hMy3A"}],"hMy3A":[function(require,module,exports) {
var memoize = require("3eae3348a04dd403");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"3eae3348a04dd403":"bGAos"}],"bGAos":[function(require,module,exports) {
var MapCache = require("c499f5225b133133");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"c499f5225b133133":"85pTo"}],"eICPV":[function(require,module,exports) {
var baseToString = require("650f9188006ca075");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"650f9188006ca075":"fTTVP"}],"fTTVP":[function(require,module,exports) {
var Symbol = require("5f414bae84be6a03"), arrayMap = require("252c34a3e52b33f8"), isArray = require("634264143aafbcc2"), isSymbol = require("33ca3dd83cacbc13");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"5f414bae84be6a03":"ircXK","252c34a3e52b33f8":"1GskI","634264143aafbcc2":"gMJNW","33ca3dd83cacbc13":"9cCFz"}],"1GskI":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"ljcfr":[function(require,module,exports) {
var isSymbol = require("4fac9c71a7c8f6ac");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"4fac9c71a7c8f6ac":"9cCFz"}],"atowU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UPLOAD_CSV_TYPES", function() {
    return UPLOAD_CSV_TYPES;
});
parcelHelpers.export(exports, "UPLOAD_PDF_TYPES", function() {
    return UPLOAD_PDF_TYPES;
});
parcelHelpers.export(exports, "UPLOAD_IMAGE_TYPES", function() {
    return UPLOAD_IMAGE_TYPES;
});
parcelHelpers.export(exports, "UPLOAD_IMAGE_EXTENSIONS", function() {
    return UPLOAD_IMAGE_EXTENSIONS;
});
parcelHelpers.export(exports, "isFileCSV", function() {
    return isFileCSV;
});
parcelHelpers.export(exports, "isFilePDF", function() {
    return isFilePDF;
});
parcelHelpers.export(exports, "isFileDOC", function() {
    return isFileDOC;
});
parcelHelpers.export(exports, "isFileValidImage", function() {
    return isFileValidImage;
});
parcelHelpers.export(exports, "getBase64", function() {
    return getBase64;
});
parcelHelpers.export(exports, "formattedFileSize", function() {
    return formattedFileSize;
});
var UPLOAD_CSV_TYPES = [
    "text/csv",
    "text/x-csv",
    "text/plain",
    "application/csv",
    "application/x-csv",
    "text/csv",
    "text/comma-separated-values",
    "text/x-comma-separated-values",
    "text/tab-separated-values",
    "application/vnd.ms-excel"
];
var UPLOAD_CSV_EXTENSION = "csv";
var UPLOAD_PDF_TYPES = [
    "application/pdf"
];
var UPLOAD_PDF_EXTENSION = "pdf";
var UPLOAD_DOCX_TYPES = [
    "text/doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];
var UPLOAD_DOCX_EXTENSION = "docx";
var UPLOAD_IMAGE_TYPES = [
    "image/jpeg",
    "image/pjpeg",
    "image/jpeg",
    "image/pjpeg",
    "image/jpeg",
    "image/png"
];
var UPLOAD_IMAGE_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".jpg-large",
    ".png"
];
var isFileCSV = function(fileType) {
    var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return UPLOAD_CSV_TYPES.indexOf(fileType) >= 0 || ext.toString().toLowerCase() === UPLOAD_CSV_EXTENSION;
};
var isFilePDF = function(fileType) {
    var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return UPLOAD_PDF_TYPES.indexOf(fileType) >= 0 || ext.toString().toLowerCase() === UPLOAD_PDF_EXTENSION;
};
var isFileDOC = function(fileType) {
    var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return UPLOAD_DOCX_TYPES.indexOf(fileType) >= 0 || ext.toString().toLowerCase() === UPLOAD_DOCX_EXTENSION;
};
var isFileValidImage = function(fileType) {
    var ext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return UPLOAD_IMAGE_TYPES.indexOf(fileType) >= 0 || UPLOAD_IMAGE_EXTENSIONS.indexOf(ext.toString().toLowerCase()) >= 0;
};
var getBase64 = function(file) {
    return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
            return resolve(reader.result);
        };
        reader.onerror = function(error) {
            return reject(error);
        };
    });
};
var formattedFileSize = function(fileSize) {
    var sizeDivisor = fileSize < 500000 ? 1024 : 1048576;
    var modifiedSize = Number.parseFloat(String(fileSize / sizeDivisor)).toPrecision(3);
    var formattedSize = "".concat(modifiedSize, " ").concat(sizeDivisor === 1024 ? "Kb" : "Mb");
    return formattedSize;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aI0VK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "goBackWithFallback", function() {
    return goBackWithFallback;
});
parcelHelpers.export(exports, "getBackLinkProps", function() {
    return getBackLinkProps;
});
var goBackWithFallback = function(history, altRoute) {
    if (history.length > 1) history.goBack();
    else history.push(altRoute);
};
var getBackLinkProps = function(history, altRoute) {
    if (history.length > 1) return {
        onClick: function() {
            return history.goBack();
        }
    };
    return {
        to: altRoute
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1MmlG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePrevious", function() {
    return usePrevious;
});
parcelHelpers.export(exports, "useResizeBrowser", function() {
    return useResizeBrowser;
});
parcelHelpers.export(exports, "useFetch", function() {
    return useFetch;
});
parcelHelpers.export(exports, "useFetchAll", function() {
    return useFetchAll;
});
parcelHelpers.export(exports, "useClickOutside", function() {
    return useClickOutside;
});
parcelHelpers.export(exports, "useMeasure", function() {
    return useMeasure;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var usePrevious = function(value) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        ref.current = value;
    });
    return ref.current;
};
var useResizeBrowser = function(debounceTime) {
    var isClient = typeof window === "object";
    var getSize = function() {
        return {
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        };
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(getSize), 2), windowSize = _useState[0], setWindowSize = _useState[1];
    (0, _react.useEffect)(function() {
        if (!isClient) return function() {};
        var handleResize = (0, _debounceDefault.default)(function() {
            setWindowSize(getSize());
        }, debounceTime ? debounceTime : 200);
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        size: windowSize,
        height: windowSize.height,
        width: windowSize.width
    };
};
var useFetch = function(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(null), 2), error = _useState2[0], setError = _useState2[1];
    (0, _react.useEffect)(function() {
        var abortController = new AbortController();
        var signal = abortController.signal;
        setLoading(true);
        fetch(url, {
            credentials: "include",
            signal: signal
        }).then(function(r) {
            return r.json();
        }).then(function(data) {
            setData(data);
            setLoading(false);
            options.onCompleted && options.onCompleted(data);
        }).catch(function(e) {
            setError(e);
            setLoading(false);
        });
        return function() {
            abortController.abort();
        };
    }, [
        url
    ]);
    return {
        loading: loading,
        data: data,
        error: error
    };
};
var useFetchAll = function(urls) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(null), 2), error = _useState2[0], setError = _useState2[1];
    var memoizedUrls = (0, _react.useMemo)(function() {
        return urls;
    }, [
        urls.join(",")
    ]);
    (0, _react.useEffect)(function() {
        setLoading(true);
        var abortController = new AbortController();
        var signal = abortController.signal; // If no batchSize is provided, fetch all urls in parallel
        var batchSize = options.batchSize || memoizedUrls.length;
        var batches = Array.from({
            length: Math.ceil(memoizedUrls.length / batchSize)
        }, function(_, index) {
            return memoizedUrls.slice(index * batchSize, (index + 1) * batchSize);
        });
        var fetchBatch = function(batchUrls) {
            return Promise.all(batchUrls.map(function(url) {
                return fetch(url, {
                    credentials: "include",
                    signal: signal
                }).then(function(r) {
                    return r.json();
                });
            }));
        };
        var fetchAllBatches = function() {
            return __awaiter(void 0, void 0, void 0, function() {
                var accumulatedResults, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, batch, _accumulatedResults, _, _1, _tmp, e, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            accumulatedResults = [];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                8,
                                9,
                                10
                            ]);
                            _iterator = batches[Symbol.iterator]();
                            _state.label = 2;
                        case 2:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            batch = _step.value;
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                5,
                                ,
                                6
                            ]);
                            _1 = (_ = (_accumulatedResults = accumulatedResults).push).apply;
                            _tmp = [
                                _accumulatedResults
                            ];
                            return [
                                4,
                                fetchBatch(batch)
                            ];
                        case 4:
                            _1.apply(_, _tmp.concat([
                                (0, _toConsumableArray._).apply(void 0, [
                                    _state.sent()
                                ])
                            ]));
                            return [
                                3,
                                6
                            ];
                        case 5:
                            e = _state.sent();
                            if (e instanceof Error && e.name !== "AbortError") {
                                setError(e);
                                setLoading(false);
                                return [
                                    2
                                ];
                            }
                            return [
                                3,
                                6
                            ];
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                2
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            setData(accumulatedResults);
                            setLoading(false);
                            options.onCompleted && options.onCompleted(accumulatedResults);
                            return [
                                2
                            ];
                    }
                });
            });
        };
        fetchAllBatches();
        return function() {
            abortController.abort();
        };
    }, [
        memoizedUrls,
        options.batchSize
    ]);
    return {
        loading: loading,
        data: data,
        error: error
    };
};
var useClickOutside = function(ref, handler) {
    (0, _react.useEffect)(function() {
        var listener = function(e) {
            if (!ref.current || ref.current.contains(e.target)) return;
            handler(e);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return function() {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [
        ref,
        handler
    ]);
};
var defaultRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
}; // https://github.com/streamich/react-use/blob/master/src/useMeasure.ts
var useMeasure = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), element = _useState[0], ref = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(defaultRect), 2), rect = _useState1[0], setRect = _useState1[1];
    var observer = (0, _react.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _entries__contentRect = entries[0].contentRect, x = _entries__contentRect.x, y = _entries__contentRect.y, width = _entries__contentRect.width, height = _entries__contentRect.height, top = _entries__contentRect.top, left = _entries__contentRect.left, bottom = _entries__contentRect.bottom, right = _entries__contentRect.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, _react.useLayoutEffect)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_ts_generator":"HrSs8","react":"ktQNc","lodash/debounce":"ejCgv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ejCgv":[function(require,module,exports) {
var isObject = require("6312786bf7794562"), now = require("f8e951285e5b3ba0"), toNumber = require("528092776f45c016");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"6312786bf7794562":"lMTBq","f8e951285e5b3ba0":"4eSoA","528092776f45c016":"fbmet"}],"4eSoA":[function(require,module,exports) {
var root = require("b785ee5208f41c35");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function now() {
    return root.Date.now();
};
module.exports = now;

},{"b785ee5208f41c35":"kwR0A"}],"fbmet":[function(require,module,exports) {
var isObject = require("6f2a632a1281e3a4"), isSymbol = require("75211c95bf2b99e5");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == "number") return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace(reTrim, "");
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"6f2a632a1281e3a4":"lMTBq","75211c95bf2b99e5":"9cCFz"}],"210OC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignHotKey", function() {
    return assignHotKey;
});
parcelHelpers.export(exports, "pageSizePixelToCanvasCoordinate", function() {
    return pageSizePixelToCanvasCoordinate;
});
var _findIndex = require("lodash/findIndex");
var _findIndexDefault = parcelHelpers.interopDefault(_findIndex);
var assignHotKey = function(field, index, array) {
    if (field.removeLabel) return 0;
    else if ((0, _findIndexDefault.default)(array, function(field) {
        return field.removeLabel || false;
    }) > -1 && index + 1 < 21) return index % 10;
    else if (index + 1 < 20) return (index + 1) % 10;
    else return null;
}; /**
    * Takes the pixel coordinate (that is associated with pageSize) and converts it to it's equivalent for canvasHeigth or canvasWidth
    * @param pixelCoordinate - top, bottom, left or right pixel value
    * @param pageDimension - pageSize.height or pageSize.width - the height or width of the document in pixels
    * @param canvasDimension - canvasHeight or canvasWidth - the height or width value of the canvas
    * @returns - coordinate for top, bottom, left or right in canvas height or width
    */ 
var pageSizePixelToCanvasCoordinate = function(pixelCoordinate, pageDimension, canvasDimension) {
    return pixelCoordinate / pageDimension * canvasDimension;
};

},{"lodash/findIndex":"kRHJF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kRHJF":[function(require,module,exports) {
var baseFindIndex = require("19d0f1840016f3e0"), baseIteratee = require("77afcf0e28c73e7"), toInteger = require("1560d9f6fe8fb4a9");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : toInteger(fromIndex);
    if (index < 0) index = nativeMax(length + index, 0);
    return baseFindIndex(array, baseIteratee(predicate, 3), index);
}
module.exports = findIndex;

},{"19d0f1840016f3e0":"kbj6r","77afcf0e28c73e7":"8TlrS","1560d9f6fe8fb4a9":"d7yop"}],"kbj6r":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"8TlrS":[function(require,module,exports) {
var baseMatches = require("ff2663bdc95c2322"), baseMatchesProperty = require("40924a9f12ea578a"), identity = require("ee6a7341149a78e0"), isArray = require("137c1f1c68e4304d"), property = require("d4d8e1dd54d434c2");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"ff2663bdc95c2322":"kwLCd","40924a9f12ea578a":"l7COi","ee6a7341149a78e0":"3yRAa","137c1f1c68e4304d":"gMJNW","d4d8e1dd54d434c2":"G48st"}],"kwLCd":[function(require,module,exports) {
var baseIsMatch = require("c8226bb13eb8341d"), getMatchData = require("c4dbf81f095903db"), matchesStrictComparable = require("6caa981aae0e8e97");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"c8226bb13eb8341d":"19DLx","c4dbf81f095903db":"cUppB","6caa981aae0e8e97":"bQCLm"}],"19DLx":[function(require,module,exports) {
var Stack = require("156b0a3932ff2d4c"), baseIsEqual = require("9fd5e5577a6735d9");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"156b0a3932ff2d4c":"ddAbE","9fd5e5577a6735d9":"bPuT7"}],"bPuT7":[function(require,module,exports) {
var baseIsEqualDeep = require("5c44e742549c024"), isObjectLike = require("e233aff8909ea850");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"5c44e742549c024":"8kYxF","e233aff8909ea850":"58m9I"}],"8kYxF":[function(require,module,exports) {
var Stack = require("93c9821dc4b36b0b"), equalArrays = require("1ef84f87a08a72cc"), equalByTag = require("4e302e6cd78a9a4f"), equalObjects = require("c2634f7fc79ba9a9"), getTag = require("d48029f2d661f150"), isArray = require("de44f5f9442a2661"), isBuffer = require("d1360ef467a4d291"), isTypedArray = require("b9c896e3e6ccc844");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"93c9821dc4b36b0b":"ddAbE","1ef84f87a08a72cc":"A1WQ2","4e302e6cd78a9a4f":"7TFmb","c2634f7fc79ba9a9":"cqXsL","d48029f2d661f150":"4GVbK","de44f5f9442a2661":"gMJNW","d1360ef467a4d291":"eqlIb","b9c896e3e6ccc844":"gzK78"}],"A1WQ2":[function(require,module,exports) {
var SetCache = require("26574f4f7c8a1ede"), arraySome = require("217e7f0787c4281"), cacheHas = require("8599703e043d55f0");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = equalArrays;

},{"26574f4f7c8a1ede":"lmHy4","217e7f0787c4281":"4j4Kx","8599703e043d55f0":"4QeX6"}],"lmHy4":[function(require,module,exports) {
var MapCache = require("e58da3e2fae60f5a"), setCacheAdd = require("1f282be252b5e1db"), setCacheHas = require("fef13cab9def339e");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"e58da3e2fae60f5a":"85pTo","1f282be252b5e1db":"ckPZn","fef13cab9def339e":"e8VXm"}],"ckPZn":[function(require,module,exports) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"e8VXm":[function(require,module,exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"4j4Kx":[function(require,module,exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"4QeX6":[function(require,module,exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7TFmb":[function(require,module,exports) {
var Symbol = require("4a0b938bfe3eb4d7"), Uint8Array = require("2393e61691c822ea"), eq = require("d82ebd3696c5fb49"), equalArrays = require("a194f29f6586f663"), mapToArray = require("88068be574bde23"), setToArray = require("52678d8b4afad705");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"4a0b938bfe3eb4d7":"ircXK","2393e61691c822ea":"hxINO","d82ebd3696c5fb49":"2ZfGW","a194f29f6586f663":"A1WQ2","88068be574bde23":"7RJMz","52678d8b4afad705":"aCzLk"}],"7RJMz":[function(require,module,exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"aCzLk":[function(require,module,exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"cqXsL":[function(require,module,exports) {
var getAllKeys = require("ba4ac437ca80ead0");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = equalObjects;

},{"ba4ac437ca80ead0":"lb43s"}],"lb43s":[function(require,module,exports) {
var baseGetAllKeys = require("c50c5cd78c5abcba"), getSymbols = require("d4b44cfa6287122a"), keys = require("6be62fecfc48b1c9");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c50c5cd78c5abcba":"gpLhg","d4b44cfa6287122a":"jDL4O","6be62fecfc48b1c9":"klkTN"}],"gpLhg":[function(require,module,exports) {
var arrayPush = require("98c522993c4bf19"), isArray = require("fc3714093d0a1b52");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"98c522993c4bf19":"0pXTK","fc3714093d0a1b52":"gMJNW"}],"0pXTK":[function(require,module,exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"jDL4O":[function(require,module,exports) {
var arrayFilter = require("62c7ea33b43e32ac"), stubArray = require("30483a25a42271d6");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"62c7ea33b43e32ac":"cKKSX","30483a25a42271d6":"8BcoV"}],"cKKSX":[function(require,module,exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"8BcoV":[function(require,module,exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"klkTN":[function(require,module,exports) {
var arrayLikeKeys = require("a81d3a750649e68c"), baseKeys = require("41ab517ff747b7ae"), isArrayLike = require("c0adc8891bd1bb44");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"a81d3a750649e68c":"8powF","41ab517ff747b7ae":"9Vd2j","c0adc8891bd1bb44":"e6ZuG"}],"9Vd2j":[function(require,module,exports) {
var isPrototype = require("3d4f22861da00db8"), nativeKeys = require("8fc8e194ae1efbf7");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = baseKeys;

},{"3d4f22861da00db8":"c3Raj","8fc8e194ae1efbf7":"9rL5b"}],"9rL5b":[function(require,module,exports) {
var overArg = require("1b829621f74ae6d2");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"1b829621f74ae6d2":"hSZ3G"}],"4GVbK":[function(require,module,exports) {
var DataView = require("6cfe40bc76d650be"), Map = require("a422804824e20648"), Promise = require("d4ff27611952fe8a"), Set = require("17f0210beef7875f"), WeakMap = require("90e7e78d2e4c0e5c"), baseGetTag = require("e59c0eebfd6e871e"), toSource = require("755bc8ad19603442");
/** `Object#toString` result references. */ var mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"6cfe40bc76d650be":"cBuju","a422804824e20648":"kbs7M","d4ff27611952fe8a":"dmbs5","17f0210beef7875f":"8Nnmt","90e7e78d2e4c0e5c":"jKwno","e59c0eebfd6e871e":"6xUuq","755bc8ad19603442":"hQ9dn"}],"cBuju":[function(require,module,exports) {
var getNative = require("69ee10216c6d359b"), root = require("f085344ed196c92a");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView");
module.exports = DataView;

},{"69ee10216c6d359b":"c4FjT","f085344ed196c92a":"kwR0A"}],"dmbs5":[function(require,module,exports) {
var getNative = require("4f61c3119e9e80ef"), root = require("89fcad28db799072");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, "Promise");
module.exports = Promise;

},{"4f61c3119e9e80ef":"c4FjT","89fcad28db799072":"kwR0A"}],"8Nnmt":[function(require,module,exports) {
var getNative = require("44228180ef71eb55"), root = require("d90e241c6e926cb");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, "Set");
module.exports = Set;

},{"44228180ef71eb55":"c4FjT","d90e241c6e926cb":"kwR0A"}],"jKwno":[function(require,module,exports) {
var getNative = require("312f883336260a1f"), root = require("6dc729850f51d994");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, "WeakMap");
module.exports = WeakMap;

},{"312f883336260a1f":"c4FjT","6dc729850f51d994":"kwR0A"}],"cUppB":[function(require,module,exports) {
var isStrictComparable = require("1d97070fb0595268"), keys = require("1d519c16d278ba48");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"1d97070fb0595268":"fyD5y","1d519c16d278ba48":"klkTN"}],"fyD5y":[function(require,module,exports) {
var isObject = require("c71db634b55f0d74");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"c71db634b55f0d74":"lMTBq"}],"bQCLm":[function(require,module,exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"l7COi":[function(require,module,exports) {
var baseIsEqual = require("828abf539233240a"), get = require("89c37251dd640600"), hasIn = require("9fe37535d74b796b"), isKey = require("200b33cbac97c86e"), isStrictComparable = require("e40a8ca3e86837e1"), matchesStrictComparable = require("b06d9f485a64e194"), toKey = require("9e7cff46fa72585e");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"828abf539233240a":"bPuT7","89c37251dd640600":"9bodu","9fe37535d74b796b":"7FP6g","200b33cbac97c86e":"6fZAC","e40a8ca3e86837e1":"fyD5y","b06d9f485a64e194":"bQCLm","9e7cff46fa72585e":"ljcfr"}],"7FP6g":[function(require,module,exports) {
var baseHasIn = require("cb2872109879ce2b"), hasPath = require("4596580f67d132b5");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"cb2872109879ce2b":"azWkA","4596580f67d132b5":"6Yd7R"}],"azWkA":[function(require,module,exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"6Yd7R":[function(require,module,exports) {
var castPath = require("7eee2713e20cc4dc"), isArguments = require("695e103e3ebed2ba"), isArray = require("32f2c87040c02087"), isIndex = require("5b592491f63005d"), isLength = require("a1513d38bfe0490f"), toKey = require("37e37dfe510b3b36");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"7eee2713e20cc4dc":"aQ5JV","695e103e3ebed2ba":"ft7R6","32f2c87040c02087":"gMJNW","5b592491f63005d":"b8Fwc","a1513d38bfe0490f":"1WDCG","37e37dfe510b3b36":"ljcfr"}],"G48st":[function(require,module,exports) {
var baseProperty = require("24e45da628b41ded"), basePropertyDeep = require("3a7cf09dc41d3562"), isKey = require("aa9c7a6e66f070dd"), toKey = require("9f41bf54224bc53");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"24e45da628b41ded":"etI5t","3a7cf09dc41d3562":"cZjw9","aa9c7a6e66f070dd":"6fZAC","9f41bf54224bc53":"ljcfr"}],"etI5t":[function(require,module,exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"cZjw9":[function(require,module,exports) {
var baseGet = require("e009da2fe992a163");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"e009da2fe992a163":"9Z4OA"}],"d7yop":[function(require,module,exports) {
var toFinite = require("d4250d81010298fd");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function toInteger(value) {
    var result = toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = toInteger;

},{"d4250d81010298fd":"g32FR"}],"g32FR":[function(require,module,exports) {
var toNumber = require("32ea1f6255c0b40");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"32ea1f6255c0b40":"fbmet"}],"lVXdh":[function(require,module,exports) {
/**
 * Takes a number and formats it nicely.
 *
 * @example numberWithCommas(12345)
 * // returns 12,345
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberWithCommas", function() {
    return numberWithCommas;
});
/**
 * Takes a number and returns it, rounded up to the maximum decimal places specified.
 *
 * @example maxDecimalPlaces(0.1694915254237288, 2)
 * // returns 0.17
 *
 * @example maxDecimalPlaces(0.1694915254237288, 3)
 * // returns 0.169
 *
 * @example maxDecimalPlaces(12.902, 2)
 * // returns 12.9
 */ parcelHelpers.export(exports, "maxDecimalPlaces", function() {
    return maxDecimalPlaces;
});
parcelHelpers.export(exports, "formatConfidence", function() {
    return formatConfidence;
});
function numberWithCommas(value) {
    return new Intl.NumberFormat(navigator.language || "en-US").format(value);
}
function maxDecimalPlaces(value, decimalPlaces) {
    return +value.toFixed(decimalPlaces);
}
function formatConfidence(confidence) {
    return Math.min(Math.floor(confidence * 100), 99);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"87qbE":[function(require,module,exports) {
/**
 * @param obj
 * @param converter
 * @returns The same object with all keys converted with `convert`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertKeys", function() {
    return convertKeys;
});
/**
 * @param obj
 * @param keyToOmit
 * @returns The same object without the key `keyToOmit`, at any level of nesting
 */ parcelHelpers.export(exports, "deepOmitKey", function() {
    return deepOmitKey;
});
function convertKeys(obj, converter) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        return convertKeys(item, converter);
    });
    var convertedObj = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var convertedKey = converter(key);
        var value = obj[key];
        convertedObj[convertedKey] = convertKeys(value, converter);
    }
    return convertedObj;
}
function deepOmitKey(obj, keyToOmit) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map(function(item) {
        return deepOmitKey(item, keyToOmit);
    });
    var newObj = {};
    for(var k in obj)if (k !== keyToOmit && Object.prototype.hasOwnProperty.call(obj, k)) newObj[k] = deepOmitKey(obj[k], keyToOmit);
    return newObj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"b1P0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseToUpperUnderscore", function() {
    return camelCaseToUpperUnderscore;
});
parcelHelpers.export(exports, "camelCaseToSpaceUpper", function() {
    return camelCaseToSpaceUpper;
});
parcelHelpers.export(exports, "underscoreToCapitalize", function() {
    return underscoreToCapitalize;
});
parcelHelpers.export(exports, "snakeCaseToCamelCase", function() {
    return snakeCaseToCamelCase;
});
parcelHelpers.export(exports, "capitalize", function() {
    return capitalize;
});
parcelHelpers.export(exports, "capitalizeFirstOnly", function() {
    return capitalizeFirstOnly;
}) /**
   * Generates a random string of English alphabet characters. Defaults to a length of 8.
   */ ;
parcelHelpers.export(exports, "createRandomString", function() {
    return createRandomString;
});
parcelHelpers.export(exports, "maxLengthWithEllipse", function() {
    return maxLengthWithEllipse;
});
parcelHelpers.export(exports, "maxLengthWithMiddleEllipsis", function() {
    return maxLengthWithMiddleEllipsis;
});
var camelCaseToUpperUnderscore = function(string) {
    return string.replace(/([A-Z])/g, function($1) {
        return "_" + $1;
    }).toUpperCase();
};
var camelCaseToSpaceUpper = function(string) {
    return string // insert a space before all caps
    .replace(/([A-Z])/g, " $1") // uppercase the first character
    .replace(/^./, function(str) {
        return str.toUpperCase();
    });
};
var underscoreToCapitalize = function(string) {
    return string // replace all _ with spaces
    .replace(/_/g, " ") // uppercase the first character
    .replace(/^./, function(str) {
        return str.toUpperCase();
    });
};
var snakeCaseToCamelCase = function(string) {
    var parts = string.split("_").map(function(part, i) {
        if (i > 0) return part.replace(/^./, function(str) {
            return str.toUpperCase();
        });
        else return part;
    });
    return parts.join().replace(/,/g, "");
};
function capitalize(string) {
    if (typeof string !== "string") return "";
    return string.slice(0, 1).toUpperCase() + string.slice(1).toLowerCase();
}
function capitalizeFirstOnly(string) {
    if (typeof string !== "string") return "";
    return string.slice(0, 1).toUpperCase() + string.slice(1);
}
function createRandomString(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    var result = "";
    for(var i = 0; i < (length || 8); i++)result += chars.charAt(Math.floor(Math.random() * chars.length));
    return result;
}
var maxLengthWithEllipse = function(string, maxLength) {
    if (string.length <= maxLength) return string;
    else return string.slice(0, maxLength - 2).concat("...");
};
var maxLengthWithMiddleEllipsis = function(string, maxLength) {
    var frontSegment = string.slice(0, Math.floor(maxLength / 2) - 2);
    var endSegmentLength = string.length - (Math.floor(maxLength / 2) - 1);
    var endSegment = string.slice(endSegmentLength, string.length);
    return string.length <= maxLength ? string : "".concat(frontSegment, "...").concat(endSegment);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"sFJVG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PARAM_AUTH_REDIRECT_KEY", function() {
    return PARAM_AUTH_REDIRECT_KEY;
});
parcelHelpers.export(exports, "PARAM_TOKEN_KEY", function() {
    return PARAM_TOKEN_KEY;
});
parcelHelpers.export(exports, "parseRedirect", function() {
    return parseRedirect;
});
parcelHelpers.export(exports, "parseToken", function() {
    return parseToken;
});
var PARAM_AUTH_REDIRECT_KEY = "redirect_url";
var PARAM_TOKEN_KEY = "token";
/**
 * Strips any leading hash or question mark characters from the string
 * so that we can parse it correctly.
 * @param urlFragment
 * @returns {*}
 */ var cleanUrlFragment = function(urlFragment) {
    while(urlFragment[0] === "#" || urlFragment[0] === "?")urlFragment = urlFragment.substr(1);
    return urlFragment;
};
var parseRedirect = function(urlFragment) {
    urlFragment = cleanUrlFragment(urlFragment);
    var queryParams = new URLSearchParams(urlFragment);
    if (queryParams.has(PARAM_AUTH_REDIRECT_KEY)) return queryParams.get(PARAM_AUTH_REDIRECT_KEY);
    else return null;
};
var parseToken = function(urlFragment) {
    urlFragment = cleanUrlFragment(urlFragment);
    var queryParams = new URLSearchParams(urlFragment);
    if (queryParams.has(PARAM_TOKEN_KEY)) return queryParams.get(PARAM_TOKEN_KEY);
    else return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ae2ip":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "containsUppercase", function() {
    return containsUppercase;
});
parcelHelpers.export(exports, "containsLowercase", function() {
    return containsLowercase;
});
parcelHelpers.export(exports, "containsSpecialCharacter", function() {
    return containsSpecialCharacter;
});
parcelHelpers.export(exports, "containsNumber", function() {
    return containsNumber;
});
parcelHelpers.export(exports, "isChecked", function() {
    return isChecked;
});
var _validateJs = require("validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var UPPERCASE_ALPHA_MATCH = /[A-Z]+/;
var LOWERCASE_ALPHA_MATCH = /[a-z]+/;
var SPECIAL_CHARACTER_MATCH = /[*@!#%$&()^~{}]+/;
var DIGIT_MATCH = /\d+/;
var containsUppercase = function(inputValue) {
    return UPPERCASE_ALPHA_MATCH.test(inputValue) ? null : "must contain an uppercase letter";
};
var containsLowercase = function(inputValue) {
    return LOWERCASE_ALPHA_MATCH.test(inputValue) ? null : "must contain a lowercase letter";
};
var containsSpecialCharacter = function(inputValue) {
    return SPECIAL_CHARACTER_MATCH.test(inputValue) ? null : "must contain one of these characters * @ ! $ # % & ( ) ^ ~ { }";
};
var containsNumber = function(inputValue) {
    return DIGIT_MATCH.test(inputValue) ? null : "must contain at least one number";
};
var isChecked = function(inputValue) {
    return (0, _validateJsDefault.default).isBoolean(inputValue) && inputValue ? null : "be checked";
};

},{"validate.js":"1eZUn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1eZUn":[function(require,module,exports) {
/*!
 * validate.js 0.13.1
 *
 * (c) 2013-2019 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */ (function(exports1, module1, define1) {
    "use strict";
    // The main function that calls the validators specified by the constraints.
    // The options are the following:
    //   - format (string) - An option that controls how the returned value is formatted
    //     * flat - Returns a flat array of just the error messages
    //     * grouped - Returns the messages grouped by attribute (default)
    //     * detailed - Returns an array of the raw validation data
    //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
    //
    // Please note that the options are also passed to each validator.
    var validate = function validate1(attributes, constraints, options) {
        options = v.extend({}, v.options, options);
        var results = v.runValidations(attributes, constraints, options), attr, validator;
        if (results.some(function(r) {
            return v.isPromise(r.error);
        })) throw new Error("Use validate.async if you want support for promises");
        return validate.processValidationResults(results, options);
    };
    var v = validate;
    // Copies over attributes from one or more sources to a single destination.
    // Very much similar to underscore's extend.
    // The first argument is the target object and the remaining arguments will be
    // used as sources.
    v.extend = function(obj) {
        [].slice.call(arguments, 1).forEach(function(source) {
            for(var attr in source)obj[attr] = source[attr];
        });
        return obj;
    };
    v.extend(validate, {
        // This is the version of the library as a semver.
        // The toString function will allow it to be coerced into a string
        version: {
            major: 0,
            minor: 13,
            patch: 1,
            metadata: null,
            toString: function toString() {
                var version = v.format("%{major}.%{minor}.%{patch}", v.version);
                if (!v.isEmpty(v.version.metadata)) version += "+" + v.version.metadata;
                return version;
            }
        },
        // Below is the dependencies that are used in validate.js
        // The constructor of the Promise implementation.
        // If you are using Q.js, RSVP or any other A+ compatible implementation
        // override this attribute to be the constructor of that promise.
        // Since jQuery promises aren't A+ compatible they won't work.
        Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,
        EMPTY_STRING_REGEXP: /^\s*$/,
        // Runs the validators specified by the constraints object.
        // Will return an array of the format:
        //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
        runValidations: function runValidations(attributes, constraints, options) {
            var results = [], attr, validatorName, value, validators, validator, validatorOptions, error;
            if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) attributes = v.collectFormValues(attributes);
            // Loops through each constraints, finds the correct validator and run it.
            for(attr in constraints){
                value = v.getDeepObjectValue(attributes, attr);
                // This allows the constraints for an attribute to be a function.
                // The function will be called with the value, attribute name, the complete dict of
                // attributes as well as the options and constraints passed in.
                // This is useful when you want to have different
                // validations depending on the attribute value.
                validators = v.result(constraints[attr], value, attributes, attr, options, constraints);
                for(validatorName in validators){
                    validator = v.validators[validatorName];
                    if (!validator) {
                        error = v.format("Unknown validator %{name}", {
                            name: validatorName
                        });
                        throw new Error(error);
                    }
                    validatorOptions = validators[validatorName];
                    // This allows the options to be a function. The function will be
                    // called with the value, attribute name, the complete dict of
                    // attributes as well as the options and constraints passed in.
                    // This is useful when you want to have different
                    // validations depending on the attribute value.
                    validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
                    if (!validatorOptions) continue;
                    results.push({
                        attribute: attr,
                        value: value,
                        validator: validatorName,
                        globalOptions: options,
                        attributes: attributes,
                        options: validatorOptions,
                        error: validator.call(validator, value, validatorOptions, attr, attributes, options)
                    });
                }
            }
            return results;
        },
        // Takes the output from runValidations and converts it to the correct
        // output format.
        processValidationResults: function processValidationResults(errors, options) {
            errors = v.pruneEmptyErrors(errors, options);
            errors = v.expandMultipleErrors(errors, options);
            errors = v.convertErrorMessages(errors, options);
            var format = options.format || "grouped";
            if (typeof v.formatters[format] === "function") errors = v.formatters[format](errors);
            else throw new Error(v.format("Unknown format %{format}", options));
            return v.isEmpty(errors) ? undefined : errors;
        },
        // Runs the validations with support for promises.
        // This function will return a promise that is settled when all the
        // validation promises have been completed.
        // It can be called even if no validations returned a promise.
        async: function async(attributes, constraints, options) {
            options = v.extend({}, v.async.options, options);
            var WrapErrors = options.wrapErrors || function(errors) {
                return errors;
            };
            // Removes unknown attributes
            if (options.cleanAttributes !== false) attributes = v.cleanAttributes(attributes, constraints);
            var results = v.runValidations(attributes, constraints, options);
            return new v.Promise(function(resolve, reject) {
                v.waitForResults(results).then(function() {
                    var errors = v.processValidationResults(results, options);
                    if (errors) reject(new WrapErrors(errors, options, attributes, constraints));
                    else resolve(attributes);
                }, function(err) {
                    reject(err);
                });
            });
        },
        single: function single(value, constraints, options) {
            options = v.extend({}, v.single.options, options, {
                format: "flat",
                fullMessages: false
            });
            return v({
                single: value
            }, {
                single: constraints
            }, options);
        },
        // Returns a promise that is resolved when all promises in the results array
        // are settled. The promise returned from this function is always resolved,
        // never rejected.
        // This function modifies the input argument, it replaces the promises
        // with the value returned from the promise.
        waitForResults: function waitForResults(results) {
            // Create a sequence of all the results starting with a resolved promise.
            return results.reduce(function(memo, result) {
                // If this result isn't a promise skip it in the sequence.
                if (!v.isPromise(result.error)) return memo;
                return memo.then(function() {
                    return result.error.then(function(error) {
                        result.error = error || null;
                    });
                });
            }, new v.Promise(function(r) {
                r();
            })); // A resolved promise
        },
        // If the given argument is a call: function the and: function return the value
        // otherwise just return the value. Additional arguments will be passed as
        // arguments to the function.
        // Example:
        // ```
        // result('foo') // 'foo'
        // result(Math.max, 1, 2) // 2
        // ```
        result: function result(value) {
            var args = [].slice.call(arguments, 1);
            if (typeof value === "function") value = value.apply(null, args);
            return value;
        },
        // Checks if the value is a number. This function does not consider NaN a
        // number like many other `isNumber` functions do.
        isNumber: function isNumber(value) {
            return typeof value === "number" && !isNaN(value);
        },
        // Returns false if the object is not a function
        isFunction: function isFunction(value) {
            return typeof value === "function";
        },
        // A simple check to verify that the value is an integer. Uses `isNumber`
        // and a simple modulo check.
        isInteger: function isInteger(value) {
            return v.isNumber(value) && value % 1 === 0;
        },
        // Checks if the value is a boolean
        isBoolean: function isBoolean(value) {
            return typeof value === "boolean";
        },
        // Uses the `Object` function to check if the given argument is an object.
        isObject: function isObject(obj) {
            return obj === Object(obj);
        },
        // Simply checks if the object is an instance of a date
        isDate: function isDate(obj) {
            return obj instanceof Date;
        },
        // Returns false if the object is `null` of `undefined`
        isDefined: function isDefined(obj) {
            return obj !== null && obj !== undefined;
        },
        // Checks if the given argument is a promise. Anything with a `then`
        // function is considered a promise.
        isPromise: function isPromise(p) {
            return !!p && v.isFunction(p.then);
        },
        isJqueryElement: function isJqueryElement(o) {
            return o && v.isString(o.jquery);
        },
        isDomElement: function isDomElement(o) {
            if (!o) return false;
            if (!o.querySelectorAll || !o.querySelector) return false;
            if (v.isObject(document) && o === document) return true;
            // http://stackoverflow.com/a/384380/699304
            /* istanbul ignore else */ if (typeof HTMLElement === "object") return o instanceof HTMLElement;
            else return o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
        },
        isEmpty: function isEmpty(value) {
            var attr;
            // Null and undefined are empty
            if (!v.isDefined(value)) return true;
            // functions are non empty
            if (v.isFunction(value)) return false;
            // Whitespace only strings are empty
            if (v.isString(value)) return v.EMPTY_STRING_REGEXP.test(value);
            // For arrays we use the length property
            if (v.isArray(value)) return value.length === 0;
            // Dates have no attributes but aren't empty
            if (v.isDate(value)) return false;
            // If we find at least one property we consider it non empty
            if (v.isObject(value)) {
                for(attr in value)return false;
                return true;
            }
            return false;
        },
        // Formats the specified strings with the given values like so:
        // ```
        // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
        // ```
        // If you want to write %{...} without having it replaced simply
        // prefix it with % like this `Foo: %%{foo}` and it will be returned
        // as `"Foo: %{foo}"`
        format: v.extend(function(str, vals) {
            if (!v.isString(str)) return str;
            return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
                if (m1 === "%") return "%{" + m2 + "}";
                else return String(vals[m2]);
            });
        }, {
            // Finds %{key} style patterns in the given string
            FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
        }),
        // "Prettifies" the given string.
        // Prettifying means replacing [.\_-] with spaces as well as splitting
        // camel case words.
        prettify: function prettify(str) {
            if (v.isNumber(str)) {
                // If there are more than 2 decimals round it to two
                if (str * 100 % 1 === 0) return "" + str;
                else return parseFloat(Math.round(str * 100) / 100).toFixed(2);
            }
            if (v.isArray(str)) return str.map(function(s) {
                return v.prettify(s);
            }).join(", ");
            if (v.isObject(str)) {
                if (!v.isDefined(str.toString)) return JSON.stringify(str);
                return str.toString();
            }
            // Ensure the string is actually a string
            str = "" + str;
            return str// Splits keys separated by periods
            .replace(/([^\s])\.([^\s])/g, "$1 $2")// Removes backslashes
            .replace(/\\+/g, "")// Replaces - and - with space
            .replace(/[_-]/g, " ")// Splits camel cased words
            .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
                return "" + m1 + " " + m2.toLowerCase();
            }).toLowerCase();
        },
        stringifyValue: function stringifyValue(value, options) {
            var prettify = options && options.prettify || v.prettify;
            return prettify(value);
        },
        isString: function isString(value) {
            return typeof value === "string";
        },
        isArray: function isArray(value) {
            return ({}).toString.call(value) === "[object Array]";
        },
        // Checks if the object is a hash, which is equivalent to an object that
        // is neither an array nor a function.
        isHash: function isHash(value) {
            return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
        },
        contains: function contains(obj, value) {
            if (!v.isDefined(obj)) return false;
            if (v.isArray(obj)) return obj.indexOf(value) !== -1;
            return value in obj;
        },
        unique: function unique(array) {
            if (!v.isArray(array)) return array;
            return array.filter(function(el, index, array) {
                return array.indexOf(el) == index;
            });
        },
        forEachKeyInKeypath: function forEachKeyInKeypath(object, keypath, callback) {
            if (!v.isString(keypath)) return undefined;
            var key = "", i, escape = false;
            for(i = 0; i < keypath.length; ++i)switch(keypath[i]){
                case ".":
                    if (escape) {
                        escape = false;
                        key += ".";
                    } else {
                        object = callback(object, key, false);
                        key = "";
                    }
                    break;
                case "\\":
                    if (escape) {
                        escape = false;
                        key += "\\";
                    } else escape = true;
                    break;
                default:
                    escape = false;
                    key += keypath[i];
                    break;
            }
            return callback(object, key, true);
        },
        getDeepObjectValue: function getDeepObjectValue(obj, keypath) {
            if (!v.isObject(obj)) return undefined;
            return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
                if (v.isObject(obj)) return obj[key];
            });
        },
        // This returns an object with all the values of the form.
        // It uses the input name as key and the value as value
        // So for example this:
        // <input type="text" name="email" value="foo@bar.com" />
        // would return:
        // {email: "foo@bar.com"}
        collectFormValues: function collectFormValues(form, options) {
            var values = {}, i, j, input, inputs, option, value;
            if (v.isJqueryElement(form)) form = form[0];
            if (!form) return values;
            options = options || {};
            inputs = form.querySelectorAll("input[name], textarea[name]");
            for(i = 0; i < inputs.length; ++i){
                input = inputs.item(i);
                if (v.isDefined(input.getAttribute("data-ignored"))) continue;
                var name = input.name.replace(/\./g, "\\\\.");
                value = v.sanitizeFormValue(input.value, options);
                if (input.type === "number") value = value ? +value : null;
                else if (input.type === "checkbox") {
                    if (input.attributes.value) {
                        if (!input.checked) value = values[name] || null;
                    } else value = input.checked;
                } else if (input.type === "radio") {
                    if (!input.checked) value = values[name] || null;
                }
                values[name] = value;
            }
            inputs = form.querySelectorAll("select[name]");
            for(i = 0; i < inputs.length; ++i){
                input = inputs.item(i);
                if (v.isDefined(input.getAttribute("data-ignored"))) continue;
                if (input.multiple) {
                    value = [];
                    for(j in input.options){
                        option = input.options[j];
                        if (option && option.selected) value.push(v.sanitizeFormValue(option.value, options));
                    }
                } else {
                    var _val = typeof input.options[input.selectedIndex] !== "undefined" ? input.options[input.selectedIndex].value : /* istanbul ignore next */ "";
                    value = v.sanitizeFormValue(_val, options);
                }
                values[input.name] = value;
            }
            return values;
        },
        sanitizeFormValue: function sanitizeFormValue(value, options) {
            if (options.trim && v.isString(value)) value = value.trim();
            if (options.nullify !== false && value === "") return null;
            return value;
        },
        capitalize: function capitalize(str) {
            if (!v.isString(str)) return str;
            return str[0].toUpperCase() + str.slice(1);
        },
        // Remove all errors who's error attribute is empty (null or undefined)
        pruneEmptyErrors: function pruneEmptyErrors(errors) {
            return errors.filter(function(error) {
                return !v.isEmpty(error.error);
            });
        },
        // In
        // [{error: ["err1", "err2"], ...}]
        // Out
        // [{error: "err1", ...}, {error: "err2", ...}]
        //
        // All attributes in an error with multiple messages are duplicated
        // when expanding the errors.
        expandMultipleErrors: function expandMultipleErrors(errors) {
            var ret = [];
            errors.forEach(function(error) {
                // Removes errors without a message
                if (v.isArray(error.error)) error.error.forEach(function(msg) {
                    ret.push(v.extend({}, error, {
                        error: msg
                    }));
                });
                else ret.push(error);
            });
            return ret;
        },
        // Converts the error mesages by prepending the attribute name unless the
        // message is prefixed by ^
        convertErrorMessages: function convertErrorMessages(errors, options) {
            options = options || {};
            var ret = [], prettify = options.prettify || v.prettify;
            errors.forEach(function(errorInfo) {
                var error = v.result(errorInfo.error, errorInfo.value, errorInfo.attribute, errorInfo.options, errorInfo.attributes, errorInfo.globalOptions);
                if (!v.isString(error)) {
                    ret.push(errorInfo);
                    return;
                }
                if (error[0] === "^") error = error.slice(1);
                else if (options.fullMessages !== false) error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
                error = error.replace(/\\\^/g, "^");
                error = v.format(error, {
                    value: v.stringifyValue(errorInfo.value, options)
                });
                ret.push(v.extend({}, errorInfo, {
                    error: error
                }));
            });
            return ret;
        },
        // In:
        // [{attribute: "<attributeName>", ...}]
        // Out:
        // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
        groupErrorsByAttribute: function groupErrorsByAttribute(errors) {
            var ret = {};
            errors.forEach(function(error) {
                var list = ret[error.attribute];
                if (list) list.push(error);
                else ret[error.attribute] = [
                    error
                ];
            });
            return ret;
        },
        // In:
        // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
        // Out:
        // ["<message 1>", "<message 2>"]
        flattenErrorsToArray: function flattenErrorsToArray(errors) {
            return errors.map(function(error) {
                return error.error;
            }).filter(function(value, index, self) {
                return self.indexOf(value) === index;
            });
        },
        cleanAttributes: function cleanAttributes(attributes, whitelist) {
            function whitelistCreator(obj, key, last) {
                if (v.isObject(obj[key])) return obj[key];
                return obj[key] = last ? true : {};
            }
            function buildObjectWhitelist(whitelist) {
                var ow = {}, lastObject, attr;
                for(attr in whitelist){
                    if (!whitelist[attr]) continue;
                    v.forEachKeyInKeypath(ow, attr, whitelistCreator);
                }
                return ow;
            }
            function cleanRecursive(attributes, whitelist) {
                if (!v.isObject(attributes)) return attributes;
                var ret = v.extend({}, attributes), w, attribute;
                for(attribute in attributes){
                    w = whitelist[attribute];
                    if (v.isObject(w)) ret[attribute] = cleanRecursive(ret[attribute], w);
                    else if (!w) delete ret[attribute];
                }
                return ret;
            }
            if (!v.isObject(whitelist) || !v.isObject(attributes)) return {};
            whitelist = buildObjectWhitelist(whitelist);
            return cleanRecursive(attributes, whitelist);
        },
        exposeModule: function exposeModule(validate, root, exports1, module1, define1) {
            if (exports1) {
                if (module1 && module1.exports) exports1 = module1.exports = validate;
                exports1.validate = validate;
            } else {
                root.validate = validate;
                if (validate.isFunction(define1) && define1.amd) define1([], function() {
                    return validate;
                });
            }
        },
        warn: function warn(msg) {
            if (typeof console !== "undefined" && console.warn) console.warn("[validate.js] " + msg);
        },
        error: function error(msg) {
            if (typeof console !== "undefined" && console.error) console.error("[validate.js] " + msg);
        }
    });
    validate.validators = {
        // Presence validates that the value isn't empty
        presence: function presence(value, options) {
            options = v.extend({}, this.options, options);
            if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) return options.message || this.message || "can't be blank";
        },
        length: function length(value, options, attribute) {
            // Empty values are allowed
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var is = options.is, maximum = options.maximum, minimum = options.minimum, tokenizer = options.tokenizer || function(val) {
                return val;
            }, err, errors = [];
            value = tokenizer(value);
            var length = value.length;
            if (!v.isNumber(length)) return options.message || this.notValid || "has an incorrect length";
            // Is checks
            if (v.isNumber(is) && length !== is) {
                err = options.wrongLength || this.wrongLength || "is the wrong length (should be %{count} characters)";
                errors.push(v.format(err, {
                    count: is
                }));
            }
            if (v.isNumber(minimum) && length < minimum) {
                err = options.tooShort || this.tooShort || "is too short (minimum is %{count} characters)";
                errors.push(v.format(err, {
                    count: minimum
                }));
            }
            if (v.isNumber(maximum) && length > maximum) {
                err = options.tooLong || this.tooLong || "is too long (maximum is %{count} characters)";
                errors.push(v.format(err, {
                    count: maximum
                }));
            }
            if (errors.length > 0) return options.message || errors;
        },
        numericality: function numericality(value, options, attribute, attributes, globalOptions) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var errors = [], name, count, checks = {
                greaterThan: function greaterThan(v, c) {
                    return v > c;
                },
                greaterThanOrEqualTo: function greaterThanOrEqualTo(v, c) {
                    return v >= c;
                },
                equalTo: function equalTo(v, c) {
                    return v === c;
                },
                lessThan: function lessThan(v, c) {
                    return v < c;
                },
                lessThanOrEqualTo: function lessThanOrEqualTo(v, c) {
                    return v <= c;
                },
                divisibleBy: function divisibleBy(v, c) {
                    return v % c === 0;
                }
            }, prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify;
            // Strict will check that it is a valid looking number
            if (v.isString(value) && options.strict) {
                var pattern = "^-?(0|[1-9]\\d*)";
                if (!options.onlyInteger) pattern += "(\\.\\d+)?";
                pattern += "$";
                if (!new RegExp(pattern).test(value)) return options.message || options.notValid || this.notValid || this.message || "must be a valid number";
            }
            // Coerce the value to a number unless we're being strict.
            if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) value = +value;
            // If it's not a number we shouldn't continue since it will compare it.
            if (!v.isNumber(value)) return options.message || options.notValid || this.notValid || this.message || "is not a number";
            // Same logic as above, sort of. Don't bother with comparisons if this
            // doesn't pass.
            if (options.onlyInteger && !v.isInteger(value)) return options.message || options.notInteger || this.notInteger || this.message || "must be an integer";
            for(name in checks){
                count = options[name];
                if (v.isNumber(count) && !checks[name](value, count)) {
                    // This picks the default message if specified
                    // For example the greaterThan check uses the message from
                    // this.notGreaterThan so we capitalize the name and prepend "not"
                    var key = "not" + v.capitalize(name);
                    var msg = options[key] || this[key] || this.message || "must be %{type} %{count}";
                    errors.push(v.format(msg, {
                        count: count,
                        type: prettify(name)
                    }));
                }
            }
            if (options.odd && value % 2 !== 1) errors.push(options.notOdd || this.notOdd || this.message || "must be odd");
            if (options.even && value % 2 !== 0) errors.push(options.notEven || this.notEven || this.message || "must be even");
            if (errors.length) return options.message || errors;
        },
        datetime: v.extend(function(value, options) {
            if (!v.isFunction(this.parse) || !v.isFunction(this.format)) throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
            // Empty values are fine
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var err, errors = [], earliest = options.earliest ? this.parse(options.earliest, options) : NaN, latest = options.latest ? this.parse(options.latest, options) : NaN;
            value = this.parse(value, options);
            // 86400000 is the number of milliseconds in a day, this is used to remove
            // the time from the date
            if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
                err = options.notValid || options.message || this.notValid || "must be a valid date";
                return v.format(err, {
                    value: arguments[0]
                });
            }
            if (!isNaN(earliest) && value < earliest) {
                err = options.tooEarly || options.message || this.tooEarly || "must be no earlier than %{date}";
                err = v.format(err, {
                    value: this.format(value, options),
                    date: this.format(earliest, options)
                });
                errors.push(err);
            }
            if (!isNaN(latest) && value > latest) {
                err = options.tooLate || options.message || this.tooLate || "must be no later than %{date}";
                err = v.format(err, {
                    date: this.format(latest, options),
                    value: this.format(value, options)
                });
                errors.push(err);
            }
            if (errors.length) return v.unique(errors);
        }, {
            parse: null,
            format: null
        }),
        date: function date(value, options) {
            options = v.extend({}, options, {
                dateOnly: true
            });
            return v.validators.datetime.call(v.validators.datetime, value, options);
        },
        format: function format(value, options) {
            if (v.isString(options) || options instanceof RegExp) options = {
                pattern: options
            };
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is invalid", pattern = options.pattern, match;
            // Empty values are allowed
            if (!v.isDefined(value)) return;
            if (!v.isString(value)) return message;
            if (v.isString(pattern)) pattern = new RegExp(options.pattern, options.flags);
            match = pattern.exec(value);
            if (!match || match[0].length != value.length) return message;
        },
        inclusion: function inclusion(value, options) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (v.isArray(options)) options = {
                within: options
            };
            options = v.extend({}, this.options, options);
            if (v.contains(options.within, value)) return;
            var message = options.message || this.message || "^%{value} is not included in the list";
            return v.format(message, {
                value: value
            });
        },
        exclusion: function exclusion(value, options) {
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (v.isArray(options)) options = {
                within: options
            };
            options = v.extend({}, this.options, options);
            if (!v.contains(options.within, value)) return;
            var message = options.message || this.message || "^%{value} is restricted";
            if (v.isString(options.within[value])) value = options.within[value];
            return v.format(message, {
                value: value
            });
        },
        email: v.extend(function(value, options) {
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not a valid email";
            // Empty values are fine
            if (!v.isDefined(value)) return;
            if (!v.isString(value)) return message;
            if (!this.PATTERN.exec(value)) return message;
        }, {
            PATTERN: /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
        }),
        equality: function equality(value, options, attribute, attributes, globalOptions) {
            if (!v.isDefined(value)) return;
            if (v.isString(options)) options = {
                attribute: options
            };
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not equal to %{attribute}";
            if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) throw new Error("The attribute must be a non empty string");
            var otherValue = v.getDeepObjectValue(attributes, options.attribute), comparator = options.comparator || function(v1, v2) {
                return v1 === v2;
            }, prettify = options.prettify || globalOptions && globalOptions.prettify || v.prettify;
            if (!comparator(value, otherValue, options, attribute, attributes)) return v.format(message, {
                attribute: prettify(options.attribute)
            });
        },
        // A URL validator that is used to validate URLs with the ability to
        // restrict schemes and some domains.
        url: function url(value, options) {
            if (!v.isDefined(value)) return;
            options = v.extend({}, this.options, options);
            var message = options.message || this.message || "is not a valid url", schemes = options.schemes || this.schemes || [
                "http",
                "https"
            ], allowLocal = options.allowLocal || this.allowLocal || false, allowDataUrl = options.allowDataUrl || this.allowDataUrl || false;
            if (!v.isString(value)) return message;
            // https://gist.github.com/dperini/729294
            var regex = "^(?:(?:" + schemes.join("|") + ")://)" + // user:pass authentication
            "(?:\\S+(?::\\S*)?@)?" + "(?:";
            var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
            if (allowLocal) tld += "?";
            else regex += // IP address exclusion
            // private & local networks
            "(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
            regex += // IP address dotted notation octets
            // excludes loopback network 0.0.0.0
            // excludes reserved space >= 224.0.0.0
            // excludes network & broacast addresses
            // (first & last IP address of each class)
            "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" + tld + ")" + // port number
            "(?::\\d{2,5})?" + // resource path
            "(?:[/?#]\\S*)?" + "$";
            if (allowDataUrl) {
                // RFC 2397
                var mediaType = "\\w+\\/[-+.\\w]+(?:;[\\w=]+)*";
                var urlchar = "[A-Za-z0-9-_.!~\\*'();\\/?:@&=+$,%]*";
                var dataurl = "data:(?:" + mediaType + ")?(?:;base64)?," + urlchar;
                regex = "(?:" + regex + ")|(?:^" + dataurl + "$)";
            }
            var PATTERN = new RegExp(regex, "i");
            if (!PATTERN.exec(value)) return message;
        },
        type: v.extend(function(value, originalOptions, attribute, attributes, globalOptions) {
            if (v.isString(originalOptions)) originalOptions = {
                type: originalOptions
            };
            if (!v.isDefined(value)) return;
            var options = v.extend({}, this.options, originalOptions);
            var type = options.type;
            if (!v.isDefined(type)) throw new Error("No type was specified");
            var check;
            if (v.isFunction(type)) check = type;
            else check = this.types[type];
            if (!v.isFunction(check)) throw new Error("validate.validators.type.types." + type + " must be a function.");
            if (!check(value, options, attribute, attributes, globalOptions)) {
                var message = originalOptions.message || this.messages[type] || this.message || options.message || (v.isFunction(type) ? "must be of the correct type" : "must be of type %{type}");
                if (v.isFunction(message)) message = message(value, originalOptions, attribute, attributes, globalOptions);
                return v.format(message, {
                    attribute: v.prettify(attribute),
                    type: type
                });
            }
        }, {
            types: {
                object: function object(value) {
                    return v.isObject(value) && !v.isArray(value);
                },
                array: v.isArray,
                integer: v.isInteger,
                number: v.isNumber,
                string: v.isString,
                date: v.isDate,
                boolean: v.isBoolean
            },
            messages: {}
        })
    };
    validate.formatters = {
        detailed: function detailed(errors) {
            return errors;
        },
        flat: v.flattenErrorsToArray,
        grouped: function grouped(errors) {
            var attr;
            errors = v.groupErrorsByAttribute(errors);
            for(attr in errors)errors[attr] = v.flattenErrorsToArray(errors[attr]);
            return errors;
        },
        constraint: function constraint(errors) {
            var attr;
            errors = v.groupErrorsByAttribute(errors);
            for(attr in errors)errors[attr] = errors[attr].map(function(result) {
                return result.validator;
            }).sort();
            return errors;
        }
    };
    validate.exposeModule(validate, this, exports1, module1, define1);
}).call(this, /* istanbul ignore next */ exports, /* istanbul ignore next */ module, typeof define !== "undefined" ? /* istanbul ignore next */ define : null);

},{}],"4Jm10":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
}) // TODO: Rename to `createStore` once current `createStore` is deprecated (TICKET #: https://indicodata.atlassian.net/browse/UI-990)
;
parcelHelpers.export(exports, "createTypedStore", function() {
    return createTypedStore;
}) /**
   * Works just like createStore(), but includes undo/redo functionality.
   *
   * @see {@link https://github.com/charkour/zundo}
   */ ;
parcelHelpers.export(exports, "createStoreWithUndo", function() {
    return createStoreWithUndo;
});
parcelHelpers.export(exports, "shallow", function() {
    return 0, _shallowDefault.default;
});
var _zustand = require("zustand");
var _zustandDefault = parcelHelpers.interopDefault(_zustand);
var _middleware = require("zustand/middleware");
var _immer = require("immer");
var _zundo = require("zundo");
var _shallow = require("zustand/shallow"); // Immer middleware
var _shallowDefault = parcelHelpers.interopDefault(_shallow);
var immer = function(config) {
    return function(set, get, api) {
        return config(function(fn, replace, actionName) {
            set((0, _immer.produce)(fn), replace, actionName);
        }, get, api);
    };
}; // TODO: Deprecrate this function and rely on `createTypedStore` instead for all functions (TICKET #: https://indicodata.atlassian.net/browse/UI-990)
function createStore(store) {
    return (0, _zustandDefault.default)(immer(store));
}
function createTypedStore(store) {
    return (0, _zustandDefault.default)(immer(store));
}
function createStoreWithUndo(store, options) {
    return (0, _zustandDefault.default)((0, _zundo.undoMiddleware)(immer(store), options));
}

},{"zustand":"1qkDL","zustand/middleware":"2OZrY","immer":"fy6eo","zundo":"9SM4u","zustand/shallow":"hBKbT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1qkDL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var react = require("e3cb921f47249eac");
function createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
var isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var useIsomorphicLayoutEffect = isSSR ? react.useEffect : react.useLayoutEffect;
function create(createState) {
    var api = typeof createState === "function" ? createStore(createState) : createState;
    var useStore = function useStore(selector, equalityFn) {
        if (selector === void 0) selector = api.getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        var _ref = react.useReducer(function(c) {
            return c + 1;
        }, 0), forceUpdate = _ref[1];
        var state = api.getState();
        var stateRef = react.useRef(state);
        var selectorRef = react.useRef(selector);
        var equalityFnRef = react.useRef(equalityFn);
        var erroredRef = react.useRef(false);
        var currentSliceRef = react.useRef();
        if (currentSliceRef.current === undefined) currentSliceRef.current = selector(state);
        var newStateSlice;
        var hasNewStateSlice = false;
        if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
            newStateSlice = selector(state);
            hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
        }
        useIsomorphicLayoutEffect(function() {
            if (hasNewStateSlice) currentSliceRef.current = newStateSlice;
            stateRef.current = state;
            selectorRef.current = selector;
            equalityFnRef.current = equalityFn;
            erroredRef.current = false;
        });
        var stateBeforeSubscriptionRef = react.useRef(state);
        useIsomorphicLayoutEffect(function() {
            var listener = function listener() {
                try {
                    var nextState = api.getState();
                    var nextStateSlice = selectorRef.current(nextState);
                    if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
                        stateRef.current = nextState;
                        currentSliceRef.current = nextStateSlice;
                        forceUpdate();
                    }
                } catch (error) {
                    erroredRef.current = true;
                    forceUpdate();
                }
            };
            var unsubscribe = api.subscribe(listener);
            if (api.getState() !== stateBeforeSubscriptionRef.current) listener();
            return unsubscribe;
        }, []);
        var sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
        react.useDebugValue(sliceToReturn);
        return sliceToReturn;
    };
    Object.assign(useStore, api);
    useStore[Symbol.iterator] = function() {
        console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
        var items = [
            useStore,
            api
        ];
        return {
            next: function next() {
                var done = items.length <= 0;
                return {
                    value: items.shift(),
                    done: done
                };
            }
        };
    };
    return useStore;
}
exports["default"] = create;

},{"e3cb921f47249eac":"ktQNc"}],"2OZrY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var redux = function redux(reducer, initial) {
    return function(set, get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return _extends({
            dispatch: function dispatch() {
                return api.dispatch.apply(api, arguments);
            }
        }, initial);
    };
};
function devtools(fn, options) {
    return function(set, get, api) {
        var _serialize;
        var didWarnAboutNameDeprecation = false;
        if (typeof options === "string" && !didWarnAboutNameDeprecation) {
            console.warn("[zustand devtools middleware]: passing `name` as directly will be not allowed in next majorpass the `name` in an object `{ name: ... }` instead");
            didWarnAboutNameDeprecation = true;
        }
        var devtoolsOptions = options === undefined ? {
            name: undefined,
            anonymousActionType: undefined
        } : typeof options === "string" ? {
            name: options
        } : options;
        if (typeof (devtoolsOptions == null ? void 0 : (_serialize = devtoolsOptions.serialize) == null ? void 0 : _serialize.options) !== "undefined") console.warn("[zustand devtools middleware]: `serialize.options` is deprecated, just use `serialize`");
        var extensionConnector;
        try {
            extensionConnector = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_unused) {}
        if (!extensionConnector) return fn(set, get, api);
        var extension = Object.create(extensionConnector.connect(devtoolsOptions));
        var didWarnAboutDevtools = false;
        Object.defineProperty(api, "devtools", {
            get: function get() {
                if (!didWarnAboutDevtools) {
                    console.warn("[zustand devtools middleware] `devtools` property on the store is deprecated it will be removed in the next major.\nYou shouldn't interact with the extension directly. But in case you still want to you can patch `window.__REDUX_DEVTOOLS_EXTENSION__` directly");
                    didWarnAboutDevtools = true;
                }
                return extension;
            },
            set: function set(value) {
                if (!didWarnAboutDevtools) {
                    console.warn("[zustand devtools middleware] `api.devtools` is deprecated, it will be removed in the next major.\nYou shouldn't interact with the extension directly. But in case you still want to you can patch `window.__REDUX_DEVTOOLS_EXTENSION__` directly");
                    didWarnAboutDevtools = true;
                }
                extension = value;
            }
        });
        var didWarnAboutPrefix = false;
        Object.defineProperty(extension, "prefix", {
            get: function get() {
                if (!didWarnAboutPrefix) {
                    console.warn((devtoolsOptions.name, ", because the `name` option already creates a separate instance of devtools for each store."));
                    didWarnAboutPrefix = true;
                }
                return "";
            },
            set: function set() {
                if (!didWarnAboutPrefix) {
                    console.warn((devtoolsOptions.name, ", because the `name` option already creates a separate instance of devtools for each store."));
                    didWarnAboutPrefix = true;
                }
            }
        });
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            set(state, replace);
            if (!isRecording) return;
            extension.send(nameOrAction === undefined ? {
                type: devtoolsOptions.anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction, get());
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        extension.init(initialState);
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                if (a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch.apply(void 0, a);
            };
        }
        extension.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            setStateFromDevtools(action.state);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            return extension.init(api.getState());
                        case "COMMIT":
                            return extension.init(api.getState());
                        case "ROLLBACK":
                            return parseJsonThen(message.state, function(state) {
                                setStateFromDevtools(state);
                                extension.init(api.getState());
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return parseJsonThen(message.state, function(state) {
                                setStateFromDevtools(state);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            setStateFromDevtools(lastComputedState);
                            extension.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
}
var parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var subscribeWithSelector = function subscribeWithSelector(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var combine = function combine(initialState, create) {
    return function(set, get, api) {
        return Object.assign({}, initialState, create(set, get, api));
    };
};
var toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var persist = function persist(config, baseOptions) {
    return function(set, get, api) {
        var options = _extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return _extends({}, currentState, persistedState);
            }
        }, baseOptions);
        if (options.blacklist || options.whitelist) console.warn("The " + (options.blacklist ? "blacklist" : "whitelist") + " option is deprecated and will be removed in the next version. Please use the 'partialize' option instead.");
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        else if (!storage.removeItem) console.warn("[zustand persist middleware] The given storage for item '" + options.name + "' does not contain a 'removeItem' method, which will be required in v4.");
        var thenableSerialize = toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize(_extends({}, get()));
            if (options.whitelist) Object.keys(state).forEach(function(key) {
                var _options$whitelist;
                !((_options$whitelist = options.whitelist) != null && _options$whitelist.includes(key)) && delete state[key];
            });
            if (options.blacklist) options.blacklist.forEach(function(key) {
                return delete state[key];
            });
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                stateFromStorage = options.merge(migratedState, configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = _extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem == null || _storage.removeItem(options.name);
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
exports.combine = combine;
exports.devtools = devtools;
exports.persist = persist;
exports.redux = redux;
exports.subscribeWithSelector = subscribeWithSelector;

},{}],"fy6eo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", function() {
    return on;
});
parcelHelpers.export(exports, "applyPatches", function() {
    return vn;
});
parcelHelpers.export(exports, "castDraft", function() {
    return K;
});
parcelHelpers.export(exports, "castImmutable", function() {
    return $;
});
parcelHelpers.export(exports, "createDraft", function() {
    return pn;
});
parcelHelpers.export(exports, "current", function() {
    return D;
});
parcelHelpers.export(exports, "enableAllPlugins", function() {
    return J;
});
parcelHelpers.export(exports, "enableES5", function() {
    return T;
});
parcelHelpers.export(exports, "enableMapSet", function() {
    return C;
});
parcelHelpers.export(exports, "enablePatches", function() {
    return F;
});
parcelHelpers.export(exports, "finishDraft", function() {
    return ln;
});
parcelHelpers.export(exports, "immerable", function() {
    return L;
});
parcelHelpers.export(exports, "isDraft", function() {
    return t;
});
parcelHelpers.export(exports, "isDraftable", function() {
    return r;
});
parcelHelpers.export(exports, "nothing", function() {
    return H;
});
parcelHelpers.export(exports, "original", function() {
    return e;
});
parcelHelpers.export(exports, "produce", function() {
    return an;
});
parcelHelpers.export(exports, "produceWithPatches", function() {
    return fn;
});
parcelHelpers.export(exports, "setAutoFreeze", function() {
    return cn;
});
parcelHelpers.export(exports, "setUseProxies", function() {
    return sn;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function n(n) {
    for(var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), e = 1; e < t; e++)r[e - 1] = arguments[e];
    var _$i, o;
    throw Error("[Immer] minified error nr: " + n + (r.length ? " " + r.join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function t(n) {
    return !!n && !!n[Q];
}
function r(n) {
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var t = Object.getPrototypeOf(n);
        return !t || t === Object.prototype;
    }(n) || Array.isArray(n) || !!n[L] || !!n.constructor[L] || s(n) || v(n));
}
function e(r) {
    return t(r) || n(23, r), r[Q].t;
}
function i(n, t, r) {
    void 0 === r && (r = !1), 0 === o(n) ? (r ? Object.keys : Z)(n).forEach(function(e) {
        r && "symbol" == (typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e)) || t(e, n[e], n);
    }) : n.forEach(function(r, e) {
        return t(e, r, n);
    });
}
function o(n) {
    var t = n[Q];
    return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, t) {
    return 2 === o(n) ? n.has(t) : Object.prototype.hasOwnProperty.call(n, t);
}
function a(n, t) {
    return 2 === o(n) ? n.get(t) : n[t];
}
function f(n, t, r) {
    var e = o(n);
    2 === e ? n.set(t, r) : 3 === e ? (n.delete(t), n.add(r)) : n[t] = r;
}
function c(n, t) {
    return n === t ? 0 !== n || 1 / n == 1 / t : n != n && t != t;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var t = nn(n);
    delete t[Q];
    for(var r = Z(t), e = 0; e < r.length; e++){
        var _$i = r[e], o = t[_$i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (t[_$i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[_$i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), t);
}
function d(n, e) {
    y(n) || t(n) || !r(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, t) {
        return d(t, !0);
    }, !0));
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(t) {
    var r = tn[t];
    return r || n(19, t), r;
}
function m(n, t) {
    tn[n] = t;
}
function _() {
    return U;
}
function j(n, t) {
    t && (b("Patches"), n.u = [], n.s = [], n.v = t);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var t = n[Q];
    0 === t.i || 1 === t.i ? t.j() : t.g = !0;
}
function P(t, e) {
    e._ = e.p.length;
    var _$i = e.p[0], o = void 0 !== t && t !== _$i;
    return e.h.O || b("ES5").S(e, t, o), o ? (_$i[Q].P && (g(e), n(4)), r(t) && (t = M(e, t), e.l || x(e, t)), e.u && b("Patches").M(_$i[Q], t, e.u, e.s)) : t = M(e, _$i, []), g(e), e.u && e.v(e.u, e.s), t !== H ? t : void 0;
}
function M(n, t, r) {
    if (y(t)) return t;
    var e = t[Q];
    if (!e) return i(t, function(i, o) {
        return A(n, e, t, i, o, r);
    }, !0), t;
    if (e.A !== n) return t;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o;
        i(3 === e.i ? new Set(o) : o, function(t, i) {
            return A(n, e, o, t, i, r);
        }), x(n, o, !1), r && n.u && b("Patches").R(e, r, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s) {
    if (t(c)) {
        var v = M(e, c, s && i && 3 !== i.i && !u(i.D, a) ? s.concat(a) : void 0);
        if (f(o, a, v), !t(v)) return;
        e.m = !1;
    }
    if (r(c) && !y(c)) {
        if (!e.h.N && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, t, r) {
    void 0 === r && (r = !1), n.h.N && n.m && d(t, r);
}
function z(n, t) {
    var r = n[Q];
    return (r ? p(r) : n)[t];
}
function I(n, t) {
    if (t in n) for(var r = Object.getPrototypeOf(n); r;){
        var e = Object.getOwnPropertyDescriptor(r, t);
        if (e) return e;
        r = Object.getPrototypeOf(r);
    }
}
function E(n) {
    n.P || (n.P = !0, n.l && E(n.l));
}
function k(n) {
    n.o || (n.o = l(n.t));
}
function R(n, t, r) {
    var e = s(t) ? b("MapSet").T(t, r) : v(t) ? b("MapSet").F(t, r) : n.O ? function(n, t) {
        var _$r = Array.isArray(n), e = {
            i: _$r ? 1 : 0,
            A: t ? t.A : _(),
            P: !1,
            I: !1,
            D: {},
            l: t,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, _$i = e, o = rn;
        _$r && (_$i = [
            e
        ], o = en);
        var u = Proxy.revocable(_$i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(t, r) : b("ES5").J(t, r);
    return (r ? r.A : _()).p.push(e), e;
}
function D(e) {
    return t(e) || n(22, e), function n(t) {
        if (!r(t)) return t;
        var _$e, u = t[Q], c = o(t);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, _$e = N(t, c), u.I = !1;
        } else _$e = N(t, c);
        return i(_$e, function(t, r) {
            u && a(u.t, t) === r || f(_$e, t, n(r));
        }), 3 === c ? new Set(_$e) : _$e;
    }(e);
}
function N(n, t) {
    switch(t){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function T() {
    function r(n, t) {
        var r = s[n];
        return r ? r.enumerable = t : s[n] = r = {
            configurable: !0,
            enumerable: t,
            get: function get() {
                var _$t = this[Q];
                return rn.get(_$t, n);
            },
            set: function set(t) {
                var r = this[Q];
                rn.set(r, n, t);
            }
        }, r;
    }
    function e(n) {
        for(var t = n.length - 1; t >= 0; t--){
            var r = n[t][Q];
            if (!r.P) switch(r.i){
                case 5:
                    a(r) && E(r);
                    break;
                case 4:
                    o(r) && E(r);
            }
        }
    }
    function o(n) {
        for(var t = n.t, r = n.k, e = Z(r), _$i = e.length - 1; _$i >= 0; _$i--){
            var o = e[_$i];
            if (o !== Q) {
                var a = t[o];
                if (void 0 === a && !u(t, o)) return !0;
                var f = r[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!t[Q];
        return e.length !== Z(t).length + (v ? 0 : 1);
    }
    function a(n) {
        var t = n.k;
        if (t.length !== n.t.length) return !0;
        var r = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!r || r.get);
    }
    function f(t) {
        t.g && n(3, JSON.stringify(p(t)));
    }
    var s = {};
    m("ES5", {
        J: function J(n, t) {
            var e = Array.isArray(n), _$i = function(n, t) {
                if (n) {
                    for(var e = Array(t.length), _$i = 0; _$i < t.length; _$i++)Object.defineProperty(e, "" + _$i, r(_$i, !0));
                    return e;
                }
                var o = nn(t);
                delete o[Q];
                for(var u = Z(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = r(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(t), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: n,
                k: _$i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(_$i, Q, {
                value: o,
                writable: !0
            }), _$i;
        },
        S: function S(n, r, o) {
            o ? t(r) && r[Q].A === n && e(n.p) : (n.u && function n(t) {
                if (t && "object" == typeof t) {
                    var _$r = t[Q];
                    if (_$r) {
                        var _$e = _$r.t, _$o = _$r.k, f = _$r.D, c = _$r.i;
                        if (4 === c) i(_$o, function(t) {
                            t !== Q && (void 0 !== _$e[t] || u(_$e, t) ? f[t] || n(_$o[t]) : (f[t] = !0, E(_$r)));
                        }), i(_$e, function(n) {
                            void 0 !== _$o[n] || u(_$o, n) || (f[n] = !1, E(_$r));
                        });
                        else if (5 === c) {
                            if (a(_$r) && (E(_$r), f.length = !0), _$o.length < _$e.length) for(var s = _$o.length; s < _$e.length; s++)f[s] = !1;
                            else for(var v = _$e.length; v < _$o.length; v++)f[v] = !0;
                            for(var p = Math.min(_$o.length, _$e.length), l = 0; l < p; l++)void 0 === f[l] && n(_$o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function K(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function F() {
    function e(n) {
        if (!r(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var t = Object.create(Object.getPrototypeOf(n));
        for(var _$i in n)t[_$i] = e(n[_$i]);
        return t;
    }
    function f(n) {
        return t(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function $(t, r) {
            return r.forEach(function(r) {
                for(var _$i = r.path, u = r.op, f = t, s = 0; s < _$i.length - 1; s++)"object" != typeof (f = a(f, _$i[s])) && n(15, _$i.join("/"));
                var v = o(f), p = e(r.value), l = _$i[_$i.length - 1];
                switch(u){
                    case "replace":
                        switch(v){
                            case 2:
                                return f.set(l, p);
                            case 3:
                                n(16);
                            default:
                                return f[l] = p;
                        }
                    case c:
                        switch(v){
                            case 1:
                                return f.splice(l, 0, p);
                            case 2:
                                return f.set(l, p);
                            case 3:
                                return f.add(p);
                            default:
                                return f[l] = p;
                        }
                    case "remove":
                        switch(v){
                            case 1:
                                return f.splice(l, 1);
                            case 2:
                                return f.delete(l);
                            case 3:
                                return f.delete(r.value);
                            default:
                                return delete f[l];
                        }
                    default:
                        n(17, u);
                }
            }), t;
        },
        R: function R(n, t, r, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, t, r, e) {
                        var o = n.t, s = n.o;
                        i(n.D, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = t.concat(n);
                                r.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, t, r, e);
                case 5:
                case 1:
                    return function(n, t, r, e) {
                        var _$i = n.t, o = n.D, u = n.o;
                        if (u.length < _$i.length) {
                            var a = [
                                u,
                                _$i
                            ];
                            _$i = a[0], u = a[1];
                            var s = [
                                e,
                                r
                            ];
                            r = s[0], e = s[1];
                        }
                        for(var v = 0; v < _$i.length; v++)if (o[v] && u[v] !== _$i[v]) {
                            var p = t.concat([
                                v
                            ]);
                            r.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(_$i[v])
                            });
                        }
                        for(var l = _$i.length; l < u.length; l++){
                            var d = t.concat([
                                l
                            ]);
                            r.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        _$i.length < u.length && e.push({
                            op: "replace",
                            path: t.concat([
                                "length"
                            ]),
                            value: _$i.length
                        });
                    }(n, t, r, e);
                case 3:
                    return function(n, t, r, e) {
                        var _$i = n.t, o = n.o, u = 0;
                        _$i.forEach(function(n) {
                            if (!o.has(n)) {
                                var _$i = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: "remove",
                                    path: _$i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: _$i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!_$i.has(n)) {
                                var o = t.concat([
                                    u
                                ]);
                                r.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, t, r, e);
            }
        },
        M: function M(n, t, r, e) {
            r.push({
                op: "replace",
                path: [],
                value: t
            }), e.push({
                op: "replace",
                path: [],
                value: n.t
            });
        }
    });
}
function C() {
    function t(n, t) {
        function r() {
            this.constructor = n;
        }
        a(n, t), n.prototype = (r.prototype = t.prototype, new r);
    }
    function e(n) {
        n.o || (n.D = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(t) {
            if (r(t)) {
                var e = R(n.A.h, t, n);
                n.p.set(t, e), n.o.add(e);
            } else n.o.add(t);
        }));
    }
    function u(t) {
        t.g && n(3, JSON.stringify(p(t)));
    }
    var a = function a1(n, t) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, t) {
            n.__proto__ = t;
        } || function(n, t) {
            for(var r in t)t.hasOwnProperty(r) && (n[r] = t[r]);
        })(n, t);
    }, f = function() {
        function n(n, t) {
            return this[Q] = {
                i: 2,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                D: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        t(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function get() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, t) {
            var r = this[Q];
            return u(r), p(r).has(n) && p(r).get(n) === t || (e(r), E(r), r.D.set(n, !0), r.o.set(n, t), r.D.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var _$t = this[Q];
            return u(_$t), e(_$t), E(_$t), _$t.D.set(n, !1), _$t.o.delete(n), !0;
        }, o.clear = function() {
            var _$n = this[Q];
            u(_$n), p(_$n).size && (e(_$n), E(_$n), _$n.D = new Map, i(_$n.t, function(t) {
                _$n.D.set(t, !1);
            }), _$n.o.clear());
        }, o.forEach = function(n, t) {
            var r = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(t, r.get(i), i, r);
            });
        }, o.get = function(n) {
            var _$t = this[Q];
            u(_$t);
            var _$i = p(_$t).get(n);
            if (_$t.I || !r(_$i)) return _$i;
            if (_$i !== _$t.t.get(n)) return _$i;
            var o = R(_$t.A.h, _$i, _$t);
            return e(_$t), _$t.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var _$n, _$t = this, r = this.keys();
            return (_$n = {})[V] = function() {
                return _$t.values();
            }, _$n.next = function() {
                var _$n = r.next();
                return _$n.done ? _$n : {
                    done: !1,
                    value: _$t.get(_$n.value)
                };
            }, _$n;
        }, o.entries = function() {
            var _$n, _$t = this, r = this.keys();
            return (_$n = {})[V] = function() {
                return _$t.entries();
            }, _$n.next = function() {
                var _$n = r.next();
                if (_$n.done) return _$n;
                var e = _$t.get(_$n.value);
                return {
                    done: !1,
                    value: [
                        _$n.value,
                        e
                    ]
                };
            }, _$n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, t) {
            return this[Q] = {
                i: 3,
                l: t,
                A: t ? t.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        t(n, Set);
        var r = n.prototype;
        return Object.defineProperty(r, "size", {
            get: function get() {
                return p(this[Q]).size;
            }
        }), r.has = function(n) {
            var _$t = this[Q];
            return u(_$t), _$t.o ? !!_$t.o.has(n) || !(!_$t.p.has(n) || !_$t.o.has(_$t.p.get(n))) : _$t.t.has(n);
        }, r.add = function(n) {
            var _$t = this[Q];
            return u(_$t), this.has(n) || (o(_$t), E(_$t), _$t.o.add(n)), this;
        }, r.delete = function(n) {
            if (!this.has(n)) return !1;
            var _$t = this[Q];
            return u(_$t), o(_$t), E(_$t), _$t.o.delete(n) || !!_$t.p.has(n) && _$t.o.delete(_$t.p.get(n));
        }, r.clear = function() {
            var _$n = this[Q];
            u(_$n), p(_$n).size && (o(_$n), E(_$n), _$n.o.clear());
        }, r.values = function() {
            var _$n = this[Q];
            return u(_$n), o(_$n), _$n.o.values();
        }, r.entries = function() {
            var _$n = this[Q];
            return u(_$n), o(_$n), _$n.o.entries();
        }, r.keys = function() {
            return this.values();
        }, r[V] = function() {
            return this.values();
        }, r.forEach = function(n, t) {
            for(var r = this.values(), e = r.next(); !e.done;)n.call(t, e.value, e.value, this), e = r.next();
        }, n;
    }();
    m("MapSet", {
        T: function T(n, t) {
            return new f(n, t);
        },
        F: function F(n, t) {
            return new c(n, t);
        }
    });
}
function J() {
    T(), C(), F();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == (0, _typeOf._)(Symbol("x")), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    19: "plugin not loaded",
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    }
}, Z = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function Z(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, nn = Object.getOwnPropertyDescriptors || function(n) {
    var t = {};
    return Z(n).forEach(function(r) {
        t[r] = Object.getOwnPropertyDescriptor(n, r);
    }), t;
}, tn = {}, rn = {
    get: function get(n, t) {
        if (t === Q) return n;
        var e = p(n);
        if (!u(e, t)) return function(n, t, r) {
            var e, _$i = I(t, r);
            return _$i ? "value" in _$i ? _$i.value : null === (e = _$i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, t);
        var _$i = e[t];
        return n.I || !r(_$i) ? _$i : _$i === z(n.t, t) ? (k(n), n.o[t] = R(n.A.h, _$i, n)) : _$i;
    },
    has: function has(n, t) {
        return t in p(n);
    },
    ownKeys: function ownKeys(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function set(n, t, r) {
        var e = I(p(n), t);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, r), !0;
        if (!n.P) {
            var _$i = z(p(n), t), o = null == _$i ? void 0 : _$i[Q];
            if (o && o.t === r) return n.o[t] = r, n.D[t] = !1, !0;
            if (c(r, _$i) && (void 0 !== r || u(n.t, t))) return !0;
            k(n), E(n);
        }
        return n.o[t] = r, n.D[t] = !0, !0;
    },
    deleteProperty: function deleteProperty(n, t) {
        return void 0 !== z(n.t, t) || t in n.t ? (n.D[t] = !1, k(n), E(n)) : delete n.D[t], n.o && delete n.o[t], !0;
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(n, t) {
        var r = p(n), e = Reflect.getOwnPropertyDescriptor(r, t);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== t,
            enumerable: e.enumerable,
            value: r[t]
        } : e;
    },
    defineProperty: function defineProperty() {
        n(11);
    },
    getPrototypeOf: function getPrototypeOf(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function setPrototypeOf() {
        n(12);
    }
}, en = {};
i(rn, function(n, t) {
    en[n] = function() {
        return arguments[0] = arguments[0][0], t.apply(this, arguments);
    };
}), en.deleteProperty = function(t, r) {
    return rn.deleteProperty.call(this, t[0], r);
}, en.set = function(t, r, e) {
    return rn.set.call(this, t[0], r, e, t[0]);
};
var on = function() {
    function e(n) {
        this.O = B, this.N = false, "boolean" == typeof (null == n ? void 0 : n.useProxies) && this.setUseProxies(n.useProxies), "boolean" == typeof (null == n ? void 0 : n.autoFreeze) && this.setAutoFreeze(n.autoFreeze), this.produce = this.produce.bind(this), this.produceWithPatches = this.produceWithPatches.bind(this);
    }
    var _$i = e.prototype;
    return _$i.produce = function(t, e, i) {
        if ("function" == typeof t && "function" != typeof e) {
            var o = e;
            e = t;
            var u = this;
            return function(n) {
                var _$t = this;
                void 0 === n && (n = o);
                for(var _$r = arguments.length, _$i = Array(_$r > 1 ? _$r - 1 : 0), a = 1; a < _$r; a++)_$i[a - 1] = arguments[a];
                return u.produce(n, function(n) {
                    var _$r;
                    return (_$r = e).call.apply(_$r, [
                        _$t,
                        n
                    ].concat(_$i));
                });
            };
        }
        var a;
        if ("function" != typeof e && n(6), void 0 !== i && "function" != typeof i && n(7), r(t)) {
            var f = w(this), c = R(this, t, void 0), s = !0;
            try {
                a = e(c), s = !1;
            } finally{
                s ? g(f) : O(f);
            }
            return "undefined" != typeof Promise && a instanceof Promise ? a.then(function(n) {
                return j(f, i), P(n, f);
            }, function(n) {
                throw g(f), n;
            }) : (j(f, i), P(a, f));
        }
        if (!t || "object" != typeof t) {
            if ((a = e(t)) === H) return;
            return void 0 === a && (a = t), this.N && d(a, !0), a;
        }
        n(21, t);
    }, _$i.produceWithPatches = function(n, t) {
        var r, _$e, _$i = this;
        return "function" == typeof n ? function(t) {
            for(var r = arguments.length, _$e = Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)_$e[o - 1] = arguments[o];
            return _$i.produceWithPatches(t, function(t) {
                return n.apply(void 0, [
                    t
                ].concat(_$e));
            });
        } : [
            this.produce(n, t, function(n, t) {
                r = n, _$e = t;
            }),
            r,
            _$e
        ];
    }, _$i.createDraft = function(e) {
        r(e) || n(8), t(e) && (e = D(e));
        var _$i = w(this), o = R(this, e, void 0);
        return o[Q].C = !0, O(_$i), o;
    }, _$i.finishDraft = function(t, r) {
        var _$e = t && t[Q];
        var _$i = _$e.A;
        return j(_$i, r), P(void 0, _$i);
    }, _$i.setAutoFreeze = function(n) {
        this.N = n;
    }, _$i.setUseProxies = function(t) {
        t && !B && n(20), this.O = t;
    }, _$i.applyPatches = function(n, r) {
        var _$e;
        for(_$e = r.length - 1; _$e >= 0; _$e--){
            var _$i = r[_$e];
            if (0 === _$i.path.length && "replace" === _$i.op) {
                n = _$i.value;
                break;
            }
        }
        var o = b("Patches").$;
        return t(n) ? o(n, r) : this.produce(n, function(n) {
            return o(n, r.slice(_$e + 1));
        });
    }, e;
}(), un = new on, an = un.produce, fn = un.produceWithPatches.bind(un), cn = un.setAutoFreeze.bind(un), sn = un.setUseProxies.bind(un), vn = un.applyPatches.bind(un), pn = un.createDraft.bind(un), ln = un.finishDraft.bind(un);
exports.default = an;

},{"@swc/helpers/_/_type_of":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9SM4u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", function() {
    return create;
});
parcelHelpers.export(exports, "undoMiddleware", function() {
    return undoMiddleware;
});
var _zustand = require("zustand");
var _zustandDefault = parcelHelpers.interopDefault(_zustand);
var _lodashIsequal = require("lodash.isequal");
var _lodashIsequalDefault = parcelHelpers.interopDefault(_lodashIsequal);
var _vanilla = require("zustand/vanilla");
var _vanillaDefault = parcelHelpers.interopDefault(_vanilla);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// TODO: make this a better type
var filterState = function filterState(state, options) {
    var excluded = (options == null ? void 0 : options.exclude) || (options == null ? void 0 : options.omit);
    var included = options == null ? void 0 : options.include;
    var filteredState = {};
    Object.keys(state).forEach(function(key) {
        if (!(excluded && excluded.includes(key)) && (!included || included.includes(key))) filteredState[key] = state[key];
    });
    return filteredState;
};
var handleStoreUpdates = function handleStoreUpdates(get, action) {
    var _get = get(), prevStates = _get.prevStates, futureStates = _get.futureStates, setStore = _get.setStore, getStore = _get.getStore, options = _get.options;
    var isUndo = action === "undo";
    var currentActionStates = isUndo ? prevStates : futureStates;
    var otherActionStates = isUndo ? futureStates : prevStates;
    var limit = options == null ? void 0 : options.historyDepthLimit;
    if (currentActionStates.length > 0) {
        // check history limit
        if (limit && otherActionStates.length >= limit) // pop front
        otherActionStates.shift();
        otherActionStates.push(filterState(getStore(), options));
        var currentStoreState = currentActionStates.pop();
        setStore(currentStoreState);
    }
}; // factory to create undoStore. contains memory about past and future states and has methods to traverse states
var createUndoStore = function createUndoStore() {
    return (0, _vanillaDefault.default)(function(set, get) {
        return {
            prevStates: [],
            futureStates: [],
            isUndoHistoryEnabled: true,
            undo: function undo() {
                var _get2 = get(), coolOffTimer = _get2.coolOffTimer; // Clear cool off if user clicks "undo" during cool-off period
                if (coolOffTimer) clearTimeout(coolOffTimer);
                set({
                    isCoolingOff: false
                });
                handleStoreUpdates(get, "undo");
            },
            redo: function redo() {
                handleStoreUpdates(get, "redo");
            },
            clear: function clear() {
                set({
                    prevStates: [],
                    futureStates: []
                });
                get().setStore();
            },
            setIsUndoHistoryEnabled: function setIsUndoHistoryEnabled(isEnabled) {
                var _get3 = get(), prevStates = _get3.prevStates, getStore = _get3.getStore, options = _get3.options;
                var currState = filterState(getStore(), options);
                set({
                    isUndoHistoryEnabled: isEnabled,
                    prevStates: isEnabled ? prevStates : [].concat(prevStates, [
                        currState
                    ])
                });
            },
            setStore: function setStore() {},
            getStore: function getStore() {},
            options: {},
            forceUpdate: function forceUpdate() {}
        };
    });
};
var undoMiddleware = function undoMiddleware(config, options) {
    return function(set, get, api) {
        var undoStore = createUndoStore();
        var getState = undoStore.getState, setState = undoStore.setState;
        return config(function(args) {
            /* TODO: const, should call this function and inject the values once, but it does
      it on every action call currently. */ var _getState = getState(), undo = _getState.undo, clear = _getState.clear, redo = _getState.redo, setIsUndoHistoryEnabled = _getState.setIsUndoHistoryEnabled, isUndoHistoryEnabled = _getState.isUndoHistoryEnabled, isCoolingOff = _getState.isCoolingOff, coolOffTimer = _getState.coolOffTimer; // inject helper functions to user defined store.
            set({
                undo: undo,
                clear: clear,
                redo: redo,
                getState: getState,
                setIsUndoHistoryEnabled: setIsUndoHistoryEnabled
            }); // Get the last state before updating state
            var lastState = filterState(_extends({}, get()), options);
            set(args); // Get the current state after updating state
            var currState = filterState(_extends({}, get()), options); // Only store changes if state isn't equal (or option has been set)
            var shouldStoreChange = isUndoHistoryEnabled && (!(0, _lodashIsequalDefault.default)(lastState, currState) || (options == null ? void 0 : options.allowUnchanged));
            var limit = options == null ? void 0 : options.historyDepthLimit;
            if (shouldStoreChange) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                coolOffTimer && clearTimeout(coolOffTimer);
                if (!isCoolingOff) {
                    var _getState2 = getState(), prevStates = _getState2.prevStates;
                    if (limit && prevStates.length >= limit) // pop front
                    prevStates.shift();
                    setState({
                        prevStates: [].concat(prevStates, [
                            lastState
                        ]),
                        futureStates: [],
                        options: options,
                        setStore: set,
                        getStore: get
                    });
                }
                setState({
                    isCoolingOff: true,
                    coolOffTimer: window.setTimeout(function() {
                        setState({
                            isCoolingOff: false
                        });
                    }, options == null ? void 0 : options.coolOffDurationMs)
                });
            }
        }, get, api);
    };
};
var create = function create(config, options) {
    return (0, _zustandDefault.default)(undoMiddleware(config, options));
};
exports.default = create;

},{"zustand":"1qkDL","lodash.isequal":"hL5C4","zustand/vanilla":"a0lGu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hL5C4":[function(require,module,exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function isArguments(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"a0lGu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function createStore(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (nextState !== state) {
            var _previousState = state;
            state = replace ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
        if (selector === void 0) selector = getState;
        if (equalityFn === void 0) equalityFn = Object.is;
        console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
        var currentSlice = selector(state);
        function listenerToAdd() {
            var nextSlice = selector(state);
            if (!equalityFn(currentSlice, nextSlice)) {
                var _previousSlice = currentSlice;
                listener(currentSlice = nextSlice, _previousSlice);
            }
        }
        listeners.add(listenerToAdd);
        return function() {
            return listeners.delete(listenerToAdd);
        };
    };
    var subscribe = function subscribe(listener, selector, equalityFn) {
        if (selector || equalityFn) return subscribeWithSelector(listener, selector, equalityFn);
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        return listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
}
exports["default"] = createStore;

},{}],"hBKbT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
exports["default"] = shallow;

},{}],"8Uc6P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4SCVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Buttons", function() {
    return Buttons;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  appearance: none;\n  background-color: ",
        ";\n  border: 0;\n  border-radius: 2px;\n  color: ",
        ";\n  cursor: pointer;\n  display: inline-block;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  font-family: ",
        ";\n  font-size: ",
        ";\n  -webkit-font-smoothing: antialiased;\n  line-height: 1;\n  padding: ",
        " ",
        ";\n  text-align: center;\n  text-decoration: none;\n  transition: background-color ",
        " ",
        ";\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  box-shadow: 0 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  :where(button, [type='button'], [type='reset'], [type='submit'], .button):not(.btn) {\n    ",
        "\n\n    &:hover,\n    &:focus {\n      background-color: #bebebe;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n\n      background-color: ",
        ";\n  \n      &:hover {\n        background-color: ",
        ";\n      }\n    }\n\n    &.red {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #ed3c39;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: ",
        ";\n\n        &:hover {\n          background-color: ",
        ";\n        }\n      }\n\n      &.round:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: ",
        ";\n\n        &:hover {\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    &.blue {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #1777c2;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: #1e88e5;\n\n        &:hover {\n          background-color: #1e88e5;\n        }\n      }\n    }\n\n    &.green {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #419a45;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: #419a45;\n\n        &:hover {\n          background-color: #419a45;\n        }\n      }\n    }\n\n    &.cta {\n      font-size: ",
        ";\n    }\n\n    &.round {\n      border-radius: 50%;\n      padding: 10px;\n    }\n\n    &.link-style {\n      background: none;\n      box-shadow: none;\n      text-decoration: underline;\n      padding: 0;\n      transition: color ",
        " ",
        ", text-decoration-color ",
        " ",
        ";\n      color: ",
        ";\n      text-decoration-color: currentColor;\n\n      &:hover {\n        text-decoration-color: transparent;\n        color: ",
        ";\n      }\n    }\n\n    .fa-fw {\n      width: 1em;\n      text-align: center;\n    }\n\n    i {\n      display: inline-block;\n      margin-right: 2px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var buttonColor = (0, _constants.COLORS).darkFontColor;
var buttonBackground = (0, _constants.COLORS).iron;
var buttonDefault = (0, _styledComponents.css)(_templateObject(), buttonBackground, buttonColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).spacing.base, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).black);
var Buttons = (0, _styledComponents.createGlobalStyle)(_templateObject1(), buttonDefault, buttonColor, (0, _constants.COLORS).romanSilver, (0, _constants.COLORS).romanSilver, (0, _constants.COLORS).red, (0, _constants.COLORS).hiliteFontColor, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).curiousBlue, (0, _constants.COLORS).hiliteFontColor, (0, _constants.COLORS).green, (0, _constants.COLORS).hiliteFontColor, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k8r4V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", function() {
    return Layout;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _colorProperties = require("./color-properties");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  html {\n    box-sizing: border-box;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n\n  html,\n  body {\n    height: 100%;\n  }\n\n  body {\n    margin: 0;\n    background-color: var(",
        ");\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Layout = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _colorProperties.colorProperties).appBackground);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","./color-properties":"jMbJk","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4fZWz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lists", function() {
    return Lists;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ul,\n  ol {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  dl {\n    margin: 0;\n  }\n\n  dt {\n    font-weight: 600;\n    margin: 0;\n  }\n\n  dd {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Lists = (0, _styledComponents.createGlobalStyle)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3D7c7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Media", function() {
    return Media;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "  \n  figure {\n    margin: 0;\n  }\n\n  img,\n  picture {\n    margin: 0;\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Media = (0, _styledComponents.createGlobalStyle)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"69syw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tables", function() {
    return Tables;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _utils = require("@indico-data/utils");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  table {\n    border-collapse: collapse;\n    margin: ",
        " 0;\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  th {\n    font-size: ",
        ";\n    border-bottom: 0.5px solid ",
        ";\n    padding: 20px 15px 5px;\n    font-weight: 400;\n    text-align: left;\n  }\n\n  td {\n    border-bottom: 0.5px solid ",
        ";\n    padding: 20px 15px;\n    font-size: ",
        ";\n  }\n\n  tr,\n  td,\n  th {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Tables = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _utils.colorUtils).hexToRgb((0, _constants.COLORS).defaultFontColor, 0.1), (0, _utils.colorUtils).hexToRgb((0, _constants.COLORS).defaultFontColor, 0.1), (0, _constants.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"epDVt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Typography", function() {
    return Typography;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  html {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-size: 100%;\n    line-height: ",
        ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    margin: 0 0 10px;\n    color: ",
        ";\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  h3 {\n    font-size: ",
        ";\n  }\n\n  h4 {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  h5 {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  p {\n    margin: 0 0;\n    font-size: ",
        ";\n  }\n\n  .t-caption { font-size: ",
        "; }\n  .t-base { font-size: ",
        "; }\n  .t-subhead-small { font-size: ",
        "; }\n  .t-subhead-large { font-size: ",
        "; }\n  .t-display { font-size: ",
        "; }\n\n  .t-bold { font-weight: bold; }\n  .t-italic { font-style: italic; }\n\n  .error {\n    color: ",
        ";\n  }\n\n  .prompt {\n    color: ",
        ";\n  }\n\n  .warning {\n    color: ",
        ";\n  }\n\n  .success {\n    color: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n    transition: color ",
        " ",
        ";\n\n    &:active,\n    &:focus,\n    &:hover {\n      color: ",
        ";\n      text-decoration: none;\n    }\n  }\n\n  hr {\n    border-bottom: 1px solid ",
        ";\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    margin: ",
        " 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Typography = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).lineHeight.base, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.display, (0, _constants.TYPOGRAPHY).lineHeight.heading, (0, _constants.COLORS).lightGray, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontSize.caption, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.caption, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.TYPOGRAPHY).fontSize.display, (0, _constants.COLORS).red, (0, _constants.COLORS).curiousBlue, (0, _constants.COLORS).yellow, (0, _constants.COLORS).green, (0, _constants.COLORS).actionColor, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).defaultFontColor, (0, _constants.COLORS).borderColor, (0, _constants.TYPOGRAPHY).spacing.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aJKOr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginPadding", function() {
    return MarginPadding;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "  \n  .pt-md {\n    padding-top: ",
        ";\n  }\n  .pt-sm {\n    padding-top: ",
        ";\n  }\n  .pb-md {\n    padding-bottom: ",
        ";\n  }\n  .pb-sm {\n    padding-bottom: ",
        ";\n  }\n  .mt-md {\n    margin-top: ",
        ";\n  }\n  .mt-sm {\n    margin-top: ",
        ";\n  }\n  .mb-md {\n    margin-bottom: ",
        ";\n  }\n  .mb-sm {\n    margin-bottom: ",
        ";\n  }\n  .my-md {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var MarginPadding = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.PADDINGS).md, (0, _constants.PADDINGS).sm, (0, _constants.PADDINGS).md, (0, _constants.PADDINGS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).md);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"g2nxL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6IUjL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleLineEllipsis", function() {
    return singleLineEllipsis;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var singleLineEllipsis = (0, _styledComponents.css)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2E3tr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "faIcons", function() {
    return faIcons;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var faIcons = {
    "fa-dot-circle": generateSvg((0, _freeRegularSvgIcons.faDotCircle)),
    "fa-file": generateSvg((0, _freeRegularSvgIcons.faFile)),
    "fa-file-alt": generateSvg((0, _freeRegularSvgIcons.faFileAlt)),
    "fa-file-pdf": generateSvg((0, _freeRegularSvgIcons.faFilePdf)),
    "fa-file-word": generateSvg((0, _freeRegularSvgIcons.faFileWord)),
    "fa-check-square": generateSvg((0, _freeRegularSvgIcons.faCheckSquare)),
    "fa-square": generateSvg((0, _freeRegularSvgIcons.faSquare)),
    "fa-angle-double-left": generateSvg((0, _freeSolidSvgIcons.faAngleDoubleLeft)),
    "fa-arrow-circle-right": generateSvg((0, _freeSolidSvgIcons.faArrowCircleRight)),
    "fa-arrow-down": generateSvg((0, _freeSolidSvgIcons.faArrowDown)),
    "fa-arrow-left": generateSvg((0, _freeSolidSvgIcons.faArrowLeft)),
    "fa-arrow-right": generateSvg((0, _freeSolidSvgIcons.faArrowRight)),
    "fa-arrow-up": generateSvg((0, _freeSolidSvgIcons.faArrowUp)),
    "fa-ban": generateSvg((0, _freeSolidSvgIcons.faBan)),
    "fa-binoculars": generateSvg((0, _freeSolidSvgIcons.faBinoculars)),
    "fa-bell": generateSvg((0, _freeSolidSvgIcons.faBell)),
    "fa-caret-down": generateSvg((0, _freeSolidSvgIcons.faCaretDown)),
    "fa-caret-up": generateSvg((0, _freeSolidSvgIcons.faCaretUp)),
    "fa-chart-bar": generateSvg((0, _freeSolidSvgIcons.faChartBar)),
    "fa-check": generateSvg((0, _freeSolidSvgIcons.faCheck)),
    "fa-check-circle": generateSvg((0, _freeSolidSvgIcons.faCheckCircle)),
    "fa-circle-notch": generateSvg((0, _freeSolidSvgIcons.faCircleNotch)),
    "fa-clipboard": generateSvg((0, _freeSolidSvgIcons.faClipboard)),
    "fa-clock": generateSvg((0, _freeSolidSvgIcons.faClock)),
    "fa-clone": generateSvg((0, _freeSolidSvgIcons.faClone)),
    "fa-cloud": generateSvg((0, _freeSolidSvgIcons.faCloud)),
    "fa-cog": generateSvg((0, _freeSolidSvgIcons.faCog)),
    "fa-cogs": generateSvg((0, _freeSolidSvgIcons.faCogs)),
    "fa-coins": generateSvg((0, _freeSolidSvgIcons.faCoins)),
    "fa-cube": generateSvg((0, _freeSolidSvgIcons.faCube)),
    "fa-cut": generateSvg((0, _freeSolidSvgIcons.faCut)),
    "fa-download": generateSvg((0, _freeSolidSvgIcons.faDownload)),
    "fa-exclamation-circle": generateSvg((0, _freeSolidSvgIcons.faExclamationCircle)),
    "fa-exclamation-triangle": generateSvg((0, _freeSolidSvgIcons.faExclamationTriangle)),
    "fa-external-link-alt": generateSvg((0, _freeSolidSvgIcons.faExternalLinkAlt)),
    "fa-eye-dropper": generateSvg((0, _freeSolidSvgIcons.faEyeDropper)),
    "fa-file-download": generateSvg((0, _freeSolidSvgIcons.faFileDownload)),
    "fa-file-export": generateSvg((0, _freeSolidSvgIcons.faFileExport)),
    "fa-file-upload": generateSvg((0, _freeSolidSvgIcons.faFileUpload)),
    "fa-filter": generateSvg((0, _freeSolidSvgIcons.faFilter)),
    "fa-ghost": generateSvg((0, _freeSolidSvgIcons.faGhost)),
    "fa-hat-wizard": generateSvg((0, _freeSolidSvgIcons.faHatWizard)),
    "fa-info-circle": generateSvg((0, _freeSolidSvgIcons.faInfoCircle)),
    "fa-key": generateSvg((0, _freeSolidSvgIcons.faKey)),
    "fa-keyboard": generateSvg((0, _freeSolidSvgIcons.faKeyboard)),
    "fa-layer-group": generateSvg((0, _freeSolidSvgIcons.faLayerGroup)),
    "fa-pencil-alt": generateSvg((0, _freeSolidSvgIcons.faPencilAlt)),
    "fa-plus": generateSvg((0, _freeSolidSvgIcons.faPlus)),
    "fa-plus-square": generateSvg((0, _freeSolidSvgIcons.faPlusSquare)),
    "fa-question-circle": generateSvg((0, _freeSolidSvgIcons.faQuestionCircle)),
    "fa-robot": generateSvg((0, _freeSolidSvgIcons.faRobot)),
    "fa-search": generateSvg((0, _freeSolidSvgIcons.faSearch)),
    "fa-sign-out-alt": generateSvg((0, _freeSolidSvgIcons.faSignOutAlt)),
    "fa-sliders-h": generateSvg((0, _freeSolidSvgIcons.faSlidersH)),
    "fa-sync-alt": generateSvg((0, _freeSolidSvgIcons.faSyncAlt)),
    "fa-tag": generateSvg((0, _freeSolidSvgIcons.faTag)),
    "fa-times": generateSvg((0, _freeSolidSvgIcons.faTimes)),
    "fa-times-circle": generateSvg((0, _freeSolidSvgIcons.faTimesCircle)),
    "fa-tint": generateSvg((0, _freeSolidSvgIcons.faTint)),
    "fa-toggle-off": generateSvg((0, _freeSolidSvgIcons.faToggleOff)),
    "fa-toggle-on": generateSvg((0, _freeSolidSvgIcons.faToggleOn)),
    "fa-trash": generateSvg((0, _freeSolidSvgIcons.faTrash)),
    "fa-trash-alt": generateSvg((0, _freeSolidSvgIcons.faTrashAlt)),
    "fa-undo": generateSvg((0, _freeSolidSvgIcons.faUndo)),
    "fa-user": generateSvg((0, _freeSolidSvgIcons.faUser)),
    "fa-users": generateSvg((0, _freeSolidSvgIcons.faUsers)),
    "fa-mouse-pointer": generateSvg((0, _freeSolidSvgIcons.faMousePointer)),
    "fa-step-forward": generateSvg((0, _freeSolidSvgIcons.faStepForward)),
    "fa-search-minus": generateSvg((0, _freeSolidSvgIcons.faSearchMinus)),
    "fa-search-plus": generateSvg((0, _freeSolidSvgIcons.faSearchPlus)),
    "fa-table": generateSvg((0, _freeSolidSvgIcons.faTable)),
    "fa-image": generateSvg((0, _freeSolidSvgIcons.faImage)),
    "fa-link": generateSvg((0, _freeSolidSvgIcons.faLink)),
    "fa-list": generateSvg((0, _freeSolidSvgIcons.faList)),
    "fa-money-bill": generateSvg((0, _freeSolidSvgIcons.faMoneyBill)),
    "fa-minus": generateSvg((0, _freeSolidSvgIcons.faMinus)),
    "fa-expand": generateSvg((0, _freeSolidSvgIcons.faExpand))
};
function generateSvg(iconDefinition) {
    var icon = iconDefinition.icon;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        fill: "currentColor",
        viewBox: "0 0 ".concat(icon[0], " ").concat(icon[1])
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "".concat(icon[4])
    }));
}

},{"react":"ktQNc","@fortawesome/free-regular-svg-icons":"hw28Z","@fortawesome/free-solid-svg-icons":"eavdx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hw28Z":[function(require,module,exports) {
/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "far", function() {
    return _iconsCache;
});
parcelHelpers.export(exports, "prefix", function() {
    return prefix;
});
parcelHelpers.export(exports, "faAddressBook", function() {
    return faAddressBook;
});
parcelHelpers.export(exports, "faAddressCard", function() {
    return faAddressCard;
});
parcelHelpers.export(exports, "faAngry", function() {
    return faAngry;
});
parcelHelpers.export(exports, "faArrowAltCircleDown", function() {
    return faArrowAltCircleDown;
});
parcelHelpers.export(exports, "faArrowAltCircleLeft", function() {
    return faArrowAltCircleLeft;
});
parcelHelpers.export(exports, "faArrowAltCircleRight", function() {
    return faArrowAltCircleRight;
});
parcelHelpers.export(exports, "faArrowAltCircleUp", function() {
    return faArrowAltCircleUp;
});
parcelHelpers.export(exports, "faBell", function() {
    return faBell;
});
parcelHelpers.export(exports, "faBellSlash", function() {
    return faBellSlash;
});
parcelHelpers.export(exports, "faBookmark", function() {
    return faBookmark;
});
parcelHelpers.export(exports, "faBuilding", function() {
    return faBuilding;
});
parcelHelpers.export(exports, "faCalendar", function() {
    return faCalendar;
});
parcelHelpers.export(exports, "faCalendarAlt", function() {
    return faCalendarAlt;
});
parcelHelpers.export(exports, "faCalendarCheck", function() {
    return faCalendarCheck;
});
parcelHelpers.export(exports, "faCalendarMinus", function() {
    return faCalendarMinus;
});
parcelHelpers.export(exports, "faCalendarPlus", function() {
    return faCalendarPlus;
});
parcelHelpers.export(exports, "faCalendarTimes", function() {
    return faCalendarTimes;
});
parcelHelpers.export(exports, "faCaretSquareDown", function() {
    return faCaretSquareDown;
});
parcelHelpers.export(exports, "faCaretSquareLeft", function() {
    return faCaretSquareLeft;
});
parcelHelpers.export(exports, "faCaretSquareRight", function() {
    return faCaretSquareRight;
});
parcelHelpers.export(exports, "faCaretSquareUp", function() {
    return faCaretSquareUp;
});
parcelHelpers.export(exports, "faChartBar", function() {
    return faChartBar;
});
parcelHelpers.export(exports, "faCheckCircle", function() {
    return faCheckCircle;
});
parcelHelpers.export(exports, "faCheckSquare", function() {
    return faCheckSquare;
});
parcelHelpers.export(exports, "faCircle", function() {
    return faCircle;
});
parcelHelpers.export(exports, "faClipboard", function() {
    return faClipboard;
});
parcelHelpers.export(exports, "faClock", function() {
    return faClock;
});
parcelHelpers.export(exports, "faClone", function() {
    return faClone;
});
parcelHelpers.export(exports, "faClosedCaptioning", function() {
    return faClosedCaptioning;
});
parcelHelpers.export(exports, "faComment", function() {
    return faComment;
});
parcelHelpers.export(exports, "faCommentAlt", function() {
    return faCommentAlt;
});
parcelHelpers.export(exports, "faCommentDots", function() {
    return faCommentDots;
});
parcelHelpers.export(exports, "faComments", function() {
    return faComments;
});
parcelHelpers.export(exports, "faCompass", function() {
    return faCompass;
});
parcelHelpers.export(exports, "faCopy", function() {
    return faCopy;
});
parcelHelpers.export(exports, "faCopyright", function() {
    return faCopyright;
});
parcelHelpers.export(exports, "faCreditCard", function() {
    return faCreditCard;
});
parcelHelpers.export(exports, "faDizzy", function() {
    return faDizzy;
});
parcelHelpers.export(exports, "faDotCircle", function() {
    return faDotCircle;
});
parcelHelpers.export(exports, "faEdit", function() {
    return faEdit;
});
parcelHelpers.export(exports, "faEnvelope", function() {
    return faEnvelope;
});
parcelHelpers.export(exports, "faEnvelopeOpen", function() {
    return faEnvelopeOpen;
});
parcelHelpers.export(exports, "faEye", function() {
    return faEye;
});
parcelHelpers.export(exports, "faEyeSlash", function() {
    return faEyeSlash;
});
parcelHelpers.export(exports, "faFile", function() {
    return faFile;
});
parcelHelpers.export(exports, "faFileAlt", function() {
    return faFileAlt;
});
parcelHelpers.export(exports, "faFileArchive", function() {
    return faFileArchive;
});
parcelHelpers.export(exports, "faFileAudio", function() {
    return faFileAudio;
});
parcelHelpers.export(exports, "faFileCode", function() {
    return faFileCode;
});
parcelHelpers.export(exports, "faFileExcel", function() {
    return faFileExcel;
});
parcelHelpers.export(exports, "faFileImage", function() {
    return faFileImage;
});
parcelHelpers.export(exports, "faFilePdf", function() {
    return faFilePdf;
});
parcelHelpers.export(exports, "faFilePowerpoint", function() {
    return faFilePowerpoint;
});
parcelHelpers.export(exports, "faFileVideo", function() {
    return faFileVideo;
});
parcelHelpers.export(exports, "faFileWord", function() {
    return faFileWord;
});
parcelHelpers.export(exports, "faFlag", function() {
    return faFlag;
});
parcelHelpers.export(exports, "faFlushed", function() {
    return faFlushed;
});
parcelHelpers.export(exports, "faFolder", function() {
    return faFolder;
});
parcelHelpers.export(exports, "faFolderOpen", function() {
    return faFolderOpen;
});
parcelHelpers.export(exports, "faFontAwesomeLogoFull", function() {
    return faFontAwesomeLogoFull;
});
parcelHelpers.export(exports, "faFrown", function() {
    return faFrown;
});
parcelHelpers.export(exports, "faFrownOpen", function() {
    return faFrownOpen;
});
parcelHelpers.export(exports, "faFutbol", function() {
    return faFutbol;
});
parcelHelpers.export(exports, "faGem", function() {
    return faGem;
});
parcelHelpers.export(exports, "faGrimace", function() {
    return faGrimace;
});
parcelHelpers.export(exports, "faGrin", function() {
    return faGrin;
});
parcelHelpers.export(exports, "faGrinAlt", function() {
    return faGrinAlt;
});
parcelHelpers.export(exports, "faGrinBeam", function() {
    return faGrinBeam;
});
parcelHelpers.export(exports, "faGrinBeamSweat", function() {
    return faGrinBeamSweat;
});
parcelHelpers.export(exports, "faGrinHearts", function() {
    return faGrinHearts;
});
parcelHelpers.export(exports, "faGrinSquint", function() {
    return faGrinSquint;
});
parcelHelpers.export(exports, "faGrinSquintTears", function() {
    return faGrinSquintTears;
});
parcelHelpers.export(exports, "faGrinStars", function() {
    return faGrinStars;
});
parcelHelpers.export(exports, "faGrinTears", function() {
    return faGrinTears;
});
parcelHelpers.export(exports, "faGrinTongue", function() {
    return faGrinTongue;
});
parcelHelpers.export(exports, "faGrinTongueSquint", function() {
    return faGrinTongueSquint;
});
parcelHelpers.export(exports, "faGrinTongueWink", function() {
    return faGrinTongueWink;
});
parcelHelpers.export(exports, "faGrinWink", function() {
    return faGrinWink;
});
parcelHelpers.export(exports, "faHandLizard", function() {
    return faHandLizard;
});
parcelHelpers.export(exports, "faHandPaper", function() {
    return faHandPaper;
});
parcelHelpers.export(exports, "faHandPeace", function() {
    return faHandPeace;
});
parcelHelpers.export(exports, "faHandPointDown", function() {
    return faHandPointDown;
});
parcelHelpers.export(exports, "faHandPointLeft", function() {
    return faHandPointLeft;
});
parcelHelpers.export(exports, "faHandPointRight", function() {
    return faHandPointRight;
});
parcelHelpers.export(exports, "faHandPointUp", function() {
    return faHandPointUp;
});
parcelHelpers.export(exports, "faHandPointer", function() {
    return faHandPointer;
});
parcelHelpers.export(exports, "faHandRock", function() {
    return faHandRock;
});
parcelHelpers.export(exports, "faHandScissors", function() {
    return faHandScissors;
});
parcelHelpers.export(exports, "faHandSpock", function() {
    return faHandSpock;
});
parcelHelpers.export(exports, "faHandshake", function() {
    return faHandshake;
});
parcelHelpers.export(exports, "faHdd", function() {
    return faHdd;
});
parcelHelpers.export(exports, "faHeart", function() {
    return faHeart;
});
parcelHelpers.export(exports, "faHospital", function() {
    return faHospital;
});
parcelHelpers.export(exports, "faHourglass", function() {
    return faHourglass;
});
parcelHelpers.export(exports, "faIdBadge", function() {
    return faIdBadge;
});
parcelHelpers.export(exports, "faIdCard", function() {
    return faIdCard;
});
parcelHelpers.export(exports, "faImage", function() {
    return faImage;
});
parcelHelpers.export(exports, "faImages", function() {
    return faImages;
});
parcelHelpers.export(exports, "faKeyboard", function() {
    return faKeyboard;
});
parcelHelpers.export(exports, "faKiss", function() {
    return faKiss;
});
parcelHelpers.export(exports, "faKissBeam", function() {
    return faKissBeam;
});
parcelHelpers.export(exports, "faKissWinkHeart", function() {
    return faKissWinkHeart;
});
parcelHelpers.export(exports, "faLaugh", function() {
    return faLaugh;
});
parcelHelpers.export(exports, "faLaughBeam", function() {
    return faLaughBeam;
});
parcelHelpers.export(exports, "faLaughSquint", function() {
    return faLaughSquint;
});
parcelHelpers.export(exports, "faLaughWink", function() {
    return faLaughWink;
});
parcelHelpers.export(exports, "faLemon", function() {
    return faLemon;
});
parcelHelpers.export(exports, "faLifeRing", function() {
    return faLifeRing;
});
parcelHelpers.export(exports, "faLightbulb", function() {
    return faLightbulb;
});
parcelHelpers.export(exports, "faListAlt", function() {
    return faListAlt;
});
parcelHelpers.export(exports, "faMap", function() {
    return faMap;
});
parcelHelpers.export(exports, "faMeh", function() {
    return faMeh;
});
parcelHelpers.export(exports, "faMehBlank", function() {
    return faMehBlank;
});
parcelHelpers.export(exports, "faMehRollingEyes", function() {
    return faMehRollingEyes;
});
parcelHelpers.export(exports, "faMinusSquare", function() {
    return faMinusSquare;
});
parcelHelpers.export(exports, "faMoneyBillAlt", function() {
    return faMoneyBillAlt;
});
parcelHelpers.export(exports, "faMoon", function() {
    return faMoon;
});
parcelHelpers.export(exports, "faNewspaper", function() {
    return faNewspaper;
});
parcelHelpers.export(exports, "faObjectGroup", function() {
    return faObjectGroup;
});
parcelHelpers.export(exports, "faObjectUngroup", function() {
    return faObjectUngroup;
});
parcelHelpers.export(exports, "faPaperPlane", function() {
    return faPaperPlane;
});
parcelHelpers.export(exports, "faPauseCircle", function() {
    return faPauseCircle;
});
parcelHelpers.export(exports, "faPlayCircle", function() {
    return faPlayCircle;
});
parcelHelpers.export(exports, "faPlusSquare", function() {
    return faPlusSquare;
});
parcelHelpers.export(exports, "faQuestionCircle", function() {
    return faQuestionCircle;
});
parcelHelpers.export(exports, "faRegistered", function() {
    return faRegistered;
});
parcelHelpers.export(exports, "faSadCry", function() {
    return faSadCry;
});
parcelHelpers.export(exports, "faSadTear", function() {
    return faSadTear;
});
parcelHelpers.export(exports, "faSave", function() {
    return faSave;
});
parcelHelpers.export(exports, "faShareSquare", function() {
    return faShareSquare;
});
parcelHelpers.export(exports, "faSmile", function() {
    return faSmile;
});
parcelHelpers.export(exports, "faSmileBeam", function() {
    return faSmileBeam;
});
parcelHelpers.export(exports, "faSmileWink", function() {
    return faSmileWink;
});
parcelHelpers.export(exports, "faSnowflake", function() {
    return faSnowflake;
});
parcelHelpers.export(exports, "faSquare", function() {
    return faSquare;
});
parcelHelpers.export(exports, "faStar", function() {
    return faStar;
});
parcelHelpers.export(exports, "faStarHalf", function() {
    return faStarHalf;
});
parcelHelpers.export(exports, "faStickyNote", function() {
    return faStickyNote;
});
parcelHelpers.export(exports, "faStopCircle", function() {
    return faStopCircle;
});
parcelHelpers.export(exports, "faSun", function() {
    return faSun;
});
parcelHelpers.export(exports, "faSurprise", function() {
    return faSurprise;
});
parcelHelpers.export(exports, "faThumbsDown", function() {
    return faThumbsDown;
});
parcelHelpers.export(exports, "faThumbsUp", function() {
    return faThumbsUp;
});
parcelHelpers.export(exports, "faTimesCircle", function() {
    return faTimesCircle;
});
parcelHelpers.export(exports, "faTired", function() {
    return faTired;
});
parcelHelpers.export(exports, "faTrashAlt", function() {
    return faTrashAlt;
});
parcelHelpers.export(exports, "faUser", function() {
    return faUser;
});
parcelHelpers.export(exports, "faUserCircle", function() {
    return faUserCircle;
});
parcelHelpers.export(exports, "faWindowClose", function() {
    return faWindowClose;
});
parcelHelpers.export(exports, "faWindowMaximize", function() {
    return faWindowMaximize;
});
parcelHelpers.export(exports, "faWindowMinimize", function() {
    return faWindowMinimize;
});
parcelHelpers.export(exports, "faWindowRestore", function() {
    return faWindowRestore;
});
var prefix = "far";
var faAddressBook = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
    ]
};
var faAddressCard = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
    ]
};
var faAngry = {
    prefix: "far",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
    ]
};
var faArrowAltCircleDown = {
    prefix: "far",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
    ]
};
var faArrowAltCircleLeft = {
    prefix: "far",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
    ]
};
var faArrowAltCircleRight = {
    prefix: "far",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
    ]
};
var faArrowAltCircleUp = {
    prefix: "far",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
    ]
};
var faBell = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var faBellSlash = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var faBookmark = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
    ]
};
var faBuilding = {
    prefix: "far",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
    ]
};
var faCalendar = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
    ]
};
var faCalendarAlt = {
    prefix: "far",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCalendarCheck = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
    ]
};
var faCalendarMinus = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCalendarPlus = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCalendarTimes = {
    prefix: "far",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCaretSquareDown = {
    prefix: "far",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCaretSquareLeft = {
    prefix: "far",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCaretSquareRight = {
    prefix: "far",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faCaretSquareUp = {
    prefix: "far",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faChartBar = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
    ]
};
var faCheckCircle = {
    prefix: "far",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
    ]
};
var faCheckSquare = {
    prefix: "far",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
    ]
};
var faCircle = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
    ]
};
var faClipboard = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
    ]
};
var faClock = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
    ]
};
var faClone = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
    ]
};
var faClosedCaptioning = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
    ]
};
var faComment = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
    ]
};
var faCommentAlt = {
    prefix: "far",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
    ]
};
var faCommentDots = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
    ]
};
var faComments = {
    prefix: "far",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
    ]
};
var faCompass = {
    prefix: "far",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
    ]
};
var faCopy = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
    ]
};
var faCopyright = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
    ]
};
var faCreditCard = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
    ]
};
var faDizzy = {
    prefix: "far",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
    ]
};
var faDotCircle = {
    prefix: "far",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
    ]
};
var faEdit = {
    prefix: "far",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
    ]
};
var faEnvelope = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
    ]
};
var faEnvelopeOpen = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
    ]
};
var faEye = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
    ]
};
var faEyeSlash = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
    ]
};
var faFile = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
    ]
};
var faFileAlt = {
    prefix: "far",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
    ]
};
var faFileArchive = {
    prefix: "far",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
    ]
};
var faFileAudio = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
    ]
};
var faFileCode = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
    ]
};
var faFileExcel = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
    ]
};
var faFileImage = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
    ]
};
var faFilePdf = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
    ]
};
var faFilePowerpoint = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
    ]
};
var faFileVideo = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
    ]
};
var faFileWord = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
    ]
};
var faFlag = {
    prefix: "far",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
    ]
};
var faFlushed = {
    prefix: "far",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var faFolder = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
    ]
};
var faFolderOpen = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
    ]
};
var faFontAwesomeLogoFull = {
    prefix: "far",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var faFrown = {
    prefix: "far",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
    ]
};
var faFrownOpen = {
    prefix: "far",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
    ]
};
var faFutbol = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        496,
        512,
        [],
        "f1e3",
        "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
    ]
};
var faGem = {
    prefix: "far",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
    ]
};
var faGrimace = {
    prefix: "far",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
    ]
};
var faGrin = {
    prefix: "far",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var faGrinAlt = {
    prefix: "far",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
    ]
};
var faGrinBeam = {
    prefix: "far",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
    ]
};
var faGrinBeamSweat = {
    prefix: "far",
    iconName: "grin-beam-sweat",
    icon: [
        496,
        512,
        [],
        "f583",
        "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
    ]
};
var faGrinHearts = {
    prefix: "far",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
    ]
};
var faGrinSquint = {
    prefix: "far",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
    ]
};
var faGrinSquintTears = {
    prefix: "far",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
    ]
};
var faGrinStars = {
    prefix: "far",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
    ]
};
var faGrinTears = {
    prefix: "far",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
    ]
};
var faGrinTongue = {
    prefix: "far",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faGrinTongueSquint = {
    prefix: "far",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
    ]
};
var faGrinTongueWink = {
    prefix: "far",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
    ]
};
var faGrinWink = {
    prefix: "far",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
    ]
};
var faHandLizard = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
    ]
};
var faHandPaper = {
    prefix: "far",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
    ]
};
var faHandPeace = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
    ]
};
var faHandPointDown = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        448,
        512,
        [],
        "f0a7",
        "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
    ]
};
var faHandPointLeft = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
    ]
};
var faHandPointRight = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
    ]
};
var faHandPointUp = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        448,
        512,
        [],
        "f0a6",
        "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
    ]
};
var faHandPointer = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
    ]
};
var faHandRock = {
    prefix: "far",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
    ]
};
var faHandScissors = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
    ]
};
var faHandSpock = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
    ]
};
var faHandshake = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
    ]
};
var faHdd = {
    prefix: "far",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
    ]
};
var faHeart = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
    ]
};
var faHospital = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
    ]
};
var faHourglass = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
    ]
};
var faIdBadge = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
    ]
};
var faIdCard = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var faImage = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
    ]
};
var faImages = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
    ]
};
var faKeyboard = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
    ]
};
var faKiss = {
    prefix: "far",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faKissBeam = {
    prefix: "far",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
    ]
};
var faKissWinkHeart = {
    prefix: "far",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
    ]
};
var faLaugh = {
    prefix: "far",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var faLaughBeam = {
    prefix: "far",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var faLaughSquint = {
    prefix: "far",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var faLaughWink = {
    prefix: "far",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var faLemon = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
    ]
};
var faLifeRing = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
    ]
};
var faLightbulb = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
    ]
};
var faListAlt = {
    prefix: "far",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
    ]
};
var faMap = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
    ]
};
var faMeh = {
    prefix: "far",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var faMehBlank = {
    prefix: "far",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faMehRollingEyes = {
    prefix: "far",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var faMinusSquare = {
    prefix: "far",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faMoneyBillAlt = {
    prefix: "far",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
    ]
};
var faMoon = {
    prefix: "far",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
    ]
};
var faNewspaper = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
    ]
};
var faObjectGroup = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
    ]
};
var faObjectUngroup = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
    ]
};
var faPaperPlane = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
    ]
};
var faPauseCircle = {
    prefix: "far",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
    ]
};
var faPlayCircle = {
    prefix: "far",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    ]
};
var faPlusSquare = {
    prefix: "far",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var faQuestionCircle = {
    prefix: "far",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
    ]
};
var faRegistered = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
    ]
};
var faSadCry = {
    prefix: "far",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
    ]
};
var faSadTear = {
    prefix: "far",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
    ]
};
var faSave = {
    prefix: "far",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
    ]
};
var faShareSquare = {
    prefix: "far",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
    ]
};
var faSmile = {
    prefix: "far",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
    ]
};
var faSmileBeam = {
    prefix: "far",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
    ]
};
var faSmileWink = {
    prefix: "far",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
    ]
};
var faSnowflake = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
    ]
};
var faSquare = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
    ]
};
var faStar = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
    ]
};
var faStarHalf = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
    ]
};
var faStickyNote = {
    prefix: "far",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
    ]
};
var faStopCircle = {
    prefix: "far",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
    ]
};
var faSun = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
    ]
};
var faSurprise = {
    prefix: "far",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faThumbsDown = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
    ]
};
var faThumbsUp = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
    ]
};
var faTimesCircle = {
    prefix: "far",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
    ]
};
var faTired = {
    prefix: "far",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
    ]
};
var faTrashAlt = {
    prefix: "far",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
    ]
};
var faUser = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
    ]
};
var faUserCircle = {
    prefix: "far",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
    ]
};
var faWindowClose = {
    prefix: "far",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
    ]
};
var faWindowMaximize = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
    ]
};
var faWindowMinimize = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var faWindowRestore = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
    ]
};
var _iconsCache = {
    faAddressBook: faAddressBook,
    faAddressCard: faAddressCard,
    faAngry: faAngry,
    faArrowAltCircleDown: faArrowAltCircleDown,
    faArrowAltCircleLeft: faArrowAltCircleLeft,
    faArrowAltCircleRight: faArrowAltCircleRight,
    faArrowAltCircleUp: faArrowAltCircleUp,
    faBell: faBell,
    faBellSlash: faBellSlash,
    faBookmark: faBookmark,
    faBuilding: faBuilding,
    faCalendar: faCalendar,
    faCalendarAlt: faCalendarAlt,
    faCalendarCheck: faCalendarCheck,
    faCalendarMinus: faCalendarMinus,
    faCalendarPlus: faCalendarPlus,
    faCalendarTimes: faCalendarTimes,
    faCaretSquareDown: faCaretSquareDown,
    faCaretSquareLeft: faCaretSquareLeft,
    faCaretSquareRight: faCaretSquareRight,
    faCaretSquareUp: faCaretSquareUp,
    faChartBar: faChartBar,
    faCheckCircle: faCheckCircle,
    faCheckSquare: faCheckSquare,
    faCircle: faCircle,
    faClipboard: faClipboard,
    faClock: faClock,
    faClone: faClone,
    faClosedCaptioning: faClosedCaptioning,
    faComment: faComment,
    faCommentAlt: faCommentAlt,
    faCommentDots: faCommentDots,
    faComments: faComments,
    faCompass: faCompass,
    faCopy: faCopy,
    faCopyright: faCopyright,
    faCreditCard: faCreditCard,
    faDizzy: faDizzy,
    faDotCircle: faDotCircle,
    faEdit: faEdit,
    faEnvelope: faEnvelope,
    faEnvelopeOpen: faEnvelopeOpen,
    faEye: faEye,
    faEyeSlash: faEyeSlash,
    faFile: faFile,
    faFileAlt: faFileAlt,
    faFileArchive: faFileArchive,
    faFileAudio: faFileAudio,
    faFileCode: faFileCode,
    faFileExcel: faFileExcel,
    faFileImage: faFileImage,
    faFilePdf: faFilePdf,
    faFilePowerpoint: faFilePowerpoint,
    faFileVideo: faFileVideo,
    faFileWord: faFileWord,
    faFlag: faFlag,
    faFlushed: faFlushed,
    faFolder: faFolder,
    faFolderOpen: faFolderOpen,
    faFontAwesomeLogoFull: faFontAwesomeLogoFull,
    faFrown: faFrown,
    faFrownOpen: faFrownOpen,
    faFutbol: faFutbol,
    faGem: faGem,
    faGrimace: faGrimace,
    faGrin: faGrin,
    faGrinAlt: faGrinAlt,
    faGrinBeam: faGrinBeam,
    faGrinBeamSweat: faGrinBeamSweat,
    faGrinHearts: faGrinHearts,
    faGrinSquint: faGrinSquint,
    faGrinSquintTears: faGrinSquintTears,
    faGrinStars: faGrinStars,
    faGrinTears: faGrinTears,
    faGrinTongue: faGrinTongue,
    faGrinTongueSquint: faGrinTongueSquint,
    faGrinTongueWink: faGrinTongueWink,
    faGrinWink: faGrinWink,
    faHandLizard: faHandLizard,
    faHandPaper: faHandPaper,
    faHandPeace: faHandPeace,
    faHandPointDown: faHandPointDown,
    faHandPointLeft: faHandPointLeft,
    faHandPointRight: faHandPointRight,
    faHandPointUp: faHandPointUp,
    faHandPointer: faHandPointer,
    faHandRock: faHandRock,
    faHandScissors: faHandScissors,
    faHandSpock: faHandSpock,
    faHandshake: faHandshake,
    faHdd: faHdd,
    faHeart: faHeart,
    faHospital: faHospital,
    faHourglass: faHourglass,
    faIdBadge: faIdBadge,
    faIdCard: faIdCard,
    faImage: faImage,
    faImages: faImages,
    faKeyboard: faKeyboard,
    faKiss: faKiss,
    faKissBeam: faKissBeam,
    faKissWinkHeart: faKissWinkHeart,
    faLaugh: faLaugh,
    faLaughBeam: faLaughBeam,
    faLaughSquint: faLaughSquint,
    faLaughWink: faLaughWink,
    faLemon: faLemon,
    faLifeRing: faLifeRing,
    faLightbulb: faLightbulb,
    faListAlt: faListAlt,
    faMap: faMap,
    faMeh: faMeh,
    faMehBlank: faMehBlank,
    faMehRollingEyes: faMehRollingEyes,
    faMinusSquare: faMinusSquare,
    faMoneyBillAlt: faMoneyBillAlt,
    faMoon: faMoon,
    faNewspaper: faNewspaper,
    faObjectGroup: faObjectGroup,
    faObjectUngroup: faObjectUngroup,
    faPaperPlane: faPaperPlane,
    faPauseCircle: faPauseCircle,
    faPlayCircle: faPlayCircle,
    faPlusSquare: faPlusSquare,
    faQuestionCircle: faQuestionCircle,
    faRegistered: faRegistered,
    faSadCry: faSadCry,
    faSadTear: faSadTear,
    faSave: faSave,
    faShareSquare: faShareSquare,
    faSmile: faSmile,
    faSmileBeam: faSmileBeam,
    faSmileWink: faSmileWink,
    faSnowflake: faSnowflake,
    faSquare: faSquare,
    faStar: faStar,
    faStarHalf: faStarHalf,
    faStickyNote: faStickyNote,
    faStopCircle: faStopCircle,
    faSun: faSun,
    faSurprise: faSurprise,
    faThumbsDown: faThumbsDown,
    faThumbsUp: faThumbsUp,
    faTimesCircle: faTimesCircle,
    faTired: faTired,
    faTrashAlt: faTrashAlt,
    faUser: faUser,
    faUserCircle: faUserCircle,
    faWindowClose: faWindowClose,
    faWindowMaximize: faWindowMaximize,
    faWindowMinimize: faWindowMinimize,
    faWindowRestore: faWindowRestore
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eavdx":[function(require,module,exports) {
/*!
 * Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fas", function() {
    return _iconsCache;
});
parcelHelpers.export(exports, "prefix", function() {
    return prefix;
});
parcelHelpers.export(exports, "faAd", function() {
    return faAd;
});
parcelHelpers.export(exports, "faAddressBook", function() {
    return faAddressBook;
});
parcelHelpers.export(exports, "faAddressCard", function() {
    return faAddressCard;
});
parcelHelpers.export(exports, "faAdjust", function() {
    return faAdjust;
});
parcelHelpers.export(exports, "faAirFreshener", function() {
    return faAirFreshener;
});
parcelHelpers.export(exports, "faAlignCenter", function() {
    return faAlignCenter;
});
parcelHelpers.export(exports, "faAlignJustify", function() {
    return faAlignJustify;
});
parcelHelpers.export(exports, "faAlignLeft", function() {
    return faAlignLeft;
});
parcelHelpers.export(exports, "faAlignRight", function() {
    return faAlignRight;
});
parcelHelpers.export(exports, "faAllergies", function() {
    return faAllergies;
});
parcelHelpers.export(exports, "faAmbulance", function() {
    return faAmbulance;
});
parcelHelpers.export(exports, "faAmericanSignLanguageInterpreting", function() {
    return faAmericanSignLanguageInterpreting;
});
parcelHelpers.export(exports, "faAnchor", function() {
    return faAnchor;
});
parcelHelpers.export(exports, "faAngleDoubleDown", function() {
    return faAngleDoubleDown;
});
parcelHelpers.export(exports, "faAngleDoubleLeft", function() {
    return faAngleDoubleLeft;
});
parcelHelpers.export(exports, "faAngleDoubleRight", function() {
    return faAngleDoubleRight;
});
parcelHelpers.export(exports, "faAngleDoubleUp", function() {
    return faAngleDoubleUp;
});
parcelHelpers.export(exports, "faAngleDown", function() {
    return faAngleDown;
});
parcelHelpers.export(exports, "faAngleLeft", function() {
    return faAngleLeft;
});
parcelHelpers.export(exports, "faAngleRight", function() {
    return faAngleRight;
});
parcelHelpers.export(exports, "faAngleUp", function() {
    return faAngleUp;
});
parcelHelpers.export(exports, "faAngry", function() {
    return faAngry;
});
parcelHelpers.export(exports, "faAnkh", function() {
    return faAnkh;
});
parcelHelpers.export(exports, "faAppleAlt", function() {
    return faAppleAlt;
});
parcelHelpers.export(exports, "faArchive", function() {
    return faArchive;
});
parcelHelpers.export(exports, "faArchway", function() {
    return faArchway;
});
parcelHelpers.export(exports, "faArrowAltCircleDown", function() {
    return faArrowAltCircleDown;
});
parcelHelpers.export(exports, "faArrowAltCircleLeft", function() {
    return faArrowAltCircleLeft;
});
parcelHelpers.export(exports, "faArrowAltCircleRight", function() {
    return faArrowAltCircleRight;
});
parcelHelpers.export(exports, "faArrowAltCircleUp", function() {
    return faArrowAltCircleUp;
});
parcelHelpers.export(exports, "faArrowCircleDown", function() {
    return faArrowCircleDown;
});
parcelHelpers.export(exports, "faArrowCircleLeft", function() {
    return faArrowCircleLeft;
});
parcelHelpers.export(exports, "faArrowCircleRight", function() {
    return faArrowCircleRight;
});
parcelHelpers.export(exports, "faArrowCircleUp", function() {
    return faArrowCircleUp;
});
parcelHelpers.export(exports, "faArrowDown", function() {
    return faArrowDown;
});
parcelHelpers.export(exports, "faArrowLeft", function() {
    return faArrowLeft;
});
parcelHelpers.export(exports, "faArrowRight", function() {
    return faArrowRight;
});
parcelHelpers.export(exports, "faArrowUp", function() {
    return faArrowUp;
});
parcelHelpers.export(exports, "faArrowsAlt", function() {
    return faArrowsAlt;
});
parcelHelpers.export(exports, "faArrowsAltH", function() {
    return faArrowsAltH;
});
parcelHelpers.export(exports, "faArrowsAltV", function() {
    return faArrowsAltV;
});
parcelHelpers.export(exports, "faAssistiveListeningSystems", function() {
    return faAssistiveListeningSystems;
});
parcelHelpers.export(exports, "faAsterisk", function() {
    return faAsterisk;
});
parcelHelpers.export(exports, "faAt", function() {
    return faAt;
});
parcelHelpers.export(exports, "faAtlas", function() {
    return faAtlas;
});
parcelHelpers.export(exports, "faAtom", function() {
    return faAtom;
});
parcelHelpers.export(exports, "faAudioDescription", function() {
    return faAudioDescription;
});
parcelHelpers.export(exports, "faAward", function() {
    return faAward;
});
parcelHelpers.export(exports, "faBaby", function() {
    return faBaby;
});
parcelHelpers.export(exports, "faBabyCarriage", function() {
    return faBabyCarriage;
});
parcelHelpers.export(exports, "faBackspace", function() {
    return faBackspace;
});
parcelHelpers.export(exports, "faBackward", function() {
    return faBackward;
});
parcelHelpers.export(exports, "faBacon", function() {
    return faBacon;
});
parcelHelpers.export(exports, "faBacteria", function() {
    return faBacteria;
});
parcelHelpers.export(exports, "faBacterium", function() {
    return faBacterium;
});
parcelHelpers.export(exports, "faBahai", function() {
    return faBahai;
});
parcelHelpers.export(exports, "faBalanceScale", function() {
    return faBalanceScale;
});
parcelHelpers.export(exports, "faBalanceScaleLeft", function() {
    return faBalanceScaleLeft;
});
parcelHelpers.export(exports, "faBalanceScaleRight", function() {
    return faBalanceScaleRight;
});
parcelHelpers.export(exports, "faBan", function() {
    return faBan;
});
parcelHelpers.export(exports, "faBandAid", function() {
    return faBandAid;
});
parcelHelpers.export(exports, "faBarcode", function() {
    return faBarcode;
});
parcelHelpers.export(exports, "faBars", function() {
    return faBars;
});
parcelHelpers.export(exports, "faBaseballBall", function() {
    return faBaseballBall;
});
parcelHelpers.export(exports, "faBasketballBall", function() {
    return faBasketballBall;
});
parcelHelpers.export(exports, "faBath", function() {
    return faBath;
});
parcelHelpers.export(exports, "faBatteryEmpty", function() {
    return faBatteryEmpty;
});
parcelHelpers.export(exports, "faBatteryFull", function() {
    return faBatteryFull;
});
parcelHelpers.export(exports, "faBatteryHalf", function() {
    return faBatteryHalf;
});
parcelHelpers.export(exports, "faBatteryQuarter", function() {
    return faBatteryQuarter;
});
parcelHelpers.export(exports, "faBatteryThreeQuarters", function() {
    return faBatteryThreeQuarters;
});
parcelHelpers.export(exports, "faBed", function() {
    return faBed;
});
parcelHelpers.export(exports, "faBeer", function() {
    return faBeer;
});
parcelHelpers.export(exports, "faBell", function() {
    return faBell;
});
parcelHelpers.export(exports, "faBellSlash", function() {
    return faBellSlash;
});
parcelHelpers.export(exports, "faBezierCurve", function() {
    return faBezierCurve;
});
parcelHelpers.export(exports, "faBible", function() {
    return faBible;
});
parcelHelpers.export(exports, "faBicycle", function() {
    return faBicycle;
});
parcelHelpers.export(exports, "faBiking", function() {
    return faBiking;
});
parcelHelpers.export(exports, "faBinoculars", function() {
    return faBinoculars;
});
parcelHelpers.export(exports, "faBiohazard", function() {
    return faBiohazard;
});
parcelHelpers.export(exports, "faBirthdayCake", function() {
    return faBirthdayCake;
});
parcelHelpers.export(exports, "faBlender", function() {
    return faBlender;
});
parcelHelpers.export(exports, "faBlenderPhone", function() {
    return faBlenderPhone;
});
parcelHelpers.export(exports, "faBlind", function() {
    return faBlind;
});
parcelHelpers.export(exports, "faBlog", function() {
    return faBlog;
});
parcelHelpers.export(exports, "faBold", function() {
    return faBold;
});
parcelHelpers.export(exports, "faBolt", function() {
    return faBolt;
});
parcelHelpers.export(exports, "faBomb", function() {
    return faBomb;
});
parcelHelpers.export(exports, "faBone", function() {
    return faBone;
});
parcelHelpers.export(exports, "faBong", function() {
    return faBong;
});
parcelHelpers.export(exports, "faBook", function() {
    return faBook;
});
parcelHelpers.export(exports, "faBookDead", function() {
    return faBookDead;
});
parcelHelpers.export(exports, "faBookMedical", function() {
    return faBookMedical;
});
parcelHelpers.export(exports, "faBookOpen", function() {
    return faBookOpen;
});
parcelHelpers.export(exports, "faBookReader", function() {
    return faBookReader;
});
parcelHelpers.export(exports, "faBookmark", function() {
    return faBookmark;
});
parcelHelpers.export(exports, "faBorderAll", function() {
    return faBorderAll;
});
parcelHelpers.export(exports, "faBorderNone", function() {
    return faBorderNone;
});
parcelHelpers.export(exports, "faBorderStyle", function() {
    return faBorderStyle;
});
parcelHelpers.export(exports, "faBowlingBall", function() {
    return faBowlingBall;
});
parcelHelpers.export(exports, "faBox", function() {
    return faBox;
});
parcelHelpers.export(exports, "faBoxOpen", function() {
    return faBoxOpen;
});
parcelHelpers.export(exports, "faBoxTissue", function() {
    return faBoxTissue;
});
parcelHelpers.export(exports, "faBoxes", function() {
    return faBoxes;
});
parcelHelpers.export(exports, "faBraille", function() {
    return faBraille;
});
parcelHelpers.export(exports, "faBrain", function() {
    return faBrain;
});
parcelHelpers.export(exports, "faBreadSlice", function() {
    return faBreadSlice;
});
parcelHelpers.export(exports, "faBriefcase", function() {
    return faBriefcase;
});
parcelHelpers.export(exports, "faBriefcaseMedical", function() {
    return faBriefcaseMedical;
});
parcelHelpers.export(exports, "faBroadcastTower", function() {
    return faBroadcastTower;
});
parcelHelpers.export(exports, "faBroom", function() {
    return faBroom;
});
parcelHelpers.export(exports, "faBrush", function() {
    return faBrush;
});
parcelHelpers.export(exports, "faBug", function() {
    return faBug;
});
parcelHelpers.export(exports, "faBuilding", function() {
    return faBuilding;
});
parcelHelpers.export(exports, "faBullhorn", function() {
    return faBullhorn;
});
parcelHelpers.export(exports, "faBullseye", function() {
    return faBullseye;
});
parcelHelpers.export(exports, "faBurn", function() {
    return faBurn;
});
parcelHelpers.export(exports, "faBus", function() {
    return faBus;
});
parcelHelpers.export(exports, "faBusAlt", function() {
    return faBusAlt;
});
parcelHelpers.export(exports, "faBusinessTime", function() {
    return faBusinessTime;
});
parcelHelpers.export(exports, "faCalculator", function() {
    return faCalculator;
});
parcelHelpers.export(exports, "faCalendar", function() {
    return faCalendar;
});
parcelHelpers.export(exports, "faCalendarAlt", function() {
    return faCalendarAlt;
});
parcelHelpers.export(exports, "faCalendarCheck", function() {
    return faCalendarCheck;
});
parcelHelpers.export(exports, "faCalendarDay", function() {
    return faCalendarDay;
});
parcelHelpers.export(exports, "faCalendarMinus", function() {
    return faCalendarMinus;
});
parcelHelpers.export(exports, "faCalendarPlus", function() {
    return faCalendarPlus;
});
parcelHelpers.export(exports, "faCalendarTimes", function() {
    return faCalendarTimes;
});
parcelHelpers.export(exports, "faCalendarWeek", function() {
    return faCalendarWeek;
});
parcelHelpers.export(exports, "faCamera", function() {
    return faCamera;
});
parcelHelpers.export(exports, "faCameraRetro", function() {
    return faCameraRetro;
});
parcelHelpers.export(exports, "faCampground", function() {
    return faCampground;
});
parcelHelpers.export(exports, "faCandyCane", function() {
    return faCandyCane;
});
parcelHelpers.export(exports, "faCannabis", function() {
    return faCannabis;
});
parcelHelpers.export(exports, "faCapsules", function() {
    return faCapsules;
});
parcelHelpers.export(exports, "faCar", function() {
    return faCar;
});
parcelHelpers.export(exports, "faCarAlt", function() {
    return faCarAlt;
});
parcelHelpers.export(exports, "faCarBattery", function() {
    return faCarBattery;
});
parcelHelpers.export(exports, "faCarCrash", function() {
    return faCarCrash;
});
parcelHelpers.export(exports, "faCarSide", function() {
    return faCarSide;
});
parcelHelpers.export(exports, "faCaravan", function() {
    return faCaravan;
});
parcelHelpers.export(exports, "faCaretDown", function() {
    return faCaretDown;
});
parcelHelpers.export(exports, "faCaretLeft", function() {
    return faCaretLeft;
});
parcelHelpers.export(exports, "faCaretRight", function() {
    return faCaretRight;
});
parcelHelpers.export(exports, "faCaretSquareDown", function() {
    return faCaretSquareDown;
});
parcelHelpers.export(exports, "faCaretSquareLeft", function() {
    return faCaretSquareLeft;
});
parcelHelpers.export(exports, "faCaretSquareRight", function() {
    return faCaretSquareRight;
});
parcelHelpers.export(exports, "faCaretSquareUp", function() {
    return faCaretSquareUp;
});
parcelHelpers.export(exports, "faCaretUp", function() {
    return faCaretUp;
});
parcelHelpers.export(exports, "faCarrot", function() {
    return faCarrot;
});
parcelHelpers.export(exports, "faCartArrowDown", function() {
    return faCartArrowDown;
});
parcelHelpers.export(exports, "faCartPlus", function() {
    return faCartPlus;
});
parcelHelpers.export(exports, "faCashRegister", function() {
    return faCashRegister;
});
parcelHelpers.export(exports, "faCat", function() {
    return faCat;
});
parcelHelpers.export(exports, "faCertificate", function() {
    return faCertificate;
});
parcelHelpers.export(exports, "faChair", function() {
    return faChair;
});
parcelHelpers.export(exports, "faChalkboard", function() {
    return faChalkboard;
});
parcelHelpers.export(exports, "faChalkboardTeacher", function() {
    return faChalkboardTeacher;
});
parcelHelpers.export(exports, "faChargingStation", function() {
    return faChargingStation;
});
parcelHelpers.export(exports, "faChartArea", function() {
    return faChartArea;
});
parcelHelpers.export(exports, "faChartBar", function() {
    return faChartBar;
});
parcelHelpers.export(exports, "faChartLine", function() {
    return faChartLine;
});
parcelHelpers.export(exports, "faChartPie", function() {
    return faChartPie;
});
parcelHelpers.export(exports, "faCheck", function() {
    return faCheck;
});
parcelHelpers.export(exports, "faCheckCircle", function() {
    return faCheckCircle;
});
parcelHelpers.export(exports, "faCheckDouble", function() {
    return faCheckDouble;
});
parcelHelpers.export(exports, "faCheckSquare", function() {
    return faCheckSquare;
});
parcelHelpers.export(exports, "faCheese", function() {
    return faCheese;
});
parcelHelpers.export(exports, "faChess", function() {
    return faChess;
});
parcelHelpers.export(exports, "faChessBishop", function() {
    return faChessBishop;
});
parcelHelpers.export(exports, "faChessBoard", function() {
    return faChessBoard;
});
parcelHelpers.export(exports, "faChessKing", function() {
    return faChessKing;
});
parcelHelpers.export(exports, "faChessKnight", function() {
    return faChessKnight;
});
parcelHelpers.export(exports, "faChessPawn", function() {
    return faChessPawn;
});
parcelHelpers.export(exports, "faChessQueen", function() {
    return faChessQueen;
});
parcelHelpers.export(exports, "faChessRook", function() {
    return faChessRook;
});
parcelHelpers.export(exports, "faChevronCircleDown", function() {
    return faChevronCircleDown;
});
parcelHelpers.export(exports, "faChevronCircleLeft", function() {
    return faChevronCircleLeft;
});
parcelHelpers.export(exports, "faChevronCircleRight", function() {
    return faChevronCircleRight;
});
parcelHelpers.export(exports, "faChevronCircleUp", function() {
    return faChevronCircleUp;
});
parcelHelpers.export(exports, "faChevronDown", function() {
    return faChevronDown;
});
parcelHelpers.export(exports, "faChevronLeft", function() {
    return faChevronLeft;
});
parcelHelpers.export(exports, "faChevronRight", function() {
    return faChevronRight;
});
parcelHelpers.export(exports, "faChevronUp", function() {
    return faChevronUp;
});
parcelHelpers.export(exports, "faChild", function() {
    return faChild;
});
parcelHelpers.export(exports, "faChurch", function() {
    return faChurch;
});
parcelHelpers.export(exports, "faCircle", function() {
    return faCircle;
});
parcelHelpers.export(exports, "faCircleNotch", function() {
    return faCircleNotch;
});
parcelHelpers.export(exports, "faCity", function() {
    return faCity;
});
parcelHelpers.export(exports, "faClinicMedical", function() {
    return faClinicMedical;
});
parcelHelpers.export(exports, "faClipboard", function() {
    return faClipboard;
});
parcelHelpers.export(exports, "faClipboardCheck", function() {
    return faClipboardCheck;
});
parcelHelpers.export(exports, "faClipboardList", function() {
    return faClipboardList;
});
parcelHelpers.export(exports, "faClock", function() {
    return faClock;
});
parcelHelpers.export(exports, "faClone", function() {
    return faClone;
});
parcelHelpers.export(exports, "faClosedCaptioning", function() {
    return faClosedCaptioning;
});
parcelHelpers.export(exports, "faCloud", function() {
    return faCloud;
});
parcelHelpers.export(exports, "faCloudDownloadAlt", function() {
    return faCloudDownloadAlt;
});
parcelHelpers.export(exports, "faCloudMeatball", function() {
    return faCloudMeatball;
});
parcelHelpers.export(exports, "faCloudMoon", function() {
    return faCloudMoon;
});
parcelHelpers.export(exports, "faCloudMoonRain", function() {
    return faCloudMoonRain;
});
parcelHelpers.export(exports, "faCloudRain", function() {
    return faCloudRain;
});
parcelHelpers.export(exports, "faCloudShowersHeavy", function() {
    return faCloudShowersHeavy;
});
parcelHelpers.export(exports, "faCloudSun", function() {
    return faCloudSun;
});
parcelHelpers.export(exports, "faCloudSunRain", function() {
    return faCloudSunRain;
});
parcelHelpers.export(exports, "faCloudUploadAlt", function() {
    return faCloudUploadAlt;
});
parcelHelpers.export(exports, "faCocktail", function() {
    return faCocktail;
});
parcelHelpers.export(exports, "faCode", function() {
    return faCode;
});
parcelHelpers.export(exports, "faCodeBranch", function() {
    return faCodeBranch;
});
parcelHelpers.export(exports, "faCoffee", function() {
    return faCoffee;
});
parcelHelpers.export(exports, "faCog", function() {
    return faCog;
});
parcelHelpers.export(exports, "faCogs", function() {
    return faCogs;
});
parcelHelpers.export(exports, "faCoins", function() {
    return faCoins;
});
parcelHelpers.export(exports, "faColumns", function() {
    return faColumns;
});
parcelHelpers.export(exports, "faComment", function() {
    return faComment;
});
parcelHelpers.export(exports, "faCommentAlt", function() {
    return faCommentAlt;
});
parcelHelpers.export(exports, "faCommentDollar", function() {
    return faCommentDollar;
});
parcelHelpers.export(exports, "faCommentDots", function() {
    return faCommentDots;
});
parcelHelpers.export(exports, "faCommentMedical", function() {
    return faCommentMedical;
});
parcelHelpers.export(exports, "faCommentSlash", function() {
    return faCommentSlash;
});
parcelHelpers.export(exports, "faComments", function() {
    return faComments;
});
parcelHelpers.export(exports, "faCommentsDollar", function() {
    return faCommentsDollar;
});
parcelHelpers.export(exports, "faCompactDisc", function() {
    return faCompactDisc;
});
parcelHelpers.export(exports, "faCompass", function() {
    return faCompass;
});
parcelHelpers.export(exports, "faCompress", function() {
    return faCompress;
});
parcelHelpers.export(exports, "faCompressAlt", function() {
    return faCompressAlt;
});
parcelHelpers.export(exports, "faCompressArrowsAlt", function() {
    return faCompressArrowsAlt;
});
parcelHelpers.export(exports, "faConciergeBell", function() {
    return faConciergeBell;
});
parcelHelpers.export(exports, "faCookie", function() {
    return faCookie;
});
parcelHelpers.export(exports, "faCookieBite", function() {
    return faCookieBite;
});
parcelHelpers.export(exports, "faCopy", function() {
    return faCopy;
});
parcelHelpers.export(exports, "faCopyright", function() {
    return faCopyright;
});
parcelHelpers.export(exports, "faCouch", function() {
    return faCouch;
});
parcelHelpers.export(exports, "faCreditCard", function() {
    return faCreditCard;
});
parcelHelpers.export(exports, "faCrop", function() {
    return faCrop;
});
parcelHelpers.export(exports, "faCropAlt", function() {
    return faCropAlt;
});
parcelHelpers.export(exports, "faCross", function() {
    return faCross;
});
parcelHelpers.export(exports, "faCrosshairs", function() {
    return faCrosshairs;
});
parcelHelpers.export(exports, "faCrow", function() {
    return faCrow;
});
parcelHelpers.export(exports, "faCrown", function() {
    return faCrown;
});
parcelHelpers.export(exports, "faCrutch", function() {
    return faCrutch;
});
parcelHelpers.export(exports, "faCube", function() {
    return faCube;
});
parcelHelpers.export(exports, "faCubes", function() {
    return faCubes;
});
parcelHelpers.export(exports, "faCut", function() {
    return faCut;
});
parcelHelpers.export(exports, "faDatabase", function() {
    return faDatabase;
});
parcelHelpers.export(exports, "faDeaf", function() {
    return faDeaf;
});
parcelHelpers.export(exports, "faDemocrat", function() {
    return faDemocrat;
});
parcelHelpers.export(exports, "faDesktop", function() {
    return faDesktop;
});
parcelHelpers.export(exports, "faDharmachakra", function() {
    return faDharmachakra;
});
parcelHelpers.export(exports, "faDiagnoses", function() {
    return faDiagnoses;
});
parcelHelpers.export(exports, "faDice", function() {
    return faDice;
});
parcelHelpers.export(exports, "faDiceD20", function() {
    return faDiceD20;
});
parcelHelpers.export(exports, "faDiceD6", function() {
    return faDiceD6;
});
parcelHelpers.export(exports, "faDiceFive", function() {
    return faDiceFive;
});
parcelHelpers.export(exports, "faDiceFour", function() {
    return faDiceFour;
});
parcelHelpers.export(exports, "faDiceOne", function() {
    return faDiceOne;
});
parcelHelpers.export(exports, "faDiceSix", function() {
    return faDiceSix;
});
parcelHelpers.export(exports, "faDiceThree", function() {
    return faDiceThree;
});
parcelHelpers.export(exports, "faDiceTwo", function() {
    return faDiceTwo;
});
parcelHelpers.export(exports, "faDigitalTachograph", function() {
    return faDigitalTachograph;
});
parcelHelpers.export(exports, "faDirections", function() {
    return faDirections;
});
parcelHelpers.export(exports, "faDisease", function() {
    return faDisease;
});
parcelHelpers.export(exports, "faDivide", function() {
    return faDivide;
});
parcelHelpers.export(exports, "faDizzy", function() {
    return faDizzy;
});
parcelHelpers.export(exports, "faDna", function() {
    return faDna;
});
parcelHelpers.export(exports, "faDog", function() {
    return faDog;
});
parcelHelpers.export(exports, "faDollarSign", function() {
    return faDollarSign;
});
parcelHelpers.export(exports, "faDolly", function() {
    return faDolly;
});
parcelHelpers.export(exports, "faDollyFlatbed", function() {
    return faDollyFlatbed;
});
parcelHelpers.export(exports, "faDonate", function() {
    return faDonate;
});
parcelHelpers.export(exports, "faDoorClosed", function() {
    return faDoorClosed;
});
parcelHelpers.export(exports, "faDoorOpen", function() {
    return faDoorOpen;
});
parcelHelpers.export(exports, "faDotCircle", function() {
    return faDotCircle;
});
parcelHelpers.export(exports, "faDove", function() {
    return faDove;
});
parcelHelpers.export(exports, "faDownload", function() {
    return faDownload;
});
parcelHelpers.export(exports, "faDraftingCompass", function() {
    return faDraftingCompass;
});
parcelHelpers.export(exports, "faDragon", function() {
    return faDragon;
});
parcelHelpers.export(exports, "faDrawPolygon", function() {
    return faDrawPolygon;
});
parcelHelpers.export(exports, "faDrum", function() {
    return faDrum;
});
parcelHelpers.export(exports, "faDrumSteelpan", function() {
    return faDrumSteelpan;
});
parcelHelpers.export(exports, "faDrumstickBite", function() {
    return faDrumstickBite;
});
parcelHelpers.export(exports, "faDumbbell", function() {
    return faDumbbell;
});
parcelHelpers.export(exports, "faDumpster", function() {
    return faDumpster;
});
parcelHelpers.export(exports, "faDumpsterFire", function() {
    return faDumpsterFire;
});
parcelHelpers.export(exports, "faDungeon", function() {
    return faDungeon;
});
parcelHelpers.export(exports, "faEdit", function() {
    return faEdit;
});
parcelHelpers.export(exports, "faEgg", function() {
    return faEgg;
});
parcelHelpers.export(exports, "faEject", function() {
    return faEject;
});
parcelHelpers.export(exports, "faEllipsisH", function() {
    return faEllipsisH;
});
parcelHelpers.export(exports, "faEllipsisV", function() {
    return faEllipsisV;
});
parcelHelpers.export(exports, "faEnvelope", function() {
    return faEnvelope;
});
parcelHelpers.export(exports, "faEnvelopeOpen", function() {
    return faEnvelopeOpen;
});
parcelHelpers.export(exports, "faEnvelopeOpenText", function() {
    return faEnvelopeOpenText;
});
parcelHelpers.export(exports, "faEnvelopeSquare", function() {
    return faEnvelopeSquare;
});
parcelHelpers.export(exports, "faEquals", function() {
    return faEquals;
});
parcelHelpers.export(exports, "faEraser", function() {
    return faEraser;
});
parcelHelpers.export(exports, "faEthernet", function() {
    return faEthernet;
});
parcelHelpers.export(exports, "faEuroSign", function() {
    return faEuroSign;
});
parcelHelpers.export(exports, "faExchangeAlt", function() {
    return faExchangeAlt;
});
parcelHelpers.export(exports, "faExclamation", function() {
    return faExclamation;
});
parcelHelpers.export(exports, "faExclamationCircle", function() {
    return faExclamationCircle;
});
parcelHelpers.export(exports, "faExclamationTriangle", function() {
    return faExclamationTriangle;
});
parcelHelpers.export(exports, "faExpand", function() {
    return faExpand;
});
parcelHelpers.export(exports, "faExpandAlt", function() {
    return faExpandAlt;
});
parcelHelpers.export(exports, "faExpandArrowsAlt", function() {
    return faExpandArrowsAlt;
});
parcelHelpers.export(exports, "faExternalLinkAlt", function() {
    return faExternalLinkAlt;
});
parcelHelpers.export(exports, "faExternalLinkSquareAlt", function() {
    return faExternalLinkSquareAlt;
});
parcelHelpers.export(exports, "faEye", function() {
    return faEye;
});
parcelHelpers.export(exports, "faEyeDropper", function() {
    return faEyeDropper;
});
parcelHelpers.export(exports, "faEyeSlash", function() {
    return faEyeSlash;
});
parcelHelpers.export(exports, "faFan", function() {
    return faFan;
});
parcelHelpers.export(exports, "faFastBackward", function() {
    return faFastBackward;
});
parcelHelpers.export(exports, "faFastForward", function() {
    return faFastForward;
});
parcelHelpers.export(exports, "faFaucet", function() {
    return faFaucet;
});
parcelHelpers.export(exports, "faFax", function() {
    return faFax;
});
parcelHelpers.export(exports, "faFeather", function() {
    return faFeather;
});
parcelHelpers.export(exports, "faFeatherAlt", function() {
    return faFeatherAlt;
});
parcelHelpers.export(exports, "faFemale", function() {
    return faFemale;
});
parcelHelpers.export(exports, "faFighterJet", function() {
    return faFighterJet;
});
parcelHelpers.export(exports, "faFile", function() {
    return faFile;
});
parcelHelpers.export(exports, "faFileAlt", function() {
    return faFileAlt;
});
parcelHelpers.export(exports, "faFileArchive", function() {
    return faFileArchive;
});
parcelHelpers.export(exports, "faFileAudio", function() {
    return faFileAudio;
});
parcelHelpers.export(exports, "faFileCode", function() {
    return faFileCode;
});
parcelHelpers.export(exports, "faFileContract", function() {
    return faFileContract;
});
parcelHelpers.export(exports, "faFileCsv", function() {
    return faFileCsv;
});
parcelHelpers.export(exports, "faFileDownload", function() {
    return faFileDownload;
});
parcelHelpers.export(exports, "faFileExcel", function() {
    return faFileExcel;
});
parcelHelpers.export(exports, "faFileExport", function() {
    return faFileExport;
});
parcelHelpers.export(exports, "faFileImage", function() {
    return faFileImage;
});
parcelHelpers.export(exports, "faFileImport", function() {
    return faFileImport;
});
parcelHelpers.export(exports, "faFileInvoice", function() {
    return faFileInvoice;
});
parcelHelpers.export(exports, "faFileInvoiceDollar", function() {
    return faFileInvoiceDollar;
});
parcelHelpers.export(exports, "faFileMedical", function() {
    return faFileMedical;
});
parcelHelpers.export(exports, "faFileMedicalAlt", function() {
    return faFileMedicalAlt;
});
parcelHelpers.export(exports, "faFilePdf", function() {
    return faFilePdf;
});
parcelHelpers.export(exports, "faFilePowerpoint", function() {
    return faFilePowerpoint;
});
parcelHelpers.export(exports, "faFilePrescription", function() {
    return faFilePrescription;
});
parcelHelpers.export(exports, "faFileSignature", function() {
    return faFileSignature;
});
parcelHelpers.export(exports, "faFileUpload", function() {
    return faFileUpload;
});
parcelHelpers.export(exports, "faFileVideo", function() {
    return faFileVideo;
});
parcelHelpers.export(exports, "faFileWord", function() {
    return faFileWord;
});
parcelHelpers.export(exports, "faFill", function() {
    return faFill;
});
parcelHelpers.export(exports, "faFillDrip", function() {
    return faFillDrip;
});
parcelHelpers.export(exports, "faFilm", function() {
    return faFilm;
});
parcelHelpers.export(exports, "faFilter", function() {
    return faFilter;
});
parcelHelpers.export(exports, "faFingerprint", function() {
    return faFingerprint;
});
parcelHelpers.export(exports, "faFire", function() {
    return faFire;
});
parcelHelpers.export(exports, "faFireAlt", function() {
    return faFireAlt;
});
parcelHelpers.export(exports, "faFireExtinguisher", function() {
    return faFireExtinguisher;
});
parcelHelpers.export(exports, "faFirstAid", function() {
    return faFirstAid;
});
parcelHelpers.export(exports, "faFish", function() {
    return faFish;
});
parcelHelpers.export(exports, "faFistRaised", function() {
    return faFistRaised;
});
parcelHelpers.export(exports, "faFlag", function() {
    return faFlag;
});
parcelHelpers.export(exports, "faFlagCheckered", function() {
    return faFlagCheckered;
});
parcelHelpers.export(exports, "faFlagUsa", function() {
    return faFlagUsa;
});
parcelHelpers.export(exports, "faFlask", function() {
    return faFlask;
});
parcelHelpers.export(exports, "faFlushed", function() {
    return faFlushed;
});
parcelHelpers.export(exports, "faFolder", function() {
    return faFolder;
});
parcelHelpers.export(exports, "faFolderMinus", function() {
    return faFolderMinus;
});
parcelHelpers.export(exports, "faFolderOpen", function() {
    return faFolderOpen;
});
parcelHelpers.export(exports, "faFolderPlus", function() {
    return faFolderPlus;
});
parcelHelpers.export(exports, "faFont", function() {
    return faFont;
});
parcelHelpers.export(exports, "faFontAwesomeLogoFull", function() {
    return faFontAwesomeLogoFull;
});
parcelHelpers.export(exports, "faFootballBall", function() {
    return faFootballBall;
});
parcelHelpers.export(exports, "faForward", function() {
    return faForward;
});
parcelHelpers.export(exports, "faFrog", function() {
    return faFrog;
});
parcelHelpers.export(exports, "faFrown", function() {
    return faFrown;
});
parcelHelpers.export(exports, "faFrownOpen", function() {
    return faFrownOpen;
});
parcelHelpers.export(exports, "faFunnelDollar", function() {
    return faFunnelDollar;
});
parcelHelpers.export(exports, "faFutbol", function() {
    return faFutbol;
});
parcelHelpers.export(exports, "faGamepad", function() {
    return faGamepad;
});
parcelHelpers.export(exports, "faGasPump", function() {
    return faGasPump;
});
parcelHelpers.export(exports, "faGavel", function() {
    return faGavel;
});
parcelHelpers.export(exports, "faGem", function() {
    return faGem;
});
parcelHelpers.export(exports, "faGenderless", function() {
    return faGenderless;
});
parcelHelpers.export(exports, "faGhost", function() {
    return faGhost;
});
parcelHelpers.export(exports, "faGift", function() {
    return faGift;
});
parcelHelpers.export(exports, "faGifts", function() {
    return faGifts;
});
parcelHelpers.export(exports, "faGlassCheers", function() {
    return faGlassCheers;
});
parcelHelpers.export(exports, "faGlassMartini", function() {
    return faGlassMartini;
});
parcelHelpers.export(exports, "faGlassMartiniAlt", function() {
    return faGlassMartiniAlt;
});
parcelHelpers.export(exports, "faGlassWhiskey", function() {
    return faGlassWhiskey;
});
parcelHelpers.export(exports, "faGlasses", function() {
    return faGlasses;
});
parcelHelpers.export(exports, "faGlobe", function() {
    return faGlobe;
});
parcelHelpers.export(exports, "faGlobeAfrica", function() {
    return faGlobeAfrica;
});
parcelHelpers.export(exports, "faGlobeAmericas", function() {
    return faGlobeAmericas;
});
parcelHelpers.export(exports, "faGlobeAsia", function() {
    return faGlobeAsia;
});
parcelHelpers.export(exports, "faGlobeEurope", function() {
    return faGlobeEurope;
});
parcelHelpers.export(exports, "faGolfBall", function() {
    return faGolfBall;
});
parcelHelpers.export(exports, "faGopuram", function() {
    return faGopuram;
});
parcelHelpers.export(exports, "faGraduationCap", function() {
    return faGraduationCap;
});
parcelHelpers.export(exports, "faGreaterThan", function() {
    return faGreaterThan;
});
parcelHelpers.export(exports, "faGreaterThanEqual", function() {
    return faGreaterThanEqual;
});
parcelHelpers.export(exports, "faGrimace", function() {
    return faGrimace;
});
parcelHelpers.export(exports, "faGrin", function() {
    return faGrin;
});
parcelHelpers.export(exports, "faGrinAlt", function() {
    return faGrinAlt;
});
parcelHelpers.export(exports, "faGrinBeam", function() {
    return faGrinBeam;
});
parcelHelpers.export(exports, "faGrinBeamSweat", function() {
    return faGrinBeamSweat;
});
parcelHelpers.export(exports, "faGrinHearts", function() {
    return faGrinHearts;
});
parcelHelpers.export(exports, "faGrinSquint", function() {
    return faGrinSquint;
});
parcelHelpers.export(exports, "faGrinSquintTears", function() {
    return faGrinSquintTears;
});
parcelHelpers.export(exports, "faGrinStars", function() {
    return faGrinStars;
});
parcelHelpers.export(exports, "faGrinTears", function() {
    return faGrinTears;
});
parcelHelpers.export(exports, "faGrinTongue", function() {
    return faGrinTongue;
});
parcelHelpers.export(exports, "faGrinTongueSquint", function() {
    return faGrinTongueSquint;
});
parcelHelpers.export(exports, "faGrinTongueWink", function() {
    return faGrinTongueWink;
});
parcelHelpers.export(exports, "faGrinWink", function() {
    return faGrinWink;
});
parcelHelpers.export(exports, "faGripHorizontal", function() {
    return faGripHorizontal;
});
parcelHelpers.export(exports, "faGripLines", function() {
    return faGripLines;
});
parcelHelpers.export(exports, "faGripLinesVertical", function() {
    return faGripLinesVertical;
});
parcelHelpers.export(exports, "faGripVertical", function() {
    return faGripVertical;
});
parcelHelpers.export(exports, "faGuitar", function() {
    return faGuitar;
});
parcelHelpers.export(exports, "faHSquare", function() {
    return faHSquare;
});
parcelHelpers.export(exports, "faHamburger", function() {
    return faHamburger;
});
parcelHelpers.export(exports, "faHammer", function() {
    return faHammer;
});
parcelHelpers.export(exports, "faHamsa", function() {
    return faHamsa;
});
parcelHelpers.export(exports, "faHandHolding", function() {
    return faHandHolding;
});
parcelHelpers.export(exports, "faHandHoldingHeart", function() {
    return faHandHoldingHeart;
});
parcelHelpers.export(exports, "faHandHoldingMedical", function() {
    return faHandHoldingMedical;
});
parcelHelpers.export(exports, "faHandHoldingUsd", function() {
    return faHandHoldingUsd;
});
parcelHelpers.export(exports, "faHandHoldingWater", function() {
    return faHandHoldingWater;
});
parcelHelpers.export(exports, "faHandLizard", function() {
    return faHandLizard;
});
parcelHelpers.export(exports, "faHandMiddleFinger", function() {
    return faHandMiddleFinger;
});
parcelHelpers.export(exports, "faHandPaper", function() {
    return faHandPaper;
});
parcelHelpers.export(exports, "faHandPeace", function() {
    return faHandPeace;
});
parcelHelpers.export(exports, "faHandPointDown", function() {
    return faHandPointDown;
});
parcelHelpers.export(exports, "faHandPointLeft", function() {
    return faHandPointLeft;
});
parcelHelpers.export(exports, "faHandPointRight", function() {
    return faHandPointRight;
});
parcelHelpers.export(exports, "faHandPointUp", function() {
    return faHandPointUp;
});
parcelHelpers.export(exports, "faHandPointer", function() {
    return faHandPointer;
});
parcelHelpers.export(exports, "faHandRock", function() {
    return faHandRock;
});
parcelHelpers.export(exports, "faHandScissors", function() {
    return faHandScissors;
});
parcelHelpers.export(exports, "faHandSparkles", function() {
    return faHandSparkles;
});
parcelHelpers.export(exports, "faHandSpock", function() {
    return faHandSpock;
});
parcelHelpers.export(exports, "faHands", function() {
    return faHands;
});
parcelHelpers.export(exports, "faHandsHelping", function() {
    return faHandsHelping;
});
parcelHelpers.export(exports, "faHandsWash", function() {
    return faHandsWash;
});
parcelHelpers.export(exports, "faHandshake", function() {
    return faHandshake;
});
parcelHelpers.export(exports, "faHandshakeAltSlash", function() {
    return faHandshakeAltSlash;
});
parcelHelpers.export(exports, "faHandshakeSlash", function() {
    return faHandshakeSlash;
});
parcelHelpers.export(exports, "faHanukiah", function() {
    return faHanukiah;
});
parcelHelpers.export(exports, "faHardHat", function() {
    return faHardHat;
});
parcelHelpers.export(exports, "faHashtag", function() {
    return faHashtag;
});
parcelHelpers.export(exports, "faHatCowboy", function() {
    return faHatCowboy;
});
parcelHelpers.export(exports, "faHatCowboySide", function() {
    return faHatCowboySide;
});
parcelHelpers.export(exports, "faHatWizard", function() {
    return faHatWizard;
});
parcelHelpers.export(exports, "faHdd", function() {
    return faHdd;
});
parcelHelpers.export(exports, "faHeadSideCough", function() {
    return faHeadSideCough;
});
parcelHelpers.export(exports, "faHeadSideCoughSlash", function() {
    return faHeadSideCoughSlash;
});
parcelHelpers.export(exports, "faHeadSideMask", function() {
    return faHeadSideMask;
});
parcelHelpers.export(exports, "faHeadSideVirus", function() {
    return faHeadSideVirus;
});
parcelHelpers.export(exports, "faHeading", function() {
    return faHeading;
});
parcelHelpers.export(exports, "faHeadphones", function() {
    return faHeadphones;
});
parcelHelpers.export(exports, "faHeadphonesAlt", function() {
    return faHeadphonesAlt;
});
parcelHelpers.export(exports, "faHeadset", function() {
    return faHeadset;
});
parcelHelpers.export(exports, "faHeart", function() {
    return faHeart;
});
parcelHelpers.export(exports, "faHeartBroken", function() {
    return faHeartBroken;
});
parcelHelpers.export(exports, "faHeartbeat", function() {
    return faHeartbeat;
});
parcelHelpers.export(exports, "faHelicopter", function() {
    return faHelicopter;
});
parcelHelpers.export(exports, "faHighlighter", function() {
    return faHighlighter;
});
parcelHelpers.export(exports, "faHiking", function() {
    return faHiking;
});
parcelHelpers.export(exports, "faHippo", function() {
    return faHippo;
});
parcelHelpers.export(exports, "faHistory", function() {
    return faHistory;
});
parcelHelpers.export(exports, "faHockeyPuck", function() {
    return faHockeyPuck;
});
parcelHelpers.export(exports, "faHollyBerry", function() {
    return faHollyBerry;
});
parcelHelpers.export(exports, "faHome", function() {
    return faHome;
});
parcelHelpers.export(exports, "faHorse", function() {
    return faHorse;
});
parcelHelpers.export(exports, "faHorseHead", function() {
    return faHorseHead;
});
parcelHelpers.export(exports, "faHospital", function() {
    return faHospital;
});
parcelHelpers.export(exports, "faHospitalAlt", function() {
    return faHospitalAlt;
});
parcelHelpers.export(exports, "faHospitalSymbol", function() {
    return faHospitalSymbol;
});
parcelHelpers.export(exports, "faHospitalUser", function() {
    return faHospitalUser;
});
parcelHelpers.export(exports, "faHotTub", function() {
    return faHotTub;
});
parcelHelpers.export(exports, "faHotdog", function() {
    return faHotdog;
});
parcelHelpers.export(exports, "faHotel", function() {
    return faHotel;
});
parcelHelpers.export(exports, "faHourglass", function() {
    return faHourglass;
});
parcelHelpers.export(exports, "faHourglassEnd", function() {
    return faHourglassEnd;
});
parcelHelpers.export(exports, "faHourglassHalf", function() {
    return faHourglassHalf;
});
parcelHelpers.export(exports, "faHourglassStart", function() {
    return faHourglassStart;
});
parcelHelpers.export(exports, "faHouseDamage", function() {
    return faHouseDamage;
});
parcelHelpers.export(exports, "faHouseUser", function() {
    return faHouseUser;
});
parcelHelpers.export(exports, "faHryvnia", function() {
    return faHryvnia;
});
parcelHelpers.export(exports, "faICursor", function() {
    return faICursor;
});
parcelHelpers.export(exports, "faIceCream", function() {
    return faIceCream;
});
parcelHelpers.export(exports, "faIcicles", function() {
    return faIcicles;
});
parcelHelpers.export(exports, "faIcons", function() {
    return faIcons;
});
parcelHelpers.export(exports, "faIdBadge", function() {
    return faIdBadge;
});
parcelHelpers.export(exports, "faIdCard", function() {
    return faIdCard;
});
parcelHelpers.export(exports, "faIdCardAlt", function() {
    return faIdCardAlt;
});
parcelHelpers.export(exports, "faIgloo", function() {
    return faIgloo;
});
parcelHelpers.export(exports, "faImage", function() {
    return faImage;
});
parcelHelpers.export(exports, "faImages", function() {
    return faImages;
});
parcelHelpers.export(exports, "faInbox", function() {
    return faInbox;
});
parcelHelpers.export(exports, "faIndent", function() {
    return faIndent;
});
parcelHelpers.export(exports, "faIndustry", function() {
    return faIndustry;
});
parcelHelpers.export(exports, "faInfinity", function() {
    return faInfinity;
});
parcelHelpers.export(exports, "faInfo", function() {
    return faInfo;
});
parcelHelpers.export(exports, "faInfoCircle", function() {
    return faInfoCircle;
});
parcelHelpers.export(exports, "faItalic", function() {
    return faItalic;
});
parcelHelpers.export(exports, "faJedi", function() {
    return faJedi;
});
parcelHelpers.export(exports, "faJoint", function() {
    return faJoint;
});
parcelHelpers.export(exports, "faJournalWhills", function() {
    return faJournalWhills;
});
parcelHelpers.export(exports, "faKaaba", function() {
    return faKaaba;
});
parcelHelpers.export(exports, "faKey", function() {
    return faKey;
});
parcelHelpers.export(exports, "faKeyboard", function() {
    return faKeyboard;
});
parcelHelpers.export(exports, "faKhanda", function() {
    return faKhanda;
});
parcelHelpers.export(exports, "faKiss", function() {
    return faKiss;
});
parcelHelpers.export(exports, "faKissBeam", function() {
    return faKissBeam;
});
parcelHelpers.export(exports, "faKissWinkHeart", function() {
    return faKissWinkHeart;
});
parcelHelpers.export(exports, "faKiwiBird", function() {
    return faKiwiBird;
});
parcelHelpers.export(exports, "faLandmark", function() {
    return faLandmark;
});
parcelHelpers.export(exports, "faLanguage", function() {
    return faLanguage;
});
parcelHelpers.export(exports, "faLaptop", function() {
    return faLaptop;
});
parcelHelpers.export(exports, "faLaptopCode", function() {
    return faLaptopCode;
});
parcelHelpers.export(exports, "faLaptopHouse", function() {
    return faLaptopHouse;
});
parcelHelpers.export(exports, "faLaptopMedical", function() {
    return faLaptopMedical;
});
parcelHelpers.export(exports, "faLaugh", function() {
    return faLaugh;
});
parcelHelpers.export(exports, "faLaughBeam", function() {
    return faLaughBeam;
});
parcelHelpers.export(exports, "faLaughSquint", function() {
    return faLaughSquint;
});
parcelHelpers.export(exports, "faLaughWink", function() {
    return faLaughWink;
});
parcelHelpers.export(exports, "faLayerGroup", function() {
    return faLayerGroup;
});
parcelHelpers.export(exports, "faLeaf", function() {
    return faLeaf;
});
parcelHelpers.export(exports, "faLemon", function() {
    return faLemon;
});
parcelHelpers.export(exports, "faLessThan", function() {
    return faLessThan;
});
parcelHelpers.export(exports, "faLessThanEqual", function() {
    return faLessThanEqual;
});
parcelHelpers.export(exports, "faLevelDownAlt", function() {
    return faLevelDownAlt;
});
parcelHelpers.export(exports, "faLevelUpAlt", function() {
    return faLevelUpAlt;
});
parcelHelpers.export(exports, "faLifeRing", function() {
    return faLifeRing;
});
parcelHelpers.export(exports, "faLightbulb", function() {
    return faLightbulb;
});
parcelHelpers.export(exports, "faLink", function() {
    return faLink;
});
parcelHelpers.export(exports, "faLiraSign", function() {
    return faLiraSign;
});
parcelHelpers.export(exports, "faList", function() {
    return faList;
});
parcelHelpers.export(exports, "faListAlt", function() {
    return faListAlt;
});
parcelHelpers.export(exports, "faListOl", function() {
    return faListOl;
});
parcelHelpers.export(exports, "faListUl", function() {
    return faListUl;
});
parcelHelpers.export(exports, "faLocationArrow", function() {
    return faLocationArrow;
});
parcelHelpers.export(exports, "faLock", function() {
    return faLock;
});
parcelHelpers.export(exports, "faLockOpen", function() {
    return faLockOpen;
});
parcelHelpers.export(exports, "faLongArrowAltDown", function() {
    return faLongArrowAltDown;
});
parcelHelpers.export(exports, "faLongArrowAltLeft", function() {
    return faLongArrowAltLeft;
});
parcelHelpers.export(exports, "faLongArrowAltRight", function() {
    return faLongArrowAltRight;
});
parcelHelpers.export(exports, "faLongArrowAltUp", function() {
    return faLongArrowAltUp;
});
parcelHelpers.export(exports, "faLowVision", function() {
    return faLowVision;
});
parcelHelpers.export(exports, "faLuggageCart", function() {
    return faLuggageCart;
});
parcelHelpers.export(exports, "faLungs", function() {
    return faLungs;
});
parcelHelpers.export(exports, "faLungsVirus", function() {
    return faLungsVirus;
});
parcelHelpers.export(exports, "faMagic", function() {
    return faMagic;
});
parcelHelpers.export(exports, "faMagnet", function() {
    return faMagnet;
});
parcelHelpers.export(exports, "faMailBulk", function() {
    return faMailBulk;
});
parcelHelpers.export(exports, "faMale", function() {
    return faMale;
});
parcelHelpers.export(exports, "faMap", function() {
    return faMap;
});
parcelHelpers.export(exports, "faMapMarked", function() {
    return faMapMarked;
});
parcelHelpers.export(exports, "faMapMarkedAlt", function() {
    return faMapMarkedAlt;
});
parcelHelpers.export(exports, "faMapMarker", function() {
    return faMapMarker;
});
parcelHelpers.export(exports, "faMapMarkerAlt", function() {
    return faMapMarkerAlt;
});
parcelHelpers.export(exports, "faMapPin", function() {
    return faMapPin;
});
parcelHelpers.export(exports, "faMapSigns", function() {
    return faMapSigns;
});
parcelHelpers.export(exports, "faMarker", function() {
    return faMarker;
});
parcelHelpers.export(exports, "faMars", function() {
    return faMars;
});
parcelHelpers.export(exports, "faMarsDouble", function() {
    return faMarsDouble;
});
parcelHelpers.export(exports, "faMarsStroke", function() {
    return faMarsStroke;
});
parcelHelpers.export(exports, "faMarsStrokeH", function() {
    return faMarsStrokeH;
});
parcelHelpers.export(exports, "faMarsStrokeV", function() {
    return faMarsStrokeV;
});
parcelHelpers.export(exports, "faMask", function() {
    return faMask;
});
parcelHelpers.export(exports, "faMedal", function() {
    return faMedal;
});
parcelHelpers.export(exports, "faMedkit", function() {
    return faMedkit;
});
parcelHelpers.export(exports, "faMeh", function() {
    return faMeh;
});
parcelHelpers.export(exports, "faMehBlank", function() {
    return faMehBlank;
});
parcelHelpers.export(exports, "faMehRollingEyes", function() {
    return faMehRollingEyes;
});
parcelHelpers.export(exports, "faMemory", function() {
    return faMemory;
});
parcelHelpers.export(exports, "faMenorah", function() {
    return faMenorah;
});
parcelHelpers.export(exports, "faMercury", function() {
    return faMercury;
});
parcelHelpers.export(exports, "faMeteor", function() {
    return faMeteor;
});
parcelHelpers.export(exports, "faMicrochip", function() {
    return faMicrochip;
});
parcelHelpers.export(exports, "faMicrophone", function() {
    return faMicrophone;
});
parcelHelpers.export(exports, "faMicrophoneAlt", function() {
    return faMicrophoneAlt;
});
parcelHelpers.export(exports, "faMicrophoneAltSlash", function() {
    return faMicrophoneAltSlash;
});
parcelHelpers.export(exports, "faMicrophoneSlash", function() {
    return faMicrophoneSlash;
});
parcelHelpers.export(exports, "faMicroscope", function() {
    return faMicroscope;
});
parcelHelpers.export(exports, "faMinus", function() {
    return faMinus;
});
parcelHelpers.export(exports, "faMinusCircle", function() {
    return faMinusCircle;
});
parcelHelpers.export(exports, "faMinusSquare", function() {
    return faMinusSquare;
});
parcelHelpers.export(exports, "faMitten", function() {
    return faMitten;
});
parcelHelpers.export(exports, "faMobile", function() {
    return faMobile;
});
parcelHelpers.export(exports, "faMobileAlt", function() {
    return faMobileAlt;
});
parcelHelpers.export(exports, "faMoneyBill", function() {
    return faMoneyBill;
});
parcelHelpers.export(exports, "faMoneyBillAlt", function() {
    return faMoneyBillAlt;
});
parcelHelpers.export(exports, "faMoneyBillWave", function() {
    return faMoneyBillWave;
});
parcelHelpers.export(exports, "faMoneyBillWaveAlt", function() {
    return faMoneyBillWaveAlt;
});
parcelHelpers.export(exports, "faMoneyCheck", function() {
    return faMoneyCheck;
});
parcelHelpers.export(exports, "faMoneyCheckAlt", function() {
    return faMoneyCheckAlt;
});
parcelHelpers.export(exports, "faMonument", function() {
    return faMonument;
});
parcelHelpers.export(exports, "faMoon", function() {
    return faMoon;
});
parcelHelpers.export(exports, "faMortarPestle", function() {
    return faMortarPestle;
});
parcelHelpers.export(exports, "faMosque", function() {
    return faMosque;
});
parcelHelpers.export(exports, "faMotorcycle", function() {
    return faMotorcycle;
});
parcelHelpers.export(exports, "faMountain", function() {
    return faMountain;
});
parcelHelpers.export(exports, "faMouse", function() {
    return faMouse;
});
parcelHelpers.export(exports, "faMousePointer", function() {
    return faMousePointer;
});
parcelHelpers.export(exports, "faMugHot", function() {
    return faMugHot;
});
parcelHelpers.export(exports, "faMusic", function() {
    return faMusic;
});
parcelHelpers.export(exports, "faNetworkWired", function() {
    return faNetworkWired;
});
parcelHelpers.export(exports, "faNeuter", function() {
    return faNeuter;
});
parcelHelpers.export(exports, "faNewspaper", function() {
    return faNewspaper;
});
parcelHelpers.export(exports, "faNotEqual", function() {
    return faNotEqual;
});
parcelHelpers.export(exports, "faNotesMedical", function() {
    return faNotesMedical;
});
parcelHelpers.export(exports, "faObjectGroup", function() {
    return faObjectGroup;
});
parcelHelpers.export(exports, "faObjectUngroup", function() {
    return faObjectUngroup;
});
parcelHelpers.export(exports, "faOilCan", function() {
    return faOilCan;
});
parcelHelpers.export(exports, "faOm", function() {
    return faOm;
});
parcelHelpers.export(exports, "faOtter", function() {
    return faOtter;
});
parcelHelpers.export(exports, "faOutdent", function() {
    return faOutdent;
});
parcelHelpers.export(exports, "faPager", function() {
    return faPager;
});
parcelHelpers.export(exports, "faPaintBrush", function() {
    return faPaintBrush;
});
parcelHelpers.export(exports, "faPaintRoller", function() {
    return faPaintRoller;
});
parcelHelpers.export(exports, "faPalette", function() {
    return faPalette;
});
parcelHelpers.export(exports, "faPallet", function() {
    return faPallet;
});
parcelHelpers.export(exports, "faPaperPlane", function() {
    return faPaperPlane;
});
parcelHelpers.export(exports, "faPaperclip", function() {
    return faPaperclip;
});
parcelHelpers.export(exports, "faParachuteBox", function() {
    return faParachuteBox;
});
parcelHelpers.export(exports, "faParagraph", function() {
    return faParagraph;
});
parcelHelpers.export(exports, "faParking", function() {
    return faParking;
});
parcelHelpers.export(exports, "faPassport", function() {
    return faPassport;
});
parcelHelpers.export(exports, "faPastafarianism", function() {
    return faPastafarianism;
});
parcelHelpers.export(exports, "faPaste", function() {
    return faPaste;
});
parcelHelpers.export(exports, "faPause", function() {
    return faPause;
});
parcelHelpers.export(exports, "faPauseCircle", function() {
    return faPauseCircle;
});
parcelHelpers.export(exports, "faPaw", function() {
    return faPaw;
});
parcelHelpers.export(exports, "faPeace", function() {
    return faPeace;
});
parcelHelpers.export(exports, "faPen", function() {
    return faPen;
});
parcelHelpers.export(exports, "faPenAlt", function() {
    return faPenAlt;
});
parcelHelpers.export(exports, "faPenFancy", function() {
    return faPenFancy;
});
parcelHelpers.export(exports, "faPenNib", function() {
    return faPenNib;
});
parcelHelpers.export(exports, "faPenSquare", function() {
    return faPenSquare;
});
parcelHelpers.export(exports, "faPencilAlt", function() {
    return faPencilAlt;
});
parcelHelpers.export(exports, "faPencilRuler", function() {
    return faPencilRuler;
});
parcelHelpers.export(exports, "faPeopleArrows", function() {
    return faPeopleArrows;
});
parcelHelpers.export(exports, "faPeopleCarry", function() {
    return faPeopleCarry;
});
parcelHelpers.export(exports, "faPepperHot", function() {
    return faPepperHot;
});
parcelHelpers.export(exports, "faPercent", function() {
    return faPercent;
});
parcelHelpers.export(exports, "faPercentage", function() {
    return faPercentage;
});
parcelHelpers.export(exports, "faPersonBooth", function() {
    return faPersonBooth;
});
parcelHelpers.export(exports, "faPhone", function() {
    return faPhone;
});
parcelHelpers.export(exports, "faPhoneAlt", function() {
    return faPhoneAlt;
});
parcelHelpers.export(exports, "faPhoneSlash", function() {
    return faPhoneSlash;
});
parcelHelpers.export(exports, "faPhoneSquare", function() {
    return faPhoneSquare;
});
parcelHelpers.export(exports, "faPhoneSquareAlt", function() {
    return faPhoneSquareAlt;
});
parcelHelpers.export(exports, "faPhoneVolume", function() {
    return faPhoneVolume;
});
parcelHelpers.export(exports, "faPhotoVideo", function() {
    return faPhotoVideo;
});
parcelHelpers.export(exports, "faPiggyBank", function() {
    return faPiggyBank;
});
parcelHelpers.export(exports, "faPills", function() {
    return faPills;
});
parcelHelpers.export(exports, "faPizzaSlice", function() {
    return faPizzaSlice;
});
parcelHelpers.export(exports, "faPlaceOfWorship", function() {
    return faPlaceOfWorship;
});
parcelHelpers.export(exports, "faPlane", function() {
    return faPlane;
});
parcelHelpers.export(exports, "faPlaneArrival", function() {
    return faPlaneArrival;
});
parcelHelpers.export(exports, "faPlaneDeparture", function() {
    return faPlaneDeparture;
});
parcelHelpers.export(exports, "faPlaneSlash", function() {
    return faPlaneSlash;
});
parcelHelpers.export(exports, "faPlay", function() {
    return faPlay;
});
parcelHelpers.export(exports, "faPlayCircle", function() {
    return faPlayCircle;
});
parcelHelpers.export(exports, "faPlug", function() {
    return faPlug;
});
parcelHelpers.export(exports, "faPlus", function() {
    return faPlus;
});
parcelHelpers.export(exports, "faPlusCircle", function() {
    return faPlusCircle;
});
parcelHelpers.export(exports, "faPlusSquare", function() {
    return faPlusSquare;
});
parcelHelpers.export(exports, "faPodcast", function() {
    return faPodcast;
});
parcelHelpers.export(exports, "faPoll", function() {
    return faPoll;
});
parcelHelpers.export(exports, "faPollH", function() {
    return faPollH;
});
parcelHelpers.export(exports, "faPoo", function() {
    return faPoo;
});
parcelHelpers.export(exports, "faPooStorm", function() {
    return faPooStorm;
});
parcelHelpers.export(exports, "faPoop", function() {
    return faPoop;
});
parcelHelpers.export(exports, "faPortrait", function() {
    return faPortrait;
});
parcelHelpers.export(exports, "faPoundSign", function() {
    return faPoundSign;
});
parcelHelpers.export(exports, "faPowerOff", function() {
    return faPowerOff;
});
parcelHelpers.export(exports, "faPray", function() {
    return faPray;
});
parcelHelpers.export(exports, "faPrayingHands", function() {
    return faPrayingHands;
});
parcelHelpers.export(exports, "faPrescription", function() {
    return faPrescription;
});
parcelHelpers.export(exports, "faPrescriptionBottle", function() {
    return faPrescriptionBottle;
});
parcelHelpers.export(exports, "faPrescriptionBottleAlt", function() {
    return faPrescriptionBottleAlt;
});
parcelHelpers.export(exports, "faPrint", function() {
    return faPrint;
});
parcelHelpers.export(exports, "faProcedures", function() {
    return faProcedures;
});
parcelHelpers.export(exports, "faProjectDiagram", function() {
    return faProjectDiagram;
});
parcelHelpers.export(exports, "faPumpMedical", function() {
    return faPumpMedical;
});
parcelHelpers.export(exports, "faPumpSoap", function() {
    return faPumpSoap;
});
parcelHelpers.export(exports, "faPuzzlePiece", function() {
    return faPuzzlePiece;
});
parcelHelpers.export(exports, "faQrcode", function() {
    return faQrcode;
});
parcelHelpers.export(exports, "faQuestion", function() {
    return faQuestion;
});
parcelHelpers.export(exports, "faQuestionCircle", function() {
    return faQuestionCircle;
});
parcelHelpers.export(exports, "faQuidditch", function() {
    return faQuidditch;
});
parcelHelpers.export(exports, "faQuoteLeft", function() {
    return faQuoteLeft;
});
parcelHelpers.export(exports, "faQuoteRight", function() {
    return faQuoteRight;
});
parcelHelpers.export(exports, "faQuran", function() {
    return faQuran;
});
parcelHelpers.export(exports, "faRadiation", function() {
    return faRadiation;
});
parcelHelpers.export(exports, "faRadiationAlt", function() {
    return faRadiationAlt;
});
parcelHelpers.export(exports, "faRainbow", function() {
    return faRainbow;
});
parcelHelpers.export(exports, "faRandom", function() {
    return faRandom;
});
parcelHelpers.export(exports, "faReceipt", function() {
    return faReceipt;
});
parcelHelpers.export(exports, "faRecordVinyl", function() {
    return faRecordVinyl;
});
parcelHelpers.export(exports, "faRecycle", function() {
    return faRecycle;
});
parcelHelpers.export(exports, "faRedo", function() {
    return faRedo;
});
parcelHelpers.export(exports, "faRedoAlt", function() {
    return faRedoAlt;
});
parcelHelpers.export(exports, "faRegistered", function() {
    return faRegistered;
});
parcelHelpers.export(exports, "faRemoveFormat", function() {
    return faRemoveFormat;
});
parcelHelpers.export(exports, "faReply", function() {
    return faReply;
});
parcelHelpers.export(exports, "faReplyAll", function() {
    return faReplyAll;
});
parcelHelpers.export(exports, "faRepublican", function() {
    return faRepublican;
});
parcelHelpers.export(exports, "faRestroom", function() {
    return faRestroom;
});
parcelHelpers.export(exports, "faRetweet", function() {
    return faRetweet;
});
parcelHelpers.export(exports, "faRibbon", function() {
    return faRibbon;
});
parcelHelpers.export(exports, "faRing", function() {
    return faRing;
});
parcelHelpers.export(exports, "faRoad", function() {
    return faRoad;
});
parcelHelpers.export(exports, "faRobot", function() {
    return faRobot;
});
parcelHelpers.export(exports, "faRocket", function() {
    return faRocket;
});
parcelHelpers.export(exports, "faRoute", function() {
    return faRoute;
});
parcelHelpers.export(exports, "faRss", function() {
    return faRss;
});
parcelHelpers.export(exports, "faRssSquare", function() {
    return faRssSquare;
});
parcelHelpers.export(exports, "faRubleSign", function() {
    return faRubleSign;
});
parcelHelpers.export(exports, "faRuler", function() {
    return faRuler;
});
parcelHelpers.export(exports, "faRulerCombined", function() {
    return faRulerCombined;
});
parcelHelpers.export(exports, "faRulerHorizontal", function() {
    return faRulerHorizontal;
});
parcelHelpers.export(exports, "faRulerVertical", function() {
    return faRulerVertical;
});
parcelHelpers.export(exports, "faRunning", function() {
    return faRunning;
});
parcelHelpers.export(exports, "faRupeeSign", function() {
    return faRupeeSign;
});
parcelHelpers.export(exports, "faSadCry", function() {
    return faSadCry;
});
parcelHelpers.export(exports, "faSadTear", function() {
    return faSadTear;
});
parcelHelpers.export(exports, "faSatellite", function() {
    return faSatellite;
});
parcelHelpers.export(exports, "faSatelliteDish", function() {
    return faSatelliteDish;
});
parcelHelpers.export(exports, "faSave", function() {
    return faSave;
});
parcelHelpers.export(exports, "faSchool", function() {
    return faSchool;
});
parcelHelpers.export(exports, "faScrewdriver", function() {
    return faScrewdriver;
});
parcelHelpers.export(exports, "faScroll", function() {
    return faScroll;
});
parcelHelpers.export(exports, "faSdCard", function() {
    return faSdCard;
});
parcelHelpers.export(exports, "faSearch", function() {
    return faSearch;
});
parcelHelpers.export(exports, "faSearchDollar", function() {
    return faSearchDollar;
});
parcelHelpers.export(exports, "faSearchLocation", function() {
    return faSearchLocation;
});
parcelHelpers.export(exports, "faSearchMinus", function() {
    return faSearchMinus;
});
parcelHelpers.export(exports, "faSearchPlus", function() {
    return faSearchPlus;
});
parcelHelpers.export(exports, "faSeedling", function() {
    return faSeedling;
});
parcelHelpers.export(exports, "faServer", function() {
    return faServer;
});
parcelHelpers.export(exports, "faShapes", function() {
    return faShapes;
});
parcelHelpers.export(exports, "faShare", function() {
    return faShare;
});
parcelHelpers.export(exports, "faShareAlt", function() {
    return faShareAlt;
});
parcelHelpers.export(exports, "faShareAltSquare", function() {
    return faShareAltSquare;
});
parcelHelpers.export(exports, "faShareSquare", function() {
    return faShareSquare;
});
parcelHelpers.export(exports, "faShekelSign", function() {
    return faShekelSign;
});
parcelHelpers.export(exports, "faShieldAlt", function() {
    return faShieldAlt;
});
parcelHelpers.export(exports, "faShieldVirus", function() {
    return faShieldVirus;
});
parcelHelpers.export(exports, "faShip", function() {
    return faShip;
});
parcelHelpers.export(exports, "faShippingFast", function() {
    return faShippingFast;
});
parcelHelpers.export(exports, "faShoePrints", function() {
    return faShoePrints;
});
parcelHelpers.export(exports, "faShoppingBag", function() {
    return faShoppingBag;
});
parcelHelpers.export(exports, "faShoppingBasket", function() {
    return faShoppingBasket;
});
parcelHelpers.export(exports, "faShoppingCart", function() {
    return faShoppingCart;
});
parcelHelpers.export(exports, "faShower", function() {
    return faShower;
});
parcelHelpers.export(exports, "faShuttleVan", function() {
    return faShuttleVan;
});
parcelHelpers.export(exports, "faSign", function() {
    return faSign;
});
parcelHelpers.export(exports, "faSignInAlt", function() {
    return faSignInAlt;
});
parcelHelpers.export(exports, "faSignLanguage", function() {
    return faSignLanguage;
});
parcelHelpers.export(exports, "faSignOutAlt", function() {
    return faSignOutAlt;
});
parcelHelpers.export(exports, "faSignal", function() {
    return faSignal;
});
parcelHelpers.export(exports, "faSignature", function() {
    return faSignature;
});
parcelHelpers.export(exports, "faSimCard", function() {
    return faSimCard;
});
parcelHelpers.export(exports, "faSink", function() {
    return faSink;
});
parcelHelpers.export(exports, "faSitemap", function() {
    return faSitemap;
});
parcelHelpers.export(exports, "faSkating", function() {
    return faSkating;
});
parcelHelpers.export(exports, "faSkiing", function() {
    return faSkiing;
});
parcelHelpers.export(exports, "faSkiingNordic", function() {
    return faSkiingNordic;
});
parcelHelpers.export(exports, "faSkull", function() {
    return faSkull;
});
parcelHelpers.export(exports, "faSkullCrossbones", function() {
    return faSkullCrossbones;
});
parcelHelpers.export(exports, "faSlash", function() {
    return faSlash;
});
parcelHelpers.export(exports, "faSleigh", function() {
    return faSleigh;
});
parcelHelpers.export(exports, "faSlidersH", function() {
    return faSlidersH;
});
parcelHelpers.export(exports, "faSmile", function() {
    return faSmile;
});
parcelHelpers.export(exports, "faSmileBeam", function() {
    return faSmileBeam;
});
parcelHelpers.export(exports, "faSmileWink", function() {
    return faSmileWink;
});
parcelHelpers.export(exports, "faSmog", function() {
    return faSmog;
});
parcelHelpers.export(exports, "faSmoking", function() {
    return faSmoking;
});
parcelHelpers.export(exports, "faSmokingBan", function() {
    return faSmokingBan;
});
parcelHelpers.export(exports, "faSms", function() {
    return faSms;
});
parcelHelpers.export(exports, "faSnowboarding", function() {
    return faSnowboarding;
});
parcelHelpers.export(exports, "faSnowflake", function() {
    return faSnowflake;
});
parcelHelpers.export(exports, "faSnowman", function() {
    return faSnowman;
});
parcelHelpers.export(exports, "faSnowplow", function() {
    return faSnowplow;
});
parcelHelpers.export(exports, "faSoap", function() {
    return faSoap;
});
parcelHelpers.export(exports, "faSocks", function() {
    return faSocks;
});
parcelHelpers.export(exports, "faSolarPanel", function() {
    return faSolarPanel;
});
parcelHelpers.export(exports, "faSort", function() {
    return faSort;
});
parcelHelpers.export(exports, "faSortAlphaDown", function() {
    return faSortAlphaDown;
});
parcelHelpers.export(exports, "faSortAlphaDownAlt", function() {
    return faSortAlphaDownAlt;
});
parcelHelpers.export(exports, "faSortAlphaUp", function() {
    return faSortAlphaUp;
});
parcelHelpers.export(exports, "faSortAlphaUpAlt", function() {
    return faSortAlphaUpAlt;
});
parcelHelpers.export(exports, "faSortAmountDown", function() {
    return faSortAmountDown;
});
parcelHelpers.export(exports, "faSortAmountDownAlt", function() {
    return faSortAmountDownAlt;
});
parcelHelpers.export(exports, "faSortAmountUp", function() {
    return faSortAmountUp;
});
parcelHelpers.export(exports, "faSortAmountUpAlt", function() {
    return faSortAmountUpAlt;
});
parcelHelpers.export(exports, "faSortDown", function() {
    return faSortDown;
});
parcelHelpers.export(exports, "faSortNumericDown", function() {
    return faSortNumericDown;
});
parcelHelpers.export(exports, "faSortNumericDownAlt", function() {
    return faSortNumericDownAlt;
});
parcelHelpers.export(exports, "faSortNumericUp", function() {
    return faSortNumericUp;
});
parcelHelpers.export(exports, "faSortNumericUpAlt", function() {
    return faSortNumericUpAlt;
});
parcelHelpers.export(exports, "faSortUp", function() {
    return faSortUp;
});
parcelHelpers.export(exports, "faSpa", function() {
    return faSpa;
});
parcelHelpers.export(exports, "faSpaceShuttle", function() {
    return faSpaceShuttle;
});
parcelHelpers.export(exports, "faSpellCheck", function() {
    return faSpellCheck;
});
parcelHelpers.export(exports, "faSpider", function() {
    return faSpider;
});
parcelHelpers.export(exports, "faSpinner", function() {
    return faSpinner;
});
parcelHelpers.export(exports, "faSplotch", function() {
    return faSplotch;
});
parcelHelpers.export(exports, "faSprayCan", function() {
    return faSprayCan;
});
parcelHelpers.export(exports, "faSquare", function() {
    return faSquare;
});
parcelHelpers.export(exports, "faSquareFull", function() {
    return faSquareFull;
});
parcelHelpers.export(exports, "faSquareRootAlt", function() {
    return faSquareRootAlt;
});
parcelHelpers.export(exports, "faStamp", function() {
    return faStamp;
});
parcelHelpers.export(exports, "faStar", function() {
    return faStar;
});
parcelHelpers.export(exports, "faStarAndCrescent", function() {
    return faStarAndCrescent;
});
parcelHelpers.export(exports, "faStarHalf", function() {
    return faStarHalf;
});
parcelHelpers.export(exports, "faStarHalfAlt", function() {
    return faStarHalfAlt;
});
parcelHelpers.export(exports, "faStarOfDavid", function() {
    return faStarOfDavid;
});
parcelHelpers.export(exports, "faStarOfLife", function() {
    return faStarOfLife;
});
parcelHelpers.export(exports, "faStepBackward", function() {
    return faStepBackward;
});
parcelHelpers.export(exports, "faStepForward", function() {
    return faStepForward;
});
parcelHelpers.export(exports, "faStethoscope", function() {
    return faStethoscope;
});
parcelHelpers.export(exports, "faStickyNote", function() {
    return faStickyNote;
});
parcelHelpers.export(exports, "faStop", function() {
    return faStop;
});
parcelHelpers.export(exports, "faStopCircle", function() {
    return faStopCircle;
});
parcelHelpers.export(exports, "faStopwatch", function() {
    return faStopwatch;
});
parcelHelpers.export(exports, "faStopwatch20", function() {
    return faStopwatch20;
});
parcelHelpers.export(exports, "faStore", function() {
    return faStore;
});
parcelHelpers.export(exports, "faStoreAlt", function() {
    return faStoreAlt;
});
parcelHelpers.export(exports, "faStoreAltSlash", function() {
    return faStoreAltSlash;
});
parcelHelpers.export(exports, "faStoreSlash", function() {
    return faStoreSlash;
});
parcelHelpers.export(exports, "faStream", function() {
    return faStream;
});
parcelHelpers.export(exports, "faStreetView", function() {
    return faStreetView;
});
parcelHelpers.export(exports, "faStrikethrough", function() {
    return faStrikethrough;
});
parcelHelpers.export(exports, "faStroopwafel", function() {
    return faStroopwafel;
});
parcelHelpers.export(exports, "faSubscript", function() {
    return faSubscript;
});
parcelHelpers.export(exports, "faSubway", function() {
    return faSubway;
});
parcelHelpers.export(exports, "faSuitcase", function() {
    return faSuitcase;
});
parcelHelpers.export(exports, "faSuitcaseRolling", function() {
    return faSuitcaseRolling;
});
parcelHelpers.export(exports, "faSun", function() {
    return faSun;
});
parcelHelpers.export(exports, "faSuperscript", function() {
    return faSuperscript;
});
parcelHelpers.export(exports, "faSurprise", function() {
    return faSurprise;
});
parcelHelpers.export(exports, "faSwatchbook", function() {
    return faSwatchbook;
});
parcelHelpers.export(exports, "faSwimmer", function() {
    return faSwimmer;
});
parcelHelpers.export(exports, "faSwimmingPool", function() {
    return faSwimmingPool;
});
parcelHelpers.export(exports, "faSynagogue", function() {
    return faSynagogue;
});
parcelHelpers.export(exports, "faSync", function() {
    return faSync;
});
parcelHelpers.export(exports, "faSyncAlt", function() {
    return faSyncAlt;
});
parcelHelpers.export(exports, "faSyringe", function() {
    return faSyringe;
});
parcelHelpers.export(exports, "faTable", function() {
    return faTable;
});
parcelHelpers.export(exports, "faTableTennis", function() {
    return faTableTennis;
});
parcelHelpers.export(exports, "faTablet", function() {
    return faTablet;
});
parcelHelpers.export(exports, "faTabletAlt", function() {
    return faTabletAlt;
});
parcelHelpers.export(exports, "faTablets", function() {
    return faTablets;
});
parcelHelpers.export(exports, "faTachometerAlt", function() {
    return faTachometerAlt;
});
parcelHelpers.export(exports, "faTag", function() {
    return faTag;
});
parcelHelpers.export(exports, "faTags", function() {
    return faTags;
});
parcelHelpers.export(exports, "faTape", function() {
    return faTape;
});
parcelHelpers.export(exports, "faTasks", function() {
    return faTasks;
});
parcelHelpers.export(exports, "faTaxi", function() {
    return faTaxi;
});
parcelHelpers.export(exports, "faTeeth", function() {
    return faTeeth;
});
parcelHelpers.export(exports, "faTeethOpen", function() {
    return faTeethOpen;
});
parcelHelpers.export(exports, "faTemperatureHigh", function() {
    return faTemperatureHigh;
});
parcelHelpers.export(exports, "faTemperatureLow", function() {
    return faTemperatureLow;
});
parcelHelpers.export(exports, "faTenge", function() {
    return faTenge;
});
parcelHelpers.export(exports, "faTerminal", function() {
    return faTerminal;
});
parcelHelpers.export(exports, "faTextHeight", function() {
    return faTextHeight;
});
parcelHelpers.export(exports, "faTextWidth", function() {
    return faTextWidth;
});
parcelHelpers.export(exports, "faTh", function() {
    return faTh;
});
parcelHelpers.export(exports, "faThLarge", function() {
    return faThLarge;
});
parcelHelpers.export(exports, "faThList", function() {
    return faThList;
});
parcelHelpers.export(exports, "faTheaterMasks", function() {
    return faTheaterMasks;
});
parcelHelpers.export(exports, "faThermometer", function() {
    return faThermometer;
});
parcelHelpers.export(exports, "faThermometerEmpty", function() {
    return faThermometerEmpty;
});
parcelHelpers.export(exports, "faThermometerFull", function() {
    return faThermometerFull;
});
parcelHelpers.export(exports, "faThermometerHalf", function() {
    return faThermometerHalf;
});
parcelHelpers.export(exports, "faThermometerQuarter", function() {
    return faThermometerQuarter;
});
parcelHelpers.export(exports, "faThermometerThreeQuarters", function() {
    return faThermometerThreeQuarters;
});
parcelHelpers.export(exports, "faThumbsDown", function() {
    return faThumbsDown;
});
parcelHelpers.export(exports, "faThumbsUp", function() {
    return faThumbsUp;
});
parcelHelpers.export(exports, "faThumbtack", function() {
    return faThumbtack;
});
parcelHelpers.export(exports, "faTicketAlt", function() {
    return faTicketAlt;
});
parcelHelpers.export(exports, "faTimes", function() {
    return faTimes;
});
parcelHelpers.export(exports, "faTimesCircle", function() {
    return faTimesCircle;
});
parcelHelpers.export(exports, "faTint", function() {
    return faTint;
});
parcelHelpers.export(exports, "faTintSlash", function() {
    return faTintSlash;
});
parcelHelpers.export(exports, "faTired", function() {
    return faTired;
});
parcelHelpers.export(exports, "faToggleOff", function() {
    return faToggleOff;
});
parcelHelpers.export(exports, "faToggleOn", function() {
    return faToggleOn;
});
parcelHelpers.export(exports, "faToilet", function() {
    return faToilet;
});
parcelHelpers.export(exports, "faToiletPaper", function() {
    return faToiletPaper;
});
parcelHelpers.export(exports, "faToiletPaperSlash", function() {
    return faToiletPaperSlash;
});
parcelHelpers.export(exports, "faToolbox", function() {
    return faToolbox;
});
parcelHelpers.export(exports, "faTools", function() {
    return faTools;
});
parcelHelpers.export(exports, "faTooth", function() {
    return faTooth;
});
parcelHelpers.export(exports, "faTorah", function() {
    return faTorah;
});
parcelHelpers.export(exports, "faToriiGate", function() {
    return faToriiGate;
});
parcelHelpers.export(exports, "faTractor", function() {
    return faTractor;
});
parcelHelpers.export(exports, "faTrademark", function() {
    return faTrademark;
});
parcelHelpers.export(exports, "faTrafficLight", function() {
    return faTrafficLight;
});
parcelHelpers.export(exports, "faTrailer", function() {
    return faTrailer;
});
parcelHelpers.export(exports, "faTrain", function() {
    return faTrain;
});
parcelHelpers.export(exports, "faTram", function() {
    return faTram;
});
parcelHelpers.export(exports, "faTransgender", function() {
    return faTransgender;
});
parcelHelpers.export(exports, "faTransgenderAlt", function() {
    return faTransgenderAlt;
});
parcelHelpers.export(exports, "faTrash", function() {
    return faTrash;
});
parcelHelpers.export(exports, "faTrashAlt", function() {
    return faTrashAlt;
});
parcelHelpers.export(exports, "faTrashRestore", function() {
    return faTrashRestore;
});
parcelHelpers.export(exports, "faTrashRestoreAlt", function() {
    return faTrashRestoreAlt;
});
parcelHelpers.export(exports, "faTree", function() {
    return faTree;
});
parcelHelpers.export(exports, "faTrophy", function() {
    return faTrophy;
});
parcelHelpers.export(exports, "faTruck", function() {
    return faTruck;
});
parcelHelpers.export(exports, "faTruckLoading", function() {
    return faTruckLoading;
});
parcelHelpers.export(exports, "faTruckMonster", function() {
    return faTruckMonster;
});
parcelHelpers.export(exports, "faTruckMoving", function() {
    return faTruckMoving;
});
parcelHelpers.export(exports, "faTruckPickup", function() {
    return faTruckPickup;
});
parcelHelpers.export(exports, "faTshirt", function() {
    return faTshirt;
});
parcelHelpers.export(exports, "faTty", function() {
    return faTty;
});
parcelHelpers.export(exports, "faTv", function() {
    return faTv;
});
parcelHelpers.export(exports, "faUmbrella", function() {
    return faUmbrella;
});
parcelHelpers.export(exports, "faUmbrellaBeach", function() {
    return faUmbrellaBeach;
});
parcelHelpers.export(exports, "faUnderline", function() {
    return faUnderline;
});
parcelHelpers.export(exports, "faUndo", function() {
    return faUndo;
});
parcelHelpers.export(exports, "faUndoAlt", function() {
    return faUndoAlt;
});
parcelHelpers.export(exports, "faUniversalAccess", function() {
    return faUniversalAccess;
});
parcelHelpers.export(exports, "faUniversity", function() {
    return faUniversity;
});
parcelHelpers.export(exports, "faUnlink", function() {
    return faUnlink;
});
parcelHelpers.export(exports, "faUnlock", function() {
    return faUnlock;
});
parcelHelpers.export(exports, "faUnlockAlt", function() {
    return faUnlockAlt;
});
parcelHelpers.export(exports, "faUpload", function() {
    return faUpload;
});
parcelHelpers.export(exports, "faUser", function() {
    return faUser;
});
parcelHelpers.export(exports, "faUserAlt", function() {
    return faUserAlt;
});
parcelHelpers.export(exports, "faUserAltSlash", function() {
    return faUserAltSlash;
});
parcelHelpers.export(exports, "faUserAstronaut", function() {
    return faUserAstronaut;
});
parcelHelpers.export(exports, "faUserCheck", function() {
    return faUserCheck;
});
parcelHelpers.export(exports, "faUserCircle", function() {
    return faUserCircle;
});
parcelHelpers.export(exports, "faUserClock", function() {
    return faUserClock;
});
parcelHelpers.export(exports, "faUserCog", function() {
    return faUserCog;
});
parcelHelpers.export(exports, "faUserEdit", function() {
    return faUserEdit;
});
parcelHelpers.export(exports, "faUserFriends", function() {
    return faUserFriends;
});
parcelHelpers.export(exports, "faUserGraduate", function() {
    return faUserGraduate;
});
parcelHelpers.export(exports, "faUserInjured", function() {
    return faUserInjured;
});
parcelHelpers.export(exports, "faUserLock", function() {
    return faUserLock;
});
parcelHelpers.export(exports, "faUserMd", function() {
    return faUserMd;
});
parcelHelpers.export(exports, "faUserMinus", function() {
    return faUserMinus;
});
parcelHelpers.export(exports, "faUserNinja", function() {
    return faUserNinja;
});
parcelHelpers.export(exports, "faUserNurse", function() {
    return faUserNurse;
});
parcelHelpers.export(exports, "faUserPlus", function() {
    return faUserPlus;
});
parcelHelpers.export(exports, "faUserSecret", function() {
    return faUserSecret;
});
parcelHelpers.export(exports, "faUserShield", function() {
    return faUserShield;
});
parcelHelpers.export(exports, "faUserSlash", function() {
    return faUserSlash;
});
parcelHelpers.export(exports, "faUserTag", function() {
    return faUserTag;
});
parcelHelpers.export(exports, "faUserTie", function() {
    return faUserTie;
});
parcelHelpers.export(exports, "faUserTimes", function() {
    return faUserTimes;
});
parcelHelpers.export(exports, "faUsers", function() {
    return faUsers;
});
parcelHelpers.export(exports, "faUsersCog", function() {
    return faUsersCog;
});
parcelHelpers.export(exports, "faUsersSlash", function() {
    return faUsersSlash;
});
parcelHelpers.export(exports, "faUtensilSpoon", function() {
    return faUtensilSpoon;
});
parcelHelpers.export(exports, "faUtensils", function() {
    return faUtensils;
});
parcelHelpers.export(exports, "faVectorSquare", function() {
    return faVectorSquare;
});
parcelHelpers.export(exports, "faVenus", function() {
    return faVenus;
});
parcelHelpers.export(exports, "faVenusDouble", function() {
    return faVenusDouble;
});
parcelHelpers.export(exports, "faVenusMars", function() {
    return faVenusMars;
});
parcelHelpers.export(exports, "faVest", function() {
    return faVest;
});
parcelHelpers.export(exports, "faVestPatches", function() {
    return faVestPatches;
});
parcelHelpers.export(exports, "faVial", function() {
    return faVial;
});
parcelHelpers.export(exports, "faVials", function() {
    return faVials;
});
parcelHelpers.export(exports, "faVideo", function() {
    return faVideo;
});
parcelHelpers.export(exports, "faVideoSlash", function() {
    return faVideoSlash;
});
parcelHelpers.export(exports, "faVihara", function() {
    return faVihara;
});
parcelHelpers.export(exports, "faVirus", function() {
    return faVirus;
});
parcelHelpers.export(exports, "faVirusSlash", function() {
    return faVirusSlash;
});
parcelHelpers.export(exports, "faViruses", function() {
    return faViruses;
});
parcelHelpers.export(exports, "faVoicemail", function() {
    return faVoicemail;
});
parcelHelpers.export(exports, "faVolleyballBall", function() {
    return faVolleyballBall;
});
parcelHelpers.export(exports, "faVolumeDown", function() {
    return faVolumeDown;
});
parcelHelpers.export(exports, "faVolumeMute", function() {
    return faVolumeMute;
});
parcelHelpers.export(exports, "faVolumeOff", function() {
    return faVolumeOff;
});
parcelHelpers.export(exports, "faVolumeUp", function() {
    return faVolumeUp;
});
parcelHelpers.export(exports, "faVoteYea", function() {
    return faVoteYea;
});
parcelHelpers.export(exports, "faVrCardboard", function() {
    return faVrCardboard;
});
parcelHelpers.export(exports, "faWalking", function() {
    return faWalking;
});
parcelHelpers.export(exports, "faWallet", function() {
    return faWallet;
});
parcelHelpers.export(exports, "faWarehouse", function() {
    return faWarehouse;
});
parcelHelpers.export(exports, "faWater", function() {
    return faWater;
});
parcelHelpers.export(exports, "faWaveSquare", function() {
    return faWaveSquare;
});
parcelHelpers.export(exports, "faWeight", function() {
    return faWeight;
});
parcelHelpers.export(exports, "faWeightHanging", function() {
    return faWeightHanging;
});
parcelHelpers.export(exports, "faWheelchair", function() {
    return faWheelchair;
});
parcelHelpers.export(exports, "faWifi", function() {
    return faWifi;
});
parcelHelpers.export(exports, "faWind", function() {
    return faWind;
});
parcelHelpers.export(exports, "faWindowClose", function() {
    return faWindowClose;
});
parcelHelpers.export(exports, "faWindowMaximize", function() {
    return faWindowMaximize;
});
parcelHelpers.export(exports, "faWindowMinimize", function() {
    return faWindowMinimize;
});
parcelHelpers.export(exports, "faWindowRestore", function() {
    return faWindowRestore;
});
parcelHelpers.export(exports, "faWineBottle", function() {
    return faWineBottle;
});
parcelHelpers.export(exports, "faWineGlass", function() {
    return faWineGlass;
});
parcelHelpers.export(exports, "faWineGlassAlt", function() {
    return faWineGlassAlt;
});
parcelHelpers.export(exports, "faWonSign", function() {
    return faWonSign;
});
parcelHelpers.export(exports, "faWrench", function() {
    return faWrench;
});
parcelHelpers.export(exports, "faXRay", function() {
    return faXRay;
});
parcelHelpers.export(exports, "faYenSign", function() {
    return faYenSign;
});
parcelHelpers.export(exports, "faYinYang", function() {
    return faYinYang;
});
var prefix = "fas";
var faAd = {
    prefix: "fas",
    iconName: "ad",
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var faAddressBook = {
    prefix: "fas",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faAddressCard = {
    prefix: "fas",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var faAdjust = {
    prefix: "fas",
    iconName: "adjust",
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var faAirFreshener = {
    prefix: "fas",
    iconName: "air-freshener",
    icon: [
        384,
        512,
        [],
        "f5d0",
        "M378.94 321.41L284.7 224h49.22c15.3 0 23.66-16.6 13.86-27.53L234.45 69.96c3.43-6.61 5.55-14 5.55-21.96 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 7.96 2.12 15.35 5.55 21.96L36.22 196.47C26.42 207.4 34.78 224 50.08 224H99.3L5.06 321.41C-6.69 333.56 3.34 352 21.7 352H160v32H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16H224v-32h138.3c18.36 0 28.39-18.44 16.64-30.59zM192 31.98c8.85 0 16.02 7.17 16.02 16.02 0 8.84-7.17 16.02-16.02 16.02S175.98 56.84 175.98 48c0-8.85 7.17-16.02 16.02-16.02zM304 432v32H80v-32h224z"
    ]
};
var faAlignCenter = {
    prefix: "fas",
    iconName: "align-center",
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var faAlignJustify = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faAlignLeft = {
    prefix: "fas",
    iconName: "align-left",
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faAlignRight = {
    prefix: "fas",
    iconName: "align-right",
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var faAllergies = {
    prefix: "fas",
    iconName: "allergies",
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faAmbulance = {
    prefix: "fas",
    iconName: "ambulance",
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faAmericanSignLanguageInterpreting = {
    prefix: "fas",
    iconName: "american-sign-language-interpreting",
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var faAnchor = {
    prefix: "fas",
    iconName: "anchor",
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var faAngleDoubleDown = {
    prefix: "fas",
    iconName: "angle-double-down",
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var faAngleDoubleLeft = {
    prefix: "fas",
    iconName: "angle-double-left",
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var faAngleDoubleRight = {
    prefix: "fas",
    iconName: "angle-double-right",
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var faAngleDoubleUp = {
    prefix: "fas",
    iconName: "angle-double-up",
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var faAngleDown = {
    prefix: "fas",
    iconName: "angle-down",
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var faAngleLeft = {
    prefix: "fas",
    iconName: "angle-left",
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var faAngleRight = {
    prefix: "fas",
    iconName: "angle-right",
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var faAngleUp = {
    prefix: "fas",
    iconName: "angle-up",
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var faAngry = {
    prefix: "fas",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var faAnkh = {
    prefix: "fas",
    iconName: "ankh",
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var faAppleAlt = {
    prefix: "fas",
    iconName: "apple-alt",
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var faArchive = {
    prefix: "fas",
    iconName: "archive",
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var faArchway = {
    prefix: "fas",
    iconName: "archway",
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var faArrowAltCircleDown = {
    prefix: "fas",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var faArrowAltCircleLeft = {
    prefix: "fas",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var faArrowAltCircleRight = {
    prefix: "fas",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var faArrowAltCircleUp = {
    prefix: "fas",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var faArrowCircleDown = {
    prefix: "fas",
    iconName: "arrow-circle-down",
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var faArrowCircleLeft = {
    prefix: "fas",
    iconName: "arrow-circle-left",
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var faArrowCircleRight = {
    prefix: "fas",
    iconName: "arrow-circle-right",
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var faArrowCircleUp = {
    prefix: "fas",
    iconName: "arrow-circle-up",
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var faArrowDown = {
    prefix: "fas",
    iconName: "arrow-down",
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var faArrowLeft = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var faArrowRight = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var faArrowUp = {
    prefix: "fas",
    iconName: "arrow-up",
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var faArrowsAlt = {
    prefix: "fas",
    iconName: "arrows-alt",
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var faArrowsAltH = {
    prefix: "fas",
    iconName: "arrows-alt-h",
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var faArrowsAltV = {
    prefix: "fas",
    iconName: "arrows-alt-v",
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var faAssistiveListeningSystems = {
    prefix: "fas",
    iconName: "assistive-listening-systems",
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var faAsterisk = {
    prefix: "fas",
    iconName: "asterisk",
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var faAt = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var faAtlas = {
    prefix: "fas",
    iconName: "atlas",
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var faAtom = {
    prefix: "fas",
    iconName: "atom",
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var faAudioDescription = {
    prefix: "fas",
    iconName: "audio-description",
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var faAward = {
    prefix: "fas",
    iconName: "award",
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var faBaby = {
    prefix: "fas",
    iconName: "baby",
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var faBabyCarriage = {
    prefix: "fas",
    iconName: "baby-carriage",
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var faBackspace = {
    prefix: "fas",
    iconName: "backspace",
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var faBackward = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var faBacon = {
    prefix: "fas",
    iconName: "bacon",
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var faBacteria = {
    prefix: "fas",
    iconName: "bacteria",
    icon: [
        640,
        512,
        [],
        "e059",
        "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
    ]
};
var faBacterium = {
    prefix: "fas",
    iconName: "bacterium",
    icon: [
        512,
        512,
        [],
        "e05a",
        "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
    ]
};
var faBahai = {
    prefix: "fas",
    iconName: "bahai",
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var faBalanceScale = {
    prefix: "fas",
    iconName: "balance-scale",
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faBalanceScaleLeft = {
    prefix: "fas",
    iconName: "balance-scale-left",
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var faBalanceScaleRight = {
    prefix: "fas",
    iconName: "balance-scale-right",
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var faBan = {
    prefix: "fas",
    iconName: "ban",
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var faBandAid = {
    prefix: "fas",
    iconName: "band-aid",
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var faBarcode = {
    prefix: "fas",
    iconName: "barcode",
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var faBars = {
    prefix: "fas",
    iconName: "bars",
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var faBaseballBall = {
    prefix: "fas",
    iconName: "baseball-ball",
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var faBasketballBall = {
    prefix: "fas",
    iconName: "basketball-ball",
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var faBath = {
    prefix: "fas",
    iconName: "bath",
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var faBatteryEmpty = {
    prefix: "fas",
    iconName: "battery-empty",
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var faBatteryFull = {
    prefix: "fas",
    iconName: "battery-full",
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var faBatteryHalf = {
    prefix: "fas",
    iconName: "battery-half",
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var faBatteryQuarter = {
    prefix: "fas",
    iconName: "battery-quarter",
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var faBatteryThreeQuarters = {
    prefix: "fas",
    iconName: "battery-three-quarters",
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var faBed = {
    prefix: "fas",
    iconName: "bed",
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var faBeer = {
    prefix: "fas",
    iconName: "beer",
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var faBell = {
    prefix: "fas",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var faBellSlash = {
    prefix: "fas",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var faBezierCurve = {
    prefix: "fas",
    iconName: "bezier-curve",
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faBible = {
    prefix: "fas",
    iconName: "bible",
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var faBicycle = {
    prefix: "fas",
    iconName: "bicycle",
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var faBiking = {
    prefix: "fas",
    iconName: "biking",
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var faBinoculars = {
    prefix: "fas",
    iconName: "binoculars",
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var faBiohazard = {
    prefix: "fas",
    iconName: "biohazard",
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faBirthdayCake = {
    prefix: "fas",
    iconName: "birthday-cake",
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var faBlender = {
    prefix: "fas",
    iconName: "blender",
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var faBlenderPhone = {
    prefix: "fas",
    iconName: "blender-phone",
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBlind = {
    prefix: "fas",
    iconName: "blind",
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var faBlog = {
    prefix: "fas",
    iconName: "blog",
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var faBold = {
    prefix: "fas",
    iconName: "bold",
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var faBolt = {
    prefix: "fas",
    iconName: "bolt",
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var faBomb = {
    prefix: "fas",
    iconName: "bomb",
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var faBone = {
    prefix: "fas",
    iconName: "bone",
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var faBong = {
    prefix: "fas",
    iconName: "bong",
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var faBook = {
    prefix: "fas",
    iconName: "book",
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var faBookDead = {
    prefix: "fas",
    iconName: "book-dead",
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var faBookMedical = {
    prefix: "fas",
    iconName: "book-medical",
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var faBookOpen = {
    prefix: "fas",
    iconName: "book-open",
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var faBookReader = {
    prefix: "fas",
    iconName: "book-reader",
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var faBookmark = {
    prefix: "fas",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var faBorderAll = {
    prefix: "fas",
    iconName: "border-all",
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var faBorderNone = {
    prefix: "fas",
    iconName: "border-none",
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faBorderStyle = {
    prefix: "fas",
    iconName: "border-style",
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faBowlingBall = {
    prefix: "fas",
    iconName: "bowling-ball",
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faBox = {
    prefix: "fas",
    iconName: "box",
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var faBoxOpen = {
    prefix: "fas",
    iconName: "box-open",
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var faBoxTissue = {
    prefix: "fas",
    iconName: "box-tissue",
    icon: [
        512,
        512,
        [],
        "e05b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var faBoxes = {
    prefix: "fas",
    iconName: "boxes",
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var faBraille = {
    prefix: "fas",
    iconName: "braille",
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var faBrain = {
    prefix: "fas",
    iconName: "brain",
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var faBreadSlice = {
    prefix: "fas",
    iconName: "bread-slice",
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var faBriefcase = {
    prefix: "fas",
    iconName: "briefcase",
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var faBriefcaseMedical = {
    prefix: "fas",
    iconName: "briefcase-medical",
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var faBroadcastTower = {
    prefix: "fas",
    iconName: "broadcast-tower",
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var faBroom = {
    prefix: "fas",
    iconName: "broom",
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var faBrush = {
    prefix: "fas",
    iconName: "brush",
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var faBug = {
    prefix: "fas",
    iconName: "bug",
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var faBuilding = {
    prefix: "fas",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var faBullhorn = {
    prefix: "fas",
    iconName: "bullhorn",
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var faBullseye = {
    prefix: "fas",
    iconName: "bullseye",
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var faBurn = {
    prefix: "fas",
    iconName: "burn",
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var faBus = {
    prefix: "fas",
    iconName: "bus",
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBusAlt = {
    prefix: "fas",
    iconName: "bus-alt",
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBusinessTime = {
    prefix: "fas",
    iconName: "business-time",
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var faCalculator = {
    prefix: "fas",
    iconName: "calculator",
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var faCalendar = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var faCalendarAlt = {
    prefix: "fas",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCalendarCheck = {
    prefix: "fas",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var faCalendarDay = {
    prefix: "fas",
    iconName: "calendar-day",
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCalendarMinus = {
    prefix: "fas",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var faCalendarPlus = {
    prefix: "fas",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var faCalendarTimes = {
    prefix: "fas",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var faCalendarWeek = {
    prefix: "fas",
    iconName: "calendar-week",
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCamera = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var faCameraRetro = {
    prefix: "fas",
    iconName: "camera-retro",
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var faCampground = {
    prefix: "fas",
    iconName: "campground",
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var faCandyCane = {
    prefix: "fas",
    iconName: "candy-cane",
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var faCannabis = {
    prefix: "fas",
    iconName: "cannabis",
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var faCapsules = {
    prefix: "fas",
    iconName: "capsules",
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var faCar = {
    prefix: "fas",
    iconName: "car",
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var faCarAlt = {
    prefix: "fas",
    iconName: "car-alt",
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var faCarBattery = {
    prefix: "fas",
    iconName: "car-battery",
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var faCarCrash = {
    prefix: "fas",
    iconName: "car-crash",
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var faCarSide = {
    prefix: "fas",
    iconName: "car-side",
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var faCaravan = {
    prefix: "fas",
    iconName: "caravan",
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var faCaretDown = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var faCaretLeft = {
    prefix: "fas",
    iconName: "caret-left",
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var faCaretRight = {
    prefix: "fas",
    iconName: "caret-right",
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var faCaretSquareDown = {
    prefix: "fas",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var faCaretSquareLeft = {
    prefix: "fas",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var faCaretSquareRight = {
    prefix: "fas",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var faCaretSquareUp = {
    prefix: "fas",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var faCaretUp = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var faCarrot = {
    prefix: "fas",
    iconName: "carrot",
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var faCartArrowDown = {
    prefix: "fas",
    iconName: "cart-arrow-down",
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var faCartPlus = {
    prefix: "fas",
    iconName: "cart-plus",
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var faCashRegister = {
    prefix: "fas",
    iconName: "cash-register",
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var faCat = {
    prefix: "fas",
    iconName: "cat",
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faCertificate = {
    prefix: "fas",
    iconName: "certificate",
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var faChair = {
    prefix: "fas",
    iconName: "chair",
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var faChalkboard = {
    prefix: "fas",
    iconName: "chalkboard",
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faChalkboardTeacher = {
    prefix: "fas",
    iconName: "chalkboard-teacher",
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var faChargingStation = {
    prefix: "fas",
    iconName: "charging-station",
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var faChartArea = {
    prefix: "fas",
    iconName: "chart-area",
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var faChartBar = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faChartLine = {
    prefix: "fas",
    iconName: "chart-line",
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var faChartPie = {
    prefix: "fas",
    iconName: "chart-pie",
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var faCheck = {
    prefix: "fas",
    iconName: "check",
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var faCheckCircle = {
    prefix: "fas",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var faCheckDouble = {
    prefix: "fas",
    iconName: "check-double",
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var faCheckSquare = {
    prefix: "fas",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var faCheese = {
    prefix: "fas",
    iconName: "cheese",
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var faChess = {
    prefix: "fas",
    iconName: "chess",
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var faChessBishop = {
    prefix: "fas",
    iconName: "chess-bishop",
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessBoard = {
    prefix: "fas",
    iconName: "chess-board",
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var faChessKing = {
    prefix: "fas",
    iconName: "chess-king",
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var faChessKnight = {
    prefix: "fas",
    iconName: "chess-knight",
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessPawn = {
    prefix: "fas",
    iconName: "chess-pawn",
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessQueen = {
    prefix: "fas",
    iconName: "chess-queen",
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var faChessRook = {
    prefix: "fas",
    iconName: "chess-rook",
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChevronCircleDown = {
    prefix: "fas",
    iconName: "chevron-circle-down",
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var faChevronCircleLeft = {
    prefix: "fas",
    iconName: "chevron-circle-left",
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var faChevronCircleRight = {
    prefix: "fas",
    iconName: "chevron-circle-right",
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var faChevronCircleUp = {
    prefix: "fas",
    iconName: "chevron-circle-up",
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var faChevronDown = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var faChevronLeft = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var faChevronRight = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var faChevronUp = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var faChild = {
    prefix: "fas",
    iconName: "child",
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var faChurch = {
    prefix: "fas",
    iconName: "church",
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var faCircle = {
    prefix: "fas",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var faCircleNotch = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var faCity = {
    prefix: "fas",
    iconName: "city",
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var faClinicMedical = {
    prefix: "fas",
    iconName: "clinic-medical",
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var faClipboard = {
    prefix: "fas",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var faClipboardCheck = {
    prefix: "fas",
    iconName: "clipboard-check",
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var faClipboardList = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var faClock = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var faClone = {
    prefix: "fas",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var faClosedCaptioning = {
    prefix: "fas",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var faCloud = {
    prefix: "fas",
    iconName: "cloud",
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var faCloudDownloadAlt = {
    prefix: "fas",
    iconName: "cloud-download-alt",
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var faCloudMeatball = {
    prefix: "fas",
    iconName: "cloud-meatball",
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var faCloudMoon = {
    prefix: "fas",
    iconName: "cloud-moon",
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var faCloudMoonRain = {
    prefix: "fas",
    iconName: "cloud-moon-rain",
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var faCloudRain = {
    prefix: "fas",
    iconName: "cloud-rain",
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var faCloudShowersHeavy = {
    prefix: "fas",
    iconName: "cloud-showers-heavy",
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var faCloudSun = {
    prefix: "fas",
    iconName: "cloud-sun",
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var faCloudSunRain = {
    prefix: "fas",
    iconName: "cloud-sun-rain",
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var faCloudUploadAlt = {
    prefix: "fas",
    iconName: "cloud-upload-alt",
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var faCocktail = {
    prefix: "fas",
    iconName: "cocktail",
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var faCode = {
    prefix: "fas",
    iconName: "code",
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var faCodeBranch = {
    prefix: "fas",
    iconName: "code-branch",
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var faCoffee = {
    prefix: "fas",
    iconName: "coffee",
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var faCog = {
    prefix: "fas",
    iconName: "cog",
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faCogs = {
    prefix: "fas",
    iconName: "cogs",
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var faCoins = {
    prefix: "fas",
    iconName: "coins",
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var faColumns = {
    prefix: "fas",
    iconName: "columns",
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var faComment = {
    prefix: "fas",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var faCommentAlt = {
    prefix: "fas",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var faCommentDollar = {
    prefix: "fas",
    iconName: "comment-dollar",
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var faCommentDots = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faCommentMedical = {
    prefix: "fas",
    iconName: "comment-medical",
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var faCommentSlash = {
    prefix: "fas",
    iconName: "comment-slash",
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var faComments = {
    prefix: "fas",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var faCommentsDollar = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var faCompactDisc = {
    prefix: "fas",
    iconName: "compact-disc",
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faCompass = {
    prefix: "fas",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var faCompress = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var faCompressAlt = {
    prefix: "fas",
    iconName: "compress-alt",
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var faCompressArrowsAlt = {
    prefix: "fas",
    iconName: "compress-arrows-alt",
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var faConciergeBell = {
    prefix: "fas",
    iconName: "concierge-bell",
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faCookie = {
    prefix: "fas",
    iconName: "cookie",
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faCookieBite = {
    prefix: "fas",
    iconName: "cookie-bite",
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faCopy = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var faCopyright = {
    prefix: "fas",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var faCouch = {
    prefix: "fas",
    iconName: "couch",
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var faCreditCard = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var faCrop = {
    prefix: "fas",
    iconName: "crop",
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faCropAlt = {
    prefix: "fas",
    iconName: "crop-alt",
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var faCross = {
    prefix: "fas",
    iconName: "cross",
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faCrosshairs = {
    prefix: "fas",
    iconName: "crosshairs",
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var faCrow = {
    prefix: "fas",
    iconName: "crow",
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faCrown = {
    prefix: "fas",
    iconName: "crown",
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var faCrutch = {
    prefix: "fas",
    iconName: "crutch",
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var faCube = {
    prefix: "fas",
    iconName: "cube",
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var faCubes = {
    prefix: "fas",
    iconName: "cubes",
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var faCut = {
    prefix: "fas",
    iconName: "cut",
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var faDatabase = {
    prefix: "fas",
    iconName: "database",
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var faDeaf = {
    prefix: "fas",
    iconName: "deaf",
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var faDemocrat = {
    prefix: "fas",
    iconName: "democrat",
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var faDesktop = {
    prefix: "fas",
    iconName: "desktop",
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var faDharmachakra = {
    prefix: "fas",
    iconName: "dharmachakra",
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var faDiagnoses = {
    prefix: "fas",
    iconName: "diagnoses",
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDice = {
    prefix: "fas",
    iconName: "dice",
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faDiceD20 = {
    prefix: "fas",
    iconName: "dice-d20",
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var faDiceD6 = {
    prefix: "fas",
    iconName: "dice-d6",
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var faDiceFive = {
    prefix: "fas",
    iconName: "dice-five",
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceFour = {
    prefix: "fas",
    iconName: "dice-four",
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceOne = {
    prefix: "fas",
    iconName: "dice-one",
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceSix = {
    prefix: "fas",
    iconName: "dice-six",
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceThree = {
    prefix: "fas",
    iconName: "dice-three",
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceTwo = {
    prefix: "fas",
    iconName: "dice-two",
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDigitalTachograph = {
    prefix: "fas",
    iconName: "digital-tachograph",
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var faDirections = {
    prefix: "fas",
    iconName: "directions",
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var faDisease = {
    prefix: "fas",
    iconName: "disease",
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var faDivide = {
    prefix: "fas",
    iconName: "divide",
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faDizzy = {
    prefix: "fas",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var faDna = {
    prefix: "fas",
    iconName: "dna",
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var faDog = {
    prefix: "fas",
    iconName: "dog",
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var faDollarSign = {
    prefix: "fas",
    iconName: "dollar-sign",
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var faDolly = {
    prefix: "fas",
    iconName: "dolly",
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faDollyFlatbed = {
    prefix: "fas",
    iconName: "dolly-flatbed",
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDonate = {
    prefix: "fas",
    iconName: "donate",
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var faDoorClosed = {
    prefix: "fas",
    iconName: "door-closed",
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var faDoorOpen = {
    prefix: "fas",
    iconName: "door-open",
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var faDotCircle = {
    prefix: "fas",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var faDove = {
    prefix: "fas",
    iconName: "dove",
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faDownload = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var faDraftingCompass = {
    prefix: "fas",
    iconName: "drafting-compass",
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var faDragon = {
    prefix: "fas",
    iconName: "dragon",
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var faDrawPolygon = {
    prefix: "fas",
    iconName: "draw-polygon",
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var faDrum = {
    prefix: "fas",
    iconName: "drum",
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var faDrumSteelpan = {
    prefix: "fas",
    iconName: "drum-steelpan",
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var faDrumstickBite = {
    prefix: "fas",
    iconName: "drumstick-bite",
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var faDumbbell = {
    prefix: "fas",
    iconName: "dumbbell",
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var faDumpster = {
    prefix: "fas",
    iconName: "dumpster",
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDumpsterFire = {
    prefix: "fas",
    iconName: "dumpster-fire",
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var faDungeon = {
    prefix: "fas",
    iconName: "dungeon",
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var faEdit = {
    prefix: "fas",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var faEgg = {
    prefix: "fas",
    iconName: "egg",
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var faEject = {
    prefix: "fas",
    iconName: "eject",
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var faEllipsisH = {
    prefix: "fas",
    iconName: "ellipsis-h",
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var faEllipsisV = {
    prefix: "fas",
    iconName: "ellipsis-v",
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var faEnvelope = {
    prefix: "fas",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var faEnvelopeOpen = {
    prefix: "fas",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var faEnvelopeOpenText = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var faEnvelopeSquare = {
    prefix: "fas",
    iconName: "envelope-square",
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var faEquals = {
    prefix: "fas",
    iconName: "equals",
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faEraser = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var faEthernet = {
    prefix: "fas",
    iconName: "ethernet",
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var faEuroSign = {
    prefix: "fas",
    iconName: "euro-sign",
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var faExchangeAlt = {
    prefix: "fas",
    iconName: "exchange-alt",
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var faExclamation = {
    prefix: "fas",
    iconName: "exclamation",
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var faExclamationCircle = {
    prefix: "fas",
    iconName: "exclamation-circle",
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var faExclamationTriangle = {
    prefix: "fas",
    iconName: "exclamation-triangle",
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var faExpand = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var faExpandAlt = {
    prefix: "fas",
    iconName: "expand-alt",
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var faExpandArrowsAlt = {
    prefix: "fas",
    iconName: "expand-arrows-alt",
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var faExternalLinkAlt = {
    prefix: "fas",
    iconName: "external-link-alt",
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var faExternalLinkSquareAlt = {
    prefix: "fas",
    iconName: "external-link-square-alt",
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var faEye = {
    prefix: "fas",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var faEyeDropper = {
    prefix: "fas",
    iconName: "eye-dropper",
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var faEyeSlash = {
    prefix: "fas",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var faFan = {
    prefix: "fas",
    iconName: "fan",
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var faFastBackward = {
    prefix: "fas",
    iconName: "fast-backward",
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var faFastForward = {
    prefix: "fas",
    iconName: "fast-forward",
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var faFaucet = {
    prefix: "fas",
    iconName: "faucet",
    icon: [
        512,
        512,
        [],
        "e005",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var faFax = {
    prefix: "fas",
    iconName: "fax",
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var faFeather = {
    prefix: "fas",
    iconName: "feather",
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var faFeatherAlt = {
    prefix: "fas",
    iconName: "feather-alt",
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var faFemale = {
    prefix: "fas",
    iconName: "female",
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var faFighterJet = {
    prefix: "fas",
    iconName: "fighter-jet",
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var faFile = {
    prefix: "fas",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileAlt = {
    prefix: "fas",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileArchive = {
    prefix: "fas",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var faFileAudio = {
    prefix: "fas",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileCode = {
    prefix: "fas",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var faFileContract = {
    prefix: "fas",
    iconName: "file-contract",
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileCsv = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileDownload = {
    prefix: "fas",
    iconName: "file-download",
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileExcel = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileExport = {
    prefix: "fas",
    iconName: "file-export",
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var faFileImage = {
    prefix: "fas",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var faFileImport = {
    prefix: "fas",
    iconName: "file-import",
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var faFileInvoice = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var faFileInvoiceDollar = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var faFileMedical = {
    prefix: "fas",
    iconName: "file-medical",
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var faFileMedicalAlt = {
    prefix: "fas",
    iconName: "file-medical-alt",
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFilePdf = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var faFilePowerpoint = {
    prefix: "fas",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var faFilePrescription = {
    prefix: "fas",
    iconName: "file-prescription",
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileSignature = {
    prefix: "fas",
    iconName: "file-signature",
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var faFileUpload = {
    prefix: "fas",
    iconName: "file-upload",
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileVideo = {
    prefix: "fas",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var faFileWord = {
    prefix: "fas",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFill = {
    prefix: "fas",
    iconName: "fill",
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var faFillDrip = {
    prefix: "fas",
    iconName: "fill-drip",
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var faFilm = {
    prefix: "fas",
    iconName: "film",
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var faFilter = {
    prefix: "fas",
    iconName: "filter",
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var faFingerprint = {
    prefix: "fas",
    iconName: "fingerprint",
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var faFire = {
    prefix: "fas",
    iconName: "fire",
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var faFireAlt = {
    prefix: "fas",
    iconName: "fire-alt",
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var faFireExtinguisher = {
    prefix: "fas",
    iconName: "fire-extinguisher",
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var faFirstAid = {
    prefix: "fas",
    iconName: "first-aid",
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faFish = {
    prefix: "fas",
    iconName: "fish",
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var faFistRaised = {
    prefix: "fas",
    iconName: "fist-raised",
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var faFlag = {
    prefix: "fas",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var faFlagCheckered = {
    prefix: "fas",
    iconName: "flag-checkered",
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var faFlagUsa = {
    prefix: "fas",
    iconName: "flag-usa",
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var faFlask = {
    prefix: "fas",
    iconName: "flask",
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var faFlushed = {
    prefix: "fas",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var faFolder = {
    prefix: "fas",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var faFolderMinus = {
    prefix: "fas",
    iconName: "folder-minus",
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var faFolderOpen = {
    prefix: "fas",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var faFolderPlus = {
    prefix: "fas",
    iconName: "folder-plus",
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var faFont = {
    prefix: "fas",
    iconName: "font",
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var faFontAwesomeLogoFull = {
    prefix: "fas",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var faFootballBall = {
    prefix: "fas",
    iconName: "football-ball",
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var faForward = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var faFrog = {
    prefix: "fas",
    iconName: "frog",
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var faFrown = {
    prefix: "fas",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var faFrownOpen = {
    prefix: "fas",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faFunnelDollar = {
    prefix: "fas",
    iconName: "funnel-dollar",
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var faFutbol = {
    prefix: "fas",
    iconName: "futbol",
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var faGamepad = {
    prefix: "fas",
    iconName: "gamepad",
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var faGasPump = {
    prefix: "fas",
    iconName: "gas-pump",
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var faGavel = {
    prefix: "fas",
    iconName: "gavel",
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var faGem = {
    prefix: "fas",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var faGenderless = {
    prefix: "fas",
    iconName: "genderless",
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var faGhost = {
    prefix: "fas",
    iconName: "ghost",
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faGift = {
    prefix: "fas",
    iconName: "gift",
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var faGifts = {
    prefix: "fas",
    iconName: "gifts",
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var faGlassCheers = {
    prefix: "fas",
    iconName: "glass-cheers",
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var faGlassMartini = {
    prefix: "fas",
    iconName: "glass-martini",
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var faGlassMartiniAlt = {
    prefix: "fas",
    iconName: "glass-martini-alt",
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var faGlassWhiskey = {
    prefix: "fas",
    iconName: "glass-whiskey",
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var faGlasses = {
    prefix: "fas",
    iconName: "glasses",
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var faGlobe = {
    prefix: "fas",
    iconName: "globe",
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var faGlobeAfrica = {
    prefix: "fas",
    iconName: "globe-africa",
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var faGlobeAmericas = {
    prefix: "fas",
    iconName: "globe-americas",
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var faGlobeAsia = {
    prefix: "fas",
    iconName: "globe-asia",
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var faGlobeEurope = {
    prefix: "fas",
    iconName: "globe-europe",
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var faGolfBall = {
    prefix: "fas",
    iconName: "golf-ball",
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var faGopuram = {
    prefix: "fas",
    iconName: "gopuram",
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var faGraduationCap = {
    prefix: "fas",
    iconName: "graduation-cap",
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var faGreaterThan = {
    prefix: "fas",
    iconName: "greater-than",
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var faGreaterThanEqual = {
    prefix: "fas",
    iconName: "greater-than-equal",
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faGrimace = {
    prefix: "fas",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var faGrin = {
    prefix: "fas",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinAlt = {
    prefix: "fas",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinBeam = {
    prefix: "fas",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinBeamSweat = {
    prefix: "fas",
    iconName: "grin-beam-sweat",
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinHearts = {
    prefix: "fas",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var faGrinSquint = {
    prefix: "fas",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinSquintTears = {
    prefix: "fas",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var faGrinStars = {
    prefix: "fas",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var faGrinTears = {
    prefix: "fas",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinTongue = {
    prefix: "fas",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var faGrinTongueSquint = {
    prefix: "fas",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var faGrinTongueWink = {
    prefix: "fas",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var faGrinWink = {
    prefix: "fas",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var faGripHorizontal = {
    prefix: "fas",
    iconName: "grip-horizontal",
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faGripLines = {
    prefix: "fas",
    iconName: "grip-lines",
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faGripLinesVertical = {
    prefix: "fas",
    iconName: "grip-lines-vertical",
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var faGripVertical = {
    prefix: "fas",
    iconName: "grip-vertical",
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faGuitar = {
    prefix: "fas",
    iconName: "guitar",
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var faHSquare = {
    prefix: "fas",
    iconName: "h-square",
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var faHamburger = {
    prefix: "fas",
    iconName: "hamburger",
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var faHammer = {
    prefix: "fas",
    iconName: "hammer",
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var faHamsa = {
    prefix: "fas",
    iconName: "hamsa",
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var faHandHolding = {
    prefix: "fas",
    iconName: "hand-holding",
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandHoldingHeart = {
    prefix: "fas",
    iconName: "hand-holding-heart",
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandHoldingMedical = {
    prefix: "fas",
    iconName: "hand-holding-medical",
    icon: [
        576,
        512,
        [],
        "e05c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var faHandHoldingUsd = {
    prefix: "fas",
    iconName: "hand-holding-usd",
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var faHandHoldingWater = {
    prefix: "fas",
    iconName: "hand-holding-water",
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandLizard = {
    prefix: "fas",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var faHandMiddleFinger = {
    prefix: "fas",
    iconName: "hand-middle-finger",
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var faHandPaper = {
    prefix: "fas",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var faHandPeace = {
    prefix: "fas",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var faHandPointDown = {
    prefix: "fas",
    iconName: "hand-point-down",
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var faHandPointLeft = {
    prefix: "fas",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var faHandPointRight = {
    prefix: "fas",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var faHandPointUp = {
    prefix: "fas",
    iconName: "hand-point-up",
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var faHandPointer = {
    prefix: "fas",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var faHandRock = {
    prefix: "fas",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var faHandScissors = {
    prefix: "fas",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var faHandSparkles = {
    prefix: "fas",
    iconName: "hand-sparkles",
    icon: [
        640,
        512,
        [],
        "e05d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var faHandSpock = {
    prefix: "fas",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var faHands = {
    prefix: "fas",
    iconName: "hands",
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var faHandsHelping = {
    prefix: "fas",
    iconName: "hands-helping",
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var faHandsWash = {
    prefix: "fas",
    iconName: "hands-wash",
    icon: [
        576,
        512,
        [],
        "e05e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var faHandshake = {
    prefix: "fas",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var faHandshakeAltSlash = {
    prefix: "fas",
    iconName: "handshake-alt-slash",
    icon: [
        640,
        512,
        [],
        "e05f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var faHandshakeSlash = {
    prefix: "fas",
    iconName: "handshake-slash",
    icon: [
        640,
        512,
        [],
        "e060",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var faHanukiah = {
    prefix: "fas",
    iconName: "hanukiah",
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var faHardHat = {
    prefix: "fas",
    iconName: "hard-hat",
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faHashtag = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var faHatCowboy = {
    prefix: "fas",
    iconName: "hat-cowboy",
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var faHatCowboySide = {
    prefix: "fas",
    iconName: "hat-cowboy-side",
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var faHatWizard = {
    prefix: "fas",
    iconName: "hat-wizard",
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var faHdd = {
    prefix: "fas",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var faHeadSideCough = {
    prefix: "fas",
    iconName: "head-side-cough",
    icon: [
        640,
        512,
        [],
        "e061",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var faHeadSideCoughSlash = {
    prefix: "fas",
    iconName: "head-side-cough-slash",
    icon: [
        640,
        512,
        [],
        "e062",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var faHeadSideMask = {
    prefix: "fas",
    iconName: "head-side-mask",
    icon: [
        512,
        512,
        [],
        "e063",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var faHeadSideVirus = {
    prefix: "fas",
    iconName: "head-side-virus",
    icon: [
        512,
        512,
        [],
        "e064",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var faHeading = {
    prefix: "fas",
    iconName: "heading",
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var faHeadphones = {
    prefix: "fas",
    iconName: "headphones",
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var faHeadphonesAlt = {
    prefix: "fas",
    iconName: "headphones-alt",
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var faHeadset = {
    prefix: "fas",
    iconName: "headset",
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var faHeart = {
    prefix: "fas",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var faHeartBroken = {
    prefix: "fas",
    iconName: "heart-broken",
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var faHeartbeat = {
    prefix: "fas",
    iconName: "heartbeat",
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var faHelicopter = {
    prefix: "fas",
    iconName: "helicopter",
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var faHighlighter = {
    prefix: "fas",
    iconName: "highlighter",
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var faHiking = {
    prefix: "fas",
    iconName: "hiking",
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var faHippo = {
    prefix: "fas",
    iconName: "hippo",
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faHistory = {
    prefix: "fas",
    iconName: "history",
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var faHockeyPuck = {
    prefix: "fas",
    iconName: "hockey-puck",
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var faHollyBerry = {
    prefix: "fas",
    iconName: "holly-berry",
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var faHome = {
    prefix: "fas",
    iconName: "home",
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var faHorse = {
    prefix: "fas",
    iconName: "horse",
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faHorseHead = {
    prefix: "fas",
    iconName: "horse-head",
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var faHospital = {
    prefix: "fas",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var faHospitalAlt = {
    prefix: "fas",
    iconName: "hospital-alt",
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var faHospitalSymbol = {
    prefix: "fas",
    iconName: "hospital-symbol",
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var faHospitalUser = {
    prefix: "fas",
    iconName: "hospital-user",
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var faHotTub = {
    prefix: "fas",
    iconName: "hot-tub",
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var faHotdog = {
    prefix: "fas",
    iconName: "hotdog",
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var faHotel = {
    prefix: "fas",
    iconName: "hotel",
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var faHourglass = {
    prefix: "fas",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var faHourglassEnd = {
    prefix: "fas",
    iconName: "hourglass-end",
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var faHourglassHalf = {
    prefix: "fas",
    iconName: "hourglass-half",
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var faHourglassStart = {
    prefix: "fas",
    iconName: "hourglass-start",
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var faHouseDamage = {
    prefix: "fas",
    iconName: "house-damage",
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var faHouseUser = {
    prefix: "fas",
    iconName: "house-user",
    icon: [
        576,
        512,
        [],
        "e065",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var faHryvnia = {
    prefix: "fas",
    iconName: "hryvnia",
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var faICursor = {
    prefix: "fas",
    iconName: "i-cursor",
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var faIceCream = {
    prefix: "fas",
    iconName: "ice-cream",
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var faIcicles = {
    prefix: "fas",
    iconName: "icicles",
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var faIcons = {
    prefix: "fas",
    iconName: "icons",
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var faIdBadge = {
    prefix: "fas",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faIdCard = {
    prefix: "fas",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var faIdCardAlt = {
    prefix: "fas",
    iconName: "id-card-alt",
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var faIgloo = {
    prefix: "fas",
    iconName: "igloo",
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var faImage = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var faImages = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var faInbox = {
    prefix: "fas",
    iconName: "inbox",
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var faIndent = {
    prefix: "fas",
    iconName: "indent",
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faIndustry = {
    prefix: "fas",
    iconName: "industry",
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var faInfinity = {
    prefix: "fas",
    iconName: "infinity",
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var faInfo = {
    prefix: "fas",
    iconName: "info",
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var faInfoCircle = {
    prefix: "fas",
    iconName: "info-circle",
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var faItalic = {
    prefix: "fas",
    iconName: "italic",
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var faJedi = {
    prefix: "fas",
    iconName: "jedi",
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var faJoint = {
    prefix: "fas",
    iconName: "joint",
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var faJournalWhills = {
    prefix: "fas",
    iconName: "journal-whills",
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var faKaaba = {
    prefix: "fas",
    iconName: "kaaba",
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var faKey = {
    prefix: "fas",
    iconName: "key",
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var faKeyboard = {
    prefix: "fas",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var faKhanda = {
    prefix: "fas",
    iconName: "khanda",
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var faKiss = {
    prefix: "fas",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faKissBeam = {
    prefix: "fas",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var faKissWinkHeart = {
    prefix: "fas",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var faKiwiBird = {
    prefix: "fas",
    iconName: "kiwi-bird",
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var faLandmark = {
    prefix: "fas",
    iconName: "landmark",
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faLanguage = {
    prefix: "fas",
    iconName: "language",
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var faLaptop = {
    prefix: "fas",
    iconName: "laptop",
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var faLaptopCode = {
    prefix: "fas",
    iconName: "laptop-code",
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var faLaptopHouse = {
    prefix: "fas",
    iconName: "laptop-house",
    icon: [
        640,
        512,
        [],
        "e066",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var faLaptopMedical = {
    prefix: "fas",
    iconName: "laptop-medical",
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var faLaugh = {
    prefix: "fas",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var faLaughBeam = {
    prefix: "fas",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLaughSquint = {
    prefix: "fas",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLaughWink = {
    prefix: "fas",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLayerGroup = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var faLeaf = {
    prefix: "fas",
    iconName: "leaf",
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var faLemon = {
    prefix: "fas",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var faLessThan = {
    prefix: "fas",
    iconName: "less-than",
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var faLessThanEqual = {
    prefix: "fas",
    iconName: "less-than-equal",
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faLevelDownAlt = {
    prefix: "fas",
    iconName: "level-down-alt",
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var faLevelUpAlt = {
    prefix: "fas",
    iconName: "level-up-alt",
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var faLifeRing = {
    prefix: "fas",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var faLightbulb = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var faLink = {
    prefix: "fas",
    iconName: "link",
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var faLiraSign = {
    prefix: "fas",
    iconName: "lira-sign",
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var faList = {
    prefix: "fas",
    iconName: "list",
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faListAlt = {
    prefix: "fas",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var faListOl = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var faListUl = {
    prefix: "fas",
    iconName: "list-ul",
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faLocationArrow = {
    prefix: "fas",
    iconName: "location-arrow",
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var faLock = {
    prefix: "fas",
    iconName: "lock",
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var faLockOpen = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var faLongArrowAltDown = {
    prefix: "fas",
    iconName: "long-arrow-alt-down",
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var faLongArrowAltLeft = {
    prefix: "fas",
    iconName: "long-arrow-alt-left",
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var faLongArrowAltRight = {
    prefix: "fas",
    iconName: "long-arrow-alt-right",
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var faLongArrowAltUp = {
    prefix: "fas",
    iconName: "long-arrow-alt-up",
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var faLowVision = {
    prefix: "fas",
    iconName: "low-vision",
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var faLuggageCart = {
    prefix: "fas",
    iconName: "luggage-cart",
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var faLungs = {
    prefix: "fas",
    iconName: "lungs",
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var faLungsVirus = {
    prefix: "fas",
    iconName: "lungs-virus",
    icon: [
        640,
        512,
        [],
        "e067",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var faMagic = {
    prefix: "fas",
    iconName: "magic",
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var faMagnet = {
    prefix: "fas",
    iconName: "magnet",
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var faMailBulk = {
    prefix: "fas",
    iconName: "mail-bulk",
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var faMale = {
    prefix: "fas",
    iconName: "male",
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var faMap = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarked = {
    prefix: "fas",
    iconName: "map-marked",
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarkedAlt = {
    prefix: "fas",
    iconName: "map-marked-alt",
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarker = {
    prefix: "fas",
    iconName: "map-marker",
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var faMapMarkerAlt = {
    prefix: "fas",
    iconName: "map-marker-alt",
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var faMapPin = {
    prefix: "fas",
    iconName: "map-pin",
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var faMapSigns = {
    prefix: "fas",
    iconName: "map-signs",
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var faMarker = {
    prefix: "fas",
    iconName: "marker",
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var faMars = {
    prefix: "fas",
    iconName: "mars",
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faMarsDouble = {
    prefix: "fas",
    iconName: "mars-double",
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var faMarsStroke = {
    prefix: "fas",
    iconName: "mars-stroke",
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faMarsStrokeH = {
    prefix: "fas",
    iconName: "mars-stroke-h",
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var faMarsStrokeV = {
    prefix: "fas",
    iconName: "mars-stroke-v",
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var faMask = {
    prefix: "fas",
    iconName: "mask",
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var faMedal = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var faMedkit = {
    prefix: "fas",
    iconName: "medkit",
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var faMeh = {
    prefix: "fas",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMehBlank = {
    prefix: "fas",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMehRollingEyes = {
    prefix: "fas",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var faMemory = {
    prefix: "fas",
    iconName: "memory",
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var faMenorah = {
    prefix: "fas",
    iconName: "menorah",
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var faMercury = {
    prefix: "fas",
    iconName: "mercury",
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var faMeteor = {
    prefix: "fas",
    iconName: "meteor",
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var faMicrochip = {
    prefix: "fas",
    iconName: "microchip",
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var faMicrophone = {
    prefix: "fas",
    iconName: "microphone",
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var faMicrophoneAlt = {
    prefix: "fas",
    iconName: "microphone-alt",
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var faMicrophoneAltSlash = {
    prefix: "fas",
    iconName: "microphone-alt-slash",
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var faMicrophoneSlash = {
    prefix: "fas",
    iconName: "microphone-slash",
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var faMicroscope = {
    prefix: "fas",
    iconName: "microscope",
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var faMinus = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faMinusCircle = {
    prefix: "fas",
    iconName: "minus-circle",
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var faMinusSquare = {
    prefix: "fas",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var faMitten = {
    prefix: "fas",
    iconName: "mitten",
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var faMobile = {
    prefix: "fas",
    iconName: "mobile",
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMobileAlt = {
    prefix: "fas",
    iconName: "mobile-alt",
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var faMoneyBill = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var faMoneyBillAlt = {
    prefix: "fas",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var faMoneyBillWave = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var faMoneyBillWaveAlt = {
    prefix: "fas",
    iconName: "money-bill-wave-alt",
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var faMoneyCheck = {
    prefix: "fas",
    iconName: "money-check",
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var faMoneyCheckAlt = {
    prefix: "fas",
    iconName: "money-check-alt",
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var faMonument = {
    prefix: "fas",
    iconName: "monument",
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var faMoon = {
    prefix: "fas",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var faMortarPestle = {
    prefix: "fas",
    iconName: "mortar-pestle",
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faMosque = {
    prefix: "fas",
    iconName: "mosque",
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var faMotorcycle = {
    prefix: "fas",
    iconName: "motorcycle",
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var faMountain = {
    prefix: "fas",
    iconName: "mountain",
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var faMouse = {
    prefix: "fas",
    iconName: "mouse",
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var faMousePointer = {
    prefix: "fas",
    iconName: "mouse-pointer",
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var faMugHot = {
    prefix: "fas",
    iconName: "mug-hot",
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var faMusic = {
    prefix: "fas",
    iconName: "music",
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var faNetworkWired = {
    prefix: "fas",
    iconName: "network-wired",
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var faNeuter = {
    prefix: "fas",
    iconName: "neuter",
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faNewspaper = {
    prefix: "fas",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var faNotEqual = {
    prefix: "fas",
    iconName: "not-equal",
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var faNotesMedical = {
    prefix: "fas",
    iconName: "notes-medical",
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var faObjectGroup = {
    prefix: "fas",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var faObjectUngroup = {
    prefix: "fas",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var faOilCan = {
    prefix: "fas",
    iconName: "oil-can",
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var faOm = {
    prefix: "fas",
    iconName: "om",
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var faOtter = {
    prefix: "fas",
    iconName: "otter",
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var faOutdent = {
    prefix: "fas",
    iconName: "outdent",
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faPager = {
    prefix: "fas",
    iconName: "pager",
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var faPaintBrush = {
    prefix: "fas",
    iconName: "paint-brush",
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var faPaintRoller = {
    prefix: "fas",
    iconName: "paint-roller",
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var faPalette = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faPallet = {
    prefix: "fas",
    iconName: "pallet",
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var faPaperPlane = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var faPaperclip = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var faParachuteBox = {
    prefix: "fas",
    iconName: "parachute-box",
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var faParagraph = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var faParking = {
    prefix: "fas",
    iconName: "parking",
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var faPassport = {
    prefix: "fas",
    iconName: "passport",
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var faPastafarianism = {
    prefix: "fas",
    iconName: "pastafarianism",
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var faPaste = {
    prefix: "fas",
    iconName: "paste",
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var faPause = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var faPauseCircle = {
    prefix: "fas",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var faPaw = {
    prefix: "fas",
    iconName: "paw",
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var faPeace = {
    prefix: "fas",
    iconName: "peace",
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var faPen = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var faPenAlt = {
    prefix: "fas",
    iconName: "pen-alt",
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var faPenFancy = {
    prefix: "fas",
    iconName: "pen-fancy",
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var faPenNib = {
    prefix: "fas",
    iconName: "pen-nib",
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var faPenSquare = {
    prefix: "fas",
    iconName: "pen-square",
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var faPencilAlt = {
    prefix: "fas",
    iconName: "pencil-alt",
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var faPencilRuler = {
    prefix: "fas",
    iconName: "pencil-ruler",
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var faPeopleArrows = {
    prefix: "fas",
    iconName: "people-arrows",
    icon: [
        576,
        512,
        [],
        "e068",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var faPeopleCarry = {
    prefix: "fas",
    iconName: "people-carry",
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var faPepperHot = {
    prefix: "fas",
    iconName: "pepper-hot",
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var faPercent = {
    prefix: "fas",
    iconName: "percent",
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var faPercentage = {
    prefix: "fas",
    iconName: "percentage",
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var faPersonBooth = {
    prefix: "fas",
    iconName: "person-booth",
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var faPhone = {
    prefix: "fas",
    iconName: "phone",
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var faPhoneAlt = {
    prefix: "fas",
    iconName: "phone-alt",
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var faPhoneSlash = {
    prefix: "fas",
    iconName: "phone-slash",
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var faPhoneSquare = {
    prefix: "fas",
    iconName: "phone-square",
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var faPhoneSquareAlt = {
    prefix: "fas",
    iconName: "phone-square-alt",
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var faPhoneVolume = {
    prefix: "fas",
    iconName: "phone-volume",
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var faPhotoVideo = {
    prefix: "fas",
    iconName: "photo-video",
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var faPiggyBank = {
    prefix: "fas",
    iconName: "piggy-bank",
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var faPills = {
    prefix: "fas",
    iconName: "pills",
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var faPizzaSlice = {
    prefix: "fas",
    iconName: "pizza-slice",
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var faPlaceOfWorship = {
    prefix: "fas",
    iconName: "place-of-worship",
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var faPlane = {
    prefix: "fas",
    iconName: "plane",
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var faPlaneArrival = {
    prefix: "fas",
    iconName: "plane-arrival",
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var faPlaneDeparture = {
    prefix: "fas",
    iconName: "plane-departure",
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var faPlaneSlash = {
    prefix: "fas",
    iconName: "plane-slash",
    icon: [
        640,
        512,
        [],
        "e069",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var faPlay = {
    prefix: "fas",
    iconName: "play",
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var faPlayCircle = {
    prefix: "fas",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var faPlug = {
    prefix: "fas",
    iconName: "plug",
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var faPlus = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faPlusCircle = {
    prefix: "fas",
    iconName: "plus-circle",
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var faPlusSquare = {
    prefix: "fas",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var faPodcast = {
    prefix: "fas",
    iconName: "podcast",
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var faPoll = {
    prefix: "fas",
    iconName: "poll",
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var faPollH = {
    prefix: "fas",
    iconName: "poll-h",
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var faPoo = {
    prefix: "fas",
    iconName: "poo",
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faPooStorm = {
    prefix: "fas",
    iconName: "poo-storm",
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var faPoop = {
    prefix: "fas",
    iconName: "poop",
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var faPortrait = {
    prefix: "fas",
    iconName: "portrait",
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faPoundSign = {
    prefix: "fas",
    iconName: "pound-sign",
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var faPowerOff = {
    prefix: "fas",
    iconName: "power-off",
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var faPray = {
    prefix: "fas",
    iconName: "pray",
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var faPrayingHands = {
    prefix: "fas",
    iconName: "praying-hands",
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var faPrescription = {
    prefix: "fas",
    iconName: "prescription",
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var faPrescriptionBottle = {
    prefix: "fas",
    iconName: "prescription-bottle",
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var faPrescriptionBottleAlt = {
    prefix: "fas",
    iconName: "prescription-bottle-alt",
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var faPrint = {
    prefix: "fas",
    iconName: "print",
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faProcedures = {
    prefix: "fas",
    iconName: "procedures",
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var faProjectDiagram = {
    prefix: "fas",
    iconName: "project-diagram",
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var faPumpMedical = {
    prefix: "fas",
    iconName: "pump-medical",
    icon: [
        384,
        512,
        [],
        "e06a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var faPumpSoap = {
    prefix: "fas",
    iconName: "pump-soap",
    icon: [
        384,
        512,
        [],
        "e06b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var faPuzzlePiece = {
    prefix: "fas",
    iconName: "puzzle-piece",
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var faQrcode = {
    prefix: "fas",
    iconName: "qrcode",
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var faQuestion = {
    prefix: "fas",
    iconName: "question",
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var faQuestionCircle = {
    prefix: "fas",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var faQuidditch = {
    prefix: "fas",
    iconName: "quidditch",
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var faQuoteLeft = {
    prefix: "fas",
    iconName: "quote-left",
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var faQuoteRight = {
    prefix: "fas",
    iconName: "quote-right",
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var faQuran = {
    prefix: "fas",
    iconName: "quran",
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var faRadiation = {
    prefix: "fas",
    iconName: "radiation",
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var faRadiationAlt = {
    prefix: "fas",
    iconName: "radiation-alt",
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var faRainbow = {
    prefix: "fas",
    iconName: "rainbow",
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var faRandom = {
    prefix: "fas",
    iconName: "random",
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var faReceipt = {
    prefix: "fas",
    iconName: "receipt",
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var faRecordVinyl = {
    prefix: "fas",
    iconName: "record-vinyl",
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var faRecycle = {
    prefix: "fas",
    iconName: "recycle",
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var faRedo = {
    prefix: "fas",
    iconName: "redo",
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var faRedoAlt = {
    prefix: "fas",
    iconName: "redo-alt",
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var faRegistered = {
    prefix: "fas",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var faRemoveFormat = {
    prefix: "fas",
    iconName: "remove-format",
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var faReply = {
    prefix: "fas",
    iconName: "reply",
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var faReplyAll = {
    prefix: "fas",
    iconName: "reply-all",
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var faRepublican = {
    prefix: "fas",
    iconName: "republican",
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var faRestroom = {
    prefix: "fas",
    iconName: "restroom",
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var faRetweet = {
    prefix: "fas",
    iconName: "retweet",
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var faRibbon = {
    prefix: "fas",
    iconName: "ribbon",
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var faRing = {
    prefix: "fas",
    iconName: "ring",
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var faRoad = {
    prefix: "fas",
    iconName: "road",
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var faRobot = {
    prefix: "fas",
    iconName: "robot",
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var faRocket = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var faRoute = {
    prefix: "fas",
    iconName: "route",
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faRss = {
    prefix: "fas",
    iconName: "rss",
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var faRssSquare = {
    prefix: "fas",
    iconName: "rss-square",
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var faRubleSign = {
    prefix: "fas",
    iconName: "ruble-sign",
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var faRuler = {
    prefix: "fas",
    iconName: "ruler",
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var faRulerCombined = {
    prefix: "fas",
    iconName: "ruler-combined",
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faRulerHorizontal = {
    prefix: "fas",
    iconName: "ruler-horizontal",
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var faRulerVertical = {
    prefix: "fas",
    iconName: "ruler-vertical",
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var faRunning = {
    prefix: "fas",
    iconName: "running",
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var faRupeeSign = {
    prefix: "fas",
    iconName: "rupee-sign",
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var faSadCry = {
    prefix: "fas",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var faSadTear = {
    prefix: "fas",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var faSatellite = {
    prefix: "fas",
    iconName: "satellite",
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var faSatelliteDish = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var faSave = {
    prefix: "fas",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var faSchool = {
    prefix: "fas",
    iconName: "school",
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var faScrewdriver = {
    prefix: "fas",
    iconName: "screwdriver",
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var faScroll = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var faSdCard = {
    prefix: "fas",
    iconName: "sd-card",
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var faSearch = {
    prefix: "fas",
    iconName: "search",
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var faSearchDollar = {
    prefix: "fas",
    iconName: "search-dollar",
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var faSearchLocation = {
    prefix: "fas",
    iconName: "search-location",
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faSearchMinus = {
    prefix: "fas",
    iconName: "search-minus",
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var faSearchPlus = {
    prefix: "fas",
    iconName: "search-plus",
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var faSeedling = {
    prefix: "fas",
    iconName: "seedling",
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var faServer = {
    prefix: "fas",
    iconName: "server",
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var faShapes = {
    prefix: "fas",
    iconName: "shapes",
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var faShare = {
    prefix: "fas",
    iconName: "share",
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var faShareAlt = {
    prefix: "fas",
    iconName: "share-alt",
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var faShareAltSquare = {
    prefix: "fas",
    iconName: "share-alt-square",
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var faShareSquare = {
    prefix: "fas",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var faShekelSign = {
    prefix: "fas",
    iconName: "shekel-sign",
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var faShieldAlt = {
    prefix: "fas",
    iconName: "shield-alt",
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var faShieldVirus = {
    prefix: "fas",
    iconName: "shield-virus",
    icon: [
        512,
        512,
        [],
        "e06c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var faShip = {
    prefix: "fas",
    iconName: "ship",
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var faShippingFast = {
    prefix: "fas",
    iconName: "shipping-fast",
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faShoePrints = {
    prefix: "fas",
    iconName: "shoe-prints",
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var faShoppingBag = {
    prefix: "fas",
    iconName: "shopping-bag",
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var faShoppingBasket = {
    prefix: "fas",
    iconName: "shopping-basket",
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var faShoppingCart = {
    prefix: "fas",
    iconName: "shopping-cart",
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var faShower = {
    prefix: "fas",
    iconName: "shower",
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var faShuttleVan = {
    prefix: "fas",
    iconName: "shuttle-van",
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var faSign = {
    prefix: "fas",
    iconName: "sign",
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var faSignInAlt = {
    prefix: "fas",
    iconName: "sign-in-alt",
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var faSignLanguage = {
    prefix: "fas",
    iconName: "sign-language",
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var faSignOutAlt = {
    prefix: "fas",
    iconName: "sign-out-alt",
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var faSignal = {
    prefix: "fas",
    iconName: "signal",
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var faSignature = {
    prefix: "fas",
    iconName: "signature",
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var faSimCard = {
    prefix: "fas",
    iconName: "sim-card",
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var faSink = {
    prefix: "fas",
    iconName: "sink",
    icon: [
        512,
        512,
        [],
        "e06d",
        "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
    ]
};
var faSitemap = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faSkating = {
    prefix: "fas",
    iconName: "skating",
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var faSkiing = {
    prefix: "fas",
    iconName: "skiing",
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var faSkiingNordic = {
    prefix: "fas",
    iconName: "skiing-nordic",
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var faSkull = {
    prefix: "fas",
    iconName: "skull",
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var faSkullCrossbones = {
    prefix: "fas",
    iconName: "skull-crossbones",
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var faSlash = {
    prefix: "fas",
    iconName: "slash",
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var faSleigh = {
    prefix: "fas",
    iconName: "sleigh",
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var faSlidersH = {
    prefix: "fas",
    iconName: "sliders-h",
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var faSmile = {
    prefix: "fas",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var faSmileBeam = {
    prefix: "fas",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var faSmileWink = {
    prefix: "fas",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var faSmog = {
    prefix: "fas",
    iconName: "smog",
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var faSmoking = {
    prefix: "fas",
    iconName: "smoking",
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var faSmokingBan = {
    prefix: "fas",
    iconName: "smoking-ban",
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var faSms = {
    prefix: "fas",
    iconName: "sms",
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var faSnowboarding = {
    prefix: "fas",
    iconName: "snowboarding",
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var faSnowflake = {
    prefix: "fas",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var faSnowman = {
    prefix: "fas",
    iconName: "snowman",
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faSnowplow = {
    prefix: "fas",
    iconName: "snowplow",
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var faSoap = {
    prefix: "fas",
    iconName: "soap",
    icon: [
        512,
        512,
        [],
        "e06e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var faSocks = {
    prefix: "fas",
    iconName: "socks",
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var faSolarPanel = {
    prefix: "fas",
    iconName: "solar-panel",
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var faSort = {
    prefix: "fas",
    iconName: "sort",
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var faSortAlphaDown = {
    prefix: "fas",
    iconName: "sort-alpha-down",
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var faSortAlphaDownAlt = {
    prefix: "fas",
    iconName: "sort-alpha-down-alt",
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var faSortAlphaUp = {
    prefix: "fas",
    iconName: "sort-alpha-up",
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var faSortAlphaUpAlt = {
    prefix: "fas",
    iconName: "sort-alpha-up-alt",
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var faSortAmountDown = {
    prefix: "fas",
    iconName: "sort-amount-down",
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faSortAmountDownAlt = {
    prefix: "fas",
    iconName: "sort-amount-down-alt",
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var faSortAmountUp = {
    prefix: "fas",
    iconName: "sort-amount-up",
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faSortAmountUpAlt = {
    prefix: "fas",
    iconName: "sort-amount-up-alt",
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var faSortDown = {
    prefix: "fas",
    iconName: "sort-down",
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var faSortNumericDown = {
    prefix: "fas",
    iconName: "sort-numeric-down",
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var faSortNumericDownAlt = {
    prefix: "fas",
    iconName: "sort-numeric-down-alt",
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var faSortNumericUp = {
    prefix: "fas",
    iconName: "sort-numeric-up",
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var faSortNumericUpAlt = {
    prefix: "fas",
    iconName: "sort-numeric-up-alt",
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var faSortUp = {
    prefix: "fas",
    iconName: "sort-up",
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var faSpa = {
    prefix: "fas",
    iconName: "spa",
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var faSpaceShuttle = {
    prefix: "fas",
    iconName: "space-shuttle",
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var faSpellCheck = {
    prefix: "fas",
    iconName: "spell-check",
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var faSpider = {
    prefix: "fas",
    iconName: "spider",
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var faSpinner = {
    prefix: "fas",
    iconName: "spinner",
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var faSplotch = {
    prefix: "fas",
    iconName: "splotch",
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var faSprayCan = {
    prefix: "fas",
    iconName: "spray-can",
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var faSquare = {
    prefix: "fas",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faSquareFull = {
    prefix: "fas",
    iconName: "square-full",
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var faSquareRootAlt = {
    prefix: "fas",
    iconName: "square-root-alt",
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var faStamp = {
    prefix: "fas",
    iconName: "stamp",
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var faStar = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var faStarAndCrescent = {
    prefix: "fas",
    iconName: "star-and-crescent",
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var faStarHalf = {
    prefix: "fas",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var faStarHalfAlt = {
    prefix: "fas",
    iconName: "star-half-alt",
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var faStarOfDavid = {
    prefix: "fas",
    iconName: "star-of-david",
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var faStarOfLife = {
    prefix: "fas",
    iconName: "star-of-life",
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var faStepBackward = {
    prefix: "fas",
    iconName: "step-backward",
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var faStepForward = {
    prefix: "fas",
    iconName: "step-forward",
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var faStethoscope = {
    prefix: "fas",
    iconName: "stethoscope",
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faStickyNote = {
    prefix: "fas",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var faStop = {
    prefix: "fas",
    iconName: "stop",
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faStopCircle = {
    prefix: "fas",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var faStopwatch = {
    prefix: "fas",
    iconName: "stopwatch",
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var faStopwatch20 = {
    prefix: "fas",
    iconName: "stopwatch-20",
    icon: [
        448,
        512,
        [],
        "e06f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var faStore = {
    prefix: "fas",
    iconName: "store",
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var faStoreAlt = {
    prefix: "fas",
    iconName: "store-alt",
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var faStoreAltSlash = {
    prefix: "fas",
    iconName: "store-alt-slash",
    icon: [
        640,
        512,
        [],
        "e070",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var faStoreSlash = {
    prefix: "fas",
    iconName: "store-slash",
    icon: [
        640,
        512,
        [],
        "e071",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var faStream = {
    prefix: "fas",
    iconName: "stream",
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var faStreetView = {
    prefix: "fas",
    iconName: "street-view",
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var faStrikethrough = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var faStroopwafel = {
    prefix: "fas",
    iconName: "stroopwafel",
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var faSubscript = {
    prefix: "fas",
    iconName: "subscript",
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var faSubway = {
    prefix: "fas",
    iconName: "subway",
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var faSuitcase = {
    prefix: "fas",
    iconName: "suitcase",
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var faSuitcaseRolling = {
    prefix: "fas",
    iconName: "suitcase-rolling",
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var faSun = {
    prefix: "fas",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var faSuperscript = {
    prefix: "fas",
    iconName: "superscript",
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var faSurprise = {
    prefix: "fas",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faSwatchbook = {
    prefix: "fas",
    iconName: "swatchbook",
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var faSwimmer = {
    prefix: "fas",
    iconName: "swimmer",
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var faSwimmingPool = {
    prefix: "fas",
    iconName: "swimming-pool",
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var faSynagogue = {
    prefix: "fas",
    iconName: "synagogue",
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var faSync = {
    prefix: "fas",
    iconName: "sync",
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var faSyncAlt = {
    prefix: "fas",
    iconName: "sync-alt",
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var faSyringe = {
    prefix: "fas",
    iconName: "syringe",
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var faTable = {
    prefix: "fas",
    iconName: "table",
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var faTableTennis = {
    prefix: "fas",
    iconName: "table-tennis",
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var faTablet = {
    prefix: "fas",
    iconName: "tablet",
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faTabletAlt = {
    prefix: "fas",
    iconName: "tablet-alt",
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var faTablets = {
    prefix: "fas",
    iconName: "tablets",
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var faTachometerAlt = {
    prefix: "fas",
    iconName: "tachometer-alt",
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faTag = {
    prefix: "fas",
    iconName: "tag",
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var faTags = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var faTape = {
    prefix: "fas",
    iconName: "tape",
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var faTasks = {
    prefix: "fas",
    iconName: "tasks",
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faTaxi = {
    prefix: "fas",
    iconName: "taxi",
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faTeeth = {
    prefix: "fas",
    iconName: "teeth",
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var faTeethOpen = {
    prefix: "fas",
    iconName: "teeth-open",
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var faTemperatureHigh = {
    prefix: "fas",
    iconName: "temperature-high",
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var faTemperatureLow = {
    prefix: "fas",
    iconName: "temperature-low",
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var faTenge = {
    prefix: "fas",
    iconName: "tenge",
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var faTerminal = {
    prefix: "fas",
    iconName: "terminal",
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var faTextHeight = {
    prefix: "fas",
    iconName: "text-height",
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var faTextWidth = {
    prefix: "fas",
    iconName: "text-width",
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var faTh = {
    prefix: "fas",
    iconName: "th",
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var faThLarge = {
    prefix: "fas",
    iconName: "th-large",
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var faThList = {
    prefix: "fas",
    iconName: "th-list",
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var faTheaterMasks = {
    prefix: "fas",
    iconName: "theater-masks",
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var faThermometer = {
    prefix: "fas",
    iconName: "thermometer",
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var faThermometerEmpty = {
    prefix: "fas",
    iconName: "thermometer-empty",
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerFull = {
    prefix: "fas",
    iconName: "thermometer-full",
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var faThermometerHalf = {
    prefix: "fas",
    iconName: "thermometer-half",
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerQuarter = {
    prefix: "fas",
    iconName: "thermometer-quarter",
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerThreeQuarters = {
    prefix: "fas",
    iconName: "thermometer-three-quarters",
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThumbsDown = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var faThumbsUp = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var faThumbtack = {
    prefix: "fas",
    iconName: "thumbtack",
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var faTicketAlt = {
    prefix: "fas",
    iconName: "ticket-alt",
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var faTimes = {
    prefix: "fas",
    iconName: "times",
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var faTimesCircle = {
    prefix: "fas",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var faTint = {
    prefix: "fas",
    iconName: "tint",
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var faTintSlash = {
    prefix: "fas",
    iconName: "tint-slash",
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var faTired = {
    prefix: "fas",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var faToggleOff = {
    prefix: "fas",
    iconName: "toggle-off",
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var faToggleOn = {
    prefix: "fas",
    iconName: "toggle-on",
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var faToilet = {
    prefix: "fas",
    iconName: "toilet",
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var faToiletPaper = {
    prefix: "fas",
    iconName: "toilet-paper",
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var faToiletPaperSlash = {
    prefix: "fas",
    iconName: "toilet-paper-slash",
    icon: [
        640,
        512,
        [],
        "e072",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var faToolbox = {
    prefix: "fas",
    iconName: "toolbox",
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var faTools = {
    prefix: "fas",
    iconName: "tools",
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var faTooth = {
    prefix: "fas",
    iconName: "tooth",
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var faTorah = {
    prefix: "fas",
    iconName: "torah",
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var faToriiGate = {
    prefix: "fas",
    iconName: "torii-gate",
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var faTractor = {
    prefix: "fas",
    iconName: "tractor",
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var faTrademark = {
    prefix: "fas",
    iconName: "trademark",
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var faTrafficLight = {
    prefix: "fas",
    iconName: "traffic-light",
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var faTrailer = {
    prefix: "fas",
    iconName: "trailer",
    icon: [
        640,
        512,
        [],
        "e041",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var faTrain = {
    prefix: "fas",
    iconName: "train",
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var faTram = {
    prefix: "fas",
    iconName: "tram",
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var faTransgender = {
    prefix: "fas",
    iconName: "transgender",
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faTransgenderAlt = {
    prefix: "fas",
    iconName: "transgender-alt",
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faTrash = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var faTrashAlt = {
    prefix: "fas",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTrashRestore = {
    prefix: "fas",
    iconName: "trash-restore",
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTrashRestoreAlt = {
    prefix: "fas",
    iconName: "trash-restore-alt",
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTree = {
    prefix: "fas",
    iconName: "tree",
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var faTrophy = {
    prefix: "fas",
    iconName: "trophy",
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var faTruck = {
    prefix: "fas",
    iconName: "truck",
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faTruckLoading = {
    prefix: "fas",
    iconName: "truck-loading",
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faTruckMonster = {
    prefix: "fas",
    iconName: "truck-monster",
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var faTruckMoving = {
    prefix: "fas",
    iconName: "truck-moving",
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var faTruckPickup = {
    prefix: "fas",
    iconName: "truck-pickup",
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var faTshirt = {
    prefix: "fas",
    iconName: "tshirt",
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var faTty = {
    prefix: "fas",
    iconName: "tty",
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var faTv = {
    prefix: "fas",
    iconName: "tv",
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var faUmbrella = {
    prefix: "fas",
    iconName: "umbrella",
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var faUmbrellaBeach = {
    prefix: "fas",
    iconName: "umbrella-beach",
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var faUnderline = {
    prefix: "fas",
    iconName: "underline",
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faUndo = {
    prefix: "fas",
    iconName: "undo",
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var faUndoAlt = {
    prefix: "fas",
    iconName: "undo-alt",
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var faUniversalAccess = {
    prefix: "fas",
    iconName: "universal-access",
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var faUniversity = {
    prefix: "fas",
    iconName: "university",
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var faUnlink = {
    prefix: "fas",
    iconName: "unlink",
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var faUnlock = {
    prefix: "fas",
    iconName: "unlock",
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var faUnlockAlt = {
    prefix: "fas",
    iconName: "unlock-alt",
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var faUpload = {
    prefix: "fas",
    iconName: "upload",
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var faUser = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserAlt = {
    prefix: "fas",
    iconName: "user-alt",
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var faUserAltSlash = {
    prefix: "fas",
    iconName: "user-alt-slash",
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var faUserAstronaut = {
    prefix: "fas",
    iconName: "user-astronaut",
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var faUserCheck = {
    prefix: "fas",
    iconName: "user-check",
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var faUserCircle = {
    prefix: "fas",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var faUserClock = {
    prefix: "fas",
    iconName: "user-clock",
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var faUserCog = {
    prefix: "fas",
    iconName: "user-cog",
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var faUserEdit = {
    prefix: "fas",
    iconName: "user-edit",
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var faUserFriends = {
    prefix: "fas",
    iconName: "user-friends",
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var faUserGraduate = {
    prefix: "fas",
    iconName: "user-graduate",
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var faUserInjured = {
    prefix: "fas",
    iconName: "user-injured",
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var faUserLock = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var faUserMd = {
    prefix: "fas",
    iconName: "user-md",
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var faUserMinus = {
    prefix: "fas",
    iconName: "user-minus",
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserNinja = {
    prefix: "fas",
    iconName: "user-ninja",
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var faUserNurse = {
    prefix: "fas",
    iconName: "user-nurse",
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var faUserPlus = {
    prefix: "fas",
    iconName: "user-plus",
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserSecret = {
    prefix: "fas",
    iconName: "user-secret",
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var faUserShield = {
    prefix: "fas",
    iconName: "user-shield",
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var faUserSlash = {
    prefix: "fas",
    iconName: "user-slash",
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var faUserTag = {
    prefix: "fas",
    iconName: "user-tag",
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var faUserTie = {
    prefix: "fas",
    iconName: "user-tie",
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var faUserTimes = {
    prefix: "fas",
    iconName: "user-times",
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUsers = {
    prefix: "fas",
    iconName: "users",
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var faUsersCog = {
    prefix: "fas",
    iconName: "users-cog",
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var faUsersSlash = {
    prefix: "fas",
    iconName: "users-slash",
    icon: [
        640,
        512,
        [],
        "e073",
        "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
    ]
};
var faUtensilSpoon = {
    prefix: "fas",
    iconName: "utensil-spoon",
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var faUtensils = {
    prefix: "fas",
    iconName: "utensils",
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var faVectorSquare = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var faVenus = {
    prefix: "fas",
    iconName: "venus",
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var faVenusDouble = {
    prefix: "fas",
    iconName: "venus-double",
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var faVenusMars = {
    prefix: "fas",
    iconName: "venus-mars",
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faVest = {
    prefix: "fas",
    iconName: "vest",
    icon: [
        448,
        512,
        [],
        "e085",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
    ]
};
var faVestPatches = {
    prefix: "fas",
    iconName: "vest-patches",
    icon: [
        448,
        512,
        [],
        "e086",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
    ]
};
var faVial = {
    prefix: "fas",
    iconName: "vial",
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var faVials = {
    prefix: "fas",
    iconName: "vials",
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var faVideo = {
    prefix: "fas",
    iconName: "video",
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var faVideoSlash = {
    prefix: "fas",
    iconName: "video-slash",
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var faVihara = {
    prefix: "fas",
    iconName: "vihara",
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var faVirus = {
    prefix: "fas",
    iconName: "virus",
    icon: [
        512,
        512,
        [],
        "e074",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var faVirusSlash = {
    prefix: "fas",
    iconName: "virus-slash",
    icon: [
        640,
        512,
        [],
        "e075",
        "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
    ]
};
var faViruses = {
    prefix: "fas",
    iconName: "viruses",
    icon: [
        640,
        512,
        [],
        "e076",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var faVoicemail = {
    prefix: "fas",
    iconName: "voicemail",
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var faVolleyballBall = {
    prefix: "fas",
    iconName: "volleyball-ball",
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var faVolumeDown = {
    prefix: "fas",
    iconName: "volume-down",
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var faVolumeMute = {
    prefix: "fas",
    iconName: "volume-mute",
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var faVolumeOff = {
    prefix: "fas",
    iconName: "volume-off",
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var faVolumeUp = {
    prefix: "fas",
    iconName: "volume-up",
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var faVoteYea = {
    prefix: "fas",
    iconName: "vote-yea",
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var faVrCardboard = {
    prefix: "fas",
    iconName: "vr-cardboard",
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var faWalking = {
    prefix: "fas",
    iconName: "walking",
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var faWallet = {
    prefix: "fas",
    iconName: "wallet",
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faWarehouse = {
    prefix: "fas",
    iconName: "warehouse",
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var faWater = {
    prefix: "fas",
    iconName: "water",
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var faWaveSquare = {
    prefix: "fas",
    iconName: "wave-square",
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var faWeight = {
    prefix: "fas",
    iconName: "weight",
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var faWeightHanging = {
    prefix: "fas",
    iconName: "weight-hanging",
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var faWheelchair = {
    prefix: "fas",
    iconName: "wheelchair",
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var faWifi = {
    prefix: "fas",
    iconName: "wifi",
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var faWind = {
    prefix: "fas",
    iconName: "wind",
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var faWindowClose = {
    prefix: "fas",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var faWindowMaximize = {
    prefix: "fas",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var faWindowMinimize = {
    prefix: "fas",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var faWindowRestore = {
    prefix: "fas",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var faWineBottle = {
    prefix: "fas",
    iconName: "wine-bottle",
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var faWineGlass = {
    prefix: "fas",
    iconName: "wine-glass",
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var faWineGlassAlt = {
    prefix: "fas",
    iconName: "wine-glass-alt",
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var faWonSign = {
    prefix: "fas",
    iconName: "won-sign",
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var faWrench = {
    prefix: "fas",
    iconName: "wrench",
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faXRay = {
    prefix: "fas",
    iconName: "x-ray",
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var faYenSign = {
    prefix: "fas",
    iconName: "yen-sign",
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var faYinYang = {
    prefix: "fas",
    iconName: "yin-yang",
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var _iconsCache = {
    faAd: faAd,
    faAddressBook: faAddressBook,
    faAddressCard: faAddressCard,
    faAdjust: faAdjust,
    faAirFreshener: faAirFreshener,
    faAlignCenter: faAlignCenter,
    faAlignJustify: faAlignJustify,
    faAlignLeft: faAlignLeft,
    faAlignRight: faAlignRight,
    faAllergies: faAllergies,
    faAmbulance: faAmbulance,
    faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
    faAnchor: faAnchor,
    faAngleDoubleDown: faAngleDoubleDown,
    faAngleDoubleLeft: faAngleDoubleLeft,
    faAngleDoubleRight: faAngleDoubleRight,
    faAngleDoubleUp: faAngleDoubleUp,
    faAngleDown: faAngleDown,
    faAngleLeft: faAngleLeft,
    faAngleRight: faAngleRight,
    faAngleUp: faAngleUp,
    faAngry: faAngry,
    faAnkh: faAnkh,
    faAppleAlt: faAppleAlt,
    faArchive: faArchive,
    faArchway: faArchway,
    faArrowAltCircleDown: faArrowAltCircleDown,
    faArrowAltCircleLeft: faArrowAltCircleLeft,
    faArrowAltCircleRight: faArrowAltCircleRight,
    faArrowAltCircleUp: faArrowAltCircleUp,
    faArrowCircleDown: faArrowCircleDown,
    faArrowCircleLeft: faArrowCircleLeft,
    faArrowCircleRight: faArrowCircleRight,
    faArrowCircleUp: faArrowCircleUp,
    faArrowDown: faArrowDown,
    faArrowLeft: faArrowLeft,
    faArrowRight: faArrowRight,
    faArrowUp: faArrowUp,
    faArrowsAlt: faArrowsAlt,
    faArrowsAltH: faArrowsAltH,
    faArrowsAltV: faArrowsAltV,
    faAssistiveListeningSystems: faAssistiveListeningSystems,
    faAsterisk: faAsterisk,
    faAt: faAt,
    faAtlas: faAtlas,
    faAtom: faAtom,
    faAudioDescription: faAudioDescription,
    faAward: faAward,
    faBaby: faBaby,
    faBabyCarriage: faBabyCarriage,
    faBackspace: faBackspace,
    faBackward: faBackward,
    faBacon: faBacon,
    faBacteria: faBacteria,
    faBacterium: faBacterium,
    faBahai: faBahai,
    faBalanceScale: faBalanceScale,
    faBalanceScaleLeft: faBalanceScaleLeft,
    faBalanceScaleRight: faBalanceScaleRight,
    faBan: faBan,
    faBandAid: faBandAid,
    faBarcode: faBarcode,
    faBars: faBars,
    faBaseballBall: faBaseballBall,
    faBasketballBall: faBasketballBall,
    faBath: faBath,
    faBatteryEmpty: faBatteryEmpty,
    faBatteryFull: faBatteryFull,
    faBatteryHalf: faBatteryHalf,
    faBatteryQuarter: faBatteryQuarter,
    faBatteryThreeQuarters: faBatteryThreeQuarters,
    faBed: faBed,
    faBeer: faBeer,
    faBell: faBell,
    faBellSlash: faBellSlash,
    faBezierCurve: faBezierCurve,
    faBible: faBible,
    faBicycle: faBicycle,
    faBiking: faBiking,
    faBinoculars: faBinoculars,
    faBiohazard: faBiohazard,
    faBirthdayCake: faBirthdayCake,
    faBlender: faBlender,
    faBlenderPhone: faBlenderPhone,
    faBlind: faBlind,
    faBlog: faBlog,
    faBold: faBold,
    faBolt: faBolt,
    faBomb: faBomb,
    faBone: faBone,
    faBong: faBong,
    faBook: faBook,
    faBookDead: faBookDead,
    faBookMedical: faBookMedical,
    faBookOpen: faBookOpen,
    faBookReader: faBookReader,
    faBookmark: faBookmark,
    faBorderAll: faBorderAll,
    faBorderNone: faBorderNone,
    faBorderStyle: faBorderStyle,
    faBowlingBall: faBowlingBall,
    faBox: faBox,
    faBoxOpen: faBoxOpen,
    faBoxTissue: faBoxTissue,
    faBoxes: faBoxes,
    faBraille: faBraille,
    faBrain: faBrain,
    faBreadSlice: faBreadSlice,
    faBriefcase: faBriefcase,
    faBriefcaseMedical: faBriefcaseMedical,
    faBroadcastTower: faBroadcastTower,
    faBroom: faBroom,
    faBrush: faBrush,
    faBug: faBug,
    faBuilding: faBuilding,
    faBullhorn: faBullhorn,
    faBullseye: faBullseye,
    faBurn: faBurn,
    faBus: faBus,
    faBusAlt: faBusAlt,
    faBusinessTime: faBusinessTime,
    faCalculator: faCalculator,
    faCalendar: faCalendar,
    faCalendarAlt: faCalendarAlt,
    faCalendarCheck: faCalendarCheck,
    faCalendarDay: faCalendarDay,
    faCalendarMinus: faCalendarMinus,
    faCalendarPlus: faCalendarPlus,
    faCalendarTimes: faCalendarTimes,
    faCalendarWeek: faCalendarWeek,
    faCamera: faCamera,
    faCameraRetro: faCameraRetro,
    faCampground: faCampground,
    faCandyCane: faCandyCane,
    faCannabis: faCannabis,
    faCapsules: faCapsules,
    faCar: faCar,
    faCarAlt: faCarAlt,
    faCarBattery: faCarBattery,
    faCarCrash: faCarCrash,
    faCarSide: faCarSide,
    faCaravan: faCaravan,
    faCaretDown: faCaretDown,
    faCaretLeft: faCaretLeft,
    faCaretRight: faCaretRight,
    faCaretSquareDown: faCaretSquareDown,
    faCaretSquareLeft: faCaretSquareLeft,
    faCaretSquareRight: faCaretSquareRight,
    faCaretSquareUp: faCaretSquareUp,
    faCaretUp: faCaretUp,
    faCarrot: faCarrot,
    faCartArrowDown: faCartArrowDown,
    faCartPlus: faCartPlus,
    faCashRegister: faCashRegister,
    faCat: faCat,
    faCertificate: faCertificate,
    faChair: faChair,
    faChalkboard: faChalkboard,
    faChalkboardTeacher: faChalkboardTeacher,
    faChargingStation: faChargingStation,
    faChartArea: faChartArea,
    faChartBar: faChartBar,
    faChartLine: faChartLine,
    faChartPie: faChartPie,
    faCheck: faCheck,
    faCheckCircle: faCheckCircle,
    faCheckDouble: faCheckDouble,
    faCheckSquare: faCheckSquare,
    faCheese: faCheese,
    faChess: faChess,
    faChessBishop: faChessBishop,
    faChessBoard: faChessBoard,
    faChessKing: faChessKing,
    faChessKnight: faChessKnight,
    faChessPawn: faChessPawn,
    faChessQueen: faChessQueen,
    faChessRook: faChessRook,
    faChevronCircleDown: faChevronCircleDown,
    faChevronCircleLeft: faChevronCircleLeft,
    faChevronCircleRight: faChevronCircleRight,
    faChevronCircleUp: faChevronCircleUp,
    faChevronDown: faChevronDown,
    faChevronLeft: faChevronLeft,
    faChevronRight: faChevronRight,
    faChevronUp: faChevronUp,
    faChild: faChild,
    faChurch: faChurch,
    faCircle: faCircle,
    faCircleNotch: faCircleNotch,
    faCity: faCity,
    faClinicMedical: faClinicMedical,
    faClipboard: faClipboard,
    faClipboardCheck: faClipboardCheck,
    faClipboardList: faClipboardList,
    faClock: faClock,
    faClone: faClone,
    faClosedCaptioning: faClosedCaptioning,
    faCloud: faCloud,
    faCloudDownloadAlt: faCloudDownloadAlt,
    faCloudMeatball: faCloudMeatball,
    faCloudMoon: faCloudMoon,
    faCloudMoonRain: faCloudMoonRain,
    faCloudRain: faCloudRain,
    faCloudShowersHeavy: faCloudShowersHeavy,
    faCloudSun: faCloudSun,
    faCloudSunRain: faCloudSunRain,
    faCloudUploadAlt: faCloudUploadAlt,
    faCocktail: faCocktail,
    faCode: faCode,
    faCodeBranch: faCodeBranch,
    faCoffee: faCoffee,
    faCog: faCog,
    faCogs: faCogs,
    faCoins: faCoins,
    faColumns: faColumns,
    faComment: faComment,
    faCommentAlt: faCommentAlt,
    faCommentDollar: faCommentDollar,
    faCommentDots: faCommentDots,
    faCommentMedical: faCommentMedical,
    faCommentSlash: faCommentSlash,
    faComments: faComments,
    faCommentsDollar: faCommentsDollar,
    faCompactDisc: faCompactDisc,
    faCompass: faCompass,
    faCompress: faCompress,
    faCompressAlt: faCompressAlt,
    faCompressArrowsAlt: faCompressArrowsAlt,
    faConciergeBell: faConciergeBell,
    faCookie: faCookie,
    faCookieBite: faCookieBite,
    faCopy: faCopy,
    faCopyright: faCopyright,
    faCouch: faCouch,
    faCreditCard: faCreditCard,
    faCrop: faCrop,
    faCropAlt: faCropAlt,
    faCross: faCross,
    faCrosshairs: faCrosshairs,
    faCrow: faCrow,
    faCrown: faCrown,
    faCrutch: faCrutch,
    faCube: faCube,
    faCubes: faCubes,
    faCut: faCut,
    faDatabase: faDatabase,
    faDeaf: faDeaf,
    faDemocrat: faDemocrat,
    faDesktop: faDesktop,
    faDharmachakra: faDharmachakra,
    faDiagnoses: faDiagnoses,
    faDice: faDice,
    faDiceD20: faDiceD20,
    faDiceD6: faDiceD6,
    faDiceFive: faDiceFive,
    faDiceFour: faDiceFour,
    faDiceOne: faDiceOne,
    faDiceSix: faDiceSix,
    faDiceThree: faDiceThree,
    faDiceTwo: faDiceTwo,
    faDigitalTachograph: faDigitalTachograph,
    faDirections: faDirections,
    faDisease: faDisease,
    faDivide: faDivide,
    faDizzy: faDizzy,
    faDna: faDna,
    faDog: faDog,
    faDollarSign: faDollarSign,
    faDolly: faDolly,
    faDollyFlatbed: faDollyFlatbed,
    faDonate: faDonate,
    faDoorClosed: faDoorClosed,
    faDoorOpen: faDoorOpen,
    faDotCircle: faDotCircle,
    faDove: faDove,
    faDownload: faDownload,
    faDraftingCompass: faDraftingCompass,
    faDragon: faDragon,
    faDrawPolygon: faDrawPolygon,
    faDrum: faDrum,
    faDrumSteelpan: faDrumSteelpan,
    faDrumstickBite: faDrumstickBite,
    faDumbbell: faDumbbell,
    faDumpster: faDumpster,
    faDumpsterFire: faDumpsterFire,
    faDungeon: faDungeon,
    faEdit: faEdit,
    faEgg: faEgg,
    faEject: faEject,
    faEllipsisH: faEllipsisH,
    faEllipsisV: faEllipsisV,
    faEnvelope: faEnvelope,
    faEnvelopeOpen: faEnvelopeOpen,
    faEnvelopeOpenText: faEnvelopeOpenText,
    faEnvelopeSquare: faEnvelopeSquare,
    faEquals: faEquals,
    faEraser: faEraser,
    faEthernet: faEthernet,
    faEuroSign: faEuroSign,
    faExchangeAlt: faExchangeAlt,
    faExclamation: faExclamation,
    faExclamationCircle: faExclamationCircle,
    faExclamationTriangle: faExclamationTriangle,
    faExpand: faExpand,
    faExpandAlt: faExpandAlt,
    faExpandArrowsAlt: faExpandArrowsAlt,
    faExternalLinkAlt: faExternalLinkAlt,
    faExternalLinkSquareAlt: faExternalLinkSquareAlt,
    faEye: faEye,
    faEyeDropper: faEyeDropper,
    faEyeSlash: faEyeSlash,
    faFan: faFan,
    faFastBackward: faFastBackward,
    faFastForward: faFastForward,
    faFaucet: faFaucet,
    faFax: faFax,
    faFeather: faFeather,
    faFeatherAlt: faFeatherAlt,
    faFemale: faFemale,
    faFighterJet: faFighterJet,
    faFile: faFile,
    faFileAlt: faFileAlt,
    faFileArchive: faFileArchive,
    faFileAudio: faFileAudio,
    faFileCode: faFileCode,
    faFileContract: faFileContract,
    faFileCsv: faFileCsv,
    faFileDownload: faFileDownload,
    faFileExcel: faFileExcel,
    faFileExport: faFileExport,
    faFileImage: faFileImage,
    faFileImport: faFileImport,
    faFileInvoice: faFileInvoice,
    faFileInvoiceDollar: faFileInvoiceDollar,
    faFileMedical: faFileMedical,
    faFileMedicalAlt: faFileMedicalAlt,
    faFilePdf: faFilePdf,
    faFilePowerpoint: faFilePowerpoint,
    faFilePrescription: faFilePrescription,
    faFileSignature: faFileSignature,
    faFileUpload: faFileUpload,
    faFileVideo: faFileVideo,
    faFileWord: faFileWord,
    faFill: faFill,
    faFillDrip: faFillDrip,
    faFilm: faFilm,
    faFilter: faFilter,
    faFingerprint: faFingerprint,
    faFire: faFire,
    faFireAlt: faFireAlt,
    faFireExtinguisher: faFireExtinguisher,
    faFirstAid: faFirstAid,
    faFish: faFish,
    faFistRaised: faFistRaised,
    faFlag: faFlag,
    faFlagCheckered: faFlagCheckered,
    faFlagUsa: faFlagUsa,
    faFlask: faFlask,
    faFlushed: faFlushed,
    faFolder: faFolder,
    faFolderMinus: faFolderMinus,
    faFolderOpen: faFolderOpen,
    faFolderPlus: faFolderPlus,
    faFont: faFont,
    faFontAwesomeLogoFull: faFontAwesomeLogoFull,
    faFootballBall: faFootballBall,
    faForward: faForward,
    faFrog: faFrog,
    faFrown: faFrown,
    faFrownOpen: faFrownOpen,
    faFunnelDollar: faFunnelDollar,
    faFutbol: faFutbol,
    faGamepad: faGamepad,
    faGasPump: faGasPump,
    faGavel: faGavel,
    faGem: faGem,
    faGenderless: faGenderless,
    faGhost: faGhost,
    faGift: faGift,
    faGifts: faGifts,
    faGlassCheers: faGlassCheers,
    faGlassMartini: faGlassMartini,
    faGlassMartiniAlt: faGlassMartiniAlt,
    faGlassWhiskey: faGlassWhiskey,
    faGlasses: faGlasses,
    faGlobe: faGlobe,
    faGlobeAfrica: faGlobeAfrica,
    faGlobeAmericas: faGlobeAmericas,
    faGlobeAsia: faGlobeAsia,
    faGlobeEurope: faGlobeEurope,
    faGolfBall: faGolfBall,
    faGopuram: faGopuram,
    faGraduationCap: faGraduationCap,
    faGreaterThan: faGreaterThan,
    faGreaterThanEqual: faGreaterThanEqual,
    faGrimace: faGrimace,
    faGrin: faGrin,
    faGrinAlt: faGrinAlt,
    faGrinBeam: faGrinBeam,
    faGrinBeamSweat: faGrinBeamSweat,
    faGrinHearts: faGrinHearts,
    faGrinSquint: faGrinSquint,
    faGrinSquintTears: faGrinSquintTears,
    faGrinStars: faGrinStars,
    faGrinTears: faGrinTears,
    faGrinTongue: faGrinTongue,
    faGrinTongueSquint: faGrinTongueSquint,
    faGrinTongueWink: faGrinTongueWink,
    faGrinWink: faGrinWink,
    faGripHorizontal: faGripHorizontal,
    faGripLines: faGripLines,
    faGripLinesVertical: faGripLinesVertical,
    faGripVertical: faGripVertical,
    faGuitar: faGuitar,
    faHSquare: faHSquare,
    faHamburger: faHamburger,
    faHammer: faHammer,
    faHamsa: faHamsa,
    faHandHolding: faHandHolding,
    faHandHoldingHeart: faHandHoldingHeart,
    faHandHoldingMedical: faHandHoldingMedical,
    faHandHoldingUsd: faHandHoldingUsd,
    faHandHoldingWater: faHandHoldingWater,
    faHandLizard: faHandLizard,
    faHandMiddleFinger: faHandMiddleFinger,
    faHandPaper: faHandPaper,
    faHandPeace: faHandPeace,
    faHandPointDown: faHandPointDown,
    faHandPointLeft: faHandPointLeft,
    faHandPointRight: faHandPointRight,
    faHandPointUp: faHandPointUp,
    faHandPointer: faHandPointer,
    faHandRock: faHandRock,
    faHandScissors: faHandScissors,
    faHandSparkles: faHandSparkles,
    faHandSpock: faHandSpock,
    faHands: faHands,
    faHandsHelping: faHandsHelping,
    faHandsWash: faHandsWash,
    faHandshake: faHandshake,
    faHandshakeAltSlash: faHandshakeAltSlash,
    faHandshakeSlash: faHandshakeSlash,
    faHanukiah: faHanukiah,
    faHardHat: faHardHat,
    faHashtag: faHashtag,
    faHatCowboy: faHatCowboy,
    faHatCowboySide: faHatCowboySide,
    faHatWizard: faHatWizard,
    faHdd: faHdd,
    faHeadSideCough: faHeadSideCough,
    faHeadSideCoughSlash: faHeadSideCoughSlash,
    faHeadSideMask: faHeadSideMask,
    faHeadSideVirus: faHeadSideVirus,
    faHeading: faHeading,
    faHeadphones: faHeadphones,
    faHeadphonesAlt: faHeadphonesAlt,
    faHeadset: faHeadset,
    faHeart: faHeart,
    faHeartBroken: faHeartBroken,
    faHeartbeat: faHeartbeat,
    faHelicopter: faHelicopter,
    faHighlighter: faHighlighter,
    faHiking: faHiking,
    faHippo: faHippo,
    faHistory: faHistory,
    faHockeyPuck: faHockeyPuck,
    faHollyBerry: faHollyBerry,
    faHome: faHome,
    faHorse: faHorse,
    faHorseHead: faHorseHead,
    faHospital: faHospital,
    faHospitalAlt: faHospitalAlt,
    faHospitalSymbol: faHospitalSymbol,
    faHospitalUser: faHospitalUser,
    faHotTub: faHotTub,
    faHotdog: faHotdog,
    faHotel: faHotel,
    faHourglass: faHourglass,
    faHourglassEnd: faHourglassEnd,
    faHourglassHalf: faHourglassHalf,
    faHourglassStart: faHourglassStart,
    faHouseDamage: faHouseDamage,
    faHouseUser: faHouseUser,
    faHryvnia: faHryvnia,
    faICursor: faICursor,
    faIceCream: faIceCream,
    faIcicles: faIcicles,
    faIcons: faIcons,
    faIdBadge: faIdBadge,
    faIdCard: faIdCard,
    faIdCardAlt: faIdCardAlt,
    faIgloo: faIgloo,
    faImage: faImage,
    faImages: faImages,
    faInbox: faInbox,
    faIndent: faIndent,
    faIndustry: faIndustry,
    faInfinity: faInfinity,
    faInfo: faInfo,
    faInfoCircle: faInfoCircle,
    faItalic: faItalic,
    faJedi: faJedi,
    faJoint: faJoint,
    faJournalWhills: faJournalWhills,
    faKaaba: faKaaba,
    faKey: faKey,
    faKeyboard: faKeyboard,
    faKhanda: faKhanda,
    faKiss: faKiss,
    faKissBeam: faKissBeam,
    faKissWinkHeart: faKissWinkHeart,
    faKiwiBird: faKiwiBird,
    faLandmark: faLandmark,
    faLanguage: faLanguage,
    faLaptop: faLaptop,
    faLaptopCode: faLaptopCode,
    faLaptopHouse: faLaptopHouse,
    faLaptopMedical: faLaptopMedical,
    faLaugh: faLaugh,
    faLaughBeam: faLaughBeam,
    faLaughSquint: faLaughSquint,
    faLaughWink: faLaughWink,
    faLayerGroup: faLayerGroup,
    faLeaf: faLeaf,
    faLemon: faLemon,
    faLessThan: faLessThan,
    faLessThanEqual: faLessThanEqual,
    faLevelDownAlt: faLevelDownAlt,
    faLevelUpAlt: faLevelUpAlt,
    faLifeRing: faLifeRing,
    faLightbulb: faLightbulb,
    faLink: faLink,
    faLiraSign: faLiraSign,
    faList: faList,
    faListAlt: faListAlt,
    faListOl: faListOl,
    faListUl: faListUl,
    faLocationArrow: faLocationArrow,
    faLock: faLock,
    faLockOpen: faLockOpen,
    faLongArrowAltDown: faLongArrowAltDown,
    faLongArrowAltLeft: faLongArrowAltLeft,
    faLongArrowAltRight: faLongArrowAltRight,
    faLongArrowAltUp: faLongArrowAltUp,
    faLowVision: faLowVision,
    faLuggageCart: faLuggageCart,
    faLungs: faLungs,
    faLungsVirus: faLungsVirus,
    faMagic: faMagic,
    faMagnet: faMagnet,
    faMailBulk: faMailBulk,
    faMale: faMale,
    faMap: faMap,
    faMapMarked: faMapMarked,
    faMapMarkedAlt: faMapMarkedAlt,
    faMapMarker: faMapMarker,
    faMapMarkerAlt: faMapMarkerAlt,
    faMapPin: faMapPin,
    faMapSigns: faMapSigns,
    faMarker: faMarker,
    faMars: faMars,
    faMarsDouble: faMarsDouble,
    faMarsStroke: faMarsStroke,
    faMarsStrokeH: faMarsStrokeH,
    faMarsStrokeV: faMarsStrokeV,
    faMask: faMask,
    faMedal: faMedal,
    faMedkit: faMedkit,
    faMeh: faMeh,
    faMehBlank: faMehBlank,
    faMehRollingEyes: faMehRollingEyes,
    faMemory: faMemory,
    faMenorah: faMenorah,
    faMercury: faMercury,
    faMeteor: faMeteor,
    faMicrochip: faMicrochip,
    faMicrophone: faMicrophone,
    faMicrophoneAlt: faMicrophoneAlt,
    faMicrophoneAltSlash: faMicrophoneAltSlash,
    faMicrophoneSlash: faMicrophoneSlash,
    faMicroscope: faMicroscope,
    faMinus: faMinus,
    faMinusCircle: faMinusCircle,
    faMinusSquare: faMinusSquare,
    faMitten: faMitten,
    faMobile: faMobile,
    faMobileAlt: faMobileAlt,
    faMoneyBill: faMoneyBill,
    faMoneyBillAlt: faMoneyBillAlt,
    faMoneyBillWave: faMoneyBillWave,
    faMoneyBillWaveAlt: faMoneyBillWaveAlt,
    faMoneyCheck: faMoneyCheck,
    faMoneyCheckAlt: faMoneyCheckAlt,
    faMonument: faMonument,
    faMoon: faMoon,
    faMortarPestle: faMortarPestle,
    faMosque: faMosque,
    faMotorcycle: faMotorcycle,
    faMountain: faMountain,
    faMouse: faMouse,
    faMousePointer: faMousePointer,
    faMugHot: faMugHot,
    faMusic: faMusic,
    faNetworkWired: faNetworkWired,
    faNeuter: faNeuter,
    faNewspaper: faNewspaper,
    faNotEqual: faNotEqual,
    faNotesMedical: faNotesMedical,
    faObjectGroup: faObjectGroup,
    faObjectUngroup: faObjectUngroup,
    faOilCan: faOilCan,
    faOm: faOm,
    faOtter: faOtter,
    faOutdent: faOutdent,
    faPager: faPager,
    faPaintBrush: faPaintBrush,
    faPaintRoller: faPaintRoller,
    faPalette: faPalette,
    faPallet: faPallet,
    faPaperPlane: faPaperPlane,
    faPaperclip: faPaperclip,
    faParachuteBox: faParachuteBox,
    faParagraph: faParagraph,
    faParking: faParking,
    faPassport: faPassport,
    faPastafarianism: faPastafarianism,
    faPaste: faPaste,
    faPause: faPause,
    faPauseCircle: faPauseCircle,
    faPaw: faPaw,
    faPeace: faPeace,
    faPen: faPen,
    faPenAlt: faPenAlt,
    faPenFancy: faPenFancy,
    faPenNib: faPenNib,
    faPenSquare: faPenSquare,
    faPencilAlt: faPencilAlt,
    faPencilRuler: faPencilRuler,
    faPeopleArrows: faPeopleArrows,
    faPeopleCarry: faPeopleCarry,
    faPepperHot: faPepperHot,
    faPercent: faPercent,
    faPercentage: faPercentage,
    faPersonBooth: faPersonBooth,
    faPhone: faPhone,
    faPhoneAlt: faPhoneAlt,
    faPhoneSlash: faPhoneSlash,
    faPhoneSquare: faPhoneSquare,
    faPhoneSquareAlt: faPhoneSquareAlt,
    faPhoneVolume: faPhoneVolume,
    faPhotoVideo: faPhotoVideo,
    faPiggyBank: faPiggyBank,
    faPills: faPills,
    faPizzaSlice: faPizzaSlice,
    faPlaceOfWorship: faPlaceOfWorship,
    faPlane: faPlane,
    faPlaneArrival: faPlaneArrival,
    faPlaneDeparture: faPlaneDeparture,
    faPlaneSlash: faPlaneSlash,
    faPlay: faPlay,
    faPlayCircle: faPlayCircle,
    faPlug: faPlug,
    faPlus: faPlus,
    faPlusCircle: faPlusCircle,
    faPlusSquare: faPlusSquare,
    faPodcast: faPodcast,
    faPoll: faPoll,
    faPollH: faPollH,
    faPoo: faPoo,
    faPooStorm: faPooStorm,
    faPoop: faPoop,
    faPortrait: faPortrait,
    faPoundSign: faPoundSign,
    faPowerOff: faPowerOff,
    faPray: faPray,
    faPrayingHands: faPrayingHands,
    faPrescription: faPrescription,
    faPrescriptionBottle: faPrescriptionBottle,
    faPrescriptionBottleAlt: faPrescriptionBottleAlt,
    faPrint: faPrint,
    faProcedures: faProcedures,
    faProjectDiagram: faProjectDiagram,
    faPumpMedical: faPumpMedical,
    faPumpSoap: faPumpSoap,
    faPuzzlePiece: faPuzzlePiece,
    faQrcode: faQrcode,
    faQuestion: faQuestion,
    faQuestionCircle: faQuestionCircle,
    faQuidditch: faQuidditch,
    faQuoteLeft: faQuoteLeft,
    faQuoteRight: faQuoteRight,
    faQuran: faQuran,
    faRadiation: faRadiation,
    faRadiationAlt: faRadiationAlt,
    faRainbow: faRainbow,
    faRandom: faRandom,
    faReceipt: faReceipt,
    faRecordVinyl: faRecordVinyl,
    faRecycle: faRecycle,
    faRedo: faRedo,
    faRedoAlt: faRedoAlt,
    faRegistered: faRegistered,
    faRemoveFormat: faRemoveFormat,
    faReply: faReply,
    faReplyAll: faReplyAll,
    faRepublican: faRepublican,
    faRestroom: faRestroom,
    faRetweet: faRetweet,
    faRibbon: faRibbon,
    faRing: faRing,
    faRoad: faRoad,
    faRobot: faRobot,
    faRocket: faRocket,
    faRoute: faRoute,
    faRss: faRss,
    faRssSquare: faRssSquare,
    faRubleSign: faRubleSign,
    faRuler: faRuler,
    faRulerCombined: faRulerCombined,
    faRulerHorizontal: faRulerHorizontal,
    faRulerVertical: faRulerVertical,
    faRunning: faRunning,
    faRupeeSign: faRupeeSign,
    faSadCry: faSadCry,
    faSadTear: faSadTear,
    faSatellite: faSatellite,
    faSatelliteDish: faSatelliteDish,
    faSave: faSave,
    faSchool: faSchool,
    faScrewdriver: faScrewdriver,
    faScroll: faScroll,
    faSdCard: faSdCard,
    faSearch: faSearch,
    faSearchDollar: faSearchDollar,
    faSearchLocation: faSearchLocation,
    faSearchMinus: faSearchMinus,
    faSearchPlus: faSearchPlus,
    faSeedling: faSeedling,
    faServer: faServer,
    faShapes: faShapes,
    faShare: faShare,
    faShareAlt: faShareAlt,
    faShareAltSquare: faShareAltSquare,
    faShareSquare: faShareSquare,
    faShekelSign: faShekelSign,
    faShieldAlt: faShieldAlt,
    faShieldVirus: faShieldVirus,
    faShip: faShip,
    faShippingFast: faShippingFast,
    faShoePrints: faShoePrints,
    faShoppingBag: faShoppingBag,
    faShoppingBasket: faShoppingBasket,
    faShoppingCart: faShoppingCart,
    faShower: faShower,
    faShuttleVan: faShuttleVan,
    faSign: faSign,
    faSignInAlt: faSignInAlt,
    faSignLanguage: faSignLanguage,
    faSignOutAlt: faSignOutAlt,
    faSignal: faSignal,
    faSignature: faSignature,
    faSimCard: faSimCard,
    faSink: faSink,
    faSitemap: faSitemap,
    faSkating: faSkating,
    faSkiing: faSkiing,
    faSkiingNordic: faSkiingNordic,
    faSkull: faSkull,
    faSkullCrossbones: faSkullCrossbones,
    faSlash: faSlash,
    faSleigh: faSleigh,
    faSlidersH: faSlidersH,
    faSmile: faSmile,
    faSmileBeam: faSmileBeam,
    faSmileWink: faSmileWink,
    faSmog: faSmog,
    faSmoking: faSmoking,
    faSmokingBan: faSmokingBan,
    faSms: faSms,
    faSnowboarding: faSnowboarding,
    faSnowflake: faSnowflake,
    faSnowman: faSnowman,
    faSnowplow: faSnowplow,
    faSoap: faSoap,
    faSocks: faSocks,
    faSolarPanel: faSolarPanel,
    faSort: faSort,
    faSortAlphaDown: faSortAlphaDown,
    faSortAlphaDownAlt: faSortAlphaDownAlt,
    faSortAlphaUp: faSortAlphaUp,
    faSortAlphaUpAlt: faSortAlphaUpAlt,
    faSortAmountDown: faSortAmountDown,
    faSortAmountDownAlt: faSortAmountDownAlt,
    faSortAmountUp: faSortAmountUp,
    faSortAmountUpAlt: faSortAmountUpAlt,
    faSortDown: faSortDown,
    faSortNumericDown: faSortNumericDown,
    faSortNumericDownAlt: faSortNumericDownAlt,
    faSortNumericUp: faSortNumericUp,
    faSortNumericUpAlt: faSortNumericUpAlt,
    faSortUp: faSortUp,
    faSpa: faSpa,
    faSpaceShuttle: faSpaceShuttle,
    faSpellCheck: faSpellCheck,
    faSpider: faSpider,
    faSpinner: faSpinner,
    faSplotch: faSplotch,
    faSprayCan: faSprayCan,
    faSquare: faSquare,
    faSquareFull: faSquareFull,
    faSquareRootAlt: faSquareRootAlt,
    faStamp: faStamp,
    faStar: faStar,
    faStarAndCrescent: faStarAndCrescent,
    faStarHalf: faStarHalf,
    faStarHalfAlt: faStarHalfAlt,
    faStarOfDavid: faStarOfDavid,
    faStarOfLife: faStarOfLife,
    faStepBackward: faStepBackward,
    faStepForward: faStepForward,
    faStethoscope: faStethoscope,
    faStickyNote: faStickyNote,
    faStop: faStop,
    faStopCircle: faStopCircle,
    faStopwatch: faStopwatch,
    faStopwatch20: faStopwatch20,
    faStore: faStore,
    faStoreAlt: faStoreAlt,
    faStoreAltSlash: faStoreAltSlash,
    faStoreSlash: faStoreSlash,
    faStream: faStream,
    faStreetView: faStreetView,
    faStrikethrough: faStrikethrough,
    faStroopwafel: faStroopwafel,
    faSubscript: faSubscript,
    faSubway: faSubway,
    faSuitcase: faSuitcase,
    faSuitcaseRolling: faSuitcaseRolling,
    faSun: faSun,
    faSuperscript: faSuperscript,
    faSurprise: faSurprise,
    faSwatchbook: faSwatchbook,
    faSwimmer: faSwimmer,
    faSwimmingPool: faSwimmingPool,
    faSynagogue: faSynagogue,
    faSync: faSync,
    faSyncAlt: faSyncAlt,
    faSyringe: faSyringe,
    faTable: faTable,
    faTableTennis: faTableTennis,
    faTablet: faTablet,
    faTabletAlt: faTabletAlt,
    faTablets: faTablets,
    faTachometerAlt: faTachometerAlt,
    faTag: faTag,
    faTags: faTags,
    faTape: faTape,
    faTasks: faTasks,
    faTaxi: faTaxi,
    faTeeth: faTeeth,
    faTeethOpen: faTeethOpen,
    faTemperatureHigh: faTemperatureHigh,
    faTemperatureLow: faTemperatureLow,
    faTenge: faTenge,
    faTerminal: faTerminal,
    faTextHeight: faTextHeight,
    faTextWidth: faTextWidth,
    faTh: faTh,
    faThLarge: faThLarge,
    faThList: faThList,
    faTheaterMasks: faTheaterMasks,
    faThermometer: faThermometer,
    faThermometerEmpty: faThermometerEmpty,
    faThermometerFull: faThermometerFull,
    faThermometerHalf: faThermometerHalf,
    faThermometerQuarter: faThermometerQuarter,
    faThermometerThreeQuarters: faThermometerThreeQuarters,
    faThumbsDown: faThumbsDown,
    faThumbsUp: faThumbsUp,
    faThumbtack: faThumbtack,
    faTicketAlt: faTicketAlt,
    faTimes: faTimes,
    faTimesCircle: faTimesCircle,
    faTint: faTint,
    faTintSlash: faTintSlash,
    faTired: faTired,
    faToggleOff: faToggleOff,
    faToggleOn: faToggleOn,
    faToilet: faToilet,
    faToiletPaper: faToiletPaper,
    faToiletPaperSlash: faToiletPaperSlash,
    faToolbox: faToolbox,
    faTools: faTools,
    faTooth: faTooth,
    faTorah: faTorah,
    faToriiGate: faToriiGate,
    faTractor: faTractor,
    faTrademark: faTrademark,
    faTrafficLight: faTrafficLight,
    faTrailer: faTrailer,
    faTrain: faTrain,
    faTram: faTram,
    faTransgender: faTransgender,
    faTransgenderAlt: faTransgenderAlt,
    faTrash: faTrash,
    faTrashAlt: faTrashAlt,
    faTrashRestore: faTrashRestore,
    faTrashRestoreAlt: faTrashRestoreAlt,
    faTree: faTree,
    faTrophy: faTrophy,
    faTruck: faTruck,
    faTruckLoading: faTruckLoading,
    faTruckMonster: faTruckMonster,
    faTruckMoving: faTruckMoving,
    faTruckPickup: faTruckPickup,
    faTshirt: faTshirt,
    faTty: faTty,
    faTv: faTv,
    faUmbrella: faUmbrella,
    faUmbrellaBeach: faUmbrellaBeach,
    faUnderline: faUnderline,
    faUndo: faUndo,
    faUndoAlt: faUndoAlt,
    faUniversalAccess: faUniversalAccess,
    faUniversity: faUniversity,
    faUnlink: faUnlink,
    faUnlock: faUnlock,
    faUnlockAlt: faUnlockAlt,
    faUpload: faUpload,
    faUser: faUser,
    faUserAlt: faUserAlt,
    faUserAltSlash: faUserAltSlash,
    faUserAstronaut: faUserAstronaut,
    faUserCheck: faUserCheck,
    faUserCircle: faUserCircle,
    faUserClock: faUserClock,
    faUserCog: faUserCog,
    faUserEdit: faUserEdit,
    faUserFriends: faUserFriends,
    faUserGraduate: faUserGraduate,
    faUserInjured: faUserInjured,
    faUserLock: faUserLock,
    faUserMd: faUserMd,
    faUserMinus: faUserMinus,
    faUserNinja: faUserNinja,
    faUserNurse: faUserNurse,
    faUserPlus: faUserPlus,
    faUserSecret: faUserSecret,
    faUserShield: faUserShield,
    faUserSlash: faUserSlash,
    faUserTag: faUserTag,
    faUserTie: faUserTie,
    faUserTimes: faUserTimes,
    faUsers: faUsers,
    faUsersCog: faUsersCog,
    faUsersSlash: faUsersSlash,
    faUtensilSpoon: faUtensilSpoon,
    faUtensils: faUtensils,
    faVectorSquare: faVectorSquare,
    faVenus: faVenus,
    faVenusDouble: faVenusDouble,
    faVenusMars: faVenusMars,
    faVest: faVest,
    faVestPatches: faVestPatches,
    faVial: faVial,
    faVials: faVials,
    faVideo: faVideo,
    faVideoSlash: faVideoSlash,
    faVihara: faVihara,
    faVirus: faVirus,
    faVirusSlash: faVirusSlash,
    faViruses: faViruses,
    faVoicemail: faVoicemail,
    faVolleyballBall: faVolleyballBall,
    faVolumeDown: faVolumeDown,
    faVolumeMute: faVolumeMute,
    faVolumeOff: faVolumeOff,
    faVolumeUp: faVolumeUp,
    faVoteYea: faVoteYea,
    faVrCardboard: faVrCardboard,
    faWalking: faWalking,
    faWallet: faWallet,
    faWarehouse: faWarehouse,
    faWater: faWater,
    faWaveSquare: faWaveSquare,
    faWeight: faWeight,
    faWeightHanging: faWeightHanging,
    faWheelchair: faWheelchair,
    faWifi: faWifi,
    faWind: faWind,
    faWindowClose: faWindowClose,
    faWindowMaximize: faWindowMaximize,
    faWindowMinimize: faWindowMinimize,
    faWindowRestore: faWindowRestore,
    faWineBottle: faWineBottle,
    faWineGlass: faWineGlass,
    faWineGlassAlt: faWineGlassAlt,
    faWonSign: faWonSign,
    faWrench: faWrench,
    faXRay: faXRay,
    faYenSign: faYenSign,
    faYinYang: faYinYang
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"i9WOp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "indicons", function() {
    return indicons;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var indicons = {
    "indico-o-white": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM50 19.4c-16.9 0-30.6 13.7-30.6 30.6S33.1 80.6 50 80.6 80.6 66.9 80.6 50 66.9 19.4 50 19.4zm0 21.7c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
    })),
    account: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 8c23.2 0 42 18.8 42 42 0 9.9-3.4 19-9.2 26.2C75.6 65.8 63.6 59 50 59s-25.6 6.8-32.8 17.2C11.4 69 8 59.9 8 50 8 26.8 26.8 8 50 8zM22.9 82c5.7-9 15.7-15 27.1-15s21.4 6 27.1 15C69.8 88.2 60.3 92 50 92s-19.8-3.8-27.1-10zM50 56c11.6 0 21-9.4 21-21s-9.4-21-21-21-21 9.4-21 21 9.4 21 21 21zm0-34c7.2 0 13 5.8 13 13s-5.8 13-13 13-13-5.8-13-13 5.8-13 13-13z"
    })),
    address: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m24 33.7q5.35-4.3 8.1-8.25t2.75-7.5q0-3.05-1.1-5.175t-2.75-3.475-3.55-1.95-3.45-0.6-3.45 0.6-3.55 1.95-2.75 3.475-1.1 5.175q0 3.55 2.75 7.5t8.1 8.25zm0 2.85q-6.65-5-9.9-9.6t-3.25-9q0-3.35 1.2-5.85t3.075-4.2 4.225-2.55 4.65-0.85 4.65 0.85 4.225 2.55 3.075 4.2 1.2 5.85q0 4.4-3.25 9t-9.9 9.6zm0-15.8q1.3 0 2.225-0.925t0.925-2.225-0.925-2.2-2.225-0.9-2.225 0.925-0.925 2.225 0.925 2.2 2.225 0.9zm-13.15 22.75v-2.25h26.3v2.25zm13.15-25.55z"
    })),
    "api-doc": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm33.3 47.5L69.1 33.3c-1.3-1.3-3.6-1.3-4.9 0-.7.7-1 1.6-1 2.4 0 .8.4 1.8 1 2.4L76 49.9 64.2 61.7c-.7.7-1 1.5-1 2.4 0 .9.4 1.8 1 2.4s1.5 1 2.4 1c.9 0 1.8-.4 2.4-1l14.2-14.2c.7-.7 1-1.5 1-2.4.1-.9-.3-1.8-.9-2.4zM24 49.9l11.8-11.7c1.4-1.4 1.4-3.7 0-5.1-1.3-1.3-3.6-1.3-4.9 0L16.7 47.5c-.7.7-1 1.6-1 2.4s.4 1.8 1 2.4l14.2 14.3c.7.7 1.5 1 2.4 1 .9 0 1.8-.4 2.4-1 .7-.7 1-1.6 1-2.4 0-.9-.4-1.8-1-2.4L24 49.9zM58.7 31c-.4-.8-1.2-1.4-2.2-1.8-1.9-.6-3.8.4-4.3 2.2L41.1 66.5c-.2.9-.2 1.8.2 2.6s1.1 1.4 2 1.7c.4.2.7.2 1.2.2.2 0 .4 0 .7-.1 1.2-.3 2.3-1.2 2.7-2.4l11.4-35c-.1-.9-.1-1.8-.6-2.5z"
    })),
    "arrow-dots": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M19 10c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9zm11-9c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM30 21c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM50 41c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM30 61c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM10 81c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
    })),
    "arrow-down": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M41.4,69.3L41.4,69.3L41.4,69.3z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "arrow",
        d: "M7.4,59l39.8,39.7c1.7,1.7,3.8,1.7,5.5,0L92.6,59c0.8-0.8,0.8-1.9,0-2.7l-2.6-2.6c-0.8-0.8-1.9-0.8-2.7,0\n        L53.8,87.1V1.9C53.8,0.8,53,0,51.9,0h-3.7c-1.1,0-1.9,0.9-1.9,1.9v85.1L12.7,53.6c-0.8-0.8-1.9-0.8-2.7,0l-2.6,2.6\n        C6.6,57,6.7,58.2,7.4,59z"
    })),
    "arrow-up-circle": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zm-28.6-6.1L53.3 25.8c-.5-.6-1.5-1.8-3.3-1.8-1.7 0-2.8 1.2-3.4 1.8L28.5 43.9c-1.4 1.4-1.4 3.7 0 5.1 1.4 1.4 3.7 1.4 5.1 0L46 36.6V70c0 2.2 1.8 4 4 4s4-1.8 4-4V36.6L66.3 49c1.4 1.4 3.7 1.4 5.1 0 1.4-1.4 1.4-3.7 0-5.1z"
    })),
    "arrows-cursor": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M68.8 83.2L53.3 98.6c-1.8 1.8-4.8 1.8-6.6 0L31.2 83.2c-3-3-.9-8 3.3-8h10V55.5H24.8v10c0 4.2-5 6.3-8 3.3L1.4 53.3c-1.8-1.8-1.8-4.8 0-6.6l15.5-15.5c3-3 8-.9 8 3.3v10h19.7V24.8h-10c-4.2 0-6.3-5-3.3-8L46.7 1.4c1.8-1.8 4.8-1.8 6.6 0l15.5 15.5c3 3 .9 8-3.3 8h-10v19.7h19.7v-10c0-4.2 5-6.3 8-3.3l15.5 15.5c1.8 1.8 1.8 4.8 0 6.6L83.2 68.8c-3 3-8 .9-8-3.3v-10H55.5v19.7h10c4.2 0 6.2 5 3.3 8z"
    })),
    branch: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 642 514"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M385 321H257c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V353c0-17.67-14.33-32-32-32zM193 33c0-17.67-14.33-32-32-32H33C15.33 1 1 15.33 1 33v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C212.98 301.98 233.4 289 257 289h.28L193 176.51V129h224V65H193V33zM609 1H481c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V33c0-17.67-14.33-32-32-32z",
        fill: "currentColor"
    })),
    "check-circle": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM78 30.7c-.7-1-1.9-1.5-3.5-1.5-1.2 0-2.3.5-3.3 1.5C65 37 45.3 56.6 42.4 59.4L28.8 48c-1-.9-2.2-1.3-3.5-1.2-1.3.1-2.5.7-3.3 1.8-.9 1-1.3 2.2-1.2 3.5.1 1.3.7 2.5 1.8 3.3l16.8 14.2c.9.7 2 1.1 3.1 1.1 1.3 0 2.5-.5 3.4-1.4 6.8-6.6 28.7-28.7 32-32 1.8-1.7 1.8-4.6.1-6.6z"
    })),
    check: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M96.4 18.5c-1.4-1.6-3.4-2.4-6.3-2.4-2.1 0-4.3 1-6 2.7-10.9 11.1-41.6 41.6-46.7 46.7l-22-18c-1.8-1.6-4.1-2.3-6.4-2.1-2.3.2-4.4 1.3-6 3.1-3.2 3.7-2.8 9.2 1 12.4l27.9 23c1.6 1.3 3.6 2 5.6 2 2.3 0 4.6-.8 6.1-2.5 12-11.8 46.8-46.7 52.6-52.6 3.3-3.2 3.4-8.6.2-12.3z"
    })),
    checkbox: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1 1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        display: "none",
        d: "m10.3 97.3c-2.8 0-5.1-1-7.1-2.9-1.9-1.9-2.9-4.3-2.9-7.1v-74.5c0-2.8 1-5.2 2.9-7.1s4.3-3 7.1-3h74.5c1.2 0 2.4 0.3 3.7 0.9s2.3 1.2 3 1.9l-7.8 7.8v-0.5h-73.4v74.5h74.5v-42l10.1-10.1v52.1c0 2.8-1 5.1-3 7.1-2 1.9-4.4 2.9-7.1 2.9h-74.5zm35.2-23.4-28-28 5.9-5.9 22.1 22.2 49-49 5.8 5.9-54.8 54.8z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M45.1,74.3L45.1,74.3H45L19.1,48.4l9.7-9.7L45.1,55L90.1,9.9l9.7,9.7L45.1,74.3z M81,51v32.5H13.9V16.4h57L84.5,2.9  c-0.6-0.1-1.2-0.1-1.7-0.1H12.1c-6.6,0-12,5.4-12,12v70.6c0,6.6,5.4,12,12,12h70.6c6.6,0,12-5.4,12-12v-48L81,51z"
    }))),
    "chevron-down": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M46.1 78.7L1.6 34.2c-2.1-2.1-2.1-5.6 0-7.8l5.2-5.2c2.1-2.1 5.6-2.1 7.8 0L50 56.5l35.4-35.3c2.1-2.1 5.6-2.1 7.8 0l5.2 5.2c2.1 2.1 2.1 5.6 0 7.8L53.9 78.7c-2.2 2.2-5.6 2.2-7.8 0z"
    })),
    "chevron-left": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.3 46.1L65.8 1.6c2.1-2.1 5.6-2.1 7.8 0l5.2 5.2c2.1 2.1 2.1 5.6 0 7.8L43.5 50l35.3 35.4c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L21.3 53.9c-2.2-2.2-2.2-5.6 0-7.8z"
    })),
    "chevron-right": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M78.7 53.9L34.2 98.4c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8L56.5 50 21.3 14.6c-2.1-2.1-2.1-5.6 0-7.8l5.2-5.2c2.1-2.1 5.6-2.1 7.8 0l44.5 44.5c2.1 2.2 2.1 5.6-.1 7.8z"
    })),
    "chevron-up": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.9 21.3l44.5 44.5c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L50 43.5 14.6 78.7c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8l44.5-44.5c2.2-2.1 5.6-2.1 7.8.1z"
    })),
    "classification-document": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.9 21.3l44.5 44.5c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L50 43.5 14.6 78.7c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8l44.5-44.5c2.2-2.1 5.6-2.1 7.8.1z"
    })),
    "classification-image": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M91,0H9C4,0,0,4,0,9v82c0,5,4,9,9,9h82c5,0,9-4,9-9V9C100,4,96,0,91,0z M90,90H10V10h80V90z M21.2,77.9L40,59l9.5,9.5l11.6-14.6l19.2,24.1H21.2z M29.9,37.6c-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.8-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8c1.9-1.9,4.1-2.8,6.8-2.8c2.7,0,5,0.9,6.8,2.8c1.8,1.9,2.8,4.1,2.8,6.8c0,2.7-0.9,5-2.8,6.8C34.9,36.7,32.6,37.6,29.9,37.6z"
    })),
    "classification-page": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80,32v58H20V10h38v22H80z M62.9,0H19c-5,0-9,4-9,9v82c0,5,4,9,9,9h62c5,0,9-4,9-9V27.1L62.9,0z"
    })),
    "classify-and-unbundle": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10,46V9c0-5,4-9,9-9h43.9L90,27.1V46H80V32H58V10H20v36H10z M80,72v18H20V72H10v19c0,5,4,9,9,9h62c5,0,9-4,9-9V72H80zM36,64h28V54H36V64z M28,54H0v10h28V54z M72,54v10h28V54H72z"
    })),
    clipboard: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10,46V9c0-5,4-9,9-9h43.9L90,27.1V46H80V32H58V10H20v36H10z M80,72v18H20V72H10v19c0,5,4,9,9,9h62c5,0,9-4,9-9V72H80zM36,64h28V54H36V64z M28,54H0v10h28V54z M72,54v10h28V54H72z"
    })),
    "coffee-1": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M87.9 43.8h-1.2v-3.3-.2-.2c0-1.9-1.6-3.5-3.5-3.5h-79c-1.5 0-2.8.9-3.3 2.3-.2.5-.4 1-.4 1.6v4.8c0 1.1.1 2.1.1 3.1C1.7 63.7 11 76.8 24.1 83.3c.2 3.4 3 6.1 6.4 6.1h25.9c.3 0 .6 0 .9-.1 2.8-.5 5-2.9 5.2-5.8 7.5-3.6 13.8-9.3 18.1-16.4.3.1.7.2 1.1.2h6.2c6.5 0 11.8-5.3 11.8-11.8-.1-6.4-5.3-11.7-11.8-11.7zm-8.5 1.9c-.2 19.1-15.8 34.6-35 34.6h-1.6c-19.2 0-34.8-15.5-35-34.6v-2h71.7l-.1 2zm8.5 15.2h-4.2c1.3-3.3 2.2-6.9 2.7-10.6h1.5c2.9 0 5.3 2.4 5.3 5.3s-2.4 5.3-5.3 5.3zm-3.7 31.9H2.6c0 3.6 2.9 6.4 6.5 6.4h69.3c3.5 0 6.4-2.9 6.5-6.4h-.7zM45 .7c-1-1-2.6-1-3.5 0-4.6 4.6-4.6 12.1 0 16.7 2.6 2.7 2.6 6.9 0 9.6-1 1-1 2.6 0 3.5s2.6 1 3.5 0c4.6-4.6 4.6-12.1 0-16.7-2.6-2.7-2.6-6.9 0-9.6 1-.9 1-2.5 0-3.5zM29.8 8.3c-1-1-2.6-1-3.5 0-3.6 3.6-3.6 9.3 0 12.9 1.6 1.6 1.6 4.2 0 5.8-1 1-1 2.6 0 3.5 1 1 2.6 1 3.5 0 3.6-3.6 3.6-9.3 0-12.9-1.6-1.6-1.6-4.2 0-5.8 1-1 1-2.6 0-3.5zm30.4 0c-1-1-2.6-1-3.5 0-3.6 3.6-3.6 9.3 0 12.9 1.6 1.6 1.6 4.2 0 5.8-1 1-1 2.6 0 3.5 1 1 2.6 1 3.5 0 3.6-3.6 3.6-9.3 0-12.9-1.6-1.6-1.6-4.2 0-5.8.9-1 .9-2.6 0-3.5z"
    })),
    "coffee-2": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M87.9 43.8h-1.2v-3.3-.2-.2c0-1.9-1.6-3.5-3.5-3.5h-79c-1.5 0-2.8.9-3.3 2.3-.2.5-.4 1-.4 1.6v4.8c0 1.1.1 2.1.1 3.1C1.7 63.7 11 76.8 24.1 83.3c.2 3.4 3 6.1 6.4 6.1h25.9c.3 0 .6 0 .9-.1 2.8-.5 5-2.9 5.2-5.8 7.5-3.6 13.8-9.3 18.1-16.4.3.1.7.2 1.1.2h6.2c6.5 0 11.8-5.3 11.8-11.8-.1-6.4-5.3-11.7-11.8-11.7zm-8.5 1.9c-.2 19.1-15.8 34.6-35 34.6h-1.6c-19.2 0-34.8-15.5-35-34.6v-2h71.7l-.1 2zm8.5 15.2h-4.2c1.3-3.3 2.2-6.9 2.7-10.6h1.5c2.9 0 5.3 2.4 5.3 5.3s-2.4 5.3-5.3 5.3zm-3.7 31.9H2.6c0 3.6 2.9 6.4 6.5 6.4h69.3c3.5 0 6.4-2.9 6.5-6.4h-.7zM41.5.7c-1 1-1 2.6 0 3.5 2.6 2.7 2.6 6.9 0 9.6-4.6 4.6-4.6 12.1 0 16.7.9 1 2.5.9 3.5 0s1-2.5 0-3.5c-2.6-2.7-2.6-6.9 0-9.6 4.6-4.6 4.6-12.1 0-16.7-.9-1-2.5-1-3.5 0zm15.2 11.1c1.6 1.6 1.6 4.2 0 5.8-3.6 3.6-3.6 9.3 0 12.9.9 1 2.5 1 3.5 0 1-.9 1-2.5 0-3.5-1.6-1.6-1.6-4.2 0-5.8 3.6-3.6 3.6-9.3 0-12.9-.9-1-2.5-1-3.5 0-1 .9-1 2.5 0 3.5zM26.3 8.3c-.9.9-.9 2.5 0 3.5 1.6 1.6 1.6 4.2 0 5.8-3.6 3.6-3.6 9.3 0 12.9.9 1 2.5 1 3.5 0 1-.9 1-2.5 0-3.5-1.6-1.6-1.6-4.2 0-5.8 3.6-3.6 3.6-9.3 0-12.9-.9-1-2.5-1-3.5 0z"
    })),
    "coffee-fail": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80.5 3l-.7.7-2.1-2-.1-.1-.1-.1c-1.2-1.2-3.2-1.2-4.3 0l-49 49.2c-.9.9-1.2 2.3-.6 3.5.2.4.4.9.7 1.2l3 3c.7.7 1.4 1.2 2 1.9 10.2 8.8 24.1 11.1 36.3 7 2.2 2 5.7 1.9 7.8-.2l.1-.1.1-.1 15.9-16c.2-.2.4-.4.5-.6 1.4-2.1 1.3-4.9-.4-6.8 2.4-6.9 2.8-14.4 1-21.4.2-.1.6-.3.8-.6l3.8-3.9c4-4 4-10.6 0-14.7C91-1 84.5-1 80.5 3zm-4.1 6.5c11.8 12 11.8 31.3-.1 43.2l-1 1c-11.9 12-31.2 12.1-43.2.4l-1.2-1.2L75.2 8.2l1.2 1.3zm14.7 4.1l-2.6 2.6c-1.3-2.9-2.9-5.6-4.9-8.2l.9-.9c1.8-1.8 4.8-1.8 6.6 0 1.8 1.7 1.8 4.7 0 6.5zM14.5 38.4c3.6 0 7.8 1.1 10.3 3.5.3.3 0 .8-.4.7-.9-.2-2-.3-2.8-.3-11.7 0-8.3 10.9-15.3 10.9-1.8 0-4.4-1-4.4-4.7 0-3.9 3.7-10.1 12.6-10.1zm11.2-1.9c.1.3-.3.5-.6.3-1.5-1.4-4.2-3.4-11.9-2.7-3 .3-6.4-2.1-4.7-5.1 2.1-3.7 9.3-2 11.6-.6 3.1 1.9 5.2 5.3 5.6 8.1zm47.5 54.7c-1.8.2-5.9 1.2-2.5 2.8 2.7 1.3-.7 6.1-29.1 6-23.6-.1-33.5-3.5-32.5-6.9.7-2.5 5.4-3.4 12.7-4.5 1.5-.2 3.2-1.4.2-2.6-1.4-.6-2.9-1.5-2.9-2.6 0-3.9 18.7-5.5 41.6-5.5 22.9 0 36.7 3.1 36.7 7 .1 3.2-6.6 4.4-24.2 6.3z"
    })),
    coffeecup: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 150 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M132.6 18.8h-1.8v-5-.3-.3c0-2.9-2.4-5.3-5.3-5.3H6c-2.3 0-4.2 1.4-5 3.5-.3.8-.6 1.5-.6 2.4v7.3c0 1.7.2 3.2.2 4.7 1.7 23.1 15.7 42.9 35.5 52.8.3 5.1 4.5 9.2 9.7 9.2H85c.5 0 .9 0 1.4-.2 4.2-.8 7.6-4.4 7.9-8.8 11.3-5.4 20.9-14.1 27.4-24.8.5.2 1.1.3 1.7.3h9.4c9.8 0 17.8-8 17.8-17.8-.3-9.7-8.2-17.7-18-17.7zm-12.9 2.9C119.4 50.5 95.8 74 66.8 74h-2.4c-29 0-52.6-23.4-52.9-52.3v-3h108.4l-.2 3zm12.9 22.9h-6.4c2-5 3.3-10.4 4.1-16h2.3c4.4 0 8 3.6 8 8s-3.6 8-8 8zM127 92.9H3.6c0 5.4 4.4 9.7 9.8 9.7h104.8c5.3 0 9.7-4.4 9.8-9.7h-1z"
    })),
    coffeesteam: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 150 76",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.1 1.6c-1.3 2.6-1.3 5.7 0 8.2l3.8 7.5c2.3 4.6 2.3 10.1 0 14.7l-3.8 7.5c-1.3 2.6-1.3 5.7 0 8.2l3.8 7.5c2.3 4.6 2.3 10.1 0 14.7l-3 5.9h-7.7c.2-.5.4-1.1.7-1.6l3.8-7.5c1.3-2.6 1.3-5.7 0-8.2L59.9 51c-2.3-4.6-2.3-10.1 0-14.7l3.8-7.5c1.3-2.6 1.3-5.7 0-8.2l-3.8-7.5C57.8 9 57.6 4.2 59.2 0h7.7l-.8 1.6zM83.9 0h-7.7c-1.6 4.2-1.4 9 .7 13.1l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-2.3 4.6-2.3 10.1 0 14.7l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-.3.5-.5 1.1-.7 1.6h7.7l3-5.9c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l3.8-7.5c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l.8-1.6zm-34 0h-7.7c-1.6 4.2-1.4 9 .7 13.1l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-2.3 4.6-2.3 10.1 0 14.7l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-.3.5-.5 1.1-.7 1.6h7.7l3-5.9c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l3.8-7.5c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l.8-1.6z"
    })),
    "company-name": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m8.05 41.15v-26.9h10.7v-5.75l5.25-5 5.25 5v13.95h10.7v18.7zm2.25-2.25h5.95v-5.95h-5.95zm0-8.25h5.95v-5.95h-5.95zm0-8.2h5.95v-5.95h-5.95zm10.7 16.45h6v-5.95h-6zm0-8.25h6v-5.95h-6zm0-8.2h6v-5.95h-6zm0-8.2h6v-5.95h-6zm10.75 24.65h5.95v-5.95h-5.95zm0-8.25h5.95v-5.95h-5.95z"
    })),
    "confidence-bar-1": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 67v33h16V56.3z"
    })),
    "confidence-bar-2": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 48.2V100h16V37.5z"
    })),
    "confidence-bar-3": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 29.5V100h16V18.8z"
    })),
    "confidence-bar-4": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M16 0v100H0V10.7z"
    })),
    "confidence-bars": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 0v100H84V10.7L100 0zM0 67v33h16V56.3L0 67zm28-18.8V100h16V37.5L28 48.2zm28-18.7V100h16V18.8L56 29.5z"
    })),
    configure: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M96.9 75H31.2v-3.1c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1V75H3.1C1.4 75 0 76.4 0 78.1v6.2c0 1.7 1.4 3.1 3.1 3.1h15.6v3.1c0 1.7 1.4 3.1 3.1 3.1H28c1.7 0 3.1-1.4 3.1-3.1v-3.1h65.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.7-1.2-3.1-2.9-3.1zm0-31.2H81.2v-3.1c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1v3.1H3.1c-1.7 0-3.1 1.4-3.1 3.1v6.2c0 1.7 1.4 3.1 3.1 3.1h65.6v3.1c0 1.7 1.4 3.1 3.1 3.1H78c1.7 0 3.1-1.4 3.1-3.1v-3.1h15.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.7-1.2-3.1-2.9-3.1zm0-31.3H56.2V9.4c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1v3.1H3.1c-1.7 0-3.1 1.4-3.1 3.1v6.2C0 23.6 1.4 25 3.1 25h40.6v3.1c0 1.7 1.4 3.1 3.1 3.1H53c1.7 0 3.1-1.4 3.1-3.1V25h40.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.8-1.2-3.2-2.9-3.2z"
    })),
    crowdlabel: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M55 .2C78.6 2.6 97.4 21.4 99.8 45H89.7C87.4 26.9 73.1 12.6 55 10.3V.2zM10.3 45C12.6 26.9 26.9 12.6 45 10.3V.2C21.4 2.6 2.6 21.4.2 45h10.1zm79.4 10C87.4 73.1 73.1 87.4 55 89.7v10.1C78.6 97.4 97.4 78.6 99.8 55H89.7zM45 89.7C26.9 87.4 12.6 73.1 10.3 55H.2C2.6 78.6 21.4 97.4 45 99.8V89.7zM71 45H55V29c0-2.8-2.2-5-5-5s-5 2.2-5 5v16H29c-2.8 0-5 2.2-5 5s2.2 5 5 5h16v16c0 2.8 2.2 5 5 5s5-2.2 5-5V55h16c2.8 0 5-2.2 5-5s-2.3-5-5-5z"
    })),
    currency: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m26.75 26.15q-2.1 0-3.55-1.45t-1.45-3.55 1.45-3.55 3.55-1.45 3.55 1.45 1.45 3.55-1.45 3.55-3.55 1.45zm-14.65 6.95q-1.15 0-2-0.875t-0.85-2.025v-18.1q0-1.15 0.85-2t2-0.85h29.3q1.2 0 2.05 0.85t0.85 2v18.1q0 1.15-0.85 2.025t-2.05 0.875zm3.75-2.3h21.85q0-1.8 1.275-3.075t3.075-1.275v-10.6q-1.8 0-3.075-1.275t-1.275-3.075h-21.85q0 1.8-1.275 3.075t-3.075 1.275v10.6q1.8 0 3.075 1.275t1.275 3.075zm22.5 7.8h-31.75q-1.2 0-2.05-0.85t-0.85-2v-20.55h2.25v20.55q0 0.2 0.2 0.4t0.45 0.2h31.75zm-26.25-7.8h-0.6t0-0.175 0-0.425v-18.1q0-0.25 0-0.425t0-0.175h0.6q-0.25 0-0.425 0.175t-0.175 0.425v18.1q0 0.25 0.175 0.425t0.425 0.175z"
    })),
    dashboard: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M99.8 56.9c0 13.7-5.5 26.1-14.4 35.1 0 0-1 1-2.2 1-.7 0-1.5-.3-2.1-.9l-7.4-7.4c-1.2-1.1-1.2-3 0-4.2 1.1-1.2 3-1.2 4.2 0l2.4 2.4c5.4-6.3 8.9-14.3 9.5-23.1H86c-1.7 0-3-1.3-3-3s1.3-3 3-3h3.7c-.3-5-1.7-9.7-3.8-14 2.4-2.9 4.8-5.8 7-8.5 4.4 7.4 7 16.1 6.9 25.6zM22.1 80.7L19.8 83c-5.4-6.3-9-14.3-9.6-23h3.7c1.7 0 3-1.3 3-3s-1.3-3-3-3h-3.8c.6-8.8 4.1-16.8 9.5-23.1l2.4 2.4c.6.6 1.4.9 2.1.9.7 0 1.5-.3 2.1-.9 1.2-1.2 1.2-3.1 0-4.2l-2.4-2.4c6.3-5.4 14.3-9 23-9.6v3.7c0 1.7 1.3 3 3 3s3-1.3 3-3V17c4.8.3 9.4 1.6 13.6 3.4 2.8-2.4 5.6-4.8 8.3-7.1C67.4 9.2 59 6.8 50 6.8c-27.6 0-50 22.4-50 50 0 13.7 5.5 26.1 14.4 35.1.7.7 1.7 1.3 2.4 1.3s1.5-.3 2.1-.9l7.4-7.4c1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0zm63.7-60.4c-.9-.9-2.3-1.1-3.4-.4l-.1.1c-9.7 8.3-23.4 20-29.9 25.3-.7-.2-1.6-.3-2.4-.3-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12c0-1.1-.2-2.1-.4-3.1 5.3-6.7 16.5-20.4 24.6-30.2.7-1 .6-2.4-.4-3.4z"
    })),
    "data-and-access": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90.8 51H49V10.1c-1-.1-2-.1-3-.1C21.1 10 1 30.1 1 55s20.1 45 45 45 45-20.1 45-45c0-1.3-.1-2.7-.2-4zM46 90c-19.3 0-35-15.7-35-35 0-16.9 12-31 28-34.3V61h41.5C77.6 77.4 63.3 90 46 90zM57 .1V43h42.9C98.9 19.7 80.3 1.1 57 .1zM67 33V12.1c9.7 3.5 17.3 11.2 20.9 20.9H67z"
    })),
    database: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 448 512",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    })),
    date: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m24 28.15q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm16 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 7.85q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm16 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-22.1 7q-1.2 0-2.05-0.85t-0.85-2.05v-28.95q0-1.15 0.85-2.025t2.05-0.875h3.7v-3.5h2.5v3.5h15.9v-3.5h2.45v3.5h3.65q1.2 0 2.05 0.875t0.85 2.025v28.95q0 1.2-0.85 2.05t-2.05 0.85zm0-2.25h28.2q0.25 0 0.45-0.2t0.2-0.45v-19.85h-29.5v19.85q0 0.25 0.2 0.45t0.45 0.2zm-0.65-22.75h29.5v-6.85q0-0.25-0.2-0.425t-0.45-0.175h-28.2q-0.25 0-0.45 0.175t-0.2 0.425zm0 0v-6.85q0-0.25 0-0.425t0-0.175 0 0.175 0 0.425v6.85z"
    })),
    draggable: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 322 514",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m88 352c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48zm192 0c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zm-240-32c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48zm240-128c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zm-240-32c-22.09 0-40-17.9-40-40v-48c0-22.09 17.91-40 40-40h48c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40h-48zm240-128c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.09 17.9-40 40-40h48z"
    })),
    droplet: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M53.5 1.9C52.7.7 51.4 0 50 0s-2.7.7-3.5 1.9c-3.1 4.8-30.1 47.6-30.1 64.6C16.5 85 31.5 100 50 100s33.5-15 33.5-33.5c0-17-27-59.8-30-64.6zm-3.4 83.9c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1c6.5 0 11.8-5.3 11.8-11.8 0-2.3 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1c0 11-9 20-20 20z"
    })),
    edit: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M68 12.2l8.8-8.8C79.9.3 84.8.3 88 3.3l8.7 8.7c3 3 3 8-.1 11.2L87.8 32 68 12.2zM32.5 87.3l49.7-49.7-19.8-19.8-49.7 49.7 19.8 19.8zM7.1 73.1c-.5.5-.9 1.2-1.1 2L1.1 95.7c-.4 2 1.3 3.6 3.2 3.2l20.8-5.1c.8-.2 1.4-.5 2-1.1l-20-19.6z"
    })),
    education: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50.9 57.2c-.6 0-1.2-.1-1.9-.3l-28.6-9.5c-.5 1.3-.8 3.1-.8 5.6 1.9 1.1 3.7 3.3 3.7 7 0 2.3-1.1 3.9-2.1 5 4.2 4.9 15.9 8.5 29.7 8.5 17.4 0 31.4-5.6 31.4-12.5V47.1L52.7 57c-.6.1-1.2.2-1.8.2zm47.8-24.8L51.5 16.7c-.4-.1-.8-.1-1.2 0L3.1 32.4c-.8.3-1.3 1-1.3 1.9 0 .8.5 1.6 1.3 1.9l10.8 3.6c-2.5 2.9-3.9 7-4.5 13.6-1.7.8-2.9 2.5-2.9 4.5 0 2.1 1.2 3.8 3 4.6C8 75.8 0 80.3 0 81.4c0 .6 6.2 3.9 7.7 3.9 2.3 0 7.7-3.9 7.7-12.2 0-4.9-.4-8.6-.9-11.3 1.3-.9 2.1-2.3 2.1-4 0-1.8-1-3.4-2.5-4.3.8-10.9 4.2-12.7 12.4-16.1.8-.3 2.4-.9 3.3-1.3 1.6-.7 3.1-1.2 4.4-1.8 4.5-1.8 8.3-3.2 11.2-4.3 3.2-1.1 4.6-1.5 4.6-1.6 1.2-.4 2.6.2 3 1.5.4 1.2-.2 2.6-1.5 3-.1 0-5.6 1.6-20 7.5-.9.4-1.8.7-2.6 1.1-1.7.7-3.1 1.2-4.3 1.8l25.6 8.5c.2.1.4.1.6.1.2 0 .4 0 .6-.1l47.1-15.7c.8-.3 1.3-1 1.3-1.9.2-.7-.3-1.5-1.1-1.8z"
    })),
    ellipsis: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M64.5 50c0 8-6.5 14.5-14.5 14.5S35.5 58 35.5 50 42 35.5 50 35.5 64.5 42 64.5 50zm21-14.5C77.5 35.5 71 42 71 50s6.5 14.5 14.5 14.5S100 58 100 50s-6.5-14.5-14.5-14.5zm-71 0C6.5 35.5 0 42 0 50s6.5 14.5 14.5 14.5S29 58 29 50s-6.5-14.5-14.5-14.5z"
    })),
    "elmos-fire": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.1 38.3l-7.7 16.1L46 46l16.1-7.7m12.8-12.8l-33.4 16-16 33.4 33.4-16 16-33.4zM50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0z"
    })),
    email: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 25.6V21c0-3.9 3.2-7 7-7h86c3.8 0 7 3.1 7 7v4.6L52.8 46.2c-1.8.8-3.8.8-5.6 0L0 25.6zm52.8 31.7c-1.8.8-3.9.8-5.7 0L0 36.7V79c0 3.8 3.2 7 7 7h86c3.8 0 7-3.2 7-7V36.7L52.8 57.3z"
    })),
    enterprise: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59 25H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm41 22.5c0 1.5-1 2.5-3 2.5H3c-2 0-3-1-3-2.5S1 95 3 95h4V38c0-1 1-2 2-2h5v-6c0-1 1-2 2-2h9V10c0-1 1-2 2-2h8V2c0-1 1-2 2-2h26c1 0 2 1 2 2v6h8c1 0 2 1 2 2v18h9c1 0 2 1 2 2v6h5c1 0 2 1 2 2v57h4c2 0 3 1 3 2.5zM75 38h7v-6h-7v6zM39 10h22V4H39v6zM19 38h6v-6h-6v6zm6 57V41H13v54h12zm45 0V13H30v82h40zm18 0V41H75v54h13z"
    })),
    "exclamation-circle": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M96,50c0,25.4-20.6,46-46,46S4,75.4,4,50\n	C4,24.6,24.6,4,50,4S96,24.6,96,50z M50,59.3c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S54.7,59.3,50,59.3z\n	 M41.9,28.6l1.4,25.2c0.1,1.2,1,2.1,2.2,2.1h9c1.2,0,2.2-0.9,2.2-2.1l1.4-25.2c0.1-1.3-0.9-2.3-2.2-2.3H44.1\n	C42.8,26.3,41.8,27.3,41.9,28.6L41.9,28.6z"
    })),
    "exclamation-circle-stroke": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFFFFF",
        d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0L50,0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F95359",
        d: "M96,50c0,25.4-20.6,46-46,46S4,75.4,4,50\n	C4,24.6,24.6,4,50,4S96,24.6,96,50z M50,59.3c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S54.7,59.3,50,59.3z\n	 M41.9,28.6l1.4,25.2c0.1,1.2,1,2.1,2.2,2.1h9c1.2,0,2.2-0.9,2.2-2.1l1.4-25.2c0.1-1.3-0.9-2.3-2.2-2.3H44.1\n	C42.8,26.3,41.8,27.3,41.9,28.6L41.9,28.6z"
    })),
    extraction: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M66.7 26.7c0-1.1-.4-2.2-1.2-2.9l-17-17c-.8-.8-1.8-1.2-3-1.2h-1.1v22.2h22.2v-1.1zM99.1 59L82.5 42.3c-1.8-1.8-4.8-.5-4.8 2v11.3h-11v11.1h11.1V78c0 2.5 3 3.7 4.8 2l16.6-16.8c1.1-1.2 1.1-3-.1-4.2zm-65.8 4.9v-5.6c0-1.5 1.3-2.8 2.8-2.8h30.6V33.3H43.1c-2.3 0-4.2-1.9-4.2-4.2V5.6H4.2C1.9 5.6 0 7.4 0 9.7v80.6c0 2.3 1.9 4.2 4.2 4.2h58.3c2.3 0 4.2-1.9 4.2-4.2V66.7H36.1c-1.5 0-2.8-1.3-2.8-2.8z"
    })),
    eye: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 18 12",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M17.891 5.544C16.197 2.237 12.841 0 9 0 5.158 0 1.802 2.239.109 5.544a1.01 1.01 0 0 0 0 .912C1.803 9.763 5.159 12 9 12c3.842 0 7.197-2.239 8.891-5.544a1.01 1.01 0 0 0 0-.912zM9 10.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM9 3a2.978 2.978 0 0 0-.791.118 1.495 1.495 0 0 1-2.09 2.091A2.993 2.993 0 1 0 9 3z"
    })),
    file: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7v-64H60.9c-2.5 0-4.7-2.2-4.7-4.7zm31.3-2.8V25h-25V0h1.2c1.2 0 2.4.5 3.3 1.4l19.1 19.1c.9.9 1.4 2.1 1.4 3.3z"
    })),
    fileHappy: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.2,26.6V0h-39c-2.6,0-4.7,2.1-4.7,4.7v90.6c0,2.6,2.1,4.7,4.7,4.7h65.6c2.6,0,4.7-2.1,4.7-4.7v-64H60.9 C58.4,31.3,56.2,29.1,56.2,26.6z M31.3,51.5c-2,0-3.7-1.6-3.7-3.7c0-2,1.6-3.7,3.7-3.7c2,0,3.7,1.6,3.7,3.7S33.3,51.5,31.3,51.5z M68.7,44.2c2,0,3.7,1.6,3.7,3.7c0,2-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7S66.7,44.2,68.7,44.2z M61.4,63.6c0,6.2-5,11.2-11.2,11.2 S39,69.8,39,63.6l0,0H61.4z M87.5,23.8V25h-25V0h1.2c1.2,0,2.4,0.5,3.3,1.4l19.1,19.1C87,21.4,87.5,22.6,87.5,23.8z"
    })),
    filter: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M95.3 0H4.7C.5 0-1.6 5.1 1.4 8l36.1 36.1v40.2c0 1.5.7 3 2 3.8L55.1 99c3.1 2.2 7.4 0 7.4-3.8V44.1L98.6 8c3-2.9.9-8-3.3-8z"
    })),
    "filter-outline": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M93.7,0H6.3C0.7,0-2.1,6.7,1.8,10.7l35.7,35.7v36.5v0c0,1.8,0.8,3.5,2.1,4.7\n        l12.5,10.9c4,3.5,10.4,0.7,10.4-4.7V46.3l35.7-35.7C102.1,6.7,99.3,0,93.7,0L93.7,0z M56.3,43.8v50L43.8,82.8V43.8L6.2,6.2h87.5\n        L56.3,43.8z"
    })),
    folder: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 514 514",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M465 129H273l-64-64H49C22.49 65 1 86.49 1 113v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V177c0-26.51-21.49-48-48-48z"
    })),
    form: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M81,0H19c-5,0-9,4-9,9v82c0,5,4,9,9,9h62c5,0,9-4,9-9V9C90,4,86,0,81,0z M80,90H20V10h60V90z M74,26H26v-6h48V26z M74,38H26v-6h48V38z M74,49.7H26v-6h48V49.7z M74,79.8H56v-6h18V79.8z M74,67.8H56v-6h18V67.8z M34.2,80l14.1-14.1L44,61.8l-9.9,10L30,67.7l-4,4.1L34.2,80z"
    })),
    gallery: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M5.9 46H40c3.3 0 6-2.7 6-6V5.9c0-2.5-2.3-4.4-4.8-3.9C21.5 5.9 5.9 21.5 1.9 41.2c-.5 2.5 1.4 4.8 4 4.8zM36 13.9V36H13.9C18 26 26 18 36 13.9zM62 56c-3.3 0-6 2.7-6 6v34.2c0 2.5 2.3 4.4 4.8 3.9 19.8-4 35.4-19.6 39.3-39.3.5-2.5-1.4-4.8-3.9-4.8H62zm4 32.1V66h22.1C84 76 76 84 66 88.1zM40 56H5.9c-2.5 0-4.4 2.3-3.9 4.8 4 19.8 19.6 35.4 39.3 39.3 2.5.5 4.8-1.4 4.8-3.9V62c-.1-3.3-2.8-6-6.1-6zM13.9 66H36v22.1C26 84 18 76 13.9 66zM62 46h34.2c2.5 0 4.4-2.3 3.9-4.8-4-19.8-19.6-35.4-39.3-39.3-2.5-.5-4.8 1.4-4.8 4V40c0 3.3 2.7 6 6 6zm26.1-10H66V13.9C76 18 84 26 88.1 36z"
    })),
    graphiql: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90,62.8c-0.8-0.4-1.5-0.7-2.3-0.9V38.1c0.8-0.2,1.6-0.5,2.4-0.9c4.3-2.5,5.7-7.9,3.3-12.2c-2.5-4.3-7.9-5.7-12.2-3.3  c-0.8,0.4-1.4,1-2,1.6L58.5,11.5c0.2-0.8,0.4-1.7,0.4-2.5C58.9,4,54.9,0,50,0s-8.9,4-8.9,8.9c0,0.9,0.1,1.7,0.4,2.5L20.9,23.3  c-0.6-0.6-1.2-1.1-2-1.6c-4.3-2.5-9.7-1-12.2,3.3c-2.5,4.3-1,9.7,3.3,12.2c0.8,0.4,1.6,0.7,2.4,0.9v23.8c-0.8,0.2-1.6,0.5-2.3,0.9  C5.7,65.3,4.3,70.7,6.7,75s7.9,5.7,12.2,3.3c0.8-0.4,1.4-1,2-1.6l20.6,11.9c-0.2,0.8-0.4,1.6-0.4,2.5c0,4.9,4,8.9,8.9,8.9  s8.9-4,8.9-8.9c0-1-0.2-1.9-0.5-2.8l20.4-11.8c0.6,0.7,1.4,1.3,2.2,1.8c4.3,2.5,9.7,1,12.2-3.3C95.8,70.7,94.3,65.3,90,62.8z   M23.1,68.4c-0.2-0.8-0.5-1.6-0.9-2.3c-0.4-0.8-1-1.4-1.6-2l26.9-46.6c0.8,0.2,1.6,0.4,2.5,0.4c0.9,0,1.7-0.1,2.5-0.4l26.9,46.6  c-0.6,0.6-1.1,1.2-1.6,2c-0.4,0.8-0.7,1.5-0.9,2.3H23.1z M77,27c-0.6,2.2-0.4,4.7,0.8,6.9c1.3,2.2,3.3,3.6,5.6,4.2v23.8  c-0.1,0-0.2,0.1-0.3,0.1L56.2,15.4c0.1-0.1,0.2-0.2,0.2-0.2L77,27z M43.6,15.1c0.1,0.1,0.2,0.2,0.3,0.3L16.9,62  c-0.1,0-0.2-0.1-0.3-0.1V38.1c2.3-0.6,4.3-2,5.6-4.2c1.3-2.2,1.5-4.7,0.8-6.9L43.6,15.1z M56.6,85.1c-1.6-1.8-4-2.9-6.6-2.9  c-2.5,0-4.8,1-6.4,2.7L23,73c0-0.1,0.1-0.2,0.1-0.3h53.8c0,0.2,0.1,0.4,0.2,0.6L56.6,85.1z"
    })),
    happy: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zm-78.6-7.4c-.1-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.6 5.7 5.7 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5C37.7 36.7 32.8 32 27 32s-10.6 4.8-10.6 10.6c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5zM73 32c-5.9 0-10.6 4.8-10.6 10.6 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-3.1 2.6-5.7 5.7-5.7s5.7 2.6 5.7 5.7c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5C83.7 36.7 78.9 32 73 32zm4.8 24.6c-1.4-.6-3 0-3.5 1.4-4.2 9.7-13.7 16-24.3 16-10.6 0-20.1-6.3-24.3-16.1-.6-1.4-2.1-2-3.5-1.4-1.4.6-2 2.1-1.4 3.5 5.1 11.7 16.5 19.3 29.3 19.3 12.7 0 24.2-7.5 29.1-19.3.6-1.2-.1-2.8-1.4-3.4z"
    })),
    "help-solid": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm9.4 80.2c0 5.2-4.3 9.5-9.5 9.5s-9.5-4.3-9.5-9.5 4.3-9.5 9.5-9.5 9.5 4.2 9.5 9.5zM72.7 32c0 11.5-7.5 16.9-11.1 19.5l-.2.1c-3.5 2.5-4 4.6-4 6.4 0 4.2-3.5 5.9-7.8 5.9-4.2 0-7.5-1.8-7.5-6 0-7.6 3.6-14.1 10.4-18.7 3.7-2.6 4.8-4.2 4.8-7.2 0-.6-.2-5.3-7.6-5.3-3.7 0-6.3 1.5-7.4 5.1-1.3 4-4.4 6.2-8.2 6.2-5.7 0-7.8-4.4-6.7-9.1 2.3-10.2 11.4-17.3 22.5-17.3 16.7-.3 22.8 12 22.8 20.4z"
    })),
    help: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 18.4c-9.5 0-17.4 6-19.2 14.6-.3 1.3.3 4.9 4.9 4.9 3 0 4.4-1.2 4.9-2.9 1.1-3.8 4.7-6.7 9.3-6.7 9.1 0 9.4 6.6 9.4 7.2 0 4-2 6.1-5.5 8.6C48 48.3 45 53.7 45 60.3c0 2.8 2.3 4.1 5 4.1 2.9 0 5.1-1.2 5.1-4 0-2 .5-4.8 4.7-7.8 3.1-2.3 9.8-6.8 9.8-16.8-.1-7.1-5.3-17.4-19.6-17.4zm0 51c-3.5 0-6.4 2.8-6.4 6.4s2.8 6.4 6.4 6.4c3.5 0 6.4-2.8 6.4-6.4s-2.9-6.4-6.4-6.4z"
    })),
    highlight: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 91.2l18.4 5.9 6.5-6.5-12.3-12.4L0 91.2zm22.9-44.1c-2 1.7-2.8 4.5-2 7l2.4 7.9-9.3 9.3L31.6 89l9.3-9.3 7.9 2.4c2.5.8 5.3 0 7-2l6.5-7.7-31.8-31.9-7.6 6.6zM97 17.5L85.4 5.9c-3.8-3.8-9.8-4-13.8-.4L35 36.7l31.2 31.2 31.2-36.6c3.6-4 3.4-10-.4-13.8z"
    })),
    "highlight-outline": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M97.2,16.9L86.1,5.8c-1.9-1.9-4.4-2.8-6.8-2.8c-2.4,0-4.6,0.9-6.4,2.4\n          L20.3,51.1c-1.9,1.7-2.6,4.3-1.9,6.7l2.3,7.5L14,72c-1.2,1.2-1.2,3.2,0,4.5l0,0L0,91.2l18.4,5.9l8.1-8.1l0,0c1.2,1.2,3.3,1.2,4.5,0\n          l6.7-6.7l7.5,2.3c3.3,1,5.8-0.8,6.7-1.9l45.7-52.6C101,26.3,100.8,20.5,97.2,16.9z M16.7,90.4l-5.9-1.9l7.4-7.7l4.1,4.1L16.7,90.4z\n          M47.5,78.8C47.3,78.9,47.2,79,47,79c0,0-0.1,0-0.2,0l-7.5-2.3l-3.4-1l-7.3,7.3l-8.6-8.6l7.3-7.3l-1-3.4l-2.3-7.5\n          c-0.1-0.2,0-0.4,0.1-0.6l8.3-7.2l22.2,22.2L47.5,78.8z M93.1,26.3L58.5,66.1L36.9,44.4L76.7,9.8C77.6,9,80,8,81.9,9.9L93,21.1\n          C94.4,22.5,94.5,24.7,93.1,26.3L93.1,26.3z"
    })),
    "indico-logo-white": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 30",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M59.6 20.1c0-5.5 4.5-9.9 9.9-9.9h7.2v3.5h-7.2c-3.5 0-6.2 2.9-6.2 6.2 0 3.5 2.9 6.2 6.2 6.2h7.2V30h-7.2c-5.4 0-9.9-4.5-9.9-9.9zM0 30h3.6V10.3H0V30zM1.8 4.3C.8 4.3 0 5 0 6s.7 1.7 1.8 1.7S3.5 7 3.5 6c.1-1-.7-1.7-1.7-1.7zm5 16V30h3.6v-9.7c0-3.5 2.9-6.2 6.2-6.2 3.5 0 6.2 2.9 6.2 6.2V30h3.6v-9.7c0-5.5-4.5-9.9-9.9-9.9-5.2-.1-9.7 4.4-9.7 9.9zM52.9 30h3.6V10.3h-3.6V30zm1.9-25.7c-1 0-1.8.7-1.8 1.7s.7 1.7 1.8 1.7c1 0 1.8-.8 1.8-1.7s-.8-1.7-1.8-1.7zM100 20c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.5-10 10-10 10 4.5 10 10zm-16.1 0c0 3.4 2.8 6.1 6.1 6.1s6.1-2.8 6.1-6.1c0-3.4-2.8-6.1-6.1-6.1s-6.1 2.7-6.1 6.1zm7.9 0c0 1-.8 1.7-1.7 1.7s-1.8-.7-1.8-1.7.8-1.7 1.8-1.7 1.7.7 1.7 1.7zM49.8.4V20.1c0 5.5-4.5 9.9-10 9.9s-10-4.5-10-10 4.5-10 10-10c2.4 0 4.6.9 6.4 2.4V.5h3.6V.4zM33.6 20c0 3.4 2.7 6.1 6.1 6.1 3.4 0 6.1-2.8 6.1-6.1 0-3.4-2.7-6.1-6.1-6.1-3.3 0-6.1 2.7-6.1 6.1z"
    })),
    "indico-o": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM50 19.4c-16.9 0-30.6 13.7-30.6 30.6S33.1 80.6 50 80.6 80.6 66.9 80.6 50 66.9 19.4 50 19.4zm0 21.7c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
    })),
    info: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50,6.5c23.9,0,43.5,19.4,43.5,43.5c0,24.1-19.5,43.5-43.5,43.5\n	C26,93.5,6.5,74.1,6.5,50C6.5,26,25.9,6.5,50,6.5 M50,0C22.4,0,0,22.4,0,50c0,27.6,22.4,50,50,50s50-22.4,50-50\n	C100,22.4,77.6,0,50,0z M42.7,69.4h2.4V45.2h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-1.6c0-1.3,1.1-2.4,2.4-2.4h9.7c1.3,0,2.4,1.1,2.4,2.4\n	v28.2h2.4c1.3,0,2.4,1.1,2.4,2.4v1.6c0,1.3-1.1,2.4-2.4,2.4H42.7c-1.3,0-2.4-1.1-2.4-2.4v-1.6C40.3,70.4,41.4,69.4,42.7,69.4z\n	 M50,21c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5C56.5,23.9,53.6,21,50,21z"
    })),
    kabob: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m50 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm9 73c0-5-4-9-9-9s-9 4-9 9 4 9 9 9 9-4 9-9zm0-41c0-5-4-9-9-9s-9 4-9 9 4 9 9 9 9-4 9-9z"
    })),
    key: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M81.3 30c-3.1 3.1-8.1 3.1-11.4 0-3.1-3.1-3.1-8.1 0-11.4 3.1-3.1 8.1-3.1 11.4 0 3.1 3.3 3.1 8.3 0 11.4zm11.4-19.1C81.5-1.8 61.9-2.3 50.1 9.6c-7.9 7.9-10.3 19.1-7.4 29L2.5 78.9C1.4 80 .8 81.4.7 82.9L0 95.7c-.1 1.9 1.5 3.4 3.4 3.3l15.5-1.3c1.3-.2 2.4-.7 3.6-1.7V82.2h13v-13H51c6.5-6.2 11.3-11 11.3-11 10.5 3.1 22.4.2 30.2-8.6 9.9-10.8 10-27.7.2-38.7z"
    })),
    label: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M98.6 45.4L78.9 17.7c-3-4.2-7.9-6.7-13.1-6.7H10.6c-8 .5-12.8 9-9.5 16.2L9.3 50 1 72.6c-3 6.6.8 14.6 8 16.1.8.2 1.6.3 2.5.3h54.4c5.2 0 10.1-2.5 13.1-6.7l19.5-27.7c2-2.9 2-6.4.1-9.2z"
    })),
    "layout-complex": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M74 72H43v-4h31v4zM26 60v4h13v-4H26zm13 12v-4H26v4h13zm35-16v-4H43v4h31zm-35 0v-4H26v4h13zm4 4v4h31v-4H43zm47 35V5c0-2.7-3.2-5-6-5H15c-2.7 0-5 2.2-5 5v90c0 2.7 2.2 5 5 5h70c2.8 0 5-2.2 5-5zM79 76H21V48h58v28zm0-48H62v-4h17v4zm-23 8h-4v-4h4v4zm0-8h-4v-4h4v4zm23 8H62v-4h17v4zm-40-8H21v-4h18v4zm0 8H21v-4h18v4z"
    })),
    "layout-simple": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M85 100H15c-2.7 0-5-2.2-5-5V5c0-2.7 2.2-5 5-5h69c2.7 0 6 2.2 6 5v90c0 2.8-2.2 5-5 5zM46 52H21v4h25v-4zm0 20H21v4h25v-4zm0-10H21v4h25v-4zm0-30H21v4h25v-4zm0-10H21v4h25v-4zm0 20H21v4h25v-4zm8-6h25v-4H54v4zm0-10h25v-4H54v4zm0 20h25v-4H54v4zm0 20h25v-4H54v4zm0 10h25v-4H54v4zm0-20h25v-4H54v4z"
    })),
    location: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m22.85 43v-8.75h-11l-5.15-5.1 5.15-5.15h11v-4.35h-14.5v-10.3h14.5v-4.35h2.3v4.35h11l5.15 5.15-5.15 5.15h-11v4.35h14.5v10.25h-14.5v8.75zm-12.2-25.65h24.55l2.9-2.85-2.9-2.85h-24.55zm2.15 14.65h24.55v-5.75h-24.55l-2.9 2.9zm-2.15-14.65v-5.7 5.7zm26.7 14.65v-5.75 5.75z"
    })),
    lock: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M79 46.2V29C79 13 66 0 50 0S21 13 21 29v17.2c-5.7 1-10 5.9-10 11.8v30c0 6.6 5.4 12 12 12h54c6.6 0 12-5.4 12-12V58c0-5.9-4.3-10.9-10-11.8zM49.2 14c8.7-.4 15.8 6.5 15.8 15v17H35V29.4c0-8 6.2-15 14.2-15.4zm.8 71c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8z"
    })),
    menu: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M94 24H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6zM94 56H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6zM94 88H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6z"
    })),
    message: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 24 22",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M21.8 5.10019H17.8V2.4002C17.8 1.2002 16.8 0.200195 15.6 0.200195H2.2C1 0.200195 0 1.2002 0 2.4002V15.8002C0 16.5002 0.5 16.9002 1.1 16.9002C1.3 16.9002 1.6 16.8002 1.8 16.6002L5.9 13.2002H6.2V16.0002C6.2 17.2002 7.2 18.2002 8.4 18.2002H18.1L22.2 21.6002C22.4 21.8002 22.7 21.9002 22.9 21.9002C23.5 21.9002 24 21.5002 24 20.8002V7.3002C24 6.1002 23 5.10019 21.8 5.10019ZM4.6 11.6002L2 13.9002V2.4002C2 2.3002 2.1 2.2002 2.2 2.2002H15.6C15.7 2.2002 15.8 2.3002 15.8 2.4002V11.0002C15.8 11.1002 15.7 11.2002 15.6 11.2002H5.9C5.5 11.2002 5 11.3002 4.6 11.6002ZM22 18.8002L19.4 16.6002C19 16.3002 18.6 16.1002 18.1 16.1002H8.4C8.3 16.1002 8.2 16.0002 8.2 15.9002V13.1002H15.6C16.8 13.1002 17.8 12.1002 17.8 10.9002V7.1002H21.8C21.9 7.1002 22 7.2002 22 7.3002V18.8002Z"
    })),
    "model-import": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M96.4,19.1L88.6,4.7C87,1.8,83.9,0,80.7,0H19.3c-3.3,0-6.3,1.8-7.9,4.7L3.6,19.1c-1,1.9-1.6,4-1.6,6.1V91c0,5,4,9,9,9h78c5,0,9-4,9-9V25.2C98,23.1,97.5,21,96.4,19.1z M19.9,10h60.1l6,11H13.9L19.9,10z M12,90V31h76v59H12z M67.8,57.8L50,40L32.2,57.8l5.7,5.6l8.1-8.1V80h8V55.3l8.1,8.1L67.8,57.8"
    })),
    "model-starter": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M96.4,19.1L88.6,4.7C87,1.8,83.9,0,80.7,0H19.3c-3.3,0-6.3,1.8-7.9,4.7L3.6,19.1c-1,1.9-1.6,4-1.6,6.1V91c0,5,4,9,9,9h78c5,0,9-4,9-9V25.2C98,23.1,97.5,21,96.4,19.1z M19.9,10h60.1l6,11H13.9L19.9,10z M12,90V31h76v59H12z M66,64H54v12h-8V64H34v-8h12V44h8v12h12V64z"
    })),
    moon: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M98.7 52.5c-.8-.4-2.1-.3-2.9.8-6.2 7.9-16.2 12.1-26.2 12.1C50.4 65.4 35 50 35 30.8c0-10 4.2-19.2 12.1-26.2.8-.8 1.1-2.2.8-2.9C47.3.3 46.2 0 45 0 19.2 2.5 0 23.8 0 50c0 27.9 22.5 50 50 50 25.8 0 47.5-19.2 50-45 .1-1.2-.4-2.1-1.3-2.5z"
    })),
    moonbow: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M42 65c2.2 0 4 1.8 4 4v5c0 2.2-1.8 4-4 4H8.6c-2.7-4-4.8-8.3-6.3-13H42zm25-12v-5c0-2.2-1.8-4-4-4H.4c-.3 2-.4 4-.4 6 0 2.4.2 4.7.5 7H63c2.2 0 4-1.8 4-4zM51 23H7.9C5.4 27 3.4 31.4 2 36h49c2.2 0 4-1.8 4-4v-5c0-2.2-1.8-4-4-4zm49 27c0-27.6-22.4-50-50-50-.8 0-1.7 0-2.5.1-.2 0-.5 0-.7.1-.6 0-1.2.1-1.8.1-.3 0-.5.1-.8.1-.6.1-1.1.1-1.6.2-.3 0-.5.1-.8.1-.5.1-1.1.2-1.6.3-.3.1-.6.1-.8.2-.5.1-1 .2-1.5.4-.3.1-.6.2-.9.2-.5.1-1 .3-1.4.4l-.9.3c-.4.1-.9.3-1.3.4-.3.1-.7.2-1 .4-.4.1-.8.3-1.1.4-.5.2-.9.3-1.3.5-.3.1-.6.3-.9.4-.4.2-.9.4-1.3.6l-.6.3c-.5.3-1 .5-1.5.8-.1 0-.2.1-.3.1-3.2 1.8-6.2 4-9 6.5h18.4c4.7-1.9 9.8-3 15.2-3 22.1 0 40 17.9 40 40S72.1 90 50 90c-5.4 0-10.6-1.1-15.2-3H16.4c2.7 2.5 5.7 4.7 9 6.5.1 0 .2.1.3.1.5.3 1 .6 1.5.8l.6.3c.4.2.9.4 1.3.6.3.1.6.3.9.4.4.2.8.3 1.1.5.4.2.8.3 1.1.4.3.1.7.3 1 .4.4.2.9.3 1.3.4l.9.3c.5.1 1 .3 1.4.4.3.1.6.2.9.2.5.1 1 .2 1.5.4.3.1.6.1.8.2.5.1 1.1.2 1.6.3.3 0 .5.1.8.1.5.1 1.1.1 1.6.2.3 0 .5.1.8.1.6.1 1.2.1 1.8.1.2 0 .5 0 .7.1.8 0 1.7.1 2.5.1C77.6 100 100 77.6 100 50z"
    })),
    "no-format": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m24 43q-3.95 0-7.425-1.5t-6.05-4.075-4.05-6.05-1.475-7.475q0-3.95 1.475-7.4t4.05-6.025 6.05-4.025 7.425-1.45 7.425 1.45 6.05 4.025 4.05 6.025 1.475 7.4q0 4-1.475 7.475t-4.05 6.05-6.05 4.075-7.425 1.5zm7.35-26h7.95q-1.75-3.8-4.875-6.225t-7.275-3.225q1.45 1.9 2.475 4.25t1.725 5.2zm-12.35 0h10.1q-0.65-2.8-1.975-5.3t-3.125-4.45q-1.7 1.55-2.875 3.85t-2.125 5.9zm-11.05 11.7h8.25q-0.15-1.4-0.2-2.55t-0.05-2.25q0-1.2 0.05-2.275t0.25-2.325h-8.3q-0.35 1.15-0.525 2.225t-0.175 2.375q0 1.35 0.175 2.475t0.525 2.325zm12.9 11.7q-1.45-1.8-2.525-4.225t-1.675-5.225h-7.95q1.9 3.9 4.8 6.125t7.35 3.325zm-12.15-23.4h7.95q0.65-2.75 1.675-5.075t2.475-4.325q-4.15 0.8-7.225 3.175t-4.875 6.225zm15.3 23.85q1.85-2.05 3.05-4.4t2-5.5h-10.05q0.75 3.1 1.95 5.5t3.05 4.4zm-5.45-12.15h10.95q0.2-1.55 0.275-2.6t0.075-2.2q0-1.05-0.075-2.075t-0.275-2.525h-10.95q-0.2 1.5-0.275 2.525t-0.075 2.075q0 1.15 0.075 2.2t0.275 2.6zm8.65 11.7q3.95-0.9 7.125-3.35t4.975-6.1h-7.9q-0.75 2.8-1.8 5.2t-2.4 4.25zm4.55-11.7h8.3q0.35-1.2 0.525-2.325t0.175-2.475q0-1.3-0.175-2.375t-0.525-2.225h-8.25q0.15 1.65 0.225 2.675t0.075 1.925q0 1.15-0.075 2.225t-0.275 2.575z"
    })),
    "object-detection": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0,91V66h10v24h24v10H9C4,100,0,96,0,91z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M90,90H66v10h25c5,0,9-4,9-9V66H90V90z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M91,0H66v10h24v24h10V9C100,4,96,0,91,0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M10,10h24V0H9C4,0,0,4,0,9v25h10V10z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "32",
        y: "32",
        width: "36",
        height: "36"
    })),
    organizations: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M86.9 53.9C85.9 43 80.3 33.4 72 27.2V26c0-12.2-9.8-22-22-22s-22 9.8-22 22v1.2c-8.3 6.2-14 15.7-14.9 26.6C5.4 57.3 0 65 0 74c0 12.2 9.8 22 22 22 5.2 0 10-1.8 13.8-4.9C40.2 93 45 94 50 94s9.8-1 14.2-2.9C68 94.2 72.8 96 78 96c12.2 0 22-9.8 22-22 0-9-5.4-16.7-13.1-20.1zM50 14c6.6 0 12 5.4 12 12s-5.4 12-12 12-12-5.4-12-12 5.4-12 12-12zM22 86c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12zm20.2-3.2c1.2-2.7 1.8-5.7 1.8-8.8 0-11.7-9.1-21.2-20.5-21.9 1-5.6 3.9-10.7 7.8-14.5C35.2 43.8 42.1 48 50 48s14.8-4.2 18.7-10.4c4 3.8 6.8 8.8 7.8 14.5C65.1 52.8 56 62.3 56 74c0 3.1.7 6.1 1.8 8.8-2.4.8-5.1 1.2-7.8 1.2s-5.4-.4-7.8-1.2zM78 86c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12z"
    })),
    output: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7V31.2H60.9c-2.5 0-4.7-2.1-4.7-4.6zm15 41.2L52.3 86.5a3.32 3.32 0 01-4.7 0L28.8 67.8c-2-2-.6-5.3 2.2-5.3h12.7V46.9c0-1.7 1.4-3.1 3.1-3.1H53c1.7 0 3.1 1.4 3.1 3.1v15.6H69c2.8 0 4.2 3.4 2.2 5.3zm14.9-47.3L67 1.4C66.1.5 64.9 0 63.7 0h-1.2v25h25v-1.2c0-1.2-.5-2.4-1.4-3.3z"
    })),
    "page-thumbnail": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7v-64H60.9c-2.5 0-4.7-2.2-4.7-4.7zm12.6 46.1c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.3 1.1 2.3 2.3v1.6zm0-12.5c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.3 1.1 2.3 2.3v1.6zm0-14.1v1.6c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.4 1 2.4 2.3zm18.7-22.3V25h-25V0h1.2c1.2 0 2.4.5 3.3 1.4l19.1 19.1c.9.9 1.4 2.1 1.4 3.3z"
    })),
    "pay-as-you-go": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M69.1 66.8c1 1 1.5 2.7.1 4.1-1.6 1.6-4.1 0-4.9-.8 0 0-18.1-15.7-18.3-15.9-1.2-1.2-1.8-2.6-1.6-4.2L46 19.4c.2-2 .8-3.4 2.8-3.4 2.2 0 2.8 1.2 2.8 3.4L54.2 47c0 .6.4 1.4.8 1.8l14.1 18zm16.4 18.6c1.4-1.4 1.4-3.6 0-4.9-1.4-1.4-3.6-1.4-4.9 0-8.2 8-19 12.5-30.5 12.5C26.3 93 7 73.7 7 50S26.3 7 50.1 7c1.9 0 3.5-1.6 3.5-3.5S52 0 50.1 0C22.5 0 0 22.4 0 50s22.5 50 50.1 50c13.4 0 25.9-5.2 35.4-14.6zm3.5-9.6c-1.7-1-2.3-3.1-1.3-4.7 1-1.7 3.1-2.3 4.8-1.3 1.7 1 2.3 3.1 1.3 4.8-.7 1.2-1.9 1.8-3.1 1.8-.6-.1-1.2-.3-1.7-.6zm5.9-12.6c-1.9-.4-3.1-2.3-2.7-4.1.4-1.9 2.3-3.1 4.1-2.7 1.9.4 3.1 2.3 2.7 4.1-.4 1.7-1.9 2.8-3.5 2.8-.1 0-.4-.1-.6-.1zm-1.9-17c-.2-1.9 1.3-3.6 3.2-3.8 1.9-.2 3.6 1.2 3.8 3.2.2 1.9-1.2 3.6-3.2 3.8h-.4c-1.7 0-3.2-1.4-3.4-3.2zm-3-12.5c-.7-1.8.1-3.8 1.9-4.6 1.8-.7 3.8.1 4.6 1.9.7 1.8-.1 3.8-1.9 4.5-.5.2-1 .3-1.4.3-1.4.1-2.7-.8-3.2-2.1zm-6.6-11c-1.2-1.5-1-3.7.5-4.9 1.5-1.2 3.7-1 4.9.5 1.2 1.5 1 3.7-.5 4.9-.7.5-1.5.8-2.3.8-1-.1-1.9-.5-2.6-1.3zm-9.6-8.6c-1.6-1.1-2-3.2-1-4.8 1.1-1.6 3.2-2.1 4.8-1 1.6 1.1 2 3.2 1 4.8-.7 1.1-1.8 1.6-3 1.6-.6-.1-1.2-.3-1.8-.6zM62.1 8.7c-1.9-.5-2.9-2.5-2.4-4.3.5-1.8 2.5-2.9 4.3-2.4 1.9.5 2.9 2.5 2.4 4.3-.4 1.6-1.8 2.6-3.4 2.5-.3 0-.6 0-.9-.1z"
    })),
    person: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m24 23.35q-2.9 0-4.775-1.875t-1.875-4.775 1.875-4.75 4.775-1.85 4.775 1.85 1.875 4.75-1.875 4.775-4.775 1.875zm-15 15.25v-3.8q0-1.6 0.85-2.8t2.2-1.85q3.2-1.4 6.125-2.1t5.825-0.7 5.825 0.725 6.075 2.125q1.4 0.65 2.25 1.825t0.85 2.775v3.8zm2.25-2.25h25.5v-1.55q0-0.75-0.5-1.475t-1.3-1.125q-2.95-1.45-5.575-2.025t-5.375-0.575-5.425 0.575-5.575 2.025q-0.75 0.4-1.25 1.125t-0.5 1.475zm12.75-15.25q1.85 0 3.1-1.25t1.25-3.15q0-1.85-1.25-3.1t-3.1-1.25-3.1 1.25-1.25 3.1q0 1.9 1.25 3.15t3.1 1.25zm0-4.4zm0 19.65z"
    })),
    phone: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m20.15 40.9h7.7v-1.75h-7.7zm-6.9-5.8h21.5v-25.45h-21.5zm0.65 9.9q-1.2 0-2.05-0.85t-0.85-2.05v-36.2q0-1.2 0.85-2.05t2.05-0.85h20.2q1.2 0 2.05 0.85t0.85 2.05v36.2q0 1.2-0.85 2.05t-2.05 0.85zm-0.65-37.6h21.5v-1.5q0-0.25-0.2-0.45t-0.45-0.2h-20.2q-0.25 0-0.45 0.2t-0.2 0.45zm0-2.15t0 0.175 0 0.475v1.5-1.5q0-0.3 0-0.475t0-0.175zm0 32.1v4.75q0 0.25 0.2 0.45t0.45 0.2h20.2q0.25 0 0.45-0.2t0.2-0.45v-4.75zm0 5.4t0-0.175 0-0.475v-4.75 4.75q0 0.3 0 0.475t0 0.175z"
    })),
    pin: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M63.9,72.1c-0.7-2.9,0.1-6,2.1-8.3l20.9-23.2c0,0,9.3,2.4,11.9-0.1c4.2-4.2-2.9-14.4-13.9-25.4 C75.8,6,63.5-3,59.4,1.1C56.9,3.7,59.3,13,59.3,13L36.1,33.9c-2.2,2-5.3,2.8-8.3,2.1c-6-1.4-16.1-3.1-19.8,0.6 c-2.2,2.2-2.4,5.7,0.8,8.8l18.5,18.5L1.3,94.6c-3.3,3.7,0.3,7.3,4,4l30.7-25.9l18.5,18.5c3.3,3.3,6.6,3,8.8,0.8 C67,88.2,65.3,78.1,63.9,72.1z"
    })),
    plus: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M94 44H56V6c0-3.3-2.7-6-6-6s-6 2.7-6 6v38H6c-3.3 0-6 2.7-6 6s2.7 6 6 6h38v38c0 3.3 2.7 6 6 6s6-2.7 6-6V56h38c3.3 0 6-2.7 6-6s-2.7-6-6-6z"
    })),
    pointer: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M80.8 64.3H60.1L71 90.8c.8 1.8-.1 3.9-1.8 4.7l-9.6 4.2c-1.8.8-3.8-.1-4.6-1.9L44.6 72.6 27.7 90c-2.3 2.3-5.9.5-5.9-2.5V3.6c0-3.2 3.9-4.8 5.9-2.5l55.5 57.1c2.3 2.2.6 6.1-2.4 6.1z"
    })),
    popup: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M78 65c0-3.9 3.1-7 7-7s7 3.1 7 7v25.7c0 5.1-4.2 9.3-9.3 9.3H9.3C4.2 100 0 95.8 0 90.7V17.3C0 12.2 4.2 8 9.3 8H35c3.9 0 7 3.1 7 7s-3.1 7-7 7H14v64h64V65zM93 0H57c-3.9 0-7 3.1-7 7s3.1 7 7 7h17L41.5 46.5c-3 3-3 8 0 11s8 3 11 0L86 24v19c0 3.9 3.1 7 7 7s7-3.1 7-7V7c0-3.9-3.1-7-7-7z"
    })),
    price: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m25.8 43q-0.45 0-0.875-0.15t-0.825-0.5l-18.4-18.45q-0.4-0.35-0.55-0.775t-0.15-0.925v-14.95q0-0.95 0.65-1.6t1.6-0.65h14.95q0.45 0 0.925 0.15t0.825 0.5l18.35 18.35q0.8 0.75 0.8 1.7t-0.75 1.7l-14.95 14.95q-0.3 0.3-0.725 0.475t-0.875 0.175zm0.05-2.2 14.95-14.95-18.55-18.6h-15v14.95zm-13.4-26.15q0.9 0 1.55-0.675t0.65-1.575-0.65-1.55-1.55-0.65-1.55 0.65-0.65 1.55 0.65 1.575 1.55 0.675z"
    })),
    "radio-button": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1 1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m49.9 72.5c6.3 0 11.6-2.2 15.9-6.5s6.5-9.7 6.5-15.9-2.2-11.6-6.5-15.9-9.7-6.5-15.9-6.5-11.5 2.1-15.9 6.4c-4.3 4.3-6.5 9.7-6.5 15.9s2.2 11.6 6.5 16 9.7 6.5 15.9 6.5zm0 27.5c-6.8 0-13.3-1.3-19.4-3.9s-11.4-6.2-15.9-10.7-8.1-9.8-10.7-15.9-3.9-12.5-3.9-19.4 1.3-13.4 3.9-19.5 6.2-11.4 10.7-15.9 9.8-8.1 15.9-10.7 12.5-4 19.4-4 13.4 1.3 19.5 4 11.4 6.2 15.9 10.7 8 9.7 10.7 15.8 4 12.6 4 19.6c0 6.9-1.3 13.4-4 19.5s-6.2 11.4-10.7 15.9-9.8 8.1-15.8 10.7c-6.1 2.5-12.6 3.8-19.6 3.8zm0-9.5c11.3 0 20.8-3.9 28.6-11.8s11.8-17.4 11.8-28.6c0-11.3-3.9-20.8-11.8-28.6s-17.3-11.8-28.6-11.8c-11.2 0-20.7 3.9-28.6 11.8s-11.8 17.3-11.8 28.6c0 11.2 3.9 20.7 11.8 28.6s17.5 11.8 28.6 11.8z"
    }))),
    recruiter: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 21c-16 0-29 13-29 29 0 6.2 1.9 11.9 5.3 16.6-.1.1-.3.2-.4.3l-24 24c-2 2-2 5.2 0 7.2s5.2 2 7.2 0L33 74.2c.1-.1.2-.3.3-.4C38.1 77.1 43.8 79 50 79c16 0 29-13 29-29S66 21 50 21zm0 48c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19-8.5 19-19 19zm50-19c0 27.6-22.4 50-50 50-9.2 0-17.8-2.5-25.2-6.8l7.4-7.4C37.5 88.5 43.6 90 50 90c22.1 0 40-17.9 40-40S72.1 10 50 10 10 27.9 10 50c0 6.4 1.5 12.5 4.2 17.8l-7.4 7.4C2.5 67.8 0 59.2 0 50 0 22.4 22.4 0 50 0s50 22.4 50 50z"
    })),
    regex: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M28.85 39.1V36.85H34Q35.2 36.85 36.025 36.025Q36.85 35.2 36.85 34V29.1Q36.85 27.35 37.925 25.975Q39 24.6 40.65 24.15V23.85Q39 23.4 37.925 22.025Q36.85 20.65 36.85 18.9V14Q36.85 12.8 36.025 11.975Q35.2 11.15 34 11.15H28.85V8.9H34Q36.15 8.9 37.625 10.4Q39.1 11.9 39.1 14V18.9Q39.1 20.15 39.95 20.975Q40.8 21.8 42.05 21.8H42.9V26.2H42.05Q40.8 26.2 39.95 27.025Q39.1 27.85 39.1 29.1V34Q39.1 36.1 37.6 37.6Q36.1 39.1 34 39.1ZM14 39.1Q11.85 39.1 10.375 37.6Q8.9 36.1 8.9 34V29.1Q8.9 27.85 8.05 27.025Q7.2 26.2 5.95 26.2H5.1V21.8H5.95Q7.2 21.8 8.05 20.975Q8.9 20.15 8.9 18.9V14Q8.9 11.9 10.4 10.4Q11.9 8.9 14 8.9H19.15V11.15H14Q12.8 11.15 11.975 11.975Q11.15 12.8 11.15 14V18.9Q11.15 20.65 10.075 22.025Q9 23.4 7.35 23.85V24.15Q9 24.6 10.075 25.975Q11.15 27.35 11.15 29.1V34Q11.15 35.2 11.975 36.025Q12.8 36.85 14 36.85H19.15V39.1Z"
    })),
    reject: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm26.2 23.8C89.4 37 90.3 57.1 80.4 71.3L28.7 19.6c14.2-9.9 34.3-9 47.5 4.2zM23.8 76.2C10.6 63 9.7 42.9 19.6 28.7l51.7 51.7c-14.2 10-34.3 9-47.5-4.2z"
    })),
    repair: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currenftColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M98.2 36.7c1.2 4.3 1.8 8.8 1.8 13.5-.1 26.3-21.1 48.4-47.4 49.7-29.7 1.5-54-22.8-52.5-52.5C1.4 21.5 22.8.6 48.8 0c18.9-.5 35.6 9.6 44.4 24.8L47.6 70.4c-1.2 1.2-3.1 1.2-4.2 0L21.9 49c-1.2-1.2-1.2-3.1 0-4.2l4.2-4.2c1.2-1.2 3.1-1.2 4.2 0l15.1 15.1 33.3-33.3C71.2 14.3 60.3 9.5 48.3 10c-20.2.8-36.8 17-38.2 37.1C8.5 70.6 27 90 50 90c22.1 0 40-17.9 40-40 0-1.6-.1-3.1-.3-4.7l8.5-8.6z"
    })),
    research: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M84.6 84.3L62.2 49.6c-.3-.7-.7-1-.7-1.7V37c2.1 0 3.5-1.4 3.5-3.5S63.6 30 61.5 30h-21c-1.7 0-3.5 1.4-3.5 3.5s1.4 3.5 3.5 3.5v10.8c0 .7 0 1-.3 1.4l-22.7 35c-3.8 7 1 15.7 9.1 15.7h49c7.6.1 13.2-8.3 9-15.6zM46.1 53.1c1-1.7 1.4-3.5 1.4-5.2V37h7v10.8c0 1.7.3 3.5 1.4 5.2l7.7 12H38.4l7.7-11.9zM75.5 93h-49c-2.8 0-4.2-3.1-3.1-4.9l10.5-15.7h34.3l10.1 15.7c1.4 2.1-.4 4.9-2.8 4.9zM51 25.8c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3-3.3 7.3-7.3 7.3zm0-9.6c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3zM69.9 18.3c-4.9 0-8.8-4-8.8-8.8s4-8.8 8.8-8.8c4.9 0 8.8 4 8.8 8.8s-3.9 8.8-8.8 8.8zm0-12.6c-2.1 0-3.8 1.7-3.8 3.8s1.7 3.8 3.8 3.8c2.1 0 3.8-1.7 3.8-3.8S72 5.7 69.9 5.7z"
    })),
    retrain: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M98.4 20.3l-26 17.2c-1 .7-2.4-.1-2.4-1.3V26H21v25.1c0 .3-.2.7-.5.8-1.9 1.2-8.9 5.6-12 7.6-.7.4-1.5-.1-1.5-.8V16c0-2.2 1.8-4 4-4h59V1.8c0-1.2 1.4-2 2.4-1.3l26 17.2c1 .6 1 2 0 2.6zM79 48.9V74H30V63.8c0-1.2-1.4-2-2.4-1.3l-26 17.2c-1 .6-1 2 0 2.6l26 17.2c1 .7 2.4-.1 2.4-1.3V88h59c2.2 0 4-1.8 4-4V41.3c0-.8-.8-1.2-1.5-.8-3.1 2-10.2 6.4-12 7.6-.3.2-.5.5-.5.8z"
    })),
    sad: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM61.6 70.5c-3.2-2.4-7.1-3.9-11.6-3.9s-8.5 1.4-11.6 3.9c-1.9 1.5-3.2 2.9-3.9 4.1-.9 1.5-.5 3.5 1 4.4 1.5.9 3.5.5 4.4-1 .3-.5 1.1-1.4 2.3-2.3C44.3 74 46.9 73 50 73s5.7 1 7.8 2.5c1.2.9 2 1.9 2.3 2.3.9 1.5 2.9 2 4.4 1 1.5-.9 2-2.9 1-4.4-.7-1-1.9-2.5-3.9-3.9zM24.5 44.9c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm52 .2c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zM29.8 34c-.5-1.3-2-1.9-3.3-1.3l-12 5c-1.3.5-1.9 2-1.3 3.3.4 1 1.3 1.5 2.3 1.5.3 0 .6-.1 1-.2l12-5c1.2-.5 1.8-2 1.3-3.3zm55.7 3.7l-12-5c-1.3-.5-2.7.1-3.3 1.3-.5 1.3.1 2.7 1.3 3.3l12 5c.3.1.6.2 1 .2 1 0 1.9-.6 2.3-1.5.5-1.3-.1-2.8-1.3-3.3z"
    })),
    search: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M39.4.4C17.9.4.4 17.9.4 39.4s17.5 39 39 39c8.8 0 16.9-2.9 23.4-7.8-.3 1.9.2 3.8 1.7 5.2l22 22c1.2 1.2 2.7 1.8 4.3 1.8s3.1-.6 4.3-1.8l2.8-2.8c2.4-2.4 2.4-6.2 0-8.5l-22-22c-1.2-1.2-2.7-1.8-4.2-1.8-.3 0-.7 0-1 .1 4.9-6.5 7.8-14.6 7.8-23.4C78.4 17.9 61 .4 39.4.4zm0 63c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24c0 13.3-10.7 24-24 24z"
    })),
    shrug: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 250 66",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M2.1 4.7C.7 4.7 0 3.6 0 2.3 0 .9.7 0 2.1 0h15.8c1.4 0 2 .9 2 2.3s-.6 2.4-2 2.4H2.1zm47.6 57.7c.2.4.3.8.3 1.2 0 1-.7 1.8-1.9 2.2-.4.1-.9.2-1.2.2-1.1 0-1.9-.5-2.4-1.6L21.7 3.7c-.1-.4-.2-.8-.2-1.1 0-1 .7-1.8 1.9-2.3.4-.1.8-.2 1.1-.2 1.1 0 2 .5 2.4 1.7l22.8 60.6zm4.1 3.6c-1.4 0-2.1-1-2.1-2.4s.7-2.3 2.1-2.3h23.8c1.4 0 2 .9 2 2.3s-.6 2.4-2 2.4H53.8zM232.1 4.7c-1.4 0-2-1-2-2.4s.6-2.3 2-2.3h15.8c1.4 0 2.1.9 2.1 2.3s-.7 2.4-2.1 2.4h-15.8zm-9-2.8c.4-1.2 1.2-1.7 2.4-1.7.3 0 .7.1 1.1.2 1.2.4 1.9 1.2 1.9 2.3 0 .3-.1.7-.2 1.1l-22.7 60.6c-.5 1.1-1.3 1.6-2.4 1.6-.3 0-.8-.1-1.2-.2-1.1-.4-1.9-1.2-1.9-2.2 0-.3.1-.8.3-1.2l22.7-60.5zM171.4 66c-1.4 0-2-1-2-2.4s.6-2.3 2-2.3h24.8c1.4 0 2.1.9 2.1 2.3s-.7 2.4-2.1 2.4h-24.8zM90.8 3.5c0 .5-.2 1-.6 1.6-6.1 8.2-9.7 16.3-9.7 28.1 0 11.9 3.6 20.1 9.6 28.2.4.6.6 1.2.6 1.6 0 1-.6 1.7-1.4 2.3-.6.5-1.3.7-2 .7-.8 0-1.6-.4-2.3-1.3-6.9-9.5-10.5-18.6-10.5-31.5 0-12.9 3.6-21.9 10.6-31.3.7-.9 1.6-1.3 2.4-1.3.7 0 1.3.2 1.8.6.8.5 1.5 1.3 1.5 2.3zm10.6 1.4c1 0 1.8.5 2.4 1.4 2.8 5.2 5.5 12.5 7.2 18.1.1.5.2.9.2 1.2 0 1.2-.7 2.1-2 2.5-.4.1-.8.2-1.2.2-1.2 0-2.2-.8-2.6-2-1.5-5.3-4.5-12.7-6.8-17.5-.2-.5-.3-.9-.3-1.3 0-1.1.6-2 1.8-2.4.4-.1.8-.2 1.3-.2zm49.9 1.3v.4c-1.1 11.5-5 22.9-10.7 30.8-6.7 9-17.2 15.9-28.2 18.4-.3.1-.7.1-1 .1-1.3 0-2.2-.6-2.6-2.1-.1-.3-.1-.7-.1-1 0-1.4.9-2.3 2.3-2.7 10-2.9 19.2-8.4 25-16.4 5.2-7.1 8.5-17.3 9.5-28 .1-1.8 1.4-2.5 2.8-2.5.3 0 .5 0 .7.1 1.3.2 2.3 1.3 2.3 2.9zm-32.1-4.7c1.1 0 2.2.5 2.8 1.7 2.3 5.1 4.9 11.7 6.5 17.5.1.3.1.5.1.8 0 1.4-.9 2.5-2.2 2.8-.3.1-.7.1-1.1.1-1.2 0-2.2-.6-2.6-1.9-1.4-5.5-4.1-12.5-6.3-17.1-.2-.5-.3-1-.3-1.4 0-1.1.7-1.9 1.9-2.3.4-.2.8-.2 1.2-.2zm42.8-1c.9 0 1.8.4 2.4 1.3 7 9.5 10.7 18.4 10.7 31.3 0 12.9-3.7 22-10.6 31.5-.6.9-1.4 1.3-2.3 1.3-.6 0-1.3-.3-1.9-.7-.8-.5-1.4-1.4-1.4-2.3 0-.5.2-1.1.6-1.6 5.9-8.1 9.6-16.3 9.6-28.2 0-11.8-3.6-19.9-9.7-28.1-.4-.5-.6-1.1-.6-1.6 0-.9.5-1.7 1.4-2.3.5-.4 1.2-.6 1.8-.6z"
    })),
    signature: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1 1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m28.9 48.7-2.4-2.7-18.9 18.8h-7.5v-7.7l41.9-41.8c3.7-3.2 10-9 27.4-9 5.6 0 11.1 1.2 16.5 3.7 5.4 2.4 10.1 5.5 14.3 9.1l-21.6 21.4h-7.6v8.9c-3 3-6.5 5.2-10.4 6.6-4 1.4-7.9 2-11.7 2-11.7 0.1-18.9-7.9-20-9.3zm54.5-28.3c-2.2-1.1-4.4-1.9-6.6-2.6-2.2-0.6-4.7-1-7.4-1-4.7 0-9.1 1-13.2 2.9s-7.9 4.6-11.3 8l-10.6 10.7 2.6 2.9c1.1 1.3 2.9 2.6 5.6 4.1 2.7 1.4 5.3 2.2 7.8 2.2 1.8 0 3.6-0.3 5.3-0.8s3.3-1.3 4.9-2.4v-14.6h13.5l9.4-9.4z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m97.7 63.2c-5.9-4.9-10.2 4.3-14.7 7.2-5.5 4.7-11.4 9.3-18.2 12.1 1.1-6.5 2.8-17.7-4.9-17.7-5.6 0-14.9 10.8-20.9 15.8 0.8-6.2-1.4-12.9-8.1-12.9-1.9 0-4.2 1-6.2 3.2-2.8 3.1-7.4 11.7-12 11.8-0.7 0-3.5-0.5-1.8-7.9 1.4-6.3-8-8.9-9.6-2.7-6.2 23.7 16.7 27.5 27.7 9 0.6 24.7 17.5 6.8 26.1-2.1-3.9 19.2 7.1 16.7 19.9 9.7 5.2-3.6 29.9-18.7 22.7-25.5z"
    }))),
    "sort-down": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M58.1,74.2H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0\n        c0,1.8,1.4,3.2,3.2,3.2h12.9l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2l0,0C61.3,75.6,59.8,74.2,58.1,74.2L58.1,74.2z M29.8,75.8H21V8.1l0,0\n        c0-1.8-1.4-3.2-3.2-3.2h-3.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v67.7h-9l0,0c-1.3,0-2.4,1.1-2.4,2.4c0,0.6,0.2,1.2,0.7,1.7l13.7,14.5\n        l0,0c0.9,1,2.4,1,3.4,0.1l0.1-0.1l13.7-14.5l0,0c0.9-1,0.9-2.5-0.1-3.4C31,76,30.5,75.8,29.8,75.8L29.8,75.8z M83.9,35.5H45.2l0,0\n        c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2h38.7l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2l0,0C87.1,36.9,85.7,35.5,83.9,35.5\n        L83.9,35.5z M96.8,16.1H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2h51.6l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2\n        l0,0C100,17.6,98.6,16.1,96.8,16.1L96.8,16.1z M71,54.8H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2H71l0,0\n        c1.8,0,3.2-1.4,3.2-3.2V58l0,0C74.2,56.3,72.7,54.8,71,54.8L71,54.8z"
    })),
    split: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M62.1 50l37.1-37.1c1-1 1-2.7 0-3.8-7.3-7.3-19.2-7.3-26.5 0L46.9 34.9l-5.5-5.5c1-2.4 1.5-5.1 1.5-7.9C42.9 9.6 33.3 0 21.4 0S0 9.6 0 21.4s9.6 21.4 21.4 21.4c1 0 2-.1 3-.2l7.4 7.4-7.4 7.4c-1-.1-2-.2-3-.2C9.6 57.1 0 66.7 0 78.6S9.6 100 21.4 100s21.4-9.6 21.4-21.4c0-2.8-.5-5.4-1.5-7.9l5.5-5.5L72.6 91c7.3 7.3 19.2 7.3 26.5 0 1-1 1-2.7 0-3.8L62.1 50zM21.4 28.6c-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1 7.1 3.2 7.1 7.1-3.1 7.1-7.1 7.1zm0 57.1c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1c.1 3.9-3.1 7.1-7.1 7.1z"
    })),
    "step-forward": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 11 16",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M11 .429V15.57a.422.422 0 0 1-.412.429h-1.65a.422.422 0 0 1-.413-.429v-6.3l-6.72 6.464c-.708.611-1.805.1-1.805-.878V1.143C0 .165 1.097-.347 1.805.265l6.72 6.424V.43c0-.236.186-.429.412-.429h1.65c.227 0 .413.193.413.429Z"
    })),
    sun: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M49.8 23.8c-14.6 0-26.4 11.7-26.4 26.4s11.7 26.4 26.4 26.4 26.4-11.7 26.4-26.4-11.8-26.4-26.4-26.4zM50 16c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4s4 1.8 4 4v8c0 2.2-1.8 4-4 4zm-17 4.6c-1.9 1.1-4.4.4-5.5-1.5l-4-6.9c-1.1-1.9-.4-4.4 1.5-5.5 1.9-1.1 4.4-.4 5.5 1.5l4 6.9c1.1 1.9.4 4.4-1.5 5.5zM20.6 33c-1.1 1.9-3.6 2.6-5.5 1.5l-6.9-4c-1.9-1.1-2.6-3.6-1.5-5.5s3.6-2.6 5.5-1.5l6.9 4c1.9 1.1 2.6 3.6 1.5 5.5zM16 50c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h8c2.2 0 4 1.8 4 4zm4.6 17c1.1 1.9.4 4.4-1.5 5.5l-6.9 4c-1.9 1.1-4.4.4-5.5-1.5-1.1-1.9-.4-4.4 1.5-5.5l6.9-4c1.9-1.1 4.4-.4 5.5 1.5zM33 79.4c1.9 1.1 2.6 3.6 1.5 5.5l-4 6.9c-1.1 1.9-3.6 2.6-5.5 1.5s-2.6-3.6-1.5-5.5l4-6.9c1.1-1.9 3.6-2.6 5.5-1.5zM50 84c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4s-4-1.8-4-4v-8c0-2.2 1.8-4 4-4zm17-4.6c1.9-1.1 4.4-.4 5.5 1.5l4 6.9c1.1 1.9.4 4.4-1.5 5.5-1.9 1.1-4.4.4-5.5-1.5l-4-6.9c-1.1-1.9-.4-4.4 1.5-5.5zM79.4 67c1.1-1.9 3.6-2.6 5.5-1.5l6.9 4c1.9 1.1 2.6 3.6 1.5 5.5s-3.6 2.6-5.5 1.5l-6.9-4c-1.9-1.1-2.6-3.6-1.5-5.5zM84 50c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4s-1.8 4-4 4h-8c-2.2 0-4-1.8-4-4zm-4.6-17c-1.1-1.9-.4-4.4 1.5-5.5l6.9-4c1.9-1.1 4.4-.4 5.5 1.5 1.1 1.9.4 4.4-1.5 5.5l-6.9 4c-1.9 1.1-4.4.4-5.5-1.5zM67 20.6c-1.9-1.1-2.6-3.6-1.5-5.5l4-6.9c1.1-1.9 3.6-2.6 5.5-1.5s2.6 3.6 1.5 5.5l-4 6.9c-1.1 1.9-3.6 2.6-5.5 1.5z"
    })),
    surround: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M100 25V6.2c0-3.5-2.8-6.2-6.2-6.2H75c-3.5 0-6.2 2.8-6.2 6.2H31.2C31.2 2.8 28.5 0 25 0H6.2C2.8 0 0 2.8 0 6.2V25c0 3.5 2.8 6.2 6.2 6.2v37.5C2.8 68.8 0 71.5 0 75v18.8c0 3.5 2.8 6.2 6.2 6.2H25c3.5 0 6.2-2.8 6.2-6.2h37.5c0 3.5 2.8 6.2 6.2 6.2h18.8c3.5 0 6.2-2.8 6.2-6.2V75c0-3.5-2.8-6.2-6.2-6.2V31.2c3.5 0 6.3-2.7 6.3-6.2zM81.2 12.5h6.2v6.2h-6.2v-6.2zm-68.7 0h6.2v6.2h-6.2v-6.2zm6.3 75h-6.2v-6.2h6.2v6.2zm68.7 0h-6.2v-6.2h6.2v6.2zm-6.3-18.7H75c-3.5 0-6.2 2.8-6.2 6.2v6.2H31.2V75c0-3.5-2.8-6.2-6.2-6.2h-6.2V31.2H25c3.5 0 6.2-2.8 6.2-6.2v-6.2h37.5V25c0 3.5 2.8 6.2 6.2 6.2h6.2v37.6z"
    })),
    "surround-outline": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M89.3,71.9V28.1c6.2-1.6,10.7-7.1,10.7-13.8C100,6.4,93.6,0,85.7,0\n	c-6.6,0-12.2,4.6-13.8,10.7H28.1C26.5,4.6,20.9,0,14.3,0C6.4,0,0,6.4,0,14.3c0,6.6,4.6,12.2,10.7,13.8v43.9C4.6,73.5,0,79.1,0,85.7\n	C0,93.6,6.4,100,14.3,100c6.6,0,12.2-4.6,13.8-10.7h43.9c1.6,6.2,7.1,10.7,13.8,10.7c7.9,0,14.3-6.4,14.3-14.3\n	C100,79.1,95.4,73.5,89.3,71.9z M71.9,82.1H28.1c-1.3-5-5.2-8.9-10.2-10.2V28.1c5-1.3,8.9-5.2,10.2-10.2h43.9\n	c1.3,5,5.2,8.9,10.2,10.2v43.9C77.1,73.2,73.2,77.1,71.9,82.1z M85.7,7.1c3.9,0,7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1\n	c-3.9,0-7.1-3.2-7.1-7.1S81.8,7.1,85.7,7.1z M7.1,14.3c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1S7.1,18.2,7.1,14.3z\n	 M14.3,92.9c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1S18.2,92.9,14.3,92.9z M85.7,92.9c-3.9,0-7.1-3.2-7.1-7.1\n	s3.2-7.1,7.1-7.1c3.9,0,7.1,3.2,7.1,7.1S89.6,92.9,85.7,92.9z"
    })),
    swagger: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M50,4.8C75,4.8,95.2,25,95.2,50S75,95.2,50,95.2  C25,95.2,4.8,75,4.8,50S25,4.8,50,4.8z M34.9,24.4c-0.6,0-1.2,0-1.8,0c-4.1,0.2-6.5,2.2-7.2,6.1c-0.5,2.8-0.4,5.6-0.6,8.4  c-0.1,1.5-0.2,2.9-0.5,4.3c-0.6,2.5-1.6,3.3-4.2,3.5c-0.3,0-0.7,0.1-1,0.2v6.1c4.7,0.2,5.3,1.9,5.7,6.8c0.1,1.8,0,3.6,0.1,5.4  c0.1,1.7,0.3,3.4,0.6,5c1.1,4.5,5.5,6,10.7,5.1v-5.4c-0.9,0-1.6,0-2.3,0c-1.8-0.1-2.5-0.5-2.6-2.2c-0.2-2.2-0.2-4.5-0.3-6.7  c-0.3-4.2-0.7-8.3-4.8-10.9c2.1-1.5,3.6-3.4,4.1-5.8c0.3-1.7,0.6-3.4,0.7-5.2c0.1-1.7-0.1-3.5,0.1-5.2c0.2-2.8,0.4-3.9,3.7-3.8  c0.5,0,1-0.1,1.5-0.1v-5.5C36.1,24.5,35.5,24.5,34.9,24.4z M66.5,24.5c-1.1,0-2.3,0-3.4,0.2V30c1,0,1.8,0,2.6,0  c1.4,0,2.4,0.6,2.5,2.1c0.1,1.4,0.1,2.8,0.3,4.2c0.3,2.8,0.4,5.6,0.9,8.4c0.4,2.3,2,4,3.9,5.4c-3.4,2.3-4.4,5.5-4.6,9.2  c-0.1,2.5-0.2,5-0.3,7.6c-0.1,2.3-0.9,3.1-3.3,3.1c-0.7,0-1.3,0.1-2,0.1v5.4c1.3,0,2.6,0.1,3.9,0c3.9-0.2,6.2-2.1,7-5.9  c0.3-2.1,0.5-4.2,0.6-6.3c0.1-1.9,0.1-3.9,0.3-5.8c0.3-3,1.7-4.2,4.6-4.4c0.3,0,0.6-0.1,0.8-0.2v-6.1c-0.5-0.1-0.8-0.1-1.2-0.1  c-2.2-0.1-3.3-0.9-3.9-3c-0.3-1.4-0.6-2.7-0.6-4.1c-0.2-2.6-0.1-5.2-0.3-7.7C74,27,71.1,24.6,66.5,24.5L66.5,24.5z M37.8,46.5  c-4.5,0-4.8,6.6-0.4,7h0.2c1.9,0.1,3.5-1.3,3.6-3.2v-0.2C41.4,48.1,39.8,46.5,37.8,46.5L37.8,46.5z M49.9,46.5  c-1.9-0.1-3.4,1.4-3.5,3.3c0,0.1,0,0.2,0,0.3c0,2.1,1.4,3.4,3.6,3.4c2.1,0,3.5-1.4,3.5-3.5C53.5,47.9,52.1,46.5,49.9,46.5L49.9,46.5  z M62.3,46.5c-2,0-3.6,1.5-3.6,3.5c0,2,1.6,3.5,3.5,3.5h0c1.8,0.3,3.5-1.4,3.7-3.4C66,48.2,64.2,46.5,62.3,46.5L62.3,46.5z"
    })),
    text: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1 1)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M25.4,90.3V23.4H0V9.7h64.5v13.7H39.1v66.9H25.4z M70.6,90.3V49.2H54.8V35.5H100v13.7H84.3v41.2H70.6z"
    }))),
    "thumbs-down": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M3.5 2.3h15c2 0 3.5 1.9 3.5 3.8v45.3c0 1.9-1.6 3.8-3.5 3.8h-15c-2 0-3.5-1.9-3.5-3.8V6.1c0-1.9 1.6-3.8 3.5-3.8zM100 57.6v-1.5c0-3.8-3.2-6.8-7-6.8h-2.5c3.6-.3 6.5-3.5 6.5-7.2v-1.5c0-3.8-3.2-7.3-7-7.3h-3c3.9 0 7-2.9 7-6.7v-1.5c0-3.8-3.2-6.8-7-6.8h-3c3.9 0 7-3.4 7-7.2V9.6c0-3.8-3.2-7.3-7-7.3H40.2c-6.1 0-12.1 6.2-12.1 12.3v38c0 3.9 20.5 40 20.5 40 2.1 4.6 7.6 6.7 12.2 4.6l1.2-.5c4.6-2.1 7.3-7.7 6-12.6l-5.4-19.7H93c3.8-.1 7-3 7-6.8z"
    })),
    "thumbs-up": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M0 94.2V48.8C0 46.9 1.6 45 3.5 45h15c2 0 3.5 1.9 3.5 3.8v45.3c0 1.9-1.6 3.8-3.5 3.8h-15C1.6 98 0 96.1 0 94.2zM93 36H62.7L68 16.3c1.3-4.9-1.4-10.6-6-12.6l-1.2-.5c-4.6-2.1-10.1 0-12.2 4.6 0 0-20.5 36.1-20.5 40v38c0 6.1 5.9 12.3 12.1 12.3h43.7c3.9 0 7-3.4 7-7.3v-1.5c0-3.8-3.2-7.2-7-7.2h3c3.9 0 7-2.9 7-6.8v-1.5c0-3.8-3.2-6.7-7-6.7h3c3.9 0 7-3.4 7-7.3v-1.5c0-3.7-2.9-6.9-6.5-7.2H93c3.9 0 7-2.9 7-6.8v-1.5c0-3.9-3.2-6.8-7-6.8z"
    })),
    time: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m31.5 33.25 1.7-1.7-7.95-8v-10.05h-2.25v10.95zm-7.5 9.75q-3.9 0-7.375-1.5t-6.05-4.075-4.075-6.05-1.5-7.375 1.5-7.375 4.075-6.05 6.05-4.075 7.375-1.5 7.375 1.5 6.05 4.075 4.075 6.05 1.5 7.375-1.5 7.375-4.075 6.05-6.05 4.075-7.375 1.5zm0-19zm0 16.75q6.9 0 11.825-4.925t4.925-11.825-4.925-11.825-11.825-4.925-11.825 4.925-4.925 11.825 4.925 11.825 11.825 4.925z"
    })),
    trash: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M98 27c0-4.4-3.6-10-8-10H75.8L68.7 5.7C66.5 2.1 62.6 0 58.5 0h-17c-4.2 0-8 2.1-10.3 5.7l-7 11.3H10c-4.4 0-8 5.6-8 10 0 1.1.9 2 2 2h9v63c0 4.4 3.6 8 8 8h58c4.4 0 8-3.6 8-8V29h9c1.1 0 2-.9 2-2zM39.8 11c.4-.6 1.1-1 1.8-1h16.9c.7 0 1.4.4 1.8 1l3.8 6H36l3.8-6zM33 86h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3zm18 0h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3zm18 0h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3z"
    })),
    unlock: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M79 46.2V29.6C79 13.6 65.9 0 50 0 37.1 0 26.3 8.4 22.5 19.9c-.8 2.3.6 4.8 3 5.3l5.8 1.2c1.9.4 3.9-.6 4.6-2.5C38 18.4 43 14.3 49.1 14c8.8-.4 15.9 6.5 15.9 15v17H23c-6.6 0-12 5.4-12 12v30c0 6.6 5.4 12 12 12h54c6.6 0 12-5.4 12-12V58c0-5.9-4.3-10.9-10-11.8zM50 85c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8z"
    })),
    upload: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7V31.2H60.9c-2.5 0-4.7-2.1-4.7-4.6zm15 36.9c2 1.9.6 5.3-2.2 5.3H56.1v15.6c0 1.7-1.4 3.1-3.1 3.1h-6.2c-1.7 0-3.1-1.4-3.1-3.1V68.8H31c-2.8 0-4.2-3.3-2.2-5.3l18.8-18.7c1.3-1.3 3.4-1.3 4.7 0l18.9 18.7zm14.9-43L67 1.4C66.1.5 64.9 0 63.7 0h-1.2v25h25v-1.2c0-1.2-.5-2.4-1.4-3.3z"
    })),
    url: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "m22 33.1h-8q-3.85 0-6.475-2.625t-2.625-6.475 2.625-6.475 6.475-2.625h8v2.3h-8q-2.9 0-4.85 1.95t-1.95 4.85 1.95 4.85 4.85 1.95h8zm-5.3-7.95v-2.3h14.65v2.3zm9.3 7.95v-2.3h8q2.9 0 4.85-1.95t1.95-4.85-1.95-4.85-4.85-1.95h-8v-2.3h8q3.85 0 6.475 2.625t2.625 6.475-2.625 6.475-6.475 2.625z"
    })),
    user: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M50 10c9.9 0 18 8.1 18 18s-8.1 18-18 18-18-8.1-18-18 8.1-18 18-18m0-10C34.5 0 22 12.5 22 28s12.5 28 28 28 28-12.5 28-28S65.5 0 50 0zm0 70c12.6 0 23.4 4.8 31.2 13.8.5.6.8 1.4.8 2.3V90H18v-3.8c0-.9.4-1.9 1-2.6C26.9 74.7 37.6 70 50 70m0-10c-15.6 0-29 6.2-38.5 16.9C9.3 79.5 8 82.7 8 86.2v7.2c0 3.7 3 6.7 6.7 6.7h70.6c3.7 0 6.7-3 6.7-6.7v-7.2c0-3.2-1.1-6.4-3.2-8.9C79.3 66.4 65.8 60 50 60z"
    })),
    wand: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M87.7 25.3L85 22.6c-1.4-1.4-3.2-2-4.9-2-1.8 0-3.6.7-4.9 2L12.3 85.4c-2.7 2.7-2.7 7.2 0 9.9L15 98c1.4 1.4 3.2 2 4.9 2 1.8 0 3.6-.7 4.9-2l62.8-62.8c2.8-2.8 2.8-7.2.1-9.9zm-3.5 6.3L65.5 50.3 60 44.8l18.7-18.7c.5-.5 1.1-.6 1.4-.6.3 0 .9.1 1.4.6l2.7 2.7c.5.5.6 1.1.6 1.4s-.1.9-.6 1.4zM30.6 7.1l2.8 11.3c.2.6.6 1.1 1.2 1.2l11.3 2.8c1.7.4 1.7 2.9 0 3.3l-11.3 2.8c-.6.2-1.1.6-1.2 1.2L30.6 41c-.4 1.7-2.9 1.7-3.3 0l-2.8-11.3c-.2-.6-.6-1.1-1.2-1.2L12 25.7c-1.7-.4-1.7-2.9 0-3.3l11.3-2.8c.6-.2 1.1-.6 1.2-1.2l2.8-11.3c.4-1.7 2.9-1.7 3.3 0zm29.1-5.7l.9 3.5c.2.7.7 1.2 1.4 1.4l3.5.9c1.9.5 1.9 3.2 0 3.7l-3.5.9c-.7.2-1.2.7-1.4 1.4l-.9 3.5c-.5 1.9-3.2 1.9-3.7 0l-.9-3.5c-.2-.7-.7-1.2-1.4-1.4l-3.5-.9c-1.9-.5-1.9-3.2 0-3.7l3.5-.9c.7-.2 1.2-.7 1.4-1.4l.9-3.5c.4-1.9 3.2-1.9 3.7 0z"
    })),
    warning: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M83.9 95.3H16.1c-6.8 0-12-2.4-14.5-6.8s-2-10 1.4-16l33.9-58.7C40.3 7.9 45 4.6 50 4.6s9.7 3.3 13.1 9.2L97 72.6c3.4 5.9 3.9 11.6 1.4 16-2.5 4.3-7.7 6.7-14.5 6.7zm-27-19.7c0-3.5-2.9-6.4-6.4-6.4s-6.4 2.9-6.4 6.4c0 3.5 2.9 6.4 6.4 6.4s6.4-2.8 6.4-6.4zm.2-40.4c0-3.6-2.9-6.6-6.6-6.6s-6.5 3-6.5 6.6l1.5 23.3c.2 2.6 2.4 4.6 5 4.6 5 0 5-4.6 5-4.6l1.6-23.3z"
    })),
    "warning-stroke": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFFFFF",
        d: "M50,4.7c-6,0-11.6,3.8-15.4,10.4L3.8,68.5C0,75.2-0.5,81.8,2.5,87c3,5.3,8.9,8.2,16.7,8.2h61.7\n   c7.6,0,13.7-2.9,16.6-8.1c3-5.3,2.6-11.9-1.3-18.6L65.4,15.1C61.6,8.5,56,4.7,50,4.7L50,4.7z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFCA28",
        d: "M80.8,91.2H19.2C13,91.2,8.3,89,6,85s-1.8-9.1,1.3-14.6L38.1,17c3.1-5.4,7.4-8.4,11.9-8.4\n   s8.8,3,11.9,8.4l30.8,53.5c3.1,5.4,3.5,10.6,1.3,14.6C91.7,89,87,91.2,80.8,91.2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M56.3,73.3c0-3.2-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8S56.3,76.6,56.3,73.3z M56.5,36.5\n   c0-3.3-2.6-6-6-6s-5.9,2.7-5.9,6L46,57.7l0,0c0.2,2.4,2.2,4.2,4.5,4.2c4.5,0,4.5-4.2,4.5-4.2L56.5,36.5z"
    })),
    workflows: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M99 74c0 7.7-6.3 14-14 14s-14-6.3-14-14c0-1.1.1-2.2.4-3.2L50 58.6 28.6 70.8c.2 1 .4 2.1.4 3.2 0 7.7-6.3 14-14 14S1 81.7 1 74s6.3-14 14-14c3.7 0 7.1 1.5 9.6 3.9L46 51.7V27.4c-5.8-1.7-10-7.1-10-13.4 0-7.7 6.3-14 14-14s14 6.3 14 14c0 6.3-4.2 11.7-10 13.4v24.3l21.4 12.2c2.5-2.4 5.9-3.9 9.6-3.9 7.7 0 14 6.3 14 14zM14.1 51.9c.7-11.7 6.9-22 16.2-28-1.5-3-2.3-6.3-2.3-9.9v-.4C13.7 21.4 4 36.6 4 54v.8c3-1.7 6.4-2.7 10.1-2.9zm58-37.9c0 3.6-.8 6.9-2.3 9.9 9.3 6.1 15.5 16.3 16.2 28 3.6.2 7.1 1.2 10 2.9V54c0-17.4-9.7-32.6-23.9-40.4v.4zm-5.6 72C61.6 88.5 56 90 50 90s-11.5-1.4-16.5-4c-1.9 3-4.5 5.4-7.6 7.2 7 4.3 15.3 6.8 24.1 6.8s17.1-2.5 24.1-6.8C71 91.4 68.4 89 66.5 86z"
    })),
    "x-close": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M60 50l37.9-37.9c2.7-2.7 2.7-7.2 0-10s-7.2-2.7-10 0L50 40 12.1 2.1c-2.7-2.7-7.2-2.7-10 0s-2.7 7.2 0 10L40 50 2.1 87.9c-2.7 2.7-2.7 7.2 0 10s7.2 2.7 10 0L50 60l37.9 37.9c2.7 2.7 7.2 2.7 10 0s2.7-7.2 0-10L60 50z"
    })),
    "zoom-in": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M60.9,38.3V43c0,1.3-1.1,2.3-2.3,2.3H45.3v13.3c0,1.3-1.1,2.3-2.3,2.3h-4.7\n	c-1.3,0-2.3-1.1-2.3-2.3V45.3H22.7c-1.3,0-2.3-1.1-2.3-2.3v-4.7c0-1.3,1.1-2.3,2.3-2.3H36V22.7c0-1.3,1.1-2.3,2.3-2.3H43\n	c1.3,0,2.3,1.1,2.3,2.3V36h13.3C59.9,35.9,60.9,37,60.9,38.3z M99.3,94.9l-4.4,4.4c-0.9,0.9-2.4,0.9-3.3,0L67.9,75.6\n	c-0.4-0.4-0.7-1-0.7-1.7v-2.6c-7.1,6.2-16.4,9.9-26.6,9.9C18.2,81.2,0,63.1,0,40.6S18.2,0,40.6,0s40.6,18.2,40.6,40.6\n	c0,10.2-3.7,19.4-9.9,26.6h2.6c0.6,0,1.2,0.3,1.7,0.7l23.7,23.7C100.2,92.5,100.2,94,99.3,94.9L99.3,94.9z M71.9,40.6\n	c0-17.3-14-31.2-31.2-31.2S9.4,23.4,9.4,40.6s14,31.2,31.2,31.2S71.9,57.9,71.9,40.6z"
    })),
    "zoom-out": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M60.9,38.3V43c0,1.3-1.1,2.3-2.3,2.3H22.7c-1.3,0-2.3-1.1-2.3-2.3v-4.7\n	c0-1.3,1.1-2.3,2.3-2.3h35.9C59.9,35.9,60.9,37,60.9,38.3z M99.3,94.9l-4.4,4.4c-0.9,0.9-2.4,0.9-3.3,0L67.9,75.6\n	c-0.4-0.4-0.7-1-0.7-1.7v-2.6c-7.1,6.2-16.4,9.9-26.6,9.9C18.2,81.2,0,63.1,0,40.6S18.2,0,40.6,0s40.6,18.2,40.6,40.6\n	c0,10.2-3.7,19.4-9.9,26.6h2.6c0.6,0,1.2,0.3,1.7,0.7l23.7,23.7C100.2,92.5,100.2,94,99.3,94.9L99.3,94.9z M71.9,40.6\n	c0-17.3-14-31.2-31.2-31.2S9.4,23.4,9.4,40.6s14,31.2,31.2,31.2S71.9,57.9,71.9,40.6z"
    })),
    "local-type-none": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04088 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26707 15.732C4.73998 14.2053 0.640625 10.1069 0.640625 6.54315ZM9.89062 7.13333C9.73677 7.25894 9.5271 7.33083 9.30729 7.33333H4.30729C4.08628 7.33333 3.87432 7.2631 3.71804 7.13807C3.56176 7.01305 3.47396 6.84348 3.47396 6.66667C3.4841 6.49247 3.57516 6.32758 3.72929 6.20427C3.88343 6.08096 4.08955 6.00812 4.30729 6H9.30729C9.52831 6 9.74027 6.07024 9.89655 6.19526C10.0528 6.32029 10.1406 6.48986 10.1406 6.66667C10.1375 6.84251 10.0476 7.01025 9.89062 7.13333Z",
        fill: "white",
        fillOpacity: "0.7"
    })),
    "local-type-approx": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04088 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26707 15.732C4.73998 14.2053 0.640625 10.1069 0.640625 6.54315ZM4.21176 6.64367L4.21197 6.64328L4.21294 6.64156C4.21479 6.63828 4.2185 6.6318 4.22397 6.62258C4.23498 6.60407 4.25285 6.57504 4.27699 6.53904C4.3261 6.46579 4.39676 6.37026 4.48363 6.27741C4.6781 6.06954 4.84978 5.98333 4.97396 5.98333C5.52117 5.98333 5.90263 6.18124 6.51434 6.79295C7.24533 7.52394 7.9759 7.98333 9.011 7.98333C9.68723 7.98333 10.1743 7.56452 10.441 7.26777C10.5838 7.10879 10.6927 6.95269 10.7657 6.83738C10.8027 6.77907 10.8315 6.72947 10.8519 6.69286C10.8622 6.67451 10.8703 6.6593 10.8764 6.64774L10.884 6.63317L10.8866 6.62803L10.8877 6.62602L10.8881 6.62516L10.8883 6.62476C10.8884 6.62457 10.8885 6.62439 10.3073 6.33333L10.8885 6.62439C11.0492 6.3034 10.9193 5.91288 10.5983 5.75214C10.2783 5.59185 9.88905 5.72056 9.72747 6.03956L9.7272 6.04008L9.72651 6.04139C9.72488 6.04448 9.72153 6.05075 9.71651 6.05975C9.70643 6.07782 9.68994 6.10635 9.66749 6.14179C9.62176 6.21398 9.55575 6.30788 9.47397 6.3989C9.29135 6.60214 9.13027 6.68333 9.011 6.68333C8.45507 6.68333 8.03593 6.47606 7.43358 5.87371C6.71196 5.15209 6.01777 4.68333 4.97396 4.68333C4.30263 4.68333 3.80763 5.09712 3.53432 5.38926C3.38729 5.54641 3.27378 5.70088 3.19719 5.81513C3.15848 5.87288 3.12811 5.92197 3.1066 5.95815C3.09582 5.97628 3.08719 5.99128 3.08078 6.00264L3.07281 6.01693L3.07007 6.02194L3.06901 6.02388L3.06856 6.02472L3.06836 6.0251C3.06826 6.02528 3.06817 6.02545 3.64048 6.33325L3.06817 6.02545C2.89813 6.34161 3.01658 6.73575 3.33274 6.90579C3.64808 7.07539 4.04098 6.95799 4.21174 6.64369L4.21176 6.64367ZM9.72651 6.04139L9.72644 6.0416L9.72673 6.04101L9.72651 6.04139ZM10.3073 6.33333C9.7261 6.04228 9.72618 6.0421 9.72627 6.04193L9.7261 6.04228L10.3073 6.33333Z",
        fill: "white",
        fillOpacity: "0.7"
    })),
    "local-type-exact": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04087 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26708 15.732C4.73999 14.2053 0.640625 10.1069 0.640625 6.54315ZM5.52329 8.47982C5.63189 8.58842 5.76764 8.64272 5.90339 8.64272C6.03914 8.64272 6.17489 8.58842 6.28349 8.47982L9.92159 4.81457C10.1388 4.62452 10.1388 4.29872 9.92159 4.08152C9.73154 3.86432 9.40574 3.86432 9.18854 4.08152L5.87624 7.36667L4.43729 5.92772C4.24724 5.71052 3.92144 5.71052 3.70424 5.92772C3.48704 6.11777 3.48704 6.44357 3.70424 6.66077L5.52329 8.47982Z",
        fill: "white",
        fillOpacity: "0.7"
    }))
};

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iKD0d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partnerIcons", function() {
    return partnerIcons;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var partnerIcons = {
    base64ai: /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        version: "1.1",
        id: "Base64.ai",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 40"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "logo",
        fill: "#0F97FF",
        d: "M52.4,34.8V3.9h13.4c5.8,0,9.4,3,9.4,7.7c0,3.4-2.5,6.2-5.8,6.7v0.2c4.2,0.3,7.3,3.4,7.3,7.5\n          c0,5.4-4.1,8.8-10.7,8.8H52.4z M58.8,16.8h4.6c3.4,0,5.4-1.5,5.4-4.1c0-2.5-1.7-3.9-4.7-3.9h-5.3V16.8z M64.4,30\n          c3.7,0,5.7-1.6,5.7-4.5c0-2.9-2.1-4.4-5.9-4.4h-5.4v9H64.4z M79,28.2c0-4.2,3.2-6.6,8.9-6.9l5.8-0.3v-1.5c0-2.1-1.5-3.4-3.9-3.4\n          c-2.3,0-3.8,1.2-4.1,2.8H80c0.2-4.4,4-7.5,10.1-7.5c5.9,0,9.7,3,9.7,7.7v15.8h-6v-3.5h-0.1c-1.3,2.4-4.1,3.9-7,3.9\n          C82.3,35.2,79,32.3,79,28.2z M93.7,26.4v-1.7L88.8,25c-2.3,0.2-3.7,1.2-3.7,2.8c0,1.7,1.4,2.8,3.5,2.8\n          C91.4,30.6,93.7,28.9,93.7,26.4z M113.1,11.4c5.8,0,9.5,2.9,9.6,7.4h-5.8c-0.1-1.8-1.6-3-3.9-3c-2.2,0-3.6,1-3.6,2.5\n          c0,1.1,1,1.9,3,2.4l4.4,0.9c4.6,1,6.5,2.8,6.5,6.3c0,4.5-4.1,7.5-10.2,7.5c-6.1,0-9.9-3-10.2-7.4h6.1c0.3,1.9,1.8,3,4.3,3\n          c2.4,0,3.8-0.9,3.8-2.4c0-1.2-0.8-1.8-2.8-2.3l-4.2-0.9c-4.3-1-6.6-3.3-6.6-6.6C103.4,14.2,107.2,11.4,113.1,11.4z M147.3,27.8\n          c-0.7,4.5-4.8,7.5-10.5,7.5c-7.1,0-11.3-4.5-11.3-11.9c0-7.3,4.3-12.1,11.1-12.1c6.7,0,10.9,4.5,10.9,11.5v1.9h-15.8v0.4\n          c0,3.3,2.1,5.5,5.3,5.5c2.3,0,4-1.1,4.6-2.9H147.3z M131.8,20.9h9.7c-0.1-2.9-2-4.9-4.8-4.9C133.9,16,132,18.1,131.8,20.9z\n          M153.1,29.8c-1.7-2.6-2.6-6.1-2.6-10.2c0-10.2,5-16.4,12.9-16.4c5.9,0,10.5,3.5,11.3,8.5h-6.4c-0.6-2.1-2.6-3.4-5-3.4\n          c-4.3,0-6.9,4.1-6.8,11.1h0.1c1.2-3,4.3-5,8.2-5c5.9,0,10.2,4.3,10.2,10.2c0,6.4-4.9,10.9-11.9,10.9\n          C158.9,35.5,155.2,33.5,153.1,29.8z M168.9,24.8c0-3.2-2.4-5.5-5.6-5.5c-3.2,0-5.6,2.3-5.6,5.5c0,3.1,2.5,5.6,5.6,5.6\n          C166.4,30.3,168.9,27.9,168.9,24.8z M193.8,29.3h-15.4v-5.5c2.7-5.1,6.1-10.5,12.4-19.9h9.1v20.2h4v5.2h-4v5.5h-6.1V29.3z\n          M184.1,24.3h9.8V8.5h-0.1c-4.5,6.6-7.2,10.8-9.7,15.6V24.3z M207.9,31.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4\n          c0,1.9-1.5,3.4-3.4,3.4C209.4,35.1,207.9,33.5,207.9,31.6z M218.6,28.2c0-4.2,3.2-6.6,8.9-6.9l5.8-0.3v-1.5c0-2.1-1.5-3.4-3.9-3.4\n          c-2.3,0-3.8,1.2-4.1,2.8h-5.7c0.2-4.4,4-7.5,10.1-7.5c5.9,0,9.7,3,9.7,7.7v15.8h-6v-3.5h-0.1c-1.3,2.4-4.1,3.9-7,3.9\n          C221.9,35.2,218.6,32.3,218.6,28.2z M233.3,26.4v-1.7l-4.8,0.3c-2.3,0.2-3.7,1.2-3.7,2.8c0,1.7,1.4,2.8,3.5,2.8\n          C231,30.6,233.3,28.9,233.3,26.4z M243.3,6.1c0-1.8,1.5-3.2,3.3-3.2c1.9,0,3.3,1.4,3.3,3.2c0,1.8-1.5,3.2-3.3,3.2\n          C244.8,9.3,243.3,7.9,243.3,6.1z M243.5,11.9h6.2v22.9h-6.2V11.9z M19.3,13.8c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2\n          s6.2-2.8,6.2-6.2S22.8,13.8,19.3,13.8z M38.6,20c0,10.7-8.7,19.3-19.3,19.3S0,30.7,0,20S8.7,0.7,19.3,0.7S38.6,9.3,38.6,20z\n          M19.3,8.2C12.8,8.2,7.5,13.5,7.5,20s5.3,11.8,11.8,11.8S31.1,26.5,31.1,20S25.8,8.2,19.3,8.2z"
    })),
    "openai-logo": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        role: "img",
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z"
    })),
    "huggingface-logo": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        version: "1.1",
        viewBox: "0 0 250 44",
        xmlSpace: "preserve",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFFFFF",
        d: "m61.4 10.3h5v8.5h7.7v-8.5h5v22.2h-5v-9.3h-7.7v9.3h-5v-22.2zm21.7 5.3h5v9.8c0 1.2 0.2 2.1 0.5 2.5s0.9 0.7 1.6 0.7c0.6 0 1.2-0.1 1.6-0.4s0.9-0.8 1.4-1.4v-11.2h5v16.9h-4.1l-0.4-2.3h-0.1c-0.7 0.9-1.5 1.5-2.3 2s-1.8 0.7-3 0.7c-1.8 0-3.2-0.6-4-1.8s-1.2-2.9-1.2-5v-10.5zm17.8 19.8c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4-0.4 0.7-1.1 1.4-1.9 1.9s-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.6-0.6-0.7-1.3-0.7-2zm4.1-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.7-0.7 0.4-0.5 0.7-1.2 0.7-2.1s-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.7-0.7s-1.2 0.2-1.7 0.7c-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1.1 0.7 1.7 0.7zm10.1 11.3c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4s-1.1 1.4-1.9 1.9-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.6-0.6-0.7-1.3-0.7-2zm4.1-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.6-0.7s0.7-1.2 0.7-2.1-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.6-0.7-0.7 0-1.2 0.2-1.7 0.7-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1 0.7 1.7 0.7zm13.6-11c-0.8 0-1.5-0.2-2.1-0.7-0.5-0.5-0.8-1.1-0.8-1.9s0.3-1.4 0.8-1.9 1.2-0.7 2.1-0.7 1.6 0.2 2.1 0.7 0.8 1.1 0.8 1.9-0.3 1.4-0.8 1.9c-0.6 0.5-1.2 0.7-2.1 0.7zm-2.5 2.5h5v16.9h-5v-16.9zm8.7 0h4.1l0.3 2.1h0.1c0.7-0.7 1.5-1.3 2.4-1.8s1.9-0.8 3-0.8c1.8 0 3.2 0.6 4 1.8s1.2 2.9 1.2 5v10.5h-5v-9.8c0-1.2-0.2-2.1-0.5-2.5-0.3-0.5-0.9-0.7-1.6-0.7-0.6 0-1.2 0.1-1.6 0.4-0.5 0.3-1 0.7-1.5 1.2v11.4h-5v-16.8zm17.7 19.8c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4-0.4 0.7-1.1 1.4-1.9 1.9s-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.5-0.6-0.7-1.3-0.7-2zm4.2-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.6-0.7s0.7-1.2 0.7-2.1-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.6-0.7-0.7 0-1.2 0.2-1.7 0.7-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1 0.7 1.7 0.7zm17.9-13.8h14v4.2h-9v5.1h7.7v4.2h-7.7v8.6h-5v-22.1zm14.8 17.5c0-1.8 0.8-3.2 2.2-4.2 1.5-1 3.9-1.7 7.2-2 0-0.7-0.3-1.3-0.7-1.8-0.4-0.4-1.1-0.7-2-0.7-0.7 0-1.5 0.1-2.2 0.4s-1.5 0.6-2.3 1.1l-1.8-3.3c1.1-0.7 2.2-1.2 3.4-1.6s2.5-0.6 3.8-0.6c2.2 0 3.8 0.6 5 1.9 1.1 1.2 1.7 3.2 1.7 5.8v9.7h-3.8l-0.4-1.7h-0.1c-0.7 0.6-1.5 1.2-2.3 1.5-0.8 0.4-1.7 0.6-2.6 0.6-0.8 0-1.5-0.1-2.1-0.4s-1.1-0.6-1.6-1.1c-0.4-0.5-0.8-1-1-1.6s-0.4-1.3-0.4-2zm4.8-0.4c0 0.5 0.2 0.9 0.5 1.2s0.8 0.4 1.4 0.4 1.1-0.1 1.5-0.4c0.4-0.2 0.8-0.6 1.3-1.1v-3c-1.8 0.2-3 0.6-3.7 1.1-0.6 0.6-1 1.2-1 1.8zm12.4-3.4c0-1.4 0.2-2.7 0.7-3.8s1.1-2 1.9-2.8c0.8-0.7 1.7-1.3 2.8-1.7s2.2-0.6 3.3-0.6c1 0 2 0.2 2.8 0.5 0.8 0.4 1.5 0.8 2.1 1.4l-2.3 3.1c-0.8-0.7-1.6-1-2.3-1-1.2 0-2.2 0.4-2.9 1.3s-1.1 2-1.1 3.5 0.4 2.6 1.1 3.5 1.6 1.3 2.7 1.3c0.6 0 1.2-0.1 1.7-0.4 0.5-0.2 1-0.5 1.4-0.9l2 3.2c-0.8 0.7-1.7 1.3-2.7 1.6s-2 0.5-2.9 0.5c-1.2 0-2.3-0.2-3.3-0.6s-1.9-1-2.6-1.7-1.3-1.7-1.8-2.8-0.6-2.2-0.6-3.6zm14.2 0c0-1.4 0.2-2.6 0.7-3.7s1-2 1.8-2.8c0.7-0.8 1.6-1.3 2.5-1.8 1-0.4 1.9-0.6 3-0.6 1.2 0 2.3 0.2 3.1 0.6 0.9 0.4 1.6 1 2.2 1.7s1 1.6 1.3 2.6 0.4 2.1 0.4 3.2c0 0.5 0 0.9-0.1 1.2 0 0.4-0.1 0.7-0.1 0.9h-10.1c0.2 1.3 0.7 2.2 1.5 2.8s1.7 0.9 2.9 0.9 2.4-0.4 3.6-1.1l1.7 3c-0.9 0.6-1.8 1.1-2.9 1.4s-2.1 0.5-3.1 0.5c-1.2 0-2.3-0.2-3.4-0.6-1-0.4-2-1-2.7-1.7-0.8-0.8-1.4-1.7-1.8-2.8s-0.5-2.3-0.5-3.7zm10.9-1.7c0-1-0.2-1.8-0.6-2.4s-1.2-0.9-2.2-0.9c-0.8 0-1.5 0.3-2.1 0.8s-1 1.4-1.2 2.5h6.1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F8D14E",
        d: "M23.5,39.6c10.3,0,18.6-8.3,18.6-18.6S33.7,2.4,23.5,2.4C13.2,2.4,4.9,10.7,4.9,21S13.2,39.6,23.5,39.6z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F19F3C",
        d: "m42.1 21c0-10.3-8.3-18.6-18.6-18.6s-18.6 8.3-18.6 18.6 8.3 18.6 18.6 18.6c10.2 0 18.6-8.3 18.6-18.6zm-39.3 0c0-11.5 9.2-20.7 20.7-20.7 11.4 0 20.7 9.3 20.7 20.7s-9.3 20.7-20.7 20.7c-11.5 0-20.7-9.3-20.7-20.7z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3A3B44",
        d: "m29.5 15.9c0.7 0.2 1 1.6 1.6 1.3 1.3-0.7 1.8-2.3 1.1-3.6s-2.3-1.8-3.6-1.1-1.8 2.3-1.1 3.6c0.4 0.6 1.4-0.4 2-0.2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3A3B44",
        d: "m16.9 15.9c-0.7 0.2-1 1.6-1.6 1.3-1.3-0.7-1.8-2.3-1.1-3.6s2.3-1.8 3.6-1.1 1.8 2.3 1.1 3.6c-0.3 0.6-1.4-0.4-2-0.2z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#3A3B44",
        d: "m23.3 28.8c5.3 0 7-4.7 7-7.1 0-1.3-0.8-0.9-2.2-0.2-1.2 0.6-2.9 1.5-4.8 1.5-3.8 0-7-3.7-7-1.3s1.8 7.1 7 7.1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("filter", {
        id: "b",
        x: "18.8",
        y: "25.1",
        width: "9.3",
        height: "9.1",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("feColorMatrix", {
        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: "a",
        x: "18.8",
        y: "25.1",
        width: "9.3",
        height: "9.1",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFFFFF",
        filter: "url(#b)",
        d: "m23.3 28.8c5.3 0 7-4.7 7-7.1 0-1.3-0.8-0.9-2.2-0.2-1.2 0.6-2.9 1.5-4.8 1.5-3.8 0-7-3.7-7-1.3s1.8 7.1 7 7.1z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        mask: "url(#a)"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#E55049",
        d: "m23.5 34.2c2.6 0 4.6-2.1 4.6-4.6 0-2-1.3-3.7-3-4.4-0.1 0-0.1 0-0.2-0.1-0.4-0.1-0.9 1.4-1.4 1.4s-0.9-1.5-1.3-1.4c-1.9 0.6-3.3 2.3-3.3 4.4-0.1 2.7 2 4.7 4.6 4.7z"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F19F3C",
        d: "m36.1 18.5c1 0 1.7-0.8 1.7-1.7s-0.8-1.8-1.7-1.8c-1 0-1.7 0.8-1.7 1.7s0.7 1.8 1.7 1.8z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F19F3C",
        d: "m11.2 18.5c1 0 1.7-0.8 1.7-1.7s-0.8-1.8-1.7-1.8c-1 0-1.7 0.8-1.7 1.7s0.7 1.8 1.7 1.8z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F19F3C",
        d: "m7.6 24.3c-0.9 0-1.6 0.4-2.2 1-0.3 0.4-0.7 1-0.7 2-0.4-0.1-0.7-0.2-1-0.2-0.8 0-1.6 0.3-2.1 0.9-0.7 0.7-1 1.7-0.9 2.6 0.1 0.4 0.2 0.8 0.4 1.2-0.5 0.4-0.8 0.9-1 1.5-0.1 0.5-0.3 1.5 0.4 2.5 0 0.1-0.1 0.1-0.1 0.2-0.4 0.8-0.4 1.7-0.1 2.5 0.7 1.3 2 2.3 4.7 3.3 1.6 0.7 3.2 1.1 3.2 1.1 2.2 0.6 4.1 0.9 5.8 0.9 3.1 0 5.4-1 6.7-2.9 2.1-3 1.8-5.8-0.9-8.5-1.5-1.5-2.5-3.7-2.7-4.2-0.4-1.4-1.5-3-3.3-3h-0.5c-0.8 0.1-1.5 0.6-2 1.3-0.5-0.7-1.1-1.2-1.5-1.5-0.8-0.4-1.5-0.7-2.2-0.7zm0 2.2c0.3 0 0.6 0.1 1 0.3 1.1 0.7 3.3 4.5 4.1 6 0.3 0.5 0.7 0.7 1.1 0.7 0.8 0 1.5-0.8 0.1-1.9-2.1-1.6-1.4-4.1-0.4-4.3h0.1c0.9 0 1.3 1.6 1.3 1.6s1.2 3 3.2 5 2.1 3.6 0.7 5.8c-1 1.5-2.9 1.9-4.9 1.9s-4.1-0.5-5.3-0.8c-0.1 0-7.2-2-6.3-3.7 0.2-0.3 0.4-0.4 0.7-0.4 1.3 0 3.6 1.9 4.6 1.9 0.2 0 0.4-0.1 0.4-0.3 0.4-1.5-6.4-2.2-5.9-4.4 0.1-0.4 0.4-0.5 0.8-0.5 1.7 0 5.5 3 6.2 3 0.1 0 0.1 0 0.1-0.1 0.4-0.6 0.2-1.1-2.6-2.8-2.6-1.7-4.6-2.8-3.5-4 0.1-0.1 0.3-0.2 0.5-0.2 1.7 0 5.7 3.6 5.7 3.6s1.1 1.1 1.7 1.1c0.2 0 0.3-0.1 0.4-0.2 0.5-0.8-4.3-4.4-4.6-5.9-0.1-0.9 0.2-1.4 0.8-1.4z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F8D14E",
        d: "m18.9 39.7c1.5-2.2 1.4-3.8-0.7-5.8-2-2-3.2-5-3.2-5s-0.4-1.7-1.4-1.6-1.7 2.7 0.4 4.3-0.4 2.6-1.2 1.2c-0.8-1.5-3-5.3-4.1-6s-1.9-0.3-1.7 1.2c0.3 1.5 5 5.1 4.6 5.9-0.6 0.8-2.2-0.9-2.2-0.9s-5.1-4.7-6.2-3.4c-1.2 1.1 0.8 2.2 3.6 3.8 2.8 1.7 3 2.1 2.6 2.8-0.4 0.6-6.6-4.6-7.1-2.4-0.6 2.2 6.3 2.8 5.9 4.4-0.4 1.5-4.8-2.9-5.7-1.2s6.2 3.7 6.3 3.7c2.2 0.7 8 2 10.1-1z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F19F3C",
        d: "m39.6 24.3c0.9 0 1.6 0.4 2.2 1 0.3 0.4 0.7 1 0.7 2 0.4-0.1 0.7-0.2 1-0.2 0.8 0 1.6 0.3 2.1 0.9 0.7 0.7 1 1.7 0.9 2.6-0.1 0.4-0.2 0.8-0.4 1.2 0.5 0.4 0.8 0.9 1 1.5 0.1 0.5 0.3 1.5-0.4 2.5 0 0.1 0.1 0.1 0.1 0.2 0.4 0.8 0.4 1.7 0.1 2.5-0.5 1.2-1.9 2.2-4.6 3.3-1.6 0.7-3.2 1.1-3.2 1.1-2.2 0.6-4.1 0.9-5.8 0.9-3.1 0-5.4-1-6.7-2.9-2.1-3-1.8-5.8 0.9-8.5 1.5-1.5 2.5-3.7 2.7-4.2 0.4-1.4 1.5-3 3.3-3h0.5c0.8 0.1 1.5 0.6 2 1.3 0.5-0.7 1.1-1.2 1.5-1.5 0.7-0.4 1.4-0.7 2.1-0.7zm0 2.2c-0.3 0-0.6 0.1-1 0.3-1.1 0.7-3.3 4.5-4.1 6-0.3 0.5-0.7 0.7-1.1 0.7-0.8 0-1.5-0.8-0.1-1.9 2.1-1.6 1.4-4.1 0.4-4.3h-0.1c-0.9 0-1.3 1.6-1.3 1.6s-1.2 3-3.2 5-2.1 3.6-0.7 5.8c1 1.5 2.9 1.9 4.9 1.9s4.1-0.5 5.3-0.8c0.1 0 7.2-2 6.3-3.7-0.2-0.3-0.4-0.4-0.7-0.4-1.3 0-3.6 1.9-4.6 1.9-0.2 0-0.4-0.1-0.4-0.3-0.4-1.5 6.4-2.2 5.9-4.4-0.1-0.4-0.4-0.5-0.8-0.5-1.7 0-5.5 3-6.2 3-0.1 0-0.1 0-0.1-0.1-0.4-0.6-0.2-1.1 2.6-2.8s4.8-2.7 3.6-3.9c-0.1-0.1-0.3-0.2-0.5-0.2-1.7 0-5.7 3.6-5.7 3.6s-1.1 1.1-1.7 1.1c-0.2 0-0.3-0.1-0.4-0.2-0.5-0.8 4.3-4.4 4.6-5.9 0-1-0.3-1.5-0.9-1.5z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#F8D14E",
        d: "m28.4 39.7c-1.5-2.2-1.4-3.8 0.7-5.8 2-2 3.2-5 3.2-5s0.4-1.7 1.4-1.6c1 0.2 1.7 2.7-0.4 4.3s0.4 2.6 1.2 1.2c0.8-1.5 3-5.3 4.1-6s1.9-0.3 1.7 1.2c-0.3 1.5-5 5.1-4.6 5.9 0.5 0.8 2.1-0.9 2.1-0.9s5.1-4.7 6.2-3.4-0.8 2.2-3.6 3.9-3 2.1-2.6 2.8c0.4 0.6 6.6-4.6 7.1-2.4 0.6 2.2-6.3 2.8-5.9 4.4 0.4 1.5 4.8-2.9 5.7-1.2s-6.2 3.7-6.3 3.7c-2.1 0.6-8 1.9-10-1.1z"
    })),
    "microsoft-exchange-logo": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 81 70"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#28A8EA",
        d: "M75.6,0H57.8c-1.3,0-2.6,0.5-3.6,1.5l-42,42c-1,1-1.5,2.2-1.5,3.6v17.8c0,2.8,2.3,5.1,5.1,5.1c0,0,0,0,0,0h17.8\n	c1.3,0,2.6-0.5,3.6-1.5l42-42c1-1,1.5-2.2,1.5-3.6V5.1C80.7,2.3,78.4,0,75.6,0C75.6,0,75.6,0,75.6,0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#0078D4",
        d: "M75.6,70H57.8c-1.3,0-2.6-0.5-3.6-1.5L45.7,60V44.1c0-5,4.1-9.1,9.1-9.1h0h15.9l8.5,8.5c1,1,1.5,2.2,1.5,3.6\n	v17.8C80.7,67.7,78.4,70,75.6,70L75.6,70z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#50D9FF",
        d: "M15.8,0h17.8c1.3,0,2.6,0.5,3.6,1.5l8.5,8.5v15.9c0,5-4.1,9.1-9.1,9.1l0,0H20.7l-8.5-8.5c-1-1-1.5-2.2-1.5-3.6\n	V5.1C10.7,2.3,13,0,15.8,0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        opacity: "0.2",
        d: "M42.8,18v38.4c0,0.2,0,0.4-0.1,0.6c-0.3,1.6-1.7,2.8-3.3,2.8H10.7V14.6h28.7C41.3,14.6,42.8,16.1,42.8,18\n	C42.8,18,42.8,18,42.8,18z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        opacity: "0.1",
        d: "M44.2,18v35.5c0,2.7-2.2,4.8-4.9,4.9H10.7V13.1h28.7C42.1,13.1,44.2,15.3,44.2,18z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        opacity: "0.2",
        d: "M42.8,18v35.5c0,1.9-1.5,3.4-3.4,3.4c0,0,0,0,0,0H10.7V14.6h28.7C41.3,14.6,42.8,16.1,42.8,18\n	C42.8,18,42.8,18,42.8,18z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        opacity: "0.1",
        d: "M41.3,18v35.5c0,1.9-1.5,3.4-3.4,3.4c0,0,0,0,0,0H10.7V14.6h27.2C39.8,14.6,41.3,16.1,41.3,18\n	C41.3,18,41.3,18,41.3,18z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#0078D4",
        d: "M3.9,14.6h34c1.9,0,3.4,1.5,3.4,3.4v34c0,1.9-1.5,3.4-3.4,3.4h-34c-1.9,0-3.4-1.5-3.4-3.4V18\n	C0.5,16.1,2,14.6,3.9,14.6z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#FFFFFF",
        d: "M27.6,27.5h-9.5v5.6h9v3.6h-9v5.8h10.1v3.6H13.7V23.9h13.9L27.6,27.5z"
    })),
    "microsoft-form-recognizer-logo": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        version: "1.1",
        id: "Microsoft_Form_Recognizer",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 70 70"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "logo",
        fill: "#0078D4",
        d: "M42.2,20c0,0.8-0.6,1.5-1.5,1.5H11.5c-0.8,0-1.5-0.6-1.5-1.5c0-0.8,0.6-1.5,1.5-1.5h29.2\n	C41.5,18.5,42.2,19.2,42.2,20z M11.5,51h11.1c0-0.1-0.1-0.2-0.1-0.2c-0.4-0.9-0.7-1.8-1-2.7h-10c-0.8,0-1.5,0.6-1.5,1.5\n	C10.1,50.3,10.7,51,11.5,51z M26.5,58.4H3.3V3.3H39v8.4h8.6v13c1.1,0.1,2.2,0.3,3.3,0.5V10l-10-10H0v61.7h28.8\n	C28,60.7,27.2,59.6,26.5,58.4z M11.5,31.3h5.9c-0.1-0.9-0.2-1.4-0.2-1.5l-0.1-1.4h-5.6c-0.8,0-1.5,0.6-1.5,1.5\n	C10.1,30.6,10.7,31.3,11.5,31.3z M11.5,41.1h7.8c-0.3-1-0.5-2-0.7-2.9h-7.1c-0.8,0-1.5,0.6-1.5,1.5C10.1,40.5,10.7,41.1,11.5,41.1z\n	 M42.1,26.8c13.4,0,27.9,5.9,27.9,22.3c0,15.9-14.5,20.8-20.5,20.8c-26,0-29.8-40.3-29.8-40.3S30.1,26.8,42.1,26.8z M49.1,30.6\n	C39,30.6,30.8,38.8,30.8,49S39,67.3,49.1,67.3S67.5,59.1,67.5,49S59.3,30.6,49.1,30.6z M52.8,41H47v5.8h5.8V41z M62.5,41h-5.8v5.8\n	h5.8V41z M43,46.8h-5.8V41H43V46.8z M43,51.8h-5.8v5.8H43V51.8z M52.8,51.8H47v5.8h5.8V51.8z M62.5,51.8h-5.8v5.8h5.8V51.8z"
    })),
    "privateai-logo": /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        version: "1.1",
        id: "Private_AI",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 52"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        id: "logo"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "box",
        fill: "#197ACF",
        d: "M246.8,3.1v45.8h-59V3.1H246.8 M249.9,0h-65.2v52h65.2V0L249.9,0z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        id: "type",
        fill: "#FFFFFF",
        d: "M0,13.4h4.6c2.5,0,4.3,0.2,5.4,0.7c1.1,0.5,2,1.2,2.6,2.2c0.6,1,1,2.3,1,3.7c0,1.6-0.4,2.9-1.2,4\n            c-0.8,1.1-2,1.8-3.4,2.2c-0.8,0.2-2.4,0.4-4.6,0.4v9.6H0V13.4z M4.3,22.3h1.4c1.1,0,1.8-0.1,2.3-0.2c0.4-0.2,0.8-0.4,1-0.8\n            c0.2-0.4,0.4-0.8,0.4-1.3c0-0.9-0.3-1.5-1-1.9c-0.5-0.3-1.4-0.5-2.8-0.5H4.3V22.3z M28,13.4h4.6c2.5,0,4.3,0.2,5.4,0.7\n            c1.1,0.4,1.9,1.2,2.6,2.2c0.6,1,1,2.3,1,3.7c0,1.5-0.4,2.7-1.1,3.8c-0.7,1-1.8,1.8-3.2,2.3l5.4,10.1h-4.7l-5.1-9.6h-0.4v9.6H28\n            V13.4z M32.3,22.3h1.4c1.4,0,2.3-0.2,2.8-0.5c0.5-0.4,0.8-1,0.8-1.8c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.4-0.6-0.6-1-0.8\n            s-1.2-0.2-2.4-0.2h-1.2V22.3z M55.6,13.4h4.3v22.8h-4.3V13.4z M73,13.4h4.5l5.7,16.2L89,13.4h4.5l-8.2,22.8H81L73,13.4z\n            M111.6,13.4h4.4l8.8,22.8h-4.5l-1.8-4.7h-9.3l-1.9,4.7h-4.5L111.6,13.4z M113.9,19.4l-3.1,7.8h6.1L113.9,19.4z M135.3,13.4h12.6\n            v4.3h-4.2v18.5h-4.4V17.7h-4V13.4z M160.2,13.4h12.4v4.2h-8.1v4.1h8.1v4.2h-8.1v6h8.1v4.3h-12.4V13.4z M205,13.4h4.4l8.8,22.8h-4.5\n            l-1.8-4.7h-9.3l-1.9,4.7h-4.5L205,13.4z M207.2,19.4l-3.1,7.8h6.1L207.2,19.4z M230.6,13.4h4.3v22.8h-4.3V13.4z"
    })))
};

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Q7WR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", function() {
    return Button;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _buttonStyles = require("./Button.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function Button(props) {
    var busy = props.busy, children = props.children, className = props.className, disabled = props.disabled, id = props.id, onClick = props.onClick, onFocus = props.onFocus, role = props.role, style = props.style, tabindex = props.tabindex, type = props.type, _props_variant = props.variant, variant = _props_variant === void 0 ? "default" : _props_variant, rest = __rest(props, [
        "busy",
        "children",
        "className",
        "disabled",
        "id",
        "onClick",
        "onFocus",
        "role",
        "style",
        "tabindex",
        "type",
        "variant"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonStyles.StyledButton), Object.assign({
        "aria-disabled": busy,
        "aria-label": props["aria-label"],
        "aria-pressed": props["aria-pressed"],
        "aria-selected": props["aria-selected"],
        className: (0, _classnamesDefault.default)(variant, className, {
            blue: variant === "primary" || variant === "cta",
            busy: busy
        }),
        "data-cy": props["data-cy"],
        "data-for": props["data-for"],
        "data-tip": props["data-tip"],
        disabled: disabled,
        id: id,
        onClick: busy ? undefined : onClick,
        onFocus: onFocus,
        role: role,
        style: style,
        tabIndex: tabindex,
        type: type || "button"
    }, rest), busy && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), {
        size: "0.9em",
        style: {
            marginRight: "0.5em"
        }
    }), children);
}

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Button.styles":"j1Stv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9xS9S":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg);
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg) && arg.length) {
                var inner = classNames.apply(null, arg);
                if (inner) classes.push(inner);
            } else if (argType === "object") {
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"iliLC":[function(require,module,exports) {
// Storybook Helpers
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storyTitle", function() {
    return 0, _storyTitle.storyTitle;
});
parcelHelpers.export(exports, "GlobalStyles", function() {
    return 0, _globals.GlobalStyles;
});
parcelHelpers.export(exports, "colorProperties", function() {
    return 0, _colorProperties.colorProperties;
});
///// UI Foundations
// Icons
parcelHelpers.export(exports, "faIcons", function() {
    return 0, _faIcons.faIcons;
});
parcelHelpers.export(exports, "indicons", function() {
    return 0, _indicons.indicons;
});
parcelHelpers.export(exports, "partnerIcons", function() {
    return 0, _partnerIcons.partnerIcons;
});
// Buttons
parcelHelpers.export(exports, "Button", function() {
    return 0, _button.Button;
});
parcelHelpers.export(exports, "ControlButton", function() {
    return 0, _controlButton.ControlButton;
});
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return 0, _controlButton.controlButtonSpacing;
});
parcelHelpers.export(exports, "GenerateReport", function() {
    return 0, _generateReport.GenerateReport;
});
parcelHelpers.export(exports, "IconButton", function() {
    return 0, _iconButton.IconButton;
});
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return 0, _segmentedControlButtons.SegmentedControlButtons;
});
// Navigation
parcelHelpers.export(exports, "BackToLink", function() {
    return 0, _backToLink.BackToLink;
});
// Dropdowns
parcelHelpers.export(exports, "MultiCombobox", function() {
    return 0, _dropdowns.MultiCombobox;
});
parcelHelpers.export(exports, "useCombobox", function() {
    return 0, _dropdowns.useCombobox;
});
parcelHelpers.export(exports, "BorderSelect", function() {
    return 0, _dropdowns.BorderSelect;
});
parcelHelpers.export(exports, "Select", function() {
    return 0, _dropdowns.Select;
});
parcelHelpers.export(exports, "SingleCombobox", function() {
    return 0, _dropdowns.SingleCombobox;
});
parcelHelpers.export(exports, "Filter", function() {
    return 0, _dropdowns.Filter;
});
parcelHelpers.export(exports, "FilterSelect", function() {
    return 0, _dropdowns.FilterSelect;
});
// Fields
parcelHelpers.export(exports, "EditableField", function() {
    return 0, _editableField.EditableField;
});
parcelHelpers.export(exports, "NumberField", function() {
    return 0, _numberField.NumberField;
});
parcelHelpers.export(exports, "NumberFieldV2", function() {
    return 0, _numberField1.NumberField;
});
parcelHelpers.export(exports, "SearchField", function() {
    return 0, _searchField.SearchField;
});
parcelHelpers.export(exports, "TextField", function() {
    return 0, _textField.TextField;
});
// Interactive Controls
parcelHelpers.export(exports, "Card", function() {
    return 0, _card.Card;
});
parcelHelpers.export(exports, "CardContainer", function() {
    return 0, _cardContainer.CardContainer;
});
parcelHelpers.export(exports, "Checkbox", function() {
    return 0, _checkbox.Checkbox;
});
parcelHelpers.export(exports, "DatePicker", function() {
    return 0, _datePicker.DatePicker;
});
parcelHelpers.export(exports, "DateRangePicker", function() {
    return 0, _dateRangePicker.DateRangePicker;
});
// export { Flipper } from './components/ui-foundations/interactive-controls/Flipper/Flipper';
parcelHelpers.export(exports, "KabobMenu", function() {
    return 0, _kabobMenu.KabobMenu;
});
parcelHelpers.export(exports, "MenuButton", function() {
    return 0, _menuButton.MenuButton;
});
// export {
//   Radio,
//   RadioGroup,
// } from './components/ui-foundations/interactive-controls/RadioButtons/RadioButtons';
parcelHelpers.export(exports, "PillCheckGroup", function() {
    return 0, _pillCheckGroup.PillCheckGroup;
});
parcelHelpers.export(exports, "StyledToggle", function() {
    return 0, _toggleStyles.StyledToggle;
});
parcelHelpers.export(exports, "Toggle", function() {
    return 0, _toggle.Toggle;
});
parcelHelpers.export(exports, "Tag", function() {
    return 0, _tag.Tag;
});
parcelHelpers.export(exports, "ValidationText", function() {
    return 0, _validationText.ValidationText;
});
// Status Indicators
parcelHelpers.export(exports, "BarSpinner", function() {
    return 0, _barSpinner.BarSpinner;
});
parcelHelpers.export(exports, "LoadingIndicator", function() {
    return 0, _loadingIndicator.LoadingIndicator;
});
parcelHelpers.export(exports, "LoadingList", function() {
    return 0, _loadingList.LoadingList;
});
parcelHelpers.export(exports, "LoadingSpinner", function() {
    return 0, _loadingSpinner.LoadingSpinner;
});
parcelHelpers.export(exports, "PercentageRing", function() {
    return 0, _percentageRing.PercentageRing;
});
parcelHelpers.export(exports, "ProgressBar", function() {
    return 0, _progressBar.ProgressBar;
});
parcelHelpers.export(exports, "RandomLoadingMessage", function() {
    return 0, _randomLoadingMessage.RandomLoadingMessage;
});
parcelHelpers.export(exports, "StyledProgressBar", function() {
    return 0, _progressBarStyles.StyledProgressBar;
});
parcelHelpers.export(exports, "AppCrash", function() {
    return 0, _appCrash.AppCrash;
});
parcelHelpers.export(exports, "ConfirmModal", function() {
    return 0, _confirmModal.ConfirmModal;
});
parcelHelpers.export(exports, "ContentModal", function() {
    return 0, _contentModal.ContentModal;
});
parcelHelpers.export(exports, "FailSnail", function() {
    return 0, _failSnail.FailSnail;
});
parcelHelpers.export(exports, "Shrug", function() {
    return 0, _shrug.Shrug;
});
parcelHelpers.export(exports, "Toast", function() {
    return 0, _toast.Toast;
});
parcelHelpers.export(exports, "Tooltip", function() {
    return 0, _tooltip.Tooltip;
});
parcelHelpers.export(exports, "Flag", function() {
    return 0, _flag.Flag;
});
// Basic Section
parcelHelpers.export(exports, "Section", function() {
    return 0, _section.Section;
});
parcelHelpers.export(exports, "SectionBody", function() {
    return 0, _sectionBody.SectionBody;
});
parcelHelpers.export(exports, "SectionHeader", function() {
    return 0, _sectionHeader.SectionHeader;
});
parcelHelpers.export(exports, "SectionBlock", function() {
    return 0, _sectionBlock.SectionBlock;
});
parcelHelpers.export(exports, "SectionTable", function() {
    return 0, _sectionTable.SectionTable;
});
// Cards
parcelHelpers.export(exports, "WidgetCard", function() {
    return 0, _widgetCard.WidgetCard;
});
parcelHelpers.export(exports, "WidgetCardContent", function() {
    return 0, _widgetCard.WidgetCardContent;
});
parcelHelpers.export(exports, "WidgetCardHeader", function() {
    return 0, _widgetCard.WidgetCardHeader;
});
// Datavis
parcelHelpers.export(exports, "ChartContextMenu", function() {
    return 0, _chartContextMenu.ChartContextMenu;
});
parcelHelpers.export(exports, "ChartToolTip", function() {
    return 0, _chartToolTip.ChartToolTip;
});
parcelHelpers.export(exports, "Matrix", function() {
    return 0, _matrix.Matrix;
});
parcelHelpers.export(exports, "Bar", function() {
    return 0, _barDefault.default;
});
parcelHelpers.export(exports, "Circle", function() {
    return 0, _circle.Circle;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _line.Line;
});
parcelHelpers.export(exports, "HorizontalBarChart", function() {
    return 0, _horizontalBarChart.HorizontalBarChart;
});
parcelHelpers.export(exports, "Accordion", function() {
    return 0, _accordion.Accordion;
});
parcelHelpers.export(exports, "DragDropList", function() {
    return 0, _dragDropList.DragDropList;
});
parcelHelpers.export(exports, "OldDragDropList", function() {
    return 0, _oldDragDropList.OldDragDropList;
});
parcelHelpers.export(exports, "Icon", function() {
    return 0, _icon.Icon;
});
parcelHelpers.export(exports, "HeaderValues", function() {
    return 0, _headerValues.HeaderValues;
});
parcelHelpers.export(exports, "ListTable", function() {
    return 0, _listTable.ListTable;
});
parcelHelpers.export(exports, "LoadingAwareContainer", function() {
    return 0, _loadingAwareContainer.LoadingAwareContainer;
});
parcelHelpers.export(exports, "Logo", function() {
    return 0, _logo.Logo;
});
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _pagination.Pagination;
});
parcelHelpers.export(exports, "PaginationWithoutQuery", function() {
    return 0, _paginationWithoutQuery.PaginationWithoutQuery;
});
parcelHelpers.export(exports, "ReorderableList", function() {
    return 0, _reorderableList.ReorderableList;
});
parcelHelpers.export(exports, "ListControls", function() {
    return 0, _reorderableList.ListControls;
});
parcelHelpers.export(exports, "useListItem", function() {
    return 0, _reorderableList.useListItem;
});
parcelHelpers.export(exports, "useListControls", function() {
    return 0, _reorderableList.useListControls;
});
parcelHelpers.export(exports, "SaveCancel", function() {
    return 0, _saveCancel.SaveCancel;
});
parcelHelpers.export(exports, "StyledSaveCancel", function() {
    return 0, _saveCancelStyles.StyledSaveCancel;
});
parcelHelpers.export(exports, "TabbedContainer", function() {
    return 0, _tabbedContainer.TabbedContainer;
});
parcelHelpers.export(exports, "TabNavigation", function() {
    return 0, _tabNavigation.TabNavigation;
});
parcelHelpers.export(exports, "Table", function() {
    return 0, _table.Table;
});
parcelHelpers.export(exports, "TeamTable", function() {
    return 0, _teamTable.TeamTable;
});
parcelHelpers.export(exports, "Wizard", function() {
    return 0, _wizard.Wizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return 0, _wizard.WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return 0, _wizard.WizardSection;
});
parcelHelpers.export(exports, "StyledWizard", function() {
    return 0, _wizard.StyledWizard;
});
parcelHelpers.export(exports, "DragDropVerticalList", function() {
    return 0, _dragDropVerticalList.DragDropVerticalList;
});
parcelHelpers.export(exports, "ModalBase", function() {
    return 0, _modalBase.ModalBase;
});
parcelHelpers.export(exports, "AbstractRadio", function() {
    return 0, _radioGroup.Radio;
});
parcelHelpers.export(exports, "AbstractRadioGroup", function() {
    return 0, _radioGroup.RadioGroup;
});
parcelHelpers.export(exports, "TabbedInterface", function() {
    return 0, _tabbedInterface.TabbedInterface;
});
parcelHelpers.export(exports, "CopyableFilename", function() {
    return 0, _copyableFilename.CopyableFilename;
});
parcelHelpers.export(exports, "CopyableSelect", function() {
    return 0, _copyableSelect.CopyableSelect;
});
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return 0, _dateTimeDisplay.DateTimeDisplay;
});
// todo
parcelHelpers.export(exports, "AppTitle", function() {
    return 0, _appTitle.AppTitle;
});
// Form Controls
parcelHelpers.export(exports, "Radio", function() {
    return 0, _radioButtons.Radio;
});
parcelHelpers.export(exports, "RadioGroup", function() {
    return 0, _radioButtons.RadioGroup;
});
parcelHelpers.export(exports, "Flipper", function() {
    return 0, _flipper.Flipper;
});
parcelHelpers.export(exports, "partialTextStyles", function() {
    return _text;
});
var _storyTitle = require("./storybook-helpers/storyTitle");
// Component System Modules
var _constants = require("./constants");
parcelHelpers.exportAll(_constants, exports);
var _globals = require("./styles/globals");
var _text = require("./styles/partials/text");
var _colorProperties = require("./styles/globals/color-properties");
var _faIcons = require("./components/ui-foundations/Icon/faIcons");
var _indicons = require("./components/ui-foundations/Icon/indicons");
var _partnerIcons = require("./components/ui-foundations/Icon/partnerIcons");
var _button = require("./components/ui-foundations/buttons/Button/Button");
var _controlButton = require("./components/ui-foundations/buttons/ControlButton");
var _generateReport = require("./components/ui-foundations/buttons/GenerateReport/GenerateReport");
var _iconButton = require("./components/ui-foundations/buttons/IconButton/IconButton");
var _segmentedControlButtons = require("./components/ui-foundations/buttons/SegmentedControlButtons");
var _backToLink = require("./components/ui-foundations/navigation/BackToLink");
var _dropdowns = require("./components/ui-foundations/dropdowns");
var _editableField = require("./components/ui-foundations/fields/EditableField/EditableField");
var _numberField = require("./components/ui-foundations/fields/NumberField/NumberField");
var _numberField1 = require("./components/ui-foundations/fields/NumberFieldV2/NumberField");
var _searchField = require("./components/ui-foundations/fields/SearchField/SearchField");
var _textField = require("./components/ui-foundations/fields/TextField/TextField");
var _card = require("./components/ui-foundations/cards/Card/Card");
var _cardContainer = require("./components/ui-foundations/cards/CardContainer");
var _checkbox = require("./components/ui-foundations/interactive-controls/Checkbox/Checkbox");
var _datePicker = require("./components/ui-foundations/interactive-controls/DatePicker/DatePicker");
var _dateRangePicker = require("./components/ui-foundations/interactive-controls/DateRangePicker/DateRangePicker");
var _kabobMenu = require("./components/ui-foundations/interactive-controls/KabobMenu/KabobMenu");
var _menuButton = require("./components/ui-foundations/interactive-controls/MenuButton/MenuButton");
var _pillCheckGroup = require("./components/ui-foundations/interactive-controls/PillCheckGroup");
var _toggleStyles = require("./components/ui-foundations/interactive-controls/Toggle/Toggle.styles");
var _toggle = require("./components/ui-foundations/interactive-controls/Toggle/Toggle");
var _tag = require("./components/ui-foundations/interactive-controls/Tag/Tag");
var _validationText = require("./components/ui-foundations/interactive-controls/ValidationText/ValidationText");
var _barSpinner = require("./components/ui-foundations/status-indicators/BarSpinner/BarSpinner");
var _loadingIndicator = require("./components/ui-foundations/status-indicators/LoadingIndicator/LoadingIndicator");
var _loadingList = require("./components/ui-foundations/status-indicators/LoadingList/LoadingList");
var _loadingSpinner = require("./components/ui-foundations/status-indicators/LoadingSpinner/LoadingSpinner");
var _percentageRing = require("./components/ui-foundations/status-indicators/PercentageRing/PercentageRing");
var _progressBar = require("./components/ui-foundations/status-indicators/ProgressBar/ProgressBar");
var _randomLoadingMessage = require("./components/ui-foundations/status-indicators/RandomLoadingMessage/RandomLoadingMessage");
var _progressBarStyles = require("./components/ui-foundations/status-indicators/ProgressBar/ProgressBar.styles");
var _appCrash = require("./components/ui-foundations/user-feedback/AppCrash/AppCrash");
var _confirmModal = require("./components/ui-foundations/user-feedback/ConfirmModal/ConfirmModal");
var _contentModal = require("./components/ui-foundations/user-feedback/ContentModal/ContentModal");
var _failSnail = require("./components/ui-foundations/user-feedback/FailSnail/FailSnail");
var _shrug = require("./components/ui-foundations/user-feedback/Shrug/Shrug");
var _toast = require("./components/ui-foundations/user-feedback/Toast/Toast");
var _tooltip = require("./components/ui-foundations/user-feedback/Tooltip/Tooltip");
var _flag = require("./components/ui-foundations/user-feedback/Flag/Flag");
var _section = require("./components/ui-foundations/basic-section/Section/Section");
var _sectionBody = require("./components/ui-foundations/basic-section/SectionBody/SectionBody");
var _sectionHeader = require("./components/ui-foundations/basic-section/SectionHeader/SectionHeader");
var _sectionBlock = require("./components/ui-foundations/basic-section/SectionBlock/SectionBlock");
var _sectionTable = require("./components/ui-foundations/basic-section/SectionTable/SectionTable");
var _widgetCard = require("./components/ui-foundations/cards/WidgetCard/WidgetCard");
var _chartContextMenu = require("./components/ui-foundations/datavis/ChartContextMenu/ChartContextMenu");
var _chartToolTip = require("./components/ui-foundations/datavis/ChartToolTip/ChartToolTip");
var _matrix = require("./components/ui-foundations/datavis/Matrix/Matrix");
var _bar = require("./components/ui-foundations/datavis/d3/Bar/Bar");
var _barDefault = parcelHelpers.interopDefault(_bar);
var _circle = require("./components/ui-foundations/datavis/d3/Circle/Circle");
var _line = require("./components/ui-foundations/datavis/d3/Line/Line");
var _horizontalBarChart = require("./components/ui-foundations/datavis/HorizontalBarChart/HorizontalBarChart");
var _accordion = require("./components/ui-foundations/Accordion/Accordion");
var _dragDropList = require("./components/ui-foundations/drag-n-drop/DragDropList/DragDropList");
var _oldDragDropList = require("./components/ui-foundations/drag-n-drop/OldDragDropList/OldDragDropList");
var _icon = require("./components/ui-foundations/Icon/Icon");
var _headerValues = require("./components/ui-foundations/HeaderValues");
var _listTable = require("./components/ui-foundations/ListTable");
var _loadingAwareContainer = require("./components/ui-foundations/LoadingAwareContainer/LoadingAwareContainer");
var _logo = require("./components/ui-foundations/Logo/Logo");
var _pagination = require("./components/ui-foundations/pagination-components/Pagination/Pagination");
var _paginationWithoutQuery = require("./components/ui-foundations/pagination-components/PaginationWithoutQuery/PaginationWithoutQuery");
var _reorderableList = require("./components/ui-foundations/ReorderableList");
var _saveCancel = require("./components/ui-foundations/SaveCancel/SaveCancel");
var _saveCancelStyles = require("./components/ui-foundations/SaveCancel/SaveCancel.styles");
var _tabbedContainer = require("./components/ui-foundations/TabbedContainer/TabbedContainer");
var _tabNavigation = require("./components/ui-foundations/TabNavigation/TabNavigation");
var _table = require("./components/ui-foundations/Table/Table");
var _teamTable = require("./components/ui-foundations/TeamTable/TeamTable");
var _wizard = require("./components/ui-foundations/Wizard");
var _dragDropVerticalList = require("./components/utility-components/DragDropVerticalList/DragDropVerticalList");
var _modalBase = require("./components/utility-components/ModalBase/ModalBase");
var _radioGroup = require("./components/utility-components/RadioGroup/RadioGroup");
var _tabbedInterface = require("./components/utility-components/TabbedInterface/TabbedInterface");
var _copyableFilename = require("./components/utility-components/CopyableFilename");
var _copyableSelect = require("./components/ui-foundations/dropdowns/CopyableSelect");
var _dateTimeDisplay = require("./components/utility-components/text-utilities/DateTimeDisplay");
var _appTitle = require("./components/chrome/AppTitle/AppTitle");
var _radioButtons = require("./components/form-controls/RadioButtons/RadioButtons");
var _flipper = require("./components/form-controls/Flipper/Flipper");

},{"./storybook-helpers/storyTitle":"9WGtC","./constants":"hYHjJ","./styles/globals":"crzXb","./styles/partials/text":"5cEUr","./styles/globals/color-properties":"hFIWF","./components/ui-foundations/Icon/faIcons":"9OrkN","./components/ui-foundations/Icon/indicons":"5ixPq","./components/ui-foundations/Icon/partnerIcons":"5MAF6","./components/ui-foundations/buttons/Button/Button":"gPP3j","./components/ui-foundations/buttons/ControlButton":"iUiDq","./components/ui-foundations/buttons/GenerateReport/GenerateReport":"3d71L","./components/ui-foundations/buttons/IconButton/IconButton":"aQAJo","./components/ui-foundations/buttons/SegmentedControlButtons":"kw0QR","./components/ui-foundations/navigation/BackToLink":"bWP3o","./components/ui-foundations/dropdowns":"9lp1V","./components/ui-foundations/fields/EditableField/EditableField":"Z9AlT","./components/ui-foundations/fields/NumberField/NumberField":"32qiH","./components/ui-foundations/fields/NumberFieldV2/NumberField":"1xQ7o","./components/ui-foundations/fields/SearchField/SearchField":"5M87q","./components/ui-foundations/fields/TextField/TextField":"kADDo","./components/ui-foundations/cards/Card/Card":"0aYlm","./components/ui-foundations/cards/CardContainer":"jrzRT","./components/ui-foundations/interactive-controls/Checkbox/Checkbox":"ha84m","./components/ui-foundations/interactive-controls/DatePicker/DatePicker":"5FaIf","./components/ui-foundations/interactive-controls/DateRangePicker/DateRangePicker":"hxIZ2","./components/ui-foundations/interactive-controls/KabobMenu/KabobMenu":"a9WPa","./components/ui-foundations/interactive-controls/MenuButton/MenuButton":"gLGqS","./components/ui-foundations/interactive-controls/PillCheckGroup":"45sEn","./components/ui-foundations/interactive-controls/Toggle/Toggle.styles":"anZ95","./components/ui-foundations/interactive-controls/Toggle/Toggle":"bBv5h","./components/ui-foundations/interactive-controls/Tag/Tag":"gI4sY","./components/ui-foundations/interactive-controls/ValidationText/ValidationText":"lXUmL","./components/ui-foundations/status-indicators/BarSpinner/BarSpinner":"hFYGz","./components/ui-foundations/status-indicators/LoadingIndicator/LoadingIndicator":"c4vDX","./components/ui-foundations/status-indicators/LoadingList/LoadingList":"emtiw","./components/ui-foundations/status-indicators/LoadingSpinner/LoadingSpinner":"2ZVeg","./components/ui-foundations/status-indicators/PercentageRing/PercentageRing":"eKrnJ","./components/ui-foundations/status-indicators/ProgressBar/ProgressBar":"jMRYG","./components/ui-foundations/status-indicators/RandomLoadingMessage/RandomLoadingMessage":"6Xmp2","./components/ui-foundations/status-indicators/ProgressBar/ProgressBar.styles":"l5S2r","./components/ui-foundations/user-feedback/AppCrash/AppCrash":"bkG7I","./components/ui-foundations/user-feedback/ConfirmModal/ConfirmModal":"bOUgi","./components/ui-foundations/user-feedback/ContentModal/ContentModal":"hbcR0","./components/ui-foundations/user-feedback/FailSnail/FailSnail":"YRMhe","./components/ui-foundations/user-feedback/Shrug/Shrug":"4I7nt","./components/ui-foundations/user-feedback/Toast/Toast":"lwcDf","./components/ui-foundations/user-feedback/Tooltip/Tooltip":"6XST1","./components/ui-foundations/user-feedback/Flag/Flag":"dHgiV","./components/ui-foundations/basic-section/Section/Section":"edPPv","./components/ui-foundations/basic-section/SectionBody/SectionBody":"dSc33","./components/ui-foundations/basic-section/SectionHeader/SectionHeader":"fdltS","./components/ui-foundations/basic-section/SectionBlock/SectionBlock":"97bu9","./components/ui-foundations/basic-section/SectionTable/SectionTable":"7pFkX","./components/ui-foundations/cards/WidgetCard/WidgetCard":"lfmK0","./components/ui-foundations/datavis/ChartContextMenu/ChartContextMenu":"kStzr","./components/ui-foundations/datavis/ChartToolTip/ChartToolTip":"1uTGc","./components/ui-foundations/datavis/Matrix/Matrix":"jxcY4","./components/ui-foundations/datavis/d3/Bar/Bar":"iXGem","./components/ui-foundations/datavis/d3/Circle/Circle":"lKBfG","./components/ui-foundations/datavis/d3/Line/Line":"ibbxE","./components/ui-foundations/datavis/HorizontalBarChart/HorizontalBarChart":"lsbPL","./components/ui-foundations/Accordion/Accordion":"gCfG3","./components/ui-foundations/drag-n-drop/DragDropList/DragDropList":"6wXLi","./components/ui-foundations/drag-n-drop/OldDragDropList/OldDragDropList":"fbvvs","./components/ui-foundations/Icon/Icon":"cld9p","./components/ui-foundations/HeaderValues":"hGWir","./components/ui-foundations/ListTable":"8QN7l","./components/ui-foundations/LoadingAwareContainer/LoadingAwareContainer":"ik9Lz","./components/ui-foundations/Logo/Logo":"5mDID","./components/ui-foundations/pagination-components/Pagination/Pagination":"asoma","./components/ui-foundations/pagination-components/PaginationWithoutQuery/PaginationWithoutQuery":"6fUIw","./components/ui-foundations/ReorderableList":"lXxra","./components/ui-foundations/SaveCancel/SaveCancel":"1i751","./components/ui-foundations/SaveCancel/SaveCancel.styles":"bdJL9","./components/ui-foundations/TabbedContainer/TabbedContainer":"60CMB","./components/ui-foundations/TabNavigation/TabNavigation":"fj2ra","./components/ui-foundations/Table/Table":"kJUwg","./components/ui-foundations/TeamTable/TeamTable":"e1wbT","./components/ui-foundations/Wizard":"7DipF","./components/utility-components/DragDropVerticalList/DragDropVerticalList":"hym5P","./components/utility-components/ModalBase/ModalBase":"fQQMg","./components/utility-components/RadioGroup/RadioGroup":"aCsXt","./components/utility-components/TabbedInterface/TabbedInterface":"1WGwM","./components/utility-components/CopyableFilename":"8x69h","./components/ui-foundations/dropdowns/CopyableSelect":"1sJXR","./components/utility-components/text-utilities/DateTimeDisplay":"afu0R","./components/chrome/AppTitle/AppTitle":"kixGB","./components/form-controls/RadioButtons/RadioButtons":"dZlUo","./components/form-controls/Flipper/Flipper":"bTfuJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9WGtC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storyTitle", function() {
    return storyTitle;
});
function storyTitle(base) {
    var capitalize = function(str) {
        return str.slice(0, 1).toUpperCase() + str.slice(1);
    };
    return base.split("/").filter(function(str) {
        return str.length > 0 && str !== "src" && str !== "packages" && str !== "components";
    }).map(function(str) {
        if (str.includes("-")) return str.split("-").map(function(s) {
            return capitalize(s);
        }).join(" ");
        return capitalize(str);
    }).join("/");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hYHjJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ANIMATION", function() {
    return 0, _animation.animation;
});
parcelHelpers.export(exports, "BREAKPOINT", function() {
    return 0, _breakpoints.breakpoints;
});
parcelHelpers.export(exports, "MEDIA_QUERIES", function() {
    return 0, _breakpoints.mediaQueries;
});
parcelHelpers.export(exports, "TYPOGRAPHY", function() {
    return 0, _typography.typography;
});
parcelHelpers.export(exports, "FONT_SIZE", function() {
    return 0, _typography.fontSize;
});
parcelHelpers.export(exports, "PADDINGS", function() {
    return 0, _padding.padding;
});
parcelHelpers.export(exports, "SPACING", function() {
    return 0, _spacings.spacings;
});
parcelHelpers.export(exports, "MARGINS", function() {
    return 0, _margin.margin;
});
parcelHelpers.export(exports, "MATH", function() {
    return 0, _numbers.MATH;
});
parcelHelpers.export(exports, "COLORS", function() {
    return 0, _colors.allColors;
});
parcelHelpers.export(exports, "BASE_COLORS", function() {
    return 0, _colors.baseColors;
});
parcelHelpers.export(exports, "FIELD_COLORS", function() {
    return 0, _colors.fieldColors;
});
parcelHelpers.export(exports, "LAYOUT_COLORS", function() {
    return 0, _colors.layoutColors;
});
parcelHelpers.export(exports, "GRAY_COLORS", function() {
    return 0, _colors.grayColors;
});
parcelHelpers.export(exports, "FONT_COLORS", function() {
    return 0, _colors.fontColors;
});
parcelHelpers.export(exports, "BUTTON_COLORS", function() {
    return 0, _colors.buttonColors;
});
parcelHelpers.export(exports, "NEW_BUTTON_COLORS", function() {
    return 0, _colors.newButtonColors;
});
parcelHelpers.export(exports, "VIZ_COLORS", function() {
    return 0, _colors.vizColors;
});
parcelHelpers.export(exports, "VIZ_COLORS_ARRAY", function() {
    return 0, _colors.vizColorsArray;
});
var _animation = require("./animation");
var _breakpoints = require("./breakpoints");
var _typography = require("./typography");
var _padding = require("./padding");
var _spacings = require("./spacings");
var _margin = require("./margin");
var _numbers = require("./numbers");
var _colors = require("./colors");

},{"./animation":"eJfWo","./breakpoints":"8RMah","./typography":"hqDXg","./padding":"fgskx","./spacings":"8K9E1","./margin":"cq5WS","./numbers":"emhLd","./colors":"eHGMX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eJfWo":[function(require,module,exports) {
// This is used for "micro animations" - general purpose values to give the app a general feel
// By no means is this the rule for building out custom animations for various parts of the application
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animation", function() {
    return animation;
});
var animation = {
    duration: "200ms",
    timing: "ease"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8RMah":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpoints", function() {
    return breakpoints;
});
parcelHelpers.export(exports, "mediaQueries", function() {
    return mediaQueries;
});
var breakpoints = {
    mediumScreen: "600px",
    largeScreen: "900px",
    maxScreen: "1300px"
};
var mediaQueries = {
    mediumScreen: "only screen and (min-width: ".concat(breakpoints.mediumScreen, ")"),
    largeScreen: "only screen and (min-width: ".concat(breakpoints.largeScreen, ")"),
    maxScreen: "only screen and (min-width: ".concat(breakpoints.maxScreen, ")")
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hqDXg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fontStack", function() {
    return fontStack;
});
parcelHelpers.export(exports, "fontFamily", function() {
    return fontFamily;
});
parcelHelpers.export(exports, "fontSize", function() {
    return fontSize;
});
parcelHelpers.export(exports, "lineHeight", function() {
    return lineHeight;
});
parcelHelpers.export(exports, "spacing", function() {
    return spacing;
});
parcelHelpers.export(exports, "ellipsis", function() {
    return ellipsis;
});
parcelHelpers.export(exports, "typography", function() {
    return typography;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var fontStack = [
    "Noto Sans",
    "-apple-system",
    "BlinkMacSystemFont",
    "Avenir Next",
    "Avenir",
    "Segoe UI",
    "Lucida Grande",
    "Helvetica Neue",
    "Helvetica",
    "Fira Sans",
    "Roboto",
    "Noto",
    "Droid Sans",
    "Cantarell",
    "Oxygen",
    "Ubuntu",
    "Franklin Gothic Medium",
    "Century Gothic",
    "Liberation Sans",
    "sans-serif"
];
var fontFamily = {
    base: fontStack.join(","),
    heading: fontStack.join(",")
};
var fontSize = {
    caption: "12px",
    base: "14px",
    subheadSmall: "16px",
    subheadLarge: "18px",
    subheadXl: "22px",
    display: "30px"
};
var lineHeight = {
    base: 1.25,
    heading: 1.2
};
var spacing = {
    base: "".concat(lineHeight.base, "em"),
    half: "".concat(lineHeight.base / 2, "em"),
    quarter: "".concat(lineHeight.base / 4, "em"),
    third: "".concat(lineHeight.base / 3, "em")
};
var ellipsis = (0, _styledComponents.css)(_templateObject());
var typography = {
    fontFamily: fontFamily,
    fontSize: fontSize,
    lineHeight: lineHeight,
    spacing: spacing,
    ellipsis: ellipsis
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fgskx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "padding", function() {
    return padding;
});
var padding = {
    // todo -- get with mike L for other padding values as they become needed. Ideally we should create a formula.
    xs: "10px",
    sm: "15px",
    md: "20px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8K9E1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spacings", function() {
    return spacings;
});
var spacings = {
    xs: "8px",
    sm: "12px",
    md: "24px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cq5WS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "margin", function() {
    return margin;
});
var margin = {
    // todo -- get with mike L for other padding values as they become needed. Ideally we should create a formula.
    sm: "15px",
    md: "20px"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"emhLd":[function(require,module,exports) {
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimalAdjust", function() {
    return decimalAdjust;
});
parcelHelpers.export(exports, "round10", function() {
    return round10;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "numberWithCommas", function() {
    return numberWithCommas;
});
parcelHelpers.export(exports, "MATH", function() {
    return MATH;
});
var decimalAdjust = function(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === "undefined" || +exp === 0) return Math[type](value);
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) return NaN;
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
};
var round10 = function(value, exp) {
    return decimalAdjust("round", value, exp);
};
var clamp = function(value, min, max) {
    value = value < min ? min : value;
    value = value > max ? max : value;
    return value;
};
var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var MATH = {
    decimalAdjust: decimalAdjust,
    round10: round10,
    clamp: clamp,
    numberWithCommas: numberWithCommas
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eHGMX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allColors", function() {
    return allColors;
});
parcelHelpers.export(exports, "baseColors", function() {
    return baseColors;
});
parcelHelpers.export(exports, "layoutColors", function() {
    return layoutColors;
});
parcelHelpers.export(exports, "grayColors", function() {
    return grayColors;
});
parcelHelpers.export(exports, "fontColors", function() {
    return fontColors;
});
parcelHelpers.export(exports, "buttonColors", function() {
    return buttonColors;
});
parcelHelpers.export(exports, "newButtonColors", function() {
    return newButtonColors;
});
parcelHelpers.export(exports, "vizColors", function() {
    return vizColors;
});
parcelHelpers.export(exports, "vizColorsArray", function() {
    return vizColorsArray;
});
parcelHelpers.export(exports, "fieldColors", function() {
    return fieldColors;
});
var allColors = {
    akaroa: "#cbc98f",
    alizarin: "#e72326",
    amber: "#f4c401",
    amethyst: "#8e57b3",
    aqua: "#10e4fe",
    astralBlue: "#2f7ca2",
    ateneoBlue: "#0d466a",
    avocado: "#81b12f",
    azure: "#108cf7",
    baliHai: "#8498b6",
    bermudaGrey: "#7488A4",
    biscay: "#334154",
    black: "#000",
    blackPearl: "#141B24",
    blueBayoux: "#4f5e74",
    blueMagenta: "#542f9d",
    blueRibbon: "#0b35ff",
    blueYonder: "#586fd2",
    bouqet: "#a35c9a",
    brick: "#c62828",
    brightOrange: "#f29c22",
    brown: "#785349",
    candyCorn: "#fcef4d",
    carnation: "#ff8adf",
    carrot: "#f29a2d",
    cerise: "#d52a96",
    cerulean: "#008b9e",
    chantilly: "#f7b0eb",
    charcoal: "#474b4b",
    charcoalBlue: "#334154 ",
    chartreuse: "#34ff01",
    chatamsBlue: "#2A496B",
    clay: "#283243",
    cloudBurst: "#333D4C",
    cocoaBean: "#5c1200",
    coffeeBean: "#321014",
    coolGray: "#8593B3",
    comet: "#5a6982",
    cornflower: "#2060ff",
    crimson: "#e53126",
    curiousBlue: "#178ee0",
    cyan: "#0cf",
    darkFontColor: "#0d151d",
    darkGray: "#333",
    darkPurple: "#6f3eae",
    darkRed: "#b30000",
    defaultFontColor: "#bbbfc5",
    deepTeal: "#003D27",
    dodgerBlue: "#1774ff",
    eagleGreen: "#005557",
    ebony: "#101a26",
    eggplant: "#7a0074",
    electricGreen: "#00ff0a",
    emerald: "#09c199",
    espresso: "#5a3627",
    fieldPromptError: "#fd9693",
    fieldPromptInfo: "#00bfff",
    fireEngineRed: "#c21d20",
    flamingo: "#f861b6",
    flirt: "#910870",
    forestGreen: "#1f7f1f",
    geraldine: "#fe9486",
    grannysmith: "#92e959",
    green: "#4caf50",
    goldenBrown: "#80670c",
    gunmetalBlue: "#344152",
    harlequin: "#20cb00",
    harvestGold: "#e6c079",
    hemlock: "#626740",
    imperial: "#4b0134",
    independence: "#4A5669",
    iron: "#d9dee0",
    japaneseIndigo: "#264359",
    juniper: "#6d9292",
    jungleGreen: "#087950",
    khaki: "#bba44b",
    koamaru: "#2f346a",
    korma: "#90370e",
    lavender: "#B086E3",
    lavenderRose: "#fb9fda",
    lightGray: "#eee",
    lightPurple: "#b43be4",
    lilac: "#a195d4",
    lincolnGreen: "#254600",
    magenta: "#ff15e0",
    malibu: "#68C2FB",
    mantis: "#4fa83d",
    maroon: "#ad3349",
    mauve: "#e06cfb",
    mediumGray: "#999",
    midFontColor: "#8593b3",
    midnight: "#233346",
    midnightBlue: "#1A2736",
    mint: "#3ac999",
    mintGreen: "#15b77d",
    mirage: "#182432",
    mulberry: "#5c0536",
    olive: "#807300",
    oliveBrown: "#463703",
    orange: "#ff7200",
    orchid: "#ab00ff",
    oxfordBlue: "#384558",
    pacific: "#00b5b6",
    pakistanGreen: "#006e00",
    portGore: "#394c6b",
    palm: "#1aa511",
    persian: "#1717cf",
    persianLight: "#0327ce",
    pewterBlue: "#92a8c2",
    pine: "#017074",
    pink: "#f74f8a",
    pistachio: "#aac609",
    raspberry: "#990030",
    red: "#f95359",
    reddishPink: "#CE6068",
    regalBlue: "#1D354E",
    robinsEggBlue: "#00bcd4",
    romanSilver: "#7d888d",
    salem: "#03832e",
    sanguineRed: "#68252A",
    sapGreen: "#5f7e20",
    seaGreen: "#0b8a51",
    seance: "#7f1f82",
    shiraz: "#c61021",
    sinopia: "#D14200",
    summerSky: "#36A1EA",
    spindle: "#bcc7da",
    tangerine: "#ff9900",
    teal: "#008285",
    toast: "#997862",
    trueBlue: "#066CC6",
    turquoise: "#00b5b6",
    vermilion: "#b95555",
    viking: "#59cfe0",
    violet: "#3e4eb8",
    violetBlue: "#8060d2",
    vividAzure: "#198BDC ",
    walnut: "#783f00",
    white: "#fff",
    whiteSmoke: "#f8f8f8",
    windsorTan: "#b35c00",
    yellow: "#ffca28",
    yellowOrange: "#fa3",
    zucchini: "#016422",
    get hiliteFontColor () {
        return this.white;
    },
    get lightFontColor () {
        return this.lightGray;
    },
    get borderColor () {
        return this.lightGray;
    },
    get actionColor () {
        return this.midFontColor;
    },
    get backgroundColor () {
        return this.mirage;
    }
};
/**
 * Given an array of valid color names, return an array containing their hex values as strings.
 */ function returnColorPalette(colorNames) {
    return colorNames.map(function(name) {
        return allColors[name];
    });
}
var baseColors = returnColorPalette([
    "curiousBlue",
    "robinsEggBlue",
    "green",
    "yellow",
    "red",
    "white",
    "black"
]);
var layoutColors = returnColorPalette([
    "ebony",
    "mirage",
    "clay",
    "oxfordBlue",
    "blueBayoux",
    "comet",
    "baliHai"
]);
var grayColors = returnColorPalette([
    "darkGray",
    "mediumGray",
    "lightGray",
    "iron"
]);
var fontColors = returnColorPalette([
    "darkFontColor",
    "hiliteFontColor",
    "lightFontColor",
    "defaultFontColor",
    "midFontColor"
]);
var buttonColors = returnColorPalette([
    "turquoise",
    "violet",
    "emerald",
    "seaGreen",
    "avocado",
    "brick",
    "pink",
    "lightPurple",
    "charcoal"
]);
var newButtonColors = returnColorPalette([
    "azure",
    "orchid",
    "tangerine",
    "palm",
    "magenta",
    "blueRibbon",
    "orange",
    "darkRed",
    "amber",
    "lilac",
    "pacific",
    "carnation",
    "brown",
    "khaki",
    "zucchini",
    "eggplant",
    //'crimson',
    "cerulean",
    "harlequin",
    "akaroa",
    "persianLight",
    "viking",
    "mauve",
    "espresso",
    "toast",
    "salem",
    "darkPurple",
    "cornflower",
    "grannysmith",
    "lavender"
]);
var vizColors = returnColorPalette([
    "aqua",
    "carrot",
    "flamingo",
    "dodgerBlue",
    "chantilly",
    "crimson",
    "candyCorn",
    "amethyst"
]);
var vizColorsArray = returnColorPalette([
    "aqua",
    "carrot",
    "flamingo",
    "green",
    "dodgerBlue",
    "chantilly",
    "crimson",
    "candyCorn",
    "amethyst",
    "baliHai"
]);
var fieldColors = returnColorPalette([
    "trueBlue",
    "eggplant",
    "sinopia",
    "forestGreen",
    "cerise",
    "persian",
    "teal",
    "violetBlue",
    "olive",
    "raspberry",
    "eagleGreen",
    "maroon",
    "brown",
    "windsorTan",
    "koamaru",
    "seance",
    "cocoaBean",
    "ateneoBlue",
    "sapGreen",
    "vermilion",
    "blueYonder",
    "korma",
    "hemlock",
    "imperial",
    "astralBlue",
    "shiraz",
    "blueMagenta",
    "flirt",
    "lincolnGreen",
    "bouqet"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"crzXb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalStyles", function() {
    return GlobalStyles;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _designSystemOverrides = require("./design-system-overrides");
var _jspreadsheetOverrides = require("./jspreadsheet-overrides");
var _colorProperties = require("./color-properties");
var _utilityClasses = require("./utility-classes");
var _forms = require("./forms");
var _buttons = require("./buttons");
var _layout = require("./layout");
var _lists = require("./lists");
var _media = require("./media");
var _tables = require("./tables");
var _typography = require("./typography");
var _marginPadding = require("./margin-padding");
var GlobalStyles = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colorProperties.ColorProperties), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilityClasses.UtilityClasses), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.Buttons), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _forms.Forms), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layout.Layout), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lists.Lists), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _media.Media), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tables.Tables), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typography.Typography), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _marginPadding.MarginPadding), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _designSystemOverrides.DesignSystemOverrides), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jspreadsheetOverrides.JspreadsheetOverrides), {})
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./design-system-overrides":"7LEBq","./jspreadsheet-overrides":"jufgJ","./color-properties":"hFIWF","./utility-classes":"8W2nb","./forms":"emeIr","./buttons":"dkVUC","./layout":"a3sVP","./lists":"4pwUv","./media":"crngS","./tables":"bOY1l","./typography":"8ZYbH","./margin-padding":"52HPa","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7LEBq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DesignSystemOverrides", function() {
    return DesignSystemOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n:root,\n:root [data-theme=light],\n:root [data-theme=dark] {\n    --pf-font-color: ",
        ";    \n    --pf-font-family-base: ",
        ";\n\n    .theme {\n      // Needed a bit more specificity to override the design system (dont love this but eh)\n      --pf-font-color: ",
        ";\n      --pf-font-family-base: ",
        ";\n\n      background-color: var(--app-background);\n      \n    }\n\n    .ElevatedOverlay.ReactModal__Overlay {\n      z-index: 999;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var GlobalOverrideStyles = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base);
var DesignSystemOverrides = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GlobalOverrideStyles, {});
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react/jsx-runtime":"gJK5Y","react":"ktQNc","styled-components":"6Gjjc","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jufgJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JspreadsheetOverrides", function() {
    return JspreadsheetOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .theme {\n    // Jspreadsheet Theme Vars\n    --header_color: var(--pf-primary-color-200);\n    --header_color_highlighted: var(--pf-white-color);\n    --header_background: var(--pf-primary-color-950);\n    --header_background_highlighted: var(--pf-secondary-color-700);\n    --content_color: var(--pf-white-color);\n    --content_color_highlighted: red;\n    --content_background: var(--pf-primary-color-900);\n    --content_background_highlighted: red;\n    --menu_background: var(--pf-primary-color-600);\n    --menu_background_highlighted: var(--pf-primary-color-500);\n    --menu_color: var(--pf-white-color);\n    --menu_color_highlighted: var(--pf-white-color);\n    --menu_box_shadow: unset;\n    --border_color: var(--pf-tertiary-color-600);\n    --border_color_highlighted: var(--pf-secondary-color-900);\n    --content_color: var(--pf-white-color);\n    --cursor: var(--pf-secondary-color-900);\n    --active_color: red;\n\n    // Other Jspreadsheet Style Overrides\n    .jss { \n      background-color: var(--pf-primary-color-950);\n      margin: 0;\n\n      .jss_header {          \n        font-size: 14px; \n        font-weight: 600;\n        line-height: 20px;  \n        text-align: center;\n      }\n\n      tr { \n        td[data-role='cell'] {\n          text-align: left;\n        }\n      }\n    }\n \n    .jss_input.jss_focus {\n      background-color: var(--pf-secondary-color-900);\n      border: var(--pf-border-md) solid var(--pf-secondary-color-500); \n      color: var(--pf-white-color);\n    }\n\n    .jss_border_main {\n      background-color: var(--pf-secondary-color-900);\n      border: var(--pf-border-md) solid var(--pf-secondary-color-500);\n      color: var(--pf-white-color);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var JspreadsheetOverrideStyles = (0, _styledComponents.createGlobalStyle)(_templateObject());
var JspreadsheetOverrides = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(JspreadsheetOverrideStyles, {});
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react/jsx-runtime":"gJK5Y","react":"ktQNc","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hFIWF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorProperties", function() {
    return colorProperties;
});
parcelHelpers.export(exports, "ColorProperties", function() {
    return ColorProperties;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _colors = require("Permafrost/design-language/colors");
var _colors1 = require("../../constants/colors");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  :root {\n    --app-background: ",
        ";\n    --card-background: ",
        ";\n    --menu-background: ",
        ";\n\n    --button-background-primary: ",
        ";\n\n    --focus-ring: ",
        ";\n\n    --logo-primary: ",
        ";\n    --logo-secondary: ",
        ";\n\n    --text-error: ",
        ";\n    --text-highlight: ",
        ";\n    --text-prompt: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var colorProperties = {
    appBackground: "--app-background",
    cardBackground: "--card-background",
    menuBackground: "--menu-background",
    buttonBackgroundPrimary: "--button-background-primary",
    focusRing: "--focus-ring",
    logoPrimary: "--logo-primary",
    logoSecondary: "--logo-secondary",
    textError: "--text-error",
    textHighlight: "--text-highlight",
    textPrompt: "--text-prompt"
};
var ColorProperties = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _colors1.allColors).backgroundColor, (0, _colors1.allColors).clay, (0, _colors1.allColors).ebony, (0, _colors.currentColors).indicoBlue, (0, _colors.currentColors).cyan, (0, _colors.currentColors).indicoBlue, (0, _colors1.allColors).white, (0, _colors1.allColors).fieldPromptError, (0, _colors.currentColors).orange, (0, _colors1.allColors).fieldPromptInfo);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/design-language/colors":"kN500","../../constants/colors":"eHGMX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8W2nb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UtilityClasses", function() {
    return UtilityClasses;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .link-style {\n    text-decoration: underline;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  .spin {\n    animation: spin 2s infinite linear;\n  }\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .card-body {\n    background-color: ",
        ";\n    border-radius: 4px;\n    border: 1px solid ",
        ";\n    padding: 20px;\n    \n    hr {\n    margin: 1.25em 0;\n      border: 1px solid transparent;\n      border-bottom-color: ",
        ";\n    }\n  }\n  \n  .scrollable-vertical {\n    overflow: hidden auto;\n  \n    scrollbar-color: ",
        " transparent;\n    scrollbar-gutter: stable;\n    scrollbar-width: thin;\n  \n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: darkgrey;\n      outline: 1px solid slategrey;\n      border-radius: 20px;\n    }\n  }\n\n  .page-bottom {\n    padding-bottom: 20px;\n  }\n\n  .aria-invisible {\n    border: 0; \n    clip: rect(0 0 0 0); \n    height: 1px;  \n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var UtilityClasses = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).clay, (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).ebony, (0, _constants.COLORS).darkGray);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"emeIr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Forms", function() {
    return Forms;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
var _utils = require("@indico-data/utils");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\nfieldset {\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n\nlegend {\n  font-weight: 600;\n  margin-bottom: ",
        ";\n  padding: 0;\n}\n\nlabel {\n  display: block;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n}\n\ninput,\nselect,\ntextarea {\n  display: block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n}\n\n[type='color'],\n[type='date'],\n[type='datetime'],\n[type='datetime-local'],\n[type='email'],\n[type='month'],\n[type='number'],\n[type='password'],\n[type='search'],\n[type='tel'],\n[type='text'],\n[type='time'],\n[type='url'],\n[type='week'],\ninput:not([type]),\ntextarea {\n  appearance: none;\n  background-color: ",
        ";\n  border: ",
        ";\n  border-radius: 2px;\n  box-shadow: ",
        ";\n  box-sizing: border-box;\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  padding: ",
        ";\n  transition: border-color ",
        " ",
        ";\n  width: 100%;\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: ",
        ";\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    cursor: not-allowed;\n\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  &::placeholder {\n    color: ",
        ';\n  }\n}\n\ntextarea {\n  resize: vertical;\n}\n\n[type="checkbox"],\n[type="radio"] {\n  display: inline;\n  margin-right: ',
        ';\n}\n\n[type="file"] {\n  margin-bottom: ',
        ";\n  width: 100%;\n}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var formBoxShadow = "inset 0 0 0 rgba(#000, 0)";
var formBoxShadowFocus = formBoxShadow;
var Forms = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).clay, (0, _constants.COLORS).clay, formBoxShadow, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).spacing.third, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _utils.colorUtils).shade((0, _constants.COLORS).borderColor, 20), (0, _constants.COLORS).actionColor, formBoxShadowFocus, (0, _utils.colorUtils).shade((0, _constants.COLORS).backgroundColor, 5), (0, _constants.COLORS).lightGray, (0, _utils.colorUtils).tint((0, _constants.COLORS).defaultFontColor, 40), (0, _constants.TYPOGRAPHY).spacing.quarter, (0, _constants.TYPOGRAPHY).spacing.half);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"hYHjJ","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dkVUC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Buttons", function() {
    return Buttons;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  appearance: none;\n  background-color: ",
        ";\n  border: 0;\n  border-radius: 2px;\n  color: ",
        ";\n  cursor: pointer;\n  display: inline-block;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  font-family: ",
        ";\n  font-size: ",
        ";\n  -webkit-font-smoothing: antialiased;\n  line-height: 1;\n  padding: ",
        " ",
        ";\n  text-align: center;\n  text-decoration: none;\n  transition: background-color ",
        " ",
        ";\n  user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n  box-shadow: 0 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  :where(button, [type='button'], [type='reset'], [type='submit'], .button):not(.btn) {\n    ",
        "\n\n    &:hover,\n    &:focus {\n      background-color: #bebebe;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n\n      background-color: ",
        ";\n  \n      &:hover {\n        background-color: ",
        ";\n      }\n    }\n\n    &.red {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #ed3c39;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: ",
        ";\n\n        &:hover {\n          background-color: ",
        ";\n        }\n      }\n\n      &.round:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: ",
        ";\n\n        &:hover {\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    &.blue {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #1777c2;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: #1e88e5;\n\n        &:hover {\n          background-color: #1e88e5;\n        }\n      }\n    }\n\n    &.green {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: #419a45;\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n        background-color: #419a45;\n\n        &:hover {\n          background-color: #419a45;\n        }\n      }\n    }\n\n    &.cta {\n      font-size: ",
        ";\n    }\n\n    &.round {\n      border-radius: 50%;\n      padding: 10px;\n    }\n\n    &.link-style {\n      background: none;\n      box-shadow: none;\n      text-decoration: underline;\n      padding: 0;\n      transition: color ",
        " ",
        ", text-decoration-color ",
        " ",
        ";\n      color: ",
        ";\n      text-decoration-color: currentColor;\n\n      &:hover {\n        text-decoration-color: transparent;\n        color: ",
        ";\n      }\n    }\n\n    .fa-fw {\n      width: 1em;\n      text-align: center;\n    }\n\n    i {\n      display: inline-block;\n      margin-right: 2px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var buttonColor = (0, _constants.COLORS).darkFontColor;
var buttonBackground = (0, _constants.COLORS).iron;
var buttonDefault = (0, _styledComponents.css)(_templateObject(), buttonBackground, buttonColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).spacing.base, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).black);
var Buttons = (0, _styledComponents.createGlobalStyle)(_templateObject1(), buttonDefault, buttonColor, (0, _constants.COLORS).romanSilver, (0, _constants.COLORS).romanSilver, (0, _constants.COLORS).red, (0, _constants.COLORS).hiliteFontColor, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).red, (0, _constants.COLORS).curiousBlue, (0, _constants.COLORS).hiliteFontColor, (0, _constants.COLORS).green, (0, _constants.COLORS).hiliteFontColor, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a3sVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layout", function() {
    return Layout;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _colorProperties = require("./color-properties");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  html {\n    box-sizing: border-box;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n\n  html,\n  body {\n    height: 100%;\n  }\n\n  body {\n    margin: 0;\n    background-color: var(",
        ");\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Layout = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _colorProperties.colorProperties).appBackground);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","./color-properties":"hFIWF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4pwUv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lists", function() {
    return Lists;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ul,\n  ol {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  dl {\n    margin: 0;\n  }\n\n  dt {\n    font-weight: 600;\n    margin: 0;\n  }\n\n  dd {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Lists = (0, _styledComponents.createGlobalStyle)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"crngS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Media", function() {
    return Media;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "  \n  figure {\n    margin: 0;\n  }\n\n  img,\n  picture {\n    margin: 0;\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Media = (0, _styledComponents.createGlobalStyle)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bOY1l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tables", function() {
    return Tables;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _utils = require("@indico-data/utils");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  table {\n    border-collapse: collapse;\n    margin: ",
        " 0;\n    table-layout: fixed;\n    width: 100%;\n  }\n\n  th {\n    font-size: ",
        ";\n    border-bottom: 0.5px solid ",
        ";\n    padding: 20px 15px 5px;\n    font-weight: 400;\n    text-align: left;\n  }\n\n  td {\n    border-bottom: 0.5px solid ",
        ";\n    padding: 20px 15px;\n    font-size: ",
        ";\n  }\n\n  tr,\n  td,\n  th {\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Tables = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.TYPOGRAPHY).spacing.half, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _utils.colorUtils).hexToRgb((0, _constants.COLORS).defaultFontColor, 0.1), (0, _utils.colorUtils).hexToRgb((0, _constants.COLORS).defaultFontColor, 0.1), (0, _constants.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8ZYbH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Typography", function() {
    return Typography;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  html {\n    color: ",
        ";\n    font-family: ",
        ";\n    font-size: 100%;\n    line-height: ",
        ";\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    margin: 0 0 10px;\n    color: ",
        ";\n    font-weight: 400;\n    font-style: normal;\n  }\n\n  h3 {\n    font-size: ",
        ";\n  }\n\n  h4 {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  h5 {\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n\n  p {\n    margin: 0 0;\n    font-size: ",
        ";\n  }\n\n  .t-caption { font-size: ",
        "; }\n  .t-base { font-size: ",
        "; }\n  .t-subhead-small { font-size: ",
        "; }\n  .t-subhead-large { font-size: ",
        "; }\n  .t-display { font-size: ",
        "; }\n\n  .t-bold { font-weight: bold; }\n  .t-italic { font-style: italic; }\n\n  .error {\n    color: ",
        ";\n  }\n\n  .prompt {\n    color: ",
        ";\n  }\n\n  .warning {\n    color: ",
        ";\n  }\n\n  .success {\n    color: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n    transition: color ",
        " ",
        ";\n\n    &:active,\n    &:focus,\n    &:hover {\n      color: ",
        ";\n      text-decoration: none;\n    }\n  }\n\n  hr {\n    border-bottom: 1px solid ",
        ";\n    border-left: 0;\n    border-right: 0;\n    border-top: 0;\n    margin: ",
        " 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Typography = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).lineHeight.base, (0, _constants.TYPOGRAPHY).fontFamily.base, (0, _constants.TYPOGRAPHY).fontSize.display, (0, _constants.TYPOGRAPHY).lineHeight.heading, (0, _constants.COLORS).lightGray, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontSize.caption, (0, _constants.COLORS).defaultFontColor, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.caption, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.TYPOGRAPHY).fontSize.subheadLarge, (0, _constants.TYPOGRAPHY).fontSize.display, (0, _constants.COLORS).red, (0, _constants.COLORS).curiousBlue, (0, _constants.COLORS).yellow, (0, _constants.COLORS).green, (0, _constants.COLORS).actionColor, (0, _constants.ANIMATION).duration, (0, _constants.ANIMATION).timing, (0, _constants.COLORS).defaultFontColor, (0, _constants.COLORS).borderColor, (0, _constants.TYPOGRAPHY).spacing.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"52HPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarginPadding", function() {
    return MarginPadding;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _constants = require("../../constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "  \n  .pt-md {\n    padding-top: ",
        ";\n  }\n  .pt-sm {\n    padding-top: ",
        ";\n  }\n  .pb-md {\n    padding-bottom: ",
        ";\n  }\n  .pb-sm {\n    padding-bottom: ",
        ";\n  }\n  .mt-md {\n    margin-top: ",
        ";\n  }\n  .mt-sm {\n    margin-top: ",
        ";\n  }\n  .mb-md {\n    margin-bottom: ",
        ";\n  }\n  .mb-sm {\n    margin-bottom: ",
        ";\n  }\n  .my-md {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var MarginPadding = (0, _styledComponents.createGlobalStyle)(_templateObject(), (0, _constants.PADDINGS).md, (0, _constants.PADDINGS).sm, (0, _constants.PADDINGS).md, (0, _constants.PADDINGS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).sm, (0, _constants.MARGINS).md, (0, _constants.MARGINS).md);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","../../constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5cEUr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleLineEllipsis", function() {
    return singleLineEllipsis;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var singleLineEllipsis = (0, _styledComponents.css)(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9OrkN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "faIcons", function() {
    return faIcons;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _freeRegularSvgIcons = require("@fortawesome/free-regular-svg-icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var faIcons = {
    "fa-dot-circle": generateSvg((0, _freeRegularSvgIcons.faDotCircle)),
    "fa-file": generateSvg((0, _freeRegularSvgIcons.faFile)),
    "fa-file-alt": generateSvg((0, _freeRegularSvgIcons.faFileAlt)),
    "fa-file-pdf": generateSvg((0, _freeRegularSvgIcons.faFilePdf)),
    "fa-file-word": generateSvg((0, _freeRegularSvgIcons.faFileWord)),
    "fa-check-square": generateSvg((0, _freeRegularSvgIcons.faCheckSquare)),
    "fa-square": generateSvg((0, _freeRegularSvgIcons.faSquare)),
    "fa-angle-double-left": generateSvg((0, _freeSolidSvgIcons.faAngleDoubleLeft)),
    "fa-arrow-circle-right": generateSvg((0, _freeSolidSvgIcons.faArrowCircleRight)),
    "fa-arrow-down": generateSvg((0, _freeSolidSvgIcons.faArrowDown)),
    "fa-arrow-left": generateSvg((0, _freeSolidSvgIcons.faArrowLeft)),
    "fa-arrow-right": generateSvg((0, _freeSolidSvgIcons.faArrowRight)),
    "fa-arrow-up": generateSvg((0, _freeSolidSvgIcons.faArrowUp)),
    "fa-ban": generateSvg((0, _freeSolidSvgIcons.faBan)),
    "fa-binoculars": generateSvg((0, _freeSolidSvgIcons.faBinoculars)),
    "fa-bell": generateSvg((0, _freeSolidSvgIcons.faBell)),
    "fa-caret-down": generateSvg((0, _freeSolidSvgIcons.faCaretDown)),
    "fa-caret-up": generateSvg((0, _freeSolidSvgIcons.faCaretUp)),
    "fa-chart-bar": generateSvg((0, _freeSolidSvgIcons.faChartBar)),
    "fa-check": generateSvg((0, _freeSolidSvgIcons.faCheck)),
    "fa-check-circle": generateSvg((0, _freeSolidSvgIcons.faCheckCircle)),
    "fa-circle-notch": generateSvg((0, _freeSolidSvgIcons.faCircleNotch)),
    "fa-clipboard": generateSvg((0, _freeSolidSvgIcons.faClipboard)),
    "fa-clock": generateSvg((0, _freeSolidSvgIcons.faClock)),
    "fa-clone": generateSvg((0, _freeSolidSvgIcons.faClone)),
    "fa-cloud": generateSvg((0, _freeSolidSvgIcons.faCloud)),
    "fa-cog": generateSvg((0, _freeSolidSvgIcons.faCog)),
    "fa-cogs": generateSvg((0, _freeSolidSvgIcons.faCogs)),
    "fa-coins": generateSvg((0, _freeSolidSvgIcons.faCoins)),
    "fa-cube": generateSvg((0, _freeSolidSvgIcons.faCube)),
    "fa-cut": generateSvg((0, _freeSolidSvgIcons.faCut)),
    "fa-download": generateSvg((0, _freeSolidSvgIcons.faDownload)),
    "fa-exclamation-circle": generateSvg((0, _freeSolidSvgIcons.faExclamationCircle)),
    "fa-exclamation-triangle": generateSvg((0, _freeSolidSvgIcons.faExclamationTriangle)),
    "fa-external-link-alt": generateSvg((0, _freeSolidSvgIcons.faExternalLinkAlt)),
    "fa-eye-dropper": generateSvg((0, _freeSolidSvgIcons.faEyeDropper)),
    "fa-file-download": generateSvg((0, _freeSolidSvgIcons.faFileDownload)),
    "fa-file-export": generateSvg((0, _freeSolidSvgIcons.faFileExport)),
    "fa-file-upload": generateSvg((0, _freeSolidSvgIcons.faFileUpload)),
    "fa-filter": generateSvg((0, _freeSolidSvgIcons.faFilter)),
    "fa-ghost": generateSvg((0, _freeSolidSvgIcons.faGhost)),
    "fa-hat-wizard": generateSvg((0, _freeSolidSvgIcons.faHatWizard)),
    "fa-info-circle": generateSvg((0, _freeSolidSvgIcons.faInfoCircle)),
    "fa-key": generateSvg((0, _freeSolidSvgIcons.faKey)),
    "fa-keyboard": generateSvg((0, _freeSolidSvgIcons.faKeyboard)),
    "fa-layer-group": generateSvg((0, _freeSolidSvgIcons.faLayerGroup)),
    "fa-pencil-alt": generateSvg((0, _freeSolidSvgIcons.faPencilAlt)),
    "fa-plus": generateSvg((0, _freeSolidSvgIcons.faPlus)),
    "fa-plus-square": generateSvg((0, _freeSolidSvgIcons.faPlusSquare)),
    "fa-question-circle": generateSvg((0, _freeSolidSvgIcons.faQuestionCircle)),
    "fa-robot": generateSvg((0, _freeSolidSvgIcons.faRobot)),
    "fa-search": generateSvg((0, _freeSolidSvgIcons.faSearch)),
    "fa-sign-out-alt": generateSvg((0, _freeSolidSvgIcons.faSignOutAlt)),
    "fa-sliders-h": generateSvg((0, _freeSolidSvgIcons.faSlidersH)),
    "fa-sync-alt": generateSvg((0, _freeSolidSvgIcons.faSyncAlt)),
    "fa-tag": generateSvg((0, _freeSolidSvgIcons.faTag)),
    "fa-times": generateSvg((0, _freeSolidSvgIcons.faTimes)),
    "fa-times-circle": generateSvg((0, _freeSolidSvgIcons.faTimesCircle)),
    "fa-tint": generateSvg((0, _freeSolidSvgIcons.faTint)),
    "fa-toggle-off": generateSvg((0, _freeSolidSvgIcons.faToggleOff)),
    "fa-toggle-on": generateSvg((0, _freeSolidSvgIcons.faToggleOn)),
    "fa-trash": generateSvg((0, _freeSolidSvgIcons.faTrash)),
    "fa-trash-alt": generateSvg((0, _freeSolidSvgIcons.faTrashAlt)),
    "fa-undo": generateSvg((0, _freeSolidSvgIcons.faUndo)),
    "fa-user": generateSvg((0, _freeSolidSvgIcons.faUser)),
    "fa-users": generateSvg((0, _freeSolidSvgIcons.faUsers)),
    "fa-mouse-pointer": generateSvg((0, _freeSolidSvgIcons.faMousePointer)),
    "fa-step-forward": generateSvg((0, _freeSolidSvgIcons.faStepForward)),
    "fa-search-minus": generateSvg((0, _freeSolidSvgIcons.faSearchMinus)),
    "fa-search-plus": generateSvg((0, _freeSolidSvgIcons.faSearchPlus)),
    "fa-table": generateSvg((0, _freeSolidSvgIcons.faTable)),
    "fa-image": generateSvg((0, _freeSolidSvgIcons.faImage)),
    "fa-link": generateSvg((0, _freeSolidSvgIcons.faLink)),
    "fa-list": generateSvg((0, _freeSolidSvgIcons.faList)),
    "fa-money-bill": generateSvg((0, _freeSolidSvgIcons.faMoneyBill)),
    "fa-minus": generateSvg((0, _freeSolidSvgIcons.faMinus)),
    "fa-expand": generateSvg((0, _freeSolidSvgIcons.faExpand))
};
function generateSvg(iconDefinition) {
    var icon = iconDefinition.icon;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        fill: "currentColor",
        viewBox: "0 0 ".concat(icon[0], " ").concat(icon[1]),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "".concat(icon[4])
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@fortawesome/free-regular-svg-icons":"hw28Z","@fortawesome/free-solid-svg-icons":"eavdx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5ixPq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "indicons", function() {
    return indicons;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var indicons = {
    "indico-o-white": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM50 19.4c-16.9 0-30.6 13.7-30.6 30.6S33.1 80.6 50 80.6 80.6 66.9 80.6 50 66.9 19.4 50 19.4zm0 21.7c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
        })
    }),
    account: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 8c23.2 0 42 18.8 42 42 0 9.9-3.4 19-9.2 26.2C75.6 65.8 63.6 59 50 59s-25.6 6.8-32.8 17.2C11.4 69 8 59.9 8 50 8 26.8 26.8 8 50 8zM22.9 82c5.7-9 15.7-15 27.1-15s21.4 6 27.1 15C69.8 88.2 60.3 92 50 92s-19.8-3.8-27.1-10zM50 56c11.6 0 21-9.4 21-21s-9.4-21-21-21-21 9.4-21 21 9.4 21 21 21zm0-34c7.2 0 13 5.8 13 13s-5.8 13-13 13-13-5.8-13-13 5.8-13 13-13z"
        })
    }),
    address: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m24 33.7q5.35-4.3 8.1-8.25t2.75-7.5q0-3.05-1.1-5.175t-2.75-3.475-3.55-1.95-3.45-0.6-3.45 0.6-3.55 1.95-2.75 3.475-1.1 5.175q0 3.55 2.75 7.5t8.1 8.25zm0 2.85q-6.65-5-9.9-9.6t-3.25-9q0-3.35 1.2-5.85t3.075-4.2 4.225-2.55 4.65-0.85 4.65 0.85 4.225 2.55 3.075 4.2 1.2 5.85q0 4.4-3.25 9t-9.9 9.6zm0-15.8q1.3 0 2.225-0.925t0.925-2.225-0.925-2.2-2.225-0.9-2.225 0.925-0.925 2.225 0.925 2.2 2.225 0.9zm-13.15 22.75v-2.25h26.3v2.25zm13.15-25.55z"
        })
    }),
    "api-doc": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm33.3 47.5L69.1 33.3c-1.3-1.3-3.6-1.3-4.9 0-.7.7-1 1.6-1 2.4 0 .8.4 1.8 1 2.4L76 49.9 64.2 61.7c-.7.7-1 1.5-1 2.4 0 .9.4 1.8 1 2.4s1.5 1 2.4 1c.9 0 1.8-.4 2.4-1l14.2-14.2c.7-.7 1-1.5 1-2.4.1-.9-.3-1.8-.9-2.4zM24 49.9l11.8-11.7c1.4-1.4 1.4-3.7 0-5.1-1.3-1.3-3.6-1.3-4.9 0L16.7 47.5c-.7.7-1 1.6-1 2.4s.4 1.8 1 2.4l14.2 14.3c.7.7 1.5 1 2.4 1 .9 0 1.8-.4 2.4-1 .7-.7 1-1.6 1-2.4 0-.9-.4-1.8-1-2.4L24 49.9zM58.7 31c-.4-.8-1.2-1.4-2.2-1.8-1.9-.6-3.8.4-4.3 2.2L41.1 66.5c-.2.9-.2 1.8.2 2.6s1.1 1.4 2 1.7c.4.2.7.2 1.2.2.2 0 .4 0 .7-.1 1.2-.3 2.3-1.2 2.7-2.4l11.4-35c-.1-.9-.1-1.8-.6-2.5z"
        })
    }),
    "arrow-dots": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M19 10c0 5-4 9-9 9s-9-4-9-9 4-9 9-9 9 4 9 9zm11-9c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM30 21c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM50 41c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM30 61c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zM10 81c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm20 0c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9z"
        })
    }),
    "arrow-down": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M41.4,69.3L41.4,69.3L41.4,69.3z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                id: "arrow",
                d: "M7.4,59l39.8,39.7c1.7,1.7,3.8,1.7,5.5,0L92.6,59c0.8-0.8,0.8-1.9,0-2.7l-2.6-2.6c-0.8-0.8-1.9-0.8-2.7,0 L53.8,87.1V1.9C53.8,0.8,53,0,51.9,0h-3.7c-1.1,0-1.9,0.9-1.9,1.9v85.1L12.7,53.6c-0.8-0.8-1.9-0.8-2.7,0l-2.6,2.6 C6.6,57,6.7,58.2,7.4,59z"
            })
        ]
    }),
    "arrow-up-circle": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zm-28.6-6.1L53.3 25.8c-.5-.6-1.5-1.8-3.3-1.8-1.7 0-2.8 1.2-3.4 1.8L28.5 43.9c-1.4 1.4-1.4 3.7 0 5.1 1.4 1.4 3.7 1.4 5.1 0L46 36.6V70c0 2.2 1.8 4 4 4s4-1.8 4-4V36.6L66.3 49c1.4 1.4 3.7 1.4 5.1 0 1.4-1.4 1.4-3.7 0-5.1z"
        })
    }),
    "arrows-cursor": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M68.8 83.2L53.3 98.6c-1.8 1.8-4.8 1.8-6.6 0L31.2 83.2c-3-3-.9-8 3.3-8h10V55.5H24.8v10c0 4.2-5 6.3-8 3.3L1.4 53.3c-1.8-1.8-1.8-4.8 0-6.6l15.5-15.5c3-3 8-.9 8 3.3v10h19.7V24.8h-10c-4.2 0-6.3-5-3.3-8L46.7 1.4c1.8-1.8 4.8-1.8 6.6 0l15.5 15.5c3 3 .9 8-3.3 8h-10v19.7h19.7v-10c0-4.2 5-6.3 8-3.3l15.5 15.5c1.8 1.8 1.8 4.8 0 6.6L83.2 68.8c-3 3-8 .9-8-3.3v-10H55.5v19.7h10c4.2 0 6.2 5 3.3 8z"
        })
    }),
    branch: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 642 514",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M385 321H257c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V353c0-17.67-14.33-32-32-32zM193 33c0-17.67-14.33-32-32-32H33C15.33 1 1 15.33 1 33v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C212.98 301.98 233.4 289 257 289h.28L193 176.51V129h224V65H193V33zM609 1H481c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V33c0-17.67-14.33-32-32-32z",
            fill: "currentColor"
        })
    }),
    "check-circle": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM78 30.7c-.7-1-1.9-1.5-3.5-1.5-1.2 0-2.3.5-3.3 1.5C65 37 45.3 56.6 42.4 59.4L28.8 48c-1-.9-2.2-1.3-3.5-1.2-1.3.1-2.5.7-3.3 1.8-.9 1-1.3 2.2-1.2 3.5.1 1.3.7 2.5 1.8 3.3l16.8 14.2c.9.7 2 1.1 3.1 1.1 1.3 0 2.5-.5 3.4-1.4 6.8-6.6 28.7-28.7 32-32 1.8-1.7 1.8-4.6.1-6.6z"
        })
    }),
    check: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M96.4 18.5c-1.4-1.6-3.4-2.4-6.3-2.4-2.1 0-4.3 1-6 2.7-10.9 11.1-41.6 41.6-46.7 46.7l-22-18c-1.8-1.6-4.1-2.3-6.4-2.1-2.3.2-4.4 1.3-6 3.1-3.2 3.7-2.8 9.2 1 12.4l27.9 23c1.6 1.3 3.6 2 5.6 2 2.3 0 4.6-.8 6.1-2.5 12-11.8 46.8-46.7 52.6-52.6 3.3-3.2 3.4-8.6.2-12.3z"
        })
    }),
    checkbox: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    display: "none",
                    d: "m10.3 97.3c-2.8 0-5.1-1-7.1-2.9-1.9-1.9-2.9-4.3-2.9-7.1v-74.5c0-2.8 1-5.2 2.9-7.1s4.3-3 7.1-3h74.5c1.2 0 2.4 0.3 3.7 0.9s2.3 1.2 3 1.9l-7.8 7.8v-0.5h-73.4v74.5h74.5v-42l10.1-10.1v52.1c0 2.8-1 5.1-3 7.1-2 1.9-4.4 2.9-7.1 2.9h-74.5zm35.2-23.4-28-28 5.9-5.9 22.1 22.2 49-49 5.8 5.9-54.8 54.8z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M45.1,74.3L45.1,74.3H45L19.1,48.4l9.7-9.7L45.1,55L90.1,9.9l9.7,9.7L45.1,74.3z M81,51v32.5H13.9V16.4h57L84.5,2.9  c-0.6-0.1-1.2-0.1-1.7-0.1H12.1c-6.6,0-12,5.4-12,12v70.6c0,6.6,5.4,12,12,12h70.6c6.6,0,12-5.4,12-12v-48L81,51z"
                })
            ]
        })
    }),
    "chevron-down": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M46.1 78.7L1.6 34.2c-2.1-2.1-2.1-5.6 0-7.8l5.2-5.2c2.1-2.1 5.6-2.1 7.8 0L50 56.5l35.4-35.3c2.1-2.1 5.6-2.1 7.8 0l5.2 5.2c2.1 2.1 2.1 5.6 0 7.8L53.9 78.7c-2.2 2.2-5.6 2.2-7.8 0z"
        })
    }),
    "chevron-left": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21.3 46.1L65.8 1.6c2.1-2.1 5.6-2.1 7.8 0l5.2 5.2c2.1 2.1 2.1 5.6 0 7.8L43.5 50l35.3 35.4c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L21.3 53.9c-2.2-2.2-2.2-5.6 0-7.8z"
        })
    }),
    "chevron-right": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M78.7 53.9L34.2 98.4c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8L56.5 50 21.3 14.6c-2.1-2.1-2.1-5.6 0-7.8l5.2-5.2c2.1-2.1 5.6-2.1 7.8 0l44.5 44.5c2.1 2.2 2.1 5.6-.1 7.8z"
        })
    }),
    "chevron-up": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M53.9 21.3l44.5 44.5c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L50 43.5 14.6 78.7c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8l44.5-44.5c2.2-2.1 5.6-2.1 7.8.1z"
        })
    }),
    "classification-document": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M53.9 21.3l44.5 44.5c2.1 2.1 2.1 5.6 0 7.8l-5.2 5.2c-2.1 2.1-5.6 2.1-7.8 0L50 43.5 14.6 78.7c-2.1 2.1-5.6 2.1-7.8 0l-5.2-5.2c-2.1-2.1-2.1-5.6 0-7.8l44.5-44.5c2.2-2.1 5.6-2.1 7.8.1z"
        })
    }),
    "classification-image": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M91,0H9C4,0,0,4,0,9v82c0,5,4,9,9,9h82c5,0,9-4,9-9V9C100,4,96,0,91,0z M90,90H10V10h80V90z M21.2,77.9L40,59l9.5,9.5l11.6-14.6l19.2,24.1H21.2z M29.9,37.6c-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.8-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8c1.9-1.9,4.1-2.8,6.8-2.8c2.7,0,5,0.9,6.8,2.8c1.8,1.9,2.8,4.1,2.8,6.8c0,2.7-0.9,5-2.8,6.8C34.9,36.7,32.6,37.6,29.9,37.6z"
        })
    }),
    "classification-page": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M80,32v58H20V10h38v22H80z M62.9,0H19c-5,0-9,4-9,9v82c0,5,4,9,9,9h62c5,0,9-4,9-9V27.1L62.9,0z"
        })
    }),
    "classify-and-unbundle": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M10,46V9c0-5,4-9,9-9h43.9L90,27.1V46H80V32H58V10H20v36H10z M80,72v18H20V72H10v19c0,5,4,9,9,9h62c5,0,9-4,9-9V72H80zM36,64h28V54H36V64z M28,54H0v10h28V54z M72,54v10h28V54H72z"
        })
    }),
    clipboard: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M10,46V9c0-5,4-9,9-9h43.9L90,27.1V46H80V32H58V10H20v36H10z M80,72v18H20V72H10v19c0,5,4,9,9,9h62c5,0,9-4,9-9V72H80zM36,64h28V54H36V64z M28,54H0v10h28V54z M72,54v10h28V54H72z"
        })
    }),
    "coffee-1": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M87.9 43.8h-1.2v-3.3-.2-.2c0-1.9-1.6-3.5-3.5-3.5h-79c-1.5 0-2.8.9-3.3 2.3-.2.5-.4 1-.4 1.6v4.8c0 1.1.1 2.1.1 3.1C1.7 63.7 11 76.8 24.1 83.3c.2 3.4 3 6.1 6.4 6.1h25.9c.3 0 .6 0 .9-.1 2.8-.5 5-2.9 5.2-5.8 7.5-3.6 13.8-9.3 18.1-16.4.3.1.7.2 1.1.2h6.2c6.5 0 11.8-5.3 11.8-11.8-.1-6.4-5.3-11.7-11.8-11.7zm-8.5 1.9c-.2 19.1-15.8 34.6-35 34.6h-1.6c-19.2 0-34.8-15.5-35-34.6v-2h71.7l-.1 2zm8.5 15.2h-4.2c1.3-3.3 2.2-6.9 2.7-10.6h1.5c2.9 0 5.3 2.4 5.3 5.3s-2.4 5.3-5.3 5.3zm-3.7 31.9H2.6c0 3.6 2.9 6.4 6.5 6.4h69.3c3.5 0 6.4-2.9 6.5-6.4h-.7zM45 .7c-1-1-2.6-1-3.5 0-4.6 4.6-4.6 12.1 0 16.7 2.6 2.7 2.6 6.9 0 9.6-1 1-1 2.6 0 3.5s2.6 1 3.5 0c4.6-4.6 4.6-12.1 0-16.7-2.6-2.7-2.6-6.9 0-9.6 1-.9 1-2.5 0-3.5zM29.8 8.3c-1-1-2.6-1-3.5 0-3.6 3.6-3.6 9.3 0 12.9 1.6 1.6 1.6 4.2 0 5.8-1 1-1 2.6 0 3.5 1 1 2.6 1 3.5 0 3.6-3.6 3.6-9.3 0-12.9-1.6-1.6-1.6-4.2 0-5.8 1-1 1-2.6 0-3.5zm30.4 0c-1-1-2.6-1-3.5 0-3.6 3.6-3.6 9.3 0 12.9 1.6 1.6 1.6 4.2 0 5.8-1 1-1 2.6 0 3.5 1 1 2.6 1 3.5 0 3.6-3.6 3.6-9.3 0-12.9-1.6-1.6-1.6-4.2 0-5.8.9-1 .9-2.6 0-3.5z"
        })
    }),
    "coffee-2": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M87.9 43.8h-1.2v-3.3-.2-.2c0-1.9-1.6-3.5-3.5-3.5h-79c-1.5 0-2.8.9-3.3 2.3-.2.5-.4 1-.4 1.6v4.8c0 1.1.1 2.1.1 3.1C1.7 63.7 11 76.8 24.1 83.3c.2 3.4 3 6.1 6.4 6.1h25.9c.3 0 .6 0 .9-.1 2.8-.5 5-2.9 5.2-5.8 7.5-3.6 13.8-9.3 18.1-16.4.3.1.7.2 1.1.2h6.2c6.5 0 11.8-5.3 11.8-11.8-.1-6.4-5.3-11.7-11.8-11.7zm-8.5 1.9c-.2 19.1-15.8 34.6-35 34.6h-1.6c-19.2 0-34.8-15.5-35-34.6v-2h71.7l-.1 2zm8.5 15.2h-4.2c1.3-3.3 2.2-6.9 2.7-10.6h1.5c2.9 0 5.3 2.4 5.3 5.3s-2.4 5.3-5.3 5.3zm-3.7 31.9H2.6c0 3.6 2.9 6.4 6.5 6.4h69.3c3.5 0 6.4-2.9 6.5-6.4h-.7zM41.5.7c-1 1-1 2.6 0 3.5 2.6 2.7 2.6 6.9 0 9.6-4.6 4.6-4.6 12.1 0 16.7.9 1 2.5.9 3.5 0s1-2.5 0-3.5c-2.6-2.7-2.6-6.9 0-9.6 4.6-4.6 4.6-12.1 0-16.7-.9-1-2.5-1-3.5 0zm15.2 11.1c1.6 1.6 1.6 4.2 0 5.8-3.6 3.6-3.6 9.3 0 12.9.9 1 2.5 1 3.5 0 1-.9 1-2.5 0-3.5-1.6-1.6-1.6-4.2 0-5.8 3.6-3.6 3.6-9.3 0-12.9-.9-1-2.5-1-3.5 0-1 .9-1 2.5 0 3.5zM26.3 8.3c-.9.9-.9 2.5 0 3.5 1.6 1.6 1.6 4.2 0 5.8-3.6 3.6-3.6 9.3 0 12.9.9 1 2.5 1 3.5 0 1-.9 1-2.5 0-3.5-1.6-1.6-1.6-4.2 0-5.8 3.6-3.6 3.6-9.3 0-12.9-.9-1-2.5-1-3.5 0z"
        })
    }),
    "coffee-fail": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M80.5 3l-.7.7-2.1-2-.1-.1-.1-.1c-1.2-1.2-3.2-1.2-4.3 0l-49 49.2c-.9.9-1.2 2.3-.6 3.5.2.4.4.9.7 1.2l3 3c.7.7 1.4 1.2 2 1.9 10.2 8.8 24.1 11.1 36.3 7 2.2 2 5.7 1.9 7.8-.2l.1-.1.1-.1 15.9-16c.2-.2.4-.4.5-.6 1.4-2.1 1.3-4.9-.4-6.8 2.4-6.9 2.8-14.4 1-21.4.2-.1.6-.3.8-.6l3.8-3.9c4-4 4-10.6 0-14.7C91-1 84.5-1 80.5 3zm-4.1 6.5c11.8 12 11.8 31.3-.1 43.2l-1 1c-11.9 12-31.2 12.1-43.2.4l-1.2-1.2L75.2 8.2l1.2 1.3zm14.7 4.1l-2.6 2.6c-1.3-2.9-2.9-5.6-4.9-8.2l.9-.9c1.8-1.8 4.8-1.8 6.6 0 1.8 1.7 1.8 4.7 0 6.5zM14.5 38.4c3.6 0 7.8 1.1 10.3 3.5.3.3 0 .8-.4.7-.9-.2-2-.3-2.8-.3-11.7 0-8.3 10.9-15.3 10.9-1.8 0-4.4-1-4.4-4.7 0-3.9 3.7-10.1 12.6-10.1zm11.2-1.9c.1.3-.3.5-.6.3-1.5-1.4-4.2-3.4-11.9-2.7-3 .3-6.4-2.1-4.7-5.1 2.1-3.7 9.3-2 11.6-.6 3.1 1.9 5.2 5.3 5.6 8.1zm47.5 54.7c-1.8.2-5.9 1.2-2.5 2.8 2.7 1.3-.7 6.1-29.1 6-23.6-.1-33.5-3.5-32.5-6.9.7-2.5 5.4-3.4 12.7-4.5 1.5-.2 3.2-1.4.2-2.6-1.4-.6-2.9-1.5-2.9-2.6 0-3.9 18.7-5.5 41.6-5.5 22.9 0 36.7 3.1 36.7 7 .1 3.2-6.6 4.4-24.2 6.3z"
        })
    }),
    coffeecup: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 150 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M132.6 18.8h-1.8v-5-.3-.3c0-2.9-2.4-5.3-5.3-5.3H6c-2.3 0-4.2 1.4-5 3.5-.3.8-.6 1.5-.6 2.4v7.3c0 1.7.2 3.2.2 4.7 1.7 23.1 15.7 42.9 35.5 52.8.3 5.1 4.5 9.2 9.7 9.2H85c.5 0 .9 0 1.4-.2 4.2-.8 7.6-4.4 7.9-8.8 11.3-5.4 20.9-14.1 27.4-24.8.5.2 1.1.3 1.7.3h9.4c9.8 0 17.8-8 17.8-17.8-.3-9.7-8.2-17.7-18-17.7zm-12.9 2.9C119.4 50.5 95.8 74 66.8 74h-2.4c-29 0-52.6-23.4-52.9-52.3v-3h108.4l-.2 3zm12.9 22.9h-6.4c2-5 3.3-10.4 4.1-16h2.3c4.4 0 8 3.6 8 8s-3.6 8-8 8zM127 92.9H3.6c0 5.4 4.4 9.7 9.8 9.7h104.8c5.3 0 9.7-4.4 9.8-9.7h-1z"
        })
    }),
    coffeesteam: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 150 76",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M66.1 1.6c-1.3 2.6-1.3 5.7 0 8.2l3.8 7.5c2.3 4.6 2.3 10.1 0 14.7l-3.8 7.5c-1.3 2.6-1.3 5.7 0 8.2l3.8 7.5c2.3 4.6 2.3 10.1 0 14.7l-3 5.9h-7.7c.2-.5.4-1.1.7-1.6l3.8-7.5c1.3-2.6 1.3-5.7 0-8.2L59.9 51c-2.3-4.6-2.3-10.1 0-14.7l3.8-7.5c1.3-2.6 1.3-5.7 0-8.2l-3.8-7.5C57.8 9 57.6 4.2 59.2 0h7.7l-.8 1.6zM83.9 0h-7.7c-1.6 4.2-1.4 9 .7 13.1l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-2.3 4.6-2.3 10.1 0 14.7l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-.3.5-.5 1.1-.7 1.6h7.7l3-5.9c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l3.8-7.5c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l.8-1.6zm-34 0h-7.7c-1.6 4.2-1.4 9 .7 13.1l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-2.3 4.6-2.3 10.1 0 14.7l3.8 7.5c1.3 2.6 1.3 5.7 0 8.2l-3.8 7.5c-.3.5-.5 1.1-.7 1.6h7.7l3-5.9c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l3.8-7.5c2.3-4.6 2.3-10.1 0-14.7l-3.8-7.5c-1.3-2.6-1.3-5.7 0-8.2l.8-1.6z"
        })
    }),
    "company-name": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m8.05 41.15v-26.9h10.7v-5.75l5.25-5 5.25 5v13.95h10.7v18.7zm2.25-2.25h5.95v-5.95h-5.95zm0-8.25h5.95v-5.95h-5.95zm0-8.2h5.95v-5.95h-5.95zm10.7 16.45h6v-5.95h-6zm0-8.25h6v-5.95h-6zm0-8.2h6v-5.95h-6zm0-8.2h6v-5.95h-6zm10.75 24.65h5.95v-5.95h-5.95zm0-8.25h5.95v-5.95h-5.95z"
        })
    }),
    "confidence-bar-1": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 67v33h16V56.3z"
        })
    }),
    "confidence-bar-2": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 48.2V100h16V37.5z"
        })
    }),
    "confidence-bar-3": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 29.5V100h16V18.8z"
        })
    }),
    "confidence-bar-4": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 28 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M16 0v100H0V10.7z"
        })
    }),
    "confidence-bars": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 0v100H84V10.7L100 0zM0 67v33h16V56.3L0 67zm28-18.8V100h16V37.5L28 48.2zm28-18.7V100h16V18.8L56 29.5z"
        })
    }),
    configure: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M96.9 75H31.2v-3.1c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1V75H3.1C1.4 75 0 76.4 0 78.1v6.2c0 1.7 1.4 3.1 3.1 3.1h15.6v3.1c0 1.7 1.4 3.1 3.1 3.1H28c1.7 0 3.1-1.4 3.1-3.1v-3.1h65.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.7-1.2-3.1-2.9-3.1zm0-31.2H81.2v-3.1c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1v3.1H3.1c-1.7 0-3.1 1.4-3.1 3.1v6.2c0 1.7 1.4 3.1 3.1 3.1h65.6v3.1c0 1.7 1.4 3.1 3.1 3.1H78c1.7 0 3.1-1.4 3.1-3.1v-3.1h15.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.7-1.2-3.1-2.9-3.1zm0-31.3H56.2V9.4c0-1.7-1.4-3.1-3.1-3.1h-6.2c-1.7 0-3.1 1.4-3.1 3.1v3.1H3.1c-1.7 0-3.1 1.4-3.1 3.1v6.2C0 23.6 1.4 25 3.1 25h40.6v3.1c0 1.7 1.4 3.1 3.1 3.1H53c1.7 0 3.1-1.4 3.1-3.1V25h40.6c1.7 0 3.1-1.4 3.1-3.1v-6.2c.2-1.8-1.2-3.2-2.9-3.2z"
        })
    }),
    crowdlabel: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M55 .2C78.6 2.6 97.4 21.4 99.8 45H89.7C87.4 26.9 73.1 12.6 55 10.3V.2zM10.3 45C12.6 26.9 26.9 12.6 45 10.3V.2C21.4 2.6 2.6 21.4.2 45h10.1zm79.4 10C87.4 73.1 73.1 87.4 55 89.7v10.1C78.6 97.4 97.4 78.6 99.8 55H89.7zM45 89.7C26.9 87.4 12.6 73.1 10.3 55H.2C2.6 78.6 21.4 97.4 45 99.8V89.7zM71 45H55V29c0-2.8-2.2-5-5-5s-5 2.2-5 5v16H29c-2.8 0-5 2.2-5 5s2.2 5 5 5h16v16c0 2.8 2.2 5 5 5s5-2.2 5-5V55h16c2.8 0 5-2.2 5-5s-2.3-5-5-5z"
        })
    }),
    currency: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m26.75 26.15q-2.1 0-3.55-1.45t-1.45-3.55 1.45-3.55 3.55-1.45 3.55 1.45 1.45 3.55-1.45 3.55-3.55 1.45zm-14.65 6.95q-1.15 0-2-0.875t-0.85-2.025v-18.1q0-1.15 0.85-2t2-0.85h29.3q1.2 0 2.05 0.85t0.85 2v18.1q0 1.15-0.85 2.025t-2.05 0.875zm3.75-2.3h21.85q0-1.8 1.275-3.075t3.075-1.275v-10.6q-1.8 0-3.075-1.275t-1.275-3.075h-21.85q0 1.8-1.275 3.075t-3.075 1.275v10.6q1.8 0 3.075 1.275t1.275 3.075zm22.5 7.8h-31.75q-1.2 0-2.05-0.85t-0.85-2v-20.55h2.25v20.55q0 0.2 0.2 0.4t0.45 0.2h31.75zm-26.25-7.8h-0.6t0-0.175 0-0.425v-18.1q0-0.25 0-0.425t0-0.175h0.6q-0.25 0-0.425 0.175t-0.175 0.425v18.1q0 0.25 0.175 0.425t0.425 0.175z"
        })
    }),
    dashboard: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M99.8 56.9c0 13.7-5.5 26.1-14.4 35.1 0 0-1 1-2.2 1-.7 0-1.5-.3-2.1-.9l-7.4-7.4c-1.2-1.1-1.2-3 0-4.2 1.1-1.2 3-1.2 4.2 0l2.4 2.4c5.4-6.3 8.9-14.3 9.5-23.1H86c-1.7 0-3-1.3-3-3s1.3-3 3-3h3.7c-.3-5-1.7-9.7-3.8-14 2.4-2.9 4.8-5.8 7-8.5 4.4 7.4 7 16.1 6.9 25.6zM22.1 80.7L19.8 83c-5.4-6.3-9-14.3-9.6-23h3.7c1.7 0 3-1.3 3-3s-1.3-3-3-3h-3.8c.6-8.8 4.1-16.8 9.5-23.1l2.4 2.4c.6.6 1.4.9 2.1.9.7 0 1.5-.3 2.1-.9 1.2-1.2 1.2-3.1 0-4.2l-2.4-2.4c6.3-5.4 14.3-9 23-9.6v3.7c0 1.7 1.3 3 3 3s3-1.3 3-3V17c4.8.3 9.4 1.6 13.6 3.4 2.8-2.4 5.6-4.8 8.3-7.1C67.4 9.2 59 6.8 50 6.8c-27.6 0-50 22.4-50 50 0 13.7 5.5 26.1 14.4 35.1.7.7 1.7 1.3 2.4 1.3s1.5-.3 2.1-.9l7.4-7.4c1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0zm63.7-60.4c-.9-.9-2.3-1.1-3.4-.4l-.1.1c-9.7 8.3-23.4 20-29.9 25.3-.7-.2-1.6-.3-2.4-.3-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12c0-1.1-.2-2.1-.4-3.1 5.3-6.7 16.5-20.4 24.6-30.2.7-1 .6-2.4-.4-3.4z"
        })
    }),
    "data-and-access": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M90.8 51H49V10.1c-1-.1-2-.1-3-.1C21.1 10 1 30.1 1 55s20.1 45 45 45 45-20.1 45-45c0-1.3-.1-2.7-.2-4zM46 90c-19.3 0-35-15.7-35-35 0-16.9 12-31 28-34.3V61h41.5C77.6 77.4 63.3 90 46 90zM57 .1V43h42.9C98.9 19.7 80.3 1.1 57 .1zM67 33V12.1c9.7 3.5 17.3 11.2 20.9 20.9H67z"
        })
    }),
    database: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 448 512",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
        })
    }),
    date: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m24 28.15q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm16 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 7.85q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-8 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm16 0q-0.75 0-1.25-0.525t-0.5-1.225q0-0.75 0.5-1.275t1.25-0.525 1.25 0.525 0.5 1.275q0 0.7-0.5 1.225t-1.25 0.525zm-22.1 7q-1.2 0-2.05-0.85t-0.85-2.05v-28.95q0-1.15 0.85-2.025t2.05-0.875h3.7v-3.5h2.5v3.5h15.9v-3.5h2.45v3.5h3.65q1.2 0 2.05 0.875t0.85 2.025v28.95q0 1.2-0.85 2.05t-2.05 0.85zm0-2.25h28.2q0.25 0 0.45-0.2t0.2-0.45v-19.85h-29.5v19.85q0 0.25 0.2 0.45t0.45 0.2zm-0.65-22.75h29.5v-6.85q0-0.25-0.2-0.425t-0.45-0.175h-28.2q-0.25 0-0.45 0.175t-0.2 0.425zm0 0v-6.85q0-0.25 0-0.425t0-0.175 0 0.175 0 0.425v6.85z"
        })
    }),
    draggable: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 322 514",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m88 352c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48zm192 0c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zm-240-32c-22.09 0-40-17.9-40-40v-48c0-22.1 17.91-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48zm240-128c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48zm-240-32c-22.09 0-40-17.9-40-40v-48c0-22.09 17.91-40 40-40h48c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40h-48zm240-128c22.1 0 40 17.91 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.09 17.9-40 40-40h48z"
        })
    }),
    droplet: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M53.5 1.9C52.7.7 51.4 0 50 0s-2.7.7-3.5 1.9c-3.1 4.8-30.1 47.6-30.1 64.6C16.5 85 31.5 100 50 100s33.5-15 33.5-33.5c0-17-27-59.8-30-64.6zm-3.4 83.9c-2.3 0-4.1-1.8-4.1-4.1s1.8-4.1 4.1-4.1c6.5 0 11.8-5.3 11.8-11.8 0-2.3 1.8-4.1 4.1-4.1s4.1 1.8 4.1 4.1c0 11-9 20-20 20z"
        })
    }),
    edit: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M68 12.2l8.8-8.8C79.9.3 84.8.3 88 3.3l8.7 8.7c3 3 3 8-.1 11.2L87.8 32 68 12.2zM32.5 87.3l49.7-49.7-19.8-19.8-49.7 49.7 19.8 19.8zM7.1 73.1c-.5.5-.9 1.2-1.1 2L1.1 95.7c-.4 2 1.3 3.6 3.2 3.2l20.8-5.1c.8-.2 1.4-.5 2-1.1l-20-19.6z"
        })
    }),
    education: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50.9 57.2c-.6 0-1.2-.1-1.9-.3l-28.6-9.5c-.5 1.3-.8 3.1-.8 5.6 1.9 1.1 3.7 3.3 3.7 7 0 2.3-1.1 3.9-2.1 5 4.2 4.9 15.9 8.5 29.7 8.5 17.4 0 31.4-5.6 31.4-12.5V47.1L52.7 57c-.6.1-1.2.2-1.8.2zm47.8-24.8L51.5 16.7c-.4-.1-.8-.1-1.2 0L3.1 32.4c-.8.3-1.3 1-1.3 1.9 0 .8.5 1.6 1.3 1.9l10.8 3.6c-2.5 2.9-3.9 7-4.5 13.6-1.7.8-2.9 2.5-2.9 4.5 0 2.1 1.2 3.8 3 4.6C8 75.8 0 80.3 0 81.4c0 .6 6.2 3.9 7.7 3.9 2.3 0 7.7-3.9 7.7-12.2 0-4.9-.4-8.6-.9-11.3 1.3-.9 2.1-2.3 2.1-4 0-1.8-1-3.4-2.5-4.3.8-10.9 4.2-12.7 12.4-16.1.8-.3 2.4-.9 3.3-1.3 1.6-.7 3.1-1.2 4.4-1.8 4.5-1.8 8.3-3.2 11.2-4.3 3.2-1.1 4.6-1.5 4.6-1.6 1.2-.4 2.6.2 3 1.5.4 1.2-.2 2.6-1.5 3-.1 0-5.6 1.6-20 7.5-.9.4-1.8.7-2.6 1.1-1.7.7-3.1 1.2-4.3 1.8l25.6 8.5c.2.1.4.1.6.1.2 0 .4 0 .6-.1l47.1-15.7c.8-.3 1.3-1 1.3-1.9.2-.7-.3-1.5-1.1-1.8z"
        })
    }),
    ellipsis: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M64.5 50c0 8-6.5 14.5-14.5 14.5S35.5 58 35.5 50 42 35.5 50 35.5 64.5 42 64.5 50zm21-14.5C77.5 35.5 71 42 71 50s6.5 14.5 14.5 14.5S100 58 100 50s-6.5-14.5-14.5-14.5zm-71 0C6.5 35.5 0 42 0 50s6.5 14.5 14.5 14.5S29 58 29 50s-6.5-14.5-14.5-14.5z"
        })
    }),
    "elmos-fire": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M62.1 38.3l-7.7 16.1L46 46l16.1-7.7m12.8-12.8l-33.4 16-16 33.4 33.4-16 16-33.4zM50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0z"
        })
    }),
    email: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 25.6V21c0-3.9 3.2-7 7-7h86c3.8 0 7 3.1 7 7v4.6L52.8 46.2c-1.8.8-3.8.8-5.6 0L0 25.6zm52.8 31.7c-1.8.8-3.9.8-5.7 0L0 36.7V79c0 3.8 3.2 7 7 7h86c3.8 0 7-3.2 7-7V36.7L52.8 57.3z"
        })
    }),
    enterprise: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M59 25H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm0 10H40c-.8 0-2-1-2-2s1-2 2-2h19c1 0 2 1 2 2s-1 2-2 2zm41 22.5c0 1.5-1 2.5-3 2.5H3c-2 0-3-1-3-2.5S1 95 3 95h4V38c0-1 1-2 2-2h5v-6c0-1 1-2 2-2h9V10c0-1 1-2 2-2h8V2c0-1 1-2 2-2h26c1 0 2 1 2 2v6h8c1 0 2 1 2 2v18h9c1 0 2 1 2 2v6h5c1 0 2 1 2 2v57h4c2 0 3 1 3 2.5zM75 38h7v-6h-7v6zM39 10h22V4H39v6zM19 38h6v-6h-6v6zm6 57V41H13v54h12zm45 0V13H30v82h40zm18 0V41H75v54h13z"
        })
    }),
    "exclamation-circle": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M96,50c0,25.4-20.6,46-46,46S4,75.4,4,50  C4,24.6,24.6,4,50,4S96,24.6,96,50z M50,59.3c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S54.7,59.3,50,59.3z  M41.9,28.6l1.4,25.2c0.1,1.2,1,2.1,2.2,2.1h9c1.2,0,2.2-0.9,2.2-2.1l1.4-25.2c0.1-1.3-0.9-2.3-2.2-2.3H44.1  C42.8,26.3,41.8,27.3,41.9,28.6L41.9,28.6z"
        })
    }),
    "exclamation-circle-stroke": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFFFFF",
                d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0L50,0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F95359",
                d: "M96,50c0,25.4-20.6,46-46,46S4,75.4,4,50  C4,24.6,24.6,4,50,4S96,24.6,96,50z M50,59.3c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S54.7,59.3,50,59.3z  M41.9,28.6l1.4,25.2c0.1,1.2,1,2.1,2.2,2.1h9c1.2,0,2.2-0.9,2.2-2.1l1.4-25.2c0.1-1.3-0.9-2.3-2.2-2.3H44.1  C42.8,26.3,41.8,27.3,41.9,28.6L41.9,28.6z"
            })
        ]
    }),
    extraction: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M66.7 26.7c0-1.1-.4-2.2-1.2-2.9l-17-17c-.8-.8-1.8-1.2-3-1.2h-1.1v22.2h22.2v-1.1zM99.1 59L82.5 42.3c-1.8-1.8-4.8-.5-4.8 2v11.3h-11v11.1h11.1V78c0 2.5 3 3.7 4.8 2l16.6-16.8c1.1-1.2 1.1-3-.1-4.2zm-65.8 4.9v-5.6c0-1.5 1.3-2.8 2.8-2.8h30.6V33.3H43.1c-2.3 0-4.2-1.9-4.2-4.2V5.6H4.2C1.9 5.6 0 7.4 0 9.7v80.6c0 2.3 1.9 4.2 4.2 4.2h58.3c2.3 0 4.2-1.9 4.2-4.2V66.7H36.1c-1.5 0-2.8-1.3-2.8-2.8z"
        })
    }),
    eye: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 18 12",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M17.891 5.544C16.197 2.237 12.841 0 9 0 5.158 0 1.802 2.239.109 5.544a1.01 1.01 0 0 0 0 .912C1.803 9.763 5.159 12 9 12c3.842 0 7.197-2.239 8.891-5.544a1.01 1.01 0 0 0 0-.912zM9 10.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zM9 3a2.978 2.978 0 0 0-.791.118 1.495 1.495 0 0 1-2.09 2.091A2.993 2.993 0 1 0 9 3z"
        })
    }),
    file: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7v-64H60.9c-2.5 0-4.7-2.2-4.7-4.7zm31.3-2.8V25h-25V0h1.2c1.2 0 2.4.5 3.3 1.4l19.1 19.1c.9.9 1.4 2.1 1.4 3.3z"
        })
    }),
    fileHappy: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M56.2,26.6V0h-39c-2.6,0-4.7,2.1-4.7,4.7v90.6c0,2.6,2.1,4.7,4.7,4.7h65.6c2.6,0,4.7-2.1,4.7-4.7v-64H60.9 C58.4,31.3,56.2,29.1,56.2,26.6z M31.3,51.5c-2,0-3.7-1.6-3.7-3.7c0-2,1.6-3.7,3.7-3.7c2,0,3.7,1.6,3.7,3.7S33.3,51.5,31.3,51.5z M68.7,44.2c2,0,3.7,1.6,3.7,3.7c0,2-1.6,3.7-3.7,3.7c-2,0-3.7-1.6-3.7-3.7S66.7,44.2,68.7,44.2z M61.4,63.6c0,6.2-5,11.2-11.2,11.2 S39,69.8,39,63.6l0,0H61.4z M87.5,23.8V25h-25V0h1.2c1.2,0,2.4,0.5,3.3,1.4l19.1,19.1C87,21.4,87.5,22.6,87.5,23.8z"
        })
    }),
    filter: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M95.3 0H4.7C.5 0-1.6 5.1 1.4 8l36.1 36.1v40.2c0 1.5.7 3 2 3.8L55.1 99c3.1 2.2 7.4 0 7.4-3.8V44.1L98.6 8c3-2.9.9-8-3.3-8z"
        })
    }),
    "filter-outline": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M93.7,0H6.3C0.7,0-2.1,6.7,1.8,10.7l35.7,35.7v36.5v0c0,1.8,0.8,3.5,2.1,4.7 l12.5,10.9c4,3.5,10.4,0.7,10.4-4.7V46.3l35.7-35.7C102.1,6.7,99.3,0,93.7,0L93.7,0z M56.3,43.8v50L43.8,82.8V43.8L6.2,6.2h87.5 L56.3,43.8z"
        })
    }),
    folder: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 514 514",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M465 129H273l-64-64H49C22.49 65 1 86.49 1 113v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V177c0-26.51-21.49-48-48-48z"
        })
    }),
    form: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M81,0H19c-5,0-9,4-9,9v82c0,5,4,9,9,9h62c5,0,9-4,9-9V9C90,4,86,0,81,0z M80,90H20V10h60V90z M74,26H26v-6h48V26z M74,38H26v-6h48V38z M74,49.7H26v-6h48V49.7z M74,79.8H56v-6h18V79.8z M74,67.8H56v-6h18V67.8z M34.2,80l14.1-14.1L44,61.8l-9.9,10L30,67.7l-4,4.1L34.2,80z"
        })
    }),
    gallery: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M5.9 46H40c3.3 0 6-2.7 6-6V5.9c0-2.5-2.3-4.4-4.8-3.9C21.5 5.9 5.9 21.5 1.9 41.2c-.5 2.5 1.4 4.8 4 4.8zM36 13.9V36H13.9C18 26 26 18 36 13.9zM62 56c-3.3 0-6 2.7-6 6v34.2c0 2.5 2.3 4.4 4.8 3.9 19.8-4 35.4-19.6 39.3-39.3.5-2.5-1.4-4.8-3.9-4.8H62zm4 32.1V66h22.1C84 76 76 84 66 88.1zM40 56H5.9c-2.5 0-4.4 2.3-3.9 4.8 4 19.8 19.6 35.4 39.3 39.3 2.5.5 4.8-1.4 4.8-3.9V62c-.1-3.3-2.8-6-6.1-6zM13.9 66H36v22.1C26 84 18 76 13.9 66zM62 46h34.2c2.5 0 4.4-2.3 3.9-4.8-4-19.8-19.6-35.4-39.3-39.3-2.5-.5-4.8 1.4-4.8 4V40c0 3.3 2.7 6 6 6zm26.1-10H66V13.9C76 18 84 26 88.1 36z"
        })
    }),
    graphiql: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M90,62.8c-0.8-0.4-1.5-0.7-2.3-0.9V38.1c0.8-0.2,1.6-0.5,2.4-0.9c4.3-2.5,5.7-7.9,3.3-12.2c-2.5-4.3-7.9-5.7-12.2-3.3  c-0.8,0.4-1.4,1-2,1.6L58.5,11.5c0.2-0.8,0.4-1.7,0.4-2.5C58.9,4,54.9,0,50,0s-8.9,4-8.9,8.9c0,0.9,0.1,1.7,0.4,2.5L20.9,23.3  c-0.6-0.6-1.2-1.1-2-1.6c-4.3-2.5-9.7-1-12.2,3.3c-2.5,4.3-1,9.7,3.3,12.2c0.8,0.4,1.6,0.7,2.4,0.9v23.8c-0.8,0.2-1.6,0.5-2.3,0.9  C5.7,65.3,4.3,70.7,6.7,75s7.9,5.7,12.2,3.3c0.8-0.4,1.4-1,2-1.6l20.6,11.9c-0.2,0.8-0.4,1.6-0.4,2.5c0,4.9,4,8.9,8.9,8.9  s8.9-4,8.9-8.9c0-1-0.2-1.9-0.5-2.8l20.4-11.8c0.6,0.7,1.4,1.3,2.2,1.8c4.3,2.5,9.7,1,12.2-3.3C95.8,70.7,94.3,65.3,90,62.8z   M23.1,68.4c-0.2-0.8-0.5-1.6-0.9-2.3c-0.4-0.8-1-1.4-1.6-2l26.9-46.6c0.8,0.2,1.6,0.4,2.5,0.4c0.9,0,1.7-0.1,2.5-0.4l26.9,46.6  c-0.6,0.6-1.1,1.2-1.6,2c-0.4,0.8-0.7,1.5-0.9,2.3H23.1z M77,27c-0.6,2.2-0.4,4.7,0.8,6.9c1.3,2.2,3.3,3.6,5.6,4.2v23.8  c-0.1,0-0.2,0.1-0.3,0.1L56.2,15.4c0.1-0.1,0.2-0.2,0.2-0.2L77,27z M43.6,15.1c0.1,0.1,0.2,0.2,0.3,0.3L16.9,62  c-0.1,0-0.2-0.1-0.3-0.1V38.1c2.3-0.6,4.3-2,5.6-4.2c1.3-2.2,1.5-4.7,0.8-6.9L43.6,15.1z M56.6,85.1c-1.6-1.8-4-2.9-6.6-2.9  c-2.5,0-4.8,1-6.4,2.7L23,73c0-0.1,0.1-0.2,0.1-0.3h53.8c0,0.2,0.1,0.4,0.2,0.6L56.6,85.1z"
        })
    }),
    happy: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zm-78.6-7.4c-.1-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.6 5.7 5.7 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5C37.7 36.7 32.8 32 27 32s-10.6 4.8-10.6 10.6c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5zM73 32c-5.9 0-10.6 4.8-10.6 10.6 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-3.1 2.6-5.7 5.7-5.7s5.7 2.6 5.7 5.7c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5C83.7 36.7 78.9 32 73 32zm4.8 24.6c-1.4-.6-3 0-3.5 1.4-4.2 9.7-13.7 16-24.3 16-10.6 0-20.1-6.3-24.3-16.1-.6-1.4-2.1-2-3.5-1.4-1.4.6-2 2.1-1.4 3.5 5.1 11.7 16.5 19.3 29.3 19.3 12.7 0 24.2-7.5 29.1-19.3.6-1.2-.1-2.8-1.4-3.4z"
        })
    }),
    "help-solid": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm9.4 80.2c0 5.2-4.3 9.5-9.5 9.5s-9.5-4.3-9.5-9.5 4.3-9.5 9.5-9.5 9.5 4.2 9.5 9.5zM72.7 32c0 11.5-7.5 16.9-11.1 19.5l-.2.1c-3.5 2.5-4 4.6-4 6.4 0 4.2-3.5 5.9-7.8 5.9-4.2 0-7.5-1.8-7.5-6 0-7.6 3.6-14.1 10.4-18.7 3.7-2.6 4.8-4.2 4.8-7.2 0-.6-.2-5.3-7.6-5.3-3.7 0-6.3 1.5-7.4 5.1-1.3 4-4.4 6.2-8.2 6.2-5.7 0-7.8-4.4-6.7-9.1 2.3-10.2 11.4-17.3 22.5-17.3 16.7-.3 22.8 12 22.8 20.4z"
        })
    }),
    help: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 10c22.1 0 40 17.9 40 40S72.1 90 50 90 10 72.1 10 50s17.9-40 40-40m0-10C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm0 18.4c-9.5 0-17.4 6-19.2 14.6-.3 1.3.3 4.9 4.9 4.9 3 0 4.4-1.2 4.9-2.9 1.1-3.8 4.7-6.7 9.3-6.7 9.1 0 9.4 6.6 9.4 7.2 0 4-2 6.1-5.5 8.6C48 48.3 45 53.7 45 60.3c0 2.8 2.3 4.1 5 4.1 2.9 0 5.1-1.2 5.1-4 0-2 .5-4.8 4.7-7.8 3.1-2.3 9.8-6.8 9.8-16.8-.1-7.1-5.3-17.4-19.6-17.4zm0 51c-3.5 0-6.4 2.8-6.4 6.4s2.8 6.4 6.4 6.4c3.5 0 6.4-2.8 6.4-6.4s-2.9-6.4-6.4-6.4z"
        })
    }),
    highlight: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 91.2l18.4 5.9 6.5-6.5-12.3-12.4L0 91.2zm22.9-44.1c-2 1.7-2.8 4.5-2 7l2.4 7.9-9.3 9.3L31.6 89l9.3-9.3 7.9 2.4c2.5.8 5.3 0 7-2l6.5-7.7-31.8-31.9-7.6 6.6zM97 17.5L85.4 5.9c-3.8-3.8-9.8-4-13.8-.4L35 36.7l31.2 31.2 31.2-36.6c3.6-4 3.4-10-.4-13.8z"
        })
    }),
    "highlight-outline": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M97.2,16.9L86.1,5.8c-1.9-1.9-4.4-2.8-6.8-2.8c-2.4,0-4.6,0.9-6.4,2.4 L20.3,51.1c-1.9,1.7-2.6,4.3-1.9,6.7l2.3,7.5L14,72c-1.2,1.2-1.2,3.2,0,4.5l0,0L0,91.2l18.4,5.9l8.1-8.1l0,0c1.2,1.2,3.3,1.2,4.5,0 l6.7-6.7l7.5,2.3c3.3,1,5.8-0.8,6.7-1.9l45.7-52.6C101,26.3,100.8,20.5,97.2,16.9z M16.7,90.4l-5.9-1.9l7.4-7.7l4.1,4.1L16.7,90.4z M47.5,78.8C47.3,78.9,47.2,79,47,79c0,0-0.1,0-0.2,0l-7.5-2.3l-3.4-1l-7.3,7.3l-8.6-8.6l7.3-7.3l-1-3.4l-2.3-7.5 c-0.1-0.2,0-0.4,0.1-0.6l8.3-7.2l22.2,22.2L47.5,78.8z M93.1,26.3L58.5,66.1L36.9,44.4L76.7,9.8C77.6,9,80,8,81.9,9.9L93,21.1 C94.4,22.5,94.5,24.7,93.1,26.3L93.1,26.3z"
        })
    }),
    "indico-logo-white": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 30",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M59.6 20.1c0-5.5 4.5-9.9 9.9-9.9h7.2v3.5h-7.2c-3.5 0-6.2 2.9-6.2 6.2 0 3.5 2.9 6.2 6.2 6.2h7.2V30h-7.2c-5.4 0-9.9-4.5-9.9-9.9zM0 30h3.6V10.3H0V30zM1.8 4.3C.8 4.3 0 5 0 6s.7 1.7 1.8 1.7S3.5 7 3.5 6c.1-1-.7-1.7-1.7-1.7zm5 16V30h3.6v-9.7c0-3.5 2.9-6.2 6.2-6.2 3.5 0 6.2 2.9 6.2 6.2V30h3.6v-9.7c0-5.5-4.5-9.9-9.9-9.9-5.2-.1-9.7 4.4-9.7 9.9zM52.9 30h3.6V10.3h-3.6V30zm1.9-25.7c-1 0-1.8.7-1.8 1.7s.7 1.7 1.8 1.7c1 0 1.8-.8 1.8-1.7s-.8-1.7-1.8-1.7zM100 20c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.5-10 10-10 10 4.5 10 10zm-16.1 0c0 3.4 2.8 6.1 6.1 6.1s6.1-2.8 6.1-6.1c0-3.4-2.8-6.1-6.1-6.1s-6.1 2.7-6.1 6.1zm7.9 0c0 1-.8 1.7-1.7 1.7s-1.8-.7-1.8-1.7.8-1.7 1.8-1.7 1.7.7 1.7 1.7zM49.8.4V20.1c0 5.5-4.5 9.9-10 9.9s-10-4.5-10-10 4.5-10 10-10c2.4 0 4.6.9 6.4 2.4V.5h3.6V.4zM33.6 20c0 3.4 2.7 6.1 6.1 6.1 3.4 0 6.1-2.8 6.1-6.1 0-3.4-2.7-6.1-6.1-6.1-3.3 0-6.1 2.7-6.1 6.1z"
        })
    }),
    "indico-o": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM50 19.4c-16.9 0-30.6 13.7-30.6 30.6S33.1 80.6 50 80.6 80.6 66.9 80.6 50 66.9 19.4 50 19.4zm0 21.7c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
        })
    }),
    info: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50,6.5c23.9,0,43.5,19.4,43.5,43.5c0,24.1-19.5,43.5-43.5,43.5  C26,93.5,6.5,74.1,6.5,50C6.5,26,25.9,6.5,50,6.5 M50,0C22.4,0,0,22.4,0,50c0,27.6,22.4,50,50,50s50-22.4,50-50  C100,22.4,77.6,0,50,0z M42.7,69.4h2.4V45.2h-2.4c-1.3,0-2.4-1.1-2.4-2.4v-1.6c0-1.3,1.1-2.4,2.4-2.4h9.7c1.3,0,2.4,1.1,2.4,2.4  v28.2h2.4c1.3,0,2.4,1.1,2.4,2.4v1.6c0,1.3-1.1,2.4-2.4,2.4H42.7c-1.3,0-2.4-1.1-2.4-2.4v-1.6C40.3,70.4,41.4,69.4,42.7,69.4z  M50,21c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5C56.5,23.9,53.6,21,50,21z"
        })
    }),
    kabob: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m50 18c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm9 73c0-5-4-9-9-9s-9 4-9 9 4 9 9 9 9-4 9-9zm0-41c0-5-4-9-9-9s-9 4-9 9 4 9 9 9 9-4 9-9z"
        })
    }),
    key: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M81.3 30c-3.1 3.1-8.1 3.1-11.4 0-3.1-3.1-3.1-8.1 0-11.4 3.1-3.1 8.1-3.1 11.4 0 3.1 3.3 3.1 8.3 0 11.4zm11.4-19.1C81.5-1.8 61.9-2.3 50.1 9.6c-7.9 7.9-10.3 19.1-7.4 29L2.5 78.9C1.4 80 .8 81.4.7 82.9L0 95.7c-.1 1.9 1.5 3.4 3.4 3.3l15.5-1.3c1.3-.2 2.4-.7 3.6-1.7V82.2h13v-13H51c6.5-6.2 11.3-11 11.3-11 10.5 3.1 22.4.2 30.2-8.6 9.9-10.8 10-27.7.2-38.7z"
        })
    }),
    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M98.6 45.4L78.9 17.7c-3-4.2-7.9-6.7-13.1-6.7H10.6c-8 .5-12.8 9-9.5 16.2L9.3 50 1 72.6c-3 6.6.8 14.6 8 16.1.8.2 1.6.3 2.5.3h54.4c5.2 0 10.1-2.5 13.1-6.7l19.5-27.7c2-2.9 2-6.4.1-9.2z"
        })
    }),
    "layout-complex": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M74 72H43v-4h31v4zM26 60v4h13v-4H26zm13 12v-4H26v4h13zm35-16v-4H43v4h31zm-35 0v-4H26v4h13zm4 4v4h31v-4H43zm47 35V5c0-2.7-3.2-5-6-5H15c-2.7 0-5 2.2-5 5v90c0 2.7 2.2 5 5 5h70c2.8 0 5-2.2 5-5zM79 76H21V48h58v28zm0-48H62v-4h17v4zm-23 8h-4v-4h4v4zm0-8h-4v-4h4v4zm23 8H62v-4h17v4zm-40-8H21v-4h18v4zm0 8H21v-4h18v4z"
        })
    }),
    "layout-simple": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M85 100H15c-2.7 0-5-2.2-5-5V5c0-2.7 2.2-5 5-5h69c2.7 0 6 2.2 6 5v90c0 2.8-2.2 5-5 5zM46 52H21v4h25v-4zm0 20H21v4h25v-4zm0-10H21v4h25v-4zm0-30H21v4h25v-4zm0-10H21v4h25v-4zm0 20H21v4h25v-4zm8-6h25v-4H54v4zm0-10h25v-4H54v4zm0 20h25v-4H54v4zm0 20h25v-4H54v4zm0 10h25v-4H54v4zm0-20h25v-4H54v4z"
        })
    }),
    location: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m22.85 43v-8.75h-11l-5.15-5.1 5.15-5.15h11v-4.35h-14.5v-10.3h14.5v-4.35h2.3v4.35h11l5.15 5.15-5.15 5.15h-11v4.35h14.5v10.25h-14.5v8.75zm-12.2-25.65h24.55l2.9-2.85-2.9-2.85h-24.55zm2.15 14.65h24.55v-5.75h-24.55l-2.9 2.9zm-2.15-14.65v-5.7 5.7zm26.7 14.65v-5.75 5.75z"
        })
    }),
    lock: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M79 46.2V29C79 13 66 0 50 0S21 13 21 29v17.2c-5.7 1-10 5.9-10 11.8v30c0 6.6 5.4 12 12 12h54c6.6 0 12-5.4 12-12V58c0-5.9-4.3-10.9-10-11.8zM49.2 14c8.7-.4 15.8 6.5 15.8 15v17H35V29.4c0-8 6.2-15 14.2-15.4zm.8 71c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8z"
        })
    }),
    menu: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M94 24H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6zM94 56H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6zM94 88H6c-3.2 0-6-2.8-6-6s2.8-6 6-6h88c3.2 0 6 2.8 6 6s-2.8 6-6 6z"
        })
    }),
    message: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 24 22",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21.8 5.10019H17.8V2.4002C17.8 1.2002 16.8 0.200195 15.6 0.200195H2.2C1 0.200195 0 1.2002 0 2.4002V15.8002C0 16.5002 0.5 16.9002 1.1 16.9002C1.3 16.9002 1.6 16.8002 1.8 16.6002L5.9 13.2002H6.2V16.0002C6.2 17.2002 7.2 18.2002 8.4 18.2002H18.1L22.2 21.6002C22.4 21.8002 22.7 21.9002 22.9 21.9002C23.5 21.9002 24 21.5002 24 20.8002V7.3002C24 6.1002 23 5.10019 21.8 5.10019ZM4.6 11.6002L2 13.9002V2.4002C2 2.3002 2.1 2.2002 2.2 2.2002H15.6C15.7 2.2002 15.8 2.3002 15.8 2.4002V11.0002C15.8 11.1002 15.7 11.2002 15.6 11.2002H5.9C5.5 11.2002 5 11.3002 4.6 11.6002ZM22 18.8002L19.4 16.6002C19 16.3002 18.6 16.1002 18.1 16.1002H8.4C8.3 16.1002 8.2 16.0002 8.2 15.9002V13.1002H15.6C16.8 13.1002 17.8 12.1002 17.8 10.9002V7.1002H21.8C21.9 7.1002 22 7.2002 22 7.3002V18.8002Z"
        })
    }),
    "model-import": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M96.4,19.1L88.6,4.7C87,1.8,83.9,0,80.7,0H19.3c-3.3,0-6.3,1.8-7.9,4.7L3.6,19.1c-1,1.9-1.6,4-1.6,6.1V91c0,5,4,9,9,9h78c5,0,9-4,9-9V25.2C98,23.1,97.5,21,96.4,19.1z M19.9,10h60.1l6,11H13.9L19.9,10z M12,90V31h76v59H12z M67.8,57.8L50,40L32.2,57.8l5.7,5.6l8.1-8.1V80h8V55.3l8.1,8.1L67.8,57.8"
        })
    }),
    "model-starter": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M96.4,19.1L88.6,4.7C87,1.8,83.9,0,80.7,0H19.3c-3.3,0-6.3,1.8-7.9,4.7L3.6,19.1c-1,1.9-1.6,4-1.6,6.1V91c0,5,4,9,9,9h78c5,0,9-4,9-9V25.2C98,23.1,97.5,21,96.4,19.1z M19.9,10h60.1l6,11H13.9L19.9,10z M12,90V31h76v59H12z M66,64H54v12h-8V64H34v-8h12V44h8v12h12V64z"
        })
    }),
    moon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M98.7 52.5c-.8-.4-2.1-.3-2.9.8-6.2 7.9-16.2 12.1-26.2 12.1C50.4 65.4 35 50 35 30.8c0-10 4.2-19.2 12.1-26.2.8-.8 1.1-2.2.8-2.9C47.3.3 46.2 0 45 0 19.2 2.5 0 23.8 0 50c0 27.9 22.5 50 50 50 25.8 0 47.5-19.2 50-45 .1-1.2-.4-2.1-1.3-2.5z"
        })
    }),
    moonbow: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M42 65c2.2 0 4 1.8 4 4v5c0 2.2-1.8 4-4 4H8.6c-2.7-4-4.8-8.3-6.3-13H42zm25-12v-5c0-2.2-1.8-4-4-4H.4c-.3 2-.4 4-.4 6 0 2.4.2 4.7.5 7H63c2.2 0 4-1.8 4-4zM51 23H7.9C5.4 27 3.4 31.4 2 36h49c2.2 0 4-1.8 4-4v-5c0-2.2-1.8-4-4-4zm49 27c0-27.6-22.4-50-50-50-.8 0-1.7 0-2.5.1-.2 0-.5 0-.7.1-.6 0-1.2.1-1.8.1-.3 0-.5.1-.8.1-.6.1-1.1.1-1.6.2-.3 0-.5.1-.8.1-.5.1-1.1.2-1.6.3-.3.1-.6.1-.8.2-.5.1-1 .2-1.5.4-.3.1-.6.2-.9.2-.5.1-1 .3-1.4.4l-.9.3c-.4.1-.9.3-1.3.4-.3.1-.7.2-1 .4-.4.1-.8.3-1.1.4-.5.2-.9.3-1.3.5-.3.1-.6.3-.9.4-.4.2-.9.4-1.3.6l-.6.3c-.5.3-1 .5-1.5.8-.1 0-.2.1-.3.1-3.2 1.8-6.2 4-9 6.5h18.4c4.7-1.9 9.8-3 15.2-3 22.1 0 40 17.9 40 40S72.1 90 50 90c-5.4 0-10.6-1.1-15.2-3H16.4c2.7 2.5 5.7 4.7 9 6.5.1 0 .2.1.3.1.5.3 1 .6 1.5.8l.6.3c.4.2.9.4 1.3.6.3.1.6.3.9.4.4.2.8.3 1.1.5.4.2.8.3 1.1.4.3.1.7.3 1 .4.4.2.9.3 1.3.4l.9.3c.5.1 1 .3 1.4.4.3.1.6.2.9.2.5.1 1 .2 1.5.4.3.1.6.1.8.2.5.1 1.1.2 1.6.3.3 0 .5.1.8.1.5.1 1.1.1 1.6.2.3 0 .5.1.8.1.6.1 1.2.1 1.8.1.2 0 .5 0 .7.1.8 0 1.7.1 2.5.1C77.6 100 100 77.6 100 50z"
        })
    }),
    "no-format": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m24 43q-3.95 0-7.425-1.5t-6.05-4.075-4.05-6.05-1.475-7.475q0-3.95 1.475-7.4t4.05-6.025 6.05-4.025 7.425-1.45 7.425 1.45 6.05 4.025 4.05 6.025 1.475 7.4q0 4-1.475 7.475t-4.05 6.05-6.05 4.075-7.425 1.5zm7.35-26h7.95q-1.75-3.8-4.875-6.225t-7.275-3.225q1.45 1.9 2.475 4.25t1.725 5.2zm-12.35 0h10.1q-0.65-2.8-1.975-5.3t-3.125-4.45q-1.7 1.55-2.875 3.85t-2.125 5.9zm-11.05 11.7h8.25q-0.15-1.4-0.2-2.55t-0.05-2.25q0-1.2 0.05-2.275t0.25-2.325h-8.3q-0.35 1.15-0.525 2.225t-0.175 2.375q0 1.35 0.175 2.475t0.525 2.325zm12.9 11.7q-1.45-1.8-2.525-4.225t-1.675-5.225h-7.95q1.9 3.9 4.8 6.125t7.35 3.325zm-12.15-23.4h7.95q0.65-2.75 1.675-5.075t2.475-4.325q-4.15 0.8-7.225 3.175t-4.875 6.225zm15.3 23.85q1.85-2.05 3.05-4.4t2-5.5h-10.05q0.75 3.1 1.95 5.5t3.05 4.4zm-5.45-12.15h10.95q0.2-1.55 0.275-2.6t0.075-2.2q0-1.05-0.075-2.075t-0.275-2.525h-10.95q-0.2 1.5-0.275 2.525t-0.075 2.075q0 1.15 0.075 2.2t0.275 2.6zm8.65 11.7q3.95-0.9 7.125-3.35t4.975-6.1h-7.9q-0.75 2.8-1.8 5.2t-2.4 4.25zm4.55-11.7h8.3q0.35-1.2 0.525-2.325t0.175-2.475q0-1.3-0.175-2.375t-0.525-2.225h-8.25q0.15 1.65 0.225 2.675t0.075 1.925q0 1.15-0.075 2.225t-0.275 2.575z"
        })
    }),
    "object-detection": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0,91V66h10v24h24v10H9C4,100,0,96,0,91z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M90,90H66v10h25c5,0,9-4,9-9V66H90V90z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M91,0H66v10h24v24h10V9C100,4,96,0,91,0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10,10h24V0H9C4,0,0,4,0,9v25h10V10z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                x: "32",
                y: "32",
                width: "36",
                height: "36"
            })
        ]
    }),
    organizations: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M86.9 53.9C85.9 43 80.3 33.4 72 27.2V26c0-12.2-9.8-22-22-22s-22 9.8-22 22v1.2c-8.3 6.2-14 15.7-14.9 26.6C5.4 57.3 0 65 0 74c0 12.2 9.8 22 22 22 5.2 0 10-1.8 13.8-4.9C40.2 93 45 94 50 94s9.8-1 14.2-2.9C68 94.2 72.8 96 78 96c12.2 0 22-9.8 22-22 0-9-5.4-16.7-13.1-20.1zM50 14c6.6 0 12 5.4 12 12s-5.4 12-12 12-12-5.4-12-12 5.4-12 12-12zM22 86c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12zm20.2-3.2c1.2-2.7 1.8-5.7 1.8-8.8 0-11.7-9.1-21.2-20.5-21.9 1-5.6 3.9-10.7 7.8-14.5C35.2 43.8 42.1 48 50 48s14.8-4.2 18.7-10.4c4 3.8 6.8 8.8 7.8 14.5C65.1 52.8 56 62.3 56 74c0 3.1.7 6.1 1.8 8.8-2.4.8-5.1 1.2-7.8 1.2s-5.4-.4-7.8-1.2zM78 86c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12-5.4 12-12 12z"
        })
    }),
    output: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7V31.2H60.9c-2.5 0-4.7-2.1-4.7-4.6zm15 41.2L52.3 86.5a3.32 3.32 0 01-4.7 0L28.8 67.8c-2-2-.6-5.3 2.2-5.3h12.7V46.9c0-1.7 1.4-3.1 3.1-3.1H53c1.7 0 3.1 1.4 3.1 3.1v15.6H69c2.8 0 4.2 3.4 2.2 5.3zm14.9-47.3L67 1.4C66.1.5 64.9 0 63.7 0h-1.2v25h25v-1.2c0-1.2-.5-2.4-1.4-3.3z"
        })
    }),
    "page-thumbnail": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7v-64H60.9c-2.5 0-4.7-2.2-4.7-4.7zm12.6 46.1c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.3 1.1 2.3 2.3v1.6zm0-12.5c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.3 1.1 2.3 2.3v1.6zm0-14.1v1.6c0 1.3-1.1 2.3-2.3 2.3H33.6c-1.3 0-2.3-1.1-2.3-2.3v-1.6c0-1.3 1.1-2.3 2.3-2.3h32.8c1.3 0 2.4 1 2.4 2.3zm18.7-22.3V25h-25V0h1.2c1.2 0 2.4.5 3.3 1.4l19.1 19.1c.9.9 1.4 2.1 1.4 3.3z"
        })
    }),
    "pay-as-you-go": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M69.1 66.8c1 1 1.5 2.7.1 4.1-1.6 1.6-4.1 0-4.9-.8 0 0-18.1-15.7-18.3-15.9-1.2-1.2-1.8-2.6-1.6-4.2L46 19.4c.2-2 .8-3.4 2.8-3.4 2.2 0 2.8 1.2 2.8 3.4L54.2 47c0 .6.4 1.4.8 1.8l14.1 18zm16.4 18.6c1.4-1.4 1.4-3.6 0-4.9-1.4-1.4-3.6-1.4-4.9 0-8.2 8-19 12.5-30.5 12.5C26.3 93 7 73.7 7 50S26.3 7 50.1 7c1.9 0 3.5-1.6 3.5-3.5S52 0 50.1 0C22.5 0 0 22.4 0 50s22.5 50 50.1 50c13.4 0 25.9-5.2 35.4-14.6zm3.5-9.6c-1.7-1-2.3-3.1-1.3-4.7 1-1.7 3.1-2.3 4.8-1.3 1.7 1 2.3 3.1 1.3 4.8-.7 1.2-1.9 1.8-3.1 1.8-.6-.1-1.2-.3-1.7-.6zm5.9-12.6c-1.9-.4-3.1-2.3-2.7-4.1.4-1.9 2.3-3.1 4.1-2.7 1.9.4 3.1 2.3 2.7 4.1-.4 1.7-1.9 2.8-3.5 2.8-.1 0-.4-.1-.6-.1zm-1.9-17c-.2-1.9 1.3-3.6 3.2-3.8 1.9-.2 3.6 1.2 3.8 3.2.2 1.9-1.2 3.6-3.2 3.8h-.4c-1.7 0-3.2-1.4-3.4-3.2zm-3-12.5c-.7-1.8.1-3.8 1.9-4.6 1.8-.7 3.8.1 4.6 1.9.7 1.8-.1 3.8-1.9 4.5-.5.2-1 .3-1.4.3-1.4.1-2.7-.8-3.2-2.1zm-6.6-11c-1.2-1.5-1-3.7.5-4.9 1.5-1.2 3.7-1 4.9.5 1.2 1.5 1 3.7-.5 4.9-.7.5-1.5.8-2.3.8-1-.1-1.9-.5-2.6-1.3zm-9.6-8.6c-1.6-1.1-2-3.2-1-4.8 1.1-1.6 3.2-2.1 4.8-1 1.6 1.1 2 3.2 1 4.8-.7 1.1-1.8 1.6-3 1.6-.6-.1-1.2-.3-1.8-.6zM62.1 8.7c-1.9-.5-2.9-2.5-2.4-4.3.5-1.8 2.5-2.9 4.3-2.4 1.9.5 2.9 2.5 2.4 4.3-.4 1.6-1.8 2.6-3.4 2.5-.3 0-.6 0-.9-.1z"
        })
    }),
    person: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m24 23.35q-2.9 0-4.775-1.875t-1.875-4.775 1.875-4.75 4.775-1.85 4.775 1.85 1.875 4.75-1.875 4.775-4.775 1.875zm-15 15.25v-3.8q0-1.6 0.85-2.8t2.2-1.85q3.2-1.4 6.125-2.1t5.825-0.7 5.825 0.725 6.075 2.125q1.4 0.65 2.25 1.825t0.85 2.775v3.8zm2.25-2.25h25.5v-1.55q0-0.75-0.5-1.475t-1.3-1.125q-2.95-1.45-5.575-2.025t-5.375-0.575-5.425 0.575-5.575 2.025q-0.75 0.4-1.25 1.125t-0.5 1.475zm12.75-15.25q1.85 0 3.1-1.25t1.25-3.15q0-1.85-1.25-3.1t-3.1-1.25-3.1 1.25-1.25 3.1q0 1.9 1.25 3.15t3.1 1.25zm0-4.4zm0 19.65z"
        })
    }),
    phone: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m20.15 40.9h7.7v-1.75h-7.7zm-6.9-5.8h21.5v-25.45h-21.5zm0.65 9.9q-1.2 0-2.05-0.85t-0.85-2.05v-36.2q0-1.2 0.85-2.05t2.05-0.85h20.2q1.2 0 2.05 0.85t0.85 2.05v36.2q0 1.2-0.85 2.05t-2.05 0.85zm-0.65-37.6h21.5v-1.5q0-0.25-0.2-0.45t-0.45-0.2h-20.2q-0.25 0-0.45 0.2t-0.2 0.45zm0-2.15t0 0.175 0 0.475v1.5-1.5q0-0.3 0-0.475t0-0.175zm0 32.1v4.75q0 0.25 0.2 0.45t0.45 0.2h20.2q0.25 0 0.45-0.2t0.2-0.45v-4.75zm0 5.4t0-0.175 0-0.475v-4.75 4.75q0 0.3 0 0.475t0 0.175z"
        })
    }),
    pin: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M63.9,72.1c-0.7-2.9,0.1-6,2.1-8.3l20.9-23.2c0,0,9.3,2.4,11.9-0.1c4.2-4.2-2.9-14.4-13.9-25.4 C75.8,6,63.5-3,59.4,1.1C56.9,3.7,59.3,13,59.3,13L36.1,33.9c-2.2,2-5.3,2.8-8.3,2.1c-6-1.4-16.1-3.1-19.8,0.6 c-2.2,2.2-2.4,5.7,0.8,8.8l18.5,18.5L1.3,94.6c-3.3,3.7,0.3,7.3,4,4l30.7-25.9l18.5,18.5c3.3,3.3,6.6,3,8.8,0.8 C67,88.2,65.3,78.1,63.9,72.1z"
        })
    }),
    plus: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M94 44H56V6c0-3.3-2.7-6-6-6s-6 2.7-6 6v38H6c-3.3 0-6 2.7-6 6s2.7 6 6 6h38v38c0 3.3 2.7 6 6 6s6-2.7 6-6V56h38c3.3 0 6-2.7 6-6s-2.7-6-6-6z"
        })
    }),
    pointer: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M80.8 64.3H60.1L71 90.8c.8 1.8-.1 3.9-1.8 4.7l-9.6 4.2c-1.8.8-3.8-.1-4.6-1.9L44.6 72.6 27.7 90c-2.3 2.3-5.9.5-5.9-2.5V3.6c0-3.2 3.9-4.8 5.9-2.5l55.5 57.1c2.3 2.2.6 6.1-2.4 6.1z"
        })
    }),
    popup: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M78 65c0-3.9 3.1-7 7-7s7 3.1 7 7v25.7c0 5.1-4.2 9.3-9.3 9.3H9.3C4.2 100 0 95.8 0 90.7V17.3C0 12.2 4.2 8 9.3 8H35c3.9 0 7 3.1 7 7s-3.1 7-7 7H14v64h64V65zM93 0H57c-3.9 0-7 3.1-7 7s3.1 7 7 7h17L41.5 46.5c-3 3-3 8 0 11s8 3 11 0L86 24v19c0 3.9 3.1 7 7 7s7-3.1 7-7V7c0-3.9-3.1-7-7-7z"
        })
    }),
    price: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m25.8 43q-0.45 0-0.875-0.15t-0.825-0.5l-18.4-18.45q-0.4-0.35-0.55-0.775t-0.15-0.925v-14.95q0-0.95 0.65-1.6t1.6-0.65h14.95q0.45 0 0.925 0.15t0.825 0.5l18.35 18.35q0.8 0.75 0.8 1.7t-0.75 1.7l-14.95 14.95q-0.3 0.3-0.725 0.475t-0.875 0.175zm0.05-2.2 14.95-14.95-18.55-18.6h-15v14.95zm-13.4-26.15q0.9 0 1.55-0.675t0.65-1.575-0.65-1.55-1.55-0.65-1.55 0.65-0.65 1.55 0.65 1.575 1.55 0.675z"
        })
    }),
    "radio-button": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(1 1)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "m49.9 72.5c6.3 0 11.6-2.2 15.9-6.5s6.5-9.7 6.5-15.9-2.2-11.6-6.5-15.9-9.7-6.5-15.9-6.5-11.5 2.1-15.9 6.4c-4.3 4.3-6.5 9.7-6.5 15.9s2.2 11.6 6.5 16 9.7 6.5 15.9 6.5zm0 27.5c-6.8 0-13.3-1.3-19.4-3.9s-11.4-6.2-15.9-10.7-8.1-9.8-10.7-15.9-3.9-12.5-3.9-19.4 1.3-13.4 3.9-19.5 6.2-11.4 10.7-15.9 9.8-8.1 15.9-10.7 12.5-4 19.4-4 13.4 1.3 19.5 4 11.4 6.2 15.9 10.7 8 9.7 10.7 15.8 4 12.6 4 19.6c0 6.9-1.3 13.4-4 19.5s-6.2 11.4-10.7 15.9-9.8 8.1-15.8 10.7c-6.1 2.5-12.6 3.8-19.6 3.8zm0-9.5c11.3 0 20.8-3.9 28.6-11.8s11.8-17.4 11.8-28.6c0-11.3-3.9-20.8-11.8-28.6s-17.3-11.8-28.6-11.8c-11.2 0-20.7 3.9-28.6 11.8s-11.8 17.3-11.8 28.6c0 11.2 3.9 20.7 11.8 28.6s17.5 11.8 28.6 11.8z"
            })
        })
    }),
    recruiter: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 21c-16 0-29 13-29 29 0 6.2 1.9 11.9 5.3 16.6-.1.1-.3.2-.4.3l-24 24c-2 2-2 5.2 0 7.2s5.2 2 7.2 0L33 74.2c.1-.1.2-.3.3-.4C38.1 77.1 43.8 79 50 79c16 0 29-13 29-29S66 21 50 21zm0 48c-10.5 0-19-8.5-19-19s8.5-19 19-19 19 8.5 19 19-8.5 19-19 19zm50-19c0 27.6-22.4 50-50 50-9.2 0-17.8-2.5-25.2-6.8l7.4-7.4C37.5 88.5 43.6 90 50 90c22.1 0 40-17.9 40-40S72.1 10 50 10 10 27.9 10 50c0 6.4 1.5 12.5 4.2 17.8l-7.4 7.4C2.5 67.8 0 59.2 0 50 0 22.4 22.4 0 50 0s50 22.4 50 50z"
        })
    }),
    regex: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M28.85 39.1V36.85H34Q35.2 36.85 36.025 36.025Q36.85 35.2 36.85 34V29.1Q36.85 27.35 37.925 25.975Q39 24.6 40.65 24.15V23.85Q39 23.4 37.925 22.025Q36.85 20.65 36.85 18.9V14Q36.85 12.8 36.025 11.975Q35.2 11.15 34 11.15H28.85V8.9H34Q36.15 8.9 37.625 10.4Q39.1 11.9 39.1 14V18.9Q39.1 20.15 39.95 20.975Q40.8 21.8 42.05 21.8H42.9V26.2H42.05Q40.8 26.2 39.95 27.025Q39.1 27.85 39.1 29.1V34Q39.1 36.1 37.6 37.6Q36.1 39.1 34 39.1ZM14 39.1Q11.85 39.1 10.375 37.6Q8.9 36.1 8.9 34V29.1Q8.9 27.85 8.05 27.025Q7.2 26.2 5.95 26.2H5.1V21.8H5.95Q7.2 21.8 8.05 20.975Q8.9 20.15 8.9 18.9V14Q8.9 11.9 10.4 10.4Q11.9 8.9 14 8.9H19.15V11.15H14Q12.8 11.15 11.975 11.975Q11.15 12.8 11.15 14V18.9Q11.15 20.65 10.075 22.025Q9 23.4 7.35 23.85V24.15Q9 24.6 10.075 25.975Q11.15 27.35 11.15 29.1V34Q11.15 35.2 11.975 36.025Q12.8 36.85 14 36.85H19.15V39.1Z"
        })
    }),
    reject: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 0C22.4 0 0 22.4 0 50s22.4 50 50 50 50-22.4 50-50S77.6 0 50 0zm26.2 23.8C89.4 37 90.3 57.1 80.4 71.3L28.7 19.6c14.2-9.9 34.3-9 47.5 4.2zM23.8 76.2C10.6 63 9.7 42.9 19.6 28.7l51.7 51.7c-14.2 10-34.3 9-47.5-4.2z"
        })
    }),
    repair: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currenftColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M98.2 36.7c1.2 4.3 1.8 8.8 1.8 13.5-.1 26.3-21.1 48.4-47.4 49.7-29.7 1.5-54-22.8-52.5-52.5C1.4 21.5 22.8.6 48.8 0c18.9-.5 35.6 9.6 44.4 24.8L47.6 70.4c-1.2 1.2-3.1 1.2-4.2 0L21.9 49c-1.2-1.2-1.2-3.1 0-4.2l4.2-4.2c1.2-1.2 3.1-1.2 4.2 0l15.1 15.1 33.3-33.3C71.2 14.3 60.3 9.5 48.3 10c-20.2.8-36.8 17-38.2 37.1C8.5 70.6 27 90 50 90c22.1 0 40-17.9 40-40 0-1.6-.1-3.1-.3-4.7l8.5-8.6z"
        })
    }),
    research: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M84.6 84.3L62.2 49.6c-.3-.7-.7-1-.7-1.7V37c2.1 0 3.5-1.4 3.5-3.5S63.6 30 61.5 30h-21c-1.7 0-3.5 1.4-3.5 3.5s1.4 3.5 3.5 3.5v10.8c0 .7 0 1-.3 1.4l-22.7 35c-3.8 7 1 15.7 9.1 15.7h49c7.6.1 13.2-8.3 9-15.6zM46.1 53.1c1-1.7 1.4-3.5 1.4-5.2V37h7v10.8c0 1.7.3 3.5 1.4 5.2l7.7 12H38.4l7.7-11.9zM75.5 93h-49c-2.8 0-4.2-3.1-3.1-4.9l10.5-15.7h34.3l10.1 15.7c1.4 2.1-.4 4.9-2.8 4.9zM51 25.8c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3-3.3 7.3-7.3 7.3zm0-9.6c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3zM69.9 18.3c-4.9 0-8.8-4-8.8-8.8s4-8.8 8.8-8.8c4.9 0 8.8 4 8.8 8.8s-3.9 8.8-8.8 8.8zm0-12.6c-2.1 0-3.8 1.7-3.8 3.8s1.7 3.8 3.8 3.8c2.1 0 3.8-1.7 3.8-3.8S72 5.7 69.9 5.7z"
        })
    }),
    retrain: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M98.4 20.3l-26 17.2c-1 .7-2.4-.1-2.4-1.3V26H21v25.1c0 .3-.2.7-.5.8-1.9 1.2-8.9 5.6-12 7.6-.7.4-1.5-.1-1.5-.8V16c0-2.2 1.8-4 4-4h59V1.8c0-1.2 1.4-2 2.4-1.3l26 17.2c1 .6 1 2 0 2.6zM79 48.9V74H30V63.8c0-1.2-1.4-2-2.4-1.3l-26 17.2c-1 .6-1 2 0 2.6l26 17.2c1 .7 2.4-.1 2.4-1.3V88h59c2.2 0 4-1.8 4-4V41.3c0-.8-.8-1.2-1.5-.8-3.1 2-10.2 6.4-12 7.6-.3.2-.5.5-.5.8z"
        })
    }),
    sad: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 50c0 27.6-22.4 50-50 50S0 77.6 0 50 22.4 0 50 0s50 22.4 50 50zM61.6 70.5c-3.2-2.4-7.1-3.9-11.6-3.9s-8.5 1.4-11.6 3.9c-1.9 1.5-3.2 2.9-3.9 4.1-.9 1.5-.5 3.5 1 4.4 1.5.9 3.5.5 4.4-1 .3-.5 1.1-1.4 2.3-2.3C44.3 74 46.9 73 50 73s5.7 1 7.8 2.5c1.2.9 2 1.9 2.3 2.3.9 1.5 2.9 2 4.4 1 1.5-.9 2-2.9 1-4.4-.7-1-1.9-2.5-3.9-3.9zM24.5 44.9c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm52 .2c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zM29.8 34c-.5-1.3-2-1.9-3.3-1.3l-12 5c-1.3.5-1.9 2-1.3 3.3.4 1 1.3 1.5 2.3 1.5.3 0 .6-.1 1-.2l12-5c1.2-.5 1.8-2 1.3-3.3zm55.7 3.7l-12-5c-1.3-.5-2.7.1-3.3 1.3-.5 1.3.1 2.7 1.3 3.3l12 5c.3.1.6.2 1 .2 1 0 1.9-.6 2.3-1.5.5-1.3-.1-2.8-1.3-3.3z"
        })
    }),
    search: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M39.4.4C17.9.4.4 17.9.4 39.4s17.5 39 39 39c8.8 0 16.9-2.9 23.4-7.8-.3 1.9.2 3.8 1.7 5.2l22 22c1.2 1.2 2.7 1.8 4.3 1.8s3.1-.6 4.3-1.8l2.8-2.8c2.4-2.4 2.4-6.2 0-8.5l-22-22c-1.2-1.2-2.7-1.8-4.2-1.8-.3 0-.7 0-1 .1 4.9-6.5 7.8-14.6 7.8-23.4C78.4 17.9 61 .4 39.4.4zm0 63c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24c0 13.3-10.7 24-24 24z"
        })
    }),
    shrug: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 250 66",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M2.1 4.7C.7 4.7 0 3.6 0 2.3 0 .9.7 0 2.1 0h15.8c1.4 0 2 .9 2 2.3s-.6 2.4-2 2.4H2.1zm47.6 57.7c.2.4.3.8.3 1.2 0 1-.7 1.8-1.9 2.2-.4.1-.9.2-1.2.2-1.1 0-1.9-.5-2.4-1.6L21.7 3.7c-.1-.4-.2-.8-.2-1.1 0-1 .7-1.8 1.9-2.3.4-.1.8-.2 1.1-.2 1.1 0 2 .5 2.4 1.7l22.8 60.6zm4.1 3.6c-1.4 0-2.1-1-2.1-2.4s.7-2.3 2.1-2.3h23.8c1.4 0 2 .9 2 2.3s-.6 2.4-2 2.4H53.8zM232.1 4.7c-1.4 0-2-1-2-2.4s.6-2.3 2-2.3h15.8c1.4 0 2.1.9 2.1 2.3s-.7 2.4-2.1 2.4h-15.8zm-9-2.8c.4-1.2 1.2-1.7 2.4-1.7.3 0 .7.1 1.1.2 1.2.4 1.9 1.2 1.9 2.3 0 .3-.1.7-.2 1.1l-22.7 60.6c-.5 1.1-1.3 1.6-2.4 1.6-.3 0-.8-.1-1.2-.2-1.1-.4-1.9-1.2-1.9-2.2 0-.3.1-.8.3-1.2l22.7-60.5zM171.4 66c-1.4 0-2-1-2-2.4s.6-2.3 2-2.3h24.8c1.4 0 2.1.9 2.1 2.3s-.7 2.4-2.1 2.4h-24.8zM90.8 3.5c0 .5-.2 1-.6 1.6-6.1 8.2-9.7 16.3-9.7 28.1 0 11.9 3.6 20.1 9.6 28.2.4.6.6 1.2.6 1.6 0 1-.6 1.7-1.4 2.3-.6.5-1.3.7-2 .7-.8 0-1.6-.4-2.3-1.3-6.9-9.5-10.5-18.6-10.5-31.5 0-12.9 3.6-21.9 10.6-31.3.7-.9 1.6-1.3 2.4-1.3.7 0 1.3.2 1.8.6.8.5 1.5 1.3 1.5 2.3zm10.6 1.4c1 0 1.8.5 2.4 1.4 2.8 5.2 5.5 12.5 7.2 18.1.1.5.2.9.2 1.2 0 1.2-.7 2.1-2 2.5-.4.1-.8.2-1.2.2-1.2 0-2.2-.8-2.6-2-1.5-5.3-4.5-12.7-6.8-17.5-.2-.5-.3-.9-.3-1.3 0-1.1.6-2 1.8-2.4.4-.1.8-.2 1.3-.2zm49.9 1.3v.4c-1.1 11.5-5 22.9-10.7 30.8-6.7 9-17.2 15.9-28.2 18.4-.3.1-.7.1-1 .1-1.3 0-2.2-.6-2.6-2.1-.1-.3-.1-.7-.1-1 0-1.4.9-2.3 2.3-2.7 10-2.9 19.2-8.4 25-16.4 5.2-7.1 8.5-17.3 9.5-28 .1-1.8 1.4-2.5 2.8-2.5.3 0 .5 0 .7.1 1.3.2 2.3 1.3 2.3 2.9zm-32.1-4.7c1.1 0 2.2.5 2.8 1.7 2.3 5.1 4.9 11.7 6.5 17.5.1.3.1.5.1.8 0 1.4-.9 2.5-2.2 2.8-.3.1-.7.1-1.1.1-1.2 0-2.2-.6-2.6-1.9-1.4-5.5-4.1-12.5-6.3-17.1-.2-.5-.3-1-.3-1.4 0-1.1.7-1.9 1.9-2.3.4-.2.8-.2 1.2-.2zm42.8-1c.9 0 1.8.4 2.4 1.3 7 9.5 10.7 18.4 10.7 31.3 0 12.9-3.7 22-10.6 31.5-.6.9-1.4 1.3-2.3 1.3-.6 0-1.3-.3-1.9-.7-.8-.5-1.4-1.4-1.4-2.3 0-.5.2-1.1.6-1.6 5.9-8.1 9.6-16.3 9.6-28.2 0-11.8-3.6-19.9-9.7-28.1-.4-.5-.6-1.1-.6-1.6 0-.9.5-1.7 1.4-2.3.5-.4 1.2-.6 1.8-.6z"
        })
    }),
    signature: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(1 1)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "m28.9 48.7-2.4-2.7-18.9 18.8h-7.5v-7.7l41.9-41.8c3.7-3.2 10-9 27.4-9 5.6 0 11.1 1.2 16.5 3.7 5.4 2.4 10.1 5.5 14.3 9.1l-21.6 21.4h-7.6v8.9c-3 3-6.5 5.2-10.4 6.6-4 1.4-7.9 2-11.7 2-11.7 0.1-18.9-7.9-20-9.3zm54.5-28.3c-2.2-1.1-4.4-1.9-6.6-2.6-2.2-0.6-4.7-1-7.4-1-4.7 0-9.1 1-13.2 2.9s-7.9 4.6-11.3 8l-10.6 10.7 2.6 2.9c1.1 1.3 2.9 2.6 5.6 4.1 2.7 1.4 5.3 2.2 7.8 2.2 1.8 0 3.6-0.3 5.3-0.8s3.3-1.3 4.9-2.4v-14.6h13.5l9.4-9.4z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "m97.7 63.2c-5.9-4.9-10.2 4.3-14.7 7.2-5.5 4.7-11.4 9.3-18.2 12.1 1.1-6.5 2.8-17.7-4.9-17.7-5.6 0-14.9 10.8-20.9 15.8 0.8-6.2-1.4-12.9-8.1-12.9-1.9 0-4.2 1-6.2 3.2-2.8 3.1-7.4 11.7-12 11.8-0.7 0-3.5-0.5-1.8-7.9 1.4-6.3-8-8.9-9.6-2.7-6.2 23.7 16.7 27.5 27.7 9 0.6 24.7 17.5 6.8 26.1-2.1-3.9 19.2 7.1 16.7 19.9 9.7 5.2-3.6 29.9-18.7 22.7-25.5z"
                })
            ]
        })
    }),
    "sort-down": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M58.1,74.2H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0 c0,1.8,1.4,3.2,3.2,3.2h12.9l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2l0,0C61.3,75.6,59.8,74.2,58.1,74.2L58.1,74.2z M29.8,75.8H21V8.1l0,0 c0-1.8-1.4-3.2-3.2-3.2h-3.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v67.7h-9l0,0c-1.3,0-2.4,1.1-2.4,2.4c0,0.6,0.2,1.2,0.7,1.7l13.7,14.5 l0,0c0.9,1,2.4,1,3.4,0.1l0.1-0.1l13.7-14.5l0,0c0.9-1,0.9-2.5-0.1-3.4C31,76,30.5,75.8,29.8,75.8L29.8,75.8z M83.9,35.5H45.2l0,0 c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2h38.7l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2l0,0C87.1,36.9,85.7,35.5,83.9,35.5 L83.9,35.5z M96.8,16.1H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2h51.6l0,0c1.8,0,3.2-1.4,3.2-3.2v-3.2 l0,0C100,17.6,98.6,16.1,96.8,16.1L96.8,16.1z M71,54.8H45.2l0,0c-1.8,0-3.2,1.4-3.2,3.2l0,0v3.2l0,0c0,1.8,1.4,3.2,3.2,3.2H71l0,0 c1.8,0,3.2-1.4,3.2-3.2V58l0,0C74.2,56.3,72.7,54.8,71,54.8L71,54.8z"
        })
    }),
    split: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M62.1 50l37.1-37.1c1-1 1-2.7 0-3.8-7.3-7.3-19.2-7.3-26.5 0L46.9 34.9l-5.5-5.5c1-2.4 1.5-5.1 1.5-7.9C42.9 9.6 33.3 0 21.4 0S0 9.6 0 21.4s9.6 21.4 21.4 21.4c1 0 2-.1 3-.2l7.4 7.4-7.4 7.4c-1-.1-2-.2-3-.2C9.6 57.1 0 66.7 0 78.6S9.6 100 21.4 100s21.4-9.6 21.4-21.4c0-2.8-.5-5.4-1.5-7.9l5.5-5.5L72.6 91c7.3 7.3 19.2 7.3 26.5 0 1-1 1-2.7 0-3.8L62.1 50zM21.4 28.6c-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1 7.1 3.2 7.1 7.1-3.1 7.1-7.1 7.1zm0 57.1c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1c.1 3.9-3.1 7.1-7.1 7.1z"
        })
    }),
    "step-forward": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 11 16",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11 .429V15.57a.422.422 0 0 1-.412.429h-1.65a.422.422 0 0 1-.413-.429v-6.3l-6.72 6.464c-.708.611-1.805.1-1.805-.878V1.143C0 .165 1.097-.347 1.805.265l6.72 6.424V.43c0-.236.186-.429.412-.429h1.65c.227 0 .413.193.413.429Z"
        })
    }),
    sun: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M49.8 23.8c-14.6 0-26.4 11.7-26.4 26.4s11.7 26.4 26.4 26.4 26.4-11.7 26.4-26.4-11.8-26.4-26.4-26.4zM50 16c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4s4 1.8 4 4v8c0 2.2-1.8 4-4 4zm-17 4.6c-1.9 1.1-4.4.4-5.5-1.5l-4-6.9c-1.1-1.9-.4-4.4 1.5-5.5 1.9-1.1 4.4-.4 5.5 1.5l4 6.9c1.1 1.9.4 4.4-1.5 5.5zM20.6 33c-1.1 1.9-3.6 2.6-5.5 1.5l-6.9-4c-1.9-1.1-2.6-3.6-1.5-5.5s3.6-2.6 5.5-1.5l6.9 4c1.9 1.1 2.6 3.6 1.5 5.5zM16 50c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4s1.8-4 4-4h8c2.2 0 4 1.8 4 4zm4.6 17c1.1 1.9.4 4.4-1.5 5.5l-6.9 4c-1.9 1.1-4.4.4-5.5-1.5-1.1-1.9-.4-4.4 1.5-5.5l6.9-4c1.9-1.1 4.4-.4 5.5 1.5zM33 79.4c1.9 1.1 2.6 3.6 1.5 5.5l-4 6.9c-1.1 1.9-3.6 2.6-5.5 1.5s-2.6-3.6-1.5-5.5l4-6.9c1.1-1.9 3.6-2.6 5.5-1.5zM50 84c2.2 0 4 1.8 4 4v8c0 2.2-1.8 4-4 4s-4-1.8-4-4v-8c0-2.2 1.8-4 4-4zm17-4.6c1.9-1.1 4.4-.4 5.5 1.5l4 6.9c1.1 1.9.4 4.4-1.5 5.5-1.9 1.1-4.4.4-5.5-1.5l-4-6.9c-1.1-1.9-.4-4.4 1.5-5.5zM79.4 67c1.1-1.9 3.6-2.6 5.5-1.5l6.9 4c1.9 1.1 2.6 3.6 1.5 5.5s-3.6 2.6-5.5 1.5l-6.9-4c-1.9-1.1-2.6-3.6-1.5-5.5zM84 50c0-2.2 1.8-4 4-4h8c2.2 0 4 1.8 4 4s-1.8 4-4 4h-8c-2.2 0-4-1.8-4-4zm-4.6-17c-1.1-1.9-.4-4.4 1.5-5.5l6.9-4c1.9-1.1 4.4-.4 5.5 1.5 1.1 1.9.4 4.4-1.5 5.5l-6.9 4c-1.9 1.1-4.4.4-5.5-1.5zM67 20.6c-1.9-1.1-2.6-3.6-1.5-5.5l4-6.9c1.1-1.9 3.6-2.6 5.5-1.5s2.6 3.6 1.5 5.5l-4 6.9c-1.1 1.9-3.6 2.6-5.5 1.5z"
        })
    }),
    surround: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M100 25V6.2c0-3.5-2.8-6.2-6.2-6.2H75c-3.5 0-6.2 2.8-6.2 6.2H31.2C31.2 2.8 28.5 0 25 0H6.2C2.8 0 0 2.8 0 6.2V25c0 3.5 2.8 6.2 6.2 6.2v37.5C2.8 68.8 0 71.5 0 75v18.8c0 3.5 2.8 6.2 6.2 6.2H25c3.5 0 6.2-2.8 6.2-6.2h37.5c0 3.5 2.8 6.2 6.2 6.2h18.8c3.5 0 6.2-2.8 6.2-6.2V75c0-3.5-2.8-6.2-6.2-6.2V31.2c3.5 0 6.3-2.7 6.3-6.2zM81.2 12.5h6.2v6.2h-6.2v-6.2zm-68.7 0h6.2v6.2h-6.2v-6.2zm6.3 75h-6.2v-6.2h6.2v6.2zm68.7 0h-6.2v-6.2h6.2v6.2zm-6.3-18.7H75c-3.5 0-6.2 2.8-6.2 6.2v6.2H31.2V75c0-3.5-2.8-6.2-6.2-6.2h-6.2V31.2H25c3.5 0 6.2-2.8 6.2-6.2v-6.2h37.5V25c0 3.5 2.8 6.2 6.2 6.2h6.2v37.6z"
        })
    }),
    "surround-outline": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M89.3,71.9V28.1c6.2-1.6,10.7-7.1,10.7-13.8C100,6.4,93.6,0,85.7,0  c-6.6,0-12.2,4.6-13.8,10.7H28.1C26.5,4.6,20.9,0,14.3,0C6.4,0,0,6.4,0,14.3c0,6.6,4.6,12.2,10.7,13.8v43.9C4.6,73.5,0,79.1,0,85.7  C0,93.6,6.4,100,14.3,100c6.6,0,12.2-4.6,13.8-10.7h43.9c1.6,6.2,7.1,10.7,13.8,10.7c7.9,0,14.3-6.4,14.3-14.3  C100,79.1,95.4,73.5,89.3,71.9z M71.9,82.1H28.1c-1.3-5-5.2-8.9-10.2-10.2V28.1c5-1.3,8.9-5.2,10.2-10.2h43.9  c1.3,5,5.2,8.9,10.2,10.2v43.9C77.1,73.2,73.2,77.1,71.9,82.1z M85.7,7.1c3.9,0,7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1  c-3.9,0-7.1-3.2-7.1-7.1S81.8,7.1,85.7,7.1z M7.1,14.3c0-3.9,3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1s-3.2,7.1-7.1,7.1S7.1,18.2,7.1,14.3z  M14.3,92.9c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1s7.1,3.2,7.1,7.1S18.2,92.9,14.3,92.9z M85.7,92.9c-3.9,0-7.1-3.2-7.1-7.1  s3.2-7.1,7.1-7.1c3.9,0,7.1,3.2,7.1,7.1S89.6,92.9,85.7,92.9z"
        })
    }),
    swagger: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M50,4.8C75,4.8,95.2,25,95.2,50S75,95.2,50,95.2  C25,95.2,4.8,75,4.8,50S25,4.8,50,4.8z M34.9,24.4c-0.6,0-1.2,0-1.8,0c-4.1,0.2-6.5,2.2-7.2,6.1c-0.5,2.8-0.4,5.6-0.6,8.4  c-0.1,1.5-0.2,2.9-0.5,4.3c-0.6,2.5-1.6,3.3-4.2,3.5c-0.3,0-0.7,0.1-1,0.2v6.1c4.7,0.2,5.3,1.9,5.7,6.8c0.1,1.8,0,3.6,0.1,5.4  c0.1,1.7,0.3,3.4,0.6,5c1.1,4.5,5.5,6,10.7,5.1v-5.4c-0.9,0-1.6,0-2.3,0c-1.8-0.1-2.5-0.5-2.6-2.2c-0.2-2.2-0.2-4.5-0.3-6.7  c-0.3-4.2-0.7-8.3-4.8-10.9c2.1-1.5,3.6-3.4,4.1-5.8c0.3-1.7,0.6-3.4,0.7-5.2c0.1-1.7-0.1-3.5,0.1-5.2c0.2-2.8,0.4-3.9,3.7-3.8  c0.5,0,1-0.1,1.5-0.1v-5.5C36.1,24.5,35.5,24.5,34.9,24.4z M66.5,24.5c-1.1,0-2.3,0-3.4,0.2V30c1,0,1.8,0,2.6,0  c1.4,0,2.4,0.6,2.5,2.1c0.1,1.4,0.1,2.8,0.3,4.2c0.3,2.8,0.4,5.6,0.9,8.4c0.4,2.3,2,4,3.9,5.4c-3.4,2.3-4.4,5.5-4.6,9.2  c-0.1,2.5-0.2,5-0.3,7.6c-0.1,2.3-0.9,3.1-3.3,3.1c-0.7,0-1.3,0.1-2,0.1v5.4c1.3,0,2.6,0.1,3.9,0c3.9-0.2,6.2-2.1,7-5.9  c0.3-2.1,0.5-4.2,0.6-6.3c0.1-1.9,0.1-3.9,0.3-5.8c0.3-3,1.7-4.2,4.6-4.4c0.3,0,0.6-0.1,0.8-0.2v-6.1c-0.5-0.1-0.8-0.1-1.2-0.1  c-2.2-0.1-3.3-0.9-3.9-3c-0.3-1.4-0.6-2.7-0.6-4.1c-0.2-2.6-0.1-5.2-0.3-7.7C74,27,71.1,24.6,66.5,24.5L66.5,24.5z M37.8,46.5  c-4.5,0-4.8,6.6-0.4,7h0.2c1.9,0.1,3.5-1.3,3.6-3.2v-0.2C41.4,48.1,39.8,46.5,37.8,46.5L37.8,46.5z M49.9,46.5  c-1.9-0.1-3.4,1.4-3.5,3.3c0,0.1,0,0.2,0,0.3c0,2.1,1.4,3.4,3.6,3.4c2.1,0,3.5-1.4,3.5-3.5C53.5,47.9,52.1,46.5,49.9,46.5L49.9,46.5  z M62.3,46.5c-2,0-3.6,1.5-3.6,3.5c0,2,1.6,3.5,3.5,3.5h0c1.8,0.3,3.5-1.4,3.7-3.4C66,48.2,64.2,46.5,62.3,46.5L62.3,46.5z"
        })
    }),
    text: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 102 102",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(1 1)",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M25.4,90.3V23.4H0V9.7h64.5v13.7H39.1v66.9H25.4z M70.6,90.3V49.2H54.8V35.5H100v13.7H84.3v41.2H70.6z"
            })
        })
    }),
    "thumbs-down": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M3.5 2.3h15c2 0 3.5 1.9 3.5 3.8v45.3c0 1.9-1.6 3.8-3.5 3.8h-15c-2 0-3.5-1.9-3.5-3.8V6.1c0-1.9 1.6-3.8 3.5-3.8zM100 57.6v-1.5c0-3.8-3.2-6.8-7-6.8h-2.5c3.6-.3 6.5-3.5 6.5-7.2v-1.5c0-3.8-3.2-7.3-7-7.3h-3c3.9 0 7-2.9 7-6.7v-1.5c0-3.8-3.2-6.8-7-6.8h-3c3.9 0 7-3.4 7-7.2V9.6c0-3.8-3.2-7.3-7-7.3H40.2c-6.1 0-12.1 6.2-12.1 12.3v38c0 3.9 20.5 40 20.5 40 2.1 4.6 7.6 6.7 12.2 4.6l1.2-.5c4.6-2.1 7.3-7.7 6-12.6l-5.4-19.7H93c3.8-.1 7-3 7-6.8z"
        })
    }),
    "thumbs-up": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M0 94.2V48.8C0 46.9 1.6 45 3.5 45h15c2 0 3.5 1.9 3.5 3.8v45.3c0 1.9-1.6 3.8-3.5 3.8h-15C1.6 98 0 96.1 0 94.2zM93 36H62.7L68 16.3c1.3-4.9-1.4-10.6-6-12.6l-1.2-.5c-4.6-2.1-10.1 0-12.2 4.6 0 0-20.5 36.1-20.5 40v38c0 6.1 5.9 12.3 12.1 12.3h43.7c3.9 0 7-3.4 7-7.3v-1.5c0-3.8-3.2-7.2-7-7.2h3c3.9 0 7-2.9 7-6.8v-1.5c0-3.8-3.2-6.7-7-6.7h3c3.9 0 7-3.4 7-7.3v-1.5c0-3.7-2.9-6.9-6.5-7.2H93c3.9 0 7-2.9 7-6.8v-1.5c0-3.9-3.2-6.8-7-6.8z"
        })
    }),
    time: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m31.5 33.25 1.7-1.7-7.95-8v-10.05h-2.25v10.95zm-7.5 9.75q-3.9 0-7.375-1.5t-6.05-4.075-4.075-6.05-1.5-7.375 1.5-7.375 4.075-6.05 6.05-4.075 7.375-1.5 7.375 1.5 6.05 4.075 4.075 6.05 1.5 7.375-1.5 7.375-4.075 6.05-6.05 4.075-7.375 1.5zm0-19zm0 16.75q6.9 0 11.825-4.925t4.925-11.825-4.925-11.825-11.825-4.925-11.825 4.925-4.925 11.825 4.925 11.825 11.825 4.925z"
        })
    }),
    trash: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M98 27c0-4.4-3.6-10-8-10H75.8L68.7 5.7C66.5 2.1 62.6 0 58.5 0h-17c-4.2 0-8 2.1-10.3 5.7l-7 11.3H10c-4.4 0-8 5.6-8 10 0 1.1.9 2 2 2h9v63c0 4.4 3.6 8 8 8h58c4.4 0 8-3.6 8-8V29h9c1.1 0 2-.9 2-2zM39.8 11c.4-.6 1.1-1 1.8-1h16.9c.7 0 1.4.4 1.8 1l3.8 6H36l3.8-6zM33 86h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3zm18 0h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3zm18 0h-2c-1.7 0-3-1.4-3-3V35c0-1.7 1.4-3 3-3h2c1.7 0 3 1.4 3 3v48c0 1.6-1.4 3-3 3z"
        })
    }),
    unlock: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M79 46.2V29.6C79 13.6 65.9 0 50 0 37.1 0 26.3 8.4 22.5 19.9c-.8 2.3.6 4.8 3 5.3l5.8 1.2c1.9.4 3.9-.6 4.6-2.5C38 18.4 43 14.3 49.1 14c8.8-.4 15.9 6.5 15.9 15v17H23c-6.6 0-12 5.4-12 12v30c0 6.6 5.4 12 12 12h54c6.6 0 12-5.4 12-12V58c0-5.9-4.3-10.9-10-11.8zM50 85c-4.4 0-8-3.6-8-8v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 4.4-3.6 8-8 8z"
        })
    }),
    upload: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M56.2 26.6V0h-39c-2.6 0-4.7 2.1-4.7 4.7v90.6c0 2.6 2.1 4.7 4.7 4.7h65.6c2.6 0 4.7-2.1 4.7-4.7V31.2H60.9c-2.5 0-4.7-2.1-4.7-4.6zm15 36.9c2 1.9.6 5.3-2.2 5.3H56.1v15.6c0 1.7-1.4 3.1-3.1 3.1h-6.2c-1.7 0-3.1-1.4-3.1-3.1V68.8H31c-2.8 0-4.2-3.3-2.2-5.3l18.8-18.7c1.3-1.3 3.4-1.3 4.7 0l18.9 18.7zm14.9-43L67 1.4C66.1.5 64.9 0 63.7 0h-1.2v25h25v-1.2c0-1.2-.5-2.4-1.4-3.3z"
        })
    }),
    url: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 50 50",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m22 33.1h-8q-3.85 0-6.475-2.625t-2.625-6.475 2.625-6.475 6.475-2.625h8v2.3h-8q-2.9 0-4.85 1.95t-1.95 4.85 1.95 4.85 4.85 1.95h8zm-5.3-7.95v-2.3h14.65v2.3zm9.3 7.95v-2.3h8q2.9 0 4.85-1.95t1.95-4.85-1.95-4.85-4.85-1.95h-8v-2.3h8q3.85 0 6.475 2.625t2.625 6.475-2.625 6.475-6.475 2.625z"
        })
    }),
    user: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M50 10c9.9 0 18 8.1 18 18s-8.1 18-18 18-18-8.1-18-18 8.1-18 18-18m0-10C34.5 0 22 12.5 22 28s12.5 28 28 28 28-12.5 28-28S65.5 0 50 0zm0 70c12.6 0 23.4 4.8 31.2 13.8.5.6.8 1.4.8 2.3V90H18v-3.8c0-.9.4-1.9 1-2.6C26.9 74.7 37.6 70 50 70m0-10c-15.6 0-29 6.2-38.5 16.9C9.3 79.5 8 82.7 8 86.2v7.2c0 3.7 3 6.7 6.7 6.7h70.6c3.7 0 6.7-3 6.7-6.7v-7.2c0-3.2-1.1-6.4-3.2-8.9C79.3 66.4 65.8 60 50 60z"
        })
    }),
    wand: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M87.7 25.3L85 22.6c-1.4-1.4-3.2-2-4.9-2-1.8 0-3.6.7-4.9 2L12.3 85.4c-2.7 2.7-2.7 7.2 0 9.9L15 98c1.4 1.4 3.2 2 4.9 2 1.8 0 3.6-.7 4.9-2l62.8-62.8c2.8-2.8 2.8-7.2.1-9.9zm-3.5 6.3L65.5 50.3 60 44.8l18.7-18.7c.5-.5 1.1-.6 1.4-.6.3 0 .9.1 1.4.6l2.7 2.7c.5.5.6 1.1.6 1.4s-.1.9-.6 1.4zM30.6 7.1l2.8 11.3c.2.6.6 1.1 1.2 1.2l11.3 2.8c1.7.4 1.7 2.9 0 3.3l-11.3 2.8c-.6.2-1.1.6-1.2 1.2L30.6 41c-.4 1.7-2.9 1.7-3.3 0l-2.8-11.3c-.2-.6-.6-1.1-1.2-1.2L12 25.7c-1.7-.4-1.7-2.9 0-3.3l11.3-2.8c.6-.2 1.1-.6 1.2-1.2l2.8-11.3c.4-1.7 2.9-1.7 3.3 0zm29.1-5.7l.9 3.5c.2.7.7 1.2 1.4 1.4l3.5.9c1.9.5 1.9 3.2 0 3.7l-3.5.9c-.7.2-1.2.7-1.4 1.4l-.9 3.5c-.5 1.9-3.2 1.9-3.7 0l-.9-3.5c-.2-.7-.7-1.2-1.4-1.4l-3.5-.9c-1.9-.5-1.9-3.2 0-3.7l3.5-.9c.7-.2 1.2-.7 1.4-1.4l.9-3.5c.4-1.9 3.2-1.9 3.7 0z"
        })
    }),
    warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M83.9 95.3H16.1c-6.8 0-12-2.4-14.5-6.8s-2-10 1.4-16l33.9-58.7C40.3 7.9 45 4.6 50 4.6s9.7 3.3 13.1 9.2L97 72.6c3.4 5.9 3.9 11.6 1.4 16-2.5 4.3-7.7 6.7-14.5 6.7zm-27-19.7c0-3.5-2.9-6.4-6.4-6.4s-6.4 2.9-6.4 6.4c0 3.5 2.9 6.4 6.4 6.4s6.4-2.8 6.4-6.4zm.2-40.4c0-3.6-2.9-6.6-6.6-6.6s-6.5 3-6.5 6.6l1.5 23.3c.2 2.6 2.4 4.6 5 4.6 5 0 5-4.6 5-4.6l1.6-23.3z"
        })
    }),
    "warning-stroke": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        viewBox: "0 0 100 100",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFFFFF",
                d: "M50,4.7c-6,0-11.6,3.8-15.4,10.4L3.8,68.5C0,75.2-0.5,81.8,2.5,87c3,5.3,8.9,8.2,16.7,8.2h61.7 c7.6,0,13.7-2.9,16.6-8.1c3-5.3,2.6-11.9-1.3-18.6L65.4,15.1C61.6,8.5,56,4.7,50,4.7L50,4.7z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFCA28",
                d: "M80.8,91.2H19.2C13,91.2,8.3,89,6,85s-1.8-9.1,1.3-14.6L38.1,17c3.1-5.4,7.4-8.4,11.9-8.4 s8.8,3,11.9,8.4l30.8,53.5c3.1,5.4,3.5,10.6,1.3,14.6C91.7,89,87,91.2,80.8,91.2z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#000",
                d: "M56.3,73.3c0-3.2-2.6-5.8-5.8-5.8s-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8S56.3,76.6,56.3,73.3z M56.5,36.5 c0-3.3-2.6-6-6-6s-5.9,2.7-5.9,6L46,57.7l0,0c0.2,2.4,2.2,4.2,4.5,4.2c4.5,0,4.5-4.2,4.5-4.2L56.5,36.5z"
            })
        ]
    }),
    workflows: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M99 74c0 7.7-6.3 14-14 14s-14-6.3-14-14c0-1.1.1-2.2.4-3.2L50 58.6 28.6 70.8c.2 1 .4 2.1.4 3.2 0 7.7-6.3 14-14 14S1 81.7 1 74s6.3-14 14-14c3.7 0 7.1 1.5 9.6 3.9L46 51.7V27.4c-5.8-1.7-10-7.1-10-13.4 0-7.7 6.3-14 14-14s14 6.3 14 14c0 6.3-4.2 11.7-10 13.4v24.3l21.4 12.2c2.5-2.4 5.9-3.9 9.6-3.9 7.7 0 14 6.3 14 14zM14.1 51.9c.7-11.7 6.9-22 16.2-28-1.5-3-2.3-6.3-2.3-9.9v-.4C13.7 21.4 4 36.6 4 54v.8c3-1.7 6.4-2.7 10.1-2.9zm58-37.9c0 3.6-.8 6.9-2.3 9.9 9.3 6.1 15.5 16.3 16.2 28 3.6.2 7.1 1.2 10 2.9V54c0-17.4-9.7-32.6-23.9-40.4v.4zm-5.6 72C61.6 88.5 56 90 50 90s-11.5-1.4-16.5-4c-1.9 3-4.5 5.4-7.6 7.2 7 4.3 15.3 6.8 24.1 6.8s17.1-2.5 24.1-6.8C71 91.4 68.4 89 66.5 86z"
        })
    }),
    "x-close": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M60 50l37.9-37.9c2.7-2.7 2.7-7.2 0-10s-7.2-2.7-10 0L50 40 12.1 2.1c-2.7-2.7-7.2-2.7-10 0s-2.7 7.2 0 10L40 50 2.1 87.9c-2.7 2.7-2.7 7.2 0 10s7.2 2.7 10 0L50 60l37.9 37.9c2.7 2.7 7.2 2.7 10 0s2.7-7.2 0-10L60 50z"
        })
    }),
    "zoom-in": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M60.9,38.3V43c0,1.3-1.1,2.3-2.3,2.3H45.3v13.3c0,1.3-1.1,2.3-2.3,2.3h-4.7  c-1.3,0-2.3-1.1-2.3-2.3V45.3H22.7c-1.3,0-2.3-1.1-2.3-2.3v-4.7c0-1.3,1.1-2.3,2.3-2.3H36V22.7c0-1.3,1.1-2.3,2.3-2.3H43  c1.3,0,2.3,1.1,2.3,2.3V36h13.3C59.9,35.9,60.9,37,60.9,38.3z M99.3,94.9l-4.4,4.4c-0.9,0.9-2.4,0.9-3.3,0L67.9,75.6  c-0.4-0.4-0.7-1-0.7-1.7v-2.6c-7.1,6.2-16.4,9.9-26.6,9.9C18.2,81.2,0,63.1,0,40.6S18.2,0,40.6,0s40.6,18.2,40.6,40.6  c0,10.2-3.7,19.4-9.9,26.6h2.6c0.6,0,1.2,0.3,1.7,0.7l23.7,23.7C100.2,92.5,100.2,94,99.3,94.9L99.3,94.9z M71.9,40.6  c0-17.3-14-31.2-31.2-31.2S9.4,23.4,9.4,40.6s14,31.2,31.2,31.2S71.9,57.9,71.9,40.6z"
        })
    }),
    "zoom-out": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        viewBox: "0 0 100 100",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M60.9,38.3V43c0,1.3-1.1,2.3-2.3,2.3H22.7c-1.3,0-2.3-1.1-2.3-2.3v-4.7  c0-1.3,1.1-2.3,2.3-2.3h35.9C59.9,35.9,60.9,37,60.9,38.3z M99.3,94.9l-4.4,4.4c-0.9,0.9-2.4,0.9-3.3,0L67.9,75.6  c-0.4-0.4-0.7-1-0.7-1.7v-2.6c-7.1,6.2-16.4,9.9-26.6,9.9C18.2,81.2,0,63.1,0,40.6S18.2,0,40.6,0s40.6,18.2,40.6,40.6  c0,10.2-3.7,19.4-9.9,26.6h2.6c0.6,0,1.2,0.3,1.7,0.7l23.7,23.7C100.2,92.5,100.2,94,99.3,94.9L99.3,94.9z M71.9,40.6  c0-17.3-14-31.2-31.2-31.2S9.4,23.4,9.4,40.6s14,31.2,31.2,31.2S71.9,57.9,71.9,40.6z"
        })
    }),
    "local-type-none": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04088 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26707 15.732C4.73998 14.2053 0.640625 10.1069 0.640625 6.54315ZM9.89062 7.13333C9.73677 7.25894 9.5271 7.33083 9.30729 7.33333H4.30729C4.08628 7.33333 3.87432 7.2631 3.71804 7.13807C3.56176 7.01305 3.47396 6.84348 3.47396 6.66667C3.4841 6.49247 3.57516 6.32758 3.72929 6.20427C3.88343 6.08096 4.08955 6.00812 4.30729 6H9.30729C9.52831 6 9.74027 6.07024 9.89655 6.19526C10.0528 6.32029 10.1406 6.48986 10.1406 6.66667C10.1375 6.84251 10.0476 7.01025 9.89062 7.13333Z",
            fill: "white",
            fillOpacity: "0.7"
        })
    }),
    "local-type-approx": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04088 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26707 15.732C4.73998 14.2053 0.640625 10.1069 0.640625 6.54315ZM4.21176 6.64367L4.21197 6.64328L4.21294 6.64156C4.21479 6.63828 4.2185 6.6318 4.22397 6.62258C4.23498 6.60407 4.25285 6.57504 4.27699 6.53904C4.3261 6.46579 4.39676 6.37026 4.48363 6.27741C4.6781 6.06954 4.84978 5.98333 4.97396 5.98333C5.52117 5.98333 5.90263 6.18124 6.51434 6.79295C7.24533 7.52394 7.9759 7.98333 9.011 7.98333C9.68723 7.98333 10.1743 7.56452 10.441 7.26777C10.5838 7.10879 10.6927 6.95269 10.7657 6.83738C10.8027 6.77907 10.8315 6.72947 10.8519 6.69286C10.8622 6.67451 10.8703 6.6593 10.8764 6.64774L10.884 6.63317L10.8866 6.62803L10.8877 6.62602L10.8881 6.62516L10.8883 6.62476C10.8884 6.62457 10.8885 6.62439 10.3073 6.33333L10.8885 6.62439C11.0492 6.3034 10.9193 5.91288 10.5983 5.75214C10.2783 5.59185 9.88905 5.72056 9.72747 6.03956L9.7272 6.04008L9.72651 6.04139C9.72488 6.04448 9.72153 6.05075 9.71651 6.05975C9.70643 6.07782 9.68994 6.10635 9.66749 6.14179C9.62176 6.21398 9.55575 6.30788 9.47397 6.3989C9.29135 6.60214 9.13027 6.68333 9.011 6.68333C8.45507 6.68333 8.03593 6.47606 7.43358 5.87371C6.71196 5.15209 6.01777 4.68333 4.97396 4.68333C4.30263 4.68333 3.80763 5.09712 3.53432 5.38926C3.38729 5.54641 3.27378 5.70088 3.19719 5.81513C3.15848 5.87288 3.12811 5.92197 3.1066 5.95815C3.09582 5.97628 3.08719 5.99128 3.08078 6.00264L3.07281 6.01693L3.07007 6.02194L3.06901 6.02388L3.06856 6.02472L3.06836 6.0251C3.06826 6.02528 3.06817 6.02545 3.64048 6.33325L3.06817 6.02545C2.89813 6.34161 3.01658 6.73575 3.33274 6.90579C3.64808 7.07539 4.04098 6.95799 4.21174 6.64369L4.21176 6.64367ZM9.72651 6.04139L9.72644 6.0416L9.72673 6.04101L9.72651 6.04139ZM10.3073 6.33333C9.7261 6.04228 9.72618 6.0421 9.72627 6.04193L9.7261 6.04228L10.3073 6.33333Z",
            fill: "white",
            fillOpacity: "0.7"
        })
    }),
    "local-type-exact": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "16",
        viewBox: "0 0 13 16",
        fill: "none",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.640625 6.54315C0.640625 2.94442 3.22154 0 6.82027 0C10.419 0 12.9999 2.87172 12.9999 6.54315C12.9999 10.1161 9.04087 14.0677 7.45482 15.6508C7.41109 15.6944 7.36917 15.7363 7.32918 15.7763C7.26448 15.8468 7.18584 15.9031 7.09823 15.9416C7.01062 15.9801 6.91597 16 6.82027 16C6.72457 16 6.62992 15.9801 6.54231 15.9416C6.4547 15.9031 6.37606 15.8468 6.31136 15.7763L6.26708 15.732C4.73999 14.2053 0.640625 10.1069 0.640625 6.54315ZM5.52329 8.47982C5.63189 8.58842 5.76764 8.64272 5.90339 8.64272C6.03914 8.64272 6.17489 8.58842 6.28349 8.47982L9.92159 4.81457C10.1388 4.62452 10.1388 4.29872 9.92159 4.08152C9.73154 3.86432 9.40574 3.86432 9.18854 4.08152L5.87624 7.36667L4.43729 5.92772C4.24724 5.71052 3.92144 5.71052 3.70424 5.92772C3.48704 6.11777 3.48704 6.44357 3.70424 6.66077L5.52329 8.47982Z",
            fill: "white",
            fillOpacity: "0.7"
        })
    })
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5MAF6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partnerIcons", function() {
    return partnerIcons;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var partnerIcons = {
    base64ai: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        version: "1.1",
        id: "Base64.ai",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 40",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            id: "logo",
            fill: "#0F97FF",
            d: "M52.4,34.8V3.9h13.4c5.8,0,9.4,3,9.4,7.7c0,3.4-2.5,6.2-5.8,6.7v0.2c4.2,0.3,7.3,3.4,7.3,7.5 c0,5.4-4.1,8.8-10.7,8.8H52.4z M58.8,16.8h4.6c3.4,0,5.4-1.5,5.4-4.1c0-2.5-1.7-3.9-4.7-3.9h-5.3V16.8z M64.4,30 c3.7,0,5.7-1.6,5.7-4.5c0-2.9-2.1-4.4-5.9-4.4h-5.4v9H64.4z M79,28.2c0-4.2,3.2-6.6,8.9-6.9l5.8-0.3v-1.5c0-2.1-1.5-3.4-3.9-3.4 c-2.3,0-3.8,1.2-4.1,2.8H80c0.2-4.4,4-7.5,10.1-7.5c5.9,0,9.7,3,9.7,7.7v15.8h-6v-3.5h-0.1c-1.3,2.4-4.1,3.9-7,3.9 C82.3,35.2,79,32.3,79,28.2z M93.7,26.4v-1.7L88.8,25c-2.3,0.2-3.7,1.2-3.7,2.8c0,1.7,1.4,2.8,3.5,2.8 C91.4,30.6,93.7,28.9,93.7,26.4z M113.1,11.4c5.8,0,9.5,2.9,9.6,7.4h-5.8c-0.1-1.8-1.6-3-3.9-3c-2.2,0-3.6,1-3.6,2.5 c0,1.1,1,1.9,3,2.4l4.4,0.9c4.6,1,6.5,2.8,6.5,6.3c0,4.5-4.1,7.5-10.2,7.5c-6.1,0-9.9-3-10.2-7.4h6.1c0.3,1.9,1.8,3,4.3,3 c2.4,0,3.8-0.9,3.8-2.4c0-1.2-0.8-1.8-2.8-2.3l-4.2-0.9c-4.3-1-6.6-3.3-6.6-6.6C103.4,14.2,107.2,11.4,113.1,11.4z M147.3,27.8 c-0.7,4.5-4.8,7.5-10.5,7.5c-7.1,0-11.3-4.5-11.3-11.9c0-7.3,4.3-12.1,11.1-12.1c6.7,0,10.9,4.5,10.9,11.5v1.9h-15.8v0.4 c0,3.3,2.1,5.5,5.3,5.5c2.3,0,4-1.1,4.6-2.9H147.3z M131.8,20.9h9.7c-0.1-2.9-2-4.9-4.8-4.9C133.9,16,132,18.1,131.8,20.9z M153.1,29.8c-1.7-2.6-2.6-6.1-2.6-10.2c0-10.2,5-16.4,12.9-16.4c5.9,0,10.5,3.5,11.3,8.5h-6.4c-0.6-2.1-2.6-3.4-5-3.4 c-4.3,0-6.9,4.1-6.8,11.1h0.1c1.2-3,4.3-5,8.2-5c5.9,0,10.2,4.3,10.2,10.2c0,6.4-4.9,10.9-11.9,10.9 C158.9,35.5,155.2,33.5,153.1,29.8z M168.9,24.8c0-3.2-2.4-5.5-5.6-5.5c-3.2,0-5.6,2.3-5.6,5.5c0,3.1,2.5,5.6,5.6,5.6 C166.4,30.3,168.9,27.9,168.9,24.8z M193.8,29.3h-15.4v-5.5c2.7-5.1,6.1-10.5,12.4-19.9h9.1v20.2h4v5.2h-4v5.5h-6.1V29.3z M184.1,24.3h9.8V8.5h-0.1c-4.5,6.6-7.2,10.8-9.7,15.6V24.3z M207.9,31.6c0-1.9,1.5-3.4,3.4-3.4c1.9,0,3.4,1.5,3.4,3.4 c0,1.9-1.5,3.4-3.4,3.4C209.4,35.1,207.9,33.5,207.9,31.6z M218.6,28.2c0-4.2,3.2-6.6,8.9-6.9l5.8-0.3v-1.5c0-2.1-1.5-3.4-3.9-3.4 c-2.3,0-3.8,1.2-4.1,2.8h-5.7c0.2-4.4,4-7.5,10.1-7.5c5.9,0,9.7,3,9.7,7.7v15.8h-6v-3.5h-0.1c-1.3,2.4-4.1,3.9-7,3.9 C221.9,35.2,218.6,32.3,218.6,28.2z M233.3,26.4v-1.7l-4.8,0.3c-2.3,0.2-3.7,1.2-3.7,2.8c0,1.7,1.4,2.8,3.5,2.8 C231,30.6,233.3,28.9,233.3,26.4z M243.3,6.1c0-1.8,1.5-3.2,3.3-3.2c1.9,0,3.3,1.4,3.3,3.2c0,1.8-1.5,3.2-3.3,3.2 C244.8,9.3,243.3,7.9,243.3,6.1z M243.5,11.9h6.2v22.9h-6.2V11.9z M19.3,13.8c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2 s6.2-2.8,6.2-6.2S22.8,13.8,19.3,13.8z M38.6,20c0,10.7-8.7,19.3-19.3,19.3S0,30.7,0,20S8.7,0.7,19.3,0.7S38.6,9.3,38.6,20z M19.3,8.2C12.8,8.2,7.5,13.5,7.5,20s5.3,11.8,11.8,11.8S31.1,26.5,31.1,20S25.8,8.2,19.3,8.2z"
        })
    }),
    "openai-logo": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        role: "img",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073zM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494zM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855l-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023l-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.5 4.5 0 0 1 6.68 4.66zm-12.64 4.135l-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681zm1.097-2.365l2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z"
        })
    }),
    "huggingface-logo": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        version: "1.1",
        viewBox: "0 0 250 44",
        xmlSpace: "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFFFFF",
                d: "m61.4 10.3h5v8.5h7.7v-8.5h5v22.2h-5v-9.3h-7.7v9.3h-5v-22.2zm21.7 5.3h5v9.8c0 1.2 0.2 2.1 0.5 2.5s0.9 0.7 1.6 0.7c0.6 0 1.2-0.1 1.6-0.4s0.9-0.8 1.4-1.4v-11.2h5v16.9h-4.1l-0.4-2.3h-0.1c-0.7 0.9-1.5 1.5-2.3 2s-1.8 0.7-3 0.7c-1.8 0-3.2-0.6-4-1.8s-1.2-2.9-1.2-5v-10.5zm17.8 19.8c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4-0.4 0.7-1.1 1.4-1.9 1.9s-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.6-0.6-0.7-1.3-0.7-2zm4.1-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.7-0.7 0.4-0.5 0.7-1.2 0.7-2.1s-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.7-0.7s-1.2 0.2-1.7 0.7c-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1.1 0.7 1.7 0.7zm10.1 11.3c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4s-1.1 1.4-1.9 1.9-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.6-0.6-0.7-1.3-0.7-2zm4.1-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.6-0.7s0.7-1.2 0.7-2.1-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.6-0.7-0.7 0-1.2 0.2-1.7 0.7-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1 0.7 1.7 0.7zm13.6-11c-0.8 0-1.5-0.2-2.1-0.7-0.5-0.5-0.8-1.1-0.8-1.9s0.3-1.4 0.8-1.9 1.2-0.7 2.1-0.7 1.6 0.2 2.1 0.7 0.8 1.1 0.8 1.9-0.3 1.4-0.8 1.9c-0.6 0.5-1.2 0.7-2.1 0.7zm-2.5 2.5h5v16.9h-5v-16.9zm8.7 0h4.1l0.3 2.1h0.1c0.7-0.7 1.5-1.3 2.4-1.8s1.9-0.8 3-0.8c1.8 0 3.2 0.6 4 1.8s1.2 2.9 1.2 5v10.5h-5v-9.8c0-1.2-0.2-2.1-0.5-2.5-0.3-0.5-0.9-0.7-1.6-0.7-0.6 0-1.2 0.1-1.6 0.4-0.5 0.3-1 0.7-1.5 1.2v11.4h-5v-16.8zm17.7 19.8c0-1.4 0.8-2.5 2.4-3.4v-0.1c-0.5-0.3-0.8-0.7-1.1-1.1-0.3-0.5-0.4-1-0.4-1.7 0-0.6 0.2-1.2 0.5-1.8 0.4-0.6 0.8-1 1.4-1.4v-0.1c-0.6-0.4-1.1-1-1.6-1.8s-0.7-1.6-0.7-2.6 0.2-1.9 0.6-2.7 0.9-1.4 1.5-1.9 1.4-0.9 2.2-1.1 1.7-0.4 2.6-0.4c1 0 1.9 0.1 2.6 0.4h6.2v3.6h-2.7c0.2 0.2 0.3 0.6 0.4 1s0.2 0.8 0.2 1.3c0 1-0.2 1.8-0.5 2.5s-0.8 1.3-1.4 1.8-1.3 0.8-2.1 1-1.7 0.3-2.6 0.3c-0.7 0-1.3-0.1-2-0.3l-0.5 0.5c-0.1 0.2-0.1 0.4-0.1 0.7 0 0.4 0.2 0.8 0.6 1s1 0.3 2 0.3h2.7c2.1 0 3.7 0.3 4.8 1s1.7 1.8 1.7 3.3c0 0.9-0.2 1.7-0.7 2.4-0.4 0.7-1.1 1.4-1.9 1.9s-1.8 1-3 1.3-2.5 0.5-3.9 0.5c-1 0-1.9-0.1-2.8-0.3s-1.6-0.4-2.2-0.8c-0.6-0.3-1.2-0.8-1.5-1.3-0.5-0.6-0.7-1.3-0.7-2zm4.2-0.8c0 0.6 0.3 1.1 1 1.4s1.6 0.5 2.7 0.5 2.1-0.2 2.8-0.6 1.1-0.9 1.1-1.5c0-0.5-0.2-0.9-0.7-1.1-0.4-0.2-1.1-0.3-1.9-0.3h-1.7c-0.6 0-1.1 0-1.4-0.1-0.4 0-0.7-0.1-1-0.2-0.6 0.8-0.9 1.3-0.9 1.9zm3.3-10.5c0.7 0 1.2-0.2 1.6-0.7s0.7-1.2 0.7-2.1-0.2-1.6-0.7-2c-0.4-0.5-1-0.7-1.6-0.7-0.7 0-1.2 0.2-1.7 0.7-0.4 0.5-0.7 1.1-0.7 2 0 1 0.2 1.7 0.7 2.1 0.5 0.5 1 0.7 1.7 0.7zm17.9-13.8h14v4.2h-9v5.1h7.7v4.2h-7.7v8.6h-5v-22.1zm14.8 17.5c0-1.8 0.8-3.2 2.2-4.2 1.5-1 3.9-1.7 7.2-2 0-0.7-0.3-1.3-0.7-1.8-0.4-0.4-1.1-0.7-2-0.7-0.7 0-1.5 0.1-2.2 0.4s-1.5 0.6-2.3 1.1l-1.8-3.3c1.1-0.7 2.2-1.2 3.4-1.6s2.5-0.6 3.8-0.6c2.2 0 3.8 0.6 5 1.9 1.1 1.2 1.7 3.2 1.7 5.8v9.7h-3.8l-0.4-1.7h-0.1c-0.7 0.6-1.5 1.2-2.3 1.5-0.8 0.4-1.7 0.6-2.6 0.6-0.8 0-1.5-0.1-2.1-0.4s-1.1-0.6-1.6-1.1c-0.4-0.5-0.8-1-1-1.6s-0.4-1.3-0.4-2zm4.8-0.4c0 0.5 0.2 0.9 0.5 1.2s0.8 0.4 1.4 0.4 1.1-0.1 1.5-0.4c0.4-0.2 0.8-0.6 1.3-1.1v-3c-1.8 0.2-3 0.6-3.7 1.1-0.6 0.6-1 1.2-1 1.8zm12.4-3.4c0-1.4 0.2-2.7 0.7-3.8s1.1-2 1.9-2.8c0.8-0.7 1.7-1.3 2.8-1.7s2.2-0.6 3.3-0.6c1 0 2 0.2 2.8 0.5 0.8 0.4 1.5 0.8 2.1 1.4l-2.3 3.1c-0.8-0.7-1.6-1-2.3-1-1.2 0-2.2 0.4-2.9 1.3s-1.1 2-1.1 3.5 0.4 2.6 1.1 3.5 1.6 1.3 2.7 1.3c0.6 0 1.2-0.1 1.7-0.4 0.5-0.2 1-0.5 1.4-0.9l2 3.2c-0.8 0.7-1.7 1.3-2.7 1.6s-2 0.5-2.9 0.5c-1.2 0-2.3-0.2-3.3-0.6s-1.9-1-2.6-1.7-1.3-1.7-1.8-2.8-0.6-2.2-0.6-3.6zm14.2 0c0-1.4 0.2-2.6 0.7-3.7s1-2 1.8-2.8c0.7-0.8 1.6-1.3 2.5-1.8 1-0.4 1.9-0.6 3-0.6 1.2 0 2.3 0.2 3.1 0.6 0.9 0.4 1.6 1 2.2 1.7s1 1.6 1.3 2.6 0.4 2.1 0.4 3.2c0 0.5 0 0.9-0.1 1.2 0 0.4-0.1 0.7-0.1 0.9h-10.1c0.2 1.3 0.7 2.2 1.5 2.8s1.7 0.9 2.9 0.9 2.4-0.4 3.6-1.1l1.7 3c-0.9 0.6-1.8 1.1-2.9 1.4s-2.1 0.5-3.1 0.5c-1.2 0-2.3-0.2-3.4-0.6-1-0.4-2-1-2.7-1.7-0.8-0.8-1.4-1.7-1.8-2.8s-0.5-2.3-0.5-3.7zm10.9-1.7c0-1-0.2-1.8-0.6-2.4s-1.2-0.9-2.2-0.9c-0.8 0-1.5 0.3-2.1 0.8s-1 1.4-1.2 2.5h6.1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F8D14E",
                d: "M23.5,39.6c10.3,0,18.6-8.3,18.6-18.6S33.7,2.4,23.5,2.4C13.2,2.4,4.9,10.7,4.9,21S13.2,39.6,23.5,39.6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F19F3C",
                d: "m42.1 21c0-10.3-8.3-18.6-18.6-18.6s-18.6 8.3-18.6 18.6 8.3 18.6 18.6 18.6c10.2 0 18.6-8.3 18.6-18.6zm-39.3 0c0-11.5 9.2-20.7 20.7-20.7 11.4 0 20.7 9.3 20.7 20.7s-9.3 20.7-20.7 20.7c-11.5 0-20.7-9.3-20.7-20.7z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#3A3B44",
                d: "m29.5 15.9c0.7 0.2 1 1.6 1.6 1.3 1.3-0.7 1.8-2.3 1.1-3.6s-2.3-1.8-3.6-1.1-1.8 2.3-1.1 3.6c0.4 0.6 1.4-0.4 2-0.2z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#3A3B44",
                d: "m16.9 15.9c-0.7 0.2-1 1.6-1.6 1.3-1.3-0.7-1.8-2.3-1.1-3.6s2.3-1.8 3.6-1.1 1.8 2.3 1.1 3.6c-0.3 0.6-1.4-0.4-2-0.2z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#3A3B44",
                d: "m23.3 28.8c5.3 0 7-4.7 7-7.1 0-1.3-0.8-0.9-2.2-0.2-1.2 0.6-2.9 1.5-4.8 1.5-3.8 0-7-3.7-7-1.3s1.8 7.1 7 7.1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("filter", {
                    id: "b",
                    x: "18.8",
                    y: "25.1",
                    width: "9.3",
                    height: "9.1",
                    filterUnits: "userSpaceOnUse",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                        values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                id: "a",
                x: "18.8",
                y: "25.1",
                width: "9.3",
                height: "9.1",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#FFFFFF",
                    filter: "url(#b)",
                    d: "m23.3 28.8c5.3 0 7-4.7 7-7.1 0-1.3-0.8-0.9-2.2-0.2-1.2 0.6-2.9 1.5-4.8 1.5-3.8 0-7-3.7-7-1.3s1.8 7.1 7 7.1z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                mask: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E55049",
                    d: "m23.5 34.2c2.6 0 4.6-2.1 4.6-4.6 0-2-1.3-3.7-3-4.4-0.1 0-0.1 0-0.2-0.1-0.4-0.1-0.9 1.4-1.4 1.4s-0.9-1.5-1.3-1.4c-1.9 0.6-3.3 2.3-3.3 4.4-0.1 2.7 2 4.7 4.6 4.7z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F19F3C",
                d: "m36.1 18.5c1 0 1.7-0.8 1.7-1.7s-0.8-1.8-1.7-1.8c-1 0-1.7 0.8-1.7 1.7s0.7 1.8 1.7 1.8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F19F3C",
                d: "m11.2 18.5c1 0 1.7-0.8 1.7-1.7s-0.8-1.8-1.7-1.8c-1 0-1.7 0.8-1.7 1.7s0.7 1.8 1.7 1.8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F19F3C",
                d: "m7.6 24.3c-0.9 0-1.6 0.4-2.2 1-0.3 0.4-0.7 1-0.7 2-0.4-0.1-0.7-0.2-1-0.2-0.8 0-1.6 0.3-2.1 0.9-0.7 0.7-1 1.7-0.9 2.6 0.1 0.4 0.2 0.8 0.4 1.2-0.5 0.4-0.8 0.9-1 1.5-0.1 0.5-0.3 1.5 0.4 2.5 0 0.1-0.1 0.1-0.1 0.2-0.4 0.8-0.4 1.7-0.1 2.5 0.7 1.3 2 2.3 4.7 3.3 1.6 0.7 3.2 1.1 3.2 1.1 2.2 0.6 4.1 0.9 5.8 0.9 3.1 0 5.4-1 6.7-2.9 2.1-3 1.8-5.8-0.9-8.5-1.5-1.5-2.5-3.7-2.7-4.2-0.4-1.4-1.5-3-3.3-3h-0.5c-0.8 0.1-1.5 0.6-2 1.3-0.5-0.7-1.1-1.2-1.5-1.5-0.8-0.4-1.5-0.7-2.2-0.7zm0 2.2c0.3 0 0.6 0.1 1 0.3 1.1 0.7 3.3 4.5 4.1 6 0.3 0.5 0.7 0.7 1.1 0.7 0.8 0 1.5-0.8 0.1-1.9-2.1-1.6-1.4-4.1-0.4-4.3h0.1c0.9 0 1.3 1.6 1.3 1.6s1.2 3 3.2 5 2.1 3.6 0.7 5.8c-1 1.5-2.9 1.9-4.9 1.9s-4.1-0.5-5.3-0.8c-0.1 0-7.2-2-6.3-3.7 0.2-0.3 0.4-0.4 0.7-0.4 1.3 0 3.6 1.9 4.6 1.9 0.2 0 0.4-0.1 0.4-0.3 0.4-1.5-6.4-2.2-5.9-4.4 0.1-0.4 0.4-0.5 0.8-0.5 1.7 0 5.5 3 6.2 3 0.1 0 0.1 0 0.1-0.1 0.4-0.6 0.2-1.1-2.6-2.8-2.6-1.7-4.6-2.8-3.5-4 0.1-0.1 0.3-0.2 0.5-0.2 1.7 0 5.7 3.6 5.7 3.6s1.1 1.1 1.7 1.1c0.2 0 0.3-0.1 0.4-0.2 0.5-0.8-4.3-4.4-4.6-5.9-0.1-0.9 0.2-1.4 0.8-1.4z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F8D14E",
                d: "m18.9 39.7c1.5-2.2 1.4-3.8-0.7-5.8-2-2-3.2-5-3.2-5s-0.4-1.7-1.4-1.6-1.7 2.7 0.4 4.3-0.4 2.6-1.2 1.2c-0.8-1.5-3-5.3-4.1-6s-1.9-0.3-1.7 1.2c0.3 1.5 5 5.1 4.6 5.9-0.6 0.8-2.2-0.9-2.2-0.9s-5.1-4.7-6.2-3.4c-1.2 1.1 0.8 2.2 3.6 3.8 2.8 1.7 3 2.1 2.6 2.8-0.4 0.6-6.6-4.6-7.1-2.4-0.6 2.2 6.3 2.8 5.9 4.4-0.4 1.5-4.8-2.9-5.7-1.2s6.2 3.7 6.3 3.7c2.2 0.7 8 2 10.1-1z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F19F3C",
                d: "m39.6 24.3c0.9 0 1.6 0.4 2.2 1 0.3 0.4 0.7 1 0.7 2 0.4-0.1 0.7-0.2 1-0.2 0.8 0 1.6 0.3 2.1 0.9 0.7 0.7 1 1.7 0.9 2.6-0.1 0.4-0.2 0.8-0.4 1.2 0.5 0.4 0.8 0.9 1 1.5 0.1 0.5 0.3 1.5-0.4 2.5 0 0.1 0.1 0.1 0.1 0.2 0.4 0.8 0.4 1.7 0.1 2.5-0.5 1.2-1.9 2.2-4.6 3.3-1.6 0.7-3.2 1.1-3.2 1.1-2.2 0.6-4.1 0.9-5.8 0.9-3.1 0-5.4-1-6.7-2.9-2.1-3-1.8-5.8 0.9-8.5 1.5-1.5 2.5-3.7 2.7-4.2 0.4-1.4 1.5-3 3.3-3h0.5c0.8 0.1 1.5 0.6 2 1.3 0.5-0.7 1.1-1.2 1.5-1.5 0.7-0.4 1.4-0.7 2.1-0.7zm0 2.2c-0.3 0-0.6 0.1-1 0.3-1.1 0.7-3.3 4.5-4.1 6-0.3 0.5-0.7 0.7-1.1 0.7-0.8 0-1.5-0.8-0.1-1.9 2.1-1.6 1.4-4.1 0.4-4.3h-0.1c-0.9 0-1.3 1.6-1.3 1.6s-1.2 3-3.2 5-2.1 3.6-0.7 5.8c1 1.5 2.9 1.9 4.9 1.9s4.1-0.5 5.3-0.8c0.1 0 7.2-2 6.3-3.7-0.2-0.3-0.4-0.4-0.7-0.4-1.3 0-3.6 1.9-4.6 1.9-0.2 0-0.4-0.1-0.4-0.3-0.4-1.5 6.4-2.2 5.9-4.4-0.1-0.4-0.4-0.5-0.8-0.5-1.7 0-5.5 3-6.2 3-0.1 0-0.1 0-0.1-0.1-0.4-0.6-0.2-1.1 2.6-2.8s4.8-2.7 3.6-3.9c-0.1-0.1-0.3-0.2-0.5-0.2-1.7 0-5.7 3.6-5.7 3.6s-1.1 1.1-1.7 1.1c-0.2 0-0.3-0.1-0.4-0.2-0.5-0.8 4.3-4.4 4.6-5.9 0-1-0.3-1.5-0.9-1.5z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F8D14E",
                d: "m28.4 39.7c-1.5-2.2-1.4-3.8 0.7-5.8 2-2 3.2-5 3.2-5s0.4-1.7 1.4-1.6c1 0.2 1.7 2.7-0.4 4.3s0.4 2.6 1.2 1.2c0.8-1.5 3-5.3 4.1-6s1.9-0.3 1.7 1.2c-0.3 1.5-5 5.1-4.6 5.9 0.5 0.8 2.1-0.9 2.1-0.9s5.1-4.7 6.2-3.4-0.8 2.2-3.6 3.9-3 2.1-2.6 2.8c0.4 0.6 6.6-4.6 7.1-2.4 0.6 2.2-6.3 2.8-5.9 4.4 0.4 1.5 4.8-2.9 5.7-1.2s-6.2 3.7-6.3 3.7c-2.1 0.6-8 1.9-10-1.1z"
            })
        ]
    }),
    "microsoft-exchange-logo": /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 81 70",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#28A8EA",
                d: "M75.6,0H57.8c-1.3,0-2.6,0.5-3.6,1.5l-42,42c-1,1-1.5,2.2-1.5,3.6v17.8c0,2.8,2.3,5.1,5.1,5.1c0,0,0,0,0,0h17.8  c1.3,0,2.6-0.5,3.6-1.5l42-42c1-1,1.5-2.2,1.5-3.6V5.1C80.7,2.3,78.4,0,75.6,0C75.6,0,75.6,0,75.6,0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#0078D4",
                d: "M75.6,70H57.8c-1.3,0-2.6-0.5-3.6-1.5L45.7,60V44.1c0-5,4.1-9.1,9.1-9.1h0h15.9l8.5,8.5c1,1,1.5,2.2,1.5,3.6  v17.8C80.7,67.7,78.4,70,75.6,70L75.6,70z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#50D9FF",
                d: "M15.8,0h17.8c1.3,0,2.6,0.5,3.6,1.5l8.5,8.5v15.9c0,5-4.1,9.1-9.1,9.1l0,0H20.7l-8.5-8.5c-1-1-1.5-2.2-1.5-3.6  V5.1C10.7,2.3,13,0,15.8,0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                opacity: "0.2",
                d: "M42.8,18v38.4c0,0.2,0,0.4-0.1,0.6c-0.3,1.6-1.7,2.8-3.3,2.8H10.7V14.6h28.7C41.3,14.6,42.8,16.1,42.8,18  C42.8,18,42.8,18,42.8,18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                opacity: "0.1",
                d: "M44.2,18v35.5c0,2.7-2.2,4.8-4.9,4.9H10.7V13.1h28.7C42.1,13.1,44.2,15.3,44.2,18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                opacity: "0.2",
                d: "M42.8,18v35.5c0,1.9-1.5,3.4-3.4,3.4c0,0,0,0,0,0H10.7V14.6h28.7C41.3,14.6,42.8,16.1,42.8,18  C42.8,18,42.8,18,42.8,18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                opacity: "0.1",
                d: "M41.3,18v35.5c0,1.9-1.5,3.4-3.4,3.4c0,0,0,0,0,0H10.7V14.6h27.2C39.8,14.6,41.3,16.1,41.3,18  C41.3,18,41.3,18,41.3,18z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#0078D4",
                d: "M3.9,14.6h34c1.9,0,3.4,1.5,3.4,3.4v34c0,1.9-1.5,3.4-3.4,3.4h-34c-1.9,0-3.4-1.5-3.4-3.4V18  C0.5,16.1,2,14.6,3.9,14.6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFFFFF",
                d: "M27.6,27.5h-9.5v5.6h9v3.6h-9v5.8h10.1v3.6H13.7V23.9h13.9L27.6,27.5z"
            })
        ]
    }),
    "microsoft-form-recognizer-logo": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        version: "1.1",
        id: "Microsoft_Form_Recognizer",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 70 70",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            id: "logo",
            fill: "#0078D4",
            d: "M42.2,20c0,0.8-0.6,1.5-1.5,1.5H11.5c-0.8,0-1.5-0.6-1.5-1.5c0-0.8,0.6-1.5,1.5-1.5h29.2  C41.5,18.5,42.2,19.2,42.2,20z M11.5,51h11.1c0-0.1-0.1-0.2-0.1-0.2c-0.4-0.9-0.7-1.8-1-2.7h-10c-0.8,0-1.5,0.6-1.5,1.5  C10.1,50.3,10.7,51,11.5,51z M26.5,58.4H3.3V3.3H39v8.4h8.6v13c1.1,0.1,2.2,0.3,3.3,0.5V10l-10-10H0v61.7h28.8  C28,60.7,27.2,59.6,26.5,58.4z M11.5,31.3h5.9c-0.1-0.9-0.2-1.4-0.2-1.5l-0.1-1.4h-5.6c-0.8,0-1.5,0.6-1.5,1.5  C10.1,30.6,10.7,31.3,11.5,31.3z M11.5,41.1h7.8c-0.3-1-0.5-2-0.7-2.9h-7.1c-0.8,0-1.5,0.6-1.5,1.5C10.1,40.5,10.7,41.1,11.5,41.1z  M42.1,26.8c13.4,0,27.9,5.9,27.9,22.3c0,15.9-14.5,20.8-20.5,20.8c-26,0-29.8-40.3-29.8-40.3S30.1,26.8,42.1,26.8z M49.1,30.6  C39,30.6,30.8,38.8,30.8,49S39,67.3,49.1,67.3S67.5,59.1,67.5,49S59.3,30.6,49.1,30.6z M52.8,41H47v5.8h5.8V41z M62.5,41h-5.8v5.8  h5.8V41z M43,46.8h-5.8V41H43V46.8z M43,51.8h-5.8v5.8H43V51.8z M52.8,51.8H47v5.8h5.8V51.8z M62.5,51.8h-5.8v5.8h5.8V51.8z"
        })
    }),
    "privateai-logo": /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        version: "1.1",
        id: "Private_AI",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 250 52",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            id: "logo",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    id: "box",
                    fill: "#197ACF",
                    d: "M246.8,3.1v45.8h-59V3.1H246.8 M249.9,0h-65.2v52h65.2V0L249.9,0z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    id: "type",
                    fill: "#FFFFFF",
                    d: "M0,13.4h4.6c2.5,0,4.3,0.2,5.4,0.7c1.1,0.5,2,1.2,2.6,2.2c0.6,1,1,2.3,1,3.7c0,1.6-0.4,2.9-1.2,4 c-0.8,1.1-2,1.8-3.4,2.2c-0.8,0.2-2.4,0.4-4.6,0.4v9.6H0V13.4z M4.3,22.3h1.4c1.1,0,1.8-0.1,2.3-0.2c0.4-0.2,0.8-0.4,1-0.8 c0.2-0.4,0.4-0.8,0.4-1.3c0-0.9-0.3-1.5-1-1.9c-0.5-0.3-1.4-0.5-2.8-0.5H4.3V22.3z M28,13.4h4.6c2.5,0,4.3,0.2,5.4,0.7 c1.1,0.4,1.9,1.2,2.6,2.2c0.6,1,1,2.3,1,3.7c0,1.5-0.4,2.7-1.1,3.8c-0.7,1-1.8,1.8-3.2,2.3l5.4,10.1h-4.7l-5.1-9.6h-0.4v9.6H28 V13.4z M32.3,22.3h1.4c1.4,0,2.3-0.2,2.8-0.5c0.5-0.4,0.8-1,0.8-1.8c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.4-0.6-0.6-1-0.8 s-1.2-0.2-2.4-0.2h-1.2V22.3z M55.6,13.4h4.3v22.8h-4.3V13.4z M73,13.4h4.5l5.7,16.2L89,13.4h4.5l-8.2,22.8H81L73,13.4z M111.6,13.4h4.4l8.8,22.8h-4.5l-1.8-4.7h-9.3l-1.9,4.7h-4.5L111.6,13.4z M113.9,19.4l-3.1,7.8h6.1L113.9,19.4z M135.3,13.4h12.6 v4.3h-4.2v18.5h-4.4V17.7h-4V13.4z M160.2,13.4h12.4v4.2h-8.1v4.1h8.1v4.2h-8.1v6h8.1v4.3h-12.4V13.4z M205,13.4h4.4l8.8,22.8h-4.5 l-1.8-4.7h-9.3l-1.9,4.7h-4.5L205,13.4z M207.2,19.4l-3.1,7.8h6.1L207.2,19.4z M230.6,13.4h4.3v22.8h-4.3V13.4z"
                })
            ]
        })
    })
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gPP3j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", function() {
    return Button;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _buttonStyles = require("./Button.styles");
function Button(props) {
    var busy = props.busy, children = props.children, className = props.className, disabled = props.disabled, id = props.id, onClick = props.onClick, onFocus = props.onFocus, role = props.role, style = props.style, tabindex = props.tabindex, type = props.type, _props_variant = props.variant, variant = _props_variant === void 0 ? "default" : _props_variant, rest = (0, _objectWithoutProperties._)(props, [
        "busy",
        "children",
        "className",
        "disabled",
        "id",
        "onClick",
        "onFocus",
        "role",
        "style",
        "tabindex",
        "type",
        "variant"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonStyles.StyledButton), (0, _objectSpreadProps._)((0, _objectSpread._)({
        "aria-disabled": busy,
        "aria-label": props["aria-label"],
        "aria-pressed": props["aria-pressed"],
        "aria-selected": props["aria-selected"],
        className: (0, _classnamesDefault.default)(variant, className, {
            blue: variant === "primary" || variant === "cta",
            busy: busy
        }),
        "data-cy": props["data-cy"],
        "data-for": props["data-for"],
        "data-tip": props["data-tip"],
        disabled: disabled,
        id: id,
        onClick: busy ? undefined : onClick,
        onFocus: onFocus,
        role: role,
        style: style,
        tabIndex: tabindex,
        type: type || "button"
    }, rest), {
        children: [
            busy && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {
                size: "0.9em",
                style: {
                    marginRight: "0.5em"
                }
            }),
            children
        ]
    }));
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Button.styles":"bIyM9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ghPIz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_without_properties", function() {
    return _object_without_properties;
});
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._object_without_properties_loose)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"lSsy1","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lSsy1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_without_properties_loose", function() {
    return _object_without_properties_loose;
});
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bIyM9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledButton", function() {
    return StyledButton;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 0;\n  display: inline-block;\n  cursor: pointer;\n  font-family: ",
        ";\n\n  &.default {\n    border-radius: 2px;\n    padding: 0.625em 1.25em;\n    box-shadow: 0 1px 1px 0 ",
        ";\n    transition: background-color ",
        " ",
        ";\n  }\n\n  &.primary,\n  &.cta {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      // todo: shouldn't have to override...\n      color: ",
        ";\n      // todo: store as constant\n      background-color: #1777c2;\n    }\n  }\n\n  &.cta {\n    font-size: ",
        ";\n  }\n\n  &.normal {\n    font-size: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      // todo: store as constant\n      background-color: #bebebe;\n    }\n  }\n\n  &.outline {\n    color: ",
        ";\n    background: transparent;\n    border: 1px solid ",
        ";\n    transition: border ",
        " ",
        ",\n      color ",
        " ",
        ";\n\n    &:hover,\n    &:focus {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      background: transparent;\n    }\n\n    &:disabled {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      background: transparent;\n      opacity: 0.6;\n\n      &:hover {\n        background: transparent;\n        border: 1px solid ",
        ";\n        color: ",
        ";\n        opacity: 0.6;\n      }\n    }\n  }\n\n  &.no-style {\n    font-size: inherit;\n    color: inherit;\n    background-color: transparent;\n    box-shadow: none;\n    padding: 0;\n\n    &:hover,\n    &:focus {\n      color: inherit;\n      background-color: transparent;\n    }\n\n    &:not(.focus-visible) {\n      outline: none;\n    }\n  }\n\n  &.busy {\n    cursor: wait;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledButton = (0, _styledComponentsDefault.default).button(_templateObject(), (0, _index.TYPOGRAPHY).fontFamily.base, (0, _index.COLORS).black, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.COLORS).white, (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).iron, (0, _index.COLORS).darkFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iUiDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlButton", function() {
    return 0, _controlButton.ControlButton;
});
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return 0, _controlButton.controlButtonSpacing;
});
var _controlButton = require("./ControlButton");

},{"./ControlButton":"iRQkH","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iRQkH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return controlButtonSpacing;
});
/**
 * Small icon-only buttons used for UI controls.
 */ parcelHelpers.export(exports, "ControlButton", function() {
    return ControlButton;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _button = require("@react-aria/button");
var _focus = require("@react-aria/focus");
var _index = require("Permafrost/index");
var _controlButtonStyles = require("./ControlButton.styles");
var controlButtonSpacing = {
    normal: "16px"
};
var controlButton = {
    reject: {
        icon: "trash",
        label: "Reject"
    },
    submit: {
        icon: "check",
        label: "Submit"
    },
    restore: {
        icon: "upload",
        label: "Restore"
    },
    "step-forward": {
        icon: "step-forward",
        label: "Step Forward"
    }
};
function ControlButton(props) {
    var busy = props.busy, buttonType = props.buttonType, className = props.className, id = props.id, tooltipDisabled = props.tooltipDisabled, tooltipText = props.tooltipText;
    var buttonEl = (0, _react.useRef)();
    var buttonProps = (0, _button.useButton)(props, buttonEl).buttonProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var iconSize = buttonType === "submit" ? "22px" : (0, _controlButtonStyles.iconSizeDefault);
    var tooltipId = (0, _uuid.v4)();
    var buttonTooltipProps = tooltipDisabled ? {
        "aria-label": controlButton[buttonType].label
    } : {
        "data-tip": true,
        "data-for": tooltipId,
        "aria-labelledby": tooltipId
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _controlButtonStyles.StyledControlButton), (0, _objectSpreadProps._)((0, _objectSpread._)({
                $buttonType: buttonType,
                $iconSize: iconSize,
                id: id,
                className: (0, _classnamesDefault.default)(className, {
                    "focus-visible": isFocusVisible
                }),
                "data-cy": props["data-cy"]
            }, buttonProps, focusProps, buttonTooltipProps), {
                children: busy ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {
                    size: (0, _controlButtonStyles.iconSizeDefault)
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: controlButton[buttonType].icon,
                    size: [
                        iconSize
                    ]
                })
            })),
            !tooltipDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                for: tooltipId,
                children: tooltipText || controlButton[buttonType].label
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","classnames":"9xS9S","@react-aria/button":"3Kuyu","@react-aria/focus":"dmSXv","Permafrost/index":"iliLC","./ControlButton.styles":"hbQmE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6ZyFu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"bihOB","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bihOB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJsDefault.default)(rnds);
}
exports.default = v4;

},{"./rng.js":"PObXF","./stringify.js":"fSXyI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"PObXF":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
var rnds8 = new Uint8Array(16);
function rng() {
    if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fSXyI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).substr(1));
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"l57uG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l57uG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"eK3NJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eK3NJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3Kuyu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useButton", function() {
    return $701a24aa0da5b062$export$ea18c227d4417cc3;
});
parcelHelpers.export(exports, "useToggleButton", function() {
    return $55f54f7887471b58$export$51e84d46ca0bc451;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $701a24aa0da5b062$export$ea18c227d4417cc3(props, ref) {
    var tmp = props.elementType, elementType = tmp === void 0 ? "button" : tmp, isDisabled = props.isDisabled, onPress = props.onPress, onPressStart = props.onPressStart, onPressEnd = props.onPressEnd, onPressUp = props.onPressUp, onPressChange = props.onPressChange, preventFocusOnPress = props.preventFocusOnPress, allowFocusWhenDisabled = props.allowFocusWhenDisabled, deprecatedOnClick = props.onClick, href = props.href, target = props.target, rel = props.rel, tmp1 = props.type, type = tmp1 === void 0 ? "button" : tmp1;
    var additionalProps;
    if (elementType === "button") additionalProps = {
        type: type,
        disabled: isDisabled
    };
    else additionalProps = {
        role: "button",
        tabIndex: isDisabled ? undefined : 0,
        href: elementType === "a" && isDisabled ? undefined : href,
        target: elementType === "a" ? target : undefined,
        type: elementType === "input" ? type : undefined,
        disabled: elementType === "input" ? isDisabled : undefined,
        "aria-disabled": !isDisabled || elementType === "input" ? undefined : isDisabled,
        rel: elementType === "a" ? rel : undefined
    };
    var _$cE0pI$usePress = (0, _interactions.usePress)({
        onPressStart: onPressStart,
        onPressEnd: onPressEnd,
        onPressChange: onPressChange,
        onPress: onPress,
        onPressUp: onPressUp,
        isDisabled: isDisabled,
        preventFocusOnPress: preventFocusOnPress,
        ref: ref
    }), pressProps = _$cE0pI$usePress.pressProps, isPressed = _$cE0pI$usePress.isPressed;
    var _$cE0pI$useFocusable = (0, _focus.useFocusable)(props, ref), focusableProps = _$cE0pI$useFocusable.focusableProps;
    if (allowFocusWhenDisabled) focusableProps.tabIndex = isDisabled ? -1 : focusableProps.tabIndex;
    var buttonProps = (0, _utils.mergeProps)(focusableProps, pressProps, (0, _utils.filterDOMProps)(props, {
        labelable: true
    }));
    return {
        isPressed: isPressed,
        buttonProps: (0, _utils.mergeProps)(additionalProps, buttonProps, {
            "aria-haspopup": props["aria-haspopup"],
            "aria-expanded": props["aria-expanded"],
            "aria-controls": props["aria-controls"],
            "aria-pressed": props["aria-pressed"],
            onClick: function(e) {
                if (deprecatedOnClick) {
                    deprecatedOnClick(e);
                    console.warn("onClick is deprecated, please use onPress");
                }
            }
        })
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $55f54f7887471b58$export$51e84d46ca0bc451(props, state, ref) {
    var isSelected = state.isSelected;
    var _$701a24aa0da5b062$export$ea18c227d4417cc3 = $701a24aa0da5b062$export$ea18c227d4417cc3((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onPress: (0, _utils.chain)(state.toggle, props.onPress)
    }), ref), isPressed = _$701a24aa0da5b062$export$ea18c227d4417cc3.isPressed, buttonProps = _$701a24aa0da5b062$export$ea18c227d4417cc3.buttonProps;
    return {
        isPressed: isPressed,
        buttonProps: (0, _utils.mergeProps)(buttonProps, {
            "aria-pressed": isSelected
        })
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@react-aria/utils":"99Fak","@react-aria/focus":"dmSXv","@react-aria/interactions":"7Ysj1","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"99Fak":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", function() {
    return $bdb11010cef70236$export$f680877a34711e37;
});
parcelHelpers.export(exports, "mergeIds", function() {
    return $bdb11010cef70236$export$cd8c9cb68f842629;
});
parcelHelpers.export(exports, "useSlotId", function() {
    return $bdb11010cef70236$export$b4cc09c592e8fdb8;
});
parcelHelpers.export(exports, "chain", function() {
    return $ff5963eb1fccf552$export$e08e3b67e392101e;
});
parcelHelpers.export(exports, "getOwnerDocument", function() {
    return $431fbd86ca7dc216$export$b204af158042fbac;
});
parcelHelpers.export(exports, "getOwnerWindow", function() {
    return $431fbd86ca7dc216$export$f21a1ffae260145a;
});
parcelHelpers.export(exports, "mergeProps", function() {
    return $3ef42575df84b30b$export$9d1611c77c2fe928;
});
parcelHelpers.export(exports, "mergeRefs", function() {
    return $5dc95899b306f630$export$c9058316764c140e;
});
parcelHelpers.export(exports, "filterDOMProps", function() {
    return $65484d02dcb7eb3e$export$457c3d6518dd4c6f;
});
parcelHelpers.export(exports, "focusWithoutScrolling", function() {
    return $7215afc6de606d6b$export$de79e2c695e052f3;
});
parcelHelpers.export(exports, "getOffset", function() {
    return $ab71dadb03a6fb2e$export$622cea445a1c5b7d;
});
parcelHelpers.export(exports, "openLink", function() {
    return $ea8dcbcb9ea1b556$export$95185d699e05d4d7;
});
parcelHelpers.export(exports, "getSyntheticLinkProps", function() {
    return $ea8dcbcb9ea1b556$export$51437d503373d223;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return $ea8dcbcb9ea1b556$export$323e4fc2fa4753fb;
});
parcelHelpers.export(exports, "shouldClientNavigate", function() {
    return $ea8dcbcb9ea1b556$export$efa8c9099e530235;
});
parcelHelpers.export(exports, "useRouter", function() {
    return $ea8dcbcb9ea1b556$export$9a302a45f65d0572;
});
parcelHelpers.export(exports, "runAfterTransition", function() {
    return $bbed8b41f857bcc0$export$24490316f764c430;
});
parcelHelpers.export(exports, "useDrag1D", function() {
    return $9cc09df9fd7676be$export$7bbed75feba39706;
});
parcelHelpers.export(exports, "useGlobalListeners", function() {
    return $03deb23ff14920c4$export$4eaf04e54aa8eed6;
});
parcelHelpers.export(exports, "useLabels", function() {
    return $313b98861ee5dd6c$export$d6875122194c7b44;
});
parcelHelpers.export(exports, "useObjectRef", function() {
    return $df56164dff5785e2$export$4338b53315abf666;
});
parcelHelpers.export(exports, "useUpdateEffect", function() {
    return $4f58c5f72bcf79f7$export$496315a1608d9602;
});
parcelHelpers.export(exports, "useLayoutEffect", function() {
    return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c;
});
parcelHelpers.export(exports, "useResizeObserver", function() {
    return $9daab02d461809db$export$683480f191c0e3ea;
});
parcelHelpers.export(exports, "useSyncRef", function() {
    return $e7801be82b4b2a53$export$4debdb1a3f0fa79e;
});
parcelHelpers.export(exports, "getScrollParent", function() {
    return $62d8ded9296f3872$export$cfa2225e87938781;
});
parcelHelpers.export(exports, "isScrollable", function() {
    return $62d8ded9296f3872$export$2bb74740c4e19def;
});
parcelHelpers.export(exports, "useViewportSize", function() {
    return $5df64b3807dc15ee$export$d699905dd57c73ca;
});
parcelHelpers.export(exports, "useDescription", function() {
    return $ef06256079686ba0$export$f8aeda7b10753fa1;
});
parcelHelpers.export(exports, "isMac", function() {
    return $c87311424ea30a05$export$9ac100e40613ea10;
});
parcelHelpers.export(exports, "isIPhone", function() {
    return $c87311424ea30a05$export$186c6964ca17d99;
});
parcelHelpers.export(exports, "isIPad", function() {
    return $c87311424ea30a05$export$7bef049ce92e4224;
});
parcelHelpers.export(exports, "isIOS", function() {
    return $c87311424ea30a05$export$fedb369cb70207f1;
});
parcelHelpers.export(exports, "isAppleDevice", function() {
    return $c87311424ea30a05$export$e1865c3bedcd822b;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return $c87311424ea30a05$export$78551043582a6a98;
});
parcelHelpers.export(exports, "isChrome", function() {
    return $c87311424ea30a05$export$6446a186d09e379e;
});
parcelHelpers.export(exports, "isAndroid", function() {
    return $c87311424ea30a05$export$a11b0059900ceec8;
});
parcelHelpers.export(exports, "isFirefox", function() {
    return $c87311424ea30a05$export$b7d78993b74f766d;
});
parcelHelpers.export(exports, "useEvent", function() {
    return $e9faafb641e167db$export$90fc3a17d93f704c;
});
parcelHelpers.export(exports, "useValueEffect", function() {
    return $1dbecbe27a04f9af$export$14d238f342723f25;
});
parcelHelpers.export(exports, "scrollIntoView", function() {
    return $2f04cbc44ee30ce0$export$53a0910f038337bd;
});
parcelHelpers.export(exports, "scrollIntoViewport", function() {
    return $2f04cbc44ee30ce0$export$c826860796309d1b;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _utils.clamp;
});
parcelHelpers.export(exports, "snapValueToStep", function() {
    return 0, _utils.snapValueToStep;
});
parcelHelpers.export(exports, "isVirtualClick", function() {
    return $6a7db85432448f7f$export$60278871457622de;
});
parcelHelpers.export(exports, "isVirtualPointerEvent", function() {
    return $6a7db85432448f7f$export$29bf1b5f2c56cf63;
});
parcelHelpers.export(exports, "useEffectEvent", function() {
    return $8ae05eaa5c114e9c$export$7f54fc3180508a52;
});
parcelHelpers.export(exports, "useDeepMemo", function() {
    return $5a387cc49350e6db$export$722debc0e56fea39;
});
parcelHelpers.export(exports, "useFormReset", function() {
    return $99facab73266f662$export$5add1d006293d136;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@react-stately/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ssr = require("@react-aria/ssr");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, _reactDefault.default).useLayoutEffect : function() {};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
    var ref = (0, _react.useRef)(null);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var f = ref.current;
        return f === null || f === void 0 ? void 0 : f.apply(void 0, (0, _toConsumableArray._)(args));
    }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(defaultValue), 2), value1 = _$12uGp$useState[0], setValue = _$12uGp$useState[1];
    var effect = (0, _react.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    var nextRef = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function() {
        if (!effect.current) return;
        // Run the generator to the next yield.
        var newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value1 === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    var queue = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function(fn) {
        effect.current = fn(value1);
        nextRef();
    });
    return [
        value1,
        queue
    ];
}
// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
var $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(defaultId), 2), value1 = _$12uGp$useState[0], setValue = _$12uGp$useState[1];
    var nextId = (0, _react.useRef)(null);
    var res = (0, _ssr.useSSRSafeId)(value1);
    var updateValue = (0, _react.useCallback)(function(val) {
        nextId.current = val;
    }, []);
    if ($bdb11010cef70236$var$canUseDOM) $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        var r = res;
        return function() {
            $bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, _react.useEffect)(function() {
        var newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    var setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    var setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8() {
    var depArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var id = $bdb11010cef70236$export$f680877a34711e37();
    var _$1dbecbe27a04f9af$export$14d238f342723f25 = (0, _slicedToArray._)($1dbecbe27a04f9af$export$14d238f342723f25(id), 2), resolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[0], setResolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[1];
    var updateId = (0, _react.useCallback)(function() {
        setResolvedId(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            id
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            document.getElementById(id) ? id : undefined
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        id,
        setResolvedId
    ]);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId
    ].concat((0, _toConsumableArray._)(depArray)));
    return resolvedId;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $ff5963eb1fccf552$export$e08e3b67e392101e() {
    for(var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++){
        callbacks[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                if (typeof callback === "function") callback.apply(void 0, (0, _toConsumableArray._)(args));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
var $431fbd86ca7dc216$export$b204af158042fbac = function(el) {
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
var $431fbd86ca7dc216$export$f21a1ffae260145a = function(el) {
    if (el && "window" in el && el.window === el) return el;
    var doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3ef42575df84b30b$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    var result = (0, _objectSpread._)({}, args[0]);
    for(var i = 1; i < args.length; i++){
        var props = args[i];
        for(var key in props){
            var a = result[key];
            var b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, _clsxDefault.default)(a, b);
            else if (key === "id" && a && b) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5dc95899b306f630$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    if (refs.length === 1) return refs[0];
    return function(value1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ref = _step.value;
                if (typeof ref === "function") ref(value1);
                else if (ref != null) ref.current = value1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
var $65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
var $65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
var $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var labelable = opts.labelable, isLink = opts.isLink, propNames = opts.propNames;
    var filteredProps = {};
    for(var prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
    if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        var scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
var $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
    if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scrollableElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, element = _step_value.element, scrollTop = _step_value.scrollTop, scrollLeft = _step_value.scrollLeft;
            element.scrollTop = scrollTop;
            element.scrollLeft = scrollLeft;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab71dadb03a6fb2e$export$622cea445a1c5b7d(element, reverse) {
    var orientation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "horizontal";
    var rect = element.getBoundingClientRect();
    if (reverse) return orientation === "horizontal" ? rect.right : rect.bottom;
    return orientation === "horizontal" ? rect.left : rect.top;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(function(brand) {
        return re.test(brand.brand);
    })) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
    return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
    return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
    return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
    return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$e1865c3bedcd822b() {
    return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}
function $c87311424ea30a05$export$78551043582a6a98() {
    return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}
function $c87311424ea30a05$export$6446a186d09e379e() {
    return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
    return $c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $c87311424ea30a05$export$b7d78993b74f766d() {
    return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
}
var $ea8dcbcb9ea1b556$var$RouterContext = (0, _react.createContext)({
    isNative: true,
    open: $ea8dcbcb9ea1b556$var$openSyntheticLink
});
function $ea8dcbcb9ea1b556$export$323e4fc2fa4753fb(props) {
    var children = props.children, navigate = props.navigate;
    var ctx = (0, _react.useMemo)(function() {
        return {
            isNative: false,
            open: function(target, modifiers) {
                $ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
                    if ($ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers)) navigate(link.pathname + link.search + link.hash);
                    else $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers);
                });
            }
        };
    }, [
        navigate
    ]);
    return (0, _reactDefault.default).createElement($ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
    return (0, _react.useContext)($ea8dcbcb9ea1b556$var$RouterContext);
}
function $ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    var target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target, modifiers) {
    var setOpening = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _window_event_type, _window_event;
    var metaKey = modifiers.metaKey, ctrlKey = modifiers.ctrlKey, altKey = modifiers.altKey, shiftKey = modifiers.shiftKey;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ($c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ($c87311424ea30a05$export$9ac100e40613ea10()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    var event = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = setOpening;
    $7215afc6de606d6b$export$de79e2c695e052f3(target);
    target.dispatchEvent(event);
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
function $ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        var link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
        return $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers);
    });
}
function $ea8dcbcb9ea1b556$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
var $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
var $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    var onTransitionStart = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        var transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    var onTransitionEnd = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        var properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $bbed8b41f857bcc0$var$transitionCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cb = _step.value;
                    cb();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            $bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(function() {
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ // Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
var $9cc09df9fd7676be$var$draggingElements = [];
function $9cc09df9fd7676be$export$7bbed75feba39706(props) {
    console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
    var containerRef = props.containerRef, reverse = props.reverse, orientation = props.orientation, onHover = props.onHover, onDrag = props.onDrag, onPositionChange = props.onPositionChange, onIncrement = props.onIncrement, onDecrement = props.onDecrement, onIncrementToMax = props.onIncrementToMax, onDecrementToMin = props.onDecrementToMin, onCollapseToggle = props.onCollapseToggle;
    var getPosition = function(e) {
        return orientation === "horizontal" ? e.clientX : e.clientY;
    };
    var getNextOffset = function(e) {
        var containerOffset = $ab71dadb03a6fb2e$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        var mouseOffset = getPosition(e);
        var nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    var dragging = (0, _react.useRef)(false);
    var prevPosition = (0, _react.useRef)(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    var handlers = (0, _react.useRef)({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    var onMouseDragged = function(e) {
        e.preventDefault();
        var nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    var onMouseUp = function(e) {
        var target = e.target;
        dragging.current = false;
        var nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $9cc09df9fd7676be$var$draggingElements.splice($9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener("mouseup", onMouseUp, false);
        window.removeEventListener("mousemove", onMouseDragged, false);
    };
    var onMouseDown = function(e) {
        var target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($9cc09df9fd7676be$var$draggingElements.some(function(elt) {
            return target.contains(elt);
        })) return;
        $9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener("mousemove", onMouseDragged, false);
        window.addEventListener("mouseup", onMouseUp, false);
    };
    var onMouseEnter = function() {
        if (onHover) onHover(true);
    };
    var onMouseOut = function() {
        if (onHover) onHover(false);
    };
    var onKeyDown = function(e) {
        switch(e.key){
            case "Left":
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Up":
            case "ArrowUp":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Right":
            case "ArrowRight":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Down":
            case "ArrowDown":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Home":
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case "End":
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case "Enter":
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
    var globalListeners = (0, _react.useRef)(new Map());
    var addGlobalListener = (0, _react.useCallback)(function(eventTarget, type, listener, options) {
        // Make sure we remove the listener after it is called with the `once` option.
        var fn = (options === null || options === void 0 ? void 0 : options.once) ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            globalListeners.current.delete(listener);
            listener.apply(void 0, (0, _toConsumableArray._)(args));
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    var removeGlobalListener = (0, _react.useCallback)(function(eventTarget, type, listener, options) {
        var _globalListeners_current_get;
        var fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    var removeAllGlobalListeners = (0, _react.useCallback)(function() {
        globalListeners.current.forEach(function(value1, key) {
            removeGlobalListener(value1.eventTarget, value1.type, key, value1.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, _react.useEffect)(function() {
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
    var id = props.id, label = props["aria-label"], labelledBy = props["aria-labelledby"];
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $bdb11010cef70236$export$f680877a34711e37(id);
    if (labelledBy && label) {
        var ids = new Set([
            id
        ].concat((0, _toConsumableArray._)(labelledBy.trim().split(/\s+/))));
        labelledBy = (0, _toConsumableArray._)(ids).join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
    var objRef = (0, _react.useRef)(null);
    return (0, _react.useMemo)(function() {
        return {
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        };
    }, [
        forwardedRef
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4f58c5f72bcf79f7$export$496315a1608d9602(effect, dependencies) {
    var isInitialMount = (0, _react.useRef)(true);
    var lastDeps = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        isInitialMount.current = true;
        return function() {
            isInitialMount.current = false;
        };
    }, []);
    (0, _react.useEffect)(function() {
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some(function(dep, i) {
            return !Object.is(dep, lastDeps[i]);
        })) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}
function $9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
    var ref = options.ref, onResize = options.onResize;
    (0, _react.useEffect)(function() {
        var element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return function() {
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            var resizeObserverInstance = new window.ResizeObserver(function(entries) {
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return function() {
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return function() {
                if (context.ref) context.ref.current = null;
            };
        }
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62d8ded9296f3872$export$cfa2225e87938781(node, checkForOverflow) {
    var scrollableNode = node;
    if ($62d8ded9296f3872$export$2bb74740c4e19def(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !$62d8ded9296f3872$export$2bb74740c4e19def(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}
function $62d8ded9296f3872$export$2bb74740c4e19def(node, checkForOverflow) {
    var style = window.getComputedStyle(node);
    var isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
var $5df64b3807dc15ee$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $5df64b3807dc15ee$export$d699905dd57c73ca() {
    var isSSR = (0, _ssr.useIsSSR)();
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return isSSR ? {
            width: 0,
            height: 0
        } : $5df64b3807dc15ee$var$getViewportSize();
    }), 2), size = _$12uGp$useState[0], setSize = _$12uGp$useState[1];
    (0, _react.useEffect)(function() {
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        var onResize = function() {
            setSize(function(size) {
                var newSize = $5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$5df64b3807dc15ee$var$visualViewport) window.addEventListener("resize", onResize);
        else $5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
        return function() {
            if (!$5df64b3807dc15ee$var$visualViewport) window.removeEventListener("resize", onResize);
            else $5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size;
}
function $5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ef06256079686ba0$var$descriptionId = 0;
var $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(), 2), id = _$12uGp$useState[0], setId = _$12uGp$useState[1];
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        if (!description) return;
        var desc = $ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            var id = "react-aria-description-".concat($ef06256079686ba0$var$descriptionId++);
            setId(id);
            var node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return function() {
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler, options) {
    var handleEvent = $8ae05eaa5c114e9c$export$7f54fc3180508a52(handler);
    var isDisabled = handler == null;
    (0, _react.useEffect)(function() {
        if (isDisabled || !ref.current) return;
        var element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return function() {
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView, element) {
    var offsetX = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    var offsetY = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    var x = scrollView.scrollLeft;
    var y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    var _getComputedStyle = getComputedStyle(scrollView), borderTopWidth = _getComputedStyle.borderTopWidth, borderLeftWidth = _getComputedStyle.borderLeftWidth;
    var borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    var borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    var maxX = borderAdjustedX + scrollView.clientWidth;
    var maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    var prop = axis === "left" ? "offsetLeft" : "offsetTop";
    var sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $2f04cbc44ee30ce0$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        var root = document.scrollingElement || document.documentElement;
        var isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            var _targetElement_getBoundingClientRect = targetElement.getBoundingClientRect(), originalLeft = _targetElement_getBoundingClientRect.left, originalTop = _targetElement_getBoundingClientRect.top;
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            var _targetElement_getBoundingClientRect1 = targetElement.getBoundingClientRect(), newLeft = _targetElement_getBoundingClientRect1.left, newTop = _targetElement_getBoundingClientRect1.top;
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            var scrollParent = $62d8ded9296f3872$export$cfa2225e87938781(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            while(targetElement && scrollParent && targetElement !== root && scrollParent !== root){
                $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollParent, targetElement);
                targetElement = scrollParent;
                scrollParent = $62d8ded9296f3872$export$cfa2225e87938781(targetElement);
            }
        }
    }
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a7db85432448f7f$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !$c87311424ea30a05$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $5a387cc49350e6db$export$722debc0e56fea39(value1, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    var lastValue = (0, _react.useRef)(null);
    if (value1 && lastValue.current && isEqual(value1, lastValue.current)) value1 = lastValue.current;
    lastValue.current = value1;
    return value1;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $99facab73266f662$export$5add1d006293d136(ref, initialValue, onReset) {
    var resetValue = (0, _react.useRef)(initialValue);
    var handleReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function() {
        if (onReset) onReset(resetValue.current);
    });
    (0, _react.useEffect)(function() {
        var _ref_current;
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return function() {
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_ts_generator":"HrSs8","@react-stately/utils":false,"react":"ktQNc","@react-aria/ssr":"8ZKMZ","clsx":"k6xBP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8ZKMZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", function() {
    return $b5e257d569688ac6$export$9f8ac96af4b1b2ae;
});
parcelHelpers.export(exports, "useSSRSafeId", function() {
    return $b5e257d569688ac6$export$619500959fc48b26;
});
parcelHelpers.export(exports, "useIsSSR", function() {
    return $b5e257d569688ac6$export$535bd6ca7f90a273;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $b5e257d569688ac6$var$SSRContext = (0, _reactDefault.default).createContext($b5e257d569688ac6$var$defaultContext);
var $b5e257d569688ac6$var$IsSSRContext = (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function $b5e257d569688ac6$var$LegacySSRProvider(props) {
    var cur = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    var counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
    var _$73SJx$useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isSSR = _$73SJx$useState[0], setIsSSR = _$73SJx$useState[1];
    var value = (0, _react.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b5e257d569688ac6$var$defaultContext ? "" : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, _react.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, _reactDefault.default)["useId"] === "function") {
        if (!$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    }
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}
var $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    var ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        var currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    var counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    var id = (0, _reactDefault.default).useId();
    var _$73SJx$useState = (0, _slicedToArray._)((0, _react.useState)($b5e257d569688ac6$export$535bd6ca7f90a273()), 1), didSSR = _$73SJx$useState[0];
    var prefix = didSSR || false ? "react-aria" : "react-aria".concat($b5e257d569688ac6$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, _reactDefault.default)["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)["useSyncExternalStore"] === "function") return (0, _reactDefault.default)["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)($b5e257d569688ac6$var$IsSSRContext);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k6xBP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", function() {
    return clsx;
});
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dmSXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", function() {
    return $9bf71ea28793e738$export$20e40289641fbbb6;
});
parcelHelpers.export(exports, "useFocusManager", function() {
    return $9bf71ea28793e738$export$10c5169755ce7bd7;
});
parcelHelpers.export(exports, "getFocusableTreeWalker", function() {
    return $9bf71ea28793e738$export$2d6ec8fc375ceafa;
});
parcelHelpers.export(exports, "createFocusManager", function() {
    return $9bf71ea28793e738$export$c5251b9e124bf29;
});
parcelHelpers.export(exports, "isElementInChildOfActiveScope", function() {
    return $9bf71ea28793e738$export$1258395f99bf9cbf;
});
parcelHelpers.export(exports, "FocusRing", function() {
    return $907718708eab68af$export$1a38b4ad7f578e1d;
});
parcelHelpers.export(exports, "FocusableProvider", function() {
    return $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5;
});
parcelHelpers.export(exports, "useFocusable", function() {
    return $e6afbd83fe6ebbd2$export$4c014de7c8940b4c;
});
parcelHelpers.export(exports, "useFocusRing", function() {
    return $f7dceffc5ad7768b$export$4e328f61c538687f;
});
parcelHelpers.export(exports, "focusSafely", function() {
    return $6a99195332edec8b$export$80f3e147d781571c;
});
parcelHelpers.export(exports, "useHasTabbableChild", function() {
    return $83013635b024ae3d$export$eac1895992b9f3d6;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a99195332edec8b$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    var ownerDocument = (0, _utils.getOwnerDocument)(element);
    if ((0, _interactions.getInteractionModality)() === "virtual") {
        var lastFocusedElement = ownerDocument.activeElement;
        (0, _utils.runAfterTransition)(function() {
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, _utils.focusWithoutScrolling)(element);
        });
    } else (0, _utils.focusWithoutScrolling)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $645f2e67b85a24c9$var$isStyleVisible(element) {
    var windowObject = (0, _utils.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    var _element_style = element.style, display = _element_style.display, visibility = _element_style.visibility;
    var isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        var _element_ownerDocument_defaultView = element.ownerDocument.defaultView, getComputedStyle = _element_ownerDocument_defaultView.getComputedStyle;
        var _getComputedStyle = getComputedStyle(element), computedDisplay = _getComputedStyle.display, computedVisibility = _getComputedStyle.visibility;
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
var $9bf71ea28793e738$var$FocusContext = (0, _reactDefault.default).createContext(null);
var $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
    var children = props.children, contain = props.contain, restoreFocus = props.restoreFocus, autoFocus = props.autoFocus;
    var startRef = (0, _react.useRef)(null);
    var endRef = (0, _react.useRef)(null);
    var scopeRef = (0, _react.useRef)([]);
    var _ref = (0, _react.useContext)($9bf71ea28793e738$var$FocusContext) || {}, parentNode = _ref.parentNode;
    // Create a tree node here so we can add children to it even before it is added to the tree.
    var node = (0, _react.useMemo)(function() {
        return new $9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
    }, [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(function() {
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        var parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
        if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            var activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var node = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        var node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        var nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, _react.useEffect)(function() {
        var activeElement = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        var scope = null;
        if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // We need to traverse the focusScope tree and find the bottom most scope that
                // contains the active element and set that as the activeScope.
                for(var _iterator = $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (node.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            var parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
            $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    var focusManager = (0, _react.useMemo)(function() {
        return $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    }, []);
    var value = (0, _react.useMemo)(function() {
        return {
            focusManager: focusManager,
            parentNode: node
        };
    }, [
        node,
        focusManager
    ]);
    return (0, _reactDefault.default).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $9bf71ea28793e738$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, _react.useContext)($9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[0].previousElementSibling;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[scope.length - 1].nextElementSibling;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            var nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            var previousNode = walker.previousNode();
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
var $9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
var $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    var scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    var focusedNode = (0, _react.useRef)();
    var raf = (0, _react.useRef)();
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            var focusedElement = ownerDocument.activeElement;
            var scope = scopeRef.current;
            if (!scope || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        var onFocus = function(e) {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        var onBlur = function(e) {
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(function() {
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusout", onBlur, false);
        });
        return function() {
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusout", onBlur, false);
            });
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some(function(node) {
        return node.contains(element);
    });
}
function $9bf71ea28793e738$var$isElementInChildScope(element) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // node.contains in isElementInScope covers child scopes that are also DOM children,
        // but does not cover child scopes in portals.
        for(var _iterator = $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, s = _step_value.scopeRef;
            if (s && $9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    var parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $9bf71ea28793e738$var$focusElement(element) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (element != null && !scroll) try {
        $6a99195332edec8b$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope) {
    var tabbable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var sentinel = scope[0].previousElementSibling;
    var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    var nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $9bf71ea28793e738$var$focusElement(nextNode);
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    var autoFocusRef = (0, _reactDefault.default).useRef(autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current) {
            $9bf71ea28793e738$var$activeScope = scopeRef;
            var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, _utils.useLayoutEffect)(function() {
        if (restore || contain) return;
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        var onFocus = function(e) {
            var target = e.target;
            if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    var scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    var nodeToRestoreRef = (0, _react.useRef)(typeof document !== "undefined" ? (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        var onFocus = function() {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            var focusedElement = ownerDocument.activeElement;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return function() {
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return function() {
            var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                var clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(function() {
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        var treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
    var selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    var walker = (0, _utils.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $9bf71ea28793e738$export$c5251b9e124bf29(ref) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                var next = $9bf71ea28793e738$var$last(walker);
                if (next) $9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                var lastNode = $9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var next = $9bf71ea28793e738$var$last(walker);
            if (next) $9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $9bf71ea28793e738$var$last(walker) {
    var next = undefined;
    var last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
var $9bf71ea28793e738$var$Tree = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$Tree() {
        (0, _classCallCheck._)(this, $9bf71ea28793e738$var$Tree);
        this.fastMap = new Map();
        this.root = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    (0, _createClass._)($9bf71ea28793e738$var$Tree, [
        {
            key: "size",
            get: function get() {
                return this.fastMap.size;
            }
        },
        {
            key: "getTreeNode",
            value: function getTreeNode(data) {
                return this.fastMap.get(data);
            }
        },
        {
            key: "addTreeNode",
            value: function addTreeNode(scopeRef, parent, nodeToRestore) {
                var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
                if (!parentNode) return;
                var node = new $9bf71ea28793e738$var$TreeNode({
                    scopeRef: scopeRef
                });
                parentNode.addChild(node);
                node.parent = parentNode;
                this.fastMap.set(scopeRef, node);
                if (nodeToRestore) node.nodeToRestore = nodeToRestore;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                this.fastMap.set(node.scopeRef, node);
            }
        },
        {
            key: "removeTreeNode",
            value: function removeTreeNode(scopeRef) {
                // never remove the root
                if (scopeRef === null) return;
                var node = this.fastMap.get(scopeRef);
                if (!node) return;
                var parentNode = node.parent;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
                    // if we are, then replace the siblings restore with the restore from the scope we're removing
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var current = _step.value;
                        if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var children = node.children;
                if (parentNode) {
                    parentNode.removeChild(node);
                    if (children.size > 0) children.forEach(function(child) {
                        return parentNode && parentNode.addChild(child);
                    });
                }
                this.fastMap.delete(node.scopeRef);
            }
        },
        {
            key: "traverse",
            value: // Pre Order Depth First
            function traverse() {
                var node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, err;
                var _arguments = arguments;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.root;
                            if (!(node.scopeRef != null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                node
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!(node.children.size > 0)) return [
                                3,
                                10
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = node.children[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            child = _step.value;
                            return [
                                5,
                                (0, _tsValues._)(this.traverse(child))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "clone",
            value: function clone() {
                var _node_parent;
                var newTree = new $9bf71ea28793e738$var$Tree();
                var _node_parent_scopeRef;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newTree;
            }
        }
    ]);
    return $9bf71ea28793e738$var$Tree;
}();
var $9bf71ea28793e738$var$TreeNode = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$TreeNode(props) {
        (0, _classCallCheck._)(this, $9bf71ea28793e738$var$TreeNode);
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    (0, _createClass._)($9bf71ea28793e738$var$TreeNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.children.add(node);
                node.parent = this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.children.delete(node);
                node.parent = undefined;
            }
        }
    ]);
    return $9bf71ea28793e738$var$TreeNode;
}();
var $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f7dceffc5ad7768b$export$4e328f61c538687f() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = props.autoFocus, autoFocus = tmp === void 0 ? false : tmp, isTextInput = props.isTextInput, within = props.within;
    var state = (0, _react.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, _interactions.isFocusVisible)()
    });
    var _$6nfFC$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _$6nfFC$useState[0], setFocused = _$6nfFC$useState[1];
    var _$6nfFC$useState1 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return state.current.isFocused && state.current.isFocusVisible;
    }), 2), isFocusVisibleState = _$6nfFC$useState1[0], setFocusVisible = _$6nfFC$useState1[1];
    var updateState = (0, _react.useCallback)(function() {
        return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
    }, []);
    var onFocusChange = (0, _react.useCallback)(function(isFocused) {
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, _interactions.useFocusVisibleListener)(function(isFocusVisible) {
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    var _$6nfFC$useFocus = (0, _interactions.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    }), focusProps = _$6nfFC$useFocus.focusProps;
    var _$6nfFC$useFocusWithin = (0, _interactions.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    }), focusWithinProps = _$6nfFC$useFocusWithin.focusWithinProps;
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $907718708eab68af$export$1a38b4ad7f578e1d(props) {
    var children = props.children, focusClass = props.focusClass, focusRingClass = props.focusRingClass;
    var _$f7dceffc5ad7768b$export$4e328f61c538687f = $f7dceffc5ad7768b$export$4e328f61c538687f(props), isFocused = _$f7dceffc5ad7768b$export$4e328f61c538687f.isFocused, isFocusVisible = _$f7dceffc5ad7768b$export$4e328f61c538687f.isFocusVisible, focusProps = _$f7dceffc5ad7768b$export$4e328f61c538687f.focusProps;
    var child = (0, _reactDefault.default).Children.only(children);
    var _obj;
    return (0, _reactDefault.default).cloneElement(child, (0, _utils.mergeProps)(child.props, (0, _objectSpreadProps._)((0, _objectSpread._)({}, focusProps), {
        className: (0, _clsxDefault.default)((_obj = {}, (0, _defineProperty._)(_obj, focusClass || "", isFocused), (0, _defineProperty._)(_obj, focusRingClass || "", isFocusVisible), _obj))
    })));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e6afbd83fe6ebbd2$var$FocusableContext = (0, _reactDefault.default).createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    var context = (0, _react.useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, _utils.useSyncRef)(context, ref);
    // eslint-disable-next-line
    var _ = context.ref, otherProps = (0, _objectWithoutProperties._)(context, [
        "ref"
    ]);
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    var children = props.children, otherProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    var objRef = (0, _utils.useObjectRef)(ref);
    var context = (0, _objectSpreadProps._)((0, _objectSpread._)({}, otherProps), {
        ref: objRef
    });
    return (0, _reactDefault.default).createElement($e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
var $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5 = (0, _reactDefault.default).forwardRef($e6afbd83fe6ebbd2$var$FocusableProvider);
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
    var _$6nfFC$useFocus = (0, _interactions.useFocus)(props), focusProps = _$6nfFC$useFocus.focusProps;
    var _$6nfFC$useKeyboard = (0, _interactions.useKeyboard)(props), keyboardProps = _$6nfFC$useKeyboard.keyboardProps;
    var interactions = (0, _utils.mergeProps)(focusProps, keyboardProps);
    var domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    var interactionProps = props.isDisabled ? {} : domProps;
    var autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current && domRef.current) $6a99195332edec8b$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, _utils.mergeProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, interactions), {
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }), interactionProps)
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $83013635b024ae3d$export$eac1895992b9f3d6(ref, options) {
    var isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    var _$6nfFC$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hasTabbableChild = _$6nfFC$useState[0], setHasTabbableChild = _$6nfFC$useState[1];
    (0, _utils.useLayoutEffect)(function() {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            var update = function() {
                if (ref.current) {
                    var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            var observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return function() {
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_ts_generator":"HrSs8","@swc/helpers/_/_ts_values":"3HUTY","@react-aria/utils":"99Fak","react":"ktQNc","@react-aria/interactions":"7Ysj1","clsx":"k6xBP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1b19W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_call_check", function() {
    return _class_call_check;
});
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k0x0i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_create_class", function() {
    return _create_class;
});
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3HUTY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
parcelHelpers.export(exports, "_ts_values", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"eUtpo","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Ysj1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pressable", function() {
    return $3b117e43dc0ca95d$export$27c701ed9e449e99;
});
parcelHelpers.export(exports, "PressResponder", function() {
    return $f1ab8c75478c6f73$export$3351871ee4b288b8;
});
parcelHelpers.export(exports, "ClearPressResponder", function() {
    return $f1ab8c75478c6f73$export$cf75428e0b9ed1ea;
});
parcelHelpers.export(exports, "useFocus", function() {
    return $a1ea59d68270f0dd$export$f8168d8dd8fd66e6;
});
parcelHelpers.export(exports, "isFocusVisible", function() {
    return $507fabe10e71c6fb$export$b9b3dfddab17db27;
});
parcelHelpers.export(exports, "getInteractionModality", function() {
    return $507fabe10e71c6fb$export$630ff653c5ada6a9;
});
parcelHelpers.export(exports, "setInteractionModality", function() {
    return $507fabe10e71c6fb$export$8397ddfc504fdb9a;
});
parcelHelpers.export(exports, "addWindowFocusTracking", function() {
    return $507fabe10e71c6fb$export$2f1888112f558a7d;
});
parcelHelpers.export(exports, "useInteractionModality", function() {
    return $507fabe10e71c6fb$export$98e20ec92f614cfe;
});
parcelHelpers.export(exports, "useFocusVisible", function() {
    return $507fabe10e71c6fb$export$ffd9e5021c1fb2d6;
});
parcelHelpers.export(exports, "useFocusVisibleListener", function() {
    return $507fabe10e71c6fb$export$ec71b4b83ac08ec3;
});
parcelHelpers.export(exports, "useFocusWithin", function() {
    return $9ab94262bd0047c7$export$420e68273165f4ec;
});
parcelHelpers.export(exports, "useHover", function() {
    return $6179b936705e76d3$export$ae780daf29e6d456;
});
parcelHelpers.export(exports, "useInteractOutside", function() {
    return $e0b6e0b68ec7f50f$export$872b660ac5a1ff98;
});
parcelHelpers.export(exports, "useKeyboard", function() {
    return $46d819fcbaf35654$export$8f71654801c2f7cd;
});
parcelHelpers.export(exports, "useMove", function() {
    return $e8a7022cf87cba2a$export$36da96379f79f245;
});
parcelHelpers.export(exports, "usePress", function() {
    return $f6c31cce2adf654f$export$45712eceda6fad21;
});
parcelHelpers.export(exports, "useScrollWheel", function() {
    return $7d0a636d7a4dcefd$export$2123ff2b87c81ca;
});
parcelHelpers.export(exports, "useLongPress", function() {
    return $8a26561d2877236e$export$c24ed0104d07eab9;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _ssr = require("@react-aria/ssr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
var $14c0b72509d70225$var$state = "default";
var $14c0b72509d70225$var$savedUserSelect = "";
var $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, _utils.isIOS)()) {
        if ($14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            var documentObject = (0, _utils.getOwnerDocument)(target);
            $14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, _utils.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($14c0b72509d70225$var$state !== "disabled") return;
        $14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(function() {
            (0, _utils.runAfterTransition)(function() {
                // Avoid race conditions
                if ($14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    var documentObject = (0, _utils.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
                    $14c0b72509d70225$var$savedUserSelect = "";
                    $14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
            var targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, _reactDefault.default).createContext({
    register: function() {}
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    var context = (0, _react.useContext)($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        var register = context.register, contextProps = (0, _objectWithoutProperties._)(context, [
            "register"
        ]);
        props = (0, _utils.mergeProps)(contextProps, props);
        register();
    }
    (0, _utils.useSyncRef)(context, props.ref);
    return props;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
var $f6c31cce2adf654f$var$PressEvent = /*#__PURE__*/ function() {
    "use strict";
    function $f6c31cce2adf654f$var$PressEvent(type, pointerType, originalEvent) {
        (0, _classCallCheck._)(this, $f6c31cce2adf654f$var$PressEvent);
        (0, _classPrivateFieldInit._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
    (0, _createClass._)($f6c31cce2adf654f$var$PressEvent, [
        {
            key: "continuePropagation",
            value: function continuePropagation() {
                (0, _classPrivateFieldSet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, false);
            }
        },
        {
            key: "shouldStopPropagation",
            get: function get() {
                return (0, _classPrivateFieldGet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
            }
        }
    ]);
    return $f6c31cce2adf654f$var$PressEvent;
}();
var $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
    var _$f6c31cce2adf654f$var$usePressResponderContext = $f6c31cce2adf654f$var$usePressResponderContext(props), onPress = _$f6c31cce2adf654f$var$usePressResponderContext.onPress, onPressChange = _$f6c31cce2adf654f$var$usePressResponderContext.onPressChange, onPressStart = _$f6c31cce2adf654f$var$usePressResponderContext.onPressStart, onPressEnd = _$f6c31cce2adf654f$var$usePressResponderContext.onPressEnd, onPressUp = _$f6c31cce2adf654f$var$usePressResponderContext.onPressUp, isDisabled = _$f6c31cce2adf654f$var$usePressResponderContext.isDisabled, isPressedProp = _$f6c31cce2adf654f$var$usePressResponderContext.isPressed, preventFocusOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.preventFocusOnPress, shouldCancelOnPointerExit = _$f6c31cce2adf654f$var$usePressResponderContext.shouldCancelOnPointerExit, allowTextSelectionOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.allowTextSelectionOnPress, _ = _$f6c31cce2adf654f$var$usePressResponderContext.ref, domProps = (0, _objectWithoutProperties._)(_$f6c31cce2adf654f$var$usePressResponderContext, [
        "onPress",
        "onPressChange",
        "onPressStart",
        "onPressEnd",
        "onPressUp",
        "isDisabled",
        "isPressed",
        "preventFocusOnPress",
        "shouldCancelOnPointerExit",
        "allowTextSelectionOnPress",
        "ref"
    ]);
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPressed = _$bx7SL$useState[0], setPressed = _$bx7SL$useState[1];
    var ref = (0, _react.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$bx7SL$useGlobalListeners.removeAllGlobalListeners;
    var triggerPressStart = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        var shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            var event = new $f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    var triggerPressEnd = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var wasPressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        var shouldStopPropagation = true;
        if (onPressEnd) {
            var event = new $f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            var event1 = new $f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event1);
            shouldStopPropagation && (shouldStopPropagation = event1.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    var triggerPressUp = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            var event = new $f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    var cancel = (0, _utils.useEffectEvent)(function(e) {
        var state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
    });
    var cancelOnPointerExit = (0, _utils.useEffectEvent)(function(e) {
        if (shouldCancelOnPointerExit) cancel(e);
    });
    var pressProps = (0, _react.useMemo)(function() {
        var state = ref.current;
        var pressProps = {
            onKeyDown: function(e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    var shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        var originalTarget = e.currentTarget;
                        var pressUp = function(e) {
                            if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "keyup", (0, _utils.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, _utils.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick: function(e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, _utils.openLink).isOpening) {
                    var shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, _utils.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                        var stopPressStart = triggerPressStart(e, "virtual");
                        var stopPressUp = triggerPressUp(e, "virtual");
                        var stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        var onKeyUp = function(e) {
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                var target = e.target;
                triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, _utils.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                var events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = events.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var event = _step.value;
                        (_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = function(e) {
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, _utils.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                var shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = function(e) {
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            var onPointerMove = function(e) {
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            var onPointerUp = function(e) {
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            var onPointerCancel = function(e) {
                cancel(e);
            };
            pressProps.onDragStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = function(e) {
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, _utils.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                var shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            var onMouseUp = function(e) {
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                var shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                var shouldStopPropagation = true;
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                var shouldStopPropagation = true;
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            var onScroll = function(e) {
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            var _ref_current_target;
            if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, _utils.mergeProps)(domProps, pressProps)
    };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    var key = event.key, code = event.code;
    var element = currentTarget;
    var role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, _utils.getOwnerWindow)(element).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, _utils.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
    var targetTouches = event.targetTouches;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    var changedTouches = event.changedTouches;
    for(var i = 0; i < changedTouches.length; i++){
        var touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
    var offsetX = 0;
    var offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
    var rect = target.getBoundingClientRect();
    var pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
    return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
var $f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
var $3b117e43dc0ca95d$export$27c701ed9e449e99 = (0, _reactDefault.default).forwardRef(function(_param, ref) {
    var children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    ref = (0, _utils.useObjectRef)(ref);
    var _$f6c31cce2adf654f$export$45712eceda6fad21 = $f6c31cce2adf654f$export$45712eceda6fad21((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref
    })), pressProps = _$f6c31cce2adf654f$export$45712eceda6fad21.pressProps;
    var child = (0, _reactDefault.default).Children.only(children);
    return (0, _reactDefault.default).cloneElement(child, (0, _objectSpread._)({
        ref: ref
    }, (0, _utils.mergeProps)(child.props, pressProps)));
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f1ab8c75478c6f73$export$3351871ee4b288b8 = (0, _reactDefault.default).forwardRef(function(_param, ref) {
    var children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    var isRegistered = (0, _react.useRef)(false);
    var prevContext = (0, _react.useContext)($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    ref = (0, _utils.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    var context = (0, _utils.mergeProps)(prevContext || {}, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref,
        register: function() {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    }));
    (0, _utils.useSyncRef)(prevContext, ref);
    (0, _react.useEffect)(function() {
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, _reactDefault.default).createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea(param) {
    var children = param.children;
    var context = (0, _react.useMemo)(function() {
        return {
            register: function() {}
        };
    }, []);
    return (0, _reactDefault.default).createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8a9cb279dc87e130$export$905e7fc544a71f36 = /*#__PURE__*/ function() {
    "use strict";
    function $8a9cb279dc87e130$export$905e7fc544a71f36(type, nativeEvent) {
        (0, _classCallCheck._)(this, $8a9cb279dc87e130$export$905e7fc544a71f36);
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
    (0, _createClass._)($8a9cb279dc87e130$export$905e7fc544a71f36, [
        {
            key: "isDefaultPrevented",
            value: function isDefaultPrevented() {
                return this.nativeEvent.defaultPrevented;
            }
        },
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
                this.nativeEvent.preventDefault();
            }
        },
        {
            key: "stopPropagation",
            value: function stopPropagation() {
                this.nativeEvent.stopPropagation();
                this.isPropagationStopped = function() {
                    return true;
                };
            }
        },
        {
            key: "isPropagationStopped",
            value: function isPropagationStopped() {
                return false;
            }
        },
        {
            key: "persist",
            value: function persist() {}
        }
    ]);
    return $8a9cb279dc87e130$export$905e7fc544a71f36;
}();
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    var stateRef = (0, _react.useRef)({
        isFocused: false,
        observer: null
    });
    (0, _utils.useLayoutEffect)(function() {
        var state = stateRef.current;
        return function() {
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    var dispatchBlur = (0, _utils.useEffectEvent)(function(e) {
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, _react.useCallback)(function(e) {
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            var target = e.target;
            var onBlurHandler = function(e) {
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(function() {
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    var relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
    var isDisabled = props.isDisabled, onFocusProp = props.onFocus, onBlurProp = props.onBlur, onFocusChange = props.onFocusChange;
    var onBlur = (0, _react.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    var onFocus = (0, _react.useCallback)(function(e) {
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = new Set();
var $507fabe10e71c6fb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
var $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $507fabe10e71c6fb$var$changeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            handler(modality, e);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, _utils.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($507fabe10e71c6fb$var$isValidKey(e)) {
        $507fabe10e71c6fb$var$currentModality = "keyboard";
        $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
    $507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, _utils.isVirtualClick)(e)) {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $507fabe10e71c6fb$var$currentModality = "virtual";
        $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get((0, _utils.getOwnerWindow)(element))) return;
    var windowObject = (0, _utils.getOwnerWindow)(element);
    var documentObject = (0, _utils.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    var focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", function() {
        $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
var $507fabe10e71c6fb$var$tearDownWindowFocusTracking = function(element, loadListener) {
    var windowObject = (0, _utils.getOwnerWindow)(element);
    var documentObject = (0, _utils.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
    var documentObject = (0, _utils.getOwnerDocument)(element);
    var loadListener;
    if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = function() {
            $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return function() {
        return $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
    };
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
    return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
    return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
    $507fabe10e71c6fb$var$currentModality = modality;
    $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $507fabe10e71c6fb$export$98e20ec92f614cfe() {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)($507fabe10e71c6fb$var$currentModality), 2), modality = _$bx7SL$useState[0], setModality = _$bx7SL$useState[1];
    (0, _react.useEffect)(function() {
        var handler = function() {
            setModality($507fabe10e71c6fb$var$currentModality);
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, _ssr.useIsSSR)() ? null : modality;
}
var $507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    var IHTMLInputElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    var IHTMLTextAreaElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    var IHTMLElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    var IKeyboardEvent = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ffd9e5021c1fb2d6() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isTextInput = props.isTextInput, autoFocus = props.autoFocus;
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()), 2), isFocusVisibleState = _$bx7SL$useState[0], setFocusVisible = _$bx7SL$useState[1];
    $507fabe10e71c6fb$export$ec71b4b83ac08ec3(function(isFocusVisible) {
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, _react.useEffect)(function() {
        var handler = function(modality, e) {
            if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
    var isDisabled = props.isDisabled, onBlurWithin = props.onBlurWithin, onFocusWithin = props.onFocusWithin, onFocusWithinChange = props.onFocusWithinChange;
    var state = (0, _react.useRef)({
        isFocusWithin: false
    });
    var onBlur = (0, _react.useCallback)(function(e) {
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    var onFocus = (0, _react.useCallback)(function(e) {
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
var $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(function() {
        $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6179b936705e76d3$var$hoverCount++;
    return function() {
        $6179b936705e76d3$var$hoverCount--;
        if ($6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
    var onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, isDisabled = props.isDisabled;
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isHovered = _$bx7SL$useState[0], setHovered = _$bx7SL$useState[1];
    var state = (0, _react.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, _react.useEffect)($6179b936705e76d3$var$setupGlobalTouchEvents, []);
    var _$bx7SL$useMemo = (0, _react.useMemo)(function() {
        var triggerHoverStart = function(event, pointerType) {
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            var target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        var triggerHoverEnd = function(event, pointerType) {
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            var target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        var hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = function(e) {
                if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = function(e) {
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = function() {
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = function(e) {
                if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = function(e) {
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]), hoverProps = _$bx7SL$useMemo.hoverProps, triggerHoverEnd = _$bx7SL$useMemo.triggerHoverEnd;
    (0, _react.useEffect)(function() {
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
    var ref = props.ref, onInteractOutside = props.onInteractOutside, isDisabled = props.isDisabled, onInteractOutsideStart = props.onInteractOutsideStart;
    var stateRef = (0, _react.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    var onPointerDown = (0, _utils.useEffectEvent)(function(e) {
        if (onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    var triggerInteractOutside = (0, _utils.useEffectEvent)(function(e) {
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, _react.useEffect)(function() {
        var state = stateRef.current;
        if (isDisabled) return;
        var element = ref.current;
        var documentObject = (0, _utils.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            var onPointerUp = function(e) {
                if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return function() {
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            var onMouseUp = function(e) {
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            var onTouchEnd = function(e) {
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return function() {
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        var ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    var shouldStopPropagation = true;
    return function(e) {
        var event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            preventDefault: function() {
                e.preventDefault();
            },
            isDefaultPrevented: function() {
                return e.isDefaultPrevented();
            },
            stopPropagation: function() {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation: function() {
                shouldStopPropagation = false;
            }
        });
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e8a7022cf87cba2a$export$36da96379f79f245(props) {
    var onMoveStart = props.onMoveStart, onMove = props.onMove, onMoveEnd = props.onMoveEnd;
    var state = (0, _react.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeGlobalListener = _$bx7SL$useGlobalListeners.removeGlobalListener;
    var move = (0, _utils.useEffectEvent)(function(originalEvent, pointerType, deltaX, deltaY) {
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: "movestart",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: "move",
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    var end = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        $14c0b72509d70225$export$b0d6fa1ab32e3295();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: "moveend",
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    var moveProps = (0, _react.useMemo)(function() {
        var moveProps = {};
        var start = function() {
            $14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            var onMouseMove = function(e) {
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            var onMouseUp = function(e) {
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = function(e) {
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            var onTouchMove = function(e) {
                var touch = (0, _toConsumableArray._)(e.changedTouches).findIndex(function(param) {
                    var identifier = param.identifier;
                    return identifier === state.current.id;
                });
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _e_changedTouches_touch = e.changedTouches[touch], pageX = _e_changedTouches_touch.pageX, pageY = _e_changedTouches_touch.pageY;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            var onTouchEnd = function(e) {
                var touch = (0, _toConsumableArray._)(e.changedTouches).findIndex(function(param) {
                    var identifier = param.identifier;
                    return identifier === state.current.id;
                });
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = function(e) {
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                var _e_changedTouches_ = e.changedTouches[0], pageX = _e_changedTouches_.pageX, pageY = _e_changedTouches_.pageY, identifier = _e_changedTouches_.identifier;
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            var onPointerMove = function(e) {
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            var onPointerUp = function(e) {
                if (e.pointerId === state.current.id) {
                    var pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = function(e) {
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        var triggerKeyboardMove = function(e, deltaX, deltaY) {
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = function(e) {
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7d0a636d7a4dcefd$export$2123ff2b87c81ca(props, ref) {
    var onScroll = props.onScroll, isDisabled = props.isDisabled;
    var onScrollHandler = (0, _react.useCallback)(function(e) {
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, _utils.useEvent)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
    var isDisabled = props.isDisabled, onLongPressStart = props.onLongPressStart, onLongPressEnd = props.onLongPressEnd, onLongPress = props.onLongPress, tmp = props.threshold, threshold = tmp === void 0 ? $8a26561d2877236e$var$DEFAULT_THRESHOLD : tmp, accessibilityDescription = props.accessibilityDescription;
    var timeRef = (0, _react.useRef)();
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeGlobalListener = _$bx7SL$useGlobalListeners.removeGlobalListener;
    var _$f6c31cce2adf654f$export$45712eceda6fad21 = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart: function(e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                    type: "longpressstart"
                }));
                timeRef.current = setTimeout(function() {
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                        type: "longpress"
                    }));
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    var onContextMenu = function(e) {
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", function() {
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(function() {
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd: function(e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                type: "longpressend"
            }));
        }
    }), pressProps = _$f6c31cce2adf654f$export$45712eceda6fad21.pressProps;
    var descriptionProps = (0, _utils.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, _utils.mergeProps)(pressProps, descriptionProps)
    };
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@react-aria/utils":"99Fak","react":"ktQNc","@swc/helpers/_/_class_private_field_get":"aTr5X","@swc/helpers/_/_class_private_field_init":"f5jxq","@swc/helpers/_/_class_private_field_set":"CcybI","@react-aria/ssr":"8ZKMZ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aTr5X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_get", function() {
    return _class_private_field_get;
});
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_get;
});
var _classApplyDescriptorGetJs = require("./_class_apply_descriptor_get.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_get(receiver, privateMap) {
    var descriptor = (0, _classExtractFieldDescriptorJs._class_extract_field_descriptor)(receiver, privateMap, "get");
    return (0, _classApplyDescriptorGetJs._class_apply_descriptor_get)(receiver, descriptor);
}

},{"./_class_apply_descriptor_get.js":"iBDrH","./_class_extract_field_descriptor.js":"iy6Z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iBDrH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_apply_descriptor_get", function() {
    return _class_apply_descriptor_get;
});
parcelHelpers.export(exports, "_", function() {
    return _class_apply_descriptor_get;
});
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iy6Z0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_extract_field_descriptor", function() {
    return _class_extract_field_descriptor;
});
parcelHelpers.export(exports, "_", function() {
    return _class_extract_field_descriptor;
});
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f5jxq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_init", function() {
    return _class_private_field_init;
});
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_init;
});
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_field_init(obj, privateMap, value) {
    (0, _checkPrivateRedeclarationJs._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

},{"./_check_private_redeclaration.js":"keckX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"keckX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_check_private_redeclaration", function() {
    return _check_private_redeclaration;
});
parcelHelpers.export(exports, "_", function() {
    return _check_private_redeclaration;
});
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"CcybI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_set", function() {
    return _class_private_field_set;
});
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_set;
});
var _classApplyDescriptorSetJs = require("./_class_apply_descriptor_set.js");
var _classExtractFieldDescriptorJs = require("./_class_extract_field_descriptor.js");
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = (0, _classExtractFieldDescriptorJs._class_extract_field_descriptor)(receiver, privateMap, "set");
    (0, _classApplyDescriptorSetJs._class_apply_descriptor_set)(receiver, descriptor, value);
    return value;
}

},{"./_class_apply_descriptor_set.js":"hEZkg","./_class_extract_field_descriptor.js":"iy6Z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hEZkg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_apply_descriptor_set", function() {
    return _class_apply_descriptor_set;
});
parcelHelpers.export(exports, "_", function() {
    return _class_apply_descriptor_set;
});
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hbQmE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconSizeDefault", function() {
    return iconSizeDefault;
});
parcelHelpers.export(exports, "StyledControlButton", function() {
    return StyledControlButton;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _commonStyles = require("Permafrost/components/ui-foundations/buttons/commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  height: calc(",
        " * 2);\n  width: ",
        ";\n\n  // todo: default override\n  &[type='button'] {\n    padding: 0;\n    ",
        "\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var buttonStyles = {
    reject: (0, _commonStyles.variantDestructive),
    submit: (0, _commonStyles.variantPrimary),
    restore: (0, _commonStyles.variantPrimary),
    "step-forward": (0, _commonStyles.variantDefault)
};
var iconSizeDefault = "16px";
var StyledControlButton = (0, _styledComponentsDefault.default).button(_templateObject(), (0, _commonStyles.basicDefaults), iconSizeDefault, function(props) {
    return "calc(".concat(props.$iconSize, " * 2)");
}, function(props) {
    return buttonStyles[props.$buttonType];
}, (0, _commonStyles.disabledOverrides));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/components/ui-foundations/buttons/commonStyles":"eg1Ne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eg1Ne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultHeight", function() {
    return defaultHeight;
});
parcelHelpers.export(exports, "largeHeight", function() {
    return largeHeight;
});
parcelHelpers.export(exports, "basicDefaults", function() {
    return basicDefaults;
});
parcelHelpers.export(exports, "defaults", function() {
    return defaults;
});
parcelHelpers.export(exports, "sizeLarge", function() {
    return sizeLarge;
});
parcelHelpers.export(exports, "variantDefault", function() {
    return variantDefault;
});
parcelHelpers.export(exports, "variantPrimary", function() {
    return variantPrimary;
});
parcelHelpers.export(exports, "variantDestructive", function() {
    return variantDestructive;
});
parcelHelpers.export(exports, "disabledOverrides", function() {
    return disabledOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 0;\n  display: inline-block;\n  cursor: pointer;\n\n  border-radius: 2px;\n  box-shadow: 0 1px 1px 0 ",
        ";\n\n  &.busy {\n    cursor: wait;\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &:not(.focus-visible) {\n    outline: none;\n  }\n\n  transition-property: opacity, background-color;\n  transition-duration: ",
        ";\n  transition-timing-function: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  height: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n\n  padding: 0 1em !important;\n\n  & + button {\n    margin-left: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n\n  &:hover {\n    background-color: #bebebe;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: #1777c2;\n    color: ",
        ";\n\n    &:disabled {\n      background-color: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: #d4464b;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:disabled,\n  &.disabled {\n    &:hover {\n      // todo: override due to default global styling\n      background-color: ",
        " !important;\n\n      &.primary {\n        // todo: override due to default global styling\n        background-color: ",
        " !important;\n      }\n\n      &.destructive {\n        // todo: override due to default global styling\n        background-color: ",
        " !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var defaultHeight = "36px";
var largeHeight = "50px";
var basicDefaults = (0, _styledComponents.css)(_templateObject(), (0, _index.COLORS).black, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing);
var defaults = (0, _styledComponents.css)(_templateObject1(), basicDefaults, defaultHeight, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.TYPOGRAPHY).fontFamily.base);
var sizeLarge = (0, _styledComponents.css)(_templateObject2(), largeHeight, (0, _index.TYPOGRAPHY).fontSize.subheadLarge);
var variantDefault = (0, _styledComponents.css)(_templateObject3(), (0, _index.COLORS).darkFontColor, (0, _index.COLORS).iron);
var variantPrimary = (0, _styledComponents.css)(_templateObject4(), (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.COLORS).white, (0, _index.COLORS).curiousBlue);
var variantDestructive = (0, _styledComponents.css)(_templateObject5(), (0, _index.COLORS).red, (0, _index.COLORS).white, (0, _index.COLORS).white);
var disabledOverrides = (0, _styledComponents.css)(_templateObject6(), (0, _index.COLORS).iron, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).red);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3d71L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenerateReport", function() {
    return GenerateReport;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _generateReportStyles = require("./GenerateReport.styles");
var GenerateReport = function(props) {
    var actionHandler = props.actionHandler, className = props.className, disabled = props.disabled, downloadReady = props.downloadReady, id = props.id, isPolling = props.isPolling, tooLarge = props.tooLarge;
    if (tooLarge) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _generateReportStyles.StyledTooLarge), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "too-large-message",
                children: "There is too much data to generate a report. Please use our client libraries."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "https://docs.indico.io",
                target: "_blank",
                rel: "noreferrer",
                className: "docs-link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "LinkList-Text",
                    children: "How to Generate a Large Report"
                })
            })
        ]
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generateReportStyles.StyledGenerateReport), {
        "aria-label": "Generate and Download Report",
        className: (0, _classnamesDefault.default)("generate-button", className, downloadReady ? "download normal" : "generate cta"),
        "data-cy": props["data-cy"],
        disabled: disabled || isPolling,
        id: id,
        onClick: function() {
            return actionHandler();
        },
        children: downloadReady ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "fa-file-download",
                    size: [
                        14
                    ]
                }),
                " Download Report"
            ]
        }) : isPolling ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {}),
                " Generating..."
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "plus",
                    size: [
                        14
                    ]
                }),
                " Generate Report"
            ]
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./GenerateReport.styles":"ewnhS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ewnhS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTooLarge", function() {
    return StyledTooLarge;
});
parcelHelpers.export(exports, "StyledGenerateReport", function() {
    return StyledGenerateReport;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-left: 15px;\n\n  .too-large-message {\n    color: ",
        ";\n  }\n\n  .docs-link {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 36px;\n  font-size: 14px !important;\n  margin-left: 15px;\n\n  svg {\n    vertical-align: top;\n    margin-right: 5px;\n  }\n\n  &:disabled {\n    opacity: 0.4;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTooLarge = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).red);
var StyledGenerateReport = (0, _styledComponentsDefault.default)((0, _index.Button))(_templateObject1());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aQAJo":[function(require,module,exports) {
// todo: styling from the mock does not fully match the current button style implementation.
//  will be updated during permafrost refactor tasks - 4/21 jm
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconButton", function() {
    return IconButton;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _button = require("@react-aria/button");
var _focus = require("@react-aria/focus");
var _index = require("Permafrost/index");
var _iconButtonStyles = require("./IconButton.styles");
var IconButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var _props_adjustAlignment = props.adjustAlignment, adjustAlignment = _props_adjustAlignment === void 0 ? 0 : _props_adjustAlignment, busy = props.busy, className = props.className, iconName = props.iconName, _props_iconSide = props.iconSide, iconSide = _props_iconSide === void 0 ? "start" : _props_iconSide, id = props.id, isDisabled = props.isDisabled, isLink = props.isLink, label = props.label, _props_size = props.size, size = _props_size === void 0 ? "normal" : _props_size, style = props.style, variant = props.variant;
    var buttonRef = (0, _react.useRef)(null);
    var anchorRef = (0, _react.useRef)(null);
    var elementRef = isLink ? anchorRef : buttonRef;
    var buttonProps = (0, _button.useButton)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onPress: busy ? undefined : props.onPress
    }), elementRef).buttonProps;
    // Exposes select methods on the internal button ref to the parent component
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            // Timeout places the focus at the end of the event queue to ensure the button is focusable
            focus: function() {
                return setTimeout(function() {
                    var _elementRef_current;
                    return (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.focus();
                }, 0);
            },
            contains: function(el) {
                var _elementRef_current;
                return !!((_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.contains(el));
            }
        };
    });
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var commonProps = (0, _objectSpreadProps._)((0, _objectSpread._)({
        "aria-disabled": busy,
        className: (0, _classnamesDefault.default)(iconSide, size, variant, className, {
            "focus-visible": isFocusVisible,
            busy: busy,
            disabled: isLink && isDisabled
        })
    }, buttonProps, focusProps), {
        "data-cy": props["data-cy"],
        id: id,
        style: style
    });
    var iconElement = busy ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {
        size: "1em",
        style: {
            marginTop: "".concat(adjustAlignment, "px"),
            marginBottom: "".concat(Math.abs(adjustAlignment), "px")
        }
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
        className: (0, _classnamesDefault.default)({
            "right-margin": label
        }),
        name: iconName
    });
    var labelElement = label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        style: {
            marginTop: "".concat(adjustAlignment, "px")
        },
        children: label
    }) : null;
    if (isLink && !isDisabled) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _iconButtonStyles.StyledIconButtonLink), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
        ref: anchorRef,
        to: isLink,
        children: [
            iconElement,
            " ",
            labelElement
        ]
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _iconButtonStyles.StyledIconButton), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonProps), {
        ref: buttonRef,
        children: [
            iconElement,
            " ",
            labelElement
        ]
    }));
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@react-aria/button":"3Kuyu","@react-aria/focus":"dmSXv","Permafrost/index":"iliLC","./IconButton.styles":"2kXex","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2kXex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconButton", function() {
    return iconButton;
});
parcelHelpers.export(exports, "StyledIconButton", function() {
    return StyledIconButton;
});
parcelHelpers.export(exports, "StyledIconButtonLink", function() {
    return StyledIconButtonLink;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactRouterDom = require("react-router-dom");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n\n  ",
        ";\n\n  svg {\n    height: 16px;\n    width: 16px;\n  }\n\n  &.large {\n    ",
        ";\n\n    svg {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n  &.default {\n    ",
        ";\n  }\n\n  &.destructive {\n    ",
        ";\n  }\n\n  &.primary {\n    ",
        ";\n  }\n\n  // todo: use this rule/selector after global styling removed\n  //:not(:disabled):hover {\n  //  background-color: #bebebe;\n  //}\n  ",
        ";\n\n  &.start {\n    svg.right-margin {\n      margin-right: ",
        ";\n    }\n  }\n\n  &.end {\n    svg {\n      order: 1;\n      margin-left: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // todo: overrides the global button styling\n  display: flex !important;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // todo: overrides the global button styling\n  display: inline-flex !important;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var iconMargin = "0.5em";
var iconButton = (0, _styledComponents.css)(_templateObject(), (0, _commonStyles.defaults), (0, _commonStyles.sizeLarge), (0, _commonStyles.variantDefault), (0, _commonStyles.variantDestructive), (0, _commonStyles.variantPrimary), (0, _commonStyles.disabledOverrides), iconMargin, iconMargin);
var StyledIconButton = (0, _styledComponentsDefault.default).button(_templateObject1(), iconButton);
var StyledIconButtonLink = (0, _styledComponentsDefault.default)((0, _reactRouterDom.Link))(_templateObject2(), iconButton);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-router-dom":"6Au42","../commonStyles":"eg1Ne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Au42":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _reactRouter.MemoryRouter;
});
parcelHelpers.export(exports, "Prompt", function() {
    return 0, _reactRouter.Prompt;
});
parcelHelpers.export(exports, "Redirect", function() {
    return 0, _reactRouter.Redirect;
});
parcelHelpers.export(exports, "Route", function() {
    return 0, _reactRouter.Route;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _reactRouter.Router;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return 0, _reactRouter.StaticRouter;
});
parcelHelpers.export(exports, "Switch", function() {
    return 0, _reactRouter.Switch;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _reactRouter.generatePath;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _reactRouter.matchPath;
});
parcelHelpers.export(exports, "useHistory", function() {
    return 0, _reactRouter.useHistory;
});
parcelHelpers.export(exports, "useLocation", function() {
    return 0, _reactRouter.useLocation;
});
parcelHelpers.export(exports, "useParams", function() {
    return 0, _reactRouter.useParams;
});
parcelHelpers.export(exports, "useRouteMatch", function() {
    return 0, _reactRouter.useRouteMatch;
});
parcelHelpers.export(exports, "withRouter", function() {
    return 0, _reactRouter.withRouter;
});
parcelHelpers.export(exports, "BrowserRouter", function() {
    return BrowserRouter;
});
parcelHelpers.export(exports, "HashRouter", function() {
    return HashRouter;
});
parcelHelpers.export(exports, "Link", function() {
    return Link;
});
parcelHelpers.export(exports, "NavLink", function() {
    return NavLink;
});
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"7jQJW","@babel/runtime/helpers/esm/inheritsLoose":"bwuGa","react":"ktQNc","history":"bx7k2","prop-types":"8INHm","tiny-warning":"gTZSq","@babel/runtime/helpers/esm/extends":"9S0TS","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"2RW69","tiny-invariant":"5gG5R","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7jQJW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
parcelHelpers.export(exports, "Prompt", function() {
    return Prompt;
});
parcelHelpers.export(exports, "Redirect", function() {
    return Redirect;
});
parcelHelpers.export(exports, "Route", function() {
    return Route;
});
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
parcelHelpers.export(exports, "StaticRouter", function() {
    return StaticRouter;
});
parcelHelpers.export(exports, "Switch", function() {
    return Switch;
});
parcelHelpers.export(exports, "__HistoryContext", function() {
    return historyContext;
});
parcelHelpers.export(exports, "__RouterContext", function() {
    return context;
});
parcelHelpers.export(exports, "generatePath", function() {
    return generatePath;
});
parcelHelpers.export(exports, "matchPath", function() {
    return matchPath;
});
parcelHelpers.export(exports, "useHistory", function() {
    return useHistory;
});
parcelHelpers.export(exports, "useLocation", function() {
    return useLocation;
});
parcelHelpers.export(exports, "useParams", function() {
    return useParams;
});
parcelHelpers.export(exports, "useRouteMatch", function() {
    return useRouteMatch;
});
parcelHelpers.export(exports, "withRouter", function() {
    return withRouter;
});
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _miniCreateReactContext = require("mini-create-react-context");
var _miniCreateReactContextDefault = parcelHelpers.interopDefault(_miniCreateReactContext);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = (0, _miniCreateReactContextDefault.default)();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"bwuGa","react":"ktQNc","prop-types":"8INHm","history":"bx7k2","tiny-warning":"gTZSq","mini-create-react-context":"4Zjym","tiny-invariant":"5gG5R","@babel/runtime/helpers/esm/extends":"9S0TS","path-to-regexp":"a6d1G","react-is":"iU89U","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"2RW69","hoist-non-react-statics":"kIv5Y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bwuGa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inheritsLoose;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"kg9ht","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8INHm":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"dFxC4"}],"dFxC4":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"i6Jgz"}],"i6Jgz":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;

},{}],"bx7k2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createLocation", function() {
    return createLocation;
});
parcelHelpers.export(exports, "locationsAreEqual", function() {
    return locationsAreEqual;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, _$state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: _$state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = stripHash(window.location.href);
        return href + "#" + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(_$path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var _$path = createPath(location);
            var encodedPath = encodePath(basename + _$path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = _$path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = _$path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = "PUSH";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"9S0TS","resolve-pathname":"2CtMq","value-equal":"ltN7z","tiny-warning":"gTZSq","tiny-invariant":"5gG5R","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9S0TS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2CtMq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") spliceOne(fromParts, i);
        else if (part === "..") {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ltN7z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gTZSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5gG5R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return invariant;
});
var isProduction = true;
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4Zjym":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, _inheritsLooseDefault.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _react.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _react.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var index = (0, _reactDefault.default).createContext || createReactContext;
exports.default = index;

},{"react":"ktQNc","@babel/runtime/helpers/esm/inheritsLoose":"bwuGa","prop-types":"8INHm","tiny-warning":"gTZSq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a6d1G":[function(require,module,exports) {
var isarray = require("cf8c389b9beef7f4");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : "[^" + escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var _$options = opts || {};
        var encode = _$options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"cf8c389b9beef7f4":"be8U2"}],"be8U2":[function(require,module,exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

},{}],"iU89U":[function(require,module,exports) {
"use strict";
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1OYEf"}],"1OYEf":[function(require,module,exports) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"2RW69":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kIv5Y":[function(require,module,exports) {
"use strict";
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"iU89U"}],"kw0QR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return 0, _segmentedControlButtons.SegmentedControlButtons;
});
var _segmentedControlButtons = require("./SegmentedControlButtons");

},{"./SegmentedControlButtons":"8VaHb","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8VaHb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return SegmentedControlButtons;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _values = require("Permafrost/styles/values");
var _controlButtonStyles = require("../ControlButton/ControlButton.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  border-radius: ",
        ";\n  box-shadow: 0 1px 1px 0 #000;\n\n  button {\n    // todo: override global\n    padding: 0 !important;\n    box-shadow: 0 0 1px 0 #000 !important;\n\n    height: calc(",
        " * 2);\n    width: calc(",
        " * 2);\n\n    &:first-of-type {\n      border-radius: ",
        " 0 0 ",
        ";\n    }\n\n    &:last-of-type {\n      border-radius: 0 ",
        " ",
        " 0;\n    }\n\n    &:not(:first-of-type):not(:last-of-type) {\n      border-radius: 0;\n    }\n\n    &:disabled {\n      opacity: 0.7;\n    }\n\n    &:focus {\n      // ensures focus ring has no overlap with sibling buttons\n      transform: rotate(0);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SegmentedControlButtons = (0, _styledComponentsDefault.default).div.attrs(function() {
    return {
        role: "group"
    };
})(_templateObject(), (0, _values.buttonBorderRadius), (0, _controlButtonStyles.iconSizeDefault), (0, _controlButtonStyles.iconSizeDefault), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/styles/values":"avAcu","../ControlButton/ControlButton.styles":"hbQmE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"avAcu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buttonBorderRadius", function() {
    return buttonBorderRadius;
});
var buttonBorderRadius = "2px";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bWP3o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackToLink", function() {
    return 0, _backToLink.BackToLink;
});
var _backToLink = require("./BackToLink");

},{"./BackToLink":"icrCr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"icrCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Found on item detail pages; used to navigate to the current module’s list page.
 * If an action needs to occur in addition to navigation, pass a handler into the
 * `onClick` prop.
 *
 * If navigation is not needed and nothing is provided to the `to` prop, this
 * component will be rendered as a button element.
 */ parcelHelpers.export(exports, "BackToLink", function() {
    return BackToLink;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
var _button = require("Permafrost/components/ui-foundations/buttons/Button/Button");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n  line-height: 20px !important;\n  font-size: ",
        " !important;\n  width: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BackToLink(props) {
    var className = props.className, id = props.id, onClick = props.onClick, text = props.text, to = props.to, style = props.style;
    var attributes = {
        // override the element’s innerText so AT ignores the left-angle quote character
        "aria-label": text ? text : "Back",
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style
    };
    if (to !== undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBackToLink, (0, _objectSpreadProps._)((0, _objectSpread._)({
        to: to,
        onClick: onClick
    }, attributes), {
        children: [
            "\xab ",
            text ? text : "Back"
        ]
    }));
    else if (onClick !== undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBackToLink, (0, _objectSpreadProps._)((0, _objectSpread._)({
        as: (0, _button.Button),
        onClick: onClick,
        variant: "link-style"
    }, attributes), {
        children: [
            "\xab ",
            text ? text : "Back"
        ]
    }));
    return null;
}
var StyledBackToLink = (0, _styledComponentsDefault.default)((0, _reactRouterDom.Link)).attrs(function(props) {
    return {
        as: props.as
    };
})(_templateObject(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall);

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_tagged_template_literal":"9gf6S","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","Permafrost/components/ui-foundations/buttons/Button/Button":"gPP3j","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9lp1V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiCombobox", function() {
    return 0, _multiCombobox.MultiCombobox;
});
parcelHelpers.export(exports, "SingleCombobox", function() {
    return 0, _singleCombobox.SingleCombobox;
});
parcelHelpers.export(exports, "CreateableSelect", function() {
    return 0, _createableSelect.CreateableSelect;
});
parcelHelpers.export(exports, "useCombobox", function() {
    return 0, _useCombobox.useCombobox;
});
parcelHelpers.export(exports, "BorderSelect", function() {
    return 0, _borderSelect.BorderSelect;
});
parcelHelpers.export(exports, "Select", function() {
    return 0, _select.Select;
});
parcelHelpers.export(exports, "Filter", function() {
    return 0, _filter.Filter;
});
parcelHelpers.export(exports, "FilterSelect", function() {
    return 0, _filterSelect.FilterSelect;
});
var _multiCombobox = require("./MultiCombobox/MultiCombobox");
var _singleCombobox = require("./SingleCombobox/SingleCombobox");
var _createableSelect = require("./CreateableSelect/CreateableSelect");
var _useCombobox = require("./useCombobox");
var _borderSelect = require("./BorderSelect/BorderSelect");
var _select = require("./Select/Select");
var _filter = require("./Filter/Filter");
var _filterSelect = require("./FilterSelect/FilterSelect");

},{"./MultiCombobox/MultiCombobox":"dQNJS","./SingleCombobox/SingleCombobox":"l9A9t","./CreateableSelect/CreateableSelect":"2qco7","./useCombobox":"e1QeV","./BorderSelect/BorderSelect":"hbX3C","./Select/Select":"gyv5P","./Filter/Filter":"dGfIJ","./FilterSelect/FilterSelect":"dXInN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dQNJS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiCombobox", function() {
    return MultiCombobox;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("Permafrost/index");
var _utils = require("Permafrost/components/ui-foundations/dropdowns/utils");
var _multiComboboxStyles = require("./MultiCombobox.styles");
var MultiCombobox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var className = props.className, closeMenuOnSelect = props.closeMenuOnSelect, customOption = props.customOption, customOptionLabel = props.customOptionLabel, customOptionValue = props.customOptionValue, defaultValue = props.defaultValue, disabled = props.disabled, id = props.id, loading = props.loading, menuIsOpen = props.menuIsOpen, _props_multiValueProps = props.multiValueProps, multiValueProps = _props_multiValueProps === void 0 ? {} : _props_multiValueProps, noOptionsMessage = props.noOptionsMessage, onChange = props.onChange, _props_optionProps = props.optionProps, optionProps = _props_optionProps === void 0 ? {} : _props_optionProps, options = props.options, placeholder = props.placeholder, validationErrors = props.validationErrors, values = props.values;
    var MultiValue = function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).MultiValue, (0, _objectSpread._)({}, props));
    };
    var MultiValueRemove = function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).MultiValueRemove, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: "x-close",
                ariaLabel: "remove",
                size: [
                    10
                ]
            })
        }));
    };
    // handles a custom option component generator, if passed in
    var Option = function(props) {
        if (customOption) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props, optionProps), {
            children: customOption(props)
        }));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, (0, _objectSpread._)({}, props, optionProps));
    };
    var ComboboxComponent = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _multiComboboxStyles.StyledMultiCombobox), {
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            ref: ref,
            className: className,
            classNamePrefix: "combobox",
            closeMenuOnSelect: closeMenuOnSelect,
            components: {
                MultiValue: (0, _utils.addCustomProps)(MultiValue, multiValueProps),
                MultiValueRemove: MultiValueRemove,
                Option: (0, _utils.addCustomProps)(Option, optionProps)
            },
            defaultValue: defaultValue,
            getOptionLabel: customOptionLabel,
            getOptionValue: customOptionValue,
            id: id,
            isClearable: false,
            isDisabled: disabled,
            isMulti: true,
            isLoading: loading,
            menuIsOpen: menuIsOpen,
            noOptionsMessage: function() {
                return noOptionsMessage;
            },
            onChange: onChange,
            options: options,
            placeholder: placeholder,
            validationErrors: validationErrors,
            value: values
        });
    };
    if (props["data-cy"]) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-cy": props["data-cy"],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComboboxComponent, {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComboboxComponent, {});
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-select":"dRNnj","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/dropdowns/utils":"9zg6P","./MultiCombobox.styles":"3031K","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dRNnj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", function() {
    return 0, _useStateManager7E1E8489EsmJs.u;
});
parcelHelpers.export(exports, "createFilter", function() {
    return 0, _select49A62830EsmJs.c;
});
parcelHelpers.export(exports, "defaultTheme", function() {
    return 0, _select49A62830EsmJs.d;
});
parcelHelpers.export(exports, "mergeStyles", function() {
    return 0, _select49A62830EsmJs.m;
});
parcelHelpers.export(exports, "components", function() {
    return 0, _indexA301F526EsmJs.c;
});
parcelHelpers.export(exports, "NonceProvider", function() {
    return NonceProvider;
});
parcelHelpers.export(exports, "default", function() {
    return StateManagedSelect$1;
});
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select49A62830EsmJs = require("./Select-49a62830.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _select49A62830EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function NonceProvider(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"9HcWO","@babel/runtime/helpers/esm/extends":"9S0TS","react":"ktQNc","./Select-49a62830.esm.js":"dumXN","@emotion/react":"bwzrg","@emotion/cache":"bEMFg","./index-a301f526.esm.js":"pcXEj","@babel/runtime/helpers/objectSpread2":"1TgeK","@babel/runtime/helpers/slicedToArray":"5PeD3","@babel/runtime/helpers/objectWithoutProperties":"etrXP","@babel/runtime/helpers/classCallCheck":"ht6Fe","@babel/runtime/helpers/createClass":"31Y4E","@babel/runtime/helpers/inherits":"5rh4C","@babel/runtime/helpers/createSuper":"dXiEO","@babel/runtime/helpers/toConsumableArray":"2oiaH","memoize-one":"avOPP","@babel/runtime/helpers/typeof":"4IXI4","@babel/runtime/helpers/taggedTemplateLiteral":"fv4hc","@babel/runtime/helpers/defineProperty":"jrIQs","react-dom":"lyZO5","@floating-ui/dom":"1c7Qe","use-isomorphic-layout-effect":"2pfmI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9HcWO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", function() {
    return useStateManager;
});
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === "function") propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === "function") newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === "function") propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === "function") propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59kaA","@babel/runtime/helpers/esm/slicedToArray":"3n5Tm","@babel/runtime/helpers/esm/objectWithoutProperties":"92cFe","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"59kaA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectSpread2;
});
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"daOmd","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3n5Tm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _slicedToArray;
});
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(arr, i) {
    return (0, _arrayWithHolesJsDefault.default)(arr) || (0, _iterableToArrayLimitJsDefault.default)(arr, i) || (0, _unsupportedIterableToArrayJsDefault.default)(arr, i) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"lUY4j","./iterableToArrayLimit.js":"c4RNX","./unsupportedIterableToArray.js":"3xIpU","./nonIterableRest.js":"7661N","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lUY4j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayWithHoles;
});
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"c4RNX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _iterableToArrayLimit;
});
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7661N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _nonIterableRest;
});
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"92cFe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutProperties;
});
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJsDefault.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./objectWithoutPropertiesLoose.js":"2RW69","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dumXN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", function() {
    return Select;
});
parcelHelpers.export(exports, "a", function() {
    return defaultProps;
});
parcelHelpers.export(exports, "b", function() {
    return getOptionLabel$1;
});
parcelHelpers.export(exports, "c", function() {
    return createFilter;
});
parcelHelpers.export(exports, "d", function() {
    return defaultTheme;
});
parcelHelpers.export(exports, "g", function() {
    return getOptionValue$1;
});
parcelHelpers.export(exports, "m", function() {
    return mergeStyles;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case "menu":
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
            case "input":
                return isInitialFocus ? "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "") : "";
            case "value":
                return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
            default:
                return "";
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case "deselect-option":
            case "pop-value":
            case "remove-value":
                return "option ".concat(label, ", deselected.");
            case "clear":
                return "All selected options have been cleared.";
            case "initial-input-focus":
                return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
            case "select-option":
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return "";
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : "";
        };
        if (context === "value" && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === "menu" && isAppleDevice) {
            var disabled = isDisabled ? " disabled" : "";
            var status = "".concat(isSelected ? " selected" : "").concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return "";
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps["aria-label"];
    var ariaLive = selectProps["aria-live"];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = "";
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : "";
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = "";
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? "menu" : "value",
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = "";
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = "";
        if (messages.guidance) {
            var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
            guidanceMsg = messages.guidance({
                "aria-label": ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _indexA301F526EsmJs.r)(props, "onExited", "in", "enter", "exit", "appear");
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: "transparent",
            fontSize: "inherit",
            gridArea: "1 / 1 / 2 / 3",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(.01)"
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _indexA301F526EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener("wheel", onWheel, notPassive);
        el.addEventListener("touchstart", onTouchStart, notPassive);
        el.addEventListener("touchmove", onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener("wheel", onWheel, false);
        el.removeEventListener("touchstart", onTouchStart, false);
        el.removeEventListener("touchmove", onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function preventTouchMove(e) {
    e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener("touchmove", preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window$navigator$use = window.navigator["userAgentData"]) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _indexA301F526EsmJs.a),
    container: (0, _indexA301F526EsmJs.b),
    control: (0, _indexA301F526EsmJs.d),
    dropdownIndicator: (0, _indexA301F526EsmJs.e),
    group: (0, _indexA301F526EsmJs.g),
    groupHeading: (0, _indexA301F526EsmJs.f),
    indicatorsContainer: (0, _indexA301F526EsmJs.i),
    indicatorSeparator: (0, _indexA301F526EsmJs.h),
    input: (0, _indexA301F526EsmJs.j),
    loadingIndicator: (0, _indexA301F526EsmJs.l),
    loadingMessage: (0, _indexA301F526EsmJs.k),
    menu: (0, _indexA301F526EsmJs.m),
    menuList: (0, _indexA301F526EsmJs.n),
    menuPortal: (0, _indexA301F526EsmJs.o),
    multiValue: (0, _indexA301F526EsmJs.p),
    multiValueLabel: (0, _indexA301F526EsmJs.q),
    multiValueRemove: (0, _indexA301F526EsmJs.t),
    noOptionsMessage: (0, _indexA301F526EsmJs.u),
    option: (0, _indexA301F526EsmJs.v),
    placeholder: (0, _indexA301F526EsmJs.w),
    singleValue: (0, _indexA301F526EsmJs.x),
    valueContainer: (0, _indexA301F526EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    "aria-live": "polite",
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _indexA301F526EsmJs.z)(),
    captureMenuScroll: !(0, _indexA301F526EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _indexA301F526EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: "option",
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ("options" in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: "group",
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _indexA301F526EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === "group") optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === "function") return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ""
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange("", {
                action: "set-value",
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _indexA301F526EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), "deselect-option", newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _indexA301F526EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), "select-option", newValue);
                else _this.setValue((0, _indexA301F526EsmJs.C)(newValue), "select-option");
            } else {
                _this.ariaOnChange((0, _indexA301F526EsmJs.C)(newValue), {
                    action: "select-option",
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _indexA301F526EsmJs.D)(_this.props.isMulti, [], null), {
                action: "clear",
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _indexA301F526EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId("option"));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _indexA301F526EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _indexA301F526EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, _indexA301F526EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: "input-change",
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur",
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange("", {
                            action: "menu-close",
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _indexA301F526EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _indexA301F526EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange("", {
                    action: "menu-close",
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId("input");
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    "aria-autocomplete": "list",
                    "aria-expanded": menuIsOpen,
                    "aria-haspopup": true,
                    "aria-errormessage": this.props["aria-errormessage"],
                    "aria-invalid": this.props["aria-invalid"],
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"],
                    "aria-required": required,
                    role: "combobox",
                    "aria-activedescendant": this.isAppleDevice ? undefined : this.state.focusedOptionId || ""
                }, menuIsOpen && {
                    "aria-controls": this.getElementId("listbox")
                }), !isSearchable && {
                    "aria-readonly": true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
                    "aria-describedby": this.getElementId("live-region")
                } : {
                    "aria-describedby": this.getElementId("placeholder")
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _indexA301F526EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId("placeholder")
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, "value"));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function onHover() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function onSelect() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: "option",
                        "aria-selected": _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === "group") {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === "option") return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _indexA301F526EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: "listbox",
                                "aria-multiselectable": commonProps.isMulti,
                                id: _this4.getElementId("listbox")
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId("live-region"),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _indexA301F526EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _indexA301F526EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: "initial-input-focus"
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"9S0TS","@babel/runtime/helpers/esm/objectSpread2":"59kaA","@babel/runtime/helpers/esm/classCallCheck":"6xwAy","@babel/runtime/helpers/esm/createClass":"h0HMR","@babel/runtime/helpers/esm/inherits":"50XNH","@babel/runtime/helpers/esm/createSuper":"hMpTf","@babel/runtime/helpers/esm/toConsumableArray":"hmtBY","react":"ktQNc","./index-a301f526.esm.js":"pcXEj","@emotion/react":"bwzrg","memoize-one":"avOPP","@babel/runtime/helpers/esm/objectWithoutProperties":"92cFe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hmtBY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _toConsumableArray;
});
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(arr) {
    return (0, _arrayWithoutHolesJsDefault.default)(arr) || (0, _iterableToArrayJsDefault.default)(arr) || (0, _unsupportedIterableToArrayJsDefault.default)(arr) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"dmYYI","./iterableToArray.js":"apKy3","./unsupportedIterableToArray.js":"3xIpU","./nonIterableSpread.js":"jKwz6","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dmYYI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayWithoutHoles;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJsDefault.default)(arr);
}

},{"./arrayLikeToArray.js":"7Z7Xh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"apKy3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _iterableToArray;
});
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jKwz6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _nonIterableSpread;
});
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"pcXEj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", function() {
    return isMobileDevice;
});
parcelHelpers.export(exports, "B", function() {
    return multiValueAsValue;
});
parcelHelpers.export(exports, "C", function() {
    return singleValueAsValue;
});
parcelHelpers.export(exports, "D", function() {
    return valueTernary;
});
parcelHelpers.export(exports, "E", function() {
    return classNames;
});
parcelHelpers.export(exports, "F", function() {
    return defaultComponents;
});
parcelHelpers.export(exports, "G", function() {
    return isDocumentElement;
});
parcelHelpers.export(exports, "H", function() {
    return cleanValue;
});
parcelHelpers.export(exports, "I", function() {
    return scrollIntoView;
});
parcelHelpers.export(exports, "J", function() {
    return noop;
});
parcelHelpers.export(exports, "K", function() {
    return notNullish;
});
parcelHelpers.export(exports, "L", function() {
    return handleInputChange;
});
parcelHelpers.export(exports, "M", function() {
    return MenuPlacer;
});
parcelHelpers.export(exports, "a", function() {
    return clearIndicatorCSS;
});
parcelHelpers.export(exports, "b", function() {
    return containerCSS;
});
parcelHelpers.export(exports, "c", function() {
    return components;
});
parcelHelpers.export(exports, "d", function() {
    return css$1;
});
parcelHelpers.export(exports, "e", function() {
    return dropdownIndicatorCSS;
});
parcelHelpers.export(exports, "f", function() {
    return groupHeadingCSS;
});
parcelHelpers.export(exports, "g", function() {
    return groupCSS;
});
parcelHelpers.export(exports, "h", function() {
    return indicatorSeparatorCSS;
});
parcelHelpers.export(exports, "i", function() {
    return indicatorsContainerCSS;
});
parcelHelpers.export(exports, "j", function() {
    return inputCSS;
});
parcelHelpers.export(exports, "k", function() {
    return loadingMessageCSS;
});
parcelHelpers.export(exports, "l", function() {
    return loadingIndicatorCSS;
});
parcelHelpers.export(exports, "m", function() {
    return menuCSS;
});
parcelHelpers.export(exports, "n", function() {
    return menuListCSS;
});
parcelHelpers.export(exports, "o", function() {
    return menuPortalCSS;
});
parcelHelpers.export(exports, "p", function() {
    return multiValueCSS;
});
parcelHelpers.export(exports, "q", function() {
    return multiValueLabelCSS;
});
parcelHelpers.export(exports, "r", function() {
    return removeProps;
});
parcelHelpers.export(exports, "s", function() {
    return supportsPassiveEvents;
});
parcelHelpers.export(exports, "t", function() {
    return multiValueRemoveCSS;
});
parcelHelpers.export(exports, "u", function() {
    return noOptionsMessageCSS;
});
parcelHelpers.export(exports, "v", function() {
    return optionCSS;
});
parcelHelpers.export(exports, "w", function() {
    return placeholderCSS;
});
parcelHelpers.export(exports, "x", function() {
    return css;
});
parcelHelpers.export(exports, "y", function() {
    return valueContainerCSS;
});
parcelHelpers.export(exports, "z", function() {
    return isTouchCapable;
});
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === "string") return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    if (style.position === "fixed") return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener("p", noop, options);
    w.removeEventListener("p", noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === "bottom") {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: "menu"
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), "100%"), (0, _definePropertyDefault.default)(_objectSpread2, "position", "absolute"), (0, _definePropertyDefault.default)(_objectSpread2, "width", "100%"), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === "fixed";
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "menu", {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: "auto",
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "menuList", {
        "menu-list": true,
        "menu-list--is-multi": isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: "center"
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? "No options" : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "noOptionsMessage", {
        "menu-notice": true,
        "menu-notice--no-options": true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? "Loading..." : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), "loadingMessage", {
        "menu-notice": true,
        "menu-notice--loading": true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === "function") {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: "ResizeObserver" in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== "fixed" || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), "menuPortal", {
        "menu-portal": true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : undefined,
        pointerEvents: isDisabled ? "none" : undefined,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "container", {
        "--is-disabled": isDisabled,
        "--is-rtl": isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: "center",
        display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "valueContainer", {
        "value-container": true,
        "value-container--is-multi": isMulti,
        "value-container--has-value": hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "indicatorsContainer", {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "dropdownIndicator", {
        indicator: true,
        "dropdown-indicator": true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "clearIndicator", {
        indicator: true,
        "clear-indicator": true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "indicatorSeparator",
        alignSelf: "stretch",
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, "indicatorSeparator", {
        "indicator-separator": true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: "loadingIndicator",
        display: "flex",
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : undefined,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), "loadingIndicator", {
        indicator: true,
        "loading-indicator": true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: "control",
        alignItems: "center",
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms"
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, "control", {
        control: true,
        "control--is-disabled": isDisabled,
        "control--is-focused": isFocused,
        "control--menu-is-open": menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "group", {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: "group",
        cursor: "default",
        display: "block"
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "groupHeading", {
        "group-heading": true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? "hidden" : "visible",
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? "translateZ(0)" : ""
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: "100%"
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "input", {
        "input-container": true
    }), {
        "data-value": value || ""
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "multiValue",
        display: "flex",
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: "hidden",
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? "ellipsis" : undefined,
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: "center",
        display: "flex"
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValue", {
            "multi-value": true,
            "multi-value--is-disabled": isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValueLabel", {
            "multi-value__label": true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, "multiValueRemove", {
            "multi-value__remove": true
        })), {}, {
            "aria-label": "Remove ".concat(children || "option")
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "option",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "option", {
        option: true,
        "option--is-disabled": isDisabled,
        "option--is-focused": isFocused,
        "option--is-selected": isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "placeholder",
        gridArea: "1 / 1 / 2 / 3"
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "placeholder", {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: "singleValue",
        gridArea: "1 / 1 / 2 / 3",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, "singleValue", {
        "single-value": true,
        "single-value--is-disabled": isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"59kaA","@babel/runtime/helpers/esm/extends":"9S0TS","@emotion/react":"bwzrg","@babel/runtime/helpers/esm/slicedToArray":"3n5Tm","@babel/runtime/helpers/esm/objectWithoutProperties":"92cFe","@babel/runtime/helpers/esm/typeof":"8XnLL","@babel/runtime/helpers/esm/taggedTemplateLiteral":"fqoDW","@babel/runtime/helpers/esm/defineProperty":"daOmd","react":"ktQNc","react-dom":"lyZO5","@floating-ui/dom":"1c7Qe","use-isomorphic-layout-effect":"2pfmI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bwzrg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.C;
});
parcelHelpers.export(exports, "ThemeContext", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.T;
});
parcelHelpers.export(exports, "ThemeProvider", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.a;
});
parcelHelpers.export(exports, "__unsafe_useEmotionCache", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs._;
});
parcelHelpers.export(exports, "useTheme", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.u;
});
parcelHelpers.export(exports, "withEmotionCache", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.w;
});
parcelHelpers.export(exports, "withTheme", function() {
    return 0, _emotionElement43C6Fea0BrowserEsmJs.b;
});
parcelHelpers.export(exports, "ClassNames", function() {
    return ClassNames;
});
parcelHelpers.export(exports, "Global", function() {
    return Global;
});
parcelHelpers.export(exports, "createElement", function() {
    return jsx;
});
parcelHelpers.export(exports, "css", function() {
    return css;
});
parcelHelpers.export(exports, "jsx", function() {
    return jsx;
});
parcelHelpers.export(exports, "keyframes", function() {
    return keyframes;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _emotionElement43C6Fea0BrowserEsmJs = require("./emotion-element-43c6fea0.browser.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var jsx = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, _emotionElement43C6Fea0BrowserEsmJs.h).call(props, "css")) // $FlowFixMe
    return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElement43C6Fea0BrowserEsmJs.E);
    createElementArgArray[1] = (0, _emotionElement43C6Fea0BrowserEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return _react.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T)));
    if (!(0, _emotionElement43C6Fea0BrowserEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg)){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, _utils.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElement43C6Fea0BrowserEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElement43C6Fea0BrowserEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var isBrowser, isTestEnv, globalContext, globalKey;

},{"@swc/helpers/_/_type_of":"6Gp9n","./emotion-element-43c6fea0.browser.esm.js":"hztCO","react":"ktQNc","@emotion/utils":"5cMu6","@emotion/use-insertion-effect-with-fallbacks":"iRGb9","@emotion/serialize":"d1zGg","@emotion/cache":"bEMFg","@babel/runtime/helpers/extends":"gdwe5","@emotion/weak-memoize":"5txsD","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"5O6ti","hoist-non-react-statics":"kIv5Y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hztCO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", function() {
    return CacheProvider;
});
parcelHelpers.export(exports, "E", function() {
    return Emotion$1;
});
parcelHelpers.export(exports, "T", function() {
    return ThemeContext;
});
parcelHelpers.export(exports, "_", function() {
    return __unsafe_useEmotionCache;
});
parcelHelpers.export(exports, "a", function() {
    return ThemeProvider;
});
parcelHelpers.export(exports, "b", function() {
    return withTheme;
});
parcelHelpers.export(exports, "c", function() {
    return createEmotionProps;
});
parcelHelpers.export(exports, "h", function() {
    return hasOwn;
});
parcelHelpers.export(exports, "i", function() {
    return isBrowser;
});
parcelHelpers.export(exports, "u", function() {
    return useTheme;
});
parcelHelpers.export(exports, "w", function() {
    return withEmotionCache;
});
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsBrowserEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js");
var _emotionReactIsolatedHnrsBrowserEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsBrowserEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isBrowser = true;
var hasOwn = {}.hasOwnProperty;
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: "css"
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: "css"
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ _react.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsBrowserEsmJsDefault.default)(WithTheme, Component);
}
var getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return getLastPart(match[1]);
    return undefined;
};
var internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if (internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
    }
    return undefined;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key)) newProps[key] = props[key];
    newProps[typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if (hasOwn.call(props, key) && key !== "css" && key !== typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"ktQNc","@emotion/cache":"bEMFg","@babel/runtime/helpers/esm/extends":"9S0TS","@emotion/weak-memoize":"5txsD","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js":"5O6ti","@emotion/utils":"5cMu6","@emotion/serialize":"d1zGg","@emotion/use-insertion-effect-with-fallbacks":"iRGb9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bEMFg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createCache;
});
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _memoize = require("@emotion/memoize");
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if (isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        nullifyElement(element);
    } else if (isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + "box-$1$2" + (0, _stylis.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-item-" + (0, _stylis.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + "flex-line-pack" + (0, _stylis.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + "box-" + (0, _stylis.replace)(value, "-grow", "") + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, "$1" + (0, _stylis.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + "$1"), /(image-set)/, (0, _stylis.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + "box-pack:$3" + (0, _stylis.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, _stylis.WEBKIT) + "$2-$3" + "$1" + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, "stretch") ? prefix((0, _stylis.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ":", ":" + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, _stylis.WEBKIT) + "$2$3" + "$1" + (0, _stylis.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, "@", "@" + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ":" + (0, _stylis.MOZ) + "$1")
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, _stylis.stringify),
        (0, _stylis.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"7UTXd","stylis":"aMJSq","@emotion/weak-memoize":"5txsD","@emotion/memoize":"1sZmP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7UTXd":[function(require,module,exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", function() {
    return StyleSheet;
});
function sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aMJSq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", function() {
    return f;
});
parcelHelpers.export(exports, "COMMENT", function() {
    return n;
});
parcelHelpers.export(exports, "COUNTER_STYLE", function() {
    return w;
});
parcelHelpers.export(exports, "DECLARATION", function() {
    return s;
});
parcelHelpers.export(exports, "DOCUMENT", function() {
    return v;
});
parcelHelpers.export(exports, "FONT_FACE", function() {
    return b;
});
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", function() {
    return d;
});
parcelHelpers.export(exports, "IMPORT", function() {
    return i;
});
parcelHelpers.export(exports, "KEYFRAMES", function() {
    return h;
});
parcelHelpers.export(exports, "LAYER", function() {
    return $;
});
parcelHelpers.export(exports, "MEDIA", function() {
    return u;
});
parcelHelpers.export(exports, "MOZ", function() {
    return r;
});
parcelHelpers.export(exports, "MS", function() {
    return e;
});
parcelHelpers.export(exports, "NAMESPACE", function() {
    return p;
});
parcelHelpers.export(exports, "PAGE", function() {
    return t;
});
parcelHelpers.export(exports, "RULESET", function() {
    return c;
});
parcelHelpers.export(exports, "SUPPORTS", function() {
    return l;
});
parcelHelpers.export(exports, "VIEWPORT", function() {
    return o;
});
parcelHelpers.export(exports, "WEBKIT", function() {
    return a;
});
parcelHelpers.export(exports, "abs", function() {
    return g;
});
parcelHelpers.export(exports, "alloc", function() {
    return V;
});
parcelHelpers.export(exports, "append", function() {
    return q;
});
parcelHelpers.export(exports, "assign", function() {
    return m;
});
parcelHelpers.export(exports, "caret", function() {
    return R;
});
parcelHelpers.export(exports, "char", function() {
    return L;
});
parcelHelpers.export(exports, "character", function() {
    return H;
});
parcelHelpers.export(exports, "characters", function() {
    return I;
});
parcelHelpers.export(exports, "charat", function() {
    return O;
});
parcelHelpers.export(exports, "column", function() {
    return E;
});
parcelHelpers.export(exports, "combine", function() {
    return B;
});
parcelHelpers.export(exports, "comment", function() {
    return ue;
});
parcelHelpers.export(exports, "commenter", function() {
    return ae;
});
parcelHelpers.export(exports, "compile", function() {
    return ce;
});
parcelHelpers.export(exports, "copy", function() {
    return K;
});
parcelHelpers.export(exports, "dealloc", function() {
    return W;
});
parcelHelpers.export(exports, "declaration", function() {
    return ie;
});
parcelHelpers.export(exports, "delimit", function() {
    return X;
});
parcelHelpers.export(exports, "delimiter", function() {
    return re;
});
parcelHelpers.export(exports, "escaping", function() {
    return ee;
});
parcelHelpers.export(exports, "from", function() {
    return k;
});
parcelHelpers.export(exports, "hash", function() {
    return x;
});
parcelHelpers.export(exports, "identifier", function() {
    return ne;
});
parcelHelpers.export(exports, "indexof", function() {
    return C;
});
parcelHelpers.export(exports, "length", function() {
    return F;
});
parcelHelpers.export(exports, "line", function() {
    return D;
});
parcelHelpers.export(exports, "match", function() {
    return j;
});
parcelHelpers.export(exports, "middleware", function() {
    return ve;
});
parcelHelpers.export(exports, "namespace", function() {
    return be;
});
parcelHelpers.export(exports, "next", function() {
    return P;
});
parcelHelpers.export(exports, "node", function() {
    return J;
});
parcelHelpers.export(exports, "parse", function() {
    return se;
});
parcelHelpers.export(exports, "peek", function() {
    return Q;
});
parcelHelpers.export(exports, "position", function() {
    return G;
});
parcelHelpers.export(exports, "prefix", function() {
    return fe;
});
parcelHelpers.export(exports, "prefixer", function() {
    return he;
});
parcelHelpers.export(exports, "prev", function() {
    return N;
});
parcelHelpers.export(exports, "replace", function() {
    return z;
});
parcelHelpers.export(exports, "ruleset", function() {
    return te;
});
parcelHelpers.export(exports, "rulesheet", function() {
    return pe;
});
parcelHelpers.export(exports, "serialize", function() {
    return oe;
});
parcelHelpers.export(exports, "sizeof", function() {
    return S;
});
parcelHelpers.export(exports, "slice", function() {
    return T;
});
parcelHelpers.export(exports, "stringify", function() {
    return le;
});
parcelHelpers.export(exports, "strlen", function() {
    return M;
});
parcelHelpers.export(exports, "substr", function() {
    return A;
});
parcelHelpers.export(exports, "token", function() {
    return U;
});
parcelHelpers.export(exports, "tokenize", function() {
    return Y;
});
parcelHelpers.export(exports, "tokenizer", function() {
    return _;
});
parcelHelpers.export(exports, "trim", function() {
    return y;
});
parcelHelpers.export(exports, "whitespace", function() {
    return Z;
});
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5txsD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return weakMemoize;
});
var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5O6ti":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoistNonReactStatics;
});
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"kIv5Y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5cMu6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", function() {
    return getRegisteredStyles;
});
parcelHelpers.export(exports, "insertStyles", function() {
    return insertStyles;
});
parcelHelpers.export(exports, "registerStyles", function() {
    return registerStyles;
});
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d1zGg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", function() {
    return serializeStyles;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache;
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation === "undefined" ? "undefined" : (0, _typeOf._)(interpolation)){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if (isProcessableValue(value)) string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
};

},{"@swc/helpers/_/_type_of":"6Gp9n","@emotion/hash":"dUQgz","@emotion/unitless":"l8Jf5","@emotion/memoize":"1sZmP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dUQgz":[function(require,module,exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return murmur2;
});
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l8Jf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return unitlessKeys;
});
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iRGb9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", function() {
    return useInsertionEffectAlwaysWithSyncFallback;
});
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", function() {
    return useInsertionEffectWithLayoutFallback;
});
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gdwe5":[function(require,module,exports) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fqoDW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _taggedTemplateLiteral;
});
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1c7Qe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _core.detectOverflow;
});
parcelHelpers.export(exports, "offset", function() {
    return 0, _core.offset;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return 0, _dom.getOverflowAncestors;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "autoUpdate", function() {
    return autoUpdate;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "platform", function() {
    return platform;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    var css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = (0, _dom.isHTMLElement)(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    var domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    var rect = domElement.getBoundingClientRect();
    var _getCssDimensions = getCssDimensions(domElement), width = _getCssDimensions.width, height = _getCssDimensions.height, $ = _getCssDimensions.$;
    var x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    var y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    var win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = unwrapElement(element);
    var scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = (0, _dom.getWindow)(domElement);
        var offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            var iframeScale = getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = (0, _dom.getComputedStyle)(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, _core.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
var topLayerSelectors = [
    ":popover-open",
    ":modal"
];
function isTopLayer(floating) {
    return topLayerSelectors.some(function(selector) {
        try {
            return floating.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === "fixed";
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var topLayer = elements ? isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = (0, _utils.createCoords)(1);
    var offsets = (0, _utils.createCoords)(0);
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            var offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + (0, _dom.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    var html = (0, _dom.getDocumentElement)(element);
    var scroll = (0, _dom.getNodeScroll)(element);
    var body = element.ownerDocument.body;
    var width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === "rtl") x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getViewportRect(element, strategy) {
    var win = (0, _dom.getWindow)(element);
    var html = (0, _dom.getDocumentElement)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    var clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    var width = element.clientWidth * scale.x;
    var height = element.clientHeight * scale.y;
    var x = left * scale.x;
    var y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = getVisualOffsets(element);
        rect = (0, _objectSpreadProps._)((0, _objectSpread._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    var parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = (0, _dom.getOverflowAncestors)(element, [], false).filter(function(el) {
        return (0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = (0, _dom.getComputedStyle)(element).position === "fixed";
    var currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        var computedStyle = (0, _dom.getComputedStyle)(currentNode);
        var currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
    var clippingAncestors = (0, _toConsumableArray._)(elementClippingAncestors).concat([
        rootBoundary
    ]);
    var firstClippingAncestor = clippingAncestors[0];
    var clippingRect = clippingAncestors.reduce(function(accRect, clippingAncestor) {
        var rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    var _getCssDimensions = getCssDimensions(element), width = _getCssDimensions.width, height = _getCssDimensions.height;
    return {
        width: width,
        height: height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    var documentElement = (0, _dom.getDocumentElement)(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== "body" || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = getWindowScrollBarX(documentElement);
    }
    var x = rect.left + scroll.scrollLeft - offsets.x;
    var y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    var window = (0, _dom.getWindow)(element);
    if (!(0, _dom.isHTMLElement)(element) || isTopLayer(element)) return window;
    var offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && (0, _dom.getComputedStyle)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, _dom.getNodeName)(offsetParent) === "html" || (0, _dom.getNodeName)(offsetParent) === "body" && (0, _dom.getComputedStyle)(offsetParent).position === "static" && !(0, _dom.isContainingBlock)(offsetParent))) return window;
    return offsetParent || (0, _dom.getContainingBlock)(element) || window;
}
var getElementRects = function() {
    var _ref = (0, _asyncToGenerator._)(function(data) {
        var getOffsetParentFn, getDimensionsFn, _tmp, _tmp1, _tmp2;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 1:
                    _tmp.reference = getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat([
                        _state.sent(),
                        data.strategy
                    ]));
                    _tmp2 = [
                        {
                            x: 0,
                            y: 0
                        }
                    ];
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.floating = (0, _objectSpread._).apply(void 0, _tmp2.concat([
                            _state.sent()
                        ])), _tmp)
                    ];
            }
        });
    });
    return function getElementRects(data) {
        return _ref.apply(this, arguments);
    };
}();
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === "rtl";
}
var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: (0, _dom.isElement),
    isRTL: isRTL
};
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    var io = null;
    var timeoutId;
    var root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top, width = _element_getBoundingClientRect.width, height = _element_getBoundingClientRect.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = (0, _utils.floor)(top);
        var insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        var insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        var insetLeft = (0, _utils.floor)(left);
        var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        var options = {
            rootMargin: rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _options_ancestorScroll = options.ancestorScroll, ancestorScroll = _options_ancestorScroll === void 0 ? true : _options_ancestorScroll, _options_ancestorResize = options.ancestorResize, ancestorResize = _options_ancestorResize === void 0 ? true : _options_ancestorResize, _options_elementResize = options.elementResize, elementResize = _options_elementResize === void 0 ? typeof ResizeObserver === "function" : _options_elementResize, _options_layoutShift = options.layoutShift, layoutShift = _options_layoutShift === void 0 ? typeof IntersectionObserver === "function" : _options_layoutShift, _options_animationFrame = options.animationFrame, animationFrame = _options_animationFrame === void 0 ? false : _options_animationFrame;
    var referenceEl = unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0, _toConsumableArray._)(referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : []).concat((0, _toConsumableArray._)((0, _dom.getOverflowAncestors)(floating))) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 1), firstEntry = _$_ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ var computePosition = function(reference, floating, options) {
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    var cache = new Map();
    var mergedOptions = (0, _objectSpread._)({
        platform: platform
    }, options);
    var platformWithCache = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, _core.computePosition)(reference, floating, (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

},{"@swc/helpers/_/_async_to_generator":"5F0bU","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_ts_generator":"HrSs8","@floating-ui/core":"l7qSC","@floating-ui/utils":"75Faf","@floating-ui/utils/dom":"8EN7d","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l7qSC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", function() {
    return 0, _utils.rectToClientRect;
});
parcelHelpers.export(exports, "arrow", function() {
    return arrow;
});
parcelHelpers.export(exports, "autoPlacement", function() {
    return autoPlacement;
});
parcelHelpers.export(exports, "computePosition", function() {
    return computePosition;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return detectOverflow;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "hide", function() {
    return hide;
});
parcelHelpers.export(exports, "inline", function() {
    return inline;
});
parcelHelpers.export(exports, "limitShift", function() {
    return limitShift;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shift", function() {
    return shift;
});
parcelHelpers.export(exports, "size", function() {
    return size;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = (0, _utils.getSideAxis)(placement);
    var alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    var alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    var side = (0, _utils.getSide)(placement);
    var isVertical = sideAxis === "y";
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ var computePosition = function() {
    var _ref = (0, _asyncToGenerator._)(function(reference, floating, config) {
        var _config_placement, placement, _config_strategy, strategy, _config_middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPlacement, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware_i, name, fn, _ref, nextX, nextY, data, reset, _tmp, ref;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _config_placement = config.placement, placement = _config_placement === void 0 ? "bottom" : _config_placement, _config_strategy = config.strategy, strategy = _config_strategy === void 0 ? "absolute" : _config_strategy, _config_middleware = config.middleware, middleware = _config_middleware === void 0 ? [] : _config_middleware, platform = config.platform;
                    validMiddleware = middleware.filter(Boolean);
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    _computeCoordsFromPlacement = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPlacement.x, y = _computeCoordsFromPlacement.y;
                    statefulPlacement = placement;
                    middlewareData = {};
                    resetCount = 0;
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < validMiddleware.length)) return [
                        3,
                        11
                    ];
                    _validMiddleware_i = validMiddleware[i], name = _validMiddleware_i.name, fn = _validMiddleware_i.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platform,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    _ref = _state.sent(), nextX = _ref.x, nextY = _ref.y, data = _ref.data, reset = _ref.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, middlewareData), (0, _defineProperty._)({}, name, (0, _objectSpread._)({}, middlewareData[name], data)));
                    if (!(reset && resetCount <= 50)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref.x, y = ref.y, ref;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
function detectOverflow(state, options) {
    return _detectOverflow.apply(this, arguments);
}
function _detectOverflow() {
    _detectOverflow = /**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ (0, _asyncToGenerator._)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate, _evaluate_boundary, boundary, _evaluate_rootBoundary, rootBoundary, _evaluate_elementContext, elementContext, _evaluate_altBoundary, altBoundary, _evaluate_padding, padding, paddingObject, altContext, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    _evaluate = (0, _utils.evaluate)(options, state), _evaluate_boundary = _evaluate.boundary, boundary = _evaluate_boundary === void 0 ? "clippingAncestors" : _evaluate_boundary, _evaluate_rootBoundary = _evaluate.rootBoundary, rootBoundary = _evaluate_rootBoundary === void 0 ? "viewport" : _evaluate_rootBoundary, _evaluate_elementContext = _evaluate.elementContext, elementContext = _evaluate_elementContext === void 0 ? "floating" : _evaluate_elementContext, _evaluate_altBoundary = _evaluate.altBoundary, altBoundary = _evaluate_altBoundary === void 0 ? false : _evaluate_altBoundary, _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 0 : _evaluate_padding;
                    paddingObject = (0, _utils.getPaddingObject)(padding);
                    altContext = elementContext === "floating" ? "reference" : "floating";
                    element = elements[altBoundary ? altContext : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, rects.floating), {
                        x: x,
                        y: y
                    }) : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = (0, _utils.rectToClientRect).apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return _detectOverflow.apply(this, arguments);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ var arrow = function(options) {
    return {
        name: "arrow",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, rects, platform, elements, middlewareData, _ref, element, _ref_padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, _tmp, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            // Since `element` is required, we don't Partial<> the type.
                            _ref = (0, _utils.evaluate)(options, state) || {}, element = _ref.element, _ref_padding = _ref.padding, padding = _ref_padding === void 0 ? 0 : _ref_padding;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = (0, _utils.getAlignmentAxis)(placement);
                            length = (0, _utils.getAxisLength)(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            return [
                                4,
                                platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element)
                            ];
                        case 2:
                            arrowOffsetParent = _state.sent();
                            clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                            _tmp = !clientSize;
                            if (_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)
                            ];
                        case 3:
                            _tmp = !_state.sent();
                            _state.label = 4;
                        case 4:
                            // DOM platform can return `window` as the `offsetParent`.
                            if (_tmp) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            // If the padding is large enough that it causes the arrow to no longer be
                            // centered, modify the padding so that it is centered.
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
                            // Make sure the arrow doesn't overflow the floating element if the center
                            // point is outside the floating element's bounds.
                            min$1 = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = (0, _utils.clamp)(min$1, center, max);
                            // If the reference is small enough that the arrow's padding causes it to
                            // to point to nothing for an aligned placement, adjust the offset of the
                            // floating element itself. To ensure `shift()` continues to take action,
                            // a single reset is performed when this is true.
                            shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0, _defineProperty._)(_obj1, axis, coords[axis] + alignmentOffset), (0, _defineProperty._)(_obj1, "data", (0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, axis, offset), (0, _defineProperty._)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0, _defineProperty._)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    var allowedPlacementsSortedByAlignment = alignment ? (0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) === alignment;
    })).concat((0, _toConsumableArray._)(allowedPlacements.filter(function(placement) {
        return (0, _utils.getAlignment)(placement) !== alignment;
    }))) : allowedPlacements.filter(function(placement) {
        return (0, _utils.getSide)(placement) === placement;
    });
    return allowedPlacementsSortedByAlignment.filter(function(placement) {
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ var autoPlacement = function autoPlacement(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE, rects, middlewareData, placement, platform, elements, _evaluate, _evaluate_crossAxis, crossAxis, alignment, _evaluate_allowedPlacements, allowedPlacements, _evaluate_autoAlignment, autoAlignment, detectOverflowOptions, placements$1, overflow, currentIndex, currentPlacement, alignmentSides, _tmp, currentOverflows, allOverflows, nextPlacement, placementsSortedByMostSpace, placementsThatFitOnEachSide, resetPlacement;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, middlewareData = state.middlewareData, placement = state.placement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_crossAxis = _evaluate.crossAxis, crossAxis = _evaluate_crossAxis === void 0 ? false : _evaluate_crossAxis, alignment = _evaluate.alignment, _evaluate_allowedPlacements = _evaluate.allowedPlacements, allowedPlacements = _evaluate_allowedPlacements === void 0 ? (0, _utils.placements) : _evaluate_allowedPlacements, _evaluate_autoAlignment = _evaluate.autoAlignment, autoAlignment = _evaluate_autoAlignment === void 0 ? true : _evaluate_autoAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "crossAxis",
                                "alignment",
                                "allowedPlacements",
                                "autoAlignment"
                            ]);
                            placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                            currentPlacement = placements$1[currentIndex];
                            if (currentPlacement == null) return [
                                2,
                                {}
                            ];
                            _tmp = [
                                currentPlacement,
                                rects
                            ];
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            alignmentSides = (0, _utils.getAlignmentSides).apply(void 0, _tmp.concat([
                                _state.sent()
                            ]));
                            // Make `computeCoords` start from the right place.
                            if (placement !== currentPlacement) return [
                                2,
                                {
                                    reset: {
                                        placement: placements$1[0]
                                    }
                                }
                            ];
                            currentOverflows = [
                                overflow[(0, _utils.getSide)(currentPlacement)],
                                overflow[alignmentSides[0]],
                                overflow[alignmentSides[1]]
                            ];
                            allOverflows = (0, _toConsumableArray._)(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []).concat([
                                {
                                    placement: currentPlacement,
                                    overflows: currentOverflows
                                }
                            ]);
                            nextPlacement = placements$1[currentIndex + 1];
                            // There are more placements to check.
                            if (nextPlacement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: nextPlacement
                                    }
                                }
                            ];
                            placementsSortedByMostSpace = allOverflows.map(function(d) {
                                var alignment = (0, _utils.getAlignment)(d.placement);
                                return [
                                    d.placement,
                                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                                    d.overflows.slice(0, 2).reduce(function(acc, v) {
                                        return acc + v;
                                    }, 0) : // Check only the mainAxis.
                                    d.overflows[0],
                                    d.overflows
                                ];
                            }).sort(function(a, b) {
                                return a[1] - b[1];
                            });
                            placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(function(d) {
                                return d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                                // side.
                                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every(function(v) {
                                    return v <= 0;
                                });
                            });
                            resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                            if (resetPlacement !== placement) return [
                                2,
                                {
                                    data: {
                                        index: currentIndex + 1,
                                        overflows: allOverflows
                                    },
                                    reset: {
                                        placement: resetPlacement
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ var flip = function flip(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _evaluate_fallbackStrategy, fallbackStrategy, _evaluate_fallbackAxisSideDirection, fallbackAxisSideDirection, _evaluate_flipAlignment, flipAlignment, detectOverflowOptions, side, isBasePlacement, rtl, fallbackPlacements, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$map$so, placement1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate_fallbackStrategy = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate_fallbackStrategy === void 0 ? "bestFit" : _evaluate_fallbackStrategy, _evaluate_fallbackAxisSideDirection = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate_fallbackAxisSideDirection === void 0 ? "none" : _evaluate_fallbackAxisSideDirection, _evaluate_flipAlignment = _evaluate.flipAlignment, flipAlignment = _evaluate_flipAlignment === void 0 ? true : _evaluate_flipAlignment, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            // If a reset by the arrow was caused due to an alignment offset being
                            // added, we should skip any logic now since `flip()` has already done its
                            // work.
                            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = (0, _utils.getSide)(placement);
                            isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                (0, _utils.getOppositePlacement)(initialPlacement)
                            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
                            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0, _toConsumableArray._)((0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0, _toConsumableArray._)(fallbackPlacements));
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0, _toConsumableArray._)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            // One or more sides is overflowing.
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) // Try next placement and re-run the lifecycle.
                                return [
                                    2,
                                    {
                                        data: {
                                            index: nextIndex,
                                            overflows: overflowsData
                                        },
                                        reset: {
                                            placement: nextPlacement
                                        }
                                    }
                                ];
                                // First, find the candidates that fit on the mainAxis side of overflow,
                                // then find the placement that fits the best on the main crossAxis side.
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                // Otherwise fallback.
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$map$so = overflowsData.map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$map$so[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ var hide = function hide(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var rects, _evaluate, _evaluate_strategy, strategy, detectOverflowOptions, overflow, offsets, overflow1, offsets1;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_strategy = _evaluate.strategy, strategy = _evaluate_strategy === void 0 ? "referenceHidden" : _evaluate_strategy, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            overflow = _state.sent();
                            offsets = getSideOffsets(overflow, rects.reference);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                detectOverflow(state, (0, _objectSpreadProps._)((0, _objectSpread._)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            overflow1 = _state.sent();
                            offsets1 = getSideOffsets(overflow1, rects.floating);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
function getBoundingRect(rects) {
    var minX = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.left;
    })));
    var minY = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.top;
    })));
    var maxX = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.right;
    })));
    var maxY = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(rects.map(function(rect) {
        return rect.bottom;
    })));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    var sortedRects = rects.slice().sort(function(a, b) {
        return a.y - b.y;
    });
    var groups = [];
    var prevRect = null;
    for(var i = 0; i < sortedRects.length; i++){
        var rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map(function(rect) {
        return (0, _utils.rectToClientRect)(getBoundingRect(rect));
    });
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ var inline = function inline(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, elements, rects, platform, strategy, _evaluate, _evaluate_padding, padding, x, y, nativeClientRects, _, clientRects, fallback, paddingObject, resetRects;
                function getBoundingClientRect() {
                    // There are two rects and they are disjoined.
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                    return clientRects.find(function(rect) {
                        return x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom;
                    }) || fallback;
                    // There are 2 or more connected rects.
                    if (clientRects.length >= 2) {
                        if ((0, _utils.getSideAxis)(placement) === "y") {
                            var firstRect = clientRects[0];
                            var lastRect = clientRects[clientRects.length - 1];
                            var isTop = (0, _utils.getSide)(placement) === "top";
                            var top = firstRect.top;
                            var bottom = lastRect.bottom;
                            var left = isTop ? firstRect.left : lastRect.left;
                            var right = isTop ? firstRect.right : lastRect.right;
                            var width = right - left;
                            var height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        var isLeftSide = (0, _utils.getSide)(placement) === "left";
                        var maxRight = (0, _utils.max).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.right;
                        })));
                        var minLeft = (0, _utils.min).apply(void 0, (0, _toConsumableArray._)(clientRects.map(function(rect) {
                            return rect.left;
                        })));
                        var measureRects = clientRects.filter(function(rect) {
                            return isLeftSide ? rect.left === minLeft : rect.right === maxRight;
                        });
                        var top1 = measureRects[0].top;
                        var bottom1 = measureRects[measureRects.length - 1].bottom;
                        var left1 = minLeft;
                        var right1 = maxRight;
                        var width1 = right1 - left1;
                        var height1 = bottom1 - top1;
                        return {
                            top: top1,
                            bottom: bottom1,
                            left: left1,
                            right: right1,
                            width: width1,
                            height: height1,
                            x: left1,
                            y: top1
                        };
                    }
                    return fallback;
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, elements = state.elements, rects = state.rects, platform = state.platform, strategy = state.strategy;
                            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
                            // ClientRect's bounds, despite the event listener being triggered. A
                            // padding of 2 seems to handle this issue.
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_padding = _evaluate.padding, padding = _evaluate_padding === void 0 ? 2 : _evaluate_padding, x = _evaluate.x, y = _evaluate.y;
                            _ = Array.from;
                            return [
                                4,
                                platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)
                            ];
                        case 1:
                            nativeClientRects = _.apply(Array, [
                                _state.sent() || []
                            ]);
                            clientRects = getRectsByLine(nativeClientRects);
                            fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
                            paddingObject = (0, _utils.getPaddingObject)(padding);
                            return [
                                4,
                                platform.getElementRects({
                                    reference: {
                                        getBoundingClientRect: getBoundingClientRect
                                    },
                                    floating: elements.floating,
                                    strategy: strategy
                                })
                            ];
                        case 2:
                            resetRects = _state.sent();
                            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return [
                                2,
                                {
                                    reset: {
                                        rects: resetRects
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function convertValueToCoords(state, options) {
    return _convertValueToCoords.apply(this, arguments);
}
function _convertValueToCoords() {
    _convertValueToCoords = // For type backwards-compatibility, the `OffsetOptions` type was also
    // Derivable.
    (0, _asyncToGenerator._)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref, mainAxis, crossAxis, alignmentAxis;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = (0, _utils.getSide)(placement);
                    alignment = (0, _utils.getAlignment)(placement);
                    isVertical = (0, _utils.getSideAxis)(placement) === "y";
                    mainAxisMulti = [
                        "left",
                        "top"
                    ].includes(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = (0, _utils.evaluate)(options, state);
                    _ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : (0, _objectSpread._)({
                        mainAxis: 0,
                        crossAxis: 0,
                        alignmentAxis: null
                    }, rawValue), mainAxis = _ref.mainAxis, crossAxis = _ref.crossAxis, alignmentAxis = _ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ var offset = function offset(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            // If the placement is the same and the arrow caused an alignment offset
                            // then we don't need to change the positioning coordinates.
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ var shift = function shift(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var x, y, placement, _evaluate, tmp, checkMainAxis, tmp1, checkCrossAxis, _evaluate_limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement;
                            _evaluate = (0, _utils.evaluate)(options, state), tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _evaluate_limiter = _evaluate.limiter, limiter = _evaluate_limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _evaluate_limiter, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
                            mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = (0, _utils.clamp)(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), (_obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0, _objectSpreadProps._)((0, _objectSpread._)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ var limitShift = function limitShift(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var _evaluate = (0, _utils.evaluate)(options, state), _evaluate_offset = _evaluate.offset, offset = _evaluate_offset === void 0 ? 0 : _evaluate_offset, tmp = _evaluate.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _evaluate.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = (0, _utils.getSideAxis)(placement);
            var mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = (0, _utils.evaluate)(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, _objectSpread._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = [
                    "top",
                    "left"
                ].includes((0, _utils.getSide)(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0, _defineProperty._)(_obj, mainAxis, mainAxisCoord), (0, _defineProperty._)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ var size = function size(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn: function(state) {
            return (0, _asyncToGenerator._)(function() {
                var placement, rects, platform, elements, _evaluate, _evaluate_apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects_floating, width, height, heightSide, widthSide, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, maximumClippingWidth, maximumClippingHeight, xMin, xMax, yMin, yMax, nextDimensions;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _evaluate = (0, _utils.evaluate)(options, state), _evaluate_apply = _evaluate.apply, apply = _evaluate_apply === void 0 ? function() {} : _evaluate_apply, detectOverflowOptions = (0, _objectWithoutProperties._)(_evaluate, [
                                "apply"
                            ]);
                            return [
                                4,
                                detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = (0, _utils.getSide)(placement);
                            alignment = (0, _utils.getAlignment)(placement);
                            isYAxis = (0, _utils.getSideAxis)(placement) === "y";
                            _rects_floating = rects.floating, width = _rects_floating.width, height = _rects_floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            overflowAvailableHeight = height - overflow[heightSide];
                            overflowAvailableWidth = width - overflow[widthSide];
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if (isYAxis) {
                                maximumClippingWidth = width - overflow.left - overflow.right;
                                availableWidth = alignment || noShift ? (0, _utils.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
                            } else {
                                maximumClippingHeight = height - overflow.top - overflow.bottom;
                                availableHeight = alignment || noShift ? (0, _utils.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
                            }
                            if (noShift && !alignment) {
                                xMin = (0, _utils.max)(overflow.left, 0);
                                xMax = (0, _utils.max)(overflow.right, 0);
                                yMin = (0, _utils.max)(overflow.top, 0);
                                yMax = (0, _utils.max)(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};

},{"@swc/helpers/_/_async_to_generator":"5F0bU","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_ts_generator":"HrSs8","@floating-ui/utils":"75Faf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"75Faf":[function(require,module,exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", function() {
    return alignments;
});
parcelHelpers.export(exports, "clamp", function() {
    return clamp;
});
parcelHelpers.export(exports, "createCoords", function() {
    return createCoords;
});
parcelHelpers.export(exports, "evaluate", function() {
    return evaluate;
});
parcelHelpers.export(exports, "expandPaddingObject", function() {
    return expandPaddingObject;
});
parcelHelpers.export(exports, "floor", function() {
    return floor;
});
parcelHelpers.export(exports, "getAlignment", function() {
    return getAlignment;
});
parcelHelpers.export(exports, "getAlignmentAxis", function() {
    return getAlignmentAxis;
});
parcelHelpers.export(exports, "getAlignmentSides", function() {
    return getAlignmentSides;
});
parcelHelpers.export(exports, "getAxisLength", function() {
    return getAxisLength;
});
parcelHelpers.export(exports, "getExpandedPlacements", function() {
    return getExpandedPlacements;
});
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", function() {
    return getOppositeAlignmentPlacement;
});
parcelHelpers.export(exports, "getOppositeAxis", function() {
    return getOppositeAxis;
});
parcelHelpers.export(exports, "getOppositeAxisPlacements", function() {
    return getOppositeAxisPlacements;
});
parcelHelpers.export(exports, "getOppositePlacement", function() {
    return getOppositePlacement;
});
parcelHelpers.export(exports, "getPaddingObject", function() {
    return getPaddingObject;
});
parcelHelpers.export(exports, "getSide", function() {
    return getSide;
});
parcelHelpers.export(exports, "getSideAxis", function() {
    return getSideAxis;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "rectToClientRect", function() {
    return rectToClientRect;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
parcelHelpers.export(exports, "sides", function() {
    return sides;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var sides = [
    "top",
    "right",
    "bottom",
    "left"
];
var alignments = [
    "start",
    "end"
];
var placements = /*#__PURE__*/ sides.reduce(function(acc, side) {
    return acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]);
}, []);
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
var oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
var oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    return [
        "top",
        "bottom"
    ].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = getAlignment(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var length = getAxisLength(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, function(alignment) {
        return oppositeAlignmentMap[alignment];
    });
}
function getSideList(side, isStart, rtl) {
    var lr = [
        "left",
        "right"
    ];
    var rl = [
        "right",
        "left"
    ];
    var tb = [
        "top",
        "bottom"
    ];
    var bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = getAlignment(placement);
    var list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(side) {
        return oppositeSideMap[side];
    });
}
function expandPaddingObject(padding) {
    return (0, _objectSpread._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, rect), {
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8EN7d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", function() {
    return getComputedStyle;
});
parcelHelpers.export(exports, "getContainingBlock", function() {
    return getContainingBlock;
});
parcelHelpers.export(exports, "getDocumentElement", function() {
    return getDocumentElement;
});
parcelHelpers.export(exports, "getNearestOverflowAncestor", function() {
    return getNearestOverflowAncestor;
});
parcelHelpers.export(exports, "getNodeName", function() {
    return getNodeName;
});
parcelHelpers.export(exports, "getNodeScroll", function() {
    return getNodeScroll;
});
parcelHelpers.export(exports, "getOverflowAncestors", function() {
    return getOverflowAncestors;
});
parcelHelpers.export(exports, "getParentNode", function() {
    return getParentNode;
});
parcelHelpers.export(exports, "getWindow", function() {
    return getWindow;
});
parcelHelpers.export(exports, "isContainingBlock", function() {
    return isContainingBlock;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isLastTraversableNode", function() {
    return isLastTraversableNode;
});
parcelHelpers.export(exports, "isNode", function() {
    return isNode;
});
parcelHelpers.export(exports, "isOverflowElement", function() {
    return isOverflowElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
parcelHelpers.export(exports, "isTableElement", function() {
    return isTableElement;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return isWebKit;
});
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY, display = _getComputedStyle.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].includes(getNodeName(element));
}
function isContainingBlock(element) {
    var webkit = isWebKit();
    var css = getComputedStyle(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some(function(value) {
        return (css.willChange || "").includes(value);
    }) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some(function(value) {
        return (css.contain || "").includes(value);
    });
}
function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    var result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    var parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = getWindow(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? getOverflowAncestors(win.frameElement) : []);
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2pfmI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var index = (0, _react.useLayoutEffect);
exports.default = index;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"avOPP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return memoizeOne;
});
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1TgeK":[function(require,module,exports) {
var defineProperty = require("818faec3224b1d63");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"818faec3224b1d63":"jrIQs"}],"jrIQs":[function(require,module,exports) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"8aVB5"}],"8aVB5":[function(require,module,exports) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"4IXI4","2713647ce51d8c75":"aFm3i"}],"4IXI4":[function(require,module,exports) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aFm3i":[function(require,module,exports) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"4IXI4"}],"5PeD3":[function(require,module,exports) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(arr, i) {
    return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"iBLsC","c109e0e3b1a7ef05":"e4FzU","6782568c4383bd49":"kcWRI","1e06d43f4bd6e532":"1XnXg"}],"iBLsC":[function(require,module,exports) {
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"e4FzU":[function(require,module,exports) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kcWRI":[function(require,module,exports) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"3Sqfh"}],"3Sqfh":[function(require,module,exports) {
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1XnXg":[function(require,module,exports) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"etrXP":[function(require,module,exports) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"9Tegq"}],"9Tegq":[function(require,module,exports) {
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"ht6Fe":[function(require,module,exports) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"31Y4E":[function(require,module,exports) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"8aVB5"}],"5rh4C":[function(require,module,exports) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"5GWQC"}],"5GWQC":[function(require,module,exports) {
function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"dXiEO":[function(require,module,exports) {
var getPrototypeOf = require("b241ea01e2bf5861");
var isNativeReflectConstruct = require("35b08a444265bcf9");
var possibleConstructorReturn = require("d50bbe07b7bb3622");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return possibleConstructorReturn(this, result);
    };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b241ea01e2bf5861":"9tsUB","35b08a444265bcf9":"9N3r0","d50bbe07b7bb3622":"eWSLp"}],"9tsUB":[function(require,module,exports) {
function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"9N3r0":[function(require,module,exports) {
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"eWSLp":[function(require,module,exports) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"4IXI4","ca3744a9acc8b6f9":"8MDds"}],"8MDds":[function(require,module,exports) {
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2oiaH":[function(require,module,exports) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"j8QJD","4f1268a27b81f1fd":"jJxD8","bfa7725fe5f724b":"kcWRI","24ae2b6222a85da6":"j5Hcw"}],"j8QJD":[function(require,module,exports) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"3Sqfh"}],"jJxD8":[function(require,module,exports) {
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"j5Hcw":[function(require,module,exports) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"fv4hc":[function(require,module,exports) {
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"9zg6P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCustomProps", function() {
    return addCustomProps;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var addCustomProps = function(Component, customProps) {
    return function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            innerProps: Object.assign({}, props.innerProps, (0, _objectSpread._)({}, customProps))
        }));
    };
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3031K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMultiCombobox", function() {
    return StyledMultiCombobox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  background-color: ",
        ";\n\n  .combobox__control,\n  .combobox__menu {\n    background-color: inherit;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n  }\n\n  // overall component container\n  .combobox__control {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    margin-top: 3px;\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    margin-left: calc(",
        " + 2px); // ensures text doesn\u2019t overlap with input cursor\n    color: ",
        ";\n  }\n\n  // container component for the text input\n  .combobox__input-container {\n    margin-left: ",
        ";\n  }\n\n  // container for selected items (visually inside input)\n  .combobox__value-container {\n    padding: 0;\n    border-radius: inherit;\n  }\n\n  // each selected item (pill)\n  .combobox__multi-value {\n    height: 30px;\n\n    color: ",
        ";\n    background-color: ",
        ";\n    border-radius: 2px;\n\n    > * {\n      color: inherit;\n      margin-top: auto;\n      margin-bottom: auto;\n    }\n\n    &__remove {\n      padding-right: ",
        ";\n\n      &:hover {\n        cursor: pointer;\n        color: ",
        ";\n        background-color: transparent;\n      }\n    }\n\n    &__label {\n      padding-left: ",
        ";\n    }\n  }\n\n  // caret button to open/close menu\n  .combobox__dropdown-indicator {\n    border-radius: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var spacingCommon = "10px";
var StyledMultiCombobox = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).clay, (0, _index.COLORS).comet, (0, _index.COLORS).baliHai, (0, _index.COLORS).comet, spacingCommon, (0, _index.COLORS).lightFontColor, spacingCommon, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, spacingCommon, (0, _index.COLORS).white, spacingCommon);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"4YUJC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4YUJC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basicDefaults", function() {
    return basicDefaults;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n\n  &.combobox--is-disabled {\n    pointer-events: auto;\n    opacity: 0.6;\n  }\n\n  // overall component container\n  .combobox__control {\n    box-shadow: none;\n    min-height: unset;\n  }\n\n  .combobox__control--is-disabled {\n    cursor: not-allowed;\n  }\n\n  // container component for the text input\n  .combobox__input-container {\n    color: ",
        ";\n    cursor: text;\n\n    input {\n      margin-bottom: 0;\n      caret-color: ",
        ";\n    }\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  // each available item in the dropdown list\n  .combobox__option {\n    background-color: inherit;\n\n    :hover,\n    &--is-focused {\n      background-color: ",
        ";\n    }\n  }\n\n  // normally displays as a thin vertical line before the buttons on the far right\n  .combobox__indicator-separator {\n    display: none;\n  }\n\n  // caret button to open/close menu\n  .combobox__dropdown-indicator {\n    color: ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var basicDefaults = (0, _styledComponents.css)(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).white, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l9A9t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SingleCombobox", function() {
    return SingleCombobox;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("Permafrost/index");
var _utils = require("Permafrost/components/ui-foundations/dropdowns/utils");
var _singleComboboxStyles = require("./SingleCombobox.styles");
var SingleCombobox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var className = props.className, closeMenuOnSelect = props.closeMenuOnSelect, customOptionLabel = props.customOptionLabel, customOptionValue = props.customOptionValue, defaultValue = props.defaultValue, disabled = props.disabled, _props_dropdownIndicatorProps = props.dropdownIndicatorProps, dropdownIndicatorProps = _props_dropdownIndicatorProps === void 0 ? {} : _props_dropdownIndicatorProps, id = props.id, menuIsOpen = props.menuIsOpen, noOptionsMessage = props.noOptionsMessage, onChange = props.onChange, _props_optionProps = props.optionProps, optionProps = _props_optionProps === void 0 ? {} : _props_optionProps, options = props.options, placeholder = props.placeholder, validationErrors = props.validationErrors, value = props.value;
    var DropdownIndicator = function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).DropdownIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: "fa-caret-down",
                ariaLabel: "open dropdown",
                size: [
                    14
                ]
            })
        }));
    };
    var Option = function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, (0, _objectSpread._)({}, props, optionProps));
    };
    var ComboboxComponent = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _singleComboboxStyles.StyledSingleCombobox), {
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            ref: ref,
            className: className,
            classNamePrefix: "combobox",
            closeMenuOnSelect: closeMenuOnSelect,
            components: {
                DropdownIndicator: (0, _utils.addCustomProps)(DropdownIndicator, dropdownIndicatorProps),
                Option: (0, _utils.addCustomProps)(Option, optionProps)
            },
            defaultValue: defaultValue,
            getOptionLabel: customOptionLabel,
            getOptionValue: customOptionValue,
            id: id,
            isClearable: false,
            isDisabled: disabled,
            isMulti: false,
            menuIsOpen: menuIsOpen,
            noOptionsMessage: function() {
                return noOptionsMessage;
            },
            onChange: onChange,
            options: options,
            placeholder: placeholder,
            validationErrors: validationErrors,
            value: value
        });
    };
    if (props["data-cy"]) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        "data-cy": props["data-cy"],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComboboxComponent, {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ComboboxComponent, {});
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-select":"dRNnj","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/dropdowns/utils":"9zg6P","./SingleCombobox.styles":"3qRF3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3qRF3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSingleCombobox", function() {
    return StyledSingleCombobox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  // overall component container\n  .combobox__control {\n    border-radius: 0;\n\n    background-color: transparent;\n\n    border-top: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    border-left: none;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  // selected item text inside input\n  .combobox__single-value {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSingleCombobox = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"4YUJC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2qco7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateableSelect", function() {
    return CreateableSelect;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("../../../../index");
var _utils = require("../../../../components/ui-foundations/dropdowns/utils");
var _createableSelectStyles = require("./CreateableSelect.styles");
var DropdownIndicator = function(indicatorProps) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).DropdownIndicator, (0, _objectSpreadProps._)((0, _objectSpread._)({}, indicatorProps), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
            name: "fa-caret-down",
            ariaLabel: "open dropdown",
            size: [
                (0, _index.TYPOGRAPHY).fontSize.base
            ]
        })
    }));
};
var CustomOption = function(optionProps) {
    var children = optionProps.children, data = optionProps.data, rest = (0, _objectWithoutProperties._)(optionProps, [
        "children",
        "data"
    ]);
    var iconString = (data === null || data === void 0 ? void 0 : data.icon) || "";
    var swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSelect.components).Option, (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        children: [
            swatchColor ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "swatch",
                style: {
                    backgroundColor: swatchColor
                }
            }) : null,
            iconString ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: iconString,
                className: "inline-icon",
                ariaLabel: "".concat(iconString, " icon"),
                size: [
                    (0, _index.TYPOGRAPHY).fontSize.base
                ]
            }) : null,
            children
        ]
    }));
};
var CustomSingleValue = function(optionProps) {
    var children = optionProps.children, data = optionProps.data, rest = (0, _objectWithoutProperties._)(optionProps, [
        "children",
        "data"
    ]);
    var iconString = (data === null || data === void 0 ? void 0 : data.icon) || "";
    var swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactSelect.components).SingleValue, (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        children: [
            swatchColor ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "swatch",
                style: {
                    backgroundColor: swatchColor
                }
            }) : null,
            iconString ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: iconString,
                className: "inline-icon",
                ariaLabel: "".concat(iconString, " icon"),
                size: [
                    (0, _index.TYPOGRAPHY).fontSize.base
                ]
            }) : null,
            children
        ]
    }));
};
var CreateableSelect = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var id = props.id, isDisabled = props.isDisabled, className = props.className, isClearable = props.isClearable, closeMenuOnSelect = props.closeMenuOnSelect, isLoading = props.isLoading, onChange = props.onChange, _props_dropdownIndicatorProps = props.dropdownIndicatorProps, dropdownIndicatorProps = _props_dropdownIndicatorProps === void 0 ? {} : _props_dropdownIndicatorProps, onCreateOption = props.onCreateOption, placeholder = props.placeholder, value = props.value, menuIsOpen = props.menuIsOpen, options = props.options, _props_hasWordBreak = props.hasWordBreak, hasWordBreak = _props_hasWordBreak === void 0 ? true : _props_hasWordBreak, defaultValue = props.defaultValue, labelText = props.labelText, _props_hasHiddenLabel = props.hasHiddenLabel, hasHiddenLabel = _props_hasHiddenLabel === void 0 ? false : _props_hasHiddenLabel;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(options), 2), localOptions = _useState[0], setLocalOptions = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(value), 2), localValue = _useState1[0], setLocalValue = _useState1[1];
    var filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: "start"
    };
    var handleCreate = function(inputValue) {
        var newOption = createOption(inputValue);
        setLocalOptions(function(prev) {
            return (0, _toConsumableArray._)(prev).concat([
                newOption
            ]);
        });
        setLocalValue(newOption);
        onCreateOption(inputValue);
    };
    var createOption = function(label) {
        return {
            label: label,
            value: label.toLowerCase()
        };
    };
    var handleSelectChange = function(newValue) {
        setLocalValue(newValue);
        onChange(newValue);
    };
    var breakWord = hasWordBreak ? "has-word-break" : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "combobox-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                "data-testid": "combobox-label",
                className: hasHiddenLabel ? "aria-invisible" : "",
                htmlFor: id,
                children: labelText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createableSelectStyles.StyledCreateableSelect), {
                id: id,
                ref: ref,
                components: {
                    DropdownIndicator: (0, _utils.addCustomProps)(DropdownIndicator, dropdownIndicatorProps),
                    Option: CustomOption,
                    SingleValue: CustomSingleValue
                },
                isDisabled: isLoading || isDisabled,
                isLoading: isLoading,
                closeMenuOnSelect: closeMenuOnSelect,
                menuIsOpen: menuIsOpen,
                isClearable: isClearable,
                hasWordBreak: hasWordBreak,
                options: localOptions,
                classNamePrefix: "combobox",
                className: "".concat(breakWord, " ").concat(className),
                placeholder: placeholder,
                onChange: handleSelectChange,
                onCreateOption: handleCreate,
                value: localValue,
                defaultValue: defaultValue,
                filterOption: (0, _reactSelect.createFilter)(filterConfig)
            })
        ]
    });
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-select":"dRNnj","../../../../index":"iliLC","../../../../components/ui-foundations/dropdowns/utils":"9zg6P","./CreateableSelect.styles":"dGuvE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dGuvE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCreateableSelect", function() {
    return StyledCreateableSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _index = require("../../../../index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      word-break: break-word;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  .combobox__control {\n    border-radius: 0;\n    background-color: transparent;\n    border-top: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    border-left: none;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__menu {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  .combobox__single-value {\n    color: ",
        ";\n  }\n\n  .swatch {\n    display: inline-block;\n    vertical-align: top;\n    margin-right: ",
        ";\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n  }\n  .inline-icon {\n    margin-right: ",
        ";\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCreateableSelect = (0, _styledComponentsDefault.default)((0, _creatableDefault.default))(_templateObject1(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.SPACING).xs, (0, _index.SPACING).xs, function(props) {
    return props.hasWordBreak && (0, _styledComponents.css)(_templateObject());
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select/creatable":"88Lfg","../../../../index":"iliLC","../commonStyles":"4YUJC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"88Lfg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", function() {
    return 0, _useCreatableD97Ef2C9EsmJs.u;
});
parcelHelpers.export(exports, "default", function() {
    return CreatableSelect$1;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _select49A62830EsmJs = require("../../dist/Select-49a62830.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useCreatableD97Ef2C9EsmJs = require("../../dist/useCreatable-d97ef2c9.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _indexA301F526EsmJs = require("../../dist/index-a301f526.esm.js");
var _react1 = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var creatableProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    var selectProps = (0, _useCreatableD97Ef2C9EsmJs.u)(creatableProps);
    return /*#__PURE__*/ _react.createElement((0, _select49A62830EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

},{"@babel/runtime/helpers/esm/extends":"9S0TS","react":"ktQNc","../../dist/Select-49a62830.esm.js":"dumXN","../../dist/useStateManager-7e1e8489.esm.js":"9HcWO","../../dist/useCreatable-d97ef2c9.esm.js":"co0fP","@babel/runtime/helpers/objectSpread2":"1TgeK","@babel/runtime/helpers/classCallCheck":"ht6Fe","@babel/runtime/helpers/createClass":"31Y4E","@babel/runtime/helpers/inherits":"5rh4C","@babel/runtime/helpers/createSuper":"dXiEO","@babel/runtime/helpers/toConsumableArray":"2oiaH","../../dist/index-a301f526.esm.js":"pcXEj","@emotion/react":"bwzrg","@babel/runtime/helpers/slicedToArray":"5PeD3","@babel/runtime/helpers/objectWithoutProperties":"etrXP","@babel/runtime/helpers/typeof":"4IXI4","@babel/runtime/helpers/taggedTemplateLiteral":"fv4hc","@babel/runtime/helpers/defineProperty":"jrIQs","react-dom":"lyZO5","@floating-ui/dom":"1c7Qe","use-isomorphic-layout-effect":"2pfmI","memoize-one":"avOPP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"co0fP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", function() {
    return useCreatable;
});
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _indexA301F526EsmJs = require("./index-a301f526.esm.js");
var _select49A62830EsmJs = require("./Select-49a62830.esm.js");
var _excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function useCreatable(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, _select49A62830EsmJs.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, _select49A62830EsmJs.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, _react.useMemo)(function() {
        return isValidNewOption(inputValue, (0, _indexA301F526EsmJs.H)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, _react.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
            newOption
        ].concat((0, _toConsumableArrayDefault.default)(propsOptions)) : [].concat((0, _toConsumableArrayDefault.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== "select-option") return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: "create-option",
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, _indexA301F526EsmJs.D)(isMulti, [].concat((0, _toConsumableArrayDefault.default)((0, _indexA301F526EsmJs.H)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59kaA","@babel/runtime/helpers/esm/toConsumableArray":"hmtBY","@babel/runtime/helpers/esm/objectWithoutProperties":"92cFe","react":"ktQNc","./index-a301f526.esm.js":"pcXEj","./Select-49a62830.esm.js":"dumXN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e1QeV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @filename useCombobox.ts
 * Allows access to the internals of a MultiCombobox component. For example, a discrete
 * button to clear all selected values.
 *
 * In your component’s file, import this hook and create a `ref` to the component.
 * Then, pass the ref into this hook.
 *
 * @example
 * const comboboxEl = useRef(null);
 * const { clearValue } = useCombobox(comboboxEl);
 *
 * <MultiCombobox ref={comboboxEl} ... />
 *
 * const handleSubmit = () => {
 *   clearValue();
 * };
 *
 * @see {@link https://react-select.com/props}
 * @see {@link https://github.com/JedWatson/react-select/discussions/4352}
 */ parcelHelpers.export(exports, "useCombobox", function() {
    return useCombobox;
});
function useCombobox(comboboxEl) {
    var clearValue = function() {
        if (comboboxEl === null || comboboxEl === void 0 ? void 0 : comboboxEl.current) comboboxEl.current.clearValue();
    };
    return {
        clearValue: clearValue
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hbX3C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BorderSelect", function() {
    return BorderSelect;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _borderSelectStyles = require("./BorderSelect.styles");
var BorderSelect = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, disabled = props.disabled, horizontal = props.horizontal, id = props.id, initialText = props.initialText, label = props.label, onChange = props.onChange, options = props.options, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, value = props.value, validationErrors = props.validationErrors;
    var selectId = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _borderSelectStyles.StyledSelect), {
        className: (0, _classnamesDefault.default)("Select", {
            horizontal: horizontal
        }, className),
        "data-cy": props["data-cy"],
        id: id,
        style: style,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: selectId,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "select-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                        onChange: onChange,
                        value: value,
                        disabled: disabled,
                        id: selectId,
                        children: [
                            initialText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                disabled: true,
                                value: "",
                                children: initialText
                            }),
                            options.map(function(o) {
                                var key = (0, _uuid.v4)();
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                    value: o.value,
                                    children: o.name
                                }, key);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        name: "fa-caret-down",
                        className: "selectCaret"
                    })
                ]
            }),
            validationErrors ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _borderSelectStyles.StyledValidationError), {
                children: validationErrors.map(function(err, i) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-".concat(err),
                        children: err
                    }, i);
                })
            }) : null
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","classnames":"9xS9S","Permafrost/index":"iliLC","./BorderSelect.styles":"4bZdf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4bZdf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelect", function() {
    return StyledSelect;
});
parcelHelpers.export(exports, "StyledValidationError", function() {
    return StyledValidationError;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.horizontal {\n    > * {\n      display: inline-block;\n    }\n\n    > label {\n      margin-right: 12px;\n    }\n  }\n\n  label {\n    line-height: 1.2;\n    margin-bottom: 14px;\n    color: ",
        ";\n  }\n\n  .select-container {\n    position: relative;\n    max-width: 300px;\n\n    select {\n      background: transparent;\n      border: 1px solid ",
        ";\n      width: 100%;\n      max-width: 300px;\n      color: ",
        ";\n      font-size: ",
        ";\n      border-radius: 4px;\n      padding: 7px 30px 8px 15px;\n      appearance: none;\n      position: relative;\n      z-index: 2;\n\n      &:focus {\n        outline: 0;\n      }\n\n      &::-ms-expand {\n        display: none;\n      }\n    }\n\n    option {\n      color: ",
        ";\n\n      &:not(:checked) {\n        color: ",
        ";\n      }\n    }\n\n    .selectCaret {\n      display: inline-block;\n      right: 12px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: 1;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-top: 13px;\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).lightFontColor, (0, _index.COLORS).baliHai, (0, _index.COLORS).lightFontColor, (0, _index.FONT_SIZE).base, (0, _index.COLORS).black, (0, _index.COLORS).black);
var StyledValidationError = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gyv5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", function() {
    return Select;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _selectStyles = require("./Select.styles");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var Select = function(props) {
    var id = props.id, className = props.className, disabled = props.disabled, initialText = props.initialText, onChange = props.onChange, options = props.options, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, value = props.value, variant = props.variant, onClick = props.onClick;
    var selectId = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStyles.StyledSelect), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("Select__container", size, variant),
            onClick: function(e) {
                return onClick ? onClick(e) : null;
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
                    onChange: onChange,
                    value: value,
                    disabled: disabled,
                    id: selectId,
                    children: [
                        initialText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                            disabled: true,
                            value: "",
                            children: initialText
                        }),
                        options.map(function(o) {
                            var key = (0, _uuid.v4)();
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: o.value,
                                children: o.name
                            }, key);
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    className: "chevron",
                    name: "chevron-down",
                    size: size === "small" ? [
                        10
                    ] : [
                        12
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./Select.styles":"j8ZS2","classnames":"9xS9S","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j8ZS2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelect", function() {
    return StyledSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n\n  .Select__container {\n    position: relative;\n    z-index: 0;\n\n    select {\n      color: ",
        ";\n      appearance: none;\n      background: transparent;\n      border: none;\n      z-index: 1;\n\n      &:focus {\n        outline: 0;\n      }\n    }\n\n    option {\n      color: ",
        ";\n\n      &:not(:checked) {\n        color: ",
        ";\n      }\n    }\n\n    .chevron {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: -1;\n    }\n\n    &.light {\n      select {\n        color: ",
        ";\n      }\n\n      .chevron {\n        color: ",
        ";\n      }\n    }\n\n    &.small {\n      select {\n        font-size: ",
        ";\n        padding: 0;\n        padding-right: 15px;\n      }\n\n      .chevron {\n        right: 0px;\n      }\n    }\n\n    &.medium {\n      font-size: ",
        ";\n\n      select {\n        padding: 7px 35px 8px 15px;\n      }\n\n      .chevron {\n        right: 12px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.FONT_SIZE).base, (0, _index.FONT_SIZE).subheadSmall);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dGfIJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Filter", function() {
    return Filter;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _filterStyles = require("./Filter.styles");
var _lodash = require("lodash");
var Filter = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var filter = props.filter, onFilter = props.onFilter, optionsList = props.optionsList, _props_isMulti = props.isMulti, isMulti = _props_isMulti === void 0 ? false : _props_isMulti, _props_placement = props.placement, placement = _props_placement === void 0 ? "right" : _props_placement;
    var menuEl = (0, _react.useRef)();
    var hasFilter = !!filter.length;
    var handleToggleMultiFilter = function(option) {
        if (filter.some(function(filterOption) {
            return (0, _lodash.isEqual)(filterOption.value, option.value);
        })) onFilter(filter.filter(function(filterOption) {
            return !(0, _lodash.isEqual)(filterOption.value, option.value);
        }));
        else onFilter((0, _toConsumableArray._)(filter).concat([
            option
        ]));
    };
    var handleToggleSingleFilter = function(option) {
        (0, _lodash.isEqual)(filter[0], option) && hasFilter ? onFilter([]) : onFilter([
            option
        ]);
    };
    var handleOptionClick = function(option) {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    (0, _utils.hookUtils).useClickOutside(menuEl, function() {
        setIsOpen(false);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _filterStyles.StyledFilter), {
        ref: menuEl,
        $placement: placement,
        className: "filter",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _index.Button), {
                variant: "outline",
                className: (0, _classnamesDefault.default)("filter__toggle", "square", {
                    "filters-on": hasFilter
                }),
                "data-testid": "button-filter-toggle",
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                children: [
                    props.label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "filter-label",
                        children: props.label
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        name: "filter-outline"
                    }),
                    hasFilter ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "swatch-circle"
                    }) : []
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                "data-testid": "div-filter-options-container",
                className: (0, _classnamesDefault.default)("filter__container", {
                    visible: isOpen
                }),
                children: [
                    hasFilter ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "filter__clear-filter",
                        onClick: function() {
                            onFilter([]);
                        },
                        children: "Clear Filter"
                    }) : [],
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter__options",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                className: "filter__title",
                                children: "FILTER ON"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                children: optionsList.map(function(filterOption) {
                                    var text = filterOption.text, value = filterOption.value, iconName = filterOption.iconName;
                                    var selected = filter.some(function(item) {
                                        return item.value === value;
                                    });
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        "data-testid": "li--filter-list-".concat(value),
                                        className: (0, _classnamesDefault.default)("filter__option", {
                                            selected: selected
                                        }),
                                        onClick: function() {
                                            handleOptionClick(filterOption);
                                        },
                                        children: [
                                            selected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                                name: "check",
                                                className: "filter__check",
                                                "data-testid": "li--filter-list-icon-selected-indicator-for-".concat(value)
                                            }) : [],
                                            " ",
                                            text,
                                            iconName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                                name: iconName,
                                                className: "filter__icon",
                                                "data-testid": "li--filter-list-icon-for-".concat(value)
                                            }) : []
                                        ]
                                    }, "LabelFilter-".concat(value));
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./Filter.styles":"gUuXw","lodash":"h75z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gUuXw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilter", function() {
    return StyledFilter;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  position: relative;\n  margin-right: 10px;\n\n  .filter__toggle {\n    display: flex;\n    height: 35px;\n\n    .filter-label {\n      margin-right: 10px;\n    }\n\n    &.filters-on {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    }\n\n    .swatch-circle {\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      background-color: ",
        ";\n      top: -3px;\n      right: -3px;\n    }\n  }\n\n  .filter__container {\n    width: 275px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    position: absolute;\n    top: 45px;\n    ",
        "\n    display: none;\n    z-index: 100;\n\n    &:before {\n      content: '';\n      border-bottom: 10px solid ",
        ";\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      position: absolute;\n      top: -11px;\n      ",
        "\n    }\n\n    &:after {\n      content: '';\n      border-bottom: 9px solid ",
        ";\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      position: absolute;\n      top: -9px;\n      ",
        "\n    }\n  }\n\n  .visible {\n    display: block;\n  }\n\n  .filter__options {\n    padding: 10px 0 10px 15px;\n  }\n\n  .filter__title,\n  .filter__option:not(:last-child) {\n    margin-bottom: 8px;\n  }\n\n  .filter__option {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    &.selected {\n      color: ",
        ";\n    }\n  }\n\n  .filter__clear-filter {\n    border-bottom: 1px solid ",
        ";\n    padding: 10px 10px 10px 15px;\n    font-size: ",
        ";\n    margin-right: ",
        ";\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .filter__icon {\n    margin-left: ",
        ";\n  }\n\n  .filter__check {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilter = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).ebony, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).midFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 0;" : "left: 0;";
}, (0, _constants.COLORS).midFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 7px;" : "left: 7px;";
}, (0, _constants.COLORS).ebony, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 8px;" : "left: 8px;";
}, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).midFontColor, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.SPACING).xs, (0, _constants.SPACING).xs, (0, _constants.SPACING).xs);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"h75z0":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined1;
    /** Used as the semantic version number. */ var VERSION = "4.17.15";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g, reTrimStart = /^\s+/, reTrimEnd = /\s+$/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined1 : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined1) result = result === undefined1 ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined1 : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, _$Function = context.Function, Math = context.Math, _$Object = context.Object, _$RegExp = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = _$Function.prototype, objectProto = _$Object.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(_$Object);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = _$RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined1, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined1, getPrototype = overArg(_$Object.getPrototypeOf, _$Object), objectCreate = _$Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined1, symIterator = Symbol ? Symbol.iterator : undefined1, symToStringTag = Symbol ? Symbol.toStringTag : undefined1;
        var defineProperty = function() {
            try {
                var func = getNative(_$Object, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = _$Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(_$Object.keys, _$Object), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(_$Object, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined1, symbolToString = symbolProto ? symbolProto.toString : undefined1;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var _$result = new object;
                object.prototype = undefined1;
                return _$result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined1;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var _$result = new LazyWrapper(this.__wrapped__);
            _$result.__actions__ = copyArray(this.__actions__);
            _$result.__dir__ = this.__dir__;
            _$result.__filtered__ = this.__filtered__;
            _$result.__iteratees__ = copyArray(this.__iteratees__);
            _$result.__takeCount__ = this.__takeCount__;
            _$result.__views__ = copyArray(this.__views__);
            return _$result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var _$result = new LazyWrapper(this);
                _$result.__dir__ = -1;
                _$result.__filtered__ = true;
            } else {
                _$result = this.clone();
                _$result.__dir__ *= -1;
            }
            return _$result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var _$result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], _$iteratee = data.iteratee, type = data.type, computed = _$iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                _$result[resIndex++] = value;
            }
            return _$result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var _$result = this.has(key) && delete this.__data__[key];
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var _$result = data[key];
                return _$result === HASH_UNDEFINED ? undefined1 : _$result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined1;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined1 : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined1 ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined1 : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var _$result = getMapData(this, key)["delete"](key);
            this.size -= _$result ? 1 : 0;
            return _$result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), _$size = data.size;
            data.set(key, value);
            this.size += data.size == _$size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, _$result = data["delete"](key);
            this.size = data.size;
            return _$result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, _$result = skipIndexes ? baseTimes(value.length, String) : [], length = _$result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) _$result.push(key);
            return _$result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined1;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined1 && !eq(object[key], value) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined1 && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, _$result = Array1(length), skip = object == null;
            while(++index < length)_$result[index] = skip ? undefined1 : get(object, paths[index]);
            return _$result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined1) number = number <= upper ? number : upper;
                if (lower !== undefined1) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var _$result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) _$result = object ? customizer(value, key, object, stack) : customizer(value);
            if (_$result !== undefined1) return _$result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                _$result = initCloneArray(value);
                if (!isDeep) return copyArray(value, _$result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    _$result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(_$result, value)) : copySymbols(value, baseAssign(_$result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    _$result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, _$result);
            if (isSet(value)) value.forEach(function(subValue) {
                _$result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                _$result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined1 : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(_$result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return _$result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = _$Object(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined1 && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined1, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, isCommon = true, length = array.length, _$result = [], valuesLength = values.length;
            if (!length) return _$result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                _$includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                _$includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    _$result.push(value);
                } else if (!_$includes(values, computed, comparator)) _$result.push(value);
            }
            return _$result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var _$result = true;
            baseEach(collection, function(value, index, collection) {
                _$result = !!predicate(value, index, collection);
                return _$result;
            });
            return _$result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined1 ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, _$result = value;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined1 || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var _$result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) _$result.push(value);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined1;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var _$result = keysFunc(object);
            return isArray(object) ? _$result : arrayPush(_$result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined1 ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in _$Object(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in _$Object(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var _$includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, _$result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined1;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && _$result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : _$includes(_$result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : _$includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined1 : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = _$Object(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined1 && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var _$result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(_$result === undefined1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : _$result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var _$result = [];
            for(var key in _$Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), _$result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) _$result.push(key);
            return _$result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                _$result[++index] = iteratee(value, key, collection);
            });
            return _$result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined1;
                    if (newValue === undefined1) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined1;
            var isCommon = newValue === undefined1;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined1;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            var index = -1;
            iteratees = arrayMap(iteratees.length ? iteratees : [
                identity
            ], baseUnary(getIteratee()));
            var _$result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(_$result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, _$result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(_$result, castPath(path, object), value);
            }
            return _$result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var _$indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = _$indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), _$result = Array1(length);
            while(length--){
                _$result[fromRight ? length : ++index] = start;
                start += step;
            }
            return _$result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var _$result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return _$result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) _$result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return _$result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined1;
                    if (newValue === undefined1) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function baseSetData(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function baseSetToString(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var _$result = Array1(length);
            while(++index < length)_$result[index] = array[index + start];
            return _$result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var _$result;
            baseEach(collection, function(value, index, collection) {
                _$result = predicate(value, index, collection);
                return !_$result;
            });
            return !!_$result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            value = iteratee(value);
            var low = 0, high = array == null ? 0 : array.length, valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined1;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    _$result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, _$includes = arrayIncludes, length = array.length, isCommon = true, _$result = [], seen = _$result;
            if (comparator) {
                isCommon = false;
                _$includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var _$set = iteratee ? null : createSet(array);
                if (_$set) return setToArray(_$set);
                isCommon = false;
                _$includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : _$result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    _$result.push(value);
                } else if (!_$includes(seen, computed, comparator)) {
                    if (seen !== _$result) seen.push(computed);
                    _$result.push(value);
                }
            }
            return _$result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var _$result = value;
            if (_$result instanceof LazyWrapper) _$result = _$result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, _$result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, _$result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) _$result[index] = baseDifference(_$result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(_$result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, _$result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined1;
                assignFunc(_$result, props[index], value);
            }
            return _$result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined1 ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, _$result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(_$result);
            return _$result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var _$result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(_$result).set(new Uint8Array(arrayBuffer));
            return _$result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var _$result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            _$result.lastIndex = regexp.lastIndex;
            return _$result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? _$Object(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var _$result = compareAscending(objCriteria[index], othCriteria[index]);
                if (_$result) {
                    if (index >= ordersLength) return _$result;
                    var order = orders[index];
                    return _$result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)_$result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)_$result[leftIndex++] = args[argsIndex++];
            return _$result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), _$result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)_$result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)_$result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) _$result[offset + holders[holdersIndex]] = args[argsIndex++];
            return _$result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined1;
                if (newValue === undefined1) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined1, guard = length > 2 ? sources[2] : undefined1;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined1;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined1 : customizer;
                    length = 1;
                }
                object = _$Object(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = _$Object(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = _$Object(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined1;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), _$result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(_$result) ? _$result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined1, args, holders, undefined1, undefined1, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = _$Object(collection);
                if (!isArrayLike(collection)) {
                    var _$iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function predicate(key) {
                        return _$iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[_$iteratee ? collection[index] : index] : undefined1;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined1;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, _$result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)_$result = funcs[index].call(this, _$result);
                    return _$result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined1 : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var _$result;
                if (value === undefined1 && other === undefined1) return defaultValue;
                if (value !== undefined1) _$result = value;
                if (other !== undefined1) {
                    if (_$result === undefined1) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    _$result = operator(value, other);
                }
                return _$result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined1 ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var _$result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(_$result), 0, length).join("") : _$result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined1;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined1) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined1 ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined1, newHoldersRight = isCurry ? undefined1 : holders, newPartials = isCurry ? partials : undefined1, newPartialsRight = isCurry ? undefined1 : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var _$result = wrapFunc.apply(undefined1, newData);
            if (isLaziable(func)) setData(_$result, newData);
            _$result.placeholder = placeholder;
            return setWrapToString(_$result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function createSet(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined1;
            }
            ary = ary === undefined1 ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined1 ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined1;
            }
            var data = isBindKey ? undefined1 : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var _$result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) _$result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) _$result = createPartial(func, bitmask, thisArg, partials);
            else _$result = createHybrid.apply(undefined1, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(_$result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined1, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined1 : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(array);
            if (stacked && stack.get(other)) return stacked == other;
            var index = -1, _$result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined1;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined1) {
                    if (compared) continue;
                    _$result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        _$result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    _$result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var _$result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return _$result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked && stack.get(other)) return stacked == other;
            var _$result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    _$result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (_$result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) _$result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return _$result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined1, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function getData(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var _$result = func.name + "", array = realNames[_$result], length = hasOwnProperty.call(realNames, _$result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return _$result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var _$result = lodash.iteratee || iteratee;
            _$result = _$result === iteratee ? baseIteratee : _$result;
            return arguments.length ? _$result(arguments[0], arguments[1]) : _$result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var _$result = keys(object), length = _$result.length;
            while(length--){
                var key = _$result[length], value = object[key];
                _$result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return _$result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined1;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined1;
                var unmasked = true;
            } catch (e) {}
            var _$result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return _$result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function getSymbols(object) {
            if (object == null) return [];
            object = _$Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function getSymbolsIn(object) {
            var _$result = [];
            while(object){
                arrayPush(_$result, getSymbols(object));
                object = getPrototype(object);
            }
            return _$result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function getTag(value) {
            var _$result = baseGetTag(value), Ctor = _$result == objectTag ? value.constructor : undefined1, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return _$result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], _$size = data.size;
                switch(data.type){
                    case "drop":
                        start += _$size;
                        break;
                    case "dropRight":
                        end -= _$size;
                        break;
                    case "take":
                        end = nativeMin(end, start + _$size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - _$size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, _$result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(_$result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (_$result || ++index != length) return _$result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, _$result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                _$result.index = array.index;
                _$result.input = array.input;
            }
            return _$result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index === "undefined" ? "undefined" : (0, _typeOf._)(index);
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in _$Object(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined1 || key in _$Object(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var _$result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = _$result.cache;
            return _$result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var _$result = [];
            if (object != null) for(var key in _$Object(object))_$result.push(key);
            return _$result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined1 ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined1;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined1, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined1 ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var _$result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) _$result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                _$result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return _$result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var _$result = value + "";
            return _$result == "0" && 1 / value == -INFINITY ? "-0" : _$result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var _$result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            _$result.__actions__ = copyArray(wrapper.__actions__);
            _$result.__index__ = wrapper.__index__;
            _$result.__values__ = wrapper.__values__;
            return _$result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined1) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, _$result = Array1(nativeCeil(length / size));
            while(index < length)_$result[resIndex++] = baseSlice(array, index, index += size);
            return _$result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, _$result = [];
            while(++index < length){
                var value = array[index];
                if (value) _$result[resIndex++] = value;
            }
            return _$result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var _$iteratee = last(values);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined1;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined1, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, _$result = {};
            while(++index < length){
                var pair = pairs[index];
                _$result[pair[0]] = pair[1];
            }
            return _$result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined1;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (_$iteratee === last(mapped)) _$iteratee = undefined1;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(_$iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined1, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined1;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined1) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined1;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined1, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, _$result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return _$result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var _$result = [];
            if (!(array && array.length)) return _$result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    _$result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return _$result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined1 ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined1 ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined1, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return array && array.length ? baseUniq(array, undefined1, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var _$result = unzip(array);
            if (iteratee == null) return _$result;
            return arrayMap(_$result, function(group) {
                return apply(iteratee, undefined1, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var _$iteratee = last(arrays);
            if (isArrayLikeObject(_$iteratee)) _$iteratee = undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(_$iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined1;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined1, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, _$iteratee = length > 1 ? arrays[length - 1] : undefined1;
            _$iteratee = typeof _$iteratee == "function" ? (arrays.pop(), _$iteratee) : undefined1;
            return unzipWith(arrays, _$iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var _$result = lodash(value);
            _$result.__chain__ = true;
            return _$result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function interceptor(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined1
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined1);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined1) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined1 : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var _$result, parent = this;
            while(parent instanceof baseLodash){
                var _$clone = wrapperClone(parent);
                _$clone.__index__ = 0;
                _$clone.__values__ = undefined1;
                if (_$result) previous.__wrapped__ = _$clone;
                else _$result = _$clone;
                var previous = _$clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return _$result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined1
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined1 ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", _$result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                _$result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return _$result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined1 : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined1;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined1 : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined1, undefined1, undefined1, undefined1, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var _$result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) _$result = func.apply(this, arguments);
                if (n <= 1) func = undefined1;
                return _$result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curry.placeholder;
            return _$result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined1 : arity;
            var _$result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined1, undefined1, undefined1, undefined1, undefined1, arity);
            _$result.placeholder = curryRight.placeholder;
            return _$result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, _$result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined1;
                lastInvokeTime = time;
                _$result = func.apply(thisArg, args);
                return _$result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : _$result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined1;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined1;
                return _$result;
            }
            function cancel() {
                if (timerId !== undefined1) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined1;
            }
            function flush() {
                return timerId === undefined1 ? _$result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined1) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined1) timerId = setTimeout(timerExpired, wait);
                return _$result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function memoized1() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var _$result = func.apply(this, args);
                memoized.cache = cache.set(key, _$result) || cache;
                return _$result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined1, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined1, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined1, undefined1, undefined1, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined1 ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function isArguments(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            var _$result = customizer ? customizer(value, other) : undefined1;
            return _$result === undefined1 ? baseIsEqual(value, other, undefined1, customizer) : !!_$result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined1;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var _$result = toFinite(value), remainder = _$result % 1;
            return _$result === _$result ? remainder ? _$result - remainder : _$result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = value.replace(reTrim, "");
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var _$result = baseCreate(prototype);
            return properties == null ? _$result : baseAssign(_$result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = _$Object(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined1;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined1, customDefaultsMerge);
            return apply(mergeWith, undefined1, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var _$result = object == null ? undefined1 : baseGet(object, path);
            return _$result === undefined1 ? defaultValue : _$result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, iteratee(value, key, object), value);
            });
            return _$result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var _$result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(_$result, key, iteratee(value, key, object));
            });
            return _$result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var _$result = {};
            if (object == null) return _$result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), _$result);
            if (isDeep) _$result = baseClone(_$result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(_$result, paths[length]);
            return _$result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined1;
            }
            while(++index < length){
                var value = object == null ? undefined1 : object[toKey(path[index])];
                if (value === undefined1) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined1;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined1) {
                upper = lower;
                lower = undefined1;
            }
            if (upper !== undefined1) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined1) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined1) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined1;
            if (floating === undefined1) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined1;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined1;
                }
            }
            if (lower === undefined1 && upper === undefined1) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined1) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined1 ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined1) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined1;
            limit = limit === undefined1 ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined1;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = _$RegExp((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
            // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/[\r\n]/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            // Like with sourceURL, we take care to not check the option's prototype,
            // as this configuration is a code injection vector.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var _$result = attempt(function() {
                return _$Function(importsKeys, sourceURL + "return " + source).apply(undefined1, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            _$result.source = source;
            if (isError(_$result)) throw _$result;
            return _$result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrim, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimEnd, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined1)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var _$result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined1) return _$result + omission;
            if (strSymbols) end += _$result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = _$result;
                    if (!separator.global) separator = _$RegExp(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    _$result = _$result.slice(0, newEnd === undefined1 ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = _$result.lastIndexOf(separator);
                if (index > -1) _$result = _$result.slice(0, index);
            }
            return _$result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined1 : pattern;
            if (pattern === undefined1) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined1, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var _$chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (_$chain || chainAll) {
                        var _$result = object(this.__wrapped__), actions = _$result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        _$result.__chain__ = chainAll;
                        return _$result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined1 : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var _$result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return _$result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined1;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined1;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined1;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined1;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined1 ? 1 : nativeMax(toInteger(n), 0);
                var _$result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (_$result.__filtered__) _$result.__takeCount__ = nativeMin(n, _$result.__takeCount__);
                else _$result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (_$result.__dir__ < 0 ? "Right" : "")
                });
                return _$result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var _$result = this.clone();
                _$result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                _$result.__filtered__ = _$result.__filtered__ || isFilter;
                return _$result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var _$result = this;
            if (_$result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(_$result);
            if (start < 0) _$result = _$result.takeRight(-start);
            else if (start) _$result = _$result.drop(start);
            if (end !== undefined1) {
                end = toInteger(end);
                _$result = end < 0 ? _$result.dropRight(-end) : _$result.take(end - start);
            }
            return _$result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, _$iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function interceptor(value) {
                    var _$result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? _$result[0] : _$result;
                };
                if (useLazy && checkIteratee && typeof _$iteratee == "function" && _$iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var _$result = func.apply(value, args);
                    _$result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined1
                    });
                    return new LodashWrapper(_$result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                _$result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? _$result.value()[0] : _$result.value() : _$result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined1, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined1
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(undefined);

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"dXInN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelect", function() {
    return FilterSelect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _filterSelectStyles = require("./FilterSelect.styles");
var _lodash = require("lodash");
var _components = require("./components");
var _helpers = require("./helpers");
var FilterSelect = function(param) {
    var _param_isMulti = param.isMulti, isMulti = _param_isMulti === void 0 ? false : _param_isMulti, label = param.label, optionsList = param.optionsList, _param_placement = param.placement, placement = _param_placement === void 0 ? "right" : _param_placement, selected = param.selected, onSave = param.onSave;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), selectedFilters = _useState1[0], setSelectedFilters = _useState1[1];
    var menuEl = (0, _react.useRef)();
    var hasSelected = (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0;
    var handleToggleMultiFilter = function(option) {
        if (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some(function(filterOption) {
            return (0, _lodash.isEqual)(filterOption.value, option.value);
        })) setSelectedFilters(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.filter(function(filterOption) {
            return !(0, _lodash.isEqual)(filterOption.value, option.value);
        }));
        else setSelectedFilters((0, _toConsumableArray._)(selectedFilters).concat([
            option
        ]));
    };
    var handleToggleSingleFilter = function(option) {
        (0, _lodash.isEqual)(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters[0], option) && hasSelected ? setSelectedFilters([]) : setSelectedFilters([
            option
        ]);
    };
    var handleOptionClick = function(option) {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    (0, _utils.hookUtils).useClickOutside(menuEl, function() {
        if (isOpen) {
            setSelectedFilters(selected ? selected : []);
            setIsOpen(false);
        }
    });
    // ensures local state of selectedFilters is updated when selected prop is changed
    (0, _react.useEffect)(function() {
        if (selected && selected !== selectedFilters) setSelectedFilters(selected);
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _filterSelectStyles.StyledFilterSelect), {
        ref: menuEl,
        $placement: placement,
        className: "filter",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _index.Button), {
                className: (0, _classnamesDefault.default)("FilterSelect__toggle", "square", {
                    "filters-on": hasSelected
                }),
                "data-testid": "toggle-btn",
                onClick: function() {
                    setIsOpen(!isOpen);
                },
                children: [
                    label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "filter-label",
                        children: label
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        name: label ? "fa-caret-down" : "filter"
                    }),
                    hasSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "swatch-circle"
                    }) : []
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                "data-testid": "div-filter-options-container",
                className: (0, _classnamesDefault.default)("filter__container", {
                    visible: isOpen
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "FilterSelect__options",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterSelectOptions), {
                                isMulti: isMulti,
                                optionsList: (0, _helpers.sortOptionsList)(optionsList, selected),
                                selectedFilters: selectedFilters,
                                handleOptionClick: handleOptionClick
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterSelectReset), {
                                selectedFilterCount: selectedFilters.length,
                                setSelectedFilters: setSelectedFilters
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _components.FilterSelectControls), {
                        currentStoreFilters: selected,
                        selectedFilters: selectedFilters,
                        onSave: onSave,
                        setIsOpen: setIsOpen,
                        setSelectedFilters: setSelectedFilters
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./FilterSelect.styles":"56zsS","lodash":"h75z0","./components":"jbAA2","./helpers":"aXQLe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"56zsS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelect", function() {
    return StyledFilterSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  display: inline-block;\n  margin: 0 var(--pf-padding-2) var(--pf-padding-2) 0;\n  position: relative;\n\n  .FilterSelect__toggle {\n    display: flex;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    height: 35px;\n    padding: 5px 10px;\n    box-shadow: none;\n\n    .filter-label {\n      margin-right: var(--pf-padding-2);\n    }\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  .swatch-circle {\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--pf-secondary-color-400);\n  }\n\n  .filter__container {\n    position: absolute;\n    top: 36px;\n    ",
        "\n    width: 275px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    color: ",
        ";\n    display: none;\n    z-index: 100;\n  }\n\n  .visible {\n    display: block;\n  }\n\n  .FilterSelect__options {\n    padding: var(--pf-padding-3) 0;\n  }\n\n  .filter__title,\n  .option-container:not(:last-child) {\n    margin-bottom: var(--pf-padding-2);\n  }\n\n  .filter__icon {\n    margin-left: var(--pf-padding-2);\n  }\n\n  .filter__check {\n    margin-right: var(--pf-padding-2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).ebony, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 0;" : "left: 0;";
}, (0, _constants.COLORS).midnight, (0, _constants.COLORS).comet, (0, _constants.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jbAA2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectControls", function() {
    return 0, _filterSelectControls.FilterSelectControls;
});
parcelHelpers.export(exports, "FilterSelectOptions", function() {
    return 0, _filterSelectOptions.FilterSelectOptions;
});
parcelHelpers.export(exports, "FilterSelectReset", function() {
    return 0, _filterSelectReset.FilterSelectReset;
});
var _filterSelectControls = require("./FilterSelectControls/FilterSelectControls");
var _filterSelectOptions = require("./FilterSelectOptions/FilterSelectOptions");
var _filterSelectReset = require("./FilterSelectReset/FilterSelectReset");

},{"./FilterSelectControls/FilterSelectControls":"4vB8p","./FilterSelectOptions/FilterSelectOptions":"39wlf","./FilterSelectReset/FilterSelectReset":"YpTjv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4vB8p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectControls", function() {
    return FilterSelectControls;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("Permafrost/components/ui-foundations/buttons/Button/Button");
var _filterSelectControlsStyles = require("./FilterSelectControls.styles");
var FilterSelectControls = function(param) {
    var currentStoreFilters = param.currentStoreFilters, selectedFilters = param.selectedFilters, onSave = param.onSave, setIsOpen = param.setIsOpen, setSelectedFilters = param.setSelectedFilters;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _filterSelectControlsStyles.StyledFilterSelectControls), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                "aria-label": "Apply filter button",
                className: "apply-btn",
                onClick: function() {
                    onSave(selectedFilters);
                    setIsOpen(false);
                },
                children: "Apply"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                "aria-label": "Cancel filter button",
                className: "cancel-btn",
                onClick: function() {
                    setSelectedFilters(currentStoreFilters);
                    setIsOpen(false);
                },
                children: "Cancel"
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/components/ui-foundations/buttons/Button/Button":"gPP3j","./FilterSelectControls.styles":"MfJlP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"MfJlP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectControls", function() {
    return StyledFilterSelectControls;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 0 var(--pf-padding-3) var(--pf-padding-3) 0;\n\n  .apply-btn {\n    background-color: ",
        ";\n    border-radius: 10px;\n    color: ",
        ";\n  }\n\n  .cancel-btn {\n    background: none;\n    box-shadow: none;\n    color: ",
        ";\n    margin-right: var(--pf-padding-2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectControls = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).summerSky, (0, _constants.COLORS).white, (0, _constants.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"39wlf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectOptions", function() {
    return FilterSelectOptions;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _filterSelectOptionsStyles = require("./FilterSelectOptions.styles");
var FilterSelectOptions = function(param) {
    var isMulti = param.isMulti, optionsList = param.optionsList, selectedFilters = param.selectedFilters, handleOptionClick = param.handleOptionClick;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSelectOptionsStyles.StyledFilterSelectOptions), {
        children: optionsList === null || optionsList === void 0 ? void 0 : optionsList.map(function(filterOption) {
            var text = filterOption.text, value = filterOption.value, iconName = filterOption.iconName;
            var selected = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some(function(item) {
                return item.value === value;
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                "data-testid": "li--filter-list-".concat(value),
                className: (0, _classnamesDefault.default)("option-container", {
                    selected: selected
                }),
                onClick: function() {
                    handleOptionClick(filterOption);
                },
                children: isMulti ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "multi-option",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Checkbox), {
                            "aria-label": "Checkbox option ".concat(filterOption.value),
                            className: "option-checkbox",
                            isSelected: selected
                        }),
                        text
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "single-option",
                    children: [
                        text,
                        iconName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: iconName,
                            className: "filter__icon",
                            "data-testid": "li--filter-list-icon-for-".concat(value)
                        }) : null,
                        selected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "check",
                            className: "selected-checkmark",
                            "data-testid": "li--filter-list-icon-selected-indicator-for-".concat(value)
                        }) : null
                    ]
                })
            }, "LabelFilter-".concat(value));
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./FilterSelectOptions.styles":"J6dh7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"J6dh7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectOptions", function() {
    return StyledFilterSelectOptions;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .option-container {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid ",
        ";\n    cursor: pointer;\n\n    .single-option,\n    .multi-option {\n      display: flex;\n      padding: 0 0 var(--pf-padding-2) var(--pf-padding-3);\n    }\n\n    .option-checkbox {\n      color: ",
        ";\n      margin-right: var(--pf-padding-2);\n\n      .checkboxSquare {\n        stroke-width: 1;\n      }\n\n      &.checked {\n        .checkboxSquare {\n          color: var(--pf-secondary-color-400);\n          fill: var(--pf-secondary-color-400);\n        }\n\n        .checkmark {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .selected-checkmark {\n      color: var(--pf-secondary-color-400);\n      margin-left: var(--pf-padding-2);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectOptions = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).baliHai, (0, _constants.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"YpTjv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectReset", function() {
    return FilterSelectReset;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _filterSelectStyles = require("./FilterSelect.styles");
var FilterSelectReset = function(param) {
    var selectedFilterCount = param.selectedFilterCount, setSelectedFilters = param.setSelectedFilters;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _filterSelectStyles.StyledFilterSelectReset), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "reset",
                onClick: function() {
                    setSelectedFilters([]);
                },
                children: "Reset"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    " ",
                    selectedFilterCount,
                    " Selected "
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./FilterSelect.styles":"3yZVK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3yZVK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectReset", function() {
    return StyledFilterSelectReset;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  background-color: ",
        ";\n  margin-top: var(--pf-padding-2);\n  padding: var(--pf-padding-2) var(--pf-padding-3);\n  font-size: ",
        ";\n\n  .reset:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectReset = (0, _styledComponentsDefault.default).p(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aXQLe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortOptionsList", function() {
    return sortOptionsList;
});
var sortOptionsList = function(optionsList, selected) {
    var selectedValues = new Set(selected.map(function(item) {
        return item.value;
    }));
    return optionsList.sort(function(a, b) {
        var aSelected = selectedValues.has(a.value) ? 0 : 1;
        var bSelected = selectedValues.has(b.value) ? 0 : 1;
        return aSelected - bSelected;
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Z9AlT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wrapper component which enables text editing in place directly on a child component,
 * element, or plain text.
 */ parcelHelpers.export(exports, "EditableField", function() {
    return EditableField;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// todo: how to handle/inform user when length is too short?
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _editableFieldStyles = require("./EditableField.styles");
function EditableField(props) {
    var children = props.children, className = props.className, _props_minLength = props.minLength, minLength = _props_minLength === void 0 ? 3 : _props_minLength, onUpdate = props.onUpdate;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), initialValue = _useState[0], setInitialValue = _useState[1];
    // used as unique css class name
    var _useRef = (0, _react.useRef)((0, _utils.stringUtils).createRandomString()), id = _useRef.current;
    var editableEl = (0, _react.useRef)();
    var handleBlur = function() {
        var node = editableEl.current.children[0];
        var currentValue = node.innerText || editableEl.current.innerText;
        if (minLength && currentValue.length < minLength) {
            // revert to last good value
            if (node) node.textContent = initialValue;
            else editableEl.current.textContent = initialValue;
        } else if (currentValue !== initialValue) {
            // allow updated value
            setInitialValue(currentValue);
            if (onUpdate) onUpdate(currentValue);
        }
    };
    var handleKeypress = function(event) {
        if (event.key === "Enter") editableEl.current.blur();
    };
    // Records the initial value for the text, in order to check length and compare to current text.
    // Also ensures the size of the icon is relative to the text inside the editable element (which
    // is the icon’s *sibling*, not ancestor).
    (0, _react.useEffect)(function() {
        var style = document.createElement("style");
        var node = editableEl.current.children[0];
        document.head.appendChild(style);
        if (node) {
            var _style_sheet;
            var fontSize = getComputedStyle(node).fontSize;
            style === null || style === void 0 ? void 0 : (_style_sheet = style.sheet) === null || _style_sheet === void 0 ? void 0 : _style_sheet.insertRule(".".concat(id, " .pencil-icon { font-size: calc(").concat(fontSize, " * 0.8) }"));
            setInitialValue(node.innerText);
        } else {
            var _style_sheet1;
            style === null || style === void 0 ? void 0 : (_style_sheet1 = style.sheet) === null || _style_sheet1 === void 0 ? void 0 : _style_sheet1.insertRule(".".concat(id, " .pencil-icon { font-size: 0.8em }"));
            setInitialValue(editableEl.current.innerText);
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _editableFieldStyles.StyledEditableField), {
        className: (0, _classnamesDefault.default)("EditableField-container", id, className),
        "data-cy": props["data-cy"],
        id: props.id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                role: "textbox",
                tabIndex: 0,
                contentEditable: true,
                suppressContentEditableWarning: true,
                ref: editableEl,
                onKeyDown: handleKeypress,
                onBlur: handleBlur,
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: "fa-pencil-alt",
                className: "pencil-icon"
            })
        ]
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./EditableField.styles":"de6X2","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"de6X2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledEditableField", function() {
    return StyledEditableField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:hover .pencil-icon {\n    opacity: 1;\n  }\n\n  [role='textbox'] > * {\n    display: inline-block;\n  }\n\n  .pencil-icon {\n    margin-left: 0.25em;\n    margin-right: 3px;\n    opacity: 0;\n\n    transition: opacity ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var transitionDuration = "200ms";
var StyledEditableField = (0, _styledComponentsDefault.default).span(_templateObject(), transitionDuration);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"32qiH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Basic numeric input field. A label is required, but may be visually hidden
 * using the `hiddenLabel` property.
 */ parcelHelpers.export(exports, "NumberField", function() {
    return NumberField;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _numberFieldStyles = require("./NumberField.styles");
function NumberField(props) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoFocus = props.autoFocus, className = props.className, disabled = props.disabled, hiddenLabel = props.hiddenLabel, id = props.id, label = props.label, max = props.max, min = props.min, onChange = props.onChange, placeholder = props.placeholder, required = props.required, step = props.step, tabIndex = props.tabIndex, value = props.value;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(value ? value : value === 0 ? 0 : ""), 2), currentValue = _useState[0], setCurrentValue = _useState[1];
    var inputEl = (0, _react.useRef)(null);
    var increment = function() {
        var input = inputEl.current;
        if (input) {
            input.stepUp();
            // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.increment) props.increment();
    };
    var decrement = function() {
        var input = inputEl.current;
        if (input) {
            input.stepDown();
            // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.decrement) props.decrement();
    };
    var handleChange = function(event) {
        var _event_target;
        var targetValue = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value;
        setCurrentValue(targetValue === "" ? "" : +targetValue);
    };
    // When external state changes, we update local state to match, if not already
    (0, _react.useEffect)(function() {
        if (currentValue === value) return;
        setCurrentValue(value);
    }, [
        value
    ]);
    // todo: this is problematic because it means on mount the onChange handler will always be fired
    // therefore - if the onChange is some heavy operation or call to the BE - that will automatically get called
    // without the user even doing anything
    (0, _react.useEffect)(function() {
        // We must debounce the min/max evaluation until after the user has finished typing
        var delayDebounceFn = setTimeout(function() {
            if ((min || min === 0) && +currentValue < min) {
                setCurrentValue("");
                onChange("");
            } else if ((max || max === 0) && +currentValue > max) {
                setCurrentValue("");
                onChange("");
            } else if (+currentValue < 0) {
                setCurrentValue("");
                onChange("");
            } else onChange(currentValue);
        }, 1000);
        return function() {
            return clearTimeout(delayDebounceFn);
        };
    }, [
        currentValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _numberFieldStyles.StyledNumberField), {
        className: (0, _classnamesDefault.default)(className, {
            hiddenLabel: hiddenLabel
        }),
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                "data-testid": props["data-testid"],
                tabIndex: tabIndex,
                autoFocus: autoFocus,
                id: fieldId,
                type: "number",
                value: currentValue,
                disabled: disabled,
                max: max,
                min: min,
                onChange: handleChange,
                placeholder: placeholder,
                required: required,
                step: step,
                "aria-label": hiddenLabel ? label : "",
                ref: inputEl
            }),
            !hiddenLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: fieldId,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "spin-buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        variant: "no-style",
                        onClick: increment,
                        tabindex: -1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-caret-up",
                            ariaLabel: "increase"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        variant: "no-style",
                        onClick: decrement,
                        tabindex: -1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-caret-down",
                            ariaLabel: "decrease"
                        })
                    })
                ]
            })
        ]
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","uuid":"6ZyFu","Permafrost/index":"iliLC","./NumberField.styles":"bVa0p","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bVa0p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNumberField", function() {
    return StyledNumberField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  min-height: 40px;\n\n  &:not(.hiddenLabel) {\n    margin-top: 35px;\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    -moz-appearance: textfield;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      appearance: none;\n    }\n\n    &::placeholder {\n      opacity: 0.5;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      background-color: transparent;\n      opacity: 0.7;\n\n      pointer-events: none;\n\n      ~ .spin-buttons {\n        opacity: 0.7;\n\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  label {\n    ",
        ";\n\n    position: absolute;\n    top: -24px;\n  }\n\n  .spin-buttons {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    margin-bottom: 0.5em;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNumberField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _fieldsCommonStyles.inputCommon), (0, _index.COLORS).lightFontColor, (0, _fieldsCommonStyles.labelCommon));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"80ySS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"80ySS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputCommon", function() {
    return inputCommon;
});
parcelHelpers.export(exports, "labelCommon", function() {
    return labelCommon;
});
parcelHelpers.export(exports, "fieldInfoCommon", function() {
    return fieldInfoCommon;
});
parcelHelpers.export(exports, "placeholderCommon", function() {
    return placeholderCommon;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: transparent;\n  color: ",
        ";\n\n  border-radius: 0;\n  border: 0 solid currentColor;\n  border-bottom-width: 1px;\n\n  &:focus,\n  &:hover,\n  &.filled {\n    border-color: ",
        ";\n  }\n\n  &:required {\n    border-bottom-color: ",
        ";\n\n    + label:after {\n      content: '*';\n      margin-left: 4px;\n    }\n  }\n\n  &:disabled {\n    border-style: dotted;\n    border-bottom-color: ",
        ";\n    cursor: not-allowed;\n\n    &:hover {\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-top: 13px;\n  font-size: ",
        ";\n\n  .prompt {\n    color: ",
        ";\n  }\n\n  .error {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &::placeholder,\n  &::-webkit-input-placeholder {\n    opacity: 0.42;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var inputCommon = (0, _styledComponents.css)(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).lightGray);
var labelCommon = (0, _styledComponents.css)(_templateObject1(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).lightFontColor);
var fieldInfoCommon = (0, _styledComponents.css)(_templateObject2(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).red);
var placeholderCommon = (0, _styledComponents.css)(_templateObject3());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1xQ7o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Basic numeric input field. A label is required, but may be visually hidden
 * using the `hiddenLabel` property.
 */ parcelHelpers.export(exports, "NumberField", function() {
    return NumberField;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodash = require("lodash");
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _numberFieldStyles = require("./NumberField.styles");
function NumberField(props) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoFocus = props.autoFocus, className = props.className, disabled = props.disabled, hiddenLabel = props.hiddenLabel, id = props.id, label = props.label, max = props.max, min = props.min, placeholder = props.placeholder, _props_readOnly = props.readOnly, readOnly = _props_readOnly === void 0 ? false : _props_readOnly, required = props.required, step = props.step, tabIndex = props.tabIndex, value = props.value, onChange = props.onChange, onClick = props.onClick;
    var inputEl = (0, _react.useRef)(null);
    var increment = function() {
        var input = inputEl.current;
        if (input) {
            input.stepUp();
            // if !value OR value < min, set value to min or 1 - else increment by step
            (0, _lodash.isNil)(value) || !(0, _lodash.isNil)(min) && value < min ? onChange(min || 1) : onChange(+input.value);
        }
    };
    var decrement = function() {
        var input = inputEl.current;
        if (input) {
            input.stepDown();
            // if !value, set value to min or 0 - else if value > max, set value to max - else decrement by step
            (0, _lodash.isNil)(value) ? onChange(min || 0) : !(0, _lodash.isNil)(max) && value > max ? onChange(max) : onChange(+input.value);
        }
    };
    var handleChange = function(event) {
        var _event_target;
        // no validation for min or max - whatever value the user enters will be passed to onChange
        var targetValue = event === null || event === void 0 ? void 0 : (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value;
        onChange(targetValue === "" ? null : +targetValue);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _numberFieldStyles.StyledNumberField), {
        className: (0, _classnamesDefault.default)(className, {
            hiddenLabel: hiddenLabel
        }),
        "data-cy": props["data-cy"],
        id: id,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: fieldId,
                "aria-label": hiddenLabel ? label : "",
                autoFocus: autoFocus,
                "data-testid": props["data-testid"],
                readOnly: readOnly,
                disabled: disabled,
                max: max,
                min: min,
                onChange: handleChange,
                placeholder: placeholder,
                ref: inputEl,
                required: required,
                step: step,
                tabIndex: tabIndex,
                type: "number",
                value: !(0, _lodash.isNil)(value) ? value : ""
            }),
            !hiddenLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: fieldId,
                children: label
            }) : null,
            readOnly ? null : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "spin-buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        "data-testid": "increment-button",
                        disabled: !(0, _lodash.isNil)(value) && !(0, _lodash.isNil)(max) && value >= max ? true : false,
                        onClick: increment,
                        tabindex: -1,
                        variant: "no-style",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-caret-up",
                            ariaLabel: "increase"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        "data-testid": "decrement-button",
                        disabled: !(0, _lodash.isNil)(value) && !(0, _lodash.isNil)(min) && value <= min ? true : false,
                        onClick: decrement,
                        tabindex: -1,
                        variant: "no-style",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-caret-down",
                            ariaLabel: "decrease"
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","lodash":"h75z0","uuid":"6ZyFu","Permafrost/index":"iliLC","./NumberField.styles":"90Xjt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"90Xjt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNumberField", function() {
    return StyledNumberField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  min-height: 40px;\n\n  &:not(.hiddenLabel) {\n    margin-top: 35px;\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    -moz-appearance: textfield;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      appearance: none;\n    }\n\n    &::placeholder {\n      opacity: 0.5;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      background-color: transparent;\n      opacity: 0.7;\n\n      pointer-events: none;\n\n      ~ .spin-buttons {\n        opacity: 0.7;\n\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  label {\n    ",
        ";\n\n    position: absolute;\n    top: -24px;\n  }\n\n  .spin-buttons {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    margin-bottom: 0.5em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNumberField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _fieldsCommonStyles.inputCommon), (0, _index.COLORS).lightFontColor, (0, _fieldsCommonStyles.labelCommon));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"80ySS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5M87q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", function() {
    return SearchField;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _searchFieldStyles = require("./SearchField.styles");
var SearchField = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, inputProps = props.inputProps, onChange = props.onChange, onKeyUp = props.onKeyUp, placeholder = props.placeholder, value = props.value;
    var id = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _searchFieldStyles.StyledSearchField), {
        className: className,
        "data-cy": props["data-cy"],
        id: props.id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "fa-search",
                    ariaLabel: "search"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                type: "search",
                id: id,
                placeholder: placeholder,
                value: value,
                onChange: onChange,
                onKeyUp: onKeyUp
            }, inputProps))
        ]
    });
};
exports.default = SearchField;

},{"@swc/helpers/_/_object_spread":"6U9Ts","react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./SearchField.styles":"aWStc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aWStc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSearchField", function() {
    return StyledSearchField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  background: transparent;\n\n  label {\n    position: absolute;\n    top: 4px;\n    left: 0;\n    font-size: ",
        ";\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 5px 5px 25px;\n    font-size: ",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSearchField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _fieldsCommonStyles.inputCommon), (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"80ySS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kADDo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", function() {
    return TextField;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _textFieldStyles = require("./TextField.styles");
var TextField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoComplete = props.autoComplete, autoFocus = props.autoFocus, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayErrors = props.displayErrors, id = props.id, inputProps = props.inputProps, label = props.label, maxLength = props.maxLength, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onKeyUp = props.onKeyUp, onClick = props.onClick, onFocus = props.onFocus, placeholder = props.placeholder, promptProps = props.promptProps, required = props.required, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, validationErrors = props.validationErrors, value = props.value, readOnly = props.readOnly;
    var handleKeyUp = function(e) {
        if (!onKeyUp && e.key === "Enter") e.currentTarget.blur();
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    };
    var errorClass = displayErrors ? "error" : "prompt";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _textFieldStyles.StyledTextField), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                autoComplete: autoComplete,
                autoFocus: autoFocus,
                className: (0, _classnamesDefault.default)("text-input__input-element", {
                    filled: value && value.length > 0 || defaultValue
                }),
                disabled: disabled,
                defaultValue: defaultValue,
                id: fieldId,
                maxLength: maxLength,
                name: name,
                onBlur: onBlur,
                onChange: onChange,
                onClick: onClick,
                onFocus: onFocus,
                onKeyUp: handleKeyUp,
                placeholder: placeholder,
                required: required,
                type: type,
                value: value,
                readOnly: readOnly,
                ref: ref
            }, inputProps)),
            label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: fieldId,
                children: label
            }) : null,
            (validationErrors || maxLength) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _textFieldStyles.StyledFieldInfo), {
                children: [
                    validationErrors && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: validationErrors.map(function(err, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                className: errorClass
                            }, promptProps), {
                                children: err
                            }), i);
                        })
                    }),
                    maxLength && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("count", {
                            isMax: (value === null || value === void 0 ? void 0 : value.length) === maxLength
                        }),
                        children: [
                            (value === null || value === void 0 ? void 0 : value.length) || 0,
                            " / ",
                            maxLength
                        ]
                    })
                ]
            })
        ]
    });
});

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","classnames":"9xS9S","react":"ktQNc","uuid":"6ZyFu","./TextField.styles":"aqSzG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aqSzG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTextField", function() {
    return StyledTextField;
});
parcelHelpers.export(exports, "StyledFieldInfo", function() {
    return StyledFieldInfo;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  color: ",
        ";\n  font-family: ",
        ";\n\n  min-height: 40px;\n  margin-top: 35px;\n\n  label {\n    pointer-events: none;\n\n    position: absolute;\n    top: 6px;\n\n    transition: transform ",
        " ",
        ";\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    border: 0 solid currentColor;\n    border-bottom-width: 1px;\n\n    &::placeholder,\n    &::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0;\n\n      transition: opacity ",
        " ",
        ";\n    }\n\n    &:focus,\n    &.filled {\n      ",
        "\n\n      + label {\n        ",
        ";\n\n        transform: translateY(-30px);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  display: flex;\n\n  p {\n    margin: 0;\n  }\n\n  .count {\n    margin-left: auto;\n  }\n\n  .isMax {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTextField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.TYPOGRAPHY).fontFamily.base, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _fieldsCommonStyles.inputCommon), (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _fieldsCommonStyles.placeholderCommon), (0, _fieldsCommonStyles.labelCommon));
var StyledFieldInfo = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _fieldsCommonStyles.fieldInfoCommon), (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"80ySS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"0aYlm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", function() {
    return Card;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodash = require("lodash");
var _index = require("Permafrost/index");
var _cardStyles = require("./Card.styles");
var Card = function(card) {
    var id = card.id, className = card.className, description = card.description, disabled = card.disabled, disabledTooltip = card.disabledTooltip, footer = card.footer, header = card.header, kabobMenuOptions = card.kabobMenuOptions, selectable = card.selectable, style = card.style, title = card.title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardStyles.StyledCard), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            disabled: disabled === true,
            selectable: (0, _lodash.isFunction)(selectable === null || selectable === void 0 ? void 0 : selectable.onSelect) === true,
            // TODO: confirm this check is sufficient here.
            selected: (selectable === null || selectable === void 0 ? void 0 : selectable.selected) === true
        }),
        "data-tip": true,
        "data-for": id,
        "data-tip-disable": !disabled,
        onClick: function() {
            if (!disabled) selectable === null || selectable === void 0 ? void 0 : selectable.onSelect();
        },
        style: style,
        "data-testid": card["data-testid"],
        children: [
            disabledTooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                for: id,
                children: disabledTooltip
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "Card--header-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header",
                        children: header
                    }),
                    kabobMenuOptions ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.KabobMenu), {
                        id: "".concat(id, "-kabob-menu"),
                        className: "kabob",
                        disabled: disabled,
                        menuOptions: kabobMenuOptions
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Card--content-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "body-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("header", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "title",
                                    children: title
                                })
                            }),
                            description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "desc",
                                children: description
                            }) : null
                        ]
                    }),
                    footer ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "footer",
                        children: footer
                    }) : null
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","lodash":"h75z0","Permafrost/index":"iliLC","./Card.styles":"5uh94","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5uh94":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCard", function() {
    return StyledCard;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: solid 1px ",
        ";\n  border-radius: 4px;\n  box-sizing: content-box;\n\n  &,\n  .Card--header-container,\n  .Card--content-container,\n  .Card--header-container .header {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .Card--header-container {\n    align-items: center;\n    background: ",
        ";\n    border-radius: 2px 2px 0 0;\n    padding: 0 30px;\n    position: relative;\n    width: 100%;\n\n    .header {\n      color: ",
        ";\n      height: 80px;\n      width: 100%;\n      max-width: 150px;\n      margin: 0;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .kabob {\n      position: absolute;\n      right: 2px;\n      top: -2px;\n    }\n  }\n\n  .Card--content-container {\n    height: 100%;\n    justify-content: space-between;\n    padding: 10px;\n\n    .title {\n      color: ",
        ";\n      font-size: 18px;\n    }\n\n    .desc {\n      margin-top: 10px;\n      word-break: break-word;\n    }\n\n    .footer {\n      color: ",
        ";\n      display: flex;\n      font-size: 12px;\n      margin-top: 20px;\n    }\n  }\n\n  &.selectable {\n    cursor: pointer;\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  &.selected {\n    border: solid 2px ",
        ";\n    margin: -1px;\n  }\n\n  &.disabled {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCard = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).midFontColor, (0, _index.COLORS).white, (0, _index.COLORS).midFontColor, (0, _index.COLORS).fieldPromptInfo);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jrzRT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardContainer", function() {
    return 0, _cardContainer.CardContainer;
});
var _cardContainer = require("./CardContainer");

},{"./CardContainer":"fpDOO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fpDOO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardContainer", function() {
    return CardContainer;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _card = require("../Card/Card");
var _cardContainerStyles = require("./CardContainer.styles");
var CardContainer = function(props) {
    var cards = props.cards;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardContainerStyles.StyledCardContainer), {
        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    card.disabledTooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        className: "tooltip",
                        for: card.id,
                        children: card.disabledTooltip
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _card.Card), {
                        id: card.id,
                        className: "CardContainer__Card ".concat(card === null || card === void 0 ? void 0 : card.className),
                        description: (card === null || card === void 0 ? void 0 : card.description) || "",
                        disabled: card === null || card === void 0 ? void 0 : card.disabled,
                        footer: card === null || card === void 0 ? void 0 : card.footer,
                        header: card === null || card === void 0 ? void 0 : card.header,
                        kabobMenuOptions: card === null || card === void 0 ? void 0 : card.kabobMenuOptions,
                        selectable: card === null || card === void 0 ? void 0 : card.selectable,
                        style: card === null || card === void 0 ? void 0 : card.style,
                        title: card.title,
                        "data-testid": "card-".concat(card.id)
                    })
                ]
            }, card.id);
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","../Card/Card":"0aYlm","./CardContainer.styles":"gtYhU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gtYhU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCardContainer", function() {
    return StyledCardContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 16px;\n\n  .tooltip {\n    position: absolute;\n  }\n\n  .CardContainer__Card {\n    height: 100%;\n  }\n\n  .gallery-icon--base64ai,\n  .gallery-icon--huggingface-logo,\n  .gallery-icon--privateai-logo {\n    width: 100%;\n  }\n\n  .gallery-icon--img {\n    max-height: 60px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCardContainer = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).largeScreen);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ha84m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A single checkbox and its label.
 */ parcelHelpers.export(exports, "Checkbox", function() {
    return Checkbox;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _index = require("Permafrost/index");
var _checkboxStyles = require("./Checkbox.styles");
function Checkbox(props) {
    var _props_checkmarkColor = props.checkmarkColor, checkmarkColor = _props_checkmarkColor === void 0 ? (0, _index.COLORS).black : _props_checkmarkColor, children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? (0, _index.COLORS).white : _props_color, id = props.id, isDisabled = props.isDisabled, _props_isLoading = props.isLoading, isLoading = _props_isLoading === void 0 ? false : _props_isLoading, _props_isSelected = props.isSelected, isSelected = _props_isSelected === void 0 ? false : _props_isSelected, _props_isInline = props.isInline, isInline = _props_isInline === void 0 ? false : _props_isInline, _props_onChange = props.onChange, onChange = _props_onChange === void 0 ? function() {} : _props_onChange;
    var inputRef = (0, _react.useRef)(null);
    var checkboxState = {
        isSelected: isSelected,
        setSelected: onChange,
        toggle: function() {
            return onChange(!isSelected);
        }
    };
    var inputProps = (0, _checkbox.useCheckbox)(props, checkboxState, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var checkboxMeasure = 18;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _checkboxStyles.StyledCheckbox), {
        "data-cy": props["data-cy"],
        "data-tip": props["data-tip"],
        "data-for": props["data-for"],
        className: (0, _classnamesDefault.default)({
            checked: isSelected,
            disabled: isDisabled || isLoading,
            inline: isInline
        }, className),
        id: id,
        $color: color,
        $checkmarkColor: checkmarkColor,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpreadProps._)((0, _objectSpread._)({
                type: "checkbox"
            }, inputProps, visuallyHiddenProps, focusProps), {
                ref: inputRef,
                disabled: isDisabled || isLoading
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                viewBox: "0 0 20 20",
                "aria-hidden": "true",
                focusable: "false",
                overflow: "visible",
                className: "checkbox",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: 1,
                        y: 1,
                        width: checkboxMeasure,
                        height: checkboxMeasure,
                        rx: 2,
                        fill: "none",
                        stroke: "currentColor",
                        className: "checkboxSquare"
                    }),
                    isFocusVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        x: -2.5,
                        y: -2.5,
                        width: checkboxMeasure + 7,
                        height: checkboxMeasure + 7,
                        rx: 4,
                        fill: "none",
                        className: "focusRing"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        transform: "translate(1, 1)",
                        children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "check",
                            className: "checkmark",
                            size: [
                                checkboxMeasure
                            ]
                        })
                    })
                ]
            }),
            children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "checkbox__text",
                children: children
            }) : null
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@react-aria/checkbox":"aEPJn","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","Permafrost/index":"iliLC","./Checkbox.styles":"lf5Pn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aEPJn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckbox", function() {
    return $406796ff087fe49b$export$e375f10ce42261c5;
});
parcelHelpers.export(exports, "useCheckboxGroup", function() {
    return $1e9fce0cfacc738b$export$49ff6f28c54f1cbe;
});
parcelHelpers.export(exports, "useCheckboxGroupItem", function() {
    return $fba3e38d5ca8983f$export$353b32fc6898d37d;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _form = require("@react-aria/form");
var _form1 = require("@react-stately/form");
var _toggle = require("@react-aria/toggle");
var _utils = require("@react-aria/utils");
var _label = require("@react-aria/label");
var _interactions = require("@react-aria/interactions");
var _toggle1 = require("@react-stately/toggle");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $406796ff087fe49b$export$e375f10ce42261c5(props, state, inputRef) {
    // Create validation state here because it doesn't make sense to add to general useToggleState.
    var validationState = (0, _form1.useFormValidationState)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        value: state.isSelected
    }));
    var _validationState_displayValidation = validationState.displayValidation, isInvalid = _validationState_displayValidation.isInvalid, validationErrors = _validationState_displayValidation.validationErrors, validationDetails = _validationState_displayValidation.validationDetails;
    var _$cKEhs$useToggle = (0, _toggle.useToggle)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        isInvalid: isInvalid
    }), state, inputRef), labelProps = _$cKEhs$useToggle.labelProps, inputProps = _$cKEhs$useToggle.inputProps, isSelected = _$cKEhs$useToggle.isSelected, isPressed = _$cKEhs$useToggle.isPressed, isDisabled = _$cKEhs$useToggle.isDisabled, isReadOnly = _$cKEhs$useToggle.isReadOnly;
    (0, _form.useFormValidation)(props, validationState, inputRef);
    var isIndeterminate = props.isIndeterminate, isRequired = props.isRequired, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? "aria" : tmp;
    (0, _react.useEffect)(function() {
        // indeterminate is a property, but it can only be set via javascript
        // https://css-tricks.com/indeterminate-checkboxes/
        if (inputRef.current) inputRef.current.indeterminate = !!isIndeterminate;
    });
    return {
        labelProps: labelProps,
        inputProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, inputProps), {
            checked: isSelected,
            "aria-required": isRequired && validationBehavior === "aria" || undefined,
            required: isRequired && validationBehavior === "native"
        }),
        isSelected: isSelected,
        isPressed: isPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $1ae600c947479353$export$ec98120685d4f57d = new WeakMap();
function $1e9fce0cfacc738b$export$49ff6f28c54f1cbe(props, state) {
    var isDisabled = props.isDisabled, name = props.name, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? "aria" : tmp;
    var _state_displayValidation = state.displayValidation, isInvalid = _state_displayValidation.isInvalid, validationErrors = _state_displayValidation.validationErrors, validationDetails = _state_displayValidation.validationDetails;
    var _$cKEhs$useField = (0, _label.useField)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        // Checkbox group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span",
        isInvalid: isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$cKEhs$useField.labelProps, fieldProps = _$cKEhs$useField.fieldProps, descriptionProps = _$cKEhs$useField.descriptionProps, errorMessageProps = _$cKEhs$useField.errorMessageProps;
    $1ae600c947479353$export$ec98120685d4f57d.set(state, {
        name: name,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    var domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    var _$cKEhs$useFocusWithin = (0, _interactions.useFocusWithin)({
        onBlurWithin: props.onBlur,
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    }), focusWithinProps = _$cKEhs$useFocusWithin.focusWithinProps;
    return {
        groupProps: (0, _utils.mergeProps)(domProps, (0, _objectSpread._)({
            role: "group",
            "aria-disabled": isDisabled || undefined
        }, fieldProps, focusWithinProps)),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $fba3e38d5ca8983f$export$353b32fc6898d37d(props, state, inputRef) {
    var toggleState = (0, _toggle1.useToggleState)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isSelected: state.isSelected(props.value),
        onChange: function(isSelected) {
            if (isSelected) state.addValue(props.value);
            else state.removeValue(props.value);
            if (props.onChange) props.onChange(isSelected);
        }
    });
    var _$1ae600c947479353$export$ec98120685d4f57d_get = $1ae600c947479353$export$ec98120685d4f57d.get(state), name = _$1ae600c947479353$export$ec98120685d4f57d_get.name, descriptionId = _$1ae600c947479353$export$ec98120685d4f57d_get.descriptionId, errorMessageId = _$1ae600c947479353$export$ec98120685d4f57d_get.errorMessageId, validationBehavior = _$1ae600c947479353$export$ec98120685d4f57d_get.validationBehavior;
    var _props_validationBehavior;
    validationBehavior = (_props_validationBehavior = props.validationBehavior) !== null && _props_validationBehavior !== void 0 ? _props_validationBehavior : validationBehavior;
    // Local validation for this checkbox.
    var _$cKEhs$useFormValidationState = (0, _form1.useFormValidationState)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        value: toggleState.isSelected,
        // Server validation is handled at the group level.
        name: undefined,
        validationBehavior: "aria"
    })), realtimeValidation = _$cKEhs$useFormValidationState.realtimeValidation;
    // Update the checkbox group state when realtime validation changes.
    var nativeValidation = (0, _react.useRef)((0, _form1.DEFAULT_VALIDATION_RESULT));
    var updateValidation = function() {
        state.setInvalid(props.value, realtimeValidation.isInvalid ? realtimeValidation : nativeValidation.current);
    };
    (0, _react.useEffect)(updateValidation);
    // Combine group and checkbox level validation.
    var combinedRealtimeValidation = state.realtimeValidation.isInvalid ? state.realtimeValidation : realtimeValidation;
    var displayValidation = validationBehavior === "native" ? state.displayValidation : combinedRealtimeValidation;
    var _props_isRequired;
    var res = $406796ff087fe49b$export$e375f10ce42261c5((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), (0, _defineProperty._)({
        isReadOnly: props.isReadOnly || state.isReadOnly,
        isDisabled: props.isDisabled || state.isDisabled,
        name: props.name || name,
        isRequired: (_props_isRequired = props.isRequired) !== null && _props_isRequired !== void 0 ? _props_isRequired : state.isRequired,
        validationBehavior: validationBehavior
    }, (0, _form1.privateValidationStateProp), {
        realtimeValidation: combinedRealtimeValidation,
        displayValidation: displayValidation,
        resetValidation: state.resetValidation,
        commitValidation: state.commitValidation,
        updateValidation: function(v) {
            nativeValidation.current = v;
            updateValidation();
        }
    })), toggleState, inputRef);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, res), {
        inputProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, res.inputProps), {
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        })
    });
}

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react":"ktQNc","@react-aria/form":"bfEeS","@react-stately/form":"atqUq","@react-aria/toggle":"eQXBq","@react-aria/utils":"jTQk5","@react-aria/label":"fvVMI","@react-aria/interactions":"kSKDi","@react-stately/toggle":"a43G4","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bfEeS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormValidation", function() {
    return $e93e671b31057976$export$b8473d3665f3a75a;
});
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e93e671b31057976$export$b8473d3665f3a75a(props, state, ref) {
    var validationBehavior = props.validationBehavior, focus = props.focus;
    (0, _utils.useLayoutEffect)(function() {
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            var errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    var onReset = (0, _utils.useEffectEvent)(function() {
        state.resetValidation();
    });
    var onInvalid = (0, _utils.useEffectEvent)(function(e) {
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, _interactions.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    var onChange = (0, _utils.useEffectEvent)(function() {
        state.commitValidation();
    });
    (0, _react.useEffect)(function() {
        var input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        var form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return function() {
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    var validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $e93e671b31057976$var$getFirstInvalidInput(form) {
    for(var i = 0; i < form.elements.length; i++){
        var element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

},{"react":"ktQNc","@react-aria/interactions":"kSKDi","@react-aria/utils":"jTQk5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kSKDi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pressable", function() {
    return $3b117e43dc0ca95d$export$27c701ed9e449e99;
});
parcelHelpers.export(exports, "PressResponder", function() {
    return $f1ab8c75478c6f73$export$3351871ee4b288b8;
});
parcelHelpers.export(exports, "ClearPressResponder", function() {
    return $f1ab8c75478c6f73$export$cf75428e0b9ed1ea;
});
parcelHelpers.export(exports, "useFocus", function() {
    return $a1ea59d68270f0dd$export$f8168d8dd8fd66e6;
});
parcelHelpers.export(exports, "isFocusVisible", function() {
    return $507fabe10e71c6fb$export$b9b3dfddab17db27;
});
parcelHelpers.export(exports, "getInteractionModality", function() {
    return $507fabe10e71c6fb$export$630ff653c5ada6a9;
});
parcelHelpers.export(exports, "setInteractionModality", function() {
    return $507fabe10e71c6fb$export$8397ddfc504fdb9a;
});
parcelHelpers.export(exports, "addWindowFocusTracking", function() {
    return $507fabe10e71c6fb$export$2f1888112f558a7d;
});
parcelHelpers.export(exports, "useInteractionModality", function() {
    return $507fabe10e71c6fb$export$98e20ec92f614cfe;
});
parcelHelpers.export(exports, "useFocusVisible", function() {
    return $507fabe10e71c6fb$export$ffd9e5021c1fb2d6;
});
parcelHelpers.export(exports, "useFocusVisibleListener", function() {
    return $507fabe10e71c6fb$export$ec71b4b83ac08ec3;
});
parcelHelpers.export(exports, "useFocusWithin", function() {
    return $9ab94262bd0047c7$export$420e68273165f4ec;
});
parcelHelpers.export(exports, "useHover", function() {
    return $6179b936705e76d3$export$ae780daf29e6d456;
});
parcelHelpers.export(exports, "useInteractOutside", function() {
    return $e0b6e0b68ec7f50f$export$872b660ac5a1ff98;
});
parcelHelpers.export(exports, "useKeyboard", function() {
    return $46d819fcbaf35654$export$8f71654801c2f7cd;
});
parcelHelpers.export(exports, "useMove", function() {
    return $e8a7022cf87cba2a$export$36da96379f79f245;
});
parcelHelpers.export(exports, "usePress", function() {
    return $f6c31cce2adf654f$export$45712eceda6fad21;
});
parcelHelpers.export(exports, "useScrollWheel", function() {
    return $7d0a636d7a4dcefd$export$2123ff2b87c81ca;
});
parcelHelpers.export(exports, "useLongPress", function() {
    return $8a26561d2877236e$export$c24ed0104d07eab9;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classPrivateFieldGet = require("@swc/helpers/_/_class_private_field_get");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
var _classPrivateFieldSet = require("@swc/helpers/_/_class_private_field_set");
var _ssr = require("@react-aria/ssr");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Note that state only matters here for iOS. Non-iOS gets user-select: none applied to the target element
// rather than at the document level so we just need to apply/remove user-select: none for each pressed element individually
var $14c0b72509d70225$var$state = "default";
var $14c0b72509d70225$var$savedUserSelect = "";
var $14c0b72509d70225$var$modifiedElementMap = new WeakMap();
function $14c0b72509d70225$export$16a4697467175487(target) {
    if ((0, _utils.isIOS)()) {
        if ($14c0b72509d70225$var$state === "default") {
            // eslint-disable-next-line no-restricted-globals
            var documentObject = (0, _utils.getOwnerDocument)(target);
            $14c0b72509d70225$var$savedUserSelect = documentObject.documentElement.style.webkitUserSelect;
            documentObject.documentElement.style.webkitUserSelect = "none";
        }
        $14c0b72509d70225$var$state = "disabled";
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        // If not iOS, store the target's original user-select and change to user-select: none
        // Ignore state since it doesn't apply for non iOS
        $14c0b72509d70225$var$modifiedElementMap.set(target, target.style.userSelect);
        target.style.userSelect = "none";
    }
}
function $14c0b72509d70225$export$b0d6fa1ab32e3295(target) {
    if ((0, _utils.isIOS)()) {
        // If the state is already default, there's nothing to do.
        // If it is restoring, then there's no need to queue a second restore.
        if ($14c0b72509d70225$var$state !== "disabled") return;
        $14c0b72509d70225$var$state = "restoring";
        // There appears to be a delay on iOS where selection still might occur
        // after pointer up, so wait a bit before removing user-select.
        setTimeout(function() {
            (0, _utils.runAfterTransition)(function() {
                // Avoid race conditions
                if ($14c0b72509d70225$var$state === "restoring") {
                    // eslint-disable-next-line no-restricted-globals
                    var documentObject = (0, _utils.getOwnerDocument)(target);
                    if (documentObject.documentElement.style.webkitUserSelect === "none") documentObject.documentElement.style.webkitUserSelect = $14c0b72509d70225$var$savedUserSelect || "";
                    $14c0b72509d70225$var$savedUserSelect = "";
                    $14c0b72509d70225$var$state = "default";
                }
            });
        }, 300);
    } else if (target instanceof HTMLElement || target instanceof SVGElement) {
        if (target && $14c0b72509d70225$var$modifiedElementMap.has(target)) {
            var targetOldUserSelect = $14c0b72509d70225$var$modifiedElementMap.get(target);
            if (target.style.userSelect === "none") target.style.userSelect = targetOldUserSelect;
            if (target.getAttribute("style") === "") target.removeAttribute("style");
            $14c0b72509d70225$var$modifiedElementMap.delete(target);
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ae1eeba8b9eafd08$export$5165eccb35aaadb5 = (0, _reactDefault.default).createContext({
    register: function() {}
});
$ae1eeba8b9eafd08$export$5165eccb35aaadb5.displayName = "PressResponderContext";
function $f6c31cce2adf654f$var$usePressResponderContext(props) {
    // Consume context from <PressResponder> and merge with props.
    var context = (0, _react.useContext)($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    if (context) {
        var register = context.register, contextProps = (0, _objectWithoutProperties._)(context, [
            "register"
        ]);
        props = (0, _utils.mergeProps)(contextProps, props);
        register();
    }
    (0, _utils.useSyncRef)(context, props.ref);
    return props;
}
var $f6c31cce2adf654f$var$_shouldStopPropagation = /*#__PURE__*/ new WeakMap();
var $f6c31cce2adf654f$var$PressEvent = /*#__PURE__*/ function() {
    "use strict";
    function $f6c31cce2adf654f$var$PressEvent(type, pointerType, originalEvent) {
        (0, _classCallCheck._)(this, $f6c31cce2adf654f$var$PressEvent);
        (0, _classPrivateFieldInit._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, {
            writable: true,
            value: void 0
        });
        (0, _classPrivateFieldSet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, true);
        this.type = type;
        this.pointerType = pointerType;
        this.target = originalEvent.currentTarget;
        this.shiftKey = originalEvent.shiftKey;
        this.metaKey = originalEvent.metaKey;
        this.ctrlKey = originalEvent.ctrlKey;
        this.altKey = originalEvent.altKey;
    }
    (0, _createClass._)($f6c31cce2adf654f$var$PressEvent, [
        {
            key: "continuePropagation",
            value: function continuePropagation() {
                (0, _classPrivateFieldSet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation, false);
            }
        },
        {
            key: "shouldStopPropagation",
            get: function get() {
                return (0, _classPrivateFieldGet._)(this, $f6c31cce2adf654f$var$_shouldStopPropagation);
            }
        }
    ]);
    return $f6c31cce2adf654f$var$PressEvent;
}();
var $f6c31cce2adf654f$var$LINK_CLICKED = Symbol("linkClicked");
function $f6c31cce2adf654f$export$45712eceda6fad21(props) {
    var _$f6c31cce2adf654f$var$usePressResponderContext = $f6c31cce2adf654f$var$usePressResponderContext(props), onPress = _$f6c31cce2adf654f$var$usePressResponderContext.onPress, onPressChange = _$f6c31cce2adf654f$var$usePressResponderContext.onPressChange, onPressStart = _$f6c31cce2adf654f$var$usePressResponderContext.onPressStart, onPressEnd = _$f6c31cce2adf654f$var$usePressResponderContext.onPressEnd, onPressUp = _$f6c31cce2adf654f$var$usePressResponderContext.onPressUp, isDisabled = _$f6c31cce2adf654f$var$usePressResponderContext.isDisabled, isPressedProp = _$f6c31cce2adf654f$var$usePressResponderContext.isPressed, preventFocusOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.preventFocusOnPress, shouldCancelOnPointerExit = _$f6c31cce2adf654f$var$usePressResponderContext.shouldCancelOnPointerExit, allowTextSelectionOnPress = _$f6c31cce2adf654f$var$usePressResponderContext.allowTextSelectionOnPress, _ = _$f6c31cce2adf654f$var$usePressResponderContext.ref, domProps = (0, _objectWithoutProperties._)(_$f6c31cce2adf654f$var$usePressResponderContext, [
        "onPress",
        "onPressChange",
        "onPressStart",
        "onPressEnd",
        "onPressUp",
        "isDisabled",
        "isPressed",
        "preventFocusOnPress",
        "shouldCancelOnPointerExit",
        "allowTextSelectionOnPress",
        "ref"
    ]);
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPressed = _$bx7SL$useState[0], setPressed = _$bx7SL$useState[1];
    var ref = (0, _react.useRef)({
        isPressed: false,
        ignoreEmulatedMouseEvents: false,
        ignoreClickAfterPress: false,
        didFirePressStart: false,
        isTriggeringEvent: false,
        activePointerId: null,
        target: null,
        isOverTarget: false,
        pointerType: null
    });
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeAllGlobalListeners = _$bx7SL$useGlobalListeners.removeAllGlobalListeners;
    var triggerPressStart = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled || state.didFirePressStart) return false;
        var shouldStopPropagation = true;
        state.isTriggeringEvent = true;
        if (onPressStart) {
            var event = new $f6c31cce2adf654f$var$PressEvent("pressstart", pointerType, originalEvent);
            onPressStart(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(true);
        state.isTriggeringEvent = false;
        state.didFirePressStart = true;
        setPressed(true);
        return shouldStopPropagation;
    });
    var triggerPressEnd = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var wasPressed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var state = ref.current;
        if (!state.didFirePressStart) return false;
        state.ignoreClickAfterPress = true;
        state.didFirePressStart = false;
        state.isTriggeringEvent = true;
        var shouldStopPropagation = true;
        if (onPressEnd) {
            var event = new $f6c31cce2adf654f$var$PressEvent("pressend", pointerType, originalEvent);
            onPressEnd(event);
            shouldStopPropagation = event.shouldStopPropagation;
        }
        if (onPressChange) onPressChange(false);
        setPressed(false);
        if (onPress && wasPressed && !isDisabled) {
            var event1 = new $f6c31cce2adf654f$var$PressEvent("press", pointerType, originalEvent);
            onPress(event1);
            shouldStopPropagation && (shouldStopPropagation = event1.shouldStopPropagation);
        }
        state.isTriggeringEvent = false;
        return shouldStopPropagation;
    });
    var triggerPressUp = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        var state = ref.current;
        if (isDisabled) return false;
        if (onPressUp) {
            state.isTriggeringEvent = true;
            var event = new $f6c31cce2adf654f$var$PressEvent("pressup", pointerType, originalEvent);
            onPressUp(event);
            state.isTriggeringEvent = false;
            return event.shouldStopPropagation;
        }
        return true;
    });
    var cancel = (0, _utils.useEffectEvent)(function(e) {
        var state = ref.current;
        if (state.isPressed && state.target) {
            if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
            state.isPressed = false;
            state.isOverTarget = false;
            state.activePointerId = null;
            state.pointerType = null;
            removeAllGlobalListeners();
            if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
        }
    });
    var cancelOnPointerExit = (0, _utils.useEffectEvent)(function(e) {
        if (shouldCancelOnPointerExit) cancel(e);
    });
    var pressProps = (0, _react.useMemo)(function() {
        var state = ref.current;
        var pressProps = {
            onKeyDown: function(e) {
                if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e.nativeEvent, e.currentTarget) && e.currentTarget.contains(e.target)) {
                    var _state_metaKeyEvents;
                    if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                    // If the event is repeating, it may have started on a different element
                    // after which focus moved to the current element. Ignore these events and
                    // only handle the first key down event.
                    var shouldStopPropagation = true;
                    if (!state.isPressed && !e.repeat) {
                        state.target = e.currentTarget;
                        state.isPressed = true;
                        shouldStopPropagation = triggerPressStart(e, "keyboard");
                        // Focus may move before the key up event, so register the event on the document
                        // instead of the same element where the key down event occurred. Make it capturing so that it will trigger
                        // before stopPropagation from useKeyboard on a child element may happen and thus we can still call triggerPress for the parent element.
                        var originalTarget = e.currentTarget;
                        var pressUp = function(e) {
                            if ($f6c31cce2adf654f$var$isValidKeyboardEvent(e, originalTarget) && !e.repeat && originalTarget.contains(e.target) && state.target) triggerPressUp($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard");
                        };
                        addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "keyup", (0, _utils.chain)(pressUp, onKeyUp), true);
                    }
                    if (shouldStopPropagation) e.stopPropagation();
                    // Keep track of the keydown events that occur while the Meta (e.g. Command) key is held.
                    // macOS has a bug where keyup events are not fired while the Meta key is down.
                    // When the Meta key itself is released we will get an event for that, and we'll act as if
                    // all of these other keys were released as well.
                    // https://bugs.chromium.org/p/chromium/issues/detail?id=1393524
                    // https://bugs.webkit.org/show_bug.cgi?id=55291
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1299553
                    if (e.metaKey && (0, _utils.isMac)()) (_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 || _state_metaKeyEvents.set(e.key, e.nativeEvent);
                } else if (e.key === "Meta") state.metaKeyEvents = new Map();
            },
            onClick: function(e) {
                if (e && !e.currentTarget.contains(e.target)) return;
                if (e && e.button === 0 && !state.isTriggeringEvent && !(0, _utils.openLink).isOpening) {
                    var shouldStopPropagation = true;
                    if (isDisabled) e.preventDefault();
                    // If triggered from a screen reader or by using element.click(),
                    // trigger as if it were a keyboard click.
                    if (!state.ignoreClickAfterPress && !state.ignoreEmulatedMouseEvents && !state.isPressed && (state.pointerType === "virtual" || (0, _utils.isVirtualClick)(e.nativeEvent))) {
                        // Ensure the element receives focus (VoiceOver on iOS does not do this)
                        if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                        var stopPressStart = triggerPressStart(e, "virtual");
                        var stopPressUp = triggerPressUp(e, "virtual");
                        var stopPressEnd = triggerPressEnd(e, "virtual");
                        shouldStopPropagation = stopPressStart && stopPressUp && stopPressEnd;
                    }
                    state.ignoreEmulatedMouseEvents = false;
                    state.ignoreClickAfterPress = false;
                    if (shouldStopPropagation) e.stopPropagation();
                }
            }
        };
        var onKeyUp = function(e) {
            var _state_metaKeyEvents;
            if (state.isPressed && state.target && $f6c31cce2adf654f$var$isValidKeyboardEvent(e, state.target)) {
                var _state_metaKeyEvents1;
                if ($f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(e.target, e.key)) e.preventDefault();
                var target = e.target;
                triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), "keyboard", state.target.contains(target));
                removeAllGlobalListeners();
                // If a link was triggered with a key other than Enter, open the URL ourselves.
                // This means the link has a role override, and the default browser behavior
                // only applies when using the Enter key.
                if (e.key !== "Enter" && $f6c31cce2adf654f$var$isHTMLAnchorLink(state.target) && state.target.contains(target) && !e[$f6c31cce2adf654f$var$LINK_CLICKED]) {
                    // Store a hidden property on the event so we only trigger link click once,
                    // even if there are multiple usePress instances attached to the element.
                    e[$f6c31cce2adf654f$var$LINK_CLICKED] = true;
                    (0, _utils.openLink)(state.target, e, false);
                }
                state.isPressed = false;
                (_state_metaKeyEvents1 = state.metaKeyEvents) === null || _state_metaKeyEvents1 === void 0 || _state_metaKeyEvents1.delete(e.key);
            } else if (e.key === "Meta" && ((_state_metaKeyEvents = state.metaKeyEvents) === null || _state_metaKeyEvents === void 0 ? void 0 : _state_metaKeyEvents.size)) {
                var _state_target;
                // If we recorded keydown events that occurred while the Meta key was pressed,
                // and those haven't received keyup events already, fire keyup events ourselves.
                // See comment above for more info about the macOS bug causing this.
                var events = state.metaKeyEvents;
                state.metaKeyEvents = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = events.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var event = _step.value;
                        (_state_target = state.target) === null || _state_target === void 0 || _state_target.dispatchEvent(new KeyboardEvent("keyup", event));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        if (typeof PointerEvent !== "undefined") {
            pressProps.onPointerDown = function(e) {
                // Only handle left clicks, and ignore events that bubbled through portals.
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // iOS safari fires pointer events from VoiceOver with incorrect coordinates/target.
                // Ignore and let the onClick handler take care of it instead.
                // https://bugs.webkit.org/show_bug.cgi?id=222627
                // https://bugs.webkit.org/show_bug.cgi?id=223202
                if ((0, _utils.isVirtualPointerEvent)(e.nativeEvent)) {
                    state.pointerType = "virtual";
                    return;
                }
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on pointer down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                state.pointerType = e.pointerType;
                var shouldStopPropagation = true;
                if (!state.isPressed) {
                    state.isPressed = true;
                    state.isOverTarget = true;
                    state.activePointerId = e.pointerId;
                    state.target = e.currentTarget;
                    if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointermove", onPointerMove, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointerup", onPointerUp, false);
                    addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "pointercancel", onPointerCancel, false);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseDown = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (e.button === 0) {
                    // Chrome and Firefox on touch Windows devices require mouse down events
                    // to be canceled in addition to pointer events, or an extra asynchronous
                    // focus event will be fired.
                    if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                    e.stopPropagation();
                }
            };
            pressProps.onPointerUp = function(e) {
                // iOS fires pointerup with zero width and height, so check the pointerType recorded during pointerdown.
                if (!e.currentTarget.contains(e.target) || state.pointerType === "virtual") return;
                // Only handle left clicks
                // Safari on iOS sometimes fires pointerup events, even
                // when the touch isn't over the target, so double check.
                if (e.button === 0 && $f6c31cce2adf654f$var$isOverTarget(e, e.currentTarget)) triggerPressUp(e, state.pointerType || e.pointerType);
            };
            // Safari on iOS < 13.2 does not implement pointerenter/pointerleave events correctly.
            // Use pointer move events instead to implement our own hit testing.
            // See https://bugs.webkit.org/show_bug.cgi?id=199803
            var onPointerMove = function(e) {
                if (e.pointerId !== state.activePointerId) return;
                if (state.target && $f6c31cce2adf654f$var$isOverTarget(e, state.target)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        triggerPressStart($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    }
                } else if (state.target && state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    cancelOnPointerExit(e);
                }
            };
            var onPointerUp = function(e) {
                if (e.pointerId === state.activePointerId && state.isPressed && e.button === 0 && state.target) {
                    if ($f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                    else if (state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                    state.isPressed = false;
                    state.isOverTarget = false;
                    state.activePointerId = null;
                    state.pointerType = null;
                    removeAllGlobalListeners();
                    if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                }
            };
            var onPointerCancel = function(e) {
                cancel(e);
            };
            pressProps.onDragStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                // Safari does not call onPointerCancel when a drag starts, whereas Chrome and Firefox do.
                cancel(e);
            };
        } else {
            pressProps.onMouseDown = function(e) {
                // Only handle left clicks
                if (e.button !== 0 || !e.currentTarget.contains(e.target)) return;
                // Due to browser inconsistencies, especially on mobile browsers, we prevent
                // default on mouse down and handle focusing the pressable element ourselves.
                if ($f6c31cce2adf654f$var$shouldPreventDefault(e.currentTarget)) e.preventDefault();
                if (state.ignoreEmulatedMouseEvents) {
                    e.stopPropagation();
                    return;
                }
                state.isPressed = true;
                state.isOverTarget = true;
                state.target = e.currentTarget;
                state.pointerType = (0, _utils.isVirtualClick)(e.nativeEvent) ? "virtual" : "mouse";
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                var shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerDocument)(e.currentTarget), "mouseup", onMouseUp, false);
            };
            pressProps.onMouseEnter = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = true;
                    shouldStopPropagation = triggerPressStart(e, state.pointerType);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseLeave = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var shouldStopPropagation = true;
                if (state.isPressed && !state.ignoreEmulatedMouseEvents && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onMouseUp = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.ignoreEmulatedMouseEvents && e.button === 0) triggerPressUp(e, state.pointerType || "mouse");
            };
            var onMouseUp = function(e) {
                // Only handle left clicks
                if (e.button !== 0) return;
                state.isPressed = false;
                removeAllGlobalListeners();
                if (state.ignoreEmulatedMouseEvents) {
                    state.ignoreEmulatedMouseEvents = false;
                    return;
                }
                if (state.target && $f6c31cce2adf654f$var$isOverTarget(e, state.target) && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType);
                else if (state.target && state.isOverTarget && state.pointerType != null) triggerPressEnd($f6c31cce2adf654f$var$createEvent(state.target, e), state.pointerType, false);
                state.isOverTarget = false;
            };
            pressProps.onTouchStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                var touch = $f6c31cce2adf654f$var$getTouchFromEvent(e.nativeEvent);
                if (!touch) return;
                state.activePointerId = touch.identifier;
                state.ignoreEmulatedMouseEvents = true;
                state.isOverTarget = true;
                state.isPressed = true;
                state.target = e.currentTarget;
                state.pointerType = "touch";
                // Due to browser inconsistencies, especially on mobile browsers, we prevent default
                // on the emulated mouse event and handle focusing the pressable element ourselves.
                if (!isDisabled && !preventFocusOnPress) (0, _utils.focusWithoutScrolling)(e.currentTarget);
                if (!allowTextSelectionOnPress) $14c0b72509d70225$export$16a4697467175487(state.target);
                var shouldStopPropagation = triggerPressStart(e, state.pointerType);
                if (shouldStopPropagation) e.stopPropagation();
                addGlobalListener((0, _utils.getOwnerWindow)(e.currentTarget), "scroll", onScroll, true);
            };
            pressProps.onTouchMove = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                var shouldStopPropagation = true;
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget)) {
                    if (!state.isOverTarget && state.pointerType != null) {
                        state.isOverTarget = true;
                        shouldStopPropagation = triggerPressStart(e, state.pointerType);
                    }
                } else if (state.isOverTarget && state.pointerType != null) {
                    state.isOverTarget = false;
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                    cancelOnPointerExit(e);
                }
                if (shouldStopPropagation) e.stopPropagation();
            };
            pressProps.onTouchEnd = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                if (!state.isPressed) {
                    e.stopPropagation();
                    return;
                }
                var touch = $f6c31cce2adf654f$var$getTouchById(e.nativeEvent, state.activePointerId);
                var shouldStopPropagation = true;
                if (touch && $f6c31cce2adf654f$var$isOverTarget(touch, e.currentTarget) && state.pointerType != null) {
                    triggerPressUp(e, state.pointerType);
                    shouldStopPropagation = triggerPressEnd(e, state.pointerType);
                } else if (state.isOverTarget && state.pointerType != null) shouldStopPropagation = triggerPressEnd(e, state.pointerType, false);
                if (shouldStopPropagation) e.stopPropagation();
                state.isPressed = false;
                state.activePointerId = null;
                state.isOverTarget = false;
                state.ignoreEmulatedMouseEvents = true;
                if (state.target && !allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295(state.target);
                removeAllGlobalListeners();
            };
            pressProps.onTouchCancel = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                e.stopPropagation();
                if (state.isPressed) cancel(e);
            };
            var onScroll = function(e) {
                if (state.isPressed && e.target.contains(state.target)) cancel({
                    currentTarget: state.target,
                    shiftKey: false,
                    ctrlKey: false,
                    metaKey: false,
                    altKey: false
                });
            };
            pressProps.onDragStart = function(e) {
                if (!e.currentTarget.contains(e.target)) return;
                cancel(e);
            };
        }
        return pressProps;
    }, [
        addGlobalListener,
        isDisabled,
        preventFocusOnPress,
        removeAllGlobalListeners,
        allowTextSelectionOnPress,
        cancel,
        cancelOnPointerExit,
        triggerPressEnd,
        triggerPressStart,
        triggerPressUp
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            var _ref_current_target;
            if (!allowTextSelectionOnPress) $14c0b72509d70225$export$b0d6fa1ab32e3295((_ref_current_target = ref.current.target) !== null && _ref_current_target !== void 0 ? _ref_current_target : undefined);
        };
    }, [
        allowTextSelectionOnPress
    ]);
    return {
        isPressed: isPressedProp || isPressed,
        pressProps: (0, _utils.mergeProps)(domProps, pressProps)
    };
}
function $f6c31cce2adf654f$var$isHTMLAnchorLink(target) {
    return target.tagName === "A" && target.hasAttribute("href");
}
function $f6c31cce2adf654f$var$isValidKeyboardEvent(event, currentTarget) {
    var key = event.key, code = event.code;
    var element = currentTarget;
    var role = element.getAttribute("role");
    // Accessibility for keyboards. Space and Enter only.
    // "Spacebar" is for IE 11
    return (key === "Enter" || key === " " || key === "Spacebar" || code === "Space") && !(element instanceof (0, _utils.getOwnerWindow)(element).HTMLInputElement && !$f6c31cce2adf654f$var$isValidInputKey(element, key) || element instanceof (0, _utils.getOwnerWindow)(element).HTMLTextAreaElement || element.isContentEditable) && // Links should only trigger with Enter key
    !((role === "link" || !role && $f6c31cce2adf654f$var$isHTMLAnchorLink(element)) && key !== "Enter");
}
function $f6c31cce2adf654f$var$getTouchFromEvent(event) {
    var targetTouches = event.targetTouches;
    if (targetTouches.length > 0) return targetTouches[0];
    return null;
}
function $f6c31cce2adf654f$var$getTouchById(event, pointerId) {
    var changedTouches = event.changedTouches;
    for(var i = 0; i < changedTouches.length; i++){
        var touch = changedTouches[i];
        if (touch.identifier === pointerId) return touch;
    }
    return null;
}
function $f6c31cce2adf654f$var$createEvent(target, e) {
    return {
        currentTarget: target,
        shiftKey: e.shiftKey,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        altKey: e.altKey
    };
}
function $f6c31cce2adf654f$var$getPointClientRect(point) {
    var offsetX = 0;
    var offsetY = 0;
    if (point.width !== undefined) offsetX = point.width / 2;
    else if (point.radiusX !== undefined) offsetX = point.radiusX;
    if (point.height !== undefined) offsetY = point.height / 2;
    else if (point.radiusY !== undefined) offsetY = point.radiusY;
    return {
        top: point.clientY - offsetY,
        right: point.clientX + offsetX,
        bottom: point.clientY + offsetY,
        left: point.clientX - offsetX
    };
}
function $f6c31cce2adf654f$var$areRectanglesOverlapping(a, b) {
    // check if they cannot overlap on x axis
    if (a.left > b.right || b.left > a.right) return false;
    // check if they cannot overlap on y axis
    if (a.top > b.bottom || b.top > a.bottom) return false;
    return true;
}
function $f6c31cce2adf654f$var$isOverTarget(point, target) {
    var rect = target.getBoundingClientRect();
    var pointRect = $f6c31cce2adf654f$var$getPointClientRect(point);
    return $f6c31cce2adf654f$var$areRectanglesOverlapping(rect, pointRect);
}
function $f6c31cce2adf654f$var$shouldPreventDefault(target) {
    // We cannot prevent default if the target is a draggable element.
    return !(target instanceof HTMLElement) || !target.hasAttribute("draggable");
}
function $f6c31cce2adf654f$var$shouldPreventDefaultKeyboard(target, key) {
    if (target instanceof HTMLInputElement) return !$f6c31cce2adf654f$var$isValidInputKey(target, key);
    if (target instanceof HTMLButtonElement) return target.type !== "submit" && target.type !== "reset";
    if ($f6c31cce2adf654f$var$isHTMLAnchorLink(target)) return false;
    return true;
}
var $f6c31cce2adf654f$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
function $f6c31cce2adf654f$var$isValidInputKey(target, key) {
    // Only space should toggle checkboxes and radios, not enter.
    return target.type === "checkbox" || target.type === "radio" ? key === " " : $f6c31cce2adf654f$var$nonTextInputTypes.has(target.type);
}
var $3b117e43dc0ca95d$export$27c701ed9e449e99 = (0, _reactDefault.default).forwardRef(function(_param, ref) {
    var children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    ref = (0, _utils.useObjectRef)(ref);
    var _$f6c31cce2adf654f$export$45712eceda6fad21 = $f6c31cce2adf654f$export$45712eceda6fad21((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref
    })), pressProps = _$f6c31cce2adf654f$export$45712eceda6fad21.pressProps;
    var child = (0, _reactDefault.default).Children.only(children);
    return (0, _reactDefault.default).cloneElement(child, (0, _objectSpread._)({
        ref: ref
    }, (0, _utils.mergeProps)(child.props, pressProps)));
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f1ab8c75478c6f73$export$3351871ee4b288b8 = (0, _reactDefault.default).forwardRef(function(_param, ref) {
    var children = _param.children, props = (0, _objectWithoutProperties._)(_param, [
        "children"
    ]);
    var isRegistered = (0, _react.useRef)(false);
    var prevContext = (0, _react.useContext)($ae1eeba8b9eafd08$export$5165eccb35aaadb5);
    ref = (0, _utils.useObjectRef)(ref || (prevContext === null || prevContext === void 0 ? void 0 : prevContext.ref));
    var context = (0, _utils.mergeProps)(prevContext || {}, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        ref: ref,
        register: function() {
            isRegistered.current = true;
            if (prevContext) prevContext.register();
        }
    }));
    (0, _utils.useSyncRef)(prevContext, ref);
    (0, _react.useEffect)(function() {
        if (!isRegistered.current) {
            console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component.");
            isRegistered.current = true; // only warn once in strict mode.
        }
    }, []);
    return (0, _reactDefault.default).createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
});
function $f1ab8c75478c6f73$export$cf75428e0b9ed1ea(param) {
    var children = param.children;
    var context = (0, _react.useMemo)(function() {
        return {
            register: function() {}
        };
    }, []);
    return (0, _reactDefault.default).createElement($ae1eeba8b9eafd08$export$5165eccb35aaadb5.Provider, {
        value: context
    }, children);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8a9cb279dc87e130$export$905e7fc544a71f36 = /*#__PURE__*/ function() {
    "use strict";
    function $8a9cb279dc87e130$export$905e7fc544a71f36(type, nativeEvent) {
        (0, _classCallCheck._)(this, $8a9cb279dc87e130$export$905e7fc544a71f36);
        this.nativeEvent = nativeEvent;
        this.target = nativeEvent.target;
        this.currentTarget = nativeEvent.currentTarget;
        this.relatedTarget = nativeEvent.relatedTarget;
        this.bubbles = nativeEvent.bubbles;
        this.cancelable = nativeEvent.cancelable;
        this.defaultPrevented = nativeEvent.defaultPrevented;
        this.eventPhase = nativeEvent.eventPhase;
        this.isTrusted = nativeEvent.isTrusted;
        this.timeStamp = nativeEvent.timeStamp;
        this.type = type;
    }
    (0, _createClass._)($8a9cb279dc87e130$export$905e7fc544a71f36, [
        {
            key: "isDefaultPrevented",
            value: function isDefaultPrevented() {
                return this.nativeEvent.defaultPrevented;
            }
        },
        {
            key: "preventDefault",
            value: function preventDefault() {
                this.defaultPrevented = true;
                this.nativeEvent.preventDefault();
            }
        },
        {
            key: "stopPropagation",
            value: function stopPropagation() {
                this.nativeEvent.stopPropagation();
                this.isPropagationStopped = function() {
                    return true;
                };
            }
        },
        {
            key: "isPropagationStopped",
            value: function isPropagationStopped() {
                return false;
            }
        },
        {
            key: "persist",
            value: function persist() {}
        }
    ]);
    return $8a9cb279dc87e130$export$905e7fc544a71f36;
}();
function $8a9cb279dc87e130$export$715c682d09d639cc(onBlur) {
    var stateRef = (0, _react.useRef)({
        isFocused: false,
        observer: null
    });
    (0, _utils.useLayoutEffect)(function() {
        var state = stateRef.current;
        return function() {
            if (state.observer) {
                state.observer.disconnect();
                state.observer = null;
            }
        };
    }, []);
    var dispatchBlur = (0, _utils.useEffectEvent)(function(e) {
        onBlur === null || onBlur === void 0 || onBlur(e);
    });
    // This function is called during a React onFocus event.
    return (0, _react.useCallback)(function(e) {
        // React does not fire onBlur when an element is disabled. https://github.com/facebook/react/issues/9142
        // Most browsers fire a native focusout event in this case, except for Firefox. In that case, we use a
        // MutationObserver to watch for the disabled attribute, and dispatch these events ourselves.
        // For browsers that do, focusout fires before the MutationObserver, so onBlur should not fire twice.
        if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
            stateRef.current.isFocused = true;
            var target = e.target;
            var onBlurHandler = function(e) {
                stateRef.current.isFocused = false;
                if (target.disabled) dispatchBlur(new $8a9cb279dc87e130$export$905e7fc544a71f36("blur", e));
                // We no longer need the MutationObserver once the target is blurred.
                if (stateRef.current.observer) {
                    stateRef.current.observer.disconnect();
                    stateRef.current.observer = null;
                }
            };
            target.addEventListener("focusout", onBlurHandler, {
                once: true
            });
            stateRef.current.observer = new MutationObserver(function() {
                if (stateRef.current.isFocused && target.disabled) {
                    var _stateRef_current_observer;
                    (_stateRef_current_observer = stateRef.current.observer) === null || _stateRef_current_observer === void 0 || _stateRef_current_observer.disconnect();
                    var relatedTargetEl = target === document.activeElement ? null : document.activeElement;
                    target.dispatchEvent(new FocusEvent("blur", {
                        relatedTarget: relatedTargetEl
                    }));
                    target.dispatchEvent(new FocusEvent("focusout", {
                        bubbles: true,
                        relatedTarget: relatedTargetEl
                    }));
                }
            });
            stateRef.current.observer.observe(target, {
                attributes: true,
                attributeFilter: [
                    "disabled"
                ]
            });
        }
    }, [
        dispatchBlur
    ]);
}
function $a1ea59d68270f0dd$export$f8168d8dd8fd66e6(props) {
    var isDisabled = props.isDisabled, onFocusProp = props.onFocus, onBlurProp = props.onBlur, onFocusChange = props.onFocusChange;
    var onBlur = (0, _react.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (onBlurProp) onBlurProp(e);
            if (onFocusChange) onFocusChange(false);
            return true;
        }
    }, [
        onBlurProp,
        onFocusChange
    ]);
    var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    var onFocus = (0, _react.useCallback)(function(e) {
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (e.target === e.currentTarget && document.activeElement === e.target) {
            if (onFocusProp) onFocusProp(e);
            if (onFocusChange) onFocusChange(true);
            onSyntheticFocus(e);
        }
    }, [
        onFocusChange,
        onFocusProp,
        onSyntheticFocus
    ]);
    return {
        focusProps: {
            onFocus: !isDisabled && (onFocusProp || onFocusChange || onBlurProp) ? onFocus : undefined,
            onBlur: !isDisabled && (onBlurProp || onFocusChange) ? onBlur : undefined
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
var $507fabe10e71c6fb$var$currentModality = null;
var $507fabe10e71c6fb$var$changeHandlers = new Set();
var $507fabe10e71c6fb$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
var $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
var $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
var $507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $507fabe10e71c6fb$var$changeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            handler(modality, e);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, _utils.isMac)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($507fabe10e71c6fb$var$isValidKey(e)) {
        $507fabe10e71c6fb$var$currentModality = "keyboard";
        $507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $507fabe10e71c6fb$var$handlePointerEvent(e) {
    $507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, _utils.isVirtualClick)(e)) {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$507fabe10e71c6fb$var$hasEventBeforeFocus && !$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $507fabe10e71c6fb$var$currentModality = "virtual";
        $507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $507fabe10e71c6fb$export$d90243b58daecda7.get((0, _utils.getOwnerWindow)(element))) return;
    var windowObject = (0, _utils.getOwnerWindow)(element);
    var documentObject = (0, _utils.getOwnerDocument)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    var focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", function() {
        $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $507fabe10e71c6fb$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
var $507fabe10e71c6fb$var$tearDownWindowFocusTracking = function(element, loadListener) {
    var windowObject = (0, _utils.getOwnerWindow)(element);
    var documentObject = (0, _utils.getOwnerDocument)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$507fabe10e71c6fb$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $507fabe10e71c6fb$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $507fabe10e71c6fb$export$d90243b58daecda7.delete(windowObject);
};
function $507fabe10e71c6fb$export$2f1888112f558a7d(element) {
    var documentObject = (0, _utils.getOwnerDocument)(element);
    var loadListener;
    if (documentObject.readyState !== "loading") $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = function() {
            $507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return function() {
        return $507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
    };
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $507fabe10e71c6fb$export$2f1888112f558a7d();
function $507fabe10e71c6fb$export$b9b3dfddab17db27() {
    return $507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $507fabe10e71c6fb$export$630ff653c5ada6a9() {
    return $507fabe10e71c6fb$var$currentModality;
}
function $507fabe10e71c6fb$export$8397ddfc504fdb9a(modality) {
    $507fabe10e71c6fb$var$currentModality = modality;
    $507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $507fabe10e71c6fb$export$98e20ec92f614cfe() {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)($507fabe10e71c6fb$var$currentModality), 2), modality = _$bx7SL$useState[0], setModality = _$bx7SL$useState[1];
    (0, _react.useEffect)(function() {
        var handler = function() {
            setModality($507fabe10e71c6fb$var$currentModality);
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, _ssr.useIsSSR)() ? null : modality;
}
var $507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    var IHTMLInputElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    var IHTMLTextAreaElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    var IHTMLElement = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    var IKeyboardEvent = typeof window !== "undefined" ? (0, _utils.getOwnerWindow)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $507fabe10e71c6fb$export$ffd9e5021c1fb2d6() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isTextInput = props.isTextInput, autoFocus = props.autoFocus;
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(autoFocus || $507fabe10e71c6fb$export$b9b3dfddab17db27()), 2), isFocusVisibleState = _$bx7SL$useState[0], setFocusVisible = _$bx7SL$useState[1];
    $507fabe10e71c6fb$export$ec71b4b83ac08ec3(function(isFocusVisible) {
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $507fabe10e71c6fb$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, _react.useEffect)(function() {
        var handler = function(modality, e) {
            if (!$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($507fabe10e71c6fb$export$b9b3dfddab17db27());
        };
        $507fabe10e71c6fb$var$changeHandlers.add(handler);
        return function() {
            $507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $9ab94262bd0047c7$export$420e68273165f4ec(props) {
    var isDisabled = props.isDisabled, onBlurWithin = props.onBlurWithin, onFocusWithin = props.onFocusWithin, onFocusWithinChange = props.onFocusWithinChange;
    var state = (0, _react.useRef)({
        isFocusWithin: false
    });
    var onBlur = (0, _react.useCallback)(function(e) {
        // We don't want to trigger onBlurWithin and then immediately onFocusWithin again
        // when moving focus inside the element. Only trigger if the currentTarget doesn't
        // include the relatedTarget (where focus is moving).
        if (state.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget)) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange,
        state
    ]);
    var onSyntheticFocus = $8a9cb279dc87e130$export$715c682d09d639cc(onBlur);
    var onFocus = (0, _react.useCallback)(function(e) {
        // Double check that document.activeElement actually matches e.target in case a previously chained
        // focus handler already moved focus somewhere else.
        if (!state.current.isFocusWithin && document.activeElement === e.target) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
            onSyntheticFocus(e);
        }
    }, [
        onFocusWithin,
        onFocusWithinChange,
        onSyntheticFocus
    ]);
    if (isDisabled) return {
        focusWithinProps: {
            // These should not have been null, that would conflict in mergeProps
            onFocus: undefined,
            onBlur: undefined
        }
    };
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
// iOS fires onPointerEnter twice: once with pointerType="touch" and again with pointerType="mouse".
// We want to ignore these emulated events so they do not trigger hover behavior.
// See https://bugs.webkit.org/show_bug.cgi?id=214609.
var $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
var $6179b936705e76d3$var$hoverCount = 0;
function $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents() {
    $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = true;
    // Clear globalIgnoreEmulatedMouseEvents after a short timeout. iOS fires onPointerEnter
    // with pointerType="mouse" immediately after onPointerUp and before onFocus. On other
    // devices that don't have this quirk, we don't want to ignore a mouse hover sometime in
    // the distant future because a user previously touched the element.
    setTimeout(function() {
        $6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents = false;
    }, 50);
}
function $6179b936705e76d3$var$handleGlobalPointerEvent(e) {
    if (e.pointerType === "touch") $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents();
}
function $6179b936705e76d3$var$setupGlobalTouchEvents() {
    if (typeof document === "undefined") return;
    if (typeof PointerEvent !== "undefined") document.addEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
    else document.addEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    $6179b936705e76d3$var$hoverCount++;
    return function() {
        $6179b936705e76d3$var$hoverCount--;
        if ($6179b936705e76d3$var$hoverCount > 0) return;
        if (typeof PointerEvent !== "undefined") document.removeEventListener("pointerup", $6179b936705e76d3$var$handleGlobalPointerEvent);
        else document.removeEventListener("touchend", $6179b936705e76d3$var$setGlobalIgnoreEmulatedMouseEvents);
    };
}
function $6179b936705e76d3$export$ae780daf29e6d456(props) {
    var onHoverStart = props.onHoverStart, onHoverChange = props.onHoverChange, onHoverEnd = props.onHoverEnd, isDisabled = props.isDisabled;
    var _$bx7SL$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isHovered = _$bx7SL$useState[0], setHovered = _$bx7SL$useState[1];
    var state = (0, _react.useRef)({
        isHovered: false,
        ignoreEmulatedMouseEvents: false,
        pointerType: "",
        target: null
    }).current;
    (0, _react.useEffect)($6179b936705e76d3$var$setupGlobalTouchEvents, []);
    var _$bx7SL$useMemo = (0, _react.useMemo)(function() {
        var triggerHoverStart = function(event, pointerType) {
            state.pointerType = pointerType;
            if (isDisabled || pointerType === "touch" || state.isHovered || !event.currentTarget.contains(event.target)) return;
            state.isHovered = true;
            var target = event.currentTarget;
            state.target = target;
            if (onHoverStart) onHoverStart({
                type: "hoverstart",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(true);
            setHovered(true);
        };
        var triggerHoverEnd = function(event, pointerType) {
            state.pointerType = "";
            state.target = null;
            if (pointerType === "touch" || !state.isHovered) return;
            state.isHovered = false;
            var target = event.currentTarget;
            if (onHoverEnd) onHoverEnd({
                type: "hoverend",
                target: target,
                pointerType: pointerType
            });
            if (onHoverChange) onHoverChange(false);
            setHovered(false);
        };
        var hoverProps = {};
        if (typeof PointerEvent !== "undefined") {
            hoverProps.onPointerEnter = function(e) {
                if ($6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents && e.pointerType === "mouse") return;
                triggerHoverStart(e, e.pointerType);
            };
            hoverProps.onPointerLeave = function(e) {
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, e.pointerType);
            };
        } else {
            hoverProps.onTouchStart = function() {
                state.ignoreEmulatedMouseEvents = true;
            };
            hoverProps.onMouseEnter = function(e) {
                if (!state.ignoreEmulatedMouseEvents && !$6179b936705e76d3$var$globalIgnoreEmulatedMouseEvents) triggerHoverStart(e, "mouse");
                state.ignoreEmulatedMouseEvents = false;
            };
            hoverProps.onMouseLeave = function(e) {
                if (!isDisabled && e.currentTarget.contains(e.target)) triggerHoverEnd(e, "mouse");
            };
        }
        return {
            hoverProps: hoverProps,
            triggerHoverEnd: triggerHoverEnd
        };
    }, [
        onHoverStart,
        onHoverChange,
        onHoverEnd,
        isDisabled,
        state
    ]), hoverProps = _$bx7SL$useMemo.hoverProps, triggerHoverEnd = _$bx7SL$useMemo.triggerHoverEnd;
    (0, _react.useEffect)(function() {
        // Call the triggerHoverEnd as soon as isDisabled changes to true
        // Safe to call triggerHoverEnd, it will early return if we aren't currently hovering
        if (isDisabled) triggerHoverEnd({
            currentTarget: state.target
        }, state.pointerType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDisabled
    ]);
    return {
        hoverProps: hoverProps,
        isHovered: isHovered
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
function $e0b6e0b68ec7f50f$export$872b660ac5a1ff98(props) {
    var ref = props.ref, onInteractOutside = props.onInteractOutside, isDisabled = props.isDisabled, onInteractOutsideStart = props.onInteractOutsideStart;
    var stateRef = (0, _react.useRef)({
        isPointerDown: false,
        ignoreEmulatedMouseEvents: false
    });
    var onPointerDown = (0, _utils.useEffectEvent)(function(e) {
        if (onInteractOutside && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) {
            if (onInteractOutsideStart) onInteractOutsideStart(e);
            stateRef.current.isPointerDown = true;
        }
    });
    var triggerInteractOutside = (0, _utils.useEffectEvent)(function(e) {
        if (onInteractOutside) onInteractOutside(e);
    });
    (0, _react.useEffect)(function() {
        var state = stateRef.current;
        if (isDisabled) return;
        var element = ref.current;
        var documentObject = (0, _utils.getOwnerDocument)(element);
        // Use pointer events if available. Otherwise, fall back to mouse and touch events.
        if (typeof PointerEvent !== "undefined") {
            var onPointerUp = function(e) {
                if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            // changing these to capture phase fixed combobox
            documentObject.addEventListener("pointerdown", onPointerDown, true);
            documentObject.addEventListener("pointerup", onPointerUp, true);
            return function() {
                documentObject.removeEventListener("pointerdown", onPointerDown, true);
                documentObject.removeEventListener("pointerup", onPointerUp, true);
            };
        } else {
            var onMouseUp = function(e) {
                if (state.ignoreEmulatedMouseEvents) state.ignoreEmulatedMouseEvents = false;
                else if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            var onTouchEnd = function(e) {
                state.ignoreEmulatedMouseEvents = true;
                if (state.isPointerDown && $e0b6e0b68ec7f50f$var$isValidEvent(e, ref)) triggerInteractOutside(e);
                state.isPointerDown = false;
            };
            documentObject.addEventListener("mousedown", onPointerDown, true);
            documentObject.addEventListener("mouseup", onMouseUp, true);
            documentObject.addEventListener("touchstart", onPointerDown, true);
            documentObject.addEventListener("touchend", onTouchEnd, true);
            return function() {
                documentObject.removeEventListener("mousedown", onPointerDown, true);
                documentObject.removeEventListener("mouseup", onMouseUp, true);
                documentObject.removeEventListener("touchstart", onPointerDown, true);
                documentObject.removeEventListener("touchend", onTouchEnd, true);
            };
        }
    }, [
        ref,
        isDisabled,
        onPointerDown,
        triggerInteractOutside
    ]);
}
function $e0b6e0b68ec7f50f$var$isValidEvent(event, ref) {
    if (event.button > 0) return false;
    if (event.target) {
        // if the event target is no longer in the document, ignore
        var ownerDocument = event.target.ownerDocument;
        if (!ownerDocument || !ownerDocument.documentElement.contains(event.target)) return false;
        // If the target is within a top layer element (e.g. toasts), ignore.
        if (event.target.closest("[data-react-aria-top-layer]")) return false;
    }
    return ref.current && !ref.current.contains(event.target);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $93925083ecbb358c$export$48d1ea6320830260(handler) {
    if (!handler) return undefined;
    var shouldStopPropagation = true;
    return function(e) {
        var event = (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            preventDefault: function() {
                e.preventDefault();
            },
            isDefaultPrevented: function() {
                return e.isDefaultPrevented();
            },
            stopPropagation: function() {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
            },
            continuePropagation: function() {
                shouldStopPropagation = false;
            }
        });
        handler(event);
        if (shouldStopPropagation) e.stopPropagation();
    };
}
function $46d819fcbaf35654$export$8f71654801c2f7cd(props) {
    return {
        keyboardProps: props.isDisabled ? {} : {
            onKeyDown: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyDown),
            onKeyUp: $93925083ecbb358c$export$48d1ea6320830260(props.onKeyUp)
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e8a7022cf87cba2a$export$36da96379f79f245(props) {
    var onMoveStart = props.onMoveStart, onMove = props.onMove, onMoveEnd = props.onMoveEnd;
    var state = (0, _react.useRef)({
        didMove: false,
        lastPosition: null,
        id: null
    });
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeGlobalListener = _$bx7SL$useGlobalListeners.removeGlobalListener;
    var move = (0, _utils.useEffectEvent)(function(originalEvent, pointerType, deltaX, deltaY) {
        if (deltaX === 0 && deltaY === 0) return;
        if (!state.current.didMove) {
            state.current.didMove = true;
            onMoveStart === null || onMoveStart === void 0 || onMoveStart({
                type: "movestart",
                pointerType: pointerType,
                shiftKey: originalEvent.shiftKey,
                metaKey: originalEvent.metaKey,
                ctrlKey: originalEvent.ctrlKey,
                altKey: originalEvent.altKey
            });
        }
        onMove === null || onMove === void 0 || onMove({
            type: "move",
            pointerType: pointerType,
            deltaX: deltaX,
            deltaY: deltaY,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    var end = (0, _utils.useEffectEvent)(function(originalEvent, pointerType) {
        $14c0b72509d70225$export$b0d6fa1ab32e3295();
        if (state.current.didMove) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd({
            type: "moveend",
            pointerType: pointerType,
            shiftKey: originalEvent.shiftKey,
            metaKey: originalEvent.metaKey,
            ctrlKey: originalEvent.ctrlKey,
            altKey: originalEvent.altKey
        });
    });
    var moveProps = (0, _react.useMemo)(function() {
        var moveProps = {};
        var start = function() {
            $14c0b72509d70225$export$16a4697467175487();
            state.current.didMove = false;
        };
        if (typeof PointerEvent === "undefined") {
            var onMouseMove = function(e) {
                if (e.button === 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "mouse", e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            var onMouseUp = function(e) {
                if (e.button === 0) {
                    end(e, "mouse");
                    removeGlobalListener(window, "mousemove", onMouseMove, false);
                    removeGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            moveProps.onMouseDown = function(e) {
                if (e.button === 0) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    addGlobalListener(window, "mousemove", onMouseMove, false);
                    addGlobalListener(window, "mouseup", onMouseUp, false);
                }
            };
            var onTouchMove = function(e) {
                var touch = (0, _toConsumableArray._)(e.changedTouches).findIndex(function(param) {
                    var identifier = param.identifier;
                    return identifier === state.current.id;
                });
                if (touch >= 0) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var _e_changedTouches_touch = e.changedTouches[touch], pageX = _e_changedTouches_touch.pageX, pageY = _e_changedTouches_touch.pageY;
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    move(e, "touch", pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: pageX,
                        pageY: pageY
                    };
                }
            };
            var onTouchEnd = function(e) {
                var touch = (0, _toConsumableArray._)(e.changedTouches).findIndex(function(param) {
                    var identifier = param.identifier;
                    return identifier === state.current.id;
                });
                if (touch >= 0) {
                    end(e, "touch");
                    state.current.id = null;
                    removeGlobalListener(window, "touchmove", onTouchMove);
                    removeGlobalListener(window, "touchend", onTouchEnd);
                    removeGlobalListener(window, "touchcancel", onTouchEnd);
                }
            };
            moveProps.onTouchStart = function(e) {
                if (e.changedTouches.length === 0 || state.current.id != null) return;
                var _e_changedTouches_ = e.changedTouches[0], pageX = _e_changedTouches_.pageX, pageY = _e_changedTouches_.pageY, identifier = _e_changedTouches_.identifier;
                start();
                e.stopPropagation();
                e.preventDefault();
                state.current.lastPosition = {
                    pageX: pageX,
                    pageY: pageY
                };
                state.current.id = identifier;
                addGlobalListener(window, "touchmove", onTouchMove, false);
                addGlobalListener(window, "touchend", onTouchEnd, false);
                addGlobalListener(window, "touchcancel", onTouchEnd, false);
            };
        } else {
            var onPointerMove = function(e) {
                if (e.pointerId === state.current.id) {
                    var _state_current_lastPosition, _state_current_lastPosition1;
                    var pointerType = e.pointerType || "mouse";
                    var _state_current_lastPosition_pageX, _state_current_lastPosition_pageY;
                    // Problems with PointerEvent#movementX/movementY:
                    // 1. it is always 0 on macOS Safari.
                    // 2. On Chrome Android, it's scaled by devicePixelRatio, but not on Chrome macOS
                    move(e, pointerType, e.pageX - ((_state_current_lastPosition_pageX = (_state_current_lastPosition = state.current.lastPosition) === null || _state_current_lastPosition === void 0 ? void 0 : _state_current_lastPosition.pageX) !== null && _state_current_lastPosition_pageX !== void 0 ? _state_current_lastPosition_pageX : 0), e.pageY - ((_state_current_lastPosition_pageY = (_state_current_lastPosition1 = state.current.lastPosition) === null || _state_current_lastPosition1 === void 0 ? void 0 : _state_current_lastPosition1.pageY) !== null && _state_current_lastPosition_pageY !== void 0 ? _state_current_lastPosition_pageY : 0));
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                }
            };
            var onPointerUp = function(e) {
                if (e.pointerId === state.current.id) {
                    var pointerType = e.pointerType || "mouse";
                    end(e, pointerType);
                    state.current.id = null;
                    removeGlobalListener(window, "pointermove", onPointerMove, false);
                    removeGlobalListener(window, "pointerup", onPointerUp, false);
                    removeGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
            moveProps.onPointerDown = function(e) {
                if (e.button === 0 && state.current.id == null) {
                    start();
                    e.stopPropagation();
                    e.preventDefault();
                    state.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                    };
                    state.current.id = e.pointerId;
                    addGlobalListener(window, "pointermove", onPointerMove, false);
                    addGlobalListener(window, "pointerup", onPointerUp, false);
                    addGlobalListener(window, "pointercancel", onPointerUp, false);
                }
            };
        }
        var triggerKeyboardMove = function(e, deltaX, deltaY) {
            start();
            move(e, "keyboard", deltaX, deltaY);
            end(e, "keyboard");
        };
        moveProps.onKeyDown = function(e) {
            switch(e.key){
                case "Left":
                case "ArrowLeft":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, -1, 0);
                    break;
                case "Right":
                case "ArrowRight":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 1, 0);
                    break;
                case "Up":
                case "ArrowUp":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, -1);
                    break;
                case "Down":
                case "ArrowDown":
                    e.preventDefault();
                    e.stopPropagation();
                    triggerKeyboardMove(e, 0, 1);
                    break;
            }
        };
        return moveProps;
    }, [
        state,
        addGlobalListener,
        removeGlobalListener,
        move,
        end
    ]);
    return {
        moveProps: moveProps
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7d0a636d7a4dcefd$export$2123ff2b87c81ca(props, ref) {
    var onScroll = props.onScroll, isDisabled = props.isDisabled;
    var onScrollHandler = (0, _react.useCallback)(function(e) {
        // If the ctrlKey is pressed, this is a zoom event, do nothing.
        if (e.ctrlKey) return;
        // stop scrolling the page
        e.preventDefault();
        e.stopPropagation();
        if (onScroll) onScroll({
            deltaX: e.deltaX,
            deltaY: e.deltaY
        });
    }, [
        onScroll
    ]);
    (0, _utils.useEvent)(ref, "wheel", isDisabled ? undefined : onScrollHandler);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $8a26561d2877236e$var$DEFAULT_THRESHOLD = 500;
function $8a26561d2877236e$export$c24ed0104d07eab9(props) {
    var isDisabled = props.isDisabled, onLongPressStart = props.onLongPressStart, onLongPressEnd = props.onLongPressEnd, onLongPress = props.onLongPress, tmp = props.threshold, threshold = tmp === void 0 ? $8a26561d2877236e$var$DEFAULT_THRESHOLD : tmp, accessibilityDescription = props.accessibilityDescription;
    var timeRef = (0, _react.useRef)();
    var _$bx7SL$useGlobalListeners = (0, _utils.useGlobalListeners)(), addGlobalListener = _$bx7SL$useGlobalListeners.addGlobalListener, removeGlobalListener = _$bx7SL$useGlobalListeners.removeGlobalListener;
    var _$f6c31cce2adf654f$export$45712eceda6fad21 = $f6c31cce2adf654f$export$45712eceda6fad21({
        isDisabled: isDisabled,
        onPressStart: function(e) {
            e.continuePropagation();
            if (e.pointerType === "mouse" || e.pointerType === "touch") {
                if (onLongPressStart) onLongPressStart((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                    type: "longpressstart"
                }));
                timeRef.current = setTimeout(function() {
                    // Prevent other usePress handlers from also handling this event.
                    e.target.dispatchEvent(new PointerEvent("pointercancel", {
                        bubbles: true
                    }));
                    if (onLongPress) onLongPress((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                        type: "longpress"
                    }));
                    timeRef.current = undefined;
                }, threshold);
                // Prevent context menu, which may be opened on long press on touch devices
                if (e.pointerType === "touch") {
                    var onContextMenu = function(e) {
                        e.preventDefault();
                    };
                    addGlobalListener(e.target, "contextmenu", onContextMenu, {
                        once: true
                    });
                    addGlobalListener(window, "pointerup", function() {
                        // If no contextmenu event is fired quickly after pointerup, remove the handler
                        // so future context menu events outside a long press are not prevented.
                        setTimeout(function() {
                            removeGlobalListener(e.target, "contextmenu", onContextMenu);
                        }, 30);
                    }, {
                        once: true
                    });
                }
            }
        },
        onPressEnd: function(e) {
            if (timeRef.current) clearTimeout(timeRef.current);
            if (onLongPressEnd && (e.pointerType === "mouse" || e.pointerType === "touch")) onLongPressEnd((0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
                type: "longpressend"
            }));
        }
    }), pressProps = _$f6c31cce2adf654f$export$45712eceda6fad21.pressProps;
    var descriptionProps = (0, _utils.useDescription)(onLongPress && !isDisabled ? accessibilityDescription : undefined);
    return {
        longPressProps: (0, _utils.mergeProps)(pressProps, descriptionProps)
    };
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@react-aria/utils":"jTQk5","react":"ktQNc","@swc/helpers/_/_class_private_field_get":"aTr5X","@swc/helpers/_/_class_private_field_init":"f5jxq","@swc/helpers/_/_class_private_field_set":"CcybI","@react-aria/ssr":"5NmzK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jTQk5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useId", function() {
    return $bdb11010cef70236$export$f680877a34711e37;
});
parcelHelpers.export(exports, "mergeIds", function() {
    return $bdb11010cef70236$export$cd8c9cb68f842629;
});
parcelHelpers.export(exports, "useSlotId", function() {
    return $bdb11010cef70236$export$b4cc09c592e8fdb8;
});
parcelHelpers.export(exports, "chain", function() {
    return $ff5963eb1fccf552$export$e08e3b67e392101e;
});
parcelHelpers.export(exports, "getOwnerDocument", function() {
    return $431fbd86ca7dc216$export$b204af158042fbac;
});
parcelHelpers.export(exports, "getOwnerWindow", function() {
    return $431fbd86ca7dc216$export$f21a1ffae260145a;
});
parcelHelpers.export(exports, "mergeProps", function() {
    return $3ef42575df84b30b$export$9d1611c77c2fe928;
});
parcelHelpers.export(exports, "mergeRefs", function() {
    return $5dc95899b306f630$export$c9058316764c140e;
});
parcelHelpers.export(exports, "filterDOMProps", function() {
    return $65484d02dcb7eb3e$export$457c3d6518dd4c6f;
});
parcelHelpers.export(exports, "focusWithoutScrolling", function() {
    return $7215afc6de606d6b$export$de79e2c695e052f3;
});
parcelHelpers.export(exports, "getOffset", function() {
    return $ab71dadb03a6fb2e$export$622cea445a1c5b7d;
});
parcelHelpers.export(exports, "openLink", function() {
    return $ea8dcbcb9ea1b556$export$95185d699e05d4d7;
});
parcelHelpers.export(exports, "getSyntheticLinkProps", function() {
    return $ea8dcbcb9ea1b556$export$51437d503373d223;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return $ea8dcbcb9ea1b556$export$323e4fc2fa4753fb;
});
parcelHelpers.export(exports, "shouldClientNavigate", function() {
    return $ea8dcbcb9ea1b556$export$efa8c9099e530235;
});
parcelHelpers.export(exports, "useRouter", function() {
    return $ea8dcbcb9ea1b556$export$9a302a45f65d0572;
});
parcelHelpers.export(exports, "runAfterTransition", function() {
    return $bbed8b41f857bcc0$export$24490316f764c430;
});
parcelHelpers.export(exports, "useDrag1D", function() {
    return $9cc09df9fd7676be$export$7bbed75feba39706;
});
parcelHelpers.export(exports, "useGlobalListeners", function() {
    return $03deb23ff14920c4$export$4eaf04e54aa8eed6;
});
parcelHelpers.export(exports, "useLabels", function() {
    return $313b98861ee5dd6c$export$d6875122194c7b44;
});
parcelHelpers.export(exports, "useObjectRef", function() {
    return $df56164dff5785e2$export$4338b53315abf666;
});
parcelHelpers.export(exports, "useUpdateEffect", function() {
    return $4f58c5f72bcf79f7$export$496315a1608d9602;
});
parcelHelpers.export(exports, "useLayoutEffect", function() {
    return $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c;
});
parcelHelpers.export(exports, "useResizeObserver", function() {
    return $9daab02d461809db$export$683480f191c0e3ea;
});
parcelHelpers.export(exports, "useSyncRef", function() {
    return $e7801be82b4b2a53$export$4debdb1a3f0fa79e;
});
parcelHelpers.export(exports, "getScrollParent", function() {
    return $62d8ded9296f3872$export$cfa2225e87938781;
});
parcelHelpers.export(exports, "isScrollable", function() {
    return $62d8ded9296f3872$export$2bb74740c4e19def;
});
parcelHelpers.export(exports, "useViewportSize", function() {
    return $5df64b3807dc15ee$export$d699905dd57c73ca;
});
parcelHelpers.export(exports, "useDescription", function() {
    return $ef06256079686ba0$export$f8aeda7b10753fa1;
});
parcelHelpers.export(exports, "isMac", function() {
    return $c87311424ea30a05$export$9ac100e40613ea10;
});
parcelHelpers.export(exports, "isIPhone", function() {
    return $c87311424ea30a05$export$186c6964ca17d99;
});
parcelHelpers.export(exports, "isIPad", function() {
    return $c87311424ea30a05$export$7bef049ce92e4224;
});
parcelHelpers.export(exports, "isIOS", function() {
    return $c87311424ea30a05$export$fedb369cb70207f1;
});
parcelHelpers.export(exports, "isAppleDevice", function() {
    return $c87311424ea30a05$export$e1865c3bedcd822b;
});
parcelHelpers.export(exports, "isWebKit", function() {
    return $c87311424ea30a05$export$78551043582a6a98;
});
parcelHelpers.export(exports, "isChrome", function() {
    return $c87311424ea30a05$export$6446a186d09e379e;
});
parcelHelpers.export(exports, "isAndroid", function() {
    return $c87311424ea30a05$export$a11b0059900ceec8;
});
parcelHelpers.export(exports, "isFirefox", function() {
    return $c87311424ea30a05$export$b7d78993b74f766d;
});
parcelHelpers.export(exports, "useEvent", function() {
    return $e9faafb641e167db$export$90fc3a17d93f704c;
});
parcelHelpers.export(exports, "useValueEffect", function() {
    return $1dbecbe27a04f9af$export$14d238f342723f25;
});
parcelHelpers.export(exports, "scrollIntoView", function() {
    return $2f04cbc44ee30ce0$export$53a0910f038337bd;
});
parcelHelpers.export(exports, "scrollIntoViewport", function() {
    return $2f04cbc44ee30ce0$export$c826860796309d1b;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _utils.clamp;
});
parcelHelpers.export(exports, "snapValueToStep", function() {
    return 0, _utils.snapValueToStep;
});
parcelHelpers.export(exports, "isVirtualClick", function() {
    return $6a7db85432448f7f$export$60278871457622de;
});
parcelHelpers.export(exports, "isVirtualPointerEvent", function() {
    return $6a7db85432448f7f$export$29bf1b5f2c56cf63;
});
parcelHelpers.export(exports, "useEffectEvent", function() {
    return $8ae05eaa5c114e9c$export$7f54fc3180508a52;
});
parcelHelpers.export(exports, "useDeepMemo", function() {
    return $5a387cc49350e6db$export$722debc0e56fea39;
});
parcelHelpers.export(exports, "useFormReset", function() {
    return $99facab73266f662$export$5add1d006293d136;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@react-stately/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ssr = require("@react-aria/ssr");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, _reactDefault.default).useLayoutEffect : function() {};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $8ae05eaa5c114e9c$export$7f54fc3180508a52(fn) {
    var ref = (0, _react.useRef)(null);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        ref.current = fn;
    }, [
        fn
    ]);
    // @ts-ignore
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var f = ref.current;
        return f === null || f === void 0 ? void 0 : f.apply(void 0, (0, _toConsumableArray._)(args));
    }, []);
}
function $1dbecbe27a04f9af$export$14d238f342723f25(defaultValue) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(defaultValue), 2), value1 = _$12uGp$useState[0], setValue = _$12uGp$useState[1];
    var effect = (0, _react.useRef)(null);
    // Store the function in a ref so we can always access the current version
    // which has the proper `value` in scope.
    var nextRef = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function() {
        if (!effect.current) return;
        // Run the generator to the next yield.
        var newValue = effect.current.next();
        // If the generator is done, reset the effect.
        if (newValue.done) {
            effect.current = null;
            return;
        }
        // If the value is the same as the current value,
        // then continue to the next yield. Otherwise,
        // set the value in state and wait for the next layout effect.
        if (value1 === newValue.value) nextRef();
        else setValue(newValue.value);
    });
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        // If there is an effect currently running, continue to the next yield.
        if (effect.current) nextRef();
    });
    var queue = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function(fn) {
        effect.current = fn(value1);
        nextRef();
    });
    return [
        value1,
        queue
    ];
}
// copied from SSRProvider.tsx to reduce exports, if needed again, consider sharing
var $bdb11010cef70236$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $bdb11010cef70236$var$idsUpdaterMap = new Map();
function $bdb11010cef70236$export$f680877a34711e37(defaultId) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(defaultId), 2), value1 = _$12uGp$useState[0], setValue = _$12uGp$useState[1];
    var nextId = (0, _react.useRef)(null);
    var res = (0, _ssr.useSSRSafeId)(value1);
    var updateValue = (0, _react.useCallback)(function(val) {
        nextId.current = val;
    }, []);
    if ($bdb11010cef70236$var$canUseDOM) $bdb11010cef70236$var$idsUpdaterMap.set(res, updateValue);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        var r = res;
        return function() {
            $bdb11010cef70236$var$idsUpdaterMap.delete(r);
        };
    }, [
        res
    ]);
    (0, _react.useEffect)(function() {
        var newId = nextId.current;
        if (newId) {
            nextId.current = null;
            setValue(newId);
        }
    });
    return res;
}
function $bdb11010cef70236$export$cd8c9cb68f842629(idA, idB) {
    if (idA === idB) return idA;
    var setIdA = $bdb11010cef70236$var$idsUpdaterMap.get(idA);
    if (setIdA) {
        setIdA(idB);
        return idB;
    }
    var setIdB = $bdb11010cef70236$var$idsUpdaterMap.get(idB);
    if (setIdB) {
        setIdB(idA);
        return idA;
    }
    return idB;
}
function $bdb11010cef70236$export$b4cc09c592e8fdb8() {
    var depArray = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var id = $bdb11010cef70236$export$f680877a34711e37();
    var _$1dbecbe27a04f9af$export$14d238f342723f25 = (0, _slicedToArray._)($1dbecbe27a04f9af$export$14d238f342723f25(id), 2), resolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[0], setResolvedId = _$1dbecbe27a04f9af$export$14d238f342723f25[1];
    var updateId = (0, _react.useCallback)(function() {
        setResolvedId(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            id
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            document.getElementById(id) ? id : undefined
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    }, [
        id,
        setResolvedId
    ]);
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(updateId, [
        id,
        updateId
    ].concat((0, _toConsumableArray._)(depArray)));
    return resolvedId;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Calls all functions in the order they were chained with the same arguments.
 */ function $ff5963eb1fccf552$export$e08e3b67e392101e() {
    for(var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++){
        callbacks[_key] = arguments[_key];
    }
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                if (typeof callback === "function") callback.apply(void 0, (0, _toConsumableArray._)(args));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
var $431fbd86ca7dc216$export$b204af158042fbac = function(el) {
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
var $431fbd86ca7dc216$export$f21a1ffae260145a = function(el) {
    if (el && "window" in el && el.window === el) return el;
    var doc = $431fbd86ca7dc216$export$b204af158042fbac(el);
    return doc.defaultView || window;
};
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3ef42575df84b30b$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    // Start with a base clone of the first argument. This is a lot faster than starting
    // with an empty object and adding properties as we go.
    var result = (0, _objectSpread._)({}, args[0]);
    for(var i = 1; i < args.length; i++){
        var props = args[i];
        for(var key in props){
            var a = result[key];
            var b = props[key];
            // Chain events
            if (typeof a === "function" && typeof b === "function" && // This is a lot faster than a regex.
            key[0] === "o" && key[1] === "n" && key.charCodeAt(2) >= /* 'A' */ 65 && key.charCodeAt(2) <= /* 'Z' */ 90) result[key] = $ff5963eb1fccf552$export$e08e3b67e392101e(a, b);
            else if ((key === "className" || key === "UNSAFE_className") && typeof a === "string" && typeof b === "string") result[key] = (0, _clsxDefault.default)(a, b);
            else if (key === "id" && a && b) result.id = $bdb11010cef70236$export$cd8c9cb68f842629(a, b);
            else result[key] = b !== undefined ? b : a;
        }
    }
    return result;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $5dc95899b306f630$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    if (refs.length === 1) return refs[0];
    return function(value1) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ref = _step.value;
                if (typeof ref === "function") ref(value1);
                else if (ref != null) ref.current = value1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $65484d02dcb7eb3e$var$DOMPropNames = new Set([
    "id"
]);
var $65484d02dcb7eb3e$var$labelablePropNames = new Set([
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-details"
]);
// See LinkDOMProps in dom.d.ts.
var $65484d02dcb7eb3e$var$linkPropNames = new Set([
    "href",
    "target",
    "rel",
    "download",
    "ping",
    "referrerPolicy"
]);
var $65484d02dcb7eb3e$var$propRe = /^(data-.*)$/;
function $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var labelable = opts.labelable, isLink = opts.isLink, propNames = opts.propNames;
    var filteredProps = {};
    for(var prop in props)if (Object.prototype.hasOwnProperty.call(props, prop) && ($65484d02dcb7eb3e$var$DOMPropNames.has(prop) || labelable && $65484d02dcb7eb3e$var$labelablePropNames.has(prop) || isLink && $65484d02dcb7eb3e$var$linkPropNames.has(prop) || (propNames === null || propNames === void 0 ? void 0 : propNames.has(prop)) || $65484d02dcb7eb3e$var$propRe.test(prop))) filteredProps[prop] = props[prop];
    return filteredProps;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $7215afc6de606d6b$export$de79e2c695e052f3(element) {
    if ($7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        var scrollableElements = $7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
var $7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $7215afc6de606d6b$var$supportsPreventScroll() {
    if ($7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            var focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $7215afc6de606d6b$var$getScrollableElements(element) {
    var parent = element.parentNode;
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = scrollableElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, element = _step_value.element, scrollTop = _step_value.scrollTop, scrollLeft = _step_value.scrollLeft;
            element.scrollTop = scrollTop;
            element.scrollLeft = scrollLeft;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $ab71dadb03a6fb2e$export$622cea445a1c5b7d(element, reverse) {
    var orientation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "horizontal";
    var rect = element.getBoundingClientRect();
    if (reverse) return orientation === "horizontal" ? rect.right : rect.bottom;
    return orientation === "horizontal" ? rect.left : rect.top;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some(function(brand) {
        return re.test(brand.brand);
    })) || re.test(window.navigator.userAgent);
}
function $c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $c87311424ea30a05$export$9ac100e40613ea10() {
    return $c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $c87311424ea30a05$export$186c6964ca17d99() {
    return $c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $c87311424ea30a05$export$7bef049ce92e4224() {
    return $c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $c87311424ea30a05$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $c87311424ea30a05$export$fedb369cb70207f1() {
    return $c87311424ea30a05$export$186c6964ca17d99() || $c87311424ea30a05$export$7bef049ce92e4224();
}
function $c87311424ea30a05$export$e1865c3bedcd822b() {
    return $c87311424ea30a05$export$9ac100e40613ea10() || $c87311424ea30a05$export$fedb369cb70207f1();
}
function $c87311424ea30a05$export$78551043582a6a98() {
    return $c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$c87311424ea30a05$export$6446a186d09e379e();
}
function $c87311424ea30a05$export$6446a186d09e379e() {
    return $c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $c87311424ea30a05$export$a11b0059900ceec8() {
    return $c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $c87311424ea30a05$export$b7d78993b74f766d() {
    return $c87311424ea30a05$var$testUserAgent(/Firefox/i);
}
var $ea8dcbcb9ea1b556$var$RouterContext = (0, _react.createContext)({
    isNative: true,
    open: $ea8dcbcb9ea1b556$var$openSyntheticLink
});
function $ea8dcbcb9ea1b556$export$323e4fc2fa4753fb(props) {
    var children = props.children, navigate = props.navigate;
    var ctx = (0, _react.useMemo)(function() {
        return {
            isNative: false,
            open: function(target, modifiers) {
                $ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
                    if ($ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers)) navigate(link.pathname + link.search + link.hash);
                    else $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers);
                });
            }
        };
    }, [
        navigate
    ]);
    return (0, _reactDefault.default).createElement($ea8dcbcb9ea1b556$var$RouterContext.Provider, {
        value: ctx
    }, children);
}
function $ea8dcbcb9ea1b556$export$9a302a45f65d0572() {
    return (0, _react.useContext)($ea8dcbcb9ea1b556$var$RouterContext);
}
function $ea8dcbcb9ea1b556$export$efa8c9099e530235(link, modifiers) {
    // Use getAttribute here instead of link.target. Firefox will default link.target to "_parent" when inside an iframe.
    var target = link.getAttribute("target");
    return (!target || target === "_self") && link.origin === location.origin && !link.hasAttribute("download") && !modifiers.metaKey && // open in new tab (mac)
    !modifiers.ctrlKey && // open in new tab (windows)
    !modifiers.altKey && // download
    !modifiers.shiftKey;
}
function $ea8dcbcb9ea1b556$export$95185d699e05d4d7(target, modifiers) {
    var setOpening = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _window_event_type, _window_event;
    var metaKey = modifiers.metaKey, ctrlKey = modifiers.ctrlKey, altKey = modifiers.altKey, shiftKey = modifiers.shiftKey;
    // Firefox does not recognize keyboard events as a user action by default, and the popup blocker
    // will prevent links with target="_blank" from opening. However, it does allow the event if the
    // Command/Control key is held, which opens the link in a background tab. This seems like the best we can do.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=257870 and https://bugzilla.mozilla.org/show_bug.cgi?id=746640.
    if ($c87311424ea30a05$export$b7d78993b74f766d() && ((_window_event = window.event) === null || _window_event === void 0 ? void 0 : (_window_event_type = _window_event.type) === null || _window_event_type === void 0 ? void 0 : _window_event_type.startsWith("key")) && target.target === "_blank") {
        if ($c87311424ea30a05$export$9ac100e40613ea10()) metaKey = true;
        else ctrlKey = true;
    }
    // WebKit does not support firing click events with modifier keys, but does support keyboard events.
    // https://github.com/WebKit/WebKit/blob/c03d0ac6e6db178f90923a0a63080b5ca210d25f/Source/WebCore/html/HTMLAnchorElement.cpp#L184
    var event = $c87311424ea30a05$export$78551043582a6a98() && $c87311424ea30a05$export$9ac100e40613ea10() && !$c87311424ea30a05$export$7bef049ce92e4224() && true ? new KeyboardEvent("keydown", {
        keyIdentifier: "Enter",
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey
    }) : new MouseEvent("click", {
        metaKey: metaKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        shiftKey: shiftKey,
        bubbles: true,
        cancelable: true
    });
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = setOpening;
    $7215afc6de606d6b$export$de79e2c695e052f3(target);
    target.dispatchEvent(event);
    $ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
}
// https://github.com/parcel-bundler/parcel/issues/8724
$ea8dcbcb9ea1b556$export$95185d699e05d4d7.isOpening = false;
function $ea8dcbcb9ea1b556$var$getSyntheticLink(target, open) {
    if (target instanceof HTMLAnchorElement) open(target);
    else if (target.hasAttribute("data-href")) {
        var link = document.createElement("a");
        link.href = target.getAttribute("data-href");
        if (target.hasAttribute("data-target")) link.target = target.getAttribute("data-target");
        if (target.hasAttribute("data-rel")) link.rel = target.getAttribute("data-rel");
        if (target.hasAttribute("data-download")) link.download = target.getAttribute("data-download");
        if (target.hasAttribute("data-ping")) link.ping = target.getAttribute("data-ping");
        if (target.hasAttribute("data-referrer-policy")) link.referrerPolicy = target.getAttribute("data-referrer-policy");
        target.appendChild(link);
        open(link);
        target.removeChild(link);
    }
}
function $ea8dcbcb9ea1b556$var$openSyntheticLink(target, modifiers) {
    $ea8dcbcb9ea1b556$var$getSyntheticLink(target, function(link) {
        return $ea8dcbcb9ea1b556$export$95185d699e05d4d7(link, modifiers);
    });
}
function $ea8dcbcb9ea1b556$export$51437d503373d223(props) {
    return {
        "data-href": props.href,
        "data-target": props.target,
        "data-rel": props.rel,
        "data-download": props.download,
        "data-ping": props.ping,
        "data-referrer-policy": props.referrerPolicy
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
var $bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
var $bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    var onTransitionStart = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        var transitions = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    var onTransitionEnd = function(e) {
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        var properties = $bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $bbed8b41f857bcc0$var$transitionCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cb = _step.value;
                    cb();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            $bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $bbed8b41f857bcc0$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(function() {
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ // Keep track of elements that we are currently handling dragging for via useDrag1D.
// If there's an ancestor and a descendant both using useDrag1D(), and the user starts
// dragging the descendant, we don't want useDrag1D events to fire for the ancestor.
var $9cc09df9fd7676be$var$draggingElements = [];
function $9cc09df9fd7676be$export$7bbed75feba39706(props) {
    console.warn("useDrag1D is deprecated, please use `useMove` instead https://react-spectrum.adobe.com/react-aria/useMove.html");
    var containerRef = props.containerRef, reverse = props.reverse, orientation = props.orientation, onHover = props.onHover, onDrag = props.onDrag, onPositionChange = props.onPositionChange, onIncrement = props.onIncrement, onDecrement = props.onDecrement, onIncrementToMax = props.onIncrementToMax, onDecrementToMin = props.onDecrementToMin, onCollapseToggle = props.onCollapseToggle;
    var getPosition = function(e) {
        return orientation === "horizontal" ? e.clientX : e.clientY;
    };
    var getNextOffset = function(e) {
        var containerOffset = $ab71dadb03a6fb2e$export$622cea445a1c5b7d(containerRef.current, reverse, orientation);
        var mouseOffset = getPosition(e);
        var nextOffset = reverse ? containerOffset - mouseOffset : mouseOffset - containerOffset;
        return nextOffset;
    };
    var dragging = (0, _react.useRef)(false);
    var prevPosition = (0, _react.useRef)(0);
    // Keep track of the current handlers in a ref so that the events can access them.
    var handlers = (0, _react.useRef)({
        onPositionChange: onPositionChange,
        onDrag: onDrag
    });
    handlers.current.onDrag = onDrag;
    handlers.current.onPositionChange = onPositionChange;
    var onMouseDragged = function(e) {
        e.preventDefault();
        var nextOffset = getNextOffset(e);
        if (!dragging.current) {
            dragging.current = true;
            if (handlers.current.onDrag) handlers.current.onDrag(true);
            if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        }
        if (prevPosition.current === nextOffset) return;
        prevPosition.current = nextOffset;
        if (onPositionChange) onPositionChange(nextOffset);
    };
    var onMouseUp = function(e) {
        var target = e.target;
        dragging.current = false;
        var nextOffset = getNextOffset(e);
        if (handlers.current.onDrag) handlers.current.onDrag(false);
        if (handlers.current.onPositionChange) handlers.current.onPositionChange(nextOffset);
        $9cc09df9fd7676be$var$draggingElements.splice($9cc09df9fd7676be$var$draggingElements.indexOf(target), 1);
        window.removeEventListener("mouseup", onMouseUp, false);
        window.removeEventListener("mousemove", onMouseDragged, false);
    };
    var onMouseDown = function(e) {
        var target = e.currentTarget;
        // If we're already handling dragging on a descendant with useDrag1D, then
        // we don't want to handle the drag motion on this target as well.
        if ($9cc09df9fd7676be$var$draggingElements.some(function(elt) {
            return target.contains(elt);
        })) return;
        $9cc09df9fd7676be$var$draggingElements.push(target);
        window.addEventListener("mousemove", onMouseDragged, false);
        window.addEventListener("mouseup", onMouseUp, false);
    };
    var onMouseEnter = function() {
        if (onHover) onHover(true);
    };
    var onMouseOut = function() {
        if (onHover) onHover(false);
    };
    var onKeyDown = function(e) {
        switch(e.key){
            case "Left":
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Up":
            case "ArrowUp":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onDecrement && !reverse) onDecrement();
                    else if (onIncrement && reverse) onIncrement();
                }
                break;
            case "Right":
            case "ArrowRight":
                if (orientation === "horizontal") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Down":
            case "ArrowDown":
                if (orientation === "vertical") {
                    e.preventDefault();
                    if (onIncrement && !reverse) onIncrement();
                    else if (onDecrement && reverse) onDecrement();
                }
                break;
            case "Home":
                e.preventDefault();
                if (onDecrementToMin) onDecrementToMin();
                break;
            case "End":
                e.preventDefault();
                if (onIncrementToMax) onIncrementToMax();
                break;
            case "Enter":
                e.preventDefault();
                if (onCollapseToggle) onCollapseToggle();
                break;
        }
    };
    return {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onKeyDown: onKeyDown
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $03deb23ff14920c4$export$4eaf04e54aa8eed6() {
    var globalListeners = (0, _react.useRef)(new Map());
    var addGlobalListener = (0, _react.useCallback)(function(eventTarget, type, listener, options) {
        // Make sure we remove the listener after it is called with the `once` option.
        var fn = (options === null || options === void 0 ? void 0 : options.once) ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            globalListeners.current.delete(listener);
            listener.apply(void 0, (0, _toConsumableArray._)(args));
        } : listener;
        globalListeners.current.set(listener, {
            type: type,
            eventTarget: eventTarget,
            fn: fn,
            options: options
        });
        eventTarget.addEventListener(type, listener, options);
    }, []);
    var removeGlobalListener = (0, _react.useCallback)(function(eventTarget, type, listener, options) {
        var _globalListeners_current_get;
        var fn = ((_globalListeners_current_get = globalListeners.current.get(listener)) === null || _globalListeners_current_get === void 0 ? void 0 : _globalListeners_current_get.fn) || listener;
        eventTarget.removeEventListener(type, fn, options);
        globalListeners.current.delete(listener);
    }, []);
    var removeAllGlobalListeners = (0, _react.useCallback)(function() {
        globalListeners.current.forEach(function(value1, key) {
            removeGlobalListener(value1.eventTarget, value1.type, key, value1.options);
        });
    }, [
        removeGlobalListener
    ]);
    (0, _react.useEffect)(function() {
        return removeAllGlobalListeners;
    }, [
        removeAllGlobalListeners
    ]);
    return {
        addGlobalListener: addGlobalListener,
        removeGlobalListener: removeGlobalListener,
        removeAllGlobalListeners: removeAllGlobalListeners
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $313b98861ee5dd6c$export$d6875122194c7b44(props, defaultLabel) {
    var id = props.id, label = props["aria-label"], labelledBy = props["aria-labelledby"];
    // If there is both an aria-label and aria-labelledby,
    // combine them by pointing to the element itself.
    id = $bdb11010cef70236$export$f680877a34711e37(id);
    if (labelledBy && label) {
        var ids = new Set([
            id
        ].concat((0, _toConsumableArray._)(labelledBy.trim().split(/\s+/))));
        labelledBy = (0, _toConsumableArray._)(ids).join(" ");
    } else if (labelledBy) labelledBy = labelledBy.trim().split(/\s+/).join(" ");
    // If no labels are provided, use the default
    if (!label && !labelledBy && defaultLabel) label = defaultLabel;
    return {
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $df56164dff5785e2$export$4338b53315abf666(forwardedRef) {
    var objRef = (0, _react.useRef)(null);
    return (0, _react.useMemo)(function() {
        return {
            get current () {
                return objRef.current;
            },
            set current (value){
                objRef.current = value;
                if (typeof forwardedRef === "function") forwardedRef(value);
                else if (forwardedRef) forwardedRef.current = value;
            }
        };
    }, [
        forwardedRef
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $4f58c5f72bcf79f7$export$496315a1608d9602(effect, dependencies) {
    var isInitialMount = (0, _react.useRef)(true);
    var lastDeps = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        isInitialMount.current = true;
        return function() {
            isInitialMount.current = false;
        };
    }, []);
    (0, _react.useEffect)(function() {
        if (isInitialMount.current) isInitialMount.current = false;
        else if (!lastDeps.current || dependencies.some(function(dep, i) {
            return !Object.is(dep, lastDeps[i]);
        })) effect();
        lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}
function $9daab02d461809db$var$hasResizeObserver() {
    return typeof window.ResizeObserver !== "undefined";
}
function $9daab02d461809db$export$683480f191c0e3ea(options) {
    var ref = options.ref, onResize = options.onResize;
    (0, _react.useEffect)(function() {
        var element = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!element) return;
        if (!$9daab02d461809db$var$hasResizeObserver()) {
            window.addEventListener("resize", onResize, false);
            return function() {
                window.removeEventListener("resize", onResize, false);
            };
        } else {
            var resizeObserverInstance = new window.ResizeObserver(function(entries) {
                if (!entries.length) return;
                onResize();
            });
            resizeObserverInstance.observe(element);
            return function() {
                if (element) resizeObserverInstance.unobserve(element);
            };
        }
    }, [
        onResize,
        ref
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e7801be82b4b2a53$export$4debdb1a3f0fa79e(context, ref) {
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        if (context && context.ref && ref) {
            context.ref.current = ref.current;
            return function() {
                if (context.ref) context.ref.current = null;
            };
        }
    });
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $62d8ded9296f3872$export$cfa2225e87938781(node, checkForOverflow) {
    var scrollableNode = node;
    if ($62d8ded9296f3872$export$2bb74740c4e19def(scrollableNode, checkForOverflow)) scrollableNode = scrollableNode.parentElement;
    while(scrollableNode && !$62d8ded9296f3872$export$2bb74740c4e19def(scrollableNode, checkForOverflow))scrollableNode = scrollableNode.parentElement;
    return scrollableNode || document.scrollingElement || document.documentElement;
}
function $62d8ded9296f3872$export$2bb74740c4e19def(node, checkForOverflow) {
    var style = window.getComputedStyle(node);
    var isScrollable = /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
    if (isScrollable && checkForOverflow) isScrollable = node.scrollHeight !== node.clientHeight || node.scrollWidth !== node.clientWidth;
    return isScrollable;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // @ts-ignore
var $5df64b3807dc15ee$var$visualViewport = typeof document !== "undefined" && window.visualViewport;
function $5df64b3807dc15ee$export$d699905dd57c73ca() {
    var isSSR = (0, _ssr.useIsSSR)();
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(function() {
        return isSSR ? {
            width: 0,
            height: 0
        } : $5df64b3807dc15ee$var$getViewportSize();
    }), 2), size = _$12uGp$useState[0], setSize = _$12uGp$useState[1];
    (0, _react.useEffect)(function() {
        // Use visualViewport api to track available height even on iOS virtual keyboard opening
        var onResize = function() {
            setSize(function(size) {
                var newSize = $5df64b3807dc15ee$var$getViewportSize();
                if (newSize.width === size.width && newSize.height === size.height) return size;
                return newSize;
            });
        };
        if (!$5df64b3807dc15ee$var$visualViewport) window.addEventListener("resize", onResize);
        else $5df64b3807dc15ee$var$visualViewport.addEventListener("resize", onResize);
        return function() {
            if (!$5df64b3807dc15ee$var$visualViewport) window.removeEventListener("resize", onResize);
            else $5df64b3807dc15ee$var$visualViewport.removeEventListener("resize", onResize);
        };
    }, []);
    return size;
}
function $5df64b3807dc15ee$var$getViewportSize() {
    return {
        width: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.width) || window.innerWidth,
        height: $5df64b3807dc15ee$var$visualViewport && ($5df64b3807dc15ee$var$visualViewport === null || $5df64b3807dc15ee$var$visualViewport === void 0 ? void 0 : $5df64b3807dc15ee$var$visualViewport.height) || window.innerHeight
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $ef06256079686ba0$var$descriptionId = 0;
var $ef06256079686ba0$var$descriptionNodes = new Map();
function $ef06256079686ba0$export$f8aeda7b10753fa1(description) {
    var _$12uGp$useState = (0, _slicedToArray._)((0, _react.useState)(), 2), id = _$12uGp$useState[0], setId = _$12uGp$useState[1];
    $f0a04ccd8dbdd83b$export$e5c5a5f917a5871c(function() {
        if (!description) return;
        var desc = $ef06256079686ba0$var$descriptionNodes.get(description);
        if (!desc) {
            var id = "react-aria-description-".concat($ef06256079686ba0$var$descriptionId++);
            setId(id);
            var node = document.createElement("div");
            node.id = id;
            node.style.display = "none";
            node.textContent = description;
            document.body.appendChild(node);
            desc = {
                refCount: 0,
                element: node
            };
            $ef06256079686ba0$var$descriptionNodes.set(description, desc);
        } else setId(desc.element.id);
        desc.refCount++;
        return function() {
            if (desc && --desc.refCount === 0) {
                desc.element.remove();
                $ef06256079686ba0$var$descriptionNodes.delete(description);
            }
        };
    }, [
        description
    ]);
    return {
        "aria-describedby": description ? id : undefined
    };
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e9faafb641e167db$export$90fc3a17d93f704c(ref, event, handler, options) {
    var handleEvent = $8ae05eaa5c114e9c$export$7f54fc3180508a52(handler);
    var isDisabled = handler == null;
    (0, _react.useEffect)(function() {
        if (isDisabled || !ref.current) return;
        var element = ref.current;
        element.addEventListener(event, handleEvent, options);
        return function() {
            element.removeEventListener(event, handleEvent, options);
        };
    }, [
        ref,
        event,
        options,
        isDisabled,
        handleEvent
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollView, element) {
    var offsetX = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "left");
    var offsetY = $2f04cbc44ee30ce0$var$relativeOffset(scrollView, element, "top");
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    var x = scrollView.scrollLeft;
    var y = scrollView.scrollTop;
    // Account for top/left border offsetting the scroll top/Left
    var _getComputedStyle = getComputedStyle(scrollView), borderTopWidth = _getComputedStyle.borderTopWidth, borderLeftWidth = _getComputedStyle.borderLeftWidth;
    var borderAdjustedX = scrollView.scrollLeft + parseInt(borderLeftWidth, 10);
    var borderAdjustedY = scrollView.scrollTop + parseInt(borderTopWidth, 10);
    // Ignore end/bottom border via clientHeight/Width instead of offsetHeight/Width
    var maxX = borderAdjustedX + scrollView.clientWidth;
    var maxY = borderAdjustedY + scrollView.clientHeight;
    if (offsetX <= x) x = offsetX - parseInt(borderLeftWidth, 10);
    else if (offsetX + width > maxX) x += offsetX + width - maxX;
    if (offsetY <= borderAdjustedY) y = offsetY - parseInt(borderTopWidth, 10);
    else if (offsetY + height > maxY) y += offsetY + height - maxY;
    scrollView.scrollLeft = x;
    scrollView.scrollTop = y;
}
/**
 * Computes the offset left or top from child to ancestor by accumulating
 * offsetLeft or offsetTop through intervening offsetParents.
 */ function $2f04cbc44ee30ce0$var$relativeOffset(ancestor, child, axis) {
    var prop = axis === "left" ? "offsetLeft" : "offsetTop";
    var sum = 0;
    while(child.offsetParent){
        sum += child[prop];
        if (child.offsetParent === ancestor) break;
        else if (child.offsetParent.contains(ancestor)) {
            // If the ancestor is not `position:relative`, then we stop at
            // _its_ offset parent, and we subtract off _its_ offset, so that
            // we end up with the proper offset from child to ancestor.
            sum -= ancestor[prop];
            break;
        }
        child = child.offsetParent;
    }
    return sum;
}
function $2f04cbc44ee30ce0$export$c826860796309d1b(targetElement, opts) {
    if (document.contains(targetElement)) {
        var root = document.scrollingElement || document.documentElement;
        var isScrollPrevented = window.getComputedStyle(root).overflow === "hidden";
        // If scrolling is not currently prevented then we aren’t in a overlay nor is a overlay open, just use element.scrollIntoView to bring the element into view
        if (!isScrollPrevented) {
            var // won't cause a scroll if the element is already focused and doesn't behave consistently when an element is partially out of view horizontally vs vertically
            _targetElement_scrollIntoView;
            var _targetElement_getBoundingClientRect = targetElement.getBoundingClientRect(), originalLeft = _targetElement_getBoundingClientRect.left, originalTop = _targetElement_getBoundingClientRect.top;
            targetElement === null || targetElement === void 0 || (_targetElement_scrollIntoView = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView === void 0 || _targetElement_scrollIntoView.call(targetElement, {
                block: "nearest"
            });
            var _targetElement_getBoundingClientRect1 = targetElement.getBoundingClientRect(), newLeft = _targetElement_getBoundingClientRect1.left, newTop = _targetElement_getBoundingClientRect1.top;
            // Account for sub pixel differences from rounding
            if (Math.abs(originalLeft - newLeft) > 1 || Math.abs(originalTop - newTop) > 1) {
                var _opts_containingElement_scrollIntoView, _opts_containingElement, _targetElement_scrollIntoView1;
                opts === null || opts === void 0 || (_opts_containingElement = opts.containingElement) === null || _opts_containingElement === void 0 || (_opts_containingElement_scrollIntoView = _opts_containingElement.scrollIntoView) === null || _opts_containingElement_scrollIntoView === void 0 || _opts_containingElement_scrollIntoView.call(_opts_containingElement, {
                    block: "center",
                    inline: "center"
                });
                (_targetElement_scrollIntoView1 = targetElement.scrollIntoView) === null || _targetElement_scrollIntoView1 === void 0 || _targetElement_scrollIntoView1.call(targetElement, {
                    block: "nearest"
                });
            }
        } else {
            var scrollParent = $62d8ded9296f3872$export$cfa2225e87938781(targetElement);
            // If scrolling is prevented, we don't want to scroll the body since it might move the overlay partially offscreen and the user can't scroll it back into view.
            while(targetElement && scrollParent && targetElement !== root && scrollParent !== root){
                $2f04cbc44ee30ce0$export$53a0910f038337bd(scrollParent, targetElement);
                targetElement = scrollParent;
                scrollParent = $62d8ded9296f3872$export$cfa2225e87938781(targetElement);
            }
        }
    }
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a7db85432448f7f$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ($c87311424ea30a05$export$a11b0059900ceec8() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $6a7db85432448f7f$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !$c87311424ea30a05$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /* eslint-disable rulesdir/pure-render */ function $5a387cc49350e6db$export$722debc0e56fea39(value1, isEqual) {
    // Using a ref during render is ok here because it's only an optimization – both values are equivalent.
    // If a render is thrown away, it'll still work the same no matter if the next render is the same or not.
    var lastValue = (0, _react.useRef)(null);
    if (value1 && lastValue.current && isEqual(value1, lastValue.current)) value1 = lastValue.current;
    lastValue.current = value1;
    return value1;
}
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $99facab73266f662$export$5add1d006293d136(ref, initialValue, onReset) {
    var resetValue = (0, _react.useRef)(initialValue);
    var handleReset = $8ae05eaa5c114e9c$export$7f54fc3180508a52(function() {
        if (onReset) onReset(resetValue.current);
    });
    (0, _react.useEffect)(function() {
        var _ref_current;
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        form === null || form === void 0 || form.addEventListener("reset", handleReset);
        return function() {
            form === null || form === void 0 || form.removeEventListener("reset", handleReset);
        };
    }, [
        ref,
        handleReset
    ]);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_ts_generator":"HrSs8","@react-stately/utils":false,"react":"ktQNc","@react-aria/ssr":"5NmzK","clsx":"k6xBP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"10UOm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledState", function() {
    return $458b0a5536c1a7cf$export$40bfa8c7b0832715;
});
parcelHelpers.export(exports, "clamp", function() {
    return $9446cca9a3875146$export$7d15b64cf5a3a4c4;
});
parcelHelpers.export(exports, "snapValueToStep", function() {
    return $9446cca9a3875146$export$cb6e0bb50bc19463;
});
parcelHelpers.export(exports, "toFixedNumber", function() {
    return $9446cca9a3875146$export$b6268554fba451f;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    var _$6imuh$useState = (0, _slicedToArray._)((0, _react.useState)(value || defaultValue), 2), stateValue = _$6imuh$useState[0], setStateValue = _$6imuh$useState[1];
    var isControlledRef = (0, _react.useRef)(value !== undefined);
    var isControlled = value !== undefined;
    (0, _react.useEffect)(function() {
        var wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn("WARN: A component changed from ".concat(wasControlled ? "controlled" : "uncontrolled", " to ").concat(isControlled ? "controlled" : "uncontrolled", "."));
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var currentValue = isControlled ? value : stateValue;
    var setValue = (0, _react.useCallback)(function(value) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var onChangeCaller = function(value) {
            for(var _len = arguments.length, onChangeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                onChangeArgs[_key - 1] = arguments[_key];
            }
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange.apply(void 0, [
                    value
                ].concat((0, _toConsumableArray._)(onChangeArgs)));
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            var updateFunction = function(oldValue) {
                for(var _len = arguments.length, functionArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    functionArgs[_key - 1] = arguments[_key];
                }
                var interceptedValue = value.apply(void 0, [
                    isControlled ? currentValue : oldValue
                ].concat((0, _toConsumableArray._)(functionArgs)));
                onChangeCaller.apply(void 0, [
                    interceptedValue
                ].concat((0, _toConsumableArray._)(args)));
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller.apply(void 0, [
                value
            ].concat((0, _toConsumableArray._)(args)));
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    var newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9446cca9a3875146$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    var remainder = (value - (isNaN(min) ? 0 : min)) % step;
    var snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    var string = step.toString();
    var index = string.indexOf(".");
    var precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        var pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $9446cca9a3875146$export$b6268554fba451f(value, digits) {
    var base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5NmzK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SSRProvider", function() {
    return $b5e257d569688ac6$export$9f8ac96af4b1b2ae;
});
parcelHelpers.export(exports, "useSSRSafeId", function() {
    return $b5e257d569688ac6$export$619500959fc48b26;
});
parcelHelpers.export(exports, "useIsSSR", function() {
    return $b5e257d569688ac6$export$535bd6ca7f90a273;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
var $b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
var $b5e257d569688ac6$var$SSRContext = (0, _reactDefault.default).createContext($b5e257d569688ac6$var$defaultContext);
var $b5e257d569688ac6$var$IsSSRContext = (0, _reactDefault.default).createContext(false);
// This is only used in React < 18.
function $b5e257d569688ac6$var$LegacySSRProvider(props) {
    var cur = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    var counter = $b5e257d569688ac6$var$useCounter(cur === $b5e257d569688ac6$var$defaultContext);
    var _$73SJx$useState = (0, _slicedToArray._)((0, _react.useState)(true), 2), isSSR = _$73SJx$useState[0], setIsSSR = _$73SJx$useState[1];
    var value = (0, _react.useMemo)(function() {
        return {
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $b5e257d569688ac6$var$defaultContext ? "" : "".concat(cur.prefix, "-").concat(counter),
            current: 0
        };
    }, [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, _react.useLayoutEffect)(function() {
        setIsSSR(false);
    }, []);
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement($b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
var $b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $b5e257d569688ac6$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, _reactDefault.default)["useId"] === "function") {
        if (!$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.children);
    }
    return (0, _reactDefault.default).createElement($b5e257d569688ac6$var$LegacySSRProvider, props);
}
var $b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
var $b5e257d569688ac6$var$componentIds = new WeakMap();
function $b5e257d569688ac6$var$useCounter() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    var ref = (0, _react.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        var currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, _reactDefault.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            var prevComponentValue = $b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    var ctx = (0, _react.useContext)($b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $b5e257d569688ac6$var$defaultContext && !$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    var counter = $b5e257d569688ac6$var$useCounter(!!defaultId);
    var prefix = "react-aria".concat(ctx.prefix);
    return defaultId || "".concat(prefix, "-").concat(counter);
}
function $b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    var id = (0, _reactDefault.default).useId();
    var _$73SJx$useState = (0, _slicedToArray._)((0, _react.useState)($b5e257d569688ac6$export$535bd6ca7f90a273()), 1), didSSR = _$73SJx$useState[0];
    var prefix = didSSR || false ? "react-aria" : "react-aria".concat($b5e257d569688ac6$var$defaultContext.prefix);
    return defaultId || "".concat(prefix, "-").concat(id);
}
var $b5e257d569688ac6$export$619500959fc48b26 = typeof (0, _reactDefault.default)["useId"] === "function" ? $b5e257d569688ac6$var$useModernSSRSafeId : $b5e257d569688ac6$var$useLegacySSRSafeId;
function $b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return function() {};
}
function $b5e257d569688ac6$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, _reactDefault.default)["useSyncExternalStore"] === "function") return (0, _reactDefault.default)["useSyncExternalStore"]($b5e257d569688ac6$var$subscribe, $b5e257d569688ac6$var$getSnapshot, $b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, _react.useContext)($b5e257d569688ac6$var$IsSSRContext);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"atqUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormValidationContext", function() {
    return $e5be200c675c3b3a$export$571b5131b7e65c11;
});
parcelHelpers.export(exports, "useFormValidationState", function() {
    return $e5be200c675c3b3a$export$fc1a364ae1f3ff10;
});
parcelHelpers.export(exports, "DEFAULT_VALIDATION_RESULT", function() {
    return $e5be200c675c3b3a$export$dad6ae84456c676a;
});
parcelHelpers.export(exports, "VALID_VALIDITY_STATE", function() {
    return $e5be200c675c3b3a$export$aca958c65c314e6c;
});
parcelHelpers.export(exports, "privateValidationStateProp", function() {
    return $e5be200c675c3b3a$export$a763b9476acd3eb;
});
parcelHelpers.export(exports, "mergeValidation", function() {
    return $e5be200c675c3b3a$export$75ee7c75d68f5b0e;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e5be200c675c3b3a$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
var $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = (0, _objectSpreadProps._)((0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c), {
    customError: true,
    valid: false
});
var $e5be200c675c3b3a$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
    validationErrors: []
};
var $e5be200c675c3b3a$export$571b5131b7e65c11 = (0, _react.createContext)({});
var $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
        var _props_$e5be200c675c3b3a$export$a763b9476acd3eb = props[$e5be200c675c3b3a$export$a763b9476acd3eb], realtimeValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.realtimeValidation, displayValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.displayValidation, updateValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.updateValidation, resetValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.resetValidation, commitValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.commitValidation;
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    var isInvalid = props.isInvalid, validationState = props.validationState, name = props.name, value = props.value, builtinValidation = props.builtinValidation, validate = props.validate, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? "aria" : tmp;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    var controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    var clientError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult($e5be200c675c3b3a$var$runValidate(validate, value));
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    var serverErrors = (0, _react.useContext)($e5be200c675c3b3a$export$571b5131b7e65c11);
    var serverErrorMessages = (0, _react.useMemo)(function() {
        if (name) return Array.isArray(name) ? name.flatMap(function(name) {
            return $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        }) : $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    var _$jcIOw$useState = (0, _slicedToArray._)((0, _react.useState)(serverErrors), 2), lastServerErrors = _$jcIOw$useState[0], setLastServerErrors = _$jcIOw$useState[1];
    var _$jcIOw$useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isServerErrorCleared = _$jcIOw$useState1[0], setServerErrorCleared = _$jcIOw$useState1[1];
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    var serverError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages);
    }, [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    var nextValidation = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var _$jcIOw$useState2 = (0, _slicedToArray._)((0, _react.useState)($e5be200c675c3b3a$export$dad6ae84456c676a), 2), currentValidity = _$jcIOw$useState2[0], setCurrentValidity = _$jcIOw$useState2[1];
    var lastError = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var commitValidation = function() {
        if (!commitQueued) return;
        setCommitQueued(false);
        var error = clientError || builtinValidation || nextValidation.current;
        if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    var _$jcIOw$useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), commitQueued = _$jcIOw$useState3[0], setCommitQueued = _$jcIOw$useState3[1];
    (0, _react.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    var realtimeValidation = controlledError || serverError || clientError || builtinValidation || $e5be200c675c3b3a$export$dad6ae84456c676a;
    var displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation: function(value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation: function() {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            var error = $e5be200c675c3b3a$export$dad6ae84456c676a;
            if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation: function() {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        var e = validate(value);
        if (e && typeof e !== "boolean") return $e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every(function(a, i) {
        return a === b.validationErrors[i];
    }) && Object.entries(a.validationDetails).every(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
        return b.validationDetails[k] === v;
    });
}
function $e5be200c675c3b3a$export$75ee7c75d68f5b0e() {
    for(var _len = arguments.length, results = new Array(_len), _key = 0; _key < _len; _key++){
        results[_key] = arguments[_key];
    }
    var errors = new Set();
    var isInvalid = false;
    var validationDetails = (0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            var _validationDetails, _key1;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = v.validationErrors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e = _step1.value;
                    errors.add(e);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Only these properties apply for checkboxes.
            isInvalid || (isInvalid = v.isInvalid);
            for(var key in validationDetails)(_validationDetails = validationDetails)[_key1 = key] || (_validationDetails[_key1] = v.validationDetails[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: (0, _toConsumableArray._)(errors),
        validationDetails: validationDetails
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eQXBq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggle", function() {
    return $d2c8e2b0480f3f34$export$cbe85ee05b554577;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _interactions = require("@react-aria/interactions");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d2c8e2b0480f3f34$export$cbe85ee05b554577(props, state, ref) {
    var tmp = props.isDisabled, isDisabled = tmp === void 0 ? false : tmp, tmp1 = props.isReadOnly, isReadOnly = tmp1 === void 0 ? false : tmp1, value = props.value, name = props.name, children = props.children, ariaLabel = props["aria-label"], ariaLabelledby = props["aria-labelledby"], tmp2 = props.validationState, validationState = tmp2 === void 0 ? "valid" : tmp2, isInvalid = props.isInvalid;
    var onChange = function(e) {
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    var hasChildren = children != null;
    var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    // This handles focusing the input on pointer down, which Safari does not do by default.
    var _$7CUUz$usePress = (0, _interactions.usePress)({
        isDisabled: isDisabled
    }), pressProps = _$7CUUz$usePress.pressProps, isPressed = _$7CUUz$usePress.isPressed;
    // iOS does not toggle checkboxes if you drag off and back onto the label, so handle it ourselves.
    var _$7CUUz$usePress1 = (0, _interactions.usePress)({
        isDisabled: isDisabled || isReadOnly,
        onPress: function() {
            state.toggle();
        }
    }), labelProps = _$7CUUz$usePress1.pressProps, isLabelPressed = _$7CUUz$usePress1.isPressed;
    var _$7CUUz$useFocusable = (0, _focus.useFocusable)(props, ref), focusableProps = _$7CUUz$useFocusable.focusableProps;
    var interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    var domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    (0, _utils.useFormReset)(ref, state.isSelected, state.setSelected);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, {
            onClick: function(e) {
                return e.preventDefault();
            }
        }),
        inputProps: (0, _utils.mergeProps)(domProps, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({
            "aria-invalid": isInvalid || validationState === "invalid" || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-controls": props["aria-controls"],
            "aria-readonly": isReadOnly || undefined,
            onChange: onChange,
            disabled: isDisabled
        }, value == null ? {} : {
            value: value
        }), {
            name: name,
            type: "checkbox"
        }), interactions)),
        isSelected: state.isSelected,
        isPressed: isPressed || isLabelPressed,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly,
        isInvalid: isInvalid || validationState === "invalid"
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@react-aria/utils":"jTQk5","@react-aria/focus":"9EVEm","@react-aria/interactions":"kSKDi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9EVEm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusScope", function() {
    return $9bf71ea28793e738$export$20e40289641fbbb6;
});
parcelHelpers.export(exports, "useFocusManager", function() {
    return $9bf71ea28793e738$export$10c5169755ce7bd7;
});
parcelHelpers.export(exports, "getFocusableTreeWalker", function() {
    return $9bf71ea28793e738$export$2d6ec8fc375ceafa;
});
parcelHelpers.export(exports, "createFocusManager", function() {
    return $9bf71ea28793e738$export$c5251b9e124bf29;
});
parcelHelpers.export(exports, "isElementInChildOfActiveScope", function() {
    return $9bf71ea28793e738$export$1258395f99bf9cbf;
});
parcelHelpers.export(exports, "FocusRing", function() {
    return $907718708eab68af$export$1a38b4ad7f578e1d;
});
parcelHelpers.export(exports, "FocusableProvider", function() {
    return $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5;
});
parcelHelpers.export(exports, "useFocusable", function() {
    return $e6afbd83fe6ebbd2$export$4c014de7c8940b4c;
});
parcelHelpers.export(exports, "useFocusRing", function() {
    return $f7dceffc5ad7768b$export$4e328f61c538687f;
});
parcelHelpers.export(exports, "focusSafely", function() {
    return $6a99195332edec8b$export$80f3e147d781571c;
});
parcelHelpers.export(exports, "useHasTabbableChild", function() {
    return $83013635b024ae3d$export$eac1895992b9f3d6;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $6a99195332edec8b$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    var ownerDocument = (0, _utils.getOwnerDocument)(element);
    if ((0, _interactions.getInteractionModality)() === "virtual") {
        var lastFocusedElement = ownerDocument.activeElement;
        (0, _utils.runAfterTransition)(function() {
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, _utils.focusWithoutScrolling)(element);
        });
    } else (0, _utils.focusWithoutScrolling)(element);
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $645f2e67b85a24c9$var$isStyleVisible(element) {
    var windowObject = (0, _utils.getOwnerWindow)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    var _element_style = element.style, display = _element_style.display, visibility = _element_style.visibility;
    var isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        var _element_ownerDocument_defaultView = element.ownerDocument.defaultView, getComputedStyle = _element_ownerDocument_defaultView.getComputedStyle;
        var _getComputedStyle = getComputedStyle(element), computedDisplay = _getComputedStyle.display, computedVisibility = _getComputedStyle.visibility;
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $645f2e67b85a24c9$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $645f2e67b85a24c9$var$isStyleVisible(element) && $645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $645f2e67b85a24c9$export$e989c0fffaa6b27a(element.parentElement, element));
}
var $9bf71ea28793e738$var$FocusContext = (0, _reactDefault.default).createContext(null);
var $9bf71ea28793e738$var$activeScope = null;
function $9bf71ea28793e738$export$20e40289641fbbb6(props) {
    var children = props.children, contain = props.contain, restoreFocus = props.restoreFocus, autoFocus = props.autoFocus;
    var startRef = (0, _react.useRef)(null);
    var endRef = (0, _react.useRef)(null);
    var scopeRef = (0, _react.useRef)([]);
    var _ref = (0, _react.useContext)($9bf71ea28793e738$var$FocusContext) || {}, parentNode = _ref.parentNode;
    // Create a tree node here so we can add children to it even before it is added to the tree.
    var node = (0, _react.useMemo)(function() {
        return new $9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
    }, [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(function() {
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        var parent = parentNode || $9bf71ea28793e738$export$d06fae2ee68b101e.root;
        if ($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $9bf71ea28793e738$var$activeScope && !$9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            var activeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $9bf71ea28793e738$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var node = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        var node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        var nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, _react.useEffect)(function() {
        var activeElement = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        var scope = null;
        if ($9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // We need to traverse the focusScope tree and find the bottom most scope that
                // contains the active element and set that as the activeScope.
                for(var _iterator = $9bf71ea28793e738$export$d06fae2ee68b101e.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (node.scopeRef && $9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (scope === $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            var parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope(scopeRef, $9bf71ea28793e738$var$activeScope)) && (!parentScope || $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(parentScope))) $9bf71ea28793e738$var$activeScope = parentScope;
            $9bf71ea28793e738$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    var focusManager = (0, _react.useMemo)(function() {
        return $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef);
    }, []);
    var value = (0, _react.useMemo)(function() {
        return {
            focusManager: focusManager,
            parentNode: node
        };
    }, [
        node,
        focusManager
    ]);
    return (0, _reactDefault.default).createElement($9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, _reactDefault.default).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $9bf71ea28793e738$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, _react.useContext)($9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[0].previousElementSibling;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var from = opts.from, tabbable = opts.tabbable, wrap = opts.wrap, accept = opts.accept;
            var node = from || (0, _utils.getOwnerDocument)(scope[0]).activeElement;
            var sentinel = scope[scope.length - 1].nextElementSibling;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            var nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var scope = scopeRef.current;
            var tabbable = opts.tabbable, accept = opts.accept;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            var previousNode = walker.previousNode();
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
var $9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
var $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
var $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    var scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    var focusedNode = (0, _react.useRef)();
    var raf = (0, _react.useRef)();
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            var focusedElement = ownerDocument.activeElement;
            var scope = scopeRef.current;
            if (!scope || !$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        var onFocus = function(e) {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($9bf71ea28793e738$var$activeScope && $9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
            } else if ($9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        var onBlur = function(e) {
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(function() {
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($9bf71ea28793e738$var$activeScope.current) $9bf71ea28793e738$var$focusFirstInScope($9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusout", onBlur, false);
        });
        return function() {
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusout", onBlur, false);
            });
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        return function() {
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element);
}
function $9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some(function(node) {
        return node.contains(element);
    });
}
function $9bf71ea28793e738$var$isElementInChildScope(element) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // node.contains in isElementInScope covers child scopes that are also DOM children,
        // but does not cover child scopes in portals.
        for(var _iterator = $9bf71ea28793e738$export$d06fae2ee68b101e.traverse($9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, s = _step_value.scopeRef;
            if (s && $9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $9bf71ea28793e738$export$1258395f99bf9cbf(element) {
    return $9bf71ea28793e738$var$isElementInChildScope(element, $9bf71ea28793e738$var$activeScope);
}
function $9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    var parent = (_focusScopeTree_getTreeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $9bf71ea28793e738$var$focusElement(element) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (element != null && !scroll) try {
        $6a99195332edec8b$export$80f3e147d781571c(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $9bf71ea28793e738$var$focusFirstInScope(scope) {
    var tabbable = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var sentinel = scope[0].previousElementSibling;
    var scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
    var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    var nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $9bf71ea28793e738$var$focusElement(nextNode);
}
function $9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    var autoFocusRef = (0, _reactDefault.default).useRef(autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current) {
            $9bf71ea28793e738$var$activeScope = scopeRef;
            var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, _utils.useLayoutEffect)(function() {
        if (restore || contain) return;
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        var onFocus = function(e) {
            var target = e.target;
            if ($9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$9bf71ea28793e738$var$isElementInAnyScope(target)) $9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    var scope = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode($9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    var nodeToRestoreRef = (0, _react.useRef)(typeof document !== "undefined" ? (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, _utils.useLayoutEffect)(function() {
        var scope = scopeRef.current;
        var ownerDocument = (0, _utils.getOwnerDocument)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        var onFocus = function() {
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$9bf71ea28793e738$var$activeScope || $9bf71ea28793e738$var$isAncestorScope($9bf71ea28793e738$var$activeScope, scopeRef)) && $9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach(function(element) {
            return element.addEventListener("focusin", onFocus, false);
        });
        return function() {
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach(function(element) {
                return element.removeEventListener("focusin", onFocus, false);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        var onKeyDown = function(e) {
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) return;
            var focusedElement = ownerDocument.activeElement;
            if (!$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return function() {
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, _utils.useLayoutEffect)(function() {
        var ownerDocument = (0, _utils.getOwnerDocument)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return function() {
            var treeNode = $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            var nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                var clonedTree = $9bf71ea28793e738$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(function() {
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        var treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $9bf71ea28793e738$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, opts, scope) {
    var selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    var walker = (0, _utils.getOwnerDocument)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode: function(node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && $645f2e67b85a24c9$export$e989c0fffaa6b27a(node) && (!scope || $9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $9bf71ea28793e738$export$c5251b9e124bf29(ref) {
    var defaultOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        focusNext: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            var nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var from = opts.from, tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.wrap, wrap = tmp1 === void 0 ? defaultOptions.wrap : tmp1, tmp2 = opts.accept, accept = tmp2 === void 0 ? defaultOptions.accept : tmp2;
            var node = from || (0, _utils.getOwnerDocument)(root).activeElement;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                var next = $9bf71ea28793e738$var$last(walker);
                if (next) $9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            var previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                var lastNode = $9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var nextNode = walker.nextNode();
            if (nextNode) $9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast: function() {
            var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultOptions;
            var root = ref.current;
            if (!root) return null;
            var tmp = opts.tabbable, tabbable = tmp === void 0 ? defaultOptions.tabbable : tmp, tmp1 = opts.accept, accept = tmp1 === void 0 ? defaultOptions.accept : tmp1;
            var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            var next = $9bf71ea28793e738$var$last(walker);
            if (next) $9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $9bf71ea28793e738$var$last(walker) {
    var next = undefined;
    var last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
var $9bf71ea28793e738$var$Tree = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$Tree() {
        (0, _classCallCheck._)(this, $9bf71ea28793e738$var$Tree);
        this.fastMap = new Map();
        this.root = new $9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
    (0, _createClass._)($9bf71ea28793e738$var$Tree, [
        {
            key: "size",
            get: function get() {
                return this.fastMap.size;
            }
        },
        {
            key: "getTreeNode",
            value: function getTreeNode(data) {
                return this.fastMap.get(data);
            }
        },
        {
            key: "addTreeNode",
            value: function addTreeNode(scopeRef, parent, nodeToRestore) {
                var parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
                if (!parentNode) return;
                var node = new $9bf71ea28793e738$var$TreeNode({
                    scopeRef: scopeRef
                });
                parentNode.addChild(node);
                node.parent = parentNode;
                this.fastMap.set(scopeRef, node);
                if (nodeToRestore) node.nodeToRestore = nodeToRestore;
            }
        },
        {
            key: "addNode",
            value: function addNode(node) {
                this.fastMap.set(node.scopeRef, node);
            }
        },
        {
            key: "removeTreeNode",
            value: function removeTreeNode(scopeRef) {
                // never remove the root
                if (scopeRef === null) return;
                var node = this.fastMap.get(scopeRef);
                if (!node) return;
                var parentNode = node.parent;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
                    // if we are, then replace the siblings restore with the restore from the scope we're removing
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var current = _step.value;
                        if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var children = node.children;
                if (parentNode) {
                    parentNode.removeChild(node);
                    if (children.size > 0) children.forEach(function(child) {
                        return parentNode && parentNode.addChild(child);
                    });
                }
                this.fastMap.delete(node.scopeRef);
            }
        },
        {
            key: "traverse",
            value: // Pre Order Depth First
            function traverse() {
                var node, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child, err;
                var _arguments = arguments;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            node = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : this.root;
                            if (!(node.scopeRef != null)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                node
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!(node.children.size > 0)) return [
                                3,
                                10
                            ];
                            _state.label = 3;
                        case 3:
                            _state.trys.push([
                                3,
                                8,
                                9,
                                10
                            ]);
                            _iterator = node.children[Symbol.iterator]();
                            _state.label = 4;
                        case 4:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                7
                            ];
                            child = _step.value;
                            return [
                                5,
                                (0, _tsValues._)(this.traverse(child))
                            ];
                        case 5:
                            _state.sent();
                            _state.label = 6;
                        case 6:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                4
                            ];
                        case 7:
                            return [
                                3,
                                10
                            ];
                        case 8:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                10
                            ];
                        case 9:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 10:
                            return [
                                2
                            ];
                    }
                });
            }
        },
        {
            key: "clone",
            value: function clone() {
                var _node_parent;
                var newTree = new $9bf71ea28793e738$var$Tree();
                var _node_parent_scopeRef;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.traverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return newTree;
            }
        }
    ]);
    return $9bf71ea28793e738$var$Tree;
}();
var $9bf71ea28793e738$var$TreeNode = /*#__PURE__*/ function() {
    "use strict";
    function $9bf71ea28793e738$var$TreeNode(props) {
        (0, _classCallCheck._)(this, $9bf71ea28793e738$var$TreeNode);
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
    (0, _createClass._)($9bf71ea28793e738$var$TreeNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.children.add(node);
                node.parent = this;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.children.delete(node);
                node.parent = undefined;
            }
        }
    ]);
    return $9bf71ea28793e738$var$TreeNode;
}();
var $9bf71ea28793e738$export$d06fae2ee68b101e = new $9bf71ea28793e738$var$Tree();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $f7dceffc5ad7768b$export$4e328f61c538687f() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = props.autoFocus, autoFocus = tmp === void 0 ? false : tmp, isTextInput = props.isTextInput, within = props.within;
    var state = (0, _react.useRef)({
        isFocused: false,
        isFocusVisible: autoFocus || (0, _interactions.isFocusVisible)()
    });
    var _$6nfFC$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _$6nfFC$useState[0], setFocused = _$6nfFC$useState[1];
    var _$6nfFC$useState1 = (0, _slicedToArray._)((0, _react.useState)(function() {
        return state.current.isFocused && state.current.isFocusVisible;
    }), 2), isFocusVisibleState = _$6nfFC$useState1[0], setFocusVisible = _$6nfFC$useState1[1];
    var updateState = (0, _react.useCallback)(function() {
        return setFocusVisible(state.current.isFocused && state.current.isFocusVisible);
    }, []);
    var onFocusChange = (0, _react.useCallback)(function(isFocused) {
        state.current.isFocused = isFocused;
        setFocused(isFocused);
        updateState();
    }, [
        updateState
    ]);
    (0, _interactions.useFocusVisibleListener)(function(isFocusVisible) {
        state.current.isFocusVisible = isFocusVisible;
        updateState();
    }, [], {
        isTextInput: isTextInput
    });
    var _$6nfFC$useFocus = (0, _interactions.useFocus)({
        isDisabled: within,
        onFocusChange: onFocusChange
    }), focusProps = _$6nfFC$useFocus.focusProps;
    var _$6nfFC$useFocusWithin = (0, _interactions.useFocusWithin)({
        isDisabled: !within,
        onFocusWithinChange: onFocusChange
    }), focusWithinProps = _$6nfFC$useFocusWithin.focusWithinProps;
    return {
        isFocused: isFocused,
        isFocusVisible: isFocusVisibleState,
        focusProps: within ? focusWithinProps : focusProps
    };
}
function $907718708eab68af$export$1a38b4ad7f578e1d(props) {
    var children = props.children, focusClass = props.focusClass, focusRingClass = props.focusRingClass;
    var _$f7dceffc5ad7768b$export$4e328f61c538687f = $f7dceffc5ad7768b$export$4e328f61c538687f(props), isFocused = _$f7dceffc5ad7768b$export$4e328f61c538687f.isFocused, isFocusVisible = _$f7dceffc5ad7768b$export$4e328f61c538687f.isFocusVisible, focusProps = _$f7dceffc5ad7768b$export$4e328f61c538687f.focusProps;
    var child = (0, _reactDefault.default).Children.only(children);
    var _obj;
    return (0, _reactDefault.default).cloneElement(child, (0, _utils.mergeProps)(child.props, (0, _objectSpreadProps._)((0, _objectSpread._)({}, focusProps), {
        className: (0, _clsxDefault.default)((_obj = {}, (0, _defineProperty._)(_obj, focusClass || "", isFocused), (0, _defineProperty._)(_obj, focusRingClass || "", isFocusVisible), _obj))
    })));
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e6afbd83fe6ebbd2$var$FocusableContext = (0, _reactDefault.default).createContext(null);
function $e6afbd83fe6ebbd2$var$useFocusableContext(ref) {
    var context = (0, _react.useContext)($e6afbd83fe6ebbd2$var$FocusableContext) || {};
    (0, _utils.useSyncRef)(context, ref);
    // eslint-disable-next-line
    var _ = context.ref, otherProps = (0, _objectWithoutProperties._)(context, [
        "ref"
    ]);
    return otherProps;
}
/**
 * Provides DOM props to the nearest focusable child.
 */ function $e6afbd83fe6ebbd2$var$FocusableProvider(props, ref) {
    var children = props.children, otherProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    var objRef = (0, _utils.useObjectRef)(ref);
    var context = (0, _objectSpreadProps._)((0, _objectSpread._)({}, otherProps), {
        ref: objRef
    });
    return (0, _reactDefault.default).createElement($e6afbd83fe6ebbd2$var$FocusableContext.Provider, {
        value: context
    }, children);
}
var $e6afbd83fe6ebbd2$export$13f3202a3e5ddd5 = (0, _reactDefault.default).forwardRef($e6afbd83fe6ebbd2$var$FocusableProvider);
function $e6afbd83fe6ebbd2$export$4c014de7c8940b4c(props, domRef) {
    var _$6nfFC$useFocus = (0, _interactions.useFocus)(props), focusProps = _$6nfFC$useFocus.focusProps;
    var _$6nfFC$useKeyboard = (0, _interactions.useKeyboard)(props), keyboardProps = _$6nfFC$useKeyboard.keyboardProps;
    var interactions = (0, _utils.mergeProps)(focusProps, keyboardProps);
    var domProps = $e6afbd83fe6ebbd2$var$useFocusableContext(domRef);
    var interactionProps = props.isDisabled ? {} : domProps;
    var autoFocusRef = (0, _react.useRef)(props.autoFocus);
    (0, _react.useEffect)(function() {
        if (autoFocusRef.current && domRef.current) $6a99195332edec8b$export$80f3e147d781571c(domRef.current);
        autoFocusRef.current = false;
    }, [
        domRef
    ]);
    return {
        focusableProps: (0, _utils.mergeProps)((0, _objectSpreadProps._)((0, _objectSpread._)({}, interactions), {
            tabIndex: props.excludeFromTabOrder && !props.isDisabled ? -1 : undefined
        }), interactionProps)
    };
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $83013635b024ae3d$export$eac1895992b9f3d6(ref, options) {
    var isDisabled = options === null || options === void 0 ? void 0 : options.isDisabled;
    var _$6nfFC$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hasTabbableChild = _$6nfFC$useState[0], setHasTabbableChild = _$6nfFC$useState[1];
    (0, _utils.useLayoutEffect)(function() {
        if ((ref === null || ref === void 0 ? void 0 : ref.current) && !isDisabled) {
            var update = function() {
                if (ref.current) {
                    var walker = $9bf71ea28793e738$export$2d6ec8fc375ceafa(ref.current, {
                        tabbable: true
                    });
                    setHasTabbableChild(!!walker.nextNode());
                }
            };
            update();
            // Update when new elements are inserted, or the tabIndex/disabled attribute updates.
            var observer = new MutationObserver(update);
            observer.observe(ref.current, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeFilter: [
                    "tabIndex",
                    "disabled"
                ]
            });
            return function() {
                // Disconnect mutation observer when a React update occurs on the top-level component
                // so we update synchronously after re-rendering. Otherwise React will emit act warnings
                // in tests since mutation observers fire asynchronously. The mutation observer is necessary
                // so we also update if a child component re-renders and adds/removes something tabbable.
                observer.disconnect();
            };
        }
    });
    return isDisabled ? false : hasTabbableChild;
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_ts_generator":"HrSs8","@swc/helpers/_/_ts_values":"3HUTY","@react-aria/utils":"jTQk5","react":"ktQNc","@react-aria/interactions":"kSKDi","clsx":"k6xBP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fvVMI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useField", function() {
    return $2baaea4c71418dea$export$294aa081a6c6f55d;
});
parcelHelpers.export(exports, "useLabel", function() {
    return $d191a55c9702f145$export$8467354a121f1b9f;
});
var _utils = require("@react-aria/utils");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d191a55c9702f145$export$8467354a121f1b9f(props) {
    var id = props.id, label = props.label, ariaLabelledby = props["aria-labelledby"], ariaLabel = props["aria-label"], tmp = props.labelElementType, labelElementType = tmp === void 0 ? "label" : tmp;
    id = (0, _utils.useId)(id);
    var labelId = (0, _utils.useId)();
    var labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? "".concat(labelId, " ").concat(ariaLabelledby) : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    var fieldProps = (0, _utils.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
    var description = props.description, errorMessage = props.errorMessage, isInvalid = props.isInvalid, validationState = props.validationState;
    var _$d191a55c9702f145$export$8467354a121f1b9f = $d191a55c9702f145$export$8467354a121f1b9f(props), labelProps = _$d191a55c9702f145$export$8467354a121f1b9f.labelProps, fieldProps = _$d191a55c9702f145$export$8467354a121f1b9f.fieldProps;
    var descriptionId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    var errorMessageId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, _utils.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

},{"@react-aria/utils":"jTQk5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a43G4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useToggleState", function() {
    return $3017fa7ffdddec74$export$8042c6c013fd5226;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@react-stately/utils");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $3017fa7ffdddec74$export$8042c6c013fd5226() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var isReadOnly = props.isReadOnly;
    // have to provide an empty function so useControlledState doesn't throw a fit
    // can't use useControlledState's prop calling because we need the event object from the change
    var _$bOkae$useControlledState = (0, _slicedToArray._)((0, _utils.useControlledState)(props.isSelected, props.defaultSelected || false, props.onChange), 2), isSelected = _$bOkae$useControlledState[0], setSelected = _$bOkae$useControlledState[1];
    function updateSelected(value) {
        if (!isReadOnly) setSelected(value);
    }
    function toggleState() {
        if (!isReadOnly) setSelected(!isSelected);
    }
    return {
        isSelected: isSelected,
        setSelected: updateSelected,
        toggle: toggleState
    };
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@react-stately/utils":"10UOm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bs06L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisuallyHidden", function() {
    return $5c3e21d68f1c4674$export$a966af930f325cab;
});
parcelHelpers.export(exports, "VisuallyHidden", function() {
    return $5c3e21d68f1c4674$export$439d29a4e110a164;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $5c3e21d68f1c4674$var$styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function $5c3e21d68f1c4674$export$a966af930f325cab() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var style = props.style, isFocusable = props.isFocusable;
    var _$9BxnE$useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _$9BxnE$useState[0], setFocused = _$9BxnE$useState[1];
    var _$9BxnE$useFocusWithin = (0, _interactions.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: function(val) {
            return setFocused(val);
        }
    }), focusWithinProps = _$9BxnE$useFocusWithin.focusWithinProps;
    // If focused, don't hide the element.
    var combinedStyles = (0, _react.useMemo)(function() {
        if (isFocused) return style;
        else if (style) return (0, _objectSpread._)({}, $5c3e21d68f1c4674$var$styles, style);
        else return $5c3e21d68f1c4674$var$styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, focusWithinProps), {
            style: combinedStyles
        })
    };
}
function $5c3e21d68f1c4674$export$439d29a4e110a164(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var children = props.children, tmp = props.elementType, Element = tmp === void 0 ? "div" : tmp, isFocusable = props.isFocusable, style = props.style, otherProps = (0, _objectWithoutProperties._)(props, [
        "children",
        "elementType",
        "isFocusable",
        "style"
    ]);
    var _$5c3e21d68f1c4674$export$a966af930f325cab = $5c3e21d68f1c4674$export$a966af930f325cab(props), visuallyHiddenProps = _$5c3e21d68f1c4674$export$a966af930f325cab.visuallyHiddenProps;
    return (0, _reactDefault.default).createElement(Element, (0, _utils.mergeProps)(otherProps, visuallyHiddenProps), children);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@react-aria/utils":"99Fak","react":"ktQNc","@react-aria/interactions":"7Ysj1","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lf5Pn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCheckbox", function() {
    return StyledCheckbox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  display: flex;\n  position: relative;\n  width: fit-content;\n\n  &.disabled {\n    cursor: not-allowed;\n  }\n\n  &.inline {\n    display: inline-block;\n  }\n\n  &:not(.disabled) {\n    cursor: pointer;\n\n    &:hover,\n    &.checked .checkboxSquare {\n      color: ",
        ";\n    }\n  }\n\n  &.checked .checkboxSquare {\n    fill: ",
        ";\n  }\n\n  transition: color ",
        " ",
        ";\n\n  .checkbox {\n    width: ",
        ";\n    height: ",
        ";\n\n    margin-top: 2px;\n  }\n\n  .checkbox__text {\n    margin-left: ",
        ";\n  }\n  .checkboxSquare {\n    stroke-width: 2.5;\n  }\n\n  .checkmark {\n    color: ",
        ";\n    pointer-events: none;\n  }\n\n  .focusRing {\n    stroke: ",
        ";\n    stroke-width: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var boxSize = "17px";
var StyledCheckbox = (0, _styledComponentsDefault.default).label(_templateObject(), function(props) {
    return props.$color;
}, function(props) {
    return props.$color;
}, function(props) {
    return props.$color;
}, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, boxSize, boxSize, (0, _index.SPACING).sm, function(props) {
    return props.$checkmarkColor;
}, (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5FaIf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", function() {
    return DatePicker;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _focusTrapReact = require("focus-trap-react");
var _focusTrapReactDefault = parcelHelpers.interopDefault(_focusTrapReact);
var _reactDayPicker = require("react-day-picker");
var _reactPopper = require("react-popper");
var _index = require("Permafrost/index");
var _datePickerStyles = require("./DatePicker.styles");
var DatePicker = function(props) {
    var ariaLabel = props.ariaLabel, className = props.className, disabled = props.disabled, disableBeforeDate = props.disableBeforeDate, disableAfterDate = props.disableAfterDate, id = props.id, label = props.label, onChange = props.onChange, placeholder = props.placeholder, value = props.value, selected = props.selected, _props_shouldShowDatePicker = props.shouldShowDatePicker, shouldShowDatePicker = _props_shouldShowDatePicker === void 0 ? true : _props_shouldShowDatePicker;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(selected || undefined), 2), localSelected = _useState[0], setLocalSelected = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(value) ? (0, _dateFns.format)(value, "y-MM-dd") : ""), 2), inputValue = _useState1[0], setInputValue = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPopperOpen = _useState2[0], setIsPopperOpen = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), popperElement = _useState3[0], setPopperElement = _useState3[1];
    var popperRef = (0, _react.useRef)(null);
    var popper = (0, _reactPopper.usePopper)(popperRef.current, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        10
                    ]
                }
            }
        ]
    });
    var inputRef = (0, _react.useRef)(null);
    var closePopper = function() {
        setIsPopperOpen(false);
    };
    // TODO -- After discussing with product, we determined handling invalid would happen at a later date.
    var handleInputChange = function(e) {
        setInputValue(e.currentTarget.value);
        var date = (0, _dateFns.parse)(e.currentTarget.value, "y-MM-dd", new Date());
        if ((0, _dateFns.isValid)(date)) {
            setLocalSelected(date);
            onChange(date);
        } else if (e.currentTarget.value === "") {
            setLocalSelected(undefined);
            setInputValue("");
            onChange(undefined);
        } else setLocalSelected(undefined);
    };
    var handleDaySelect = function(date) {
        setLocalSelected(date);
        if (date) {
            setInputValue((0, _dateFns.format)(date, "y-MM-dd"));
            onChange(date);
            closePopper();
        } else {
            setInputValue("");
            onChange(date);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _datePickerStyles.StyledDatePicker), {
        className: className,
        "aria-label": ariaLabel || "date select",
        "aria-describedby": "picker-label--".concat(id),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        id: id,
        children: [
            label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "picker-label--".concat(id),
                className: "datepicker-label",
                children: label
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: popperRef,
                className: "datepicker--inputParent",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        "data-testid": "datepicker-input-".concat(id),
                        disabled: disabled,
                        type: "text",
                        placeholder: placeholder || (0, _dateFns.format)(new Date(), "y-MM-dd"),
                        value: inputValue,
                        onChange: handleInputChange,
                        className: "datepicker--input",
                        onClick: function() {
                            if (shouldShowDatePicker) setIsPopperOpen(!isPopperOpen);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), {
                        className: "remove-btn",
                        "data-testid": "button-remove-date-value",
                        iconName: "x-close",
                        onPress: function() {
                            closePopper();
                            setInputValue("");
                            setLocalSelected(undefined);
                            onChange(undefined);
                        }
                    })
                ]
            }),
            isPopperOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusTrapReactDefault.default), {
                active: true,
                focusTrapOptions: {
                    initialFocus: false,
                    allowOutsideClick: true,
                    clickOutsideDeactivates: true,
                    onDeactivate: closePopper,
                    fallbackFocus: inputRef.current || undefined
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                    tabIndex: -1,
                    style: popper.styles.popper,
                    className: "DayPickerInput-Overlay"
                }, popper.attributes.popper), {
                    ref: setPopperElement,
                    role: "dialog",
                    "aria-label": "DayPicker calendar",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDayPicker.DayPicker), {
                        disabled: disabled,
                        mode: "single",
                        defaultMonth: localSelected,
                        selected: localSelected,
                        onSelect: handleDaySelect,
                        fromDate: disableBeforeDate,
                        toDate: disableAfterDate
                    })
                }))
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","date-fns":"5C5dq","focus-trap-react":"2xNzg","react-day-picker":"iTJs9","react-popper":"k2Ltv","Permafrost/index":"iliLC","./DatePicker.styles":"dDS18","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2xNzg":[function(require,module,exports) {
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var React = require("d7b04d8f9f20b95f");
var PropTypes = require("9fc195b8a681ab95");
var _require = require("6fa143c951e963da"), createFocusTrap = _require.createFocusTrap;
var _require2 = require("d6b4353ef35ec620"), isFocusable = _require2.isFocusable;
var FocusTrap = /*#__PURE__*/ function(_React$Component) {
    _inherits(FocusTrap, _React$Component);
    var _super = _createSuper(FocusTrap);
    function FocusTrap(props) {
        var _this;
        _classCallCheck(this, FocusTrap);
        _this = _super.call(this, props);
        /**
     * Gets the node for the given option, which is expected to be an option that
     *  can be either a DOM node, a string that is a selector to get a node, `false`
     *  (if a node is explicitly NOT given), or a function that returns any of these
     *  values.
     * @param {string} optionName
     * @returns {undefined | false | HTMLElement | SVGElement} Returns
     *  `undefined` if the option is not specified; `false` if the option
     *  resolved to `false` (node explicitly not given); otherwise, the resolved
     *  DOM node.
     * @throws {Error} If the option is set, not `false`, and is not, or does not
     *  resolve to a node.
     */ _defineProperty(_assertThisInitialized(_this), "getNodeForOption", function(optionName) {
            var _this$internalOptions;
            // use internal options first, falling back to original options
            var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
            if (typeof optionValue === "function") {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                optionValue = optionValue.apply(void 0, params);
            }
            if (optionValue === true) optionValue = undefined; // use default value
            if (!optionValue) {
                if (optionValue === undefined || optionValue === false) return optionValue;
                // else, empty string (invalid), null (invalid), 0 (invalid)
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
            }
            var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
            if (typeof optionValue === "string") {
                var _this$getDocument;
                node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
                if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
            return node;
        });
        _this.handleDeactivate = _this.handleDeactivate.bind(_assertThisInitialized(_this));
        _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_assertThisInitialized(_this));
        _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_assertThisInitialized(_this));
        // focus-trap options used internally when creating the trap
        _this.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: false,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: _this.handleDeactivate,
            onPostDeactivate: _this.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: _this.handleClickOutsideDeactivates
        };
        // original options provided by the consumer
        _this.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: true,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: false
        };
        var focusTrapOptions = props.focusTrapOptions;
        for(var optionName in focusTrapOptions){
            if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) continue;
            if (optionName === "returnFocusOnDeactivate" || optionName === "onDeactivate" || optionName === "onPostDeactivate" || optionName === "checkCanReturnFocus" || optionName === "clickOutsideDeactivates") {
                _this.originalOptions[optionName] = focusTrapOptions[optionName];
                continue; // exclude from internalOptions
            }
            _this.internalOptions[optionName] = focusTrapOptions[optionName];
        }
        // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
        //  node that was clicked, and `allowDeactivation` is the result of the consumer's
        //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
        //  function) whether to allow or deny auto-deactivation on click on this outside node
        _this.outsideClick = null;
        // elements from which to create the focus trap on mount; if a child is used
        //  instead of the `containerElements` prop, we'll get the child's related
        //  element when the trap renders and then is declared 'mounted'
        _this.focusTrapElements = props.containerElements || [];
        // now we remember what the currently focused element is, not relying on focus-trap
        _this.updatePreviousElement();
        return _this;
    }
    /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */ _createClass(FocusTrap, [
        {
            key: "getDocument",
            value: function getDocument() {
                // SSR: careful to check if `document` exists before accessing it as a variable
                return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : undefined);
            }
        },
        {
            key: "getReturnFocusNode",
            value: function getReturnFocusNode() {
                var node = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
                return node ? node : node === false ? false : this.previouslyFocusedElement;
            }
        },
        {
            key: "updatePreviousElement",
            value: function updatePreviousElement() {
                var currentDocument = this.getDocument();
                if (currentDocument) this.previouslyFocusedElement = currentDocument.activeElement;
            }
        },
        {
            key: "deactivateTrap",
            value: function deactivateTrap() {
                // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
                //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
                //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
                //  will initiate its auto-deactivation process, which will call our own
                //  handleDeactivate(), which will call into this method
                if (!this.focusTrap || !this.focusTrap.active) return;
                this.focusTrap.deactivate({
                    // NOTE: we never let the trap return the focus since we do that ourselves
                    returnFocus: false,
                    // we'll call this in our own post deactivate handler so make sure the trap doesn't
                    //  do it prematurely
                    checkCanReturnFocus: null,
                    // let it call the user's original deactivate handler, if any, instead of
                    //  our own which calls back into this function
                    onDeactivate: this.originalOptions.onDeactivate
                });
            }
        },
        {
            key: "handleClickOutsideDeactivates",
            value: function handleClickOutsideDeactivates(event) {
                // use consumer's option (or call their handler) as the permission or denial
                var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === "function" ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
                 : this.originalOptions.clickOutsideDeactivates; // boolean
                if (allowDeactivation) // capture the outside target that was clicked so we can use it in the deactivation
                //  process since the consumer allowed it to cause auto-deactivation
                this.outsideClick = {
                    target: event.target,
                    allowDeactivation: allowDeactivation
                };
                return allowDeactivation;
            }
        },
        {
            key: "handleDeactivate",
            value: function handleDeactivate() {
                if (this.originalOptions.onDeactivate) this.originalOptions.onDeactivate.call(null); // call user's handler out of context
                this.deactivateTrap();
            }
        },
        {
            key: "handlePostDeactivate",
            value: function handlePostDeactivate() {
                var _this2 = this;
                var finishDeactivation = function finishDeactivation() {
                    var returnFocusNode = _this2.getReturnFocusNode();
                    var canReturnFocus = !!// did the consumer allow it?
                    (_this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                    returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && // was there an outside click that allowed deactivation?
                    (!_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                    _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                    //  as a result of the click-through) -- in which case do NOT restore focus
                    //  to `returnFocusNode` because focus should remain on the outside node
                    !isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)));
                    var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
                    if (canReturnFocus) // return focus to the element that had focus when the trap was activated
                    returnFocusNode.focus({
                        preventScroll: preventScroll
                    });
                    if (_this2.originalOptions.onPostDeactivate) _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
                    _this2.outsideClick = null; // reset: no longer needed
                };
                if (this.originalOptions.checkCanReturnFocus) this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
                .then(finishDeactivation, finishDeactivation);
                else finishDeactivation();
            }
        },
        {
            key: "setupFocusTrap",
            value: function setupFocusTrap() {
                if (this.focusTrap) // trap already exists: it's possible we're in StrictMode and we're being remounted,
                //  in which case, we will have deactivated the trap when we got unmounted (remember,
                //  StrictMode, in development, purposely unmounts and remounts components after
                //  mounting them the first time to make sure they have reusable state,
                //  @see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state) so now
                //  we need to restore the state of the trap according to our component state
                // NOTE: Strict mode __violates__ assumptions about the `componentWillUnmount()` API
                //  which clearly states -- even for React 18 -- that, "Once a component instance is
                //  unmounted, __it will never be mounted again.__" (emphasis ours). So when we get
                //  unmounted, we assume we're gone forever and we deactivate the trap. But then
                //  we get remounted and we're supposed to restore state. But if you had paused,
                //  we've now deactivated (we don't know we're amount to get remounted again)
                //  which means we need to reactivate and then pause. Otherwise, do nothing.
                {
                    if (this.props.active && !this.focusTrap.active) {
                        this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                } else {
                    var nodesExist = this.focusTrapElements.some(Boolean);
                    if (nodesExist) {
                        // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
                        this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions);
                        if (this.props.active) this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) this.setupFocusTrap();
            // else, wait for later activation in case the `focusTrapOptions` will be updated
            //  again before the trap is activated (e.g. if waiting to know what the document
            //  object will be, so the Trap must be rendered, but the consumer is waiting to
            //  activate until they have obtained the document from a ref)
            //  @see https://github.com/focus-trap/focus-trap-react/issues/539
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.focusTrap) {
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrap.updateContainerElements(this.props.containerElements);
                    var hasActivated = !prevProps.active && this.props.active;
                    var hasDeactivated = prevProps.active && !this.props.active;
                    var hasPaused = !prevProps.paused && this.props.paused;
                    var hasUnpaused = prevProps.paused && !this.props.paused;
                    if (hasActivated) {
                        this.updatePreviousElement();
                        this.focusTrap.activate();
                    }
                    if (hasDeactivated) {
                        this.deactivateTrap();
                        return; // un/pause does nothing on an inactive trap
                    }
                    if (hasPaused) this.focusTrap.pause();
                    if (hasUnpaused) this.focusTrap.unpause();
                } else {
                    // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
                    //  it either means it shouldn't be active, or it should be but none of
                    //  of given `containerElements` were present in the DOM the last time
                    //  we tried to create the trap
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrapElements = this.props.containerElements;
                    // don't create the trap unless it should be active in case the consumer
                    //  is still updating `focusTrapOptions`
                    //  @see https://github.com/focus-trap/focus-trap-react/issues/539
                    if (this.props.active) {
                        this.updatePreviousElement();
                        this.setupFocusTrap();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deactivateTrap();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var child = this.props.children ? React.Children.only(this.props.children) : undefined;
                if (child) {
                    if (child.type && child.type === React.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
                    var callbackRef = function callbackRef(element) {
                        var containerElements = _this3.props.containerElements;
                        if (child) {
                            if (typeof child.ref === "function") child.ref(element);
                            else if (child.ref) child.ref.current = element;
                        }
                        _this3.focusTrapElements = containerElements ? containerElements : [
                            element
                        ];
                    };
                    var childWithRef = React.cloneElement(child, {
                        ref: callbackRef
                    });
                    return childWithRef;
                }
                return null;
            }
        }
    ]);
    return FocusTrap;
}(React.Component); // support server-side rendering where `Element` will not be defined
var ElementType = typeof Element === "undefined" ? Function : Element;
FocusTrap.propTypes = {
    active: PropTypes.bool,
    paused: PropTypes.bool,
    focusTrapOptions: PropTypes.shape({
        document: PropTypes.object,
        onActivate: PropTypes.func,
        onPostActivate: PropTypes.func,
        checkCanFocusTrap: PropTypes.func,
        onPause: PropTypes.func,
        onPostPause: PropTypes.func,
        onUnpause: PropTypes.func,
        onPostUnpause: PropTypes.func,
        onDeactivate: PropTypes.func,
        onPostDeactivate: PropTypes.func,
        checkCanReturnFocus: PropTypes.func,
        initialFocus: PropTypes.oneOfType([
            PropTypes.instanceOf(ElementType),
            PropTypes.string,
            PropTypes.bool,
            PropTypes.func
        ]),
        fallbackFocus: PropTypes.oneOfType([
            PropTypes.instanceOf(ElementType),
            PropTypes.string,
            // NOTE: does not support `false` as value (or return value from function)
            PropTypes.func
        ]),
        escapeDeactivates: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.func
        ]),
        clickOutsideDeactivates: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.func
        ]),
        returnFocusOnDeactivate: PropTypes.bool,
        setReturnFocus: PropTypes.oneOfType([
            PropTypes.instanceOf(ElementType),
            PropTypes.string,
            PropTypes.bool,
            PropTypes.func
        ]),
        allowOutsideClick: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.func
        ]),
        preventScroll: PropTypes.bool,
        tabbableOptions: PropTypes.shape({
            displayCheck: PropTypes.oneOf([
                "full",
                "legacy-full",
                "non-zero-area",
                "none"
            ]),
            getShadowRoot: PropTypes.oneOfType([
                PropTypes.bool,
                PropTypes.func
            ])
        }),
        trapStack: PropTypes.array,
        isKeyForward: PropTypes.func,
        isKeyBackward: PropTypes.func
    }),
    containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
    // DOM element ONLY
    children: PropTypes.oneOfType([
        PropTypes.element,
        // React element
        PropTypes.instanceOf(ElementType) // DOM element
    ])
};
FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: createFocusTrap
};
module.exports = FocusTrap;

},{"d7b04d8f9f20b95f":"ktQNc","9fc195b8a681ab95":"8INHm","6fa143c951e963da":"u4fpM","d6b4353ef35ec620":"lMcWp"}],"u4fpM":[function(require,module,exports) {
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createFocusTrap", function() {
    return createFocusTrap;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _tabbable = require("tabbable");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (typeof key === "undefined" ? "undefined" : (0, _typeOf._)(key)) === "symbol" ? key : String(key);
}
var activeFocusTraps = {
    activateTrap: function activateTrap(trapStack, trap) {
        if (trapStack.length > 0) {
            var activeTrap = trapStack[trapStack.length - 1];
            if (activeTrap !== trap) activeTrap.pause();
        }
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        if (trapStack.length > 0) trapStack[trapStack.length - 1].unpause();
    }
};
var isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Escape" || (e === null || e === void 0 ? void 0 : e.key) === "Esc" || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === "Tab" || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var isKeyForward = function isKeyForward(e) {
    return isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var isKeyBackward = function isKeyBackward(e) {
    return isTabEvent(e) && e.shiftKey;
};
var delay = function delay(fn) {
    return setTimeout(fn, 0);
};
// Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var internalTrapStack = [];
var createFocusTrap = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        isKeyForward: isKeyForward,
        isKeyBackward: isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   posTabIndexesFound: boolean,
        //   firstTabbableNode: HTMLElement|undefined,
        //   lastTabbableNode: HTMLElement|undefined,
        //   firstDomTabbableNode: HTMLElement|undefined,
        //   lastDomTabbableNode: HTMLElement|undefined,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus");
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || !(0, _tabbable.isFocusable)(node, config.tabbableOptions)) {
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, _tabbable.tabbable)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, _tabbable.focusable)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, _tabbable.isTabbable)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, _tabbable.isTabbable)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, _tabbable.getTabIndex)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, _tabbable.isTabbable)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, _tabbable.isTabbable)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement} The element that currently has the focus
   **/ var getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === getActiveElement(document)) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref2) {
        var target = _ref2.target, event = _ref2.event, _ref2$isBackward = _ref2.isBackward, isBackward = _ref2$isBackward === void 0 ? false : _ref2$isBackward;
        target = target || getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var firstTabbableNode = _ref3.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, _tabbable.isFocusable)(target, config.tabbableOptions) && !(0, _tabbable.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, _tabbable.getTabIndex)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref4) {
                    var lastTabbableNode = _ref4.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, _tabbable.isFocusable)(target, config.tabbableOptions) && !(0, _tabbable.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, _tabbable.getTabIndex)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it ocurred inside the trap
        return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if (valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, _tabbable.getTabIndex)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, _tabbable.getTabIndex)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) tryFocus(nextNode);
            else tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if (isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(event) {
        if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
            return;
        }
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    var checkClick = function checkClick(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === state.mostRecentlyFocusedNode;
            });
        });
        // If the currently focused is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved) tryFocus(getInitialFocusNode());
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            onActivate === null || onActivate === void 0 || onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                updateObservedNodes();
                onPostActivate === null || onPostActivate === void 0 || onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            onDeactivate === null || onDeactivate === void 0 || onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (state.paused || !state.active) return this;
            var onPause = getOption(pauseOptions, "onPause");
            var onPostPause = getOption(pauseOptions, "onPostPause");
            state.paused = true;
            onPause === null || onPause === void 0 || onPause();
            removeListeners();
            updateObservedNodes();
            onPostPause === null || onPostPause === void 0 || onPostPause();
            return this;
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.paused || !state.active) return this;
            var onUnpause = getOption(unpauseOptions, "onUnpause");
            var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
            state.paused = false;
            onUnpause === null || onUnpause === void 0 || onUnpause();
            updateTabbableNodes();
            addListeners();
            updateObservedNodes();
            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            updateObservedNodes();
            return this;
        }
    };
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};

},{"@swc/helpers/_/_type_of":"6Gp9n","tabbable":"lMcWp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lMcWp":[function(require,module,exports) {
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "focusable", function() {
    return focusable;
});
parcelHelpers.export(exports, "getTabIndex", function() {
    return getTabIndex;
});
parcelHelpers.export(exports, "isFocusable", function() {
    return isFocusable;
});
parcelHelpers.export(exports, "isTabbable", function() {
    return isTabbable;
});
parcelHelpers.export(exports, "tabbable", function() {
    return tabbable;
});
var candidateSelectors = [
    "input:not([inert])",
    "select:not([inert])",
    "textarea:not([inert])",
    "a[href]:not([inert])",
    "button:not([inert])",
    "[tabindex]:not(slot):not([inert])",
    "audio[controls]:not([inert])",
    "video[controls]:not([inert])",
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    "details>summary:first-of-type:not([inert])",
    "details:not([inert])"
];
var candidateSelector = /* #__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
    var inert = inertAtt === "" || inertAtt === "true";
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
    return attValue === "" || attValue === "true";
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if (isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (isInert(element, false)) continue;
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var getTabIndex = function getTabIndex(node) {
    if (!node) throw new Error("No node provided");
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = getTabIndex(node);
    if (tabIndex < 0 && isScope && !hasTabIndex(node)) return 0;
    return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== "legacy-full") return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* #__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iTJs9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", function() {
    return Button;
});
parcelHelpers.export(exports, "Caption", function() {
    return Caption;
});
parcelHelpers.export(exports, "CaptionDropdowns", function() {
    return CaptionDropdowns;
});
parcelHelpers.export(exports, "CaptionLabel", function() {
    return CaptionLabel;
});
parcelHelpers.export(exports, "CaptionNavigation", function() {
    return CaptionNavigation;
});
parcelHelpers.export(exports, "Day", function() {
    return Day;
});
parcelHelpers.export(exports, "DayContent", function() {
    return DayContent;
});
parcelHelpers.export(exports, "DayPicker", function() {
    return DayPicker;
});
parcelHelpers.export(exports, "DayPickerContext", function() {
    return DayPickerContext;
});
parcelHelpers.export(exports, "DayPickerProvider", function() {
    return DayPickerProvider;
});
parcelHelpers.export(exports, "Dropdown", function() {
    return Dropdown;
});
parcelHelpers.export(exports, "FocusContext", function() {
    return FocusContext;
});
parcelHelpers.export(exports, "FocusProvider", function() {
    return FocusProvider;
});
parcelHelpers.export(exports, "Footer", function() {
    return Footer;
});
parcelHelpers.export(exports, "Head", function() {
    return Head;
});
parcelHelpers.export(exports, "HeadRow", function() {
    return HeadRow;
});
parcelHelpers.export(exports, "IconDropdown", function() {
    return IconDropdown;
});
parcelHelpers.export(exports, "IconLeft", function() {
    return IconLeft;
});
parcelHelpers.export(exports, "IconRight", function() {
    return IconRight;
});
parcelHelpers.export(exports, "InternalModifier", function() {
    return InternalModifier;
});
parcelHelpers.export(exports, "Months", function() {
    return Months;
});
parcelHelpers.export(exports, "NavigationContext", function() {
    return NavigationContext;
});
parcelHelpers.export(exports, "NavigationProvider", function() {
    return NavigationProvider;
});
parcelHelpers.export(exports, "RootProvider", function() {
    return RootProvider;
});
parcelHelpers.export(exports, "Row", function() {
    return Row;
});
parcelHelpers.export(exports, "SelectMultipleContext", function() {
    return SelectMultipleContext;
});
parcelHelpers.export(exports, "SelectMultipleProvider", function() {
    return SelectMultipleProvider;
});
parcelHelpers.export(exports, "SelectMultipleProviderInternal", function() {
    return SelectMultipleProviderInternal;
});
parcelHelpers.export(exports, "SelectRangeContext", function() {
    return SelectRangeContext;
});
parcelHelpers.export(exports, "SelectRangeProvider", function() {
    return SelectRangeProvider;
});
parcelHelpers.export(exports, "SelectRangeProviderInternal", function() {
    return SelectRangeProviderInternal;
});
parcelHelpers.export(exports, "SelectSingleContext", function() {
    return SelectSingleContext;
});
parcelHelpers.export(exports, "SelectSingleProvider", function() {
    return SelectSingleProvider;
});
parcelHelpers.export(exports, "SelectSingleProviderInternal", function() {
    return SelectSingleProviderInternal;
});
parcelHelpers.export(exports, "WeekNumber", function() {
    return WeekNumber;
});
parcelHelpers.export(exports, "addToRange", function() {
    return addToRange;
});
parcelHelpers.export(exports, "isDateAfterType", function() {
    return isDateAfterType;
});
parcelHelpers.export(exports, "isDateBeforeType", function() {
    return isDateBeforeType;
});
parcelHelpers.export(exports, "isDateInterval", function() {
    return isDateInterval;
});
parcelHelpers.export(exports, "isDateRange", function() {
    return isDateRange;
});
parcelHelpers.export(exports, "isDayOfWeekType", function() {
    return isDayOfWeekType;
});
parcelHelpers.export(exports, "isDayPickerDefault", function() {
    return isDayPickerDefault;
});
parcelHelpers.export(exports, "isDayPickerMultiple", function() {
    return isDayPickerMultiple;
});
parcelHelpers.export(exports, "isDayPickerRange", function() {
    return isDayPickerRange;
});
parcelHelpers.export(exports, "isDayPickerSingle", function() {
    return isDayPickerSingle;
});
parcelHelpers.export(exports, "isMatch", function() {
    return isMatch;
});
parcelHelpers.export(exports, "useActiveModifiers", function() {
    return useActiveModifiers;
});
parcelHelpers.export(exports, "useDayPicker", function() {
    return useDayPicker;
});
parcelHelpers.export(exports, "useDayRender", function() {
    return useDayRender;
});
parcelHelpers.export(exports, "useFocusContext", function() {
    return useFocusContext;
});
parcelHelpers.export(exports, "useInput", function() {
    return useInput;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return useNavigation;
});
parcelHelpers.export(exports, "useSelectMultiple", function() {
    return useSelectMultiple;
});
parcelHelpers.export(exports, "useSelectRange", function() {
    return useSelectRange;
});
parcelHelpers.export(exports, "useSelectSingle", function() {
    return useSelectSingle;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function isDayPickerMultiple(props) {
    return props.mode === "multiple";
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function isDayPickerRange(props) {
    return props.mode === "range";
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function isDayPickerSingle(props) {
    return props.mode === "single";
}
/**
 * The name of the default CSS classes.
 */ var defaultClassNames = {
    root: "rdp",
    multiple_months: "rdp-multiple_months",
    with_weeknumber: "rdp-with_weeknumber",
    vhidden: "rdp-vhidden",
    button_reset: "rdp-button_reset",
    button: "rdp-button",
    caption: "rdp-caption",
    caption_start: "rdp-caption_start",
    caption_end: "rdp-caption_end",
    caption_between: "rdp-caption_between",
    caption_label: "rdp-caption_label",
    caption_dropdowns: "rdp-caption_dropdowns",
    dropdown: "rdp-dropdown",
    dropdown_month: "rdp-dropdown_month",
    dropdown_year: "rdp-dropdown_year",
    dropdown_icon: "rdp-dropdown_icon",
    months: "rdp-months",
    month: "rdp-month",
    table: "rdp-table",
    tbody: "rdp-tbody",
    tfoot: "rdp-tfoot",
    head: "rdp-head",
    head_row: "rdp-head_row",
    head_cell: "rdp-head_cell",
    nav: "rdp-nav",
    nav_button: "rdp-nav_button",
    nav_button_previous: "rdp-nav_button_previous",
    nav_button_next: "rdp-nav_button_next",
    nav_icon: "rdp-nav_icon",
    row: "rdp-row",
    weeknumber: "rdp-weeknumber",
    cell: "rdp-cell",
    day: "rdp-day",
    day_today: "rdp-day_today",
    day_outside: "rdp-day_outside",
    day_selected: "rdp-day_selected",
    day_disabled: "rdp-day_disabled",
    day_hidden: "rdp-day_hidden",
    day_range_start: "rdp-day_range_start",
    day_range_end: "rdp-day_range_end",
    day_range_middle: "rdp-day_range_middle"
};
/**
 * The default formatter for the caption.
 */ function formatCaption(month, options) {
    return (0, _dateFns.format)(month, "LLLL y", options);
}
/**
 * The default formatter for the Day button.
 */ function formatDay(day, options) {
    return (0, _dateFns.format)(day, "d", options);
}
/**
 * The default formatter for the Month caption.
 */ function formatMonthCaption(month, options) {
    return (0, _dateFns.format)(month, "LLLL", options);
}
/**
 * The default formatter for the week number.
 */ function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function formatWeekdayName(weekday, options) {
    return (0, _dateFns.format)(weekday, "cccccc", options);
}
/**
 * The default formatter for the Year caption.
 */ function formatYearCaption(year, options) {
    return (0, _dateFns.format)(year, "yyyy", options);
}
var formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var labelDay = function labelDay(day, activeModifiers, options) {
    return (0, _dateFns.format)(day, "do MMMM (EEEE)", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelMonthDropdown = function labelMonthDropdown() {
    return "Month: ";
};
/**
 * The default ARIA label for next month button in navigation
 */ var labelNext = function labelNext() {
    return "Go to next month";
};
/**
 * The default ARIA label for previous month button in navigation
 */ var labelPrevious = function labelPrevious() {
    return "Go to previous month";
};
/**
 * The default ARIA label for the Weekday element.
 */ var labelWeekday = function labelWeekday(day, options) {
    return (0, _dateFns.format)(day, "cccc", options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelWeekNumber = function labelWeekNumber(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var labelYearDropdown = function labelYearDropdown() {
    return "Year: ";
};
var labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function getDefaultContextValues() {
    var captionLayout = "buttons";
    var classNames = defaultClassNames;
    var locale = (0, _locale.enUS);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: "default"
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, _dateFns.startOfMonth)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, _dateFns.endOfMonth)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, _dateFns.startOfDay)(fromDate) : undefined,
        toDate: toDate ? (0, _dateFns.startOfDay)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var DayPickerContext = (0, _react.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== "buttons" && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = "buttons";
    var onSelect;
    if (isDayPickerSingle(initialProps) || isDayPickerMultiple(initialProps) || isDayPickerRange(initialProps)) onSelect = initialProps.onSelect;
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: __assign({}, initialProps.components),
        formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, _jsxRuntime.jsx)(DayPickerContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function useDayPicker() {
    var context = (0, _react.useContext)(DayPickerContext);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, _$formatCaption = _a.formatters.formatCaption;
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: _$formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function IconDropdown(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (0, _jsxRuntime.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, _jsxRuntime.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props["aria-label"]
            }),
            (0, _jsxRuntime.jsx)("select", {
                name: props.name,
                "aria-label": props["aria-label"],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, _jsxRuntime.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, _jsxRuntime.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, _$formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!toDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var dropdownMonths = [];
    if ((0, _dateFns.isSameYear)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, _dateFns.startOfMonth)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, _dateFns.setMonth)(date, month));
    } else {
        // display all the 12 months
        var date = (0, _dateFns.startOfMonth)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, _dateFns.setMonth)(date, month));
    }
    var handleChange = function handleChange(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, _dateFns.setMonth)((0, _dateFns.startOfMonth)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (0, _jsxRuntime.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: _$formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, _jsxRuntime.jsx)("option", {
                value: m.getMonth(),
                children: _$formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, _$formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if (!toDate) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, _dateFns.setYear)((0, _dateFns.startOfYear)(new Date()), year));
    var handleChange = function handleChange(e) {
        var newMonth = (0, _dateFns.setYear)((0, _dateFns.startOfMonth)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (0, _jsxRuntime.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: _$formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, _jsxRuntime.jsx)("option", {
                value: year.getFullYear(),
                children: _$formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function useControlledValue(defaultValue, controlledValue) {
    var _a = (0, _react.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, _dateFns.differenceInCalendarMonths)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, _dateFns.addMonths)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, _dateFns.differenceInCalendarMonths)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, _dateFns.startOfMonth)(initialMonth);
}
/** Controls the navigation state. */ function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function goToMonth(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, _dateFns.startOfMonth)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, _dateFns.startOfMonth)(month);
    var end = (0, _dateFns.startOfMonth)((0, _dateFns.addMonths)(start, numberOfMonths));
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, _dateFns.addMonths)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, _dateFns.startOfMonth)(startingMonth);
    if (!toDate) return (0, _dateFns.addMonths)(month, offset);
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, _dateFns.addMonths)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, _dateFns.startOfMonth)(startingMonth);
    if (!fromDate) return (0, _dateFns.addMonths)(month, -offset);
    var monthsDiff = (0, _dateFns.differenceInCalendarMonths)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, _dateFns.addMonths)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var NavigationContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function isDateDisplayed(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, _dateFns.isSameMonth)(date, displayMonth);
        });
    };
    var goToDate = function goToDate(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, _dateFns.isBefore)(date, refDate)) goToMonth((0, _dateFns.addMonths)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, _jsxRuntime.jsx)(NavigationContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useNavigation() {
    var context = (0, _react.useContext)(NavigationContext);
    if (!context) throw new Error("useNavigation must be used within a NavigationProvider");
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function handleMonthChange(newMonth) {
        goToMonth((0, _dateFns.addMonths)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, _jsxRuntime.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, _jsxRuntime.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, _jsxRuntime.jsx)(MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, _jsxRuntime.jsx)(YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function IconLeft(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function IconRight(props) {
    return (0, _jsxRuntime.jsx)("svg", __assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var Button = (0, _react.forwardRef)(function(props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(" ");
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, _jsxRuntime.jsx)("button", __assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(" ");
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(" ");
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (0, _jsxRuntime.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, _jsxRuntime.jsx)(Button, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === "rtl" ? (0, _jsxRuntime.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, _jsxRuntime.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, _jsxRuntime.jsx)(Button, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === "rtl" ? (0, _jsxRuntime.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, _jsxRuntime.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, _dateFns.isSameMonth)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function handlePreviousClick() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function handleNextClick() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, _jsxRuntime.jsx)(Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) caption = (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === "dropdown") caption = (0, _jsxRuntime.jsx)(CaptionDropdowns, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === "dropdown-buttons") caption = (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(CaptionDropdowns, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, _jsxRuntime.jsx)(CaptionNavigation, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, _jsxRuntime.jsx)(CaptionNavigation, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return (0, _jsxRuntime.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, _jsxRuntime.jsx)("tr", {
            children: (0, _jsxRuntime.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, _dateFns.startOfISOWeek)(new Date()) : (0, _dateFns.startOfWeek)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, _dateFns.addDays)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, _$formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, _jsxRuntime.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, _jsxRuntime.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, _jsxRuntime.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: _$formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (0, _jsxRuntime.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, _jsxRuntime.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, _$formatDay = _a.formatters.formatDay;
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: _$formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var SelectMultipleContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, _jsxRuntime.jsx)(SelectMultipleContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectMultipleProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, _dateFns.isSameDay)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, _dateFns.isSameDay)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, _jsxRuntime.jsx)(SelectMultipleContext.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectMultiple() {
    var context = (0, _react.useContext)(SelectMultipleContext);
    if (!context) throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, _dateFns.isSameDay)(to, day) && (0, _dateFns.isSameDay)(from, day)) return undefined;
        if ((0, _dateFns.isSameDay)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, _dateFns.isSameDay)(from, day)) return undefined;
        if ((0, _dateFns.isAfter)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, _dateFns.isAfter)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, _dateFns.isBefore)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var SelectRangeContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, _jsxRuntime.jsx)(SelectRangeContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectRangeProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, _dateFns.isSameDay)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, _dateFns.subDays)(selectedFrom, min - 1),
            before: (0, _dateFns.addDays)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, _dateFns.addDays)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, _dateFns.subDays)(selectedTo, min - 1),
            before: (0, _dateFns.addDays)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, _dateFns.addDays)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, _dateFns.differenceInCalendarDays)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, _dateFns.subDays)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, _dateFns.addDays)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, _dateFns.addDays)(selectedTo, max - 1)
            });
        }
    }
    return (0, _jsxRuntime.jsx)(SelectRangeContext.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectRange() {
    var context = (0, _react.useContext)(SelectRangeContext);
    if (!context) throw new Error("useSelectRange must be used within a SelectRangeProvider");
    return context;
}
/** Normalize to array a matcher input. */ function matcherToArray(matcher) {
    if (Array.isArray(matcher)) return __spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var InternalModifier;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})(InternalModifier || (InternalModifier = {}));
var Selected = InternalModifier.Selected, Disabled = InternalModifier.Disabled, Hidden = InternalModifier.Hidden, Today = InternalModifier.Today, RangeEnd = InternalModifier.RangeEnd, RangeMiddle = InternalModifier.RangeMiddle, RangeStart = InternalModifier.RangeStart, Outside = InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[Selected] = matcherToArray(dayPicker.selected), _a[Disabled] = matcherToArray(dayPicker.disabled), _a[Hidden] = matcherToArray(dayPicker.hidden), _a[Today] = [
        dayPicker.today
    ], _a[RangeEnd] = [], _a[RangeMiddle] = [], _a[RangeStart] = [], _a[Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[Disabled].push({
        after: dayPicker.toDate
    });
    if (isDayPickerMultiple(dayPicker)) internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var ModifiersContext = (0, _react.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (0, _jsxRuntime.jsx)(ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function useModifiers() {
    var context = (0, _react.useContext)(ModifiersContext);
    if (!context) throw new Error("useModifiers must be used within a ModifiersProvider");
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function isDateInterval(matcher) {
    return Boolean(matcher && typeof matcher === "object" && "before" in matcher && "after" in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function isDateRange(value) {
    return Boolean(value && typeof value === "object" && "from" in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function isDateAfterType(value) {
    return Boolean(value && typeof value === "object" && "after" in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function isDateBeforeType(value) {
    return Boolean(value && typeof value === "object" && "before" in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function isDayOfWeekType(value) {
    return Boolean(value && typeof value === "object" && "dayOfWeek" in value);
}
/** Return `true` whether `date` is inside `range`. */ function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, _dateFns.differenceInCalendarDays)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, _dateFns.differenceInCalendarDays)(date, from) >= 0 && (0, _dateFns.differenceInCalendarDays)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, _dateFns.isSameDay)(to, date);
    if (from) return (0, _dateFns.isSameDay)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function isDateType(value) {
    return (0, _dateFns.isDate)(value);
}
/** Returns true if `value` is an array of valid dates. */ function isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, _dateFns.isDate));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function isMatch(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === "boolean") return matcher;
        if (isDateType(matcher)) return (0, _dateFns.isSameDay)(day, matcher);
        if (isArrayOfDates(matcher)) return matcher.includes(day);
        if (isDateRange(matcher)) return isDateInRange(day, matcher);
        if (isDayOfWeekType(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if (isDateInterval(matcher)) {
            var diffBefore = (0, _dateFns.differenceInCalendarDays)(matcher.before, day);
            var diffAfter = (0, _dateFns.differenceInCalendarDays)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, _dateFns.isAfter)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if (isDateAfterType(matcher)) return (0, _dateFns.differenceInCalendarDays)(day, matcher.after) > 0;
        if (isDateBeforeType(matcher)) return (0, _dateFns.differenceInCalendarDays)(matcher.before, day) > 0;
        if (typeof matcher === "function") return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, _dateFns.isSameMonth)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, _dateFns.startOfMonth)(displayMonths[0]);
    var lastDayInMonth = (0, _dateFns.endOfMonth)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, _dateFns.addDays)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, _dateFns.addDays)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var MAX_RETRY = 365;
/** Return the next date to be focused. */ function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, _dateFns.addDays),
        week: (0, _dateFns.addWeeks),
        month: (0, _dateFns.addMonths),
        year: (0, _dateFns.addYears),
        startOfWeek: function startOfWeek(date) {
            return context.ISOWeek ? (0, _dateFns.startOfISOWeek)(date) : (0, _dateFns.startOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function endOfWeek(date) {
            return context.ISOWeek ? (0, _dateFns.endOfISOWeek)(date) : (0, _dateFns.endOfWeek)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === "after" ? 1 : -1);
    if (direction === "before" && fromDate) newFocusedDay = (0, _dateFns.max)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === "after" && toDate) newFocusedDay = (0, _dateFns.min)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > MAX_RETRY) return retry.lastFocused;
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var FocusContext = (0, _react.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = (0, _react.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, _react.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function blur() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function focus(date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function moveFocus(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, _dateFns.isSameDay)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function focusDayAfter() {
            return moveFocus("day", "after");
        },
        focusDayBefore: function focusDayBefore() {
            return moveFocus("day", "before");
        },
        focusWeekAfter: function focusWeekAfter() {
            return moveFocus("week", "after");
        },
        focusWeekBefore: function focusWeekBefore() {
            return moveFocus("week", "before");
        },
        focusMonthBefore: function focusMonthBefore() {
            return moveFocus("month", "before");
        },
        focusMonthAfter: function focusMonthAfter() {
            return moveFocus("month", "after");
        },
        focusYearBefore: function focusYearBefore() {
            return moveFocus("year", "before");
        },
        focusYearAfter: function focusYearAfter() {
            return moveFocus("year", "after");
        },
        focusStartOfWeek: function focusStartOfWeek() {
            return moveFocus("startOfWeek", "before");
        },
        focusEndOfWeek: function focusEndOfWeek() {
            return moveFocus("endOfWeek", "after");
        }
    };
    return (0, _jsxRuntime.jsx)(FocusContext.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useFocusContext() {
    var context = (0, _react.useContext)(FocusContext);
    if (!context) throw new Error("useFocusContext must be used within a FocusProvider");
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function useActiveModifiers(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var SelectSingleContext = (0, _react.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, _jsxRuntime.jsx)(SelectSingleContext.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, _jsxRuntime.jsx)(SelectSingleProviderInternal, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function onDayClick(day, activeModifiers, e) {
        var _$_a, _b, _c;
        (_$_a = initialProps.onDayClick) === null || _$_a === void 0 || _$_a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, _jsxRuntime.jsx)(SelectSingleContext.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function useSelectSingle() {
    var context = (0, _react.useContext)(SelectSingleContext);
    if (!context) throw new Error("useSelectSingle must be used within a SelectSingleProvider");
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function onClick(e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if (isDayPickerMultiple(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if (isDayPickerRange(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function onFocus(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function onBlur(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function onMouseEnter(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function onMouseLeave(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function onPointerEnter(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function onPointerLeave(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function onTouchCancel(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function onTouchEnd(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function onTouchMove(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function onTouchStart(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function onKeyUp(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function onKeyDown(e) {
        var _a;
        switch(e.key){
            case "ArrowLeft":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayAfter() : focusDayBefore();
                break;
            case "ArrowRight":
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === "rtl" ? focusDayBefore() : focusDayAfter();
                break;
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case "PageUp":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case "PageDown":
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case "Home":
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case "End":
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker) ? single.selected : isDayPickerMultiple(dayPicker) ? multiple.selected : isDayPickerRange(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function isInternalModifier(modifier) {
    return Object.values(InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function useDayRender(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== "default");
    // Focus the button if the day is focused according to the focus context
    (0, _react.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, _dateFns.isSameDay)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(" ");
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (0, _jsxRuntime.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: "gridcell"
    };
    var isFocusTarget = focusContext.focusTarget && (0, _dateFns.isSameDay)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, _dateFns.isSameDay)(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: "gridcell"
    }, _a["aria-selected"] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function Day(props) {
    var buttonRef = (0, _react.useRef)(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, _jsxRuntime.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, _jsxRuntime.jsx)("div", __assign({}, dayRender.divProps));
    return (0, _jsxRuntime.jsx)(Button, __assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, _$formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = _$formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, _jsxRuntime.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function handleClick(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, _jsxRuntime.jsx)(Button, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, _jsxRuntime.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, _jsxRuntime.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, _jsxRuntime.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, _jsxRuntime.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, _jsxRuntime.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, _dateFns.getUnixTime)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.endOfISOWeek)(toDate) : (0, _dateFns.endOfWeek)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.startOfISOWeek)(fromDate) : (0, _dateFns.startOfWeek)(fromDate, options);
    var nOfDays = (0, _dateFns.differenceInCalendarDays)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, _dateFns.addDays)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, _dateFns.getISOWeek)(date) : (0, _dateFns.getWeek)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks((0, _dateFns.startOfMonth)(month), (0, _dateFns.endOfMonth)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, _dateFns.getWeeksInMonth)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, _dateFns.addWeeks)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks((0, _dateFns.addWeeks)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (0, _jsxRuntime.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props["aria-labelledby"],
        children: [
            !hideHead && (0, _jsxRuntime.jsx)(HeadComponent, {}),
            (0, _jsxRuntime.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, _jsxRuntime.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, _jsxRuntime.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var useIsomorphicLayoutEffect = canUseDOM() ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : serverHandoffComplete ? genId() : null;
    var _b = (0, _react.useState)(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId(genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(function() {
        if (serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === "rtl") _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (0, _jsxRuntime.jsxs)("div", {
        className: className.join(" "),
        style: style,
        children: [
            (0, _jsxRuntime.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, _jsxRuntime.jsx)(Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (0, _jsxRuntime.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = (0, _react.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, _react.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith("data-");
    }).reduce(function(attrs, key) {
        var _$_a;
        return __assign(__assign({}, attrs), (_$_a = {}, _$_a[key] = initialProps[key], _$_a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (0, _jsxRuntime.jsx)("div", __assign({
        className: classNames.join(" "),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, _jsxRuntime.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, _jsxRuntime.jsx)(Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, [
        "children"
    ]);
    return (0, _jsxRuntime.jsx)(DayPickerProvider, {
        initialProps: initialProps,
        children: (0, _jsxRuntime.jsx)(NavigationProvider, {
            children: (0, _jsxRuntime.jsx)(SelectSingleProvider, {
                initialProps: initialProps,
                children: (0, _jsxRuntime.jsx)(SelectMultipleProvider, {
                    initialProps: initialProps,
                    children: (0, _jsxRuntime.jsx)(SelectRangeProvider, {
                        initialProps: initialProps,
                        children: (0, _jsxRuntime.jsx)(ModifiersProvider, {
                            children: (0, _jsxRuntime.jsx)(FocusProvider, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function DayPicker(props) {
    return (0, _jsxRuntime.jsx)(RootProvider, __assign({}, props, {
        children: (0, _jsxRuntime.jsx)(Root, {
            initialProps: props
        })
    }));
}
/** @private */ function isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function useInput(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, _locale.enUS) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? "PP" : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function parseValue(value) {
        return (0, _dateFns.parse)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, _react.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, _react.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, _dateFns.format)(defaultSelected, format$1, {
        locale: locale
    }) : "";
    var _g = (0, _react.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function reset() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : "");
    };
    var setSelected = function setSelected(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, _dateFns.format)(date, format$1, {
            locale: locale
        }) : "");
    };
    var handleDayClick = function handleDayClick(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue("");
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, _dateFns.format)(day, format$1, {
            locale: locale
        }) : "");
    };
    var handleMonthChange = function handleMonthChange(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function handleChange(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, _dateFns.differenceInCalendarDays)(fromDate, day) > 0;
        var isAfter = toDate && (0, _dateFns.differenceInCalendarDays)(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function handleBlur(e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function handleFocus(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, _dateFns.format)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === "default";
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","date-fns":"5C5dq","date-fns/locale":"6Kgrv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Kgrv":[function(require,module,exports) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "ar", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "arDZ", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "arEG", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "arMA", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "arSA", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "arTN", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "az", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "be", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "beTarask", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "bg", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "bn", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "bs", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "ca", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "cs", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "cy", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "da", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "de", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "deAT", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "el", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "enAU", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "enCA", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "enGB", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "enIE", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "enIN", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "enNZ", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "enUS", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "enZA", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "eo", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "es", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "et", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "eu", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "faIR", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "fi", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "fr", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "frCA", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "frCH", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "fy", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "gd", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "gl", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "gu", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "he", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "hi", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "hr", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "ht", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "hu", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "hy", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "id", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "is", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "it", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "itCH", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "ja", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "jaHira", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "ka", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "kk", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "km", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "kn", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "ko", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "lb", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "lt", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "lv", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "mk", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "mn", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "ms", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "mt", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "nb", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "nl", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "nlBE", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "nn", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "oc", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "pl", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "pt", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "ptBR", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "ro", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "ru", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "sk", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "sl", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "sq", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "sr", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "srLatn", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "sv", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "ta", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "te", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "th", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "tr", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "ug", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "uk", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "uz", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "uzCyrl", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "vi", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "zhCN", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "zhHK", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "zhTW", function() {
    return 0, _indexJsDefault92.default;
});
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":false,"./ar/index.js":false,"./ar-DZ/index.js":false,"./ar-EG/index.js":false,"./ar-MA/index.js":false,"./ar-SA/index.js":false,"./ar-TN/index.js":false,"./az/index.js":false,"./be/index.js":false,"./be-tarask/index.js":false,"./bg/index.js":false,"./bn/index.js":false,"./bs/index.js":false,"./ca/index.js":false,"./cs/index.js":false,"./cy/index.js":false,"./da/index.js":false,"./de/index.js":false,"./de-AT/index.js":false,"./el/index.js":false,"./en-AU/index.js":false,"./en-CA/index.js":false,"./en-GB/index.js":false,"./en-IE/index.js":false,"./en-IN/index.js":false,"./en-NZ/index.js":false,"./en-US/index.js":"lCNzB","./en-ZA/index.js":false,"./eo/index.js":false,"./es/index.js":false,"./et/index.js":false,"./eu/index.js":false,"./fa-IR/index.js":false,"./fi/index.js":false,"./fr/index.js":false,"./fr-CA/index.js":false,"./fr-CH/index.js":false,"./fy/index.js":false,"./gd/index.js":false,"./gl/index.js":false,"./gu/index.js":false,"./he/index.js":false,"./hi/index.js":false,"./hr/index.js":false,"./ht/index.js":false,"./hu/index.js":false,"./hy/index.js":false,"./id/index.js":false,"./is/index.js":false,"./it/index.js":false,"./it-CH/index.js":false,"./ja/index.js":false,"./ja-Hira/index.js":false,"./ka/index.js":false,"./kk/index.js":false,"./km/index.js":false,"./kn/index.js":false,"./ko/index.js":false,"./lb/index.js":false,"./lt/index.js":false,"./lv/index.js":false,"./mk/index.js":false,"./mn/index.js":false,"./ms/index.js":false,"./mt/index.js":false,"./nb/index.js":false,"./nl/index.js":false,"./nl-BE/index.js":false,"./nn/index.js":false,"./oc/index.js":false,"./pl/index.js":false,"./pt/index.js":false,"./pt-BR/index.js":false,"./ro/index.js":false,"./ru/index.js":false,"./sk/index.js":false,"./sl/index.js":false,"./sq/index.js":false,"./sr/index.js":false,"./sr-Latn/index.js":false,"./sv/index.js":false,"./ta/index.js":false,"./te/index.js":false,"./th/index.js":false,"./tr/index.js":false,"./ug/index.js":false,"./uk/index.js":false,"./uz/index.js":false,"./uz-Cyrl/index.js":false,"./vi/index.js":false,"./zh-CN/index.js":false,"./zh-HK/index.js":false,"./zh-TW/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k2Ltv":[function(require,module,exports) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return 0, _popper.Popper;
}) // Public types
;
parcelHelpers.export(exports, "Manager", function() {
    return 0, _manager.Manager;
});
parcelHelpers.export(exports, "Reference", function() {
    return 0, _reference.Reference;
});
parcelHelpers.export(exports, "usePopper", function() {
    return 0, _usePopper.usePopper;
});
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":false,"./Manager":false,"./Reference":false,"./usePopper":"6TO2R","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6TO2R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", function() {
    return usePopper;
});
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"ktQNc","react-dom":"lyZO5","@popperjs/core":"2UpHC","react-fast-compare":"75r8E","./utils":"dQzph","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2UpHC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
parcelHelpers.export(exports, "createPopperBase", function() {
    return 0, _createPopperJs.createPopper;
});
parcelHelpers.export(exports, "createPopper", function() {
    return 0, _popperJs.createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
});
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"7GJaW","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4QiBx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", function() {
    return top;
});
parcelHelpers.export(exports, "bottom", function() {
    return bottom;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "auto", function() {
    return auto;
});
parcelHelpers.export(exports, "basePlacements", function() {
    return basePlacements;
});
parcelHelpers.export(exports, "start", function() {
    return start;
});
parcelHelpers.export(exports, "end", function() {
    return end;
});
parcelHelpers.export(exports, "clippingParents", function() {
    return clippingParents;
});
parcelHelpers.export(exports, "viewport", function() {
    return viewport;
});
parcelHelpers.export(exports, "popper", function() {
    return popper;
});
parcelHelpers.export(exports, "reference", function() {
    return reference;
});
parcelHelpers.export(exports, "variationPlacements", function() {
    return variationPlacements;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "beforeRead", function() {
    return beforeRead;
});
parcelHelpers.export(exports, "read", function() {
    return read;
});
parcelHelpers.export(exports, "afterRead", function() {
    return afterRead;
});
parcelHelpers.export(exports, "beforeMain", function() {
    return beforeMain;
});
parcelHelpers.export(exports, "main", function() {
    return main;
});
parcelHelpers.export(exports, "afterMain", function() {
    return afterMain;
});
parcelHelpers.export(exports, "beforeWrite", function() {
    return beforeWrite;
});
parcelHelpers.export(exports, "write", function() {
    return write;
});
parcelHelpers.export(exports, "afterWrite", function() {
    return afterWrite;
});
parcelHelpers.export(exports, "modifierPhases", function() {
    return modifierPhases;
});
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead"; // pure-logic modifiers
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lSi3u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return popperGenerator;
});
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _detectOverflowJsDefault.default;
});
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(_$reference, (0, _getOffsetParentJsDefault.default)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, _getLayoutRectJsDefault.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4NThk","./dom-utils/getLayoutRect.js":"9riWU","./dom-utils/listScrollParents.js":"9SUc7","./dom-utils/getOffsetParent.js":"fVxTU","./utils/orderModifiers.js":"jZV9X","./utils/debounce.js":"4bIv0","./utils/mergeByName.js":"ZJRK4","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4NThk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getCompositeRect;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"hz0uH","./getNodeScroll.js":"hMKVq","./getNodeName.js":"64qby","./instanceOf.js":"9tXqC","./getWindowScrollBarX.js":"9kdCf","./getDocumentElement.js":"8aWSL","./isScrollParent.js":"kzwOv","../utils/math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hz0uH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBoundingClientRect;
});
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"9tXqC","../utils/math.js":"g1ZHU","./getWindow.js":"14SPe","./isLayoutViewport.js":"d4GuF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9tXqC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"14SPe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"14SPe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindow;
});
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g1ZHU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d4GuF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLayoutViewport;
});
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"egWcW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"egWcW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUAString;
});
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hMKVq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeScroll;
});
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"iRW5z","./getWindow.js":"14SPe","./instanceOf.js":"9tXqC","./getHTMLElementScroll.js":"41hCo","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iRW5z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScroll;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"14SPe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"41hCo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getHTMLElementScroll;
});
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"64qby":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeName;
});
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9kdCf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScrollBarX;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"hz0uH","./getDocumentElement.js":"8aWSL","./getWindowScroll.js":"iRW5z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8aWSL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentElement;
});
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kzwOv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isScrollParent;
});
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"f1Xrz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f1Xrz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getComputedStyle;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"14SPe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9riWU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getLayoutRect;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"hz0uH","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9SUc7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return listScrollParents;
});
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"4lB7b","./getParentNode.js":"jstEp","./getWindow.js":"14SPe","./isScrollParent.js":"kzwOv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4lB7b":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getScrollParent;
});
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"jstEp","./isScrollParent.js":"kzwOv","./getNodeName.js":"64qby","./instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jstEp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getParentNode;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"64qby","./getDocumentElement.js":"8aWSL","./instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fVxTU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOffsetParent;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === "html" || (0, _getNodeNameJsDefault.default)(offsetParent) === "body" && (0, _getComputedStyleJsDefault.default)(offsetParent).position === "static")) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"14SPe","./getNodeName.js":"64qby","./getComputedStyle.js":"f1Xrz","./instanceOf.js":"9tXqC","./isTableElement.js":"bXIUj","./getParentNode.js":"jstEp","../utils/userAgent.js":"egWcW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bXIUj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isTableElement;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"64qby","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jZV9X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return orderModifiers;
});
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"4QiBx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4bIv0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return debounce;
});
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ZJRK4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergeByName;
});
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6VNQJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return detectOverflow;
});
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"eq5P3","../dom-utils/getDocumentElement.js":"8aWSL","../dom-utils/getBoundingClientRect.js":"hz0uH","./computeOffsets.js":"chAN0","./rectToClientRect.js":"4Spdi","../enums.js":"4QiBx","../dom-utils/instanceOf.js":"9tXqC","./mergePaddingObject.js":"dD2RQ","./expandToHashMap.js":"dUJvK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eq5P3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getClippingRect;
});
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"4QiBx","./getViewportRect.js":"bjn4E","./getDocumentRect.js":"6exCy","./listScrollParents.js":"9SUc7","./getOffsetParent.js":"fVxTU","./getDocumentElement.js":"8aWSL","./getComputedStyle.js":"f1Xrz","./instanceOf.js":"9tXqC","./getBoundingClientRect.js":"hz0uH","./getParentNode.js":"jstEp","./contains.js":"7M2ge","./getNodeName.js":"64qby","../utils/rectToClientRect.js":"4Spdi","../utils/math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bjn4E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getViewportRect;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"14SPe","./getDocumentElement.js":"8aWSL","./getWindowScrollBarX.js":"9kdCf","./isLayoutViewport.js":"d4GuF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6exCy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentRect;
});
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === "rtl") x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"8aWSL","./getComputedStyle.js":"f1Xrz","./getWindowScrollBarX.js":"9kdCf","./getWindowScroll.js":"iRW5z","../utils/math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7M2ge":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return contains;
});
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4Spdi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rectToClientRect;
});
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"chAN0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeOffsets;
});
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"8TLRM","./getVariation.js":"dirTn","./getMainAxisFromPlacement.js":"eBVyG","../enums.js":"4QiBx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8TLRM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBasePlacement;
});
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split("-")[0];
}

},{"../enums.js":"4QiBx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dirTn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getVariation;
});
function getVariation(placement) {
    return placement.split("-")[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eBVyG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMainAxisFromPlacement;
});
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dD2RQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergePaddingObject;
});
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"g2o7z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g2o7z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getFreshSideObject;
});
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dUJvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return expandToHashMap;
});
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7GJaW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
});
parcelHelpers.export(exports, "defaultModifiers", function() {
    return defaultModifiers;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"lSi3u","./modifiers/eventListeners.js":"2raDM","./modifiers/popperOffsets.js":"8WwBt","./modifiers/computeStyles.js":"7tZRq","./modifiers/applyStyles.js":"1pW5B","./modifiers/offset.js":"7xS2J","./modifiers/flip.js":"lDiq6","./modifiers/preventOverflow.js":"6pQ1s","./modifiers/arrow.js":"1n75M","./modifiers/hide.js":"aKpFR","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2raDM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    });
    if (resize) window.addEventListener("resize", instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"14SPe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8WwBt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"chAN0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7tZRq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", function() {
    return mapToStyles;
});
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"4QiBx","../dom-utils/getOffsetParent.js":"fVxTU","../dom-utils/getWindow.js":"14SPe","../dom-utils/getDocumentElement.js":"8aWSL","../dom-utils/getComputedStyle.js":"f1Xrz","../utils/getBasePlacement.js":"8TLRM","../utils/getVariation.js":"dirTn","../utils/math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1pW5B":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect,
    requires: [
        "computeStyles"
    ]
};

},{"../dom-utils/getNodeName.js":"64qby","../dom-utils/instanceOf.js":"9tXqC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7xS2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", function() {
    return distanceAndSkiddingToXY;
});
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"8TLRM","../enums.js":"4QiBx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lDiq6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"1iadZ","../utils/getBasePlacement.js":"8TLRM","../utils/getOppositeVariationPlacement.js":"5kWAj","../utils/detectOverflow.js":"6VNQJ","../utils/computeAutoPlacement.js":"kDeZV","../enums.js":"4QiBx","../utils/getVariation.js":"dirTn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1iadZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositePlacement;
});
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5kWAj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositeVariationPlacement;
});
var hash = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kDeZV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeAutoPlacement;
});
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"dirTn","../enums.js":"4QiBx","./detectOverflow.js":"6VNQJ","./getBasePlacement.js":"8TLRM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6pQ1s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === "x" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

},{"../enums.js":"4QiBx","../utils/getBasePlacement.js":"8TLRM","../utils/getMainAxisFromPlacement.js":"eBVyG","../utils/getAltAxis.js":"4yWql","../utils/within.js":"8mxnL","../dom-utils/getLayoutRect.js":"9riWU","../dom-utils/getOffsetParent.js":"fVxTU","../utils/detectOverflow.js":"6VNQJ","../utils/getVariation.js":"dirTn","../utils/getFreshSideObject.js":"g2o7z","../utils/math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4yWql":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getAltAxis;
});
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8mxnL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", function() {
    return within;
});
parcelHelpers.export(exports, "withinMaxClamp", function() {
    return withinMaxClamp;
});
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"g1ZHU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1n75M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== "number" ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === "y" ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === "y" ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

},{"../utils/getBasePlacement.js":"8TLRM","../dom-utils/getLayoutRect.js":"9riWU","../dom-utils/contains.js":"7M2ge","../dom-utils/getOffsetParent.js":"fVxTU","../utils/getMainAxisFromPlacement.js":"eBVyG","../utils/within.js":"8mxnL","../utils/mergePaddingObject.js":"dD2RQ","../utils/expandToHashMap.js":"dUJvK","../enums.js":"4QiBx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aKpFR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};

},{"../enums.js":"4QiBx","../utils/detectOverflow.js":"6VNQJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"75r8E":[function(require,module,exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"dQzph":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", function() {
    return unwrapArray;
});
parcelHelpers.export(exports, "safeInvoke", function() {
    return safeInvoke;
});
parcelHelpers.export(exports, "setRef", function() {
    return setRef;
});
parcelHelpers.export(exports, "fromEntries", function() {
    return fromEntries;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dDS18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDatePicker", function() {
    return StyledDatePicker;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  /************************************\n  *  Default react-day-picker styling - this needed to be added because we were unable to import styling as specified by the docs (most likely because we are not using webpack)\n  *************************************/\n\n  .rdp {\n    --rdp-cell-size: 40px;\n    --rdp-accent-color: #0000ff;\n    --rdp-background-color: #e7edff;\n    --rdp-accent-color-dark: #3003e1;\n    --rdp-background-color-dark: #180270;\n    --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */\n    --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */\n\n    margin: 1em;\n  }\n\n  /* Hide elements for devices that are not screen readers */\n  .rdp-vhidden {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n    position: absolute !important;\n    top: 0;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    border: 0 !important;\n  }\n\n  /* Buttons */\n  .rdp-button_reset {\n    appearance: none;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    cursor: default;\n    color: inherit;\n    background: none;\n    font: inherit;\n\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .rdp-button_reset:focus-visible {\n    /* Make sure to reset outline only when :focus-visible is supported */\n    outline: none;\n  }\n\n  .rdp-button {\n    border: 2px solid transparent;\n  }\n\n  .rdp-button[disabled]:not(.rdp-day_selected) {\n    opacity: 0.25;\n  }\n\n  .rdp-button:not([disabled]) {\n    cursor: pointer;\n  }\n\n  .rdp-button:focus-visible:not([disabled]) {\n    color: inherit;\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n  }\n\n  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {\n    background-color: var(--rdp-background-color);\n  }\n\n  .rdp-months {\n    display: flex;\n  }\n\n  .rdp-month {\n    margin: 0 1em;\n  }\n\n  .rdp-month:first-child {\n    margin-left: 0;\n  }\n\n  .rdp-month:last-child {\n    margin-right: 0;\n  }\n\n  .rdp-table {\n    margin: 0;\n    max-width: calc(var(--rdp-cell-size) * 7);\n    border-collapse: collapse;\n  }\n\n  .rdp-with_weeknumber .rdp-table {\n    max-width: calc(var(--rdp-cell-size) * 8);\n    border-collapse: collapse;\n  }\n\n  .rdp-caption {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    text-align: left;\n  }\n\n  .rdp-multiple_months .rdp-caption {\n    position: relative;\n    display: block;\n    text-align: center;\n  }\n\n  .rdp-caption_dropdowns {\n    position: relative;\n    display: inline-flex;\n  }\n\n  .rdp-caption_label {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    padding: 0 0.25em;\n    white-space: nowrap;\n    color: currentColor;\n    border: 0;\n    border: 2px solid transparent;\n    font-family: inherit;\n    font-size: 140%;\n    font-weight: bold;\n  }\n\n  .rdp-nav {\n    white-space: nowrap;\n  }\n\n  .rdp-multiple_months .rdp-caption_start .rdp-nav {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  }\n\n  .rdp-multiple_months .rdp-caption_end .rdp-nav {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  }\n\n  .rdp-nav_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    padding: 0.25em;\n    border-radius: 100%;\n  }\n\n  /* ---------- */\n  /* Dropdowns  */\n  /* ---------- */\n\n  .rdp-dropdown_year,\n  .rdp-dropdown_month {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .rdp-dropdown {\n    appearance: none;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    cursor: inherit;\n    opacity: 0;\n    border: none;\n    background-color: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  .rdp-dropdown[disabled] {\n    opacity: unset;\n    color: unset;\n  }\n\n  .rdp-dropdown:focus-visible:not([disabled]) + .rdp-caption_label {\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n    border-radius: 6px;\n  }\n\n  .rdp-dropdown_icon {\n    margin: 0 0 0 5px;\n  }\n\n  .rdp-head {\n    border: 0;\n  }\n\n  .rdp-head_row,\n  .rdp-row {\n    height: 100%;\n  }\n\n  .rdp-head_cell {\n    vertical-align: middle;\n    font-size: 0.75em;\n    font-weight: 700;\n    text-align: center;\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n  }\n\n  .rdp-tbody {\n    border: 0;\n  }\n\n  .rdp-tfoot {\n    margin: 0.5em;\n  }\n\n  .rdp-cell {\n    width: var(--rdp-cell-size);\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    text-align: center;\n  }\n\n  .rdp-weeknumber {\n    font-size: 0.75em;\n  }\n\n  .rdp-weeknumber,\n  .rdp-day {\n    display: flex;\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: var(--rdp-cell-size);\n    max-width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    margin: 0;\n    border: 2px solid transparent;\n    border-radius: 100%;\n  }\n\n  .rdp-day_today:not(.rdp-day_outside) {\n    font-weight: bold;\n  }\n\n  .rdp-day_selected,\n  .rdp-day_selected:focus-visible,\n  .rdp-day_selected:hover {\n    color: white;\n    opacity: 1;\n    background-color: var(--rdp-accent-color);\n  }\n\n  .rdp-day_outside {\n    opacity: 0.5;\n  }\n\n  .rdp-day_selected:focus-visible {\n    /* Since the background is the same use again the outline */\n    outline: var(--rdp-outline);\n    outline-offset: 2px;\n    z-index: 1;\n  }\n\n  .rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .rdp-day_range_end.rdp-day_range_start {\n    border-radius: 100%;\n  }\n\n  .rdp-day_range_middle {\n    border-radius: 0;\n  }\n\n  /*# sourceMappingURL=style.css.map */\n\n  /******************************\n  *   Indico Custom Styling \n  *******************************/\n\n  .datepicker--inputParent {\n    position: relative;\n    width: 150px;\n  }\n\n  .datepicker-label {\n    padding: 10px 10px 10px 0;\n    color: ",
        ";\n    font-size: 14px;\n  }\n\n  .datepicker--input {\n    width: 150px;\n    border: solid ",
        " 1px;\n    border-radius: 4px;\n    text-align: center;\n    color: ",
        ";\n\n    &::placeholder {\n      opacity: 0.5;\n    }\n  }\n\n  .remove-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .remove-btn svg {\n    height: 8px;\n    margin-right: 10px;\n    width: 8px;\n  }\n\n  .remove-btn,\n  .remove-btn:hover,\n  .remove-btn:focus {\n    color: ",
        ";\n    background: transparent;\n    box-shadow: none;\n    font-size: 16px;\n    padding: 0 !important;\n  }\n\n  .DayPickerInput-Overlay {\n    background: ",
        ";\n    border-radius: 4px;\n    z-index: 999;\n    .rdp {\n      background: ",
        ";\n      z-index: 999;\n    }\n  }\n\n  .rdp-caption_label {\n    font-weight: 500;\n    font-size: 1.15em;\n  }\n\n  .rdp-button,\n  .rdp-day {\n    box-shadow: none;\n  }\n\n  .rdp-head_cell,\n  .rdp-cell {\n    border: none;\n  }\n\n  .rdp-head_cell {\n    color: ",
        ";\n  }\n\n  .rdp-day_today {\n    color: ",
        " !important;\n  }\n\n  //on hover font color\n  .rdp:not(.rdp-day_disabled)\n    .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_outside):hover {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  .rdp-day_today:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_outside) {\n    color: ",
        " !important;\n  }\n\n  .rdp-day_selected:not(.rdp-day_disabled):not(.rdp-day_outside) {\n    position: relative;\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  .rdp-day_disabled:not(.rdp-day_today) {\n    opacity: 0.3;\n  }\n\n  .rdp-day_disabled {\n    background-color: inherit !important;\n    cursor: auto !important;\n  }\n\n  .rdp-day_disabled:hover {\n    color: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDatePicker = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).baliHai, (0, _index.COLORS).white, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).mediumGray, (0, _index.COLORS).ebony, (0, _index.COLORS).mirage, (0, _index.COLORS).white, (0, _index.COLORS).red, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hxIZ2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker", function() {
    return DateRangePicker;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _focusTrapReact = require("focus-trap-react");
var _focusTrapReactDefault = parcelHelpers.interopDefault(_focusTrapReact);
var _reactPopper = require("react-popper");
var _dateFns = require("date-fns");
var _reactDayPicker = require("react-day-picker");
var _dateRangePickerStyles = require("./DateRangePicker.styles");
var _datePickerStyles = require("../DatePicker/DatePicker.styles");
var DateRangePicker = function(props) {
    var dataCy = props.dataCy, id = props.id, className = props.className, disabled = props.disabled, label = props.label, fromOnChange = props.fromOnChange, toOnChange = props.toOnChange, fromValue = props.fromValue, toValue = props.toValue, fromPlaceholder = props.fromPlaceholder, toPlaceholder = props.toPlaceholder, vertical = props.vertical, disableBeforeDate = props.disableBeforeDate, disableAfterDate = props.disableAfterDate, defaultSelected = props.defaultSelected, minRange = props.minRange, maxRange = props.maxRange;
    var initSelectedRange = function() {
        if (fromValue || toValue) return {
            from: (0, _dateFns.isValid)(fromValue) ? fromValue : undefined,
            to: (0, _dateFns.isValid)(toValue) ? toValue : undefined
        };
        return {
            from: (0, _dateFns.isValid)(defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.from) ? defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.from : undefined,
            to: (0, _dateFns.isValid)(defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.to) ? defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.to : undefined
        };
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initSelectedRange()), 2), selectedRange = _useState[0], setSelectedRange = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(fromValue) ? (0, _dateFns.format)(fromValue, "y-MM-dd") : ""), 2), fromInputValue = _useState1[0], setFromInputValue = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(toValue) ? (0, _dateFns.format)(toValue, "y-MM-dd") : ""), 2), toInputValue = _useState2[0], setToInputValue = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPopperOpen = _useState3[0], setIsPopperOpen = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(null), 2), popperElement = _useState4[0], setPopperElement = _useState4[1];
    var popperRef = (0, _react.useRef)(null);
    var popper = (0, _reactPopper.usePopper)(popperRef.current, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        10
                    ]
                }
            }
        ]
    });
    (0, _react.useEffect)(function() {
        // todo: this is problematic because it means on mount the onChange handler will always be fired
        // therefore - if the onChange is some heavy operation or call to the BE - that will automatically get called
        // without the user even doing anything
        fromOnChange(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from);
        toOnChange(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to);
    }, [
        selectedRange
    ]);
    var closePopper = function() {
        setIsPopperOpen(false);
    };
    var handleFromChange = function(e) {
        setFromInputValue(e.target.value);
        var date = (0, _dateFns.parse)(e.target.value, "y-MM-dd", new Date());
        if (!(0, _dateFns.isValid)(date)) return setSelectedRange({
            from: undefined,
            to: undefined
        });
        if ((selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to) && (0, _dateFns.isAfter)(date, selectedRange.to)) setSelectedRange({
            from: selectedRange.to,
            to: date
        });
        else setSelectedRange({
            from: date,
            to: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to
        });
    };
    var handleToChange = function(e) {
        setToInputValue(e.target.value);
        var date = (0, _dateFns.parse)(e.target.value, "y-MM-dd", new Date());
        if (!(0, _dateFns.isValid)(date)) return setSelectedRange({
            from: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from,
            to: undefined
        });
        if ((selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) && (0, _dateFns.isBefore)(date, selectedRange.from)) setSelectedRange({
            from: date,
            to: selectedRange.from
        });
        else setSelectedRange({
            from: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from,
            to: date
        });
    };
    var handleRangeSelect = function(range) {
        setSelectedRange(range);
        if (range === null || range === void 0 ? void 0 : range.from) setFromInputValue((0, _dateFns.format)(range.from, "y-MM-dd"));
        else setFromInputValue("");
        if (range === null || range === void 0 ? void 0 : range.to) {
            setToInputValue((0, _dateFns.format)(range.to, "y-MM-dd"));
            closePopper();
        } else setToInputValue("");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dateRangePickerStyles.StyledDateRangePicker), {
        id: id,
        className: className,
        "data-cy": dataCy,
        children: [
            label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "datepicker-label",
                htmlFor: "date-range-picker-inputs--".concat(id),
                children: label
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _datePickerStyles.StyledDatePicker), {
                className: (0, _classnamesDefault.default)({
                    vertical: vertical
                }),
                ref: popperRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        id: "date-range-picker-inputs--".concat(id),
                        className: "date-range-picker-inputs",
                        onClick: function() {
                            return disabled ? null : setIsPopperOpen(!isPopperOpen);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: disabled,
                                size: 10,
                                placeholder: fromPlaceholder || "From Date",
                                value: fromInputValue,
                                onChange: handleFromChange,
                                className: "datepicker--input"
                            }),
                            !vertical ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "spacer"
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                disabled: disabled,
                                size: 10,
                                placeholder: toPlaceholder || "To Date",
                                value: toInputValue,
                                onChange: handleToChange,
                                className: "datepicker--input"
                            })
                        ]
                    }),
                    isPopperOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusTrapReactDefault.default), {
                        active: true,
                        focusTrapOptions: {
                            initialFocus: false,
                            allowOutsideClick: true,
                            clickOutsideDeactivates: true,
                            onDeactivate: closePopper
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                            tabIndex: -1,
                            style: popper.styles.popper,
                            className: "DayPickerInput-Overlay"
                        }, popper.attributes.popper), {
                            ref: setPopperElement,
                            role: "dialog",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDayPicker.DayPicker), {
                                disabled: disabled,
                                mode: "range",
                                selected: selectedRange,
                                onSelect: handleRangeSelect,
                                fromDate: disableBeforeDate,
                                toDate: disableAfterDate,
                                min: minRange,
                                max: maxRange
                            })
                        }))
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","focus-trap-react":"2xNzg","react-popper":"k2Ltv","date-fns":"5C5dq","react-day-picker":"iTJs9","./DateRangePicker.styles":"aVvo2","../DatePicker/DatePicker.styles":"dDS18","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aVvo2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDateRangePicker", function() {
    return StyledDateRangePicker;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  label {\n    padding: 10px 10px 10px 0;\n    color: ",
        ";\n    font-size: 14px;\n  }\n\n  .date-range-picker-inputs {\n    display: flex;\n\n    &.vertical {\n      &,\n      .from-picker,\n      .to-picker {\n        flex-direction: column;\n      }\n    }\n\n    .spacer {\n      position: relative;\n      bottom: 5px;\n      width: 12px;\n      margin: 10px;\n      align-self: center;\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n\n  .DayPicker-Day--selected {\n    border-radius: 0;\n    opacity: 0.3;\n  }\n\n  .from-picker .DayPicker-Day--from,\n  .to-picker .DayPicker-Day--to {\n    opacity: 1;\n  }\n\n  .from-picker .DayPicker-Day--to,\n  .to-picker .DayPicker-Day--from {\n    opacity: 0.6;\n  }\n\n  .to-picker .DayPicker-Day--from,\n  .from-picker .DayPicker-Day--from {\n    border-top-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n  }\n\n  .from-picker .DayPicker-Day--to,\n  .to-picker .DayPicker-Day--to {\n    border-top-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDateRangePicker = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).lightGray);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a9WPa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KabobMenu", function() {
    return KabobMenu;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _kabobMenuStyles = require("./KabobMenu.styles");
var KabobMenu = function(param) {
    var id = param.id, className = param.className, disabled = param.disabled, _param_leftAligned = param.leftAligned, leftAligned = _param_leftAligned === void 0 ? false : _param_leftAligned, menuOptions = param.menuOptions;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var menuRef = (0, _react.useRef)(null);
    var iconButtonRef = (0, _react.useRef)(null);
    // Close the menu when clicking outside of the menu or outside of the kabob icon button
    (0, _react.useEffect)(function() {
        var listener = function(e) {
            if (!menuRef.current || !iconButtonRef.current || menuRef.current.contains(e.target) || iconButtonRef.current.contains(e.target)) return;
            setIsOpen(false);
        };
        document.addEventListener("click", listener);
        return function() {
            document.removeEventListener("click", listener);
        };
    }, [
        menuRef,
        iconButtonRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _kabobMenuStyles.StyledKabobMenu), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            "left-aligned": leftAligned
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), {
                className: (0, _classnamesDefault.default)("KabobMenu--kabob-btn", {
                    "no-background": !isOpen
                }),
                isDisabled: disabled,
                iconName: "kabob",
                label: "",
                onPress: function() {
                    return setIsOpen(!isOpen);
                },
                "data-testid": "icon-button--kabob-menu",
                ref: iconButtonRef
            }),
            isOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "KabobMenu--menu",
                ref: menuRef,
                children: menuOptions.map(function(option) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _classnamesDefault.default)("menu-item", {
                            disabled: option.disabled
                        }),
                        "data-tip": true,
                        "data-for": option.id,
                        "data-testid": "kabob-menu-item--".concat(option.id),
                        children: [
                            option.iconName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), {
                                className: "menu-item-btn",
                                isDisabled: option.disabled,
                                iconName: option.iconName,
                                label: option.label,
                                onPress: function() {
                                    option.onClick();
                                    setIsOpen(false);
                                }
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                className: "menu-item-btn",
                                disabled: option.disabled,
                                onClick: function() {
                                    option.onClick();
                                    setIsOpen(false);
                                },
                                children: option.label
                            }),
                            option.disabledText && option.disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                                for: option.id,
                                questionMark: false,
                                children: option.disabledText
                            }) : null
                        ]
                    }, option.id);
                })
            }) : null
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./KabobMenu.styles":"igIUI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"igIUI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledKabobMenu", function() {
    return StyledKabobMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin-top: 5px;\n  position: relative;\n  z-index: 3;\n\n  .KabobMenu--kabob-btn {\n    box-shadow: none;\n    padding: 0 8px !important;\n    margin-bottom: 5px;\n\n    svg {\n      height: 20px;\n      margin: 0;\n      width: 20px;\n    }\n\n    &.no-background {\n      background: transparent !important;\n    }\n  }\n\n  .KabobMenu--menu {\n    border-radius: 2px;\n    display: inline-block;\n    min-width: 150px;\n    position: absolute;\n    top: 40px;\n    z-index: 4;\n\n    .menu-item {\n      height: 36px;\n\n      .menu-item-btn,\n      .menu-item-btn:disabled {\n        background: transparent !important;\n        box-shadow: none;\n        color: ",
        ";\n        margin: 0;\n        width: 100%;\n      }\n\n      &:first-child {\n        border-radius: 2px 2px 0 0;\n      }\n\n      &:last-child {\n        border-radius: 0 0 2px 2px;\n      }\n\n      .menu-item-btn:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .KabobMenu--kabob-btn,\n  .KabobMenu--kabob-btn:focus,\n  .KabobMenu--menu,\n  .KabobMenu--menu .menu-item.disabled {\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .KabobMenu--kabob-btn:hover,\n  .KabobMenu--menu .menu-item:hover {\n    background: ",
        ";\n  }\n\n  &.left-aligned {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledKabobMenu = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).white, (0, _index.COLORS).comet);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gLGqS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Technically a Menu and Menu Button, this component offers a list
 * of actions for the user to choose from.
 *
 * This component should not be used for navigation.
 *
 * https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton
 */ parcelHelpers.export(exports, "MenuButton", function() {
    return MenuButton;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _keycodeJs = require("keycode-js");
var _index = require("Permafrost/index");
var _menuButtonStyles = require("./MenuButton.styles");
function MenuButton(props) {
    var className = props.className, disabled = props.disabled, id = props.id, open = props.open, options = props.options, processing = props.processing, _props_size = props.size, size = _props_size === void 0 ? "normal" : _props_size, title = props.title;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(open || false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var buttonEl = (0, _react.useRef)(null);
    var menuEl = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var menuItems;
        var handleKeyPress = function(ev) {
            if (!menuItems) return null;
            var activeElement = document.activeElement;
            var firstItem = menuItems[0];
            var lastItem = menuItems[menuItems.length - 1];
            var nextSibling = activeElement.nextElementSibling;
            var previousSibling = activeElement.previousElementSibling;
            // up and down arrow keys will cycle through the different options
            if (ev.key === _keycodeJs.VALUE_DOWN) {
                if (activeElement !== lastItem) nextSibling.focus();
                else firstItem.focus();
            } else if (ev.key === _keycodeJs.VALUE_UP) {
                if (activeElement !== firstItem) previousSibling.focus();
                else lastItem.focus();
            }
            if (ev.key === _keycodeJs.VALUE_ESCAPE) closeMenu();
        };
        // once the menu opens, any click should close it
        var handleMenuOpenClick = function() {
            closeMenu();
        };
        if (isOpen) {
            // add click event listener after the current event loop completes to avoid closing the menu immediately
            setTimeout(function() {
                window.addEventListener("click", handleMenuOpenClick);
            }, 0);
            window.addEventListener("keydown", handleKeyPress);
            if (menuEl.current) {
                menuItems = menuEl.current.querySelectorAll("button");
                menuItems[0].focus();
            }
        }
        return function() {
            var _buttonEl_current;
            window.removeEventListener("keydown", handleKeyPress);
            window.removeEventListener("click", handleMenuOpenClick);
            (_buttonEl_current = buttonEl.current) === null || _buttonEl_current === void 0 ? void 0 : _buttonEl_current.focus();
        };
    }, [
        isOpen
    ]);
    var openMenu = function() {
        setIsOpen(true);
    };
    var closeMenu = function() {
        setIsOpen(false);
    };
    var toggleMenu = function() {
        isOpen ? closeMenu() : openMenu();
    };
    var handleOptionClick = function(option) {
        props.handleSelection(option);
    };
    var processingText = typeof processing === "string" ? processing : "Processing";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuButtonStyles.StyledMenuButton), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuButtonStyles.StyledButton), {
                ref: buttonEl,
                type: "button",
                "aria-haspopup": true,
                "aria-expanded": isOpen,
                className: (0, _classnamesDefault.default)(processing, size),
                disabled: disabled,
                onClick: toggleMenu,
                children: [
                    processing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-cy": "menuTitleSpan",
                        className: "menuButtonTitle",
                        "aria-live": "polite",
                        children: !!processing ? processingText : title
                    }),
                    !processing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "caret",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-caret-down",
                            size: [
                                "1.2em"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuButtonStyles.StyledMenu), {
                ref: menuEl,
                role: "menu",
                className: isOpen ? "open" : "",
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        "data-cy": "menuItemBtn",
                        type: "button",
                        role: "menuitem",
                        tabIndex: -1,
                        onClick: function() {
                            return handleOptionClick(option.value);
                        },
                        children: option.text
                    }, option.value);
                })
            })
        ]
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","keycode-js":"hBBfN","Permafrost/index":"iliLC","./MenuButton.styles":"3trSh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hBBfN":[function(require,module,exports) {
// Key code constants
// Available values for `KeyboardEvent.keyCode` attribute.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CODE_0", function() {
    return CODE_0;
});
parcelHelpers.export(exports, "CODE_1", function() {
    return CODE_1;
});
parcelHelpers.export(exports, "CODE_2", function() {
    return CODE_2;
});
parcelHelpers.export(exports, "CODE_3", function() {
    return CODE_3;
});
parcelHelpers.export(exports, "CODE_4", function() {
    return CODE_4;
});
parcelHelpers.export(exports, "CODE_5", function() {
    return CODE_5;
});
parcelHelpers.export(exports, "CODE_6", function() {
    return CODE_6;
});
parcelHelpers.export(exports, "CODE_7", function() {
    return CODE_7;
});
parcelHelpers.export(exports, "CODE_8", function() {
    return CODE_8;
});
parcelHelpers.export(exports, "CODE_9", function() {
    return CODE_9;
});
parcelHelpers.export(exports, "CODE_A", function() {
    return CODE_A;
});
parcelHelpers.export(exports, "CODE_ALT_LEFT", function() {
    return CODE_ALT_LEFT;
});
parcelHelpers.export(exports, "CODE_ALT_RIGHT", function() {
    return CODE_ALT_RIGHT;
});
parcelHelpers.export(exports, "CODE_B", function() {
    return CODE_B;
});
parcelHelpers.export(exports, "CODE_BACK_QUOTE", function() {
    return CODE_BACK_QUOTE;
});
parcelHelpers.export(exports, "CODE_BACK_SLASH", function() {
    return CODE_BACK_SLASH;
});
parcelHelpers.export(exports, "CODE_BACK_SPACE", function() {
    return CODE_BACK_SPACE;
});
parcelHelpers.export(exports, "CODE_C", function() {
    return CODE_C;
});
parcelHelpers.export(exports, "CODE_CAPS_LOCK", function() {
    return CODE_CAPS_LOCK;
});
parcelHelpers.export(exports, "CODE_CLOSE_BRACKET", function() {
    return CODE_CLOSE_BRACKET;
});
parcelHelpers.export(exports, "CODE_COMMA", function() {
    return CODE_COMMA;
});
parcelHelpers.export(exports, "CODE_CONTEXT_MENU", function() {
    return CODE_CONTEXT_MENU;
});
parcelHelpers.export(exports, "CODE_CONTROL_LEFT", function() {
    return CODE_CONTROL_LEFT;
});
parcelHelpers.export(exports, "CODE_CONTROL_RIGHT", function() {
    return CODE_CONTROL_RIGHT;
});
parcelHelpers.export(exports, "CODE_D", function() {
    return CODE_D;
});
parcelHelpers.export(exports, "CODE_DASH", function() {
    return CODE_DASH;
});
parcelHelpers.export(exports, "CODE_DELETE", function() {
    return CODE_DELETE;
});
parcelHelpers.export(exports, "CODE_DOWN", function() {
    return CODE_DOWN;
});
parcelHelpers.export(exports, "CODE_E", function() {
    return CODE_E;
});
parcelHelpers.export(exports, "CODE_END", function() {
    return CODE_END;
});
parcelHelpers.export(exports, "CODE_ENTER", function() {
    return CODE_ENTER;
});
parcelHelpers.export(exports, "CODE_EQUALS", function() {
    return CODE_EQUALS;
});
parcelHelpers.export(exports, "CODE_ESCAPE", function() {
    return CODE_ESCAPE;
});
parcelHelpers.export(exports, "CODE_F", function() {
    return CODE_F;
});
parcelHelpers.export(exports, "CODE_F1", function() {
    return CODE_F1;
});
parcelHelpers.export(exports, "CODE_F10", function() {
    return CODE_F10;
});
parcelHelpers.export(exports, "CODE_F11", function() {
    return CODE_F11;
});
parcelHelpers.export(exports, "CODE_F12", function() {
    return CODE_F12;
});
parcelHelpers.export(exports, "CODE_F13", function() {
    return CODE_F13;
});
parcelHelpers.export(exports, "CODE_F14", function() {
    return CODE_F14;
});
parcelHelpers.export(exports, "CODE_F15", function() {
    return CODE_F15;
});
parcelHelpers.export(exports, "CODE_F16", function() {
    return CODE_F16;
});
parcelHelpers.export(exports, "CODE_F17", function() {
    return CODE_F17;
});
parcelHelpers.export(exports, "CODE_F18", function() {
    return CODE_F18;
});
parcelHelpers.export(exports, "CODE_F19", function() {
    return CODE_F19;
});
parcelHelpers.export(exports, "CODE_F2", function() {
    return CODE_F2;
});
parcelHelpers.export(exports, "CODE_F20", function() {
    return CODE_F20;
});
parcelHelpers.export(exports, "CODE_F21", function() {
    return CODE_F21;
});
parcelHelpers.export(exports, "CODE_F22", function() {
    return CODE_F22;
});
parcelHelpers.export(exports, "CODE_F23", function() {
    return CODE_F23;
});
parcelHelpers.export(exports, "CODE_F24", function() {
    return CODE_F24;
});
parcelHelpers.export(exports, "CODE_F3", function() {
    return CODE_F3;
});
parcelHelpers.export(exports, "CODE_F4", function() {
    return CODE_F4;
});
parcelHelpers.export(exports, "CODE_F5", function() {
    return CODE_F5;
});
parcelHelpers.export(exports, "CODE_F6", function() {
    return CODE_F6;
});
parcelHelpers.export(exports, "CODE_F7", function() {
    return CODE_F7;
});
parcelHelpers.export(exports, "CODE_F8", function() {
    return CODE_F8;
});
parcelHelpers.export(exports, "CODE_F9", function() {
    return CODE_F9;
});
parcelHelpers.export(exports, "CODE_G", function() {
    return CODE_G;
});
parcelHelpers.export(exports, "CODE_H", function() {
    return CODE_H;
});
parcelHelpers.export(exports, "CODE_HOME", function() {
    return CODE_HOME;
});
parcelHelpers.export(exports, "CODE_I", function() {
    return CODE_I;
});
parcelHelpers.export(exports, "CODE_INSERT", function() {
    return CODE_INSERT;
});
parcelHelpers.export(exports, "CODE_J", function() {
    return CODE_J;
});
parcelHelpers.export(exports, "CODE_K", function() {
    return CODE_K;
});
parcelHelpers.export(exports, "CODE_L", function() {
    return CODE_L;
});
parcelHelpers.export(exports, "CODE_LEFT", function() {
    return CODE_LEFT;
});
parcelHelpers.export(exports, "CODE_M", function() {
    return CODE_M;
});
parcelHelpers.export(exports, "CODE_META_LEFT", function() {
    return CODE_META_LEFT;
});
parcelHelpers.export(exports, "CODE_META_RIGHT", function() {
    return CODE_META_RIGHT;
});
parcelHelpers.export(exports, "CODE_MINUS", function() {
    return CODE_MINUS;
});
parcelHelpers.export(exports, "CODE_N", function() {
    return CODE_N;
});
parcelHelpers.export(exports, "CODE_NUMPAD0", function() {
    return CODE_NUMPAD0;
});
parcelHelpers.export(exports, "CODE_NUMPAD1", function() {
    return CODE_NUMPAD1;
});
parcelHelpers.export(exports, "CODE_NUMPAD2", function() {
    return CODE_NUMPAD2;
});
parcelHelpers.export(exports, "CODE_NUMPAD3", function() {
    return CODE_NUMPAD3;
});
parcelHelpers.export(exports, "CODE_NUMPAD4", function() {
    return CODE_NUMPAD4;
});
parcelHelpers.export(exports, "CODE_NUMPAD5", function() {
    return CODE_NUMPAD5;
});
parcelHelpers.export(exports, "CODE_NUMPAD6", function() {
    return CODE_NUMPAD6;
});
parcelHelpers.export(exports, "CODE_NUMPAD7", function() {
    return CODE_NUMPAD7;
});
parcelHelpers.export(exports, "CODE_NUMPAD8", function() {
    return CODE_NUMPAD8;
});
parcelHelpers.export(exports, "CODE_NUMPAD9", function() {
    return CODE_NUMPAD9;
});
parcelHelpers.export(exports, "CODE_NUMPAD_ADD", function() {
    return CODE_NUMPAD_ADD;
});
parcelHelpers.export(exports, "CODE_NUMPAD_DECIMAL", function() {
    return CODE_NUMPAD_DECIMAL;
});
parcelHelpers.export(exports, "CODE_NUMPAD_DIVIDE", function() {
    return CODE_NUMPAD_DIVIDE;
});
parcelHelpers.export(exports, "CODE_NUMPAD_ENTER", function() {
    return CODE_NUMPAD_ENTER;
});
parcelHelpers.export(exports, "CODE_NUMPAD_MULTIPLY", function() {
    return CODE_NUMPAD_MULTIPLY;
});
parcelHelpers.export(exports, "CODE_NUMPAD_SUBTRACT", function() {
    return CODE_NUMPAD_SUBTRACT;
});
parcelHelpers.export(exports, "CODE_NUM_LOCK", function() {
    return CODE_NUM_LOCK;
});
parcelHelpers.export(exports, "CODE_O", function() {
    return CODE_O;
});
parcelHelpers.export(exports, "CODE_OPEN_BRACKET", function() {
    return CODE_OPEN_BRACKET;
});
parcelHelpers.export(exports, "CODE_OS_LEFT", function() {
    return CODE_OS_LEFT;
});
parcelHelpers.export(exports, "CODE_OS_RIGHT", function() {
    return CODE_OS_RIGHT;
});
parcelHelpers.export(exports, "CODE_P", function() {
    return CODE_P;
});
parcelHelpers.export(exports, "CODE_PAGE_DOWN", function() {
    return CODE_PAGE_DOWN;
});
parcelHelpers.export(exports, "CODE_PAGE_UP", function() {
    return CODE_PAGE_UP;
});
parcelHelpers.export(exports, "CODE_PAUSE", function() {
    return CODE_PAUSE;
});
parcelHelpers.export(exports, "CODE_PERIOD", function() {
    return CODE_PERIOD;
});
parcelHelpers.export(exports, "CODE_PRINTSCREEN", function() {
    return CODE_PRINTSCREEN;
});
parcelHelpers.export(exports, "CODE_Q", function() {
    return CODE_Q;
});
parcelHelpers.export(exports, "CODE_QUOTE", function() {
    return CODE_QUOTE;
});
parcelHelpers.export(exports, "CODE_R", function() {
    return CODE_R;
});
parcelHelpers.export(exports, "CODE_RETURN", function() {
    return CODE_RETURN;
});
parcelHelpers.export(exports, "CODE_RIGHT", function() {
    return CODE_RIGHT;
});
parcelHelpers.export(exports, "CODE_S", function() {
    return CODE_S;
});
parcelHelpers.export(exports, "CODE_SCROLL_LOCK", function() {
    return CODE_SCROLL_LOCK;
});
parcelHelpers.export(exports, "CODE_SEMICOLON", function() {
    return CODE_SEMICOLON;
});
parcelHelpers.export(exports, "CODE_SHIFT_LEFT", function() {
    return CODE_SHIFT_LEFT;
});
parcelHelpers.export(exports, "CODE_SHIFT_RIGHT", function() {
    return CODE_SHIFT_RIGHT;
});
parcelHelpers.export(exports, "CODE_SLASH", function() {
    return CODE_SLASH;
});
parcelHelpers.export(exports, "CODE_SPACE", function() {
    return CODE_SPACE;
});
parcelHelpers.export(exports, "CODE_T", function() {
    return CODE_T;
});
parcelHelpers.export(exports, "CODE_TAB", function() {
    return CODE_TAB;
});
parcelHelpers.export(exports, "CODE_U", function() {
    return CODE_U;
});
parcelHelpers.export(exports, "CODE_UNIDENTIFIED", function() {
    return CODE_UNIDENTIFIED;
});
parcelHelpers.export(exports, "CODE_UP", function() {
    return CODE_UP;
});
parcelHelpers.export(exports, "CODE_V", function() {
    return CODE_V;
});
parcelHelpers.export(exports, "CODE_W", function() {
    return CODE_W;
});
parcelHelpers.export(exports, "CODE_X", function() {
    return CODE_X;
});
parcelHelpers.export(exports, "CODE_Y", function() {
    return CODE_Y;
});
parcelHelpers.export(exports, "CODE_Z", function() {
    return CODE_Z;
});
parcelHelpers.export(exports, "KEY_0", function() {
    return KEY_0;
});
parcelHelpers.export(exports, "KEY_1", function() {
    return KEY_1;
});
parcelHelpers.export(exports, "KEY_2", function() {
    return KEY_2;
});
parcelHelpers.export(exports, "KEY_3", function() {
    return KEY_3;
});
parcelHelpers.export(exports, "KEY_4", function() {
    return KEY_4;
});
parcelHelpers.export(exports, "KEY_5", function() {
    return KEY_5;
});
parcelHelpers.export(exports, "KEY_6", function() {
    return KEY_6;
});
parcelHelpers.export(exports, "KEY_7", function() {
    return KEY_7;
});
parcelHelpers.export(exports, "KEY_8", function() {
    return KEY_8;
});
parcelHelpers.export(exports, "KEY_9", function() {
    return KEY_9;
});
parcelHelpers.export(exports, "KEY_A", function() {
    return KEY_A;
});
parcelHelpers.export(exports, "KEY_ADD", function() {
    return KEY_ADD;
});
parcelHelpers.export(exports, "KEY_ALT", function() {
    return KEY_ALT;
});
parcelHelpers.export(exports, "KEY_B", function() {
    return KEY_B;
});
parcelHelpers.export(exports, "KEY_BACK_QUOTE", function() {
    return KEY_BACK_QUOTE;
});
parcelHelpers.export(exports, "KEY_BACK_SLASH", function() {
    return KEY_BACK_SLASH;
});
parcelHelpers.export(exports, "KEY_BACK_SPACE", function() {
    return KEY_BACK_SPACE;
});
parcelHelpers.export(exports, "KEY_C", function() {
    return KEY_C;
});
parcelHelpers.export(exports, "KEY_CANCEL", function() {
    return KEY_CANCEL;
});
parcelHelpers.export(exports, "KEY_CAPS_LOCK", function() {
    return KEY_CAPS_LOCK;
});
parcelHelpers.export(exports, "KEY_CLEAR", function() {
    return KEY_CLEAR;
});
parcelHelpers.export(exports, "KEY_CLOSE_BRACKET", function() {
    return KEY_CLOSE_BRACKET;
});
parcelHelpers.export(exports, "KEY_COMMA", function() {
    return KEY_COMMA;
});
parcelHelpers.export(exports, "KEY_CONTEXT_MENU", function() {
    return KEY_CONTEXT_MENU;
});
parcelHelpers.export(exports, "KEY_CONTROL", function() {
    return KEY_CONTROL;
});
parcelHelpers.export(exports, "KEY_D", function() {
    return KEY_D;
});
parcelHelpers.export(exports, "KEY_DASH", function() {
    return KEY_DASH;
});
parcelHelpers.export(exports, "KEY_DECIMAL", function() {
    return KEY_DECIMAL;
});
parcelHelpers.export(exports, "KEY_DELETE", function() {
    return KEY_DELETE;
});
parcelHelpers.export(exports, "KEY_DIVIDE", function() {
    return KEY_DIVIDE;
});
parcelHelpers.export(exports, "KEY_DOWN", function() {
    return KEY_DOWN;
});
parcelHelpers.export(exports, "KEY_E", function() {
    return KEY_E;
});
parcelHelpers.export(exports, "KEY_END", function() {
    return KEY_END;
});
parcelHelpers.export(exports, "KEY_EQUALS", function() {
    return KEY_EQUALS;
});
parcelHelpers.export(exports, "KEY_ESCAPE", function() {
    return KEY_ESCAPE;
});
parcelHelpers.export(exports, "KEY_F", function() {
    return KEY_F;
});
parcelHelpers.export(exports, "KEY_F1", function() {
    return KEY_F1;
});
parcelHelpers.export(exports, "KEY_F10", function() {
    return KEY_F10;
});
parcelHelpers.export(exports, "KEY_F11", function() {
    return KEY_F11;
});
parcelHelpers.export(exports, "KEY_F12", function() {
    return KEY_F12;
});
parcelHelpers.export(exports, "KEY_F13", function() {
    return KEY_F13;
});
parcelHelpers.export(exports, "KEY_F14", function() {
    return KEY_F14;
});
parcelHelpers.export(exports, "KEY_F15", function() {
    return KEY_F15;
});
parcelHelpers.export(exports, "KEY_F16", function() {
    return KEY_F16;
});
parcelHelpers.export(exports, "KEY_F17", function() {
    return KEY_F17;
});
parcelHelpers.export(exports, "KEY_F18", function() {
    return KEY_F18;
});
parcelHelpers.export(exports, "KEY_F19", function() {
    return KEY_F19;
});
parcelHelpers.export(exports, "KEY_F2", function() {
    return KEY_F2;
});
parcelHelpers.export(exports, "KEY_F20", function() {
    return KEY_F20;
});
parcelHelpers.export(exports, "KEY_F21", function() {
    return KEY_F21;
});
parcelHelpers.export(exports, "KEY_F22", function() {
    return KEY_F22;
});
parcelHelpers.export(exports, "KEY_F23", function() {
    return KEY_F23;
});
parcelHelpers.export(exports, "KEY_F24", function() {
    return KEY_F24;
});
parcelHelpers.export(exports, "KEY_F3", function() {
    return KEY_F3;
});
parcelHelpers.export(exports, "KEY_F4", function() {
    return KEY_F4;
});
parcelHelpers.export(exports, "KEY_F5", function() {
    return KEY_F5;
});
parcelHelpers.export(exports, "KEY_F6", function() {
    return KEY_F6;
});
parcelHelpers.export(exports, "KEY_F7", function() {
    return KEY_F7;
});
parcelHelpers.export(exports, "KEY_F8", function() {
    return KEY_F8;
});
parcelHelpers.export(exports, "KEY_F9", function() {
    return KEY_F9;
});
parcelHelpers.export(exports, "KEY_FIREFOX_ENTER", function() {
    return KEY_FIREFOX_ENTER;
});
parcelHelpers.export(exports, "KEY_FIREFOX_EQUALS", function() {
    return KEY_FIREFOX_EQUALS;
});
parcelHelpers.export(exports, "KEY_FIREFOX_META", function() {
    return KEY_FIREFOX_META;
});
parcelHelpers.export(exports, "KEY_FIREFOX_SEMICOLON", function() {
    return KEY_FIREFOX_SEMICOLON;
});
parcelHelpers.export(exports, "KEY_FIREFOX_SEPARATOR", function() {
    return KEY_FIREFOX_SEPARATOR;
});
parcelHelpers.export(exports, "KEY_G", function() {
    return KEY_G;
});
parcelHelpers.export(exports, "KEY_H", function() {
    return KEY_H;
});
parcelHelpers.export(exports, "KEY_HELP", function() {
    return KEY_HELP;
});
parcelHelpers.export(exports, "KEY_HOME", function() {
    return KEY_HOME;
});
parcelHelpers.export(exports, "KEY_I", function() {
    return KEY_I;
});
parcelHelpers.export(exports, "KEY_INSERT", function() {
    return KEY_INSERT;
});
parcelHelpers.export(exports, "KEY_J", function() {
    return KEY_J;
});
parcelHelpers.export(exports, "KEY_K", function() {
    return KEY_K;
});
parcelHelpers.export(exports, "KEY_L", function() {
    return KEY_L;
});
parcelHelpers.export(exports, "KEY_LEFT", function() {
    return KEY_LEFT;
});
parcelHelpers.export(exports, "KEY_LEFT_CMD", function() {
    return KEY_LEFT_CMD;
});
parcelHelpers.export(exports, "KEY_M", function() {
    return KEY_M;
});
parcelHelpers.export(exports, "KEY_MULTIPLY", function() {
    return KEY_MULTIPLY;
});
parcelHelpers.export(exports, "KEY_N", function() {
    return KEY_N;
});
parcelHelpers.export(exports, "KEY_NUMPAD0", function() {
    return KEY_NUMPAD0;
});
parcelHelpers.export(exports, "KEY_NUMPAD1", function() {
    return KEY_NUMPAD1;
});
parcelHelpers.export(exports, "KEY_NUMPAD2", function() {
    return KEY_NUMPAD2;
});
parcelHelpers.export(exports, "KEY_NUMPAD3", function() {
    return KEY_NUMPAD3;
});
parcelHelpers.export(exports, "KEY_NUMPAD4", function() {
    return KEY_NUMPAD4;
});
parcelHelpers.export(exports, "KEY_NUMPAD5", function() {
    return KEY_NUMPAD5;
});
parcelHelpers.export(exports, "KEY_NUMPAD6", function() {
    return KEY_NUMPAD6;
});
parcelHelpers.export(exports, "KEY_NUMPAD7", function() {
    return KEY_NUMPAD7;
});
parcelHelpers.export(exports, "KEY_NUMPAD8", function() {
    return KEY_NUMPAD8;
});
parcelHelpers.export(exports, "KEY_NUMPAD9", function() {
    return KEY_NUMPAD9;
});
parcelHelpers.export(exports, "KEY_NUM_LOCK", function() {
    return KEY_NUM_LOCK;
});
parcelHelpers.export(exports, "KEY_O", function() {
    return KEY_O;
});
parcelHelpers.export(exports, "KEY_OPEN_BRACKET", function() {
    return KEY_OPEN_BRACKET;
});
parcelHelpers.export(exports, "KEY_P", function() {
    return KEY_P;
});
parcelHelpers.export(exports, "KEY_PAGE_DOWN", function() {
    return KEY_PAGE_DOWN;
});
parcelHelpers.export(exports, "KEY_PAGE_UP", function() {
    return KEY_PAGE_UP;
});
parcelHelpers.export(exports, "KEY_PAUSE", function() {
    return KEY_PAUSE;
});
parcelHelpers.export(exports, "KEY_PERIOD", function() {
    return KEY_PERIOD;
});
parcelHelpers.export(exports, "KEY_PRINTSCREEN", function() {
    return KEY_PRINTSCREEN;
});
parcelHelpers.export(exports, "KEY_Q", function() {
    return KEY_Q;
});
parcelHelpers.export(exports, "KEY_QUOTE", function() {
    return KEY_QUOTE;
});
parcelHelpers.export(exports, "KEY_R", function() {
    return KEY_R;
});
parcelHelpers.export(exports, "KEY_RETURN", function() {
    return KEY_RETURN;
});
parcelHelpers.export(exports, "KEY_RIGHT", function() {
    return KEY_RIGHT;
});
parcelHelpers.export(exports, "KEY_RIGHT_CMD", function() {
    return KEY_RIGHT_CMD;
});
parcelHelpers.export(exports, "KEY_S", function() {
    return KEY_S;
});
parcelHelpers.export(exports, "KEY_SCROLL_LOCK", function() {
    return KEY_SCROLL_LOCK;
});
parcelHelpers.export(exports, "KEY_SEMICOLON", function() {
    return KEY_SEMICOLON;
});
parcelHelpers.export(exports, "KEY_SHIFT", function() {
    return KEY_SHIFT;
});
parcelHelpers.export(exports, "KEY_SLASH", function() {
    return KEY_SLASH;
});
parcelHelpers.export(exports, "KEY_SPACE", function() {
    return KEY_SPACE;
});
parcelHelpers.export(exports, "KEY_SUBTRACT", function() {
    return KEY_SUBTRACT;
});
parcelHelpers.export(exports, "KEY_T", function() {
    return KEY_T;
});
parcelHelpers.export(exports, "KEY_TAB", function() {
    return KEY_TAB;
});
parcelHelpers.export(exports, "KEY_U", function() {
    return KEY_U;
});
parcelHelpers.export(exports, "KEY_UP", function() {
    return KEY_UP;
});
parcelHelpers.export(exports, "KEY_V", function() {
    return KEY_V;
});
parcelHelpers.export(exports, "KEY_W", function() {
    return KEY_W;
});
parcelHelpers.export(exports, "KEY_X", function() {
    return KEY_X;
});
parcelHelpers.export(exports, "KEY_Y", function() {
    return KEY_Y;
});
parcelHelpers.export(exports, "KEY_Z", function() {
    return KEY_Z;
});
parcelHelpers.export(exports, "VALUE_0", function() {
    return VALUE_0;
});
parcelHelpers.export(exports, "VALUE_1", function() {
    return VALUE_1;
});
parcelHelpers.export(exports, "VALUE_2", function() {
    return VALUE_2;
});
parcelHelpers.export(exports, "VALUE_3", function() {
    return VALUE_3;
});
parcelHelpers.export(exports, "VALUE_4", function() {
    return VALUE_4;
});
parcelHelpers.export(exports, "VALUE_5", function() {
    return VALUE_5;
});
parcelHelpers.export(exports, "VALUE_6", function() {
    return VALUE_6;
});
parcelHelpers.export(exports, "VALUE_7", function() {
    return VALUE_7;
});
parcelHelpers.export(exports, "VALUE_8", function() {
    return VALUE_8;
});
parcelHelpers.export(exports, "VALUE_9", function() {
    return VALUE_9;
});
parcelHelpers.export(exports, "VALUE_A", function() {
    return VALUE_A;
});
parcelHelpers.export(exports, "VALUE_ADD", function() {
    return VALUE_ADD;
});
parcelHelpers.export(exports, "VALUE_ALT", function() {
    return VALUE_ALT;
});
parcelHelpers.export(exports, "VALUE_B", function() {
    return VALUE_B;
});
parcelHelpers.export(exports, "VALUE_BACK_QUOTE", function() {
    return VALUE_BACK_QUOTE;
});
parcelHelpers.export(exports, "VALUE_BACK_SLASH", function() {
    return VALUE_BACK_SLASH;
});
parcelHelpers.export(exports, "VALUE_BACK_SPACE", function() {
    return VALUE_BACK_SPACE;
});
parcelHelpers.export(exports, "VALUE_C", function() {
    return VALUE_C;
});
parcelHelpers.export(exports, "VALUE_CANCEL", function() {
    return VALUE_CANCEL;
});
parcelHelpers.export(exports, "VALUE_CAPS_LOCK", function() {
    return VALUE_CAPS_LOCK;
});
parcelHelpers.export(exports, "VALUE_CLEAR", function() {
    return VALUE_CLEAR;
});
parcelHelpers.export(exports, "VALUE_CLOSE_BRACKET", function() {
    return VALUE_CLOSE_BRACKET;
});
parcelHelpers.export(exports, "VALUE_COMMA", function() {
    return VALUE_COMMA;
});
parcelHelpers.export(exports, "VALUE_CONTEXT_MENU", function() {
    return VALUE_CONTEXT_MENU;
});
parcelHelpers.export(exports, "VALUE_CONTROL", function() {
    return VALUE_CONTROL;
});
parcelHelpers.export(exports, "VALUE_D", function() {
    return VALUE_D;
});
parcelHelpers.export(exports, "VALUE_DASH", function() {
    return VALUE_DASH;
});
parcelHelpers.export(exports, "VALUE_DECIMAL", function() {
    return VALUE_DECIMAL;
});
parcelHelpers.export(exports, "VALUE_DELETE", function() {
    return VALUE_DELETE;
});
parcelHelpers.export(exports, "VALUE_DIVIDE", function() {
    return VALUE_DIVIDE;
});
parcelHelpers.export(exports, "VALUE_DOWN", function() {
    return VALUE_DOWN;
});
parcelHelpers.export(exports, "VALUE_E", function() {
    return VALUE_E;
});
parcelHelpers.export(exports, "VALUE_END", function() {
    return VALUE_END;
});
parcelHelpers.export(exports, "VALUE_ENTER", function() {
    return VALUE_ENTER;
});
parcelHelpers.export(exports, "VALUE_EQUALS", function() {
    return VALUE_EQUALS;
});
parcelHelpers.export(exports, "VALUE_ESCAPE", function() {
    return VALUE_ESCAPE;
});
parcelHelpers.export(exports, "VALUE_F", function() {
    return VALUE_F;
});
parcelHelpers.export(exports, "VALUE_F1", function() {
    return VALUE_F1;
});
parcelHelpers.export(exports, "VALUE_F10", function() {
    return VALUE_F10;
});
parcelHelpers.export(exports, "VALUE_F11", function() {
    return VALUE_F11;
});
parcelHelpers.export(exports, "VALUE_F12", function() {
    return VALUE_F12;
});
parcelHelpers.export(exports, "VALUE_F13", function() {
    return VALUE_F13;
});
parcelHelpers.export(exports, "VALUE_F14", function() {
    return VALUE_F14;
});
parcelHelpers.export(exports, "VALUE_F15", function() {
    return VALUE_F15;
});
parcelHelpers.export(exports, "VALUE_F16", function() {
    return VALUE_F16;
});
parcelHelpers.export(exports, "VALUE_F17", function() {
    return VALUE_F17;
});
parcelHelpers.export(exports, "VALUE_F18", function() {
    return VALUE_F18;
});
parcelHelpers.export(exports, "VALUE_F19", function() {
    return VALUE_F19;
});
parcelHelpers.export(exports, "VALUE_F2", function() {
    return VALUE_F2;
});
parcelHelpers.export(exports, "VALUE_F20", function() {
    return VALUE_F20;
});
parcelHelpers.export(exports, "VALUE_F21", function() {
    return VALUE_F21;
});
parcelHelpers.export(exports, "VALUE_F22", function() {
    return VALUE_F22;
});
parcelHelpers.export(exports, "VALUE_F23", function() {
    return VALUE_F23;
});
parcelHelpers.export(exports, "VALUE_F24", function() {
    return VALUE_F24;
});
parcelHelpers.export(exports, "VALUE_F3", function() {
    return VALUE_F3;
});
parcelHelpers.export(exports, "VALUE_F4", function() {
    return VALUE_F4;
});
parcelHelpers.export(exports, "VALUE_F5", function() {
    return VALUE_F5;
});
parcelHelpers.export(exports, "VALUE_F6", function() {
    return VALUE_F6;
});
parcelHelpers.export(exports, "VALUE_F7", function() {
    return VALUE_F7;
});
parcelHelpers.export(exports, "VALUE_F8", function() {
    return VALUE_F8;
});
parcelHelpers.export(exports, "VALUE_F9", function() {
    return VALUE_F9;
});
parcelHelpers.export(exports, "VALUE_G", function() {
    return VALUE_G;
});
parcelHelpers.export(exports, "VALUE_H", function() {
    return VALUE_H;
});
parcelHelpers.export(exports, "VALUE_HELP", function() {
    return VALUE_HELP;
});
parcelHelpers.export(exports, "VALUE_HOME", function() {
    return VALUE_HOME;
});
parcelHelpers.export(exports, "VALUE_I", function() {
    return VALUE_I;
});
parcelHelpers.export(exports, "VALUE_INSERT", function() {
    return VALUE_INSERT;
});
parcelHelpers.export(exports, "VALUE_J", function() {
    return VALUE_J;
});
parcelHelpers.export(exports, "VALUE_K", function() {
    return VALUE_K;
});
parcelHelpers.export(exports, "VALUE_L", function() {
    return VALUE_L;
});
parcelHelpers.export(exports, "VALUE_LEFT", function() {
    return VALUE_LEFT;
});
parcelHelpers.export(exports, "VALUE_LEFT_CMD", function() {
    return VALUE_LEFT_CMD;
});
parcelHelpers.export(exports, "VALUE_M", function() {
    return VALUE_M;
});
parcelHelpers.export(exports, "VALUE_META", function() {
    return VALUE_META;
});
parcelHelpers.export(exports, "VALUE_MULTIPLY", function() {
    return VALUE_MULTIPLY;
});
parcelHelpers.export(exports, "VALUE_N", function() {
    return VALUE_N;
});
parcelHelpers.export(exports, "VALUE_NUMPAD0", function() {
    return VALUE_NUMPAD0;
});
parcelHelpers.export(exports, "VALUE_NUMPAD1", function() {
    return VALUE_NUMPAD1;
});
parcelHelpers.export(exports, "VALUE_NUMPAD2", function() {
    return VALUE_NUMPAD2;
});
parcelHelpers.export(exports, "VALUE_NUMPAD3", function() {
    return VALUE_NUMPAD3;
});
parcelHelpers.export(exports, "VALUE_NUMPAD4", function() {
    return VALUE_NUMPAD4;
});
parcelHelpers.export(exports, "VALUE_NUMPAD5", function() {
    return VALUE_NUMPAD5;
});
parcelHelpers.export(exports, "VALUE_NUMPAD6", function() {
    return VALUE_NUMPAD6;
});
parcelHelpers.export(exports, "VALUE_NUMPAD7", function() {
    return VALUE_NUMPAD7;
});
parcelHelpers.export(exports, "VALUE_NUMPAD8", function() {
    return VALUE_NUMPAD8;
});
parcelHelpers.export(exports, "VALUE_NUMPAD9", function() {
    return VALUE_NUMPAD9;
});
parcelHelpers.export(exports, "VALUE_NUM_LOCK", function() {
    return VALUE_NUM_LOCK;
});
parcelHelpers.export(exports, "VALUE_O", function() {
    return VALUE_O;
});
parcelHelpers.export(exports, "VALUE_OPEN_BRACKET", function() {
    return VALUE_OPEN_BRACKET;
});
parcelHelpers.export(exports, "VALUE_P", function() {
    return VALUE_P;
});
parcelHelpers.export(exports, "VALUE_PAGE_DOWN", function() {
    return VALUE_PAGE_DOWN;
});
parcelHelpers.export(exports, "VALUE_PAGE_UP", function() {
    return VALUE_PAGE_UP;
});
parcelHelpers.export(exports, "VALUE_PAUSE", function() {
    return VALUE_PAUSE;
});
parcelHelpers.export(exports, "VALUE_PERIOD", function() {
    return VALUE_PERIOD;
});
parcelHelpers.export(exports, "VALUE_PRINTSCREEN", function() {
    return VALUE_PRINTSCREEN;
});
parcelHelpers.export(exports, "VALUE_Q", function() {
    return VALUE_Q;
});
parcelHelpers.export(exports, "VALUE_QUOTE", function() {
    return VALUE_QUOTE;
});
parcelHelpers.export(exports, "VALUE_R", function() {
    return VALUE_R;
});
parcelHelpers.export(exports, "VALUE_RETURN", function() {
    return VALUE_RETURN;
});
parcelHelpers.export(exports, "VALUE_RIGHT", function() {
    return VALUE_RIGHT;
});
parcelHelpers.export(exports, "VALUE_RIGHT_CMD", function() {
    return VALUE_RIGHT_CMD;
});
parcelHelpers.export(exports, "VALUE_S", function() {
    return VALUE_S;
});
parcelHelpers.export(exports, "VALUE_SCROLL_LOCK", function() {
    return VALUE_SCROLL_LOCK;
});
parcelHelpers.export(exports, "VALUE_SEMICOLON", function() {
    return VALUE_SEMICOLON;
});
parcelHelpers.export(exports, "VALUE_SHIFT", function() {
    return VALUE_SHIFT;
});
parcelHelpers.export(exports, "VALUE_SLASH", function() {
    return VALUE_SLASH;
});
parcelHelpers.export(exports, "VALUE_SPACE", function() {
    return VALUE_SPACE;
});
parcelHelpers.export(exports, "VALUE_SUBTRACT", function() {
    return VALUE_SUBTRACT;
});
parcelHelpers.export(exports, "VALUE_T", function() {
    return VALUE_T;
});
parcelHelpers.export(exports, "VALUE_TAB", function() {
    return VALUE_TAB;
});
parcelHelpers.export(exports, "VALUE_U", function() {
    return VALUE_U;
});
parcelHelpers.export(exports, "VALUE_UP", function() {
    return VALUE_UP;
});
parcelHelpers.export(exports, "VALUE_V", function() {
    return VALUE_V;
});
parcelHelpers.export(exports, "VALUE_W", function() {
    return VALUE_W;
});
parcelHelpers.export(exports, "VALUE_X", function() {
    return VALUE_X;
});
parcelHelpers.export(exports, "VALUE_Y", function() {
    return VALUE_Y;
});
parcelHelpers.export(exports, "VALUE_Z", function() {
    return VALUE_Z;
});
var KEY_CANCEL = 3;
var KEY_HELP = 6;
var KEY_BACK_SPACE = 8;
var KEY_TAB = 9;
var KEY_CLEAR = 12;
var KEY_RETURN = 13;
var KEY_SHIFT = 16;
var KEY_CONTROL = 17;
var KEY_ALT = 18;
var KEY_PAUSE = 19;
var KEY_CAPS_LOCK = 20;
var KEY_ESCAPE = 27;
var KEY_SPACE = 32;
var KEY_PAGE_UP = 33;
var KEY_PAGE_DOWN = 34;
var KEY_END = 35;
var KEY_HOME = 36;
var KEY_LEFT = 37;
var KEY_UP = 38;
var KEY_RIGHT = 39;
var KEY_DOWN = 40;
var KEY_PRINTSCREEN = 44;
var KEY_INSERT = 45;
var KEY_DELETE = 46;
var KEY_0 = 48;
var KEY_1 = 49;
var KEY_2 = 50;
var KEY_3 = 51;
var KEY_4 = 52;
var KEY_5 = 53;
var KEY_6 = 54;
var KEY_7 = 55;
var KEY_8 = 56;
var KEY_9 = 57;
var KEY_A = 65;
var KEY_B = 66;
var KEY_C = 67;
var KEY_D = 68;
var KEY_E = 69;
var KEY_F = 70;
var KEY_G = 71;
var KEY_H = 72;
var KEY_I = 73;
var KEY_J = 74;
var KEY_K = 75;
var KEY_L = 76;
var KEY_M = 77;
var KEY_N = 78;
var KEY_O = 79;
var KEY_P = 80;
var KEY_Q = 81;
var KEY_R = 82;
var KEY_S = 83;
var KEY_T = 84;
var KEY_U = 85;
var KEY_V = 86;
var KEY_W = 87;
var KEY_X = 88;
var KEY_Y = 89;
var KEY_Z = 90;
var KEY_LEFT_CMD = 91;
var KEY_RIGHT_CMD = 92;
var KEY_CONTEXT_MENU = 93;
var KEY_NUMPAD0 = 96;
var KEY_NUMPAD1 = 97;
var KEY_NUMPAD2 = 98;
var KEY_NUMPAD3 = 99;
var KEY_NUMPAD4 = 100;
var KEY_NUMPAD5 = 101;
var KEY_NUMPAD6 = 102;
var KEY_NUMPAD7 = 103;
var KEY_NUMPAD8 = 104;
var KEY_NUMPAD9 = 105;
var KEY_MULTIPLY = 106;
var KEY_ADD = 107;
var KEY_SUBTRACT = 109;
var KEY_DECIMAL = 110;
var KEY_DIVIDE = 111;
var KEY_F1 = 112;
var KEY_F2 = 113;
var KEY_F3 = 114;
var KEY_F4 = 115;
var KEY_F5 = 116;
var KEY_F6 = 117;
var KEY_F7 = 118;
var KEY_F8 = 119;
var KEY_F9 = 120;
var KEY_F10 = 121;
var KEY_F11 = 122;
var KEY_F12 = 123;
var KEY_F13 = 124;
var KEY_F14 = 125;
var KEY_F15 = 126;
var KEY_F16 = 127;
var KEY_F17 = 128;
var KEY_F18 = 129;
var KEY_F19 = 130;
var KEY_F20 = 131;
var KEY_F21 = 132;
var KEY_F22 = 133;
var KEY_F23 = 134;
var KEY_F24 = 135;
var KEY_NUM_LOCK = 144;
var KEY_SCROLL_LOCK = 145;
var KEY_SEMICOLON = 186;
var KEY_EQUALS = 187;
var KEY_COMMA = 188;
var KEY_DASH = 189;
var KEY_PERIOD = 190;
var KEY_SLASH = 191;
var KEY_BACK_QUOTE = 192;
var KEY_OPEN_BRACKET = 219;
var KEY_BACK_SLASH = 220;
var KEY_CLOSE_BRACKET = 221;
var KEY_QUOTE = 222;
// Key code constants specific to firefox only.
var KEY_FIREFOX_ENTER = 14;
var KEY_FIREFOX_SEMICOLON = 59;
var KEY_FIREFOX_EQUALS = 61;
var KEY_FIREFOX_SEPARATOR = 108;
var KEY_FIREFOX_META = 224;
// Key values constants
// Available values for `KeyboardEvent.key` attribute.
var VALUE_CANCEL = "Cancel";
var VALUE_HELP = "Help";
var VALUE_BACK_SPACE = "Backspace";
var VALUE_TAB = "Tab";
var VALUE_CLEAR = "Clear";
var VALUE_ENTER = "Enter";
var VALUE_RETURN = "Enter";
var VALUE_SHIFT = "Shift";
var VALUE_CONTROL = "Control";
var VALUE_ALT = "Alt";
var VALUE_PAUSE = "Pause";
var VALUE_CAPS_LOCK = "CapsLock";
var VALUE_ESCAPE = "Escape";
var VALUE_SPACE = " ";
var VALUE_PAGE_UP = "PageUp";
var VALUE_PAGE_DOWN = "PageDown";
var VALUE_END = "End";
var VALUE_HOME = "Home";
var VALUE_LEFT = "ArrowLeft";
var VALUE_UP = "ArrowUp";
var VALUE_RIGHT = "ArrowRight";
var VALUE_DOWN = "ArrowDown";
var VALUE_PRINTSCREEN = "PrintScreen";
var VALUE_INSERT = "Insert";
var VALUE_DELETE = "Delete";
var VALUE_0 = "0";
var VALUE_1 = "1";
var VALUE_2 = "2";
var VALUE_3 = "3";
var VALUE_4 = "4";
var VALUE_5 = "5";
var VALUE_6 = "6";
var VALUE_7 = "7";
var VALUE_8 = "8";
var VALUE_9 = "9";
var VALUE_A = "a";
var VALUE_B = "b";
var VALUE_C = "c";
var VALUE_D = "d";
var VALUE_E = "e";
var VALUE_F = "f";
var VALUE_G = "g";
var VALUE_H = "h";
var VALUE_I = "i";
var VALUE_J = "j";
var VALUE_K = "k";
var VALUE_L = "l";
var VALUE_M = "m";
var VALUE_N = "n";
var VALUE_O = "o";
var VALUE_P = "p";
var VALUE_Q = "q";
var VALUE_R = "r";
var VALUE_S = "s";
var VALUE_T = "t";
var VALUE_U = "u";
var VALUE_V = "v";
var VALUE_W = "w";
var VALUE_X = "x";
var VALUE_Y = "y";
var VALUE_Z = "z";
var VALUE_META = "Meta";
var VALUE_LEFT_CMD = "Meta";
var VALUE_RIGHT_CMD = "Meta";
var VALUE_CONTEXT_MENU = "ContextMenu";
var VALUE_NUMPAD0 = "0";
var VALUE_NUMPAD1 = "1";
var VALUE_NUMPAD2 = "2";
var VALUE_NUMPAD3 = "3";
var VALUE_NUMPAD4 = "4";
var VALUE_NUMPAD5 = "5";
var VALUE_NUMPAD6 = "6";
var VALUE_NUMPAD7 = "7";
var VALUE_NUMPAD8 = "8";
var VALUE_NUMPAD9 = "9";
var VALUE_MULTIPLY = "*";
var VALUE_ADD = "+";
var VALUE_SUBTRACT = "-";
var VALUE_DECIMAL = ".";
var VALUE_DIVIDE = "/";
var VALUE_F1 = "F1";
var VALUE_F2 = "F2";
var VALUE_F3 = "F3";
var VALUE_F4 = "F4";
var VALUE_F5 = "F5";
var VALUE_F6 = "F6";
var VALUE_F7 = "F7";
var VALUE_F8 = "F8";
var VALUE_F9 = "F9";
var VALUE_F10 = "F10";
var VALUE_F11 = "F11";
var VALUE_F12 = "F12";
var VALUE_F13 = "F13";
var VALUE_F14 = "F14";
var VALUE_F15 = "F15";
var VALUE_F16 = "F16";
var VALUE_F17 = "F17";
var VALUE_F18 = "F18";
var VALUE_F19 = "F19";
var VALUE_F20 = "F20";
var VALUE_F21 = "F21";
var VALUE_F22 = "F22";
var VALUE_F23 = "F23";
var VALUE_F24 = "F24";
var VALUE_NUM_LOCK = "NumLock";
var VALUE_SCROLL_LOCK = "ScrollLock";
var VALUE_SEMICOLON = ";";
var VALUE_EQUALS = "=";
var VALUE_COMMA = ",";
var VALUE_DASH = "-";
var VALUE_PERIOD = ".";
var VALUE_SLASH = "/";
var VALUE_BACK_QUOTE = "`";
var VALUE_OPEN_BRACKET = "[";
var VALUE_BACK_SLASH = "\\";
var VALUE_CLOSE_BRACKET = "]";
var VALUE_QUOTE = "'";
// Key code constants
// Available values for `KeyboardEvent.code` attribute.
var CODE_UNIDENTIFIED = "Unidentified";
var CODE_ESCAPE = "Escape";
var CODE_MINUS = "Minus";
var CODE_DASH = "Minus";
var CODE_EQUALS = "Equal";
var CODE_BACK_SPACE = "Backspace";
var CODE_TAB = "Tab";
var CODE_ENTER = "Enter";
var CODE_RETURN = "Enter";
var CODE_SHIFT_LEFT = "ShiftLeft";
var CODE_SHIFT_RIGHT = "ShiftRight";
var CODE_CONTROL_LEFT = "ControlLeft";
var CODE_CONTROL_RIGHT = "ControlRight";
var CODE_ALT_LEFT = "AltLeft";
var CODE_ALT_RIGHT = "AltRight";
var CODE_PAUSE = "Pause";
var CODE_CAPS_LOCK = "CapsLock";
var CODE_SPACE = "Space";
var CODE_PAGE_UP = "PageUp";
var CODE_PAGE_DOWN = "PageDown";
var CODE_END = "End";
var CODE_HOME = "Home";
var CODE_LEFT = "ArrowLeft";
var CODE_UP = "ArrowUp";
var CODE_RIGHT = "ArrowRight";
var CODE_DOWN = "ArrowDown";
var CODE_PRINTSCREEN = "PrintScreen";
var CODE_INSERT = "Insert";
var CODE_DELETE = "Delete";
var CODE_0 = "Digit0";
var CODE_1 = "Digit1";
var CODE_2 = "Digit2";
var CODE_3 = "Digit3";
var CODE_4 = "Digit4";
var CODE_5 = "Digit5";
var CODE_6 = "Digit6";
var CODE_7 = "Digit7";
var CODE_8 = "Digit8";
var CODE_9 = "Digit9";
var CODE_A = "KeyA";
var CODE_B = "KeyB";
var CODE_C = "KeyC";
var CODE_D = "KeyD";
var CODE_E = "KeyE";
var CODE_F = "KeyF";
var CODE_G = "KeyG";
var CODE_H = "KeyH";
var CODE_I = "KeyI";
var CODE_J = "KeyJ";
var CODE_K = "KeyK";
var CODE_L = "KeyL";
var CODE_M = "KeyM";
var CODE_N = "KeyN";
var CODE_O = "KeyO";
var CODE_P = "KeyP";
var CODE_Q = "KeyQ";
var CODE_R = "KeyR";
var CODE_S = "KeyS";
var CODE_T = "KeyT";
var CODE_U = "KeyU";
var CODE_V = "KeyV";
var CODE_W = "KeyW";
var CODE_X = "KeyX";
var CODE_Y = "KeyY";
var CODE_Z = "KeyZ";
var CODE_META_LEFT = "MetaLeft";
var CODE_OS_LEFT = "OSLeft";
var CODE_META_RIGHT = "MetaRight";
var CODE_OS_RIGHT = "OSRight";
var CODE_CONTEXT_MENU = "ContextMenu";
var CODE_NUMPAD0 = "Numpad0";
var CODE_NUMPAD1 = "Numpad1";
var CODE_NUMPAD2 = "Numpad2";
var CODE_NUMPAD3 = "Numpad3";
var CODE_NUMPAD4 = "Numpad4";
var CODE_NUMPAD5 = "Numpad5";
var CODE_NUMPAD6 = "Numpad6";
var CODE_NUMPAD7 = "Numpad7";
var CODE_NUMPAD8 = "Numpad8";
var CODE_NUMPAD9 = "Numpad9";
var CODE_NUMPAD_MULTIPLY = "NumpadMultiply";
var CODE_NUMPAD_ADD = "NumpadAdd";
var CODE_NUMPAD_SUBTRACT = "NumpadSubtract";
var CODE_NUMPAD_DECIMAL = "NumpadDecimal";
var CODE_NUMPAD_DIVIDE = "NumpadDivide";
var CODE_NUMPAD_ENTER = "NumpadEnter";
var CODE_F1 = "F1";
var CODE_F2 = "F2";
var CODE_F3 = "F3";
var CODE_F4 = "F4";
var CODE_F5 = "F5";
var CODE_F6 = "F6";
var CODE_F7 = "F7";
var CODE_F8 = "F8";
var CODE_F9 = "F9";
var CODE_F10 = "F10";
var CODE_F11 = "F11";
var CODE_F12 = "F12";
var CODE_F13 = "F13";
var CODE_F14 = "F14";
var CODE_F15 = "F15";
var CODE_F16 = "F16";
var CODE_F17 = "F17";
var CODE_F18 = "F18";
var CODE_F19 = "F19";
var CODE_F20 = "F20";
var CODE_F21 = "F21";
var CODE_F22 = "F22";
var CODE_F23 = "F23";
var CODE_F24 = "F24";
var CODE_NUM_LOCK = "NumLock";
var CODE_SCROLL_LOCK = "ScrollLock";
var CODE_SEMICOLON = "Semicolon";
var CODE_COMMA = "Comma";
var CODE_PERIOD = "Period";
var CODE_SLASH = "Slash";
var CODE_BACK_QUOTE = "Backquote";
var CODE_OPEN_BRACKET = "BracketLeft";
var CODE_BACK_SLASH = "Backslash";
var CODE_CLOSE_BRACKET = "BracketRight";
var CODE_QUOTE = "Quote";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3trSh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMenuButton", function() {
    return StyledMenuButton;
});
parcelHelpers.export(exports, "StyledButton", function() {
    return StyledButton;
});
parcelHelpers.export(exports, "StyledMenu", function() {
    return StyledMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _commonStyles = require("Permafrost/components/ui-foundations/buttons/commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  position: relative;\n\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n\n  padding: 0 !important;\n  margin-bottom: 0;\n\n  &.large {\n    --caret-size: ",
        ";\n\n    ",
        ";\n  }\n\n  &.normal {\n    --caret-size: ",
        ";\n  }\n\n  // adds addt'l specificity; without, the global button styles overrule this styling...\n  &[aria-haspopup='true'] {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    display: flex;\n    align-items: center;\n\n    .menuButtonTitle {\n      padding-left: 1em;\n      padding-right: 1.9em;\n    }\n\n    .caret {\n      width: var(--caret-size);\n      height: var(--caret-size);\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: rgba(255, 255, 255, 0);\n\n      transition: background-color ",
        " ",
        ";\n    }\n\n    svg[class='spin'] {\n      margin-top: -2px;\n      height: 1em;\n      width: 1em;\n    }\n\n    // necessary to override default button styling\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n\n    &:not([disabled]):hover,\n    &[aria-expanded='true'] {\n      .caret {\n        background-color: rgba(255, 255, 255, 0.25);\n      }\n    }\n\n    &.processing {\n      color: ",
        ";\n      cursor: wait;\n      padding-left: calc(",
        " - 2px);\n\n      .menuButtonTitle {\n        padding-left: 0.75em;\n        padding-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: absolute;\n  width: 100%;\n\n  display: none;\n  flex-direction: column;\n\n  margin-top: 2px;\n\n  button {\n    border-radius: 0;\n    box-shadow: none;\n\n    margin-bottom: 1px;\n\n    // dark-on-light text looks thinner than light-on-dark; removing\n    // smoothing for that former case gives a more consistent appearance.\n    -webkit-font-smoothing: initial;\n    -moz-osx-font-smoothing: auto;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:first-of-type {\n      border-top-left-radius: 2px;\n      border-top-right-radius: 2px;\n    }\n\n    &:last-of-type {\n      border-bottom-left-radius: 2px;\n      border-bottom-right-radius: 2px;\n    }\n  }\n\n  &.open {\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var commonPadding = "3.5em";
var StyledMenuButton = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledButton = (0, _styledComponentsDefault.default).button(_templateObject1(), (0, _commonStyles.defaults), (0, _commonStyles.variantPrimary), (0, _commonStyles.largeHeight), (0, _commonStyles.sizeLarge), (0, _commonStyles.defaultHeight), (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).white, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).iron, commonPadding, commonPadding);
var StyledMenu = (0, _styledComponentsDefault.default).div(_templateObject2());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/buttons/commonStyles":"eg1Ne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"45sEn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroup", function() {
    return 0, _pillCheckGroup.PillCheckGroup;
});
var _pillCheckGroup = require("./PillCheckGroup");

},{"./PillCheckGroup":"lb0ZT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lb0ZT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders a group of 'pill checkboxes'.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "PillCheckGroup", function() {
    return PillCheckGroup;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pillCheckGroupBase = require("../PillCheckGroupBase");
function PillCheckGroup(props) {
    var ariaLabel = props.ariaLabel, enforceSingleValue = props.enforceSingleValue, disableGroup = props.disableGroup, label = props.label, onChangeHandler = props.onChangeHandler, pills = props.pills, values = props.values, verticalOrientation = props.verticalOrientation;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pillCheckGroupBase.PillCheckGroupBase), {
        "aria-label": ariaLabel,
        className: "PillCheckGroup",
        enforceSingleValue: enforceSingleValue,
        "data-testid": props["data-testid"],
        disableGroup: disableGroup,
        label: label,
        values: values,
        onChange: function(incomingValues) {
            return onChangeHandler(incomingValues);
        },
        verticalOrientation: verticalOrientation,
        children: pills.map(function(pill) {
            var id = pill.id, pillText = pill.pillText, value = pill.value, rest = (0, _objectWithoutProperties._)(pill, [
                "id",
                "pillText",
                "value"
            ]);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pillCheckGroupBase.Pill), (0, _objectSpreadProps._)((0, _objectSpread._)({
                id: id,
                "data-cy": pill["data-cy"],
                "data-testid": pill["data-testid"],
                isSelected: values.includes(value),
                value: value
            }, rest), {
                children: pillText
            }), id);
        })
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","../PillCheckGroupBase":"6aQvb","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6aQvb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroupBase", function() {
    return 0, _pillCheckGroupBase.PillCheckGroupBase;
});
parcelHelpers.export(exports, "Pill", function() {
    return 0, _pillCheckGroupBase.Pill;
});
var _pillCheckGroupBase = require("./PillCheckGroupBase");

},{"./PillCheckGroupBase":"955Sc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"955Sc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroupContext", function() {
    return PillCheckGroupContext;
});
/**
 * Renders a group of 'pill checkboxes'.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "PillCheckGroupBase", function() {
    return PillCheckGroupBase;
});
parcelHelpers.export(exports, "Pill", function() {
    return Pill;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _index = require("Permafrost/index");
var _pillCheckGroupBaseStyles = require("./PillCheckGroupBase.styles");
var _pillStyles = require("./Pill.styles");
var _reactStately = require("react-stately");
var PillCheckGroupContext = /*#__PURE__*/ (0, _react.createContext)({});
function PillCheckGroupBase(props) {
    var id = props.id, children = props.children, className = props.className, _props_disableGroup = props.disableGroup, disableGroup = _props_disableGroup === void 0 ? false : _props_disableGroup, _props_isReadOnly = props.isReadOnly, isReadOnly = _props_isReadOnly === void 0 ? false : _props_isReadOnly, label = props.label, _props_enforceSingleValue = props.enforceSingleValue, enforceSingleValue = _props_enforceSingleValue === void 0 ? false : _props_enforceSingleValue, onChange = props.onChange, verticalOrientation = props.verticalOrientation, values = props.values;
    var checkboxGroupProps = {
        value: values,
        isDisabled: disableGroup,
        isReadOnly: isReadOnly,
        onChange: function(newValue) {
            if (isReadOnly || disableGroup) return;
            if (enforceSingleValue && newValue.length > 1) onChange([
                newValue[newValue.length - 1]
            ]);
            else onChange(newValue);
        }
    };
    var state = (0, _reactStately.useCheckboxGroupState)(checkboxGroupProps);
    var _useCheckboxGroup = (0, _checkbox.useCheckboxGroup)(props, state), groupProps = _useCheckboxGroup.groupProps, labelProps = _useCheckboxGroup.labelProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pillCheckGroupBaseStyles.StyledPillCheckGroupBase), (0, _objectSpreadProps._)((0, _objectSpread._)({
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            "PillCheckGroupBase--horizontal": verticalOrientation !== true,
            "PillCheckGroupBase--disabled": disableGroup
        }),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"]
    }, groupProps), {
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                className: "PillCheckGroup__group-label"
            }, labelProps), {
                children: label
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PillCheckGroupContext.Provider, {
                value: state,
                children: children
            })
        ]
    }));
}
function Pill(props) {
    var id = props.id, caption = props.caption, captionColor = props.captionColor, children = props.children, className = props.className, fixedWidth = props.fixedWidth, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, isSelected = props.isSelected, pillTextColor = props.pillTextColor, tooltip = props.tooltip, _props_iconName = props.iconName, iconName = _props_iconName === void 0 ? "check-circle" : _props_iconName, _props_iconColor = props.iconColor, iconColor = _props_iconColor === void 0 ? (0, _index.COLORS).fieldPromptInfo : _props_iconColor;
    var state = (0, _reactDefault.default).useContext(PillCheckGroupContext);
    var inputRef = (0, _react.useRef)(null);
    var inputProps = (0, _checkbox.useCheckboxGroupItem)(props, state, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var checkMeasure = 12;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pillStyles.StyledPill), {
        id: id,
        $captionColor: captionColor || "inherit",
        className: (0, _classnamesDefault.default)({
            "Pill__label--checked": isSelected,
            isDisabled: isDisabled
        }, className),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        "data-for": id,
        "data-tip": true,
        $fixedWidth: fixedWidth,
        $pillTextColor: pillTextColor || "inherit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                ref: inputRef,
                type: "checkbox"
            }, focusProps, inputProps, visuallyHiddenProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _classnamesDefault.default)(className, {
                    "Pill__pill-ellipse--focusRing": isFocusVisible === true,
                    "Pill__pill-ellipse--selected": isSelected === true
                }, "pill-ellipse"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "pill-text",
                        children: children
                    }),
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        name: iconName,
                        className: "pill-icon",
                        size: [
                            checkMeasure
                        ],
                        fill: iconColor
                    })
                ]
            }),
            caption && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "caption",
                children: caption
            }),
            tooltip ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                for: id,
                children: tooltip
            }) : null
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@react-aria/checkbox":"aEPJn","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","Permafrost/index":"iliLC","./PillCheckGroupBase.styles":"ejVlA","./Pill.styles":"1awcx","react-stately":"l7DHI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ejVlA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPillCheckGroupBase", function() {
    return StyledPillCheckGroupBase;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .PillCheckGroup__group-label {\n    flex: 0 0 100%;\n    margin-bottom: ",
        ";\n  }\n\n  > * {\n    margin-right: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  &.PillCheckGroupBase--horizontal {\n    display: flex;\n    flex-wrap: wrap;\n\n    .caption {\n      display: none;\n    }\n  }\n\n  &:not(.PillCheckGroupBase--disabled) label {\n    cursor: pointer;\n\n    &:hover,\n    &.Pill__label--checked .pill-ellipse {\n      color: currentColor;\n    }\n  }\n\n  &.PillCheckGroupBase--disabled label {\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPillCheckGroupBase = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.SPACING).sm, (0, _index.SPACING).sm, (0, _index.SPACING).sm);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1awcx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPill", function() {
    return StyledPill;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  position: relative;\n  transition: color ",
        " ",
        ";\n\n  .caption {\n    color: ",
        ";\n    margin-left: ",
        ";\n  }\n\n  .pill-ellipse {\n    align-items: center;\n    border: 1px solid ",
        ";\n    border-radius: 2em;\n    display: flex;\n    justify-content: center;\n    margin-top: 2px;\n    padding: 0.4em 0.8em 0.5em;\n    position: relative;\n    width: ",
        ";\n\n    .pill-text {\n      color: ",
        ";\n      ",
        ";\n    }\n\n    &.Pill__pill-ellipse--selected {\n      border: 2px solid ",
        ";\n      margin-top: 1px;\n      margin-bottom: -1px;\n    }\n\n    &.Pill__pill-ellipse--focusRing {\n      outline: 2px solid ",
        ";\n      outline-offset: 5px;\n    }\n  }\n\n  .pill-icon {\n    pointer-events: none;\n    ",
        ";\n  }\n\n  &.isDisabled {\n    cursor: not-allowed !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPill = (0, _styledComponentsDefault.default).label(_templateObject(), (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, function(props) {
    return props.$captionColor;
}, (0, _index.SPACING).sm, (0, _index.COLORS).mediumGray, function(props) {
    return props.$fixedWidth ? "".concat(props.$fixedWidth, "px") : "auto";
}, function(props) {
    return props.$pillTextColor;
}, function(props) {
    return props.$fixedWidth ? " \n        flex:1;\n        display: flex;\n        justify-content: center;" : "";
}, (0, _index.COLORS).fieldPromptInfo, (0, _index.COLORS).curiousBlue, function(props) {
    return props.$fixedWidth ? " \n          position: absolute; \n          right: 0.8em;\n        }" : "margin-left: 0.8em; ";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l7DHI":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCalendarState", function() {
    return 0, _calendar.useCalendarState;
});
parcelHelpers.export(exports, "useRangeCalendarState", function() {
    return 0, _calendar.useRangeCalendarState;
});
parcelHelpers.export(exports, "useCheckboxGroupState", function() {
    return 0, _checkbox.useCheckboxGroupState;
});
parcelHelpers.export(exports, "useComboBoxState", function() {
    return 0, _combobox.useComboBoxState;
});
parcelHelpers.export(exports, "useDateFieldState", function() {
    return 0, _datepicker.useDateFieldState;
});
parcelHelpers.export(exports, "useDatePickerState", function() {
    return 0, _datepicker.useDatePickerState;
});
parcelHelpers.export(exports, "useDateRangePickerState", function() {
    return 0, _datepicker.useDateRangePickerState;
});
parcelHelpers.export(exports, "useTimeFieldState", function() {
    return 0, _datepicker.useTimeFieldState;
});
parcelHelpers.export(exports, "useDraggableCollectionState", function() {
    return 0, _dnd.useDraggableCollectionState;
});
parcelHelpers.export(exports, "useDroppableCollectionState", function() {
    return 0, _dnd.useDroppableCollectionState;
});
parcelHelpers.export(exports, "Item", function() {
    return 0, _collections.Item;
});
parcelHelpers.export(exports, "Section", function() {
    return 0, _collections.Section;
});
parcelHelpers.export(exports, "useCollection", function() {
    return 0, _collections.useCollection;
});
parcelHelpers.export(exports, "useAsyncList", function() {
    return 0, _data.useAsyncList;
});
parcelHelpers.export(exports, "useListData", function() {
    return 0, _data.useListData;
});
parcelHelpers.export(exports, "useTreeData", function() {
    return 0, _data.useTreeData;
});
parcelHelpers.export(exports, "useListState", function() {
    return 0, _list.useListState;
});
parcelHelpers.export(exports, "useSingleSelectListState", function() {
    return 0, _list.useSingleSelectListState;
});
parcelHelpers.export(exports, "useMenuTriggerState", function() {
    return 0, _menu.useMenuTriggerState;
});
parcelHelpers.export(exports, "useNumberFieldState", function() {
    return 0, _numberfield.useNumberFieldState;
});
parcelHelpers.export(exports, "useOverlayTriggerState", function() {
    return 0, _overlays.useOverlayTriggerState;
});
parcelHelpers.export(exports, "useRadioGroupState", function() {
    return 0, _radio.useRadioGroupState;
});
parcelHelpers.export(exports, "useSearchFieldState", function() {
    return 0, _searchfield.useSearchFieldState;
});
parcelHelpers.export(exports, "useSelectState", function() {
    return 0, _select.useSelectState;
});
parcelHelpers.export(exports, "useSliderState", function() {
    return 0, _slider.useSliderState;
});
parcelHelpers.export(exports, "useMultipleSelectionState", function() {
    return 0, _selection.useMultipleSelectionState;
});
parcelHelpers.export(exports, "useTableState", function() {
    return 0, _table.useTableState;
});
parcelHelpers.export(exports, "TableHeader", function() {
    return 0, _table.TableHeader;
});
parcelHelpers.export(exports, "TableBody", function() {
    return 0, _table.TableBody;
});
parcelHelpers.export(exports, "Column", function() {
    return 0, _table.Column;
});
parcelHelpers.export(exports, "Row", function() {
    return 0, _table.Row;
});
parcelHelpers.export(exports, "Cell", function() {
    return 0, _table.Cell;
});
parcelHelpers.export(exports, "useTableColumnResizeState", function() {
    return 0, _table.useTableColumnResizeState;
});
parcelHelpers.export(exports, "useTabListState", function() {
    return 0, _tabs.useTabListState;
});
parcelHelpers.export(exports, "useToggleState", function() {
    return 0, _toggle.useToggleState;
});
parcelHelpers.export(exports, "useTooltipTriggerState", function() {
    return 0, _tooltip.useTooltipTriggerState;
});
parcelHelpers.export(exports, "useTreeState", function() {
    return 0, _tree.useTreeState;
});
parcelHelpers.export(exports, "FormValidationContext", function() {
    return 0, _form.FormValidationContext;
});
var _calendar = require("@react-stately/calendar");
var _checkbox = require("@react-stately/checkbox");
var _combobox = require("@react-stately/combobox");
var _datepicker = require("@react-stately/datepicker");
var _dnd = require("@react-stately/dnd");
var _collections = require("@react-stately/collections");
var _data = require("@react-stately/data");
var _list = require("@react-stately/list");
var _menu = require("@react-stately/menu");
var _numberfield = require("@react-stately/numberfield");
var _overlays = require("@react-stately/overlays");
var _radio = require("@react-stately/radio");
var _searchfield = require("@react-stately/searchfield");
var _select = require("@react-stately/select");
var _slider = require("@react-stately/slider");
var _selection = require("@react-stately/selection");
var _table = require("@react-stately/table");
var _tabs = require("@react-stately/tabs");
var _toggle = require("@react-stately/toggle");
var _tooltip = require("@react-stately/tooltip");
var _tree = require("@react-stately/tree");
var _form = require("@react-stately/form");

},{"@react-stately/calendar":false,"@react-stately/checkbox":"6hFCW","@react-stately/combobox":false,"@react-stately/datepicker":false,"@react-stately/dnd":false,"@react-stately/collections":false,"@react-stately/data":false,"@react-stately/list":false,"@react-stately/menu":false,"@react-stately/numberfield":false,"@react-stately/overlays":false,"@react-stately/radio":"13ooN","@react-stately/searchfield":false,"@react-stately/select":false,"@react-stately/slider":false,"@react-stately/selection":false,"@react-stately/table":false,"@react-stately/tabs":false,"@react-stately/toggle":false,"@react-stately/tooltip":false,"@react-stately/tree":false,"@react-stately/form":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6hFCW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckboxGroupState", function() {
    return $587d3ad58be6d31f$export$daff6da51032a415;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $587d3ad58be6d31f$export$daff6da51032a415() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$b3nuO$useControlledState = (0, _slicedToArray._)((0, _utils.useControlledState)(props.value, props.defaultValue || [], props.onChange), 2), selectedValues = _$b3nuO$useControlledState[0], setValue = _$b3nuO$useControlledState[1];
    var isRequired = !!props.isRequired && selectedValues.length === 0;
    var invalidValues = (0, _react.useRef)(new Map());
    var validation = (0, _form.useFormValidationState)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        value: selectedValues
    }));
    var isInvalid = validation.displayValidation.isInvalid;
    var _props_validationState;
    var state = (0, _objectSpreadProps._)((0, _objectSpread._)({}, validation), {
        value: selectedValues,
        setValue: function(value) {
            if (props.isReadOnly || props.isDisabled) return;
            setValue(value);
        },
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isSelected: function(value) {
            return selectedValues.includes(value);
        },
        addValue: function(value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (!selectedValues.includes(value)) setValue(selectedValues.concat(value));
        },
        removeValue: function(value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter(function(existingValue) {
                return existingValue !== value;
            }));
        },
        toggleValue: function(value) {
            if (props.isReadOnly || props.isDisabled) return;
            if (selectedValues.includes(value)) setValue(selectedValues.filter(function(existingValue) {
                return existingValue !== value;
            }));
            else setValue(selectedValues.concat(value));
        },
        setInvalid: function(value, v) {
            var s = new Map(invalidValues.current);
            if (v.isInvalid) s.set(value, v);
            else s.delete(value);
            invalidValues.current = s;
            validation.updateValidation((0, _form.mergeValidation).apply(void 0, (0, _toConsumableArray._)(s.values())));
        },
        validationState: (_props_validationState = props.validationState) !== null && _props_validationState !== void 0 ? _props_validationState : isInvalid ? "invalid" : null,
        isInvalid: isInvalid,
        isRequired: isRequired
    });
    return state;
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@react-stately/form":"5bKue","@react-stately/utils":"j5Bxs","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5bKue":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormValidationContext", function() {
    return $e5be200c675c3b3a$export$571b5131b7e65c11;
});
parcelHelpers.export(exports, "useFormValidationState", function() {
    return $e5be200c675c3b3a$export$fc1a364ae1f3ff10;
});
parcelHelpers.export(exports, "DEFAULT_VALIDATION_RESULT", function() {
    return $e5be200c675c3b3a$export$dad6ae84456c676a;
});
parcelHelpers.export(exports, "VALID_VALIDITY_STATE", function() {
    return $e5be200c675c3b3a$export$aca958c65c314e6c;
});
parcelHelpers.export(exports, "privateValidationStateProp", function() {
    return $e5be200c675c3b3a$export$a763b9476acd3eb;
});
parcelHelpers.export(exports, "mergeValidation", function() {
    return $e5be200c675c3b3a$export$75ee7c75d68f5b0e;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e5be200c675c3b3a$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
var $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = (0, _objectSpreadProps._)((0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c), {
    customError: true,
    valid: false
});
var $e5be200c675c3b3a$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
    validationErrors: []
};
var $e5be200c675c3b3a$export$571b5131b7e65c11 = (0, _react.createContext)({});
var $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
        var _props_$e5be200c675c3b3a$export$a763b9476acd3eb = props[$e5be200c675c3b3a$export$a763b9476acd3eb], realtimeValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.realtimeValidation, displayValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.displayValidation, updateValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.updateValidation, resetValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.resetValidation, commitValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.commitValidation;
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    var isInvalid = props.isInvalid, validationState = props.validationState, name = props.name, value = props.value, builtinValidation = props.builtinValidation, validate = props.validate, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? "aria" : tmp;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    var controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    var clientError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult($e5be200c675c3b3a$var$runValidate(validate, value));
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    var serverErrors = (0, _react.useContext)($e5be200c675c3b3a$export$571b5131b7e65c11);
    var serverErrorMessages = (0, _react.useMemo)(function() {
        if (name) return Array.isArray(name) ? name.flatMap(function(name) {
            return $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        }) : $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    var _$jcIOw$useState = (0, _slicedToArray._)((0, _react.useState)(serverErrors), 2), lastServerErrors = _$jcIOw$useState[0], setLastServerErrors = _$jcIOw$useState[1];
    var _$jcIOw$useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isServerErrorCleared = _$jcIOw$useState1[0], setServerErrorCleared = _$jcIOw$useState1[1];
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    var serverError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages);
    }, [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    var nextValidation = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var _$jcIOw$useState2 = (0, _slicedToArray._)((0, _react.useState)($e5be200c675c3b3a$export$dad6ae84456c676a), 2), currentValidity = _$jcIOw$useState2[0], setCurrentValidity = _$jcIOw$useState2[1];
    var lastError = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var commitValidation = function() {
        if (!commitQueued) return;
        setCommitQueued(false);
        var error = clientError || builtinValidation || nextValidation.current;
        if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    var _$jcIOw$useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), commitQueued = _$jcIOw$useState3[0], setCommitQueued = _$jcIOw$useState3[1];
    (0, _react.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    var realtimeValidation = controlledError || serverError || clientError || builtinValidation || $e5be200c675c3b3a$export$dad6ae84456c676a;
    var displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation: function(value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation: function() {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            var error = $e5be200c675c3b3a$export$dad6ae84456c676a;
            if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation: function() {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        var e = validate(value);
        if (e && typeof e !== "boolean") return $e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every(function(a, i) {
        return a === b.validationErrors[i];
    }) && Object.entries(a.validationDetails).every(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
        return b.validationDetails[k] === v;
    });
}
function $e5be200c675c3b3a$export$75ee7c75d68f5b0e() {
    for(var _len = arguments.length, results = new Array(_len), _key = 0; _key < _len; _key++){
        results[_key] = arguments[_key];
    }
    var errors = new Set();
    var isInvalid = false;
    var validationDetails = (0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            var _validationDetails, _key1;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = v.validationErrors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e = _step1.value;
                    errors.add(e);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Only these properties apply for checkboxes.
            isInvalid || (isInvalid = v.isInvalid);
            for(var key in validationDetails)(_validationDetails = validationDetails)[_key1 = key] || (_validationDetails[_key1] = v.validationDetails[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: (0, _toConsumableArray._)(errors),
        validationDetails: validationDetails
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j5Bxs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledState", function() {
    return $458b0a5536c1a7cf$export$40bfa8c7b0832715;
});
parcelHelpers.export(exports, "clamp", function() {
    return $9446cca9a3875146$export$7d15b64cf5a3a4c4;
});
parcelHelpers.export(exports, "snapValueToStep", function() {
    return $9446cca9a3875146$export$cb6e0bb50bc19463;
});
parcelHelpers.export(exports, "toFixedNumber", function() {
    return $9446cca9a3875146$export$b6268554fba451f;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    var _$6imuh$useState = (0, _slicedToArray._)((0, _react.useState)(value || defaultValue), 2), stateValue = _$6imuh$useState[0], setStateValue = _$6imuh$useState[1];
    var isControlledRef = (0, _react.useRef)(value !== undefined);
    var isControlled = value !== undefined;
    (0, _react.useEffect)(function() {
        var wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn("WARN: A component changed from ".concat(wasControlled ? "controlled" : "uncontrolled", " to ").concat(isControlled ? "controlled" : "uncontrolled", "."));
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var currentValue = isControlled ? value : stateValue;
    var setValue = (0, _react.useCallback)(function(value) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var onChangeCaller = function(value) {
            for(var _len = arguments.length, onChangeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                onChangeArgs[_key - 1] = arguments[_key];
            }
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange.apply(void 0, [
                    value
                ].concat((0, _toConsumableArray._)(onChangeArgs)));
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            var updateFunction = function(oldValue) {
                for(var _len = arguments.length, functionArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    functionArgs[_key - 1] = arguments[_key];
                }
                var interceptedValue = value.apply(void 0, [
                    isControlled ? currentValue : oldValue
                ].concat((0, _toConsumableArray._)(functionArgs)));
                onChangeCaller.apply(void 0, [
                    interceptedValue
                ].concat((0, _toConsumableArray._)(args)));
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller.apply(void 0, [
                value
            ].concat((0, _toConsumableArray._)(args)));
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    var newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9446cca9a3875146$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    var remainder = (value - (isNaN(min) ? 0 : min)) % step;
    var snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    var string = step.toString();
    var index = string.indexOf(".");
    var precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        var pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $9446cca9a3875146$export$b6268554fba451f(value, digits) {
    var base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"13ooN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRadioGroupState", function() {
    return $a54cdc5c1942b639$export$bca9d026f8e704eb;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _form = require("@react-stately/form");
var _utils = require("@react-stately/utils");
var _react = require("react");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $a54cdc5c1942b639$var$instance = Math.round(Math.random() * 10000000000);
var $a54cdc5c1942b639$var$i = 0;
function $a54cdc5c1942b639$export$bca9d026f8e704eb(props) {
    // Preserved here for backward compatibility. React Aria now generates the name instead of stately.
    var name = (0, _react.useMemo)(function() {
        return props.name || "radio-group-".concat($a54cdc5c1942b639$var$instance, "-").concat(++$a54cdc5c1942b639$var$i);
    }, [
        props.name
    ]);
    var _props_defaultValue;
    var _$fQ2SF$useControlledState = (0, _slicedToArray._)((0, _utils.useControlledState)(props.value, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : null, props.onChange), 2), selectedValue = _$fQ2SF$useControlledState[0], setSelected = _$fQ2SF$useControlledState[1];
    var _$fQ2SF$useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), lastFocusedValue = _$fQ2SF$useState[0], setLastFocusedValue = _$fQ2SF$useState[1];
    var validation = (0, _form.useFormValidationState)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        value: selectedValue
    }));
    var setSelectedValue = function(value) {
        if (!props.isReadOnly && !props.isDisabled) {
            setSelected(value);
            validation.commitValidation();
        }
    };
    var isInvalid = validation.displayValidation.isInvalid;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, validation), {
        name: name,
        selectedValue: selectedValue,
        setSelectedValue: setSelectedValue,
        lastFocusedValue: lastFocusedValue,
        setLastFocusedValue: setLastFocusedValue,
        isDisabled: props.isDisabled || false,
        isReadOnly: props.isReadOnly || false,
        isRequired: props.isRequired || false,
        validationState: props.validationState || (isInvalid ? "invalid" : null),
        isInvalid: isInvalid
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@react-stately/form":"3m1fA","@react-stately/utils":"5gyYP","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3m1fA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormValidationContext", function() {
    return $e5be200c675c3b3a$export$571b5131b7e65c11;
});
parcelHelpers.export(exports, "useFormValidationState", function() {
    return $e5be200c675c3b3a$export$fc1a364ae1f3ff10;
});
parcelHelpers.export(exports, "DEFAULT_VALIDATION_RESULT", function() {
    return $e5be200c675c3b3a$export$dad6ae84456c676a;
});
parcelHelpers.export(exports, "VALID_VALIDITY_STATE", function() {
    return $e5be200c675c3b3a$export$aca958c65c314e6c;
});
parcelHelpers.export(exports, "privateValidationStateProp", function() {
    return $e5be200c675c3b3a$export$a763b9476acd3eb;
});
parcelHelpers.export(exports, "mergeValidation", function() {
    return $e5be200c675c3b3a$export$75ee7c75d68f5b0e;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $e5be200c675c3b3a$export$aca958c65c314e6c = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valueMissing: false,
    valid: true
};
var $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE = (0, _objectSpreadProps._)((0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c), {
    customError: true,
    valid: false
});
var $e5be200c675c3b3a$export$dad6ae84456c676a = {
    isInvalid: false,
    validationDetails: $e5be200c675c3b3a$export$aca958c65c314e6c,
    validationErrors: []
};
var $e5be200c675c3b3a$export$571b5131b7e65c11 = (0, _react.createContext)({});
var $e5be200c675c3b3a$export$a763b9476acd3eb = "__formValidationState" + Date.now();
function $e5be200c675c3b3a$export$fc1a364ae1f3ff10(props) {
    // Private prop for parent components to pass state to children.
    if (props[$e5be200c675c3b3a$export$a763b9476acd3eb]) {
        var _props_$e5be200c675c3b3a$export$a763b9476acd3eb = props[$e5be200c675c3b3a$export$a763b9476acd3eb], realtimeValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.realtimeValidation, displayValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.displayValidation, updateValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.updateValidation, resetValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.resetValidation, commitValidation = _props_$e5be200c675c3b3a$export$a763b9476acd3eb.commitValidation;
        return {
            realtimeValidation: realtimeValidation,
            displayValidation: displayValidation,
            updateValidation: updateValidation,
            resetValidation: resetValidation,
            commitValidation: commitValidation
        };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return $e5be200c675c3b3a$var$useFormValidationStateImpl(props);
}
function $e5be200c675c3b3a$var$useFormValidationStateImpl(props) {
    var isInvalid = props.isInvalid, validationState = props.validationState, name = props.name, value = props.value, builtinValidation = props.builtinValidation, validate = props.validate, tmp = props.validationBehavior, validationBehavior = tmp === void 0 ? "aria" : tmp;
    // backward compatibility.
    if (validationState) isInvalid || (isInvalid = validationState === "invalid");
    // If the isInvalid prop is true, update validation result in realtime (controlled).
    var controlledError = isInvalid ? {
        isInvalid: true,
        validationErrors: [],
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
    // Perform custom client side validation.
    var clientError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult($e5be200c675c3b3a$var$runValidate(validate, value));
    }, [
        validate,
        value
    ]);
    if (builtinValidation === null || builtinValidation === void 0 ? void 0 : builtinValidation.validationDetails.valid) builtinValidation = null;
    // Get relevant server errors from the form.
    var serverErrors = (0, _react.useContext)($e5be200c675c3b3a$export$571b5131b7e65c11);
    var serverErrorMessages = (0, _react.useMemo)(function() {
        if (name) return Array.isArray(name) ? name.flatMap(function(name) {
            return $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        }) : $e5be200c675c3b3a$var$asArray(serverErrors[name]);
        return [];
    }, [
        serverErrors,
        name
    ]);
    // Show server errors when the form gets a new value, and clear when the user changes the value.
    var _$jcIOw$useState = (0, _slicedToArray._)((0, _react.useState)(serverErrors), 2), lastServerErrors = _$jcIOw$useState[0], setLastServerErrors = _$jcIOw$useState[1];
    var _$jcIOw$useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isServerErrorCleared = _$jcIOw$useState1[0], setServerErrorCleared = _$jcIOw$useState1[1];
    if (serverErrors !== lastServerErrors) {
        setLastServerErrors(serverErrors);
        setServerErrorCleared(false);
    }
    var serverError = (0, _react.useMemo)(function() {
        return $e5be200c675c3b3a$var$getValidationResult(isServerErrorCleared ? [] : serverErrorMessages);
    }, [
        isServerErrorCleared,
        serverErrorMessages
    ]);
    // Track the next validation state in a ref until commitValidation is called.
    var nextValidation = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var _$jcIOw$useState2 = (0, _slicedToArray._)((0, _react.useState)($e5be200c675c3b3a$export$dad6ae84456c676a), 2), currentValidity = _$jcIOw$useState2[0], setCurrentValidity = _$jcIOw$useState2[1];
    var lastError = (0, _react.useRef)($e5be200c675c3b3a$export$dad6ae84456c676a);
    var commitValidation = function() {
        if (!commitQueued) return;
        setCommitQueued(false);
        var error = clientError || builtinValidation || nextValidation.current;
        if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
            lastError.current = error;
            setCurrentValidity(error);
        }
    };
    var _$jcIOw$useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), commitQueued = _$jcIOw$useState3[0], setCommitQueued = _$jcIOw$useState3[1];
    (0, _react.useEffect)(commitValidation);
    // realtimeValidation is used to update the native input element's state based on custom validation logic.
    // displayValidation is the currently displayed validation state that the user sees (e.g. on input change/form submit).
    // With validationBehavior="aria", all errors are displayed in realtime rather than on submit.
    var realtimeValidation = controlledError || serverError || clientError || builtinValidation || $e5be200c675c3b3a$export$dad6ae84456c676a;
    var displayValidation = validationBehavior === "native" ? controlledError || serverError || currentValidity : controlledError || serverError || clientError || builtinValidation || currentValidity;
    return {
        realtimeValidation: realtimeValidation,
        displayValidation: displayValidation,
        updateValidation: function(value) {
            // If validationBehavior is 'aria', update in realtime. Otherwise, store in a ref until commit.
            if (validationBehavior === "aria" && !$e5be200c675c3b3a$var$isEqualValidation(currentValidity, value)) setCurrentValidity(value);
            else nextValidation.current = value;
        },
        resetValidation: function() {
            // Update the currently displayed validation state to valid on form reset,
            // even if the native validity says it isn't. It'll show again on the next form submit.
            var error = $e5be200c675c3b3a$export$dad6ae84456c676a;
            if (!$e5be200c675c3b3a$var$isEqualValidation(error, lastError.current)) {
                lastError.current = error;
                setCurrentValidity(error);
            }
            // Do not commit validation after the next render. This avoids a condition where
            // useSelect calls commitValidation inside an onReset handler.
            if (validationBehavior === "native") setCommitQueued(false);
            setServerErrorCleared(true);
        },
        commitValidation: function() {
            // Commit validation state so the user sees it on blur/change/submit. Also clear any server errors.
            // Wait until after the next render to commit so that the latest value has been validated.
            if (validationBehavior === "native") setCommitQueued(true);
            setServerErrorCleared(true);
        }
    };
}
function $e5be200c675c3b3a$var$asArray(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [
        v
    ];
}
function $e5be200c675c3b3a$var$runValidate(validate, value) {
    if (typeof validate === "function") {
        var e = validate(value);
        if (e && typeof e !== "boolean") return $e5be200c675c3b3a$var$asArray(e);
    }
    return [];
}
function $e5be200c675c3b3a$var$getValidationResult(errors) {
    return errors.length ? {
        isInvalid: true,
        validationErrors: errors,
        validationDetails: $e5be200c675c3b3a$var$CUSTOM_VALIDITY_STATE
    } : null;
}
function $e5be200c675c3b3a$var$isEqualValidation(a, b) {
    if (a === b) return true;
    return a && b && a.isInvalid === b.isInvalid && a.validationErrors.length === b.validationErrors.length && a.validationErrors.every(function(a, i) {
        return a === b.validationErrors[i];
    }) && Object.entries(a.validationDetails).every(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
        return b.validationDetails[k] === v;
    });
}
function $e5be200c675c3b3a$export$75ee7c75d68f5b0e() {
    for(var _len = arguments.length, results = new Array(_len), _key = 0; _key < _len; _key++){
        results[_key] = arguments[_key];
    }
    var errors = new Set();
    var isInvalid = false;
    var validationDetails = (0, _objectSpread._)({}, $e5be200c675c3b3a$export$aca958c65c314e6c);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var v = _step.value;
            var _validationDetails, _key1;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = v.validationErrors[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var e = _step1.value;
                    errors.add(e);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            // Only these properties apply for checkboxes.
            isInvalid || (isInvalid = v.isInvalid);
            for(var key in validationDetails)(_validationDetails = validationDetails)[_key1 = key] || (_validationDetails[_key1] = v.validationDetails[key]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    validationDetails.valid = !isInvalid;
    return {
        isInvalid: isInvalid,
        validationErrors: (0, _toConsumableArray._)(errors),
        validationDetails: validationDetails
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5gyYP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useControlledState", function() {
    return $458b0a5536c1a7cf$export$40bfa8c7b0832715;
});
parcelHelpers.export(exports, "clamp", function() {
    return $9446cca9a3875146$export$7d15b64cf5a3a4c4;
});
parcelHelpers.export(exports, "snapValueToStep", function() {
    return $9446cca9a3875146$export$cb6e0bb50bc19463;
});
parcelHelpers.export(exports, "toFixedNumber", function() {
    return $9446cca9a3875146$export$b6268554fba451f;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $458b0a5536c1a7cf$export$40bfa8c7b0832715(value, defaultValue, onChange) {
    var _$6imuh$useState = (0, _slicedToArray._)((0, _react.useState)(value || defaultValue), 2), stateValue = _$6imuh$useState[0], setStateValue = _$6imuh$useState[1];
    var isControlledRef = (0, _react.useRef)(value !== undefined);
    var isControlled = value !== undefined;
    (0, _react.useEffect)(function() {
        var wasControlled = isControlledRef.current;
        if (wasControlled !== isControlled) console.warn("WARN: A component changed from ".concat(wasControlled ? "controlled" : "uncontrolled", " to ").concat(isControlled ? "controlled" : "uncontrolled", "."));
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var currentValue = isControlled ? value : stateValue;
    var setValue = (0, _react.useCallback)(function(value) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var onChangeCaller = function(value) {
            for(var _len = arguments.length, onChangeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                onChangeArgs[_key - 1] = arguments[_key];
            }
            if (onChange) {
                if (!Object.is(currentValue, value)) onChange.apply(void 0, [
                    value
                ].concat((0, _toConsumableArray._)(onChangeArgs)));
            }
            if (!isControlled) // calling setState multiple times with the same value only emits onChange once.
            // We do not use a ref for this because we specifically _do_ want the value to
            // reset every render, and assigning to a ref in render breaks aborted suspended renders.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            currentValue = value;
        };
        if (typeof value === "function") {
            console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320");
            // this supports functional updates https://reactjs.org/docs/hooks-reference.html#functional-updates
            // when someone using useControlledState calls setControlledState(myFunc)
            // this will call our useState setState with a function as well which invokes myFunc and calls onChange with the value from myFunc
            // if we're in an uncontrolled state, then we also return the value of myFunc which to setState looks as though it was just called with myFunc from the beginning
            // otherwise we just return the controlled value, which won't cause a rerender because React knows to bail out when the value is the same
            var updateFunction = function(oldValue) {
                for(var _len = arguments.length, functionArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    functionArgs[_key - 1] = arguments[_key];
                }
                var interceptedValue = value.apply(void 0, [
                    isControlled ? currentValue : oldValue
                ].concat((0, _toConsumableArray._)(functionArgs)));
                onChangeCaller.apply(void 0, [
                    interceptedValue
                ].concat((0, _toConsumableArray._)(args)));
                if (!isControlled) return interceptedValue;
                return oldValue;
            };
            setStateValue(updateFunction);
        } else {
            if (!isControlled) setStateValue(value);
            onChangeCaller.apply(void 0, [
                value
            ].concat((0, _toConsumableArray._)(args)));
        }
    }, [
        isControlled,
        currentValue,
        onChange
    ]);
    return [
        currentValue,
        setValue
    ];
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /**
 * Takes a value and forces it to the closest min/max if it's outside. Also forces it to the closest valid step.
 */ function $9446cca9a3875146$export$7d15b64cf5a3a4c4(value) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    var newValue = Math.min(Math.max(value, min), max);
    return newValue;
}
function $9446cca9a3875146$export$cb6e0bb50bc19463(value, min, max, step) {
    min = Number(min);
    max = Number(max);
    var remainder = (value - (isNaN(min) ? 0 : min)) % step;
    var snappedValue = Math.abs(remainder) * 2 >= step ? value + Math.sign(remainder) * (step - Math.abs(remainder)) : value - remainder;
    if (!isNaN(min)) {
        if (snappedValue < min) snappedValue = min;
        else if (!isNaN(max) && snappedValue > max) snappedValue = min + Math.floor((max - min) / step) * step;
    } else if (!isNaN(max) && snappedValue > max) snappedValue = Math.floor(max / step) * step;
    // correct floating point behavior by rounding to step precision
    var string = step.toString();
    var index = string.indexOf(".");
    var precision = index >= 0 ? string.length - index : 0;
    if (precision > 0) {
        var pow = Math.pow(10, precision);
        snappedValue = Math.round(snappedValue * pow) / pow;
    }
    return snappedValue;
}
function $9446cca9a3875146$export$b6268554fba451f(value, digits) {
    var base = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    var pow = Math.pow(base, digits);
    return Math.round(value * pow) / pow;
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"anZ95":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledToggle", function() {
    return StyledToggle;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: inline-block;\n  width: 28px;\n  height: 18px;\n  border: 2px solid ",
        ";\n  border-radius: 34px;\n  margin-bottom: 0;\n  cursor: pointer;\n\n  & input {\n    display: none;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n\n  .slider {\n    position: absolute;\n    top: 0;\n    left: -1px;\n    right: 0;\n    bottom: 0;\n    transition: 0.4s;\n    border-radius: 34px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: '';\n    height: 17px;\n    width: 17px;\n    left: -1px;\n    bottom: -1px;\n    background-color: ",
        ";\n    transition: 0.4s;\n    border: 2px solid ",
        ";\n    border-radius: 50%;\n  }\n\n  input:checked + .slider {\n    background-color: ",
        ";\n    width: 100%;\n  }\n\n  input:checked + .slider:before {\n    transform: translateX(12px);\n  }\n\n  p {\n    position: relative;\n    left: 35px;\n    bottom: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledToggle = (0, _styledComponentsDefault.default).label(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bBv5h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toggle", function() {
    return Toggle;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _toggleStyles = require("./Toggle.styles");
var Toggle = function(props) {
    var className = props.className, disabled = props.disabled, id = props.id, onChange = props.onChange, value = props.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _toggleStyles.StyledToggle), {
        className: (0, _classnamesDefault.default)(className, {
            disabled: disabled
        }),
        "data-cy": props["data-cy"],
        "data-for": props["data-for"],
        "data-tip": props["data-tip"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                "aria-label": props["aria-label"],
                type: "checkbox",
                disabled: disabled,
                checked: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "slider round"
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","./Toggle.styles":"anZ95","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gI4sY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", function() {
    return Tag;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _tagStyles = require("./Tag.styles");
var Tag = function(props) {
    var disabled = props.disabled, selected = props.selected, value = props.value, onClick = props.onClick, onRemove = props.onRemove;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagStyles.StyledTag), {
        className: (0, _classnamesDefault.default)("Tag--container", {
            selected: selected
        }),
        "data-testid": props["data-testid"],
        children: [
            onClick ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                className: "value-select",
                onClick: onClick,
                children: value
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: value
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), {
                isDisabled: disabled,
                className: "remove-btn",
                iconName: "x-close",
                onPress: onRemove
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Tag.styles":"2E4gc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2E4gc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTag", function() {
    return StyledTag;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  display: inline-flex;\n  padding: 0 10px;\n\n  &.selected {\n    background: ",
        ";\n  }\n\n  &,\n  .value-select,\n  .remove-btn,\n  .value-select:hover,\n  .remove-btn:hover,\n  .value-select:focus,\n  .remove-btn:focus {\n    color: ",
        ";\n    background: transparent;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .value-select,\n  .remove-btn {\n    padding: 0 !important;\n  }\n\n  .remove-btn svg {\n    height: 12px;\n    margin-left: 15px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTag = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lXUmL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Minimal utility component designed to display text related to field validation, to act as a
 * helper prompt or an error message for a form control or fieldset. Optionally accepts an `id` to
 * allow this element to act as a description for a control using the `aria-describedby` attribute.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute}
 */ parcelHelpers.export(exports, "ValidationText", function() {
    return ValidationText;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _validationTextStyles = require("./ValidationText.styles");
function ValidationText(props) {
    var className = props.className, id = props.id, isError = props.isError, message = props.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validationTextStyles.StyledValidationText), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            error: isError,
            prompt: !isError
        }),
        "data-cy": props["data-cy"],
        "data-testid": "validation-text",
        children: message
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","./ValidationText.styles":"aWnvl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aWnvl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledValidationText", function() {
    return StyledValidationText;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 17px;\n  margin-top: 10px;\n  font-size: ",
        ";\n\n  &.prompt {\n    color: ",
        ";\n  }\n\n  &.error {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledValidationText = (0, _styledComponentsDefault.default).p(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).fieldPromptInfo, (0, _index.COLORS).fieldPromptError);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hFYGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarSpinner", function() {
    return BarSpinner;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _barSpinnerStyles = require("./BarSpinner.styles");
function BarSpinner(props) {
    var className = props.className, id = props.id, _props_width = props.width, width = _props_width === void 0 ? "100%" : _props_width;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _barSpinnerStyles.StyledBarSpinner), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: {
            width: width
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {})
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./BarSpinner.styles":"g3Td0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g3Td0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBarSpinner", function() {
    return StyledBarSpinner;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(46px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  width: 200px;\n  height: 14px; /* Can be anything */\n  position: relative;\n  border-radius: 25px;\n\n  > span {\n    display: block;\n    height: 100%;\n    width: 100%;\n    border-radius: 25px;\n    position: relative;\n    overflow: hidden;\n    background-color: ",
        ";\n\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -46px;\n      bottom: 0;\n      right: 0;\n      background: repeating-linear-gradient(\n        -55deg,\n        transparent 1px,\n        rgba(255, 255, 255, 0.25) 2px,\n        rgba(255, 255, 255, 0.25) 11px,\n        transparent 12px,\n        transparent 20px\n      );\n      animation-name: ",
        ";\n      animation-duration: 1s;\n      animation-timing-function: linear;\n      animation-iteration-count: infinite;\n      border-radius: 20px;\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var moveBg = (0, _styledComponents.keyframes)(_templateObject());
var StyledBarSpinner = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).curiousBlue, moveBg);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"c4vDX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingIndicator", function() {
    return LoadingIndicator;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _loadingIndicatorStyles = require("./LoadingIndicator.styles");
function LoadingIndicator(props) {
    var className = props.className, color = props.color, id = props.id, _props_overallSize = props.overallSize, overallSize = _props_overallSize === void 0 ? "200px" : _props_overallSize, _props_rippleSize = props.rippleSize, rippleSize = _props_rippleSize === void 0 ? "76px" : _props_rippleSize, fixedMessage = props.fixedMessage, showRandomMessage = props.showRandomMessage;
    var loadingIndicator = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingIndicatorStyles.StyledLoadingIndicator), {
            "aria-hidden": true,
            className: className,
            "data-cy": props["data-cy"],
            id: id,
            $overallSize: returnSizeString(overallSize),
            $rippleSize: returnSizeString(rippleSize),
            style: color ? {
                color: color
            } : {
                color: (0, _index.COLORS).curiousBlue
            }
        });
    };
    var renderMessage = function() {
        if (fixedMessage) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "message",
            children: fixedMessage
        });
        if (showRandomMessage) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.RandomLoadingMessage), {});
        return null;
    };
    if (fixedMessage || showRandomMessage) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _loadingIndicatorStyles.StyledMessageLoadingIndicator), {
        $overallSize: returnSizeString(overallSize),
        children: [
            loadingIndicator(),
            renderMessage()
        ]
    });
    return loadingIndicator();
}
function returnSizeString(size) {
    if (typeof size === "number") return "".concat(size, "px");
    return size;
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./LoadingIndicator.styles":"de0Gt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"de0Gt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLoadingIndicator", function() {
    return StyledLoadingIndicator;
});
parcelHelpers.export(exports, "StyledMessageLoadingIndicator", function() {
    return StyledMessageLoadingIndicator;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  \n  20% {\n    opacity: 1;\n  }\n  \n  100% {\n    width: ",
        ";\n    height: ",
        ";\n    opacity: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: grid;\n  place-items: center;\n\n  width: ",
        ";\n  height: ",
        ";\n\n  margin-left: auto;\n  margin-right: auto;\n\n  &:before,\n  &:after {\n    content: '';\n    border: 4px solid currentColor;\n    border-radius: 50%;\n\n    grid-area: 1 / 1;\n\n    animation: ",
        " ",
        "s\n      cubic-bezier(0, 0.2, 0.8, 1) infinite;\n\n    @media (prefers-reduced-motion) {\n      animation-duration: ",
        "s;\n    }\n  }\n\n  &:after {\n    animation-delay: -",
        "s;\n\n    @media (prefers-reduced-motion) {\n      animation-delay: -",
        "s;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n\n  > * {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .message {\n    text-align: center;\n    display: block;\n    width: ",
        ";\n    margin-top: -50px;\n\n    color: ",
        ";\n    font-size: ",
        ";\n    font-style: italic;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var ripple = function(size) {
    return (0, _styledComponents.keyframes)(_templateObject(), size, size);
};
var animationSpeed = 1.4;
var StyledLoadingIndicator = (0, _styledComponentsDefault.default).div(_templateObject1(), function(props) {
    return props.$overallSize;
}, function(props) {
    return props.$overallSize;
}, function(props) {
    return ripple(props.$rippleSize);
}, animationSpeed, animationSpeed * 2, animationSpeed / 2, animationSpeed);
var StyledMessageLoadingIndicator = (0, _styledComponentsDefault.default).div(_templateObject2(), function(props) {
    return props.$overallSize;
}, (0, _index.COLORS).lightFontColor, (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"emtiw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingList", function() {
    return LoadingList;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingListStyles = require("./LoadingList.styles");
var LoadingList = function() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingListStyles.StyledLoadingList), {});
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./LoadingList.styles":"iyYOe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iyYOe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLoadingList", function() {
    return StyledLoadingList;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  height: 40vh;\n\n  background-image: repeating-linear-gradient(\n    to bottom,\n    ",
        " 0px,\n    ",
        " 60px,\n    ",
        " 60px,\n    ",
        " 65px\n  );\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n\n    opacity: 0.75;\n\n    background-image: linear-gradient(to right, transparent, ",
        ", transparent);\n    background-size: 400% 100%;\n    animation: ",
        " 2s ease infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var loadingAnimation = (0, _styledComponents.keyframes)(_templateObject());
var StyledLoadingList = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).ebony, (0, _index.COLORS).ebony, (0, _index.COLORS).clay, (0, _index.COLORS).clay, (0, _index.COLORS).clay, loadingAnimation);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2ZVeg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingSpinner", function() {
    return LoadingSpinner;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
function LoadingSpinner(props) {
    var className = props.className, fill = props.fill, id = props.id, size = props.size, style = props.style, _props_ariaLabel = props.ariaLabel, ariaLabel = _props_ariaLabel === void 0 ? "Loading..." : _props_ariaLabel;
    var loaderSize = size || "12px";
    var loaderStyle = (0, _objectSpread._)({
        position: "relative",
        top: "1px"
    }, style);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
        name: "fa-circle-notch",
        className: "spin ".concat(className || ""),
        "data-cy": props["data-cy"],
        id: id,
        size: [
            loaderSize
        ],
        style: loaderStyle,
        fill: fill || "currentColor",
        ariaLabel: ariaLabel
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eKrnJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PercentageRing", function() {
    return PercentageRing;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _percentageRingStyles = require("./PercentageRing.styles");
function PercentageRing(props) {
    var _props_backgroundColor = props.backgroundColor, backgroundColor = _props_backgroundColor === void 0 ? (0, _index.COLORS).clay : _props_backgroundColor, className = props.className, _props_foregroundColor = props.foregroundColor, foregroundColor = _props_foregroundColor === void 0 ? (0, _index.COLORS).baliHai : _props_foregroundColor, id = props.id, _props_ringRadius = props.ringRadius, ringRadius = _props_ringRadius === void 0 ? 35 : _props_ringRadius, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 5 : _props_strokeWidth, _props_value = props.value, value = _props_value === void 0 ? 0 : _props_value, _props_valueFontSize = props.valueFontSize, valueFontSize = _props_valueFontSize === void 0 ? 20 : _props_valueFontSize;
    var ringCircumference = 2 * Math.PI * (ringRadius - strokeWidth / 2);
    var valueCircumference = ringCircumference - value * ringCircumference;
    var diameter = ringRadius * 2;
    var circleRadius = ringRadius - strokeWidth / 2;
    // ensure we don’t display a value greater than 100% to the user
    var displayValue = Math.round(Math.min(value, 1) * 100);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _percentageRingStyles.StyledPercentageRing), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    fontSize: valueFontSize,
                    width: diameter,
                    height: diameter
                },
                children: [
                    displayValue,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "%"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                height: diameter,
                width: diameter,
                fill: "none",
                strokeWidth: strokeWidth,
                "aria-hidden": "true",
                focusable: "false",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            r: circleRadius,
                            cx: ringRadius,
                            cy: ringRadius,
                            stroke: backgroundColor
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            r: circleRadius,
                            cx: ringRadius,
                            cy: ringRadius,
                            stroke: foregroundColor,
                            strokeDasharray: ringCircumference,
                            strokeDashoffset: valueCircumference
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./PercentageRing.styles":"blHZh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"blHZh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPercentageRing", function() {
    return StyledPercentageRing;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  svg {\n    transform: rotate(-90deg);\n  }\n\n  div {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    margin-top: -0.05em;\n    margin-left: 0.1em;\n\n    span {\n      font-size: 0.6em;\n      margin-top: -0.5em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPercentageRing = (0, _styledComponentsDefault.default).div(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jMRYG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", function() {
    return ProgressBar;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _progressBarStyles = require("./ProgressBar.styles");
var ProgressBar = function(props) {
    var primary = props.primary, secondary = props.secondary, className = props.className, id = props.id, style = props.style, _props_onHoverDetails = props.onHoverDetails, onHoverDetails = _props_onHoverDetails === void 0 ? null : _props_onHoverDetails, _props_primaryColor = props.primaryColor, primaryColor = _props_primaryColor === void 0 ? (0, _index.COLORS).robinsEggBlue : _props_primaryColor, _props_secondaryColor = props.secondaryColor, secondaryColor = _props_secondaryColor === void 0 ? (0, _index.COLORS).red : _props_secondaryColor;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), tooltipData = _useState[0], setTooltipData = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), mouseCoordinates = _useState1[0], setMouseCoordinates = _useState1[1];
    var primaryWidth = function(primary, primaryColor) {
        if (primary === 100) return {
            width: "calc(100% + 2px)",
            borderRadius: "5px",
            background: primaryColor
        };
        else if (primary === 0) return {
            width: "0px"
        };
        else return {
            width: "calc(".concat(primary, "% + 1px)"),
            background: primaryColor
        };
    };
    var secondaryWidth = function(primary, secondary, secondaryColor) {
        if ((0, _index.MATH).round10(primary + secondary, -2) >= 100) {
            var reducedSecondary = 100 - primary;
            return {
                width: "calc(".concat(reducedSecondary, "% + 2px)"),
                borderRadius: "0 5px 5px 0",
                background: secondaryColor
            };
        } else if (secondary === 0) return {
            width: "0px"
        };
        else return {
            width: "calc(".concat(secondary, "% + 1px)"),
            background: secondaryColor
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _progressBarStyles.StyledProgressBar), {
        className: "ProgressBar ".concat(className || ""),
        "data-cy": props["data-cy"],
        id: id,
        style: style,
        onMouseLeave: function() {
            setTooltipData(null);
            setMouseCoordinates([
                -1,
                -1
            ]);
        },
        onMouseEnter: function(e) {
            setTooltipData(onHoverDetails);
            setMouseCoordinates([
                e.clientX,
                e.clientY
            ]);
        },
        onMouseMove: function(e) {
            e.persist();
            requestAnimationFrame(function() {
                return setMouseCoordinates([
                    e.clientX,
                    e.clientY
                ]);
            });
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                className: "progress-container"
            }, props === null || props === void 0 ? void 0 : props.progressBarRowProps), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "primary-progress",
                        style: primaryWidth(primary, primaryColor)
                    }),
                    secondary ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "secondary-progress",
                        style: secondaryWidth(primary, secondary, secondaryColor)
                    }) : null
                ]
            })),
            tooltipData && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "progress-bar-tooltip",
                style: {
                    top: mouseCoordinates[1],
                    left: mouseCoordinates[0]
                },
                children: tooltipData
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./ProgressBar.styles":"l5S2r","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l5S2r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledProgressBar", function() {
    return StyledProgressBar;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  height: 9px;\n  overflow: hidden;\n  border-radius: 5px;\n  width: 100%;\n\n  .progress-container {\n    display: flex;\n    border-radius: 5px;\n    border: 1px solid ",
        ";\n    height: 9px;\n    width: 100%;\n    background: ",
        ";\n  }\n\n  .primary-progress {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n\n  .progress-bar-tooltip {\n    white-space: pre-wrap;\n    left: -999em;\n    top: -999em;\n    position: fixed;\n    z-index: 800;\n    background-color: ",
        ";\n    color: ",
        ";\n    border: ",
        ";\n    border-radius: 5px;\n    transform: translate(-50%, 50%);\n    padding: 5px;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledProgressBar = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).ebony, (0, _index.COLORS).ebony, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).mirage, (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Xmp2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RandomLoadingMessage", function() {
    return RandomLoadingMessage;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _randomMessages = require("./random-messages");
var _randomMessagesDefault = parcelHelpers.interopDefault(_randomMessages);
var RandomLoadingMessage = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _randomMessagesDefault.default)[Math.floor(Math.random() * (0, _randomMessagesDefault.default).length)]), 2), randomMessage = _useState[0], changeRandomMessage = _useState[1];
    (0, _react.useEffect)(function() {
        var timer = setTimeout(function() {
            changeRandomMessage((0, _randomMessagesDefault.default)[Math.floor(Math.random() * (0, _randomMessagesDefault.default).length)]);
        }, 3000);
        return function() {
            return clearTimeout(timer);
        };
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "message",
        children: [
            randomMessage,
            "..."
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","./random-messages":"cePuW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cePuW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MESSAGES = [
    "Charging the flux capacitor",
    "Spinning up the hamster wheel",
    "Flushing the pipes",
    "Counting all the beans",
    "Take a deep breath and enjoy this beautiful moment",
    "Counting digits in pi (almost done)",
    "Folding time and space",
    "Oiling the gears",
    "Peeling the data fruits",
    "Activating the oscillation overthruster",
    "Gleaming the cube",
    "Reticulating splines",
    "Playing a quick game of squash",
    "Making the sausage",
    "Building the matrix",
    "Drawing fractals",
    "Testing memory (what did you have for breakfast?)",
    "Priming data pumps",
    "Whacking datamoles",
    "Finding Nemo",
    "Running spin cycle",
    "Chasing down a dream",
    "Twiddling the knobs",
    "Assembling lines",
    "Making the donuts",
    "Gathering magic",
    "Rolling stones",
    "Busting all the moves",
    "Augmenting reality",
    "Leveling up",
    "Obviating frequencies",
    "Declaring variables",
    "Boosting thrusters",
    "Blazing the saddles",
    "Flipping some bits",
    "Unclogging the internet",
    "Turning it off and back on again",
    "Entering the ThunderDome",
    "Rolling logs",
    "Dangling particles",
    "Catching moonbeams",
    "Digging for treasure",
    "Reconbulating the conbulator",
    "Machine learning",
    "Magicing",
    "Tuning the forks",
    "Fiddling widgets",
    "Feeding the data monkeys",
    "Regularizing expressions",
    "Ramping up the synergy",
    "Inflating point flotations",
    "Entering orbit around alpha centuri",
    "Squeezing data tubes",
    "Making a list and checking it twice",
    "Unkinking the data tubes",
    "Turning on the data hose",
    "Preparing for liftoff",
    "Replacing the hamsters",
    "Changing the batteries",
    "Waking up our engineers",
    "Contemplating the meaning of life",
    "Downloading fresh dog memes",
    "Springing the chickens"
];
exports.default = MESSAGES;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bkG7I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppCrash", function() {
    return AppCrash;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var AppCrash = function(props) {
    var className = props.className, id = props.id, style = props.style;
    var message = props.message || "Unfortunately the app has encountered a fatal error.";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.FailSnail), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        message: message,
        style: style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
            variant: "cta",
            onClick: function() {
                window.location.reload();
            },
            children: "Refresh"
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bOUgi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmModal", function() {
    return ConfirmModal;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _confirmModalStyles = require("./ConfirmModal.styles");
function ConfirmModal(props) {
    var id = (0, _uuid.v4)();
    var className = props.className, clickOutsideHandler = props.clickOutsideHandler, confirmText = props.confirmText, describedBy = props.describedBy, message = props.message, modalNode = props.modalNode, open = props.open, processing = props.processing, rejectText = props.rejectText, responseHandler = props.responseHandler, title = props.title, width = props.width;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.ModalBase), {
        className: className,
        clickToDismiss: clickOutsideHandler,
        "data-cy": props["data-cy"],
        describedBy: describedBy,
        id: props.id,
        labelElement: id,
        node: modalNode,
        open: open,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _confirmModalStyles.StyledConfirmModal), {
            style: {
                width: width || 555
            },
            children: [
                title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    id: id,
                    className: "title",
                    children: title || "Please confirm"
                }),
                message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "message",
                    children: message
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _index.LoadingAwareContainer), {
                    isLoading: processing,
                    className: "actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                            variant: "cta",
                            className: "confirm",
                            onClick: function(event) {
                                return responseHandler(true, event);
                            },
                            children: confirmText || "Yes"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                            variant: "normal",
                            className: "reject",
                            onClick: function(event) {
                                return responseHandler(false, event);
                            },
                            children: rejectText || "No"
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./ConfirmModal.styles":"g2HIW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g2HIW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledConfirmModal", function() {
    return StyledConfirmModal;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 20px;\n\n  .title {\n    margin: 30px 16px;\n    font-size: ",
        ";\n    text-align: center;\n    color: ",
        ";\n  }\n\n  .message {\n    text-align: center;\n    padding-bottom: 16px;\n  }\n\n  .actions {\n    text-align: center;\n    padding-bottom: 40px;\n\n    button {\n      min-width: 300px;\n      display: block;\n      margin: 16px auto 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledConfirmModal = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.display, (0, _index.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hbcR0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentModal", function() {
    return ContentModal;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _contentModalStyles = require("./ContentModal.styles");
function ContentModal(props) {
    var id = (0, _uuid.v4)();
    var labelText = "labelText" in props && props.labelText;
    var title = "title" in props && props.title;
    var children = props.children, className = props.className, closeModal = props.closeModal, describedBy = props.describedBy, modalNode = props.modalNode, open = props.open, width = props.width;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.ModalBase), {
        className: className,
        clickToDismiss: closeModal,
        "data-cy": props["data-cy"],
        describedBy: describedBy,
        id: props.id,
        labelElement: title ? id : "",
        labelText: labelText || "",
        node: modalNode,
        open: open,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _contentModalStyles.StyledContentModal), {
            style: {
                width: width || 555
            },
            children: [
                title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    id: id,
                    className: "title",
                    children: title
                }),
                children
            ]
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./ContentModal.styles":"7u95E","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7u95E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContentModal", function() {
    return StyledContentModal;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 20px;\n\n  .title {\n    margin: 30px 16px;\n    font-size: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContentModal = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.display);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"YRMhe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FailSnail", function() {
    return FailSnail;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _failSnailStyles = require("./FailSnail.styles");
function FailSnail(props) {
    var children = props.children, className = props.className, id = props.id, message = props.message, style = props.style;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _failSnailStyles.StyledFailSnail), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                viewBox: "0 0 463.47 341.73",
                "aria-hidden": true,
                focusable: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M253.01 143.75c10.94 65.49-28 124-83.27 129.12S64.59 228.61 58.42 162.5 76.58 44.42 143.91 37.75c55.29-5.47 96.28 29.26 109.1 106zM148.19 61.88c-41.24 3.84-70.88 47.91-66.13 98.42s41.12 91.09 82.52 90.12c56.58-1.33 71.51-53.53 66.8-104s-41.96-88.39-83.19-84.54z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        cx: "158.55",
                        cy: "163.57",
                        rx: "34.88",
                        ry: "47.14",
                        transform: "rotate(-11.61 115.421 207.313)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M291.25 259.92a109.73 109.73 0 01-17.75 9.12 130 130 0 01-19.06 6.08 146.67 146.67 0 01-19.73 3.21 131.32 131.32 0 01-19.93.37c6.54-1.26 13-2.29 19.51-3.46s12.86-2.52 19.23-4 12.67-3.19 18.93-5.12 12.47-4.13 18.8-6.2zM264.25 94.42a103.46 103.46 0 019.37 17.22 132 132 0 016.52 18.58 138.23 138.23 0 013.83 19.37 145 145 0 01.93 19.77 132.66 132.66 0 01-2 19.68l-1 4.85-1.2 4.81c-.36 1.6-.84 3.18-1.33 4.75s-1 3.16-1.51 4.71a136 136 0 01-18.11 34.76 188.12 188.12 0 0015.14-35.7 152.48 152.48 0 004.23-18.81 136.63 136.63 0 001.78-19.19 154.24 154.24 0 00-3.77-38.28 163.87 163.87 0 00-5.33-18.62 139.78 139.78 0 00-7.55-17.9z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        cx: "400.45",
                        cy: "194.7",
                        rx: "7.63",
                        ry: "6.39"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M444.31 202.47c.55-.17 3.69 2.43 6.41 5.6s.31 7.53-2 8.27-6.81-1.6-6.4-5.6c.45-4.31 1.46-8.09 2-8.27M448.12 225.75c.46-.14 3.13 2.07 5.44 4.77s.28 6.4-1.7 7-5.79-1.36-5.44-4.76c.37-3.67 1.23-6.89 1.7-7M454.42 216.64c.46-.14 3.13 2.07 5.44 4.77s.27 6.4-1.7 7-5.79-1.36-5.44-4.76c.37-3.67 1.23-6.89 1.7-7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        cx: "434.11",
                        cy: "195.43",
                        rx: "7.63",
                        ry: "6.71"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M388.57 206.57c.62.28 1.31 5.06 1.19 10-.13 4.76-5.7 6.88-8.33 5.69s-4.72-6.82-1.18-10c3.81-3.45 7.71-6 8.32-5.69M374.8 219.14c.51.23 1.08 4.18 1 8.27-.1 3.93-4.71 5.68-6.88 4.69s-3.9-5.63-1-8.27c3.16-2.84 6.37-4.92 6.88-4.69"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M99.01 280.05l-.23-.27a3.71 3.71 0 00-.36-.36l-3.11-2.63c-2.07-1.69-4.05-3.61-6-5.49s-3.85-3.88-5.77-5.83a156.66 156.66 0 01-19.78-26.08 165.42 165.42 0 01-22.08-61 167.41 167.41 0 012.72-64.56 155.68 155.68 0 0118.29-44.82l2.08-3.46c.73-1.13 1.54-2.24 2.24-3.33s1.47-2.26 2.27-3.34l2.4-3.24c1.55-2.2 3.34-4.22 5-6.32s3.63-4.1 5.35-6.1 3.74-3.87 5.69-5.72l3-2.73 1.49-1.36 1.55-1.29a138.89 138.89 0 0126.76-17.9A132.92 132.92 0 01150.9 3.31 127.3 127.3 0 01183.13.03a135.31 135.31 0 0162.36 17.19 147.55 147.55 0 0148.37 43.33l2.37 3.33c.76 1.13 1.48 2.29 2.22 3.43s1.49 2.28 2.2 3.45l2 3.53c1.4 2.34 2.6 4.79 3.83 7.22s2.31 4.92 3.45 7.39a156.91 156.91 0 019.85 31l1.44 8 1 8c.53 5.36.94 10.72 1.11 16.09.08 2.69.19 5.37.15 8.06v4c0 1.35-.09 2.69-.13 4l-.13 4-.26 4c-.1 1.33-.15 2.67-.29 4l-.41 4a161.33 161.33 0 01-6.31 31.47c-3.25 10.18-7.79 20.08-14.45 28.53a24.35 24.35 0 00-3.95 6.75 8.6 8.6 0 00.35 7.34 11.42 11.42 0 006 4.57 19.2 19.2 0 003.75 1c.63.11 1.27.13 2 .24a12.68 12.68 0 012 .45 14.14 14.14 0 013.78 1.76 9 9 0 013 3.07 5.33 5.33 0 01.39 4.45 8.68 8.68 0 01-1.74 2.67 17.93 17.93 0 013.23-.64 39 39 0 015.9-.37 97.56 97.56 0 0111.73.88l1.46.19c.49.07 1 .14 1.39.18a11.56 11.56 0 002.63-.05 11.7 11.7 0 004.87-1.75c.36-.23.72-.48 1.06-.74l1.06-.9c.76-.64 1.52-1.26 2.3-1.88 1.54-1.22 3.13-2.4 4.74-3.54a96.08 96.08 0 0120.9-11.25 80.05 80.05 0 0113.82-4c.15-.72.29-1.43.43-2.15a173.93 173.93 0 002.53-19.11c.14-3.23.39-6.46.36-9.7 0-1.61.06-3.23.05-4.85l-.15-4.84-.08-2.43-.19-2.41-.33-4.72a23.73 23.73 0 01-15.27-6.54 24.12 24.12 0 01-7.29-16.89 24.63 24.63 0 016.81-17.37 23.53 23.53 0 0117.37-7.25 23.1 23.1 0 019.28 2.19 25.09 25.09 0 017.73 5.94 24 24 0 018.11-5.32 23.74 23.74 0 019.44-1.8 22.59 22.59 0 0116.72 7.86 25 25 0 016.06 16.72 24.41 24.41 0 01-6.52 16.27 23.28 23.28 0 01-7.33 5.29c-.58.26-1.17.5-1.78.72.23 4.61.28 9.15.17 13.74-.19 5-.47 10.09-1.13 15.1a110.85 110.85 0 01-2.82 14.9 69.68 69.68 0 01-3.55 10.18 67.74 67.74 0 016.33 2.76 59 59 0 0110.43 6.56 45.46 45.46 0 018.71 9 39.27 39.27 0 015.71 11.41 34.5 34.5 0 01-2.05 25.33 37.15 37.15 0 01-7.61 10.39c-.75.76-1.58 1.42-2.37 2.14s-1.68 1.32-2.51 1.93c-1.66 1.13-3.25 2.32-5 3.39s-3.38 2.18-5.19 3.13l-2.66 1.47-2.76 1.32c-1.81.93-3.76 1.6-5.66 2.35-.94.4-1.94.65-2.91 1l-2.94.9a88.9 88.9 0 01-24 2.66 160.16 160.16 0 01-23.65-2.33c-1.94-.34-3.88-.64-5.81-1l-5.79-1.2c-1.93-.37-3.84-.8-5.74-1.26l-5.72-1.34c-7.49-1.76-15-3.5-22.52-4.52-3.76-.51-7.54-.91-11.31-1.06-.95-.07-1.89-.07-2.83-.07h-2.83c-.94 0-1.87.09-2.81.14s-1.88.07-2.81.21a86.83 86.83 0 00-11.18 1.9c-3.72.89-7.47 1.9-11.27 2.85-1.91.44-3.81.93-5.75 1.3l-2.9.58-2.92.46c-1.93.37-3.94.47-5.91.69a26.79 26.79 0 01-3 .15l-3 .07a76 76 0 01-23.18-4.53c-7.38-2.52-14.59-5.35-22.14-6.41a47.62 47.62 0 00-11.38-.24 57.27 57.27 0 00-11.19 2.08c-3.68 1.05-7.29 2.45-11 3.67-1.85.64-3.74 1.19-5.63 1.74s-3.81 1-5.74 1.39a121.86 121.86 0 01-23.44 2.54c-2 .09-3.92.06-5.88 0s-3.93 0-5.88-.09l-5.87-.22-5.89-.41c-2-.14-3.94-.42-5.91-.63-1-.11-2-.32-3-.47s-2-.28-3-.53a49 49 0 01-11.66-3.78c-1.85-.88-3.49-1.72-5.07-2.31l-1.18-.41c-.4-.11-.81-.18-1.21-.28a20.38 20.38 0 00-2.52-.39c-.86-.1-1.78-.08-2.66-.13s-1.84 0-2.75 0c-1.82 0-3.76.18-5.65.32-7.63.62-15.33 1.61-23.09 2.34a232.13 232.13 0 01-23.56 1.37 75.06 75.06 0 01-12.06-1 39.8 39.8 0 01-6.08-1.53 25.34 25.34 0 01-5.83-2.89 15.27 15.27 0 01-4.9-5 10.26 10.26 0 01-1.23-3.73 10 10 0 01.36-3.88 14.73 14.73 0 013.61-5.93 28.19 28.19 0 014.91-4c6.92-4.54 14.8-6.8 22.4-8.42 3.79-.86 7.6-1.72 11.44-2.45s7.78-1.29 11.61-1.89l18.07-2.56a8.13 8.13 0 01.39-2.61 9.76 9.76 0 014.38-5.37 11.66 11.66 0 016-1.64 13.83 13.83 0 011.57.12l1 .14 1.91.28c1.27.17 2.54.32 3.79.44a36 36 0 007.08.09c.22.02.36-.03.51-.06zm331.15-24.26a87.73 87.73 0 002.25-10.36c.82-4.89 1.3-9.83 1.64-14.77s.48-9.91.45-14.87c0-4.22-.07-8.48-.3-12.68a23.38 23.38 0 01-3.23.31 23.12 23.12 0 01-3.33-.09c-.07 1.47-.2 3-.4 4.48a65.91 65.91 0 01-1.19 6.88 73.57 73.57 0 01-4.38 13.18 81.52 81.52 0 01-6.61 12.11c-.74 1.11-1.5 2.21-2.29 3.28.32 1.71.64 3.41 1 5.11l.76 3.54a66 66 0 0111.29 2.42c1.49.45 2.9.89 4.34 1.46zm-115.27 22.54a42.12 42.12 0 01-5.8 3c-2.46 1.12-5 2.09-7.48 3-5 1.85-10.15 3.47-15.3 5s-10.32 2.89-15.53 4.16c-10.42 2.55-20.94 4.57-31.47 6.47s-21.12 3.58-31.77 4.87c-2.66.34-5.32.66-8 .94s-5.34.57-8 .82q-8 .72-16.09 1.13c-5.38.28-10.77.45-16.17.46-2.71 0-5.42-.09-8.12-.13l-8-.29c-10.71-.46-21.44-1.11-32.2-2.32-5.39-.62-10.77-1.45-16.17-2.58-2.7-.6-5.4-1.22-8.11-2.07-.67-.18-1.35-.43-2-.65s-1.35-.45-2-.72a25.81 25.81 0 01-4.31-2 13.09 13.09 0 01-4.34-3.92 10.2 10.2 0 01-1.55-3.63c-5.9 1.34-11.73 2.54-17.64 3.76-7.61 1.51-15 3.48-22.51 5.56-1.86.53-3.74 1.05-5.53 1.6s-3.59 1.19-5.33 1.91a47.12 47.12 0 00-9.79 5.18 23.37 23.37 0 00-3.95 3.48 14 14 0 00-1.46 2 8 8 0 00-.84 2 4.59 4.59 0 00.53 3.62 10.09 10.09 0 003.29 3.11 19.33 19.33 0 004.55 2.13 32.39 32.39 0 005.23 1.19 73.18 73.18 0 0011.15.66 222.35 222.35 0 0022.9-1.59c7.68-.85 15.39-1.79 23.25-2.39 2-.13 3.91-.29 6-.3a43.75 43.75 0 016.23.23 26.11 26.11 0 013.21.58c.54.14 1.08.26 1.61.42l1.57.57c2 .82 3.83 1.82 5.46 2.64 6.46 3.32 13.92 4.71 21.49 5.72a217.47 217.47 0 0023 1.7 118.24 118.24 0 0022.84-1.43c7.57-1.2 14.73-4 22.32-6.17a60.6 60.6 0 0111.66-2.05 55.28 55.28 0 0111.85.29 69.82 69.82 0 0111.5 2.66c3.75 1.15 7.4 2.46 11.09 3.6a85.62 85.62 0 0011.15 2.85 61.47 61.47 0 0011.32.92c7.57-.19 15.07-1.87 22.45-3.94 3.7-1.08 7.4-2.25 11.19-3.32a90.74 90.74 0 0111.68-2.49 95.19 95.19 0 0123.85-.06 216.8 216.8 0 0123.25 4.07c7.53 1.6 15.06 3.24 22.63 4.29a152.91 152.91 0 0022.7 1.9 81.57 81.57 0 0022.06-2.76 74.73 74.73 0 0020-9.35c1.59-1 3.1-2.13 4.65-3.19.73-.54 1.41-1.07 2.1-1.62s1.35-1.14 1.95-1.77a31.2 31.2 0 006.15-8.29 27.21 27.21 0 001.85-20 35.78 35.78 0 00-11.83-17.17 59.2 59.2 0 00-19.34-10.34 62.92 62.92 0 00-8-2.19 64.85 64.85 0 003.07 9.33l-1.18-2.2-.59-1.1-.49-1.15c-.62-1.53-1.32-3.06-1.83-4.64-1.15-3.13-2.06-6.33-3-9.52-1.75-6.41-3.27-12.88-4.61-19.39s-2.51-13-3.61-19.57c-.51-3-.88-5.34-1.32-8.36a23.36 23.36 0 01-3.7.76c.17 3.16.47 6.31.41 9.47v4.95c0 1.65-.12 3.3-.18 5l-.11 2.48c-.05.82-.14 1.64-.21 2.46l-.47 4.93a138.43 138.43 0 01-3.69 19.41 90 90 0 01-6.94 18.41 98.62 98.62 0 003.45-11.21 78 78 0 00-11 2.86 92.1 92.1 0 00-10.51 4.32 99.31 99.31 0 00-10 5.55c-1.61 1-3.2 2.08-4.75 3.19-.78.56-1.55 1.13-2.31 1.7l-1.22.9a14.57 14.57 0 01-7.5 2.65 14.71 14.71 0 01-3.18-.14c-.54-.09-1-.19-1.48-.29l-1.42-.27a93.82 93.82 0 00-11.42-1.56 42.16 42.16 0 00-5.73-.05 14.36 14.36 0 00-5.56 1.32zm91.19-78.3c.42 3.09.86 6.17 1.29 9.25.91 6.54 1.93 13.07 2.93 19.59.69 4.16 1.38 8.32 2.12 12.47.42-.73.82-1.47 1.22-2.21a98.91 98.91 0 005.46-12.29 81.63 81.63 0 003.55-12.85 67.23 67.23 0 001.17-11.56 23.71 23.71 0 01-9.74-5.71c-.52-.5-1-1.05-1.44-1.59a19 19 0 01-6.56 4.9zm12.35-17.05a34.1 34.1 0 00-4.83-3.35 28.23 28.23 0 00-5.48-2.36 26.12 26.12 0 00-11.82-.71 33.16 33.16 0 00-11.22 4 32.2 32.2 0 00-8.19 6.39 21.31 21.31 0 0019.52 13.49 22.42 22.42 0 0015.67-5.91 21 21 0 005-7.11 20.43 20.43 0 001.34-4.41m.74-4.06c-.08 5.93-1.55 10.21-4.83 14.22a18.51 18.51 0 001.58 1.74 21.52 21.52 0 0015.05 6.54 22.38 22.38 0 0015.67-5.92 19.14 19.14 0 006-10.53 37.22 37.22 0 00-7.58-4.84 34 34 0 00-4.13-1.62 35.75 35.75 0 00-4.34-1 34.66 34.66 0 00-8.87-.36l-2.21.25c-.73.13-1.47.23-2.2.39a31.7 31.7 0 00-4.13 1.1zm-118.23 64.72a86.75 86.75 0 0014-28.35c.73-2.56 1.35-5.14 2-7.71s1.1-5.19 1.52-7.82a155.25 155.25 0 001.8-15.8 206.7 206.7 0 00-.37-31.77 189.38 189.38 0 00-5-31.19 165 165 0 00-10.69-29.51c-1.17-2.33-2.23-4.73-3.53-7s-2.47-4.6-3.87-6.81l-2-3.36c-.69-1.1-1.43-2.18-2.15-3.27s-1.42-2.18-2.17-3.25l-2.3-3.16c-3.05-4.23-6.43-8.2-9.87-12.11-1.71-2-3.56-3.79-5.34-5.7s-3.74-3.64-5.65-5.38a153 153 0 00-25.12-18.47c-2.21-1.38-4.55-2.53-6.84-3.78-1.13-.64-2.32-1.18-3.5-1.74l-3.54-1.67c-2.39-1-4.8-2-7.23-3l-3.67-1.3-1.85-.66c-.61-.22-1.24-.39-1.86-.58a129.06 129.06 0 00-30.76-5.78 122.17 122.17 0 00-61.26 12.06 131.17 131.17 0 00-47.82 40.66 149 149 0 00-25.19 57.52 162.23 162.23 0 00-3.31 31.28 171.41 171.41 0 002.65 31.27 164.43 164.43 0 0022.15 58.15 148.53 148.53 0 0019.15 24.57c1.84 1.83 3.59 3.75 5.54 5.46s3.79 3.54 5.86 5.2l3 2.53a13.43 13.43 0 011.06 1c.3.32.59.66.87 1a13.06 13.06 0 011.57 2.51 7.67 7.67 0 01.72 4.19 6.59 6.59 0 01-1.75 3.64 5.79 5.79 0 01-.86.76l-.44.32a4.5 4.5 0 01-.41.25c-.26.14-.55.3-.81.42a14 14 0 01-1.46.54 16.54 16.54 0 01-2.6.54 42.71 42.71 0 01-8.89.05c-1.4-.11-2.78-.26-4.16-.42l-2-.29-1-.13h-.42a3.06 3.06 0 00-1.6.43 1.58 1.58 0 00-.64.62v-.06a1 1 0 00.11.22 5.17 5.17 0 001.61 1.32 17.26 17.26 0 003 1.32c.56.23 1.15.43 1.74.62s1.17.41 1.78.57c2.39.75 4.89 1.32 7.39 1.87 5 1.07 10.22 1.8 15.42 2.47 10.42 1.29 21 2 31.57 2.61l8 .37c2.62.07 5.24.17 7.87.2 5.26 0 10.53.05 15.81-.12 21.11-.69 42.29-2.6 63.37-5.26 10.55-1.36 21.08-2.84 31.5-4.85a261.72 261.72 0 0030.89-7.61c2.51-.82 5-1.67 7.46-2.66a28.1 28.1 0 006.83-3.6 7.28 7.28 0 002.23-2.78 3.85 3.85 0 00-.21-3.26 7.66 7.66 0 00-2.48-2.66 12.48 12.48 0 00-3.41-1.69 11.69 11.69 0 00-1.85-.48c-.61-.11-1.3-.15-2-.27a20 20 0 01-3.95-1.11 12.34 12.34 0 01-6.42-5.06 8.12 8.12 0 01-1.09-4 11.93 11.93 0 01.75-4.07 25.19 25.19 0 014.12-6.99z"
                    })
                ]
            }),
            typeof message === "string" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "message",
                "data-testid": "str-message-display",
                children: message
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "message",
                "data-testid": "node-message-display",
                children: message
            }),
            children && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./FailSnail.styles":"3CfBb","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3CfBb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFailSnail", function() {
    return StyledFailSnail;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  text-align: center;\n\n  svg {\n    display: block;\n    width: 300px;\n    margin: 150px auto 25px;\n\n    opacity: 0.5;\n  }\n\n  path,\n  ellipse {\n    fill: ",
        ";\n  }\n\n  .message {\n    margin-bottom: 25px;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFailSnail = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).iron, (0, _index.TYPOGRAPHY).fontSize.display, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4I7nt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Shrug", function() {
    return Shrug;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _index = require("Permafrost/index");
var _shrugStyles = require("./Shrug.styles");
function Shrug(props) {
    var actionLink = props.actionLink, actionText = props.actionText, buttonAction = props.buttonAction, buttonText = props.buttonText, className = props.className, id = props.id, message = props.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _shrugStyles.StyledShrug), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: "shrug",
                size: [
                    "260px",
                    "84px"
                ]
            }),
            typeof message === "string" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", (0, _objectSpreadProps._)((0, _objectSpread._)({
                className: "t-subhead-large"
            }, props === null || props === void 0 ? void 0 : props.messageProps), {
                children: message
            })) : message,
            actionLink && actionText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: actionLink,
                className: "button blue cta",
                style: {
                    marginTop: "20px"
                },
                children: actionText
            }),
            buttonAction && buttonText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                onClick: buttonAction,
                style: {
                    marginTop: "20px"
                },
                variant: "cta",
                children: buttonText
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","Permafrost/index":"iliLC","./Shrug.styles":"7f7tv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7f7tv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledShrug", function() {
    return StyledShrug;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  padding: 2em;\n\n  font-size: ",
        ";\n\n  p {\n    font-size: inherit;\n    margin-top: 2em;\n  }\n\n  svg {\n    fill: ",
        ";\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledShrug = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).iron);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lwcDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toast", function() {
    return Toast;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toastStyles = require("./Toast.styles");
var Toast = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toastStyles.StyledToast), {
        className: "Toast ".concat(className, " ").concat(props.toast.style, " ").concat(props.toast.display ? "show" : "hide"),
        style: style || {},
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            "data-cy": "toast--".concat(props.toast.style),
            children: props.toast.message
        })
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./Toast.styles":"90DRR","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"90DRR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledToast", function() {
    return StyledToast;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("@indico-data/utils");
var _colors = require("Permafrost/constants/colors");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 50px;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  transition: transform 250ms, background 250ms;\n  transform: translateY(-100%);\n  background: transparent;\n  z-index: 1000;\n  text-align: center;\n  display: table;\n\n  span {\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  &.sidebarOpen {\n    padding-left: ",
        ";\n  }\n\n  &.sidebarClosed {\n    padding-left: ",
        ";\n  }\n\n  &.show {\n    transition: transform 250ms, background 250ms;\n    transform: translateY(0);\n\n    span {\n      transition: opacity 250ms;\n      opacity: 1;\n    }\n  }\n\n  &.general {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.success {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.error {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.hide {\n    background: transparent;\n\n    span {\n      transition: opacity 250ms;\n      opacity: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var navWidthOpen = "240px";
var navWidthClosed = "50px";
var StyledToast = (0, _styledComponentsDefault.default).div(_templateObject(), navWidthOpen, navWidthClosed, (0, _colors.allColors).darkFontColor, (0, _colors.allColors).lightGray, (0, _colors.allColors).pakistanGreen, (0, _utils.colorUtils).tint((0, _colors.allColors).green, 75), (0, _colors.allColors).fireEngineRed, (0, _utils.colorUtils).tint((0, _colors.allColors).red, 75));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","Permafrost/constants/colors":"eHGMX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6XST1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", function() {
    return Tooltip;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _index = require("Permafrost/index");
var _tooltipStyles = require("./Tooltip.styles");
var Tooltip = function(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tooltipStyles.StyledTooltip), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id,
        // this was done in a hurry, consider refactor on next pass.
        style: {
            display: props.block ? "block" : "inline-block"
        },
        children: [
            props.questionMark && /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                style: {
                    color: (0, _index.COLORS).curiousBlue
                },
                className: props.questionMarkClassName,
                "data-tip": props.clickToShow ? "custom show" : "",
                "data-event": props.clickToShow ? "click focus" : "",
                "data-for": props.for,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "fa-question-circle"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTooltipDefault.default), {
                className: "tool",
                globalEventOff: props.clickToShow ? "click" : "",
                place: props.place || "top",
                id: props.for,
                delayShow: props.delayShow,
                delayHide: props.delayHide,
                children: props.children
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","react-tooltip":"dnSWJ","Permafrost/index":"iliLC","./Tooltip.styles":"6oY3i","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dnSWJ":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _class, _class2, _temp;
/* Decorators */ /* Utils */ /* CSS */ var _react = require("1483199a63382cc0");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("faa7dd536e6f065");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require("c6ea443dfcaedca1");
var _classnames2 = _interopRequireDefault(_classnames);
var _staticMethods = require("ec8c5a567640afd2");
var _staticMethods2 = _interopRequireDefault(_staticMethods);
var _windowListener = require("da46ba21cd6fc05c");
var _windowListener2 = _interopRequireDefault(_windowListener);
var _customEvent = require("23fe0331f1eca832");
var _customEvent2 = _interopRequireDefault(_customEvent);
var _isCapture = require("fddbe63c5323f110");
var _isCapture2 = _interopRequireDefault(_isCapture);
var _getEffect = require("f20be80a4aed5fd6");
var _getEffect2 = _interopRequireDefault(_getEffect);
var _trackRemoval = require("ea25865794ee2459");
var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
var _getPosition = require("421ec00125df8860");
var _getPosition2 = _interopRequireDefault(_getPosition);
var _getTipContent = require("c68ecbb929efb823");
var _getTipContent2 = _interopRequireDefault(_getTipContent);
var _aria = require("c4da7afcc82330a2");
var _nodeListToArray = require("4fcdadeec8359c80");
var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
var _style = require("faab363928564225");
var _style2 = _interopRequireDefault(_style);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function(_React$Component) {
    _inherits(ReactTooltip, _React$Component);
    function ReactTooltip(props) {
        _classCallCheck(this, ReactTooltip);
        var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
        _this.state = {
            place: props.place || "top",
            desiredPlace: props.place || "top",
            type: "dark",
            effect: "float",
            show: false,
            border: false,
            offset: {},
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            currentTarget: null,
            ariaProps: (0, _aria.parseAria)(props),
            isEmptyTip: false,
            disable: false,
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ _createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, insecure = _props.insecure, resizeHide = _props.resizeHide;
                if (insecure) this.setStyleHeader(); // Set the style to the <link>
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener();
                this.unbindWindowEvents();
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = void 0;
                if (!id) targetArray = document.querySelectorAll("[data-tip]:not([data-for])");
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
                }
                // targetArray is a NodeList, convert it to a real array
                return (0, _nodeListToArray2.default)(targetArray);
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _props2 = this.props, id = _props2.id, globalEventOff = _props2.globalEventOff, isCapture = _props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _props3 = this.props, id = _props3.id, globalEventOff = _props3.globalEventOff;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    _this4.unbindBasicListener(target);
                    if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                });
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _props4 = this.props, getContent = _props4.getContent, children = _props4.children;
                // Generate tooltip content
                var content = void 0;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _props5 = this.props, multiline = _props5.multiline, getContent = _props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = (0, _getPosition2.default)(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace;
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self = this;
                var updateState = function updateState() {
                    self.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self.props.type || "dark",
                        effect: effect,
                        offset: offset,
                        html: target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self.props.html || false,
                        delayShow: target.getAttribute("data-delay-show") || self.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self.props.delayUpdate || 0,
                        border: target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self.props.border || false,
                        extraClass: target.getAttribute("data-class") || self.props.class || self.props.className || "",
                        disable: target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self.props.disable || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self.addScrollListener(self.state.currentTarget);
                        self.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self.intervalUpdateContent = setInterval(function() {
                            if (self.mount) {
                                var _getContent = self.props.getContent;
                                var placeholder = (0, _getTipContent2.default)(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self.isEmptyTip(placeholder);
                                self.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _state = this.state, delayShow = _state.delayShow, disable = _state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var delayTime = parseInt(delayShow, 10);
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayShow) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener();
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener() {
                window.removeEventListener("scroll", this.hideTooltipOnScroll);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _state2 = this.state, currentEvent = _state2.currentEvent, currentTarget = _state2.currentTarget, place = _state2.place, desiredPlace = _state2.desiredPlace, effect = _state2.effect, offset = _state2.offset;
                var node = this.tooltipRef;
                var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "setStyleHeader",
            value: function setStyleHeader() {
                var head = document.getElementsByTagName("head")[0];
                if (!head.querySelector('style[id="react-tooltip"]')) {
                    var tag = document.createElement("style");
                    tag.id = "react-tooltip";
                    tag.innerHTML = _style2.default;
                    /* eslint-disable */ if (typeof __webpack_nonce__ !== "undefined" && __webpack_nonce__) tag.setAttribute("nonce", __webpack_nonce__);
                    /* eslint-enable */ head.insertBefore(tag, head.firstChild);
                }
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this8 = this;
                var _state3 = this.state, extraClass = _state3.extraClass, html = _state3.html, ariaProps = _state3.ariaProps, disable = _state3.disable;
                var placeholder = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(placeholder);
                var tooltipClass = (0, _classnames2.default)("__react_component_tooltip", {
                    "show": this.state.show && !disable && !isEmptyTip
                }, {
                    "border": this.state.border
                }, {
                    "place-top": this.state.place === "top"
                }, {
                    "place-bottom": this.state.place === "bottom"
                }, {
                    "place-left": this.state.place === "left"
                }, {
                    "place-right": this.state.place === "right"
                }, {
                    "type-dark": this.state.type === "dark"
                }, {
                    "type-success": this.state.type === "success"
                }, {
                    "type-warning": this.state.type === "warning"
                }, {
                    "type-error": this.state.type === "error"
                }, {
                    "type-info": this.state.type === "info"
                }, {
                    "type-light": this.state.type === "light"
                }, {
                    "allow_hover": this.props.delayUpdate
                }, {
                    "allow_click": this.props.clickable
                });
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                if (html) return _react2.default.createElement(Wrapper, _extends({
                    className: tooltipClass + " " + extraClass,
                    id: this.props.id,
                    ref: function ref(_ref) {
                        return _this8.tooltipRef = _ref;
                    }
                }, ariaProps, {
                    "data-id": "tooltip",
                    dangerouslySetInnerHTML: {
                        __html: placeholder
                    }
                }));
                else return _react2.default.createElement(Wrapper, _extends({
                    className: tooltipClass + " " + extraClass,
                    id: this.props.id
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this8.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), placeholder);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = (0, _aria.parseAria)(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return _extends({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}(_react2.default.Component), _class2.propTypes = {
    children: _propTypes2.default.any,
    place: _propTypes2.default.string,
    type: _propTypes2.default.string,
    effect: _propTypes2.default.string,
    offset: _propTypes2.default.object,
    multiline: _propTypes2.default.bool,
    border: _propTypes2.default.bool,
    insecure: _propTypes2.default.bool,
    class: _propTypes2.default.string,
    className: _propTypes2.default.string,
    id: _propTypes2.default.string,
    html: _propTypes2.default.bool,
    delayHide: _propTypes2.default.number,
    delayUpdate: _propTypes2.default.number,
    delayShow: _propTypes2.default.number,
    event: _propTypes2.default.string,
    eventOff: _propTypes2.default.string,
    watchWindow: _propTypes2.default.bool,
    isCapture: _propTypes2.default.bool,
    globalEventOff: _propTypes2.default.string,
    getContent: _propTypes2.default.any,
    afterShow: _propTypes2.default.func,
    afterHide: _propTypes2.default.func,
    overridePosition: _propTypes2.default.func,
    disable: _propTypes2.default.bool,
    scrollHide: _propTypes2.default.bool,
    resizeHide: _propTypes2.default.bool,
    wrapper: _propTypes2.default.string,
    clickable: _propTypes2.default.bool
}, _class2.defaultProps = {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}, _class2.supportedWrappers = [
    "div",
    "span"
], _class2.displayName = "ReactTooltip", _temp)) || _class) || _class) || _class) || _class) || _class) || _class;
/* export default not fit for standalone, it will exports {default:...} */ module.exports = ReactTooltip;

},{"@swc/helpers/_/_type_of":"6Gp9n","1483199a63382cc0":"ktQNc","faa7dd536e6f065":"8INHm","c6ea443dfcaedca1":"aMKnv","ec8c5a567640afd2":"3OtuE","da46ba21cd6fc05c":"9tact","23fe0331f1eca832":"4gPlD","fddbe63c5323f110":"7eBXS","f20be80a4aed5fd6":"EiBh8","ea25865794ee2459":"cw0kP","421ec00125df8860":"4YpL6","c68ecbb929efb823":"8MZyn","c4da7afcc82330a2":"kYfyK","4fcdadeec8359c80":"igpVl","faab363928564225":"3gqKt"}],"aMKnv":[function(require,module,exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"3OtuE":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            var e = {
                currentTarget: event.detail.target
            };
            this.showTooltip(e, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
};
var _constant = require("424a288eae153b2a");
var _constant2 = _interopRequireDefault(_constant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    var event = void 0;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true);
        event.detail = opts;
    }
    window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */ 

},{"424a288eae153b2a":"fbF7j"}],"fbF7j":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};

},{}],"9tact":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
        window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
        window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
};
var _constant = require("205bbd0335c2042");
var _constant2 = _interopRequireDefault(_constant);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"205bbd0335c2042":"fbF7j"}],"4gPlD":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _state = this.state, event = _state.event, eventOff = _state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, customListeners.get(ele, event));
            var customListener = checkStatus.bind(_this, dataEventOff);
            customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _state2 = this.state, event = _state2.event, eventOff = _state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
};
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var dataIsCapture = e.currentTarget.getAttribute("data-iscapture");
    var isCapture = dataIsCapture && dataIsCapture === "true" || this.props.isCapture;
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: _defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};

},{}],"7eBXS":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
};

},{}],"EiBh8":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
};

},{}],"cw0kP":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
};
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

},{}],"4YpL6":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = calculateOffset(offset), extraOffset_X = _calculateOffset.extraOffset_X, extraOffset_Y = _calculateOffset.extraOffset_Y;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offset_X = defaultOffset[place].l;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offset_X = defaultOffset[place].r;
        return mouseX + offset_X + extraOffset_X;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offset_Y = defaultOffset[place].t;
        return mouseY + offset_Y + extraOffset_Y;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offset_Y = defaultOffset[place].b;
        return mouseY + offset_Y + extraOffset_Y;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        "top",
        "bottom",
        "left",
        "right"
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace = void 0;
    if (inside(desiredPlace) && desiredPlace !== place) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
};
var getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top = void 0;
    var right = void 0;
    var bottom = void 0;
    var left = void 0;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
    var extraOffset_X = 0;
    var extraOffset_Y = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/\'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffset_Y -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffset_Y += parseInt(offset[key], 10);
        else if (key === "left") extraOffset_X -= parseInt(offset[key], 10);
        else if (key === "right") extraOffset_X += parseInt(offset[key], 10);
    }
    return {
        extraOffset_X: extraOffset_X,
        extraOffset_Y: extraOffset_Y
    };
};
// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        if (window.getComputedStyle(currentParent).getPropertyValue("transform") !== "none") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};

},{}],"8MZyn":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return _react2.default.createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
};
var _react = require("4e947083bc596487");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"4e947083bc596487":"ktQNc"}],"kYfyK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}

},{}],"igpVl":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = function(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
};

},{}],"3gqKt":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

},{}],"6oY3i":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTooltip", function() {
    return StyledTooltip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n\n  i:hover {\n    cursor: pointer;\n  }\n\n  p {\n    line-height: 1.4;\n    font-size: 13px;\n  }\n\n  .tool {\n    background: ",
        " !important;\n    border: 1px solid ",
        " !important;\n    border-radius: 2px !important;\n    padding: 8px 11px !important;\n    opacity: 1 !important;\n\n    &.place-left:after {\n      border-left-color: ",
        " !important;\n      border-top: 5px solid transparent !important;\n      border-bottom: 5px solid transparent !important;\n      right: -6px !important;\n      top: 50% !important;\n      margin-top: -9px !important;\n    }\n\n    &.place-left:before {\n      border-left-color: ",
        " !important;\n      border-left-width: 8px !important;\n      border-left-style: solid !important;\n      margin-top: -10px !important;\n    }\n\n    &.place-right:after {\n      border-right-color: ",
        " !important;\n      border-top: 5px solid transparent !important;\n      border-bottom: 5px solid transparent !important;\n      left: -6px !important;\n      top: 50% !important;\n      margin-top: -9px !important;\n    }\n\n    &.place-right:before {\n      border-right-color: ",
        " !important;\n      border-right-width: 8px !important;\n      border-right-style: solid !important;\n      margin-top: -10px !important;\n    }\n\n    &.place-top:after {\n      border-top-color: ",
        " !important;\n    }\n\n    &.place-top:before {\n      border-top-color: ",
        " !important;\n      border-top-width: 8px !important;\n      border-top-style: solid !important;\n    }\n\n    &.place-bottom:after {\n      border-bottom-color: ",
        " !important;\n    }\n\n    &.place-bottom:before {\n      border-bottom-color: ",
        " !important;\n      border-bottom-width: 8px !important;\n      border-bottom-style: solid !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTooltip = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dHgiV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flag", function() {
    return Flag;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _flagStyles = require("./Flag.styles");
var Flag = function(props) {
    var id = props.id, className = props.className, text = props.text, _props_flagColor = props.flagColor, flagColor = _props_flagColor === void 0 ? (0, _index.COLORS).yellowOrange : _props_flagColor, _props_fontColor = props.fontColor, fontColor = _props_fontColor === void 0 ? (0, _index.COLORS).black : _props_fontColor;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flagStyles.StyledFlag), {
        id: id,
        className: className,
        "data-cy": props["data-cy"],
        "data-testid": "flag-component",
        $flagColor: flagColor,
        $fontColor: fontColor,
        children: text
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./Flag.styles":"fxKE4","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fxKE4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFlag", function() {
    return StyledFlag;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  clip-path: polygon(0% 0%, 100% 0%, 85% 50%, 100% 100%, 0% 100%);\n  padding: 1px 12px 1px 4px;\n  border-radius: 3px 0 0 3px;\n  background-color: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: bold;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFlag = (0, _styledComponentsDefault.default).span(_templateObject(), function(props) {
    return props.$flagColor;
}, (0, _index.TYPOGRAPHY).fontSize.base, function(props) {
    return props.$fontColor;
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"edPPv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", function() {
    return Section;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionStyles = require("./Section.styles");
var Section = function(props) {
    var className = props.className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = (0, _objectWithoutProperties._)(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionStyles.StyledSection), (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: (0, _classnamesDefault.default)("Section", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","./Section.styles":"jqIfp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jqIfp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSection", function() {
    return StyledSection;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  float: left;\n  margin-bottom: 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSection = (0, _styledComponentsDefault.default).article(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dSc33":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionBody", function() {
    return SectionBody;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionBodyStyles = require("./SectionBody.styles");
var SectionBody = function(props) {
    var className = props.className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = (0, _objectWithoutProperties._)(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionBodyStyles.StyledSectionBody), (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: (0, _classnamesDefault.default)("SectionBody", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","./SectionBody.styles":"fpKby","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fpKby":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionBody", function() {
    return StyledSectionBody;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  border: 1px solid #333d4c;\n  padding: 0 ",
        ";\n\n  .SectionBody:last-of-type {\n    .section-bottom-border {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var sectionSidePadding = "19px";
var StyledSectionBody = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).clay, sectionSidePadding);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fdltS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionHeader", function() {
    return SectionHeader;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionHeaderStyles = require("./SectionHeader.styles");
var SectionHeader = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = (0, _objectWithoutProperties._)(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionHeaderStyles.StyledSectionHeader), (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: (0, _classnamesDefault.default)("SectionHeader", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), {
        children: children
    }));
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","./SectionHeader.styles":"6oykB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6oykB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionHeader", function() {
    return StyledSectionHeader;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 23px 0 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSectionHeader = (0, _styledComponentsDefault.default).header(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"97bu9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionBlock", function() {
    return SectionBlock;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _sectionBlockStyles = require("./SectionBlock.styles");
var SectionBlock = function(props) {
    var title = props.title, className = props.className, children = props.children, id = props.id, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, flagText = props.flagText, flagMessage = props.flagMessage, restOfProps = (0, _objectWithoutProperties._)(props, [
        "title",
        "className",
        "children",
        "id",
        "style",
        "flagText",
        "flagMessage"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sectionBlockStyles.StyledSectionBlock), (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: (0, _classnamesDefault.default)("SectionBlock", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), {
        children: [
            title ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "SectionBlock--header",
                style: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: title
                            }),
                            flagText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Flag), {
                                text: flagText
                            }) : null
                        ]
                    }),
                    flagMessage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "SectionBlock__flag-message",
                        children: flagMessage
                    }) : null
                ]
            }) : null,
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                className: "section-bottom-border"
            })
        ]
    }));
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./SectionBlock.styles":"4CR5m","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4CR5m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionBlock", function() {
    return StyledSectionBlock;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .SectionBlock--header {\n    flex-direction: column;\n    align-items: flex-start !important;\n\n    .header-container {\n      display: flex;\n      align-items: center;\n\n      h3 {\n        display: flex;\n        align-items: center;\n        margin: 24px 10px 20px 0;\n      }\n    }\n\n    .SectionBlock__flag-message {\n      color: ",
        ";\n      margin: 0 0 10px 20px;\n    }\n  }\n\n  hr {\n    width: 100%;\n    border-bottom: 1px solid ",
        ";\n    margin: 27px 0 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSectionBlock = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).yellowOrange, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7pFkX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionTable", function() {
    return SectionTable;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _sectionTableStyles = require("./SectionTable.styles");
var createTitle = function(item) {
    return typeof item === "string" || typeof item === "number" ? item : null;
};
var SectionTable = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), openRowOptions = _useState[0], changeOpenRowOptions = _useState[1];
    var handleRowClick = function(link) {
        if (!link) return null;
        return function(e) {
            e.stopPropagation();
            props.history.push(link);
        };
    };
    var handleRowOptionToggleClick = function(id) {
        if (openRowOptions.indexOf(id) === -1) changeOpenRowOptions([].concat(openRowOptions, id));
        else changeOpenRowOptions(openRowOptions.filter(function(option) {
            return option !== id;
        }));
        if (props.openRowOptionHandler) props.openRowOptionHandler(id);
    };
    var headers = Object.keys(props.tableObjects[0].content);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _sectionTableStyles.StyledSectionTable), {
        className: (0, _classnamesDefault.default)("SectionTable", props.className, {
            loading: props.loading
        }),
        "data-cy": props["data-cy"],
        id: props.id,
        children: [
            props.sortColumnHandler && props.sortedColumn && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mobile-sort",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.BorderSelect), {
                    onChange: function(e) {
                        return props.sortColumnHandler(e.target.value);
                    },
                    value: props.sortedColumn,
                    options: [].concat({
                        name: "Choose Sorting Option",
                        value: ""
                    }, headers.map(function(item) {
                        return {
                            name: item,
                            value: item
                        };
                    }))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", (0, _objectSpreadProps._)((0, _objectSpread._)({}, props.tableProps), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                props.tableObjects[0].rowAccordionContent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "action-column"
                                }) : null,
                                headers.map(function(header, i) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                        className: (0, _classnamesDefault.default)({
                                            "not-sortable": props.sortableHeaders && props.sortableHeaders.indexOf(header) === -1
                                        }),
                                        onClick: function() {
                                            if (props.sortColumnHandler) {
                                                if (props.sortableHeaders) {
                                                    if (props.sortableHeaders.indexOf(header) !== -1) props.sortColumnHandler(header);
                                                } else props.sortColumnHandler(header);
                                            }
                                        },
                                        children: [
                                            props.headersContent ? props.headersContent[header] : header,
                                            " ",
                                            props.sortedColumn === header && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                                name: "fa-caret-".concat(props.sortDirection)
                                            })
                                        ]
                                    }, i);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        className: (0, _classnamesDefault.default)({
                            "SectionTable--tbody-loading": props.loading
                        }),
                        children: props.loading ? Array.from({
                            length: 5
                        }, function(x, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                children: props.tableObjects[0].rowAccordionContent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    colSpan: headers.length + 1
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    colSpan: headers.length
                                })
                            }, i);
                        }) : props.tableObjects.map(function(obj, i) {
                            var rowStyle = obj.rowStyleCondition;
                            if (rowStyle) rowStyle = (0, _defineProperty._)({}, rowStyle.className, rowStyle.condition);
                            if (obj.rowAccordionContent) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                className: (0, _classnamesDefault.default)(rowStyle)
                            }, props.rowProps), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                    colSpan: headers.length + 1,
                                    style: {
                                        padding: "0"
                                    },
                                    className: "outer-hover",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                            className: "action-column",
                                                            style: {
                                                                padding: "0",
                                                                height: "1px",
                                                                border: "none"
                                                            }
                                                        }),
                                                        headers.map(function(e, i) {
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                                                style: {
                                                                    padding: "0",
                                                                    height: "1px",
                                                                    border: "none"
                                                                }
                                                            }, i);
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                                        onClick: function() {
                                                            return handleRowOptionToggleClick(obj.id);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                                style: {
                                                                    borderBottom: "none"
                                                                },
                                                                className: "action-column",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                                                    name: "chevron-down",
                                                                    style: {
                                                                        transform: openRowOptions.indexOf(obj.id) !== -1 ? "rotate(180deg)" : ""
                                                                    }
                                                                })
                                                            }),
                                                            Object.keys(obj.content).map(function(key, i) {
                                                                var _props_headingProps;
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                                                    style: {
                                                                        borderBottom: "none"
                                                                    },
                                                                    "data-heading": headers[i],
                                                                    title: createTitle(obj.content[key])
                                                                }, props === null || props === void 0 ? void 0 : (_props_headingProps = props.headingProps) === null || _props_headingProps === void 0 ? void 0 : _props_headingProps[headers === null || headers === void 0 ? void 0 : headers[i]]), {
                                                                    children: obj.content[key]
                                                                }), i);
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                                        className: (0, _classnamesDefault.default)("row-option", {
                                                            open: openRowOptions.indexOf(obj.id) !== -1
                                                        }),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                            className: "inner-table-cell",
                                                            colSpan: headers.length + 1,
                                                            children: obj.rowAccordionContent
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }), i);
                            else if (obj.lineItemLink) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                onClick: handleRowClick(obj.lineItemLink),
                                className: (0, _classnamesDefault.default)("hover", rowStyle)
                            }, props.rowProps), {
                                children: Object.keys(obj.content).map(function(key, i) {
                                    var _props_headingProps;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                        "data-heading": headers[i],
                                        title: createTitle(obj.content[key])
                                    }, props === null || props === void 0 ? void 0 : (_props_headingProps = props.headingProps) === null || _props_headingProps === void 0 ? void 0 : _props_headingProps[headers === null || headers === void 0 ? void 0 : headers[i]]), {
                                        children: obj.content[key]
                                    }), i);
                                })
                            }), i);
                            else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                className: (0, _classnamesDefault.default)(rowStyle)
                            }, props.rowProps), {
                                children: Object.keys(obj.content).map(function(key, i) {
                                    var _props_headingProps;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                        "data-heading": headers[i],
                                        title: createTitle(obj.content[key])
                                    }, props === null || props === void 0 ? void 0 : (_props_headingProps = props.headingProps) === null || _props_headingProps === void 0 ? void 0 : _props_headingProps[headers === null || headers === void 0 ? void 0 : headers[i]]), {
                                        children: obj.content[key]
                                    }), i);
                                })
                            }), i);
                        })
                    })
                ]
            }))
        ]
    });
};

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./SectionTable.styles":"gKzmE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gKzmE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionTable", function() {
    return StyledSectionTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  25% {\n    left: -50px;\n  }\n  50% {\n    left: calc(100% + 50px);\n  }\n  75% {\n    left: calc(100% + 50px);\n  }\n  100% {\n    left: calc(100% + 50px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .mobile-sort {\n    @media ",
        " {\n      display: none;\n    }\n\n    select {\n      max-width: none;\n    }\n  }\n\n  .outer-hover {\n    @media ",
        " {\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  &.loading {\n    margin-top: 50px;\n\n    table {\n      overflow: hidden;\n    }\n  }\n\n  .SectionTable--tbody-loading {\n    tr {\n      margin: 10px 0;\n      border-bottom: 10px solid transparent;\n    }\n\n    td {\n      position: relative;\n      border-bottom: none;\n      height: 73px;\n      background: ",
        ";\n\n      &:before {\n        position: absolute;\n        display: block;\n        top: 0;\n        left: -50px;\n        content: '';\n        height: 100%;\n        width: 50px;\n        background: linear-gradient(90deg, ",
        ", #232e3d, ",
        ");\n        animation: ",
        " 2s infinite;\n        animation-timing-function: linear;\n      }\n    }\n  }\n\n  tbody > tr {\n    @media ",
        " {\n      &.hover:hover {\n        background: ",
        ";\n        cursor: pointer;\n      }\n    }\n  }\n\n  .action-column {\n    display: none;\n    text-align: center;\n    width: 20px;\n    padding: 20px 5px;\n\n    @media ",
        " {\n      display: table-cell;\n    }\n  }\n\n  table,\n  thead,\n  tbody,\n  th,\n  td,\n  tr {\n    display: block;\n\n    @media ",
        " {\n      display: table;\n    }\n\n    .no-link {\n      cursor: default;\n    }\n  }\n\n  thead {\n    display: block;\n\n    @media ",
        " {\n      display: table-header-group;\n    }\n  }\n\n  th {\n    padding-bottom: 10px;\n    border-bottom: 1px solid #535d6d;\n  }\n\n  th:hover {\n    cursor: pointer;\n  }\n\n  th.not-sortable:hover {\n    cursor: default;\n  }\n\n  tbody {\n    display: block;\n\n    @media ",
        " {\n      display: table-row-group;\n    }\n  }\n\n  th,\n  td {\n    display: block;\n\n    @media ",
        " {\n      display: table-cell;\n    }\n  }\n\n  tr {\n    display: block;\n    padding-bottom: 10px;\n\n    @media ",
        " {\n      display: table-row;\n\n      border-bottom: 0.5px solid ",
        ";\n    }\n  }\n\n  /* Hide table headers (but not display: none;, for accessibility) */\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n\n    @media ",
        " {\n      position: static;\n    }\n  }\n\n  tr:nth-child(odd) {\n    background: ",
        ";\n\n    @media ",
        ' {\n      background: transparent;\n    }\n  }\n\n  td {\n    /* Behave  like a "row" */\n    border: none;\n    position: relative;\n    padding-left: 50%;\n    padding-top: 10px;\n    padding-bottom: 5px;\n\n    @media ',
        " {\n      position: static;\n      // border-bottom: 0.5px solid ",
        ";\n      padding: 20px 15px;\n    }\n  }\n\n  td:before {\n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    left: 6px;\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    content: attr(data-heading);\n\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  td.inner-table-cell {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 5px;\n    border: none;\n\n    &:before {\n      display: none;\n    }\n  }\n\n  tr.row-option {\n    display: none;\n\n    &.open {\n      display: table-row;\n    }\n  }\n\n  .outer-hover tr {\n    border: none;\n  }\n\n  .outer-hover .hover {\n    border-bottom: 0.5px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var cardTableLoading = (0, _styledComponents.keyframes)(_templateObject());
var StyledSectionTable = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).mirage, (0, _index.COLORS).mirage, (0, _index.COLORS).mirage, cardTableLoading, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).oxfordBlue, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).oxfordBlue, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lfmK0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetCard", function() {
    return WidgetCard;
});
parcelHelpers.export(exports, "WidgetCardHeader", function() {
    return WidgetCardHeader;
});
parcelHelpers.export(exports, "WidgetCardContent", function() {
    return WidgetCardContent;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 1px 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  height: 45px;\n\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  padding: 5px 15px;\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 18px 20px;\n\n  header {\n    margin-bottom: 26px;\n    font-size: 22px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var WidgetCard = (0, _styledComponentsDefault.default).article(_templateObject(), (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony);
var WidgetCardHeader = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).ebony);
var WidgetCardContent = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react":"ktQNc","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kStzr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartContextMenu", function() {
    return ChartContextMenu;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _chartContextMenuStyles = require("./ChartContextMenu.styles");
function ChartContextMenu(props) {
    var closeMenuHandler = props.closeMenuHandler, xPos = props.xPos, yPos = props.yPos, options = props.options, currentDatum = props.currentDatum;
    var menuEl = (0, _react.useRef)();
    (0, _utils.hookUtils).useClickOutside(menuEl, closeMenuHandler);
    var onItemClicked = function(itemHandler) {
        itemHandler(currentDatum);
        props.closeMenuHandler();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chartContextMenuStyles.StyledContextMenu), {
        style: {
            top: yPos,
            left: xPos
        },
        ref: menuEl,
        children: options.map(function(option, index) {
            var disabled = option.filter && !option.filter(currentDatum);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                className: (0, _classnamesDefault.default)({
                    disabled: disabled
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    href: "/",
                    onClick: function(e) {
                        e.preventDefault();
                        return !disabled && onItemClicked(option.handler);
                    },
                    children: [
                        option.icon ? option.icon : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "fa-square"
                        }),
                        " ",
                        option.name
                    ]
                })
            }, index);
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./ChartContextMenu.styles":"htw0N","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"htw0N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContextMenu", function() {
    return StyledContextMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  font-size: 12px;\n\n  li {\n    padding: 5px 7px;\n\n    a {\n      text-decoration: none;\n      color: ",
        ";\n    }\n\n    &.disabled {\n      opacity: 0.5;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContextMenu = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1uTGc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartToolTip", function() {
    return ChartToolTip;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// import PropTypes from 'prop-types';
var _chartToolTipStyles = require("./ChartToolTip.styles");
var ChartToolTip = function(props) {
    var children = props.children, className = props.className, id = props.id, xPos = props.xPos, yPos = props.yPos;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chartToolTipStyles.StyledChartToolTip), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: {
            top: yPos,
            left: xPos
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "Tooltip-Contents",
            children: children
        })
    });
}; // ChartToolTip.propTypes = {
 //     xPos: PropTypes.number.isRequired,
 //     yPos: PropTypes.number.isRequired
 // };

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./ChartToolTip.styles":"fgbYi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fgbYi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledChartToolTip", function() {
    return StyledChartToolTip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: 13px;\n  left: -999em;\n  top: -999em;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  z-index: 800;\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: 8px 11px;\n  transform: translate(-50%, -100%);\n  margin-top: -14px;\n\n  &:before,\n  &:after {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 50%;\n  }\n\n  &:before {\n    border-top: 8px solid ",
        ";\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    bottom: -8px;\n    margin-left: -10px;\n  }\n\n  &:after {\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    bottom: -6px;\n    margin-left: -8px;\n    border-top: 6px solid ",
        ";\n  }\n\n  p {\n    font-size: 12px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledChartToolTip = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jxcY4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Matrix", function() {
    return Matrix;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _index = require("Permafrost/index");
var _matrixStyles = require("./Matrix.styles");
function Matrix(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), selectedPos = _useState[0], setSelectedPos = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), hovered = _useState1[0], setHovered = _useState1[1];
    var handleCellClick = function(row, col) {
        setSelectedPos([
            row,
            col
        ]);
        props.selectionHandler(row, col);
    };
    var onCellHover = function(row, col) {
        setHovered([
            row,
            col
        ]);
    };
    var className = props.className, data = props.data, id = props.id, tooltipPlacement = props.tooltipPlacement, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _matrixStyles.StyledMatrix), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
            className: "Matrix-Frame",
            onMouseLeave: function() {
                return setHovered([
                    -1,
                    -1
                ]);
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        className: "Matrix-Row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "Matrix-Label-Row",
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "Matrix-Axis-X",
                                colSpan: data.labels.length,
                                children: xAxisLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {})
                        ]
                    }),
                    data.matrix.map(function(row, index) {
                        var ttKey = "rowLabel".concat(index);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            className: "Matrix-Row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                    className: "Matrix-Label-Row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            "data-tip": true,
                                            "data-for": ttKey,
                                            style: {
                                                color: "".concat(hovered[0] === index ? "#fff" : "")
                                            },
                                            children: data.labels[index]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                                            for: ttKey,
                                            place: tooltipPlacement,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: data.labels[index]
                                            })
                                        })
                                    ]
                                }),
                                row.map(function(cell, rowIndex) {
                                    var cellStyles = {
                                        backgroundColor: (0, _d3ScaleChromatic.interpolateYlGnBu)(cell)
                                    };
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        className: (0, _classnamesDefault.default)("Matrix-Cell", {
                                            selected: index === selectedPos[0] && rowIndex === selectedPos[1]
                                        }),
                                        style: cellStyles,
                                        onClick: function() {
                                            return handleCellClick(index, rowIndex);
                                        },
                                        title: cell,
                                        onMouseEnter: function() {
                                            return onCellHover(index, rowIndex);
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "Contents",
                                            children: cell
                                        })
                                    }, rowIndex);
                                }),
                                index === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "Matrix-Axis-Y",
                                    rowSpan: data.labels.length,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: yAxisLabel
                                    })
                                })
                            ]
                        }, ttKey);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        className: "Matrix-Row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                className: "Matrix-Label-Row",
                                children: "\xa0"
                            }),
                            data.labels.map(function(label, index) {
                                var ttKey = "colLabel".concat(index);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("th", {
                                    className: "Matrix-Label-Col",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "rotate",
                                            "data-tip": true,
                                            "data-for": ttKey,
                                            style: {
                                                color: "".concat(hovered[1] === index ? "#fff" : "")
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: label
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                                            for: ttKey,
                                            place: tooltipPlacement,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: label
                                            })
                                        })
                                    ]
                                }, ttKey);
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {})
                        ]
                    })
                ]
            })
        })
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","d3-scale-chromatic":"6MEXx","Permafrost/index":"iliLC","./Matrix.styles":"kJqlS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6MEXx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", function() {
    return 0, _category10Default.default;
});
parcelHelpers.export(exports, "schemeAccent", function() {
    return 0, _accentDefault.default;
});
parcelHelpers.export(exports, "schemeDark2", function() {
    return 0, _dark2Default.default;
});
parcelHelpers.export(exports, "schemePaired", function() {
    return 0, _pairedDefault.default;
});
parcelHelpers.export(exports, "schemePastel1", function() {
    return 0, _pastel1Default.default;
});
parcelHelpers.export(exports, "schemePastel2", function() {
    return 0, _pastel2Default.default;
});
parcelHelpers.export(exports, "schemeSet1", function() {
    return 0, _set1Default.default;
});
parcelHelpers.export(exports, "schemeSet2", function() {
    return 0, _set2Default.default;
});
parcelHelpers.export(exports, "schemeSet3", function() {
    return 0, _set3Default.default;
});
parcelHelpers.export(exports, "interpolateBrBG", function() {
    return 0, _brBGDefault.default;
});
parcelHelpers.export(exports, "schemeBrBG", function() {
    return 0, _brBG.scheme;
});
parcelHelpers.export(exports, "interpolatePRGn", function() {
    return 0, _prgnDefault.default;
});
parcelHelpers.export(exports, "schemePRGn", function() {
    return 0, _prgn.scheme;
});
parcelHelpers.export(exports, "interpolatePiYG", function() {
    return 0, _piYGDefault.default;
});
parcelHelpers.export(exports, "schemePiYG", function() {
    return 0, _piYG.scheme;
});
parcelHelpers.export(exports, "interpolatePuOr", function() {
    return 0, _puOrDefault.default;
});
parcelHelpers.export(exports, "schemePuOr", function() {
    return 0, _puOr.scheme;
});
parcelHelpers.export(exports, "interpolateRdBu", function() {
    return 0, _rdBuDefault.default;
});
parcelHelpers.export(exports, "schemeRdBu", function() {
    return 0, _rdBu.scheme;
});
parcelHelpers.export(exports, "interpolateRdGy", function() {
    return 0, _rdGyDefault.default;
});
parcelHelpers.export(exports, "schemeRdGy", function() {
    return 0, _rdGy.scheme;
});
parcelHelpers.export(exports, "interpolateRdYlBu", function() {
    return 0, _rdYlBuDefault.default;
});
parcelHelpers.export(exports, "schemeRdYlBu", function() {
    return 0, _rdYlBu.scheme;
});
parcelHelpers.export(exports, "interpolateRdYlGn", function() {
    return 0, _rdYlGnDefault.default;
});
parcelHelpers.export(exports, "schemeRdYlGn", function() {
    return 0, _rdYlGn.scheme;
});
parcelHelpers.export(exports, "interpolateSpectral", function() {
    return 0, _spectralDefault.default;
});
parcelHelpers.export(exports, "schemeSpectral", function() {
    return 0, _spectral.scheme;
});
parcelHelpers.export(exports, "interpolateBuGn", function() {
    return 0, _buGnDefault.default;
});
parcelHelpers.export(exports, "schemeBuGn", function() {
    return 0, _buGn.scheme;
});
parcelHelpers.export(exports, "interpolateBuPu", function() {
    return 0, _buPuDefault.default;
});
parcelHelpers.export(exports, "schemeBuPu", function() {
    return 0, _buPu.scheme;
});
parcelHelpers.export(exports, "interpolateGnBu", function() {
    return 0, _gnBuDefault.default;
});
parcelHelpers.export(exports, "schemeGnBu", function() {
    return 0, _gnBu.scheme;
});
parcelHelpers.export(exports, "interpolateOrRd", function() {
    return 0, _orRdDefault.default;
});
parcelHelpers.export(exports, "schemeOrRd", function() {
    return 0, _orRd.scheme;
});
parcelHelpers.export(exports, "interpolatePuBuGn", function() {
    return 0, _puBuGnDefault.default;
});
parcelHelpers.export(exports, "schemePuBuGn", function() {
    return 0, _puBuGn.scheme;
});
parcelHelpers.export(exports, "interpolatePuBu", function() {
    return 0, _puBuDefault.default;
});
parcelHelpers.export(exports, "schemePuBu", function() {
    return 0, _puBu.scheme;
});
parcelHelpers.export(exports, "interpolatePuRd", function() {
    return 0, _puRdDefault.default;
});
parcelHelpers.export(exports, "schemePuRd", function() {
    return 0, _puRd.scheme;
});
parcelHelpers.export(exports, "interpolateRdPu", function() {
    return 0, _rdPuDefault.default;
});
parcelHelpers.export(exports, "schemeRdPu", function() {
    return 0, _rdPu.scheme;
});
parcelHelpers.export(exports, "interpolateYlGnBu", function() {
    return 0, _ylGnBuDefault.default;
});
parcelHelpers.export(exports, "schemeYlGnBu", function() {
    return 0, _ylGnBu.scheme;
});
parcelHelpers.export(exports, "interpolateYlGn", function() {
    return 0, _ylGnDefault.default;
});
parcelHelpers.export(exports, "schemeYlGn", function() {
    return 0, _ylGn.scheme;
});
parcelHelpers.export(exports, "interpolateYlOrBr", function() {
    return 0, _ylOrBrDefault.default;
});
parcelHelpers.export(exports, "schemeYlOrBr", function() {
    return 0, _ylOrBr.scheme;
});
parcelHelpers.export(exports, "interpolateYlOrRd", function() {
    return 0, _ylOrRdDefault.default;
});
parcelHelpers.export(exports, "schemeYlOrRd", function() {
    return 0, _ylOrRd.scheme;
});
parcelHelpers.export(exports, "interpolateBlues", function() {
    return 0, _bluesDefault.default;
});
parcelHelpers.export(exports, "schemeBlues", function() {
    return 0, _blues.scheme;
});
parcelHelpers.export(exports, "interpolateGreens", function() {
    return 0, _greensDefault.default;
});
parcelHelpers.export(exports, "schemeGreens", function() {
    return 0, _greens.scheme;
});
parcelHelpers.export(exports, "interpolateGreys", function() {
    return 0, _greysDefault.default;
});
parcelHelpers.export(exports, "schemeGreys", function() {
    return 0, _greys.scheme;
});
parcelHelpers.export(exports, "interpolatePurples", function() {
    return 0, _purplesDefault.default;
});
parcelHelpers.export(exports, "schemePurples", function() {
    return 0, _purples.scheme;
});
parcelHelpers.export(exports, "interpolateReds", function() {
    return 0, _redsDefault.default;
});
parcelHelpers.export(exports, "schemeReds", function() {
    return 0, _reds.scheme;
});
parcelHelpers.export(exports, "interpolateOranges", function() {
    return 0, _orangesDefault.default;
});
parcelHelpers.export(exports, "schemeOranges", function() {
    return 0, _oranges.scheme;
});
parcelHelpers.export(exports, "interpolateCubehelixDefault", function() {
    return 0, _cubehelixDefault.default;
});
parcelHelpers.export(exports, "interpolateRainbow", function() {
    return 0, _rainbowDefault.default;
});
parcelHelpers.export(exports, "interpolateWarm", function() {
    return 0, _rainbow.warm;
});
parcelHelpers.export(exports, "interpolateCool", function() {
    return 0, _rainbow.cool;
});
parcelHelpers.export(exports, "interpolateSinebow", function() {
    return 0, _sinebowDefault.default;
});
parcelHelpers.export(exports, "interpolateViridis", function() {
    return 0, _viridisDefault.default;
});
parcelHelpers.export(exports, "interpolateMagma", function() {
    return 0, _viridis.magma;
});
parcelHelpers.export(exports, "interpolateInferno", function() {
    return 0, _viridis.inferno;
});
parcelHelpers.export(exports, "interpolatePlasma", function() {
    return 0, _viridis.plasma;
});
var _category10 = require("./categorical/category10");
var _category10Default = parcelHelpers.interopDefault(_category10);
var _accent = require("./categorical/Accent");
var _accentDefault = parcelHelpers.interopDefault(_accent);
var _dark2 = require("./categorical/Dark2");
var _dark2Default = parcelHelpers.interopDefault(_dark2);
var _paired = require("./categorical/Paired");
var _pairedDefault = parcelHelpers.interopDefault(_paired);
var _pastel1 = require("./categorical/Pastel1");
var _pastel1Default = parcelHelpers.interopDefault(_pastel1);
var _pastel2 = require("./categorical/Pastel2");
var _pastel2Default = parcelHelpers.interopDefault(_pastel2);
var _set1 = require("./categorical/Set1");
var _set1Default = parcelHelpers.interopDefault(_set1);
var _set2 = require("./categorical/Set2");
var _set2Default = parcelHelpers.interopDefault(_set2);
var _set3 = require("./categorical/Set3");
var _set3Default = parcelHelpers.interopDefault(_set3);
var _brBG = require("./diverging/BrBG");
var _brBGDefault = parcelHelpers.interopDefault(_brBG);
var _prgn = require("./diverging/PRGn");
var _prgnDefault = parcelHelpers.interopDefault(_prgn);
var _piYG = require("./diverging/PiYG");
var _piYGDefault = parcelHelpers.interopDefault(_piYG);
var _puOr = require("./diverging/PuOr");
var _puOrDefault = parcelHelpers.interopDefault(_puOr);
var _rdBu = require("./diverging/RdBu");
var _rdBuDefault = parcelHelpers.interopDefault(_rdBu);
var _rdGy = require("./diverging/RdGy");
var _rdGyDefault = parcelHelpers.interopDefault(_rdGy);
var _rdYlBu = require("./diverging/RdYlBu");
var _rdYlBuDefault = parcelHelpers.interopDefault(_rdYlBu);
var _rdYlGn = require("./diverging/RdYlGn");
var _rdYlGnDefault = parcelHelpers.interopDefault(_rdYlGn);
var _spectral = require("./diverging/Spectral");
var _spectralDefault = parcelHelpers.interopDefault(_spectral);
var _buGn = require("./sequential-multi/BuGn");
var _buGnDefault = parcelHelpers.interopDefault(_buGn);
var _buPu = require("./sequential-multi/BuPu");
var _buPuDefault = parcelHelpers.interopDefault(_buPu);
var _gnBu = require("./sequential-multi/GnBu");
var _gnBuDefault = parcelHelpers.interopDefault(_gnBu);
var _orRd = require("./sequential-multi/OrRd");
var _orRdDefault = parcelHelpers.interopDefault(_orRd);
var _puBuGn = require("./sequential-multi/PuBuGn");
var _puBuGnDefault = parcelHelpers.interopDefault(_puBuGn);
var _puBu = require("./sequential-multi/PuBu");
var _puBuDefault = parcelHelpers.interopDefault(_puBu);
var _puRd = require("./sequential-multi/PuRd");
var _puRdDefault = parcelHelpers.interopDefault(_puRd);
var _rdPu = require("./sequential-multi/RdPu");
var _rdPuDefault = parcelHelpers.interopDefault(_rdPu);
var _ylGnBu = require("./sequential-multi/YlGnBu");
var _ylGnBuDefault = parcelHelpers.interopDefault(_ylGnBu);
var _ylGn = require("./sequential-multi/YlGn");
var _ylGnDefault = parcelHelpers.interopDefault(_ylGn);
var _ylOrBr = require("./sequential-multi/YlOrBr");
var _ylOrBrDefault = parcelHelpers.interopDefault(_ylOrBr);
var _ylOrRd = require("./sequential-multi/YlOrRd");
var _ylOrRdDefault = parcelHelpers.interopDefault(_ylOrRd);
var _blues = require("./sequential-single/Blues");
var _bluesDefault = parcelHelpers.interopDefault(_blues);
var _greens = require("./sequential-single/Greens");
var _greensDefault = parcelHelpers.interopDefault(_greens);
var _greys = require("./sequential-single/Greys");
var _greysDefault = parcelHelpers.interopDefault(_greys);
var _purples = require("./sequential-single/Purples");
var _purplesDefault = parcelHelpers.interopDefault(_purples);
var _reds = require("./sequential-single/Reds");
var _redsDefault = parcelHelpers.interopDefault(_reds);
var _oranges = require("./sequential-single/Oranges");
var _orangesDefault = parcelHelpers.interopDefault(_oranges);
var _cubehelix = require("./sequential-multi/cubehelix");
var _cubehelixDefault = parcelHelpers.interopDefault(_cubehelix);
var _rainbow = require("./sequential-multi/rainbow");
var _rainbowDefault = parcelHelpers.interopDefault(_rainbow);
var _sinebow = require("./sequential-multi/sinebow");
var _sinebowDefault = parcelHelpers.interopDefault(_sinebow);
var _viridis = require("./sequential-multi/viridis");
var _viridisDefault = parcelHelpers.interopDefault(_viridis);

},{"./categorical/category10":"6YEgp","./categorical/Accent":"8r6Mw","./categorical/Dark2":"9lYoK","./categorical/Paired":"OO4QB","./categorical/Pastel1":"iTTFS","./categorical/Pastel2":"iEGuS","./categorical/Set1":"hLcNT","./categorical/Set2":"jgYJM","./categorical/Set3":"8Mvmn","./diverging/BrBG":"jKuLT","./diverging/PRGn":"2WkEc","./diverging/PiYG":"6GAoZ","./diverging/PuOr":"dGVfG","./diverging/RdBu":"2lsj2","./diverging/RdGy":"jMSpi","./diverging/RdYlBu":"7Gcdr","./diverging/RdYlGn":"bboot","./diverging/Spectral":"cajGi","./sequential-multi/BuGn":"kNx09","./sequential-multi/BuPu":"6xJ9g","./sequential-multi/GnBu":"l1Sgc","./sequential-multi/OrRd":"jtaJv","./sequential-multi/PuBuGn":"hnjIe","./sequential-multi/PuBu":"5ryri","./sequential-multi/PuRd":"8r2qy","./sequential-multi/RdPu":"9VTwP","./sequential-multi/YlGnBu":"j7gP5","./sequential-multi/YlGn":"f3A9q","./sequential-multi/YlOrBr":"hRhvS","./sequential-multi/YlOrRd":"7bxqV","./sequential-single/Blues":"bEuJN","./sequential-single/Greens":"hjeQO","./sequential-single/Greys":"eJvKh","./sequential-single/Purples":"hOWNb","./sequential-single/Reds":"3nNr2","./sequential-single/Oranges":"kjeAw","./sequential-multi/cubehelix":"d7WPx","./sequential-multi/rainbow":"7K9UV","./sequential-multi/sinebow":"iJnHT","./sequential-multi/viridis":"BO7Jj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6YEgp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7yllC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8r6Mw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9lYoK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"OO4QB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iTTFS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iEGuS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hLcNT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jgYJM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8Mvmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
exports.default = (0, _colorsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jKuLT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1I3j3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(scheme) {
        return (0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);
    };
});
var _d3Interpolate = require("d3-interpolate");

},{"d3-interpolate":"6zRsi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6zRsi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", function() {
    return 0, _valueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateArray", function() {
    return 0, _arrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasis", function() {
    return 0, _basisJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasisClosed", function() {
    return 0, _basisClosedJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDate", function() {
    return 0, _dateJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDiscrete", function() {
    return 0, _discreteJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHue", function() {
    return 0, _hueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumber", function() {
    return 0, _numberJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumberArray", function() {
    return 0, _numberArrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateObject", function() {
    return 0, _objectJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRound", function() {
    return 0, _roundJsDefault.default;
});
parcelHelpers.export(exports, "interpolateString", function() {
    return 0, _stringJsDefault.default;
});
parcelHelpers.export(exports, "interpolateTransformCss", function() {
    return 0, _indexJs.interpolateTransformCss;
});
parcelHelpers.export(exports, "interpolateTransformSvg", function() {
    return 0, _indexJs.interpolateTransformSvg;
});
parcelHelpers.export(exports, "interpolateZoom", function() {
    return 0, _zoomJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgb", function() {
    return 0, _rgbJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgbBasis", function() {
    return 0, _rgbJs.rgbBasis;
});
parcelHelpers.export(exports, "interpolateRgbBasisClosed", function() {
    return 0, _rgbJs.rgbBasisClosed;
});
parcelHelpers.export(exports, "interpolateHsl", function() {
    return 0, _hslJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHslLong", function() {
    return 0, _hslJs.hslLong;
});
parcelHelpers.export(exports, "interpolateLab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHcl", function() {
    return 0, _hclJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHclLong", function() {
    return 0, _hclJs.hclLong;
});
parcelHelpers.export(exports, "interpolateCubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
parcelHelpers.export(exports, "interpolateCubehelixLong", function() {
    return 0, _cubehelixJs.cubehelixLong;
});
parcelHelpers.export(exports, "piecewise", function() {
    return 0, _piecewiseJsDefault.default;
});
parcelHelpers.export(exports, "quantize", function() {
    return 0, _quantizeJsDefault.default;
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":false,"./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":false,"./numberArray.js":false,"./object.js":false,"./round.js":false,"./string.js":false,"./transform/index.js":false,"./zoom.js":false,"./rgb.js":"9tYWI","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":"gNlvX","./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bCtGB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", function() {
    return basis;
});
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jv2Cn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
var _basisJs = require("./basis.js");

},{"./basis.js":"bCtGB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9tYWI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", function() {
    return rgbBasis;
});
parcelHelpers.export(exports, "rgbBasisClosed", function() {
    return rgbBasisClosed;
});
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"h7Hcq","./basis.js":"bCtGB","./basisClosed.js":"jv2Cn","./color.js":"dUpDQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"h7Hcq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", function() {
    return 0, _colorJsDefault.default;
});
parcelHelpers.export(exports, "rgb", function() {
    return 0, _colorJs.rgb;
});
parcelHelpers.export(exports, "hsl", function() {
    return 0, _colorJs.hsl;
});
parcelHelpers.export(exports, "lab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "hcl", function() {
    return 0, _labJs.hcl;
});
parcelHelpers.export(exports, "lch", function() {
    return 0, _labJs.lch;
});
parcelHelpers.export(exports, "gray", function() {
    return 0, _labJs.gray;
});
parcelHelpers.export(exports, "cubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"6uYbu","./lab.js":false,"./cubehelix.js":"2yPZd","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6uYbu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", function() {
    return Color;
});
parcelHelpers.export(exports, "darker", function() {
    return darker;
});
parcelHelpers.export(exports, "brighter", function() {
    return brighter;
});
parcelHelpers.export(exports, "default", function() {
    return color;
});
parcelHelpers.export(exports, "rgbConvert", function() {
    return rgbConvert;
});
parcelHelpers.export(exports, "rgb", function() {
    return rgb;
});
parcelHelpers.export(exports, "Rgb", function() {
    return Rgb;
});
parcelHelpers.export(exports, "hslConvert", function() {
    return hslConvert;
});
parcelHelpers.export(exports, "hsl", function() {
    return hsl;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function copy(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function displayable() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function brighter1(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function darker1(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function rgb() {
        return this;
    },
    displayable: function displayable() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function brighter1(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker1(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function displayable() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function formatHsl() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"jDi0D","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jDi0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    };
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2yPZd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cubehelix;
});
parcelHelpers.export(exports, "Cubehelix", function() {
    return Cubehelix;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.rad2deg) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function brighter(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function darker(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function rgb() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"jDi0D","./color.js":"6uYbu","./math.js":"cMHiE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cMHiE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deg2rad", function() {
    return deg2rad;
});
parcelHelpers.export(exports, "rad2deg", function() {
    return rad2deg;
});
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dUpDQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", function() {
    return hue;
});
parcelHelpers.export(exports, "gamma", function() {
    return gamma;
});
parcelHelpers.export(exports, "default", function() {
    return nogamma;
});
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"fKYUC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fKYUC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gNlvX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", function() {
    return cubehelixLong;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"h7Hcq","./color.js":"dUpDQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2WkEc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6GAoZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dGVfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2lsj2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jMSpi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Gcdr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bboot":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cajGi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kNx09":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6xJ9g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l1Sgc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jtaJv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hnjIe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5ryri":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8r2qy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9VTwP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j7gP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f3A9q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hRhvS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7bxqV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bEuJN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hjeQO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eJvKh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hOWNb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3nNr2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kjeAw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", function() {
    return scheme;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
var _ramp = require("../ramp");
var _rampDefault = parcelHelpers.interopDefault(_ramp);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsDefault.default));
exports.default = (0, _rampDefault.default)(scheme);

},{"../colors":"7yllC","../ramp":"1I3j3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d7WPx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"h7Hcq","d3-interpolate":"6zRsi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7K9UV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", function() {
    return warm;
});
parcelHelpers.export(exports, "cool", function() {
    return cool;
});
parcelHelpers.export(exports, "default", function() {
    return function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    };
});
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"h7Hcq","d3-interpolate":"6zRsi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iJnHT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    };
});
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"h7Hcq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"BO7Jj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", function() {
    return magma;
});
parcelHelpers.export(exports, "inferno", function() {
    return inferno;
});
parcelHelpers.export(exports, "plasma", function() {
    return plasma;
});
var _colors = require("../colors");
var _colorsDefault = parcelHelpers.interopDefault(_colors);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors":"7yllC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kJqlS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMatrix", function() {
    return StyledMatrix;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  .Matrix-Frame {\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 2px;\n\n    td,\n    tr,\n    th,\n    td {\n      border: 0;\n      padding: 0;\n      margin: 0;\n    }\n\n    .Matrix-Cell {\n      position: relative;\n\n      &:after {\n        content: '';\n        display: block;\n        margin-top: 100%;\n      }\n\n      &:hover {\n        border: 2px solid ",
        ";\n        cursor: pointer;\n      }\n\n      &.selected {\n        border: 2px solid ",
        ";\n      }\n\n      .Contents {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: none;\n      }\n    }\n\n    .Matrix-Label-Row,\n    .Matrix-Label-Col {\n      font-size: 12px;\n      color: ",
        ";\n    }\n\n    .Matrix-Label-Row {\n      width: ",
        ";\n      padding-right: 8px;\n\n      span {\n        display: inline-block;\n        overflow: hidden;\n        white-space: nowrap;\n        max-width: 100%;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .Matrix-Label-Col {\n      height: ",
        ";\n      position: relative;\n      vertical-align: bottom;\n\n      .rotate {\n        transform-origin: 0 50%;\n        transform: rotate(-90deg);\n        white-space: nowrap;\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n\n        span {\n          display: inline-block;\n          width: ",
        " - 15px;\n          overflow: hidden;\n          white-space: nowrap;\n          text-align: right;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n\n    .Matrix-Axis-X,\n    .Matrix-Axis-Y {\n      font-size: 14px;\n      color: ",
        ";\n    }\n\n    .Matrix-Axis-X {\n      text-align: center;\n      padding-bottom: 10px;\n    }\n\n    .Matrix-Axis-Y {\n      width: 25px;\n      span {\n        position: relative;\n        display: block;\n        top: 50%;\n        transform: rotate(90deg) translateX(-50%);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var MatrixXLabelSize = "100px";
var MatrixYLabelSize = "120px";
var StyledMatrix = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).magenta, (0, _index.COLORS).magenta, (0, _index.COLORS).midFontColor, MatrixXLabelSize, MatrixYLabelSize, MatrixYLabelSize, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iXGem":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Bar = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, xPos = props.xPos, yPos = props.yPos, width = props.width, height = props.height, id = props.id, _props_toolTipKey = props.toolTipKey, toolTipKey = _props_toolTipKey === void 0 ? null : _props_toolTipKey, _props_mouseEnterHandler = props.mouseEnterHandler, mouseEnterHandler = _props_mouseEnterHandler === void 0 ? function() {
        return null;
    } : _props_mouseEnterHandler, _props_mouseLeaveHandler = props.mouseLeaveHandler, mouseLeaveHandler = _props_mouseLeaveHandler === void 0 ? function() {
        return null;
    } : _props_mouseLeaveHandler, _props_mouseMoveHandler = props.mouseMoveHandler, mouseMoveHandler = _props_mouseMoveHandler === void 0 ? function() {
        return null;
    } : _props_mouseMoveHandler, _props_contextMenuHandler = props.contextMenuHandler, contextMenuHandler = _props_contextMenuHandler === void 0 ? function() {
        return null;
    } : _props_contextMenuHandler;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
        className: "Bar ".concat(className),
        fill: "currentColor",
        x: xPos,
        y: yPos,
        width: width,
        height: height,
        id: id,
        "data-cy": props["data-cy"],
        "data-tip": toolTipKey !== null,
        "data-for": toolTipKey,
        onMouseEnter: mouseEnterHandler,
        onMouseLeave: mouseLeaveHandler,
        onMouseMove: mouseMoveHandler,
        onContextMenu: contextMenuHandler
    });
};
exports.default = Bar;

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lKBfG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", function() {
    return Circle;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Circle(props) {
    var className = props.className, cx = props.cx, cy = props.cy, _props_fill = props.fill, fill = _props_fill === void 0 ? "white" : _props_fill, _props_fillOpacity = props.fillOpacity, fillOpacity = _props_fillOpacity === void 0 ? 1 : _props_fillOpacity, id = props.id, onClick = props.onClick, _props_radius = props.radius, radius = _props_radius === void 0 ? 10 : _props_radius, showOnHover = props.showOnHover, _props_stroke = props.stroke, stroke = _props_stroke === void 0 ? "white" : _props_stroke, _props_strokeOpacity = props.strokeOpacity, strokeOpacity = _props_strokeOpacity === void 0 ? 0 : _props_strokeOpacity, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 1 : _props_strokeWidth, toolTipKey = props.toolTipKey;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hovered = _useState[0], setHovered = _useState[1];
    var effectiveFillOpacity = !showOnHover || hovered ? fillOpacity : 0;
    var effectiveStokeOpacity = !showOnHover || hovered ? strokeOpacity : 0;
    var mouseEnterHandler = function() {
        setHovered(true);
    };
    var mouseLeaveHandler = function() {
        setHovered(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        className: className,
        style: {
            cursor: "pointer"
        },
        r: radius,
        cx: cx,
        cy: cy,
        fill: fill,
        fillOpacity: effectiveFillOpacity,
        id: id,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: effectiveStokeOpacity,
        "data-cy": props["data-cy"],
        "data-tip": toolTipKey !== null,
        "data-for": toolTipKey,
        onClick: onClick,
        onMouseEnter: mouseEnterHandler,
        onMouseLeave: mouseLeaveHandler
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ibbxE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Line", function() {
    return Line;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Line(props) {
    var className = props.className, _props_fill = props.fill, fill = _props_fill === void 0 ? "none" : _props_fill, _props_hoverEffect = props.hoverEffect, hoverEffect = _props_hoverEffect === void 0 ? true : _props_hoverEffect, id = props.id, onClick = props.onClick, path = props.path, _props_stroke = props.stroke, stroke = _props_stroke === void 0 ? "white" : _props_stroke, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 1 : _props_strokeWidth;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hovered = _useState[0], setHovered = _useState[1];
    var mouseOverHandler = function() {
        setHovered(true);
    };
    var mouseOutHandler = function() {
        setHovered(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: path,
        fill: fill,
        stroke: stroke,
        style: {
            cursor: onClick ? "pointer" : "default"
        },
        strokeWidth: hovered && hoverEffect && onClick ? strokeWidth + 2 : strokeWidth,
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        onClick: onClick,
        onMouseEnter: mouseOverHandler,
        onMouseLeave: mouseOutHandler
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lsbPL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalBarChart", function() {
    return HorizontalBarChart;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axis = require("@visx/axis");
var _shape = require("@visx/shape");
var _tooltip = require("@visx/tooltip");
var _scale = require("@visx/scale");
var _event = require("@visx/event");
var _utils = require("@indico-data/utils");
var _measurementRows = require("./MeasurementRows");
var _horizontalBarChartStyles = require("./HorizontalBarChart.styles");
var BAR_HEIGHT = 16;
var BAR_PADDING = 20;
var CHART_MARGIN_RIGHT = 40;
function HorizontalBarChart(props) {
    var _Math;
    var className = props.className, fontSize = props.fontSize, graphColor = props.graphColor, graphData = props.graphData, id = props.id, numTicks = props.numTicks, xAxisKey = props.xAxisKey, yAxisKey = props.yAxisKey;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), labelsWidth = _useState[0], setLabelsWidth = _useState[1];
    var _hookUtils_useMeasure = (0, _slicedToArray._)((0, _utils.hookUtils).useMeasure(), 2), chartSvgRef = _hookUtils_useMeasure[0], _hookUtils_useMeasure_ = _hookUtils_useMeasure[1], chartWidth = _hookUtils_useMeasure_.width;
    // accessors
    var getYAxisValue = function(d) {
        return d[yAxisKey];
    };
    var getXAxisValue = function(d) {
        return d[xAxisKey];
    };
    // ensure we never have a negative value
    var xMax = (0, _react.useMemo)(function() {
        return Math.abs(chartWidth - labelsWidth - CHART_MARGIN_RIGHT);
    }, [
        chartWidth
    ]);
    var yMax = (0, _react.useMemo)(function() {
        return (BAR_HEIGHT + BAR_PADDING) * graphData.length + BAR_PADDING;
    }, [
        graphData
    ]);
    var maxCount = (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(graphData.map(getXAxisValue)));
    // limit # of lines to show so they don’t get out of control
    var verticalLinesToShow = numTicks || Math.floor(maxCount / 10);
    var _useTooltip = (0, _tooltip.useTooltip)(), tooltipData = _useTooltip.tooltipData, tooltipTop = _useTooltip.tooltipTop, tooltipLeft = _useTooltip.tooltipLeft, tooltipOpen = _useTooltip.tooltipOpen, hideTooltip = _useTooltip.hideTooltip, showTooltip = _useTooltip.showTooltip;
    var xAxisScale = (0, _react.useMemo)(function() {
        return (0, _scale.scaleLinear)({
            range: [
                0,
                xMax
            ],
            domain: [
                0,
                maxCount
            ]
        });
    }, [
        xMax
    ]);
    var yAxisScale = (0, _react.useMemo)(function() {
        return (0, _scale.scaleBand)({
            range: [
                yMax,
                0
            ],
            domain: graphData.map(getYAxisValue),
            padding: 0.1
        });
    }, [
        yMax
    ]);
    // textAnchor must be explicitly set in the component, because typescript
    // thinks it’s a string if declared here...
    var tickLabelProps = {
        fill: "currentColor",
        fontSize: fontSize
    };
    var commonAxisProps = {
        stroke: "currentColor",
        strokeWidth: 1
    };
    var horizontalAxis = function() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: xMax,
            height: 16,
            style: {
                paddingLeft: labelsWidth,
                color: graphColor
            },
            overflow: "visible",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _axis.Axis), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonAxisProps), {
                top: -8,
                scale: xAxisScale,
                hideAxisLine: true,
                hideTicks: true,
                numTicks: verticalLinesToShow,
                tickLabelProps: function() {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, tickLabelProps), {
                        textAnchor: "middle"
                    });
                }
            }))
        });
    };
    var handleTooltip = function(event, count, yPos) {
        var x = ((0, _event.localPoint)(event) || {
            x: 0
        }).x;
        var tooltipTop = yPos;
        var tooltipLeft = x + labelsWidth;
        showTooltip({
            tooltipData: count || 0,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop
        });
    };
    // measure the width of the Axis element so we can accommodate for it
    (0, _react.useLayoutEffect)(function() {
        var leftAxisElement = document.querySelector(".left-axis-container");
        var width = (leftAxisElement === null || leftAxisElement === void 0 ? void 0 : leftAxisElement.getBoundingClientRect().width) || 0;
        if (width > labelsWidth) setLabelsWidth(Math.max(width, 120));
    }, [
        labelsWidth
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        ref: chartSvgRef,
        children: [
            horizontalAxis(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _horizontalBarChartStyles.StyledHorizontalBarChart), {
                className: "scrollable-vertical",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        width: xMax,
                        height: yMax,
                        overflow: "visible",
                        style: {
                            paddingLeft: labelsWidth,
                            paddingRight: 40
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _measurementRows.MeasurementRows), {
                                axisProps: commonAxisProps,
                                color: graphColor,
                                data: graphData,
                                tickProps: tickLabelProps,
                                verticalLinesToShow: verticalLinesToShow,
                                xScale: xAxisScale,
                                yAxisKey: yAxisKey,
                                yMax: yMax,
                                yScale: yAxisScale
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                transform: "translate(0, ".concat(BAR_HEIGHT / 2, ")"),
                                children: graphData.map(function(datum) {
                                    var count = getXAxisValue(datum);
                                    var barWidth = xAxisScale(count) || 0;
                                    var x = 0;
                                    var y = yAxisScale(getYAxisValue(datum)) || 0;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shape.Bar), {
                                        x: x,
                                        y: y,
                                        width: barWidth,
                                        height: BAR_HEIGHT,
                                        fill: graphColor,
                                        onMouseMove: function(e) {
                                            return handleTooltip(e, count, y);
                                        },
                                        onMouseOut: function() {
                                            return hideTooltip();
                                        }
                                    }, "".concat(getYAxisValue(datum), "-").concat(count));
                                })
                            })
                        ]
                    }),
                    tooltipOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _horizontalBarChartStyles.StyledTooltip), {
                        top: tooltipTop,
                        left: tooltipLeft,
                        unstyled: true,
                        children: tooltipData
                    })
                ]
            }),
            horizontalAxis()
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","@visx/axis":"gF8iV","@visx/shape":"5XPpo","@visx/tooltip":"hiwzN","@visx/scale":"6Owz5","@visx/event":"N20PK","@indico-data/utils":"47VRj","./MeasurementRows":"7X5Oe","./HorizontalBarChart.styles":"BRR5j","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gF8iV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Axis", function() {
    return 0, _axisDefault.default;
});
parcelHelpers.export(exports, "AxisLeft", function() {
    return 0, _axisLeftDefault.default;
});
parcelHelpers.export(exports, "AxisRight", function() {
    return 0, _axisRightDefault.default;
});
parcelHelpers.export(exports, "AxisTop", function() {
    return 0, _axisTopDefault.default;
});
parcelHelpers.export(exports, "AxisBottom", function() {
    return 0, _axisBottomDefault.default;
});
parcelHelpers.export(exports, "Orientation", function() {
    return 0, _orientationDefault.default;
});
var _axis = require("./axis/Axis");
var _axisDefault = parcelHelpers.interopDefault(_axis);
var _axisLeft = require("./axis/AxisLeft");
var _axisLeftDefault = parcelHelpers.interopDefault(_axisLeft);
var _axisRight = require("./axis/AxisRight");
var _axisRightDefault = parcelHelpers.interopDefault(_axisRight);
var _axisTop = require("./axis/AxisTop");
var _axisTopDefault = parcelHelpers.interopDefault(_axisTop);
var _axisBottom = require("./axis/AxisBottom");
var _axisBottomDefault = parcelHelpers.interopDefault(_axisBottom);
var _orientation = require("./constants/orientation");
var _orientationDefault = parcelHelpers.interopDefault(_orientation);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./axis/Axis":"81gEj","./axis/AxisLeft":"cCycn","./axis/AxisRight":false,"./axis/AxisTop":false,"./axis/AxisBottom":false,"./constants/orientation":"jKJwV","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"81gEj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Axis;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _group = require("@visx/group");
var _scale = require("@visx/scale");
var _axisRenderer = require("./AxisRenderer");
var _axisRendererDefault = parcelHelpers.interopDefault(_axisRenderer);
var _getTickPosition = require("../utils/getTickPosition");
var _getTickPositionDefault = parcelHelpers.interopDefault(_getTickPosition);
var _getTickFormatter = require("../utils/getTickFormatter");
var _getTickFormatterDefault = parcelHelpers.interopDefault(_getTickFormatter);
var _createPoint = require("../utils/createPoint");
var _createPointDefault = parcelHelpers.interopDefault(_createPoint);
var _orientation = require("../constants/orientation");
var _orientationDefault = parcelHelpers.interopDefault(_orientation);
var _getAxisRangePaddingConfig = require("../utils/getAxisRangePaddingConfig");
var _getAxisRangePaddingConfigDefault = parcelHelpers.interopDefault(_getAxisRangePaddingConfig);
var _excluded = [
    "children",
    "axisClassName",
    "hideAxisLine",
    "hideTicks",
    "hideZero",
    "left",
    "numTicks",
    "orientation",
    "rangePadding",
    "scale",
    "tickFormat",
    "tickLength",
    "tickValues",
    "top"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Axis(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? (0, _axisRendererDefault.default) : _ref$children, axisClassName = _ref.axisClassName, _ref$hideAxisLine = _ref.hideAxisLine, hideAxisLine = _ref$hideAxisLine === void 0 ? false : _ref$hideAxisLine, _ref$hideTicks = _ref.hideTicks, hideTicks = _ref$hideTicks === void 0 ? false : _ref$hideTicks, _ref$hideZero = _ref.hideZero, hideZero = _ref$hideZero === void 0 ? false : _ref$hideZero, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? (0, _orientationDefault.default).bottom : _ref$orientation, _ref$rangePadding = _ref.rangePadding, rangePadding = _ref$rangePadding === void 0 ? 0 : _ref$rangePadding, scale = _ref.scale, tickFormat = _ref.tickFormat, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, tickValues = _ref.tickValues, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var format = tickFormat != null ? tickFormat : (0, _getTickFormatterDefault.default)(scale);
    var isLeft = orientation === (0, _orientationDefault.default).left;
    var isTop = orientation === (0, _orientationDefault.default).top;
    var horizontal = isTop || orientation === (0, _orientationDefault.default).bottom;
    var tickPosition = (0, _getTickPositionDefault.default)(scale);
    var tickSign = isLeft || isTop ? -1 : 1;
    var range = scale.range();
    var rangePaddingConfig = (0, _getAxisRangePaddingConfigDefault.default)(rangePadding);
    var axisFromPoint = (0, _createPointDefault.default)({
        x: Number(range[0]) + 0.5 - rangePaddingConfig.start,
        y: 0
    }, horizontal);
    var axisToPoint = (0, _createPointDefault.default)({
        x: Number(range[range.length - 1]) + 0.5 + rangePaddingConfig.end,
        y: 0
    }, horizontal);
    var filteredTickValues = (tickValues != null ? tickValues : (0, _scale.getTicks)(scale, numTicks)).filter(function(value) {
        return !hideZero || value !== 0 && value !== "0";
    }).map(function(value, index) {
        return {
            value: value,
            index: index
        };
    });
    var ticks = filteredTickValues.map(function(_ref2) {
        var value = _ref2.value, index = _ref2.index;
        var scaledValue = (0, _scale.coerceNumber)(tickPosition(value));
        return {
            value: value,
            index: index,
            from: (0, _createPointDefault.default)({
                x: scaledValue,
                y: 0
            }, horizontal),
            to: (0, _createPointDefault.default)({
                x: scaledValue,
                y: tickLength * tickSign
            }, horizontal),
            formattedValue: format(value, index, filteredTickValues)
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        className: (0, _classnamesDefault.default)("visx-axis", axisClassName),
        top: top,
        left: left
    }, children(_extends({}, restProps, {
        axisFromPoint: axisFromPoint,
        axisToPoint: axisToPoint,
        hideAxisLine: hideAxisLine,
        hideTicks: hideTicks,
        hideZero: hideZero,
        horizontal: horizontal,
        numTicks: numTicks,
        orientation: orientation,
        rangePadding: rangePadding,
        scale: scale,
        tickFormat: format,
        tickLength: tickLength,
        tickPosition: tickPosition,
        tickSign: tickSign,
        ticks: ticks
    })));
}

},{"prop-types":"8INHm","react":"ktQNc","classnames":"aMKnv","@visx/group":"daSh2","@visx/scale":"6Owz5","./AxisRenderer":"5R3V0","../utils/getTickPosition":"6oAss","../utils/getTickFormatter":"2Jwi6","../utils/createPoint":"kkv7S","../constants/orientation":"jKJwV","../utils/getAxisRangePaddingConfig":"irNES","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"daSh2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Group", function() {
    return 0, _groupDefault.default;
});
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);

},{"./Group":"1FvgB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1FvgB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Group;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _excluded = [
    "top",
    "left",
    "transform",
    "className",
    "children",
    "innerRef"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Group(_ref) {
    var _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, transform = _ref.transform, className = _ref.className, children = _ref.children, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", _extends({
        ref: innerRef,
        className: (0, _classnamesDefault.default)("visx-group", className),
        transform: transform || "translate(" + left + ", " + top + ")"
    }, restProps), children);
}
Group.propTypes = {
    top: (0, _propTypesDefault.default).number,
    left: (0, _propTypesDefault.default).number,
    transform: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    children: (0, _propTypesDefault.default).node,
    innerRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ])
};

},{"prop-types":"8INHm","react":"ktQNc","classnames":"aMKnv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Owz5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", function() {
    return 0, _bandDefault.default;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return 0, _pointDefault.default;
});
parcelHelpers.export(exports, "scaleLinear", function() {
    return 0, _linearDefault.default;
});
parcelHelpers.export(exports, "scaleRadial", function() {
    return 0, _radialDefault.default;
});
parcelHelpers.export(exports, "scaleTime", function() {
    return 0, _timeDefault.default;
});
parcelHelpers.export(exports, "scaleUtc", function() {
    return 0, _utcDefault.default;
});
parcelHelpers.export(exports, "scaleLog", function() {
    return 0, _logDefault.default;
});
parcelHelpers.export(exports, "scalePower", function() {
    return 0, _powerDefault.default;
});
parcelHelpers.export(exports, "scaleOrdinal", function() {
    return 0, _ordinalDefault.default;
});
parcelHelpers.export(exports, "scaleQuantize", function() {
    return 0, _quantizeDefault.default;
});
parcelHelpers.export(exports, "scaleQuantile", function() {
    return 0, _quantileDefault.default;
});
parcelHelpers.export(exports, "scaleSymlog", function() {
    return 0, _symlogDefault.default;
});
parcelHelpers.export(exports, "scaleThreshold", function() {
    return 0, _thresholdDefault.default;
});
parcelHelpers.export(exports, "scaleSqrt", function() {
    return 0, _squareRootDefault.default;
});
parcelHelpers.export(exports, "createScale", function() {
    return 0, _createScaleDefault.default;
});
parcelHelpers.export(exports, "updateScale", function() {
    return 0, _updateScaleDefault.default;
});
parcelHelpers.export(exports, "inferScaleType", function() {
    return 0, _inferScaleTypeDefault.default;
});
parcelHelpers.export(exports, "coerceNumber", function() {
    return 0, _coerceNumberDefault.default;
});
parcelHelpers.export(exports, "getTicks", function() {
    return 0, _getTicksDefault.default;
});
parcelHelpers.export(exports, "toString", function() {
    return 0, _toStringDefault.default;
});
parcelHelpers.export(exports, "scaleCanBeZeroed", function() {
    return 0, _scaleCanBeZeroedDefault.default;
});
var _band = require("./scales/band");
var _bandDefault = parcelHelpers.interopDefault(_band);
var _point = require("./scales/point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _linear = require("./scales/linear");
var _linearDefault = parcelHelpers.interopDefault(_linear);
var _radial = require("./scales/radial");
var _radialDefault = parcelHelpers.interopDefault(_radial);
var _time = require("./scales/time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _utc = require("./scales/utc");
var _utcDefault = parcelHelpers.interopDefault(_utc);
var _log = require("./scales/log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _power = require("./scales/power");
var _powerDefault = parcelHelpers.interopDefault(_power);
var _ordinal = require("./scales/ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
var _quantize = require("./scales/quantize");
var _quantizeDefault = parcelHelpers.interopDefault(_quantize);
var _quantile = require("./scales/quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _symlog = require("./scales/symlog");
var _symlogDefault = parcelHelpers.interopDefault(_symlog);
var _threshold = require("./scales/threshold");
var _thresholdDefault = parcelHelpers.interopDefault(_threshold);
var _squareRoot = require("./scales/squareRoot");
var _squareRootDefault = parcelHelpers.interopDefault(_squareRoot);
var _createScale = require("./createScale");
var _createScaleDefault = parcelHelpers.interopDefault(_createScale);
var _updateScale = require("./updateScale");
var _updateScaleDefault = parcelHelpers.interopDefault(_updateScale);
var _inferScaleType = require("./utils/inferScaleType");
var _inferScaleTypeDefault = parcelHelpers.interopDefault(_inferScaleType);
var _coerceNumber = require("./utils/coerceNumber");
var _coerceNumberDefault = parcelHelpers.interopDefault(_coerceNumber);
var _getTicks = require("./utils/getTicks");
var _getTicksDefault = parcelHelpers.interopDefault(_getTicks);
var _toString = require("./utils/toString");
var _toStringDefault = parcelHelpers.interopDefault(_toString);
var _scaleCanBeZeroed = require("./utils/scaleCanBeZeroed");
var _scaleCanBeZeroedDefault = parcelHelpers.interopDefault(_scaleCanBeZeroed);
// export types
var _base = require("./types/Base");
parcelHelpers.exportAll(_base, exports);
var _nice = require("./types/Nice");
parcelHelpers.exportAll(_nice, exports);
var _scale = require("./types/Scale");
parcelHelpers.exportAll(_scale, exports);
var _scaleConfig = require("./types/ScaleConfig");
parcelHelpers.exportAll(_scaleConfig, exports);
var _scaleInterpolate = require("./types/ScaleInterpolate");
parcelHelpers.exportAll(_scaleInterpolate, exports);

},{"./scales/band":"9loQZ","./scales/point":false,"./scales/linear":"an1iA","./scales/radial":false,"./scales/time":"6pDgf","./scales/utc":false,"./scales/log":false,"./scales/power":false,"./scales/ordinal":"7fJy5","./scales/quantize":false,"./scales/quantile":false,"./scales/symlog":false,"./scales/threshold":false,"./scales/squareRoot":false,"./createScale":false,"./updateScale":false,"./utils/inferScaleType":false,"./utils/coerceNumber":"cM7S2","./utils/getTicks":"4Occ7","./utils/toString":"f20DD","./utils/scaleCanBeZeroed":false,"./types/Base":false,"./types/Nice":false,"./types/Scale":false,"./types/ScaleConfig":false,"./types/ScaleInterpolate":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9loQZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateBandScale", function() {
    return updateBandScale;
});
parcelHelpers.export(exports, "default", function() {
    return createBandScale;
});
var _d3Scale = require("d3-scale");
var _scaleOperator = require("../operators/scaleOperator");
var _scaleOperatorDefault = parcelHelpers.interopDefault(_scaleOperator);
var updateBandScale = (0, _scaleOperatorDefault.default)("domain", "range", "reverse", "align", "padding", "round");
function createBandScale(config) {
    return updateBandScale((0, _d3Scale.scaleBand)(), config);
}

},{"d3-scale":"2Acrc","../operators/scaleOperator":"7bhE0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2Acrc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", function() {
    return 0, _bandJsDefault.default;
});
parcelHelpers.export(exports, "scalePoint", function() {
    return 0, _bandJs.point;
});
parcelHelpers.export(exports, "scaleIdentity", function() {
    return 0, _identityJsDefault.default;
});
parcelHelpers.export(exports, "scaleLinear", function() {
    return 0, _linearJsDefault.default;
});
parcelHelpers.export(exports, "scaleLog", function() {
    return 0, _logJsDefault.default;
});
parcelHelpers.export(exports, "scaleSymlog", function() {
    return 0, _symlogJsDefault.default;
});
parcelHelpers.export(exports, "scaleOrdinal", function() {
    return 0, _ordinalJsDefault.default;
});
parcelHelpers.export(exports, "scaleImplicit", function() {
    return 0, _ordinalJs.implicit;
});
parcelHelpers.export(exports, "scalePow", function() {
    return 0, _powJsDefault.default;
});
parcelHelpers.export(exports, "scaleSqrt", function() {
    return 0, _powJs.sqrt;
});
parcelHelpers.export(exports, "scaleRadial", function() {
    return 0, _radialJsDefault.default;
});
parcelHelpers.export(exports, "scaleQuantile", function() {
    return 0, _quantileJsDefault.default;
});
parcelHelpers.export(exports, "scaleQuantize", function() {
    return 0, _quantizeJsDefault.default;
});
parcelHelpers.export(exports, "scaleThreshold", function() {
    return 0, _thresholdJsDefault.default;
});
parcelHelpers.export(exports, "scaleTime", function() {
    return 0, _timeJsDefault.default;
});
parcelHelpers.export(exports, "scaleUtc", function() {
    return 0, _utcTimeJsDefault.default;
});
parcelHelpers.export(exports, "scaleSequential", function() {
    return 0, _sequentialJsDefault.default;
});
parcelHelpers.export(exports, "scaleSequentialLog", function() {
    return 0, _sequentialJs.sequentialLog;
});
parcelHelpers.export(exports, "scaleSequentialPow", function() {
    return 0, _sequentialJs.sequentialPow;
});
parcelHelpers.export(exports, "scaleSequentialSqrt", function() {
    return 0, _sequentialJs.sequentialSqrt;
});
parcelHelpers.export(exports, "scaleSequentialSymlog", function() {
    return 0, _sequentialJs.sequentialSymlog;
});
parcelHelpers.export(exports, "scaleSequentialQuantile", function() {
    return 0, _sequentialQuantileJsDefault.default;
});
parcelHelpers.export(exports, "scaleDiverging", function() {
    return 0, _divergingJsDefault.default;
});
parcelHelpers.export(exports, "scaleDivergingLog", function() {
    return 0, _divergingJs.divergingLog;
});
parcelHelpers.export(exports, "scaleDivergingPow", function() {
    return 0, _divergingJs.divergingPow;
});
parcelHelpers.export(exports, "scaleDivergingSqrt", function() {
    return 0, _divergingJs.divergingSqrt;
});
parcelHelpers.export(exports, "scaleDivergingSymlog", function() {
    return 0, _divergingJs.divergingSymlog;
});
parcelHelpers.export(exports, "tickFormat", function() {
    return 0, _tickFormatJsDefault.default;
});
var _bandJs = require("./band.js");
var _bandJsDefault = parcelHelpers.interopDefault(_bandJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _logJs = require("./log.js");
var _logJsDefault = parcelHelpers.interopDefault(_logJs);
var _symlogJs = require("./symlog.js");
var _symlogJsDefault = parcelHelpers.interopDefault(_symlogJs);
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
var _powJs = require("./pow.js");
var _powJsDefault = parcelHelpers.interopDefault(_powJs);
var _radialJs = require("./radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);
var _thresholdJs = require("./threshold.js");
var _thresholdJsDefault = parcelHelpers.interopDefault(_thresholdJs);
var _timeJs = require("./time.js");
var _timeJsDefault = parcelHelpers.interopDefault(_timeJs);
var _utcTimeJs = require("./utcTime.js");
var _utcTimeJsDefault = parcelHelpers.interopDefault(_utcTimeJs);
var _sequentialJs = require("./sequential.js");
var _sequentialJsDefault = parcelHelpers.interopDefault(_sequentialJs);
var _sequentialQuantileJs = require("./sequentialQuantile.js");
var _sequentialQuantileJsDefault = parcelHelpers.interopDefault(_sequentialQuantileJs);
var _divergingJs = require("./diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);

},{"./band.js":"1WCUo","./identity.js":false,"./linear.js":"cvN1T","./log.js":false,"./symlog.js":false,"./ordinal.js":"317ye","./pow.js":false,"./radial.js":false,"./quantile.js":false,"./quantize.js":false,"./threshold.js":false,"./time.js":"8ppAZ","./utcTime.js":false,"./sequential.js":false,"./sequentialQuantile.js":false,"./diverging.js":false,"./tickFormat.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1WCUo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return band;
});
parcelHelpers.export(exports, "point", function() {
    return point;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var _ordinalJs = require("./ordinal.js");
var _ordinalJsDefault = parcelHelpers.interopDefault(_ordinalJs);
function band() {
    var scale = (0, _ordinalJsDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        var ref;
        return arguments.length ? (ref = (0, _slicedToArray._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        var ref;
        return ref = (0, _slicedToArray._)(_, 2), r0 = ref[0], r1 = ref[1], ref, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _initJs.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","d3-array":"fmvZm","./init.js":"ibkBf","./ordinal.js":"317ye","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fmvZm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", function() {
    return 0, _bisectJsDefault.default;
});
parcelHelpers.export(exports, "bisectRight", function() {
    return 0, _bisectJs.bisectRight;
});
parcelHelpers.export(exports, "bisectLeft", function() {
    return 0, _bisectJs.bisectLeft;
});
parcelHelpers.export(exports, "bisectCenter", function() {
    return 0, _bisectJs.bisectCenter;
});
parcelHelpers.export(exports, "ascending", function() {
    return 0, _ascendingJsDefault.default;
});
parcelHelpers.export(exports, "bisector", function() {
    return 0, _bisectorJsDefault.default;
});
parcelHelpers.export(exports, "blur", function() {
    return 0, _blurJs.blur;
});
parcelHelpers.export(exports, "blur2", function() {
    return 0, _blurJs.blur2;
});
parcelHelpers.export(exports, "blurImage", function() {
    return 0, _blurJs.blurImage;
});
parcelHelpers.export(exports, "count", function() {
    return 0, _countJsDefault.default;
});
parcelHelpers.export(exports, "cross", function() {
    return 0, _crossJsDefault.default;
});
parcelHelpers.export(exports, "cumsum", function() {
    return 0, _cumsumJsDefault.default;
});
parcelHelpers.export(exports, "descending", function() {
    return 0, _descendingJsDefault.default;
});
parcelHelpers.export(exports, "deviation", function() {
    return 0, _deviationJsDefault.default;
});
parcelHelpers.export(exports, "extent", function() {
    return 0, _extentJsDefault.default;
});
parcelHelpers.export(exports, "Adder", function() {
    return 0, _fsumJs.Adder;
});
parcelHelpers.export(exports, "fsum", function() {
    return 0, _fsumJs.fsum;
});
parcelHelpers.export(exports, "fcumsum", function() {
    return 0, _fsumJs.fcumsum;
});
parcelHelpers.export(exports, "group", function() {
    return 0, _groupJsDefault.default;
});
parcelHelpers.export(exports, "flatGroup", function() {
    return 0, _groupJs.flatGroup;
});
parcelHelpers.export(exports, "flatRollup", function() {
    return 0, _groupJs.flatRollup;
});
parcelHelpers.export(exports, "groups", function() {
    return 0, _groupJs.groups;
});
parcelHelpers.export(exports, "index", function() {
    return 0, _groupJs.index;
});
parcelHelpers.export(exports, "indexes", function() {
    return 0, _groupJs.indexes;
});
parcelHelpers.export(exports, "rollup", function() {
    return 0, _groupJs.rollup;
});
parcelHelpers.export(exports, "rollups", function() {
    return 0, _groupJs.rollups;
});
parcelHelpers.export(exports, "groupSort", function() {
    return 0, _groupSortJsDefault.default;
});
parcelHelpers.export(exports, "bin", function() {
    return 0, _binJsDefault.default;
}) // Deprecated; use bin.
;
parcelHelpers.export(exports, "histogram", function() {
    return 0, _binJsDefault.default;
});
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", function() {
    return 0, _freedmanDiaconisJsDefault.default;
});
parcelHelpers.export(exports, "thresholdScott", function() {
    return 0, _scottJsDefault.default;
});
parcelHelpers.export(exports, "thresholdSturges", function() {
    return 0, _sturgesJsDefault.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _maxJsDefault.default;
});
parcelHelpers.export(exports, "maxIndex", function() {
    return 0, _maxIndexJsDefault.default;
});
parcelHelpers.export(exports, "mean", function() {
    return 0, _meanJsDefault.default;
});
parcelHelpers.export(exports, "median", function() {
    return 0, _medianJsDefault.default;
});
parcelHelpers.export(exports, "medianIndex", function() {
    return 0, _medianJs.medianIndex;
});
parcelHelpers.export(exports, "merge", function() {
    return 0, _mergeJsDefault.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _minJsDefault.default;
});
parcelHelpers.export(exports, "minIndex", function() {
    return 0, _minIndexJsDefault.default;
});
parcelHelpers.export(exports, "mode", function() {
    return 0, _modeJsDefault.default;
});
parcelHelpers.export(exports, "nice", function() {
    return 0, _niceJsDefault.default;
});
parcelHelpers.export(exports, "pairs", function() {
    return 0, _pairsJsDefault.default;
});
parcelHelpers.export(exports, "permute", function() {
    return 0, _permuteJsDefault.default;
});
parcelHelpers.export(exports, "quantile", function() {
    return 0, _quantileJsDefault.default;
});
parcelHelpers.export(exports, "quantileIndex", function() {
    return 0, _quantileJs.quantileIndex;
});
parcelHelpers.export(exports, "quantileSorted", function() {
    return 0, _quantileJs.quantileSorted;
});
parcelHelpers.export(exports, "quickselect", function() {
    return 0, _quickselectJsDefault.default;
});
parcelHelpers.export(exports, "range", function() {
    return 0, _rangeJsDefault.default;
});
parcelHelpers.export(exports, "rank", function() {
    return 0, _rankJsDefault.default;
});
parcelHelpers.export(exports, "least", function() {
    return 0, _leastJsDefault.default;
});
parcelHelpers.export(exports, "leastIndex", function() {
    return 0, _leastIndexJsDefault.default;
});
parcelHelpers.export(exports, "greatest", function() {
    return 0, _greatestJsDefault.default;
});
parcelHelpers.export(exports, "greatestIndex", function() {
    return 0, _greatestIndexJsDefault.default;
});
parcelHelpers.export(exports, "scan", function() {
    return 0, _scanJsDefault.default;
}) // Deprecated; use leastIndex.
;
parcelHelpers.export(exports, "shuffle", function() {
    return 0, _shuffleJsDefault.default;
});
parcelHelpers.export(exports, "shuffler", function() {
    return 0, _shuffleJs.shuffler;
});
parcelHelpers.export(exports, "sum", function() {
    return 0, _sumJsDefault.default;
});
parcelHelpers.export(exports, "ticks", function() {
    return 0, _ticksJsDefault.default;
});
parcelHelpers.export(exports, "tickIncrement", function() {
    return 0, _ticksJs.tickIncrement;
});
parcelHelpers.export(exports, "tickStep", function() {
    return 0, _ticksJs.tickStep;
});
parcelHelpers.export(exports, "transpose", function() {
    return 0, _transposeJsDefault.default;
});
parcelHelpers.export(exports, "variance", function() {
    return 0, _varianceJsDefault.default;
});
parcelHelpers.export(exports, "zip", function() {
    return 0, _zipJsDefault.default;
});
parcelHelpers.export(exports, "every", function() {
    return 0, _everyJsDefault.default;
});
parcelHelpers.export(exports, "some", function() {
    return 0, _someJsDefault.default;
});
parcelHelpers.export(exports, "filter", function() {
    return 0, _filterJsDefault.default;
});
parcelHelpers.export(exports, "map", function() {
    return 0, _mapJsDefault.default;
});
parcelHelpers.export(exports, "reduce", function() {
    return 0, _reduceJsDefault.default;
});
parcelHelpers.export(exports, "reverse", function() {
    return 0, _reverseJsDefault.default;
});
parcelHelpers.export(exports, "sort", function() {
    return 0, _sortJsDefault.default;
});
parcelHelpers.export(exports, "difference", function() {
    return 0, _differenceJsDefault.default;
});
parcelHelpers.export(exports, "disjoint", function() {
    return 0, _disjointJsDefault.default;
});
parcelHelpers.export(exports, "intersection", function() {
    return 0, _intersectionJsDefault.default;
});
parcelHelpers.export(exports, "subset", function() {
    return 0, _subsetJsDefault.default;
});
parcelHelpers.export(exports, "superset", function() {
    return 0, _supersetJsDefault.default;
});
parcelHelpers.export(exports, "union", function() {
    return 0, _unionJsDefault.default;
});
parcelHelpers.export(exports, "InternMap", function() {
    return 0, _internmap.InternMap;
});
parcelHelpers.export(exports, "InternSet", function() {
    return 0, _internmap.InternSet;
});
var _bisectJs = require("./bisect.js");
var _bisectJsDefault = parcelHelpers.interopDefault(_bisectJs);
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _blurJs = require("./blur.js");
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _cumsumJs = require("./cumsum.js");
var _cumsumJsDefault = parcelHelpers.interopDefault(_cumsumJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _deviationJs = require("./deviation.js");
var _deviationJsDefault = parcelHelpers.interopDefault(_deviationJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _fsumJs = require("./fsum.js");
var _groupJs = require("./group.js");
var _groupJsDefault = parcelHelpers.interopDefault(_groupJs);
var _groupSortJs = require("./groupSort.js");
var _groupSortJsDefault = parcelHelpers.interopDefault(_groupSortJs);
var _binJs = require("./bin.js");
var _binJsDefault = parcelHelpers.interopDefault(_binJs);
var _freedmanDiaconisJs = require("./threshold/freedmanDiaconis.js");
var _freedmanDiaconisJsDefault = parcelHelpers.interopDefault(_freedmanDiaconisJs);
var _scottJs = require("./threshold/scott.js");
var _scottJsDefault = parcelHelpers.interopDefault(_scottJs);
var _sturgesJs = require("./threshold/sturges.js");
var _sturgesJsDefault = parcelHelpers.interopDefault(_sturgesJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxIndexJs = require("./maxIndex.js");
var _maxIndexJsDefault = parcelHelpers.interopDefault(_maxIndexJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minIndexJs = require("./minIndex.js");
var _minIndexJsDefault = parcelHelpers.interopDefault(_minIndexJs);
var _modeJs = require("./mode.js");
var _modeJsDefault = parcelHelpers.interopDefault(_modeJs);
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
var _pairsJs = require("./pairs.js");
var _pairsJsDefault = parcelHelpers.interopDefault(_pairsJs);
var _permuteJs = require("./permute.js");
var _permuteJsDefault = parcelHelpers.interopDefault(_permuteJs);
var _quantileJs = require("./quantile.js");
var _quantileJsDefault = parcelHelpers.interopDefault(_quantileJs);
var _quickselectJs = require("./quickselect.js");
var _quickselectJsDefault = parcelHelpers.interopDefault(_quickselectJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _rankJs = require("./rank.js");
var _rankJsDefault = parcelHelpers.interopDefault(_rankJs);
var _leastJs = require("./least.js");
var _leastJsDefault = parcelHelpers.interopDefault(_leastJs);
var _leastIndexJs = require("./leastIndex.js");
var _leastIndexJsDefault = parcelHelpers.interopDefault(_leastIndexJs);
var _greatestJs = require("./greatest.js");
var _greatestJsDefault = parcelHelpers.interopDefault(_greatestJs);
var _greatestIndexJs = require("./greatestIndex.js");
var _greatestIndexJsDefault = parcelHelpers.interopDefault(_greatestIndexJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _shuffleJs = require("./shuffle.js");
var _shuffleJsDefault = parcelHelpers.interopDefault(_shuffleJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _ticksJs = require("./ticks.js");
var _ticksJsDefault = parcelHelpers.interopDefault(_ticksJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _varianceJs = require("./variance.js");
var _varianceJsDefault = parcelHelpers.interopDefault(_varianceJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _everyJs = require("./every.js");
var _everyJsDefault = parcelHelpers.interopDefault(_everyJs);
var _someJs = require("./some.js");
var _someJsDefault = parcelHelpers.interopDefault(_someJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _disjointJs = require("./disjoint.js");
var _disjointJsDefault = parcelHelpers.interopDefault(_disjointJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _subsetJs = require("./subset.js");
var _subsetJsDefault = parcelHelpers.interopDefault(_subsetJs);
var _supersetJs = require("./superset.js");
var _supersetJsDefault = parcelHelpers.interopDefault(_supersetJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _internmap = require("internmap");

},{"./bisect.js":"5Ftqv","./ascending.js":false,"./bisector.js":"hZFcz","./blur.js":false,"./count.js":false,"./cross.js":false,"./cumsum.js":false,"./descending.js":false,"./deviation.js":false,"./extent.js":false,"./fsum.js":false,"./group.js":false,"./groupSort.js":false,"./bin.js":false,"./threshold/freedmanDiaconis.js":false,"./threshold/scott.js":false,"./threshold/sturges.js":false,"./max.js":false,"./maxIndex.js":false,"./mean.js":false,"./median.js":false,"./merge.js":false,"./min.js":false,"./minIndex.js":false,"./mode.js":false,"./nice.js":false,"./pairs.js":false,"./permute.js":false,"./quantile.js":false,"./quickselect.js":false,"./range.js":"qH3fZ","./rank.js":false,"./least.js":false,"./leastIndex.js":false,"./greatest.js":false,"./greatestIndex.js":false,"./scan.js":false,"./shuffle.js":false,"./sum.js":false,"./ticks.js":"l9gkx","./transpose.js":false,"./variance.js":false,"./zip.js":false,"./every.js":false,"./some.js":false,"./filter.js":false,"./map.js":false,"./reduce.js":false,"./reverse.js":false,"./sort.js":false,"./difference.js":false,"./disjoint.js":false,"./intersection.js":false,"./subset.js":false,"./superset.js":false,"./union.js":false,"internmap":"4NbRX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Ftqv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", function() {
    return bisectRight;
});
parcelHelpers.export(exports, "bisectLeft", function() {
    return bisectLeft;
});
parcelHelpers.export(exports, "bisectCenter", function() {
    return bisectCenter;
});
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _bisectorJs = require("./bisector.js");
var _bisectorJsDefault = parcelHelpers.interopDefault(_bisectorJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var ascendingBisect = (0, _bisectorJsDefault.default)((0, _ascendingJsDefault.default));
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
var bisectCenter = (0, _bisectorJsDefault.default)((0, _numberJsDefault.default)).center;
exports.default = bisectRight;

},{"./ascending.js":"6K1bX","./bisector.js":"hZFcz","./number.js":"5gzGR","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6K1bX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ascending;
});
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hZFcz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return bisector;
});
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
function bisector(f) {
    var compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, _ascendingJsDefault.default);
        compare2 = function(d, x) {
            return (0, _ascendingJsDefault.default)(f(d), x);
        };
        delta = function(d, x) {
            return f(d) - x;
        };
    } else {
        compare1 = f === (0, _ascendingJsDefault.default) || f === (0, _descendingJsDefault.default) ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                var mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x) {
        var lo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, hi = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : a.length;
        var i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function zero() {
    return 0;
}

},{"./ascending.js":"6K1bX","./descending.js":"59REi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"59REi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return descending;
});
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5gzGR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return number;
});
parcelHelpers.export(exports, "numbers", function() {
    return numbers;
});
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function number(x) {
    return x === null ? NaN : +x;
}
function numbers(values, valueof) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value, err, index, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, value1, err;
    return (0, _tsGenerator._)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!(valueof === undefined)) return [
                    3,
                    9
                ];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    7,
                    8
                ]);
                _iterator = values[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    5
                ];
                value = _step.value;
                if (!(value != null && (value = +value) >= value)) return [
                    3,
                    4
                ];
                return [
                    4,
                    value
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 5:
                return [
                    3,
                    8
                ];
            case 6:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    8
                ];
            case 7:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 8:
                return [
                    3,
                    17
                ];
            case 9:
                index = -1;
                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                _state.label = 10;
            case 10:
                _state.trys.push([
                    10,
                    15,
                    16,
                    17
                ]);
                _iterator1 = values[Symbol.iterator]();
                _state.label = 11;
            case 11:
                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                    3,
                    14
                ];
                value1 = _step1.value;
                if (!((value1 = valueof(value1, ++index, values)) != null && (value1 = +value1) >= value1)) return [
                    3,
                    13
                ];
                return [
                    4,
                    value1
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                _iteratorNormalCompletion1 = true;
                return [
                    3,
                    11
                ];
            case 14:
                return [
                    3,
                    17
                ];
            case 15:
                err = _state.sent();
                _didIteratorError1 = true;
                _iteratorError1 = err;
                return [
                    3,
                    17
                ];
            case 16:
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
                return [
                    7
                ];
            case 17:
                return [
                    2
                ];
        }
    });
}

},{"@swc/helpers/_/_ts_generator":"HrSs8","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"qH3fZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return range;
});
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l9gkx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return ticks;
});
parcelHelpers.export(exports, "tickIncrement", function() {
    return tickIncrement;
});
parcelHelpers.export(exports, "tickStep", function() {
    return tickStep;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
    var i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function ticks(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    var reverse = stop < start, _ref = (0, _slicedToArray._)(reverse ? tickSpec(stop, start, count) : tickSpec(start, stop, count), 3), i1 = _ref[0], i2 = _ref[1], inc = _ref[2];
    if (!(i2 >= i1)) return [];
    var n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(var i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(var i3 = 0; i3 < n; ++i3)ticks[i3] = (i2 - i3) * inc;
    } else {
        if (inc < 0) for(var i4 = 0; i4 < n; ++i4)ticks[i4] = (i1 + i4) / -inc;
        else for(var i5 = 0; i5 < n; ++i5)ticks[i5] = (i1 + i5) * inc;
    }
    return ticks;
}
function tickIncrement(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return tickSpec(start, stop, count)[2];
}
function tickStep(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    var reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count) : tickIncrement(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4NbRX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternMap", function() {
    return InternMap;
});
parcelHelpers.export(exports, "InternSet", function() {
    return InternSet;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _createSuper = require("@swc/helpers/_/_create_super");
var InternMap = /*#__PURE__*/ function(Map1) {
    "use strict";
    (0, _inherits._)(InternMap, Map1);
    var _super = (0, _createSuper._)(InternMap);
    function InternMap(entries) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : keyof;
        (0, _classCallCheck._)(this, InternMap);
        var _this;
        _this = _super.call(this);
        Object.defineProperties((0, _assertThisInitialized._)(_this), {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (entries != null) try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key1 = _step_value[0], value = _step_value[1];
                _this.set(key1, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, _createClass._)(InternMap, [
        {
            key: "get",
            value: function get(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "get", this).call(this, intern_get(this, key));
            }
        },
        {
            key: "has",
            value: function has(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "has", this).call(this, intern_get(this, key));
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "set", this).call(this, intern_set(this, key), value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return (0, _get._)((0, _getPrototypeOf._)(InternMap.prototype), "delete", this).call(this, intern_delete(this, key));
            }
        }
    ]);
    return InternMap;
}((0, _wrapNativeSuper._)(Map));
var InternSet = /*#__PURE__*/ function(Set1) {
    "use strict";
    (0, _inherits._)(InternSet, Set1);
    var _super = (0, _createSuper._)(InternSet);
    function InternSet(values) {
        var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : keyof;
        (0, _classCallCheck._)(this, InternSet);
        var _this;
        _this = _super.call(this);
        Object.defineProperties((0, _assertThisInitialized._)(_this), {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (values != null) try {
            for(var _iterator = values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                _this.add(value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _this;
    }
    (0, _createClass._)(InternSet, [
        {
            key: "has",
            value: function has(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "has", this).call(this, intern_get(this, value));
            }
        },
        {
            key: "add",
            value: function add(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "add", this).call(this, intern_set(this, value));
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                return (0, _get._)((0, _getPrototypeOf._)(InternSet.prototype), "delete", this).call(this, intern_delete(this, value));
            }
        }
    ]);
    return InternSet;
}((0, _wrapNativeSuper._)(Set));
function intern_get(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete(param, value) {
    var _intern = param._intern, _key = param._key;
    var key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{"@swc/helpers/_/_assert_this_initialized":"6z9ZW","@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_get":"dwBDP","@swc/helpers/_/_get_prototype_of":"6bloJ","@swc/helpers/_/_inherits":"j9BK3","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_wrap_native_super":"9QuY0","@swc/helpers/_/_create_super":"cFmrg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6z9ZW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_assert_this_initialized", function() {
    return _assert_this_initialized;
});
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dwBDP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_get", function() {
    return _get;
});
parcelHelpers.export(exports, "_", function() {
    return _get;
});
var _superPropBaseJs = require("./_super_prop_base.js");
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function get(target, property, receiver) {
        var base = (0, _superPropBaseJs._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}

},{"./_super_prop_base.js":"4XwLX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4XwLX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_super_prop_base", function() {
    return _super_prop_base;
});
parcelHelpers.export(exports, "_", function() {
    return _super_prop_base;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, _getPrototypeOfJs._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

},{"./_get_prototype_of.js":"6bloJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6bloJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_get_prototype_of", function() {
    return _get_prototype_of;
});
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j9BK3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_inherits", function() {
    return _inherits;
});
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._set_prototype_of)(subClass, superClass);
}

},{"./_set_prototype_of.js":"2M9Ni","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2M9Ni":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_set_prototype_of", function() {
    return _set_prototype_of;
});
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9QuY0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_wrap_native_super", function() {
    return _wrap_native_super;
});
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._construct)(Class, arguments, (0, _getPrototypeOfJs._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._set_prototype_of)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"dY18V","./_get_prototype_of.js":"6bloJ","./_is_native_function.js":"vj1ib","./_set_prototype_of.js":"2M9Ni","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dY18V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_construct", function() {
    return _construct;
});
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._is_native_reflect_construct)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"bjckL","./_set_prototype_of.js":"2M9Ni","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bjckL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_is_native_reflect_construct", function() {
    return _is_native_reflect_construct;
});
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"vj1ib":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_is_native_function", function() {
    return _is_native_function;
});
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cFmrg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_create_super", function() {
    return _create_super;
});
parcelHelpers.export(exports, "_", function() {
    return _create_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _create_super(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJs._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJs._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJs._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJs._possible_constructor_return)(this, result);
    };
}

},{"./_get_prototype_of.js":"6bloJ","./_is_native_reflect_construct.js":"bjckL","./_possible_constructor_return.js":"2FrxW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2FrxW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_possible_constructor_return", function() {
    return _possible_constructor_return;
});
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._assert_this_initialized)(self);
}

},{"./_assert_this_initialized.js":"6z9ZW","./_type_of.js":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ibkBf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", function() {
    return initRange;
});
parcelHelpers.export(exports, "initInterpolator", function() {
    return initInterpolator;
});
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"317ye":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", function() {
    return implicit;
});
parcelHelpers.export(exports, "default", function() {
    return ordinal;
});
var _d3Array = require("d3-array");
var _initJs = require("./init.js");
var implicit = Symbol("implicit");
function ordinal() {
    var index = new (0, _d3Array.InternMap)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, _d3Array.InternMap)();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (index.has(value)) continue;
                index.set(value, domain.push(value) - 1);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"fmvZm","./init.js":"ibkBf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cvN1T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", function() {
    return linearish;
});
parcelHelpers.export(exports, "default", function() {
    return linear;
});
var _d3Array = require("d3-array");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _tickFormatJs = require("./tickFormat.js");
var _tickFormatJsDefault = parcelHelpers.interopDefault(_tickFormatJs);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatJsDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _d3Array.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousJsDefault.default)();
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, linear());
    };
    (0, _initJs.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"fmvZm","./continuous.js":"4OhrI","./init.js":"ibkBf","./tickFormat.js":"eTJLi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4OhrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", function() {
    return identity;
});
parcelHelpers.export(exports, "copy", function() {
    return copy;
});
parcelHelpers.export(exports, "transformer", function() {
    return transformer;
});
parcelHelpers.export(exports, "default", function() {
    return continuous;
});
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantJsDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, _numberJsDefault.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"d3-array":"fmvZm","d3-interpolate":"bxVRm","./constant.js":"6en7E","./number.js":"054pl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bxVRm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", function() {
    return 0, _valueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateArray", function() {
    return 0, _arrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasis", function() {
    return 0, _basisJsDefault.default;
});
parcelHelpers.export(exports, "interpolateBasisClosed", function() {
    return 0, _basisClosedJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDate", function() {
    return 0, _dateJsDefault.default;
});
parcelHelpers.export(exports, "interpolateDiscrete", function() {
    return 0, _discreteJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHue", function() {
    return 0, _hueJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumber", function() {
    return 0, _numberJsDefault.default;
});
parcelHelpers.export(exports, "interpolateNumberArray", function() {
    return 0, _numberArrayJsDefault.default;
});
parcelHelpers.export(exports, "interpolateObject", function() {
    return 0, _objectJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRound", function() {
    return 0, _roundJsDefault.default;
});
parcelHelpers.export(exports, "interpolateString", function() {
    return 0, _stringJsDefault.default;
});
parcelHelpers.export(exports, "interpolateTransformCss", function() {
    return 0, _indexJs.interpolateTransformCss;
});
parcelHelpers.export(exports, "interpolateTransformSvg", function() {
    return 0, _indexJs.interpolateTransformSvg;
});
parcelHelpers.export(exports, "interpolateZoom", function() {
    return 0, _zoomJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgb", function() {
    return 0, _rgbJsDefault.default;
});
parcelHelpers.export(exports, "interpolateRgbBasis", function() {
    return 0, _rgbJs.rgbBasis;
});
parcelHelpers.export(exports, "interpolateRgbBasisClosed", function() {
    return 0, _rgbJs.rgbBasisClosed;
});
parcelHelpers.export(exports, "interpolateHsl", function() {
    return 0, _hslJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHslLong", function() {
    return 0, _hslJs.hslLong;
});
parcelHelpers.export(exports, "interpolateLab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHcl", function() {
    return 0, _hclJsDefault.default;
});
parcelHelpers.export(exports, "interpolateHclLong", function() {
    return 0, _hclJs.hclLong;
});
parcelHelpers.export(exports, "interpolateCubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
parcelHelpers.export(exports, "interpolateCubehelixLong", function() {
    return 0, _cubehelixJs.cubehelixLong;
});
parcelHelpers.export(exports, "piecewise", function() {
    return 0, _piecewiseJsDefault.default;
});
parcelHelpers.export(exports, "quantize", function() {
    return 0, _quantizeJsDefault.default;
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"eFvPQ","./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"ioa8P","./numberArray.js":false,"./object.js":false,"./round.js":"9dE1z","./string.js":false,"./transform/index.js":false,"./zoom.js":false,"./rgb.js":"2Jvso","./hsl.js":"8Dkxg","./lab.js":"9tw6X","./hcl.js":"4EM1V","./cubehelix.js":"8jTHe","./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eFvPQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var t = typeof b === "undefined" ? "undefined" : (0, _typeOf._)(b), c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    };
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"@swc/helpers/_/_type_of":"6Gp9n","d3-color":"c0udm","./rgb.js":"2Jvso","./array.js":"8y0KU","./date.js":"19X6E","./number.js":"ioa8P","./object.js":"d7emm","./string.js":"bk3K5","./constant.js":"96HaN","./numberArray.js":"lm9Th","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"c0udm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", function() {
    return 0, _colorJsDefault.default;
});
parcelHelpers.export(exports, "rgb", function() {
    return 0, _colorJs.rgb;
});
parcelHelpers.export(exports, "hsl", function() {
    return 0, _colorJs.hsl;
});
parcelHelpers.export(exports, "lab", function() {
    return 0, _labJsDefault.default;
});
parcelHelpers.export(exports, "hcl", function() {
    return 0, _labJs.hcl;
});
parcelHelpers.export(exports, "lch", function() {
    return 0, _labJs.lch;
});
parcelHelpers.export(exports, "gray", function() {
    return 0, _labJs.gray;
});
parcelHelpers.export(exports, "cubehelix", function() {
    return 0, _cubehelixJsDefault.default;
});
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"cjayi","./lab.js":"4TCtY","./cubehelix.js":"7vdK7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cjayi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", function() {
    return Color;
});
parcelHelpers.export(exports, "darker", function() {
    return darker;
});
parcelHelpers.export(exports, "brighter", function() {
    return brighter;
});
parcelHelpers.export(exports, "default", function() {
    return color;
});
parcelHelpers.export(exports, "rgbConvert", function() {
    return rgbConvert;
});
parcelHelpers.export(exports, "rgb", function() {
    return rgb;
});
parcelHelpers.export(exports, "Rgb", function() {
    return Rgb;
});
parcelHelpers.export(exports, "hslConvert", function() {
    return hslConvert;
});
parcelHelpers.export(exports, "hsl", function() {
    return hsl;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(".concat(reI, ",").concat(reI, ",").concat(reI, "\\)$")), reRgbPercent = new RegExp("^rgb\\(".concat(reP, ",").concat(reP, ",").concat(reP, "\\)$")), reRgbaInteger = new RegExp("^rgba\\(".concat(reI, ",").concat(reI, ",").concat(reI, ",").concat(reN, "\\)$")), reRgbaPercent = new RegExp("^rgba\\(".concat(reP, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$")), reHslPercent = new RegExp("^hsl\\(".concat(reN, ",").concat(reP, ",").concat(reP, "\\)$")), reHslaPercent = new RegExp("^hsla\\(".concat(reN, ",").concat(reP, ",").concat(reP, ",").concat(reN, "\\)$"));
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    clamp: function() {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b));
}
function rgb_formatHex8() {
    return "#".concat(hex(this.r)).concat(hex(this.g)).concat(hex(this.b)).concat(hex((isNaN(this.opacity) ? 1 : this.opacity) * 255));
}
function rgb_formatRgb() {
    var a = clampa(this.opacity);
    return "".concat(a === 1 ? "rgb(" : "rgba(").concat(clampi(this.r), ", ").concat(clampi(this.g), ", ").concat(clampi(this.b)).concat(a === 1 ? ")" : ", ".concat(a, ")"));
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp: function() {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = clampa(this.opacity);
        return "".concat(a === 1 ? "hsl(" : "hsla(").concat(clamph(this.h), ", ").concat(clampt(this.s) * 100, "%, ").concat(clampt(this.l) * 100, "%").concat(a === 1 ? ")" : ", ".concat(a, ")"));
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"8glzl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8glzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    };
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4TCtY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", function() {
    return gray;
});
parcelHelpers.export(exports, "default", function() {
    return lab;
});
parcelHelpers.export(exports, "Lab", function() {
    return Lab;
});
parcelHelpers.export(exports, "lch", function() {
    return lch;
});
parcelHelpers.export(exports, "hcl", function() {
    return hcl;
});
parcelHelpers.export(exports, "Hcl", function() {
    return Hcl;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.degrees);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.radians);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"8glzl","./color.js":"cjayi","./math.js":"koc6a","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"koc6a":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "radians", function() {
    return radians;
});
parcelHelpers.export(exports, "degrees", function() {
    return degrees;
});
var radians = Math.PI / 180;
var degrees = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7vdK7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cubehelix;
});
parcelHelpers.export(exports, "Cubehelix", function() {
    return Cubehelix;
});
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.degrees) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.radians), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"8glzl","./color.js":"cjayi","./math.js":"koc6a","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2Jvso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", function() {
    return rgbBasis;
});
parcelHelpers.export(exports, "rgbBasisClosed", function() {
    return rgbBasisClosed;
});
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"c0udm","./basis.js":"bpvt9","./basisClosed.js":"hRZab","./color.js":"1NmoN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bpvt9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", function() {
    return basis;
});
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hRZab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    };
});
var _basisJs = require("./basis.js");

},{"./basis.js":"bpvt9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1NmoN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", function() {
    return hue;
});
parcelHelpers.export(exports, "gamma", function() {
    return gamma;
});
parcelHelpers.export(exports, "default", function() {
    return nogamma;
});
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"96HaN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"96HaN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = function(x) {
    return function() {
        return x;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8y0KU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    };
});
parcelHelpers.export(exports, "genericArray", function() {
    return genericArray;
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"eFvPQ","./numberArray.js":"lm9Th","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lm9Th":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    };
});
parcelHelpers.export(exports, "isNumberArray", function() {
    return isNumberArray;
});
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"19X6E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ioa8P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d7emm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    };
});
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"eFvPQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bk3K5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    };
});
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"ioa8P","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9dE1z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8Dkxg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", function() {
    return hslLong;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"c0udm","./color.js":"1NmoN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9tw6X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lab;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":"c0udm","./color.js":"1NmoN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4EM1V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", function() {
    return hclLong;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"c0udm","./color.js":"1NmoN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8jTHe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", function() {
    return cubehelixLong;
});
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"c0udm","./color.js":"1NmoN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6en7E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return constants;
});
function constants(x) {
    return function() {
        return x;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"054pl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return number;
});
function number(x) {
    return +x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eTJLi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return tickFormat;
});
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _d3Array.tickStep)(start, stop, count), precision;
    specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _d3Format.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _d3Format.format)(specifier);
}

},{"d3-array":"fmvZm","d3-format":"flPEX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"flPEX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", function() {
    return 0, _defaultLocaleJsDefault.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _defaultLocaleJs.format;
});
parcelHelpers.export(exports, "formatPrefix", function() {
    return 0, _defaultLocaleJs.formatPrefix;
});
parcelHelpers.export(exports, "formatLocale", function() {
    return 0, _localeJsDefault.default;
});
parcelHelpers.export(exports, "formatSpecifier", function() {
    return 0, _formatSpecifierJsDefault.default;
});
parcelHelpers.export(exports, "FormatSpecifier", function() {
    return 0, _formatSpecifierJs.FormatSpecifier;
});
parcelHelpers.export(exports, "precisionFixed", function() {
    return 0, _precisionFixedJsDefault.default;
});
parcelHelpers.export(exports, "precisionPrefix", function() {
    return 0, _precisionPrefixJsDefault.default;
});
parcelHelpers.export(exports, "precisionRound", function() {
    return 0, _precisionRoundJsDefault.default;
});
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"9H4YB","./locale.js":false,"./formatSpecifier.js":"hdIzM","./precisionFixed.js":"4gBUf","./precisionPrefix.js":"77UtU","./precisionRound.js":"01E0n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9H4YB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", function() {
    return format;
});
parcelHelpers.export(exports, "formatPrefix", function() {
    return formatPrefix;
});
parcelHelpers.export(exports, "default", function() {
    return defaultLocale;
});
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"d5HXF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d5HXF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"caOXv","./formatGroup.js":"62Rpg","./formatNumerals.js":"3OUIe","./formatSpecifier.js":"hdIzM","./formatTrim.js":"btZV7","./formatTypes.js":"1iGrY","./formatPrefixAuto.js":"egJuk","./identity.js":"72Cg6","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"caOXv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    };
});
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6I5JB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6I5JB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    };
});
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", function() {
    return formatDecimalParts;
});
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"62Rpg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3OUIe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hdIzM":[function(require,module,exports) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatSpecifier;
});
parcelHelpers.export(exports, "FormatSpecifier", function() {
    return FormatSpecifier;
});
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"btZV7":[function(require,module,exports) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1iGrY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"6I5JB","./formatPrefixAuto.js":"egJuk","./formatRounded.js":"hwHcL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"egJuk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", function() {
    return prefixExponent;
});
parcelHelpers.export(exports, "default", function() {
    return function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    };
});
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"6I5JB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hwHcL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    };
});
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6I5JB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"72Cg6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return x;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4gBUf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"caOXv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"77UtU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"caOXv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"01E0n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    };
});
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"caOXv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8ppAZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", function() {
    return calendar;
});
parcelHelpers.export(exports, "default", function() {
    return time;
});
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _continuousJs = require("./continuous.js");
var _continuousJsDefault = parcelHelpers.interopDefault(_continuousJs);
var _initJs = require("./init.js");
var _niceJs = require("./nice.js");
var _niceJsDefault = parcelHelpers.interopDefault(_niceJs);
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuousJsDefault.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _niceJsDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuousJs.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return (0, _initJs.initRange).apply(calendar((0, _d3Time.timeTicks), (0, _d3Time.timeTickInterval), (0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3TimeFormat.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d3-time":"1WRs9","d3-time-format":"eVRyC","./continuous.js":"4OhrI","./init.js":"ibkBf","./nice.js":"5EOeB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1WRs9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", function() {
    return 0, _intervalJs.timeInterval;
});
parcelHelpers.export(exports, "utcMillisecond", function() {
    return 0, _millisecondJs.millisecond;
});
parcelHelpers.export(exports, "utcMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "timeMillisecond", function() {
    return 0, _millisecondJs.millisecond;
});
parcelHelpers.export(exports, "timeMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "utcSecond", function() {
    return 0, _secondJs.second;
});
parcelHelpers.export(exports, "utcSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "timeSecond", function() {
    return 0, _secondJs.second;
});
parcelHelpers.export(exports, "timeSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "timeMinute", function() {
    return 0, _minuteJs.timeMinute;
});
parcelHelpers.export(exports, "timeMinutes", function() {
    return 0, _minuteJs.timeMinutes;
});
parcelHelpers.export(exports, "utcMinute", function() {
    return 0, _minuteJs.utcMinute;
});
parcelHelpers.export(exports, "utcMinutes", function() {
    return 0, _minuteJs.utcMinutes;
});
parcelHelpers.export(exports, "timeHour", function() {
    return 0, _hourJs.timeHour;
});
parcelHelpers.export(exports, "timeHours", function() {
    return 0, _hourJs.timeHours;
});
parcelHelpers.export(exports, "utcHour", function() {
    return 0, _hourJs.utcHour;
});
parcelHelpers.export(exports, "utcHours", function() {
    return 0, _hourJs.utcHours;
});
parcelHelpers.export(exports, "timeDay", function() {
    return 0, _dayJs.timeDay;
});
parcelHelpers.export(exports, "timeDays", function() {
    return 0, _dayJs.timeDays;
});
parcelHelpers.export(exports, "utcDay", function() {
    return 0, _dayJs.utcDay;
});
parcelHelpers.export(exports, "utcDays", function() {
    return 0, _dayJs.utcDays;
});
parcelHelpers.export(exports, "unixDay", function() {
    return 0, _dayJs.unixDay;
});
parcelHelpers.export(exports, "unixDays", function() {
    return 0, _dayJs.unixDays;
});
parcelHelpers.export(exports, "timeWeek", function() {
    return 0, _weekJs.timeSunday;
});
parcelHelpers.export(exports, "timeWeeks", function() {
    return 0, _weekJs.timeSundays;
});
parcelHelpers.export(exports, "timeSunday", function() {
    return 0, _weekJs.timeSunday;
});
parcelHelpers.export(exports, "timeSundays", function() {
    return 0, _weekJs.timeSundays;
});
parcelHelpers.export(exports, "timeMonday", function() {
    return 0, _weekJs.timeMonday;
});
parcelHelpers.export(exports, "timeMondays", function() {
    return 0, _weekJs.timeMondays;
});
parcelHelpers.export(exports, "timeTuesday", function() {
    return 0, _weekJs.timeTuesday;
});
parcelHelpers.export(exports, "timeTuesdays", function() {
    return 0, _weekJs.timeTuesdays;
});
parcelHelpers.export(exports, "timeWednesday", function() {
    return 0, _weekJs.timeWednesday;
});
parcelHelpers.export(exports, "timeWednesdays", function() {
    return 0, _weekJs.timeWednesdays;
});
parcelHelpers.export(exports, "timeThursday", function() {
    return 0, _weekJs.timeThursday;
});
parcelHelpers.export(exports, "timeThursdays", function() {
    return 0, _weekJs.timeThursdays;
});
parcelHelpers.export(exports, "timeFriday", function() {
    return 0, _weekJs.timeFriday;
});
parcelHelpers.export(exports, "timeFridays", function() {
    return 0, _weekJs.timeFridays;
});
parcelHelpers.export(exports, "timeSaturday", function() {
    return 0, _weekJs.timeSaturday;
});
parcelHelpers.export(exports, "timeSaturdays", function() {
    return 0, _weekJs.timeSaturdays;
});
parcelHelpers.export(exports, "utcWeek", function() {
    return 0, _weekJs.utcSunday;
});
parcelHelpers.export(exports, "utcWeeks", function() {
    return 0, _weekJs.utcSundays;
});
parcelHelpers.export(exports, "utcSunday", function() {
    return 0, _weekJs.utcSunday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return 0, _weekJs.utcSundays;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return 0, _weekJs.utcMonday;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return 0, _weekJs.utcMondays;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return 0, _weekJs.utcTuesday;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return 0, _weekJs.utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return 0, _weekJs.utcWednesday;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return 0, _weekJs.utcWednesdays;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return 0, _weekJs.utcThursday;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return 0, _weekJs.utcThursdays;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return 0, _weekJs.utcFriday;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return 0, _weekJs.utcFridays;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return 0, _weekJs.utcSaturday;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return 0, _weekJs.utcSaturdays;
});
parcelHelpers.export(exports, "timeMonth", function() {
    return 0, _monthJs.timeMonth;
});
parcelHelpers.export(exports, "timeMonths", function() {
    return 0, _monthJs.timeMonths;
});
parcelHelpers.export(exports, "utcMonth", function() {
    return 0, _monthJs.utcMonth;
});
parcelHelpers.export(exports, "utcMonths", function() {
    return 0, _monthJs.utcMonths;
});
parcelHelpers.export(exports, "timeYear", function() {
    return 0, _yearJs.timeYear;
});
parcelHelpers.export(exports, "timeYears", function() {
    return 0, _yearJs.timeYears;
});
parcelHelpers.export(exports, "utcYear", function() {
    return 0, _yearJs.utcYear;
});
parcelHelpers.export(exports, "utcYears", function() {
    return 0, _yearJs.utcYears;
});
parcelHelpers.export(exports, "utcTicks", function() {
    return 0, _ticksJs.utcTicks;
});
parcelHelpers.export(exports, "utcTickInterval", function() {
    return 0, _ticksJs.utcTickInterval;
});
parcelHelpers.export(exports, "timeTicks", function() {
    return 0, _ticksJs.timeTicks;
});
parcelHelpers.export(exports, "timeTickInterval", function() {
    return 0, _ticksJs.timeTickInterval;
});
var _intervalJs = require("./interval.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
var _ticksJs = require("./ticks.js");

},{"./interval.js":false,"./millisecond.js":false,"./second.js":"722u5","./minute.js":"cGJJV","./hour.js":"eILUq","./day.js":"kVnJo","./week.js":"j6z92","./month.js":"lqkpI","./year.js":"jlqnl","./ticks.js":"329b5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"62tBT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", function() {
    return timeInterval;
});
var t0 = new Date, t1 = new Date;
function timeInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        var previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return timeInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8qptf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecond", function() {
    return millisecond;
});
parcelHelpers.export(exports, "milliseconds", function() {
    return milliseconds;
});
var _intervalJs = require("./interval.js");
var millisecond = (0, _intervalJs.timeInterval)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJs.timeInterval)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var milliseconds = millisecond.range;

},{"./interval.js":"62tBT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"722u5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "second", function() {
    return second;
});
parcelHelpers.export(exports, "seconds", function() {
    return seconds;
});
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
var second = (0, _intervalJs.timeInterval)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
var seconds = second.range;

},{"./interval.js":"62tBT","./duration.js":"8l1nE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8l1nE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", function() {
    return durationSecond;
});
parcelHelpers.export(exports, "durationMinute", function() {
    return durationMinute;
});
parcelHelpers.export(exports, "durationHour", function() {
    return durationHour;
});
parcelHelpers.export(exports, "durationDay", function() {
    return durationDay;
});
parcelHelpers.export(exports, "durationWeek", function() {
    return durationWeek;
});
parcelHelpers.export(exports, "durationMonth", function() {
    return durationMonth;
});
parcelHelpers.export(exports, "durationYear", function() {
    return durationYear;
});
var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cGJJV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMinute", function() {
    return timeMinute;
});
parcelHelpers.export(exports, "timeMinutes", function() {
    return timeMinutes;
});
parcelHelpers.export(exports, "utcMinute", function() {
    return utcMinute;
});
parcelHelpers.export(exports, "utcMinutes", function() {
    return utcMinutes;
});
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
var timeMinute = (0, _intervalJs.timeInterval)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
var timeMinutes = timeMinute.range;
var utcMinute = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
var utcMinutes = utcMinute.range;

},{"./interval.js":"62tBT","./duration.js":"8l1nE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eILUq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeHour", function() {
    return timeHour;
});
parcelHelpers.export(exports, "timeHours", function() {
    return timeHours;
});
parcelHelpers.export(exports, "utcHour", function() {
    return utcHour;
});
parcelHelpers.export(exports, "utcHours", function() {
    return utcHours;
});
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
var timeHour = (0, _intervalJs.timeInterval)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
var timeHours = timeHour.range;
var utcHour = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
var utcHours = utcHour.range;

},{"./interval.js":"62tBT","./duration.js":"8l1nE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kVnJo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDay", function() {
    return timeDay;
});
parcelHelpers.export(exports, "timeDays", function() {
    return timeDays;
});
parcelHelpers.export(exports, "utcDay", function() {
    return utcDay;
});
parcelHelpers.export(exports, "utcDays", function() {
    return utcDays;
});
parcelHelpers.export(exports, "unixDay", function() {
    return unixDay;
});
parcelHelpers.export(exports, "unixDays", function() {
    return unixDays;
});
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
var timeDay = (0, _intervalJs.timeInterval)(function(date) {
    return date.setHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
var timeDays = timeDay.range;
var utcDay = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
var utcDays = utcDay.range;
var unixDay = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return Math.floor(date / (0, _durationJs.durationDay));
});
var unixDays = unixDay.range;

},{"./interval.js":"62tBT","./duration.js":"8l1nE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j6z92":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeSunday", function() {
    return timeSunday;
});
parcelHelpers.export(exports, "timeMonday", function() {
    return timeMonday;
});
parcelHelpers.export(exports, "timeTuesday", function() {
    return timeTuesday;
});
parcelHelpers.export(exports, "timeWednesday", function() {
    return timeWednesday;
});
parcelHelpers.export(exports, "timeThursday", function() {
    return timeThursday;
});
parcelHelpers.export(exports, "timeFriday", function() {
    return timeFriday;
});
parcelHelpers.export(exports, "timeSaturday", function() {
    return timeSaturday;
});
parcelHelpers.export(exports, "timeSundays", function() {
    return timeSundays;
});
parcelHelpers.export(exports, "timeMondays", function() {
    return timeMondays;
});
parcelHelpers.export(exports, "timeTuesdays", function() {
    return timeTuesdays;
});
parcelHelpers.export(exports, "timeWednesdays", function() {
    return timeWednesdays;
});
parcelHelpers.export(exports, "timeThursdays", function() {
    return timeThursdays;
});
parcelHelpers.export(exports, "timeFridays", function() {
    return timeFridays;
});
parcelHelpers.export(exports, "timeSaturdays", function() {
    return timeSaturdays;
});
parcelHelpers.export(exports, "utcSunday", function() {
    return utcSunday;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return utcMonday;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return utcTuesday;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return utcWednesday;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return utcThursday;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return utcFriday;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return utcSaturday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return utcSundays;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return utcMondays;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return utcWednesdays;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return utcThursdays;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return utcFridays;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return utcSaturdays;
});
var _intervalJs = require("./interval.js");
var _durationJs = require("./duration.js");
function timeWeekday(i) {
    return (0, _intervalJs.timeInterval)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var timeSunday = timeWeekday(0);
var timeMonday = timeWeekday(1);
var timeTuesday = timeWeekday(2);
var timeWednesday = timeWeekday(3);
var timeThursday = timeWeekday(4);
var timeFriday = timeWeekday(5);
var timeSaturday = timeWeekday(6);
var timeSundays = timeSunday.range;
var timeMondays = timeMonday.range;
var timeTuesdays = timeTuesday.range;
var timeWednesdays = timeWednesday.range;
var timeThursdays = timeThursday.range;
var timeFridays = timeFriday.range;
var timeSaturdays = timeSaturday.range;
function utcWeekday(i) {
    return (0, _intervalJs.timeInterval)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"62tBT","./duration.js":"8l1nE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lqkpI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeMonth", function() {
    return timeMonth;
});
parcelHelpers.export(exports, "timeMonths", function() {
    return timeMonths;
});
parcelHelpers.export(exports, "utcMonth", function() {
    return utcMonth;
});
parcelHelpers.export(exports, "utcMonths", function() {
    return utcMonths;
});
var _intervalJs = require("./interval.js");
var timeMonth = (0, _intervalJs.timeInterval)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var timeMonths = timeMonth.range;
var utcMonth = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var utcMonths = utcMonth.range;

},{"./interval.js":"62tBT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jlqnl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeYear", function() {
    return timeYear;
});
parcelHelpers.export(exports, "timeYears", function() {
    return timeYears;
});
parcelHelpers.export(exports, "utcYear", function() {
    return utcYear;
});
parcelHelpers.export(exports, "utcYears", function() {
    return utcYears;
});
var _intervalJs = require("./interval.js");
var timeYear = (0, _intervalJs.timeInterval)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
timeYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var timeYears = timeYear.range;
var utcYear = (0, _intervalJs.timeInterval)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJs.timeInterval)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var utcYears = utcYear.range;

},{"./interval.js":"62tBT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"329b5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcTicks", function() {
    return utcTicks;
});
parcelHelpers.export(exports, "utcTickInterval", function() {
    return utcTickInterval;
});
parcelHelpers.export(exports, "timeTicks", function() {
    return timeTicks;
});
parcelHelpers.export(exports, "timeTickInterval", function() {
    return timeTickInterval;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _d3Array = require("d3-array");
var _durationJs = require("./duration.js");
var _millisecondJs = require("./millisecond.js");
var _secondJs = require("./second.js");
var _minuteJs = require("./minute.js");
var _hourJs = require("./hour.js");
var _dayJs = require("./day.js");
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _yearJs = require("./year.js");
function ticker(year, month, week, day, hour, minute) {
    var tickIntervals = [
        [
            (0, _secondJs.second),
            1,
            (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            5,
            5 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            15,
            15 * (0, _durationJs.durationSecond)
        ],
        [
            (0, _secondJs.second),
            30,
            30 * (0, _durationJs.durationSecond)
        ],
        [
            minute,
            1,
            (0, _durationJs.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, _durationJs.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, _durationJs.durationMinute)
        ],
        [
            hour,
            1,
            (0, _durationJs.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, _durationJs.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, _durationJs.durationHour)
        ],
        [
            day,
            1,
            (0, _durationJs.durationDay)
        ],
        [
            day,
            2,
            2 * (0, _durationJs.durationDay)
        ],
        [
            week,
            1,
            (0, _durationJs.durationWeek)
        ],
        [
            month,
            1,
            (0, _durationJs.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, _durationJs.durationMonth)
        ],
        [
            year,
            1,
            (0, _durationJs.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        var reverse = stop < start;
        var ref;
        if (reverse) ref = [
            stop,
            start
        ], start = ref[0], stop = ref[1], ref;
        var interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        var _$ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? _$ticks.reverse() : _$ticks;
    }
    function tickInterval(start, stop, count) {
        var target = Math.abs(stop - start) / count;
        var i = (0, _d3Array.bisector)(function(param) {
            var _param = (0, _slicedToArray._)(param, 3), step = _param[2];
            return step;
        }).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _d3Array.tickStep)(start / (0, _durationJs.durationYear), stop / (0, _durationJs.durationYear), count));
        if (i === 0) return (0, _millisecondJs.millisecond).every(Math.max((0, _d3Array.tickStep)(start, stop, count), 1));
        var _tickIntervals_ = (0, _slicedToArray._)(tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i], 2), t = _tickIntervals_[0], step = _tickIntervals_[1];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
var _ticker = (0, _slicedToArray._)(ticker((0, _yearJs.utcYear), (0, _monthJs.utcMonth), (0, _weekJs.utcSunday), (0, _dayJs.unixDay), (0, _hourJs.utcHour), (0, _minuteJs.utcMinute)), 2), utcTicks = _ticker[0], utcTickInterval = _ticker[1];
var _ticker1 = (0, _slicedToArray._)(ticker((0, _yearJs.timeYear), (0, _monthJs.timeMonth), (0, _weekJs.timeSunday), (0, _dayJs.timeDay), (0, _hourJs.timeHour), (0, _minuteJs.timeMinute)), 2), timeTicks = _ticker1[0], timeTickInterval = _ticker1[1];

},{"@swc/helpers/_/_sliced_to_array":"gML59","d3-array":"fmvZm","./duration.js":"8l1nE","./millisecond.js":"8qptf","./second.js":"722u5","./minute.js":"cGJJV","./hour.js":"eILUq","./day.js":"kVnJo","./week.js":"j6z92","./month.js":"lqkpI","./year.js":"jlqnl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eVRyC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", function() {
    return 0, _defaultLocaleJsDefault.default;
});
parcelHelpers.export(exports, "timeFormat", function() {
    return 0, _defaultLocaleJs.timeFormat;
});
parcelHelpers.export(exports, "timeParse", function() {
    return 0, _defaultLocaleJs.timeParse;
});
parcelHelpers.export(exports, "utcFormat", function() {
    return 0, _defaultLocaleJs.utcFormat;
});
parcelHelpers.export(exports, "utcParse", function() {
    return 0, _defaultLocaleJs.utcParse;
});
parcelHelpers.export(exports, "timeFormatLocale", function() {
    return 0, _localeJsDefault.default;
});
parcelHelpers.export(exports, "isoFormat", function() {
    return 0, _isoFormatJsDefault.default;
});
parcelHelpers.export(exports, "isoParse", function() {
    return 0, _isoParseJsDefault.default;
});
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"4SGQZ","./locale.js":false,"./isoFormat.js":false,"./isoParse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4SGQZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", function() {
    return timeFormat;
});
parcelHelpers.export(exports, "timeParse", function() {
    return timeParse;
});
parcelHelpers.export(exports, "utcFormat", function() {
    return utcFormat;
});
parcelHelpers.export(exports, "utcParse", function() {
    return utcParse;
});
parcelHelpers.export(exports, "default", function() {
    return defaultLocale;
});
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"hnyPD","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hnyPD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatLocale;
});
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function format(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function parse(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function utcFormat(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function utcParse(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map(function(name, i) {
        return [
            name.toLowerCase(),
            i
        ];
    }));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"1WRs9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5EOeB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nice;
});
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7bhE0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_OPERATORS", function() {
    return ALL_OPERATORS;
});
parcelHelpers.export(exports, "default", function() {
    return scaleOperator;
});
var _domain = require("./domain");
var _domainDefault = parcelHelpers.interopDefault(_domain);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _align = require("./align");
var _alignDefault = parcelHelpers.interopDefault(_align);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _exponent = require("./exponent");
var _exponentDefault = parcelHelpers.interopDefault(_exponent);
var _interpolate = require("./interpolate");
var _interpolateDefault = parcelHelpers.interopDefault(_interpolate);
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var _padding = require("./padding");
var _paddingDefault = parcelHelpers.interopDefault(_padding);
var _reverse = require("./reverse");
var _reverseDefault = parcelHelpers.interopDefault(_reverse);
var _round = require("./round");
var _roundDefault = parcelHelpers.interopDefault(_round);
var _unknown = require("./unknown");
var _unknownDefault = parcelHelpers.interopDefault(_unknown);
var _zero = require("./zero");
var _zeroDefault = parcelHelpers.interopDefault(_zero);
var ALL_OPERATORS = [
    // domain => nice => zero
    "domain",
    "nice",
    "zero",
    // interpolate before round
    "interpolate",
    "round",
    // set range then reverse
    "range",
    "reverse",
    // Order does not matter for these operators
    "align",
    "base",
    "clamp",
    "constant",
    "exponent",
    "padding",
    "unknown"
];
// Use Record to enforce that all keys in OperatorType must exist.
var operators = {
    domain: (0, _domainDefault.default),
    nice: (0, _niceDefault.default),
    zero: (0, _zeroDefault.default),
    interpolate: (0, _interpolateDefault.default),
    round: (0, _roundDefault.default),
    align: (0, _alignDefault.default),
    base: (0, _baseDefault.default),
    clamp: (0, _clampDefault.default),
    constant: (0, _constantDefault.default),
    exponent: (0, _exponentDefault.default),
    padding: (0, _paddingDefault.default),
    range: (0, _rangeDefault.default),
    reverse: (0, _reverseDefault.default),
    unknown: (0, _unknownDefault.default)
};
function scaleOperator() {
    for(var _len = arguments.length, ops = new Array(_len), _key = 0; _key < _len; _key++)ops[_key] = arguments[_key];
    var selection = new Set(ops);
    var selectedOps = ALL_OPERATORS.filter(function(o) {
        return selection.has(o);
    });
    return function applyOperators(scale, config) {
        if (typeof config !== "undefined") selectedOps.forEach(function(op) {
            operators[op](scale, config);
        });
        return scale;
    };
}

},{"./domain":"jz9GM","./range":"5MWPg","./align":"ervlL","./base":"2hwm0","./clamp":"ccgTe","./constant":"aozrN","./exponent":"lgv00","./interpolate":"aBgNQ","./nice":"l3n5J","./padding":"dWmU3","./reverse":"g1NqU","./round":"hqnJz","./unknown":"7VovM","./zero":"1D4F7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jz9GM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyDomain;
});
function applyDomain(scale, config) {
    if (config.domain) {
        if ("nice" in scale || "quantiles" in scale) // continuous input scales
        scale.domain(config.domain);
        else if ("padding" in scale) // point and band scales
        scale.domain(config.domain);
        else // ordinal and threshold scale
        scale.domain(config.domain);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5MWPg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyRange;
});
function applyRange(scale, config) {
    if (config.range) {
        if ("padding" in scale) // point and band scales
        scale.range(config.range);
        else // the rest
        scale.range(config.range);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ervlL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyAlign;
});
function applyAlign(scale, config) {
    if ("align" in scale && "align" in config && typeof config.align !== "undefined") scale.align(config.align);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2hwm0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyBase;
});
function applyBase(scale, config) {
    if ("base" in scale && "base" in config && typeof config.base !== "undefined") scale.base(config.base);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ccgTe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyClamp;
});
function applyClamp(scale, config) {
    if ("clamp" in scale && "clamp" in config && typeof config.clamp !== "undefined") scale.clamp(config.clamp);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aozrN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyConstant;
});
function applyConstant(scale, config) {
    if ("constant" in scale && "constant" in config && typeof config.constant !== "undefined") scale.constant(config.constant);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lgv00":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyExponent;
});
function applyExponent(scale, config) {
    if ("exponent" in scale && "exponent" in config && typeof config.exponent !== "undefined") scale.exponent(config.exponent);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aBgNQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyInterpolate;
});
var _createColorInterpolator = require("../utils/createColorInterpolator");
var _createColorInterpolatorDefault = parcelHelpers.interopDefault(_createColorInterpolator);
function applyInterpolate(scale, config) {
    if ("interpolate" in config && "interpolate" in scale && typeof config.interpolate !== "undefined") {
        var interpolator = (0, _createColorInterpolatorDefault.default)(config.interpolate);
        scale.interpolate(interpolator);
    }
}

},{"../utils/createColorInterpolator":"hCzBd","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hCzBd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createColorInterpolator;
});
var _d3Interpolate = require("d3-interpolate");
var interpolatorMap = {
    lab: (0, _d3Interpolate.interpolateLab),
    hcl: (0, _d3Interpolate.interpolateHcl),
    "hcl-long": (0, _d3Interpolate.interpolateHclLong),
    hsl: (0, _d3Interpolate.interpolateHsl),
    "hsl-long": (0, _d3Interpolate.interpolateHslLong),
    cubehelix: (0, _d3Interpolate.interpolateCubehelix),
    "cubehelix-long": (0, _d3Interpolate.interpolateCubehelixLong),
    rgb: (0, _d3Interpolate.interpolateRgb)
};
function createColorInterpolator(interpolate) {
    switch(interpolate){
        case "lab":
        case "hcl":
        case "hcl-long":
        case "hsl":
        case "hsl-long":
        case "cubehelix":
        case "cubehelix-long":
        case "rgb":
            return interpolatorMap[interpolate];
        default:
    }
    var type = interpolate.type, gamma = interpolate.gamma;
    var interpolator = interpolatorMap[type];
    return typeof gamma === "undefined" ? interpolator : interpolator.gamma(gamma);
}

},{"d3-interpolate":"bxVRm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l3n5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyNice;
});
var _d3Time = require("d3-time");
var _isUtcScale = require("../utils/isUtcScale");
var _isUtcScaleDefault = parcelHelpers.interopDefault(_isUtcScale);
var localTimeIntervals = {
    day: (0, _d3Time.timeDay),
    hour: (0, _d3Time.timeHour),
    minute: (0, _d3Time.timeMinute),
    month: (0, _d3Time.timeMonth),
    second: (0, _d3Time.timeSecond),
    week: (0, _d3Time.timeWeek),
    year: (0, _d3Time.timeYear)
};
var utcIntervals = {
    day: (0, _d3Time.utcDay),
    hour: (0, _d3Time.utcHour),
    minute: (0, _d3Time.utcMinute),
    month: (0, _d3Time.utcMonth),
    second: (0, _d3Time.utcSecond),
    week: (0, _d3Time.utcWeek),
    year: (0, _d3Time.utcYear)
};
function applyNice(scale, config) {
    if ("nice" in config && typeof config.nice !== "undefined" && "nice" in scale) {
        var nice = config.nice;
        if (typeof nice === "boolean") {
            if (nice) scale.nice();
        } else if (typeof nice === "number") scale.nice(nice);
        else {
            var timeScale = scale;
            var isUtc = (0, _isUtcScaleDefault.default)(timeScale);
            if (typeof nice === "string") timeScale.nice(isUtc ? utcIntervals[nice] : localTimeIntervals[nice]);
            else {
                var interval = nice.interval, step = nice.step;
                var parsedInterval = (isUtc ? utcIntervals[interval] : localTimeIntervals[interval]).every(step);
                if (parsedInterval != null) timeScale.nice(parsedInterval);
            }
        }
    }
}

},{"d3-time":"itl0W","../utils/isUtcScale":"lHrxQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"itl0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", function() {
    return 0, _intervalJsDefault.default;
});
parcelHelpers.export(exports, "timeMillisecond", function() {
    return 0, _millisecondJsDefault.default;
});
parcelHelpers.export(exports, "timeMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "utcMillisecond", function() {
    return 0, _millisecondJsDefault.default;
});
parcelHelpers.export(exports, "utcMilliseconds", function() {
    return 0, _millisecondJs.milliseconds;
});
parcelHelpers.export(exports, "timeSecond", function() {
    return 0, _secondJsDefault.default;
});
parcelHelpers.export(exports, "timeSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "utcSecond", function() {
    return 0, _secondJsDefault.default;
});
parcelHelpers.export(exports, "utcSeconds", function() {
    return 0, _secondJs.seconds;
});
parcelHelpers.export(exports, "timeMinute", function() {
    return 0, _minuteJsDefault.default;
});
parcelHelpers.export(exports, "timeMinutes", function() {
    return 0, _minuteJs.minutes;
});
parcelHelpers.export(exports, "timeHour", function() {
    return 0, _hourJsDefault.default;
});
parcelHelpers.export(exports, "timeHours", function() {
    return 0, _hourJs.hours;
});
parcelHelpers.export(exports, "timeDay", function() {
    return 0, _dayJsDefault.default;
});
parcelHelpers.export(exports, "timeDays", function() {
    return 0, _dayJs.days;
});
parcelHelpers.export(exports, "timeWeek", function() {
    return 0, _weekJs.sunday;
});
parcelHelpers.export(exports, "timeWeeks", function() {
    return 0, _weekJs.sundays;
});
parcelHelpers.export(exports, "timeSunday", function() {
    return 0, _weekJs.sunday;
});
parcelHelpers.export(exports, "timeSundays", function() {
    return 0, _weekJs.sundays;
});
parcelHelpers.export(exports, "timeMonday", function() {
    return 0, _weekJs.monday;
});
parcelHelpers.export(exports, "timeMondays", function() {
    return 0, _weekJs.mondays;
});
parcelHelpers.export(exports, "timeTuesday", function() {
    return 0, _weekJs.tuesday;
});
parcelHelpers.export(exports, "timeTuesdays", function() {
    return 0, _weekJs.tuesdays;
});
parcelHelpers.export(exports, "timeWednesday", function() {
    return 0, _weekJs.wednesday;
});
parcelHelpers.export(exports, "timeWednesdays", function() {
    return 0, _weekJs.wednesdays;
});
parcelHelpers.export(exports, "timeThursday", function() {
    return 0, _weekJs.thursday;
});
parcelHelpers.export(exports, "timeThursdays", function() {
    return 0, _weekJs.thursdays;
});
parcelHelpers.export(exports, "timeFriday", function() {
    return 0, _weekJs.friday;
});
parcelHelpers.export(exports, "timeFridays", function() {
    return 0, _weekJs.fridays;
});
parcelHelpers.export(exports, "timeSaturday", function() {
    return 0, _weekJs.saturday;
});
parcelHelpers.export(exports, "timeSaturdays", function() {
    return 0, _weekJs.saturdays;
});
parcelHelpers.export(exports, "timeMonth", function() {
    return 0, _monthJsDefault.default;
});
parcelHelpers.export(exports, "timeMonths", function() {
    return 0, _monthJs.months;
});
parcelHelpers.export(exports, "timeYear", function() {
    return 0, _yearJsDefault.default;
});
parcelHelpers.export(exports, "timeYears", function() {
    return 0, _yearJs.years;
});
parcelHelpers.export(exports, "utcMinute", function() {
    return 0, _utcMinuteJsDefault.default;
});
parcelHelpers.export(exports, "utcMinutes", function() {
    return 0, _utcMinuteJs.utcMinutes;
});
parcelHelpers.export(exports, "utcHour", function() {
    return 0, _utcHourJsDefault.default;
});
parcelHelpers.export(exports, "utcHours", function() {
    return 0, _utcHourJs.utcHours;
});
parcelHelpers.export(exports, "utcDay", function() {
    return 0, _utcDayJsDefault.default;
});
parcelHelpers.export(exports, "utcDays", function() {
    return 0, _utcDayJs.utcDays;
});
parcelHelpers.export(exports, "utcWeek", function() {
    return 0, _utcWeekJs.utcSunday;
});
parcelHelpers.export(exports, "utcWeeks", function() {
    return 0, _utcWeekJs.utcSundays;
});
parcelHelpers.export(exports, "utcSunday", function() {
    return 0, _utcWeekJs.utcSunday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return 0, _utcWeekJs.utcSundays;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return 0, _utcWeekJs.utcMonday;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return 0, _utcWeekJs.utcMondays;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return 0, _utcWeekJs.utcTuesday;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return 0, _utcWeekJs.utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return 0, _utcWeekJs.utcWednesday;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return 0, _utcWeekJs.utcWednesdays;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return 0, _utcWeekJs.utcThursday;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return 0, _utcWeekJs.utcThursdays;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return 0, _utcWeekJs.utcFriday;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return 0, _utcWeekJs.utcFridays;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return 0, _utcWeekJs.utcSaturday;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return 0, _utcWeekJs.utcSaturdays;
});
parcelHelpers.export(exports, "utcMonth", function() {
    return 0, _utcMonthJsDefault.default;
});
parcelHelpers.export(exports, "utcMonths", function() {
    return 0, _utcMonthJs.utcMonths;
});
parcelHelpers.export(exports, "utcYear", function() {
    return 0, _utcYearJsDefault.default;
});
parcelHelpers.export(exports, "utcYears", function() {
    return 0, _utcYearJs.utcYears;
});
parcelHelpers.export(exports, "utcTicks", function() {
    return 0, _ticksJs.utcTicks;
});
parcelHelpers.export(exports, "utcTickInterval", function() {
    return 0, _ticksJs.utcTickInterval;
});
parcelHelpers.export(exports, "timeTicks", function() {
    return 0, _ticksJs.timeTicks;
});
parcelHelpers.export(exports, "timeTickInterval", function() {
    return 0, _ticksJs.timeTickInterval;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);
var _ticksJs = require("./ticks.js");

},{"./interval.js":false,"./millisecond.js":false,"./second.js":"3BvYp","./minute.js":"5aK8S","./hour.js":"9kBT8","./day.js":"9sj5P","./week.js":"8CyqM","./month.js":"lb2dq","./year.js":"cWoGZ","./utcMinute.js":"8FF8f","./utcHour.js":"2Usew","./utcDay.js":"486fe","./utcWeek.js":"il3fH","./utcMonth.js":"5TvSX","./utcYear.js":"Z9NnG","./ticks.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9K2mE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return newInterval;
});
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3BvYp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", function() {
    return seconds;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9iG60":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", function() {
    return durationSecond;
});
parcelHelpers.export(exports, "durationMinute", function() {
    return durationMinute;
});
parcelHelpers.export(exports, "durationHour", function() {
    return durationHour;
});
parcelHelpers.export(exports, "durationDay", function() {
    return durationDay;
});
parcelHelpers.export(exports, "durationWeek", function() {
    return durationWeek;
});
parcelHelpers.export(exports, "durationMonth", function() {
    return durationMonth;
});
parcelHelpers.export(exports, "durationYear", function() {
    return durationYear;
});
var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5aK8S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", function() {
    return minutes;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9kBT8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", function() {
    return hours;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9sj5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", function() {
    return days;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    return date.setHours(0, 0, 0, 0);
}, function(date, step) {
    return date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8CyqM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", function() {
    return sunday;
});
parcelHelpers.export(exports, "monday", function() {
    return monday;
});
parcelHelpers.export(exports, "tuesday", function() {
    return tuesday;
});
parcelHelpers.export(exports, "wednesday", function() {
    return wednesday;
});
parcelHelpers.export(exports, "thursday", function() {
    return thursday;
});
parcelHelpers.export(exports, "friday", function() {
    return friday;
});
parcelHelpers.export(exports, "saturday", function() {
    return saturday;
});
parcelHelpers.export(exports, "sundays", function() {
    return sundays;
});
parcelHelpers.export(exports, "mondays", function() {
    return mondays;
});
parcelHelpers.export(exports, "tuesdays", function() {
    return tuesdays;
});
parcelHelpers.export(exports, "wednesdays", function() {
    return wednesdays;
});
parcelHelpers.export(exports, "thursdays", function() {
    return thursdays;
});
parcelHelpers.export(exports, "fridays", function() {
    return fridays;
});
parcelHelpers.export(exports, "saturdays", function() {
    return saturdays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lb2dq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", function() {
    return months;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"9K2mE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cWoGZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", function() {
    return years;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"9K2mE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8FF8f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", function() {
    return utcMinutes;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2Usew":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", function() {
    return utcHours;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"486fe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", function() {
    return utcDays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"il3fH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", function() {
    return utcSunday;
});
parcelHelpers.export(exports, "utcMonday", function() {
    return utcMonday;
});
parcelHelpers.export(exports, "utcTuesday", function() {
    return utcTuesday;
});
parcelHelpers.export(exports, "utcWednesday", function() {
    return utcWednesday;
});
parcelHelpers.export(exports, "utcThursday", function() {
    return utcThursday;
});
parcelHelpers.export(exports, "utcFriday", function() {
    return utcFriday;
});
parcelHelpers.export(exports, "utcSaturday", function() {
    return utcSaturday;
});
parcelHelpers.export(exports, "utcSundays", function() {
    return utcSundays;
});
parcelHelpers.export(exports, "utcMondays", function() {
    return utcMondays;
});
parcelHelpers.export(exports, "utcTuesdays", function() {
    return utcTuesdays;
});
parcelHelpers.export(exports, "utcWednesdays", function() {
    return utcWednesdays;
});
parcelHelpers.export(exports, "utcThursdays", function() {
    return utcThursdays;
});
parcelHelpers.export(exports, "utcFridays", function() {
    return utcFridays;
});
parcelHelpers.export(exports, "utcSaturdays", function() {
    return utcSaturdays;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"9K2mE","./duration.js":"9iG60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5TvSX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", function() {
    return utcMonths;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"9K2mE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Z9NnG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", function() {
    return utcYears;
});
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"9K2mE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lHrxQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isUtcScale;
});
var TEST_TIME = new Date(Date.UTC(2020, 1, 2, 3, 4, 5));
var TEST_FORMAT = "%Y-%m-%d %H:%M";
function isUtcScale(scale) {
    // The only difference between time and utc scale is
    // whether the tick format function is utcFormat or timeFormat
    var output = scale.tickFormat(1, TEST_FORMAT)(TEST_TIME);
    return output === "2020-02-02 03:04";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dWmU3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyPadding;
});
function applyPadding(scale, config) {
    if ("padding" in scale && "padding" in config && typeof config.padding !== "undefined") scale.padding(config.padding);
    if ("paddingInner" in scale && "paddingInner" in config && typeof config.paddingInner !== "undefined") scale.paddingInner(config.paddingInner);
    if ("paddingOuter" in scale && "paddingOuter" in config && typeof config.paddingOuter !== "undefined") scale.paddingOuter(config.paddingOuter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g1NqU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyReverse;
});
function applyReverse(scale, config) {
    if (config.reverse) {
        var reversedRange = scale.range().slice().reverse();
        if ("padding" in scale) // point and band scales
        scale.range(reversedRange);
        else // the rest
        scale.range(reversedRange);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hqnJz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyRound;
});
var _d3Interpolate = require("d3-interpolate");
function applyRound(scale, config) {
    if ("round" in config && typeof config.round !== "undefined") {
        if (config.round && "interpolate" in config && typeof config.interpolate !== "undefined") console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", config);
        else if ("round" in scale) // for point and band scales
        scale.round(config.round);
        else if ("interpolate" in scale && config.round) // for continuous output scales
        // setting config.round = true
        // is actually setting interpolator to interpolateRound
        // as these scales do not have scale.round() function
        scale.interpolate((0, _d3Interpolate.interpolateRound));
    }
}

},{"d3-interpolate":"bxVRm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7VovM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyUnknown;
});
function applyUnknown(scale, config) {
    if ("unknown" in scale && "unknown" in config && typeof config.unknown !== "undefined") scale.unknown(config.unknown);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1D4F7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return applyZero;
});
function applyZero(scale, config) {
    if ("zero" in config && config.zero === true) {
        var domain = scale.domain();
        var a = domain[0], b = domain[1];
        var isDescending = b < a;
        var _ref = isDescending ? [
            b,
            a
        ] : [
            a,
            b
        ], min = _ref[0], max = _ref[1];
        var domainWithZero = [
            Math.min(0, min),
            Math.max(0, max)
        ];
        scale.domain(isDescending ? domainWithZero.reverse() : domainWithZero);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"an1iA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateLinearScale", function() {
    return updateLinearScale;
});
parcelHelpers.export(exports, "default", function() {
    return createLinearScale;
});
var _d3Scale = require("d3-scale");
var _scaleOperator = require("../operators/scaleOperator");
var _scaleOperatorDefault = parcelHelpers.interopDefault(_scaleOperator);
var updateLinearScale = (0, _scaleOperatorDefault.default)("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function createLinearScale(config) {
    return updateLinearScale((0, _d3Scale.scaleLinear)(), config);
}

},{"d3-scale":"2Acrc","../operators/scaleOperator":"7bhE0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6pDgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateTimeScale", function() {
    return updateTimeScale;
});
parcelHelpers.export(exports, "default", function() {
    return createTimeScale;
});
var _d3Scale = require("d3-scale");
var _scaleOperator = require("../operators/scaleOperator");
var _scaleOperatorDefault = parcelHelpers.interopDefault(_scaleOperator);
var updateTimeScale = (0, _scaleOperatorDefault.default)("domain", "range", "reverse", "clamp", "interpolate", "nice", "round");
function createTimeScale(config) {
    return updateTimeScale((0, _d3Scale.scaleTime)(), config);
}

},{"d3-scale":"2Acrc","../operators/scaleOperator":"7bhE0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7fJy5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateOrdinalScale", function() {
    return updateOrdinalScale;
});
parcelHelpers.export(exports, "default", function() {
    return createOrdinalScale;
});
var _d3Scale = require("d3-scale");
var _scaleOperator = require("../operators/scaleOperator");
var _scaleOperatorDefault = parcelHelpers.interopDefault(_scaleOperator);
var updateOrdinalScale = (0, _scaleOperatorDefault.default)("domain", "range", "reverse", "unknown");
function createOrdinalScale(config) {
    return updateOrdinalScale((0, _d3Scale.scaleOrdinal)(), config);
}

},{"d3-scale":"2Acrc","../operators/scaleOperator":"7bhE0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cM7S2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return coerceNumber;
});
function coerceNumber(val) {
    if ((typeof val === "function" || typeof val === "object" && !!val) && "valueOf" in val) {
        var num = val.valueOf();
        if (typeof num === "number") return num;
    }
    return val;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4Occ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTicks;
});
function getTicks(scale, numTicks) {
    // Because `Scale` is generic type which maybe a subset of AnyD3Scale
    // that may not have `ticks` field,
    // TypeScript will not let us do the `'ticks' in scale` check directly.
    // Have to manually cast and expand type first.
    var s = scale;
    if ("ticks" in s) return s.ticks(numTicks);
    return s.domain().filter(function(_, index, arr) {
        return numTicks == null || arr.length <= numTicks || index % Math.round((arr.length - 1) / numTicks) === 0;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f20DD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toString;
});
function toString(x) {
    return x == null ? void 0 : x.toString();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5R3V0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AxisRenderer;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _shape = require("@visx/shape");
var _text = require("@visx/text");
var _getLabelTransform = require("../utils/getLabelTransform");
var _getLabelTransformDefault = parcelHelpers.interopDefault(_getLabelTransform);
var _ticks = require("./Ticks");
var _ticksDefault = parcelHelpers.interopDefault(_ticks);
var _ = require("..");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var defaultTextProps = {
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 10,
    fill: "#222"
};
function AxisRenderer(_ref) {
    var axisFromPoint = _ref.axisFromPoint, axisLineClassName = _ref.axisLineClassName, axisToPoint = _ref.axisToPoint, hideAxisLine = _ref.hideAxisLine, hideTicks = _ref.hideTicks, horizontal = _ref.horizontal, _ref$label = _ref.label, label = _ref$label === void 0 ? "" : _ref$label, labelClassName = _ref.labelClassName, _ref$labelOffset = _ref.labelOffset, labelOffset = _ref$labelOffset === void 0 ? 14 : _ref$labelOffset, _ref$labelProps = _ref.labelProps, labelProps = _ref$labelProps === void 0 ? defaultTextProps : _ref$labelProps, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? (0, _.Orientation).bottom : _ref$orientation, scale = _ref.scale, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#222" : _ref$stroke, strokeDasharray = _ref.strokeDasharray, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, tickClassName = _ref.tickClassName, tickComponent = _ref.tickComponent, tickLineProps = _ref.tickLineProps, _ref$tickLabelProps = _ref.tickLabelProps, tickLabelProps = _ref$tickLabelProps === void 0 ? function tickLabelProps() {
        return defaultTextProps;
    } : _ref$tickLabelProps, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, _ref$tickStroke = _ref.tickStroke, tickStroke = _ref$tickStroke === void 0 ? "#222" : _ref$tickStroke, tickTransform = _ref.tickTransform, ticks = _ref.ticks, _ref$ticksComponent = _ref.ticksComponent, ticksComponent = _ref$ticksComponent === void 0 ? (0, _ticksDefault.default) : _ref$ticksComponent;
    // compute the max tick label size to compute label offset
    var allTickLabelProps = ticks.map(function(_ref2) {
        var value = _ref2.value, index = _ref2.index;
        return tickLabelProps(value, index, ticks);
    });
    var maxTickLabelFontSize = Math.max.apply(Math, [
        10
    ].concat(allTickLabelProps.map(function(props) {
        return typeof props.fontSize === "number" ? props.fontSize : 0;
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, ticksComponent({
        hideTicks: hideTicks,
        horizontal: horizontal,
        orientation: orientation,
        scale: scale,
        tickClassName: tickClassName,
        tickComponent: tickComponent,
        tickLabelProps: allTickLabelProps,
        tickStroke: tickStroke,
        tickTransform: tickTransform,
        ticks: ticks,
        strokeWidth: strokeWidth,
        tickLineProps: tickLineProps
    }), !hideAxisLine && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _shape.Line), {
        className: (0, _classnamesDefault.default)("visx-axis-line", axisLineClassName),
        from: axisFromPoint,
        to: axisToPoint,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeDasharray: strokeDasharray
    }), label && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        className: (0, _classnamesDefault.default)("visx-axis-label", labelClassName)
    }, (0, _getLabelTransformDefault.default)({
        labelOffset: labelOffset,
        labelProps: labelProps,
        orientation: orientation,
        range: scale.range(),
        tickLabelFontSize: maxTickLabelFontSize,
        tickLength: tickLength
    }), labelProps), label));
}

},{"react":"ktQNc","classnames":"aMKnv","@visx/shape":"5XPpo","@visx/text":"jlEhs","../utils/getLabelTransform":"efXXs","./Ticks":"ZFbTf","..":"gF8iV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5XPpo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Arc", function() {
    return 0, _arcDefault.default;
});
parcelHelpers.export(exports, "Pie", function() {
    return 0, _pieDefault.default;
});
parcelHelpers.export(exports, "Line", function() {
    return 0, _lineDefault.default;
});
parcelHelpers.export(exports, "LinePath", function() {
    return 0, _linePathDefault.default;
});
parcelHelpers.export(exports, "LineRadial", function() {
    return 0, _lineRadialDefault.default;
});
parcelHelpers.export(exports, "Area", function() {
    return 0, _areaDefault.default;
});
parcelHelpers.export(exports, "AreaClosed", function() {
    return 0, _areaClosedDefault.default;
});
parcelHelpers.export(exports, "AreaStack", function() {
    return 0, _areaStackDefault.default;
});
parcelHelpers.export(exports, "Bar", function() {
    return 0, _barDefault.default;
});
parcelHelpers.export(exports, "BarRounded", function() {
    return 0, _barRoundedDefault.default;
});
parcelHelpers.export(exports, "BarGroup", function() {
    return 0, _barGroupDefault.default;
});
parcelHelpers.export(exports, "BarGroupHorizontal", function() {
    return 0, _barGroupHorizontalDefault.default;
});
parcelHelpers.export(exports, "BarStack", function() {
    return 0, _barStackDefault.default;
});
parcelHelpers.export(exports, "BarStackHorizontal", function() {
    return 0, _barStackHorizontalDefault.default;
});
parcelHelpers.export(exports, "Stack", function() {
    return 0, _stackDefault.default;
});
parcelHelpers.export(exports, "stackOffset", function() {
    return 0, _stackOffsetDefault.default;
});
parcelHelpers.export(exports, "STACK_OFFSETS", function() {
    return 0, _stackOffset.STACK_OFFSETS;
});
parcelHelpers.export(exports, "STACK_OFFSET_NAMES", function() {
    return 0, _stackOffset.STACK_OFFSET_NAMES;
});
parcelHelpers.export(exports, "stackOrder", function() {
    return 0, _stackOrderDefault.default;
});
parcelHelpers.export(exports, "STACK_ORDERS", function() {
    return 0, _stackOrder.STACK_ORDERS;
});
parcelHelpers.export(exports, "STACK_ORDER_NAMES", function() {
    return 0, _stackOrder.STACK_ORDER_NAMES;
});
parcelHelpers.export(exports, "degreesToRadians", function() {
    return 0, _trigonometry.degreesToRadians;
});
parcelHelpers.export(exports, "LinkHorizontal", function() {
    return 0, _linkHorizontalDefault.default;
});
parcelHelpers.export(exports, "pathHorizontalDiagonal", function() {
    return 0, _linkHorizontal.pathHorizontalDiagonal;
});
parcelHelpers.export(exports, "LinkVertical", function() {
    return 0, _linkVerticalDefault.default;
});
parcelHelpers.export(exports, "pathVerticalDiagonal", function() {
    return 0, _linkVertical.pathVerticalDiagonal;
});
parcelHelpers.export(exports, "LinkRadial", function() {
    return 0, _linkRadialDefault.default;
});
parcelHelpers.export(exports, "pathRadialDiagonal", function() {
    return 0, _linkRadial.pathRadialDiagonal;
});
parcelHelpers.export(exports, "LinkHorizontalCurve", function() {
    return 0, _linkHorizontalCurveDefault.default;
});
parcelHelpers.export(exports, "pathHorizontalCurve", function() {
    return 0, _linkHorizontalCurve.pathHorizontalCurve;
});
parcelHelpers.export(exports, "LinkVerticalCurve", function() {
    return 0, _linkVerticalCurveDefault.default;
});
parcelHelpers.export(exports, "pathVerticalCurve", function() {
    return 0, _linkVerticalCurve.pathVerticalCurve;
});
parcelHelpers.export(exports, "LinkRadialCurve", function() {
    return 0, _linkRadialCurveDefault.default;
});
parcelHelpers.export(exports, "pathRadialCurve", function() {
    return 0, _linkRadialCurve.pathRadialCurve;
});
parcelHelpers.export(exports, "LinkHorizontalLine", function() {
    return 0, _linkHorizontalLineDefault.default;
});
parcelHelpers.export(exports, "pathHorizontalLine", function() {
    return 0, _linkHorizontalLine.pathHorizontalLine;
});
parcelHelpers.export(exports, "LinkVerticalLine", function() {
    return 0, _linkVerticalLineDefault.default;
});
parcelHelpers.export(exports, "pathVerticalLine", function() {
    return 0, _linkVerticalLine.pathVerticalLine;
});
parcelHelpers.export(exports, "LinkRadialLine", function() {
    return 0, _linkRadialLineDefault.default;
});
parcelHelpers.export(exports, "pathRadialLine", function() {
    return 0, _linkRadialLine.pathRadialLine;
});
parcelHelpers.export(exports, "LinkHorizontalStep", function() {
    return 0, _linkHorizontalStepDefault.default;
});
parcelHelpers.export(exports, "pathHorizontalStep", function() {
    return 0, _linkHorizontalStep.pathHorizontalStep;
});
parcelHelpers.export(exports, "LinkVerticalStep", function() {
    return 0, _linkVerticalStepDefault.default;
});
parcelHelpers.export(exports, "pathVerticalStep", function() {
    return 0, _linkVerticalStep.pathVerticalStep;
});
parcelHelpers.export(exports, "LinkRadialStep", function() {
    return 0, _linkRadialStepDefault.default;
});
parcelHelpers.export(exports, "pathRadialStep", function() {
    return 0, _linkRadialStep.pathRadialStep;
});
parcelHelpers.export(exports, "Polygon", function() {
    return 0, _polygonDefault.default;
});
parcelHelpers.export(exports, "getPoints", function() {
    return 0, _polygon.getPoints;
});
parcelHelpers.export(exports, "getPoint", function() {
    return 0, _polygon.getPoint;
});
parcelHelpers.export(exports, "Circle", function() {
    return 0, _circleDefault.default;
});
parcelHelpers.export(exports, "SplitLinePath", function() {
    return 0, _splitLinePathDefault.default;
});
var _arc = require("./shapes/Arc");
var _arcDefault = parcelHelpers.interopDefault(_arc);
var _pie = require("./shapes/Pie");
var _pieDefault = parcelHelpers.interopDefault(_pie);
var _line = require("./shapes/Line");
var _lineDefault = parcelHelpers.interopDefault(_line);
var _linePath = require("./shapes/LinePath");
var _linePathDefault = parcelHelpers.interopDefault(_linePath);
var _lineRadial = require("./shapes/LineRadial");
var _lineRadialDefault = parcelHelpers.interopDefault(_lineRadial);
var _area = require("./shapes/Area");
var _areaDefault = parcelHelpers.interopDefault(_area);
var _areaClosed = require("./shapes/AreaClosed");
var _areaClosedDefault = parcelHelpers.interopDefault(_areaClosed);
var _areaStack = require("./shapes/AreaStack");
var _areaStackDefault = parcelHelpers.interopDefault(_areaStack);
var _bar = require("./shapes/Bar");
var _barDefault = parcelHelpers.interopDefault(_bar);
var _barRounded = require("./shapes/BarRounded");
var _barRoundedDefault = parcelHelpers.interopDefault(_barRounded);
var _barGroup = require("./shapes/BarGroup");
var _barGroupDefault = parcelHelpers.interopDefault(_barGroup);
var _barGroupHorizontal = require("./shapes/BarGroupHorizontal");
var _barGroupHorizontalDefault = parcelHelpers.interopDefault(_barGroupHorizontal);
var _barStack = require("./shapes/BarStack");
var _barStackDefault = parcelHelpers.interopDefault(_barStack);
var _barStackHorizontal = require("./shapes/BarStackHorizontal");
var _barStackHorizontalDefault = parcelHelpers.interopDefault(_barStackHorizontal);
var _stack = require("./shapes/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stackOffset = require("./util/stackOffset");
var _stackOffsetDefault = parcelHelpers.interopDefault(_stackOffset);
var _stackOrder = require("./util/stackOrder");
var _stackOrderDefault = parcelHelpers.interopDefault(_stackOrder);
var _trigonometry = require("./util/trigonometry");
var _linkHorizontal = require("./shapes/link/diagonal/LinkHorizontal");
var _linkHorizontalDefault = parcelHelpers.interopDefault(_linkHorizontal);
var _linkVertical = require("./shapes/link/diagonal/LinkVertical");
var _linkVerticalDefault = parcelHelpers.interopDefault(_linkVertical);
var _linkRadial = require("./shapes/link/diagonal/LinkRadial");
var _linkRadialDefault = parcelHelpers.interopDefault(_linkRadial);
var _linkHorizontalCurve = require("./shapes/link/curve/LinkHorizontalCurve");
var _linkHorizontalCurveDefault = parcelHelpers.interopDefault(_linkHorizontalCurve);
var _linkVerticalCurve = require("./shapes/link/curve/LinkVerticalCurve");
var _linkVerticalCurveDefault = parcelHelpers.interopDefault(_linkVerticalCurve);
var _linkRadialCurve = require("./shapes/link/curve/LinkRadialCurve");
var _linkRadialCurveDefault = parcelHelpers.interopDefault(_linkRadialCurve);
var _linkHorizontalLine = require("./shapes/link/line/LinkHorizontalLine");
var _linkHorizontalLineDefault = parcelHelpers.interopDefault(_linkHorizontalLine);
var _linkVerticalLine = require("./shapes/link/line/LinkVerticalLine");
var _linkVerticalLineDefault = parcelHelpers.interopDefault(_linkVerticalLine);
var _linkRadialLine = require("./shapes/link/line/LinkRadialLine");
var _linkRadialLineDefault = parcelHelpers.interopDefault(_linkRadialLine);
var _linkHorizontalStep = require("./shapes/link/step/LinkHorizontalStep");
var _linkHorizontalStepDefault = parcelHelpers.interopDefault(_linkHorizontalStep);
var _linkVerticalStep = require("./shapes/link/step/LinkVerticalStep");
var _linkVerticalStepDefault = parcelHelpers.interopDefault(_linkVerticalStep);
var _linkRadialStep = require("./shapes/link/step/LinkRadialStep");
var _linkRadialStepDefault = parcelHelpers.interopDefault(_linkRadialStep);
var _polygon = require("./shapes/Polygon");
var _polygonDefault = parcelHelpers.interopDefault(_polygon);
var _circle = require("./shapes/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _splitLinePath = require("./shapes/SplitLinePath");
var _splitLinePathDefault = parcelHelpers.interopDefault(_splitLinePath);
// Export factory functions
var _d3ShapeConfig = require("./types/D3ShapeConfig");
parcelHelpers.exportAll(_d3ShapeConfig, exports);
var _d3ShapeFactories = require("./util/D3ShapeFactories");
parcelHelpers.exportAll(_d3ShapeFactories, exports);

},{"./shapes/Arc":false,"./shapes/Pie":false,"./shapes/Line":"sWfDf","./shapes/LinePath":false,"./shapes/LineRadial":false,"./shapes/Area":false,"./shapes/AreaClosed":"fiqra","./shapes/AreaStack":"5ahJR","./shapes/Bar":"YBQFP","./shapes/BarRounded":false,"./shapes/BarGroup":false,"./shapes/BarGroupHorizontal":false,"./shapes/BarStack":"bQMmB","./shapes/BarStackHorizontal":false,"./shapes/Stack":false,"./util/stackOffset":false,"./util/stackOrder":false,"./util/trigonometry":false,"./shapes/link/diagonal/LinkHorizontal":false,"./shapes/link/diagonal/LinkVertical":false,"./shapes/link/diagonal/LinkRadial":false,"./shapes/link/curve/LinkHorizontalCurve":false,"./shapes/link/curve/LinkVerticalCurve":false,"./shapes/link/curve/LinkRadialCurve":false,"./shapes/link/line/LinkHorizontalLine":false,"./shapes/link/line/LinkVerticalLine":false,"./shapes/link/line/LinkRadialLine":false,"./shapes/link/step/LinkHorizontalStep":false,"./shapes/link/step/LinkVerticalStep":false,"./shapes/link/step/LinkRadialStep":false,"./shapes/Polygon":false,"./shapes/Circle":false,"./shapes/SplitLinePath":false,"./types/D3ShapeConfig":false,"./util/D3ShapeFactories":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"sWfDf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Line;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _excluded = [
    "from",
    "to",
    "fill",
    "className",
    "innerRef"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Line(_ref) {
    var _ref$from = _ref.from, from = _ref$from === void 0 ? {
        x: 0,
        y: 0
    } : _ref$from, _ref$to = _ref.to, to = _ref$to === void 0 ? {
        x: 1,
        y: 1
    } : _ref$to, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var isRectilinear = from.x === to.x || from.y === to.y;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("line", _extends({
        ref: innerRef,
        className: (0, _classnamesDefault.default)("visx-line", className),
        x1: from.x,
        y1: from.y,
        x2: to.x,
        y2: to.y,
        fill: fill,
        shapeRendering: isRectilinear ? "crispEdges" : "auto"
    }, restProps));
}

},{"react":"ktQNc","classnames":"aMKnv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fiqra":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AreaClosed;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _setNumberOrNumberAccessor = require("../util/setNumberOrNumberAccessor");
var _setNumberOrNumberAccessorDefault = parcelHelpers.interopDefault(_setNumberOrNumberAccessor);
var _d3ShapeFactories = require("../util/D3ShapeFactories");
var _excluded = [
    "x",
    "x0",
    "x1",
    "y",
    "y1",
    "y0",
    "yScale",
    "data",
    "defined",
    "className",
    "curve",
    "innerRef",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AreaClosed(_ref) {
    var x = _ref.x, x0 = _ref.x0, x1 = _ref.x1, y = _ref.y, y1 = _ref.y1, y0 = _ref.y0, yScale = _ref.yScale, _ref$data = _ref.data, data = _ref$data === void 0 ? [] : _ref$data, _ref$defined = _ref.defined, defined = _ref$defined === void 0 ? function defined() {
        return true;
    } : _ref$defined, className = _ref.className, curve = _ref.curve, innerRef = _ref.innerRef, children = _ref.children, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var path = (0, _d3ShapeFactories.area)({
        x: x,
        x0: x0,
        x1: x1,
        defined: defined,
        curve: curve
    });
    if (y0 == null) /**
     * by default set the baseline to the first element of the yRange
     * @TODO take the minimum instead?
     */ path.y0(yScale.range()[0]);
    else (0, _setNumberOrNumberAccessorDefault.default)(path.y0, y0);
    if (y && !y1) (0, _setNumberOrNumberAccessorDefault.default)(path.y1, y);
    if (y1 && !y) (0, _setNumberOrNumberAccessorDefault.default)(path.y1, y1);
    if (children) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children({
        path: path
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        ref: innerRef,
        className: (0, _classnamesDefault.default)("visx-area-closed", className),
        d: path(data) || ""
    }, restProps));
}

},{"react":"ktQNc","classnames":"aMKnv","../util/setNumberOrNumberAccessor":"9jPYj","../util/D3ShapeFactories":"aoEMw","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9jPYj":[function(require,module,exports) {
/**
 * This is a workaround for TypeScript not inferring the correct
 * method overload/signature for some d3 shape methods.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setNumberOrNumberAccessor;
});
function setNumberOrNumberAccessor(func, value) {
    if (typeof value === "number") func(value);
    else func(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aoEMw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", function() {
    return arc;
});
parcelHelpers.export(exports, "area", function() {
    return area;
});
parcelHelpers.export(exports, "line", function() {
    return line;
});
parcelHelpers.export(exports, "pie", function() {
    return pie;
});
parcelHelpers.export(exports, "radialLine", function() {
    return radialLine;
});
parcelHelpers.export(exports, "stack", function() {
    return stack;
});
var _d3Shape = require("d3-shape");
var _setNumberOrNumberAccessor = require("./setNumberOrNumberAccessor");
var _setNumberOrNumberAccessorDefault = parcelHelpers.interopDefault(_setNumberOrNumberAccessor);
var _stackOrder = require("./stackOrder");
var _stackOrderDefault = parcelHelpers.interopDefault(_stackOrder);
var _stackOffset = require("./stackOffset");
var _stackOffsetDefault = parcelHelpers.interopDefault(_stackOffset);
function arc(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, cornerRadius = _ref.cornerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, padAngle = _ref.padAngle, padRadius = _ref.padRadius;
    var path = (0, _d3Shape.arc)();
    if (innerRadius != null) (0, _setNumberOrNumberAccessorDefault.default)(path.innerRadius, innerRadius);
    if (outerRadius != null) (0, _setNumberOrNumberAccessorDefault.default)(path.outerRadius, outerRadius);
    if (cornerRadius != null) (0, _setNumberOrNumberAccessorDefault.default)(path.cornerRadius, cornerRadius);
    if (startAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.startAngle, startAngle);
    if (endAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.endAngle, endAngle);
    if (padAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.padAngle, padAngle);
    if (padRadius != null) (0, _setNumberOrNumberAccessorDefault.default)(path.padRadius, padRadius);
    return path;
}
function area(_temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, x = _ref2.x, x0 = _ref2.x0, x1 = _ref2.x1, y = _ref2.y, y0 = _ref2.y0, y1 = _ref2.y1, defined = _ref2.defined, curve = _ref2.curve;
    var path = (0, _d3Shape.area)();
    if (x) (0, _setNumberOrNumberAccessorDefault.default)(path.x, x);
    if (x0) (0, _setNumberOrNumberAccessorDefault.default)(path.x0, x0);
    if (x1) (0, _setNumberOrNumberAccessorDefault.default)(path.x1, x1);
    if (y) (0, _setNumberOrNumberAccessorDefault.default)(path.y, y);
    if (y0) (0, _setNumberOrNumberAccessorDefault.default)(path.y0, y0);
    if (y1) (0, _setNumberOrNumberAccessorDefault.default)(path.y1, y1);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function line(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, x = _ref3.x, y = _ref3.y, defined = _ref3.defined, curve = _ref3.curve;
    var path = (0, _d3Shape.line)();
    if (x) (0, _setNumberOrNumberAccessorDefault.default)(path.x, x);
    if (y) (0, _setNumberOrNumberAccessorDefault.default)(path.y, y);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function pie(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, startAngle = _ref4.startAngle, endAngle = _ref4.endAngle, padAngle = _ref4.padAngle, value = _ref4.value, sort = _ref4.sort, sortValues = _ref4.sortValues;
    var path = (0, _d3Shape.pie)();
    // ts can't distinguish between these method overloads
    if (sort === null) path.sort(sort);
    else if (sort != null) path.sort(sort);
    if (sortValues === null) path.sortValues(sortValues);
    else if (sortValues != null) path.sortValues(sortValues);
    if (value != null) path.value(value);
    if (padAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.padAngle, padAngle);
    if (startAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.startAngle, startAngle);
    if (endAngle != null) (0, _setNumberOrNumberAccessorDefault.default)(path.endAngle, endAngle);
    return path;
}
function radialLine(_temp5) {
    var _ref5 = _temp5 === void 0 ? {} : _temp5, angle = _ref5.angle, radius = _ref5.radius, defined = _ref5.defined, curve = _ref5.curve;
    var path = (0, _d3Shape.radialLine)();
    if (angle) (0, _setNumberOrNumberAccessorDefault.default)(path.angle, angle);
    if (radius) (0, _setNumberOrNumberAccessorDefault.default)(path.radius, radius);
    if (defined) path.defined(defined);
    if (curve) path.curve(curve);
    return path;
}
function stack(_ref6) {
    var keys = _ref6.keys, value = _ref6.value, order = _ref6.order, offset = _ref6.offset;
    var path = (0, _d3Shape.stack)();
    if (keys) path.keys(keys);
    if (value) (0, _setNumberOrNumberAccessorDefault.default)(path.value, value);
    if (order) path.order((0, _stackOrderDefault.default)(order));
    if (offset) path.offset((0, _stackOffsetDefault.default)(offset));
    return path;
}

},{"d3-shape":"3M387","./setNumberOrNumberAccessor":"9jPYj","./stackOrder":"hdJBJ","./stackOffset":"gOe4y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3M387":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", function() {
    return 0, _arcJsDefault.default;
});
parcelHelpers.export(exports, "area", function() {
    return 0, _areaJsDefault.default;
});
parcelHelpers.export(exports, "line", function() {
    return 0, _lineJsDefault.default;
});
parcelHelpers.export(exports, "pie", function() {
    return 0, _pieJsDefault.default;
});
parcelHelpers.export(exports, "areaRadial", function() {
    return 0, _areaRadialJsDefault.default;
}) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", function() {
    return 0, _areaRadialJsDefault.default;
});
parcelHelpers.export(exports, "lineRadial", function() {
    return 0, _lineRadialJsDefault.default;
}) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", function() {
    return 0, _lineRadialJsDefault.default;
});
parcelHelpers.export(exports, "pointRadial", function() {
    return 0, _pointRadialJsDefault.default;
});
parcelHelpers.export(exports, "linkHorizontal", function() {
    return 0, _indexJs.linkHorizontal;
});
parcelHelpers.export(exports, "linkVertical", function() {
    return 0, _indexJs.linkVertical;
});
parcelHelpers.export(exports, "linkRadial", function() {
    return 0, _indexJs.linkRadial;
});
parcelHelpers.export(exports, "symbol", function() {
    return 0, _symbolJsDefault.default;
});
parcelHelpers.export(exports, "symbols", function() {
    return 0, _symbolJs.symbols;
});
parcelHelpers.export(exports, "symbolCircle", function() {
    return 0, _circleJsDefault.default;
});
parcelHelpers.export(exports, "symbolCross", function() {
    return 0, _crossJsDefault.default;
});
parcelHelpers.export(exports, "symbolDiamond", function() {
    return 0, _diamondJsDefault.default;
});
parcelHelpers.export(exports, "symbolSquare", function() {
    return 0, _squareJsDefault.default;
});
parcelHelpers.export(exports, "symbolStar", function() {
    return 0, _starJsDefault.default;
});
parcelHelpers.export(exports, "symbolTriangle", function() {
    return 0, _triangleJsDefault.default;
});
parcelHelpers.export(exports, "symbolWye", function() {
    return 0, _wyeJsDefault.default;
});
parcelHelpers.export(exports, "curveBasisClosed", function() {
    return 0, _basisClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveBasisOpen", function() {
    return 0, _basisOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveBasis", function() {
    return 0, _basisJsDefault.default;
});
parcelHelpers.export(exports, "curveBundle", function() {
    return 0, _bundleJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinalClosed", function() {
    return 0, _cardinalClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinalOpen", function() {
    return 0, _cardinalOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveCardinal", function() {
    return 0, _cardinalJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRomClosed", function() {
    return 0, _catmullRomClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRomOpen", function() {
    return 0, _catmullRomOpenJsDefault.default;
});
parcelHelpers.export(exports, "curveCatmullRom", function() {
    return 0, _catmullRomJsDefault.default;
});
parcelHelpers.export(exports, "curveLinearClosed", function() {
    return 0, _linearClosedJsDefault.default;
});
parcelHelpers.export(exports, "curveLinear", function() {
    return 0, _linearJsDefault.default;
});
parcelHelpers.export(exports, "curveMonotoneX", function() {
    return 0, _monotoneJs.monotoneX;
});
parcelHelpers.export(exports, "curveMonotoneY", function() {
    return 0, _monotoneJs.monotoneY;
});
parcelHelpers.export(exports, "curveNatural", function() {
    return 0, _naturalJsDefault.default;
});
parcelHelpers.export(exports, "curveStep", function() {
    return 0, _stepJsDefault.default;
});
parcelHelpers.export(exports, "curveStepAfter", function() {
    return 0, _stepJs.stepAfter;
});
parcelHelpers.export(exports, "curveStepBefore", function() {
    return 0, _stepJs.stepBefore;
});
parcelHelpers.export(exports, "stack", function() {
    return 0, _stackJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetExpand", function() {
    return 0, _expandJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetDiverging", function() {
    return 0, _divergingJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetNone", function() {
    return 0, _noneJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetSilhouette", function() {
    return 0, _silhouetteJsDefault.default;
});
parcelHelpers.export(exports, "stackOffsetWiggle", function() {
    return 0, _wiggleJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderAppearance", function() {
    return 0, _appearanceJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderAscending", function() {
    return 0, _ascendingJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderDescending", function() {
    return 0, _descendingJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderInsideOut", function() {
    return 0, _insideOutJsDefault.default;
});
parcelHelpers.export(exports, "stackOrderNone", function() {
    return 0, _noneJsDefault1.default;
});
parcelHelpers.export(exports, "stackOrderReverse", function() {
    return 0, _reverseJsDefault.default;
});
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _indexJs = require("./link/index.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"lvnMf","./area.js":"9qh2E","./line.js":"iUlu0","./pie.js":"fc7lX","./areaRadial.js":false,"./lineRadial.js":"khbsc","./pointRadial.js":false,"./link/index.js":false,"./symbol.js":false,"./symbol/circle.js":false,"./symbol/cross.js":false,"./symbol/diamond.js":false,"./symbol/square.js":false,"./symbol/star.js":false,"./symbol/triangle.js":false,"./symbol/wye.js":false,"./curve/basisClosed.js":false,"./curve/basisOpen.js":false,"./curve/basis.js":false,"./curve/bundle.js":false,"./curve/cardinalClosed.js":false,"./curve/cardinalOpen.js":false,"./curve/cardinal.js":false,"./curve/catmullRomClosed.js":false,"./curve/catmullRomOpen.js":false,"./curve/catmullRom.js":false,"./curve/linearClosed.js":false,"./curve/linear.js":"kggAb","./curve/monotone.js":false,"./curve/natural.js":false,"./curve/step.js":false,"./stack.js":"inAEm","./offset/expand.js":"9k1tx","./offset/diverging.js":"9cghR","./offset/none.js":"fTv5T","./offset/silhouette.js":"cb8EY","./offset/wiggle.js":"geAhJ","./order/appearance.js":false,"./order/ascending.js":"go14w","./order/descending.js":"bNrLC","./order/insideOut.js":"1U7lN","./order/none.js":"hMwgJ","./order/reverse.js":"7cvNU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lvnMf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = (0, _d3Path.path)();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < (0, _mathJs.pi) && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"d3-path":"jqdBi","./constant.js":"7PxnE","./math.js":"iGhCM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jqdBi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", function() {
    return 0, _pathJsDefault.default;
});
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);

},{"./path.js":"9aYYt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9aYYt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function moveTo(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function lineTo(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function quadraticCurveTo(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function rect(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function toString() {
        return this._;
    }
};
exports.default = path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7PxnE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(x) {
        return function constant() {
            return x;
        };
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iGhCM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", function() {
    return abs;
});
parcelHelpers.export(exports, "atan2", function() {
    return atan2;
});
parcelHelpers.export(exports, "cos", function() {
    return cos;
});
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "sin", function() {
    return sin;
});
parcelHelpers.export(exports, "sqrt", function() {
    return sqrt;
});
parcelHelpers.export(exports, "epsilon", function() {
    return epsilon;
});
parcelHelpers.export(exports, "pi", function() {
    return pi;
});
parcelHelpers.export(exports, "halfPi", function() {
    return halfPi;
});
parcelHelpers.export(exports, "tau", function() {
    return tau;
});
parcelHelpers.export(exports, "acos", function() {
    return acos;
});
parcelHelpers.export(exports, "asin", function() {
    return asin;
});
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9qh2E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var x0 = (0, _pointJs.x), x1 = null, y0 = (0, _constantJsDefault.default)(0), y1 = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function area(data) {
            var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pointJs = require("./point.js");

},{"d3-path":"jqdBi","./constant.js":"7PxnE","./curve/linear.js":"kggAb","./line.js":"iUlu0","./point.js":"6dnh7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kggAb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(context) {
        return new Linear(context);
    };
});
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function areaStart() {
        this._line = 0;
    },
    areaEnd: function areaEnd() {
        this._line = NaN;
    },
    lineStart: function lineStart() {
        this._point = 0;
    },
    lineEnd: function lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iUlu0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var x = (0, _pointJs.x), y = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function line(data) {
            var i, n = data.length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    };
});
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pointJs = require("./point.js");

},{"d3-path":"jqdBi","./constant.js":"7PxnE","./curve/linear.js":"kggAb","./point.js":"6dnh7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6dnh7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", function() {
    return x;
});
parcelHelpers.export(exports, "y", function() {
    return y;
});
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fc7lX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    };
});
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./constant.js":"7PxnE","./descending.js":"bZhBU","./identity.js":"9Hs45","./math.js":"iGhCM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bZhBU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9Hs45":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(d) {
        return d;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"khbsc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", function() {
    return lineRadial;
});
parcelHelpers.export(exports, "default", function() {
    return function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    };
});
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"9aihn","./line.js":"iUlu0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9aihn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", function() {
    return curveRadialLinear;
});
parcelHelpers.export(exports, "default", function() {
    return curveRadial;
});
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function areaStart() {
        this._curve.areaStart();
    },
    areaEnd: function areaEnd() {
        this._curve.areaEnd();
    },
    lineStart: function lineStart() {
        this._curve.lineStart();
    },
    lineEnd: function lineEnd() {
        this._curve.lineEnd();
    },
    point: function point(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"kggAb","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"inAEm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
            for(i = 0; i < n; ++i){
                for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                    si[j] = sij = [
                        0,
                        +value(data[j], ki, j, data)
                    ];
                    sij.data = data[j];
                }
                si.key = ki;
            }
            for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    };
});
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}

},{"./array.js":"gfb2X","./constant.js":"7PxnE","./offset/none.js":"fTv5T","./order/none.js":"hMwgJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gfb2X":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", function() {
    return slice;
});
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fTv5T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hMwgJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9k1tx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"fTv5T","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9cghR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    };
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cb8EY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"fTv5T","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"geAhJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"fTv5T","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1eGla":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"hMwgJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"go14w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    };
});
parcelHelpers.export(exports, "sum", function() {
    return sum;
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"hMwgJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bNrLC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    };
});
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"go14w","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1U7lN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    };
});
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"1eGla","./ascending.js":"go14w","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7cvNU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    };
});
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"hMwgJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hdJBJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STACK_ORDERS", function() {
    return STACK_ORDERS;
});
parcelHelpers.export(exports, "STACK_ORDER_NAMES", function() {
    return STACK_ORDER_NAMES;
});
parcelHelpers.export(exports, "default", function() {
    return stackOrder;
});
var _d3Shape = require("d3-shape");
var STACK_ORDERS = {
    ascending: (0, _d3Shape.stackOrderAscending),
    descending: (0, _d3Shape.stackOrderDescending),
    insideout: (0, _d3Shape.stackOrderInsideOut),
    none: (0, _d3Shape.stackOrderNone),
    reverse: (0, _d3Shape.stackOrderReverse)
};
var STACK_ORDER_NAMES = Object.keys(STACK_ORDERS);
function stackOrder(order) {
    return order && STACK_ORDERS[order] || STACK_ORDERS.none;
}

},{"d3-shape":"3M387","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gOe4y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STACK_OFFSETS", function() {
    return STACK_OFFSETS;
});
parcelHelpers.export(exports, "STACK_OFFSET_NAMES", function() {
    return STACK_OFFSET_NAMES;
});
parcelHelpers.export(exports, "default", function() {
    return stackOffset;
});
var _d3Shape = require("d3-shape");
var STACK_OFFSETS = {
    expand: (0, _d3Shape.stackOffsetExpand),
    diverging: (0, _d3Shape.stackOffsetDiverging),
    none: (0, _d3Shape.stackOffsetNone),
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    wiggle: (0, _d3Shape.stackOffsetWiggle)
};
var STACK_OFFSET_NAMES = Object.keys(STACK_OFFSETS);
function stackOffset(offset) {
    return offset && STACK_OFFSETS[offset] || STACK_OFFSETS.none;
}

},{"d3-shape":"3M387","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5ahJR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return AreaStack;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _excluded = [
    "className",
    "top",
    "left",
    "keys",
    "data",
    "curve",
    "defined",
    "x",
    "x0",
    "x1",
    "y0",
    "y1",
    "value",
    "order",
    "offset",
    "color",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function AreaStack(_ref) {
    var className = _ref.className, top = _ref.top, left = _ref.left, keys = _ref.keys, data = _ref.data, curve = _ref.curve, defined = _ref.defined, x = _ref.x, x0 = _ref.x0, x1 = _ref.x1, y0 = _ref.y0, y1 = _ref.y1, value = _ref.value, order = _ref.order, offset = _ref.offset, color = _ref.color, children = _ref.children, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stackDefault.default), _extends({
        className: className,
        top: top,
        left: left,
        keys: keys,
        data: data,
        curve: curve,
        defined: defined,
        x: x,
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1,
        value: value,
        order: order,
        offset: offset,
        color: color
    }, restProps), children || function(_ref2) {
        var stacks = _ref2.stacks, path = _ref2.path;
        return stacks.map(function(series, i) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
                className: (0, _classnamesDefault.default)("visx-area-stack", className),
                key: "area-stack-" + i + "-" + (series.key || ""),
                d: path(series) || "",
                fill: color == null ? void 0 : color(series.key, i)
            }, restProps));
        });
    });
}

},{"react":"ktQNc","classnames":"aMKnv","./Stack":"auf2V","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"auf2V":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Stack;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _group = require("@visx/group");
var _d3ShapeFactories = require("../util/D3ShapeFactories");
var _excluded = [
    "className",
    "top",
    "left",
    "keys",
    "data",
    "curve",
    "defined",
    "x",
    "x0",
    "x1",
    "y0",
    "y1",
    "value",
    "order",
    "offset",
    "color",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Stack(_ref) {
    var className = _ref.className, top = _ref.top, left = _ref.left, keys = _ref.keys, data = _ref.data, curve = _ref.curve, defined = _ref.defined, x = _ref.x, x0 = _ref.x0, x1 = _ref.x1, y0 = _ref.y0, y1 = _ref.y1, value = _ref.value, order = _ref.order, offset = _ref.offset, color = _ref.color, children = _ref.children, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var stack = (0, _d3ShapeFactories.stack)({
        keys: keys,
        value: value,
        order: order,
        offset: offset
    });
    var path = (0, _d3ShapeFactories.area)({
        x: x,
        x0: x0,
        x1: x1,
        y0: y0,
        y1: y1,
        curve: curve,
        defined: defined
    });
    var stacks = stack(data);
    if (children) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children({
        stacks: stacks,
        path: path,
        stack: stack
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        top: top,
        left: left
    }, stacks.map(function(series, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
            className: (0, _classnamesDefault.default)("visx-stack", className),
            key: "stack-" + i + "-" + (series.key || ""),
            d: path(series) || "",
            fill: color == null ? void 0 : color(series.key, i)
        }, restProps));
    }));
}

},{"react":"ktQNc","classnames":"aMKnv","@visx/group":"daSh2","../util/D3ShapeFactories":"aoEMw","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"YBQFP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Bar;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _excluded = [
    "className",
    "innerRef"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Bar(_ref) {
    var className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({
        ref: innerRef,
        className: (0, _classnamesDefault.default)("visx-bar", className)
    }, restProps));
}

},{"react":"ktQNc","classnames":"aMKnv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bQMmB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return BarStack;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _d3Shape = require("d3-shape");
var _group = require("@visx/group");
var _accessors = require("../util/accessors");
var _getBandwidth = require("../util/getBandwidth");
var _getBandwidthDefault = parcelHelpers.interopDefault(_getBandwidth);
var _setNumberOrNumberAccessor = require("../util/setNumberOrNumberAccessor");
var _setNumberOrNumberAccessorDefault = parcelHelpers.interopDefault(_setNumberOrNumberAccessor);
var _stackOrder = require("../util/stackOrder");
var _stackOrderDefault = parcelHelpers.interopDefault(_stackOrder);
var _stackOffset = require("../util/stackOffset");
var _stackOffsetDefault = parcelHelpers.interopDefault(_stackOffset);
var _bar = require("./Bar");
var _barDefault = parcelHelpers.interopDefault(_bar);
var _excluded = [
    "data",
    "className",
    "top",
    "left",
    "x",
    "y0",
    "y1",
    "xScale",
    "yScale",
    "color",
    "keys",
    "value",
    "order",
    "offset",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BarStack(_ref) {
    var data = _ref.data, className = _ref.className, top = _ref.top, left = _ref.left, x = _ref.x, _ref$y = _ref.y0, y0 = _ref$y === void 0 ? (0, _accessors.getFirstItem) : _ref$y, _ref$y2 = _ref.y1, y1 = _ref$y2 === void 0 ? (0, _accessors.getSecondItem) : _ref$y2, xScale = _ref.xScale, yScale = _ref.yScale, color = _ref.color, keys = _ref.keys, value = _ref.value, order = _ref.order, offset = _ref.offset, children = _ref.children, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var stack = (0, _d3Shape.stack)();
    if (keys) stack.keys(keys);
    if (value) (0, _setNumberOrNumberAccessorDefault.default)(stack.value, value);
    if (order) stack.order((0, _stackOrderDefault.default)(order));
    if (offset) stack.offset((0, _stackOffsetDefault.default)(offset));
    var stacks = stack(data);
    var barWidth = (0, _getBandwidthDefault.default)(xScale);
    var barStacks = stacks.map(function(barStack, i) {
        var key = barStack.key;
        return {
            index: i,
            key: key,
            bars: barStack.map(function(bar, j) {
                var barHeight = (yScale(y0(bar)) || 0) - (yScale(y1(bar)) || 0);
                var barY = yScale(y1(bar));
                var barX = "bandwidth" in xScale ? xScale(x(bar.data)) : Math.max((xScale(x(bar.data)) || 0) - barWidth / 2);
                return {
                    bar: bar,
                    key: key,
                    index: j,
                    height: barHeight,
                    width: barWidth,
                    x: barX || 0,
                    y: barY || 0,
                    color: color(barStack.key, j)
                };
            })
        };
    });
    if (children) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(barStacks));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        className: (0, _classnamesDefault.default)("visx-bar-stack", className),
        top: top,
        left: left
    }, barStacks.map(function(barStack) {
        return barStack.bars.map(function(bar) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barDefault.default), _extends({
                key: "bar-stack-" + barStack.index + "-" + bar.index,
                x: bar.x,
                y: bar.y,
                height: bar.height,
                width: bar.width,
                fill: bar.color
            }, restProps));
        });
    }));
}

},{"react":"ktQNc","classnames":"aMKnv","d3-shape":"3M387","@visx/group":"daSh2","../util/accessors":"9wy5S","../util/getBandwidth":"fFHEU","../util/setNumberOrNumberAccessor":"9jPYj","../util/stackOrder":"hdJBJ","../util/stackOffset":"gOe4y","./Bar":"YBQFP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9wy5S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getX", function() {
    return getX;
});
parcelHelpers.export(exports, "getY", function() {
    return getY;
});
parcelHelpers.export(exports, "getSource", function() {
    return getSource;
});
parcelHelpers.export(exports, "getTarget", function() {
    return getTarget;
});
parcelHelpers.export(exports, "getFirstItem", function() {
    return getFirstItem;
});
parcelHelpers.export(exports, "getSecondItem", function() {
    return getSecondItem;
});
function getX(l) {
    return typeof (l == null ? void 0 : l.x) === "number" ? l == null ? void 0 : l.x : 0;
}
function getY(l) {
    return typeof (l == null ? void 0 : l.y) === "number" ? l == null ? void 0 : l.y : 0;
}
function getSource(l) {
    return l == null ? void 0 : l.source;
}
function getTarget(l) {
    return l == null ? void 0 : l.target;
}
function getFirstItem(d) {
    return d == null ? void 0 : d[0];
}
function getSecondItem(d) {
    return d == null ? void 0 : d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fFHEU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBandwidth;
});
function getBandwidth(scale) {
    if ("bandwidth" in scale) return scale.bandwidth();
    var range = scale.range();
    var domain = scale.domain();
    return Math.abs(range[range.length - 1] - range[0]) / domain.length;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jlEhs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", function() {
    return 0, _textDefault.default;
});
parcelHelpers.export(exports, "getStringWidth", function() {
    return 0, _getStringWidthDefault.default;
});
parcelHelpers.export(exports, "useText", function() {
    return 0, _useTextDefault.default;
});
var _text = require("./Text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _getStringWidth = require("./util/getStringWidth");
var _getStringWidthDefault = parcelHelpers.interopDefault(_getStringWidth);
var _useText = require("./hooks/useText");
var _useTextDefault = parcelHelpers.interopDefault(_useText);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./Text":"aQ6b6","./util/getStringWidth":false,"./hooks/useText":false,"./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aQ6b6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Text;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useText = require("./hooks/useText");
var _useTextDefault = parcelHelpers.interopDefault(_useText);
var _excluded = [
    "dx",
    "dy",
    "textAnchor",
    "innerRef",
    "innerTextRef",
    "verticalAnchor",
    "angle",
    "lineHeight",
    "scaleToFit",
    "capHeight",
    "width"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var SVG_STYLE = {
    overflow: "visible"
};
function Text(props) {
    var _props$dx = props.dx, dx = _props$dx === void 0 ? 0 : _props$dx, _props$dy = props.dy, dy = _props$dy === void 0 ? 0 : _props$dy, _props$textAnchor = props.textAnchor, textAnchor = _props$textAnchor === void 0 ? "start" : _props$textAnchor, innerRef = props.innerRef, innerTextRef = props.innerTextRef, verticalAnchor = props.verticalAnchor, angle = props.angle, _props$lineHeight = props.lineHeight, lineHeight = _props$lineHeight === void 0 ? "1em" : _props$lineHeight, _props$scaleToFit = props.scaleToFit, scaleToFit = _props$scaleToFit === void 0 ? false : _props$scaleToFit, capHeight = props.capHeight, width = props.width, textProps = _objectWithoutPropertiesLoose(props, _excluded);
    var _textProps$x = textProps.x, x = _textProps$x === void 0 ? 0 : _textProps$x, fontSize = textProps.fontSize;
    var _useText = (0, _useTextDefault.default)(props), wordsByLines = _useText.wordsByLines, startDy = _useText.startDy, transform = _useText.transform;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        ref: innerRef,
        x: dx,
        y: dy,
        fontSize: fontSize,
        style: SVG_STYLE
    }, wordsByLines.length > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement("text", _extends({
        ref: innerTextRef,
        transform: transform
    }, textProps, {
        textAnchor: textAnchor
    }), wordsByLines.map(function(line, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tspan", {
            key: index,
            x: x,
            dy: index === 0 ? startDy : lineHeight
        }, line.words.join(" "));
    })) : null);
}

},{"react":"ktQNc","./hooks/useText":"llYoe","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"llYoe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useText;
});
var _react = require("react");
var _reduceCssCalc = require("reduce-css-calc");
var _reduceCssCalcDefault = parcelHelpers.interopDefault(_reduceCssCalc);
var _getStringWidth = require("../util/getStringWidth");
var _getStringWidthDefault = parcelHelpers.interopDefault(_getStringWidth);
var _excluded = [
    "verticalAnchor",
    "scaleToFit",
    "angle",
    "width",
    "lineHeight",
    "capHeight",
    "children",
    "style"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function isNumber(val) {
    return typeof val === "number";
}
function isXOrYInValid(xOrY) {
    return(// number that is not NaN or Infinity
    typeof xOrY === "number" && Number.isFinite(xOrY) || // for percentage
    typeof xOrY === "string");
}
function useText(props) {
    var _props$verticalAnchor = props.verticalAnchor, verticalAnchor = _props$verticalAnchor === void 0 ? "end" : _props$verticalAnchor, _props$scaleToFit = props.scaleToFit, scaleToFit = _props$scaleToFit === void 0 ? false : _props$scaleToFit, angle = props.angle, width = props.width, _props$lineHeight = props.lineHeight, lineHeight = _props$lineHeight === void 0 ? "1em" : _props$lineHeight, _props$capHeight = props.capHeight, capHeight = _props$capHeight === void 0 ? "0.71em" : _props$capHeight, children = props.children, style = props.style, textProps = _objectWithoutPropertiesLoose(props, _excluded);
    var _textProps$x = textProps.x, x = _textProps$x === void 0 ? 0 : _textProps$x, _textProps$y = textProps.y, y = _textProps$y === void 0 ? 0 : _textProps$y;
    var isXOrYNotValid = !isXOrYInValid(x) || !isXOrYInValid(y);
    var _useMemo = (0, _react.useMemo)(function() {
        var words = children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/);
        return {
            wordsWithWidth: words.map(function(word) {
                return {
                    word: word,
                    wordWidth: (0, _getStringWidthDefault.default)(word, style) || 0
                };
            }),
            spaceWidth: (0, _getStringWidthDefault.default)("\xa0", style) || 0
        };
    }, [
        children,
        style
    ]), wordsWithWidth = _useMemo.wordsWithWidth, spaceWidth = _useMemo.spaceWidth;
    var wordsByLines = (0, _react.useMemo)(function() {
        if (isXOrYNotValid) return [];
        // Only perform calculations if using features that require them (multiline, scaleToFit)
        if (width || scaleToFit) return wordsWithWidth.reduce(function(result, _ref) {
            var word = _ref.word, wordWidth = _ref.wordWidth;
            var currentLine = result[result.length - 1];
            if (currentLine && (width == null || scaleToFit || (currentLine.width || 0) + wordWidth + spaceWidth < width)) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width = currentLine.width || 0;
                currentLine.width += wordWidth + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: wordWidth
                };
                result.push(newLine);
            }
            return result;
        }, []);
        return [
            {
                words: children == null ? [] : children.toString().split(/(?:(?!\u00A0+)\s+)/)
            }
        ];
    }, [
        isXOrYNotValid,
        width,
        scaleToFit,
        children,
        wordsWithWidth,
        spaceWidth
    ]);
    var startDy = (0, _react.useMemo)(function() {
        var startDyStr = isXOrYNotValid ? "" : verticalAnchor === "start" ? (0, _reduceCssCalcDefault.default)("calc(" + capHeight + ")") : verticalAnchor === "middle" ? (0, _reduceCssCalcDefault.default)("calc(" + (wordsByLines.length - 1) / 2 + " * -" + lineHeight + " + (" + capHeight + " / 2))") : (0, _reduceCssCalcDefault.default)("calc(" + (wordsByLines.length - 1) + " * -" + lineHeight + ")");
        return startDyStr;
    }, [
        isXOrYNotValid,
        verticalAnchor,
        capHeight,
        wordsByLines.length,
        lineHeight
    ]);
    var transform = (0, _react.useMemo)(function() {
        var transforms = [];
        if (isXOrYNotValid) return "";
        if (isNumber(x) && isNumber(y) && isNumber(width) && scaleToFit && wordsByLines.length > 0) {
            var lineWidth = wordsByLines[0].width || 1;
            var sx = scaleToFit === "shrink-only" ? Math.min(width / lineWidth, 1) : width / lineWidth;
            var sy = sx;
            var originX = x - sx * x;
            var originY = y - sy * y;
            transforms.push("matrix(" + sx + ", 0, 0, " + sy + ", " + originX + ", " + originY + ")");
        }
        if (angle) transforms.push("rotate(" + angle + ", " + x + ", " + y + ")");
        return transforms.length > 0 ? transforms.join(" ") : "";
    }, [
        isXOrYNotValid,
        x,
        y,
        width,
        scaleToFit,
        wordsByLines,
        angle
    ]);
    return {
        wordsByLines: wordsByLines,
        startDy: startDy,
        transform: transform
    };
}

},{"react":"ktQNc","reduce-css-calc":"lm0ud","../util/getStringWidth":"kfR0e","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lm0ud":[function(require,module,exports) {
/**
 * Module dependencies
 */ var balanced = require("b7127c0bc8b15968");
var reduceFunctionCall = require("93f94a87c94d2e66");
var mexp = require("ee590a57cc27a3d4");
/**
 * Constantes
 */ var MAX_STACK = 100 // should be enough for a single calc()...
;
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g;
/**
 * Global variables
 */ var stack;
/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */ module.exports = reduceCSSCalc;
/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */ function reduceCSSCalc(value, decimalPrecision) {
    stack = 0;
    decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision);
    // Allow calc() on multiple lines
    value = value.replace(/\n+/g, " ");
    /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */ function evaluateExpression(expression, functionIdentifier, call) {
        if (stack++ > MAX_STACK) {
            stack = 0;
            throw new Error("Call stack overflow for " + call);
        }
        if (expression === "") throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string");
        expression = evaluateNestedExpression(expression, call);
        var units = getUnitsInExpression(expression);
        // If the expression contains multiple units or CSS variables,
        // then let the expression be (i.e. browser calc())
        if (units.length > 1 || expression.indexOf("var(") > -1) return functionIdentifier + "(" + expression + ")";
        var unit = units[0] || "";
        if (unit === "%") // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
        // console.log(expression)
        expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
            return parseFloat(percent.slice(0, -1)) * 0.01;
        });
        // Remove units in expression:
        var toEvaluate = expression.replace(new RegExp(unit, "gi"), "");
        var result;
        try {
            result = mexp.eval(toEvaluate);
        } catch (e) {
            return functionIdentifier + "(" + expression + ")";
        }
        // Transform back to a percentage result:
        if (unit === "%") result *= 100;
        // adjust rounding shit
        // (0.1 * 0.2 === 0.020000000000000004)
        if (functionIdentifier.length || unit === "%") result = Math.round(result * decimalPrecision) / decimalPrecision;
        // Add unit
        result += unit;
        return result;
    }
    /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */ function evaluateNestedExpression(expression, call) {
        // Remove the calc part from nested expressions to ensure
        // better browser compatibility
        expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "");
        var evaluatedPart = "";
        var nonEvaluatedPart = expression;
        var matches;
        while(matches = NESTED_CALC_RE.exec(nonEvaluatedPart)){
            if (matches[0].index > 0) evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index);
            var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([
                0
            ].index));
            if (balancedExpr.body === "") throw new Error("'" + expression + "' must contain a non-whitespace string");
            var evaluated = evaluateExpression(balancedExpr.body, "", call);
            evaluatedPart += balancedExpr.pre + evaluated;
            nonEvaluatedPart = balancedExpr.post;
        }
        return evaluatedPart + nonEvaluatedPart;
    }
    return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression);
}
/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */ function getUnitsInExpression(expression) {
    var uniqueUnits = [];
    var uniqueLowerCaseUnits = [];
    var unitRegEx = /[\.0-9]([%a-z]+)/gi;
    var matches = unitRegEx.exec(expression);
    while(matches){
        if (!matches || !matches[1]) continue;
        if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
            uniqueUnits.push(matches[1]);
            uniqueLowerCaseUnits.push(matches[1].toLowerCase());
        }
        matches = unitRegEx.exec(expression);
    }
    return uniqueUnits;
}

},{"b7127c0bc8b15968":"kg0rN","93f94a87c94d2e66":"NDOnx","ee590a57cc27a3d4":"jeJqm"}],"kg0rN":[function(require,module,exports) {
module.exports = balanced;
function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
balanced.range = range;
function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}

},{}],"NDOnx":[function(require,module,exports) {
/*
 * Module dependencies
 */ var balanced = require("98666a7df68373ca");
/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */ module.exports = reduceFunctionCall;
/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */ function reduceFunctionCall(string, functionRE, callback) {
    var call = string;
    return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
        return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE));
    }, string);
}
/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */ function getFunctionCalls(call, functionRE) {
    var expressions = [];
    var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE;
    do {
        var searchMatch = fnRE.exec(call);
        if (!searchMatch) return expressions;
        if (searchMatch[1] === undefined) throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE);
        var fn = searchMatch[1];
        var startIndex = searchMatch.index;
        var matches = balanced("(", ")", call.substring(startIndex));
        if (!matches || matches.start !== searchMatch[0].length - 1) throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'");
        expressions.push({
            matches: matches,
            functionIdentifier: fn
        });
        call = matches.post;
    }while (fnRE.test(call));
    return expressions;
}
/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */ function evalFunctionCall(string, functionIdentifier, callback, call, functionRE) {
    // allow recursivity
    return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call);
}

},{"98666a7df68373ca":"7MDPO"}],"7MDPO":[function(require,module,exports) {
"use strict";
module.exports = balanced;
function balanced(a, b, str) {
    if (a instanceof RegExp) a = maybeMatch(a, str);
    if (b instanceof RegExp) b = maybeMatch(b, str);
    var r = range(a, b, str);
    return r && {
        start: r[0],
        end: r[1],
        pre: str.slice(0, r[0]),
        body: str.slice(r[0] + a.length, r[1]),
        post: str.slice(r[1] + b.length)
    };
}
function maybeMatch(reg, str) {
    var m = str.match(reg);
    return m ? m[0] : null;
}
balanced.range = range;
function range(a, b, str) {
    var begs, beg, left, right, result;
    var ai = str.indexOf(a);
    var bi = str.indexOf(b, ai + 1);
    var i = ai;
    if (ai >= 0 && bi > 0) {
        if (a === b) return [
            ai,
            bi
        ];
        begs = [];
        left = str.length;
        while(i >= 0 && !result){
            if (i == ai) {
                begs.push(i);
                ai = str.indexOf(a, i + 1);
            } else if (begs.length == 1) result = [
                begs.pop(),
                bi
            ];
            else {
                beg = begs.pop();
                if (beg < left) {
                    left = beg;
                    right = bi;
                }
                bi = str.indexOf(b, i + 1);
            }
            i = ai < bi && ai >= 0 ? ai : bi;
        }
        if (begs.length) result = [
            left,
            right
        ];
    }
    return result;
}

},{}],"jeJqm":[function(require,module,exports) {
var Mexp = require("779caa614efd059");
Mexp.prototype.formulaEval = function() {
    "use strict";
    var stack = [], pop1, pop2, pop3;
    var disp = [];
    var temp = "";
    var arr = this.value;
    for(var i = 0; i < arr.length; i++){
        if (arr[i].type === 1 || arr[i].type === 3) disp.push({
            value: arr[i].type === 3 ? arr[i].show : arr[i].value,
            type: 1
        });
        else if (arr[i].type === 13) disp.push({
            value: arr[i].show,
            type: 1
        });
        else if (arr[i].type === 0) disp[disp.length - 1] = {
            value: arr[i].show + (arr[i].show != "-" ? "(" : "") + disp[disp.length - 1].value + (arr[i].show != "-" ? ")" : ""),
            type: 0
        };
        else if (arr[i].type === 7) disp[disp.length - 1] = {
            value: (disp[disp.length - 1].type != 1 ? "(" : "") + disp[disp.length - 1].value + (disp[disp.length - 1].type != 1 ? ")" : "") + arr[i].show,
            type: 7
        };
        else if (arr[i].type === 10) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            if (arr[i].show === "P" || arr[i].show === "C") disp.push({
                value: "<sup>" + pop2.value + "</sup>" + arr[i].show + "<sub>" + pop1.value + "</sub>",
                type: 10
            });
            else disp.push({
                value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + "<sup>" + pop1.value + "</sup>",
                type: 1
            });
        } else if (arr[i].type === 2 || arr[i].type === 9) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            disp.push({
                value: (pop2.type != 1 ? "(" : "") + pop2.value + (pop2.type != 1 ? ")" : "") + arr[i].show + (pop1.type != 1 ? "(" : "") + pop1.value + (pop1.type != 1 ? ")" : ""),
                type: arr[i].type
            });
        } else if (arr[i].type === 12) {
            pop1 = disp.pop();
            pop2 = disp.pop();
            pop3 = disp.pop();
            disp.push({
                value: arr[i].show + "(" + pop3.value + "," + pop2.value + "," + pop1.value + ")",
                type: 12
            });
        }
    }
    return disp[0].value;
};
module.exports = Mexp;

},{"779caa614efd059":"47Nm5"}],"47Nm5":[function(require,module,exports) {
var Mexp = require("995db297a4d16349");
Mexp.prototype.postfixEval = function(UserDefined) {
    "use strict";
    UserDefined = UserDefined || {};
    UserDefined.PI = Math.PI;
    UserDefined.E = Math.E;
    var stack = [], pop1, pop2, pop3;
    var disp = [];
    var temp = "";
    var arr = this.value;
    var bool = typeof UserDefined.n !== "undefined";
    for(var i = 0; i < arr.length; i++){
        if (arr[i].type === 1) stack.push({
            value: arr[i].value,
            type: 1
        });
        else if (arr[i].type === 3) stack.push({
            value: UserDefined[arr[i].value],
            type: 1
        });
        else if (arr[i].type === 0) {
            if (typeof stack[stack.length - 1].type === "undefined") stack[stack.length - 1].value.push(arr[i]);
            else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value);
        } else if (arr[i].type === 7) {
            if (typeof stack[stack.length - 1].type === "undefined") stack[stack.length - 1].value.push(arr[i]);
            else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value);
        } else if (arr[i].type === 8) {
            var popped = [];
            for(var x = 0; x < arr[i].numberOfArguments; x++)popped.push(stack.pop().value);
            stack.push({
                type: 1,
                value: arr[i].value.apply(arr[i], popped.reverse())
            });
        } else if (arr[i].type === 10) {
            pop1 = stack.pop();
            pop2 = stack.pop();
            if (typeof pop2.type === "undefined") {
                pop2.value = pop2.concat(pop1);
                pop2.value.push(arr[i]);
                stack.push(pop2);
            } else if (typeof pop1.type === "undefined") {
                pop1.unshift(pop2);
                pop1.push(arr[i]);
                stack.push(pop1);
            } else stack.push({
                type: 1,
                value: arr[i].value(pop2.value, pop1.value)
            });
        } else if (arr[i].type === 2 || arr[i].type === 9) {
            pop1 = stack.pop();
            pop2 = stack.pop();
            if (typeof pop2.type === "undefined") {
                pop2 = pop2.concat(pop1);
                pop2.push(arr[i]);
                stack.push(pop2);
            } else if (typeof pop1.type === "undefined") {
                pop1.unshift(pop2);
                pop1.push(arr[i]);
                stack.push(pop1);
            } else stack.push({
                type: 1,
                value: arr[i].value(pop2.value, pop1.value)
            });
        } else if (arr[i].type === 12) {
            pop1 = stack.pop();
            if (typeof pop1.type !== "undefined") pop1 = [
                pop1
            ];
            pop2 = stack.pop();
            pop3 = stack.pop();
            stack.push({
                type: 1,
                value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1))
            });
        } else if (arr[i].type === 13) {
            if (bool) stack.push({
                value: UserDefined[arr[i].value],
                type: 3
            });
            else stack.push([
                arr[i]
            ]);
        }
    }
    if (stack.length > 1) throw new Mexp.Exception("Uncaught Syntax error");
    return stack[0].value > 1000000000000000 ? "Infinity" : parseFloat(stack[0].value.toFixed(15));
};
Mexp.eval = function(str, tokens, obj) {
    if (typeof tokens === "undefined") return this.lex(str).toPostfix().postfixEval();
    else if (typeof obj === "undefined") {
        if (typeof tokens.length !== "undefined") return this.lex(str, tokens).toPostfix().postfixEval();
        else return this.lex(str).toPostfix().postfixEval(tokens);
    } else return this.lex(str, tokens).toPostfix().postfixEval(obj);
};
module.exports = Mexp;

},{"995db297a4d16349":"c48pa"}],"c48pa":[function(require,module,exports) {
var Mexp = require("b6aa331e5ee85fe1");
Mexp.prototype.toPostfix = function() {
    "use strict";
    var post = [], elem, popped, prep, pre, ele;
    var stack = [
        {
            value: "(",
            type: 4,
            pre: 0
        }
    ];
    var arr = this.value;
    for(var i = 1; i < arr.length; i++){
        if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {
            if (arr[i].type === 1) arr[i].value = Number(arr[i].value);
            post.push(arr[i]);
        } else if (arr[i].type === 4) stack.push(arr[i]);
        else if (arr[i].type === 5) while((popped = stack.pop()).type !== 4)post.push(popped);
        else if (arr[i].type === 11) {
            while((popped = stack.pop()).type !== 4)post.push(popped);
            stack.push(popped);
        } else {
            elem = arr[i];
            pre = elem.pre;
            ele = stack[stack.length - 1];
            prep = ele.pre;
            var flag = ele.value == "Math.pow" && elem.value == "Math.pow";
            if (pre > prep) stack.push(elem);
            else {
                while(prep >= pre && !flag || flag && pre < prep){
                    popped = stack.pop();
                    ele = stack[stack.length - 1];
                    post.push(popped);
                    prep = ele.pre;
                    flag = elem.value == "Math.pow" && ele.value == "Math.pow";
                }
                stack.push(elem);
            }
        }
    }
    return new Mexp(post);
};
module.exports = Mexp;

},{"b6aa331e5ee85fe1":"7vgzz"}],"7vgzz":[function(require,module,exports) {
"use strict";
var Mexp = require("73774425d510e732");
function inc(arr, val) {
    for(var i = 0; i < arr.length; i++)arr[i] += val;
    return arr;
}
var tokens = [
    {
        token: "sin",
        show: "sin",
        type: 0,
        value: Mexp.math.sin
    },
    {
        token: "cos",
        show: "cos",
        type: 0,
        value: Mexp.math.cos
    },
    {
        token: "tan",
        show: "tan",
        type: 0,
        value: Mexp.math.tan
    },
    {
        token: "pi",
        show: "&pi;",
        type: 3,
        value: "PI"
    },
    {
        token: "(",
        show: "(",
        type: 4,
        value: "("
    },
    {
        token: ")",
        show: ")",
        type: 5,
        value: ")"
    },
    {
        token: "P",
        show: "P",
        type: 10,
        value: Mexp.math.P
    },
    {
        token: "C",
        show: "C",
        type: 10,
        value: Mexp.math.C
    },
    {
        token: " ",
        show: " ",
        type: 14,
        value: " ".anchor
    },
    {
        token: "asin",
        show: "asin",
        type: 0,
        value: Mexp.math.asin
    },
    {
        token: "acos",
        show: "acos",
        type: 0,
        value: Mexp.math.acos
    },
    {
        token: "atan",
        show: "atan",
        type: 0,
        value: Mexp.math.atan
    },
    {
        token: "7",
        show: "7",
        type: 1,
        value: "7"
    },
    {
        token: "8",
        show: "8",
        type: 1,
        value: "8"
    },
    {
        token: "9",
        show: "9",
        type: 1,
        value: "9"
    },
    {
        token: "int",
        show: "Int",
        type: 0,
        value: Math.floor
    },
    {
        token: "cosh",
        show: "cosh",
        type: 0,
        value: Mexp.math.cosh
    },
    {
        token: "acosh",
        show: "acosh",
        type: 0,
        value: Mexp.math.acosh
    },
    {
        token: "ln",
        show: " ln",
        type: 0,
        value: Math.log
    },
    {
        token: "^",
        show: "^",
        type: 10,
        value: Math.pow
    },
    {
        token: "root",
        show: "root",
        type: 0,
        value: Math.sqrt
    },
    {
        token: "4",
        show: "4",
        type: 1,
        value: "4"
    },
    {
        token: "5",
        show: "5",
        type: 1,
        value: "5"
    },
    {
        token: "6",
        show: "6",
        type: 1,
        value: "6"
    },
    {
        token: "/",
        show: "&divide;",
        type: 2,
        value: Mexp.math.div
    },
    {
        token: "!",
        show: "!",
        type: 7,
        value: Mexp.math.fact
    },
    {
        token: "tanh",
        show: "tanh",
        type: 0,
        value: Mexp.math.tanh
    },
    {
        token: "atanh",
        show: "atanh",
        type: 0,
        value: Mexp.math.atanh
    },
    {
        token: "Mod",
        show: " Mod ",
        type: 2,
        value: Mexp.math.mod
    },
    {
        token: "1",
        show: "1",
        type: 1,
        value: "1"
    },
    {
        token: "2",
        show: "2",
        type: 1,
        value: "2"
    },
    {
        token: "3",
        show: "3",
        type: 1,
        value: "3"
    },
    {
        token: "*",
        show: "&times;",
        type: 2,
        value: Mexp.math.mul
    },
    {
        token: "sinh",
        show: "sinh",
        type: 0,
        value: Mexp.math.sinh
    },
    {
        token: "asinh",
        show: "asinh",
        type: 0,
        value: Mexp.math.asinh
    },
    {
        token: "e",
        show: "e",
        type: 3,
        value: "E"
    },
    {
        token: "log",
        show: " log",
        type: 0,
        value: Mexp.math.log
    },
    {
        token: "0",
        show: "0",
        type: 1,
        value: "0"
    },
    {
        token: ".",
        show: ".",
        type: 6,
        value: "."
    },
    {
        token: "+",
        show: "+",
        type: 9,
        value: Mexp.math.add
    },
    {
        token: "-",
        show: "-",
        type: 9,
        value: Mexp.math.sub
    },
    {
        token: ",",
        show: ",",
        type: 11,
        value: ","
    },
    {
        token: "Sigma",
        show: "&Sigma;",
        type: 12,
        value: Mexp.math.sigma
    },
    {
        token: "n",
        show: "n",
        type: 13,
        value: "n"
    },
    {
        token: "Pi",
        show: "&Pi;",
        type: 12,
        value: Mexp.math.Pi
    },
    {
        token: "pow",
        show: "pow",
        type: 8,
        value: Math.pow,
        numberOfArguments: 2
    },
    {
        token: "&",
        show: "&",
        type: 9,
        value: Mexp.math.and
    }
];
var preced = {
    0: 11,
    1: 0,
    2: 3,
    3: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 11,
    8: 11,
    9: 1,
    10: 10,
    11: 0,
    12: 11,
    13: 0,
    14: -1,
    15: 11
} // stores precedence by types
;
for(var i = 0; i < tokens.length; i++)tokens[i].precedence = preced[tokens[i].type];
var type0 = {
    0: true,
    1: true,
    3: true,
    4: true,
    6: true,
    8: true,
    9: true,
    12: true,
    13: true,
    14: true,
    15: true
} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
;
var type1 = {
    0: true,
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    8: true,
    9: true,
    10: true,
    11: true,
    12: true,
    13: true,
    15: true
} // type3:true,type5:true,type7:true,type23
;
var type1Asterick = {
    0: true,
    3: true,
    4: true,
    8: true,
    12: true,
    13: true,
    15: true
};
var empty = {};
var type3Asterick = {
    0: true,
    1: true,
    3: true,
    4: true,
    6: true,
    8: true,
    12: true,
    13: true,
    15: true
} // type_5:true,type_7:true,type_23
;
var type6 = {
    1: true
};
var newAr = [
    [],
    [
        "1",
        "2",
        "3",
        "7",
        "8",
        "9",
        "4",
        "5",
        "6",
        "+",
        "-",
        "*",
        "/",
        "(",
        ")",
        "^",
        "!",
        "P",
        "C",
        "e",
        "0",
        ".",
        ",",
        "n",
        " ",
        "&"
    ],
    [
        "pi",
        "ln",
        "Pi"
    ],
    [
        "sin",
        "cos",
        "tan",
        "Del",
        "int",
        "Mod",
        "log",
        "pow"
    ],
    [
        "asin",
        "acos",
        "atan",
        "cosh",
        "root",
        "tanh",
        "sinh"
    ],
    [
        "acosh",
        "atanh",
        "asinh",
        "Sigma"
    ]
];
function match(str1, str2, i, x) {
    for(var f = 0; f < x; f++){
        if (str1[i + f] !== str2[f]) return false;
    }
    return true;
}
Mexp.tokenTypes = {
    FUNCTION_WITH_ONE_ARG: 0,
    NUMBER: 1,
    BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
    CONSTANT: 3,
    OPENING_PARENTHESIS: 4,
    CLOSING_PARENTHESIS: 5,
    DECIMAL: 6,
    POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
    FUNCTION_WITH_N_ARGS: 8,
    BINARY_OPERATOR_LOW_PRECENDENCE: 9,
    BINARY_OPERATOR_PERMUTATION: 10,
    COMMA: 11,
    EVALUATED_FUNCTION: 12,
    EVALUATED_FUNCTION_PARAMETER: 13,
    SPACE: 14
};
/**
  
  0 : function with syntax function_name(Maths_exp)
  1 : numbers
  2 : binary operators like * / Mod left associate and same precedence
  3 : Math constant values like e,pi,Cruncher ans
  4 : opening bracket
  5 : closing bracket
  6 : decimal
  7 : function with syntax (Math_exp)function_name
  8: function with syntax function_name(Math_exp1,Math_exp2)
  9 : binary operator like +,-
  10: binary operator like P C or ^
  11: ,
  12: function with , seperated three parameters and third parameter is a string that will be mexp string
  13: variable of Sigma function
 */ Mexp.addToken = function(newTokens) {
    for(var i = 0; i < newTokens.length; i++){
        var x = newTokens[i].token.length;
        var temp = -1;
        if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) newTokens[i].numberOfArguments = 2;
        // newAr is a specially designed data structure index of 1d array = length of tokens
        newAr[x] = newAr[x] || [];
        for(var y = 0; y < newAr[x].length; y++)if (newTokens[i].token === newAr[x][y]) {
            temp = indexOfToken(newAr[x][y], tokens);
            break;
        }
        if (temp === -1) {
            tokens.push(newTokens[i]);
            newTokens[i].precedence = preced[newTokens[i].type];
            if (newAr.length <= newTokens[i].token.length) newAr[newTokens[i].token.length] = [];
            newAr[newTokens[i].token.length].push(newTokens[i].token);
        } else {
            // overwrite
            tokens[temp] = newTokens[i];
            newTokens[i].precedence = preced[newTokens[i].type];
        }
    }
};
function indexOfToken(key, tokens) {
    for(var search = 0; search < tokens.length; search++){
        if (tokens[search].token === key) return search;
    }
    return -1;
}
function tokenize(string) {
    var nodes = [];
    var length = string.length;
    var key, x, y;
    for(var i = 0; i < length; i++){
        if (i < length - 1 && string[i] === " " && string[i + 1] === " ") continue;
        key = "";
        for(x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--){
            if (newAr[x] === undefined) continue;
            for(y = 0; y < newAr[x].length; y++)if (match(string, newAr[x][y], i, x)) {
                key = newAr[x][y];
                y = newAr[x].length;
                x = 0;
            }
        }
        i += key.length - 1;
        if (key === "") throw new Mexp.Exception("Can't understand after " + string.slice(i));
        nodes.push(tokens[indexOfToken(key, tokens)]);
    }
    return nodes;
}
var changeSignObj = {
    value: Mexp.math.changeSign,
    type: 0,
    pre: 21,
    show: "-"
};
var closingParObj = {
    value: ")",
    show: ")",
    type: 5,
    pre: 0
};
var openingParObj = {
    value: "(",
    type: 4,
    pre: 0,
    show: "("
};
Mexp.lex = function(inp, tokens) {
    "use strict";
    var str = [
        openingParObj
    ];
    var ptc = [] // Parenthesis to close at the beginning is after one token
    ;
    var inpStr = inp;
    var allowed = type0;
    var bracToClose = 0;
    var asterick = empty;
    var prevKey = "";
    var i;
    if (typeof tokens !== "undefined") Mexp.addToken(tokens);
    var obj = {};
    var nodes = tokenize(inpStr);
    for(i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.type === 14) {
            if (i > 0 && i < nodes.length - 1 && nodes[i + 1].type === 1 && (nodes[i - 1].type === 1 || nodes[i - 1].type === 6)) throw new Mexp.Exception("Unexpected Space");
            continue;
        }
        var cToken = node.token;
        var cType = node.type;
        var cEv = node.value;
        var cPre = node.precedence;
        var cShow = node.show;
        var pre = str[str.length - 1];
        var j;
        for(j = ptc.length; j--;){
            // loop over ptc
            if (ptc[j] === 0) {
                if ([
                    0,
                    2,
                    3,
                    4,
                    5,
                    9,
                    11,
                    12,
                    13
                ].indexOf(cType) !== -1) {
                    if (allowed[cType] !== true) throw new Mexp.Exception(cToken + " is not allowed after " + prevKey);
                    str.push(closingParObj);
                    allowed = type1;
                    asterick = type3Asterick;
                    ptc.pop();
                }
            } else break;
        }
        if (allowed[cType] !== true) throw new Mexp.Exception(cToken + " is not allowed after " + prevKey);
        if (asterick[cType] === true) {
            cType = 2;
            cEv = Mexp.math.mul;
            cShow = "&times;";
            cPre = 3;
            i = i - 1;
        }
        obj = {
            value: cEv,
            type: cType,
            pre: cPre,
            show: cShow,
            numberOfArguments: node.numberOfArguments
        };
        if (cType === 0) {
            allowed = type0;
            asterick = empty;
            inc(ptc, 2);
            str.push(obj);
            if (nodes[i + 1].type !== 4) {
                str.push(openingParObj);
                ptc.push(2);
            }
        // bracToClose++
        } else if (cType === 1) {
            if (pre.type === 1) {
                pre.value += cEv;
                inc(ptc, 1);
            } else str.push(obj);
            allowed = type1;
            asterick = type1Asterick;
        } else if (cType === 2) {
            allowed = type0;
            asterick = empty;
            inc(ptc, 2);
            str.push(obj);
        } else if (cType === 3) {
            // constant
            str.push(obj);
            allowed = type1;
            asterick = type3Asterick;
        } else if (cType === 4) {
            inc(ptc, 1);
            bracToClose++;
            allowed = type0;
            asterick = empty;
            str.push(obj);
        } else if (cType === 5) {
            if (!bracToClose) throw new Mexp.Exception("Closing parenthesis are more than opening one, wait What!!!");
            bracToClose--;
            allowed = type1;
            asterick = type3Asterick;
            str.push(obj);
            inc(ptc, 1);
        } else if (cType === 6) {
            if (pre.hasDec) throw new Mexp.Exception("Two decimals are not allowed in one number");
            if (pre.type !== 1) {
                pre = {
                    value: 0,
                    type: 1,
                    pre: 0
                } // pre needs to be changed as it will the last value now to be safe in later code
                ;
                str.push(pre);
            // inc(ptc, 1)
            }
            allowed = type6;
            inc(ptc, 1);
            asterick = empty;
            pre.value += cEv;
            pre.hasDec = true;
        } else if (cType === 7) {
            allowed = type1;
            asterick = type3Asterick;
            inc(ptc, 1);
            str.push(obj);
        }
        if (cType === 8) {
            allowed = type0;
            asterick = empty;
            inc(ptc, node.numberOfArguments + 2);
            str.push(obj);
            // str.push(openingParObj)
            if (nodes[i + 1].type !== 4) {
                str.push(openingParObj);
                ptc.push(node.numberOfArguments + 2);
            }
        } else if (cType === 9) {
            if (pre.type === 9) {
                if (pre.value === Mexp.math.add) {
                    pre.value = cEv;
                    pre.show = cShow;
                    inc(ptc, 1);
                } else if (pre.value === Mexp.math.sub && cShow === "-") {
                    pre.value = Mexp.math.add;
                    pre.show = "+";
                    inc(ptc, 1);
                }
            } else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) // changesign only when negative is found
            {
                if (cToken === "-") {
                    // do nothing for + token
                    // don't add with the above if statement as that will run the else statement of parent if on Ctoken +
                    allowed = type0;
                    asterick = empty;
                    inc(ptc, 2).push(2);
                    str.push(changeSignObj);
                    str.push(openingParObj);
                }
            } else {
                str.push(obj);
                inc(ptc, 2);
            }
            allowed = type0;
            asterick = empty;
        } else if (cType === 10) {
            allowed = type0;
            asterick = empty;
            inc(ptc, 2);
            str.push(obj);
        } else if (cType === 11) {
            allowed = type0;
            asterick = empty;
            str.push(obj);
        } else if (cType === 12) {
            allowed = type0;
            asterick = empty;
            inc(ptc, 6);
            str.push(obj);
            if (nodes[i + 1].type !== 4) {
                str.push(openingParObj);
                ptc.push(6);
            }
        } else if (cType === 13) {
            allowed = type1;
            asterick = type3Asterick;
            str.push(obj);
        }
        inc(ptc, -1);
        prevKey = cToken;
    }
    for(j = ptc.length; j--;)// loop over ptc
    str.push(closingParObj);
    if (allowed[5] !== true) throw new Mexp.Exception("complete the expression");
    while(bracToClose--)str.push(closingParObj);
    str.push(closingParObj);
    //        console.log(str);
    return new Mexp(str);
};
module.exports = Mexp;

},{"73774425d510e732":"cgZ8V"}],"cgZ8V":[function(require,module,exports) {
"use strict";
var Mexp = function Mexp(parsed) {
    this.value = parsed;
};
Mexp.math = {
    isDegree: true,
    acos: function acos(x) {
        return Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x);
    },
    add: function add(a, b) {
        return a + b;
    },
    asin: function asin(x) {
        return Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x);
    },
    atan: function atan(x) {
        return Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x);
    },
    acosh: function acosh(x) {
        return Math.log(x + Math.sqrt(x * x - 1));
    },
    asinh: function asinh(x) {
        return Math.log(x + Math.sqrt(x * x + 1));
    },
    atanh: function atanh(x) {
        return Math.log((1 + x) / (1 - x));
    },
    C: function C(n, r) {
        var pro = 1;
        var other = n - r;
        var choice = r;
        if (choice < other) {
            choice = other;
            other = r;
        }
        for(var i = choice + 1; i <= n; i++)pro *= i;
        return pro / Mexp.math.fact(other);
    },
    changeSign: function changeSign(x) {
        return -x;
    },
    cos: function cos(x) {
        if (Mexp.math.isDegree) x = Mexp.math.toRadian(x);
        return Math.cos(x);
    },
    cosh: function cosh(x) {
        return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2;
    },
    div: function div(a, b) {
        return a / b;
    },
    fact: function fact(n) {
        if (n % 1 !== 0) return "NaN";
        var pro = 1;
        for(var i = 2; i <= n; i++)pro *= i;
        return pro;
    },
    inverse: function inverse(x) {
        return 1 / x;
    },
    log: function log(i) {
        return Math.log(i) / Math.log(10);
    },
    mod: function mod(a, b) {
        return a % b;
    },
    mul: function mul(a, b) {
        return a * b;
    },
    P: function P(n, r) {
        var pro = 1;
        for(var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++)pro *= i;
        return pro;
    },
    Pi: function Pi(low, high, ex) {
        var pro = 1;
        for(var i = low; i <= high; i++)pro *= Number(ex.postfixEval({
            n: i
        }));
        return pro;
    },
    pow10x: function pow10x(e) {
        var x = 1;
        while(e--)x *= 10;
        return x;
    },
    sigma: function sigma(low, high, ex) {
        var sum = 0;
        for(var i = low; i <= high; i++)sum += Number(ex.postfixEval({
            n: i
        }));
        return sum;
    },
    sin: function sin(x) {
        if (Mexp.math.isDegree) x = Mexp.math.toRadian(x);
        return Math.sin(x);
    },
    sinh: function sinh(x) {
        return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2;
    },
    sub: function sub(a, b) {
        return a - b;
    },
    tan: function tan(x) {
        if (Mexp.math.isDegree) x = Mexp.math.toRadian(x);
        return Math.tan(x);
    },
    tanh: function tanh(x) {
        return Mexp.sinha(x) / Mexp.cosha(x);
    },
    toRadian: function toRadian(x) {
        return x * Math.PI / 180;
    },
    and: function and(a, b) {
        return a & b;
    }
};
Mexp.Exception = function(message) {
    this.message = message;
};
module.exports = Mexp;

},{}],"kfR0e":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("lodash/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var MEASUREMENT_ELEMENT_ID = "__react_svg_text_measurement_id";
function getStringWidth(str, style) {
    try {
        // Calculate length of each word to be used to determine number of words per line
        var textEl = document.getElementById(MEASUREMENT_ELEMENT_ID);
        if (!textEl) {
            var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            svg.setAttribute("aria-hidden", "true");
            svg.style.width = "0";
            svg.style.height = "0";
            svg.style.position = "absolute";
            svg.style.top = "-100%";
            svg.style.left = "-100%";
            textEl = document.createElementNS("http://www.w3.org/2000/svg", "text");
            textEl.setAttribute("id", MEASUREMENT_ELEMENT_ID);
            svg.appendChild(textEl);
            document.body.appendChild(svg);
        }
        Object.assign(textEl.style, style);
        textEl.textContent = str;
        return textEl.getComputedTextLength();
    } catch (e) {
        return null;
    }
}
exports.default = (0, _memoizeDefault.default)(getStringWidth, function(str, style) {
    return str + "_" + JSON.stringify(style);
});

},{"lodash/memoize":"7Smmx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Smmx":[function(require,module,exports) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"j6LDk"}],"j6LDk":[function(require,module,exports) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"guR3I","d2967b0e32ccfa56":"fHZ6F","ca21409ea89624c0":"f6SCu","f88fd07f8dd1f67d":"jGDSH","dbf3eae765642a3b":"lDsUu"}],"guR3I":[function(require,module,exports) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"jHPSk","a07dcf3fd3097a0c":"3VK03","92c01c953ef00ded":"4hBMF"}],"jHPSk":[function(require,module,exports) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"8moHX","bc25d439ccd1fb47":"uGUfj","f096b37295a92ab0":"8CKt5","d88173cbc6a133c8":"1aUg6","afb9b3bae0461cbf":"ionJk"}],"8moHX":[function(require,module,exports) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lYmkk"}],"lYmkk":[function(require,module,exports) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"61HS2"}],"61HS2":[function(require,module,exports) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"dxB5a","16db51a0e009bd8c":"8cWqb"}],"dxB5a":[function(require,module,exports) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"lL7Sy","cabbc2adfaeb27d9":"9imPR","cbb5703fe1562e7f":"hLnzN","388b819f47a43aa5":"d68Py"}],"lL7Sy":[function(require,module,exports) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"91G3G","3cba3c966459d528":"hLnzN"}],"91G3G":[function(require,module,exports) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"jz2jE","9b2aaf31b7bdd837":"899FY","46d5beb3375f8a28":"gGSCn"}],"jz2jE":[function(require,module,exports) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"psOEG"}],"psOEG":[function(require,module,exports) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"cd92e8811deaabf5":"3QhuJ"}],"3QhuJ":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"899FY":[function(require,module,exports) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"jz2jE"}],"gGSCn":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"hLnzN":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"9imPR":[function(require,module,exports) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"67awR"}],"67awR":[function(require,module,exports) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"psOEG"}],"d68Py":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"8cWqb":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"uGUfj":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"8CKt5":[function(require,module,exports) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lYmkk"}],"1aUg6":[function(require,module,exports) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lYmkk"}],"ionJk":[function(require,module,exports) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lYmkk"}],"3VK03":[function(require,module,exports) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"2REPD","b700cb849df2c166":"6k6US","d76dd90eead6cced":"dGUi7","3d210628ba60ec8":"lOx1c","76026bf2d4cfff93":"fezgG"}],"2REPD":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"6k6US":[function(require,module,exports) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"iySKu"}],"iySKu":[function(require,module,exports) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"edRiD"}],"edRiD":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"dGUi7":[function(require,module,exports) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"iySKu"}],"lOx1c":[function(require,module,exports) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"iySKu"}],"fezgG":[function(require,module,exports) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"iySKu"}],"4hBMF":[function(require,module,exports) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"ed0752fe9f482107":"61HS2","29224713b8d411e6":"psOEG"}],"fHZ6F":[function(require,module,exports) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"cih9s"}],"cih9s":[function(require,module,exports) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5ekqx"}],"5ekqx":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"f6SCu":[function(require,module,exports) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"cih9s"}],"jGDSH":[function(require,module,exports) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"cih9s"}],"lDsUu":[function(require,module,exports) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"cih9s"}],"efXXs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getLabelTransform;
});
var _orientation = require("../constants/orientation");
var _orientationDefault = parcelHelpers.interopDefault(_orientation);
function getLabelTransform(_ref) {
    var labelOffset = _ref.labelOffset, labelProps = _ref.labelProps, orientation = _ref.orientation, range = _ref.range, tickLabelFontSize = _ref.tickLabelFontSize, tickLength = _ref.tickLength;
    var sign = orientation === (0, _orientationDefault.default).left || orientation === (0, _orientationDefault.default).top ? -1 : 1;
    var x;
    var y;
    var transform;
    if (orientation === (0, _orientationDefault.default).top || orientation === (0, _orientationDefault.default).bottom) {
        var yBottomOffset = orientation === (0, _orientationDefault.default).bottom && typeof labelProps.fontSize === "number" ? labelProps.fontSize : 0;
        x = (Number(range[0]) + Number(range[range.length - 1])) / 2;
        y = sign * (tickLength + labelOffset + tickLabelFontSize + yBottomOffset);
    } else {
        x = sign * ((Number(range[0]) + Number(range[range.length - 1])) / 2);
        y = -(tickLength + labelOffset);
        transform = "rotate(" + sign * 90 + ")";
    }
    return {
        x: x,
        y: y,
        transform: transform
    };
}

},{"../constants/orientation":"jKJwV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jKJwV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var Orientation = {
    top: "top",
    left: "left",
    right: "right",
    bottom: "bottom"
};
exports.default = Orientation;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ZFbTf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Ticks;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _shape = require("@visx/shape");
var _group = require("@visx/group");
var _text = require("@visx/text");
var _orientation = require("../constants/orientation");
var _orientationDefault = parcelHelpers.interopDefault(_orientation);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Ticks(_ref) {
    var hideTicks = _ref.hideTicks, horizontal = _ref.horizontal, orientation = _ref.orientation, tickClassName = _ref.tickClassName, tickComponent = _ref.tickComponent, allTickLabelProps = _ref.tickLabelProps, _ref$tickStroke = _ref.tickStroke, tickStroke = _ref$tickStroke === void 0 ? "#222" : _ref$tickStroke, tickTransform = _ref.tickTransform, ticks = _ref.ticks, strokeWidth = _ref.strokeWidth, tickLineProps = _ref.tickLineProps;
    return ticks.map(function(_ref2) {
        var _allTickLabelProps$in;
        var value = _ref2.value, index = _ref2.index, from = _ref2.from, to = _ref2.to, formattedValue = _ref2.formattedValue;
        var tickLabelProps = (_allTickLabelProps$in = allTickLabelProps[index]) != null ? _allTickLabelProps$in : {};
        var tickLabelFontSize = Math.max(10, typeof tickLabelProps.fontSize === "number" && tickLabelProps.fontSize || 0);
        var tickYCoord = to.y + (horizontal && orientation !== (0, _orientationDefault.default).top ? tickLabelFontSize : 0);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
            key: "visx-tick-" + value + "-" + index,
            className: (0, _classnamesDefault.default)("visx-axis-tick", tickClassName),
            transform: tickTransform
        }, !hideTicks && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _shape.Line), _extends({
            from: from,
            to: to,
            stroke: tickStroke,
            strokeWidth: strokeWidth,
            strokeLinecap: "square"
        }, tickLineProps)), tickComponent ? tickComponent(_extends({}, tickLabelProps, {
            x: to.x,
            y: tickYCoord,
            formattedValue: formattedValue
        })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
            x: to.x,
            y: tickYCoord
        }, tickLabelProps), formattedValue));
    });
}

},{"react":"ktQNc","classnames":"aMKnv","@visx/shape":"5XPpo","@visx/group":"daSh2","@visx/text":"jlEhs","../constants/orientation":"jKJwV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6oAss":[function(require,module,exports) {
/**
 * Create a function that returns a tick position for the given tick value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTickPosition;
});
function getTickPosition(scale, align) {
    if (align === void 0) align = "center";
    // Broaden type before using 'xxx' in s as typeguard.
    var s = scale;
    // For point or band scales,
    // have to add offset to make the tick at center or end.
    if (align !== "start" && "bandwidth" in s) {
        var offset = s.bandwidth();
        if (align === "center") offset /= 2;
        if (s.round()) offset = Math.round(offset);
        return function(d) {
            var scaledValue = s(d);
            return typeof scaledValue === "number" ? scaledValue + offset : scaledValue;
        };
    }
    return scale;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2Jwi6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTickFormatter;
});
var _scale = require("@visx/scale");
function getTickFormatter(scale) {
    // Broaden type before using 'xxx' in s as typeguard.
    var s = scale;
    // For point or band scales,
    // have to add offset to make the tick centered.
    if ("tickFormat" in s) return s.tickFormat();
    return 0, _scale.toString;
}

},{"@visx/scale":"6Owz5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kkv7S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return createPoint;
});
var _point = require("@visx/point");
function createPoint(_ref, horizontal) {
    var x = _ref.x, y = _ref.y;
    return new (0, _point.Point)(horizontal ? {
        x: x,
        y: y
    } : {
        x: y,
        y: x
    });
}

},{"@visx/point":"dLEk7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dLEk7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Point", function() {
    return 0, _pointDefault.default;
});
parcelHelpers.export(exports, "sumPoints", function() {
    return 0, _sumPointsDefault.default;
});
parcelHelpers.export(exports, "subtractPoints", function() {
    return 0, _subtractPointsDefault.default;
});
var _point = require("./Point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _sumPoints = require("./sumPoints");
var _sumPointsDefault = parcelHelpers.interopDefault(_sumPoints);
var _subtractPoints = require("./subtractPoints");
var _subtractPointsDefault = parcelHelpers.interopDefault(_subtractPoints);

},{"./Point":"g9iId","./sumPoints":false,"./subtractPoints":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g9iId":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Point;
});
var Point = /*#__PURE__*/ function() {
    function Point(_ref) {
        var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y;
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    var _proto = Point.prototype;
    _proto.value = function value() {
        return {
            x: this.x,
            y: this.y
        };
    };
    _proto.toArray = function toArray() {
        return [
            this.x,
            this.y
        ];
    };
    return Point;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"irNES":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAxisRangePadding", function() {
    return defaultAxisRangePadding;
});
parcelHelpers.export(exports, "default", function() {
    return getAxisRangePaddingConfig;
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var defaultAxisRangePadding = 0;
function getAxisRangePaddingConfig(originalRangePadding) {
    if (originalRangePadding === void 0) originalRangePadding = defaultAxisRangePadding;
    return typeof originalRangePadding === "number" ? {
        start: originalRangePadding,
        end: originalRangePadding
    } : _extends({
        start: defaultAxisRangePadding,
        end: defaultAxisRangePadding
    }, originalRangePadding);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cCycn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "leftTickLabelProps", function() {
    return leftTickLabelProps;
});
parcelHelpers.export(exports, "default", function() {
    return AxisLeft;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _axis = require("./Axis");
var _axisDefault = parcelHelpers.interopDefault(_axis);
var _orientation = require("../constants/orientation");
var _orientationDefault = parcelHelpers.interopDefault(_orientation);
var _excluded = [
    "axisClassName",
    "labelOffset",
    "tickLabelProps",
    "tickLength"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var leftTickLabelProps = function leftTickLabelProps() {
    return {
        dx: "-0.25em",
        dy: "0.25em",
        fill: "#222",
        fontFamily: "Arial",
        fontSize: 10,
        textAnchor: "end"
    };
};
function AxisLeft(_ref) {
    var axisClassName = _ref.axisClassName, _ref$labelOffset = _ref.labelOffset, labelOffset = _ref$labelOffset === void 0 ? 36 : _ref$labelOffset, _ref$tickLabelProps = _ref.tickLabelProps, tickLabelProps = _ref$tickLabelProps === void 0 ? leftTickLabelProps : _ref$tickLabelProps, _ref$tickLength = _ref.tickLength, tickLength = _ref$tickLength === void 0 ? 8 : _ref$tickLength, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _axisDefault.default), _extends({
        axisClassName: (0, _classnamesDefault.default)("visx-axis-left", axisClassName),
        labelOffset: labelOffset,
        orientation: (0, _orientationDefault.default).left,
        tickLabelProps: tickLabelProps,
        tickLength: tickLength
    }, restProps));
}

},{"react":"ktQNc","classnames":"aMKnv","./Axis":"81gEj","../constants/orientation":"jKJwV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hiwzN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withTooltip", function() {
    return 0, _withTooltipDefault.default;
});
parcelHelpers.export(exports, "useTooltip", function() {
    return 0, _useTooltipDefault.default;
});
parcelHelpers.export(exports, "useTooltipInPortal", function() {
    return 0, _useTooltipInPortalDefault.default;
});
parcelHelpers.export(exports, "useTooltipPosition", function() {
    return 0, _tooltipPositionContext.useTooltipPosition;
});
parcelHelpers.export(exports, "TooltipPositionConsumer", function() {
    return 0, _tooltipPositionContext.TooltipPositionConsumer;
});
parcelHelpers.export(exports, "Tooltip", function() {
    return 0, _tooltipDefault.default;
});
parcelHelpers.export(exports, "defaultStyles", function() {
    return 0, _tooltip.defaultStyles;
});
parcelHelpers.export(exports, "TooltipWithBounds", function() {
    return 0, _tooltipWithBoundsDefault.default;
});
parcelHelpers.export(exports, "Portal", function() {
    return 0, _portalDefault.default;
});
var _withTooltip = require("./enhancers/withTooltip");
var _withTooltipDefault = parcelHelpers.interopDefault(_withTooltip);
var _useTooltip = require("./hooks/useTooltip");
var _useTooltipDefault = parcelHelpers.interopDefault(_useTooltip);
var _useTooltipInPortal = require("./hooks/useTooltipInPortal");
var _useTooltipInPortalDefault = parcelHelpers.interopDefault(_useTooltipInPortal);
var _tooltipPositionContext = require("./context/TooltipPositionContext");
var _tooltip = require("./tooltips/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipWithBounds = require("./tooltips/TooltipWithBounds");
var _tooltipWithBoundsDefault = parcelHelpers.interopDefault(_tooltipWithBounds);
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);

},{"./enhancers/withTooltip":false,"./hooks/useTooltip":"k7CFS","./hooks/useTooltipInPortal":"8K2Oc","./context/TooltipPositionContext":false,"./tooltips/Tooltip":"ovXrI","./tooltips/TooltipWithBounds":"ghVaO","./Portal":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k7CFS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useTooltip;
});
var _react = require("react");
var _excluded = [
    "tooltipOpen"
];
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function useTooltip(/** Optional initial TooltipState. */ initialTooltipState) {
    var _useState = (0, _react.useState)(_extends({
        tooltipOpen: false
    }, initialTooltipState)), tooltipState = _useState[0], setTooltipState = _useState[1];
    var showTooltip = (0, _react.useCallback)(function(showArgs) {
        return setTooltipState(typeof showArgs === "function" ? function(_ref) {
            var tooltipOpen = _ref.tooltipOpen, show = _objectWithoutPropertiesLoose(_ref, _excluded);
            return _extends({}, showArgs(show), {
                tooltipOpen: true
            });
        } : {
            tooltipOpen: true,
            tooltipLeft: showArgs.tooltipLeft,
            tooltipTop: showArgs.tooltipTop,
            tooltipData: showArgs.tooltipData
        });
    }, [
        setTooltipState
    ]);
    var hideTooltip = (0, _react.useCallback)(function() {
        return setTooltipState({
            tooltipOpen: false,
            tooltipLeft: undefined,
            tooltipTop: undefined,
            tooltipData: undefined
        });
    }, [
        setTooltipState
    ]);
    return {
        tooltipOpen: tooltipState.tooltipOpen,
        tooltipLeft: tooltipState.tooltipLeft,
        tooltipTop: tooltipState.tooltipTop,
        tooltipData: tooltipState.tooltipData,
        updateTooltip: setTooltipState,
        showTooltip: showTooltip,
        hideTooltip: hideTooltip
    };
}

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8K2Oc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useTooltipInPortal;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactUseMeasure = require("react-use-measure");
var _reactUseMeasureDefault = parcelHelpers.interopDefault(_reactUseMeasure);
var _portal = require("../Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _tooltip = require("../tooltips/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipWithBounds = require("../tooltips/TooltipWithBounds");
var _tooltipWithBoundsDefault = parcelHelpers.interopDefault(_tooltipWithBounds);
var _excluded = [
    "detectBounds",
    "zIndex"
], _excluded2 = [
    "left",
    "top",
    "detectBounds",
    "zIndex"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function useTooltipInPortal(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$detectBounds = _ref.detectBounds, detectBoundsOption = _ref$detectBounds === void 0 ? true : _ref$detectBounds, zIndexOption = _ref.zIndex, useMeasureOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useMeasure = (0, _reactUseMeasureDefault.default)(useMeasureOptions), containerRef = _useMeasure[0], containerBounds = _useMeasure[1], forceRefreshBounds = _useMeasure[2];
    var TooltipInPortal = (0, _react.useMemo)(function() {
        return function(_ref2) {
            var _ref2$left = _ref2.left, containerLeft = _ref2$left === void 0 ? 0 : _ref2$left, _ref2$top = _ref2.top, containerTop = _ref2$top === void 0 ? 0 : _ref2$top, detectBoundsProp = _ref2.detectBounds, zIndexProp = _ref2.zIndex, tooltipProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
            var detectBounds = detectBoundsProp == null ? detectBoundsOption : detectBoundsProp;
            var zIndex = zIndexProp == null ? zIndexOption : zIndexProp;
            var TooltipComponent = detectBounds ? (0, _tooltipWithBoundsDefault.default) : (0, _tooltipDefault.default);
            // convert container coordinates to page coordinates
            var portalLeft = containerLeft + (containerBounds.left || 0) + window.scrollX;
            var portalTop = containerTop + (containerBounds.top || 0) + window.scrollY;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalDefault.default), {
                zIndex: zIndex
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement(TooltipComponent, _extends({
                left: portalLeft,
                top: portalTop
            }, tooltipProps)));
        };
    }, [
        detectBoundsOption,
        zIndexOption,
        containerBounds.left,
        containerBounds.top
    ]);
    return {
        containerRef: containerRef,
        containerBounds: containerBounds,
        forceRefreshBounds: forceRefreshBounds,
        TooltipInPortal: TooltipInPortal
    };
}

},{"react":"ktQNc","react-use-measure":"f7qfe","../Portal":"3h2YD","../tooltips/Tooltip":"ovXrI","../tooltips/TooltipWithBounds":"ghVaO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f7qfe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useMeasure;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _debounce = require("debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
function useMeasure(_temp) {
    var _ref = _temp === void 0 ? {
        debounce: 0,
        scroll: false,
        offsetSize: false
    } : _temp, debounce = _ref.debounce, scroll = _ref.scroll, polyfill = _ref.polyfill, offsetSize = _ref.offsetSize;
    var ResizeObserver = polyfill || (typeof window === "undefined" ? function ResizeObserver() {
        "use strict";
        (0, _classCallCheck._)(this, ResizeObserver);
    } : window.ResizeObserver);
    if (!ResizeObserver) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), 2), bounds = _useState[0], set = _useState[1]; // keep all state in a ref
    var state = (0, _react.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: bounds
    }); // set actual debounce values early, so effects know if they should react accordingly
    var scrollDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.scroll : null;
    var resizeDebounce = debounce ? typeof debounce === "number" ? debounce : debounce.resize : null; // make sure to update state only as long as the component is truly mounted
    var mounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        mounted.current = true;
        return function() {
            return void (mounted.current = false);
        };
    }); // memoize handlers, so event-listeners know when they should update
    var _useMemo = (0, _slicedToArray._)((0, _react.useMemo)(function() {
        var callback = function() {
            if (!state.current.element) return;
            var _state_current_element_getBoundingClientRect = state.current.element.getBoundingClientRect(), left = _state_current_element_getBoundingClientRect.left, top = _state_current_element_getBoundingClientRect.top, width = _state_current_element_getBoundingClientRect.width, height = _state_current_element_getBoundingClientRect.height, bottom = _state_current_element_getBoundingClientRect.bottom, right = _state_current_element_getBoundingClientRect.right, x = _state_current_element_getBoundingClientRect.x, y = _state_current_element_getBoundingClientRect.y;
            var size = {
                left: left,
                top: top,
                width: width,
                height: height,
                bottom: bottom,
                right: right,
                x: x,
                y: y
            };
            if (state.current.element instanceof HTMLElement && offsetSize) {
                size.height = state.current.element.offsetHeight;
                size.width = state.current.element.offsetWidth;
            }
            Object.freeze(size);
            if (mounted.current && !areBoundsEqual(state.current.lastBounds, size)) set(state.current.lastBounds = size);
        };
        return [
            callback,
            resizeDebounce ? (0, _debounceDefault.default)(callback, resizeDebounce) : callback,
            scrollDebounce ? (0, _debounceDefault.default)(callback, scrollDebounce) : callback
        ];
    }, [
        set,
        offsetSize,
        scrollDebounce,
        resizeDebounce
    ]), 3), forceRefresh = _useMemo[0], resizeChange = _useMemo[1], scrollChange = _useMemo[2]; // cleanup current scroll-listeners / observers
    function removeListeners() {
        if (state.current.scrollContainers) {
            state.current.scrollContainers.forEach(function(element) {
                return element.removeEventListener("scroll", scrollChange, true);
            });
            state.current.scrollContainers = null;
        }
        if (state.current.resizeObserver) {
            state.current.resizeObserver.disconnect();
            state.current.resizeObserver = null;
        }
    } // add scroll-listeners / observers
    function addListeners() {
        if (!state.current.element) return;
        state.current.resizeObserver = new ResizeObserver(scrollChange);
        state.current.resizeObserver.observe(state.current.element);
        if (scroll && state.current.scrollContainers) state.current.scrollContainers.forEach(function(scrollContainer) {
            return scrollContainer.addEventListener("scroll", scrollChange, {
                capture: true,
                passive: true
            });
        });
    } // the ref we expose to the user
    var ref = function(node) {
        if (!node || node === state.current.element) return;
        removeListeners();
        state.current.element = node;
        state.current.scrollContainers = findScrollContainers(node);
        addListeners();
    }; // add general event listeners
    useOnWindowScroll(scrollChange, Boolean(scroll));
    useOnWindowResize(resizeChange); // respond to changes that are relevant for the listeners
    (0, _react.useEffect)(function() {
        removeListeners();
        addListeners();
    }, [
        scroll,
        scrollChange,
        resizeChange
    ]); // remove all listeners when the components unmounts
    (0, _react.useEffect)(function() {
        return removeListeners;
    }, []);
    return [
        ref,
        bounds,
        forceRefresh
    ];
} // Adds native resize listener to window
function useOnWindowResize(onWindowResize) {
    (0, _react.useEffect)(function() {
        var cb = onWindowResize;
        window.addEventListener("resize", cb);
        return function() {
            return void window.removeEventListener("resize", cb);
        };
    }, [
        onWindowResize
    ]);
}
function useOnWindowScroll(onScroll, enabled) {
    (0, _react.useEffect)(function() {
        if (enabled) {
            var cb = onScroll;
            window.addEventListener("scroll", cb, {
                capture: true,
                passive: true
            });
            return function() {
                return void window.removeEventListener("scroll", cb, true);
            };
        }
    }, [
        onScroll,
        enabled
    ]);
} // Returns a list of scroll offsets
function findScrollContainers(element) {
    var result = [];
    if (!element || element === document.body) return result;
    var _window_getComputedStyle = window.getComputedStyle(element), overflow = _window_getComputedStyle.overflow, overflowX = _window_getComputedStyle.overflowX, overflowY = _window_getComputedStyle.overflowY;
    if ([
        overflow,
        overflowX,
        overflowY
    ].some(function(prop) {
        return prop === "auto" || prop === "scroll";
    })) result.push(element);
    return (0, _toConsumableArray._)(result).concat((0, _toConsumableArray._)(findScrollContainers(element.parentElement)));
} // Checks if element boundaries are equal
var keys = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
];
var areBoundsEqual = function(a, b) {
    return keys.every(function(key) {
        return a[key] === b[key];
    });
};

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","debounce":"hxL4X","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hxL4X":[function(require,module,exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function debounced() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
debounce.debounce = debounce;
module.exports = debounce;

},{}],"3h2YD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Portal;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
/** Render within a portal using a declarative component API. */ var Portal = /*#__PURE__*/ function(_React$PureComponent) {
    _inheritsLoose(Portal, _React$PureComponent);
    function Portal() {
        return _React$PureComponent.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.node && document.body) {
            document.body.removeChild(this.node);
            delete this.node;
        }
    };
    _proto.render = function render() {
        // SSR check
        if (!this.node && typeof document !== "undefined") {
            this.node = document.createElement("div");
            if (this.props.zIndex != null) this.node.style.zIndex = "" + this.props.zIndex;
            document.body.append(this.node);
        }
        if (!this.node) return null;
        return /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(this.props.children, this.node);
    };
    return Portal;
}((0, _reactDefault.default).PureComponent);
Portal.propTypes = {
    zIndex: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).string
    ])
};

},{"prop-types":"8INHm","react":"ktQNc","react-dom":"lyZO5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ovXrI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultStyles", function() {
    return defaultStyles;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _excluded = [
    "className",
    "top",
    "left",
    "offsetLeft",
    "offsetTop",
    "style",
    "children",
    "unstyled",
    "applyPositionStyle"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultStyles = {
    position: "absolute",
    backgroundColor: "white",
    color: "#666666",
    padding: ".3rem .5rem",
    borderRadius: "3px",
    fontSize: "14px",
    boxShadow: "0 1px 2px rgba(33,33,33,0.2)",
    lineHeight: "1em",
    pointerEvents: "none"
};
var Tooltip = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(_ref, ref) {
    var className = _ref.className, top = _ref.top, left = _ref.left, _ref$offsetLeft = _ref.offsetLeft, offsetLeft = _ref$offsetLeft === void 0 ? 10 : _ref$offsetLeft, _ref$offsetTop = _ref.offsetTop, offsetTop = _ref$offsetTop === void 0 ? 10 : _ref$offsetTop, _ref$style = _ref.style, style = _ref$style === void 0 ? defaultStyles : _ref$style, children = _ref.children, _ref$unstyled = _ref.unstyled, unstyled = _ref$unstyled === void 0 ? false : _ref$unstyled, _ref$applyPositionSty = _ref.applyPositionStyle, applyPositionStyle = _ref$applyPositionSty === void 0 ? false : _ref$applyPositionSty, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        ref: ref,
        className: (0, _classnamesDefault.default)("visx-tooltip", className),
        style: _extends({
            top: top == null || offsetTop == null ? top : top + offsetTop,
            left: left == null || offsetLeft == null ? left : left + offsetLeft
        }, applyPositionStyle && {
            position: "absolute"
        }, !unstyled && style)
    }, restProps), children);
});
Tooltip.propTypes = {
    children: (0, _propTypesDefault.default).node,
    className: (0, _propTypesDefault.default).string,
    left: (0, _propTypesDefault.default).number,
    offsetLeft: (0, _propTypesDefault.default).number,
    offsetTop: (0, _propTypesDefault.default).number,
    top: (0, _propTypesDefault.default).number,
    applyPositionStyle: (0, _propTypesDefault.default).bool,
    unstyled: (0, _propTypesDefault.default).bool
};
Tooltip.displayName = "Tooltip";
exports.default = Tooltip;

},{"prop-types":"8INHm","react":"ktQNc","classnames":"aMKnv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ghVaO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bounds = require("@visx/bounds");
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipPositionContext = require("../context/TooltipPositionContext");
var _excluded = [
    "children",
    "getRects",
    "left",
    "offsetLeft",
    "offsetTop",
    "parentRect",
    "rect",
    "style",
    "top",
    "unstyled",
    "nodeRef"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TooltipWithBounds(_ref) {
    var children = _ref.children, getRects = _ref.getRects, _ref$left = _ref.left, initialLeft = _ref$left === void 0 ? 0 : _ref$left, _ref$offsetLeft = _ref.offsetLeft, offsetLeft = _ref$offsetLeft === void 0 ? 10 : _ref$offsetLeft, _ref$offsetTop = _ref.offsetTop, offsetTop = _ref$offsetTop === void 0 ? 10 : _ref$offsetTop, parentBounds = _ref.parentRect, ownBounds = _ref.rect, _ref$style = _ref.style, style = _ref$style === void 0 ? (0, _tooltip.defaultStyles) : _ref$style, _ref$top = _ref.top, initialTop = _ref$top === void 0 ? 0 : _ref$top, _ref$unstyled = _ref.unstyled, unstyled = _ref$unstyled === void 0 ? false : _ref$unstyled, nodeRef = _ref.nodeRef, otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var transform;
    var placeTooltipLeft = false;
    var placeTooltipUp = false;
    if (ownBounds && parentBounds) {
        var left = initialLeft;
        var top = initialTop;
        if (parentBounds.width) {
            var rightPlacementClippedPx = left + offsetLeft + ownBounds.width - parentBounds.width;
            var leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = rightPlacementClippedPx > 0 && rightPlacementClippedPx > leftPlacementClippedPx;
        } else {
            var _rightPlacementClippedPx = left + offsetLeft + ownBounds.width - window.innerWidth;
            var _leftPlacementClippedPx = ownBounds.width - left - offsetLeft;
            placeTooltipLeft = _rightPlacementClippedPx > 0 && _rightPlacementClippedPx > _leftPlacementClippedPx;
        }
        if (parentBounds.height) {
            var bottomPlacementClippedPx = top + offsetTop + ownBounds.height - parentBounds.height;
            var topPlacementClippedPx = ownBounds.height - top - offsetTop;
            placeTooltipUp = bottomPlacementClippedPx > 0 && bottomPlacementClippedPx > topPlacementClippedPx;
        } else placeTooltipUp = top + offsetTop + ownBounds.height > window.innerHeight;
        left = placeTooltipLeft ? left - ownBounds.width - offsetLeft : left + offsetLeft;
        top = placeTooltipUp ? top - ownBounds.height - offsetTop : top + offsetTop;
        left = Math.round(left);
        top = Math.round(top);
        transform = "translate(" + left + "px, " + top + "px)";
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipDefault.default), _extends({
        ref: nodeRef,
        style: _extends({
            left: 0,
            top: 0,
            transform: transform
        }, !unstyled && style)
    }, otherProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipPositionContext.TooltipPositionProvider), {
        value: {
            isFlippedVertically: !placeTooltipUp,
            isFlippedHorizontally: !placeTooltipLeft
        }
    }, children));
}
TooltipWithBounds.propTypes = {
    nodeRef: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).object
    ])
};
exports.default = (0, _bounds.withBoundingRects)(TooltipWithBounds);

},{"prop-types":"8INHm","react":"ktQNc","@visx/bounds":"4m0HM","./Tooltip":"ovXrI","../context/TooltipPositionContext":"5hAZK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4m0HM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withBoundingRects", function() {
    return 0, _withBoundingRectsDefault.default;
});
var _withBoundingRects = require("./enhancers/withBoundingRects");
var _withBoundingRectsDefault = parcelHelpers.interopDefault(_withBoundingRects);

},{"./enhancers/withBoundingRects":"k5RvO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k5RvO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return withBoundingRects;
});
/* eslint react/no-did-mount-set-state: 0, react/no-find-dom-node: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var emptyRect = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0
};
function withBoundingRects(BaseComponent) {
    var _class;
    return _class = /*#__PURE__*/ function(_React$PureComponent) {
        _inheritsLoose(WrappedComponent, _React$PureComponent);
        function WrappedComponent(props) {
            var _this;
            _this = _React$PureComponent.call(this, props) || this;
            _this.state = {
                rect: undefined,
                parentRect: undefined
            };
            _this.nodeRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
            _this.getRects = _this.getRects.bind(_assertThisInitialized(_this));
            return _this;
        }
        var _proto = WrappedComponent.prototype;
        _proto.componentDidMount = function componentDidMount() {
            var _this$nodeRef, _this2 = this;
            this.node = (_this$nodeRef = this.nodeRef) != null && _this$nodeRef.current ? this.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
            this.setState(function() {
                return _this2.getRects();
            });
        };
        _proto.getRects = function getRects() {
            if (!this.node) return this.state;
            var node = this.node;
            var parentNode = node.parentNode;
            var rect = node.getBoundingClientRect ? node.getBoundingClientRect() : emptyRect;
            var parentRect = parentNode != null && parentNode.getBoundingClientRect ? parentNode.getBoundingClientRect() : emptyRect;
            return {
                rect: rect,
                parentRect: parentRect
            };
        };
        _proto.render = function render() {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(BaseComponent, _extends({
                nodeRef: this.nodeRef,
                getRects: this.getRects
            }, this.state, this.props));
        };
        return WrappedComponent;
    }((0, _reactDefault.default).PureComponent), _class.displayName = "withBoundingRects(" + (BaseComponent.displayName || "") + ")", _class;
}

},{"react":"ktQNc","react-dom":"lyZO5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5hAZK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipPositionProvider", function() {
    return TooltipPositionProvider;
});
parcelHelpers.export(exports, "TooltipPositionConsumer", function() {
    return TooltipPositionConsumer;
});
parcelHelpers.export(exports, "useTooltipPosition", function() {
    return useTooltipPosition;
});
var _react = require("react");
var TooltipPositionContext = /*#__PURE__*/ (0, _react.createContext)({
    isFlippedVertically: false,
    isFlippedHorizontally: false
});
var TooltipPositionProvider = TooltipPositionContext.Provider;
var TooltipPositionConsumer = TooltipPositionContext.Consumer;
var useTooltipPosition = function useTooltipPosition() {
    return (0, _react.useContext)(TooltipPositionContext);
};

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"N20PK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localPoint", function() {
    return 0, _localPointDefault.default;
});
parcelHelpers.export(exports, "touchPoint", function() {
    return 0, _touchPointDefault.default;
});
var _localPoint = require("./localPoint");
var _localPointDefault = parcelHelpers.interopDefault(_localPoint);
var _touchPoint = require("./touchPoint");
var _touchPointDefault = parcelHelpers.interopDefault(_touchPoint);

},{"./localPoint":"bXsxG","./touchPoint":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bXsxG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return localPoint;
});
var _localPointGeneric = require("./localPointGeneric");
var _localPointGenericDefault = parcelHelpers.interopDefault(_localPointGeneric);
var _typeGuards = require("./typeGuards");
function localPoint(nodeOrEvent, maybeEvent) {
    // localPoint(node, event)
    if ((0, _typeGuards.isElement)(nodeOrEvent) && maybeEvent) return (0, _localPointGenericDefault.default)(nodeOrEvent, maybeEvent);
    // localPoint(event)
    if ((0, _typeGuards.isEvent)(nodeOrEvent)) {
        var event = nodeOrEvent;
        var node = event.target;
        if (node) return (0, _localPointGenericDefault.default)(node, event);
    }
    return null;
}

},{"./localPointGeneric":"aeuPx","./typeGuards":"ihh83","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aeuPx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return localPoint;
});
var _point = require("@visx/point");
var _typeGuards = require("./typeGuards");
var _getXAndYFromEvent = require("./getXAndYFromEvent");
var _getXAndYFromEventDefault = parcelHelpers.interopDefault(_getXAndYFromEvent);
function localPoint(node, event) {
    if (!node || !event) return null;
    var coords = (0, _getXAndYFromEventDefault.default)(event);
    // find top-most SVG
    var svg = (0, _typeGuards.isSVGElement)(node) ? node.ownerSVGElement : node;
    var screenCTM = (0, _typeGuards.isSVGGraphicsElement)(svg) ? svg.getScreenCTM() : null;
    if ((0, _typeGuards.isSVGSVGElement)(svg) && screenCTM) {
        var point = svg.createSVGPoint();
        point.x = coords.x;
        point.y = coords.y;
        point = point.matrixTransform(screenCTM.inverse());
        return new (0, _point.Point)({
            x: point.x,
            y: point.y
        });
    }
    // fall back to bounding box
    var rect = node.getBoundingClientRect();
    return new (0, _point.Point)({
        x: coords.x - rect.left - node.clientLeft,
        y: coords.y - rect.top - node.clientTop
    });
}

},{"@visx/point":"dLEk7","./typeGuards":"ihh83","./getXAndYFromEvent":"7xOxJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ihh83":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
// functional definition of isSVGElement. Note that SVGSVGElements are HTMLElements
parcelHelpers.export(exports, "isSVGElement", function() {
    return isSVGElement;
});
// functional definition of SVGGElement
parcelHelpers.export(exports, "isSVGSVGElement", function() {
    return isSVGSVGElement;
});
parcelHelpers.export(exports, "isSVGGraphicsElement", function() {
    return isSVGGraphicsElement;
});
// functional definition of TouchEvent
parcelHelpers.export(exports, "isTouchEvent", function() {
    return isTouchEvent;
});
// functional definition of MouseEvent
parcelHelpers.export(exports, "isMouseEvent", function() {
    return isMouseEvent;
});
// functional definition of event
parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
function isElement(elem) {
    return !!elem && elem instanceof Element;
}
function isSVGElement(elem) {
    return !!elem && (elem instanceof SVGElement || "ownerSVGElement" in elem);
}
function isSVGSVGElement(elem) {
    return !!elem && "createSVGPoint" in elem;
}
function isSVGGraphicsElement(elem) {
    return !!elem && "getScreenCTM" in elem;
}
function isTouchEvent(event) {
    return !!event && "changedTouches" in event;
}
function isMouseEvent(event) {
    return !!event && "clientX" in event;
}
function isEvent(event) {
    return !!event && (event instanceof Event || "nativeEvent" in event && event.nativeEvent instanceof Event);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7xOxJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getXAndYFromEvent;
});
var _typeGuards = require("./typeGuards");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var DEFAULT_POINT = {
    x: 0,
    y: 0
};
function getXAndYFromEvent(event) {
    if (!event) return _extends({}, DEFAULT_POINT);
    if ((0, _typeGuards.isTouchEvent)(event)) return event.changedTouches.length > 0 ? {
        x: event.changedTouches[0].clientX,
        y: event.changedTouches[0].clientY
    } : _extends({}, DEFAULT_POINT);
    if ((0, _typeGuards.isMouseEvent)(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    // for focus events try to extract the center position of the target element
    var target = event == null ? void 0 : event.target;
    var boundingClientRect = target && "getBoundingClientRect" in target ? target.getBoundingClientRect() : null;
    if (!boundingClientRect) return _extends({}, DEFAULT_POINT);
    return {
        x: boundingClientRect.x + boundingClientRect.width / 2,
        y: boundingClientRect.y + boundingClientRect.height / 2
    };
}

},{"./typeGuards":"ihh83","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7X5Oe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides left axis and vertical lines for the `HorizontalBarChart` component.
 */ parcelHelpers.export(exports, "MeasurementRows", function() {
    return MeasurementRows;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axis = require("@visx/axis");
var _text = require("@visx/text");
var _tooltip = require("@visx/tooltip");
var _grid = require("@visx/grid");
var _horizontalBarChartStyles = require("./HorizontalBarChart.styles");
function MeasurementRows(param) {
    var axisProps = param.axisProps, color = param.color, data = param.data, tickProps = param.tickProps, verticalLinesToShow = param.verticalLinesToShow, xScale = param.xScale, yAxisKey = param.yAxisKey, yMax = param.yMax, yScale = param.yScale;
    var _useTooltipInPortal = (0, _tooltip.useTooltipInPortal)(), containerBounds = _useTooltipInPortal.containerBounds, TooltipInPortal = _useTooltipInPortal.TooltipInPortal;
    var _useTooltip = (0, _tooltip.useTooltip)(), showTooltip = _useTooltip.showTooltip, hideTooltip = _useTooltip.hideTooltip, tooltipData = _useTooltip.tooltipData, _useTooltip_tooltipLeft = _useTooltip.tooltipLeft, tooltipLeft = _useTooltip_tooltipLeft === void 0 ? 0 : _useTooltip_tooltipLeft, _useTooltip_tooltipTop = _useTooltip.tooltipTop, tooltipTop = _useTooltip_tooltipTop === void 0 ? 0 : _useTooltip_tooltipTop;
    // https://airbnb.io/visx/tooltip
    var handlePointerMove = (0, _react.useCallback)(function(event, value) {
        var containerX = ("clientX" in event ? event.clientX : 0) - containerBounds.left;
        var containerY = ("clientY" in event ? event.clientY : 0) - containerBounds.top;
        showTooltip({
            tooltipLeft: containerX,
            tooltipTop: containerY - 10,
            tooltipData: value
        });
    }, [
        showTooltip,
        containerBounds
    ]);
    var customTick = function() {
        var formattedValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", x = arguments.length > 1 ? arguments[1] : void 0, y = arguments.length > 2 ? arguments[2] : void 0;
        var className = data.find(function(datum) {
            return datum[yAxisKey] === formattedValue;
        }).className;
        var maxChars = 20;
        var trimmedValue = formattedValue.length <= maxChars ? formattedValue : formattedValue.substr(0, maxChars).concat("...");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), (0, _objectSpreadProps._)((0, _objectSpread._)({}, tickProps), {
            className: className || "",
            x: x,
            y: y,
            dx: "-0.65em",
            dy: -1,
            textAnchor: "end",
            verticalAnchor: "middle",
            onPointerMove: function(e) {
                return handlePointerMove(e, formattedValue);
            },
            onPointerLeave: function() {
                return hideTooltip();
            },
            children: trimmedValue
        }));
    };
    var tickLength = 7;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
        style: {
            color: color
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", (0, _objectSpread._)({
                x1: 0,
                y1: 1,
                x2: -tickLength,
                y2: 1
            }, axisProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", (0, _objectSpread._)({
                x1: 0,
                y1: yMax,
                x2: -tickLength,
                y2: yMax
            }, axisProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TooltipInPortal, {
                style: (0, _horizontalBarChartStyles.tooltipStyles),
                left: tooltipLeft,
                top: tooltipTop,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "tooltip",
                    children: tooltipData
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _axis.Axis), (0, _objectSpreadProps._)((0, _objectSpread._)({}, axisProps), {
                axisClassName: "left-axis-container",
                orientation: "left",
                left: 0,
                scale: yScale,
                numTicks: data.length,
                tickLength: tickLength,
                tickStroke: "currentColor",
                tickComponent: function(tickValues) {
                    return customTick(tickValues.formattedValue, tickValues.x, tickValues.y);
                }
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grid.GridColumns), {
                scale: xScale,
                height: yMax,
                numTicks: verticalLinesToShow,
                stroke: "currentColor",
                strokeOpacity: 0.4,
                pointerEvents: "none"
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","@visx/axis":"gF8iV","@visx/text":"jlEhs","@visx/tooltip":"hiwzN","@visx/grid":"5w0HZ","./HorizontalBarChart.styles":"BRR5j","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5w0HZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridRows", function() {
    return 0, _gridRowsDefault.default;
});
parcelHelpers.export(exports, "GridColumns", function() {
    return 0, _gridColumnsDefault.default;
});
parcelHelpers.export(exports, "Grid", function() {
    return 0, _gridDefault.default;
});
parcelHelpers.export(exports, "GridAngle", function() {
    return 0, _gridAngleDefault.default;
});
parcelHelpers.export(exports, "GridRadial", function() {
    return 0, _gridRadialDefault.default;
});
parcelHelpers.export(exports, "GridPolar", function() {
    return 0, _gridPolarDefault.default;
});
var _gridRows = require("./grids/GridRows");
var _gridRowsDefault = parcelHelpers.interopDefault(_gridRows);
var _gridColumns = require("./grids/GridColumns");
var _gridColumnsDefault = parcelHelpers.interopDefault(_gridColumns);
var _grid = require("./grids/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridAngle = require("./grids/GridAngle");
var _gridAngleDefault = parcelHelpers.interopDefault(_gridAngle);
var _gridRadial = require("./grids/GridRadial");
var _gridRadialDefault = parcelHelpers.interopDefault(_gridRadial);
var _gridPolar = require("./grids/GridPolar");
var _gridPolarDefault = parcelHelpers.interopDefault(_gridPolar);

},{"./grids/GridRows":"1DlG1","./grids/GridColumns":"2X6Jn","./grids/Grid":false,"./grids/GridAngle":false,"./grids/GridRadial":false,"./grids/GridPolar":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1DlG1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return GridRows;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _line = require("@visx/shape/lib/shapes/Line");
var _lineDefault = parcelHelpers.interopDefault(_line);
var _group = require("@visx/group");
var _point = require("@visx/point");
var _scale = require("@visx/scale");
var _getScaleBandwidth = require("../utils/getScaleBandwidth");
var _getScaleBandwidthDefault = parcelHelpers.interopDefault(_getScaleBandwidth);
var _excluded = [
    "top",
    "left",
    "scale",
    "width",
    "stroke",
    "strokeWidth",
    "strokeDasharray",
    "className",
    "children",
    "numTicks",
    "lineStyle",
    "offset",
    "tickValues"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function GridRows(_ref) {
    var _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, width = _ref.width, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, children = _ref.children, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset = _ref.offset, tickValues = _ref.tickValues, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var ticks = tickValues != null ? tickValues : (0, _scale.getTicks)(scale, numTicks);
    var scaleOffset = (offset != null ? offset : 0) + (0, _getScaleBandwidthDefault.default)(scale) / 2;
    var tickLines = ticks.map(function(d, index) {
        var _coerceNumber;
        var y = ((_coerceNumber = (0, _scale.coerceNumber)(scale(d))) != null ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, _point.Point)({
                x: 0,
                y: y
            }),
            to: new (0, _point.Point)({
                x: width,
                y: y
            })
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        className: (0, _classnamesDefault.default)("visx-rows", className),
        top: top,
        left: left
    }, children ? children({
        lines: tickLines
    }) : tickLines.map(function(_ref2) {
        var from = _ref2.from, to = _ref2.to, index = _ref2.index;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lineDefault.default), _extends({
            key: "row-line-" + index,
            from: from,
            to: to,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            style: lineStyle
        }, restProps));
    }));
}
GridRows.propTypes = {
    tickValues: (0, _propTypesDefault.default).array,
    width: (0, _propTypesDefault.default).number.isRequired
};

},{"prop-types":"8INHm","react":"ktQNc","classnames":"aMKnv","@visx/shape/lib/shapes/Line":"3nRag","@visx/group":"daSh2","@visx/point":"dLEk7","@visx/scale":"6Owz5","../utils/getScaleBandwidth":"lJ9rU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3nRag":[function(require,module,exports) {
"use strict";
exports.__esModule = true;
exports.default = Line;
var _react = _interopRequireDefault(require("d39bc081760bc3ba"));
var _classnames = _interopRequireDefault(require("2e95abb1284a9792"));
var _excluded = [
    "from",
    "to",
    "fill",
    "className",
    "innerRef"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Line(_ref) {
    var _ref$from = _ref.from, from = _ref$from === void 0 ? {
        x: 0,
        y: 0
    } : _ref$from, _ref$to = _ref.to, to = _ref$to === void 0 ? {
        x: 1,
        y: 1
    } : _ref$to, _ref$fill = _ref.fill, fill = _ref$fill === void 0 ? "transparent" : _ref$fill, className = _ref.className, innerRef = _ref.innerRef, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var isRectilinear = from.x === to.x || from.y === to.y;
    return /*#__PURE__*/ _react.default.createElement("line", _extends({
        ref: innerRef,
        className: (0, _classnames.default)("visx-line", className),
        x1: from.x,
        y1: from.y,
        x2: to.x,
        y2: to.y,
        fill: fill,
        shapeRendering: isRectilinear ? "crispEdges" : "auto"
    }, restProps));
}

},{"d39bc081760bc3ba":"ktQNc","2e95abb1284a9792":"aMKnv"}],"lJ9rU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getScaleBandwidth;
});
function getScaleBandwidth(scale) {
    return "bandwidth" in scale ? scale.bandwidth() : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2X6Jn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return GridColumns;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _line = require("@visx/shape/lib/shapes/Line");
var _lineDefault = parcelHelpers.interopDefault(_line);
var _group = require("@visx/group");
var _point = require("@visx/point");
var _scale = require("@visx/scale");
var _getScaleBandwidth = require("../utils/getScaleBandwidth");
var _getScaleBandwidthDefault = parcelHelpers.interopDefault(_getScaleBandwidth);
var _excluded = [
    "top",
    "left",
    "scale",
    "height",
    "stroke",
    "strokeWidth",
    "strokeDasharray",
    "className",
    "numTicks",
    "lineStyle",
    "offset",
    "tickValues",
    "children"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function GridColumns(_ref) {
    var _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, scale = _ref.scale, height = _ref.height, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? "#eaf0f6" : _ref$stroke, _ref$strokeWidth = _ref.strokeWidth, strokeWidth = _ref$strokeWidth === void 0 ? 1 : _ref$strokeWidth, strokeDasharray = _ref.strokeDasharray, className = _ref.className, _ref$numTicks = _ref.numTicks, numTicks = _ref$numTicks === void 0 ? 10 : _ref$numTicks, lineStyle = _ref.lineStyle, offset = _ref.offset, tickValues = _ref.tickValues, children = _ref.children, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var ticks = tickValues != null ? tickValues : (0, _scale.getTicks)(scale, numTicks);
    var scaleOffset = (offset != null ? offset : 0) + (0, _getScaleBandwidthDefault.default)(scale) / 2;
    var tickLines = ticks.map(function(d, index) {
        var _coerceNumber;
        var x = ((_coerceNumber = (0, _scale.coerceNumber)(scale(d))) != null ? _coerceNumber : 0) + scaleOffset;
        return {
            index: index,
            from: new (0, _point.Point)({
                x: x,
                y: 0
            }),
            to: new (0, _point.Point)({
                x: x,
                y: height
            })
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _group.Group), {
        className: (0, _classnamesDefault.default)("visx-columns", className),
        top: top,
        left: left
    }, children ? children({
        lines: tickLines
    }) : tickLines.map(function(_ref2) {
        var from = _ref2.from, to = _ref2.to, index = _ref2.index;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _lineDefault.default), _extends({
            key: "column-line-" + index,
            from: from,
            to: to,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeDasharray: strokeDasharray,
            style: lineStyle
        }, restProps));
    }));
}
GridColumns.propTypes = {
    tickValues: (0, _propTypesDefault.default).array,
    height: (0, _propTypesDefault.default).number.isRequired
};

},{"prop-types":"8INHm","react":"ktQNc","classnames":"aMKnv","@visx/shape/lib/shapes/Line":"3nRag","@visx/group":"daSh2","@visx/point":"dLEk7","@visx/scale":"6Owz5","../utils/getScaleBandwidth":"lJ9rU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"BRR5j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHorizontalBarChart", function() {
    return StyledHorizontalBarChart;
});
parcelHelpers.export(exports, "tooltipStyles", function() {
    return tooltipStyles;
});
parcelHelpers.export(exports, "StyledTooltip", function() {
    return StyledTooltip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tooltip = require("@visx/tooltip");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  &.scrollable-vertical {\n    max-height: 330px;\n  }\n\n  .left-axis-container {\n    margin-left: 40px;\n\n    cursor: default;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledHorizontalBarChart = (0, _styledComponentsDefault.default).div(_templateObject());
var tooltipStyles = {
    pointerEvents: "none",
    position: "absolute",
    padding: "5px",
    fontSize: (0, _index.TYPOGRAPHY).fontSize.base,
    borderRadius: "5px",
    opacity: 0.9,
    backgroundColor: (0, _index.COLORS).ebony,
    color: (0, _index.COLORS).white
};
var StyledTooltip = (0, _styledComponentsDefault.default)((0, _tooltip.Tooltip))(_templateObject1(), tooltipStyles);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@visx/tooltip":"hiwzN","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gCfG3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", function() {
    return Accordion;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _accordionStyles = require("./Accordion.styles");
var Accordion = function(props) {
    var className = props.className, content = props.content, header = props.header, id = props.id, open = props.open, notes = props.notes;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionStyles.StyledAccordion), {
        className: className,
        id: id,
        open: open,
        "data-cy": props["data-cy"],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("summary", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "header-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            className: "toggle-icon",
                            name: "chevron-up",
                            size: [
                                14
                            ]
                        }),
                        header ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: header
                        }) : null,
                        notes ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "header-container-notes",
                            children: notes
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content",
                children: content
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./Accordion.styles":"4uNmO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4uNmO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAccordion", function() {
    return StyledAccordion;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  summary {\n    display: inherit;\n    padding: 0 12px;\n    cursor: pointer;\n  }\n\n  .header-container,\n  h2 {\n    display: flex;\n  }\n\n  .header-container-notes {\n    color: #8498b6;\n    font-size: 16px;\n    font-style: italic;\n    padding-top: 10px;\n    padding-left: 5px;\n  }\n\n  .header-container-notes:before {\n    content: ' - ';\n  }\n\n  .toggle-icon {\n    height: 24px;\n    margin: 6px 0;\n    border-radius: 50%;\n    transition: 0.3s transform ease-in-out;\n  }\n\n  h2 {\n    align-items: center;\n    margin: 0 0 0 8px;\n    font-size: 22px;\n  }\n\n  .content {\n    margin: 10px 0 10px 20px;\n  }\n\n  &[open] > summary .toggle-icon {\n    transform: rotate(180deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledAccordion = (0, _styledComponentsDefault.default).details(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6wXLi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropList", function() {
    return DragDropList;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("@hello-pangea/dnd");
var _uuid = require("uuid");
var _dragDropListItem = require("./DragDropListItem");
var _dragDropListStyles = require("./DragDropList.styles");
var droppableId = (0, _uuid.v4)();
var DragDropList = function(param) {
    var items = param.items, onDragDropEnd = param.onDragDropEnd;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.DragDropContext), {
        onDragEnd: function(result) {
            var destination = result.destination, source = result.source;
            if (!destination || destination.index === source.index) return;
            else {
                var newItemsOrder = Array.from(items);
                var movedItem = newItemsOrder.splice(source.index, 1);
                newItemsOrder.splice(destination.index, 0, movedItem[0]);
                onDragDropEnd(newItemsOrder);
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
            droppableId: droppableId,
            children: function(provided) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dragDropListStyles.StyledDragDropList), (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref: provided.innerRef
                }, provided.droppableProps), {
                    children: [
                        items.map(function(item, index) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragDropListItem.DragDropListItem), {
                                id: item.id,
                                content: item.content,
                                dragDisabled: item.dragDisabled,
                                index: index
                            }, item.id);
                        }),
                        provided.placeholder
                    ]
                }));
            }
        })
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","@hello-pangea/dnd":"bhM3h","uuid":"6ZyFu","./DragDropListItem":"edMh3","./DragDropList.styles":"iz6WQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bhM3h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropContext", function() {
    return DragDropContext;
});
parcelHelpers.export(exports, "Draggable", function() {
    return PublicDraggable;
});
parcelHelpers.export(exports, "Droppable", function() {
    return ConnectedDroppable$1;
});
parcelHelpers.export(exports, "resetServerContext", function() {
    return resetServerContext;
});
parcelHelpers.export(exports, "useKeyboardSensor", function() {
    return useKeyboardSensor;
});
parcelHelpers.export(exports, "useMouseSensor", function() {
    return useMouseSensor;
});
parcelHelpers.export(exports, "useTouchSensor", function() {
    return useTouchSensor;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _createSuper = require("@swc/helpers/_/_create_super");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _useMemoOne = require("use-memo-one");
var _cssBoxModel = require("css-box-model");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _Math;
var isProduction$1 = true;
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;
var clean$2 = function(value) {
    return value.replace(spacesAndTabs, " ").replace(lineStartWithSpaces, "").trim();
};
var getDevMessage = function(message) {
    return clean$2("\n  %c@hello-pangea/dnd\n\n  %c".concat(clean$2(message), "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n"));
};
var getFormattedMessage = function(message) {
    return [
        getDevMessage(message),
        "color: #00C584; font-size: 1.2em; font-weight: bold;",
        "line-height: 1.5",
        "color: #723874;"
    ];
};
var isDisabledFlag = "__@hello-pangea/dnd-disable-dev-warnings";
function log(type, message) {
    var _console;
    if (isProduction$1) return;
    if (typeof window !== "undefined" && window[isDisabledFlag]) return;
    (_console = console)[type].apply(_console, (0, _toConsumableArray._)(getFormattedMessage(message)));
}
var warning = log.bind(null, "warn");
var error = log.bind(null, "error");
function noop$2() {}
function getOptions(shared, fromBinding) {
    return (0, _objectSpread._)({}, shared, fromBinding);
}
function bindEvents(el, bindings, sharedOptions) {
    var unbindings = bindings.map(function(binding) {
        var options = getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach(function(unbind) {
            unbind();
        });
    };
}
var isProduction = true;
var prefix$1 = "Invariant failed";
var RbdInvariant = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(RbdInvariant, Error1);
    var _super = (0, _createSuper._)(RbdInvariant);
    function RbdInvariant() {
        (0, _classCallCheck._)(this, RbdInvariant);
        return _super.apply(this, arguments);
    }
    return RbdInvariant;
}((0, _wrapNativeSuper._)(Error));
RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new RbdInvariant(prefix$1);
    else throw new RbdInvariant("".concat(prefix$1, ": ").concat(message || ""));
}
var ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(ErrorBoundary, _React_Component);
    var _super = (0, _createSuper._)(ErrorBoundary);
    function ErrorBoundary() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, ErrorBoundary);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.callbacks = null;
        _this.unbind = noop$2;
        _this.onWindowError = function(event) {
            var callbacks = _this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            var err = event.error;
            if (err instanceof RbdInvariant) event.preventDefault();
        };
        _this.getCallbacks = function() {
            if (!_this.callbacks) throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
            return _this.callbacks;
        };
        _this.setCallbacks = function(callbacks) {
            _this.callbacks = callbacks;
        };
        return _this;
    }
    (0, _createClass._)(ErrorBoundary, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.unbind = bindEvents(window, [
                    {
                        eventName: "error",
                        fn: this.onWindowError
                    }
                ]);
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(err) {
                if (err instanceof RbdInvariant) {
                    this.setState({});
                    return;
                }
                throw err;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbind();
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children(this.setCallbacks);
            }
        }
    ]);
    return ErrorBoundary;
}((0, _reactDefault.default).Component);
var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";
var position = function(index) {
    return index + 1;
};
var onDragStart = function(start) {
    return "\n  You have lifted an item in position ".concat(position(start.source.index), "\n");
};
var withLocation = function(source, destination) {
    var isInHomeList = source.droppableId === destination.droppableId;
    var startPosition = position(source.index);
    var endPosition = position(destination.index);
    if (isInHomeList) return "\n      You have moved the item from position ".concat(startPosition, "\n      to position ").concat(endPosition, "\n    ");
    return "\n    You have moved the item from position ".concat(startPosition, "\n    in list ").concat(source.droppableId, "\n    to list ").concat(destination.droppableId, "\n    in position ").concat(endPosition, "\n  ");
};
var withCombine = function(id, source, combine) {
    var inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return "\n      The item ".concat(id, "\n      has been combined with ").concat(combine.draggableId);
    return "\n      The item ".concat(id, "\n      in list ").concat(source.droppableId, "\n      has been combined with ").concat(combine.draggableId, "\n      in list ").concat(combine.droppableId, "\n    ");
};
var onDragUpdate = function(update) {
    var location = update.destination;
    if (location) return withLocation(update.source, location);
    var combine = update.combine;
    if (combine) return withCombine(update.draggableId, update.source, combine);
    return "You are over an area that cannot be dropped on";
};
var returnedToStart = function(source) {
    return "\n  The item has returned to its starting position\n  of ".concat(position(source.index), "\n");
};
var onDragEnd = function(result) {
    if (result.reason === "CANCEL") return "\n      Movement cancelled.\n      ".concat(returnedToStart(result.source), "\n    ");
    var location = result.destination;
    var combine = result.combine;
    if (location) return "\n      You have dropped the item.\n      ".concat(withLocation(result.source, location), "\n    ");
    if (combine) return "\n      You have dropped the item.\n      ".concat(withCombine(result.draggableId, result.source, combine), "\n    ");
    return "\n    The item has been dropped while not over a drop area.\n    ".concat(returnedToStart(result.source), "\n  ");
};
var preset = {
    dragHandleUsageInstructions: dragHandleUsageInstructions,
    onDragStart: onDragStart,
    onDragUpdate: onDragUpdate,
    onDragEnd: onDragEnd
};
var preset$1 = preset;
var origin = {
    x: 0,
    y: 0
};
var add = function(point1, point2) {
    return {
        x: point1.x + point2.x,
        y: point1.y + point2.y
    };
};
var subtract = function(point1, point2) {
    return {
        x: point1.x - point2.x,
        y: point1.y - point2.y
    };
};
var isEqual$1 = function(point1, point2) {
    return point1.x === point2.x && point1.y === point2.y;
};
var negate = function(point) {
    return {
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    };
};
var patch = function(line, value) {
    var otherValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (line === "x") return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
var distance = function(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest$1 = function(target, points) {
    return (_Math = Math).min.apply(_Math, (0, _toConsumableArray._)(points.map(function(point) {
        return distance(target, point);
    })));
};
var apply = function(fn) {
    return function(point) {
        return {
            x: fn(point.x),
            y: fn(point.y)
        };
    };
};
var executeClip = function(frame, subject) {
    var result = (0, _cssBoxModel.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
var offsetByPosition = function(spacing, point) {
    return {
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    };
};
var getCorners = function(spacing) {
    return [
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
};
var noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var scroll$1 = function(target, frame) {
    if (!frame) return target;
    return offsetByPosition(target, frame.scroll.diff.displacement);
};
var increase = function(target, axis, withPlaceholder) {
    if (withPlaceholder && withPlaceholder.increasedBy) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, target), (0, _defineProperty._)({}, axis.end, target[axis.end] + withPlaceholder.increasedBy[axis.line]));
    return target;
};
var clip = function(target, frame) {
    if (frame && frame.shouldClipSubject) return executeClip(frame.pageMarginBox, target);
    return (0, _cssBoxModel.getRect)(target);
};
var getSubject = function(param) {
    var page = param.page, withPlaceholder = param.withPlaceholder, axis = param.axis, frame = param.frame;
    var scrolled = scroll$1(page.marginBox, frame);
    var increased = increase(scrolled, axis, withPlaceholder);
    var clipped = clip(increased, frame);
    return {
        page: page,
        withPlaceholder: withPlaceholder,
        active: clipped
    };
};
var scrollDroppable = function(droppable, newScroll) {
    !droppable.frame && invariant(false);
    var scrollable = droppable.frame;
    var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
    var scrollDisplacement = negate(scrollDiff);
    var frame = (0, _objectSpreadProps._)((0, _objectSpread._)({}, scrollable), {
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    });
    var subject = getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame: frame
    });
    var result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppable), {
        frame: frame,
        subject: subject
    });
    return result;
};
var toDroppableMap = (0, _memoizeOneDefault.default)(function(droppables) {
    return droppables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var toDraggableMap = (0, _memoizeOneDefault.default)(function(draggables) {
    return draggables.reduce(function(previous, current) {
        previous[current.descriptor.id] = current;
        return previous;
    }, {});
});
var toDroppableList = (0, _memoizeOneDefault.default)(function(droppables) {
    return Object.values(droppables);
});
var toDraggableList = (0, _memoizeOneDefault.default)(function(draggables) {
    return Object.values(draggables);
});
var getDraggablesInsideDroppable = (0, _memoizeOneDefault.default)(function(droppableId, draggables) {
    var result = toDraggableList(draggables).filter(function(draggable) {
        return droppableId === draggable.descriptor.droppableId;
    }).sort(function(a, b) {
        return a.descriptor.index - b.descriptor.index;
    });
    return result;
});
function tryGetDestination(impact) {
    if (impact.at && impact.at.type === "REORDER") return impact.at.destination;
    return null;
}
function tryGetCombine(impact) {
    if (impact.at && impact.at.type === "COMBINE") return impact.at.combine;
    return null;
}
var removeDraggableFromList = (0, _memoizeOneDefault.default)(function(remove, list) {
    return list.filter(function(item) {
        return item.descriptor.id !== remove.descriptor.id;
    });
});
var moveToNextCombine = function(param) {
    var isMovingForward = param.isMovingForward, draggable = param.draggable, destination = param.destination, insideDestination = param.insideDestination, previousImpact = param.previousImpact;
    if (!destination.isCombineEnabled) return null;
    var location = tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        var at = {
            type: "COMBINE",
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, previousImpact), {
            at: at
        });
    }
    var all = previousImpact.displaced.all;
    var closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        var last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    var indexOfClosest = withoutDraggable.findIndex(function(d) {
        return d.descriptor.id === closestId;
    });
    !(indexOfClosest !== -1) && invariant(false);
    var proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    var before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var isHomeOf = function(draggable, destination) {
    return draggable.descriptor.droppableId === destination.descriptor.id;
};
var noDisplacedBy = {
    point: origin,
    value: 0
};
var emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
var noImpact = {
    displaced: emptyGroups,
    displacedBy: noDisplacedBy,
    at: null
};
var noImpact$1 = noImpact;
var isWithin = function(lowerBound, upperBound) {
    return function(value) {
        return lowerBound <= value && value <= upperBound;
    };
};
var isPartiallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var isTotallyVisibleThroughFrame = function(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function(subject) {
        var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
var vertical = {
    direction: "vertical",
    line: "y",
    crossAxisLine: "x",
    start: "top",
    end: "bottom",
    size: "height",
    crossAxisStart: "left",
    crossAxisEnd: "right",
    crossAxisSize: "width"
};
var horizontal = {
    direction: "horizontal",
    line: "x",
    crossAxisLine: "y",
    start: "left",
    end: "right",
    size: "width",
    crossAxisStart: "top",
    crossAxisEnd: "bottom",
    crossAxisSize: "height"
};
var isTotallyVisibleThroughFrameOnAxis = function(axis) {
    return function(frame) {
        var isWithinVertical = isWithin(frame.top, frame.bottom);
        var isWithinHorizontal = isWithin(frame.left, frame.right);
        return function(subject) {
            if (axis === vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
};
var getDroppableDisplaced = function(target, destination) {
    var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
    return offsetByPosition(target, displacement);
};
var isVisibleInDroppable = function(target, destination, isVisibleThroughFrameFn) {
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
var isVisibleInViewport = function(target, viewport, isVisibleThroughFrameFn) {
    return isVisibleThroughFrameFn(viewport)(target);
};
var isVisible$1 = function(param) {
    var toBeDisplaced = param.target, destination = param.destination, viewport = param.viewport, withDroppableDisplacement = param.withDroppableDisplacement, isVisibleThroughFrameFn = param.isVisibleThroughFrameFn;
    var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
var isPartiallyVisible = function(args) {
    return isVisible$1((0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
        isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
    }));
};
var isTotallyVisible = function(args) {
    return isVisible$1((0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
    }));
};
var isTotallyVisibleOnAxis = function(args) {
    return isVisible$1((0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    }));
};
var getShouldAnimate = function(id, last, forceShouldAnimate) {
    if (typeof forceShouldAnimate === "boolean") return forceShouldAnimate;
    if (!last) return true;
    var invisible = last.invisible, visible = last.visible;
    if (invisible[id]) return false;
    var previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function getTarget(draggable, displacedBy) {
    var marginBox = draggable.page.marginBox;
    var expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, _cssBoxModel.getRect)((0, _cssBoxModel.expand)(marginBox, expandBy));
}
function getDisplacementGroups(param) {
    var afterDragging = param.afterDragging, destination = param.destination, displacedBy = param.displacedBy, viewport = param.viewport, forceShouldAnimate = param.forceShouldAnimate, last = param.last;
    return afterDragging.reduce(function process(groups, draggable) {
        var target = getTarget(draggable, displacedBy);
        var id = draggable.descriptor.id;
        groups.all.push(id);
        var isVisible = isPartiallyVisible({
            target: target,
            destination: destination,
            viewport: viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
        var displacement = {
            draggableId: id,
            shouldAnimate: shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function goAtEnd(param) {
    var insideDestination = param.insideDestination, inHomeList = param.inHomeList, displacedBy = param.displacedBy, destination = param.destination;
    var newIndex = getIndexOfLastItem(insideDestination, {
        inHomeList: inHomeList
    });
    return {
        displaced: emptyGroups,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function calculateReorderImpact(param) {
    var draggable = param.draggable, insideDestination = param.insideDestination, destination = param.destination, viewport = param.viewport, displacedBy = param.displacedBy, last = param.last, index = param.index, forceShouldAnimate = param.forceShouldAnimate;
    var inHomeList = isHomeOf(draggable, destination);
    if (index == null) return goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var match = insideDestination.find(function(item) {
        return item.descriptor.index === index;
    });
    if (!match) return goAtEnd({
        insideDestination: insideDestination,
        inHomeList: inHomeList,
        displacedBy: displacedBy,
        destination: destination
    });
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var sliceFrom = insideDestination.indexOf(match);
    var impacted = withoutDragging.slice(sliceFrom);
    var displaced = getDisplacementGroups({
        afterDragging: impacted,
        destination: destination,
        displacedBy: displacedBy,
        last: last,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate
    });
    return {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: {
                droppableId: destination.descriptor.id,
                index: index
            }
        }
    };
}
function didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var fromCombine = function(param) {
    var isMovingForward = param.isMovingForward, destination = param.destination, draggables = param.draggables, combine = param.combine, afterCritical = param.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var combineId = combine.draggableId;
    var combineWith = draggables[combineId];
    var combineWithIndex = combineWith.descriptor.index;
    var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var fromReorder = function(param) {
    var isMovingForward = param.isMovingForward, isInHomeList = param.isInHomeList, insideDestination = param.insideDestination, location = param.location;
    if (!insideDestination.length) return null;
    var currentIndex = location.index;
    var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    var firstIndex = insideDestination[0].descriptor.index;
    var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    var upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var moveToNextIndex = function(param) {
    var isMovingForward = param.isMovingForward, isInHomeList = param.isInHomeList, draggable = param.draggable, draggables = param.draggables, destination = param.destination, insideDestination = param.insideDestination, previousImpact = param.previousImpact, viewport = param.viewport, afterCritical = param.afterCritical;
    var wasAt = previousImpact.at;
    !wasAt && invariant(false);
    if (wasAt.type === "REORDER") {
        var newIndex = fromReorder({
            isMovingForward: isMovingForward,
            isInHomeList: isInHomeList,
            location: wasAt.destination,
            insideDestination: insideDestination
        });
        if (newIndex == null) return null;
        return calculateReorderImpact({
            draggable: draggable,
            insideDestination: insideDestination,
            destination: destination,
            viewport: viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    var newIndex1 = fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        displaced: previousImpact.displaced,
        draggables: draggables,
        combine: wasAt.combine,
        afterCritical: afterCritical
    });
    if (newIndex1 == null) return null;
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex1
    });
};
var getCombinedItemDisplacement = function(param) {
    var displaced = param.displaced, afterCritical = param.afterCritical, combineWith = param.combineWith, displacedBy = param.displacedBy;
    var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if (didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? origin : negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : origin;
};
var whenCombining = function(param) {
    var afterCritical = param.afterCritical, impact = param.impact, draggables = param.draggables;
    var combine = tryGetCombine(impact);
    !combine && invariant(false);
    var combineWith = combine.draggableId;
    var center = draggables[combineWith].page.borderBox.center;
    var displaceBy = getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical: afterCritical,
        combineWith: combineWith,
        displacedBy: impact.displacedBy
    });
    return add(center, displaceBy);
};
var distanceFromStartToBorderBoxCenter = function(axis, box) {
    return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};
var distanceFromEndToBorderBoxCenter = function(axis, box) {
    return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};
var getCrossAxisBorderBoxCenter = function(axis, target, isMoving) {
    return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};
var goAfter = function(param) {
    var axis = param.axis, moveRelativeTo = param.moveRelativeTo, isMoving = param.isMoving;
    return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function(param) {
    var axis = param.axis, moveRelativeTo = param.moveRelativeTo, isMoving = param.isMoving;
    return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function(param) {
    var axis = param.axis, moveInto = param.moveInto, isMoving = param.isMoving;
    return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};
var whenReordering = function(param) {
    var impact = param.impact, draggable = param.draggable, draggables = param.draggables, droppable = param.droppable, afterCritical = param.afterCritical;
    var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var draggablePage = draggable.page;
    var axis = droppable.axis;
    if (!insideDestination.length) return goIntoStart({
        axis: axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    var displaced = impact.displaced, displacedBy = impact.displacedBy;
    var closestAfter = displaced.all[0];
    if (closestAfter) {
        var closest = draggables[closestAfter];
        if (didStartAfterCritical(closestAfter, afterCritical)) return goBefore({
            axis: axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        var withDisplacement = (0, _cssBoxModel.offset)(closest.page, displacedBy.point);
        return goBefore({
            axis: axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    var last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
        var page = (0, _cssBoxModel.offset)(last.page, negate(afterCritical.displacedBy.point));
        return goAfter({
            axis: axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return goAfter({
        axis: axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var withDroppableDisplacement = function(droppable, point) {
    var frame = droppable.frame;
    if (!frame) return point;
    return add(point, frame.scroll.diff.displacement);
};
var getResultWithoutDroppableDisplacement = function(param) {
    var impact = param.impact, draggable = param.draggable, droppable = param.droppable, draggables = param.draggables, afterCritical = param.afterCritical;
    var original = draggable.page.borderBox.center;
    var at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === "REORDER") return whenReordering({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return whenCombining({
        impact: impact,
        draggables: draggables,
        afterCritical: afterCritical
    });
};
var getPageBorderBoxCenterFromImpact = function(args) {
    var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
    var droppable = args.droppable;
    var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var scrollViewport = function(viewport, newScroll) {
    var diff = subtract(newScroll, viewport.scroll.initial);
    var displacement = negate(diff);
    var frame = (0, _cssBoxModel.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    var updated = {
        frame: frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement: displacement
            }
        }
    };
    return updated;
};
function getDraggables$1(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
function tryGetVisible(id, groups) {
    for(var i = 0; i < groups.length; i++){
        var displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var speculativelyIncrease = function(param) {
    var impact = param.impact, viewport = param.viewport, destination = param.destination, draggables = param.draggables, maxScrollChange = param.maxScrollChange;
    var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
    var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
    var last = impact.displaced;
    var withViewportScroll = getDisplacementGroups({
        afterDragging: getDraggables$1(last.all, draggables),
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var withDroppableScroll = getDisplacementGroups({
        afterDragging: getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last: last,
        forceShouldAnimate: false
    });
    var invisible = {};
    var visible = {};
    var groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach(function(id) {
        var displacement = tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    var newImpact = (0, _objectSpreadProps._)((0, _objectSpread._)({}, impact), {
        displaced: {
            all: last.all,
            invisible: invisible,
            visible: visible
        }
    });
    return newImpact;
};
var withViewportDisplacement = function(viewport, point) {
    return add(viewport.scroll.diff.displacement, point);
};
var getClientFromPageBorderBoxCenter = function(param) {
    var pageBorderBoxCenter = param.pageBorderBoxCenter, draggable = param.draggable, viewport = param.viewport;
    var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
    var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return add(draggable.client.borderBox.center, offset);
};
var isTotallyVisibleInNewLocation = function(param) {
    var draggable = param.draggable, destination = param.destination, newPageBorderBoxCenter = param.newPageBorderBoxCenter, viewport = param.viewport, withDroppableDisplacement = param.withDroppableDisplacement, _param_onlyOnMainAxis = param.onlyOnMainAxis, onlyOnMainAxis = _param_onlyOnMainAxis === void 0 ? false : _param_onlyOnMainAxis;
    var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
    var args = {
        target: shifted,
        destination: destination,
        withDroppableDisplacement: withDroppableDisplacement,
        viewport: viewport
    };
    return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};
var moveToNextPlace = function(param) {
    var isMovingForward = param.isMovingForward, draggable = param.draggable, destination = param.destination, draggables = param.draggables, previousImpact = param.previousImpact, viewport = param.viewport, previousPageBorderBoxCenter = param.previousPageBorderBoxCenter, previousClientSelection = param.previousClientSelection, afterCritical = param.afterCritical;
    if (!destination.isEnabled) return null;
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var isInHomeList = isHomeOf(draggable, destination);
    var impact = moveToNextCombine({
        isMovingForward: isMovingForward,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact
    }) || moveToNextIndex({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        draggables: draggables,
        destination: destination,
        insideDestination: insideDestination,
        previousImpact: previousImpact,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
        draggable: draggable,
        destination: destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        var clientSelection = getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter: pageBorderBoxCenter,
            draggable: draggable,
            viewport: viewport
        });
        return {
            clientSelection: clientSelection,
            impact: impact,
            scrollJumpRequest: null
        };
    }
    var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    var cautious = speculativelyIncrease({
        impact: impact,
        viewport: viewport,
        destination: destination,
        draggables: draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
var getKnownActive = function(droppable) {
    var rect = droppable.subject.active;
    !rect && invariant(false);
    return rect;
};
var getBestCrossAxisDroppable = function(param) {
    var isMovingForward = param.isMovingForward, pageBorderBoxCenter = param.pageBorderBoxCenter, source = param.source, droppables = param.droppables, viewport = param.viewport;
    var active = source.subject.active;
    if (!active) return null;
    var axis = source.axis;
    var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
    var candidates = toDroppableList(droppables).filter(function(droppable) {
        return droppable !== source;
    }).filter(function(droppable) {
        return droppable.isEnabled;
    }).filter(function(droppable) {
        return Boolean(droppable.subject.active);
    }).filter(function(droppable) {
        return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
    }).filter(function(droppable) {
        var activeOfTarget = getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter(function(droppable) {
        var activeOfTarget = getKnownActive(droppable);
        var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort(function(a, b) {
        var first = getKnownActive(a)[axis.crossAxisStart];
        var second = getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter(function(droppable, index, array) {
        return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    var contains = candidates.filter(function(droppable) {
        var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort(function(a, b) {
        return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
    return candidates.sort(function(a, b) {
        var first = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(a)));
        var second = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(b)));
        if (first !== second) return first - second;
        return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
};
var getCurrentPageBorderBoxCenter = function(draggable, afterCritical) {
    var original = draggable.page.borderBox.center;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function(draggable, afterCritical) {
    var original = draggable.page.borderBox;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};
var getClosestDraggable = function(param) {
    var pageBorderBoxCenter = param.pageBorderBoxCenter, viewport = param.viewport, destination = param.destination, insideDestination = param.insideDestination, afterCritical = param.afterCritical;
    var sorted = insideDestination.filter(function(draggable) {
        return isTotallyVisible({
            target: getCurrentPageBorderBox(draggable, afterCritical),
            destination: destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        });
    }).sort(function(a, b) {
        var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
        var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var getDisplacedBy = (0, _memoizeOneDefault.default)(function getDisplacedBy(axis, displaceBy) {
    var displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: patch(axis.line, displacement)
    };
});
var getRequiredGrowthForPlaceholder = function(droppable, placeholderSize, draggables) {
    var axis = droppable.axis;
    if (droppable.descriptor.mode === "virtual") return patch(axis.line, placeholderSize[axis.line]);
    var availableSpace = droppable.subject.page.contentBox[axis.size];
    var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    var spaceUsed = insideDroppable.reduce(function(sum, dimension) {
        return sum + dimension.client.marginBox[axis.size];
    }, 0);
    var requiredSpace = spaceUsed + placeholderSize[axis.line];
    var needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return patch(axis.line, needsToGrowBy);
};
var withMaxScroll = function(frame, max) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame), {
        scroll: (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame.scroll), {
            max: max
        })
    });
};
var addPlaceholder = function(droppable, draggable, draggables) {
    var frame = droppable.frame;
    !!isHomeOf(draggable, droppable) && invariant(false);
    !!droppable.subject.withPlaceholder && invariant(false);
    var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    var added = {
        placeholderSize: placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        var subject = getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppable), {
            subject: subject
        });
    }
    var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    var newFrame = withMaxScroll(frame, maxScroll);
    var subject1 = getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppable), {
        subject: subject1,
        frame: newFrame
    });
};
var removePlaceholder = function(droppable) {
    var added = droppable.subject.withPlaceholder;
    !added && invariant(false);
    var frame = droppable.frame;
    if (!frame) {
        var subject = getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppable), {
            subject: subject
        });
    }
    var oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && invariant(false);
    var newFrame = withMaxScroll(frame, oldMaxScroll);
    var subject1 = getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppable), {
        subject: subject1,
        frame: newFrame
    });
};
var moveToNewDroppable = function(param) {
    var previousPageBorderBoxCenter = param.previousPageBorderBoxCenter, moveRelativeTo = param.moveRelativeTo, insideDestination = param.insideDestination, draggable = param.draggable, draggables = param.draggables, destination = param.destination, viewport = param.viewport, afterCritical = param.afterCritical;
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        var proposed = {
            displaced: emptyGroups,
            displacedBy: noDisplacedBy,
            at: {
                type: "REORDER",
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable: draggable,
            droppable: destination,
            draggables: draggables,
            afterCritical: afterCritical
        });
        var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
        var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
            draggable: draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    var proposedIndex = function() {
        var relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    }();
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        displacedBy: displacedBy,
        last: emptyGroups,
        index: proposedIndex
    });
};
var moveCrossAxis = function(param) {
    var isMovingForward = param.isMovingForward, previousPageBorderBoxCenter = param.previousPageBorderBoxCenter, draggable = param.draggable, isOver = param.isOver, draggables = param.draggables, droppables = param.droppables, viewport = param.viewport, afterCritical = param.afterCritical;
    var destination = getBestCrossAxisDroppable({
        isMovingForward: isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables: droppables,
        viewport: viewport
    });
    if (!destination) return null;
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var moveRelativeTo = getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport: viewport,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    });
    var impact = moveToNewDroppable({
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        destination: destination,
        draggable: draggable,
        draggables: draggables,
        moveRelativeTo: moveRelativeTo,
        insideDestination: insideDestination,
        viewport: viewport,
        afterCritical: afterCritical
    });
    if (!impact) return null;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        afterCritical: afterCritical
    });
    var clientSelection = getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
    return {
        clientSelection: clientSelection,
        impact: impact,
        scrollJumpRequest: null
    };
};
var whatIsDraggedOver = function(impact) {
    var at = impact.at;
    if (!at) return null;
    if (at.type === "REORDER") return at.destination.droppableId;
    return at.combine.droppableId;
};
var getDroppableOver$1 = function(impact, droppables) {
    var id = whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var moveInDirection = function(param) {
    var state = param.state, type = param.type;
    var isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
    var isMainAxisMovementAllowed = Boolean(isActuallyOver);
    var home = state.dimensions.droppables[state.critical.droppable.id];
    var isOver = isActuallyOver || home;
    var direction = isOver.axis.direction;
    var isMovingOnMainAxis = direction === "vertical" && (type === "MOVE_UP" || type === "MOVE_DOWN") || direction === "horizontal" && (type === "MOVE_LEFT" || type === "MOVE_RIGHT");
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    var isMovingForward = type === "MOVE_DOWN" || type === "MOVE_RIGHT";
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    var _state_dimensions = state.dimensions, draggables = _state_dimensions.draggables, droppables = _state_dimensions.droppables;
    return isMovingOnMainAxis ? moveToNextPlace({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        destination: isOver,
        draggables: draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : moveCrossAxis({
        isMovingForward: isMovingForward,
        previousPageBorderBoxCenter: previousPageBorderBoxCenter,
        draggable: draggable,
        isOver: isOver,
        draggables: draggables,
        droppables: droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function isMovementAllowed(state) {
    return state.phase === "DRAGGING" || state.phase === "COLLECTING";
}
function isPositionInFrame(frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function getFurthestAway(param) {
    var pageBorderBox = param.pageBorderBox, draggable = param.draggable, candidates = param.candidates;
    var startCenter = draggable.page.borderBox.center;
    var sorted = candidates.map(function(candidate) {
        var axis = candidate.axis;
        var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: distance(startCenter, target)
        };
    }).sort(function(a, b) {
        return b.distance - a.distance;
    });
    return sorted[0] ? sorted[0].id : null;
}
function getDroppableOver(param) {
    var pageBorderBox = param.pageBorderBox, draggable = param.draggable, droppables = param.droppables;
    var candidates = toDroppableList(droppables).filter(function(item) {
        if (!item.isEnabled) return false;
        var active = item.subject.active;
        if (!active) return false;
        if (!getHasOverlap(pageBorderBox, active)) return false;
        if (isPositionInFrame(active)(pageBorderBox.center)) return true;
        var axis = item.axis;
        var childCenter = active.center[axis.crossAxisLine];
        var crossAxisStart = pageBorderBox[axis.crossAxisStart];
        var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        var isStartContained = isContained(crossAxisStart);
        var isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return getFurthestAway({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        candidates: candidates
    });
}
var offsetRectByPosition = function(rect, point) {
    return (0, _cssBoxModel.getRect)(offsetByPosition(rect, point));
};
var withDroppableScroll = function(droppable, area) {
    var frame = droppable.frame;
    if (!frame) return area;
    return offsetRectByPosition(area, frame.scroll.diff.value);
};
function getIsDisplaced(param) {
    var displaced = param.displaced, id = param.id;
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function atIndex(param) {
    var draggable = param.draggable, closest = param.closest, inHomeList = param.inHomeList;
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var getReorderImpact = function(param) {
    var targetRect = param.pageBorderBoxWithDroppableScroll, draggable = param.draggable, destination = param.destination, insideDestination = param.insideDestination, last = param.last, viewport = param.viewport, afterCritical = param.afterCritical;
    var axis = destination.axis;
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var closest = withoutDragging.find(function(child) {
        var id = child.descriptor.id;
        var childCenter = child.page.borderBox.center[axis.line];
        var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        var isDisplaced = getIsDisplaced({
            displaced: last,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    var newIndex = atIndex({
        draggable: draggable,
        closest: closest,
        inHomeList: isHomeOf(draggable, destination)
    });
    return calculateReorderImpact({
        draggable: draggable,
        insideDestination: insideDestination,
        destination: destination,
        viewport: viewport,
        last: last,
        displacedBy: displacedBy,
        index: newIndex
    });
};
var combineThresholdDivisor = 4;
var getCombineImpact = function(param) {
    var draggable = param.draggable, targetRect = param.pageBorderBoxWithDroppableScroll, previousImpact = param.previousImpact, destination = param.destination, insideDestination = param.insideDestination, afterCritical = param.afterCritical;
    if (!destination.isCombineEnabled) return null;
    var axis = destination.axis;
    var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    var displacement = displacedBy.value;
    var targetStart = targetRect[axis.start];
    var targetEnd = targetRect[axis.end];
    var withoutDragging = removeDraggableFromList(draggable, insideDestination);
    var combineWith = withoutDragging.find(function(child) {
        var id = child.descriptor.id;
        var childRect = child.page.borderBox;
        var childSize = childRect[axis.size];
        var threshold = childSize / combineThresholdDivisor;
        var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        var isDisplaced = getIsDisplaced({
            displaced: previousImpact.displaced,
            id: id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    var impact = {
        displacedBy: displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: "COMBINE",
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var getDragImpact = function(param) {
    var pageOffset = param.pageOffset, draggable = param.draggable, draggables = param.draggables, droppables = param.droppables, previousImpact = param.previousImpact, viewport = param.viewport, afterCritical = param.afterCritical;
    var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
    var destinationId = getDroppableOver({
        pageBorderBox: pageBorderBox,
        draggable: draggable,
        droppables: droppables
    });
    if (!destinationId) return noImpact$1;
    var destination = droppables[destinationId];
    var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
    return getCombineImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        previousImpact: previousImpact,
        destination: destination,
        insideDestination: insideDestination,
        afterCritical: afterCritical
    }) || getReorderImpact({
        pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
        draggable: draggable,
        destination: destination,
        insideDestination: insideDestination,
        last: previousImpact.displaced,
        viewport: viewport,
        afterCritical: afterCritical
    });
};
var patchDroppableMap = function(droppables, updated) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, droppables), (0, _defineProperty._)({}, updated.descriptor.id, updated));
};
var clearUnusedPlaceholder = function(param) {
    var previousImpact = param.previousImpact, impact = param.impact, droppables = param.droppables;
    var last = whatIsDraggedOver(previousImpact);
    var now = whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    var lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    var updated = removePlaceholder(lastDroppable);
    return patchDroppableMap(droppables, updated);
};
var recomputePlaceholders = function(param) {
    var draggable = param.draggable, draggables = param.draggables, droppables = param.droppables, previousImpact = param.previousImpact, impact = param.impact;
    var cleaned = clearUnusedPlaceholder({
        previousImpact: previousImpact,
        impact: impact,
        droppables: droppables
    });
    var isOver = whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    var droppable = droppables[isOver];
    if (isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    var patched = addPlaceholder(droppable, draggable, draggables);
    return patchDroppableMap(cleaned, patched);
};
var update = function(param) {
    var state = param.state, forcedClientSelection = param.clientSelection, forcedDimensions = param.dimensions, forcedViewport = param.viewport, forcedImpact = param.impact, scrollJumpRequest = param.scrollJumpRequest;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var clientSelection = forcedClientSelection || state.current.client.selection;
    var offset = subtract(clientSelection, state.initial.client.selection);
    var client = {
        offset: offset,
        selection: clientSelection,
        borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
    };
    var page = {
        selection: add(client.selection, viewport.scroll.current),
        borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
        offset: add(client.offset, viewport.scroll.diff.value)
    };
    var current = {
        client: client,
        page: page
    };
    if (state.phase === "COLLECTING") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        dimensions: dimensions,
        viewport: viewport,
        current: current
    });
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var newImpact = forcedImpact || getDragImpact({
        pageOffset: page.offset,
        draggable: draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    var withUpdatedPlaceholders = recomputePlaceholders({
        draggable: draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    var result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        current: current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport: viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    });
    return result;
};
function getDraggables(ids, draggables) {
    return ids.map(function(id) {
        return draggables[id];
    });
}
var recompute = function(param) {
    var impact = param.impact, viewport = param.viewport, draggables = param.draggables, destination = param.destination, forceShouldAnimate = param.forceShouldAnimate;
    var last = impact.displaced;
    var afterDragging = getDraggables(last.all, draggables);
    var displaced = getDisplacementGroups({
        afterDragging: afterDragging,
        destination: destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate: forceShouldAnimate,
        last: last
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, impact), {
        displaced: displaced
    });
};
var getClientBorderBoxCenter = function(param) {
    var impact = param.impact, draggable = param.draggable, droppable = param.droppable, draggables = param.draggables, viewport = param.viewport, afterCritical = param.afterCritical;
    var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        droppable: droppable,
        afterCritical: afterCritical
    });
    return getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter: pageBorderBoxCenter,
        draggable: draggable,
        viewport: viewport
    });
};
var refreshSnap = function(param) {
    var state = param.state, forcedDimensions = param.dimensions, forcedViewport = param.viewport;
    !(state.movementMode === "SNAP") && invariant(false);
    var needsVisibilityCheck = state.impact;
    var viewport = forcedViewport || state.viewport;
    var dimensions = forcedDimensions || state.dimensions;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var draggable = draggables[state.critical.draggable.id];
    var isOver = whatIsDraggedOver(needsVisibilityCheck);
    !isOver && invariant(false);
    var destination = droppables[isOver];
    var impact = recompute({
        impact: needsVisibilityCheck,
        viewport: viewport,
        destination: destination,
        draggables: draggables
    });
    var clientSelection = getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        droppable: destination,
        draggables: draggables,
        viewport: viewport,
        afterCritical: state.afterCritical
    });
    return update({
        impact: impact,
        clientSelection: clientSelection,
        state: state,
        dimensions: dimensions,
        viewport: viewport
    });
};
var getHomeLocation = function(descriptor) {
    return {
        index: descriptor.index,
        droppableId: descriptor.droppableId
    };
};
var getLiftEffect = function(param) {
    var draggable = param.draggable, home = param.home, draggables = param.draggables, viewport = param.viewport;
    var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
    var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
    var rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && invariant(false);
    var afterDragging = insideHome.slice(rawIndex + 1);
    var effected = afterDragging.reduce(function(previous, item) {
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    var afterCritical = {
        inVirtualList: home.descriptor.mode === "virtual",
        displacedBy: displacedBy,
        effected: effected
    };
    var displaced = getDisplacementGroups({
        afterDragging: afterDragging,
        destination: home,
        displacedBy: displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    var impact = {
        displaced: displaced,
        displacedBy: displacedBy,
        at: {
            type: "REORDER",
            destination: getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact: impact,
        afterCritical: afterCritical
    };
};
var patchDimensionMap = function(dimensions, updated) {
    return {
        draggables: dimensions.draggables,
        droppables: patchDroppableMap(dimensions.droppables, updated)
    };
};
var start = function(key) {};
var finish = function(key) {};
var offsetDraggable = function(param) {
    var draggable = param.draggable, offset$1 = param.offset, initialWindowScroll = param.initialWindowScroll;
    var client = (0, _cssBoxModel.offset)(draggable.client, offset$1);
    var page = (0, _cssBoxModel.withScroll)(client, initialWindowScroll);
    var moved = (0, _objectSpreadProps._)((0, _objectSpread._)({}, draggable), {
        placeholder: (0, _objectSpreadProps._)((0, _objectSpread._)({}, draggable.placeholder), {
            client: client
        }),
        client: client,
        page: page
    });
    return moved;
};
var getFrame = function(droppable) {
    var frame = droppable.frame;
    !frame && invariant(false);
    return frame;
};
var adjustAdditionsForScrollChanges = function(param) {
    var additions = param.additions, updatedDroppables = param.updatedDroppables, viewport = param.viewport;
    var windowScrollChange = viewport.scroll.diff.value;
    return additions.map(function(draggable) {
        var droppableId = draggable.descriptor.droppableId;
        var modified = updatedDroppables[droppableId];
        var frame = getFrame(modified);
        var droppableScrollChange = frame.scroll.diff.value;
        var totalChange = add(windowScrollChange, droppableScrollChange);
        var moved = offsetDraggable({
            draggable: draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var timingsKey = "Processing dynamic changes";
var publishWhileDraggingInVirtual = function(param) {
    var state = param.state, published = param.published;
    start();
    var withScrollChange = published.modified.map(function(update) {
        var existing = state.dimensions.droppables[update.droppableId];
        var scrolled = scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    var droppables = (0, _objectSpread._)({}, state.dimensions.droppables, toDroppableMap(withScrollChange));
    var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    var draggables = (0, _objectSpread._)({}, state.dimensions.draggables, updatedAdditions);
    published.removals.forEach(function(id) {
        delete draggables[id];
    });
    var dimensions = {
        droppables: droppables,
        draggables: draggables
    };
    var wasOverId = whatIsDraggedOver(state.impact);
    var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    var draggable = dimensions.draggables[state.critical.draggable.id];
    var home = dimensions.droppables[state.critical.droppable.id];
    var _getLiftEffect = getLiftEffect({
        draggable: draggable,
        home: home,
        draggables: draggables,
        viewport: state.viewport
    }), onLiftImpact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
    var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    var impact = getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: previousImpact,
        viewport: state.viewport,
        afterCritical: afterCritical
    });
    finish(timingsKey);
    var draggingState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        phase: "DRAGGING",
        impact: impact,
        onLiftImpact: onLiftImpact,
        dimensions: dimensions,
        afterCritical: afterCritical,
        forceShouldAnimate: false
    });
    if (state.phase === "COLLECTING") return draggingState;
    var dropPending = (0, _objectSpreadProps._)((0, _objectSpread._)({}, draggingState), {
        phase: "DROP_PENDING",
        reason: state.reason,
        isWaiting: false
    });
    return dropPending;
};
var isSnapping = function(state) {
    return state.movementMode === "SNAP";
};
var postDroppableChange = function(state, updated, isEnabledChanging) {
    var dimensions = patchDimensionMap(state.dimensions, updated);
    if (!isSnapping(state) || isEnabledChanging) return update({
        state: state,
        dimensions: dimensions
    });
    return refreshSnap({
        state: state,
        dimensions: dimensions
    });
};
function removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === "SNAP") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
        scrollJumpRequest: null
    });
    return state;
}
var idle$2 = {
    phase: "IDLE",
    completed: null,
    shouldFlush: false
};
var reducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : idle$2, action = arguments.length > 1 ? arguments[1] : void 0;
    if (action.type === "FLUSH") return (0, _objectSpreadProps._)((0, _objectSpread._)({}, idle$2), {
        shouldFlush: true
    });
    if (action.type === "INITIAL_PUBLISH") {
        !(state.phase === "IDLE") && invariant(false);
        var _action_payload = action.payload, critical = _action_payload.critical, clientSelection = _action_payload.clientSelection, viewport = _action_payload.viewport, dimensions = _action_payload.dimensions, movementMode = _action_payload.movementMode;
        var draggable = dimensions.draggables[critical.draggable.id];
        var home = dimensions.droppables[critical.droppable.id];
        var client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: origin
        };
        var initial = {
            client: client,
            page: {
                selection: add(client.selection, viewport.scroll.initial),
                borderBoxCenter: add(client.selection, viewport.scroll.initial),
                offset: add(client.selection, viewport.scroll.diff.value)
            }
        };
        var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function(item) {
            return !item.isFixedOnPage;
        });
        var _getLiftEffect = getLiftEffect({
            draggable: draggable,
            home: home,
            draggables: dimensions.draggables,
            viewport: viewport
        }), impact = _getLiftEffect.impact, afterCritical = _getLiftEffect.afterCritical;
        var result = {
            phase: "DRAGGING",
            isDragging: true,
            critical: critical,
            movementMode: movementMode,
            dimensions: dimensions,
            initial: initial,
            current: initial,
            isWindowScrollAllowed: isWindowScrollAllowed,
            impact: impact,
            afterCritical: afterCritical,
            onLiftImpact: impact,
            viewport: viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === "COLLECTION_STARTING") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && invariant(false);
        var result1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            phase: "COLLECTING"
        });
        return result1;
    }
    if (action.type === "PUBLISH_WHILE_DRAGGING") {
        !(state.phase === "COLLECTING" || state.phase === "DROP_PENDING") && invariant(false);
        return publishWhileDraggingInVirtual({
            state: state,
            published: action.payload
        });
    }
    if (action.type === "MOVE") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _action_payload1 = action.payload, clientSelection1 = _action_payload1.client;
        if (isEqual$1(clientSelection1, state.current.client.selection)) return state;
        return update({
            state: state,
            clientSelection: clientSelection1,
            impact: isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === "UPDATE_DROPPABLE_SCROLL") {
        if (state.phase === "DROP_PENDING") return removeScrollJumpRequest(state);
        if (state.phase === "COLLECTING") return removeScrollJumpRequest(state);
        !isMovementAllowed(state) && invariant(false);
        var _action_payload2 = action.payload, id = _action_payload2.id, newScroll = _action_payload2.newScroll;
        var target = state.dimensions.droppables[id];
        if (!target) return state;
        var scrolled = scrollDroppable(target, newScroll);
        return postDroppableChange(state, scrolled, false);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _action_payload3 = action.payload, id1 = _action_payload3.id, isEnabled = _action_payload3.isEnabled;
        var target1 = state.dimensions.droppables[id1];
        !target1 && invariant(false);
        !(target1.isEnabled !== isEnabled) && invariant(false);
        var updated = (0, _objectSpreadProps._)((0, _objectSpread._)({}, target1), {
            isEnabled: isEnabled
        });
        return postDroppableChange(state, updated, true);
    }
    if (action.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
        if (state.phase === "DROP_PENDING") return state;
        !isMovementAllowed(state) && invariant(false);
        var _action_payload4 = action.payload, id2 = _action_payload4.id, isCombineEnabled = _action_payload4.isCombineEnabled;
        var target2 = state.dimensions.droppables[id2];
        !target2 && invariant(false);
        !(target2.isCombineEnabled !== isCombineEnabled) && invariant(false);
        var updated1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, target2), {
            isCombineEnabled: isCombineEnabled
        });
        return postDroppableChange(state, updated1, true);
    }
    if (action.type === "MOVE_BY_WINDOW_SCROLL") {
        if (state.phase === "DROP_PENDING" || state.phase === "DROP_ANIMATING") return state;
        !isMovementAllowed(state) && invariant(false);
        !state.isWindowScrollAllowed && invariant(false);
        var newScroll1 = action.payload.newScroll;
        if (isEqual$1(state.viewport.scroll.current, newScroll1)) return removeScrollJumpRequest(state);
        var viewport1 = scrollViewport(state.viewport, newScroll1);
        if (isSnapping(state)) return refreshSnap({
            state: state,
            viewport: viewport1
        });
        return update({
            state: state,
            viewport: viewport1
        });
    }
    if (action.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
        if (!isMovementAllowed(state)) return state;
        var maxScroll = action.payload.maxScroll;
        if (isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        var withMaxScroll = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.viewport), {
            scroll: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.viewport.scroll), {
                max: maxScroll
            })
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            viewport: withMaxScroll
        });
    }
    if (action.type === "MOVE_UP" || action.type === "MOVE_DOWN" || action.type === "MOVE_LEFT" || action.type === "MOVE_RIGHT") {
        if (state.phase === "COLLECTING" || state.phase === "DROP_PENDING") return state;
        !(state.phase === "DRAGGING") && invariant(false);
        var result2 = moveInDirection({
            state: state,
            type: action.type
        });
        if (!result2) return state;
        return update({
            state: state,
            impact: result2.impact,
            clientSelection: result2.clientSelection,
            scrollJumpRequest: result2.scrollJumpRequest
        });
    }
    if (action.type === "DROP_PENDING") {
        var reason = action.payload.reason;
        !(state.phase === "COLLECTING") && invariant(false);
        var newState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            phase: "DROP_PENDING",
            isWaiting: true,
            reason: reason
        });
        return newState;
    }
    if (action.type === "DROP_ANIMATE") {
        var _action_payload5 = action.payload, completed = _action_payload5.completed, dropDuration = _action_payload5.dropDuration, newHomeClientOffset = _action_payload5.newHomeClientOffset;
        !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && invariant(false);
        var result3 = {
            phase: "DROP_ANIMATING",
            completed: completed,
            dropDuration: dropDuration,
            newHomeClientOffset: newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result3;
    }
    if (action.type === "DROP_COMPLETE") {
        var completed1 = action.payload.completed;
        return {
            phase: "IDLE",
            completed: completed1,
            shouldFlush: false
        };
    }
    return state;
};
var beforeInitialCapture = function(args) {
    return {
        type: "BEFORE_INITIAL_CAPTURE",
        payload: args
    };
};
var lift$1 = function(args) {
    return {
        type: "LIFT",
        payload: args
    };
};
var initialPublish = function(args) {
    return {
        type: "INITIAL_PUBLISH",
        payload: args
    };
};
var publishWhileDragging = function(args) {
    return {
        type: "PUBLISH_WHILE_DRAGGING",
        payload: args
    };
};
var collectionStarting = function() {
    return {
        type: "COLLECTION_STARTING",
        payload: null
    };
};
var updateDroppableScroll = function(args) {
    return {
        type: "UPDATE_DROPPABLE_SCROLL",
        payload: args
    };
};
var updateDroppableIsEnabled = function(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_ENABLED",
        payload: args
    };
};
var updateDroppableIsCombineEnabled = function(args) {
    return {
        type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
        payload: args
    };
};
var move = function(args) {
    return {
        type: "MOVE",
        payload: args
    };
};
var moveByWindowScroll = function(args) {
    return {
        type: "MOVE_BY_WINDOW_SCROLL",
        payload: args
    };
};
var updateViewportMaxScroll = function(args) {
    return {
        type: "UPDATE_VIEWPORT_MAX_SCROLL",
        payload: args
    };
};
var moveUp = function() {
    return {
        type: "MOVE_UP",
        payload: null
    };
};
var moveDown = function() {
    return {
        type: "MOVE_DOWN",
        payload: null
    };
};
var moveRight = function() {
    return {
        type: "MOVE_RIGHT",
        payload: null
    };
};
var moveLeft = function() {
    return {
        type: "MOVE_LEFT",
        payload: null
    };
};
var flush = function() {
    return {
        type: "FLUSH",
        payload: null
    };
};
var animateDrop = function(args) {
    return {
        type: "DROP_ANIMATE",
        payload: args
    };
};
var completeDrop = function(args) {
    return {
        type: "DROP_COMPLETE",
        payload: args
    };
};
var drop$1 = function(args) {
    return {
        type: "DROP",
        payload: args
    };
};
var dropPending = function(args) {
    return {
        type: "DROP_PENDING",
        payload: args
    };
};
var dropAnimationFinished = function() {
    return {
        type: "DROP_ANIMATION_FINISHED",
        payload: null
    };
};
function checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    var indexes = insideDestination.map(function(d) {
        return d.descriptor.index;
    });
    var errors = {};
    for(var i = 1; i < indexes.length; i++){
        var current = indexes[i];
        var previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    var formatted = indexes.map(function(index) {
        var hasError = Boolean(errors[index]);
        return hasError ? "[\uD83D\uDD25".concat(index, "]") : "".concat(index);
    }).join(", ");
}
function validateDimensions(critical, dimensions) {}
var lift = function(marshal) {
    return function(param) {
        var getState = param.getState, dispatch = param.dispatch;
        return function(next) {
            return function(action) {
                if (action.type !== "LIFT") {
                    next(action);
                    return;
                }
                var _action_payload = action.payload, id = _action_payload.id, clientSelection = _action_payload.clientSelection, movementMode = _action_payload.movementMode;
                var initial = getState();
                if (initial.phase === "DROP_ANIMATING") dispatch(completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === "IDLE") && invariant(false);
                dispatch(flush());
                dispatch(beforeInitialCapture({
                    draggableId: id,
                    movementMode: movementMode
                }));
                var scrollOptions = {
                    shouldPublishImmediately: movementMode === "SNAP"
                };
                var request = {
                    draggableId: id,
                    scrollOptions: scrollOptions
                };
                var _marshal_startPublishing = marshal.startPublishing(request), critical = _marshal_startPublishing.critical, dimensions = _marshal_startPublishing.dimensions, viewport = _marshal_startPublishing.viewport;
                validateDimensions(critical, dimensions);
                dispatch(initialPublish({
                    critical: critical,
                    dimensions: dimensions,
                    clientSelection: clientSelection,
                    movementMode: movementMode,
                    viewport: viewport
                }));
            };
        };
    };
};
var style = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") marshal.dragging();
                if (action.type === "DROP_ANIMATE") marshal.dropping(action.payload.completed.result.reason);
                if (action.type === "FLUSH" || action.type === "DROP_COMPLETE") marshal.resting();
                next(action);
            };
        };
    };
};
var curves = {
    outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
    drop: "cubic-bezier(.2,1,.1,1)"
};
var combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
var timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
var outOfTheWayTiming = "".concat(timings.outOfTheWay, "s ").concat(curves.outOfTheWay);
var transitions = {
    fluid: "opacity ".concat(outOfTheWayTiming),
    snap: "transform ".concat(outOfTheWayTiming, ", opacity ").concat(outOfTheWayTiming),
    drop: function(duration) {
        var timing = "".concat(duration, "s ").concat(curves.drop);
        return "transform ".concat(timing, ", opacity ").concat(timing);
    },
    outOfTheWay: "transform ".concat(outOfTheWayTiming),
    placeholder: "height ".concat(outOfTheWayTiming, ", width ").concat(outOfTheWayTiming, ", margin ").concat(outOfTheWayTiming)
};
var moveTo = function(offset) {
    return isEqual$1(offset, origin) ? undefined : "translate(".concat(offset.x, "px, ").concat(offset.y, "px)");
};
var transforms = {
    moveTo: moveTo,
    drop: function(offset, isCombining) {
        var translate = moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return "".concat(translate, " scale(").concat(combine.scale.drop, ")");
    }
};
var minDropTime = timings.minDropTime, maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = function(param) {
    var current = param.current, destination = param.destination, reason = param.reason;
    var distance$1 = distance(current, destination);
    if (distance$1 <= 0) return minDropTime;
    if (distance$1 >= maxDropTimeAtDistance) return maxDropTime;
    var percentage = distance$1 / maxDropTimeAtDistance;
    var duration = minDropTime + dropTimeRange * percentage;
    var withDuration = reason === "CANCEL" ? duration * cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var getNewHomeClientOffset = function(param) {
    var impact = param.impact, draggable = param.draggable, dimensions = param.dimensions, viewport = param.viewport, afterCritical = param.afterCritical;
    var draggables = dimensions.draggables, droppables = dimensions.droppables;
    var droppableId = whatIsDraggedOver(impact);
    var destination = droppableId ? droppables[droppableId] : null;
    var home = droppables[draggable.descriptor.droppableId];
    var newClientCenter = getClientBorderBoxCenter({
        impact: impact,
        draggable: draggable,
        draggables: draggables,
        afterCritical: afterCritical,
        droppable: destination || home,
        viewport: viewport
    });
    var offset = subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var getDropImpact = function(param) {
    var draggables = param.draggables, reason = param.reason, lastImpact = param.lastImpact, home = param.home, viewport = param.viewport, onLiftImpact = param.onLiftImpact;
    if (!lastImpact.at || reason !== "DROP") {
        var recomputedHomeImpact = recompute({
            draggables: draggables,
            impact: onLiftImpact,
            destination: home,
            viewport: viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === "REORDER") return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    var withoutMovement = (0, _objectSpreadProps._)((0, _objectSpread._)({}, lastImpact), {
        displaced: emptyGroups
    });
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
var dropMiddleware = function(param) {
    var getState = param.getState, dispatch = param.dispatch;
    return function(next) {
        return function(action) {
            if (action.type !== "DROP") {
                next(action);
                return;
            }
            var state = getState();
            var reason = action.payload.reason;
            if (state.phase === "COLLECTING") {
                dispatch(dropPending({
                    reason: reason
                }));
                return;
            }
            if (state.phase === "IDLE") return;
            var isWaitingForDrop = state.phase === "DROP_PENDING" && state.isWaiting;
            !!isWaitingForDrop && invariant(false);
            !(state.phase === "DRAGGING" || state.phase === "DROP_PENDING") && invariant(false);
            var critical = state.critical;
            var dimensions = state.dimensions;
            var draggable = dimensions.draggables[state.critical.draggable.id];
            var _getDropImpact = getDropImpact({
                reason: reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            }), impact = _getDropImpact.impact, didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;
            var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
            var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
            var source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            var result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source: source,
                reason: reason,
                mode: state.movementMode,
                destination: destination,
                combine: combine
            };
            var newHomeClientOffset = getNewHomeClientOffset({
                impact: impact,
                draggable: draggable,
                dimensions: dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            var completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result: result,
                impact: impact
            };
            var isAnimationRequired = !isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch(completeDrop({
                    completed: completed
                }));
                return;
            }
            var dropDuration = getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason: reason
            });
            var args = {
                newHomeClientOffset: newHomeClientOffset,
                dropDuration: dropDuration,
                completed: completed
            };
            dispatch(animateDrop(args));
        };
    };
};
var drop = dropMiddleware;
var getWindowScroll = function() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
function getWindowScrollBinding(update) {
    return {
        eventName: "scroll",
        options: {
            passive: true,
            capture: false
        },
        fn: function(event) {
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function getScrollListener(param) {
    var onWindowScroll = param.onWindowScroll;
    function updateScroll() {
        onWindowScroll(getWindowScroll());
    }
    var scheduled = (0, _rafSchdDefault.default)(updateScroll);
    var binding = getWindowScrollBinding(scheduled);
    var unbind = noop$2;
    function isActive() {
        return unbind !== noop$2;
    }
    function start() {
        !!isActive() && invariant(false);
        unbind = bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && invariant(false);
        scheduled.cancel();
        unbind();
        unbind = noop$2;
    }
    return {
        start: start,
        stop: stop,
        isActive: isActive
    };
}
var shouldEnd = function(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var scrollListener = function(store) {
    var listener = getScrollListener({
        onWindowScroll: function(newScroll) {
            store.dispatch(moveByWindowScroll({
                newScroll: newScroll
            }));
        }
    });
    return function(next) {
        return function(action) {
            if (!listener.isActive() && action.type === "INITIAL_PUBLISH") listener.start();
            if (listener.isActive() && shouldEnd(action)) listener.stop();
            next(action);
        };
    };
};
var scrollListener$1 = scrollListener;
var getExpiringAnnounce = function(announce) {
    var wasCalled = false;
    var isExpired = false;
    var timeoutId = setTimeout(function() {
        isExpired = true;
    });
    var result = function(message) {
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = function() {
        return wasCalled;
    };
    return result;
};
var getAsyncMarshal = function() {
    var entries = [];
    var execute = function(timerId) {
        var index = entries.findIndex(function(item) {
            return item.timerId === timerId;
        });
        !(index !== -1) && invariant(false);
        var _entries_splice = (0, _slicedToArray._)(entries.splice(index, 1), 1), entry = _entries_splice[0];
        entry.callback();
    };
    var add = function(fn) {
        var timerId = setTimeout(function() {
            return execute(timerId);
        });
        var entry = {
            timerId: timerId,
            callback: fn
        };
        entries.push(entry);
    };
    var flush = function() {
        if (!entries.length) return;
        var shallow = (0, _toConsumableArray._)(entries);
        entries.length = 0;
        shallow.forEach(function(entry) {
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add: add,
        flush: flush
    };
};
var areLocationsEqual = function(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function(first, second) {
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function(first, second) {
    if (first === second) return true;
    var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
var withTimings = function(key, fn) {
    start();
    fn();
    finish();
};
var getDragStart = function(critical, mode) {
    return {
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode: mode
    };
};
function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    var willExpire = getExpiringAnnounce(announce);
    var provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var getPublisher = function(getResponders, announce) {
    var asyncMarshal = getAsyncMarshal();
    var dragging = null;
    var beforeCapture = function(draggableId, mode) {
        !!dragging && invariant(false);
        withTimings("onBeforeCapture", function() {
            var fn = getResponders().onBeforeCapture;
            if (fn) {
                var before = {
                    draggableId: draggableId,
                    mode: mode
                };
                fn(before);
            }
        });
    };
    var beforeStart = function(critical, mode) {
        !!dragging && invariant(false);
        withTimings("onBeforeDragStart", function() {
            var fn = getResponders().onBeforeDragStart;
            if (fn) fn(getDragStart(critical, mode));
        });
    };
    var start = function(critical, mode) {
        !!dragging && invariant(false);
        var data = getDragStart(critical, mode);
        dragging = {
            mode: mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(function() {
            withTimings("onDragStart", function() {
                return execute(getResponders().onDragStart, data, announce, preset$1.onDragStart);
            });
        });
    };
    var update = function(critical, impact) {
        var location = tryGetDestination(impact);
        var combine = tryGetCombine(impact);
        !dragging && invariant(false);
        var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        var data = (0, _objectSpreadProps._)((0, _objectSpread._)({}, getDragStart(critical, dragging.mode)), {
            combine: combine,
            destination: location
        });
        asyncMarshal.add(function() {
            withTimings("onDragUpdate", function() {
                return execute(getResponders().onDragUpdate, data, announce, preset$1.onDragUpdate);
            });
        });
    };
    var flush = function() {
        !dragging && invariant(false);
        asyncMarshal.flush();
    };
    var drop = function(result) {
        !dragging && invariant(false);
        dragging = null;
        withTimings("onDragEnd", function() {
            return execute(getResponders().onDragEnd, result, announce, preset$1.onDragEnd);
        });
    };
    var abort = function() {
        if (!dragging) return;
        var result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, getDragStart(dragging.lastCritical, dragging.mode)), {
            combine: null,
            destination: null,
            reason: "CANCEL"
        });
        drop(result);
    };
    return {
        beforeCapture: beforeCapture,
        beforeStart: beforeStart,
        start: start,
        update: update,
        flush: flush,
        drop: drop,
        abort: abort
    };
};
var responders = function(getResponders, announce) {
    var publisher = getPublisher(getResponders, announce);
    return function(store) {
        return function(next) {
            return function(action) {
                if (action.type === "BEFORE_INITIAL_CAPTURE") {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    var critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    var result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (action.type === "FLUSH") {
                    publisher.abort();
                    return;
                }
                var state = store.getState();
                if (state.phase === "DRAGGING") publisher.update(state.critical, state.impact);
            };
        };
    };
};
var dropAnimationFinishMiddleware = function(store) {
    return function(next) {
        return function(action) {
            if (action.type !== "DROP_ANIMATION_FINISHED") {
                next(action);
                return;
            }
            var state = store.getState();
            !(state.phase === "DROP_ANIMATING") && invariant(false);
            store.dispatch(completeDrop({
                completed: state.completed
            }));
        };
    };
};
var dropAnimationFinish = dropAnimationFinishMiddleware;
var dropAnimationFlushOnScrollMiddleware = function(store) {
    var unbind = null;
    var frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return function(next) {
        return function(action) {
            if (action.type === "FLUSH" || action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATION_FINISHED") clear();
            next(action);
            if (action.type !== "DROP_ANIMATE") return;
            var binding = {
                eventName: "scroll",
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    var state = store.getState();
                    if (state.phase === "DROP_ANIMATING") store.dispatch(dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(function() {
                frameId = null;
                unbind = bindEvents(window, [
                    binding
                ]);
            });
        };
    };
};
var dropAnimationFlushOnScroll = dropAnimationFlushOnScrollMiddleware;
var dimensionMarshalStopper = function(marshal) {
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "DROP_COMPLETE" || action.type === "FLUSH" || action.type === "DROP_ANIMATE") marshal.stopPublishing();
                next(action);
            };
        };
    };
};
var focus = function(marshal) {
    var isWatching = false;
    return function() {
        return function(next) {
            return function(action) {
                if (action.type === "INITIAL_PUBLISH") {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (action.type === "FLUSH") {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (action.type === "DROP_COMPLETE") {
                    isWatching = false;
                    var result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
        };
    };
};
var shouldStop = function(action) {
    return action.type === "DROP_COMPLETE" || action.type === "DROP_ANIMATE" || action.type === "FLUSH";
};
var autoScroll = function(autoScroller) {
    return function(store) {
        return function(next) {
            return function(action) {
                if (shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (action.type === "INITIAL_PUBLISH") {
                    next(action);
                    var state = store.getState();
                    !(state.phase === "DRAGGING") && invariant(false);
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
        };
    };
};
var pendingDrop = function(store) {
    return function(next) {
        return function(action) {
            next(action);
            if (action.type !== "PUBLISH_WHILE_DRAGGING") return;
            var postActionState = store.getState();
            if (postActionState.phase !== "DROP_PENDING") return;
            if (postActionState.isWaiting) return;
            store.dispatch(drop$1({
                reason: postActionState.reason
            }));
        };
    };
};
var pendingDrop$1 = pendingDrop;
var composeEnhancers = (0, _redux.compose);
var createStore = function(param) {
    var dimensionMarshal = param.dimensionMarshal, focusMarshal = param.focusMarshal, styleMarshal = param.styleMarshal, getResponders = param.getResponders, announce = param.announce, autoScroller = param.autoScroller;
    return (0, _redux.createStore)(reducer, composeEnhancers((0, _redux.applyMiddleware)(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift(dimensionMarshal), drop, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop$1, autoScroll(autoScroller), scrollListener$1, focus(focusMarshal), responders(getResponders, announce))));
};
var clean$1 = function() {
    return {
        additions: {},
        removals: {},
        modified: {}
    };
};
function createPublisher(param) {
    var registry = param.registry, callbacks = param.callbacks;
    var staging = clean$1();
    var frameId = null;
    var collect = function() {
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(function() {
            frameId = null;
            start();
            var additions = staging.additions, removals = staging.removals, modified = staging.modified;
            var added = Object.keys(additions).map(function(id) {
                return registry.draggable.getById(id).getDimension(origin);
            }).sort(function(a, b) {
                return a.descriptor.index - b.descriptor.index;
            });
            var updated = Object.keys(modified).map(function(id) {
                var entry = registry.droppable.getById(id);
                var scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll: scroll
                };
            });
            var result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = clean$1();
            finish();
            callbacks.publish(result);
        });
    };
    var add = function(entry) {
        var id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    var remove = function(entry) {
        var descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    var stop = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = clean$1();
    };
    return {
        add: add,
        remove: remove,
        stop: stop
    };
}
var getMaxScroll = function(param) {
    var scrollHeight = param.scrollHeight, scrollWidth = param.scrollWidth, height = param.height, width = param.width;
    var maxScroll = subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    var adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var getDocumentElement = function() {
    var doc = document.documentElement;
    !doc && invariant(false);
    return doc;
};
var getMaxWindowScroll = function() {
    var doc = getDocumentElement();
    var maxScroll = getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var getViewport = function() {
    var scroll = getWindowScroll();
    var maxScroll = getMaxWindowScroll();
    var top = scroll.y;
    var left = scroll.x;
    var doc = getDocumentElement();
    var width = doc.clientWidth;
    var height = doc.clientHeight;
    var right = left + width;
    var bottom = top + height;
    var frame = (0, _cssBoxModel.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    var viewport = {
        frame: frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: origin,
                displacement: origin
            }
        }
    };
    return viewport;
};
var getInitialPublish = function(param) {
    var critical = param.critical, scrollOptions = param.scrollOptions, registry = param.registry;
    start();
    var viewport = getViewport();
    var windowScroll = viewport.scroll.current;
    var home = critical.droppable;
    var droppables = registry.droppable.getAllByType(home.type).map(function(entry) {
        return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
    });
    var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function(entry) {
        return entry.getDimension(windowScroll);
    });
    var dimensions = {
        draggables: toDraggableMap(draggables),
        droppables: toDroppableMap(droppables)
    };
    finish();
    var result = {
        dimensions: dimensions,
        critical: critical,
        viewport: viewport
    };
    return result;
};
function shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== "virtual") return false;
    return true;
}
var createDimensionMarshal = function(registry, callbacks) {
    var collection = null;
    var publisher = createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry: registry
    });
    var updateDroppableIsEnabled = function(id, isEnabled) {
        !registry.droppable.exists(id) && invariant(false);
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id: id,
            isEnabled: isEnabled
        });
    };
    var updateDroppableIsCombineEnabled = function(id, isCombineEnabled) {
        if (!collection) return;
        !registry.droppable.exists(id) && invariant(false);
        callbacks.updateDroppableIsCombineEnabled({
            id: id,
            isCombineEnabled: isCombineEnabled
        });
    };
    var updateDroppableScroll = function(id, newScroll) {
        if (!collection) return;
        !registry.droppable.exists(id) && invariant(false);
        callbacks.updateDroppableScroll({
            id: id,
            newScroll: newScroll
        });
    };
    var scrollDroppable = function(id, change) {
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    var stopPublishing = function() {
        if (!collection) return;
        publisher.stop();
        var home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach(function(entry) {
            return entry.callbacks.dragStopped();
        });
        collection.unsubscribe();
        collection = null;
    };
    var subscriber = function(event) {
        !collection && invariant(false);
        var dragging = collection.critical.draggable;
        if (event.type === "ADDITION") {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === "REMOVAL") {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    var startPublishing = function(request) {
        !!collection && invariant(false);
        var entry = registry.draggable.getById(request.draggableId);
        var home = registry.droppable.getById(entry.descriptor.droppableId);
        var critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        var unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical: critical,
            unsubscribe: unsubscribe
        };
        return getInitialPublish({
            critical: critical,
            registry: registry,
            scrollOptions: request.scrollOptions
        });
    };
    var marshal = {
        updateDroppableIsEnabled: updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
        scrollDroppable: scrollDroppable,
        updateDroppableScroll: updateDroppableScroll,
        startPublishing: startPublishing,
        stopPublishing: stopPublishing
    };
    return marshal;
};
var canStartDrag = function(state, id) {
    if (state.phase === "IDLE") return true;
    if (state.phase !== "DROP_ANIMATING") return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === "DROP";
};
var scrollWindow = function(change) {
    window.scrollBy(change.x, change.y);
};
var getScrollableDroppables = (0, _memoizeOneDefault.default)(function(droppables) {
    return toDroppableList(droppables).filter(function(droppable) {
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    });
});
var getScrollableDroppableOver = function(target, droppables) {
    var maybe = getScrollableDroppables(droppables).find(function(droppable) {
        !droppable.frame && invariant(false);
        return isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var getBestScrollableDroppable = function(param) {
    var center = param.center, destination = param.destination, droppables = param.droppables;
    if (destination) {
        var dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    var dimension1 = getScrollableDroppableOver(center, droppables);
    return dimension1;
};
var defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: function(percentage) {
        return Math.pow(percentage, 2);
    },
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var getDistanceThresholds = function(container, axis) {
    var getAutoScrollerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
        return defaultAutoScrollerOptions;
    };
    var autoScrollerOptions = getAutoScrollerOptions();
    var startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    var maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    var thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var getPercentage = function(param) {
    var startOfRange = param.startOfRange, endOfRange = param.endOfRange, current = param.current;
    var range = endOfRange - startOfRange;
    if (range === 0) return 0;
    var currentInRange = current - startOfRange;
    var percentage = currentInRange / range;
    return percentage;
};
var minScroll = 1;
var getValueFromDistance = function(distanceToEdge, thresholds) {
    var getAutoScrollerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
        return defaultAutoScrollerOptions;
    };
    var autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return minScroll;
    var percentageFromMaxScrollValueAt = getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    var scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var dampenValueByTime = function(proposedScroll, dragStartTime, getAutoScrollerOptions) {
    var autoScrollerOptions = getAutoScrollerOptions();
    var accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    var stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    var startOfRange = dragStartTime;
    var endOfRange = stopAt;
    var now = Date.now();
    var runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return minScroll;
    var betweenAccelerateAtAndStopAtPercentage = getPercentage({
        startOfRange: accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    var scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var getValue = function(param) {
    var distanceToEdge = param.distanceToEdge, thresholds = param.thresholds, dragStartTime = param.dragStartTime, shouldUseTimeDampening = param.shouldUseTimeDampening, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var scroll = getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max(dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), minScroll);
};
var getScrollOnAxis = function(param) {
    var container = param.container, distanceToEdges = param.distanceToEdges, dragStartTime = param.dragStartTime, axis = param.axis, shouldUseTimeDampening = param.shouldUseTimeDampening, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var thresholds = getDistanceThresholds(container, axis, getAutoScrollerOptions);
    var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return -1 * getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
};
var adjustForSizeLimits = function(param) {
    var container = param.container, subject = param.subject, proposedScroll = param.proposedScroll;
    var isTooBigVertically = subject.height > container.height;
    var isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
var clean = apply(function(value) {
    return value === 0 ? 0 : value;
});
var getScroll$1 = function(param) {
    var dragStartTime = param.dragStartTime, container = param.container, subject = param.subject, center = param.center, shouldUseTimeDampening = param.shouldUseTimeDampening, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    var y = getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: vertical,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    var x = getScrollOnAxis({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: horizontal,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    var required = clean({
        x: x,
        y: y
    });
    if (isEqual$1(required, origin)) return null;
    var limited = adjustForSizeLimits({
        container: container,
        subject: subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return isEqual$1(limited, origin) ? null : limited;
};
var smallestSigned = apply(function(value) {
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
var getOverlap = function() {
    var getRemainder = function(target, max) {
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return function(param) {
        var current = param.current, max = param.max, change = param.change;
        var targetScroll = add(current, change);
        var overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if (isEqual$1(overlap, origin)) return null;
        return overlap;
    };
}();
var canPartiallyScroll = function(param) {
    var rawMax = param.max, current = param.current, change = param.change;
    var max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    var smallestChange = smallestSigned(change);
    var overlap = getOverlap({
        max: max,
        current: current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
var canScrollWindow = function(viewport, change) {
    return canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
};
var getWindowOverlap = function(viewport, change) {
    if (!canScrollWindow(viewport, change)) return null;
    var max = viewport.scroll.max;
    var current = viewport.scroll.current;
    return getOverlap({
        current: current,
        max: max,
        change: change
    });
};
var canScrollDroppable = function(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return false;
    return canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var getDroppableOverlap = function(droppable, change) {
    var frame = droppable.frame;
    if (!frame) return null;
    if (!canScrollDroppable(droppable, change)) return null;
    return getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change: change
    });
};
var getWindowScrollChange = function(param) {
    var viewport = param.viewport, subject = param.subject, center = param.center, dragStartTime = param.dragStartTime, shouldUseTimeDampening = param.shouldUseTimeDampening, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var scroll = getScroll$1({
        dragStartTime: dragStartTime,
        container: viewport.frame,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};
var getDroppableScrollChange = function(param) {
    var droppable = param.droppable, subject = param.subject, center = param.center, dragStartTime = param.dragStartTime, shouldUseTimeDampening = param.shouldUseTimeDampening, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var frame = droppable.frame;
    if (!frame) return null;
    var scroll = getScroll$1({
        dragStartTime: dragStartTime,
        container: frame.pageMarginBox,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};
var scroll = function(param) {
    var state = param.state, dragStartTime = param.dragStartTime, shouldUseTimeDampening = param.shouldUseTimeDampening, scrollWindow = param.scrollWindow, scrollDroppable = param.scrollDroppable, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var center = state.current.page.borderBoxCenter;
    var draggable = state.dimensions.draggables[state.critical.draggable.id];
    var subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        var viewport = state.viewport;
        var change = getWindowScrollChange({
            dragStartTime: dragStartTime,
            viewport: viewport,
            subject: subject,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    var droppable = getBestScrollableDroppable({
        center: center,
        destination: whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    var change1 = getDroppableScrollChange({
        dragStartTime: dragStartTime,
        droppable: droppable,
        subject: subject,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    if (change1) scrollDroppable(droppable.descriptor.id, change1);
};
var createFluidScroller = function(param) {
    var scrollWindow = param.scrollWindow, scrollDroppable = param.scrollDroppable, _param_getAutoScrollerOptions = param.getAutoScrollerOptions, getAutoScrollerOptions = _param_getAutoScrollerOptions === void 0 ? function() {
        return defaultAutoScrollerOptions;
    } : _param_getAutoScrollerOptions;
    var scheduleWindowScroll = (0, _rafSchdDefault.default)(scrollWindow);
    var scheduleDroppableScroll = (0, _rafSchdDefault.default)(scrollDroppable);
    var dragging = null;
    var tryScroll = function(state) {
        !dragging && invariant(false);
        var shouldUseTimeDampening = dragging.shouldUseTimeDampening, dragStartTime = dragging.dragStartTime;
        scroll({
            state: state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
    };
    var start$1 = function(state) {
        start();
        !!dragging && invariant(false);
        var dragStartTime = Date.now();
        var wasScrollNeeded = false;
        var fakeScrollCallback = function() {
            wasScrollNeeded = true;
        };
        scroll({
            state: state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions: getAutoScrollerOptions
        });
        dragging = {
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    var stop = function() {
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop: stop,
        scroll: tryScroll
    };
};
var createJumpScroller = function(param) {
    var move = param.move, scrollDroppable = param.scrollDroppable, scrollWindow = param.scrollWindow;
    var moveByOffset = function(state, offset) {
        var client = add(state.current.client.selection, offset);
        move({
            client: client
        });
    };
    var scrollDroppableAsMuchAsItCan = function(droppable, change) {
        if (!canScrollDroppable(droppable, change)) return change;
        var overlap = getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        var whatTheDroppableCanScroll = subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        var remainder = subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    var scrollWindowAsMuchAsItCan = function(isWindowScrollAllowed, viewport, change) {
        if (!isWindowScrollAllowed) return change;
        if (!canScrollWindow(viewport, change)) return change;
        var overlap = getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        var whatTheWindowCanScroll = subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        var remainder = subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    var jumpScroller = function(state) {
        var request = state.scrollJumpRequest;
        if (!request) return;
        var destination = whatIsDraggedOver(state.impact);
        !destination && invariant(false);
        var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        var viewport = state.viewport;
        var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var createAutoScroller = function(param) {
    var scrollDroppable = param.scrollDroppable, scrollWindow = param.scrollWindow, move = param.move, getAutoScrollerOptions = param.getAutoScrollerOptions;
    var fluidScroller = createFluidScroller({
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable,
        getAutoScrollerOptions: getAutoScrollerOptions
    });
    var jumpScroll = createJumpScroller({
        move: move,
        scrollWindow: scrollWindow,
        scrollDroppable: scrollDroppable
    });
    var scroll = function(state) {
        var autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== "DRAGGING") return;
        if (state.movementMode === "FLUID") {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    var scroller = {
        scroll: scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
var prefix = "data-rfd";
var dragHandle = function() {
    var base = "".concat(prefix, "-drag-handle");
    return {
        base: base,
        draggableId: "".concat(base, "-draggable-id"),
        contextId: "".concat(base, "-context-id")
    };
}();
var draggable = function() {
    var base = "".concat(prefix, "-draggable");
    return {
        base: base,
        contextId: "".concat(base, "-context-id"),
        id: "".concat(base, "-id")
    };
}();
var droppable = function() {
    var base = "".concat(prefix, "-droppable");
    return {
        base: base,
        contextId: "".concat(base, "-context-id"),
        id: "".concat(base, "-id")
    };
}();
var scrollContainer = {
    contextId: "".concat(prefix, "-scroll-container-context-id")
};
var makeGetSelector = function(context) {
    return function(attribute) {
        return "[".concat(attribute, '="').concat(context, '"]');
    };
};
var getStyles = function(rules, property) {
    return rules.map(function(rule) {
        var value = rule.styles[property];
        if (!value) return "";
        return "".concat(rule.selector, " { ").concat(value, " }");
    }).join(" ");
};
var noPointerEvents = "pointer-events: none;";
var getStyles$1 = function(contextId) {
    var getSelector = makeGetSelector(contextId);
    var dragHandle$1 = function() {
        var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
        return {
            selector: getSelector(dragHandle.contextId),
            styles: {
                always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
                resting: grabCursor,
                dragging: noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    }();
    var draggable$1 = function() {
        var transition = "\n      transition: ".concat(transitions.outOfTheWay, ";\n    ");
        return {
            selector: getSelector(draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    }();
    var droppable$1 = {
        selector: getSelector(droppable.contextId),
        styles: {
            always: "overflow-anchor: none;"
        }
    };
    var body = {
        selector: "body",
        styles: {
            dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
        }
    };
    var rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: getStyles(rules, "always"),
        resting: getStyles(rules, "resting"),
        dragging: getStyles(rules, "dragging"),
        dropAnimating: getStyles(rules, "dropAnimating"),
        userCancel: getStyles(rules, "userCancel")
    };
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
var useLayoutEffect = useIsomorphicLayoutEffect;
var getHead = function() {
    var head = document.querySelector("head");
    !head && invariant(false);
    return head;
};
var createStyleEl = function(nonce) {
    var el = document.createElement("style");
    if (nonce) el.setAttribute("nonce", nonce);
    el.type = "text/css";
    return el;
};
function useStyleMarshal(contextId, nonce) {
    var styles = (0, _useMemoOne.useMemo)(function() {
        return getStyles$1(contextId);
    }, [
        contextId
    ]);
    var alwaysRef = (0, _react.useRef)(null);
    var dynamicRef = (0, _react.useRef)(null);
    var setDynamicStyle = (0, _useMemoOne.useCallback)((0, _memoizeOneDefault.default)(function(proposed) {
        var el = dynamicRef.current;
        !el && invariant(false);
        el.textContent = proposed;
    }), []);
    var setAlwaysStyle = (0, _useMemoOne.useCallback)(function(proposed) {
        var el = alwaysRef.current;
        !el && invariant(false);
        el.textContent = proposed;
    }, []);
    useLayoutEffect(function() {
        !(!alwaysRef.current && !dynamicRef.current) && invariant(false);
        var always = createStyleEl(nonce);
        var dynamic = createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute("".concat(prefix, "-always"), contextId);
        dynamic.setAttribute("".concat(prefix, "-dynamic"), contextId);
        getHead().appendChild(always);
        getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return function() {
            var remove = function(ref) {
                var current = ref.current;
                !current && invariant(false);
                getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    var dragging = (0, _useMemoOne.useCallback)(function() {
        return setDynamicStyle(styles.dragging);
    }, [
        setDynamicStyle,
        styles.dragging
    ]);
    var dropping = (0, _useMemoOne.useCallback)(function(reason) {
        if (reason === "DROP") {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    var resting = (0, _useMemoOne.useCallback)(function() {
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    var marshal = (0, _useMemoOne.useMemo)(function() {
        return {
            dragging: dragging,
            dropping: dropping,
            resting: resting
        };
    }, [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var getWindowFromEl = function(el) {
    if (el && el.ownerDocument && el.ownerDocument.defaultView) return el.ownerDocument.defaultView;
    return window;
};
function isHtmlElement(el) {
    return el instanceof getWindowFromEl(el).HTMLElement;
}
function findDragHandle(contextId, draggableId) {
    var selector = "[".concat(dragHandle.contextId, '="').concat(contextId, '"]');
    var possible = querySelectorAll(document, selector);
    if (!possible.length) return null;
    var handle = possible.find(function(el) {
        return el.getAttribute(dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function useFocusMarshal(contextId) {
    var entriesRef = (0, _react.useRef)({});
    var recordRef = (0, _react.useRef)(null);
    var restoreFocusFrameRef = (0, _react.useRef)(null);
    var isMountedRef = (0, _react.useRef)(false);
    var register = (0, _useMemoOne.useCallback)(function register(id, focus) {
        var entry = {
            id: id,
            focus: focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            var entries = entriesRef.current;
            var current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    var tryGiveFocus = (0, _useMemoOne.useCallback)(function tryGiveFocus(tryGiveFocusTo) {
        var handle = findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    var tryShiftRecord = (0, _useMemoOne.useCallback)(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    var tryRestoreFocusRecorded = (0, _useMemoOne.useCallback)(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(function() {
            restoreFocusFrameRef.current = null;
            var record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    var tryRecordFocus = (0, _useMemoOne.useCallback)(function tryRecordFocus(id) {
        recordRef.current = null;
        var focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute(dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    useLayoutEffect(function() {
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            var frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    var marshal = (0, _useMemoOne.useMemo)(function() {
        return {
            register: register,
            tryRecordFocus: tryRecordFocus,
            tryRestoreFocusRecorded: tryRestoreFocusRecorded,
            tryShiftRecord: tryShiftRecord
        };
    }, [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function createRegistry() {
    var entries = {
        draggables: {},
        droppables: {}
    };
    var subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            var index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach(function(cb) {
            return cb(event);
        });
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        var entry = findDraggableById(id);
        !entry && invariant(false);
        return entry;
    }
    var draggableAPI = {
        register: function(entry) {
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: "ADDITION",
                value: entry
            });
        },
        update: function(entry, last) {
            var current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: function(entry) {
            var draggableId = entry.descriptor.id;
            var current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: "REMOVAL",
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: function(id) {
            return Boolean(findDraggableById(id));
        },
        getAllByType: function(type) {
            return Object.values(entries.draggables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        var entry = findDroppableById(id);
        !entry && invariant(false);
        return entry;
    }
    var droppableAPI = {
        register: function(entry) {
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: function(entry) {
            var current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: function(id) {
            return Boolean(findDroppableById(id));
        },
        getAllByType: function(type) {
            return Object.values(entries.droppables).filter(function(entry) {
                return entry.descriptor.type === type;
            });
        }
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe: subscribe,
        clean: clean
    };
}
function useRegistry() {
    var registry = (0, _useMemoOne.useMemo)(createRegistry, []);
    (0, _react.useEffect)(function() {
        return function unmount() {
            if ((0, _reactDefault.default).version.startsWith("16") || (0, _reactDefault.default).version.startsWith("17")) requestAnimationFrame(registry.clean);
            else registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var StoreContext = (0, _reactDefault.default).createContext(null);
var getBodyElement = function() {
    var body = document.body;
    !body && invariant(false);
    return body;
};
var visuallyHidden = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: "0",
    padding: "0",
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    "clip-path": "inset(100%)"
};
var visuallyHidden$1 = visuallyHidden;
var getId = function(contextId) {
    return "rfd-announcement-".concat(contextId);
};
function useAnnouncer(contextId) {
    var id = (0, _useMemoOne.useMemo)(function() {
        return getId(contextId);
    }, [
        contextId
    ]);
    var ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(function setup() {
        var el = document.createElement("div");
        ref.current = el;
        el.id = id;
        el.setAttribute("aria-live", "assertive");
        el.setAttribute("aria-atomic", "true");
        (0, _extendsDefault.default)(el.style, visuallyHidden$1);
        getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                var body = getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    var announce = (0, _useMemoOne.useCallback)(function(message) {
        var el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
var count$1 = 0;
var defaults = {
    separator: "::"
};
function resetDeprecatedUniqueId() {
    count$1 = 0;
}
function useDeprecatedUniqueId(prefix) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaults;
    return (0, _useMemoOne.useMemo)(function() {
        return "".concat(prefix).concat(options.separator).concat(count$1++);
    }, [
        options.separator,
        prefix
    ]);
}
function useUniqueId(prefix) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaults;
    var id = (0, _reactDefault.default).useId();
    return (0, _useMemoOne.useMemo)(function() {
        return "".concat(prefix).concat(options.separator).concat(id);
    }, [
        options.separator,
        prefix,
        id
    ]);
}
var useUniqueId$1 = "useId" in (0, _reactDefault.default) ? useUniqueId : useDeprecatedUniqueId;
function getElementId(param) {
    var contextId = param.contextId, uniqueId = param.uniqueId;
    return "rfd-hidden-text-".concat(contextId, "-").concat(uniqueId);
}
function useHiddenTextElement(param) {
    var contextId = param.contextId, text = param.text;
    var uniqueId = useUniqueId$1("hidden-text", {
        separator: "-"
    });
    var id = (0, _useMemoOne.useMemo)(function() {
        return getElementId({
            contextId: contextId,
            uniqueId: uniqueId
        });
    }, [
        uniqueId,
        contextId
    ]);
    (0, _react.useEffect)(function mount() {
        var el = document.createElement("div");
        el.id = id;
        el.textContent = text;
        el.style.display = "none";
        getBodyElement().appendChild(el);
        return function unmount() {
            var body = getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var AppContext = (0, _reactDefault.default).createContext(null);
var peerDependencies = {
    react: "^16.8.5 || ^17.0.0 || ^18.0.0",
    "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};
var semver = /(\d+)\.(\d+)\.(\d+)/;
var getVersion = function(value) {
    var result = semver.exec(value);
    !(result != null) && invariant(false);
    var major = Number(result[1]);
    var minor = Number(result[2]);
    var patch = Number(result[3]);
    return {
        major: major,
        minor: minor,
        patch: patch,
        raw: value
    };
};
var isSatisfied = function(expected, actual) {
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var checkReactVersion = function(peerDepValue, actualValue) {
    var peerDep = getVersion(peerDepValue);
    var actual = getVersion(actualValue);
    if (isSatisfied(peerDep, actual)) return;
};
var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md\n";
var checkDoctype = function(doc) {
    var doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function useDev(useHook) {}
function useDevSetupWarning(fn, inputs) {
    useDev(function() {
        (0, _react.useEffect)(function() {
            try {
                fn();
            } catch (e) {
                error("\n          A setup problem was encountered.\n\n          > ".concat(e.message, "\n        "));
            }
        }, inputs);
    });
}
function useStartupValidation() {
    useDevSetupWarning(function() {
        checkReactVersion(peerDependencies.react, (0, _reactDefault.default).version);
        checkDoctype(document);
    }, []);
}
function usePrevious(current) {
    var ref = (0, _react.useRef)(current);
    (0, _react.useEffect)(function() {
        ref.current = current;
    });
    return ref;
}
function create() {
    var lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && invariant(false);
        var newLock = {
            abandon: abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && invariant(false);
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed: isClaimed,
        isActive: isActive,
        claim: claim,
        release: release,
        tryAbandon: tryAbandon
    };
}
function isDragging(state) {
    if (state.phase === "IDLE" || state.phase === "DROP_ANIMATING") return false;
    return state.isDragging;
}
var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;
var _obj;
var preventedKeys = (_obj = {}, (0, _defineProperty._)(_obj, enter, true), (0, _defineProperty._)(_obj, tab, true), _obj);
var preventStandardKeyEvents = function(event) {
    if (preventedKeys[event.keyCode]) event.preventDefault();
};
var supportedEventName = function() {
    var base = "visibilitychange";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "ms".concat(base),
        "webkit".concat(base),
        "moz".concat(base),
        "o".concat(base)
    ];
    var supported = candidates.find(function(eventName) {
        return "on".concat(eventName) in document;
    });
    return supported || base;
}();
var supportedPageVisibilityEventName = supportedEventName;
var primaryButton = 0;
var sloppyClickThreshold = 5;
function isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}
var idle$1 = {
    type: "IDLE"
};
function getCaptureBindings(param) {
    var cancel = param.cancel, completed = param.completed, getPhase = param.getPhase, setPhase = param.setPhase;
    return [
        {
            eventName: "mousemove",
            fn: function(event) {
                var button = event.button, clientX = event.clientX, clientY = event.clientY;
                if (button !== primaryButton) return;
                var point = {
                    x: clientX,
                    y: clientY
                };
                var phase = getPhase();
                if (phase.type === "DRAGGING") {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === "PENDING") && invariant(false);
                var pending = phase.point;
                if (!isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                var actions = phase.actions.fluidLift(point);
                setPhase({
                    type: "DRAGGING",
                    actions: actions
                });
            }
        },
        {
            eventName: "mouseup",
            fn: function(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "mousedown",
            fn: function(event) {
                if (getPhase().type === "DRAGGING") event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "keydown",
            fn: function(event) {
                var phase = getPhase();
                if (phase.type === "PENDING") {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "scroll",
            options: {
                passive: true,
                capture: false
            },
            fn: function() {
                if (getPhase().type === "PENDING") cancel();
            }
        },
        {
            eventName: "webkitmouseforcedown",
            fn: function(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && invariant(false);
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function useMouseSensor(api) {
    var phaseRef = (0, _react.useRef)(idle$1);
    var unbindEventsRef = (0, _react.useRef)(noop$2);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "mousedown",
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                var point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var preventForcePressBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "webkitmouseforcewillbegin",
            fn: function(event) {
                if (event.defaultPrevented) return;
                var id = api.findClosestDraggableId(event);
                if (!id) return;
                var options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function listenForCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    var stop = (0, _useMemoOne.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        phaseRef.current = idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    var cancel = (0, _useMemoOne.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, _useMemoOne.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var bindings = getCaptureBindings({
            cancel: cancel,
            completed: stop,
            getPhase: function() {
                return phaseRef.current;
            },
            setPhase: function(phase) {
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    var startPendingDrag = (0, _useMemoOne.useCallback)(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === "IDLE") && invariant(false);
        phaseRef.current = {
            type: "PENDING",
            point: point,
            actions: actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function noop$1() {}
var _obj1;
var scrollJumpKeys = (_obj1 = {}, (0, _defineProperty._)(_obj1, pageDown, true), (0, _defineProperty._)(_obj1, pageUp, true), (0, _defineProperty._)(_obj1, home, true), (0, _defineProperty._)(_obj1, end, true), _obj1);
function getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: "keydown",
            fn: function(event) {
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if (scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: "mousedown",
            fn: cancel
        },
        {
            eventName: "mouseup",
            fn: cancel
        },
        {
            eventName: "click",
            fn: cancel
        },
        {
            eventName: "touchstart",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "wheel",
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function useKeyboardSensor(api) {
    var unbindEventsRef = (0, _react.useRef)(noop$1);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "keydown",
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== space) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                var isCapturing = true;
                var actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && invariant(false);
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function tryStartCapture() {
        var options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
var idle = {
    type: "IDLE"
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;
function getWindowBindings(param) {
    var cancel = param.cancel, getPhase = param.getPhase;
    return [
        {
            eventName: "orientationchange",
            fn: cancel
        },
        {
            eventName: "resize",
            fn: cancel
        },
        {
            eventName: "contextmenu",
            fn: function(event) {
                event.preventDefault();
            }
        },
        {
            eventName: "keydown",
            fn: function(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function getHandleBindings(param) {
    var cancel = param.cancel, completed = param.completed, getPhase = param.getPhase;
    return [
        {
            eventName: "touchmove",
            options: {
                capture: false
            },
            fn: function(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                var _event_touches_ = event.touches[0], clientX = _event_touches_.clientX, clientY = _event_touches_.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: "touchend",
            fn: function(event) {
                var phase = getPhase();
                if (phase.type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: "touchcancel",
            fn: function(event) {
                if (getPhase().type !== "DRAGGING") {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: "touchforcechange",
            fn: function(event) {
                var phase = getPhase();
                !(phase.type !== "IDLE") && invariant(false);
                var touch = event.touches[0];
                if (!touch) return;
                var isForcePress = touch.force >= forcePressThreshold;
                if (!isForcePress) return;
                var shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === "PENDING") {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedPageVisibilityEventName,
            fn: cancel
        }
    ];
}
function useTouchSensor(api) {
    var phaseRef = (0, _react.useRef)(idle);
    var unbindEventsRef = (0, _react.useRef)(noop$2);
    var getPhase = (0, _useMemoOne.useCallback)(function getPhase() {
        return phaseRef.current;
    }, []);
    var setPhase = (0, _useMemoOne.useCallback)(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    var startCaptureBinding = (0, _useMemoOne.useMemo)(function() {
        return {
            eventName: "touchstart",
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                var draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                var actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                var touch = event.touches[0];
                var clientX = touch.clientX, clientY = touch.clientY;
                var point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        };
    }, [
        api
    ]);
    var listenForCapture = (0, _useMemoOne.useCallback)(function listenForCapture() {
        var options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    var stop = (0, _useMemoOne.useCallback)(function() {
        var current = phaseRef.current;
        if (current.type === "IDLE") return;
        if (current.type === "PENDING") clearTimeout(current.longPressTimerId);
        setPhase(idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    var cancel = (0, _useMemoOne.useCallback)(function() {
        var phase = phaseRef.current;
        stop();
        if (phase.type === "DRAGGING") phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === "PENDING") phase.actions.abort();
    }, [
        stop
    ]);
    var bindCapturingEvents = (0, _useMemoOne.useCallback)(function bindCapturingEvents() {
        var options = {
            capture: true,
            passive: false
        };
        var args = {
            cancel: cancel,
            completed: stop,
            getPhase: getPhase
        };
        var unbindTarget = bindEvents(window, getHandleBindings(args), options);
        var unbindWindow = bindEvents(window, getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    var startDragging = (0, _useMemoOne.useCallback)(function startDragging() {
        var phase = getPhase();
        !(phase.type === "PENDING") && invariant(false);
        var actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: "DRAGGING",
            actions: actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    var startPendingDrag = (0, _useMemoOne.useCallback)(function startPendingDrag(actions, point) {
        !(getPhase().type === "IDLE") && invariant(false);
        var longPressTimerId = setTimeout(startDragging, timeForLongPress);
        setPhase({
            type: "PENDING",
            point: point,
            actions: actions,
            longPressTimerId: longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    useLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            var phase = getPhase();
            if (phase.type === "PENDING") {
                clearTimeout(phase.longPressTimerId);
                setPhase(idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    useLayoutEffect(function webkitHack() {
        var unbind = bindEvents(window, [
            {
                eventName: "touchmove",
                fn: function() {},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function useValidateSensorHooks(sensorHooks) {
    useDev(function() {
        var previousRef = usePrevious(sensorHooks);
        useDevSetupWarning(function() {
            !(previousRef.current.length === sensorHooks.length) && invariant(false);
        });
    });
}
var interactiveTagNames = [
    "input",
    "button",
    "textarea",
    "select",
    "option",
    "optgroup",
    "video",
    "audio"
];
function isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    var hasAnInteractiveTag = interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    var attribute = current.getAttribute("contenteditable");
    if (attribute === "true" || attribute === "") return true;
    if (current === parent) return false;
    return isAnInteractiveElement(parent, current.parentElement);
}
function isEventInInteractiveElement(draggable, event) {
    var target = event.target;
    if (!isHtmlElement(target)) return false;
    return isAnInteractiveElement(draggable, target);
}
var getBorderBoxCenterPosition = function(el) {
    return (0, _cssBoxModel.getRect)(el.getBoundingClientRect()).center;
};
function isElement(el) {
    return el instanceof getWindowFromEl(el).Element;
}
var supportedMatchesName = function() {
    var base = "matches";
    if (typeof document === "undefined") return base;
    var candidates = [
        base,
        "msMatchesSelector",
        "webkitMatchesSelector"
    ];
    var value = candidates.find(function(name) {
        return name in Element.prototype;
    });
    return value || base;
}();
function closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[supportedMatchesName](selector)) return el;
    return closestPonyfill(el.parentElement, selector);
}
function closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return closestPonyfill(el, selector);
}
function getSelector(contextId) {
    return "[".concat(dragHandle.contextId, '="').concat(contextId, '"]');
}
function findClosestDragHandleFromEvent(contextId, event) {
    var target = event.target;
    if (!isElement(target)) return null;
    var selector = getSelector(contextId);
    var handle = closest(target, selector);
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function tryGetClosestDraggableIdFromEvent(contextId, event) {
    var handle = findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute(dragHandle.draggableId);
}
function findDraggable(contextId, draggableId) {
    var selector = "[".concat(draggable.contextId, '="').concat(contextId, '"]');
    var possible = querySelectorAll(document, selector);
    var draggable$1 = possible.find(function(el) {
        return el.getAttribute(draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function preventDefault(event) {
    event.preventDefault();
}
function isActive(param) {
    var expected = param.expected, phase = param.phase, isLockActive = param.isLockActive, shouldWarn = param.shouldWarn;
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function canStart(param) {
    var lockAPI = param.lockAPI, store = param.store, registry = param.registry, draggableId = param.draggableId;
    if (lockAPI.isClaimed()) return false;
    var entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function tryStart(param) {
    var lockAPI = param.lockAPI, contextId = param.contextId, store = param.store, registry = param.registry, draggableId = param.draggableId, forceSensorStop = param.forceSensorStop, sourceEvent = param.sourceEvent;
    var shouldStart = canStart({
        lockAPI: lockAPI,
        store: store,
        registry: registry,
        draggableId: draggableId
    });
    if (!shouldStart) return null;
    var entry = registry.draggable.getById(draggableId);
    var el = findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) return null;
    var lock = lockAPI.claim(forceSensorStop || noop$2);
    var phase = "PRE_DRAG";
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if (isActive({
            expected: expected,
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    var tryDispatchWhenDragging = tryDispatch.bind(null, "DRAGGING");
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = "COMPLETED";
        }
        if (phase !== "PRE_DRAG") {
            completed();
            invariant(false);
        }
        store.dispatch(lift$1(args.liftActionArgs));
        phase = "DRAGGING";
        function finish(reason) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                shouldBlockNextClick: false
            };
            args.cleanup();
            if (options.shouldBlockNextClick) {
                var unbind = bindEvents(window, [
                    {
                        eventName: "click",
                        fn: preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch(drop$1({
                reason: reason
            }));
        }
        return (0, _objectSpread._)({
            isActive: function() {
                return isActive({
                    expected: "DRAGGING",
                    phase: phase,
                    isLockActive: isLockActive,
                    shouldWarn: false
                });
            },
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: function(options) {
                return finish("DROP", options);
            },
            cancel: function(options) {
                return finish("CANCEL", options);
            }
        }, args.actions);
    }
    function fluidLift(clientSelection) {
        var move$1 = (0, _rafSchdDefault.default)(function(client) {
            tryDispatchWhenDragging(function() {
                return move({
                    client: client
                });
            });
        });
        var api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: clientSelection,
                movementMode: "FLUID"
            },
            cleanup: function() {
                return move$1.cancel();
            },
            actions: {
                move: move$1
            }
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, api), {
            move: move$1
        });
    }
    function snapLift() {
        var actions = {
            moveUp: function() {
                return tryDispatchWhenDragging(moveUp);
            },
            moveRight: function() {
                return tryDispatchWhenDragging(moveRight);
            },
            moveDown: function() {
                return tryDispatchWhenDragging(moveDown);
            },
            moveLeft: function() {
                return tryDispatchWhenDragging(moveLeft);
            }
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: getBorderBoxCenterPosition(el),
                movementMode: "SNAP"
            },
            cleanup: noop$2,
            actions: actions
        });
    }
    function abortPreDrag() {
        var shouldRelease = isActive({
            expected: "PRE_DRAG",
            phase: phase,
            isLockActive: isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    var preDrag = {
        isActive: function() {
            return isActive({
                expected: "PRE_DRAG",
                phase: phase,
                isLockActive: isLockActive,
                shouldWarn: false
            });
        },
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift: fluidLift,
        snapLift: snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
var defaultSensors = [
    useMouseSensor,
    useKeyboardSensor,
    useTouchSensor
];
function useSensorMarshal(param) {
    var contextId = param.contextId, store = param.store, registry = param.registry, customSensors = param.customSensors, enableDefaultSensors = param.enableDefaultSensors;
    var useSensors = (0, _toConsumableArray._)(enableDefaultSensors ? defaultSensors : []).concat((0, _toConsumableArray._)(customSensors || []));
    var lockAPI = (0, _react.useState)(function() {
        return create();
    })[0];
    var tryAbandonLock = (0, _useMemoOne.useCallback)(function tryAbandonLock(previous, current) {
        if (isDragging(previous) && !isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    useLayoutEffect(function listenToStore() {
        var previous = store.getState();
        var unsubscribe = store.subscribe(function() {
            var current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    useLayoutEffect(function() {
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    var canGetLock = (0, _useMemoOne.useCallback)(function(draggableId) {
        return canStart({
            lockAPI: lockAPI,
            registry: registry,
            store: store,
            draggableId: draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    var tryGetLock = (0, _useMemoOne.useCallback)(function(draggableId, forceStop, options) {
        return tryStart({
            lockAPI: lockAPI,
            registry: registry,
            contextId: contextId,
            store: store,
            draggableId: draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        });
    }, [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    var findClosestDraggableId = (0, _useMemoOne.useCallback)(function(event) {
        return tryGetClosestDraggableIdFromEvent(contextId, event);
    }, [
        contextId
    ]);
    var findOptionsForDraggable = (0, _useMemoOne.useCallback)(function(id) {
        var entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    var tryReleaseLock = (0, _useMemoOne.useCallback)(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== "IDLE") store.dispatch(flush());
    }, [
        lockAPI,
        store
    ]);
    var isLockClaimed = (0, _useMemoOne.useCallback)(function() {
        return lockAPI.isClaimed();
    }, [
        lockAPI
    ]);
    var api = (0, _useMemoOne.useMemo)(function() {
        return {
            canGetLock: canGetLock,
            tryGetLock: tryGetLock,
            findClosestDraggableId: findClosestDraggableId,
            findOptionsForDraggable: findOptionsForDraggable,
            tryReleaseLock: tryReleaseLock,
            isLockClaimed: isLockClaimed
        };
    }, [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    useValidateSensorHooks(useSensors);
    for(var i = 0; i < useSensors.length; i++)useSensors[i](api);
}
var createResponders = function(props) {
    return {
        onBeforeCapture: function(t) {
            var onBeforeCapureCallback = function() {
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            if ((0, _reactDefault.default).version.startsWith("16") || (0, _reactDefault.default).version.startsWith("17")) onBeforeCapureCallback();
            else (0, _reactDom.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    };
};
var createAutoScrollerOptions = function(props) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultAutoScrollerOptions, props.autoScrollerOptions), {
        durationDampening: (0, _objectSpread._)({}, defaultAutoScrollerOptions.durationDampening, props.autoScrollerOptions)
    });
};
function getStore(lazyRef) {
    !lazyRef.current && invariant(false);
    return lazyRef.current;
}
function App(props) {
    var contextId = props.contextId, setCallbacks = props.setCallbacks, sensors = props.sensors, nonce = props.nonce, dragHandleUsageInstructions = props.dragHandleUsageInstructions;
    var lazyStoreRef = (0, _react.useRef)(null);
    useStartupValidation();
    var lastPropsRef = usePrevious(props);
    var getResponders = (0, _useMemoOne.useCallback)(function() {
        return createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var getAutoScrollerOptions = (0, _useMemoOne.useCallback)(function() {
        return createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    var announce = useAnnouncer(contextId);
    var dragHandleUsageInstructionsId = useHiddenTextElement({
        contextId: contextId,
        text: dragHandleUsageInstructions
    });
    var styleMarshal = useStyleMarshal(contextId, nonce);
    var lazyDispatch = (0, _useMemoOne.useCallback)(function(action) {
        getStore(lazyStoreRef).dispatch(action);
    }, []);
    var marshalCallbacks = (0, _useMemoOne.useMemo)(function() {
        return (0, _redux.bindActionCreators)({
            publishWhileDragging: publishWhileDragging,
            updateDroppableScroll: updateDroppableScroll,
            updateDroppableIsEnabled: updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
            collectionStarting: collectionStarting
        }, lazyDispatch);
    }, [
        lazyDispatch
    ]);
    var registry = useRegistry();
    var dimensionMarshal = (0, _useMemoOne.useMemo)(function() {
        return createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    var autoScroller = (0, _useMemoOne.useMemo)(function() {
        return createAutoScroller((0, _objectSpread._)({
            scrollWindow: scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions: getAutoScrollerOptions
        }, (0, _redux.bindActionCreators)({
            move: move
        }, lazyDispatch)));
    }, [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    var focusMarshal = useFocusMarshal(contextId);
    var store = (0, _useMemoOne.useMemo)(function() {
        return createStore({
            announce: announce,
            autoScroller: autoScroller,
            dimensionMarshal: dimensionMarshal,
            focusMarshal: focusMarshal,
            getResponders: getResponders,
            styleMarshal: styleMarshal
        });
    }, [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    var tryResetStore = (0, _useMemoOne.useCallback)(function() {
        var current = getStore(lazyStoreRef);
        var state = current.getState();
        if (state.phase !== "IDLE") current.dispatch(flush());
    }, []);
    var isDragging = (0, _useMemoOne.useCallback)(function() {
        var state = getStore(lazyStoreRef).getState();
        if (state.phase === "DROP_ANIMATING") return true;
        if (state.phase === "IDLE") return false;
        return state.isDragging;
    }, []);
    var appCallbacks = (0, _useMemoOne.useMemo)(function() {
        return {
            isDragging: isDragging,
            tryAbort: tryResetStore
        };
    }, [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    var getCanLift = (0, _useMemoOne.useCallback)(function(id) {
        return canStartDrag(getStore(lazyStoreRef).getState(), id);
    }, []);
    var getIsMovementAllowed = (0, _useMemoOne.useCallback)(function() {
        return isMovementAllowed(getStore(lazyStoreRef).getState());
    }, []);
    var appContext = (0, _useMemoOne.useMemo)(function() {
        return {
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId: contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
            registry: registry
        };
    }, [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    useSensorMarshal({
        contextId: contextId,
        store: store,
        registry: registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, _react.useEffect)(function() {
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, _reactDefault.default).createElement(AppContext.Provider, {
        value: appContext
    }, (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        context: StoreContext,
        store: store
    }, props.children));
}
var count = 0;
function resetDeprecatedUniqueContextId() {
    count = 0;
}
function useDeprecatedUniqueContextId() {
    return (0, _useMemoOne.useMemo)(function() {
        return "".concat(count++);
    }, []);
}
function useUniqueContextId() {
    return (0, _reactDefault.default).useId();
}
var useUniqueContextId$1 = "useId" in (0, _reactDefault.default) ? useUniqueContextId : useDeprecatedUniqueContextId;
function resetServerContext() {
    if ("useId" in (0, _reactDefault.default)) return;
    resetDeprecatedUniqueContextId();
    resetDeprecatedUniqueId();
}
function DragDropContext(props) {
    var contextId = useUniqueContextId$1();
    var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset$1.dragHandleUsageInstructions;
    return (0, _reactDefault.default).createElement(ErrorBoundary, null, function(setCallbacks) {
        return (0, _reactDefault.default).createElement(App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children);
    });
}
var zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
var getDraggingTransition = function(shouldAnimateDragMovement, dropping) {
    if (dropping) return transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return transitions.snap;
    return transitions.fluid;
};
var getDraggingOpacity = function(isCombining, isDropAnimating) {
    if (!isCombining) return undefined;
    return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};
var getShouldDraggingAnimate = function(dragging) {
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === "SNAP";
};
function getDraggingStyle(dragging) {
    var dimension = dragging.dimension;
    var box = dimension.client;
    var offset = dragging.offset, combineWith = dragging.combineWith, dropping = dragging.dropping;
    var isCombining = Boolean(combineWith);
    var shouldAnimate = getShouldDraggingAnimate(dragging);
    var isDropAnimating = Boolean(dropping);
    var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
    var style = {
        position: "fixed",
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: "border-box",
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: getDraggingTransition(shouldAnimate, dropping),
        transform: transform,
        opacity: getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
        pointerEvents: "none"
    };
    return style;
}
function getSecondaryStyle(secondary) {
    return {
        transform: transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : "none"
    };
}
function getStyle$1(mapped) {
    return mapped.type === "DRAGGING" ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}
function getDimension$1(descriptor, el) {
    var windowScroll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : origin;
    var computedStyles = window.getComputedStyle(el);
    var borderBox = el.getBoundingClientRect();
    var client = (0, _cssBoxModel.calculateBox)(borderBox, computedStyles);
    var page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    var placeholder = {
        client: client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    var displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    var dimension = {
        descriptor: descriptor,
        placeholder: placeholder,
        displaceBy: displaceBy,
        client: client,
        page: page
    };
    return dimension;
}
function useDraggablePublisher(args) {
    var uniqueId = useUniqueId$1("draggable");
    var descriptor = args.descriptor, registry = args.registry, getDraggableRef = args.getDraggableRef, canDragInteractiveElements = args.canDragInteractiveElements, shouldRespectForcePress = args.shouldRespectForcePress, isEnabled = args.isEnabled;
    var options = (0, _useMemoOne.useMemo)(function() {
        return {
            canDragInteractiveElements: canDragInteractiveElements,
            shouldRespectForcePress: shouldRespectForcePress,
            isEnabled: isEnabled
        };
    }, [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    var getDimension = (0, _useMemoOne.useCallback)(function(windowScroll) {
        var el = getDraggableRef();
        !el && invariant(false);
        return getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    var entry = (0, _useMemoOne.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            options: options,
            getDimension: getDimension
        };
    }, [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    var publishedRef = (0, _react.useRef)(entry);
    var isFirstPublishRef = (0, _react.useRef)(true);
    useLayoutEffect(function() {
        registry.draggable.register(publishedRef.current);
        return function() {
            return registry.draggable.unregister(publishedRef.current);
        };
    }, [
        registry.draggable
    ]);
    useLayoutEffect(function() {
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        var last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var DroppableContext = (0, _reactDefault.default).createContext(null);
function checkIsValidInnerRef(el) {
    !(el && isHtmlElement(el)) && invariant(false);
}
function useValidation$1(props, contextId, getRef) {
    useDevSetupWarning(function() {
        function prefix(id) {
            return "Draggable[id: ".concat(id, "]: ");
        }
        var id = props.draggableId;
        !id && invariant(false);
        !(typeof id === "string") && invariant(false);
        !Number.isInteger(props.index) && invariant(false);
        if (props.mapped.type === "DRAGGING") return;
        checkIsValidInnerRef(getRef());
        if (props.isEnabled) !findDragHandle(contextId, id) && invariant(false);
    });
}
function useClonePropValidation(isClone) {
    useDev(function() {
        var initialRef = (0, _react.useRef)(isClone);
        useDevSetupWarning(function() {
            !(isClone === initialRef.current) && invariant(false);
        }, [
            isClone
        ]);
    });
}
function useRequiredContext(Context) {
    var result = (0, _react.useContext)(Context);
    !result && invariant(false);
    return result;
}
function preventHtml5Dnd(event) {
    event.preventDefault();
}
var Draggable = function(props) {
    var ref = (0, _react.useRef)(null);
    var setRef = (0, _useMemoOne.useCallback)(function() {
        var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        ref.current = el;
    }, []);
    var getRef = (0, _useMemoOne.useCallback)(function() {
        return ref.current;
    }, []);
    var _useRequiredContext = useRequiredContext(AppContext), contextId = _useRequiredContext.contextId, dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId, registry = _useRequiredContext.registry;
    var _useRequiredContext1 = useRequiredContext(DroppableContext), type = _useRequiredContext1.type, droppableId = _useRequiredContext1.droppableId;
    var descriptor = (0, _useMemoOne.useMemo)(function() {
        return {
            id: props.draggableId,
            index: props.index,
            type: type,
            droppableId: droppableId
        };
    }, [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    var children = props.children, draggableId = props.draggableId, isEnabled = props.isEnabled, shouldRespectForcePress = props.shouldRespectForcePress, canDragInteractiveElements = props.canDragInteractiveElements, isClone = props.isClone, mapped = props.mapped, dropAnimationFinishedAction = props.dropAnimationFinished;
    useValidation$1(props, contextId, getRef);
    useClonePropValidation(isClone);
    if (!isClone) {
        var forPublisher = (0, _useMemoOne.useMemo)(function() {
            return {
                descriptor: descriptor,
                registry: registry,
                getDraggableRef: getRef,
                canDragInteractiveElements: canDragInteractiveElements,
                shouldRespectForcePress: shouldRespectForcePress,
                isEnabled: isEnabled
            };
        }, [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        useDraggablePublisher(forPublisher);
    }
    var dragHandleProps = (0, _useMemoOne.useMemo)(function() {
        return isEnabled ? {
            tabIndex: 0,
            role: "button",
            "aria-describedby": dragHandleUsageInstructionsId,
            "data-rfd-drag-handle-draggable-id": draggableId,
            "data-rfd-drag-handle-context-id": contextId,
            draggable: false,
            onDragStart: preventHtml5Dnd
        } : null;
    }, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    var onMoveEnd = (0, _useMemoOne.useCallback)(function(event) {
        if (mapped.type !== "DRAGGING") return;
        if (!mapped.dropping) return;
        if (event.propertyName !== "transform") return;
        if ((0, _reactDefault.default).version.startsWith("16") || (0, _reactDefault.default).version.startsWith("17")) dropAnimationFinishedAction();
        else (0, _reactDom.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    var provided = (0, _useMemoOne.useMemo)(function() {
        var style = getStyle$1(mapped);
        var onTransitionEnd = mapped.type === "DRAGGING" && mapped.dropping ? onMoveEnd : undefined;
        var result = {
            innerRef: setRef,
            draggableProps: {
                "data-rfd-draggable-context-id": contextId,
                "data-rfd-draggable-id": draggableId,
                style: style,
                onTransitionEnd: onTransitionEnd
            },
            dragHandleProps: dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    var rubric = (0, _useMemoOne.useMemo)(function() {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    }, [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var Draggable$1 = Draggable;
var isStrictEqual = function(a, b) {
    return a === b;
};
var whatIsDraggedOverFromResult = function(result) {
    var combine = result.combine, destination = result.destination;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
var getCombineWithFromResult = function(result) {
    return result.combine ? result.combine.draggableId : null;
};
var getCombineWithFromImpact = function(impact) {
    return impact.at && impact.at.type === "COMBINE" ? impact.at.combine.draggableId : null;
};
function getDraggableSelector() {
    var memoizedOffset = (0, _memoizeOneDefault.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, _memoizeOneDefault.default)(function(mode, isClone) {
        var draggingOver = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, combineWith = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, dropping = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        return {
            isDragging: true,
            isClone: isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode: mode,
            draggingOver: draggingOver,
            combineWith: combineWith,
            combineTargetFor: null
        };
    });
    var getMemoizedProps = (0, _memoizeOneDefault.default)(function(offset, mode, dimension, isClone) {
        var draggingOver = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, combineWith = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, forceShouldAnimate = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
        return {
            mapped: {
                type: "DRAGGING",
                dropping: null,
                draggingOver: draggingOver,
                combineWith: combineWith,
                mode: mode,
                offset: offset,
                dimension: dimension,
                forceShouldAnimate: forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        };
    });
    var selector = function(state, ownProps) {
        if (isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            var offset = state.current.client.offset;
            var dimension = state.dimensions.draggables[ownProps.draggableId];
            var draggingOver = whatIsDraggedOver(state.impact);
            var combineWith = getCombineWithFromImpact(state.impact);
            var forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            var isClone = ownProps.isClone;
            var dimension1 = state.dimensions.draggables[ownProps.draggableId];
            var result = completed.result;
            var mode = result.mode;
            var draggingOver1 = whatIsDraggedOverFromResult(result);
            var combineWith1 = getCombineWithFromResult(result);
            var duration = state.dropDuration;
            var dropping = {
                duration: duration,
                curve: curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith1 ? combine.opacity.drop : null,
                scale: combineWith1 ? combine.scale.drop : null
            };
            return {
                mapped: {
                    type: "DRAGGING",
                    offset: state.newHomeClientOffset,
                    dimension: dimension1,
                    dropping: dropping,
                    draggingOver: draggingOver1,
                    combineWith: combineWith1,
                    mode: mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver1, combineWith1, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function getSecondarySnapshot() {
    var combineTargetFor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor: combineTargetFor,
        combineWith: null
    };
}
var atRest = {
    mapped: {
        type: "SECONDARY",
        offset: origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: getSecondarySnapshot(null)
    }
};
function getSecondarySelector() {
    var memoizedOffset = (0, _memoizeOneDefault.default)(function(x, y) {
        return {
            x: x,
            y: y
        };
    });
    var getMemoizedSnapshot = (0, _memoizeOneDefault.default)(getSecondarySnapshot);
    var getMemoizedProps = (0, _memoizeOneDefault.default)(function(offset) {
        var combineTargetFor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, shouldAnimateDisplacement = arguments.length > 2 ? arguments[2] : void 0;
        return {
            mapped: {
                type: "SECONDARY",
                offset: offset,
                combineTargetFor: combineTargetFor,
                shouldAnimateDisplacement: shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        };
    });
    var getFallback = function(combineTargetFor) {
        return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
    };
    var getProps = function(ownId, draggingId, impact, afterCritical) {
        var visualDisplacement = impact.displaced.visible[ownId];
        var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        var combine = tryGetCombine(impact);
        var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            var change = negate(afterCritical.displacedBy.point);
            var offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        var displaceBy = impact.displacedBy.point;
        var offset1 = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset1, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    var selector = function(state, ownProps) {
        if (isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
var makeMapStateToProps$1 = function() {
    var draggingSelector = getDraggableSelector();
    var secondarySelector = getSecondarySelector();
    var selector = function(state, ownProps) {
        return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
    };
    return selector;
};
var mapDispatchToProps$1 = {
    dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = (0, _reactRedux.connect)(makeMapStateToProps$1, mapDispatchToProps$1, null, {
    context: StoreContext,
    areStatePropsEqual: isStrictEqual
})(Draggable$1);
var ConnectedDraggable$1 = ConnectedDraggable;
function PrivateDraggable(props) {
    var droppableContext = useRequiredContext(DroppableContext);
    var isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, _reactDefault.default).createElement(ConnectedDraggable$1, props);
}
function PublicDraggable(props) {
    var isEnabled = typeof props.isDragDisabled === "boolean" ? !props.isDragDisabled : true;
    var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, _reactDefault.default).createElement(PrivateDraggable, (0, _extendsDefault.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
var isEqual = function(base) {
    return function(value) {
        return base === value;
    };
};
var isScroll = isEqual("scroll");
var isAuto = isEqual("auto");
var isVisible = isEqual("visible");
var isEither = function(overflow, fn) {
    return fn(overflow.overflowX) || fn(overflow.overflowY);
};
var isBoth = function(overflow, fn) {
    return fn(overflow.overflowX) && fn(overflow.overflowY);
};
var isElementScrollable = function(el) {
    var style = window.getComputedStyle(el);
    var overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};
var isBodyScrollable = function() {
    return false;
};
var getClosestScrollable = function(el) {
    if (el == null) return null;
    if (el === document.body) return isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var checkForNestedScrollContainers = function(scrollable) {
    if (!scrollable) return;
    var anotherScrollParent = getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var getScroll = function(el) {
    return {
        x: el.scrollLeft,
        y: el.scrollTop
    };
};
var getIsFixed = function(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.position === "fixed") return true;
    return getIsFixed(el.parentElement);
};
var getEnv = function(start) {
    var closestScrollable = getClosestScrollable(start);
    var isFixedOnPage = getIsFixed(start);
    return {
        closestScrollable: closestScrollable,
        isFixedOnPage: isFixedOnPage
    };
};
var getDroppableDimension = function(param) {
    var descriptor = param.descriptor, isEnabled = param.isEnabled, isCombineEnabled = param.isCombineEnabled, isFixedOnPage = param.isFixedOnPage, direction = param.direction, client = param.client, page = param.page, closest = param.closest;
    var frame = function() {
        if (!closest) return null;
        var scrollSize = closest.scrollSize, frameClient = closest.client;
        var maxScroll = getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient: frameClient,
            scrollSize: scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: origin,
                    displacement: origin
                }
            }
        };
    }();
    var axis = direction === "vertical" ? vertical : horizontal;
    var subject = getSubject({
        page: page,
        withPlaceholder: null,
        axis: axis,
        frame: frame
    });
    var dimension = {
        descriptor: descriptor,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: isFixedOnPage,
        axis: axis,
        isEnabled: isEnabled,
        client: client,
        page: page,
        frame: frame,
        subject: subject
    };
    return dimension;
};
var getClient = function(targetRef, closestScrollable) {
    var base = (0, _cssBoxModel.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    var top = base.paddingBox.top - closestScrollable.scrollTop;
    var left = base.paddingBox.left - closestScrollable.scrollLeft;
    var bottom = top + closestScrollable.scrollHeight;
    var right = left + closestScrollable.scrollWidth;
    var paddingBox = {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
    var borderBox = (0, _cssBoxModel.expand)(paddingBox, base.border);
    var client = (0, _cssBoxModel.createBox)({
        borderBox: borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var getDimension = function(param) {
    var ref = param.ref, descriptor = param.descriptor, env = param.env, windowScroll = param.windowScroll, direction = param.direction, isDropDisabled = param.isDropDisabled, isCombineEnabled = param.isCombineEnabled, shouldClipSubject = param.shouldClipSubject;
    var closestScrollable = env.closestScrollable;
    var client = getClient(ref, closestScrollable);
    var page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    var closest = function() {
        if (!closestScrollable) return null;
        var frameClient = (0, _cssBoxModel.getBox)(closestScrollable);
        var scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, _cssBoxModel.withScroll)(frameClient, windowScroll),
            scroll: getScroll(closestScrollable),
            scrollSize: scrollSize,
            shouldClipSubject: shouldClipSubject
        };
    }();
    var dimension = getDroppableDimension({
        descriptor: descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction: direction,
        client: client,
        page: page,
        closest: closest
    });
    return dimension;
};
var immediate = {
    passive: false
};
var delayed = {
    passive: true
};
var getListenerOptions = function(options) {
    return options.shouldPublishImmediately ? immediate : delayed;
};
var getClosestScrollableFromDrag = function(dragging) {
    return dragging && dragging.env.closestScrollable || null;
};
function useDroppablePublisher(args) {
    var whileDraggingRef = (0, _react.useRef)(null);
    var appContext = useRequiredContext(AppContext);
    var uniqueId = useUniqueId$1("droppable");
    var registry = appContext.registry, marshal = appContext.marshal;
    var previousRef = usePrevious(args);
    var descriptor = (0, _useMemoOne.useMemo)(function() {
        return {
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        };
    }, [
        args.droppableId,
        args.mode,
        args.type
    ]);
    var publishedDescriptorRef = (0, _react.useRef)(descriptor);
    var memoizedUpdateScroll = (0, _useMemoOne.useMemo)(function() {
        return (0, _memoizeOneDefault.default)(function(x, y) {
            !whileDraggingRef.current && invariant(false);
            var scroll = {
                x: x,
                y: y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        });
    }, [
        descriptor.id,
        marshal
    ]);
    var getClosestScroll = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return origin;
        return getScroll(dragging.env.closestScrollable);
    }, []);
    var updateScroll = (0, _useMemoOne.useCallback)(function() {
        var scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    var scheduleScrollUpdate = (0, _useMemoOne.useMemo)(function() {
        return (0, _rafSchdDefault.default)(updateScroll);
    }, [
        updateScroll
    ]);
    var onClosestScroll = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant(false);
        var options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    var getDimensionAndWatchScroll = (0, _useMemoOne.useCallback)(function(windowScroll, options) {
        !!whileDraggingRef.current && invariant(false);
        var previous = previousRef.current;
        var ref = previous.getDroppableRef();
        !ref && invariant(false);
        var env = getEnv(ref);
        var dragging = {
            ref: ref,
            descriptor: descriptor,
            env: env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        var dimension = getDimension({
            ref: ref,
            descriptor: descriptor,
            env: env,
            windowScroll: windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        var scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    var getScrollWhileDragging = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        var closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant(false);
        return getScroll(closest);
    }, []);
    var dragStopped = (0, _useMemoOne.useCallback)(function() {
        var dragging = whileDraggingRef.current;
        !dragging && invariant(false);
        var closest = getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute(scrollContainer.contextId);
        closest.removeEventListener("scroll", onClosestScroll, getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    var scroll = (0, _useMemoOne.useCallback)(function(change) {
        var dragging = whileDraggingRef.current;
        !dragging && invariant(false);
        var closest = getClosestScrollableFromDrag(dragging);
        !closest && invariant(false);
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    var callbacks = (0, _useMemoOne.useMemo)(function() {
        return {
            getDimensionAndWatchScroll: getDimensionAndWatchScroll,
            getScrollWhileDragging: getScrollWhileDragging,
            dragStopped: dragStopped,
            scroll: scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    var entry = (0, _useMemoOne.useMemo)(function() {
        return {
            uniqueId: uniqueId,
            descriptor: descriptor,
            callbacks: callbacks
        };
    }, [
        callbacks,
        descriptor,
        uniqueId
    ]);
    useLayoutEffect(function() {
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return function() {
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    useLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    useLayoutEffect(function() {
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function noop() {}
var empty = {
    width: 0,
    height: 0,
    margin: noSpacing
};
var getSize = function(param) {
    var isAnimatingOpenOnMount = param.isAnimatingOpenOnMount, placeholder = param.placeholder, animate = param.animate;
    if (isAnimatingOpenOnMount) return empty;
    if (animate === "close") return empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
var getStyle = function(param) {
    var isAnimatingOpenOnMount = param.isAnimatingOpenOnMount, placeholder = param.placeholder, animate = param.animate;
    var size = getSize({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        placeholder: placeholder,
        animate: animate
    });
    return {
        display: placeholder.display,
        boxSizing: "border-box",
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: "0",
        flexGrow: "0",
        pointerEvents: "none",
        transition: animate !== "none" ? transitions.placeholder : null
    };
};
var Placeholder = function(props) {
    var animateOpenTimerRef = (0, _react.useRef)(null);
    var tryClearAnimateOpenTimer = (0, _useMemoOne.useCallback)(function() {
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    var animate = props.animate, onTransitionEnd = props.onTransitionEnd, onClose = props.onClose, contextId = props.contextId;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(props.animate === "open"), 2), isAnimatingOpenOnMount = _useState[0], setIsAnimatingOpenOnMount = _useState[1];
    (0, _react.useEffect)(function() {
        if (!isAnimatingOpenOnMount) return noop;
        if (animate !== "open") {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return noop;
        }
        if (animateOpenTimerRef.current) return noop;
        animateOpenTimerRef.current = setTimeout(function() {
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    var onSizeChangeEnd = (0, _useMemoOne.useCallback)(function(event) {
        if (event.propertyName !== "height") return;
        onTransitionEnd();
        if (animate === "close") onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    var style = getStyle({
        isAnimatingOpenOnMount: isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, _reactDefault.default).createElement(props.placeholder.tagName, {
        style: style,
        "data-rfd-placeholder-context-id": contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var Placeholder$1 = (0, _reactDefault.default).memo(Placeholder);
function isBoolean(value) {
    return typeof value === "boolean";
}
function runChecks(args, checks) {
    checks.forEach(function(check) {
        return check(args);
    });
}
var shared = [
    function required(param) {
        var props = param.props;
        !props.droppableId && invariant(false);
        !(typeof props.droppableId === "string") && invariant(false);
    },
    function boolean(param) {
        var props = param.props;
        !isBoolean(props.isDropDisabled) && invariant(false);
        !isBoolean(props.isCombineEnabled) && invariant(false);
        !isBoolean(props.ignoreContainerClipping) && invariant(false);
    },
    function ref(param) {
        var getDroppableRef = param.getDroppableRef;
        checkIsValidInnerRef(getDroppableRef());
    }
];
var standard = [
    function placeholder(param) {
        var props = param.props, getPlaceholderRef = param.getPlaceholderRef;
        if (!props.placeholder) return;
        var ref = getPlaceholderRef();
        if (ref) return;
    }
];
var virtual = [
    function hasClone(param) {
        var props = param.props;
        !props.renderClone && invariant(false);
    },
    function hasNoPlaceholder(param) {
        var getPlaceholderRef = param.getPlaceholderRef;
        !!getPlaceholderRef() && invariant(false);
    }
];
function useValidation(args) {
    useDevSetupWarning(function() {
        runChecks(args, shared);
        if (args.props.mode === "standard") runChecks(args, standard);
        if (args.props.mode === "virtual") runChecks(args, virtual);
    });
}
var AnimateInOut = /*#__PURE__*/ function(_React_PureComponent) {
    "use strict";
    (0, _inherits._)(AnimateInOut, _React_PureComponent);
    var _super = (0, _createSuper._)(AnimateInOut);
    function AnimateInOut() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, AnimateInOut);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.state = {
            isVisible: Boolean(_this.props.on),
            data: _this.props.on,
            animate: _this.props.shouldAnimate && _this.props.on ? "open" : "none"
        };
        _this.onClose = function() {
            if (_this.state.animate !== "close") return;
            _this.setState({
                isVisible: false
            });
        };
        return _this;
    }
    (0, _createClass._)(AnimateInOut, [
        {
            key: "render",
            value: function render() {
                if (!this.state.isVisible) return null;
                var provided = {
                    onClose: this.onClose,
                    data: this.state.data,
                    animate: this.state.animate
                };
                return this.props.children(provided);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!props.shouldAnimate) return {
                    isVisible: Boolean(props.on),
                    data: props.on,
                    animate: "none"
                };
                if (props.on) return {
                    isVisible: true,
                    data: props.on,
                    animate: "open"
                };
                if (state.isVisible) return {
                    isVisible: true,
                    data: state.data,
                    animate: "close"
                };
                return {
                    isVisible: false,
                    animate: "close",
                    data: null
                };
            }
        }
    ]);
    return AnimateInOut;
}((0, _reactDefault.default).PureComponent);
var Droppable = function(props) {
    var appContext = (0, _react.useContext)(AppContext);
    !appContext && invariant(false);
    var contextId = appContext.contextId, isMovementAllowed = appContext.isMovementAllowed;
    var droppableRef = (0, _react.useRef)(null);
    var placeholderRef = (0, _react.useRef)(null);
    var children = props.children, droppableId = props.droppableId, type = props.type, mode = props.mode, direction = props.direction, ignoreContainerClipping = props.ignoreContainerClipping, isDropDisabled = props.isDropDisabled, isCombineEnabled = props.isCombineEnabled, snapshot = props.snapshot, useClone = props.useClone, updateViewportMaxScroll = props.updateViewportMaxScroll, getContainerForClone = props.getContainerForClone;
    var getDroppableRef = (0, _useMemoOne.useCallback)(function() {
        return droppableRef.current;
    }, []);
    var setDroppableRef = (0, _useMemoOne.useCallback)(function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        droppableRef.current = value;
    }, []);
    var getPlaceholderRef = (0, _useMemoOne.useCallback)(function() {
        return placeholderRef.current;
    }, []);
    var setPlaceholderRef = (0, _useMemoOne.useCallback)(function() {
        var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
        placeholderRef.current = value;
    }, []);
    useValidation({
        props: props,
        getDroppableRef: getDroppableRef,
        getPlaceholderRef: getPlaceholderRef
    });
    var onPlaceholderTransitionEnd = (0, _useMemoOne.useCallback)(function() {
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    useDroppablePublisher({
        droppableId: droppableId,
        type: type,
        mode: mode,
        direction: direction,
        isDropDisabled: isDropDisabled,
        isCombineEnabled: isCombineEnabled,
        ignoreContainerClipping: ignoreContainerClipping,
        getDroppableRef: getDroppableRef
    });
    var placeholder = (0, _useMemoOne.useMemo)(function() {
        return (0, _reactDefault.default).createElement(AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, function(param) {
            var onClose = param.onClose, data = param.data, animate = param.animate;
            return (0, _reactDefault.default).createElement(Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            });
        });
    }, [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    var provided = (0, _useMemoOne.useMemo)(function() {
        return {
            innerRef: setDroppableRef,
            placeholder: placeholder,
            droppableProps: {
                "data-rfd-droppable-id": droppableId,
                "data-rfd-droppable-context-id": contextId
            }
        };
    }, [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    var droppableContext = (0, _useMemoOne.useMemo)(function() {
        return {
            droppableId: droppableId,
            type: type,
            isUsingCloneFor: isUsingCloneFor
        };
    }, [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        var dragging = useClone.dragging, render = useClone.render;
        var node = (0, _reactDefault.default).createElement(PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, function(draggableProvided, draggableSnapshot) {
            return render(draggableProvided, draggableSnapshot, dragging);
        });
        return (0, _reactDomDefault.default).createPortal(node, getContainerForClone());
    }
    return (0, _reactDefault.default).createElement(DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
var Droppable$1 = Droppable;
function getBody() {
    !document.body && invariant(false);
    return document.body;
}
var defaultProps = {
    mode: "standard",
    type: "DEFAULT",
    direction: "vertical",
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: getBody
};
var attachDefaultPropsToOwnProps = function(ownProps) {
    var mergedProps = (0, _objectSpread._)({}, ownProps);
    var defaultPropKey;
    for(defaultPropKey in defaultProps)if (ownProps[defaultPropKey] === undefined) mergedProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, mergedProps), (0, _defineProperty._)({}, defaultPropKey, defaultProps[defaultPropKey]));
    return mergedProps;
};
var isMatchingType = function(type, critical) {
    return type === critical.droppable.type;
};
var getDraggable = function(critical, dimensions) {
    return dimensions.draggables[critical.draggable.id];
};
var makeMapStateToProps = function() {
    var idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    var idleWithoutAnimation = (0, _objectSpreadProps._)((0, _objectSpread._)({}, idleWithAnimation), {
        shouldAnimatePlaceholder: false
    });
    var getDraggableRubric = (0, _memoizeOneDefault.default)(function(descriptor) {
        return {
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        };
    });
    var getMapProps = (0, _memoizeOneDefault.default)(function(id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
        var draggableId = dragging.descriptor.id;
        var isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            var useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            var snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot: snapshot,
                useClone: useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        var snapshot1 = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot: snapshot1,
            useClone: null
        };
    });
    var selector = function(state, ownProps) {
        var ownPropsWithDefaultProps = attachDefaultPropsToOwnProps(ownProps);
        var id = ownPropsWithDefaultProps.droppableId;
        var type = ownPropsWithDefaultProps.type;
        var isEnabled = !ownPropsWithDefaultProps.isDropDisabled;
        var renderClone = ownPropsWithDefaultProps.renderClone;
        if (isDragging(state)) {
            var critical = state.critical;
            if (!isMatchingType(type, critical)) return idleWithoutAnimation;
            var dragging = getDraggable(critical, state.dimensions);
            var isDraggingOver = whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === "DROP_ANIMATING") {
            var completed = state.completed;
            if (!isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            var dragging1 = getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, dragging1, renderClone);
        }
        if (state.phase === "IDLE" && state.completed && !state.shouldFlush) {
            var completed1 = state.completed;
            if (!isMatchingType(type, completed1.critical)) return idleWithoutAnimation;
            var wasOver = whatIsDraggedOver(completed1.impact) === id;
            var wasCombining = Boolean(completed1.impact.at && completed1.impact.at.type === "COMBINE");
            var isHome = completed1.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
var mapDispatchToProps = {
    updateViewportMaxScroll: updateViewportMaxScroll
};
var ConnectedDroppable = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, function(stateProps, dispatchProps, ownProps) {
    return (0, _objectSpread._)({}, attachDefaultPropsToOwnProps(ownProps), stateProps, dispatchProps);
}, {
    context: StoreContext,
    areStatePropsEqual: isStrictEqual
})(Droppable$1);
var ConnectedDroppable$1 = ConnectedDroppable;

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_inherits":"j9BK3","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_wrap_native_super":"9QuY0","@swc/helpers/_/_create_super":"cFmrg","react":"ktQNc","react-dom":"lyZO5","redux":"3o3p3","react-redux":"5oTKd","use-memo-one":"8u404","css-box-model":"6qlQZ","memoize-one":"avOPP","raf-schd":"jv5m4","@babel/runtime/helpers/esm/extends":"4SPjz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3o3p3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", function() {
    return ActionTypes;
});
parcelHelpers.export(exports, "applyMiddleware", function() {
    return applyMiddleware;
});
parcelHelpers.export(exports, "bindActionCreators", function() {
    return bindActionCreators;
});
parcelHelpers.export(exports, "combineReducers", function() {
    return combineReducers;
});
parcelHelpers.export(exports, "compose", function() {
    return compose;
});
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
parcelHelpers.export(exports, "legacy_createStore", function() {
    return legacy_createStore;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    var constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, _typeOf._)(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@swc/helpers/_/_type_of":"6Gp9n","@babel/runtime/helpers/esm/objectSpread2":"59kaA","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5oTKd":[function(require,module,exports) {
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", function() {
    return 0, _reactBatchedUpdates.unstable_batchedUpdates;
});
var _shim = require("use-sync-external-store/shim");
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch");
var _useSelector = require("./hooks/useSelector");
var _connect = require("./components/connect");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
(0, _useSelector.initializeUseSelector)((0, _withSelector.useSyncExternalStoreWithSelector));
(0, _connect.initializeConnect)((0, _shim.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"use-sync-external-store/shim":"iaVoq","use-sync-external-store/shim/with-selector":"fg86w","./utils/reactBatchedUpdates":"2Yw5J","./utils/batch":"55YPl","./hooks/useSelector":"2ffqH","./components/connect":"MaY2K","./exports":"kWA3z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iaVoq":[function(require,module,exports) {
"use strict";
module.exports = require("8b974a2950a0796c");

},{"8b974a2950a0796c":"fRhc3"}],"fRhc3":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var e = require("2f7d03d9688f598f");
function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
function q(a, b) {
    var d = b(), f = l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    n(function() {
        c.value = d;
        c.getSnapshot = b;
        r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    m(function() {
        r(c) && g({
            inst: c
        });
        return a(function() {
            r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    p(d);
    return d;
}
function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !k(a, d);
    } catch (f) {
        return !0;
    }
}
function t(a, b) {
    return b();
}
var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
exports.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;

},{"2f7d03d9688f598f":"ktQNc"}],"fg86w":[function(require,module,exports) {
"use strict";
module.exports = require("646f3adc157912dd");

},{"646f3adc157912dd":"fhCCE"}],"fhCCE":[function(require,module,exports) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var h = require("2c99ce9e3cb5debf"), n = require("969be431eae4eb00");
function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var _$b = f.value;
                    if (g(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if (q(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== g && g(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = r(a, c[0], c[1]);
    u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    w(d);
    return d;
};

},{"2c99ce9e3cb5debf":"ktQNc","969be431eae4eb00":"iaVoq"}],"2Yw5J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", function() {
    return 0, _reactDom.unstable_batchedUpdates;
});
var _reactDom = require("react-dom");

},{"react-dom":"lyZO5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"55YPl":[function(require,module,exports) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", function() {
    return setBatch;
});
parcelHelpers.export(exports, "getBatch", function() {
    return getBatch;
});
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2ffqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeUseSelector", function() {
    return initializeUseSelector;
});
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", function() {
    return createSelectorHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return useSelector;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _context = require("../components/Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
var useSyncExternalStoreWithSelector = (0, _useSyncExternalStore.notInitialized);
var initializeUseSelector = function(fn) {
    useSyncExternalStoreWithSelector = fn;
};
var refEquality = function(a, b) {
    return a === b;
};
function createSelectorHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useSelector(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? refEquality : _ref_equalityFn, stabilityCheck = _ref.stabilityCheck, noopCheck = _ref.noopCheck;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, subscription = _useReduxContext.subscription, getServerState = _useReduxContext.getServerState, globalStabilityCheck = _useReduxContext.stabilityCheck, globalNoopCheck = _useReduxContext.noopCheck;
        var firstRun = (0, _react.useRef)(true);
        var wrappedSelector = (0, _react.useCallback)((0, _defineProperty._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        var selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"@swc/helpers/_/_define_property":"gSu9o","react":"ktQNc","./useReduxContext":"gsvWy","../components/Context":"2987h","../utils/useSyncExternalStore":"gK0vI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gsvWy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createReduxContextHook", function() {
    return createReduxContextHook;
});
parcelHelpers.export(exports, "useReduxContext", function() {
    return useReduxContext;
});
var _react = require("react");
var _context = require("../components/Context");
function createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    return function useReduxContext() {
        var contextValue = (0, _react.useContext)(context);
        return contextValue;
    };
}
var useReduxContext = /*#__PURE__*/ createReduxContextHook();

},{"react":"ktQNc","../components/Context":"2987h","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2987h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return ReactReduxContext;
});
var _react = require("react");
var ContextKey = Symbol.for("react-redux-context");
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _gT$ContextKey;
    if (!_react.createContext) return {};
    var contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
    var realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /*#__PURE__*/ getContext();
exports.default = ReactReduxContext;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gK0vI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notInitialized", function() {
    return notInitialized;
});
var notInitialized = function() {
    throw new Error("uSES not initialized!");
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"MaY2K":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeConnect", function() {
    return initializeConnect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */ var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactIs = require("react-is");
var _selectorFactory = require("../connect/selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _mapDispatchToProps = require("../connect/mapDispatchToProps");
var _mapStateToProps = require("../connect/mapStateToProps");
var _mergeProps = require("../connect/mergeProps");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _context = require("./Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
var _excluded = [
    "reactReduxForwardedRef"
];
var useSyncExternalStore = (0, _useSyncExternalStore.notInitialized);
var initializeConnect = function(fn) {
    useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
var EMPTY_ARRAY = [
    null,
    0
];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
var stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, (0, _toConsumableArray._)(effectArgs));
    }, dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return function() {}; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
var initStateUpdates = function() {
    return EMPTY_ARRAY;
};
function strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ var hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? (0, _context.ReactReduxContext) : _ref_context;
    var Context = context;
    var initMapStateToProps = (0, _mapStateToProps.mapStateToPropsFactory)(mapStateToProps);
    var initMapDispatchToProps = (0, _mapDispatchToProps.mapDispatchToPropsFactory)(mapDispatchToProps);
    var initMergeProps = (0, _mergeProps.mergePropsFactory)(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            var _React_useMemo = (0, _slicedToArray._)(_react.useMemo(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = _react.useMemo(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, _reactIs.isContextConsumer)(/*#__PURE__*/ _react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = _react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = _react.useMemo(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, _selectorFactoryDefault.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, _slicedToArray._)(_react.useMemo(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = _react.useMemo(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = _react.useRef();
            var lastWrapperProps = _react.useRef(wrapperProps);
            var childPropsFromStoreUpdate = _react.useRef();
            var renderIsScheduled = _react.useRef(false);
            var isProcessingDispatch = _react.useRef(false);
            var isMounted = _react.useRef(false);
            var latestSubscriptionCallbackError = _react.useRef();
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = _react.useMemo(function() {
                var selector = function() {
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            var subscribeForReact = _react.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = _react.useMemo(function() {
                return(/*#__PURE__*/ // @ts-ignore
                _react.createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = _react.useMemo(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        var _Connect = _react.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ _react.createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
exports.default = connect;

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@babel/runtime/helpers/esm/extends":"dyzvo","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"atwk5","hoist-non-react-statics":"kIv5Y","react":"ktQNc","react-is":"dFuaQ","../connect/selectorFactory":"ax5MX","../connect/mapDispatchToProps":"5FRGH","../connect/mapStateToProps":"gJBWH","../connect/mergeProps":"k8imv","../utils/Subscription":"4u8YC","../utils/useIsomorphicLayoutEffect":"5Z2FC","../utils/shallowEqual":"latfx","../utils/warning":"1rxMK","./Context":"2987h","../utils/useSyncExternalStore":"gK0vI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dyzvo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"atwk5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dFuaQ":[function(require,module,exports) {
"use strict";
module.exports = require("4b535dd068e8c3c9");

},{"4b535dd068e8c3c9":"dyfkW"}],"dyfkW":[function(require,module,exports) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"ax5MX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", function() {
    return pureFinalPropsSelectorFactory;
});
parcelHelpers.export(exports, "default", function() {
    return finalPropsSelectorFactory;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref) {
    var initMapStateToProps = _ref.initMapStateToProps, initMapDispatchToProps = _ref.initMapDispatchToProps, initMergeProps = _ref.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"atwk5","./verifySubselectors":"drUy1","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"drUy1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifySubselectors;
});
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, _warningDefault.default)("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}

},{"../utils/warning":"1rxMK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1rxMK":[function(require,module,exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return warning;
});
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5FRGH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToPropsFactory", function() {
    return mapDispatchToPropsFactory;
});
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, _invalidArgFactory.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

},{"../utils/bindActionCreators":"dbzgi","./wrapMapToProps":"gNQgh","./invalidArgFactory":"peVVS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dbzgi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return bindActionCreators;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, _toConsumableArray._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@swc/helpers/_/_to_consumable_array":"94EyK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gNQgh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", function() {
    return wrapMapToPropsConstant;
}) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?
parcelHelpers.export(exports, "getDependsOnOwnProps", function() {
    return getDependsOnOwnProps;
}) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", function() {
    return wrapMapToPropsFunc;
});
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"lClqk","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lClqk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifyPlainObject;
});
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}

},{"./isPlainObject":"kCehN","./warning":"1rxMK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kCehN":[function(require,module,exports) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPlainObject;
});
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"peVVS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidArgFactory", function() {
    return createInvalidArgFactory;
});
var _typeOf = require("@swc/helpers/_/_type_of");
function createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, _typeOf._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}

},{"@swc/helpers/_/_type_of":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gJBWH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToPropsFactory", function() {
    return mapStateToPropsFactory;
});
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, _invalidArgFactory.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

},{"./wrapMapToProps":"gNQgh","./invalidArgFactory":"peVVS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k8imv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", function() {
    return defaultMergeProps;
});
parcelHelpers.export(exports, "wrapMergePropsFunc", function() {
    return wrapMergePropsFunc;
});
parcelHelpers.export(exports, "mergePropsFactory", function() {
    return mergePropsFactory;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
var _invalidArgFactory = require("./invalidArgFactory");
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : (0, _invalidArgFactory.createInvalidArgFactory)(mergeProps, "mergeProps");
}

},{"@babel/runtime/helpers/esm/extends":"dyzvo","../utils/verifyPlainObject":"lClqk","./invalidArgFactory":"peVVS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4u8YC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", function() {
    return createSubscription;
});
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners; // Reasons to keep the subscription active
    var subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"55YPl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Z2FC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", function() {
    return canUseDOM;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var useIsomorphicLayoutEffect = canUseDOM ? _react.useLayoutEffect : _react.useEffect;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"latfx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return shallowEqual;
});
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kWA3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return 0, _providerDefault.default;
});
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return 0, _context.ReactReduxContext;
});
parcelHelpers.export(exports, "connect", function() {
    return 0, _connectDefault.default;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return 0, _useDispatch.useDispatch;
});
parcelHelpers.export(exports, "createDispatchHook", function() {
    return 0, _useDispatch.createDispatchHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return 0, _useSelector.useSelector;
});
parcelHelpers.export(exports, "createSelectorHook", function() {
    return 0, _useSelector.createSelectorHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return 0, _useStore.useStore;
});
parcelHelpers.export(exports, "createStoreHook", function() {
    return 0, _useStore.createStoreHook;
});
parcelHelpers.export(exports, "shallowEqual", function() {
    return 0, _shallowEqualDefault.default;
});
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connect = require("./components/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _context = require("./components/Context");
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./components/Provider":"9mk0D","./components/connect":"MaY2K","./components/Context":"2987h","./hooks/useDispatch":"761uu","./hooks/useSelector":"2ffqH","./hooks/useStore":"jo4Vl","./utils/shallowEqual":"latfx","./types":"lQVsr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9mk0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_noopCheck = param.noopCheck, noopCheck = _param_noopCheck === void 0 ? "once" : _param_noopCheck;
    var contextValue = _react.useMemo(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    var previousState = _react.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"ktQNc","./Context":"2987h","../utils/Subscription":"4u8YC","../utils/useIsomorphicLayoutEffect":"5Z2FC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"761uu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", function() {
    return createDispatchHook;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return useDispatch;
});
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"2987h","./useStore":"jo4Vl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jo4Vl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", function() {
    return createStoreHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return useStore;
});
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useStore() {
        var store = useReduxContext().store; // @ts-ignore
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"../components/Context":"2987h","./useReduxContext":"gsvWy","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lQVsr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8u404":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCallback", function() {
    return useCallback;
});
parcelHelpers.export(exports, "useCallbackOne", function() {
    return useCallbackOne;
});
parcelHelpers.export(exports, "useMemo", function() {
    return useMemo;
});
parcelHelpers.export(exports, "useMemoOne", function() {
    return useMemoOne;
});
var _react = require("react");
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function useMemoOne(getResult, inputs) {
    var initial = (0, _react.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, _react.useRef)(true);
    var committed = (0, _react.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, _react.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function useCallbackOne(callback, inputs) {
    return useMemoOne(function() {
        return callback;
    }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6qlQZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBox", function() {
    return calculateBox;
});
parcelHelpers.export(exports, "createBox", function() {
    return createBox;
});
parcelHelpers.export(exports, "expand", function() {
    return expand;
});
parcelHelpers.export(exports, "getBox", function() {
    return getBox;
});
parcelHelpers.export(exports, "getRect", function() {
    return getRect;
});
parcelHelpers.export(exports, "offset", function() {
    return offset;
});
parcelHelpers.export(exports, "shrink", function() {
    return shrink;
});
parcelHelpers.export(exports, "withScroll", function() {
    return withScroll;
});
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var getRect = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var expand = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var shrink = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var createBox = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
    var marginBox = getRect(expand(borderBox, margin));
    var paddingBox = getRect(shrink(borderBox, border));
    var contentBox = getRect(shrink(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: getRect(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== "px") return 0;
    var result = Number(value);
    !!isNaN(result) && (0, _tinyInvariantDefault.default)(false);
    return result;
};
var getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var offset = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = shift(borderBox, change);
    return createBox({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var withScroll = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = getWindowScroll();
    return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
    var margin = {
        top: parse(styles.marginTop),
        right: parse(styles.marginRight),
        bottom: parse(styles.marginBottom),
        left: parse(styles.marginLeft)
    };
    var padding = {
        top: parse(styles.paddingTop),
        right: parse(styles.paddingRight),
        bottom: parse(styles.paddingBottom),
        left: parse(styles.paddingLeft)
    };
    var border = {
        top: parse(styles.borderTopWidth),
        right: parse(styles.borderRightWidth),
        bottom: parse(styles.borderBottomWidth),
        left: parse(styles.borderLeftWidth)
    };
    return createBox({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var getBox = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return calculateBox(borderBox, styles);
};

},{"tiny-invariant":"5gG5R","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jv5m4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
exports.default = rafSchd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4SPjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"edMh3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropListItem", function() {
    return DragDropListItem;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dnd = require("@hello-pangea/dnd");
var _index = require("Permafrost/index");
var _dragDropListStyles = require("./DragDropList.styles");
var DragDropListItem = function(param) {
    var id = param.id, content = param.content, dragDisabled = param.dragDisabled, index = param.index;
    var stringContent = typeof content === "string";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
        draggableId: id,
        index: index,
        isDragDisabled: dragDisabled,
        children: function(provided, snapshot) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dragDropListStyles.StyledDragDropListItem), (0, _objectSpreadProps._)((0, _objectSpread._)({
                className: (0, _classnamesDefault.default)({
                    "is-dragging": snapshot.isDragging,
                    "drag-disabled": dragDisabled
                }),
                ref: provided.innerRef
            }, provided.draggableProps, provided.dragHandleProps), {
                children: [
                    !dragDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        className: "draggable-icon",
                        name: "draggable",
                        size: [
                            20
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _classnamesDefault.default)("draggable-content", {
                            string: stringContent
                        }),
                        children: content
                    })
                ]
            }));
        }
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@hello-pangea/dnd":"bhM3h","Permafrost/index":"iliLC","./DragDropList.styles":"iz6WQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iz6WQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDragDropList", function() {
    return StyledDragDropList;
});
parcelHelpers.export(exports, "StyledDragDropListItem", function() {
    return StyledDragDropListItem;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  display: flex;\n  margin: 4px 0;\n\n  &.is-dragging {\n    background: ",
        ";\n  }\n\n  &.drag-disabled {\n    padding-left: 20px;\n  }\n\n  & .string {\n    padding: 20px 20px 20px 0;\n  }\n\n  .draggable-icon {\n    color: ",
        ";\n    margin: 20px;\n    overflow: visible;\n  }\n\n  .draggable-content {\n    width: 100%;\n  }\n\n  .draggable-content.string {\n    align-self: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDragDropList = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledDragDropListItem = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).lightGray, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).comet);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fbvvs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OldDragDropList", function() {
    return OldDragDropList;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _oldDragDropListItem = require("./OldDragDropListItem");
var _oldDragDropListStyles = require("./OldDragDropList.styles");
var OldDragDropList = function(props) {
    var id = props.id, _props_arrows = props.arrows, arrows = _props_arrows === void 0 ? true : _props_arrows, canDelete = props.canDelete, className = props.className, header = props.header, items = props.items, onAdd = props.onAdd, onDelete = props.onDelete, onEdit = props.onEdit, onMovedItem = props.onMovedItem, subHeader = props.subHeader, disabledDeleteTargets = props.disabledDeleteTargets;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), draggedItem = _useState[0], setDraggedItem = _useState[1];
    // adding new items to the list
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), newItemOpen = _useState1[0], setNewItemOpen = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), newValue = _useState2[0], setNewValue = _useState2[1];
    // tracks whether a reordering arrow has been pressed, and which items are affected
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([
        undefined,
        undefined
    ]), 2), swapItems = _useState3[0], setSwapItems = _useState3[1];
    // updateItemOrder is called on arrow button up/down
    var updateItemOrder = function(param) {
        var destination = param.destination, source = param.source;
        if (destination === undefined || destination === source) return;
        setSwapItems([
            source,
            destination
        ]);
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items.map(function(item) {
            return item.name;
        }), source, destination);
        setTimeout(function() {
            onMovedItem(reorderedItems);
            setSwapItems([
                undefined,
                undefined
            ]);
        }, 300);
    };
    var addItem = function() {
        if (newValue !== "" && newValue.length >= 2) {
            var current = (0, _toConsumableArray._)(items.map(function(item) {
                return item.name;
            })).concat([
                newValue
            ]);
            onAdd && onAdd(current);
            // clear state and close “add item” input once added
            setNewValue("");
            setNewItemOpen(false);
        }
    };
    var editItem = function(itemToEdit, editedItem) {
        var current = (0, _toConsumableArray._)(items.map(function(item) {
            return item.name;
        }));
        var itemIndex = current.indexOf(itemToEdit);
        current[itemIndex] = editedItem;
        onEdit && onEdit(current);
    };
    // determines reordering direction, and applies appropriate css class
    var animateDirection = function(itemIndex) {
        var sourceIndex = swapItems[0];
        var destIndex = swapItems[1];
        if (Number.isInteger(sourceIndex) && Number.isInteger(destIndex) && sourceIndex !== destIndex) {
            // @ts-ignore
            var direction = sourceIndex > destIndex ? "up" : "down";
            var itemIsSource = itemIndex === sourceIndex;
            var itemIsDest = itemIndex === destIndex;
            if (itemIsSource) return direction === "up" ? "animate-up" : "animate-down";
            if (itemIsDest) return direction === "up" ? "animate-down" : "animate-up";
        }
        return "";
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _oldDragDropListStyles.StyledOldDragDropList), {
        id: id,
        className: className,
        "data-cy": props["data-cy"],
        style: !header && !subHeader ? {
            borderLeft: "none"
        } : {},
        children: [
            header && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                className: "list-header t-bold",
                "data-testid": "main-header",
                children: header
            }),
            subHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                className: "sub-header",
                "data-testid": "sub-header",
                children: subHeader
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.DragDropVerticalList), {
                itemIdList: items.map(function(item) {
                    return item.name;
                }),
                items: items.map(function(item, i) {
                    var _disabledDeleteTargets_find;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oldDragDropListItem.DragDropListItem), {
                        arrows: arrows,
                        canDelete: canDelete,
                        className: (0, _classnamesDefault.default)(animateDirection(i)),
                        disableDeleteTooltipText: disabledDeleteTargets === null || disabledDeleteTargets === void 0 ? void 0 : (_disabledDeleteTargets_find = disabledDeleteTargets.find(function(disabledDeleteField) {
                            return disabledDeleteField.targetId === item.id;
                        })) === null || _disabledDeleteTargets_find === void 0 ? void 0 : _disabledDeleteTargets_find.disableDeleteTooltipText,
                        index: i,
                        isDragging: item.name === draggedItem,
                        item: item,
                        listLength: items.length,
                        onDelete: onDelete,
                        onEdit: editItem,
                        updateItemOrder: updateItemOrder
                    }, item.id);
                }),
                itemsVerticalGap: "3px",
                onDrop: onMovedItem,
                updateDraggedItem: setDraggedItem
            }),
            onAdd && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _oldDragDropListStyles.StyledAddItemContainer), {
                className: !newItemOpen ? "dash-border" : "solid-back",
                children: [
                    !newItemOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
                        className: "add-btn",
                        onClick: function() {
                            return setNewItemOpen(true);
                        },
                        "aria-label": "add list item"
                    }, props === null || props === void 0 ? void 0 : props.addButtonProps), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "plus",
                            size: [
                                20
                            ]
                        })
                    })),
                    newItemOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpread._)({
                                type: "text",
                                autoFocus: true,
                                className: "add-item-input",
                                value: newValue,
                                onChange: function(e) {
                                    return setNewValue(e.target.value);
                                },
                                onKeyDown: function(e) {
                                    if (e.key === "Enter" && !items.some(function(item) {
                                        return item.name === newValue;
                                    })) {
                                        e.preventDefault();
                                        addItem();
                                    }
                                }
                            }, props === null || props === void 0 ? void 0 : props.inputProps)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", (0, _objectSpreadProps._)((0, _objectSpread._)({
                                "aria-label": "add new item",
                                className: "confirm",
                                onClick: function() {
                                    return addItem();
                                },
                                disabled: newValue === "" || newValue.length < 2 || items.some(function(item) {
                                    return item.name === newValue;
                                })
                            }, props === null || props === void 0 ? void 0 : props.confirmButtonProps), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                    name: "check",
                                    size: [
                                        18
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                "aria-label": "cancel new item",
                                className: "cancel",
                                onClick: function() {
                                    setNewItemOpen(false);
                                    setNewValue("");
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                    name: "x-close",
                                    size: [
                                        16
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./OldDragDropListItem":"d2mtF","./OldDragDropList.styles":"e6vof","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d2mtF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropListItem", function() {
    return DragDropListItem;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _oldDragDropListStyles = require("./OldDragDropList.styles");
var DragDropListItem = function(param) {
    var arrows = param.arrows, canDelete = param.canDelete, className = param.className, index = param.index, isDragging = param.isDragging, item = param.item, listLength = param.listLength, disableDeleteTooltipText = param.disableDeleteTooltipText, onDelete = param.onDelete, // onEdit,
    updateItemOrder = param.updateItemOrder;
    // tracks whether an arrow has been pressed on this item
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), confirmDelete = _useState1[0], setConfirmDelete = _useState1[1];
    (0, _react.useEffect)(function() {
        setActive(false);
    }, [
        index
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _oldDragDropListStyles.StyledDragDropListItem), {
        className: (0, _classnamesDefault.default)(className, {
            dragging: isDragging,
            active: active
        }),
        style: {
            backgroundColor: confirmDelete ? "".concat((0, _index.COLORS).oxfordBlue, "80") : "".concat((0, _index.COLORS).oxfordBlue)
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "list-item-text",
                style: {
                    color: confirmDelete ? "".concat((0, _index.COLORS).defaultFontColor, "80") : "".concat((0, _index.COLORS).defaultFontColor)
                },
                children: item.name
            }),
            !confirmDelete && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "list-buttons",
                children: [
                    onDelete && canDelete ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            disableDeleteTooltipText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                                for: "delete-container-".concat(item.id),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: disableDeleteTooltipText
                                })
                            }) : null,
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                "data-for": "delete-container-".concat(item.id),
                                "data-tip": true,
                                "data-testid": "div--delete-btn-".concat(item.name),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                    className: "delete",
                                    onClick: function() {
                                        return setConfirmDelete(true);
                                    },
                                    disabled: !!disableDeleteTooltipText,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                        name: "trash",
                                        size: [
                                            18
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : null,
                    arrows && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                "aria-label": "move item up",
                                className: "arrow-up",
                                disabled: index === 0,
                                onClick: function() {
                                    setActive(true);
                                    updateItemOrder({
                                        destination: index--,
                                        source: index
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                    name: "fa-arrow-up",
                                    size: [
                                        22
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                "aria-label": "move item down",
                                className: "arrow-down",
                                disabled: index === listLength - 1,
                                onClick: function() {
                                    setActive(true);
                                    updateItemOrder({
                                        destination: index++,
                                        source: index
                                    });
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                    name: "fa-arrow-down",
                                    size: [
                                        22
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            confirmDelete && onDelete && canDelete ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "confirm-delete-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Are you sure?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        "data-testid": "btn--confirm-delete-label",
                        className: "confirm",
                        onClick: function() {
                            return onDelete(item.id);
                        },
                        style: {
                            opacity: isDragging ? "0.5" : ""
                        },
                        children: "Yes, Delete It"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        "data-testid": "btn--decline-delete-label",
                        className: "cancel",
                        onClick: function() {
                            return setConfirmDelete(false);
                        },
                        style: {
                            opacity: isDragging ? "0.5" : ""
                        },
                        children: "No, Keep It"
                    })
                ]
            }) : null
        ]
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./OldDragDropList.styles":"e6vof","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e6vof":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledOldDragDropList", function() {
    return StyledOldDragDropList;
});
parcelHelpers.export(exports, "StyledDragDropListItem", function() {
    return StyledDragDropListItem;
});
parcelHelpers.export(exports, "StyledAddItemContainer", function() {
    return StyledAddItemContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-left: solid 3px ",
        ";\n  padding: 8px;\n  margin-bottom: 20px;\n\n  .list-header {\n    margin-bottom: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: flex;\n\n  align-items: center;\n  justify-content: space-between;\n\n  height: 36px;\n  transition: background-color 0.3s, transform 0.25s;\n\n  &.dragging,\n  &.active {\n    background-color: ",
        " !important;\n  }\n\n  // 39px = item height + vertical margin\n  &.animate-up {\n    transform: translate(0, -39px);\n  }\n\n  &.animate-down {\n    transform: translate(0, 39px);\n  }\n\n  &.animate-up,\n  &.animate-down {\n    &:not(.active) {\n      // ensures clicked item remains visually on top during movement\n      z-index: -1;\n    }\n  }\n\n  .list-item-text {\n    margin-left: 16px;\n    font-size: 14px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .confirm-delete-container {\n    display: flex;\n    align-items: center;\n\n    .confirm,\n    .cancel {\n      color: white;\n      box-shadow: none;\n      height: 36px;\n    }\n\n    .confirm {\n      margin-left: 16px;\n      background-color: ",
        ";\n    }\n\n    .cancel {\n      margin-left: 8px;\n      background-color: ",
        ";\n    }\n  }\n\n  .list-buttons {\n    display: flex;\n    margin-left: 10px;\n    justify-content: flex-end;\n\n    Button {\n      padding: 0;\n      background: none;\n      box-shadow: none;\n      color: ",
        ";\n\n      &:disabled {\n        opacity: 0.2;\n      }\n    }\n\n    .arrow-down {\n      margin-left: 8px;\n      margin-right: 12px;\n    }\n\n    .arrow-up {\n      margin-left: 12px;\n    }\n\n    .edit {\n      margin-left: 18px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  // visually 3px, but it abuts a negative margin, so...\n  margin-top: 6px;\n\n  .add-item-input {\n    background-color: ",
        ";\n    margin: 0;\n  }\n\n  .add-btn,\n  .confirm,\n  .cancel {\n    height: 30px;\n    margin-top: 2px;\n    padding: 0;\n  }\n\n  .confirm,\n  .cancel {\n    width: 33px;\n    border-radius: 50%;\n    margin-right: 6px;\n    color: ",
        ";\n  }\n\n  .confirm {\n    background-color: ",
        ";\n\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  .cancel {\n    background-color: ",
        ";\n  }\n\n  .add-btn {\n    width: 100%;\n    color: ",
        ";\n    background: none;\n    box-shadow: none;\n  }\n\n  &.dash-border {\n    border: 1px dashed ",
        ";\n    border-radius: 3px;\n  }\n\n  &.solid-back {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledOldDragDropList = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor);
var StyledDragDropListItem = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).mediumGray, (0, _index.COLORS).red, (0, _index.COLORS).green, (0, _index.COLORS).defaultFontColor);
var StyledAddItemContainer = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).white, (0, _index.COLORS).green, (0, _index.COLORS).red, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cld9p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generic icon component, hidden from Assistive Technology by default.
 * If icon should be available to AT, pass the desired name into the `ariaLabel` prop.
 */ parcelHelpers.export(exports, "Icon", function() {
    return Icon;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _faIcons = require("./faIcons");
var _indicons = require("./indicons");
var _partnerIcons = require("./partnerIcons");
var allIcons = (0, _objectSpread._)({}, (0, _faIcons.faIcons), (0, _indicons.indicons), (0, _partnerIcons.partnerIcons));
function Icon(_param) {
    var _param_style = _param.style, style = _param_style === void 0 ? {} : _param_style, props = (0, _objectWithoutProperties._)(_param, [
        "style"
    ]);
    var _allIcons_props_name;
    var ariaLabel = props.ariaLabel ? {
        "aria-label": props.ariaLabel
    } : {
        "aria-hidden": true,
        focusable: false
    };
    var iconComponentProps = ((_allIcons_props_name = allIcons[props.name]) === null || _allIcons_props_name === void 0 ? void 0 : _allIcons_props_name.props) || null;
    var dimensions = props.size && props.size.length > 0 ? returnDimensions(props.size) : {
        width: "1em",
        height: "1em"
    };
    if (!iconComponentProps) {
        console.error("".concat(props.name, " is not a valid icon name."));
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({}, iconComponentProps, ariaLabel, dimensions), {
        role: "img",
        className: props.className,
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        fill: props.fill || "currentColor",
        id: props.id,
        style: style,
        onClick: props.onClick
    }));
}
function returnDimensions(sizeProp) {
    if (sizeProp.length > 1) return {
        width: sizeProp[0],
        height: sizeProp[1]
    };
    return {
        width: sizeProp[0],
        height: sizeProp[0]
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","./faIcons":"9OrkN","./indicons":"5ixPq","./partnerIcons":"5MAF6","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hGWir":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderValues", function() {
    return 0, _headerValues.HeaderValues;
});
var _headerValues = require("./HeaderValues");

},{"./HeaderValues":"1Ot60","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1Ot60":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Found on item detail pages. Generates a styled list of ids and/or links
 * related to the current item.
 */ parcelHelpers.export(exports, "HeaderValues", function() {
    return HeaderValues;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerValuesStyles = require("./HeaderValues.styles");
function HeaderValues(props) {
    var values = props.values, links = props.links, className = props.className, id = props.id;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _headerValuesStyles.StyledHeaderValues), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            values === null || values === void 0 ? void 0 : values.map(function(value) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _headerValuesStyles.StyledValue), {
                    "data-cy": value["data-cy"],
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "header-text",
                            children: [
                                value.text,
                                ": "
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "header-value",
                            children: [
                                " ",
                                value.value
                            ]
                        })
                    ]
                }, "".concat(value.text, "-").concat(value.value));
            }),
            links === null || links === void 0 ? void 0 : links.map(function(link) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    "data-cy": link["data-cy"],
                    children: !link.isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: link.to,
                        children: link.text
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: link.text
                    })
                }, "".concat(link.text, "-").concat(link.to));
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","./HeaderValues.styles":"jWZ6j","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jWZ6j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledValue", function() {
    return StyledValue;
});
parcelHelpers.export(exports, "StyledHeaderValues", function() {
    return StyledHeaderValues;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n  display: flex;\n\n  .header-text {\n    font-weight: bold;\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  li:not(:last-of-type) {\n    padding-right: 10px;\n    margin-right: 10px;\n    max-height: 22px;\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledValue = (0, _styledComponentsDefault.default).li(_templateObject());
var StyledHeaderValues = (0, _styledComponentsDefault.default).ul(_templateObject1(), (0, _index.COLORS).blueBayoux);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8QN7l":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListTable", function() {
    return 0, _listTable.ListTable;
});
var _listTable = require("./ListTable");

},{"./ListTable":"cXV3N","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cXV3N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListTable", function() {
    return ListTable;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _header = require("./Header");
var _listTableStyles = require("./ListTable.styles");
var ListTable = function(props) {
    var _props_pagination_pageInfo, _props_pagination;
    var header = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
        selectProps: {
            "data-cy": "dataset--sort-by-select"
        },
        title: props.title,
        headerComponent: props.headerComponent,
        sortBy: props.sortBy,
        aggregateCount: (props === null || props === void 0 ? void 0 : (_props_pagination = props.pagination) === null || _props_pagination === void 0 ? void 0 : (_props_pagination_pageInfo = _props_pagination.pageInfo) === null || _props_pagination_pageInfo === void 0 ? void 0 : _props_pagination_pageInfo.aggregateCount) || props.totalCount,
        flagText: props.flagText,
        hasFlagMessage: props.flagMessage ? true : false
    });
    var RenderList = function() {
        if (props.loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingList), {});
        if (props.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.SectionBody), {
            className: "error-shrug",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Shrug), {
                message: props.errorMessage || "Sorry, there was an error retrieving this data"
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                props.listItems.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.SectionBody), {
                    className: "error-shrug",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Shrug), {
                        message: props.emptyListMessage || "No results found"
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                    className: "list-container",
                    children: props.listItems.map(function(li) {
                        var key = (0, _uuid.v4)();
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                            className: "list-item",
                            children: li
                        }, key);
                    })
                }),
                props.pagination ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Pagination), {
                    limit: props.pagination.limit,
                    pageInfo: props.pagination.pageInfo,
                    currentPage: props.pagination.currentPage,
                    getPage: props.pagination.getPage,
                    getPreviousPage: props.pagination.getPreviousPage,
                    getNextPage: props.pagination.getNextPage,
                    quantity: props.listItems.length
                }) : null
            ]
        });
    };
    var list = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listTableStyles.StyledListTable), {
        children: [
            props.flagMessage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "ListTable__flag-message",
                children: props.flagMessage
            }) : null,
            props.subTitle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sub-title",
                children: typeof props.subTitle === "string" ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    style: {
                        maxWidth: "75%"
                    },
                    children: props.subTitle
                }) : props.subTitle
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "list",
                children: [
                    !props.error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "list-header-container",
                        children: props.listHeader
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(RenderList, {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listTableStyles.StyledListTable), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id,
        children: props.accordion ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Accordion), {
            header: header,
            content: list,
            open: props.accordionDefaultOpen
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                header,
                list
            ]
        })
    });
};
exports.default = ListTable;

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./Header":"hMpiL","./ListTable.styles":"8PYJ3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hMpiL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", function() {
    return 0, _header.Header;
});
var _header = require("./Header");

},{"./Header":"2VPa5","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2VPa5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", function() {
    return Header;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _headerStyles = require("./Header.styles");
var Header = function(props) {
    var title = props.title, headerComponent = props.headerComponent, sortBy = props.sortBy, aggregateCount = props.aggregateCount, flagText = props.flagText, hasFlagMessage = props.hasFlagMessage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _headerStyles.StyledHeader), {
        className: (0, _classnamesDefault.default)({
            "flag-message": hasFlagMessage
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "title-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "count",
                        children: aggregateCount ? (0, _utils.numberUtils).numberWithCommas(aggregateCount) : null
                    }),
                    flagText ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Flag), {
                        className: "Header__flag",
                        text: flagText
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "controls-container",
                children: [
                    headerComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-component",
                        children: headerComponent
                    }) : null,
                    sortBy ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "sort-by",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.BorderSelect), (0, _objectSpread._)({
                                label: "Sort By",
                                value: sortBy.value,
                                options: sortBy.items,
                                onChange: function(e) {
                                    sortBy.onSort(e.target.value);
                                },
                                horizontal: true
                            }, props.selectProps)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                "data-cy": "dataset--sort-by-btn",
                                onClick: function() {
                                    return sortBy.updateDescending();
                                },
                                variant: "no-style",
                                className: "button-sort-direction",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                                    name: "fa-arrow-down",
                                    ariaLabel: "descending",
                                    size: [
                                        16
                                    ],
                                    style: {
                                        transform: sortBy.descending ? "" : "rotate(180deg)"
                                    }
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/utils":"47VRj","classnames":"9xS9S","Permafrost/index":"iliLC","./Header.styles":"6mfKR","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6mfKR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHeader", function() {
    return StyledHeader;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 42px;\n  margin-bottom: 12px;\n\n  .title {\n    font-size: 22px;\n    margin: 0;\n  }\n\n  .count {\n    font-size: 18px;\n    margin: 4px 0 0 10px;\n  }\n\n  .title-container,\n  .controls-container,\n  .sort-by {\n    display: inherit;\n  }\n\n  .sort-by {\n    margin-left: 10px;\n\n    label,\n    .button-sort-direction,\n    .button-sort-direction:focus {\n      color: ",
        ";\n    }\n\n    label {\n      font-weight: normal;\n    }\n\n    .button-sort-direction {\n      margin-left: 10px;\n\n      svg {\n        position: relative;\n        bottom: 3px;\n        transition: 0.3s transform ease-in-out;\n      }\n    }\n  }\n\n  .select-container {\n    box-sizing: border-box;\n\n    .selectCaret {\n      color: ",
        ";\n      height: 16px;\n      width: 16px;\n      margin: 0;\n    }\n  }\n\n  .Header__flag {\n    margin: 3px 0 0 10px;\n  }\n\n  &.flag-message {\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledHeader = (0, _styledComponentsDefault.default).header(_templateObject(), (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8PYJ3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListTable", function() {
    return StyledListTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .list {\n    .list-header-container,\n    .list-container .list-item {\n      border-bottom: solid ",
        " 1px;\n      padding: 0 20px 10px 20px;\n      margin-bottom: 10px;\n    }\n\n    .list-header-container {\n      border-bottom-color: ",
        ";\n    }\n\n    .list-container .list-item {\n      font-size: 14px;\n\n      & > * div {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .sub-title {\n    margin-bottom: 20px;\n  }\n\n  summary,\n  summary h2 {\n    width: 100%;\n  }\n\n  summary .header-container {\n    svg {\n      margin-top: 2px;\n    }\n\n    .header-component div {\n      padding: 0;\n    }\n  }\n\n  summary .title-container {\n    margin-bottom: 2px;\n\n    .title {\n      align-items: flex-start;\n\n      h2 {\n        margin-left: 0;\n      }\n    }\n\n    .count {\n      color: ",
        ";\n    }\n  }\n\n  summary .sort-by .button-sort-direction svg {\n    bottom: 5px;\n  }\n\n  .content {\n    margin-top: 0 !important;\n  }\n\n  .error-shrug {\n    margin: 0 20px;\n    background-color: ",
        ";\n  }\n\n  .ListTable__flag-message {\n    color: ",
        ";\n    margin-bottom: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListTable = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).blueBayoux, (0, _index.COLORS).baliHai, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).yellowOrange);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ik9Lz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A functional container for content that is yet to load or will change; displays a loading indicator and announces
 * to Assistive Technology as needed.
 *
 * todo: this is an extremely simple version of this component; as I get more familiar with LoadingIndicator use cases, this will be refactored. - jm 9/1/2020
 */ parcelHelpers.export(exports, "LoadingAwareContainer", function() {
    return LoadingAwareContainer;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _loadingAwareContainerStyles = require("./LoadingAwareContainer.styles");
function LoadingAwareContainer(props) {
    var children = props.children, className = props.className, isLoading = props.isLoading, style = props.style;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _loadingAwareContainerStyles.StyledLoadingAwareContainer), {
        className: (0, _classnamesDefault.default)({
            loading: isLoading
        }, className),
        style: style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingAwareContainerStyles.StyledStatusContainer), {
                role: "status",
                children: isLoading && "Loading"
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingIndicator), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./LoadingAwareContainer.styles":"1R0MQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1R0MQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledStatusContainer", function() {
    return StyledStatusContainer;
});
parcelHelpers.export(exports, "StyledLoadingAwareContainer", function() {
    return StyledLoadingAwareContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: absolute;\n  height: 0;\n  width: 0;\n  opacity: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledStatusContainer = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledLoadingAwareContainer = (0, _styledComponentsDefault.default).div(_templateObject1());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5mDID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Displays the Indico logo treatment, either the logotype or logomark.
 *
 * The logotype is shown by default, unless the `logomark` property is true.
 */ parcelHelpers.export(exports, "Logo", function() {
    return Logo;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoStyles = require("./Logo.styles");
function Logo(props) {
    var logomark = props.logomark, width = props.width;
    var logoWidth = width ? width : logomark ? 25 : 120;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _logoStyles.StyledLogo), {
        viewBox: logomark ? "0 0 102 102" : "0 0 202 73",
        height: logomark ? logoWidth : logoWidth * 0.35833333,
        width: logoWidth,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: "Indico Data"
            }),
            logomark ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M58.5 43.6H43.7v14.8h14.8V43.6zm-36.9 0C25 30.6 36.8 20.9 51 20.9s26 9.7 29.4 22.8h20.3C97.1 19.6 76.2 1 51 1 25.8 1 4.9 19.6 1.3 43.6h20.3zm58.7 14.8C77 71.4 65.1 81.1 51 81.1c-14.1 0-26-9.7-29.3-22.7H1.3C5 82.5 25.8 101 51 101c25.2 0 46-18.5 49.7-42.6H80.3z",
                className: "logomark"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M115 71.5h-8.7V50.3h8.7c5.9 0 10.6 4.8 10.6 10.6s-4.7 10.6-10.6 10.6zm-3.9-4.8h3.9c3.2 0 5.8-2.6 5.8-5.8s-2.6-5.8-5.8-5.8h-3.9v11.6zM173 50.3h-16.5v4.5h5.8v16.8h4.8V54.7h5.8l.1-4.4zm-34.3 0L131 71.5h5.1l1.3-3.5h8.3l1.3 3.5h5.1l-7.7-21.2h-5.7zm.3 13.2l2.5-7 2.5 7h-5zm46.6-13.2l-7.7 21.2h5.1l1.3-3.5h8.3l1.3 3.5h5.1l-7.7-21.2h-5.7zm.3 13.2l2.5-7 2.5 7h-5z",
                        className: "data"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.3 1.4v41.3H1V1.4h8.3zm133.2 41.5c5.6 0 10.9-2.2 14.8-6.2l-5.9-5.9c-2.4 2.4-5.6 3.7-9 3.7s-6.5-1.3-8.9-3.7-3.7-5.5-3.7-8.9 1.3-6.6 3.7-9c4.9-4.9 13-5 17.9-.1l5.9-5.9c-8-8-21.3-7.9-29.5.3-4 4-6.2 9.2-6.2 14.8s2.2 10.9 6.1 14.8c3.9 4 9.2 6.1 14.8 6.1zM100.3 22c0-11.4-9.3-20.6-20.7-20.6H62.9v41.2h16.8c11.3 0 20.6-9.3 20.6-20.6zM71.2 9.7h8.4C86.4 9.7 92 15.2 92 22s-5.5 12.3-12.3 12.3h-8.4l-.1-24.6zm112.1 9.2h-6.2v6.2h6.2v-6.2zm-77 6.2v17.5h8.3V25.1h-8.3zm8.4-6.2V1.4h-8.3V19h8.3v-.1zm53.2 0c1.4-5.5 6.4-9.5 12.3-9.5s10.9 4.1 12.3 9.5h8.5C199.5 8.8 190.7 1 180.2 1s-19.3 7.8-20.8 17.9h8.5zm24.6 6.2c-1.4 5.4-6.4 9.5-12.3 9.5s-10.9-4-12.3-9.5h-8.5c1.5 10.1 10.3 17.8 20.8 17.8s19.3-7.8 20.8-17.8h-8.5zM46.3 1.4v28.1L26.7 1.4h-9.2v41.3h8.3v-28l19.5 28h9.3V1.4h-8.3z",
                        className: "indico"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./Logo.styles":"bzDjs","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bzDjs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLogo", function() {
    return StyledLogo;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .indico,\n  .logomark {\n    transition: fill 0.2s;\n  }\n\n  .indico {\n    fill: var(",
        ");\n  }\n\n  .logomark,\n  .data {\n    fill: var(",
        ");\n  }\n\n  &:hover {\n    //  .indico {\n    //    fill: var(--logo-color-secondary);\n    //  }\n    //\n    .logomark {\n      fill: var(",
        ");\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLogo = (0, _styledComponentsDefault.default).svg(_templateObject(), (0, _index.colorProperties).logoPrimary, (0, _index.colorProperties).logoSecondary, (0, _index.colorProperties).logoPrimary);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"asoma":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return Pagination;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var _paginationStyles = require("./Pagination.styles");
function Pagination(props) {
    //   renderPreviousPages = (currentPage, lastPage) => {
    //     if (currentPage === lastPage - 2) {
    //       return null
    //     }
    //     // this.props.getPage(endCursor, 1)
    //     if (currentPage === lastPage - 1) {
    //       return <>{lastPage - 2 >= 1 && <button onClick={() => this.props.getBeforePage(startCursor, )}>{lastPage - 2}</button>}</>
    //     }
    //     if (currentPage === lastPage) {
    //       return (
    //         <>
    //           {lastPage - 2 >= 1 && <button>{lastPage - 2}</button>}
    //           {lastPage - 1 >= 1 && <button>{lastPage - 1}</button>}
    //         </>
    //       )
    //     }
    //   }
    var _props_pageInfo = props.pageInfo, aggregateCount = _props_pageInfo.aggregateCount, hasNextPage = _props_pageInfo.hasNextPage, endCursor = _props_pageInfo.endCursor, startCursor = _props_pageInfo.startCursor;
    var currentPage = props.currentPage, limit = props.limit, quantity = props.quantity;
    var lastPage = Math.ceil(aggregateCount / limit);
    var currentItemNumber = (currentPage - 1) * limit + 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paginationStyles.StyledPagination), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "Pagination--stats",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        "Showing",
                        " ",
                        aggregateCount === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                currentItemNumber,
                                " - ",
                                currentItemNumber + quantity - 1,
                                " of",
                                " "
                            ]
                        }),
                        (0, _utils.numberUtils).numberWithCommas(aggregateCount),
                        " entries"
                    ]
                })
            }),
            aggregateCount > limit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "Pagination--button-group",
                "data-cy": "Pagination--button-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        "data-cy": "pagination--label",
                        children: "Page:\xa0"
                    }),
                    currentPage > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPreviousPage(startCursor);
                        },
                        children: "Prev"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        "data-cy": "pagination--current-page",
                        children: currentPage
                    }),
                    lastPage > currentPage + 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPage(endCursor, 1);
                        },
                        "data-cy": "pagination--second-page-number",
                        children: currentPage + 1
                    }),
                    lastPage > currentPage + 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPage(endCursor, 2);
                        },
                        "data-cy": "pagination--third-page-number",
                        children: currentPage + 2
                    }),
                    lastPage > currentPage + 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPage(endCursor, 3);
                        },
                        children: currentPage + 3
                    }),
                    lastPage - (currentPage + 2) === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPage(endCursor, 4);
                        },
                        children: currentPage + 4
                    }),
                    lastPage - (currentPage + 2) > 2 && lastPage - (currentPage + 2) !== 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "..."
                    }),
                    lastPage !== currentPage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getPage(endCursor, lastPage - currentPage);
                        },
                        "data-cy": "pagination--last-page",
                        children: lastPage
                    }),
                    hasNextPage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: function() {
                            return props.getNextPage(endCursor);
                        },
                        "data-cy": "pagination--next-page-number",
                        children: "Next"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/utils":"47VRj","./Pagination.styles":"69n0g","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"69n0g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPagination", function() {
    return StyledPagination;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  position: relative;\n\n  .Pagination--stats {\n    display: inline-block;\n    padding: 10px 0;\n    line-height: 1.6;\n  }\n\n  .Pagination--button-group {\n    display: flex;\n    justify-content: flex-end;\n    width: calc(25% + ",
        ");\n    padding: 10px ",
        " 10px 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    > * {\n      display: inline-block;\n      font-size: 18px;\n      vertical-align: middle;\n      margin-right: 8px;\n    }\n\n    button {\n      width: auto;\n      padding: 0;\n      display: inline-block;\n      background: none;\n      box-shadow: none;\n      text-decoration: underline;\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &.Pagination--non-click {\n        text-decoration: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var paddingRight = "30px";
var StyledPagination = (0, _styledComponentsDefault.default).div(_templateObject(), paddingRight, paddingRight, (0, _index.COLORS).midFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6fUIw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationWithoutQuery", function() {
    return PaginationWithoutQuery;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pagination = require("../Pagination/Pagination");
var PaginationWithoutQuery = function(param) {
    var limit = param.limit, resetPaginationOnChange = param.resetPaginationOnChange, values = param.values, onChange = param.onChange;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(1), 2), currentPage = _useState[0], setCurrentPage = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        start: 0,
        end: limit
    }), 2), cursors = _useState1[0], setCursors = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(0), 2), paginatedValuesLength = _useState2[0], setPaginatedValuesLength = _useState2[1];
    // Passes back the updated paginated list when currentPage or master values is changed, also sets length of current paginated list to render correct controls
    (0, _react.useEffect)(function() {
        var updatedPaginatedValues = values === null || values === void 0 ? void 0 : values.slice(cursors.start, cursors.end);
        setPaginatedValuesLength(updatedPaginatedValues === null || updatedPaginatedValues === void 0 ? void 0 : updatedPaginatedValues.length);
        onChange(updatedPaginatedValues);
    }, [
        cursors,
        currentPage,
        values
    ]);
    // Resets pagination to page1 when resetPaginationOnChange is updated - intended to be used for filters/sorting on the master list
    (0, _react.useEffect)(function() {
        if (!(resetPaginationOnChange === null || resetPaginationOnChange === void 0 ? void 0 : resetPaginationOnChange.length)) return;
        setCurrentPage(1);
        setCursors({
            start: 0,
            end: limit
        });
    }, resetPaginationOnChange);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
        currentPage: currentPage,
        limit: limit,
        pageInfo: {
            aggregateCount: values === null || values === void 0 ? void 0 : values.length,
            endCursor: cursors.end,
            hasNextPage: cursors.end < (values === null || values === void 0 ? void 0 : values.length),
            startCursor: cursors.start
        },
        quantity: paginatedValuesLength,
        getPage: function(startCursor, endCursor) {
            setCurrentPage(currentPage + endCursor);
            setCursors({
                start: startCursor + limit * (endCursor - 1),
                end: startCursor + limit * endCursor
            });
        },
        getNextPage: function(cursor) {
            setCurrentPage(currentPage + 1);
            setCursors({
                start: cursor,
                end: cursor + limit
            });
        },
        getPreviousPage: function(cursor) {
            setCurrentPage(currentPage - 1);
            setCursors({
                start: cursor - limit,
                end: cursor
            });
        }
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","../Pagination/Pagination":"asoma","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lXxra":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReorderableList", function() {
    return 0, _reorderableList.ReorderableList;
});
parcelHelpers.export(exports, "ListItem", function() {
    return 0, _listItem.ListItem;
});
parcelHelpers.export(exports, "useListItem", function() {
    return 0, _listItem.useListItem;
});
parcelHelpers.export(exports, "useListControls", function() {
    return 0, _reorderableList.useListControls;
});
parcelHelpers.export(exports, "ListControls", function() {
    return 0, _listControls.ListControls;
});
var _reorderableList = require("./ReorderableList");
var _listItem = require("./ListItem/ListItem");
var _listControls = require("./ListControls/ListControls");

},{"./ReorderableList":"dr20N","./ListItem/ListItem":"d5fRa","./ListControls/ListControls":"lfJLu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dr20N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Vertical list that may be reordered by drag-and-drop action, or programmatically by either
 * including `<ListControls>` in the custom component to be passed in (`ListItemComponent`), or
 * by using the `useListItem` Context hook directly - see `ListItemContextType` at the bottom
 * of this file for a list of the props available from the hook.
 *
 * @see {@link https://reactjs.org/docs/context.html}
 */ parcelHelpers.export(exports, "ReorderableList", function() {
    return ReorderableList;
});
parcelHelpers.export(exports, "useListControls", function() {
    return useListControls;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _dnd = require("@hello-pangea/dnd");
var _utils = require("@indico-data/utils");
var _index = require("./index");
var _useItemSwap = require("./useItemSwap");
var droppableId = (0, _uuid.v4)();
var ListControlsContext = /*#__PURE__*/ (0, _react.createContext)({});
ListControlsContext.displayName = "ReorderableListControls";
function ReorderableList(props) {
    var className = props.className, id = props.id, items = props.items, _props_itemsVerticalGap = props.itemsVerticalGap, itemsVerticalGap = _props_itemsVerticalGap === void 0 ? 0 : _props_itemsVerticalGap, listControls = props.listControls, onDelete = props.onDelete, onReorder = props.onReorder, _props_swapDuration = props.swapDuration, swapDuration = _props_swapDuration === void 0 ? 250 : _props_swapDuration, ListItemComponent = props.ListItemComponent;
    var _useItemSwap1 = (0, _useItemSwap.useItemSwap)(), addItemHeight = _useItemSwap1.addItemHeight, clearSwapAnimations = _useItemSwap1.clearSwapAnimations, setSwapAnimations = _useItemSwap1.setSwapAnimations, swapAnimations = _useItemSwap1.swapAnimations;
    var handleDelete = function(itemId) {
        var itemIndex = items.findIndex(function(item) {
            return itemId === item.id;
        });
        var updatedItems = (0, _utils.arrayUtils).deleteItem(items, itemIndex);
        onReorder(updatedItems);
        onDelete && onDelete(updatedItems);
    };
    // only ever called as a result of a Drop action
    var handleDragEnd = function(result) {
        if (!result.destination || result.destination.index === result.source.index) return;
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items, result.source.index, result.destination.index);
        onReorder(reorderedItems);
    };
    // called when programmatically changing order, e.g. pressing an up/down arrow button in `ListControls`
    var handleMoveItem = function(sourceId, direction) {
        var sourceIndex = items.findIndex(function(item) {
            return item.id === sourceId;
        });
        if (sourceIndex === 0 && direction === "up" || sourceIndex === items.length && direction === "down") return;
        var destinationIndex = direction === "up" ? sourceIndex - 1 : sourceIndex + 1;
        var destinationId = items[destinationIndex].id;
        setSwapAnimations(sourceId, destinationId, direction);
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items, sourceIndex, destinationIndex);
        setTimeout(function() {
            onReorder(reorderedItems);
            clearSwapAnimations();
        }, swapDuration + 100); // jank protection: wait an extra 100ms before the css classes are removed
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.DragDropContext), {
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
            droppableId: droppableId,
            children: function(provided) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref: provided.innerRef,
                    className: className,
                    "data-cy": props["data-cy"],
                    id: id
                }, provided.droppableProps), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListControlsContext.Provider, {
                            value: (0, _objectSpread._)({}, listControls),
                            children: items.map(function(item, i) {
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.ListItem), {
                                    animating: swapAnimations.has(item.id) ? swapAnimations.get(item.id) : null,
                                    addItemHeight: addItemHeight,
                                    deleteItem: handleDelete,
                                    item: item,
                                    index: i,
                                    itemsVerticalGap: itemsVerticalGap,
                                    listLength: items.length,
                                    moveItem: function(direction) {
                                        return handleMoveItem(item.id, direction);
                                    },
                                    swapDuration: swapDuration,
                                    InnerComponent: ListItemComponent
                                }, item.id);
                            })
                        }),
                        provided.placeholder
                    ]
                }));
            }
        })
    });
}
function useListControls() {
    return (0, _react.useContext)(ListControlsContext);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","uuid":"6ZyFu","@hello-pangea/dnd":"bhM3h","@indico-data/utils":"47VRj","./index":"lXxra","./useItemSwap":"94PFx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"94PFx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores item heights, and returns necessary values for swap animations. When two items of
 * different heights are exchanging position (i.e. “swapping”), each item needs to move the distance
 * equal to the height of the item it is replacing.
 */ parcelHelpers.export(exports, "useItemSwap", function() {
    return useItemSwap;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useItemSwap() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(new Map()), 2), itemHeights = _useState[0], setItemHeights = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(new Map()), 2), swapAnimations = _useState1[0], setSwapAnimations = _useState1[1];
    var handleSetSwapAnimations = function(sourceId, destinationId, direction) {
        var destinationHeight = itemHeights.get(destinationId);
        var sourceHeight = itemHeights.get(sourceId);
        var destinationDirection = direction === "up" ? "down" : "up";
        setSwapAnimations(new Map([
            [
                sourceId,
                {
                    distance: destinationHeight,
                    direction: direction
                }
            ],
            [
                destinationId,
                {
                    distance: sourceHeight,
                    direction: destinationDirection
                }
            ]
        ]));
    };
    var clearSwapAnimations = function() {
        setSwapAnimations(new Map());
    };
    var addItemHeight = function(height, id) {
        if (height && !Number.isNaN(height)) setItemHeights(function(prevState) {
            return new Map(prevState.set(id, height));
        });
    };
    return {
        itemHeights: itemHeights,
        addItemHeight: addItemHeight,
        clearSwapAnimations: clearSwapAnimations,
        setSwapAnimations: handleSetSwapAnimations,
        swapAnimations: swapAnimations
    };
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"d5fRa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * When this component has rendered it will measure its own height, which will be used by the
 * parent component to determine its animation if this item has been programmatically reordered
 * (e.g. `ListControls` up/down arrow button has been pressed); item heights currently have no
 * other purpose.
 *
 * `itemsVerticalGap` should be used in place of margins to separate the items in the list;
 * it is applied to the container `<div>` below as padding-bottom.
 */ parcelHelpers.export(exports, "ListItem", function() {
    return ListItem;
});
/**
 * Tracks status for a particular item in the list.
 */ parcelHelpers.export(exports, "useListItem", function() {
    return useListItem;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dnd = require("@hello-pangea/dnd");
var _listItemStyles = require("./ListItem.styles");
var ListItemContext = /*#__PURE__*/ (0, _react.createContext)({});
ListItemContext.displayName = "ReorderableListItem";
function ListItem(props) {
    var listItemEl = (0, _react.useRef)(null);
    var animating = props.animating, moveItem = props.moveItem, addItemHeight = props.addItemHeight, deleteItem = props.deleteItem, item = props.item, index = props.index, itemsVerticalGap = props.itemsVerticalGap, listLength = props.listLength, swapDuration = props.swapDuration, InnerComponent = props.InnerComponent;
    var id = item.id;
    // tracks whether an arrow has been pressed on this item
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), confirmDelete = _useState1[0], setConfirmDelete = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), editing = _useState2[0], setEditing = _useState2[1];
    // handler for a “move up/down” action - this is not used by drag/drop.
    var handleMoveItem = function(direction) {
        setActive(true);
        moveItem(direction);
    };
    var measureSelf = function() {
        if (listItemEl && listItemEl.current) {
            var box = listItemEl.current.getBoundingClientRect();
            addItemHeight(box.height, id);
        }
    };
    // see this component’s style file for what this class is doing
    var animationClassName = animating ? "animate-".concat(animating.direction) : "";
    // remove “active” state after the item has been reordered
    (0, _react.useEffect)(function() {
        setActive(false);
    }, [
        index
    ]);
    // measure and store the height of this rendered component
    (0, _react.useLayoutEffect)(function() {
        measureSelf();
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
        draggableId: item.id,
        index: index,
        children: function(provided, snapshot) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemStyles.StyledListItem), (0, _objectSpreadProps._)((0, _objectSpread._)({
                ref: provided.innerRef
            }, provided.draggableProps, provided.dragHandleProps), {
                className: (0, _classnamesDefault.default)("list-item-container", animationClassName, {
                    active: active,
                    dragging: snapshot.isDragging
                }),
                $animationDistance: animating ? animating.distance : 0,
                $animationDuration: swapDuration,
                style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, provided.draggableProps.style), {
                    paddingBottom: "".concat(itemsVerticalGap, "px")
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemContext.Provider, {
                    value: {
                        active: active,
                        confirmDelete: confirmDelete,
                        deleteItem: function() {
                            return deleteItem && deleteItem(id);
                        },
                        dragging: snapshot.isDragging,
                        editing: editing,
                        index: index,
                        item: item,
                        isFirstItem: index === 0,
                        isLastItem: index === listLength - 1,
                        moveItemDown: function() {
                            return handleMoveItem("down");
                        },
                        moveItemUp: function() {
                            return handleMoveItem("up");
                        },
                        setConfirmDelete: setConfirmDelete,
                        setEditing: setEditing
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        ref: listItemEl,
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InnerComponent, {})
                    })
                })
            }));
        }
    });
}
function useListItem() {
    return (0, _react.useContext)(ListItemContext);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@hello-pangea/dnd":"bhM3h","./ListItem.styles":"ddKWv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ddKWv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListItem", function() {
    return StyledListItem;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:active {\n    cursor: grabbing;\n  }\n\n  &.dragging > * {\n    box-shadow: rgba(0, 0, 0, 0.5) 0 3px 8px 0;\n  }\n\n  // animation gets weird if common style rules are moved into a shared declaration...\n  &.animate-up {\n    animation: ",
        "\n      ",
        "ms ease-in;\n    animation-fill-mode: forwards;\n  }\n\n  &.animate-down {\n    animation: ",
        "\n      ",
        "ms ease-in;\n    animation-fill-mode: forwards;\n  }\n\n  &.animate-up,\n  &.animate-down {\n    transition: opacity 120ms;\n\n    &.active {\n      // ensures clicked item remains visually on top during movement\n      z-index: 10000;\n    }\n\n    &:not(.active) {\n      opacity: 0.8;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(0, ",
        "",
        "px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListItem = (0, _styledComponentsDefault.default).li(_templateObject(), function(props) {
    return slideKeyframes(props.$animationDistance, "up");
}, function(props) {
    return props.$animationDuration;
}, function(props) {
    return slideKeyframes(props.$animationDistance, "down");
}, function(props) {
    return props.$animationDuration;
});
var slideKeyframes = function(distance, direction) {
    return (0, _styledComponents.keyframes)(_templateObject1(), direction === "up" ? "-" : "", distance);
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lfJLu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This component **must** be used inside your custom list component. It uses methods from the
 * `useListItem` Context hook, found at the bottom of the `ListItem` file.
 *
 * Unless `promptBeforeDelete` has been disabled in the parent `ReorderableList` component (from
 * the `listControls` prop), pressing the initial “delete” button is not a destructive action.
 */ parcelHelpers.export(exports, "ListControls", function() {
    return ListControls;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
var _index = require("../index");
var _index1 = require("Permafrost/index");
var _listControlsStyles = require("./ListControls.styles");
function ListControls() {
    var _useListControls = (0, _.useListControls)(), hideArrows = _useListControls.hideArrows, hideDelete = _useListControls.hideDelete, hideEdit = _useListControls.hideEdit, promptBeforeDelete = _useListControls.promptBeforeDelete;
    var _useListItem = (0, _index.useListItem)(), confirmDelete = _useListItem.confirmDelete, deleteItem = _useListItem.deleteItem, dragging = _useListItem.dragging, editing = _useListItem.editing, isFirstItem = _useListItem.isFirstItem, isLastItem = _useListItem.isLastItem, moveItemDown = _useListItem.moveItemDown, moveItemUp = _useListItem.moveItemUp, setConfirmDelete = _useListItem.setConfirmDelete, setEditing = _useListItem.setEditing;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listControlsStyles.StyledListControls), {
        children: !confirmDelete ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "list-buttons",
            children: [
                !hideDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                    variant: "no-style",
                    "aria-label": "delete item",
                    className: "delete",
                    onClick: promptBeforeDelete ? function() {
                        return setConfirmDelete(true);
                    } : deleteItem,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Icon), {
                        name: "trash",
                        size: [
                            18
                        ]
                    })
                }),
                !hideEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                    variant: "no-style",
                    "aria-label": "edit item",
                    className: "edit",
                    onClick: function() {
                        return setEditing(true);
                    },
                    disabled: editing,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Icon), {
                        name: "edit",
                        size: [
                            18
                        ]
                    })
                }),
                !hideArrows && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "move-buttons-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                            variant: "no-style",
                            "aria-label": "move item up",
                            className: "button-move-up",
                            disabled: isFirstItem,
                            onClick: moveItemUp,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Icon), {
                                name: "fa-arrow-up",
                                size: [
                                    22
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                            variant: "no-style",
                            "aria-label": "move item down",
                            className: "button-move-down",
                            disabled: isLastItem,
                            onClick: moveItemDown,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Icon), {
                                name: "fa-arrow-down",
                                size: [
                                    22
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : // only shows if `promptBeforeDelete` has NOT been disabled
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "confirm-delete-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Are you sure?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                    className: "button-confirm-delete",
                    onClick: deleteItem,
                    style: {
                        opacity: dragging ? "0.5" : ""
                    },
                    children: "Yes, Delete It"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index1.Button), {
                    className: "button-cancel-delete",
                    onClick: function() {
                        return setConfirmDelete(false);
                    },
                    style: {
                        opacity: dragging ? "0.5" : ""
                    },
                    children: "No, Keep It"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","../":"lXxra","../index":"lXxra","Permafrost/index":"iliLC","./ListControls.styles":"2FhW2","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2FhW2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListControls", function() {
    return StyledListControls;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 36px;\n\n  display: flex;\n\n  .confirm-delete-container {\n    height: inherit;\n    display: inherit;\n    align-items: center;\n\n    .button-confirm-delete,\n    .button-cancel-delete {\n      color: white;\n      box-shadow: none;\n    }\n\n    .button-confirm-delete {\n      margin-left: 16px;\n      background-color: ",
        ";\n    }\n\n    .button-cancel-delete {\n      margin-left: 8px;\n      background-color: ",
        ";\n    }\n  }\n\n  .move-buttons-container {\n    display: flex;\n  }\n\n  .list-buttons {\n    display: inherit;\n    margin-left: 10px;\n\n    Button {\n      padding: 0;\n      background: none;\n      box-shadow: none;\n      color: ",
        ";\n\n      &:disabled {\n        opacity: 0.2;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .button-move-down {\n    margin-left: 8px;\n  }\n\n  .button-move-up {\n    margin-left: 12px;\n  }\n\n  .edit {\n    margin-left: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListControls = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).red, (0, _index.COLORS).green, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1i751":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SaveCancel", function() {
    return SaveCancel;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _saveCancelStyles = require("./SaveCancel.styles");
function SaveCancel(props) {
    var className = props.className, id = props.id, disableSave = props.disableSave, handleCancel = props.handleCancel, handleSave = props.handleSave;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _saveCancelStyles.StyledSaveCancel), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        onClick: handleSave,
                        variant: "cta",
                        className: "saveButton",
                        disabled: disableSave,
                        children: "Save"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        onClick: handleCancel,
                        variant: "link-style",
                        className: "cancelButton",
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./SaveCancel.styles":"bdJL9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bdJL9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSaveCancel", function() {
    return StyledSaveCancel;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  button {\n    &:not(.focus-visible) {\n      outline: none !important;\n    }\n  }\n\n  .saveButton {\n    padding: 0.75em 2em;\n  }\n\n  button.cancelButton {\n    font-size: ",
        ";\n    margin-left: 2em;\n\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n  }\n\n  hr {\n    margin: 1.25em 0;\n    border: 1px solid transparent;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSaveCancel = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"60CMB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An a11y-friendly tabbed interface; allows the user to tab between different sections
 * of a container.
 *
 * If the URL will change as the user moves from section to section, the `TabNavigation` component
 * should be used instead.
 */ parcelHelpers.export(exports, "TabbedContainer", function() {
    return TabbedContainer;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
function TabbedContainer(props) {
    var className = props.className, defaultSection = props.defaultSection, fullWidthTabs = props.fullWidthTabs, id = props.id, sections = props.sections, current = props.current, setCurrent = props.setCurrent;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), tabs = _useState[0], setTabs = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({}), 2), sectionContent = _useState1[0], setSectionContent = _useState1[1];
    // If the sections (aka tabs) we passed in change,
    // then update our local state and,
    // if the tab we were on no longer exists,
    // then return to the default selection
    (0, _react.useEffect)(function() {
        setTabs(sections.map(function(section) {
            return {
                id: section.id,
                name: section.name,
                disabled: section.disabled,
                tooltip: section.tooltip ? section.tooltip : undefined
            };
        }));
        setSectionContent(sections.reduce(function(acc, section) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), (0, _defineProperty._)({}, section.id, section.content));
        }, {}));
        if (!sections.some(function(section) {
            return section.id === current;
        })) setCurrent(defaultSection || sections[0].id);
    }, [
        sections
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.TabbedInterface), {
        tabType: "section",
        tabs: tabs,
        className: className,
        currentTab: current,
        "data-cy": props["data-cy"],
        id: id,
        fullWidthTabs: fullWidthTabs,
        onTabSelect: function(id) {
            return setCurrent(id);
        },
        children: sectionContent[current]
    });
}

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fj2ra":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * An a11y-friendly tabbed interface; allows the user to navigate between URLs.
 *
 * If the URL does **not** need to change between sections, the `TabbedContainer` component
 * should be used instead.
 */ parcelHelpers.export(exports, "TabNavigation", function() {
    return TabNavigation;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
function TabNavigation(props) {
    var children = props.children, className = props.className, currentTab = props.currentTab, fullWidthTabs = props.fullWidthTabs, id = props.id, tabs = props.tabs;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.TabbedInterface), {
        tabType: "navigation",
        tabs: tabs,
        className: className,
        currentTab: currentTab,
        "data-cy": props["data-cy"],
        fullWidthTabs: fullWidthTabs,
        id: id,
        children: children
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kJUwg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", function() {
    return Table;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("@tanstack/react-table");
var _tableStyles = require("./table.styles");
var _actionBar = require("./components/ActionBar");
var _pagination = require("./components/Pagination");
var _noResults = require("./components/NoResults");
var _loadingSpinner = require("../status-indicators/LoadingSpinner/LoadingSpinner");
var _lodash = require("lodash");
function Table(param) {
    var defaultColumns = param.columns, data = param.data, className = param.className, _param_isFixed = param.isFixed, isFixed = _param_isFixed === void 0 ? false : _param_isFixed, currentPage = param.currentPage, totalPageCount = param.totalPageCount, totalRowCount = param.totalRowCount, _param_paginationLimit = param.paginationLimit, paginationLimit = _param_paginationLimit === void 0 ? 1000 : _param_paginationLimit, nextPage = param.nextPage, previousPage = param.previousPage, TableActions = param.TableActions, error = param.error, _param_enableRowSelection = param.enableRowSelection, enableRowSelection = _param_enableRowSelection === void 0 ? true : _param_enableRowSelection, clearFilters = param.clearFilters, hasFiltersApplied = param.hasFiltersApplied, _param_showPagination = param.showPagination, showPagination = _param_showPagination === void 0 ? true : _param_showPagination, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, defaultPinnedColumns = param.defaultPinnedColumns;
    var columns = (0, _react.useMemo)(function() {
        return defaultColumns;
    }, []);
    var defaultData = (0, _react.useMemo)(function() {
        return [];
    }, []);
    var _useState = (0, _slicedToArray._)((0, _react.useState)({}), 2), rowSelection = _useState[0], setRowSelection = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(window.innerWidth), 2), windowWidth = _useState1[0], setWindowWidth = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(columns), 2), formattedColumns = _useState2[0], setFormattedColumns = _useState2[1];
    var thRefs = (0, _react.useRef)({});
    // Tracks changes to browser width to allow for updating of column widths
    (0, _react.useEffect)(function() {
        var handleResize = function() {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    // Sets formattedColumns with correct column widths
    (0, _react.useEffect)(function() {
        var updatedColumns = [];
        formattedColumns.forEach(function(column) {
            updatedColumns.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, column), {
                size: thRefs.current[column.id].offsetWidth
            }));
        });
        setFormattedColumns(updatedColumns);
    }, [
        data,
        columns,
        windowWidth
    ]);
    var table = (0, _reactTable.useReactTable)({
        data: data !== null && data !== void 0 ? data : defaultData,
        columns: formattedColumns,
        state: {
            rowSelection: rowSelection
        },
        enableRowSelection: enableRowSelection,
        onRowSelectionChange: setRowSelection,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        manualPagination: true,
        debugTable: true,
        initialState: {
            columnPinning: {
                left: defaultPinnedColumns
            }
        }
    });
    var totalRowsOnPage = table.getRowModel().rows.length;
    var hasPaginationProps = !(0, _lodash.isNil)(currentPage) && !(0, _lodash.isNil)(totalPageCount) && !(0, _lodash.isNil)(totalRowsOnPage) && !(0, _lodash.isNil)(totalRowCount) && nextPage && previousPage;
    // Sets style attributes for pinned columns
    var getCommonPinningStyles = function(column) {
        var isPinned = column.getIsPinned();
        var isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
        return {
            boxShadow: isLastLeftPinnedColumn ? "-4px 0 4px -4px gray inset" : undefined,
            left: isPinned === "left" ? "".concat(column.getStart("left"), "px") : undefined,
            opacity: isPinned ? 0.95 : 1,
            position: isPinned ? "sticky" : "initial",
            zIndex: isPinned ? 1 : 0
        };
    };
    var _error_errorMessage;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableStyles.StyledContainer), {
        $isFixed: isFixed,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableStyles.StyledTableContainer), {
                $isFixed: isFixed,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableStyles.StyledTable), {
                        $isFixed: isFixed,
                        className: className,
                        $isLoading: loading,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledThead), {
                                children: table.getHeaderGroups().map(function(headerGroup) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                        children: headerGroup.headers.map(function(header) {
                                            var _header_column_columnDef_meta_styles_header, _header_column_columnDef_meta_styles, _header_column_columnDef_meta, _header_column_columnDef_meta_styles1, _header_column_columnDef_meta1;
                                            var column = header.column;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledTh), {
                                                ref: function(el) {
                                                    if (el) thRefs.current[column.id] = el;
                                                },
                                                colSpan: header.colSpan,
                                                $noPadding: !!((_header_column_columnDef_meta = header.column.columnDef.meta) === null || _header_column_columnDef_meta === void 0 ? void 0 : (_header_column_columnDef_meta_styles = _header_column_columnDef_meta.styles) === null || _header_column_columnDef_meta_styles === void 0 ? void 0 : (_header_column_columnDef_meta_styles_header = _header_column_columnDef_meta_styles.header) === null || _header_column_columnDef_meta_styles_header === void 0 ? void 0 : _header_column_columnDef_meta_styles_header.noPadding),
                                                $hasDefinedColumnSize: !!((_header_column_columnDef_meta1 = header.column.columnDef.meta) === null || _header_column_columnDef_meta1 === void 0 ? void 0 : (_header_column_columnDef_meta_styles1 = _header_column_columnDef_meta1.styles) === null || _header_column_columnDef_meta_styles1 === void 0 ? void 0 : _header_column_columnDef_meta_styles1.definedColumnSize),
                                                $width: header.column.getSize(),
                                                style: (0, _objectSpread._)({}, getCommonPinningStyles(column)),
                                                children: (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext())
                                            }, header.id);
                                        })
                                    }, headerGroup.id);
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledTbody), {
                                children: (error === null || error === void 0 ? void 0 : error.hasError) && !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledBodyTr), {
                                    $isSelected: false,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.CenteredRow), {
                                        colSpan: columns.length,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResults), {
                                            clearFilters: clearFilters,
                                            hasFiltersApplied: hasFiltersApplied,
                                            message: (_error_errorMessage = error.errorMessage) !== null && _error_errorMessage !== void 0 ? _error_errorMessage : "There was an error loading the data."
                                        })
                                    })
                                }) : data.length === 0 && !loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledBodyTr), {
                                    $isSelected: false,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.CenteredRow), {
                                        colSpan: columns.length,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noResults.NoResults), {
                                            clearFilters: clearFilters,
                                            hasFiltersApplied: hasFiltersApplied,
                                            message: "No results found."
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        table.getRowModel().rows.map(function(row) {
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledBodyTr), {
                                                $isSelected: row.getIsSelected(),
                                                children: row.getVisibleCells().map(function(cell) {
                                                    var _columnDef_meta_styles_cell, _columnDef_meta_styles, _columnDef_meta, _columnDef_meta_styles_cell1, _columnDef_meta_styles1, _columnDef_meta1, _columnDef_meta_styles2, _columnDef_meta2;
                                                    var columnDef = cell.column.columnDef;
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledTd), {
                                                        $noPadding: !!((_columnDef_meta = columnDef.meta) === null || _columnDef_meta === void 0 ? void 0 : (_columnDef_meta_styles = _columnDef_meta.styles) === null || _columnDef_meta_styles === void 0 ? void 0 : (_columnDef_meta_styles_cell = _columnDef_meta_styles.cell) === null || _columnDef_meta_styles_cell === void 0 ? void 0 : _columnDef_meta_styles_cell.noPadding),
                                                        $textAlign: (_columnDef_meta1 = columnDef.meta) === null || _columnDef_meta1 === void 0 ? void 0 : (_columnDef_meta_styles1 = _columnDef_meta1.styles) === null || _columnDef_meta_styles1 === void 0 ? void 0 : (_columnDef_meta_styles_cell1 = _columnDef_meta_styles1.cell) === null || _columnDef_meta_styles_cell1 === void 0 ? void 0 : _columnDef_meta_styles_cell1.textAlign,
                                                        $hasDefinedColumnSize: !!((_columnDef_meta2 = columnDef.meta) === null || _columnDef_meta2 === void 0 ? void 0 : (_columnDef_meta_styles2 = _columnDef_meta2.styles) === null || _columnDef_meta_styles2 === void 0 ? void 0 : _columnDef_meta_styles2.definedColumnSize),
                                                        $width: cell.column.getSize(),
                                                        style: (0, _objectSpread._)({}, getCommonPinningStyles(cell.column)),
                                                        children: (0, _reactTable.flexRender)(columnDef.cell, cell.getContext())
                                                    }, cell.id);
                                                })
                                            }, row.id);
                                        }),
                                        loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.StyledBodyTr), {
                                            $isSelected: false,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableStyles.CenteredRow), {
                                                colSpan: columns.length,
                                                $isLoading: loading,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingSpinner.LoadingSpinner), {
                                                    size: "36px"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    Object.keys(rowSelection).length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionBar.ActionBar), {
                        table: table,
                        isFixed: isFixed,
                        TableActions: TableActions
                    })
                ]
            }),
            showPagination && hasPaginationProps ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pagination.Pagination), {
                currentPage: currentPage,
                totalPageCount: totalPageCount,
                totalRowCount: totalRowCount,
                paginationLimit: paginationLimit,
                totalRowsOnPage: totalRowsOnPage,
                nextPage: nextPage,
                previousPage: previousPage
            }) : null
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","@tanstack/react-table":"1A22E","./table.styles":"9UBFX","./components/ActionBar":"5NUdg","./components/Pagination":"iFW5N","./components/NoResults":"f4dRq","../status-indicators/LoadingSpinner/LoadingSpinner":"2ZVeg","lodash":"h75z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1A22E":[function(require,module,exports) {
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flexRender", function() {
    return flexRender;
});
parcelHelpers.export(exports, "useReactTable", function() {
    return useReactTable;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _tableCore = require("@tanstack/table-core");
parcelHelpers.exportAll(_tableCore, exports);
//
/**
 * If rendering headers, cells, or footers with custom markup, use flexRender instead of `cell.getValue()` or `cell.renderValue()`.
 */ function flexRender(Comp, props) {
    return !Comp ? null : isReactComponent(Comp) ? /*#__PURE__*/ _react.createElement(Comp, props) : Comp;
}
function isReactComponent(component) {
    return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent(component) {
    return typeof component === "function" && function() {
        var proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    }();
}
function isExoticComponent(component) {
    return typeof component === "object" && (0, _typeOf._)(component.$$typeof) === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function useReactTable(options) {
    // Compose in the generic options to the user options
    var resolvedOptions = (0, _objectSpread._)({
        state: {},
        // Dummy state
        onStateChange: function() {},
        // noop
        renderFallbackValue: null
    }, options);
    // Create a new table and store it in state
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return {
            current: (0, _tableCore.createTable)(resolvedOptions)
        };
    }), 1), tableRef = _React_useState[0];
    // By default, manage table state here using the table's initial state
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(function() {
        return tableRef.current.initialState;
    }), 2), state = _React_useState1[0], setState = _React_useState1[1];
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions(function(prev) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev, options), {
            state: (0, _objectSpread._)({}, state, options.state),
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: function(updater) {
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        });
    });
    return tableRef.current;
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_type_of":"6Gp9n","react":"ktQNc","@tanstack/table-core":"6Lizk","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Lizk":[function(require,module,exports) {
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */ // type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColumnFaceting", function() {
    return ColumnFaceting;
});
parcelHelpers.export(exports, "ColumnFiltering", function() {
    return ColumnFiltering;
});
parcelHelpers.export(exports, "ColumnGrouping", function() {
    return ColumnGrouping;
});
parcelHelpers.export(exports, "ColumnOrdering", function() {
    return ColumnOrdering;
});
parcelHelpers.export(exports, "ColumnPinning", function() {
    return ColumnPinning;
});
parcelHelpers.export(exports, "ColumnSizing", function() {
    return ColumnSizing;
});
parcelHelpers.export(exports, "ColumnVisibility", function() {
    return ColumnVisibility;
});
parcelHelpers.export(exports, "GlobalFaceting", function() {
    return GlobalFaceting;
});
parcelHelpers.export(exports, "GlobalFiltering", function() {
    return GlobalFiltering;
});
parcelHelpers.export(exports, "Headers", function() {
    return Headers;
});
parcelHelpers.export(exports, "RowExpanding", function() {
    return RowExpanding;
});
parcelHelpers.export(exports, "RowPagination", function() {
    return RowPagination;
});
parcelHelpers.export(exports, "RowPinning", function() {
    return RowPinning;
});
parcelHelpers.export(exports, "RowSelection", function() {
    return RowSelection;
});
parcelHelpers.export(exports, "RowSorting", function() {
    return RowSorting;
});
parcelHelpers.export(exports, "_getVisibleLeafColumns", function() {
    return _getVisibleLeafColumns;
});
parcelHelpers.export(exports, "aggregationFns", function() {
    return aggregationFns;
});
parcelHelpers.export(exports, "buildHeaderGroups", function() {
    return buildHeaderGroups;
});
parcelHelpers.export(exports, "createCell", function() {
    return createCell;
});
parcelHelpers.export(exports, "createColumn", function() {
    return createColumn;
});
parcelHelpers.export(exports, "createColumnHelper", function() {
    return createColumnHelper;
});
parcelHelpers.export(exports, "createRow", function() {
    return createRow;
});
parcelHelpers.export(exports, "createTable", function() {
    return createTable;
});
parcelHelpers.export(exports, "defaultColumnSizing", function() {
    return defaultColumnSizing;
});
parcelHelpers.export(exports, "expandRows", function() {
    return expandRows;
});
parcelHelpers.export(exports, "filterFns", function() {
    return filterFns;
});
parcelHelpers.export(exports, "flattenBy", function() {
    return flattenBy;
});
parcelHelpers.export(exports, "functionalUpdate", function() {
    return functionalUpdate;
});
parcelHelpers.export(exports, "getCoreRowModel", function() {
    return getCoreRowModel;
});
parcelHelpers.export(exports, "getExpandedRowModel", function() {
    return getExpandedRowModel;
});
parcelHelpers.export(exports, "getFacetedMinMaxValues", function() {
    return getFacetedMinMaxValues;
});
parcelHelpers.export(exports, "getFacetedRowModel", function() {
    return getFacetedRowModel;
});
parcelHelpers.export(exports, "getFacetedUniqueValues", function() {
    return getFacetedUniqueValues;
});
parcelHelpers.export(exports, "getFilteredRowModel", function() {
    return getFilteredRowModel;
});
parcelHelpers.export(exports, "getGroupedRowModel", function() {
    return getGroupedRowModel;
});
parcelHelpers.export(exports, "getMemoOptions", function() {
    return getMemoOptions;
});
parcelHelpers.export(exports, "getPaginationRowModel", function() {
    return getPaginationRowModel;
});
parcelHelpers.export(exports, "getSortedRowModel", function() {
    return getSortedRowModel;
});
parcelHelpers.export(exports, "isFunction", function() {
    return isFunction;
});
parcelHelpers.export(exports, "isNumberArray", function() {
    return isNumberArray;
});
parcelHelpers.export(exports, "isRowSelected", function() {
    return isRowSelected;
});
parcelHelpers.export(exports, "isSubRowSelected", function() {
    return isSubRowSelected;
});
parcelHelpers.export(exports, "makeStateUpdater", function() {
    return makeStateUpdater;
});
parcelHelpers.export(exports, "memo", function() {
    return memo;
});
parcelHelpers.export(exports, "noop", function() {
    return noop;
});
parcelHelpers.export(exports, "orderColumns", function() {
    return orderColumns;
});
parcelHelpers.export(exports, "passiveEventSupported", function() {
    return passiveEventSupported;
});
parcelHelpers.export(exports, "reSplitAlphaNumeric", function() {
    return reSplitAlphaNumeric;
});
parcelHelpers.export(exports, "selectRowsFn", function() {
    return selectRowsFn;
});
parcelHelpers.export(exports, "shouldAutoRemoveFilter", function() {
    return shouldAutoRemoveFilter;
});
parcelHelpers.export(exports, "sortingFns", function() {
    return sortingFns;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _toPropertyKey = require("@swc/helpers/_/_to_property_key");
function createColumnHelper() {
    return {
        accessor: function(accessor, column) {
            return typeof accessor === "function" ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, column), {
                accessorFn: accessor
            }) : (0, _objectSpreadProps._)((0, _objectSpread._)({}, column), {
                accessorKey: accessor
            });
        },
        display: function(column) {
            return column;
        },
        group: function(column) {
            return column;
        }
    };
}
// Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function noop() {
//
}
function makeStateUpdater(key, instance) {
    return function(updater) {
        instance.setState(function(old) {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), (0, _defineProperty._)({}, key, functionalUpdate(updater, old[key])));
        });
    };
}
function isFunction(d) {
    return d instanceof Function;
}
function isNumberArray(d) {
    return Array.isArray(d) && d.every(function(val) {
        return typeof val === "number";
    });
}
function flattenBy(arr, getChildren) {
    var flat = [];
    var recurse = function(subArr) {
        subArr.forEach(function(item) {
            flat.push(item);
            var children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function memo(getDeps, fn, opts) {
    var deps = [];
    var result;
    return function(depArgs) {
        var depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        var newDeps = getDeps(depArgs);
        var depsChanged = newDeps.length !== deps.length || newDeps.some(function(dep, index) {
            return deps[index] !== dep;
        });
        if (!depsChanged) return result;
        deps = newDeps;
        var resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn.apply(void 0, (0, _toConsumableArray._)(newDeps));
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                var resultFpsPercentage = resultEndTime / 16;
                var pad = function(str, num) {
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info("%c\u23F1 ".concat(pad(resultEndTime, 5), " /").concat(pad(depEndTime, 5), " ms"), "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(".concat(Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)), "deg 100% 31%);"), opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function getMemoOptions(tableOptions, debugLevel, key, onChange) {
    return {
        debug: function() {
            var _tableOptions$debugAl;
            return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
        },
        key: false,
        onChange: onChange
    };
}
function createCell(table, row, column, columnId) {
    var getRenderValue = function() {
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    var cell = {
        id: "".concat(row.id, "_").concat(column.id),
        row: row,
        column: column,
        getValue: function() {
            return row.getValue(columnId);
        },
        renderValue: getRenderValue,
        getContext: memo(function() {
            return [
                table,
                column,
                row,
                cell
            ];
        }, function(table, column, row, cell) {
            return {
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            };
        }, getMemoOptions(table.options, "debugCells", "cell.getContext"))
    };
    table._features.forEach(function(feature) {
        feature.createCell == null || feature.createCell(cell, column, row, table);
    }, {});
    return cell;
}
function createColumn(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    var defaultColumn = table._getDefaultColumnDef();
    var resolvedColumnDef = (0, _objectSpread._)({}, defaultColumn, columnDef);
    var accessorKey = resolvedColumnDef.accessorKey;
    var id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? typeof String.prototype.replaceAll === "function" ? accessorKey.replaceAll(".", "_") : accessorKey.replace(/\./g, "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    var accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = function(originalRow) {
            var result = originalRow;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = accessorKey.split(".")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var _result;
                    result = (_result = result) == null ? void 0 : _result[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return result;
        };
        else accessorFn = function(originalRow) {
            return originalRow[resolvedColumnDef.accessorKey];
        };
    }
    if (!id) throw new Error();
    var column = {
        id: "".concat(String(id)),
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: memo(function() {
            return [
                true
            ];
        }, function() {
            var _column$columns;
            return [
                column
            ].concat((0, _toConsumableArray._)((_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap(function(d) {
                return d.getFlatColumns();
            })));
        }, getMemoOptions(table.options, "debugColumns", "column.getFlatColumns")),
        getLeafColumns: memo(function() {
            return [
                table._getOrderColumnsFn()
            ];
        }, function(orderColumns) {
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                var leafColumns = column.columns.flatMap(function(column) {
                    return column.getLeafColumns();
                });
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, getMemoOptions(table.options, "debugColumns", "column.getLeafColumns"))
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = table._features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var feature = _step.value;
            feature.createColumn == null || feature.createColumn(column, table);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Yes, we have to convert table to unknown, because we know more than the compiler here.
    return column;
}
var debug = "debugHeaders";
//
function createHeader(table, column, options) {
    var _options$id;
    var id = (_options$id = options.id) != null ? _options$id : column.id;
    var header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: function() {
            var leafHeaders = [];
            var recurseHeader = function(h) {
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: function() {
            return {
                table: table,
                header: header,
                column: column
            };
        }
    };
    table._features.forEach(function(feature) {
        feature.createHeader == null || feature.createHeader(header, table);
    });
    return header;
}
var Headers = {
    createTable: function(table) {
        // Header Groups
        table.getHeaderGroups = memo(function() {
            return [
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ];
        }, function(allColumns, leafColumns, left, right) {
            var _left$map$filter, _right$map$filter;
            var leftColumns = (_left$map$filter = left == null ? void 0 : left.map(function(columnId) {
                return leafColumns.find(function(d) {
                    return d.id === columnId;
                });
            }).filter(Boolean)) != null ? _left$map$filter : [];
            var rightColumns = (_right$map$filter = right == null ? void 0 : right.map(function(columnId) {
                return leafColumns.find(function(d) {
                    return d.id === columnId;
                });
            }).filter(Boolean)) != null ? _right$map$filter : [];
            var centerColumns = leafColumns.filter(function(column) {
                return !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id));
            });
            var headerGroups = buildHeaderGroups(allColumns, (0, _toConsumableArray._)(leftColumns).concat((0, _toConsumableArray._)(centerColumns), (0, _toConsumableArray._)(rightColumns)), table);
            return headerGroups;
        }, getMemoOptions(table.options, debug, "getHeaderGroups"));
        table.getCenterHeaderGroups = memo(function() {
            return [
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ];
        }, function(allColumns, leafColumns, left, right) {
            leafColumns = leafColumns.filter(function(column) {
                return !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id));
            });
            return buildHeaderGroups(allColumns, leafColumns, table, "center");
        }, getMemoOptions(table.options, debug, "getCenterHeaderGroups"));
        table.getLeftHeaderGroups = memo(function() {
            return [
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.left
            ];
        }, function(allColumns, leafColumns, left) {
            var _left$map$filter2;
            var orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map(function(columnId) {
                return leafColumns.find(function(d) {
                    return d.id === columnId;
                });
            }).filter(Boolean)) != null ? _left$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, "left");
        }, getMemoOptions(table.options, debug, "getLeftHeaderGroups"));
        table.getRightHeaderGroups = memo(function() {
            return [
                table.getAllColumns(),
                table.getVisibleLeafColumns(),
                table.getState().columnPinning.right
            ];
        }, function(allColumns, leafColumns, right) {
            var _right$map$filter2;
            var orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map(function(columnId) {
                return leafColumns.find(function(d) {
                    return d.id === columnId;
                });
            }).filter(Boolean)) != null ? _right$map$filter2 : [];
            return buildHeaderGroups(allColumns, orderedLeafColumns, table, "right");
        }, getMemoOptions(table.options, debug, "getRightHeaderGroups"));
        // Footer Groups
        table.getFooterGroups = memo(function() {
            return [
                table.getHeaderGroups()
            ];
        }, function(headerGroups) {
            return (0, _toConsumableArray._)(headerGroups).reverse();
        }, getMemoOptions(table.options, debug, "getFooterGroups"));
        table.getLeftFooterGroups = memo(function() {
            return [
                table.getLeftHeaderGroups()
            ];
        }, function(headerGroups) {
            return (0, _toConsumableArray._)(headerGroups).reverse();
        }, getMemoOptions(table.options, debug, "getLeftFooterGroups"));
        table.getCenterFooterGroups = memo(function() {
            return [
                table.getCenterHeaderGroups()
            ];
        }, function(headerGroups) {
            return (0, _toConsumableArray._)(headerGroups).reverse();
        }, getMemoOptions(table.options, debug, "getCenterFooterGroups"));
        table.getRightFooterGroups = memo(function() {
            return [
                table.getRightHeaderGroups()
            ];
        }, function(headerGroups) {
            return (0, _toConsumableArray._)(headerGroups).reverse();
        }, getMemoOptions(table.options, debug, "getRightFooterGroups"));
        // Flat Headers
        table.getFlatHeaders = memo(function() {
            return [
                table.getHeaderGroups()
            ];
        }, function(headerGroups) {
            return headerGroups.map(function(headerGroup) {
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, "getFlatHeaders"));
        table.getLeftFlatHeaders = memo(function() {
            return [
                table.getLeftHeaderGroups()
            ];
        }, function(left) {
            return left.map(function(headerGroup) {
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, "getLeftFlatHeaders"));
        table.getCenterFlatHeaders = memo(function() {
            return [
                table.getCenterHeaderGroups()
            ];
        }, function(left) {
            return left.map(function(headerGroup) {
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, "getCenterFlatHeaders"));
        table.getRightFlatHeaders = memo(function() {
            return [
                table.getRightHeaderGroups()
            ];
        }, function(left) {
            return left.map(function(headerGroup) {
                return headerGroup.headers;
            }).flat();
        }, getMemoOptions(table.options, debug, "getRightFlatHeaders"));
        // Leaf Headers
        table.getCenterLeafHeaders = memo(function() {
            return [
                table.getCenterFlatHeaders()
            ];
        }, function(flatHeaders) {
            return flatHeaders.filter(function(header) {
                var _header$subHeaders;
                return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
            });
        }, getMemoOptions(table.options, debug, "getCenterLeafHeaders"));
        table.getLeftLeafHeaders = memo(function() {
            return [
                table.getLeftFlatHeaders()
            ];
        }, function(flatHeaders) {
            return flatHeaders.filter(function(header) {
                var _header$subHeaders2;
                return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
            });
        }, getMemoOptions(table.options, debug, "getLeftLeafHeaders"));
        table.getRightLeafHeaders = memo(function() {
            return [
                table.getRightFlatHeaders()
            ];
        }, function(flatHeaders) {
            return flatHeaders.filter(function(header) {
                var _header$subHeaders3;
                return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
            });
        }, getMemoOptions(table.options, debug, "getRightLeafHeaders"));
        table.getLeafHeaders = memo(function() {
            return [
                table.getLeftHeaderGroups(),
                table.getCenterHeaderGroups(),
                table.getRightHeaderGroups()
            ];
        }, function(left, center, right) {
            var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
            return (0, _toConsumableArray._)((_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : []).concat((0, _toConsumableArray._)((_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : []), (0, _toConsumableArray._)((_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : [])).map(function(header) {
                return header.getLeafHeaders();
            }).flat();
        }, getMemoOptions(table.options, debug, "getLeafHeaders"));
    }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    var maxDepth = 0;
    var findMaxDepth = function findMaxDepth1(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter(function(column) {
            return column.getIsVisible();
        }).forEach(function(column) {
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    var headerGroups = [];
    var createHeaderGroup = function(headersToGroup, depth) {
        // The header group we are creating
        var headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                "".concat(depth)
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        var pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach(function(headerToGroup) {
            // What is the latest (last) parent column?
            var latestPendingParentHeader = (0, _toConsumableArray._)(pendingParentHeaders).reverse()[0];
            var isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            var column;
            var isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                var header = createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? "".concat(pendingParentHeaders.filter(function(d) {
                        return d.column === column;
                    }).length) : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    var bottomHeaders = columnsToGroup.map(function(column, index) {
        return createHeader(table, column, {
            depth: maxDepth,
            index: index
        });
    });
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    var recurseHeadersForSpans = function(headers) {
        var filteredHeaders = headers.filter(function(header) {
            return header.column.getIsVisible();
        });
        return filteredHeaders.map(function(header) {
            var _Math;
            var colSpan = 0;
            var rowSpan = 0;
            var childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach(function(_ref) {
                    var childColSpan = _ref.colSpan, childRowSpan = _ref.rowSpan;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            var minChildRowSpan = (_Math = Math).min.apply(_Math, (0, _toConsumableArray._)(childRowSpans));
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
var createRow = function(table, id, original, rowIndex, depth, subRows, parentId) {
    var row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: function(columnId) {
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            var column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: function(columnId) {
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            var column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: function(columnId) {
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: function() {
            return flattenBy(row.subRows, function(d) {
                return d.subRows;
            });
        },
        getParentRow: function() {
            return row.parentId ? table.getRow(row.parentId, true) : undefined;
        },
        getParentRows: function() {
            var parentRows = [];
            var currentRow = row;
            while(true){
                var parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: memo(function() {
            return [
                table.getAllLeafColumns()
            ];
        }, function(leafColumns) {
            return leafColumns.map(function(column) {
                return createCell(table, row, column, column.id);
            });
        }, getMemoOptions(table.options, "debugRows", "getAllCells")),
        _getAllCellsByColumnId: memo(function() {
            return [
                row.getAllCells()
            ];
        }, function(allCells) {
            return allCells.reduce(function(acc, cell) {
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, getMemoOptions(table.options, "debugRows", "getAllCellsByColumnId"))
    };
    for(var i = 0; i < table._features.length; i++){
        var feature = table._features[i];
        feature == null || feature.createRow == null || feature.createRow(row, table);
    }
    return row;
};
//
var ColumnFaceting = {
    createColumn: function(column, table) {
        column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
        column.getFacetedRowModel = function() {
            if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
            return column._getFacetedRowModel();
        };
        column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
        column.getFacetedUniqueValues = function() {
            if (!column._getFacetedUniqueValues) return new Map();
            return column._getFacetedUniqueValues();
        };
        column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
        column.getFacetedMinMaxValues = function() {
            if (!column._getFacetedMinMaxValues) return undefined;
            return column._getFacetedMinMaxValues();
        };
    }
};
var includesString = function(row, columnId, filterValue) {
    var _filterValue$toString, _row$getValue;
    var search = filterValue == null || (_filterValue$toString = filterValue.toString()) == null ? void 0 : _filterValue$toString.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
includesString.autoRemove = function(val) {
    return testFalsey(val);
};
var includesStringSensitive = function(row, columnId, filterValue) {
    var _row$getValue2;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = function(val) {
    return testFalsey(val);
};
var equalsString = function(row, columnId, filterValue) {
    var _row$getValue3;
    return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
equalsString.autoRemove = function(val) {
    return testFalsey(val);
};
var arrIncludes = function(row, columnId, filterValue) {
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = function(val) {
    return testFalsey(val) || !(val != null && val.length);
};
var arrIncludesAll = function(row, columnId, filterValue) {
    return !filterValue.some(function(val) {
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
arrIncludesAll.autoRemove = function(val) {
    return testFalsey(val) || !(val != null && val.length);
};
var arrIncludesSome = function(row, columnId, filterValue) {
    return filterValue.some(function(val) {
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
arrIncludesSome.autoRemove = function(val) {
    return testFalsey(val) || !(val != null && val.length);
};
var equals = function(row, columnId, filterValue) {
    return row.getValue(columnId) === filterValue;
};
equals.autoRemove = function(val) {
    return testFalsey(val);
};
var weakEquals = function(row, columnId, filterValue) {
    return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = function(val) {
    return testFalsey(val);
};
var inNumberRange = function(row, columnId, filterValue) {
    var _filterValue = (0, _slicedToArray._)(filterValue, 2), min = _filterValue[0], max = _filterValue[1];
    var rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
inNumberRange.resolveFilterValue = function(val) {
    var _val = (0, _slicedToArray._)(val, 2), unsafeMin = _val[0], unsafeMax = _val[1];
    var parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    var parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    var min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    var max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        var temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
inNumberRange.autoRemove = function(val) {
    return testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
};
// Export
var filterFns = {
    includesString: includesString,
    includesStringSensitive: includesStringSensitive,
    equalsString: equalsString,
    arrIncludes: arrIncludes,
    arrIncludesAll: arrIncludesAll,
    arrIncludesSome: arrIncludesSome,
    equals: equals,
    weakEquals: weakEquals,
    inNumberRange: inNumberRange
};
// Utils
function testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
var ColumnFiltering = {
    getDefaultColumnDef: function() {
        return {
            filterFn: "auto"
        };
    },
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            columnFilters: []
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onColumnFiltersChange: makeStateUpdater("columnFilters", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100
        };
    },
    createColumn: function(column, table) {
        column.getAutoFilterFn = function() {
            var firstRow = table.getCoreRowModel().flatRows[0];
            var value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return filterFns.includesString;
            if (typeof value === "number") return filterFns.inNumberRange;
            if (typeof value === "boolean") return filterFns.equals;
            if (value !== null && typeof value === "object") return filterFns.equals;
            if (Array.isArray(value)) return filterFns.arrIncludes;
            return filterFns.weakEquals;
        };
        column.getFilterFn = function() {
            var _table$options$filter, _table$options$filter2;
            return isFunction(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn];
        };
        column.getCanFilter = function() {
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
            return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
        };
        column.getIsFiltered = function() {
            return column.getFilterIndex() > -1;
        };
        column.getFilterValue = function() {
            var _table$getState$colum;
            return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find(function(d) {
                return d.id === column.id;
            })) == null ? void 0 : _table$getState$colum.value;
        };
        column.getFilterIndex = function() {
            var _table$getState$colum2, _table$getState$colum3;
            return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex(function(d) {
                return d.id === column.id;
            })) != null ? _table$getState$colum2 : -1;
        };
        column.setFilterValue = function(value) {
            table.setColumnFilters(function(old) {
                var filterFn = column.getFilterFn();
                var previousFilter = old == null ? void 0 : old.find(function(d) {
                    return d.id === column.id;
                });
                var newFilter = functionalUpdate(value, previousFilter ? previousFilter.value : undefined);
                //
                if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
                    var _old$filter;
                    return (_old$filter = old == null ? void 0 : old.filter(function(d) {
                        return d.id !== column.id;
                    })) != null ? _old$filter : [];
                }
                var newFilterObj = {
                    id: column.id,
                    value: newFilter
                };
                if (previousFilter) {
                    var _old$map;
                    return (_old$map = old == null ? void 0 : old.map(function(d) {
                        if (d.id === column.id) return newFilterObj;
                        return d;
                    })) != null ? _old$map : [];
                }
                if (old != null && old.length) return (0, _toConsumableArray._)(old).concat([
                    newFilterObj
                ]);
                return [
                    newFilterObj
                ];
            });
        };
    },
    createRow: function(row, _table) {
        row.columnFilters = {};
        row.columnFiltersMeta = {};
    },
    createTable: function(table) {
        table.setColumnFilters = function(updater) {
            var leafColumns = table.getAllLeafColumns();
            var updateFn = function(old) {
                var _functionalUpdate;
                return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter(function(filter) {
                    var column = leafColumns.find(function(d) {
                        return d.id === filter.id;
                    });
                    if (column) {
                        var filterFn = column.getFilterFn();
                        if (shouldAutoRemoveFilter(filterFn, filter.value, column)) return false;
                    }
                    return true;
                });
            };
            table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
        };
        table.resetColumnFilters = function(defaultState) {
            var _table$initialState$c, _table$initialState;
            table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
        };
        table.getPreFilteredRowModel = function() {
            return table.getCoreRowModel();
        };
        table.getFilteredRowModel = function() {
            if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
            if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
            return table._getFilteredRowModel();
        };
    }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
var sum = function(columnId, _leafRows, childRows) {
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce(function(sum, next) {
        var nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
var min = function(columnId, _leafRows, childRows) {
    var min;
    childRows.forEach(function(row) {
        var value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
var max = function(columnId, _leafRows, childRows) {
    var max;
    childRows.forEach(function(row) {
        var value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
var extent = function(columnId, _leafRows, childRows) {
    var min;
    var max;
    childRows.forEach(function(row) {
        var value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
var mean = function(columnId, leafRows) {
    var count = 0;
    var sum = 0;
    leafRows.forEach(function(row) {
        var value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
var median = function(columnId, leafRows) {
    if (!leafRows.length) return;
    var values = leafRows.map(function(row) {
        return row.getValue(columnId);
    });
    if (!isNumberArray(values)) return;
    if (values.length === 1) return values[0];
    var mid = Math.floor(values.length / 2);
    var nums = values.sort(function(a, b) {
        return a - b;
    });
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
var unique = function(columnId, leafRows) {
    return Array.from(new Set(leafRows.map(function(d) {
        return d.getValue(columnId);
    })).values());
};
var uniqueCount = function(columnId, leafRows) {
    return new Set(leafRows.map(function(d) {
        return d.getValue(columnId);
    })).size;
};
var count = function(_columnId, leafRows) {
    return leafRows.length;
};
var aggregationFns = {
    sum: sum,
    min: min,
    max: max,
    extent: extent,
    mean: mean,
    median: median,
    unique: unique,
    uniqueCount: uniqueCount,
    count: count
};
//
var ColumnGrouping = {
    getDefaultColumnDef: function() {
        return {
            aggregatedCell: function(props) {
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            grouping: []
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onGroupingChange: makeStateUpdater("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: function(column, table) {
        column.toggleGrouping = function() {
            table.setGrouping(function(old) {
                // Find any existing grouping for this column
                if (old != null && old.includes(column.id)) return old.filter(function(d) {
                    return d !== column.id;
                });
                return (0, _toConsumableArray._)(old != null ? old : []).concat([
                    column.id
                ]);
            });
        };
        column.getCanGroup = function() {
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
        };
        column.getIsGrouped = function() {
            var _table$getState$group;
            return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
        };
        column.getGroupedIndex = function() {
            var _table$getState$group2;
            return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
        };
        column.getToggleGroupingHandler = function() {
            var canGroup = column.getCanGroup();
            return function() {
                if (!canGroup) return;
                column.toggleGrouping();
            };
        };
        column.getAutoAggregationFn = function() {
            var firstRow = table.getCoreRowModel().flatRows[0];
            var value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "number") return aggregationFns.sum;
            if (Object.prototype.toString.call(value) === "[object Date]") return aggregationFns.extent;
        };
        column.getAggregationFn = function() {
            var _table$options$aggreg, _table$options$aggreg2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
        };
    },
    createTable: function(table) {
        table.setGrouping = function(updater) {
            return table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
        };
        table.resetGrouping = function(defaultState) {
            var _table$initialState$g, _table$initialState;
            table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
        };
        table.getPreGroupedRowModel = function() {
            return table.getFilteredRowModel();
        };
        table.getGroupedRowModel = function() {
            if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
            if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
            return table._getGroupedRowModel();
        };
    },
    createRow: function(row, table) {
        row.getIsGrouped = function() {
            return !!row.groupingColumnId;
        };
        row.getGroupingValue = function(columnId) {
            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
            var column = table.getColumn(columnId);
            if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
            row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
            return row._groupingValuesCache[columnId];
        };
        row._groupingValuesCache = {};
    },
    createCell: function(cell, column, row, table) {
        cell.getIsGrouped = function() {
            return column.getIsGrouped() && column.id === row.groupingColumnId;
        };
        cell.getIsPlaceholder = function() {
            return !cell.getIsGrouped() && column.getIsGrouped();
        };
        cell.getIsAggregated = function() {
            var _row$subRows;
            return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
        };
    }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    var nonGroupingColumns = leafColumns.filter(function(col) {
        return !grouping.includes(col.id);
    });
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    var groupingColumns = grouping.map(function(g) {
        return leafColumns.find(function(col) {
            return col.id === g;
        });
    }).filter(Boolean);
    return (0, _toConsumableArray._)(groupingColumns).concat((0, _toConsumableArray._)(nonGroupingColumns));
}
//
var ColumnOrdering = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            columnOrder: []
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onColumnOrderChange: makeStateUpdater("columnOrder", table)
        };
    },
    createColumn: function(column, table) {
        column.getIndex = memo(function(position) {
            return [
                _getVisibleLeafColumns(table, position)
            ];
        }, function(columns) {
            return columns.findIndex(function(d) {
                return d.id === column.id;
            });
        }, getMemoOptions(table.options, "debugColumns", "getIndex"));
        column.getIsFirstColumn = function(position) {
            var _columns$;
            var columns = _getVisibleLeafColumns(table, position);
            return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
        };
        column.getIsLastColumn = function(position) {
            var _columns;
            var columns = _getVisibleLeafColumns(table, position);
            return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
        };
    },
    createTable: function(table) {
        table.setColumnOrder = function(updater) {
            return table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
        };
        table.resetColumnOrder = function(defaultState) {
            var _table$initialState$c;
            table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
        };
        table._getOrderColumnsFn = memo(function() {
            return [
                table.getState().columnOrder,
                table.getState().grouping,
                table.options.groupedColumnMode
            ];
        }, function(columnOrder, grouping, groupedColumnMode) {
            return function(columns) {
                // Sort grouped columns to the start of the column list
                // before the headers are built
                var orderedColumns = [];
                // If there is no order, return the normal columns
                if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                else {
                    var _loop = function() {
                        var targetColumnId = columnOrderCopy.shift();
                        var foundIndex = columnsCopy.findIndex(function(d) {
                            return d.id === targetColumnId;
                        });
                        if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                    };
                    var columnOrderCopy = (0, _toConsumableArray._)(columnOrder);
                    // If there is an order, make a copy of the columns
                    var columnsCopy = (0, _toConsumableArray._)(columns);
                    // And make a new ordered array of the columns
                    // Loop over the columns and place them in order into the new array
                    while(columnsCopy.length && columnOrderCopy.length)_loop();
                    // If there are any columns left, add them to the end
                    orderedColumns = (0, _toConsumableArray._)(orderedColumns).concat((0, _toConsumableArray._)(columnsCopy));
                }
                return orderColumns(orderedColumns, grouping, groupedColumnMode);
            };
        }, getMemoOptions(table.options, "debugTable", "_getOrderColumnsFn"));
    }
};
//
var getDefaultColumnPinningState = function() {
    return {
        left: [],
        right: []
    };
};
var ColumnPinning = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            columnPinning: getDefaultColumnPinningState()
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onColumnPinningChange: makeStateUpdater("columnPinning", table)
        };
    },
    createColumn: function(column, table) {
        column.pin = function(position) {
            var columnIds = column.getLeafColumns().map(function(d) {
                return d.id;
            }).filter(Boolean);
            table.setColumnPinning(function(old) {
                var _old$left3, _old$right3;
                if (position === "right") {
                    var _old$left, _old$right;
                    return {
                        left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter(function(d) {
                            return !(columnIds != null && columnIds.includes(d));
                        }),
                        right: (0, _toConsumableArray._)(((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter(function(d) {
                            return !(columnIds != null && columnIds.includes(d));
                        })).concat((0, _toConsumableArray._)(columnIds))
                    };
                }
                if (position === "left") {
                    var _old$left2, _old$right2;
                    return {
                        left: (0, _toConsumableArray._)(((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter(function(d) {
                            return !(columnIds != null && columnIds.includes(d));
                        })).concat((0, _toConsumableArray._)(columnIds)),
                        right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter(function(d) {
                            return !(columnIds != null && columnIds.includes(d));
                        })
                    };
                }
                return {
                    left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter(function(d) {
                        return !(columnIds != null && columnIds.includes(d));
                    }),
                    right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter(function(d) {
                        return !(columnIds != null && columnIds.includes(d));
                    })
                };
            });
        };
        column.getCanPin = function() {
            var leafColumns = column.getLeafColumns();
            return leafColumns.some(function(d) {
                var _d$columnDef$enablePi, _ref, _table$options$enable;
                return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
            });
        };
        column.getIsPinned = function() {
            var leafColumnIds = column.getLeafColumns().map(function(d) {
                return d.id;
            });
            var _table_getState_columnPinning = table.getState().columnPinning, left = _table_getState_columnPinning.left, right = _table_getState_columnPinning.right;
            var isLeft = leafColumnIds.some(function(d) {
                return left == null ? void 0 : left.includes(d);
            });
            var isRight = leafColumnIds.some(function(d) {
                return right == null ? void 0 : right.includes(d);
            });
            return isLeft ? "left" : isRight ? "right" : false;
        };
        column.getPinnedIndex = function() {
            var _table$getState$colum, _table$getState$colum2;
            var position = column.getIsPinned();
            return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
        };
    },
    createRow: function(row, table) {
        row.getCenterVisibleCells = memo(function() {
            return [
                row._getAllVisibleCells(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ];
        }, function(allCells, left, right) {
            var leftAndRight = (0, _toConsumableArray._)(left != null ? left : []).concat((0, _toConsumableArray._)(right != null ? right : []));
            return allCells.filter(function(d) {
                return !leftAndRight.includes(d.column.id);
            });
        }, getMemoOptions(table.options, "debugRows", "getCenterVisibleCells"));
        row.getLeftVisibleCells = memo(function() {
            return [
                row._getAllVisibleCells(),
                table.getState().columnPinning.left
            ];
        }, function(allCells, left) {
            var cells = (left != null ? left : []).map(function(columnId) {
                return allCells.find(function(cell) {
                    return cell.column.id === columnId;
                });
            }).filter(Boolean).map(function(d) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, d), {
                    position: "left"
                });
            });
            return cells;
        }, getMemoOptions(table.options, "debugRows", "getLeftVisibleCells"));
        row.getRightVisibleCells = memo(function() {
            return [
                row._getAllVisibleCells(),
                table.getState().columnPinning.right
            ];
        }, function(allCells, right) {
            var cells = (right != null ? right : []).map(function(columnId) {
                return allCells.find(function(cell) {
                    return cell.column.id === columnId;
                });
            }).filter(Boolean).map(function(d) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, d), {
                    position: "right"
                });
            });
            return cells;
        }, getMemoOptions(table.options, "debugRows", "getRightVisibleCells"));
    },
    createTable: function(table) {
        table.setColumnPinning = function(updater) {
            return table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
        };
        table.resetColumnPinning = function(defaultState) {
            var _table$initialState$c, _table$initialState;
            return table.setColumnPinning(defaultState ? getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultColumnPinningState());
        };
        table.getIsSomeColumnsPinned = function(position) {
            var _pinningState$positio;
            var pinningState = table.getState().columnPinning;
            if (!position) {
                var _pinningState$left, _pinningState$right;
                return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table.getLeftLeafColumns = memo(function() {
            return [
                table.getAllLeafColumns(),
                table.getState().columnPinning.left
            ];
        }, function(allColumns, left) {
            return (left != null ? left : []).map(function(columnId) {
                return allColumns.find(function(column) {
                    return column.id === columnId;
                });
            }).filter(Boolean);
        }, getMemoOptions(table.options, "debugColumns", "getLeftLeafColumns"));
        table.getRightLeafColumns = memo(function() {
            return [
                table.getAllLeafColumns(),
                table.getState().columnPinning.right
            ];
        }, function(allColumns, right) {
            return (right != null ? right : []).map(function(columnId) {
                return allColumns.find(function(column) {
                    return column.id === columnId;
                });
            }).filter(Boolean);
        }, getMemoOptions(table.options, "debugColumns", "getRightLeafColumns"));
        table.getCenterLeafColumns = memo(function() {
            return [
                table.getAllLeafColumns(),
                table.getState().columnPinning.left,
                table.getState().columnPinning.right
            ];
        }, function(allColumns, left, right) {
            var leftAndRight = (0, _toConsumableArray._)(left != null ? left : []).concat((0, _toConsumableArray._)(right != null ? right : []));
            return allColumns.filter(function(d) {
                return !leftAndRight.includes(d.id);
            });
        }, getMemoOptions(table.options, "debugColumns", "getCenterLeafColumns"));
    }
};
//
//
var defaultColumnSizing = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
var getDefaultColumnSizingInfoState = function() {
    return {
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    };
};
var _obj;
var ColumnSizing = (_obj = {
    getDefaultColumnDef: function() {
        return defaultColumnSizing;
    },
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            columnSizing: {},
            columnSizingInfo: getDefaultColumnSizingInfoState()
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            columnResizeMode: "onEnd",
            columnResizeDirection: "ltr",
            onColumnSizingChange: makeStateUpdater("columnSizing", table),
            onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", table)
        };
    }
}, (0, _defineProperty._)(_obj, "createColumn", function(column, table) {
    column.getSize = function() {
        var _column$columnDef$min, _ref, _column$columnDef$max;
        var columnSize = table.getState().columnSizing[column.id];
        return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
    };
    column.getStart = memo(function(position) {
        return [
            position,
            _getVisibleLeafColumns(table, position),
            table.getState().columnSizing
        ];
    }, function(position, columns) {
        return columns.slice(0, column.getIndex(position)).reduce(function(sum, column) {
            return sum + column.getSize();
        }, 0);
    }, getMemoOptions(table.options, "debugColumns", "getStart"));
    column.getAfter = memo(function(position) {
        return [
            position,
            _getVisibleLeafColumns(table, position),
            table.getState().columnSizing
        ];
    }, function(position, columns) {
        return columns.slice(column.getIndex(position) + 1).reduce(function(sum, column) {
            return sum + column.getSize();
        }, 0);
    }, getMemoOptions(table.options, "debugColumns", "getAfter"));
    var _tmp;
    _tmp = function() {
        table.setColumnSizing(function(_ref2) {
            var _column_id = column.id, _ = _ref2[_column_id], rest = (0, _objectWithoutProperties._)(_ref2, [
                _column_id
            ].map((0, _toPropertyKey._)));
            return rest;
        });
    }, column.resetSize = _tmp, _tmp;
    column.getCanResize = function() {
        var _column$columnDef$ena, _table$options$enable;
        return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
    };
    column.getIsResizing = function() {
        return table.getState().columnSizingInfo.isResizingColumn === column.id;
    };
}), (0, _defineProperty._)(_obj, "createHeader", function(header, table) {
    header.getSize = function() {
        var sum = 0;
        var recurse = function(header) {
            if (header.subHeaders.length) header.subHeaders.forEach(recurse);
            else {
                var _header$column$getSiz;
                sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
            }
        };
        recurse(header);
        return sum;
    };
    header.getStart = function() {
        if (header.index > 0) {
            var prevSiblingHeader = header.headerGroup.headers[header.index - 1];
            return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
        }
        return 0;
    };
    header.getResizeHandler = function(_contextDocument) {
        var column = table.getColumn(header.column.id);
        var canResize = column == null ? void 0 : column.getCanResize();
        return function(e) {
            if (!column || !canResize) return;
            e.persist == null || e.persist();
            if (isTouchStartEvent(e)) {
                // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                if (e.touches && e.touches.length > 1) return;
            }
            var startSize = header.getSize();
            var columnSizingStart = header ? header.getLeafHeaders().map(function(d) {
                return [
                    d.column.id,
                    d.column.getSize()
                ];
            }) : [
                [
                    column.id,
                    column.getSize()
                ]
            ];
            var clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
            var newColumnSizing = {};
            var updateOffset = function(eventType, clientXPos) {
                if (typeof clientXPos !== "number") return;
                table.setColumnSizingInfo(function(old) {
                    var _old$startOffset, _old$startSize;
                    var deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
                    var deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
                    var deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                    old.columnSizingStart.forEach(function(_ref3) {
                        var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), columnId = _$_ref3[0], headerSize = _$_ref3[1];
                        newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                    });
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                        deltaOffset: deltaOffset,
                        deltaPercentage: deltaPercentage
                    });
                });
                if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing(function(old) {
                    return (0, _objectSpread._)({}, old, newColumnSizing);
                });
            };
            var onMove = function(clientXPos) {
                return updateOffset("move", clientXPos);
            };
            var onEnd = function(clientXPos) {
                updateOffset("end", clientXPos);
                table.setColumnSizingInfo(function(old) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                        isResizingColumn: false,
                        startOffset: null,
                        startSize: null,
                        deltaOffset: null,
                        deltaPercentage: null,
                        columnSizingStart: []
                    });
                });
            };
            var contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
            var mouseEvents = {
                moveHandler: function(e) {
                    return onMove(e.clientX);
                },
                upHandler: function(e) {
                    contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
                    contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
                    onEnd(e.clientX);
                }
            };
            var touchEvents = {
                moveHandler: function(e) {
                    if (e.cancelable) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    onMove(e.touches[0].clientX);
                    return false;
                },
                upHandler: function(e) {
                    var _e$touches$;
                    contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
                    contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
                    if (e.cancelable) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                }
            };
            var passiveIfSupported = passiveEventSupported() ? {
                passive: false
            } : false;
            if (isTouchStartEvent(e)) {
                contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
            } else {
                contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
            }
            table.setColumnSizingInfo(function(old) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                    startOffset: clientX,
                    startSize: startSize,
                    deltaOffset: 0,
                    deltaPercentage: 0,
                    columnSizingStart: columnSizingStart,
                    isResizingColumn: column.id
                });
            });
        };
    };
}), (0, _defineProperty._)(_obj, "createTable", function(table) {
    table.setColumnSizing = function(updater) {
        return table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
    };
    table.setColumnSizingInfo = function(updater) {
        return table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
    };
    table.resetColumnSizing = function(defaultState) {
        var _table$initialState$c;
        table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
    };
    table.resetHeaderSizeInfo = function(defaultState) {
        var _table$initialState$c2;
        table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
    };
    table.getTotalSize = function() {
        var _table$getHeaderGroup, _table$getHeaderGroup2;
        return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce(function(sum, header) {
            return sum + header.getSize();
        }, 0)) != null ? _table$getHeaderGroup : 0;
    };
    table.getLeftTotalSize = function() {
        var _table$getLeftHeaderG, _table$getLeftHeaderG2;
        return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce(function(sum, header) {
            return sum + header.getSize();
        }, 0)) != null ? _table$getLeftHeaderG : 0;
    };
    table.getCenterTotalSize = function() {
        var _table$getCenterHeade, _table$getCenterHeade2;
        return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce(function(sum, header) {
            return sum + header.getSize();
        }, 0)) != null ? _table$getCenterHeade : 0;
    };
    table.getRightTotalSize = function() {
        var _table$getRightHeader, _table$getRightHeader2;
        return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce(function(sum, header) {
            return sum + header.getSize();
        }, 0)) != null ? _table$getRightHeader : 0;
    };
}), _obj);
var passiveSupported = null;
function passiveEventSupported() {
    if (typeof passiveSupported === "boolean") return passiveSupported;
    var supported = false;
    try {
        var options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        var noop = function() {};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    passiveSupported = supported;
    return passiveSupported;
}
function isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
var ColumnVisibility = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            columnVisibility: {}
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onColumnVisibilityChange: makeStateUpdater("columnVisibility", table)
        };
    },
    createColumn: function(column, table) {
        column.toggleVisibility = function(value) {
            if (column.getCanHide()) table.setColumnVisibility(function(old) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), (0, _defineProperty._)({}, column.id, value != null ? value : !column.getIsVisible()));
            });
        };
        column.getIsVisible = function() {
            var _ref, _table$getState$colum;
            var childColumns = column.columns;
            return (_ref = childColumns.length ? childColumns.some(function(c) {
                return c.getIsVisible();
            }) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
        };
        column.getCanHide = function() {
            var _column$columnDef$ena, _table$options$enable;
            return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
        };
        column.getToggleVisibilityHandler = function() {
            return function(e) {
                column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
            };
        };
    },
    createRow: function(row, table) {
        row._getAllVisibleCells = memo(function() {
            return [
                row.getAllCells(),
                table.getState().columnVisibility
            ];
        }, function(cells) {
            return cells.filter(function(cell) {
                return cell.column.getIsVisible();
            });
        }, getMemoOptions(table.options, "debugRows", "_getAllVisibleCells"));
        row.getVisibleCells = memo(function() {
            return [
                row.getLeftVisibleCells(),
                row.getCenterVisibleCells(),
                row.getRightVisibleCells()
            ];
        }, function(left, center, right) {
            return (0, _toConsumableArray._)(left).concat((0, _toConsumableArray._)(center), (0, _toConsumableArray._)(right));
        }, getMemoOptions(table.options, "debugRows", "getVisibleCells"));
    },
    createTable: function(table) {
        var makeVisibleColumnsMethod = function(key, getColumns) {
            return memo(function() {
                return [
                    getColumns(),
                    getColumns().filter(function(d) {
                        return d.getIsVisible();
                    }).map(function(d) {
                        return d.id;
                    }).join("_")
                ];
            }, function(columns) {
                return columns.filter(function(d) {
                    return d.getIsVisible == null ? void 0 : d.getIsVisible();
                });
            }, getMemoOptions(table.options, "debugColumns", key));
        };
        table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", function() {
            return table.getAllFlatColumns();
        });
        table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", function() {
            return table.getAllLeafColumns();
        });
        table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", function() {
            return table.getLeftLeafColumns();
        });
        table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", function() {
            return table.getRightLeafColumns();
        });
        table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", function() {
            return table.getCenterLeafColumns();
        });
        table.setColumnVisibility = function(updater) {
            return table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
        };
        table.resetColumnVisibility = function(defaultState) {
            var _table$initialState$c;
            table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
        };
        table.toggleAllColumnsVisible = function(value) {
            var _value;
            value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
            table.setColumnVisibility(table.getAllLeafColumns().reduce(function(obj, column) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, obj), (0, _defineProperty._)({}, column.id, !value ? !(column.getCanHide != null && column.getCanHide()) : value));
            }, {}));
        };
        table.getIsAllColumnsVisible = function() {
            return !table.getAllLeafColumns().some(function(column) {
                return !(column.getIsVisible != null && column.getIsVisible());
            });
        };
        table.getIsSomeColumnsVisible = function() {
            return table.getAllLeafColumns().some(function(column) {
                return column.getIsVisible == null ? void 0 : column.getIsVisible();
            });
        };
        table.getToggleAllColumnsVisibilityHandler = function() {
            return function(e) {
                var _target;
                table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
function _getVisibleLeafColumns(table, position) {
    return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
//
var GlobalFaceting = {
    createTable: function(table) {
        table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
        table.getGlobalFacetedRowModel = function() {
            if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
            return table._getGlobalFacetedRowModel();
        };
        table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
        table.getGlobalFacetedUniqueValues = function() {
            if (!table._getGlobalFacetedUniqueValues) return new Map();
            return table._getGlobalFacetedUniqueValues();
        };
        table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
        table.getGlobalFacetedMinMaxValues = function() {
            if (!table._getGlobalFacetedMinMaxValues) return;
            return table._getGlobalFacetedMinMaxValues();
        };
    }
};
//
var GlobalFiltering = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            globalFilter: undefined
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onGlobalFilterChange: makeStateUpdater("globalFilter", table),
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: function(column) {
                var _table$getCoreRowMode;
                var value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: function(column, table) {
        column.getCanGlobalFilter = function() {
            var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
            return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
        };
    },
    createTable: function(table) {
        table.getGlobalAutoFilterFn = function() {
            return filterFns.includesString;
        };
        table.getGlobalFilterFn = function() {
            var _table$options$filter, _table$options$filter2;
            var _table_options = table.options, globalFilterFn = _table_options.globalFilterFn;
            return isFunction(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : filterFns[globalFilterFn];
        };
        table.setGlobalFilter = function(updater) {
            table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
        };
        table.resetGlobalFilter = function(defaultState) {
            table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
        };
    }
};
//
var RowExpanding = (0, _defineProperty._)({
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            expanded: {}
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onExpandedChange: makeStateUpdater("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: function(table) {
        var registered = false;
        var queued = false;
        table._autoResetExpanded = function() {
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(function() {
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                if (queued) return;
                queued = true;
                table._queue(function() {
                    table.resetExpanded();
                    queued = false;
                });
            }
        };
        table.setExpanded = function(updater) {
            return table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
        };
        table.toggleAllRowsExpanded = function(expanded) {
            if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
            else table.setExpanded({});
        };
        table.resetExpanded = function(defaultState) {
            var _table$initialState$e, _table$initialState;
            table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
        };
        table.getCanSomeRowsExpand = function() {
            return table.getPrePaginationRowModel().flatRows.some(function(row) {
                return row.getCanExpand();
            });
        };
        table.getToggleAllRowsExpandedHandler = function() {
            return function(e) {
                e.persist == null || e.persist();
                table.toggleAllRowsExpanded();
            };
        };
        table.getIsSomeRowsExpanded = function() {
            var expanded = table.getState().expanded;
            return expanded === true || Object.values(expanded).some(Boolean);
        };
        table.getIsAllRowsExpanded = function() {
            var expanded = table.getState().expanded;
            // If expanded is true, save some cycles and return true
            if (typeof expanded === "boolean") return expanded === true;
            if (!Object.keys(expanded).length) return false;
            // If any row is not expanded, return false
            if (table.getRowModel().flatRows.some(function(row) {
                return !row.getIsExpanded();
            })) return false;
            // They must all be expanded :shrug:
            return true;
        };
        table.getExpandedDepth = function() {
            var maxDepth = 0;
            var rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
            rowIds.forEach(function(id) {
                var splitId = id.split(".");
                maxDepth = Math.max(maxDepth, splitId.length);
            });
            return maxDepth;
        };
        table.getPreExpandedRowModel = function() {
            return table.getSortedRowModel();
        };
        table.getExpandedRowModel = function() {
            if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
            if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
            return table._getExpandedRowModel();
        };
    }
}, "createRow", function(row, table) {
    var _tmp;
    _tmp = function(expanded) {
        table.setExpanded(function(old) {
            var _expanded;
            var exists = old === true ? true : !!(old != null && old[row.id]);
            var oldExpanded = {};
            if (old === true) Object.keys(table.getRowModel().rowsById).forEach(function(rowId) {
                oldExpanded[rowId] = true;
            });
            else oldExpanded = old;
            expanded = (_expanded = expanded) != null ? _expanded : !exists;
            if (!exists && expanded) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, oldExpanded), (0, _defineProperty._)({}, row.id, true));
            if (exists && !expanded) {
                var _row_id = row.id, _ = oldExpanded[_row_id], rest = (0, _objectWithoutProperties._)(oldExpanded, [
                    _row_id
                ].map((0, _toPropertyKey._)));
                return rest;
            }
            return old;
        });
    }, row.toggleExpanded = _tmp, _tmp;
    row.getIsExpanded = function() {
        var _table$options$getIsR;
        var expanded = table.getState().expanded;
        return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
    };
    row.getCanExpand = function() {
        var _table$options$getRow, _table$options$enable, _row$subRows;
        return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
    row.getIsAllParentsExpanded = function() {
        var isFullyExpanded = true;
        var currentRow = row;
        while(isFullyExpanded && currentRow.parentId){
            currentRow = table.getRow(currentRow.parentId, true);
            isFullyExpanded = currentRow.getIsExpanded();
        }
        return isFullyExpanded;
    };
    row.getToggleExpandedHandler = function() {
        var canExpand = row.getCanExpand();
        return function() {
            if (!canExpand) return;
            row.toggleExpanded();
        };
    };
});
//
var defaultPageIndex = 0;
var defaultPageSize = 10;
var getDefaultPaginationState = function() {
    return {
        pageIndex: defaultPageIndex,
        pageSize: defaultPageSize
    };
};
var RowPagination = {
    getInitialState: function(state) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            pagination: (0, _objectSpread._)({}, getDefaultPaginationState(), state == null ? void 0 : state.pagination)
        });
    },
    getDefaultOptions: function(table) {
        return {
            onPaginationChange: makeStateUpdater("pagination", table)
        };
    },
    createTable: function(table) {
        var registered = false;
        var queued = false;
        table._autoResetPageIndex = function() {
            var _ref, _table$options$autoRe;
            if (!registered) {
                table._queue(function() {
                    registered = true;
                });
                return;
            }
            if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                if (queued) return;
                queued = true;
                table._queue(function() {
                    table.resetPageIndex();
                    queued = false;
                });
            }
        };
        table.setPagination = function(updater) {
            var safeUpdater = function(old) {
                var newState = functionalUpdate(updater, old);
                return newState;
            };
            return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
        };
        table.resetPagination = function(defaultState) {
            var _table$initialState$p;
            table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
        };
        table.setPageIndex = function(updater) {
            table.setPagination(function(old) {
                var pageIndex = functionalUpdate(updater, old.pageIndex);
                var maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                    pageIndex: pageIndex
                });
            });
        };
        table.resetPageIndex = function(defaultState) {
            var _table$initialState$p2, _table$initialState;
            table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
        };
        table.resetPageSize = function(defaultState) {
            var _table$initialState$p3, _table$initialState2;
            table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : defaultPageSize);
        };
        table.setPageSize = function(updater) {
            table.setPagination(function(old) {
                var pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
                var topRowIndex = old.pageSize * old.pageIndex;
                var pageIndex = Math.floor(topRowIndex / pageSize);
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                    pageIndex: pageIndex,
                    pageSize: pageSize
                });
            });
        };
        //deprecated
        table.setPageCount = function(updater) {
            return table.setPagination(function(old) {
                var _table$options$pageCo;
                var newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, old), {
                    pageCount: newPageCount
                });
            });
        };
        table.getPageOptions = memo(function() {
            return [
                table.getPageCount()
            ];
        }, function(pageCount) {
            var pageOptions = [];
            if (pageCount && pageCount > 0) pageOptions = (0, _toConsumableArray._)(new Array(pageCount)).fill(null).map(function(_, i) {
                return i;
            });
            return pageOptions;
        }, getMemoOptions(table.options, "debugTable", "getPageOptions"));
        table.getCanPreviousPage = function() {
            return table.getState().pagination.pageIndex > 0;
        };
        table.getCanNextPage = function() {
            var pageIndex = table.getState().pagination.pageIndex;
            var pageCount = table.getPageCount();
            if (pageCount === -1) return true;
            if (pageCount === 0) return false;
            return pageIndex < pageCount - 1;
        };
        table.previousPage = function() {
            return table.setPageIndex(function(old) {
                return old - 1;
            });
        };
        table.nextPage = function() {
            return table.setPageIndex(function(old) {
                return old + 1;
            });
        };
        table.firstPage = function() {
            return table.setPageIndex(0);
        };
        table.lastPage = function() {
            return table.setPageIndex(table.getPageCount() - 1);
        };
        table.getPrePaginationRowModel = function() {
            return table.getExpandedRowModel();
        };
        table.getPaginationRowModel = function() {
            if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
            if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
            return table._getPaginationRowModel();
        };
        table.getPageCount = function() {
            var _table$options$pageCo2;
            return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
        };
        table.getRowCount = function() {
            var _table$options$rowCou;
            return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
        };
    }
};
//
var getDefaultRowPinningState = function() {
    return {
        top: [],
        bottom: []
    };
};
var RowPinning = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            rowPinning: getDefaultRowPinningState()
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onRowPinningChange: makeStateUpdater("rowPinning", table)
        };
    },
    createRow: function(row, table) {
        row.pin = function(position, includeLeafRows, includeParentRows) {
            var leafRowIds = includeLeafRows ? row.getLeafRows().map(function(_ref) {
                var id = _ref.id;
                return id;
            }) : [];
            var parentRowIds = includeParentRows ? row.getParentRows().map(function(_ref2) {
                var id = _ref2.id;
                return id;
            }) : [];
            var rowIds = new Set((0, _toConsumableArray._)(parentRowIds).concat([
                row.id
            ], (0, _toConsumableArray._)(leafRowIds)));
            table.setRowPinning(function(old) {
                var _old$top3, _old$bottom3;
                if (position === "bottom") {
                    var _old$top, _old$bottom;
                    return {
                        top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter(function(d) {
                            return !(rowIds != null && rowIds.has(d));
                        }),
                        bottom: (0, _toConsumableArray._)(((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter(function(d) {
                            return !(rowIds != null && rowIds.has(d));
                        })).concat((0, _toConsumableArray._)(Array.from(rowIds)))
                    };
                }
                if (position === "top") {
                    var _old$top2, _old$bottom2;
                    return {
                        top: (0, _toConsumableArray._)(((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter(function(d) {
                            return !(rowIds != null && rowIds.has(d));
                        })).concat((0, _toConsumableArray._)(Array.from(rowIds))),
                        bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter(function(d) {
                            return !(rowIds != null && rowIds.has(d));
                        })
                    };
                }
                return {
                    top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter(function(d) {
                        return !(rowIds != null && rowIds.has(d));
                    }),
                    bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter(function(d) {
                        return !(rowIds != null && rowIds.has(d));
                    })
                };
            });
        };
        row.getCanPin = function() {
            var _ref3;
            var _table_options = table.options, enableRowPinning = _table_options.enableRowPinning, enablePinning = _table_options.enablePinning;
            if (typeof enableRowPinning === "function") return enableRowPinning(row);
            return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
        };
        row.getIsPinned = function() {
            var rowIds = [
                row.id
            ];
            var _table_getState_rowPinning = table.getState().rowPinning, top = _table_getState_rowPinning.top, bottom = _table_getState_rowPinning.bottom;
            var isTop = rowIds.some(function(d) {
                return top == null ? void 0 : top.includes(d);
            });
            var isBottom = rowIds.some(function(d) {
                return bottom == null ? void 0 : bottom.includes(d);
            });
            return isTop ? "top" : isBottom ? "bottom" : false;
        };
        row.getPinnedIndex = function() {
            var _ref4, _visiblePinnedRowIds$;
            var position = row.getIsPinned();
            if (!position) return -1;
            var visiblePinnedRowIds = (_ref4 = position === "top" ? table.getTopRows() : table.getBottomRows()) == null ? void 0 : _ref4.map(function(_ref5) {
                var id = _ref5.id;
                return id;
            });
            return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
        };
    },
    createTable: function(table) {
        table.setRowPinning = function(updater) {
            return table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
        };
        table.resetRowPinning = function(defaultState) {
            var _table$initialState$r, _table$initialState;
            return table.setRowPinning(defaultState ? getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : getDefaultRowPinningState());
        };
        table.getIsSomeRowsPinned = function(position) {
            var _pinningState$positio;
            var pinningState = table.getState().rowPinning;
            if (!position) {
                var _pinningState$top, _pinningState$bottom;
                return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
            }
            return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
        };
        table._getPinnedRows = function(visibleRows, pinnedRowIds, position) {
            var _table$options$keepPi;
            var rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? //get all rows that are pinned even if they would not be otherwise visible
            //account for expanded parent rows, but not pagination or filtering
            (pinnedRowIds != null ? pinnedRowIds : []).map(function(rowId) {
                var row = table.getRow(rowId, true);
                return row.getIsAllParentsExpanded() ? row : null;
            }) : //else get only visible rows that are pinned
            (pinnedRowIds != null ? pinnedRowIds : []).map(function(rowId) {
                return visibleRows.find(function(row) {
                    return row.id === rowId;
                });
            });
            return rows.filter(Boolean).map(function(d) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, d), {
                    position: position
                });
            });
        };
        table.getTopRows = memo(function() {
            return [
                table.getRowModel().rows,
                table.getState().rowPinning.top
            ];
        }, function(allRows, topPinnedRowIds) {
            return table._getPinnedRows(allRows, topPinnedRowIds, "top");
        }, getMemoOptions(table.options, "debugRows", "getTopRows"));
        table.getBottomRows = memo(function() {
            return [
                table.getRowModel().rows,
                table.getState().rowPinning.bottom
            ];
        }, function(allRows, bottomPinnedRowIds) {
            return table._getPinnedRows(allRows, bottomPinnedRowIds, "bottom");
        }, getMemoOptions(table.options, "debugRows", "getBottomRows"));
        table.getCenterRows = memo(function() {
            return [
                table.getRowModel().rows,
                table.getState().rowPinning.top,
                table.getState().rowPinning.bottom
            ];
        }, function(allRows, top, bottom) {
            var topAndBottom = new Set((0, _toConsumableArray._)(top != null ? top : []).concat((0, _toConsumableArray._)(bottom != null ? bottom : [])));
            return allRows.filter(function(d) {
                return !topAndBottom.has(d.id);
            });
        }, getMemoOptions(table.options, "debugRows", "getCenterRows"));
    }
};
//
var RowSelection = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            rowSelection: {}
        }, state);
    },
    getDefaultOptions: function(table) {
        return {
            onRowSelectionChange: makeStateUpdater("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: function(table) {
        table.setRowSelection = function(updater) {
            return table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
        };
        table.resetRowSelection = function(defaultState) {
            var _table$initialState$r;
            return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
        };
        table.toggleAllRowsSelected = function(value) {
            table.setRowSelection(function(old) {
                value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                var rowSelection = (0, _objectSpread._)({}, old);
                var preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                // We don't use `mutateRowIsSelected` here for performance reasons.
                // All of the rows are flat already, so it wouldn't be worth it
                if (value) preGroupedFlatRows.forEach(function(row) {
                    if (!row.getCanSelect()) return;
                    rowSelection[row.id] = true;
                });
                else preGroupedFlatRows.forEach(function(row) {
                    delete rowSelection[row.id];
                });
                return rowSelection;
            });
        };
        table.toggleAllPageRowsSelected = function(value) {
            return table.setRowSelection(function(old) {
                var resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                var rowSelection = (0, _objectSpread._)({}, old);
                table.getRowModel().rows.forEach(function(row) {
                    mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
                });
                return rowSelection;
            });
        };
        // addRowSelectionRange: rowId => {
        //   const {
        //     rows,
        //     rowsById,
        //     options: { selectGroupingRows, selectSubRows },
        //   } = table
        //   const findSelectedRow = (rows: Row[]) => {
        //     let found
        //     rows.find(d => {
        //       if (d.getIsSelected()) {
        //         found = d
        //         return true
        //       }
        //       const subFound = findSelectedRow(d.subRows || [])
        //       if (subFound) {
        //         found = subFound
        //         return true
        //       }
        //       return false
        //     })
        //     return found
        //   }
        //   const firstRow = findSelectedRow(rows) || rows[0]
        //   const lastRow = rowsById[rowId]
        //   let include = false
        //   const selectedRowIds = {}
        //   const addRow = (row: Row) => {
        //     mutateRowIsSelected(selectedRowIds, row.id, true, {
        //       rowsById,
        //       selectGroupingRows: selectGroupingRows!,
        //       selectSubRows: selectSubRows!,
        //     })
        //   }
        //   table.rows.forEach(row => {
        //     const isFirstRow = row.id === firstRow.id
        //     const isLastRow = row.id === lastRow.id
        //     if (isFirstRow || isLastRow) {
        //       if (!include) {
        //         include = true
        //       } else if (include) {
        //         addRow(row)
        //         include = false
        //       }
        //     }
        //     if (include) {
        //       addRow(row)
        //     }
        //   })
        //   table.setRowSelection(selectedRowIds)
        // },
        table.getPreSelectedRowModel = function() {
            return table.getCoreRowModel();
        };
        table.getSelectedRowModel = memo(function() {
            return [
                table.getState().rowSelection,
                table.getCoreRowModel()
            ];
        }, function(rowSelection, rowModel) {
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, "debugTable", "getSelectedRowModel"));
        table.getFilteredSelectedRowModel = memo(function() {
            return [
                table.getState().rowSelection,
                table.getFilteredRowModel()
            ];
        }, function(rowSelection, rowModel) {
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, "debugTable", "getFilteredSelectedRowModel"));
        table.getGroupedSelectedRowModel = memo(function() {
            return [
                table.getState().rowSelection,
                table.getSortedRowModel()
            ];
        }, function(rowSelection, rowModel) {
            if (!Object.keys(rowSelection).length) return {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            return selectRowsFn(table, rowModel);
        }, getMemoOptions(table.options, "debugTable", "getGroupedSelectedRowModel"));
        ///
        // getGroupingRowCanSelect: rowId => {
        //   const row = table.getRow(rowId)
        //   if (!row) {
        //     throw new Error()
        //   }
        //   if (typeof table.options.enableGroupingRowSelection === 'function') {
        //     return table.options.enableGroupingRowSelection(row)
        //   }
        //   return table.options.enableGroupingRowSelection ?? false
        // },
        table.getIsAllRowsSelected = function() {
            var preGroupedFlatRows = table.getFilteredRowModel().flatRows;
            var rowSelection = table.getState().rowSelection;
            var isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
            if (isAllRowsSelected) {
                if (preGroupedFlatRows.some(function(row) {
                    return row.getCanSelect() && !rowSelection[row.id];
                })) isAllRowsSelected = false;
            }
            return isAllRowsSelected;
        };
        table.getIsAllPageRowsSelected = function() {
            var paginationFlatRows = table.getPaginationRowModel().flatRows.filter(function(row) {
                return row.getCanSelect();
            });
            var rowSelection = table.getState().rowSelection;
            var isAllPageRowsSelected = !!paginationFlatRows.length;
            if (isAllPageRowsSelected && paginationFlatRows.some(function(row) {
                return !rowSelection[row.id];
            })) isAllPageRowsSelected = false;
            return isAllPageRowsSelected;
        };
        table.getIsSomeRowsSelected = function() {
            var _table$getState$rowSe;
            var totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
            return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
        };
        table.getIsSomePageRowsSelected = function() {
            var paginationFlatRows = table.getPaginationRowModel().flatRows;
            return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter(function(row) {
                return row.getCanSelect();
            }).some(function(d) {
                return d.getIsSelected() || d.getIsSomeSelected();
            });
        };
        table.getToggleAllRowsSelectedHandler = function() {
            return function(e) {
                table.toggleAllRowsSelected(e.target.checked);
            };
        };
        table.getToggleAllPageRowsSelectedHandler = function() {
            return function(e) {
                table.toggleAllPageRowsSelected(e.target.checked);
            };
        };
    },
    createRow: function(row, table) {
        row.toggleSelected = function(value, opts) {
            var isSelected = row.getIsSelected();
            table.setRowSelection(function(old) {
                var _opts$selectChildren;
                value = typeof value !== "undefined" ? value : !isSelected;
                if (row.getCanSelect() && isSelected === value) return old;
                var selectedRowIds = (0, _objectSpread._)({}, old);
                mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
                return selectedRowIds;
            });
        };
        row.getIsSelected = function() {
            var rowSelection = table.getState().rowSelection;
            return isRowSelected(row, rowSelection);
        };
        row.getIsSomeSelected = function() {
            var rowSelection = table.getState().rowSelection;
            return isSubRowSelected(row, rowSelection) === "some";
        };
        row.getIsAllSubRowsSelected = function() {
            var rowSelection = table.getState().rowSelection;
            return isSubRowSelected(row, rowSelection) === "all";
        };
        row.getCanSelect = function() {
            var _table$options$enable;
            if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
            return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
        };
        row.getCanSelectSubRows = function() {
            var _table$options$enable2;
            if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
            return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
        };
        row.getCanMultiSelect = function() {
            var _table$options$enable3;
            if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
            return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
        };
        row.getToggleSelectedHandler = function() {
            var canSelect = row.getCanSelect();
            return function(e) {
                var _target;
                if (!canSelect) return;
                row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
            };
        };
    }
};
var mutateRowIsSelected = function(selectedRowIds, id, value, includeChildren, table) {
    var _row$subRows;
    var row = table.getRow(id, true);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach(function(key) {
            return delete selectedRowIds[key];
        });
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach(function(row) {
        return mutateRowIsSelected(selectedRowIds, row.id, value, includeChildren, table);
    });
};
function selectRowsFn(table, rowModel) {
    var rowSelection = table.getState().rowSelection;
    var newSelectedFlatRows = [];
    var newSelectedRowsById = {};
    // Filters top level and nested rows
    var recurseRows = function recurseRows1(rows, depth) {
        return rows.map(function(row) {
            var _row$subRows2;
            var isSelected = isRowSelected(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = (0, _objectSpreadProps._)((0, _objectSpread._)({}, row), {
                subRows: recurseRows(row.subRows)
            });
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function isRowSelected(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
    var _row$subRows3;
    if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
    var allChildrenSelected = true;
    var someSelected = false;
    row.subRows.forEach(function(subRow) {
        // Bail out early if we know both of these
        if (someSelected && !allChildrenSelected) return;
        if (subRow.getCanSelect()) {
            if (isRowSelected(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        }
        // Check row selection of nested subrows
        if (subRow.subRows && subRow.subRows.length) {
            var subRowChildrenSelected = isSubRowSelected(subRow, selection);
            if (subRowChildrenSelected === "all") someSelected = true;
            else if (subRowChildrenSelected === "some") {
                someSelected = true;
                allChildrenSelected = false;
            } else allChildrenSelected = false;
        }
    });
    return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
var reSplitAlphaNumeric = /([0-9]+)/gm;
var alphanumeric = function(rowA, rowB, columnId) {
    return compareAlphanumeric(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
var alphanumericCaseSensitive = function(rowA, rowB, columnId) {
    return compareAlphanumeric(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
var text = function(rowA, rowB, columnId) {
    return compareBasic(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
var textCaseSensitive = function(rowA, rowB, columnId) {
    return compareBasic(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
var datetime = function(rowA, rowB, columnId) {
    var a = rowA.getValue(columnId);
    var b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
var basic = function(rowA, rowB, columnId) {
    return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    var a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
    var b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
    // While
    while(a.length && b.length){
        var aa = a.shift();
        var bb = b.shift();
        var an = parseInt(aa, 10);
        var bn = parseInt(bb, 10);
        var combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
var sortingFns = {
    alphanumeric: alphanumeric,
    alphanumericCaseSensitive: alphanumericCaseSensitive,
    text: text,
    textCaseSensitive: textCaseSensitive,
    datetime: datetime,
    basic: basic
};
//
var RowSorting = {
    getInitialState: function(state) {
        return (0, _objectSpread._)({
            sorting: []
        }, state);
    },
    getDefaultColumnDef: function() {
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: function(table) {
        return {
            onSortingChange: makeStateUpdater("sorting", table),
            isMultiSortEvent: function(e) {
                return e.shiftKey;
            }
        };
    },
    createColumn: function(column, table) {
        column.getAutoSortingFn = function() {
            var firstRows = table.getFilteredRowModel().flatRows.slice(10);
            var isString = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = firstRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var row = _step.value;
                    var value = row == null ? void 0 : row.getValue(column.id);
                    if (Object.prototype.toString.call(value) === "[object Date]") return sortingFns.datetime;
                    if (typeof value === "string") {
                        isString = true;
                        if (value.split(reSplitAlphaNumeric).length > 1) return sortingFns.alphanumeric;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (isString) return sortingFns.text;
            return sortingFns.basic;
        };
        column.getAutoSortDir = function() {
            var firstRow = table.getFilteredRowModel().flatRows[0];
            var value = firstRow == null ? void 0 : firstRow.getValue(column.id);
            if (typeof value === "string") return "asc";
            return "desc";
        };
        column.getSortingFn = function() {
            var _table$options$sortin, _table$options$sortin2;
            if (!column) throw new Error();
            return isFunction(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
        };
        column.toggleSorting = function(desc, multi) {
            // if (column.columns.length) {
            //   column.columns.forEach((c, i) => {
            //     if (c.id) {
            //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
            //     }
            //   })
            //   return
            // }
            // this needs to be outside of table.setSorting to be in sync with rerender
            var nextSortingOrder = column.getNextSortingOrder();
            var hasManualValue = typeof desc !== "undefined" && desc !== null;
            table.setSorting(function(old) {
                // Find any existing sorting for this column
                var existingSorting = old == null ? void 0 : old.find(function(d) {
                    return d.id === column.id;
                });
                var existingIndex = old == null ? void 0 : old.findIndex(function(d) {
                    return d.id === column.id;
                });
                var newSorting = [];
                // What should we do with this sort action?
                var sortAction;
                var nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                // Multi-mode
                if (old != null && old.length && column.getCanMultiSort() && multi) {
                    if (existingSorting) sortAction = "toggle";
                    else sortAction = "add";
                } else {
                    // Normal mode
                    if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                    else if (existingSorting) sortAction = "toggle";
                    else sortAction = "replace";
                }
                // Handle toggle states that will remove the sorting
                if (sortAction === "toggle") {
                    // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                    if (!hasManualValue) // Is our intention to remove?
                    {
                        if (!nextSortingOrder) sortAction = "remove";
                    }
                }
                if (sortAction === "add") {
                    var _table$options$maxMul;
                    newSorting = (0, _toConsumableArray._)(old).concat([
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ]);
                    // Take latest n columns
                    newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                } else if (sortAction === "toggle") // This flips (or sets) the
                newSorting = old.map(function(d) {
                    if (d.id === column.id) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, d), {
                        desc: nextDesc
                    });
                    return d;
                });
                else if (sortAction === "remove") newSorting = old.filter(function(d) {
                    return d.id !== column.id;
                });
                else newSorting = [
                    {
                        id: column.id,
                        desc: nextDesc
                    }
                ];
                return newSorting;
            });
        };
        column.getFirstSortDir = function() {
            var _ref, _column$columnDef$sor;
            var sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
            return sortDescFirst ? "desc" : "asc";
        };
        column.getNextSortingOrder = function(multi) {
            var _table$options$enable, _table$options$enable2;
            var firstSortDirection = column.getFirstSortDir();
            var isSorted = column.getIsSorted();
            if (!isSorted) return firstSortDirection;
            if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
            (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
            )) return false;
            return isSorted === "desc" ? "asc" : "desc";
        };
        column.getCanSort = function() {
            var _column$columnDef$ena, _table$options$enable3;
            return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
        };
        column.getCanMultiSort = function() {
            var _ref2, _column$columnDef$ena2;
            return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
        };
        column.getIsSorted = function() {
            var _table$getState$sorti;
            var columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find(function(d) {
                return d.id === column.id;
            });
            return !columnSort ? false : columnSort.desc ? "desc" : "asc";
        };
        column.getSortIndex = function() {
            var _table$getState$sorti2, _table$getState$sorti3;
            return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex(function(d) {
                return d.id === column.id;
            })) != null ? _table$getState$sorti2 : -1;
        };
        column.clearSorting = function() {
            //clear sorting for just 1 column
            table.setSorting(function(old) {
                return old != null && old.length ? old.filter(function(d) {
                    return d.id !== column.id;
                }) : [];
            });
        };
        column.getToggleSortingHandler = function() {
            var canSort = column.getCanSort();
            return function(e) {
                if (!canSort) return;
                e.persist == null || e.persist();
                column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
            };
        };
    },
    createTable: function(table) {
        table.setSorting = function(updater) {
            return table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
        };
        table.resetSorting = function(defaultState) {
            var _table$initialState$s, _table$initialState;
            table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
        };
        table.getPreSortedRowModel = function() {
            return table.getGroupedRowModel();
        };
        table.getSortedRowModel = function() {
            if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
            if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
            return table._getSortedRowModel();
        };
    }
};
var builtInFeatures = [
    Headers,
    ColumnVisibility,
    ColumnOrdering,
    ColumnPinning,
    ColumnFaceting,
    ColumnFiltering,
    GlobalFaceting,
    //depends on ColumnFaceting
    GlobalFiltering,
    //depends on ColumnFiltering
    RowSorting,
    ColumnGrouping,
    //depends on RowSorting
    RowExpanding,
    RowPagination,
    RowPinning,
    RowSelection,
    ColumnSizing
];
//
function createTable(options) {
    var _options$_features, _options$initialState;
    var _features = (0, _toConsumableArray._)(builtInFeatures).concat((0, _toConsumableArray._)((_options$_features = options._features) != null ? _options$_features : []));
    var table = {
        _features: _features
    };
    var defaultOptions = table._features.reduce(function(obj, feature) {
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    var mergeOptions = function(options) {
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return (0, _objectSpread._)({}, defaultOptions, options);
    };
    var coreInitialState = {};
    var initialState = (0, _objectSpread._)({}, coreInitialState, (_options$initialState = options.initialState) != null ? _options$initialState : {});
    table._features.forEach(function(feature) {
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    var queued = [];
    var queuedTimeout = false;
    var coreInstance = {
        _features: _features,
        options: (0, _objectSpread._)({}, defaultOptions, options),
        initialState: initialState,
        _queue: function(cb) {
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(function() {
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch(function(error) {
                    return setTimeout(function() {
                        throw error;
                    });
                });
            }
        },
        reset: function() {
            table.setState(table.initialState);
        },
        setOptions: function(updater) {
            var newOptions = functionalUpdate(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: function() {
            return table.options.state;
        },
        setState: function(updater) {
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: function(row, index, parent) {
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : "".concat(parent ? [
                parent.id,
                index
            ].join(".") : index);
        },
        getCoreRowModel: function() {
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: function() {
            return table.getPaginationRowModel();
        },
        //in next version, we should just pass in the row model as the optional 2nd arg
        getRow: function(id, searchAll) {
            var row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
            if (!row) {
                row = table.getCoreRowModel().rowsById[id];
                if (!row) throw new Error();
            }
            return row;
        },
        _getDefaultColumnDef: memo(function() {
            return [
                table.options.defaultColumn
            ];
        }, function(defaultColumn) {
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return (0, _objectSpread._)({
                header: function(props) {
                    var resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: function(props) {
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                }
            }, table._features.reduce(function(obj, feature) {
                return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
            }, {}), defaultColumn);
        }, getMemoOptions(options, "debugColumns", "_getDefaultColumnDef")),
        _getColumnDefs: function() {
            return table.options.columns;
        },
        getAllColumns: memo(function() {
            return [
                table._getColumnDefs()
            ];
        }, function(columnDefs) {
            var recurseColumns = function recurseColumns1(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map(function(columnDef) {
                    var column = createColumn(table, columnDef, depth, parent);
                    var groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, getMemoOptions(options, "debugColumns", "getAllColumns")),
        getAllFlatColumns: memo(function() {
            return [
                table.getAllColumns()
            ];
        }, function(allColumns) {
            return allColumns.flatMap(function(column) {
                return column.getFlatColumns();
            });
        }, getMemoOptions(options, "debugColumns", "getAllFlatColumns")),
        _getAllFlatColumnsById: memo(function() {
            return [
                table.getAllFlatColumns()
            ];
        }, function(flatColumns) {
            return flatColumns.reduce(function(acc, column) {
                acc[column.id] = column;
                return acc;
            }, {});
        }, getMemoOptions(options, "debugColumns", "getAllFlatColumnsById")),
        getAllLeafColumns: memo(function() {
            return [
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ];
        }, function(allColumns, orderColumns) {
            var leafColumns = allColumns.flatMap(function(column) {
                return column.getLeafColumns();
            });
            return orderColumns(leafColumns);
        }, getMemoOptions(options, "debugColumns", "getAllLeafColumns")),
        getColumn: function(columnId) {
            var column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    for(var index = 0; index < table._features.length; index++){
        var feature = table._features[index];
        feature == null || feature.createTable == null || feature.createTable(table);
    }
    return table;
}
function getCoreRowModel() {
    return function(table) {
        return memo(function() {
            return [
                table.options.data
            ];
        }, function(data) {
            var rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            var accessRows = function accessRows1(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                var rows = [];
                for(var i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    var row = createRow(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, getMemoOptions(table.options, "debugTable", "getRowModel", function() {
            return table._autoResetPageIndex();
        }));
    };
}
function getExpandedRowModel() {
    return function(table) {
        return memo(function() {
            return [
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ];
        }, function(expanded, rowModel, paginateExpandedRows) {
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return expandRows(rowModel);
        }, getMemoOptions(table.options, "debugTable", "getExpandedRowModel"));
    };
}
function expandRows(rowModel) {
    var expandedRows = [];
    var handleRow = function(row) {
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function getFacetedMinMaxValues() {
    return function(table, columnId) {
        return memo(function() {
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, function(facetedRowModel) {
            if (!facetedRowModel) return undefined;
            var uniqueValues = facetedRowModel.flatRows.flatMap(function(flatRow) {
                var _flatRow$getUniqueVal;
                return (_flatRow$getUniqueVal = flatRow.getUniqueValues(columnId)) != null ? _flatRow$getUniqueVal : [];
            }).map(Number).filter(function(value) {
                return !Number.isNaN(value);
            });
            if (!uniqueValues.length) return;
            var facetedMinValue = uniqueValues[0];
            var facetedMaxValue = uniqueValues[uniqueValues.length - 1];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = uniqueValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var value = _step.value;
                    if (value < facetedMinValue) facetedMinValue = value;
                    else if (value > facetedMaxValue) facetedMaxValue = value;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                facetedMinValue,
                facetedMaxValue
            ];
        }, getMemoOptions(table.options, "debugTable", "getFacetedMinMaxValues"));
    };
}
function filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return filterRowModelFromLeafs(rows, filterRowImpl, table);
    return filterRowModelFromRoot(rows, filterRowImpl, table);
}
function filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    var newFilteredFlatRows = [];
    var newFilteredRowsById = {};
    var maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    var recurseFilterRows = function recurseFilterRows1(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        var rows = [];
        // Filter from children up first
        for(var i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            var row = rowsToFilter[i];
            var newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredFlatRows.push(row);
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    var newFilteredFlatRows = [];
    var newFilteredRowsById = {};
    var maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    var recurseFilterRows = function recurseFilterRows1(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        var rows = [];
        // Apply the filter to any subRows
        for(var i = 0; i < rowsToFilter.length; i++){
            var row = rowsToFilter[i];
            var pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    var newRow = createRow(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function getFacetedRowModel() {
    return function(table, columnId) {
        return memo(function() {
            return [
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ];
        }, function(preRowModel, columnFilters, globalFilter) {
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            var filterableIds = (0, _toConsumableArray._)(columnFilters.map(function(d) {
                return d.id;
            }).filter(function(d) {
                return d !== columnId;
            })).concat([
                globalFilter ? "__global__" : undefined
            ]).filter(Boolean);
            var filterRowsImpl = function(row) {
                // Horizontally filter rows through each column
                for(var i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return filterRows(preRowModel.rows, filterRowsImpl, table);
        }, getMemoOptions(table.options, "debugTable", "getFacetedRowModel"));
    };
}
function getFacetedUniqueValues() {
    return function(table, columnId) {
        return memo(function() {
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, function(facetedRowModel) {
            if (!facetedRowModel) return new Map();
            var facetedUniqueValues = new Map();
            for(var i = 0; i < facetedRowModel.flatRows.length; i++){
                var values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(var j = 0; j < values.length; j++){
                    var value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, getMemoOptions(table.options, "debugTable", "getFacetedUniqueValues_".concat(columnId)));
    };
}
function getFilteredRowModel() {
    return function(table) {
        return memo(function() {
            return [
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ];
        }, function(rowModel, columnFilters, globalFilter) {
            var _loop = function(j) {
                var _loop = function(i) {
                    currentColumnFilter = resolvedColumnFilters[i];
                    var id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, function(filterMeta) {
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                };
                var row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(var i = 0; i < resolvedColumnFilters.length; i++)_loop(i);
                if (resolvedGlobalFilters.length) {
                    var _loop1 = function(i1) {
                        currentGlobalFilter = resolvedGlobalFilters[i1];
                        var id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, function(filterMeta) {
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            return "break";
                        }
                    };
                    for(var i1 = 0; i1 < resolvedGlobalFilters.length; i1++){
                        var _ret = _loop1(i1);
                        if (_ret === "break") break;
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            };
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(var i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            var resolvedColumnFilters = [];
            var resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach(function(d) {
                var _filterFn$resolveFilt;
                var column = table.getColumn(d.id);
                if (!column) return;
                var filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            var filterableIds = (columnFilters != null ? columnFilters : []).map(function(d) {
                return d.id;
            });
            var globalFilterFn = table.getGlobalFilterFn();
            var globallyFilterableColumns = table.getAllLeafColumns().filter(function(column) {
                return column.getCanGlobalFilter();
            });
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach(function(column) {
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            var currentColumnFilter;
            var currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(var j = 0; j < rowModel.flatRows.length; j++)_loop(j);
            var filterRowsImpl = function(row) {
                // Horizontally filter rows through each column
                for(var i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return filterRows(rowModel.rows, filterRowsImpl, table);
        }, getMemoOptions(table.options, "debugTable", "getFilteredRowModel", function() {
            return table._autoResetPageIndex();
        }));
    };
}
function getGroupedRowModel() {
    return function(table) {
        return memo(function() {
            return [
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ];
        }, function(grouping, rowModel) {
            if (!rowModel.rows.length || !grouping.length) {
                rowModel.rows.forEach(function(row) {
                    row.depth = 0;
                    row.parentId = undefined;
                });
                return rowModel;
            }
            // Filter the grouping list down to columns that exist
            var existingGrouping = grouping.filter(function(columnId) {
                return table.getColumn(columnId);
            });
            var groupedFlatRows = [];
            var groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            var groupUpRecursively = function groupUpRecursively1(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map(function(row) {
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                var columnId = existingGrouping[depth];
                // Group the rows together for this level
                var rowGroupsMap = groupBy(rows, columnId);
                // Perform aggregations for each group
                var aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map(function(_ref, index) {
                    var _$_ref = (0, _slicedToArray._)(_ref, 2), groupingValue = _$_ref[0], groupedRows = _$_ref[1];
                    var id = "".concat(columnId, ":").concat(groupingValue);
                    id = parentId ? "".concat(parentId, ">").concat(id) : id;
                    // First, Recurse to group sub rows before aggregation
                    var subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    subRows.forEach(function(subRow) {
                        subRow.parentId = id;
                    });
                    // Flatten the leaf rows of the rows in this group
                    var leafRows = depth ? flattenBy(groupedRows, function(row) {
                        return row.subRows;
                    }) : groupedRows;
                    var row = createRow(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: function(columnId) {
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            var column = table.getColumn(columnId);
                            var aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach(function(subRow) {
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            var groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach(function(subRow) {
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, getMemoOptions(table.options, "debugTable", "getGroupedRowModel", function() {
            table._queue(function() {
                table._autoResetExpanded();
                table._autoResetPageIndex();
            });
        }));
    };
}
function groupBy(rows, columnId) {
    var groupMap = new Map();
    return rows.reduce(function(map, row) {
        var resKey = "".concat(row.getGroupingValue(columnId));
        var previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function getPaginationRowModel(opts) {
    return function(table) {
        return memo(function() {
            return [
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ];
        }, function(pagination, rowModel) {
            if (!rowModel.rows.length) return rowModel;
            var pageSize = pagination.pageSize, pageIndex = pagination.pageIndex;
            var rows = rowModel.rows, flatRows = rowModel.flatRows, rowsById = rowModel.rowsById;
            var pageStart = pageSize * pageIndex;
            var pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            var paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = expandRows({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            var handleRow = function(row) {
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, getMemoOptions(table.options, "debugTable", "getPaginationRowModel"));
    };
}
function getSortedRowModel() {
    return function(table) {
        return memo(function() {
            return [
                table.getState().sorting,
                table.getPreSortedRowModel()
            ];
        }, function(sorting, rowModel) {
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            var sortingState = table.getState().sorting;
            var sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            var availableSorting = sortingState.filter(function(sort) {
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            var columnInfoById = {};
            availableSorting.forEach(function(sortEntry) {
                var column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            var sortData = function(rows) {
                // This will also perform a stable sorting using the row index
                // if needed.
                var sortedData = rows.map(function(row) {
                    return (0, _objectSpread._)({}, row);
                });
                sortedData.sort(function(rowA, rowB) {
                    for(var i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        var sortEntry = availableSorting[i];
                        var columnInfo = columnInfoById[sortEntry.id];
                        var sortUndefined = columnInfo.sortUndefined;
                        var isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        var sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (sortUndefined) {
                            var aValue = rowA.getValue(sortEntry.id);
                            var bValue = rowB.getValue(sortEntry.id);
                            var aUndefined = aValue === undefined;
                            var bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) {
                                if (sortUndefined === "first") return aUndefined ? -1 : 1;
                                if (sortUndefined === "last") return aUndefined ? 1 : -1;
                                sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
                            }
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach(function(row) {
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, getMemoOptions(table.options, "debugTable", "getSortedRowModel", function() {
            return table._autoResetPageIndex();
        }));
    };
}

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_to_property_key":"7aiOt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7aiOt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_to_property_key", function() {
    return _to_property_key;
});
parcelHelpers.export(exports, "_", function() {
    return _to_property_key;
});
var _toPrimitiveJs = require("./_to_primitive.js");
var _typeOfJs = require("./_type_of.js");
function _to_property_key(arg) {
    var key = (0, _toPrimitiveJs._to_primitive)(arg, "string");
    return (0, _typeOfJs._type_of)(key) === "symbol" ? key : String(key);
}

},{"./_to_primitive.js":"ko0zY","./_type_of.js":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ko0zY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_to_primitive", function() {
    return _to_primitive;
});
parcelHelpers.export(exports, "_", function() {
    return _to_primitive;
});
var _typeOfJs = require("./_type_of.js");
function _to_primitive(input, hint) {
    if ((0, _typeOfJs._type_of)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeOfJs._type_of)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./_type_of.js":"6Gp9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9UBFX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContainer", function() {
    return StyledContainer;
});
parcelHelpers.export(exports, "StyledTableContainer", function() {
    return StyledTableContainer;
});
parcelHelpers.export(exports, "StyledTable", function() {
    return StyledTable;
});
parcelHelpers.export(exports, "StyledThead", function() {
    return StyledThead;
});
parcelHelpers.export(exports, "StyledTh", function() {
    return StyledTh;
});
parcelHelpers.export(exports, "StyledTbody", function() {
    return StyledTbody;
});
parcelHelpers.export(exports, "StyledBodyTr", function() {
    return StyledBodyTr;
});
parcelHelpers.export(exports, "StyledTd", function() {
    return StyledTd;
});
parcelHelpers.export(exports, "CenteredRow", function() {
    return CenteredRow;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: column;\n\n  width: ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n  height: 100%;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n    transition: background-color 0.2s;\n\n    border-radius: 10px;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n\n  &::-webkit-scrollbar-track,\n  &::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-collapse: separate;\n  margin: 0;\n  table-layout: auto;\n  border-spacing: 0;\n  border-radius: var(--pf-rounded-lg);\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: sticky;\n  top: 0;\n  z-index: 100;\n\n  background-color: ",
        ";\n\n  tr:first-child {\n    th {\n      &:first-child {\n        border-top-left-radius: var(--pf-rounded-lg);\n      }\n\n      &:last-child {\n        border-top-right-radius: var(--pf-rounded-lg);\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  max-width: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  color: #7488a4;\n  background: ",
        ";\n  font-size: ",
        ";\n\n  border-top: 1px solid #92a8c24d;\n  border-bottom: 1px solid #92a8c24d;\n  border-right: 1px solid #92a8c24d;\n\n  user-select: none;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &:first-child {\n    border-left: 1px solid #92a8c24d;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  tr:last-child {\n    td {\n      &:first-child {\n        border-bottom-left-radius: var(--pf-rounded-lg);\n      }\n\n      &:last-child {\n        border-bottom-right-radius: var(--pf-rounded-lg);\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  line-height: 18px;\n  color: ",
        ";\n  background: ",
        ";\n  max-width: ",
        ";\n  width: ",
        ";\n\n  border-right: 1px solid #92a8c24d;\n  border-bottom: 1px solid #92a8c24d;\n\n  text-align: ",
        ";\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &:first-child {\n    border-left: 1px solid #92a8c24d;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 5px 8px;\n  text-align: center;\n  vertical-align: middle;\n  height: 100%;\n  border: 1px solid var(--pf-border-color);\n\n  @keyframes shimmer {\n    0% {\n      background-color: var(--pf-primary-color-700) 40;\n    }\n    50% {\n      background-color: var(--pf-primary-color-700);\n    }\n    100% {\n      background-color: var(--pf-primary-color-700) 40;\n    }\n  }\n\n  animation: ",
        ";\n\n  svg {\n    margin: 0 auto;\n    display: block;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContainer = (0, _styledComponentsDefault.default).div(_templateObject(), function(props) {
    return props.$isFixed ? "100%" : "fit-content";
});
var StyledTableContainer = (0, _styledComponentsDefault.default).div(_templateObject1(), function(props) {
    return props.$isFixed ? "block" : "flex";
}, (0, _constants.COLORS).regalBlue, (0, _constants.COLORS).chatamsBlue);
var StyledTable = (0, _styledComponentsDefault.default).table(_templateObject2(), function(props) {
    return props.$isLoading && " \n    border: var(--pf-border-thin) solid var(--pf-border-color);\n    height: 100%;\n    width: 100%;\n  ";
});
var StyledThead = (0, _styledComponentsDefault.default).thead(_templateObject3(), (0, _constants.COLORS).blackPearl);
var StyledTh = (0, _styledComponentsDefault.default).th(_templateObject4(), function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "300px";
}, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "auto";
}, function(props) {
    return props.$noPadding ? 0 : "0 8px";
}, (0, _constants.COLORS).ebony, (0, _constants.TYPOGRAPHY).fontSize.base);
var StyledTbody = (0, _styledComponentsDefault.default).tbody(_templateObject5());
var StyledBodyTr = (0, _styledComponentsDefault.default).tr(_templateObject6(), function(props) {
    return props.$isSelected ? "#112341" : "transparent";
});
var StyledTd = (0, _styledComponentsDefault.default).td(_templateObject7(), function(props) {
    return props.$noPadding ? 0 : "5px 8px";
}, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).white, (0, _constants.COLORS).mirage, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "300px";
}, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "auto";
}, function(props) {
    var _props_$textAlign;
    return (_props_$textAlign = props.$textAlign) !== null && _props_$textAlign !== void 0 ? _props_$textAlign : "left";
});
var CenteredRow = (0, _styledComponentsDefault.default).td(_templateObject8(), function(props) {
    return props.$isLoading ? "shimmer 3s ease-in-out infinite" : "none";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5NUdg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", function() {
    return 0, _actionBar.ActionBar;
});
var _actionBar = require("./ActionBar");

},{"./ActionBar":"kjRBa","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kjRBa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", function() {
    return ActionBar;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionBarStyles = require("./ActionBar.styles");
function ActionBar(param) {
    var table = param.table, isFixed = param.isFixed, TableActions = param.TableActions;
    var selectedItems = table.getRowModel().rows.filter(function(row) {
        return row.getIsSelected();
    });
    var unselectRows = function() {
        table.getRowModel().rows.forEach(function(row) {
            row.toggleSelected(false);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _actionBarStyles.StyledActionBar), {
        isFixed: isFixed,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionBarStyles.StyledTextContainer), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        selectedItems.length,
                        " ",
                        selectedItems.length > 1 ? "items" : "item",
                        " selected"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _actionBarStyles.StyledButtonContainer), {
                children: TableActions && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableActions, {
                    selectedItems: selectedItems,
                    unselectRows: unselectRows
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./ActionBar.styles":"2iFG2","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2iFG2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledActionBar", function() {
    return StyledActionBar;
});
parcelHelpers.export(exports, "StyledTextContainer", function() {
    return StyledTextContainer;
});
parcelHelpers.export(exports, "StyledButtonContainer", function() {
    return StyledButtonContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  position: fixed;\n  bottom: 100px;\n  left: ",
        ";\n\n  border-radius: 8px;\n  border: 3px solid ",
        ";\n\n  background-color: ",
        ";\n  padding: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 10px 8px;\n\n  span {\n    font-size: ",
        ";\n    font-weight: 500;\n    line-height: 24px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledActionBar = (0, _styledComponentsDefault.default).div(_templateObject(), function(props) {
    return props.isFixed ? "50%" : 0;
}, (0, _constants.COLORS).portGore, (0, _constants.COLORS).midnight);
var StyledTextContainer = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).white);
var StyledButtonContainer = (0, _styledComponentsDefault.default).div(_templateObject2());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iFW5N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _pagination.Pagination;
});
var _pagination = require("./Pagination");

},{"./Pagination":"1mGDS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1mGDS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return Pagination;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paginationStyles = require("./Pagination.styles");
function Pagination(param) {
    var currentPage = param.currentPage, totalPageCount = param.totalPageCount, totalRowCount = param.totalRowCount, totalRowsOnPage = param.totalRowsOnPage, paginationLimit = param.paginationLimit, nextPage = param.nextPage, previousPage = param.previousPage;
    var isLastPage = currentPage === totalPageCount - 1;
    var isFirstPage = currentPage === 0;
    var firstRowPosition = currentPage * paginationLimit;
    var handlePreviousPage = function() {
        if (currentPage > 0) previousPage();
    };
    var handleNextPage = function() {
        if (currentPage < totalPageCount - 1) nextPage();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paginationStyles.StyledPagination), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paginationStyles.StyledPaginationInfo), {
                children: [
                    "Showing ",
                    firstRowPosition + 1,
                    " - ",
                    firstRowPosition + totalRowsOnPage,
                    " of ",
                    totalRowCount,
                    " ",
                    "entries"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paginationStyles.StyledPaginationControls), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationStyles.StyledIcon), {
                        name: "chevron-left",
                        onClick: handlePreviousPage,
                        isDisabled: isFirstPage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paginationStyles.StyledText), {
                        children: [
                            "Page",
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationStyles.StyledPageNumber), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: currentPage + 1
                                })
                            }),
                            "of ",
                            totalPageCount === 0 || !totalPageCount ? 1 : totalPageCount
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationStyles.StyledIcon), {
                        name: "chevron-right",
                        onClick: handleNextPage,
                        isDisabled: isLastPage
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./Pagination.styles":"3Csoo","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3Csoo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPagination", function() {
    return StyledPagination;
});
parcelHelpers.export(exports, "StyledPaginationInfo", function() {
    return StyledPaginationInfo;
});
parcelHelpers.export(exports, "StyledPaginationControls", function() {
    return StyledPaginationControls;
});
parcelHelpers.export(exports, "StyledText", function() {
    return StyledText;
});
parcelHelpers.export(exports, "StyledPageNumber", function() {
    return StyledPageNumber;
});
parcelHelpers.export(exports, "StyledIcon", function() {
    return StyledIcon;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _icon = require("Permafrost/components/ui-foundations/Icon/Icon");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 10px;\n  margin-right: 24px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  line-height: 20px;\n  color: #8593b3;\n  user-select: none;\n\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 1px solid #198bdc;\n  border-radius: 2px;\n\n  height: 24px;\n  width: 24px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n\n  span {\n    font-size: ",
        ";\n\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 20px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 14px;\n  width: 14px;\n  cursor: ",
        ";\n\n  &:hover {\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPagination = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledPaginationInfo = (0, _styledComponentsDefault.default).div(_templateObject1());
var StyledPaginationControls = (0, _styledComponentsDefault.default).div(_templateObject2());
var StyledText = (0, _styledComponentsDefault.default).span(_templateObject3(), (0, _constants.TYPOGRAPHY).fontSize.base);
var StyledPageNumber = (0, _styledComponentsDefault.default).span(_templateObject4(), (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).white);
var StyledIcon = (0, _styledComponentsDefault.default)((0, _icon.Icon))(_templateObject5(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "normal" : "pointer";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "1" : "0.5";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/components/ui-foundations/Icon/Icon":"cld9p","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f4dRq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResults", function() {
    return 0, _noResults.NoResults;
});
var _noResults = require("./NoResults");

},{"./NoResults":"gXXJm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gXXJm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResults", function() {
    return NoResults;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noResultsStyles = require("./NoResults.styles");
function NoResults(param) {
    var clearFilters = param.clearFilters, hasFiltersApplied = param.hasFiltersApplied, message = param.message;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _noResultsStyles.StyledNoResults), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: message
            }),
            hasFiltersApplied && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        onClick: clearFilters,
                        children: "Click here"
                    }),
                    " to reset the filters."
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./NoResults.styles":"gOU6Z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gOU6Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNoResults", function() {
    return StyledNoResults;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n\n  position: sticky;\n  left: 0;\n  margin: 30px auto;\n\n  p {\n    font-size: ",
        ";\n    font-weight: 500;\n    color: ",
        ";\n\n    span {\n      color: ",
        ";\n      cursor: pointer;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNoResults = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).white, (0, _constants.COLORS).summerSky);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e1wbT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * List of users of a Dataset or Workflow. If an owner is specified, they will appear
 * first in the list, and will not be deletable.
 */ parcelHelpers.export(exports, "TeamTable", function() {
    return TeamTable;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _teamTableStyles = require("./TeamTable.styles");
function TeamTable(props) {
    var className = props.className, id = props.id, labelledby = props.labelledby, owner = props.owner, removeUser = props.removeUser, users = props.users;
    var listItems = [];
    if (owner) listItems.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "table-row",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: owner.email
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: returnFormattedRole(owner.role)
            })
        ]
    }, owner.userId));
    users.forEach(function(user) {
        return listItems.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _classnamesDefault.default)("table-row", user.rowClassName),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: user.email
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: returnFormattedRole(user.role)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    title: "remove team member",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        onClick: function() {
                            return removeUser(user.userId);
                        },
                        variant: "no-style",
                        "aria-label": "remove team member",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "trash",
                            size: [
                                "18px"
                            ]
                        })
                    })
                })
            ]
        }, user.userId));
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _teamTableStyles.StyledTeamTable), {
        "aria-labelledby": labelledby,
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        title: "",
        listHeader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "table-row heading",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Email"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Role"
                })
            ]
        }),
        listItems: listItems
    });
}
// ensures Role is nicely formatted in the UI
function returnFormattedRole(role) {
    if (!role) return "";
    return role === "LABELER_AND_REVIEWER" ? "Labeler & Reviewer" : (0, _utils.stringUtils).capitalize(role);
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./TeamTable.styles":"bTxGz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bTxGz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTeamTable", function() {
    return StyledTeamTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .table-row {\n    display: grid;\n    grid-template-columns: 1fr 1.2fr 30px;\n    padding-top: 10px;\n\n    &:not(.heading) {\n      padding-bottom: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTeamTable = (0, _styledComponentsDefault.default)((0, _index.ListTable))(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7DipF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wizard", function() {
    return 0, _wizard.Wizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return 0, _wizardStyles.WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return 0, _wizardStyles.WizardSection;
});
parcelHelpers.export(exports, "StyledWizard", function() {
    return 0, _wizardStyles.StyledWizard;
});
var _wizard = require("./Wizard");
var _wizardStyles = require("./Wizard.styles");

},{"./Wizard":"lWWX2","./Wizard.styles":"54yjB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lWWX2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wizard", function() {
    return Wizard;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _wizardStyles = require("./Wizard.styles");
var commonButtonProps = {
    adjustAlignment: -2,
    size: "large"
};
function Wizard(props) {
    var children = props.children, className = props.className, confirmCancel = props.confirmCancel, disableNextStep = props.disableNextStep, disablePrevStep = props.disablePrevStep, disableSubmit = props.disableSubmit, id = props.id, isLastStep = props.isLastStep, onCancel = props.onCancel, onNextPress = props.onNextPress, onStepChange = props.onStepChange, onSubmit = props.onSubmit, startingStep = props.startingStep, steps = props.steps, submitButtonLabel = props.submitButtonLabel, _props_submitProcessing = props.submitProcessing, submitProcessing = _props_submitProcessing === void 0 ? "" : _props_submitProcessing, wizardTitle = props.wizardTitle, nextButtonProps = props.nextButtonProps;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(startingStep || steps[0]), 2), currentStep = _useState[0], setCurrentStep = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), openCancelConfirm = _useState1[0], setOpenCancelConfirm = _useState1[1];
    var onLastStep = (0, _react.useMemo)(function() {
        if (isLastStep !== undefined) return isLastStep;
        return steps.indexOf(currentStep) === steps.length - 1;
    }, [
        isLastStep,
        steps,
        currentStep
    ]);
    var isBusy = !!(submitProcessing && submitProcessing.length > 0);
    var nextStep = function() {
        if (!onLastStep) {
            var currentIndex = steps.indexOf(currentStep);
            setCurrentStep(steps[currentIndex + 1]);
        }
    };
    var prevStep = function() {
        var currentIndex = steps.indexOf(currentStep);
        if (currentIndex !== 0) setCurrentStep(steps[currentIndex - 1]);
    };
    // handles the user's selection in the cancel confirmation modal
    var handleCancelRequest = function(confirmCancel) {
        if (confirmCancel && onCancel) onCancel();
        setOpenCancelConfirm(false);
    };
    var handleNextPress = function() {
        var allowNext = onNextPress ? onNextPress() : true;
        if (!allowNext) return;
        if (onLastStep) handleSubmit();
        else nextStep();
    };
    var handleSubmit = function() {
        onSubmit();
    };
    // report current step to the consuming component
    (0, _react.useEffect)(function() {
        onStepChange(currentStep);
    }, [
        currentStep
    ]);
    // ensures `currentStep` is reset on unmount, just in case
    (0, _react.useEffect)(function() {
        return function() {
            return setCurrentStep(steps[0] || "");
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _wizardStyles.StyledWizard), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                        children: [
                            wizardTitle,
                            ": ",
                            currentStep
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wizard-buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                                onClick: function() {
                                    return setOpenCancelConfirm(true);
                                },
                                variant: "link-style",
                                children: "Cancel"
                            }),
                            steps.indexOf(currentStep) !== 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonButtonProps), {
                                iconName: "fa-arrow-left",
                                label: "Previous Step",
                                onPress: prevStep,
                                isDisabled: disablePrevStep
                            })),
                            onLastStep ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), (0, _objectSpreadProps._)((0, _objectSpread._)({}, commonButtonProps), {
                                variant: "primary",
                                iconName: "check",
                                busy: isBusy,
                                label: isBusy ? submitProcessing : submitButtonLabel,
                                onPress: handleNextPress,
                                isDisabled: disableSubmit
                            })) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.IconButton), (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, commonButtonProps), {
                                variant: "primary",
                                iconSide: "end",
                                iconName: "fa-arrow-right",
                                label: "Next Step",
                                onPress: handleNextPress,
                                isDisabled: disableNextStep
                            }), nextButtonProps))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.ConfirmModal), {
                title: confirmCancel.title,
                message: confirmCancel.message,
                confirmText: confirmCancel.confirmText,
                rejectText: confirmCancel.rejectText,
                open: openCancelConfirm,
                clickOutsideHandler: function() {
                    return setOpenCancelConfirm(false);
                },
                responseHandler: handleCancelRequest
            })
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./Wizard.styles":"54yjB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"54yjB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledWizard", function() {
    return StyledWizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return WizardSection;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    margin-bottom: 24px;\n\n    // override for some styling in AppChrome IPA component\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  h1 {\n    margin-bottom: 0;\n  }\n\n  .wizard-buttons {\n    display: flex;\n    align-items: center;\n\n    font-size: ",
        ";\n\n    button.link-style {\n      font-size: inherit;\n      margin-right: 1em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  padding: 14px ",
        ";\n\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 1px 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .section-heading {\n    margin-bottom: 0;\n    // todo: store value elsewhere\n    font-size: 22px;\n    color: ",
        ";\n\n    .supporting-text {\n      font-size: ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  .section-content {\n    padding: ",
        ";\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n\n    .section-content {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledWizard = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge);
var commonPadding = "20px";
var WizardCard = (0, _styledComponentsDefault.default).div(_templateObject1(), commonPadding, (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony);
var WizardSection = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).lightFontColor, (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).defaultFontColor, commonPadding, commonPadding, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hym5P":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * General-purpose drag-and-drop list component. Pass in an array of React components along with
 * an array of id strings associated with each component, and an `<ul>` containing re-sortable
 * `<li>`s is created.
 *
 * Avoid margin styling in the components passed into `items`, otherwise the drag/drop motion can
 * get janky. Instead, use the `itemsVerticalGap` prop to add a margin-bottom to each item.
 *
 * Want to target your item while it’s being dragged? Pass a SetStateAction down from the parent;
 * see Storybook stories for an example implementation.
 */ parcelHelpers.export(exports, "DragDropVerticalList", function() {
    return DragDropVerticalList;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("@hello-pangea/dnd");
var _uuid = require("uuid");
var _utils = require("@indico-data/utils");
var _dragDropVerticalListStyles = require("./DragDropVerticalList.styles");
var droppableId = (0, _uuid.v4)();
function DragDropVerticalList(props) {
    var itemIdList = props.itemIdList, items = props.items, itemsVerticalGap = props.itemsVerticalGap, listStyleClass = props.listStyleClass, lockAxis = props.lockAxis, onDrop = props.onDrop, updateDraggedItem = props.updateDraggedItem;
    var handleDragEnd = function(result) {
        if (result.destination) {
            updateDraggedItem && updateDraggedItem("");
            var items = (0, _utils.arrayUtils).reorderItem(itemIdList, result.source.index, result.destination.index);
            onDrop(items);
        }
    };
    var handleDragStart = function(initial) {
        updateDraggedItem && updateDraggedItem(itemIdList[initial.source.index]);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.DragDropContext), {
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
            droppableId: droppableId,
            children: function(provided) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ul", (0, _objectSpreadProps._)((0, _objectSpread._)({
                    ref: provided.innerRef
                }, provided.droppableProps), {
                    className: listStyleClass,
                    style: {
                        marginBottom: itemsVerticalGap && "-".concat(itemsVerticalGap)
                    },
                    children: [
                        items.map(function(item, i) {
                            var id = "".concat(droppableId, "-").concat(i);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
                                draggableId: id,
                                index: i,
                                children: function(provided) {
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dragDropVerticalListStyles.StyledLi), (0, _objectSpreadProps._)((0, _objectSpread._)({
                                        ref: provided.innerRef
                                    }, provided.draggableProps, provided.dragHandleProps), {
                                        style: getStyle(provided.draggableProps.style, itemsVerticalGap, lockAxis),
                                        $lockAxis: lockAxis,
                                        children: item
                                    }));
                                }
                            }, id);
                        }),
                        provided.placeholder
                    ]
                }));
            }
        })
    });
}
/**
 * Patches `react-beautiful-dnd` styles to optionally incorporate a horizontal axis lock for the
 * dragged element, and/or add a bottom margin to list items (if specified)
 *
 * ref: https://github.com/atlassian/react-beautiful-dnd/issues/538#issuecomment-741848961
 */ function getStyle(style, itemsMargin, lockAxis) {
    var styleProps = (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
        marginBottom: itemsMargin
    });
    if (lockAxis && (styleProps === null || styleProps === void 0 ? void 0 : styleProps.transform)) {
        var axisLock = "translate(0px, ".concat(styleProps.transform.split(",").pop());
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, styleProps), {
            transform: axisLock
        });
    }
    return styleProps;
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","@hello-pangea/dnd":"bhM3h","uuid":"6ZyFu","@indico-data/utils":"47VRj","./DragDropVerticalList.styles":"i14aC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"i14aC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLi", function() {
    return StyledLi;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // note that scale and shadow are being applied to the passed-in child component, not\n  // the parent draggable li.\n  > * {\n    transition: transform 0.2s;\n  }\n\n  &:active {\n    cursor: grabbing;\n\n    > * {\n      transform: scale(",
        ");\n      box-shadow: rgba(0, 0, 0, 0.5) 0 4px 8px 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLi = (0, _styledComponentsDefault.default).li(_templateObject(), function(props) {
    return props.$lockAxis ? 1.05 : 1;
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fQQMg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Base modal component, powered by [react-modal](http://reactcommunity.org/react-modal/#usage)
 *
 * (Also see `ModalAdapter` in the styles file)
 *
 * Accessible element label must be included either as a string passed to `labelText`, or
 * the id of one of the children passed to `labelElement`. If a description is available,
 * pass that element’s id to the `describedBy` prop.
 */ parcelHelpers.export(exports, "ModalBase", function() {
    return ModalBase;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalBaseStyles = require("./ModalBase.styles");
function ModalBase(props) {
    var children = props.children, className = props.className, clickToDismiss = props.clickToDismiss, describedBy = props.describedBy, id = props.id, node = props.node, open = props.open, preventEscDismiss = props.preventEscDismiss, preventReturnFocus = props.preventReturnFocus, maxWidth = props.maxWidth;
    var ariaProps = {};
    if ("labelElement" in props) ariaProps["labelledby"] = props.labelElement;
    if (describedBy) ariaProps["describedby"] = describedBy;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalBaseStyles.StyledModalBase), {
        ariaHideApp: false,
        "data-cy": props["data-cy"],
        aria: ariaProps,
        className: className || "baseModal",
        contentLabel: "labelText" in props ? props.labelText : null,
        id: id,
        isOpen: open,
        node: node,
        onRequestClose: clickToDismiss,
        shouldCloseOnEsc: !preventEscDismiss,
        shouldReturnFocusAfterClose: !preventReturnFocus,
        maxWidth: maxWidth,
        children: children
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./ModalBase.styles":"a1l4r","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a1l4r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledModalBase", function() {
    return StyledModalBase;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _utils = require("@indico-data/utils");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .",
        "__content {\n    position: absolute;\n    top: 70px;\n    left: 50%;\n    transform: translateX(-50%);\n\n    overflow: visible;\n    padding: 0;\n\n    border-radius: 4px;\n    background-color: ",
        ";\n    border: solid 1px ",
        ";\n    outline: none;\n\n    width: ",
        ";\n    max-width: ",
        ";\n  }\n\n  .",
        "__overlay {\n    z-index: 900;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    background-color: ",
        ";\n  }\n\n  .ReactModal__Overlay {\n    opacity: 0;\n\n    transition: opacity 120ms ease-in-out;\n  }\n\n  .ReactModal__Overlay--after-open {\n    opacity: 1;\n    position: fixed;\n  }\n\n  .ReactModal__Overlay--before-close {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// see: https://github.com/reactjs/react-modal/issues/603
function ModalAdapter(props) {
    (0, _react.useEffect)(function() {
        (0, _reactModalDefault.default).setAppElement(props.node || "#root");
    }, [
        props.node
    ]);
    var className = props.className;
    var contentClassName = "".concat(className, "__content");
    var overlayClassName = "".concat(className, "__overlay");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        portalClassName: className,
        className: contentClassName,
        overlayClassName: overlayClassName,
        closeTimeoutMS: 120,
        children: props.children
    }));
}
var StyledModalBase = (0, _styledComponentsDefault.default)(ModalAdapter)(_templateObject(), function(props) {
    return props.className;
}, (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, function(props) {
    return props.maxWidth ? "100%" : "auto";
}, function(props) {
    return props.maxWidth || "none";
}, function(props) {
    return props.className;
}, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).mirage, 0.95));

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_tagged_template_literal":"9gf6S","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-modal":"4ySdL","styled-components":"6Gjjc","Permafrost/index":"iliLC","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4ySdL":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Modal = require("61f3c1f4b26edd90");
var _Modal2 = _interopRequireDefault(_Modal);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _Modal2.default;
module.exports = exports["default"];

},{"61f3c1f4b26edd90":"4ISkm"}],"4ISkm":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("9a25229d9e827b16");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("f910a939b759baac");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = require("a79c9e589690789c");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalPortal = require("34c4b69c6470c61b");
var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
var _ariaAppHider = require("e68a5208ad96e647");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = require("573142d9c97c52f");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _reactLifecyclesCompat = require("ad84566654669dc0");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
var createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var getCreatePortal = function getCreatePortal() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector) {
    return parentSelector();
}
var Modal = function(_Component) {
    _inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function _ret() {
            !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = getCreatePortal();
            var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!_safeHTMLElement.canUseDOM) return;
                if (!isReact16) this.node = createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = getParentElement(prevProps.parentSelector);
                var nextParent = getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!_safeHTMLElement.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!_safeHTMLElement.canUseDOM || !isReact16) return null;
                if (!this.node && isReact16) this.node = createHTMLElement("div");
                var createPortal = getCreatePortal();
                return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}(_react.Component);
Modal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
    isOpen: false,
    portalClassName: portalClassName,
    bodyOpenClassName: bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return _react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return _react2.default.createElement("div", props, children);
    }
};
Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, _reactLifecyclesCompat.polyfill)(Modal);
exports.default = Modal;

},{"@swc/helpers/_/_type_of":"6Gp9n","9a25229d9e827b16":"ktQNc","f910a939b759baac":"lyZO5","a79c9e589690789c":"8INHm","34c4b69c6470c61b":"jbOTh","e68a5208ad96e647":"9sVIk","573142d9c97c52f":"l9zpv","ad84566654669dc0":"locvK"}],"jbOTh":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && (0, _typeOf._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("d320e8781d21c2c5");
var _propTypes = require("33d52b094ecec2e0");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusManager = require("bfbfef75d8e85e0");
var focusManager = _interopRequireWildcard(_focusManager);
var _scopeTab = require("8960111ee2cff0b2");
var _scopeTab2 = _interopRequireDefault(_scopeTab);
var _ariaAppHider = require("75f7ac26c5b4b642");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _classList = require("232716fc77648a71");
var classList = _interopRequireWildcard(_classList);
var _safeHTMLElement = require("5ca8a1c1e3ad494a");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _portalOpenInstances = require("ce306d5e4e8279b3");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
require("56e2a18c3da1ec8b");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeOf._)(superClass)));
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var TAB_KEY = 9;
var ESC_KEY = 27;
var ariaHiddenInstances = 0;
var ModalPortal = function(_Component) {
    _inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        _classCallCheck(this, ModalPortal);
        var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && ariaHiddenInstances > 0) {
                ariaHiddenInstances -= 1;
                if (ariaHiddenInstances === 0) ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    focusManager.returnFocus(_this.props.preventScroll);
                    focusManager.teardownScopedFocus();
                } else focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            _portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    focusManager.setupScopedFocus(_this.node);
                    focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === TAB_KEY) (0, _scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
                base: CLASS_NAMES[which],
                afterOpen: CLASS_NAMES[which] + "--after-open",
                beforeClose: CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    _createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    ariaHiddenInstances += 1;
                    ariaAppHider.hide(appElement);
                }
                _portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: _extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = _extends({
                    id: id,
                    ref: this.setContentRef,
                    style: _extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", _extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}(_react.Component);
ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
ModalPortal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    defaultStyles: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    ariaHideApp: _propTypes2.default.bool,
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onAfterClose: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    children: _propTypes2.default.node,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func,
    testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

},{"@swc/helpers/_/_type_of":"6Gp9n","d320e8781d21c2c5":"ktQNc","33d52b094ecec2e0":"8INHm","bfbfef75d8e85e0":"hyVka","8960111ee2cff0b2":"24fKQ","75f7ac26c5b4b642":"9sVIk","232716fc77648a71":"cF0FY","5ca8a1c1e3ad494a":"l9zpv","ce306d5e4e8279b3":"cT3nw","56e2a18c3da1ec8b":"jVQNB"}],"hyVka":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;
var _tabbable = require("a3112cb65ea2b6f");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    focusLaterElements = [];
}
/* istanbul ignore next */ function log() {}
/* eslint-enable no-console */ function handleBlur() {
    needToFocus = true;
}
function handleFocus() {
    if (needToFocus) {
        needToFocus = false;
        if (!modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if (modalElement.contains(document.activeElement)) return;
            var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
            el.focus();
        }, 0);
    }
}
function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if (focusLaterElements.length !== 0) {
            toFocus = focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
    modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", handleBlur, false);
        document.addEventListener("focus", handleFocus, true);
    } else {
        window.attachEvent("onBlur", handleBlur);
        document.attachEvent("onFocus", handleFocus);
    }
}
function teardownScopedFocus() {
    modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", handleBlur);
        document.removeEventListener("focus", handleFocus);
    } else {
        window.detachEvent("onBlur", handleBlur);
        document.detachEvent("onFocus", handleFocus);
    }
}

},{"a3112cb65ea2b6f":"7O2nK"}],"7O2nK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var tabbableNode = /input|select|textarea|button|object|iframe/;
function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if (hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}
function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable);
}
module.exports = exports["default"];

},{}],"24fKQ":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scopeTab;
var _tabbable = require("f055893759989bbd");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function scopeTab(node, event) {
    var tabbable = (0, _tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = exports["default"];

},{"f055893759989bbd":"7O2nK"}],"9sVIk":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = require("6eb0682e790e32c7");
var _warning2 = _interopRequireDefault(_warning);
var _safeHTMLElement = require("776bf46766969f66");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    if (globalElement) {
        if (globalElement.removeAttribute) globalElement.removeAttribute("aria-hidden");
        else if (globalElement.length != null) globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll(globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    globalElement = null;
}
/* istanbul ignore next */ function log() {
    var check;
}
/* eslint-enable no-console */ function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        assertNodeList(el, useElement);
        useElement = el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
}
function validateElement(appElement) {
    var el = appElement || globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, _warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function documentNotReadyOrSSRTesting() {
    globalElement = null;
}

},{"6eb0682e790e32c7":"iO0OJ","776bf46766969f66":"l9zpv"}],"iO0OJ":[function(require,module,exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function warning() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"l9zpv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
var _exenv = require("dfc9e0e910107876");
var _exenv2 = _interopRequireDefault(_exenv);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
var canUseDOM = exports.canUseDOM = EE.canUseDOM;
exports.default = SafeHTMLElement;

},{"dfc9e0e910107876":"jg3C3"}],"jg3C3":[function(require,module,exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{}],"cF0FY":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in htmlClassList)removeClass(htmlElement, htmlClassList[cls]);
    var body = document.body;
    for(var _cls in docBodyClassList)removeClass(body, docBodyClassList[_cls]);
    htmlClassList = {};
    docBodyClassList = {};
}
/* istanbul ignore next */ function log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var add = exports.add = function add(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var remove = exports.remove = function remove(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

},{}],"cT3nw":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
exports.resetState = resetState;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    _classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function log() {
    console.log("portalOpenInstances ----------");
    console.log(portalOpenInstances.openInstances.length);
    portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function resetState() {
    portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */ exports.default = portalOpenInstances;

},{}],"jVQNB":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var _portalOpenInstances = require("90d3c301f2b237b9");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var before = void 0, after = void 0, instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    var _arr = [
        before,
        after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    before = after = null;
    instances = [];
}
/* istanbul ignore next */ function log() {
    console.log("bodyTrap ----------");
    console.log(instances.length);
    var _arr2 = [
        before,
        after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function focusContent() {
    if (instances.length === 0) return;
    instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
    if (!before && !after) {
        before = document.createElement("div");
        before.setAttribute("data-react-modal-body-trap", "");
        before.style.position = "absolute";
        before.style.opacity = "0";
        before.setAttribute("tabindex", "0");
        before.addEventListener("focus", focusContent);
        after = before.cloneNode();
        after.addEventListener("focus", focusContent);
    }
    instances = openInstances;
    if (instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== before) document.body.insertBefore(before, document.body.firstChild);
        if (document.body.lastChild !== after) document.body.appendChild(after);
    } else {
        // Remove focus trap
        if (before.parentElement) before.parentElement.removeChild(before);
        if (after.parentElement) after.parentElement.removeChild(after);
    }
}
_portalOpenInstances2.default.subscribe(bodyTrap);

},{"90d3c301f2b237b9":"cT3nw"}],"locvK":[function(require,module,exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", function() {
    return polyfill;
});
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aCsXt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioContext", function() {
    return RadioContext;
});
/**
 * Renders a group of radio buttons with no styling. This component is not
 * designed to be user-facing, and should only be used to provide functionality.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "RadioGroup", function() {
    return RadioGroup;
});
/**
 * A single radio button and its label; no styling is applied, and the native
 * radio button is visually hidden.
 */ parcelHelpers.export(exports, "Radio", function() {
    return Radio;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _radio = require("@react-aria/radio");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _reactStately = require("react-stately");
var _radioGroupStyles = require("./RadioGroup.styles");
var RadioContext = /*#__PURE__*/ (0, _react.createContext)(null);
function RadioGroup(props) {
    var children = props.children, className = props.className, value = props.value, id = props.id, isDisabled = props.isDisabled, isReadOnly = props.isReadOnly, label = props.label, name = props.name, onChange = props.onChange, orientation = props.orientation;
    var radioGroupStateProps = {
        isDisabled: isDisabled || false,
        isReadOnly: isReadOnly || false,
        name: name || "",
        value: value,
        onChange: onChange,
        children: children
    };
    var state = (0, _reactStately.useRadioGroupState)(radioGroupStateProps);
    var _useRadioGroup = (0, _radio.useRadioGroup)(props, state), radioGroupProps = _useRadioGroup.radioGroupProps, labelProps = _useRadioGroup.labelProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupStyles.StyledRadioGroup), (0, _objectSpreadProps._)((0, _objectSpread._)({}, radioGroupProps), {
        className: (0, _classnamesDefault.default)(className, {
            horizontal: orientation === "horizontal"
        }),
        "data-cy": props["data-cy"],
        id: id,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({
                className: "groupLabel"
            }, labelProps), {
                children: label
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioContext.Provider, {
                value: state,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: children
                })
            })
        ]
    }));
}
function Radio(props) {
    var children = props.children, className = props.className, isDisabled = props.isDisabled, isVisuallySelected = props.isVisuallySelected;
    var state = (0, _react.useContext)(RadioContext);
    var inputRef = (0, _react.useRef)(null);
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var inputProps = (0, _radio.useRadio)(props, state, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var isSelected;
    if (isVisuallySelected) isSelected = isVisuallySelected(state === null || state === void 0 ? void 0 : state.selectedValue);
    else isSelected = (state === null || state === void 0 ? void 0 : state.selectedValue) === props.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: (0, _classnamesDefault.default)(className, {
            disabled: isDisabled || (state === null || state === void 0 ? void 0 : state.isDisabled),
            selected: isSelected,
            focused: isFocusVisible
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", (0, _objectSpreadProps._)((0, _objectSpread._)({}, inputProps, visuallyHiddenProps, focusProps), {
                ref: inputRef
            })),
            children
        ]
    });
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@react-aria/radio":"fHWyH","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","react-stately":"l7DHI","./RadioGroup.styles":"dx8KP","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fHWyH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRadio", function() {
    return $0d5c49892c1215da$export$37b0961d2f4751e2;
});
parcelHelpers.export(exports, "useRadioGroup", function() {
    return $430f30ed08ec25fa$export$62b9571f283ff5c2;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _form = require("@react-aria/form");
var _interactions = require("@react-aria/interactions");
var _label = require("@react-aria/label");
var _i18N = require("@react-aria/i18n");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $884aeceb3d67f00f$export$37b65e5b5444d35c = new WeakMap();
function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
    var value = props.value, children = props.children, ariaLabel = props["aria-label"], ariaLabelledby = props["aria-labelledby"];
    var isDisabled = props.isDisabled || state.isDisabled;
    var hasChildren = children != null;
    var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
    var checked = state.selectedValue === value;
    var onChange = function(e) {
        e.stopPropagation();
        state.setSelectedValue(value);
    };
    var _$4vDl6$usePress = (0, _interactions.usePress)({
        isDisabled: isDisabled
    }), pressProps = _$4vDl6$usePress.pressProps, isPressed = _$4vDl6$usePress.isPressed;
    // iOS does not toggle radios if you drag off and back onto the label, so handle it ourselves.
    var _$4vDl6$usePress1 = (0, _interactions.usePress)({
        isDisabled: isDisabled,
        onPress: function() {
            state.setSelectedValue(value);
        }
    }), labelProps = _$4vDl6$usePress1.pressProps, isLabelPressed = _$4vDl6$usePress1.isPressed;
    var _$4vDl6$useFocusable = (0, _focus.useFocusable)((0, _utils.mergeProps)(props, {
        onFocus: function() {
            return state.setLastFocusedValue(value);
        }
    }), ref), focusableProps = _$4vDl6$useFocusable.focusableProps;
    var interactions = (0, _utils.mergeProps)(pressProps, focusableProps);
    var domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    var tabIndex = -1;
    if (state.selectedValue != null) {
        if (state.selectedValue === value) tabIndex = 0;
    } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
    if (isDisabled) tabIndex = undefined;
    var _$884aeceb3d67f00f$export$37b65e5b5444d35c_get = $884aeceb3d67f00f$export$37b65e5b5444d35c.get(state), name = _$884aeceb3d67f00f$export$37b65e5b5444d35c_get.name, descriptionId = _$884aeceb3d67f00f$export$37b65e5b5444d35c_get.descriptionId, errorMessageId = _$884aeceb3d67f00f$export$37b65e5b5444d35c_get.errorMessageId, validationBehavior = _$884aeceb3d67f00f$export$37b65e5b5444d35c_get.validationBehavior;
    (0, _utils.useFormReset)(ref, state.selectedValue, state.setSelectedValue);
    (0, _form.useFormValidation)({
        validationBehavior: validationBehavior
    }, state, ref);
    return {
        labelProps: (0, _utils.mergeProps)(labelProps, {
            onClick: function(e) {
                return e.preventDefault();
            }
        }),
        inputProps: (0, _utils.mergeProps)(domProps, (0, _objectSpreadProps._)((0, _objectSpread._)({}, interactions), {
            type: "radio",
            name: name,
            tabIndex: tabIndex,
            disabled: isDisabled,
            required: state.isRequired && validationBehavior === "native",
            checked: checked,
            value: value,
            onChange: onChange,
            "aria-describedby": [
                props["aria-describedby"],
                state.isInvalid ? errorMessageId : null,
                descriptionId
            ].filter(Boolean).join(" ") || undefined
        })),
        isDisabled: isDisabled,
        isSelected: checked,
        isPressed: isPressed || isLabelPressed
    };
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $430f30ed08ec25fa$export$62b9571f283ff5c2(props, state) {
    var name = props.name, isReadOnly = props.isReadOnly, isRequired = props.isRequired, isDisabled = props.isDisabled, tmp = props.orientation, orientation = tmp === void 0 ? "vertical" : tmp, tmp1 = props.validationBehavior, validationBehavior = tmp1 === void 0 ? "aria" : tmp1;
    var _$4vDl6$useLocale = (0, _i18N.useLocale)(), direction = _$4vDl6$useLocale.direction;
    var _state_displayValidation = state.displayValidation, isInvalid = _state_displayValidation.isInvalid, validationErrors = _state_displayValidation.validationErrors, validationDetails = _state_displayValidation.validationDetails;
    var _$4vDl6$useField = (0, _label.useField)((0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        // Radio group is not an HTML input element so it
        // shouldn't be labeled by a <label> element.
        labelElementType: "span",
        isInvalid: state.isInvalid,
        errorMessage: props.errorMessage || validationErrors
    })), labelProps = _$4vDl6$useField.labelProps, fieldProps = _$4vDl6$useField.fieldProps, descriptionProps = _$4vDl6$useField.descriptionProps, errorMessageProps = _$4vDl6$useField.errorMessageProps;
    var domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    // When the radio group loses focus, reset the focusable radio to null if
    // there is no selection. This allows tabbing into the group from either
    // direction to go to the first or last radio.
    var _$4vDl6$useFocusWithin = (0, _interactions.useFocusWithin)({
        onBlurWithin: function(e) {
            var _props_onBlur;
            (_props_onBlur = props.onBlur) === null || _props_onBlur === void 0 || _props_onBlur.call(props, e);
            if (!state.selectedValue) state.setLastFocusedValue(null);
        },
        onFocusWithin: props.onFocus,
        onFocusWithinChange: props.onFocusChange
    }), focusWithinProps = _$4vDl6$useFocusWithin.focusWithinProps;
    var onKeyDown = function(e) {
        var nextDir;
        switch(e.key){
            case "ArrowRight":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "prev";
                else nextDir = "next";
                break;
            case "ArrowLeft":
                if (direction === "rtl" && orientation !== "vertical") nextDir = "next";
                else nextDir = "prev";
                break;
            case "ArrowDown":
                nextDir = "next";
                break;
            case "ArrowUp":
                nextDir = "prev";
                break;
            default:
                return;
        }
        e.preventDefault();
        var walker = (0, _focus.getFocusableTreeWalker)(e.currentTarget, {
            from: e.target
        });
        var nextElem;
        if (nextDir === "next") {
            nextElem = walker.nextNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.firstChild();
            }
        } else {
            nextElem = walker.previousNode();
            if (!nextElem) {
                walker.currentNode = e.currentTarget;
                nextElem = walker.lastChild();
            }
        }
        if (nextElem) {
            // Call focus on nextElem so that keyboard navigation scrolls the radio into view
            nextElem.focus();
            state.setSelectedValue(nextElem.value);
        }
    };
    var groupName = (0, _utils.useId)(name);
    $884aeceb3d67f00f$export$37b65e5b5444d35c.set(state, {
        name: groupName,
        descriptionId: descriptionProps.id,
        errorMessageId: errorMessageProps.id,
        validationBehavior: validationBehavior
    });
    return {
        radioGroupProps: (0, _utils.mergeProps)(domProps, (0, _objectSpread._)({
            // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
            role: "radiogroup",
            onKeyDown: onKeyDown,
            "aria-invalid": state.isInvalid || undefined,
            "aria-errormessage": props["aria-errormessage"],
            "aria-readonly": isReadOnly || undefined,
            "aria-required": isRequired || undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-orientation": orientation
        }, fieldProps, focusWithinProps)),
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        errorMessageProps: errorMessageProps,
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    };
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@react-aria/utils":"99Fak","@react-aria/focus":"dmSXv","@react-aria/form":"8T4V8","@react-aria/interactions":"7Ysj1","@react-aria/label":"k7UAz","@react-aria/i18n":"9LOix","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8T4V8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormValidation", function() {
    return $e93e671b31057976$export$b8473d3665f3a75a;
});
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _utils = require("@react-aria/utils");
/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $e93e671b31057976$export$b8473d3665f3a75a(props, state, ref) {
    var validationBehavior = props.validationBehavior, focus = props.focus;
    (0, _utils.useLayoutEffect)(function() {
        if (validationBehavior === "native" && (ref === null || ref === void 0 ? void 0 : ref.current)) {
            var errorMessage = state.realtimeValidation.isInvalid ? state.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
            ref.current.setCustomValidity(errorMessage);
            // Prevent default tooltip for validation message.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=605277
            if (!ref.current.hasAttribute("title")) ref.current.title = "";
            if (!state.realtimeValidation.isInvalid) state.updateValidation($e93e671b31057976$var$getNativeValidity(ref.current));
        }
    });
    var onReset = (0, _utils.useEffectEvent)(function() {
        state.resetValidation();
    });
    var onInvalid = (0, _utils.useEffectEvent)(function(e) {
        var _ref_current;
        // Only commit validation if we are not already displaying one.
        // This avoids clearing server errors that the user didn't actually fix.
        if (!state.displayValidation.isInvalid) state.commitValidation();
        // Auto focus the first invalid input in a form, unless the error already had its default prevented.
        var form = ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.form;
        if (!e.defaultPrevented && ref && form && $e93e671b31057976$var$getFirstInvalidInput(form) === ref.current) {
            var _ref_current1;
            if (focus) focus();
            else (_ref_current1 = ref.current) === null || _ref_current1 === void 0 || _ref_current1.focus();
            (0, _interactions.setInteractionModality)("keyboard");
        }
        // Prevent default browser error UI from appearing.
        e.preventDefault();
    });
    var onChange = (0, _utils.useEffectEvent)(function() {
        state.commitValidation();
    });
    (0, _react.useEffect)(function() {
        var input = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!input) return;
        var form = input.form;
        input.addEventListener("invalid", onInvalid);
        input.addEventListener("change", onChange);
        form === null || form === void 0 || form.addEventListener("reset", onReset);
        return function() {
            input.removeEventListener("invalid", onInvalid);
            input.removeEventListener("change", onChange);
            form === null || form === void 0 || form.removeEventListener("reset", onReset);
        };
    }, [
        ref,
        onInvalid,
        onChange,
        onReset,
        validationBehavior
    ]);
}
function $e93e671b31057976$var$getValidity(input) {
    // The native ValidityState object is live, meaning each property is a getter that returns the current state.
    // We need to create a snapshot of the validity state at the time this function is called to avoid unpredictable React renders.
    var validity = input.validity;
    return {
        badInput: validity.badInput,
        customError: validity.customError,
        patternMismatch: validity.patternMismatch,
        rangeOverflow: validity.rangeOverflow,
        rangeUnderflow: validity.rangeUnderflow,
        stepMismatch: validity.stepMismatch,
        tooLong: validity.tooLong,
        tooShort: validity.tooShort,
        typeMismatch: validity.typeMismatch,
        valueMissing: validity.valueMissing,
        valid: validity.valid
    };
}
function $e93e671b31057976$var$getNativeValidity(input) {
    return {
        isInvalid: !input.validity.valid,
        validationDetails: $e93e671b31057976$var$getValidity(input),
        validationErrors: input.validationMessage ? [
            input.validationMessage
        ] : []
    };
}
function $e93e671b31057976$var$getFirstInvalidInput(form) {
    for(var i = 0; i < form.elements.length; i++){
        var element = form.elements[i];
        if (!element.validity.valid) return element;
    }
    return null;
}

},{"react":"ktQNc","@react-aria/interactions":"7Ysj1","@react-aria/utils":"99Fak","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k7UAz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useField", function() {
    return $2baaea4c71418dea$export$294aa081a6c6f55d;
});
parcelHelpers.export(exports, "useLabel", function() {
    return $d191a55c9702f145$export$8467354a121f1b9f;
});
var _utils = require("@react-aria/utils");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $d191a55c9702f145$export$8467354a121f1b9f(props) {
    var id = props.id, label = props.label, ariaLabelledby = props["aria-labelledby"], ariaLabel = props["aria-label"], tmp = props.labelElementType, labelElementType = tmp === void 0 ? "label" : tmp;
    id = (0, _utils.useId)(id);
    var labelId = (0, _utils.useId)();
    var labelProps = {};
    if (label) {
        ariaLabelledby = ariaLabelledby ? "".concat(labelId, " ").concat(ariaLabelledby) : labelId;
        labelProps = {
            id: labelId,
            htmlFor: labelElementType === "label" ? id : undefined
        };
    } else if (!ariaLabelledby && !ariaLabel) console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
    var fieldProps = (0, _utils.useLabels)({
        id: id,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps
    };
}
function $2baaea4c71418dea$export$294aa081a6c6f55d(props) {
    var description = props.description, errorMessage = props.errorMessage, isInvalid = props.isInvalid, validationState = props.validationState;
    var _$d191a55c9702f145$export$8467354a121f1b9f = $d191a55c9702f145$export$8467354a121f1b9f(props), labelProps = _$d191a55c9702f145$export$8467354a121f1b9f.labelProps, fieldProps = _$d191a55c9702f145$export$8467354a121f1b9f.fieldProps;
    var descriptionId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    var errorMessageId = (0, _utils.useSlotId)([
        Boolean(description),
        Boolean(errorMessage),
        isInvalid,
        validationState
    ]);
    fieldProps = (0, _utils.mergeProps)(fieldProps, {
        "aria-describedby": [
            descriptionId,
            // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
            errorMessageId,
            props["aria-describedby"]
        ].filter(Boolean).join(" ") || undefined
    });
    return {
        labelProps: labelProps,
        fieldProps: fieldProps,
        descriptionProps: {
            id: descriptionId
        },
        errorMessageProps: {
            id: errorMessageId
        }
    };
}

},{"@react-aria/utils":"99Fak","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9LOix":[function(require,module,exports) {
// useMessageFormatter is deprecated, but has a large dependency on intl-messageformat
// that we want to avoid. If it is built into the same file as the rest of the package,
// it deopts tree shaking in Parcel even when unused. Instead, it is split into a separate
// file and re-exported here, which allows tree shaking to work properly.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _realModuleJs = require("./real-module.js");
parcelHelpers.exportAll(_realModuleJs, exports);
var _useMessageFormatterModuleJs = require("./useMessageFormatter.module.js");
parcelHelpers.exportAll(_useMessageFormatterModuleJs, exports);

},{"./real-module.js":"a2Zum","./useMessageFormatter.module.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a2Zum":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nProvider", function() {
    return $18f2051aff69b9bf$export$a54013f0d02a8f82;
});
parcelHelpers.export(exports, "useLocale", function() {
    return $18f2051aff69b9bf$export$43bb16f9c6d9e3f7;
});
parcelHelpers.export(exports, "useLocalizedStringFormatter", function() {
    return $fca6afa0e843324b$export$f12b703ca79dfbb1;
});
parcelHelpers.export(exports, "useLocalizedStringDictionary", function() {
    return $fca6afa0e843324b$export$87b761675e8eaa10;
});
parcelHelpers.export(exports, "useListFormatter", function() {
    return $33bf17300c498528$export$a2f47a3d2973640;
});
parcelHelpers.export(exports, "useDateFormatter", function() {
    return $896ba0a80a8f4d36$export$85fd5fdf27bacc79;
});
parcelHelpers.export(exports, "useNumberFormatter", function() {
    return $a916eb452884faea$export$b7a616150fdb9f44;
});
parcelHelpers.export(exports, "useCollator", function() {
    return $325a3faab7a68acd$export$a16aca283550c30d;
});
parcelHelpers.export(exports, "useFilter", function() {
    return $bb77f239b46e8c72$export$3274cf84b703fff;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ssr = require("@react-aria/ssr");
var _string = require("@internationalized/string");
var _date = require("@internationalized/date");
var _utils = require("@react-aria/utils");
var _number = require("@internationalized/number");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // https://en.wikipedia.org/wiki/Right-to-left
var $148a7a147e38ea7f$var$RTL_SCRIPTS = new Set([
    "Arab",
    "Syrc",
    "Samr",
    "Mand",
    "Thaa",
    "Mend",
    "Nkoo",
    "Adlm",
    "Rohg",
    "Hebr"
]);
var $148a7a147e38ea7f$var$RTL_LANGS = new Set([
    "ae",
    "ar",
    "arc",
    "bcc",
    "bqi",
    "ckb",
    "dv",
    "fa",
    "glk",
    "he",
    "ku",
    "mzn",
    "nqo",
    "pnb",
    "ps",
    "sd",
    "ug",
    "ur",
    "yi"
]);
function $148a7a147e38ea7f$export$702d680b21cbd764(localeString) {
    // If the Intl.Locale API is available, use it to get the locale's text direction.
    // @ts-ignore
    if (Intl.Locale) {
        var locale = new Intl.Locale(localeString).maximize();
        // Use the text info object to get the direction if possible.
        // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getTextInfo
        var textInfo = typeof locale.getTextInfo === "function" ? locale.getTextInfo() : locale.textInfo;
        if (textInfo) return textInfo.direction === "rtl";
        // Fallback: guess using the script.
        // This is more accurate than guessing by language, since languages can be written in multiple scripts.
        if (locale.script) return $148a7a147e38ea7f$var$RTL_SCRIPTS.has(locale.script);
    }
    // If not, just guess by the language (first part of the locale)
    var lang = localeString.split("-")[0];
    return $148a7a147e38ea7f$var$RTL_LANGS.has(lang);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Locale passed from server by PackageLocalizationProvider.
var $1e5a04cdaf7d1af8$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
function $1e5a04cdaf7d1af8$export$f09106e7c6677ec5() {
    var locale = typeof window !== "undefined" && window[$1e5a04cdaf7d1af8$var$localeSymbol] || typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage) || "en-US";
    try {
        // @ts-ignore
        Intl.DateTimeFormat.supportedLocalesOf([
            locale
        ]);
    } catch (_err) {
        locale = "en-US";
    }
    return {
        locale: locale,
        direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    };
}
var $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
var $1e5a04cdaf7d1af8$var$listeners = new Set();
function $1e5a04cdaf7d1af8$var$updateLocale() {
    $1e5a04cdaf7d1af8$var$currentLocale = $1e5a04cdaf7d1af8$export$f09106e7c6677ec5();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $1e5a04cdaf7d1af8$var$listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var listener = _step.value;
            listener($1e5a04cdaf7d1af8$var$currentLocale);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a() {
    var isSSR = (0, _ssr.useIsSSR)();
    var _$iFADg$useState = (0, _slicedToArray._)((0, _react.useState)($1e5a04cdaf7d1af8$var$currentLocale), 2), defaultLocale = _$iFADg$useState[0], setDefaultLocale = _$iFADg$useState[1];
    (0, _react.useEffect)(function() {
        if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.addEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        $1e5a04cdaf7d1af8$var$listeners.add(setDefaultLocale);
        return function() {
            $1e5a04cdaf7d1af8$var$listeners.delete(setDefaultLocale);
            if ($1e5a04cdaf7d1af8$var$listeners.size === 0) window.removeEventListener("languagechange", $1e5a04cdaf7d1af8$var$updateLocale);
        };
    }, []);
    // We cannot determine the browser's language on the server, so default to
    // en-US. This will be updated after hydration on the client to the correct value.
    if (isSSR) return {
        locale: "en-US",
        direction: "ltr"
    };
    return defaultLocale;
}
var $18f2051aff69b9bf$var$I18nContext = (0, _reactDefault.default).createContext(null);
function $18f2051aff69b9bf$export$a54013f0d02a8f82(props) {
    var locale = props.locale, children = props.children;
    var defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    var value = locale ? {
        locale: locale,
        direction: $148a7a147e38ea7f$export$702d680b21cbd764(locale) ? "rtl" : "ltr"
    } : defaultLocale;
    return (0, _reactDefault.default).createElement($18f2051aff69b9bf$var$I18nContext.Provider, {
        value: value
    }, children);
}
function $18f2051aff69b9bf$export$43bb16f9c6d9e3f7() {
    var defaultLocale = $1e5a04cdaf7d1af8$export$188ec29ebc2bdc3a();
    var context = (0, _react.useContext)($18f2051aff69b9bf$var$I18nContext);
    return context || defaultLocale;
}
var $2aa2084a6c2b6b4f$exports = {};
"use strict";
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $fca6afa0e843324b$var$cache = new WeakMap();
function $fca6afa0e843324b$var$getCachedDictionary(strings) {
    var dictionary = $fca6afa0e843324b$var$cache.get(strings);
    if (!dictionary) {
        dictionary = new (0, _string.LocalizedStringDictionary)(strings);
        $fca6afa0e843324b$var$cache.set(strings, dictionary);
    }
    return dictionary;
}
function $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName) {
    return packageName && (0, _string.LocalizedStringDictionary).getGlobalDictionaryForPackage(packageName) || $fca6afa0e843324b$var$getCachedDictionary(strings);
}
function $fca6afa0e843324b$export$f12b703ca79dfbb1(strings, packageName) {
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    var dictionary = $fca6afa0e843324b$export$87b761675e8eaa10(strings, packageName);
    return (0, _react.useMemo)(function() {
        return new (0, _string.LocalizedStringFormatter)(locale, dictionary);
    }, [
        locale,
        dictionary
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $33bf17300c498528$export$a2f47a3d2973640() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    return (0, _react.useMemo)(function() {
        return new Intl.ListFormat(locale, options);
    }, [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $896ba0a80a8f4d36$export$85fd5fdf27bacc79(options) {
    // Reuse last options object if it is shallowly equal, which allows the useMemo result to also be reused.
    options = (0, _utils.useDeepMemo)(options !== null && options !== void 0 ? options : {}, $896ba0a80a8f4d36$var$isEqual);
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    return (0, _react.useMemo)(function() {
        return new (0, _date.DateFormatter)(locale, options);
    }, [
        locale,
        options
    ]);
}
function $896ba0a80a8f4d36$var$isEqual(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (b[key] !== a[key]) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a916eb452884faea$export$b7a616150fdb9f44() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    return (0, _react.useMemo)(function() {
        return new (0, _number.NumberFormatter)(locale, options);
    }, [
        locale,
        options
    ]);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $325a3faab7a68acd$var$cache = new Map();
function $325a3faab7a68acd$export$a16aca283550c30d(options) {
    var _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7 = $18f2051aff69b9bf$export$43bb16f9c6d9e3f7(), locale = _$18f2051aff69b9bf$export$43bb16f9c6d9e3f7.locale;
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if ($325a3faab7a68acd$var$cache.has(cacheKey)) return $325a3faab7a68acd$var$cache.get(cacheKey);
    var formatter = new Intl.Collator(locale, options);
    $325a3faab7a68acd$var$cache.set(cacheKey, formatter);
    return formatter;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $bb77f239b46e8c72$export$3274cf84b703fff(options) {
    var collator = $325a3faab7a68acd$export$a16aca283550c30d((0, _objectSpread._)({
        usage: "search"
    }, options));
    // TODO(later): these methods don't currently support the ignorePunctuation option.
    var startsWith = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        // Normalize both strings so we can slice safely
        // TODO: take into account the ignorePunctuation option as well...
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(0, substring.length), substring) === 0;
    }, [
        collator
    ]);
    var endsWith = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        return collator.compare(string.slice(-substring.length), substring) === 0;
    }, [
        collator
    ]);
    var contains = (0, _react.useCallback)(function(string, substring) {
        if (substring.length === 0) return true;
        string = string.normalize("NFC");
        substring = substring.normalize("NFC");
        var scan = 0;
        var sliceLen = substring.length;
        for(; scan + sliceLen <= string.length; scan++){
            var slice = string.slice(scan, scan + sliceLen);
            if (collator.compare(substring, slice) === 0) return true;
        }
        return false;
    }, [
        collator
    ]);
    return (0, _react.useMemo)(function() {
        return {
            startsWith: startsWith,
            endsWith: endsWith,
            contains: contains
        };
    }, [
        startsWith,
        endsWith,
        contains
    ]);
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@react-aria/ssr":"8ZKMZ","@internationalized/string":"9Vht3","@internationalized/date":"021zo","@react-aria/utils":"99Fak","@internationalized/number":"kaxG1","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9Vht3":[function(require,module,exports) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalizedStringDictionary", function() {
    return $5b160d28a433310d$export$c17fa47878dc55b6;
});
parcelHelpers.export(exports, "LocalizedStringFormatter", function() {
    return $6db58dc88e78b024$export$2f817fcdc4b89ae0;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var $5b160d28a433310d$var$localeSymbol = Symbol.for("react-aria.i18n.locale");
var $5b160d28a433310d$var$stringsSymbol = Symbol.for("react-aria.i18n.strings");
var $5b160d28a433310d$var$cachedGlobalStrings = undefined;
var $5b160d28a433310d$export$c17fa47878dc55b6 = /*#__PURE__*/ function() {
    "use strict";
    function $5b160d28a433310d$export$c17fa47878dc55b6(messages) {
        var defaultLocale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
        (0, _classCallCheck._)(this, $5b160d28a433310d$export$c17fa47878dc55b6);
        // Clone messages so we don't modify the original object.
        this.strings = (0, _objectSpread._)({}, messages);
        this.defaultLocale = defaultLocale;
    }
    (0, _createClass._)($5b160d28a433310d$export$c17fa47878dc55b6, [
        {
            /** Returns a localized string for the given key and locale. */ key: "getStringForLocale",
            value: function getStringForLocale(key, locale) {
                var strings = this.getStringsForLocale(locale);
                var string = strings[key];
                if (!string) throw new Error("Could not find intl message ".concat(key, " in ").concat(locale, " locale"));
                return string;
            }
        },
        {
            /** Returns all localized strings for the given locale. */ key: "getStringsForLocale",
            value: function getStringsForLocale(locale) {
                var strings = this.strings[locale];
                if (!strings) {
                    strings = $5b160d28a433310d$var$getStringsForLocale(locale, this.strings, this.defaultLocale);
                    this.strings[locale] = strings;
                }
                return strings;
            }
        }
    ], [
        {
            key: "getGlobalDictionaryForPackage",
            value: function getGlobalDictionaryForPackage(packageName) {
                if (typeof window === "undefined") return null;
                var locale = window[$5b160d28a433310d$var$localeSymbol];
                if ($5b160d28a433310d$var$cachedGlobalStrings === undefined) {
                    var globalStrings = window[$5b160d28a433310d$var$stringsSymbol];
                    if (!globalStrings) return null;
                    $5b160d28a433310d$var$cachedGlobalStrings = {};
                    for(var pkg in globalStrings)$5b160d28a433310d$var$cachedGlobalStrings[pkg] = new $5b160d28a433310d$export$c17fa47878dc55b6((0, _defineProperty._)({}, locale, globalStrings[pkg]), locale);
                }
                var dictionary = $5b160d28a433310d$var$cachedGlobalStrings === null || $5b160d28a433310d$var$cachedGlobalStrings === void 0 ? void 0 : $5b160d28a433310d$var$cachedGlobalStrings[packageName];
                if (!dictionary) throw new Error('Strings for package "'.concat(packageName, '" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.'));
                return dictionary;
            }
        }
    ]);
    return $5b160d28a433310d$export$c17fa47878dc55b6;
}();
function $5b160d28a433310d$var$getStringsForLocale(locale, strings) {
    var defaultLocale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "en-US";
    // If there is an exact match, use it.
    if (strings[locale]) return strings[locale];
    // Attempt to find the closest match by language.
    // For example, if the locale is fr-CA (French Canadian), but there is only
    // an fr-FR (France) set of strings, use that.
    // This could be replaced with Intl.LocaleMatcher once it is supported.
    // https://github.com/tc39/proposal-intl-localematcher
    var language = $5b160d28a433310d$var$getLanguage(locale);
    if (strings[language]) return strings[language];
    for(var key in strings){
        if (key.startsWith(language + "-")) return strings[key];
    }
    // Nothing close, use english.
    return strings[defaultLocale];
}
function $5b160d28a433310d$var$getLanguage(locale) {
    // @ts-ignore
    if (Intl.Locale) return new Intl.Locale(locale).language;
    return locale.split("-")[0];
}
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $6db58dc88e78b024$var$pluralRulesCache = new Map();
var $6db58dc88e78b024$var$numberFormatCache = new Map();
var $6db58dc88e78b024$export$2f817fcdc4b89ae0 = /*#__PURE__*/ function() {
    "use strict";
    function $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale, strings) {
        (0, _classCallCheck._)(this, $6db58dc88e78b024$export$2f817fcdc4b89ae0);
        this.locale = locale;
        this.strings = strings;
    }
    (0, _createClass._)($6db58dc88e78b024$export$2f817fcdc4b89ae0, [
        {
            /** Formats a localized string for the given key with the provided variables. */ key: "format",
            value: function format(key, variables) {
                var message = this.strings.getStringForLocale(key, this.locale);
                return typeof message === "function" ? message(variables, this) : message;
            }
        },
        {
            key: "plural",
            value: function plural(count, options) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "cardinal";
                var opt = options["=" + count];
                if (opt) return typeof opt === "function" ? opt() : opt;
                var key = this.locale + ":" + type;
                var pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
                if (!pluralRules) {
                    pluralRules = new Intl.PluralRules(this.locale, {
                        type: type
                    });
                    $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
                }
                var selected = pluralRules.select(count);
                opt = options[selected] || options.other;
                return typeof opt === "function" ? opt() : opt;
            }
        },
        {
            key: "number",
            value: function number(value) {
                var numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
                if (!numberFormat) {
                    numberFormat = new Intl.NumberFormat(this.locale);
                    $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
                }
                return numberFormat.format(value);
            }
        },
        {
            key: "select",
            value: function select(options, value) {
                var opt = options[value] || options.other;
                return typeof opt === "function" ? opt() : opt;
            }
        }
    ]);
    return $6db58dc88e78b024$export$2f817fcdc4b89ae0;
}();

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_object_spread":"6U9Ts","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"021zo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarDate", function() {
    return $35ea8db9cb2ccb90$export$99faa760c7908e4f;
});
parcelHelpers.export(exports, "CalendarDateTime", function() {
    return $35ea8db9cb2ccb90$export$ca871e8dbb80966f;
});
parcelHelpers.export(exports, "Time", function() {
    return $35ea8db9cb2ccb90$export$680ea196effce5f;
});
parcelHelpers.export(exports, "ZonedDateTime", function() {
    return $35ea8db9cb2ccb90$export$d3b7288e7994edea;
});
parcelHelpers.export(exports, "GregorianCalendar", function() {
    return $3b62074eb05584b2$export$80ee6245ec4f29ec;
});
parcelHelpers.export(exports, "JapaneseCalendar", function() {
    return $62225008020f0a13$export$b746ab2b60cdffbf;
});
parcelHelpers.export(exports, "BuddhistCalendar", function() {
    return $8d73d47422ca7302$export$42d20a78301dee44;
});
parcelHelpers.export(exports, "TaiwanCalendar", function() {
    return $5f31bd6f0c8940b2$export$65e01080afcb0799;
});
parcelHelpers.export(exports, "PersianCalendar", function() {
    return $f3ed2e4472ae7e25$export$37fccdbfd14c5939;
});
parcelHelpers.export(exports, "IndianCalendar", function() {
    return $82c358003bdda0a8$export$39f31c639fa15726;
});
parcelHelpers.export(exports, "IslamicCivilCalendar", function() {
    return $f2f3e0e3a817edbd$export$2066795aadd37bfc;
});
parcelHelpers.export(exports, "IslamicTabularCalendar", function() {
    return $f2f3e0e3a817edbd$export$37f0887f2f9d22f7;
});
parcelHelpers.export(exports, "IslamicUmalquraCalendar", function() {
    return $f2f3e0e3a817edbd$export$5baab4758c231076;
});
parcelHelpers.export(exports, "HebrewCalendar", function() {
    return $7c5f6fbf42389787$export$ca405048b8fb5af;
});
parcelHelpers.export(exports, "EthiopicCalendar", function() {
    return $b956b2d7a6cf451f$export$26ba6eab5e20cd7d;
});
parcelHelpers.export(exports, "EthiopicAmeteAlemCalendar", function() {
    return $b956b2d7a6cf451f$export$d72e0c37005a4914;
});
parcelHelpers.export(exports, "CopticCalendar", function() {
    return $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1;
});
parcelHelpers.export(exports, "createCalendar", function() {
    return $64244302c3013299$export$dd0bbc9b26defe37;
});
parcelHelpers.export(exports, "toCalendarDate", function() {
    return $11d87f3f76e88657$export$93522d1a439f3617;
});
parcelHelpers.export(exports, "toCalendarDateTime", function() {
    return $11d87f3f76e88657$export$b21e0b124e224484;
});
parcelHelpers.export(exports, "toTime", function() {
    return $11d87f3f76e88657$export$d33f79e3ffc3dc83;
});
parcelHelpers.export(exports, "toCalendar", function() {
    return $11d87f3f76e88657$export$b4a036af3fc0b032;
});
parcelHelpers.export(exports, "toZoned", function() {
    return $11d87f3f76e88657$export$84c95a83c799e074;
});
parcelHelpers.export(exports, "toTimeZone", function() {
    return $11d87f3f76e88657$export$538b00033cc11c75;
});
parcelHelpers.export(exports, "toLocalTimeZone", function() {
    return $11d87f3f76e88657$export$d9b67bc93c097491;
});
parcelHelpers.export(exports, "fromDate", function() {
    return $11d87f3f76e88657$export$e57ff100d91bd4b9;
});
parcelHelpers.export(exports, "fromAbsolute", function() {
    return $11d87f3f76e88657$export$1b96692a1ba042ac;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return $14e0f24ef4ac5c92$export$ea39ec197993aef0;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return $14e0f24ef4ac5c92$export$a18c89cbd24170ff;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return $14e0f24ef4ac5c92$export$5841f9eb9773f25f;
});
parcelHelpers.export(exports, "isEqualDay", function() {
    return $14e0f24ef4ac5c92$export$91b62ebf2ba703ee;
});
parcelHelpers.export(exports, "isEqualMonth", function() {
    return $14e0f24ef4ac5c92$export$5a8da0c44a3afdf2;
});
parcelHelpers.export(exports, "isEqualYear", function() {
    return $14e0f24ef4ac5c92$export$ea840f5a6dda8147;
});
parcelHelpers.export(exports, "isToday", function() {
    return $14e0f24ef4ac5c92$export$629b0a497aa65267;
});
parcelHelpers.export(exports, "getDayOfWeek", function() {
    return $14e0f24ef4ac5c92$export$2061056d06d7cdf7;
});
parcelHelpers.export(exports, "now", function() {
    return $14e0f24ef4ac5c92$export$461939dd4422153;
});
parcelHelpers.export(exports, "today", function() {
    return $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3;
});
parcelHelpers.export(exports, "getHoursInDay", function() {
    return $14e0f24ef4ac5c92$export$126c91c941de7e;
});
parcelHelpers.export(exports, "getLocalTimeZone", function() {
    return $14e0f24ef4ac5c92$export$aa8b41735afcabd2;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return $14e0f24ef4ac5c92$export$a5a3b454ada2268e;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return $14e0f24ef4ac5c92$export$42c81a444fbfb5d4;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return $14e0f24ef4ac5c92$export$f91e89d3d0406102;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return $14e0f24ef4ac5c92$export$a2258d9c4118825c;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return $14e0f24ef4ac5c92$export$ef8b6d9133084f4e;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return $14e0f24ef4ac5c92$export$8b7aa55c66d5569e;
});
parcelHelpers.export(exports, "getMinimumMonthInYear", function() {
    return $14e0f24ef4ac5c92$export$5412ac11713b72ad;
});
parcelHelpers.export(exports, "getMinimumDayInMonth", function() {
    return $14e0f24ef4ac5c92$export$b2f4953d301981d5;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return $14e0f24ef4ac5c92$export$ccc1b2479e7dd654;
});
parcelHelpers.export(exports, "minDate", function() {
    return $14e0f24ef4ac5c92$export$5c333a116e949cdd;
});
parcelHelpers.export(exports, "maxDate", function() {
    return $14e0f24ef4ac5c92$export$a75f2bff57811055;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return $14e0f24ef4ac5c92$export$618d60ea299da42;
});
parcelHelpers.export(exports, "isWeekday", function() {
    return $14e0f24ef4ac5c92$export$ee9d87258e1d19ed;
});
parcelHelpers.export(exports, "parseDate", function() {
    return $fae977aafc393c5c$export$6b862160d295c8e;
});
parcelHelpers.export(exports, "parseDateTime", function() {
    return $fae977aafc393c5c$export$588937bcd60ade55;
});
parcelHelpers.export(exports, "parseTime", function() {
    return $fae977aafc393c5c$export$c9698ec7f05a07e1;
});
parcelHelpers.export(exports, "parseAbsolute", function() {
    return $fae977aafc393c5c$export$5adfdab05168c219;
});
parcelHelpers.export(exports, "parseAbsoluteToLocal", function() {
    return $fae977aafc393c5c$export$8e384432362ed0f0;
});
parcelHelpers.export(exports, "parseZonedDateTime", function() {
    return $fae977aafc393c5c$export$fd7893f06e92a6a4;
});
parcelHelpers.export(exports, "parseDuration", function() {
    return $fae977aafc393c5c$export$ecae829bb3747ea6;
});
parcelHelpers.export(exports, "DateFormatter", function() {
    return $fb18d541ea1ad717$export$ad991b66133851cf;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _classPrivateFieldInit = require("@swc/helpers/_/_class_private_field_init");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $2b4dce13dd5a17fa$export$842a2cf37af977e1(amount, numerator) {
    return amount - numerator * Math.floor(amount / numerator);
}
function $2b4dce13dd5a17fa$export$784d13d8ee351f07(date) {
    if (date.era) return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(date.calendar, date.era, date.year, date.month, date.day);
    else return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(date.calendar, date.year, date.month, date.day);
}
function $2b4dce13dd5a17fa$export$27fa0172ae2644b3(date) {
    if (date.era) return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
    else return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(date.calendar, date.year, date.month, date.day, date.hour, date.minute, date.second);
}
var $3b62074eb05584b2$var$EPOCH = 1721426; // 001/01/03 Julian C.E.
function $3b62074eb05584b2$export$f297eb839006d339(era, year, month, day) {
    year = $3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year);
    var y1 = year - 1;
    var monthOffset = -2;
    if (month <= 2) monthOffset = 0;
    else if ($3b62074eb05584b2$export$553d7fa8e3805fc0(year)) monthOffset = -1;
    return $3b62074eb05584b2$var$EPOCH - 1 + 365 * y1 + Math.floor(y1 / 4) - Math.floor(y1 / 100) + Math.floor(y1 / 400) + Math.floor((367 * month - 362) / 12 + monthOffset + day);
}
function $3b62074eb05584b2$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $3b62074eb05584b2$export$c36e0ecb2d4fa69d(era, year) {
    return era === "BC" ? 1 - year : year;
}
function $3b62074eb05584b2$export$4475b7e617eb123c(year) {
    var era = "AD";
    if (year <= 0) {
        era = "BC";
        year = 1 - year;
    }
    return [
        era,
        year
    ];
}
var $3b62074eb05584b2$var$daysInMonth = {
    standard: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    leapyear: [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ]
};
var $3b62074eb05584b2$export$80ee6245ec4f29ec = /*#__PURE__*/ function() {
    "use strict";
    function $3b62074eb05584b2$export$80ee6245ec4f29ec() {
        (0, _classCallCheck._)(this, $3b62074eb05584b2$export$80ee6245ec4f29ec);
        this.identifier = "gregory";
    }
    (0, _createClass._)($3b62074eb05584b2$export$80ee6245ec4f29ec, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var jd0 = jd;
                var depoch = jd0 - $3b62074eb05584b2$var$EPOCH;
                var quadricent = Math.floor(depoch / 146097);
                var dqc = $2b4dce13dd5a17fa$export$842a2cf37af977e1(depoch, 146097);
                var cent = Math.floor(dqc / 36524);
                var dcent = $2b4dce13dd5a17fa$export$842a2cf37af977e1(dqc, 36524);
                var quad = Math.floor(dcent / 1461);
                var dquad = $2b4dce13dd5a17fa$export$842a2cf37af977e1(dcent, 1461);
                var yindex = Math.floor(dquad / 365);
                var extendedYear = quadricent * 400 + cent * 100 + quad * 4 + yindex + (cent !== 4 && yindex !== 4 ? 1 : 0);
                var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, _slicedToArray._)($3b62074eb05584b2$export$4475b7e617eb123c(extendedYear), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
                var yearDay = jd0 - $3b62074eb05584b2$export$f297eb839006d339(era, year, 1, 1);
                var leapAdj = 2;
                if (jd0 < $3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 1)) leapAdj = 0;
                else if ($3b62074eb05584b2$export$553d7fa8e3805fc0(year)) leapAdj = 1;
                var month = Math.floor(((yearDay + leapAdj) * 12 + 373) / 367);
                var day = jd0 - $3b62074eb05584b2$export$f297eb839006d339(era, year, month, 1) + 1;
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $3b62074eb05584b2$var$daysInMonth[$3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? "leapyear" : "standard"][date.month - 1];
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 366 : 365;
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BC",
                    "AD"
                ];
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "BC";
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === "BC" ? "AD" : "BC";
                    date.year = 1 - date.year;
                }
            }
        }
    ]);
    return $3b62074eb05584b2$export$80ee6245ec4f29ec;
}();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Data from https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/weekData.json
// Locales starting on Sunday have been removed for compression.
var $2fe286d2fb449abb$export$7a5acbd77d414bd9 = {
    "001": 1,
    AD: 1,
    AE: 6,
    AF: 6,
    AI: 1,
    AL: 1,
    AM: 1,
    AN: 1,
    AR: 1,
    AT: 1,
    AU: 1,
    AX: 1,
    AZ: 1,
    BA: 1,
    BE: 1,
    BG: 1,
    BH: 6,
    BM: 1,
    BN: 1,
    BY: 1,
    CH: 1,
    CL: 1,
    CM: 1,
    CN: 1,
    CR: 1,
    CY: 1,
    CZ: 1,
    DE: 1,
    DJ: 6,
    DK: 1,
    DZ: 6,
    EC: 1,
    EE: 1,
    EG: 6,
    ES: 1,
    FI: 1,
    FJ: 1,
    FO: 1,
    FR: 1,
    GB: 1,
    GE: 1,
    GF: 1,
    GP: 1,
    GR: 1,
    HR: 1,
    HU: 1,
    IE: 1,
    IQ: 6,
    IR: 6,
    IS: 1,
    IT: 1,
    JO: 6,
    KG: 1,
    KW: 6,
    KZ: 1,
    LB: 1,
    LI: 1,
    LK: 1,
    LT: 1,
    LU: 1,
    LV: 1,
    LY: 6,
    MC: 1,
    MD: 1,
    ME: 1,
    MK: 1,
    MN: 1,
    MQ: 1,
    MV: 5,
    MY: 1,
    NL: 1,
    NO: 1,
    NZ: 1,
    OM: 6,
    PL: 1,
    QA: 6,
    RE: 1,
    RO: 1,
    RS: 1,
    RU: 1,
    SD: 6,
    SE: 1,
    SI: 1,
    SK: 1,
    SM: 1,
    SY: 6,
    TJ: 1,
    TM: 1,
    TR: 1,
    UA: 1,
    UY: 1,
    UZ: 1,
    VA: 1,
    VN: 1,
    XK: 1
};
function $14e0f24ef4ac5c92$export$ea39ec197993aef0(a, b) {
    b = $11d87f3f76e88657$export$b4a036af3fc0b032(b, a.calendar);
    return a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $14e0f24ef4ac5c92$export$a18c89cbd24170ff(a, b) {
    b = $11d87f3f76e88657$export$b4a036af3fc0b032(b, a.calendar);
    // In the Japanese calendar, months can span multiple eras/years, so only compare the first of the month.
    a = $14e0f24ef4ac5c92$export$a5a3b454ada2268e(a);
    b = $14e0f24ef4ac5c92$export$a5a3b454ada2268e(b);
    return a.era === b.era && a.year === b.year && a.month === b.month;
}
function $14e0f24ef4ac5c92$export$5841f9eb9773f25f(a, b) {
    b = $11d87f3f76e88657$export$b4a036af3fc0b032(b, a.calendar);
    a = $14e0f24ef4ac5c92$export$f91e89d3d0406102(a);
    b = $14e0f24ef4ac5c92$export$f91e89d3d0406102(b);
    return a.era === b.era && a.year === b.year;
}
function $14e0f24ef4ac5c92$export$91b62ebf2ba703ee(a, b) {
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month && a.day === b.day;
}
function $14e0f24ef4ac5c92$export$5a8da0c44a3afdf2(a, b) {
    a = $14e0f24ef4ac5c92$export$a5a3b454ada2268e(a);
    b = $14e0f24ef4ac5c92$export$a5a3b454ada2268e(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year && a.month === b.month;
}
function $14e0f24ef4ac5c92$export$ea840f5a6dda8147(a, b) {
    a = $14e0f24ef4ac5c92$export$f91e89d3d0406102(a);
    b = $14e0f24ef4ac5c92$export$f91e89d3d0406102(b);
    return a.calendar.identifier === b.calendar.identifier && a.era === b.era && a.year === b.year;
}
function $14e0f24ef4ac5c92$export$629b0a497aa65267(date, timeZone) {
    return $14e0f24ef4ac5c92$export$ea39ec197993aef0(date, $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(timeZone));
}
function $14e0f24ef4ac5c92$export$2061056d06d7cdf7(date, locale) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var dayOfWeek = Math.ceil(julian + 1 - $14e0f24ef4ac5c92$var$getWeekStart(locale)) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    return dayOfWeek;
}
function $14e0f24ef4ac5c92$export$461939dd4422153(timeZone) {
    return $11d87f3f76e88657$export$1b96692a1ba042ac(Date.now(), timeZone);
}
function $14e0f24ef4ac5c92$export$d0bdf45af03a6ea3(timeZone) {
    return $11d87f3f76e88657$export$93522d1a439f3617($14e0f24ef4ac5c92$export$461939dd4422153(timeZone));
}
function $14e0f24ef4ac5c92$export$68781ddf31c0090f(a, b) {
    return a.calendar.toJulianDay(a) - b.calendar.toJulianDay(b);
}
function $14e0f24ef4ac5c92$export$c19a80a9721b80f6(a, b) {
    return $14e0f24ef4ac5c92$var$timeToMs(a) - $14e0f24ef4ac5c92$var$timeToMs(b);
}
function $14e0f24ef4ac5c92$var$timeToMs(a) {
    return a.hour * 3600000 + a.minute * 60000 + a.second * 1000 + a.millisecond;
}
function $14e0f24ef4ac5c92$export$126c91c941de7e(a, timeZone) {
    var ms = $11d87f3f76e88657$export$5107c82f94518f5c(a, timeZone);
    var tomorrow = a.add({
        days: 1
    });
    var tomorrowMs = $11d87f3f76e88657$export$5107c82f94518f5c(tomorrow, timeZone);
    return (tomorrowMs - ms) / 3600000;
}
var $14e0f24ef4ac5c92$var$localTimeZone = null;
function $14e0f24ef4ac5c92$export$aa8b41735afcabd2() {
    // TODO: invalidate this somehow?
    if ($14e0f24ef4ac5c92$var$localTimeZone == null) $14e0f24ef4ac5c92$var$localTimeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return $14e0f24ef4ac5c92$var$localTimeZone;
}
function $14e0f24ef4ac5c92$export$a5a3b454ada2268e(date) {
    // Use `subtract` instead of `set` so we don't get constrained in an era.
    return date.subtract({
        days: date.day - 1
    });
}
function $14e0f24ef4ac5c92$export$a2258d9c4118825c(date) {
    return date.add({
        days: date.calendar.getDaysInMonth(date) - date.day
    });
}
function $14e0f24ef4ac5c92$export$f91e89d3d0406102(date) {
    return $14e0f24ef4ac5c92$export$a5a3b454ada2268e(date.subtract({
        months: date.month - 1
    }));
}
function $14e0f24ef4ac5c92$export$8b7aa55c66d5569e(date) {
    return $14e0f24ef4ac5c92$export$a2258d9c4118825c(date.add({
        months: date.calendar.getMonthsInYear(date) - date.month
    }));
}
function $14e0f24ef4ac5c92$export$5412ac11713b72ad(date) {
    if (date.calendar.getMinimumMonthInYear) return date.calendar.getMinimumMonthInYear(date);
    return 1;
}
function $14e0f24ef4ac5c92$export$b2f4953d301981d5(date) {
    if (date.calendar.getMinimumDayInMonth) return date.calendar.getMinimumDayInMonth(date);
    return 1;
}
function $14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date, locale) {
    var dayOfWeek = $14e0f24ef4ac5c92$export$2061056d06d7cdf7(date, locale);
    return date.subtract({
        days: dayOfWeek
    });
}
function $14e0f24ef4ac5c92$export$ef8b6d9133084f4e(date, locale) {
    return $14e0f24ef4ac5c92$export$42c81a444fbfb5d4(date, locale).add({
        days: 6
    });
}
var $14e0f24ef4ac5c92$var$cachedRegions = new Map();
function $14e0f24ef4ac5c92$var$getRegion(locale) {
    // If the Intl.Locale API is available, use it to get the region for the locale.
    // @ts-ignore
    if (Intl.Locale) {
        // Constructing an Intl.Locale is expensive, so cache the result.
        var region = $14e0f24ef4ac5c92$var$cachedRegions.get(locale);
        if (!region) {
            // @ts-ignore
            region = new Intl.Locale(locale).maximize().region;
            if (region) $14e0f24ef4ac5c92$var$cachedRegions.set(locale, region);
        }
        return region;
    }
    // If not, just try splitting the string.
    // If the second part of the locale string is 'u',
    // then this is a unicode extension, so ignore it.
    // Otherwise, it should be the region.
    var part = locale.split("-")[1];
    return part === "u" ? undefined : part;
}
function $14e0f24ef4ac5c92$var$getWeekStart(locale) {
    // TODO: use Intl.Locale for this once browsers support the weekInfo property
    // https://github.com/tc39/proposal-intl-locale-info
    var region = $14e0f24ef4ac5c92$var$getRegion(locale);
    return region ? $2fe286d2fb449abb$export$7a5acbd77d414bd9[region] || 0 : 0;
}
function $14e0f24ef4ac5c92$export$ccc1b2479e7dd654(date, locale) {
    var days = date.calendar.getDaysInMonth(date);
    return Math.ceil(($14e0f24ef4ac5c92$export$2061056d06d7cdf7($14e0f24ef4ac5c92$export$a5a3b454ada2268e(date), locale) + days) / 7);
}
function $14e0f24ef4ac5c92$export$5c333a116e949cdd(a, b) {
    if (a && b) return a.compare(b) <= 0 ? a : b;
    return a || b;
}
function $14e0f24ef4ac5c92$export$a75f2bff57811055(a, b) {
    if (a && b) return a.compare(b) >= 0 ? a : b;
    return a || b;
}
var $14e0f24ef4ac5c92$var$WEEKEND_DATA = {
    AF: [
        4,
        5
    ],
    AE: [
        5,
        6
    ],
    BH: [
        5,
        6
    ],
    DZ: [
        5,
        6
    ],
    EG: [
        5,
        6
    ],
    IL: [
        5,
        6
    ],
    IQ: [
        5,
        6
    ],
    IR: [
        5,
        5
    ],
    JO: [
        5,
        6
    ],
    KW: [
        5,
        6
    ],
    LY: [
        5,
        6
    ],
    OM: [
        5,
        6
    ],
    QA: [
        5,
        6
    ],
    SA: [
        5,
        6
    ],
    SD: [
        5,
        6
    ],
    SY: [
        5,
        6
    ],
    YE: [
        5,
        6
    ]
};
function $14e0f24ef4ac5c92$export$618d60ea299da42(date, locale) {
    var julian = date.calendar.toJulianDay(date);
    // If julian is negative, then julian % 7 will be negative, so we adjust
    // accordingly.  Julian day 0 is Monday.
    var dayOfWeek = Math.ceil(julian + 1) % 7;
    if (dayOfWeek < 0) dayOfWeek += 7;
    var region = $14e0f24ef4ac5c92$var$getRegion(locale);
    // Use Intl.Locale for this once weekInfo is supported.
    // https://github.com/tc39/proposal-intl-locale-info
    var _ref = (0, _slicedToArray._)($14e0f24ef4ac5c92$var$WEEKEND_DATA[region] || [
        6,
        0
    ], 2), start = _ref[0], end = _ref[1];
    return dayOfWeek === start || dayOfWeek === end;
}
function $14e0f24ef4ac5c92$export$ee9d87258e1d19ed(date, locale) {
    return !$14e0f24ef4ac5c92$export$618d60ea299da42(date, locale);
}
function $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) {
    date = $11d87f3f76e88657$export$b4a036af3fc0b032(date, new $3b62074eb05584b2$export$80ee6245ec4f29ec());
    var year = $3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
    return $11d87f3f76e88657$var$epochFromParts(year, date.month, date.day, date.hour, date.minute, date.second, date.millisecond);
}
function $11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, millisecond) {
    // Note: Date.UTC() interprets one and two-digit years as being in the
    // 20th century, so don't use it
    var date = new Date();
    date.setUTCHours(hour, minute, second, millisecond);
    date.setUTCFullYear(year, month - 1, day);
    return date.getTime();
}
function $11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone) {
    // Fast path for UTC.
    if (timeZone === "UTC") return 0;
    // Fast path: for local timezone after 1970, use native Date.
    if (ms > 0 && timeZone === $14e0f24ef4ac5c92$export$aa8b41735afcabd2()) return new Date(ms).getTimezoneOffset() * -60000;
    var _$11d87f3f76e88657$var$getTimeZoneParts = $11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone), year = _$11d87f3f76e88657$var$getTimeZoneParts.year, month = _$11d87f3f76e88657$var$getTimeZoneParts.month, day = _$11d87f3f76e88657$var$getTimeZoneParts.day, hour = _$11d87f3f76e88657$var$getTimeZoneParts.hour, minute = _$11d87f3f76e88657$var$getTimeZoneParts.minute, second = _$11d87f3f76e88657$var$getTimeZoneParts.second;
    var utc = $11d87f3f76e88657$var$epochFromParts(year, month, day, hour, minute, second, 0);
    return utc - Math.floor(ms / 1000) * 1000;
}
var $11d87f3f76e88657$var$formattersByTimeZone = new Map();
function $11d87f3f76e88657$var$getTimeZoneParts(ms, timeZone) {
    var formatter = $11d87f3f76e88657$var$formattersByTimeZone.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone,
            hour12: false,
            era: "short",
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric"
        });
        $11d87f3f76e88657$var$formattersByTimeZone.set(timeZone, formatter);
    }
    var parts = formatter.formatToParts(new Date(ms));
    var namedParts = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.type !== "literal") namedParts[part.type] = part.value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
        year: namedParts.era === "BC" || namedParts.era === "B" ? -namedParts.year + 1 : +namedParts.year,
        month: +namedParts.month,
        day: +namedParts.day,
        hour: namedParts.hour === "24" ? 0 : +namedParts.hour,
        minute: +namedParts.minute,
        second: +namedParts.second
    };
}
var $11d87f3f76e88657$var$DAYMILLIS = 86400000;
function $11d87f3f76e88657$export$136f38efe7caf549(date, timeZone) {
    var ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date);
    var earlier = ms - $11d87f3f76e88657$export$59c99f3515d3493f(ms - $11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var later = ms - $11d87f3f76e88657$export$59c99f3515d3493f(ms + $11d87f3f76e88657$var$DAYMILLIS, timeZone);
    return $11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later);
}
function $11d87f3f76e88657$var$getValidWallTimes(date, timeZone, earlier, later) {
    var found = earlier === later ? [
        earlier
    ] : [
        earlier,
        later
    ];
    return found.filter(function(absolute) {
        return $11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute);
    });
}
function $11d87f3f76e88657$var$isValidWallTime(date, timeZone, absolute) {
    var parts = $11d87f3f76e88657$var$getTimeZoneParts(absolute, timeZone);
    return date.year === parts.year && date.month === parts.month && date.day === parts.day && date.hour === parts.hour && date.minute === parts.minute && date.second === parts.second;
}
function $11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "compatible";
    var dateTime = $11d87f3f76e88657$export$b21e0b124e224484(date);
    // Fast path: if the time zone is UTC, use native Date.
    if (timeZone === "UTC") return $11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    // Fast path: if the time zone is the local timezone and disambiguation is compatible, use native Date.
    if (timeZone === $14e0f24ef4ac5c92$export$aa8b41735afcabd2() && disambiguation === "compatible") {
        dateTime = $11d87f3f76e88657$export$b4a036af3fc0b032(dateTime, new $3b62074eb05584b2$export$80ee6245ec4f29ec());
        // Don't use Date constructor here because two-digit years are interpreted in the 20th century.
        var _$date = new Date();
        var year = $3b62074eb05584b2$export$c36e0ecb2d4fa69d(dateTime.era, dateTime.year);
        _$date.setFullYear(year, dateTime.month - 1, dateTime.day);
        _$date.setHours(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
        return _$date.getTime();
    }
    var ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime);
    var offsetBefore = $11d87f3f76e88657$export$59c99f3515d3493f(ms - $11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var offsetAfter = $11d87f3f76e88657$export$59c99f3515d3493f(ms + $11d87f3f76e88657$var$DAYMILLIS, timeZone);
    var valid = $11d87f3f76e88657$var$getValidWallTimes(dateTime, timeZone, ms - offsetBefore, ms - offsetAfter);
    if (valid.length === 1) return valid[0];
    if (valid.length > 1) switch(disambiguation){
        // 'compatible' means 'earlier' for "fall back" transitions
        case "compatible":
        case "earlier":
            return valid[0];
        case "later":
            return valid[valid.length - 1];
        case "reject":
            throw new RangeError("Multiple possible absolute times found");
    }
    switch(disambiguation){
        case "earlier":
            return Math.min(ms - offsetBefore, ms - offsetAfter);
        // 'compatible' means 'later' for "spring forward" transitions
        case "compatible":
        case "later":
            return Math.max(ms - offsetBefore, ms - offsetAfter);
        case "reject":
            throw new RangeError("No such absolute time found");
    }
}
function $11d87f3f76e88657$export$e67a095c620b86fe(dateTime, timeZone) {
    var disambiguation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "compatible";
    return new Date($11d87f3f76e88657$export$5107c82f94518f5c(dateTime, timeZone, disambiguation));
}
function $11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone) {
    var offset = $11d87f3f76e88657$export$59c99f3515d3493f(ms, timeZone);
    var date = new Date(ms + offset);
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth() + 1;
    var day = date.getUTCDate();
    var hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    var second = date.getUTCSeconds();
    var millisecond = date.getUTCMilliseconds();
    return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(year, month, day, timeZone, offset, hour, minute, second, millisecond);
}
function $11d87f3f76e88657$export$e57ff100d91bd4b9(date, timeZone) {
    return $11d87f3f76e88657$export$1b96692a1ba042ac(date.getTime(), timeZone);
}
function $11d87f3f76e88657$export$d7f92bcd3596b086(date) {
    return $11d87f3f76e88657$export$e57ff100d91bd4b9(date, $14e0f24ef4ac5c92$export$aa8b41735afcabd2());
}
function $11d87f3f76e88657$export$93522d1a439f3617(dateTime) {
    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(dateTime.calendar, dateTime.era, dateTime.year, dateTime.month, dateTime.day);
}
function $11d87f3f76e88657$export$6f4d78149f3f53ac(date) {
    return {
        era: date.era,
        year: date.year,
        month: date.month,
        day: date.day
    };
}
function $11d87f3f76e88657$export$4d0393e732857be5(date) {
    return {
        hour: date.hour,
        minute: date.minute,
        second: date.second,
        millisecond: date.millisecond
    };
}
function $11d87f3f76e88657$export$b21e0b124e224484(date, time) {
    var hour = 0, minute = 0, second = 0, millisecond = 0;
    var ref;
    if ("timeZone" in date) ref = date, hour = ref.hour, minute = ref.minute, second = ref.second, millisecond = ref.millisecond, ref;
    else if ("hour" in date && !time) return date;
    var ref1;
    if (time) ref1 = time, hour = ref1.hour, minute = ref1.minute, second = ref1.second, millisecond = ref1.millisecond, ref1;
    return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(date.calendar, date.era, date.year, date.month, date.day, hour, minute, second, millisecond);
}
function $11d87f3f76e88657$export$d33f79e3ffc3dc83(dateTime) {
    return new $35ea8db9cb2ccb90$export$680ea196effce5f(dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
}
function $11d87f3f76e88657$export$b4a036af3fc0b032(date, calendar) {
    if (date.calendar.identifier === calendar.identifier) return date;
    var calendarDate = calendar.fromJulianDay(date.calendar.toJulianDay(date));
    var copy = date.copy();
    copy.calendar = calendar;
    copy.era = calendarDate.era;
    copy.year = calendarDate.year;
    copy.month = calendarDate.month;
    copy.day = calendarDate.day;
    $735220c2d4774dd3$export$c4e2ecac49351ef2(copy);
    return copy;
}
function $11d87f3f76e88657$export$84c95a83c799e074(date, timeZone, disambiguation) {
    if (date instanceof $35ea8db9cb2ccb90$export$d3b7288e7994edea) {
        if (date.timeZone === timeZone) return date;
        return $11d87f3f76e88657$export$538b00033cc11c75(date, timeZone);
    }
    var ms = $11d87f3f76e88657$export$5107c82f94518f5c(date, timeZone, disambiguation);
    return $11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone);
}
function $11d87f3f76e88657$export$83aac07b4c37b25(date) {
    var ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return new Date(ms);
}
function $11d87f3f76e88657$export$538b00033cc11c75(date, timeZone) {
    var ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
    return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms, timeZone), date.calendar);
}
function $11d87f3f76e88657$export$d9b67bc93c097491(date) {
    return $11d87f3f76e88657$export$538b00033cc11c75(date, $14e0f24ef4ac5c92$export$aa8b41735afcabd2());
}
var $735220c2d4774dd3$var$ONE_HOUR = 3600000;
function $735220c2d4774dd3$export$e16d8520af44a096(date, duration) {
    var mutableDate = date.copy();
    var days = "hour" in mutableDate ? $735220c2d4774dd3$var$addTimeFields(mutableDate, duration) : 0;
    $735220c2d4774dd3$var$addYears(mutableDate, duration.years || 0);
    if (mutableDate.calendar.balanceYearMonth) mutableDate.calendar.balanceYearMonth(mutableDate, date);
    mutableDate.month += duration.months || 0;
    $735220c2d4774dd3$var$balanceYearMonth(mutableDate);
    $735220c2d4774dd3$var$constrainMonthDay(mutableDate);
    mutableDate.day += (duration.weeks || 0) * 7;
    mutableDate.day += duration.days || 0;
    mutableDate.day += days;
    $735220c2d4774dd3$var$balanceDay(mutableDate);
    if (mutableDate.calendar.balanceDate) mutableDate.calendar.balanceDate(mutableDate);
    // Constrain in case adding ended up with a date outside the valid range for the calendar system.
    // The behavior here is slightly different than when constraining in the `set` function in that
    // we adjust smaller fields to their minimum/maximum values rather than constraining each field
    // individually. This matches the general behavior of `add` vs `set` regarding how fields are balanced.
    if (mutableDate.year < 1) {
        mutableDate.year = 1;
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxYear = mutableDate.calendar.getYearsInEra(mutableDate);
    if (mutableDate.year > maxYear) {
        var _mutableDate_calendar_isInverseEra, _mutableDate_calendar;
        var isInverseEra = (_mutableDate_calendar_isInverseEra = (_mutableDate_calendar = mutableDate.calendar).isInverseEra) === null || _mutableDate_calendar_isInverseEra === void 0 ? void 0 : _mutableDate_calendar_isInverseEra.call(_mutableDate_calendar, mutableDate);
        mutableDate.year = maxYear;
        mutableDate.month = isInverseEra ? 1 : mutableDate.calendar.getMonthsInYear(mutableDate);
        mutableDate.day = isInverseEra ? 1 : mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    if (mutableDate.month < 1) {
        mutableDate.month = 1;
        mutableDate.day = 1;
    }
    var maxMonth = mutableDate.calendar.getMonthsInYear(mutableDate);
    if (mutableDate.month > maxMonth) {
        mutableDate.month = maxMonth;
        mutableDate.day = mutableDate.calendar.getDaysInMonth(mutableDate);
    }
    mutableDate.day = Math.max(1, Math.min(mutableDate.calendar.getDaysInMonth(mutableDate), mutableDate.day));
    return mutableDate;
}
function $735220c2d4774dd3$var$addYears(date, years) {
    var _date_calendar_isInverseEra, _date_calendar;
    if ((_date_calendar_isInverseEra = (_date_calendar = date.calendar).isInverseEra) === null || _date_calendar_isInverseEra === void 0 ? void 0 : _date_calendar_isInverseEra.call(_date_calendar, date)) years = -years;
    date.year += years;
}
function $735220c2d4774dd3$var$balanceYearMonth(date) {
    while(date.month < 1){
        $735220c2d4774dd3$var$addYears(date, -1);
        date.month += date.calendar.getMonthsInYear(date);
    }
    var monthsInYear = 0;
    while(date.month > (monthsInYear = date.calendar.getMonthsInYear(date))){
        date.month -= monthsInYear;
        $735220c2d4774dd3$var$addYears(date, 1);
    }
}
function $735220c2d4774dd3$var$balanceDay(date) {
    while(date.day < 1){
        date.month--;
        $735220c2d4774dd3$var$balanceYearMonth(date);
        date.day += date.calendar.getDaysInMonth(date);
    }
    while(date.day > date.calendar.getDaysInMonth(date)){
        date.day -= date.calendar.getDaysInMonth(date);
        date.month++;
        $735220c2d4774dd3$var$balanceYearMonth(date);
    }
}
function $735220c2d4774dd3$var$constrainMonthDay(date) {
    date.month = Math.max(1, Math.min(date.calendar.getMonthsInYear(date), date.month));
    date.day = Math.max(1, Math.min(date.calendar.getDaysInMonth(date), date.day));
}
function $735220c2d4774dd3$export$c4e2ecac49351ef2(date) {
    if (date.calendar.constrainDate) date.calendar.constrainDate(date);
    date.year = Math.max(1, Math.min(date.calendar.getYearsInEra(date), date.year));
    $735220c2d4774dd3$var$constrainMonthDay(date);
}
function $735220c2d4774dd3$export$3e2544e88a25bff8(duration) {
    var inverseDuration = {};
    for(var key in duration)if (typeof duration[key] === "number") inverseDuration[key] = -duration[key];
    return inverseDuration;
}
function $735220c2d4774dd3$export$4e2d2ead65e5f7e3(date, duration) {
    return $735220c2d4774dd3$export$e16d8520af44a096(date, $735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $735220c2d4774dd3$export$adaa4cf7ef1b65be(date, fields) {
    var mutableDate = date.copy();
    if (fields.era != null) mutableDate.era = fields.era;
    if (fields.year != null) mutableDate.year = fields.year;
    if (fields.month != null) mutableDate.month = fields.month;
    if (fields.day != null) mutableDate.day = fields.day;
    $735220c2d4774dd3$export$c4e2ecac49351ef2(mutableDate);
    return mutableDate;
}
function $735220c2d4774dd3$export$e5d5e1c1822b6e56(value, fields) {
    var mutableValue = value.copy();
    if (fields.hour != null) mutableValue.hour = fields.hour;
    if (fields.minute != null) mutableValue.minute = fields.minute;
    if (fields.second != null) mutableValue.second = fields.second;
    if (fields.millisecond != null) mutableValue.millisecond = fields.millisecond;
    $735220c2d4774dd3$export$7555de1e070510cb(mutableValue);
    return mutableValue;
}
function $735220c2d4774dd3$var$balanceTime(time) {
    time.second += Math.floor(time.millisecond / 1000);
    time.millisecond = $735220c2d4774dd3$var$nonNegativeMod(time.millisecond, 1000);
    time.minute += Math.floor(time.second / 60);
    time.second = $735220c2d4774dd3$var$nonNegativeMod(time.second, 60);
    time.hour += Math.floor(time.minute / 60);
    time.minute = $735220c2d4774dd3$var$nonNegativeMod(time.minute, 60);
    var days = Math.floor(time.hour / 24);
    time.hour = $735220c2d4774dd3$var$nonNegativeMod(time.hour, 24);
    return days;
}
function $735220c2d4774dd3$export$7555de1e070510cb(time) {
    time.millisecond = Math.max(0, Math.min(time.millisecond, 1000));
    time.second = Math.max(0, Math.min(time.second, 59));
    time.minute = Math.max(0, Math.min(time.minute, 59));
    time.hour = Math.max(0, Math.min(time.hour, 23));
}
function $735220c2d4774dd3$var$nonNegativeMod(a, b) {
    var result = a % b;
    if (result < 0) result += b;
    return result;
}
function $735220c2d4774dd3$var$addTimeFields(time, duration) {
    time.hour += duration.hours || 0;
    time.minute += duration.minutes || 0;
    time.second += duration.seconds || 0;
    time.millisecond += duration.milliseconds || 0;
    return $735220c2d4774dd3$var$balanceTime(time);
}
function $735220c2d4774dd3$export$7ed87b6bc2506470(time, duration) {
    var res = time.copy();
    $735220c2d4774dd3$var$addTimeFields(res, duration);
    return res;
}
function $735220c2d4774dd3$export$fe34d3a381cd7501(time, duration) {
    return $735220c2d4774dd3$export$7ed87b6bc2506470(time, $735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $735220c2d4774dd3$export$d52ced6badfb9a4c(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case "era":
            {
                var eras = value.calendar.getEras();
                var eraIndex = eras.indexOf(value.era);
                if (eraIndex < 0) throw new Error("Invalid era: " + value.era);
                eraIndex = $735220c2d4774dd3$var$cycleValue(eraIndex, amount, 0, eras.length - 1, options === null || options === void 0 ? void 0 : options.round);
                mutable.era = eras[eraIndex];
                // Constrain the year and other fields within the era, so the era doesn't change when we balance below.
                $735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
                break;
            }
        case "year":
            var _mutable_calendar_isInverseEra, _mutable_calendar;
            if ((_mutable_calendar_isInverseEra = (_mutable_calendar = mutable.calendar).isInverseEra) === null || _mutable_calendar_isInverseEra === void 0 ? void 0 : _mutable_calendar_isInverseEra.call(_mutable_calendar, mutable)) amount = -amount;
            // The year field should not cycle within the era as that can cause weird behavior affecting other fields.
            // We need to also allow values < 1 so that decrementing goes to the previous era. If we get -Infinity back
            // we know we wrapped around after reaching 9999 (the maximum), so set the year back to 1.
            mutable.year = $735220c2d4774dd3$var$cycleValue(value.year, amount, -Infinity, 9999, options === null || options === void 0 ? void 0 : options.round);
            if (mutable.year === -Infinity) mutable.year = 1;
            if (mutable.calendar.balanceYearMonth) mutable.calendar.balanceYearMonth(mutable, value);
            break;
        case "month":
            mutable.month = $735220c2d4774dd3$var$cycleValue(value.month, amount, 1, value.calendar.getMonthsInYear(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        case "day":
            mutable.day = $735220c2d4774dd3$var$cycleValue(value.day, amount, 1, value.calendar.getDaysInMonth(value), options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    if (value.calendar.balanceDate) value.calendar.balanceDate(mutable);
    $735220c2d4774dd3$export$c4e2ecac49351ef2(mutable);
    return mutable;
}
function $735220c2d4774dd3$export$dd02b3e0007dfe28(value, field, amount, options) {
    var mutable = value.copy();
    switch(field){
        case "hour":
            {
                var hours = value.hour;
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = hours >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                mutable.hour = $735220c2d4774dd3$var$cycleValue(hours, amount, min, max, options === null || options === void 0 ? void 0 : options.round);
                break;
            }
        case "minute":
            mutable.minute = $735220c2d4774dd3$var$cycleValue(value.minute, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "second":
            mutable.second = $735220c2d4774dd3$var$cycleValue(value.second, amount, 0, 59, options === null || options === void 0 ? void 0 : options.round);
            break;
        case "millisecond":
            mutable.millisecond = $735220c2d4774dd3$var$cycleValue(value.millisecond, amount, 0, 999, options === null || options === void 0 ? void 0 : options.round);
            break;
        default:
            throw new Error("Unsupported field " + field);
    }
    return mutable;
}
function $735220c2d4774dd3$var$cycleValue(value, amount, min, max) {
    var round = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (round) {
        value += Math.sign(amount);
        if (value < min) value = max;
        var div = Math.abs(amount);
        if (amount > 0) value = Math.ceil(value / div) * div;
        else value = Math.floor(value / div) * div;
        if (value > max) value = min;
    } else {
        value += amount;
        if (value < min) value = max - (min - value - 1);
        else if (value > max) value = min + (value - max - 1);
    }
    return value;
}
function $735220c2d4774dd3$export$96b1d28349274637(dateTime, duration) {
    var ms;
    if (duration.years != null && duration.years !== 0 || duration.months != null && duration.months !== 0 || duration.weeks != null && duration.weeks !== 0 || duration.days != null && duration.days !== 0) {
        var res = $735220c2d4774dd3$export$e16d8520af44a096($11d87f3f76e88657$export$b21e0b124e224484(dateTime), {
            years: duration.years,
            months: duration.months,
            weeks: duration.weeks,
            days: duration.days
        });
        // Changing the date may change the timezone offset, so we need to recompute
        // using the 'compatible' disambiguation.
        ms = $11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
    } else ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
    // Perform time manipulation in milliseconds rather than on the original time fields to account for DST.
    // For example, adding one hour during a DST transition may result in the hour field staying the same or
    // skipping an hour. This results in the offset field changing value instead of the specified field.
    ms += duration.milliseconds || 0;
    ms += (duration.seconds || 0) * 1000;
    ms += (duration.minutes || 0) * 60000;
    ms += (duration.hours || 0) * 3600000;
    var res1 = $11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone);
    return $11d87f3f76e88657$export$b4a036af3fc0b032(res1, dateTime.calendar);
}
function $735220c2d4774dd3$export$6814caac34ca03c7(dateTime, duration) {
    return $735220c2d4774dd3$export$96b1d28349274637(dateTime, $735220c2d4774dd3$export$3e2544e88a25bff8(duration));
}
function $735220c2d4774dd3$export$9a297d111fc86b79(dateTime, field, amount, options) {
    // For date fields, we want the time to remain consistent and the UTC offset to potentially change to account for DST changes.
    // For time fields, we want the time to change by the amount given. This may result in the hour field staying the same, but the UTC
    // offset changing in the case of a backward DST transition, or skipping an hour in the case of a forward DST transition.
    switch(field){
        case "hour":
            {
                var min = 0;
                var max = 23;
                if ((options === null || options === void 0 ? void 0 : options.hourCycle) === 12) {
                    var isPM = dateTime.hour >= 12;
                    min = isPM ? 12 : 0;
                    max = isPM ? 23 : 11;
                }
                // The minimum and maximum hour may be affected by daylight saving time.
                // For example, it might jump forward at midnight, and skip 1am.
                // Or it might end at midnight and repeat the 11pm hour. To handle this, we get
                // the possible absolute times for the min and max, and find the maximum range
                // that is within the current day.
                var plainDateTime = $11d87f3f76e88657$export$b21e0b124e224484(dateTime);
                var minDate = $11d87f3f76e88657$export$b4a036af3fc0b032($735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: min
                }), new $3b62074eb05584b2$export$80ee6245ec4f29ec());
                var minAbsolute = [
                    $11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "earlier"),
                    $11d87f3f76e88657$export$5107c82f94518f5c(minDate, dateTime.timeZone, "later")
                ].filter(function(ms) {
                    return $11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === minDate.day;
                })[0];
                var maxDate = $11d87f3f76e88657$export$b4a036af3fc0b032($735220c2d4774dd3$export$e5d5e1c1822b6e56(plainDateTime, {
                    hour: max
                }), new $3b62074eb05584b2$export$80ee6245ec4f29ec());
                var maxAbsolute = [
                    $11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "earlier"),
                    $11d87f3f76e88657$export$5107c82f94518f5c(maxDate, dateTime.timeZone, "later")
                ].filter(function(ms) {
                    return $11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone).day === maxDate.day;
                }).pop();
                // Since hours may repeat, we need to operate on the absolute time in milliseconds.
                // This is done in hours from the Unix epoch so that cycleValue works correctly,
                // and then converted back to milliseconds.
                var ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(dateTime) - dateTime.offset;
                var hours = Math.floor(ms / $735220c2d4774dd3$var$ONE_HOUR);
                var remainder = ms % $735220c2d4774dd3$var$ONE_HOUR;
                ms = $735220c2d4774dd3$var$cycleValue(hours, amount, Math.floor(minAbsolute / $735220c2d4774dd3$var$ONE_HOUR), Math.floor(maxAbsolute / $735220c2d4774dd3$var$ONE_HOUR), options === null || options === void 0 ? void 0 : options.round) * $735220c2d4774dd3$var$ONE_HOUR + remainder;
                // Now compute the new timezone offset, and convert the absolute time back to local time.
                return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
            }
        case "minute":
        case "second":
        case "millisecond":
            // @ts-ignore
            return $735220c2d4774dd3$export$dd02b3e0007dfe28(dateTime, field, amount, options);
        case "era":
        case "year":
        case "month":
        case "day":
            {
                var res = $735220c2d4774dd3$export$d52ced6badfb9a4c($11d87f3f76e88657$export$b21e0b124e224484(dateTime), field, amount, options);
                var ms1 = $11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone);
                return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms1, dateTime.timeZone), dateTime.calendar);
            }
        default:
            throw new Error("Unsupported field " + field);
    }
}
function $735220c2d4774dd3$export$31b5430eb18be4f8(dateTime, fields, disambiguation) {
    // Set the date/time fields, and recompute the UTC offset to account for DST changes.
    // We also need to validate by converting back to a local time in case hours are skipped during forward DST transitions.
    var plainDateTime = $11d87f3f76e88657$export$b21e0b124e224484(dateTime);
    var res = $735220c2d4774dd3$export$e5d5e1c1822b6e56($735220c2d4774dd3$export$adaa4cf7ef1b65be(plainDateTime, fields), fields);
    // If the resulting plain date time values are equal, return the original time.
    // We don't want to change the offset when setting the time to the same value.
    if (res.compare(plainDateTime) === 0) return dateTime;
    var ms = $11d87f3f76e88657$export$5107c82f94518f5c(res, dateTime.timeZone, disambiguation);
    return $11d87f3f76e88657$export$b4a036af3fc0b032($11d87f3f76e88657$export$1b96692a1ba042ac(ms, dateTime.timeZone), dateTime.calendar);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $fae977aafc393c5c$var$TIME_RE = /^(\d{2})(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $fae977aafc393c5c$var$DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
var $fae977aafc393c5c$var$DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
var $fae977aafc393c5c$var$ZONED_DATE_TIME_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:([+-]\d{2})(?::?(\d{2}))?)?\[(.*?)\]$/;
var $fae977aafc393c5c$var$ABSOLUTE_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
var $fae977aafc393c5c$var$DATE_TIME_DURATION_RE = RegExp("^((?<negative>-)|\\+)?P((?<years>\\d*)Y)?((?<months>\\d*)M)?((?<weeks>\\d*)W)?((?<days>\\d*)D)?((?<time>T)((?<hours>\\d*[.,]?\\d{1,9})H)?((?<minutes>\\d*[.,]?\\d{1,9})M)?((?<seconds>\\d*[.,]?\\d{1,9})S)?)?$");
var $fae977aafc393c5c$var$requiredDurationTimeGroups = [
    "hours",
    "minutes",
    "seconds"
];
var $fae977aafc393c5c$var$requiredDurationGroups = [
    "years",
    "months",
    "weeks",
    "days"
].concat((0, _toConsumableArray._)($fae977aafc393c5c$var$requiredDurationTimeGroups));
function $fae977aafc393c5c$export$c9698ec7f05a07e1(value) {
    var m = value.match($fae977aafc393c5c$var$TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 time string: " + value);
    return new $35ea8db9cb2ccb90$export$680ea196effce5f($fae977aafc393c5c$var$parseNumber(m[1], 0, 23), m[2] ? $fae977aafc393c5c$var$parseNumber(m[2], 0, 59) : 0, m[3] ? $fae977aafc393c5c$var$parseNumber(m[3], 0, 59) : 0, m[4] ? $fae977aafc393c5c$var$parseNumber(m[4], 0, Infinity) * 1000 : 0);
}
function $fae977aafc393c5c$export$6b862160d295c8e(value) {
    var m = value.match($fae977aafc393c5c$var$DATE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date string: " + value);
    var date = new $35ea8db9cb2ccb90$export$99faa760c7908e4f($fae977aafc393c5c$var$parseNumber(m[1], 0, 9999), $fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1);
    date.day = $fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $fae977aafc393c5c$export$588937bcd60ade55(value) {
    var m = value.match($fae977aafc393c5c$var$DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new $35ea8db9cb2ccb90$export$ca871e8dbb80966f($fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[4] ? $fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    return date;
}
function $fae977aafc393c5c$export$fd7893f06e92a6a4(value, disambiguation) {
    var m = value.match($fae977aafc393c5c$var$ZONED_DATE_TIME_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new $35ea8db9cb2ccb90$export$d3b7288e7994edea($fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, m[10], 0, m[4] ? $fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var plainDateTime = $11d87f3f76e88657$export$b21e0b124e224484(date);
    var ms;
    if (m[8]) {
        var _m_;
        date.offset = $fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
        ms = $11d87f3f76e88657$export$bd4fb2bc8bb06fb(date) - date.offset;
        // Validate offset against parsed date.
        var absolutes = $11d87f3f76e88657$export$136f38efe7caf549(plainDateTime, date.timeZone);
        if (!absolutes.includes(ms)) throw new Error("Offset ".concat($fae977aafc393c5c$var$offsetToString(date.offset), " is invalid for ").concat($fae977aafc393c5c$export$4223de14708adc63(date), " in ").concat(date.timeZone));
    } else ms = $11d87f3f76e88657$export$5107c82f94518f5c($11d87f3f76e88657$export$b21e0b124e224484(plainDateTime), date.timeZone, disambiguation);
    return $11d87f3f76e88657$export$1b96692a1ba042ac(ms, date.timeZone);
}
function $fae977aafc393c5c$export$5adfdab05168c219(value, timeZone) {
    var m = value.match($fae977aafc393c5c$var$ABSOLUTE_RE);
    if (!m) throw new Error("Invalid ISO 8601 date time string: " + value);
    var date = new $35ea8db9cb2ccb90$export$d3b7288e7994edea($fae977aafc393c5c$var$parseNumber(m[1], 1, 9999), $fae977aafc393c5c$var$parseNumber(m[2], 1, 12), 1, timeZone, 0, m[4] ? $fae977aafc393c5c$var$parseNumber(m[4], 0, 23) : 0, m[5] ? $fae977aafc393c5c$var$parseNumber(m[5], 0, 59) : 0, m[6] ? $fae977aafc393c5c$var$parseNumber(m[6], 0, 59) : 0, m[7] ? $fae977aafc393c5c$var$parseNumber(m[7], 0, Infinity) * 1000 : 0);
    date.day = $fae977aafc393c5c$var$parseNumber(m[3], 0, date.calendar.getDaysInMonth(date));
    var _m_;
    if (m[8]) date.offset = $fae977aafc393c5c$var$parseNumber(m[8], -23, 23) * 3600000 + $fae977aafc393c5c$var$parseNumber((_m_ = m[9]) !== null && _m_ !== void 0 ? _m_ : "0", 0, 59) * 60000;
    return $11d87f3f76e88657$export$538b00033cc11c75(date, timeZone);
}
function $fae977aafc393c5c$export$8e384432362ed0f0(value) {
    return $fae977aafc393c5c$export$5adfdab05168c219(value, $14e0f24ef4ac5c92$export$aa8b41735afcabd2());
}
function $fae977aafc393c5c$var$parseNumber(value, min, max) {
    var val = Number(value);
    if (val < min || val > max) throw new RangeError("Value out of range: ".concat(min, " <= ").concat(val, " <= ").concat(max));
    return val;
}
function $fae977aafc393c5c$export$f59dee82248f5ad4(time) {
    return "".concat(String(time.hour).padStart(2, "0"), ":").concat(String(time.minute).padStart(2, "0"), ":").concat(String(time.second).padStart(2, "0")).concat(time.millisecond ? String(time.millisecond / 1000).slice(1) : "");
}
function $fae977aafc393c5c$export$60dfd74aa96791bd(date) {
    var gregorianDate = $11d87f3f76e88657$export$b4a036af3fc0b032(date, new $3b62074eb05584b2$export$80ee6245ec4f29ec());
    return "".concat(String(gregorianDate.year).padStart(4, "0"), "-").concat(String(gregorianDate.month).padStart(2, "0"), "-").concat(String(gregorianDate.day).padStart(2, "0"));
}
function $fae977aafc393c5c$export$4223de14708adc63(date) {
    // @ts-ignore
    return "".concat($fae977aafc393c5c$export$60dfd74aa96791bd(date), "T").concat($fae977aafc393c5c$export$f59dee82248f5ad4(date));
}
function $fae977aafc393c5c$var$offsetToString(offset) {
    var sign = Math.sign(offset) < 0 ? "-" : "+";
    offset = Math.abs(offset);
    var offsetHours = Math.floor(offset / 3600000);
    var offsetMinutes = offset % 3600000 / 60000;
    return "".concat(sign).concat(String(offsetHours).padStart(2, "0"), ":").concat(String(offsetMinutes).padStart(2, "0"));
}
function $fae977aafc393c5c$export$bf79f1ebf4b18792(date) {
    return "".concat($fae977aafc393c5c$export$4223de14708adc63(date)).concat($fae977aafc393c5c$var$offsetToString(date.offset), "[").concat(date.timeZone, "]");
}
function $fae977aafc393c5c$export$ecae829bb3747ea6(value) {
    var _match_groups, _match_groups1, _match_groups2, _match_groups3, _match_groups4, _match_groups5, _match_groups6, _match_groups7, _match_groups8;
    var match = value.match($fae977aafc393c5c$var$DATE_TIME_DURATION_RE);
    if (!match) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var parseDurationGroup = function(group, isNegative, min, max) {
        if (!group) return 0;
        try {
            var sign = isNegative ? -1 : 1;
            return sign * $fae977aafc393c5c$var$parseNumber(group.replace(",", "."), min, max);
        } catch (e) {
            throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
        }
    };
    var isNegative = !!((_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups.negative);
    var hasRequiredGroups = $fae977aafc393c5c$var$requiredDurationGroups.some(function(group) {
        var _match_groups;
        return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
    });
    if (!hasRequiredGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    var durationStringIncludesTime = (_match_groups1 = match.groups) === null || _match_groups1 === void 0 ? void 0 : _match_groups1.time;
    if (durationStringIncludesTime) {
        var hasRequiredDurationTimeGroups = $fae977aafc393c5c$var$requiredDurationTimeGroups.some(function(group) {
            var _match_groups;
            return (_match_groups = match.groups) === null || _match_groups === void 0 ? void 0 : _match_groups[group];
        });
        if (!hasRequiredDurationTimeGroups) throw new Error("Invalid ISO 8601 Duration string: ".concat(value));
    }
    var duration = {
        years: parseDurationGroup((_match_groups2 = match.groups) === null || _match_groups2 === void 0 ? void 0 : _match_groups2.years, isNegative, 0, 9999),
        months: parseDurationGroup((_match_groups3 = match.groups) === null || _match_groups3 === void 0 ? void 0 : _match_groups3.months, isNegative, 0, 12),
        weeks: parseDurationGroup((_match_groups4 = match.groups) === null || _match_groups4 === void 0 ? void 0 : _match_groups4.weeks, isNegative, 0, Infinity),
        days: parseDurationGroup((_match_groups5 = match.groups) === null || _match_groups5 === void 0 ? void 0 : _match_groups5.days, isNegative, 0, 31),
        hours: parseDurationGroup((_match_groups6 = match.groups) === null || _match_groups6 === void 0 ? void 0 : _match_groups6.hours, isNegative, 0, 23),
        minutes: parseDurationGroup((_match_groups7 = match.groups) === null || _match_groups7 === void 0 ? void 0 : _match_groups7.minutes, isNegative, 0, 59),
        seconds: parseDurationGroup((_match_groups8 = match.groups) === null || _match_groups8 === void 0 ? void 0 : _match_groups8.seconds, isNegative, 0, 59)
    };
    if (duration.hours !== undefined && duration.hours % 1 !== 0 && (duration.minutes || duration.seconds)) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    if (duration.minutes !== undefined && duration.minutes % 1 !== 0 && duration.seconds) throw new Error("Invalid ISO 8601 Duration string: ".concat(value, " - only the smallest unit can be fractional"));
    return duration;
}
function $35ea8db9cb2ccb90$var$shiftArgs(args) {
    var calendar = typeof args[0] === "object" ? args.shift() : new $3b62074eb05584b2$export$80ee6245ec4f29ec();
    var era;
    if (typeof args[0] === "string") era = args.shift();
    else {
        var eras = calendar.getEras();
        era = eras[eras.length - 1];
    }
    var year = args.shift();
    var month = args.shift();
    var day = args.shift();
    return [
        calendar,
        era,
        year,
        month,
        day
    ];
}
var // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
// If that behavior is desired, use the AnyCalendarDate interface instead.
// @ts-ignore
$35ea8db9cb2ccb90$var$_type = /*#__PURE__*/ new WeakMap();
var $35ea8db9cb2ccb90$export$99faa760c7908e4f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$99faa760c7908e4f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $35ea8db9cb2ccb90$export$99faa760c7908e4f);
        (0, _classPrivateFieldInit._)(this, $35ea8db9cb2ccb90$var$_type, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, _slicedToArray._)($35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        $735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
    (0, _createClass._)($35ea8db9cb2ccb90$export$99faa760c7908e4f, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar, this.era, this.year, this.month, this.day);
                else return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this.calendar, this.year, this.month, this.day);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return $735220c2d4774dd3$export$e16d8520af44a096(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return $735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return $735220c2d4774dd3$export$adaa4cf7ef1b65be(this, fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return $735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */ key: "toDate",
            value: function toDate(timeZone) {
                return $11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return $fae977aafc393c5c$export$60dfd74aa96791bd(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return $14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$99faa760c7908e4f;
}();
var // @ts-ignore
$35ea8db9cb2ccb90$var$_type1 = /*#__PURE__*/ new WeakMap();
var $35ea8db9cb2ccb90$export$680ea196effce5f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$680ea196effce5f() {
        var hour = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, minute = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, second = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, millisecond = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
        (0, _classCallCheck._)(this, $35ea8db9cb2ccb90$export$680ea196effce5f);
        (0, _classPrivateFieldInit._)(this, $35ea8db9cb2ccb90$var$_type1, {
            writable: true,
            value: void 0
        });
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond;
        $735220c2d4774dd3$export$7555de1e070510cb(this);
    }
    (0, _createClass._)($35ea8db9cb2ccb90$export$680ea196effce5f, [
        {
            /** Returns a copy of this time. */ key: "copy",
            value: function copy() {
                return new $35ea8db9cb2ccb90$export$680ea196effce5f(this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `Time` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return $735220c2d4774dd3$export$7ed87b6bc2506470(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return $735220c2d4774dd3$export$fe34d3a381cd7501(this, duration);
            }
        },
        {
            /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return $735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields);
            }
        },
        {
            /**
   * Returns a new `Time` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return $735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
            }
        },
        {
            /** Converts the time to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return $fae977aafc393c5c$export$f59dee82248f5ad4(this);
            }
        },
        {
            /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */ key: "compare",
            value: function compare(b) {
                return $14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, b);
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$680ea196effce5f;
}();
var // @ts-ignore
$35ea8db9cb2ccb90$var$_type2 = /*#__PURE__*/ new WeakMap();
var $35ea8db9cb2ccb90$export$ca871e8dbb80966f = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$ca871e8dbb80966f() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $35ea8db9cb2ccb90$export$ca871e8dbb80966f);
        (0, _classPrivateFieldInit._)(this, $35ea8db9cb2ccb90$var$_type2, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, _slicedToArray._)($35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
    (0, _createClass._)($35ea8db9cb2ccb90$export$ca871e8dbb80966f, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
                else return new $35ea8db9cb2ccb90$export$ca871e8dbb80966f(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return $735220c2d4774dd3$export$e16d8520af44a096(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return $735220c2d4774dd3$export$4e2d2ead65e5f7e3(this, duration);
            }
        },
        {
            /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields) {
                return $735220c2d4774dd3$export$adaa4cf7ef1b65be($735220c2d4774dd3$export$e5d5e1c1822b6e56(this, fields), fields);
            }
        },
        {
            /**
   * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                switch(field){
                    case "era":
                    case "year":
                    case "month":
                    case "day":
                        return $735220c2d4774dd3$export$d52ced6badfb9a4c(this, field, amount, options);
                    default:
                        return $735220c2d4774dd3$export$dd02b3e0007dfe28(this, field, amount, options);
                }
            }
        },
        {
            /** Converts the date to a native JavaScript Date object in the given time zone. */ key: "toDate",
            value: function toDate(timeZone, disambiguation) {
                return $11d87f3f76e88657$export$e67a095c620b86fe(this, timeZone, disambiguation);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string. */ key: "toString",
            value: function toString() {
                return $fae977aafc393c5c$export$4223de14708adc63(this);
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                var res = $14e0f24ef4ac5c92$export$68781ddf31c0090f(this, b);
                if (res === 0) return $14e0f24ef4ac5c92$export$c19a80a9721b80f6(this, $11d87f3f76e88657$export$b21e0b124e224484(b));
                return res;
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$ca871e8dbb80966f;
}();
var // @ts-ignore
$35ea8db9cb2ccb90$var$_type3 = /*#__PURE__*/ new WeakMap();
var $35ea8db9cb2ccb90$export$d3b7288e7994edea = /*#__PURE__*/ function() {
    "use strict";
    function $35ea8db9cb2ccb90$export$d3b7288e7994edea() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $35ea8db9cb2ccb90$export$d3b7288e7994edea);
        (0, _classPrivateFieldInit._)(this, $35ea8db9cb2ccb90$var$_type3, {
            writable: true,
            value: void 0
        });
        var _$35ea8db9cb2ccb90$var$shiftArgs = (0, _slicedToArray._)($35ea8db9cb2ccb90$var$shiftArgs(args), 5), calendar = _$35ea8db9cb2ccb90$var$shiftArgs[0], era = _$35ea8db9cb2ccb90$var$shiftArgs[1], year = _$35ea8db9cb2ccb90$var$shiftArgs[2], month = _$35ea8db9cb2ccb90$var$shiftArgs[3], day = _$35ea8db9cb2ccb90$var$shiftArgs[4];
        var timeZone = args.shift();
        var offset = args.shift();
        this.calendar = calendar;
        this.era = era;
        this.year = year;
        this.month = month;
        this.day = day;
        this.timeZone = timeZone;
        this.offset = offset;
        this.hour = args.shift() || 0;
        this.minute = args.shift() || 0;
        this.second = args.shift() || 0;
        this.millisecond = args.shift() || 0;
        $735220c2d4774dd3$export$c4e2ecac49351ef2(this);
    }
    (0, _createClass._)($35ea8db9cb2ccb90$export$d3b7288e7994edea, [
        {
            /** Returns a copy of this date. */ key: "copy",
            value: function copy() {
                if (this.era) return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
                else return new $35ea8db9cb2ccb90$export$d3b7288e7994edea(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration added to it. */ key: "add",
            value: function add(duration) {
                return $735220c2d4774dd3$export$96b1d28349274637(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */ key: "subtract",
            value: function subtract(duration) {
                return $735220c2d4774dd3$export$6814caac34ca03c7(this, duration);
            }
        },
        {
            /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */ key: "set",
            value: function set(fields, disambiguation) {
                return $735220c2d4774dd3$export$31b5430eb18be4f8(this, fields, disambiguation);
            }
        },
        {
            /**
   * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
   * When the resulting value reaches the limits of the field, it wraps around.
   */ key: "cycle",
            value: function cycle(field, amount, options) {
                return $735220c2d4774dd3$export$9a297d111fc86b79(this, field, amount, options);
            }
        },
        {
            /** Converts the date to a native JavaScript Date object. */ key: "toDate",
            value: function toDate() {
                return $11d87f3f76e88657$export$83aac07b4c37b25(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */ key: "toString",
            value: function toString() {
                return $fae977aafc393c5c$export$bf79f1ebf4b18792(this);
            }
        },
        {
            /** Converts the date to an ISO 8601 formatted string in UTC. */ key: "toAbsoluteString",
            value: function toAbsoluteString() {
                return this.toDate().toISOString();
            }
        },
        {
            /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */ key: "compare",
            value: function compare(b) {
                // TODO: Is this a bad idea??
                return this.toDate().getTime() - $11d87f3f76e88657$export$84c95a83c799e074(b, this.timeZone).toDate().getTime();
            }
        }
    ]);
    return $35ea8db9cb2ccb90$export$d3b7288e7994edea;
}();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from the TC39 Temporal proposal.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $62225008020f0a13$var$ERA_START_DATES = [
    [
        1868,
        9,
        8
    ],
    [
        1912,
        7,
        30
    ],
    [
        1926,
        12,
        25
    ],
    [
        1989,
        1,
        8
    ],
    [
        2019,
        5,
        1
    ]
];
var $62225008020f0a13$var$ERA_END_DATES = [
    [
        1912,
        7,
        29
    ],
    [
        1926,
        12,
        24
    ],
    [
        1989,
        1,
        7
    ],
    [
        2019,
        4,
        30
    ]
];
var $62225008020f0a13$var$ERA_ADDENDS = [
    1867,
    1911,
    1925,
    1988,
    2018
];
var $62225008020f0a13$var$ERA_NAMES = [
    "meiji",
    "taisho",
    "showa",
    "heisei",
    "reiwa"
];
function $62225008020f0a13$var$findEraFromGregorianDate(date) {
    var idx = $62225008020f0a13$var$ERA_START_DATES.findIndex(function(param) {
        var _param = (0, _slicedToArray._)(param, 3), year = _param[0], month = _param[1], day = _param[2];
        if (date.year < year) return true;
        if (date.year === year && date.month < month) return true;
        if (date.year === year && date.month === month && date.day < day) return true;
        return false;
    });
    if (idx === -1) return $62225008020f0a13$var$ERA_START_DATES.length - 1;
    if (idx === 0) return 0;
    return idx - 1;
}
function $62225008020f0a13$var$toGregorian(date) {
    var eraAddend = $62225008020f0a13$var$ERA_ADDENDS[$62225008020f0a13$var$ERA_NAMES.indexOf(date.era)];
    if (!eraAddend) throw new Error("Unknown era: " + date.era);
    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(date.year + eraAddend, date.month, date.day);
}
var $62225008020f0a13$export$b746ab2b60cdffbf = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, _inherits._)($62225008020f0a13$export$b746ab2b60cdffbf, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    var _super = (0, _createSuper._)($62225008020f0a13$export$b746ab2b60cdffbf);
    function $62225008020f0a13$export$b746ab2b60cdffbf() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $62225008020f0a13$export$b746ab2b60cdffbf);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "japanese";
        return _this;
    }
    (0, _createClass._)($62225008020f0a13$export$b746ab2b60cdffbf, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, _get._)((0, _getPrototypeOf._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "fromJulianDay", this).call(this, jd);
                var era = $62225008020f0a13$var$findEraFromGregorianDate(date);
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, $62225008020f0a13$var$ERA_NAMES[era], date.year - $62225008020f0a13$var$ERA_ADDENDS[era], date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "toJulianDay", this).call(this, $62225008020f0a13$var$toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var gregorianDate = $62225008020f0a13$var$toGregorian(date);
                var era = $62225008020f0a13$var$findEraFromGregorianDate(gregorianDate);
                if ($62225008020f0a13$var$ERA_NAMES[era] !== date.era) {
                    date.era = $62225008020f0a13$var$ERA_NAMES[era];
                    date.year = gregorianDate.year - $62225008020f0a13$var$ERA_ADDENDS[era];
                }
                // Constrain in case we went before the first supported era.
                this.constrainDate(date);
            }
        },
        {
            key: "constrainDate",
            value: function constrainDate(date) {
                var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
                var end = $62225008020f0a13$var$ERA_END_DATES[idx];
                if (end != null) {
                    var _end = (0, _slicedToArray._)(end, 3), endYear = _end[0], endMonth = _end[1], endDay = _end[2];
                    // Constrain the year to the maximum possible value in the era.
                    // Then constrain the month and day fields within that.
                    var maxYear = endYear - $62225008020f0a13$var$ERA_ADDENDS[idx];
                    date.year = Math.max(1, Math.min(maxYear, date.year));
                    if (date.year === maxYear) {
                        date.month = Math.min(endMonth, date.month);
                        if (date.month === endMonth) date.day = Math.min(endDay, date.day);
                    }
                }
                if (date.year === 1 && idx >= 0) {
                    var _$62225008020f0a13$var$ERA_START_DATES_idx = (0, _slicedToArray._)($62225008020f0a13$var$ERA_START_DATES[idx], 3), startMonth = _$62225008020f0a13$var$ERA_START_DATES_idx[1], startDay = _$62225008020f0a13$var$ERA_START_DATES_idx[2];
                    date.month = Math.max(startMonth, date.month);
                    if (date.month === startMonth) date.day = Math.max(startDay, date.day);
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return $62225008020f0a13$var$ERA_NAMES;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // Get the number of years in the era, taking into account the date's month and day fields.
                var era = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
                var cur = $62225008020f0a13$var$ERA_START_DATES[era];
                var next = $62225008020f0a13$var$ERA_START_DATES[era + 1];
                if (next == null) return 9999 - cur[0] + 1;
                var years = next[0] - cur[0];
                if (date.month < next[1] || date.month === next[1] && date.day < next[2]) years++;
                return years;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)($62225008020f0a13$export$b746ab2b60cdffbf.prototype), "getDaysInMonth", this).call(this, $62225008020f0a13$var$toGregorian(date));
            }
        },
        {
            key: "getMinimumMonthInYear",
            value: function getMinimumMonthInYear(date) {
                var start = $62225008020f0a13$var$getMinimums(date);
                return start ? start[1] : 1;
            }
        },
        {
            key: "getMinimumDayInMonth",
            value: function getMinimumDayInMonth(date) {
                var start = $62225008020f0a13$var$getMinimums(date);
                return start && date.month === start[1] ? start[2] : 1;
            }
        }
    ]);
    return $62225008020f0a13$export$b746ab2b60cdffbf;
}($3b62074eb05584b2$export$80ee6245ec4f29ec);
function $62225008020f0a13$var$getMinimums(date) {
    if (date.year === 1) {
        var idx = $62225008020f0a13$var$ERA_NAMES.indexOf(date.era);
        return $62225008020f0a13$var$ERA_START_DATES[idx];
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $8d73d47422ca7302$var$BUDDHIST_ERA_START = -543;
var $8d73d47422ca7302$export$42d20a78301dee44 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, _inherits._)($8d73d47422ca7302$export$42d20a78301dee44, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    var _super = (0, _createSuper._)($8d73d47422ca7302$export$42d20a78301dee44);
    function $8d73d47422ca7302$export$42d20a78301dee44() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $8d73d47422ca7302$export$42d20a78301dee44);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "buddhist";
        return _this;
    }
    (0, _createClass._)($8d73d47422ca7302$export$42d20a78301dee44, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var gregorianDate = (0, _get._)((0, _getPrototypeOf._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "fromJulianDay", this).call(this, jd);
                var year = $3b62074eb05584b2$export$c36e0ecb2d4fa69d(gregorianDate.era, gregorianDate.year);
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, year - $8d73d47422ca7302$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "toJulianDay", this).call(this, $8d73d47422ca7302$var$toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BE"
                ];
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)($8d73d47422ca7302$export$42d20a78301dee44.prototype), "getDaysInMonth", this).call(this, $8d73d47422ca7302$var$toGregorian(date));
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return $8d73d47422ca7302$export$42d20a78301dee44;
}($3b62074eb05584b2$export$80ee6245ec4f29ec);
function $8d73d47422ca7302$var$toGregorian(date) {
    var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, _slicedToArray._)($3b62074eb05584b2$export$4475b7e617eb123c(date.year + $8d73d47422ca7302$var$BUDDHIST_ERA_START), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era, year, date.month, date.day);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $5f31bd6f0c8940b2$var$TAIWAN_ERA_START = 1911;
function $5f31bd6f0c8940b2$var$gregorianYear(date) {
    return date.era === "minguo" ? date.year + $5f31bd6f0c8940b2$var$TAIWAN_ERA_START : 1 - date.year + $5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
}
function $5f31bd6f0c8940b2$var$gregorianToTaiwan(year) {
    var y = year - $5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
    if (y > 0) return [
        "minguo",
        y
    ];
    else return [
        "before_minguo",
        1 - y
    ];
}
var $5f31bd6f0c8940b2$export$65e01080afcb0799 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, _inherits._)($5f31bd6f0c8940b2$export$65e01080afcb0799, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    var _super = (0, _createSuper._)($5f31bd6f0c8940b2$export$65e01080afcb0799);
    function $5f31bd6f0c8940b2$export$65e01080afcb0799() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $5f31bd6f0c8940b2$export$65e01080afcb0799);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "roc" // Republic of China
        ;
        return _this;
    }
    (0, _createClass._)($5f31bd6f0c8940b2$export$65e01080afcb0799, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var date = (0, _get._)((0, _getPrototypeOf._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "fromJulianDay", this).call(this, jd);
                var extendedYear = $3b62074eb05584b2$export$c36e0ecb2d4fa69d(date.era, date.year);
                var _$5f31bd6f0c8940b2$var$gregorianToTaiwan = (0, _slicedToArray._)($5f31bd6f0c8940b2$var$gregorianToTaiwan(extendedYear), 2), era = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[0], year = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[1];
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, era, year, date.month, date.day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return (0, _get._)((0, _getPrototypeOf._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "toJulianDay", this).call(this, $5f31bd6f0c8940b2$var$toGregorian(date));
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "before_minguo",
                    "minguo"
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                var _$5f31bd6f0c8940b2$var$gregorianToTaiwan = (0, _slicedToArray._)($5f31bd6f0c8940b2$var$gregorianToTaiwan($5f31bd6f0c8940b2$var$gregorianYear(date)), 2), era = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[0], year = _$5f31bd6f0c8940b2$var$gregorianToTaiwan[1];
                date.era = era;
                date.year = year;
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "before_minguo";
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return (0, _get._)((0, _getPrototypeOf._)($5f31bd6f0c8940b2$export$65e01080afcb0799.prototype), "getDaysInMonth", this).call(this, $5f31bd6f0c8940b2$var$toGregorian(date));
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                return date.era === "before_minguo" ? 9999 : 9999 - $5f31bd6f0c8940b2$var$TAIWAN_ERA_START;
            }
        }
    ]);
    return $5f31bd6f0c8940b2$export$65e01080afcb0799;
}($3b62074eb05584b2$export$80ee6245ec4f29ec);
function $5f31bd6f0c8940b2$var$toGregorian(date) {
    var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, _slicedToArray._)($3b62074eb05584b2$export$4475b7e617eb123c($5f31bd6f0c8940b2$var$gregorianYear(date)), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(era, year, date.month, date.day);
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $f3ed2e4472ae7e25$var$PERSIAN_EPOCH = 1948321; // 622/03/19 Julian C.E.
function $f3ed2e4472ae7e25$var$isLeapYear(year) {
    var y0 = year > 0 ? year - 474 : year - 473;
    var y1 = $2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    return $2b4dce13dd5a17fa$export$842a2cf37af977e1((y1 + 38) * 31, 128) < 31;
}
function $f3ed2e4472ae7e25$var$persianToJulianDay(year, month, day) {
    var y0 = year > 0 ? year - 474 : year - 473;
    var y1 = $2b4dce13dd5a17fa$export$842a2cf37af977e1(y0, 2820) + 474;
    var offset = month <= 7 ? 31 * (month - 1) : 30 * (month - 1) + 6;
    return $f3ed2e4472ae7e25$var$PERSIAN_EPOCH - 1 + 1029983 * Math.floor(y0 / 2820) + 365 * (y1 - 1) + Math.floor((31 * y1 - 5) / 128) + offset + day;
}
var $f3ed2e4472ae7e25$export$37fccdbfd14c5939 = /*#__PURE__*/ function() {
    "use strict";
    function $f3ed2e4472ae7e25$export$37fccdbfd14c5939() {
        (0, _classCallCheck._)(this, $f3ed2e4472ae7e25$export$37fccdbfd14c5939);
        this.identifier = "persian";
    }
    (0, _createClass._)($f3ed2e4472ae7e25$export$37fccdbfd14c5939, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var d0 = jd - $f3ed2e4472ae7e25$var$persianToJulianDay(475, 1, 1);
                var n2820 = Math.floor(d0 / 1029983);
                var d1 = $2b4dce13dd5a17fa$export$842a2cf37af977e1(d0, 1029983);
                var y2820 = d1 === 1029982 ? 2820 : Math.floor((128 * d1 + 46878) / 46751);
                var year = 474 + 2820 * n2820 + y2820;
                if (year <= 0) year--;
                var yDay = jd - $f3ed2e4472ae7e25$var$persianToJulianDay(year, 1, 1) + 1;
                var month = yDay <= 186 ? Math.ceil(yDay / 31) : Math.ceil((yDay - 6) / 31);
                var day = jd - $f3ed2e4472ae7e25$var$persianToJulianDay(year, month, 1) + 1;
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $f3ed2e4472ae7e25$var$persianToJulianDay(date.year, date.month, date.day);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month <= 6) return 31;
                if (date.month <= 11) return 30;
                return $f3ed2e4472ae7e25$var$isLeapYear(date.year) ? 30 : 29;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AP"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9378-10-10 persian is 9999-12-31 gregorian.
                // Round down to 9377 to set the maximum full year.
                return 9377;
            }
        }
    ]);
    return $f3ed2e4472ae7e25$export$37fccdbfd14c5939;
}();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
// Starts in 78 AD,
var $82c358003bdda0a8$var$INDIAN_ERA_START = 78;
// The Indian year starts 80 days later than the Gregorian year.
var $82c358003bdda0a8$var$INDIAN_YEAR_START = 80;
var $82c358003bdda0a8$export$39f31c639fa15726 = /*#__PURE__*/ function($3b62074eb05584b2$export$80ee6245ec4f29ec) {
    "use strict";
    (0, _inherits._)($82c358003bdda0a8$export$39f31c639fa15726, $3b62074eb05584b2$export$80ee6245ec4f29ec);
    var _super = (0, _createSuper._)($82c358003bdda0a8$export$39f31c639fa15726);
    function $82c358003bdda0a8$export$39f31c639fa15726() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $82c358003bdda0a8$export$39f31c639fa15726);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "indian";
        return _this;
    }
    (0, _createClass._)($82c358003bdda0a8$export$39f31c639fa15726, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                // Gregorian date for Julian day
                var date = (0, _get._)((0, _getPrototypeOf._)($82c358003bdda0a8$export$39f31c639fa15726.prototype), "fromJulianDay", this).call(this, jd);
                // Year in Saka era
                var indianYear = date.year - $82c358003bdda0a8$var$INDIAN_ERA_START;
                // Day number in Gregorian year (starting from 0)
                var yDay = jd - $3b62074eb05584b2$export$f297eb839006d339(date.era, date.year, 1, 1);
                var leapMonth;
                if (yDay < $82c358003bdda0a8$var$INDIAN_YEAR_START) {
                    //  Day is at the end of the preceding Saka year
                    indianYear--;
                    // Days in leapMonth this year, previous Gregorian year
                    leapMonth = $3b62074eb05584b2$export$553d7fa8e3805fc0(date.year - 1) ? 31 : 30;
                    yDay += leapMonth + 155 + 90 + 10;
                } else {
                    // Days in leapMonth this year
                    leapMonth = $3b62074eb05584b2$export$553d7fa8e3805fc0(date.year) ? 31 : 30;
                    yDay -= $82c358003bdda0a8$var$INDIAN_YEAR_START;
                }
                var indianMonth;
                var indianDay;
                if (yDay < leapMonth) {
                    indianMonth = 1;
                    indianDay = yDay + 1;
                } else {
                    var mDay = yDay - leapMonth;
                    if (mDay < 155) {
                        indianMonth = Math.floor(mDay / 31) + 2;
                        indianDay = mDay % 31 + 1;
                    } else {
                        mDay -= 155;
                        indianMonth = Math.floor(mDay / 30) + 7;
                        indianDay = mDay % 30 + 1;
                    }
                }
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, indianYear, indianMonth, indianDay);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var extendedYear = date.year + $82c358003bdda0a8$var$INDIAN_ERA_START;
                var _$3b62074eb05584b2$export$4475b7e617eb123c = (0, _slicedToArray._)($3b62074eb05584b2$export$4475b7e617eb123c(extendedYear), 2), era = _$3b62074eb05584b2$export$4475b7e617eb123c[0], year = _$3b62074eb05584b2$export$4475b7e617eb123c[1];
                var leapMonth;
                var jd;
                if ($3b62074eb05584b2$export$553d7fa8e3805fc0(year)) {
                    leapMonth = 31;
                    jd = $3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 21);
                } else {
                    leapMonth = 30;
                    jd = $3b62074eb05584b2$export$f297eb839006d339(era, year, 3, 22);
                }
                if (date.month === 1) return jd + date.day - 1;
                jd += leapMonth + Math.min(date.month - 2, 5) * 31;
                if (date.month >= 8) jd += (date.month - 7) * 30;
                jd += date.day - 1;
                return jd;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.month === 1 && $3b62074eb05584b2$export$553d7fa8e3805fc0(date.year + $82c358003bdda0a8$var$INDIAN_ERA_START)) return 31;
                if (date.month >= 2 && date.month <= 6) return 31;
                return 30;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-12-31 gregorian is 9920-10-10 indian.
                // Round down to 9919 for the last full year.
                return 9919;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "saka"
                ];
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate() {}
        }
    ]);
    return $82c358003bdda0a8$export$39f31c639fa15726;
}($3b62074eb05584b2$export$80ee6245ec4f29ec);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $f2f3e0e3a817edbd$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
var $f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START = 1300;
var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END = 1600;
var $f2f3e0e3a817edbd$var$UMALQURA_START_DAYS = 460322;
function $f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, day) {
    return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $f2f3e0e3a817edbd$var$julianDayToIslamic(calendar, epoch, jd) {
    var year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
    var month = Math.min(12, Math.ceil((jd - (29 + $f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
    var day = jd - $f2f3e0e3a817edbd$var$islamicToJulianDay(epoch, year, month, 1) + 1;
    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(calendar, year, month, day);
}
function $f2f3e0e3a817edbd$var$isLeapYear(year) {
    return (14 + 11 * year) % 30 < 11;
}
var $f2f3e0e3a817edbd$export$2066795aadd37bfc = /*#__PURE__*/ function() {
    "use strict";
    function $f2f3e0e3a817edbd$export$2066795aadd37bfc() {
        (0, _classCallCheck._)(this, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
        this.identifier = "islamic-civil";
    }
    (0, _createClass._)($f2f3e0e3a817edbd$export$2066795aadd37bfc, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return $f2f3e0e3a817edbd$var$julianDayToIslamic(this, $f2f3e0e3a817edbd$var$CIVIL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $f2f3e0e3a817edbd$var$islamicToJulianDay($f2f3e0e3a817edbd$var$CIVIL_EPOC, date.year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                var length = 29 + date.month % 2;
                if (date.month === 12 && $f2f3e0e3a817edbd$var$isLeapYear(date.year)) length++;
                return length;
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $f2f3e0e3a817edbd$var$isLeapYear(date.year) ? 355 : 354;
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999 gregorian
                return 9665;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AH"
                ];
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$2066795aadd37bfc;
}();
var $f2f3e0e3a817edbd$export$37f0887f2f9d22f7 = /*#__PURE__*/ function($f2f3e0e3a817edbd$export$2066795aadd37bfc) {
    "use strict";
    (0, _inherits._)($f2f3e0e3a817edbd$export$37f0887f2f9d22f7, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
    var _super = (0, _createSuper._)($f2f3e0e3a817edbd$export$37f0887f2f9d22f7);
    function $f2f3e0e3a817edbd$export$37f0887f2f9d22f7() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $f2f3e0e3a817edbd$export$37f0887f2f9d22f7);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "islamic-tbla";
        return _this;
    }
    (0, _createClass._)($f2f3e0e3a817edbd$export$37f0887f2f9d22f7, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                return $f2f3e0e3a817edbd$var$julianDayToIslamic(this, $f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, jd);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                return $f2f3e0e3a817edbd$var$islamicToJulianDay($f2f3e0e3a817edbd$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$37f0887f2f9d22f7;
}($f2f3e0e3a817edbd$export$2066795aadd37bfc);
// Generated by scripts/generate-umalqura.js
var $f2f3e0e3a817edbd$var$UMALQURA_DATA = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
var $f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH;
var $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE;
function $f2f3e0e3a817edbd$var$umalquraYearStart(year) {
    return $f2f3e0e3a817edbd$var$UMALQURA_START_DAYS + $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
function $f2f3e0e3a817edbd$var$umalquraMonthLength(year, month) {
    var idx = year - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START;
    var mask = 0x01 << 11 - (month - 1);
    if (($f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;
    else return 30;
}
function $f2f3e0e3a817edbd$var$umalquraMonthStart(year, month) {
    var day = $f2f3e0e3a817edbd$var$umalquraYearStart(year);
    for(var i = 1; i < month; i++)day += $f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
    return day;
}
function $f2f3e0e3a817edbd$var$umalquraYearLength(year) {
    return $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year + 1 - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START];
}
var $f2f3e0e3a817edbd$export$5baab4758c231076 = /*#__PURE__*/ function($f2f3e0e3a817edbd$export$2066795aadd37bfc) {
    "use strict";
    (0, _inherits._)($f2f3e0e3a817edbd$export$5baab4758c231076, $f2f3e0e3a817edbd$export$2066795aadd37bfc);
    var _super = (0, _createSuper._)($f2f3e0e3a817edbd$export$5baab4758c231076);
    function $f2f3e0e3a817edbd$export$5baab4758c231076() {
        (0, _classCallCheck._)(this, $f2f3e0e3a817edbd$export$5baab4758c231076);
        var _this;
        _this = _super.call(this);
        _this.identifier = "islamic-umalqura";
        if (!$f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH) $f2f3e0e3a817edbd$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($f2f3e0e3a817edbd$var$UMALQURA_DATA), function(c) {
            return c.charCodeAt(0);
        }).buffer);
        if (!$f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE) {
            $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($f2f3e0e3a817edbd$var$UMALQURA_YEAR_END - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START + 1);
            var yearStart = 0;
            for(var year = $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START; year <= $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END; year++){
                $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START_TABLE[year - $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START] = yearStart;
                for(var i = 1; i <= 12; i++)yearStart += $f2f3e0e3a817edbd$var$umalquraMonthLength(year, i);
            }
        }
        return _this;
    }
    (0, _createClass._)($f2f3e0e3a817edbd$export$5baab4758c231076, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var days = jd - $f2f3e0e3a817edbd$var$CIVIL_EPOC;
                var startDays = $f2f3e0e3a817edbd$var$umalquraYearStart($f2f3e0e3a817edbd$var$UMALQURA_YEAR_START);
                var endDays = $f2f3e0e3a817edbd$var$umalquraYearStart($f2f3e0e3a817edbd$var$UMALQURA_YEAR_END);
                if (days < startDays || days > endDays) return (0, _get._)((0, _getPrototypeOf._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "fromJulianDay", this).call(this, jd);
                else {
                    var y = $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START - 1;
                    var m = 1;
                    var d = 1;
                    while(d > 0){
                        y++;
                        d = days - $f2f3e0e3a817edbd$var$umalquraYearStart(y) + 1;
                        var yearLength = $f2f3e0e3a817edbd$var$umalquraYearLength(y);
                        if (d === yearLength) {
                            m = 12;
                            break;
                        } else if (d < yearLength) {
                            var monthLength = $f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                            m = 1;
                            while(d > monthLength){
                                d -= monthLength;
                                m++;
                                monthLength = $f2f3e0e3a817edbd$var$umalquraMonthLength(y, m);
                            }
                            break;
                        }
                    }
                    return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, y, m, days - $f2f3e0e3a817edbd$var$umalquraMonthStart(y, m) + 1);
                }
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                if (date.year < $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "toJulianDay", this).call(this, date);
                return $f2f3e0e3a817edbd$var$CIVIL_EPOC + $f2f3e0e3a817edbd$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                if (date.year < $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "getDaysInMonth", this).call(this, date);
                return $f2f3e0e3a817edbd$var$umalquraMonthLength(date.year, date.month);
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                if (date.year < $f2f3e0e3a817edbd$var$UMALQURA_YEAR_START || date.year > $f2f3e0e3a817edbd$var$UMALQURA_YEAR_END) return (0, _get._)((0, _getPrototypeOf._)($f2f3e0e3a817edbd$export$5baab4758c231076.prototype), "getDaysInYear", this).call(this, date);
                return $f2f3e0e3a817edbd$var$umalquraYearLength(date.year);
            }
        }
    ]);
    return $f2f3e0e3a817edbd$export$5baab4758c231076;
}($f2f3e0e3a817edbd$export$2066795aadd37bfc);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $7c5f6fbf42389787$var$HEBREW_EPOCH = 347997;
// Hebrew date calculations are performed in terms of days, hours, and
// "parts" (or halakim), which are 1/1080 of an hour, or 3 1/3 seconds.
var $7c5f6fbf42389787$var$HOUR_PARTS = 1080;
var $7c5f6fbf42389787$var$DAY_PARTS = 24 * $7c5f6fbf42389787$var$HOUR_PARTS;
// An approximate value for the length of a lunar month.
// It is used to calculate the approximate year and month of a given
// absolute date.
var $7c5f6fbf42389787$var$MONTH_DAYS = 29;
var $7c5f6fbf42389787$var$MONTH_FRACT = 12 * $7c5f6fbf42389787$var$HOUR_PARTS + 793;
var $7c5f6fbf42389787$var$MONTH_PARTS = $7c5f6fbf42389787$var$MONTH_DAYS * $7c5f6fbf42389787$var$DAY_PARTS + $7c5f6fbf42389787$var$MONTH_FRACT;
function $7c5f6fbf42389787$var$isLeapYear(year) {
    return $2b4dce13dd5a17fa$export$842a2cf37af977e1(year * 7 + 1, 19) < 7;
}
// Test for delay of start of new year and to avoid
// Sunday, Wednesday, and Friday as start of the new year.
function $7c5f6fbf42389787$var$hebrewDelay1(year) {
    var months = Math.floor((235 * year - 234) / 19);
    var parts = 12084 + 13753 * months;
    var day = months * 29 + Math.floor(parts / 25920);
    if ($2b4dce13dd5a17fa$export$842a2cf37af977e1(3 * (day + 1), 7) < 3) day += 1;
    return day;
}
// Check for delay in start of new year due to length of adjacent years
function $7c5f6fbf42389787$var$hebrewDelay2(year) {
    var last = $7c5f6fbf42389787$var$hebrewDelay1(year - 1);
    var present = $7c5f6fbf42389787$var$hebrewDelay1(year);
    var next = $7c5f6fbf42389787$var$hebrewDelay1(year + 1);
    if (next - present === 356) return 2;
    if (present - last === 382) return 1;
    return 0;
}
function $7c5f6fbf42389787$var$startOfYear(year) {
    return $7c5f6fbf42389787$var$hebrewDelay1(year) + $7c5f6fbf42389787$var$hebrewDelay2(year);
}
function $7c5f6fbf42389787$var$getDaysInYear(year) {
    return $7c5f6fbf42389787$var$startOfYear(year + 1) - $7c5f6fbf42389787$var$startOfYear(year);
}
function $7c5f6fbf42389787$var$getYearType(year) {
    var yearLength = $7c5f6fbf42389787$var$getDaysInYear(year);
    if (yearLength > 380) yearLength -= 30; // Subtract length of leap month.
    switch(yearLength){
        case 353:
            return 0; // deficient
        case 354:
            return 1; // normal
        case 355:
            return 2; // complete
    }
}
function $7c5f6fbf42389787$var$getDaysInMonth(year, month) {
    // Normalize month numbers from 1 - 13, even on non-leap years
    if (month >= 6 && !$7c5f6fbf42389787$var$isLeapYear(year)) month++;
    // First of all, dispose of fixed-length 29 day months
    if (month === 4 || month === 7 || month === 9 || month === 11 || month === 13) return 29;
    var yearType = $7c5f6fbf42389787$var$getYearType(year);
    // If it's Heshvan, days depend on length of year
    if (month === 2) return yearType === 2 ? 30 : 29;
    // Similarly, Kislev varies with the length of year
    if (month === 3) return yearType === 0 ? 29 : 30;
    // Adar I only exists in leap years
    if (month === 6) return $7c5f6fbf42389787$var$isLeapYear(year) ? 30 : 0;
    return 30;
}
var $7c5f6fbf42389787$export$ca405048b8fb5af = /*#__PURE__*/ function() {
    "use strict";
    function $7c5f6fbf42389787$export$ca405048b8fb5af() {
        (0, _classCallCheck._)(this, $7c5f6fbf42389787$export$ca405048b8fb5af);
        this.identifier = "hebrew";
    }
    (0, _createClass._)($7c5f6fbf42389787$export$ca405048b8fb5af, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var d = jd - $7c5f6fbf42389787$var$HEBREW_EPOCH;
                var m = d * $7c5f6fbf42389787$var$DAY_PARTS / $7c5f6fbf42389787$var$MONTH_PARTS; // Months (approx)
                var year = Math.floor((19 * m + 234) / 235) + 1; // Years (approx)
                var ys = $7c5f6fbf42389787$var$startOfYear(year); // 1st day of year
                var dayOfYear = Math.floor(d - ys);
                // Because of the postponement rules, it's possible to guess wrong.  Fix it.
                while(dayOfYear < 1){
                    year--;
                    ys = $7c5f6fbf42389787$var$startOfYear(year);
                    dayOfYear = Math.floor(d - ys);
                }
                // Now figure out which month we're in, and the date within that month
                var month = 1;
                var monthStart = 0;
                while(monthStart < dayOfYear){
                    monthStart += $7c5f6fbf42389787$var$getDaysInMonth(year, month);
                    month++;
                }
                month--;
                monthStart -= $7c5f6fbf42389787$var$getDaysInMonth(year, month);
                var day = dayOfYear - monthStart;
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var jd = $7c5f6fbf42389787$var$startOfYear(date.year);
                for(var month = 1; month < date.month; month++)jd += $7c5f6fbf42389787$var$getDaysInMonth(date.year, month);
                return jd + date.day + $7c5f6fbf42389787$var$HEBREW_EPOCH;
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $7c5f6fbf42389787$var$getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear(date) {
                return $7c5f6fbf42389787$var$isLeapYear(date.year) ? 13 : 12;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return $7c5f6fbf42389787$var$getDaysInYear(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 6239 gregorian
                return 9999;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AM"
                ];
            }
        },
        {
            key: "balanceYearMonth",
            value: function balanceYearMonth(date, previousDate) {
                // Keep date in the same month when switching between leap years and non leap years
                if (previousDate.year !== date.year) {
                    if ($7c5f6fbf42389787$var$isLeapYear(previousDate.year) && !$7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month--;
                    else if (!$7c5f6fbf42389787$var$isLeapYear(previousDate.year) && $7c5f6fbf42389787$var$isLeapYear(date.year) && previousDate.month > 6) date.month++;
                }
            }
        }
    ]);
    return $7c5f6fbf42389787$export$ca405048b8fb5af;
}();
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.
var $b956b2d7a6cf451f$var$ETHIOPIC_EPOCH = 1723856;
var $b956b2d7a6cf451f$var$COPTIC_EPOCH = 1824665;
// The delta between Amete Alem 1 and Amete Mihret 1
// AA 5501 = AM 1
var $b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA = 5500;
function $b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, day) {
    return epoch // difference from Julian epoch to 1,1,1
     + 365 * year // number of days from years
     + Math.floor(year / 4) // extra day of leap year
     + 30 * (month - 1 // number of days from months (1 based)
    ) + day - 1 // number of days for present month (1 based)
    ;
}
function $b956b2d7a6cf451f$var$julianDayToCE(epoch, jd) {
    var year = Math.floor(4 * (jd - epoch) / 1461);
    var month = 1 + Math.floor((jd - $b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, 1, 1)) / 30);
    var day = jd + 1 - $b956b2d7a6cf451f$var$ceToJulianDay(epoch, year, month, 1);
    return [
        year,
        month,
        day
    ];
}
function $b956b2d7a6cf451f$var$getLeapDay(year) {
    return Math.floor(year % 4 / 3);
}
function $b956b2d7a6cf451f$var$getDaysInMonth(year, month) {
    // The Ethiopian and Coptic calendars have 13 months, 12 of 30 days each and
    // an intercalary month at the end of the year of 5 or 6 days, depending whether
    // the year is a leap year or not. The Leap Year follows the same rules as the
    // Julian Calendar so that the extra month always has six days in the year before
    // a Julian Leap Year.
    if (month % 13 !== 0) return 30;
    else return $b956b2d7a6cf451f$var$getLeapDay(year) + 5;
}
var $b956b2d7a6cf451f$export$26ba6eab5e20cd7d = /*#__PURE__*/ function() {
    "use strict";
    function $b956b2d7a6cf451f$export$26ba6eab5e20cd7d() {
        (0, _classCallCheck._)(this, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
        this.identifier = "ethiopic";
    }
    (0, _createClass._)($b956b2d7a6cf451f$export$26ba6eab5e20cd7d, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, _slicedToArray._)($b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                var era = "AM";
                if (year <= 0) {
                    era = "AA";
                    year += $b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                }
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === "AA") year -= $b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                return $b956b2d7a6cf451f$var$ceToJulianDay($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                return $b956b2d7a6cf451f$var$getDaysInMonth(date.year, date.month);
            }
        },
        {
            key: "getMonthsInYear",
            value: function getMonthsInYear() {
                return 13;
            }
        },
        {
            key: "getDaysInYear",
            value: function getDaysInYear(date) {
                return 365 + $b956b2d7a6cf451f$var$getLeapDay(date.year);
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-31 gregorian is 9992-20-02 ethiopic.
                // Round down to 9991 for the last full year.
                // AA 9999-01-01 ethiopic is 4506-09-30 gregorian.
                return date.era === "AA" ? 9999 : 9991;
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AA",
                    "AM"
                ];
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$26ba6eab5e20cd7d;
}();
var $b956b2d7a6cf451f$export$d72e0c37005a4914 = /*#__PURE__*/ function($b956b2d7a6cf451f$export$26ba6eab5e20cd7d) {
    "use strict";
    (0, _inherits._)($b956b2d7a6cf451f$export$d72e0c37005a4914, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
    var _super = (0, _createSuper._)($b956b2d7a6cf451f$export$d72e0c37005a4914);
    function $b956b2d7a6cf451f$export$d72e0c37005a4914() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $b956b2d7a6cf451f$export$d72e0c37005a4914);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "ethioaa" // also known as 'ethiopic-amete-alem' in ICU
        ;
        return _this;
    }
    (0, _createClass._)($b956b2d7a6cf451f$export$d72e0c37005a4914, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, _slicedToArray._)($b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$ETHIOPIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                year += $b956b2d7a6cf451f$var$AMETE_MIHRET_DELTA;
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, "AA", year, month, day);
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "AA"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra() {
                // 9999-13-04 ethioaa is the maximum date, which is equivalent to 4506-09-29 gregorian.
                return 9999;
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$d72e0c37005a4914;
}($b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
var $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1 = /*#__PURE__*/ function($b956b2d7a6cf451f$export$26ba6eab5e20cd7d) {
    "use strict";
    (0, _inherits._)($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1, $b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
    var _super = (0, _createSuper._)($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1);
    function $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, _classCallCheck._)(this, $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, _toConsumableArray._)(args)));
        _this.identifier = "coptic";
        return _this;
    }
    (0, _createClass._)($b956b2d7a6cf451f$export$fe6243cbe1a4b7c1, [
        {
            key: "fromJulianDay",
            value: function fromJulianDay(jd) {
                var _$b956b2d7a6cf451f$var$julianDayToCE = (0, _slicedToArray._)($b956b2d7a6cf451f$var$julianDayToCE($b956b2d7a6cf451f$var$COPTIC_EPOCH, jd), 3), year = _$b956b2d7a6cf451f$var$julianDayToCE[0], month = _$b956b2d7a6cf451f$var$julianDayToCE[1], day = _$b956b2d7a6cf451f$var$julianDayToCE[2];
                var era = "CE";
                if (year <= 0) {
                    era = "BCE";
                    year = 1 - year;
                }
                return new $35ea8db9cb2ccb90$export$99faa760c7908e4f(this, era, year, month, day);
            }
        },
        {
            key: "toJulianDay",
            value: function toJulianDay(date) {
                var year = date.year;
                if (date.era === "BCE") year = 1 - year;
                return $b956b2d7a6cf451f$var$ceToJulianDay($b956b2d7a6cf451f$var$COPTIC_EPOCH, year, date.month, date.day);
            }
        },
        {
            key: "getDaysInMonth",
            value: function getDaysInMonth(date) {
                var year = date.year;
                if (date.era === "BCE") year = 1 - year;
                return $b956b2d7a6cf451f$var$getDaysInMonth(year, date.month);
            }
        },
        {
            key: "isInverseEra",
            value: function isInverseEra(date) {
                return date.era === "BCE";
            }
        },
        {
            key: "balanceDate",
            value: function balanceDate(date) {
                if (date.year <= 0) {
                    date.era = date.era === "BCE" ? "CE" : "BCE";
                    date.year = 1 - date.year;
                }
            }
        },
        {
            key: "getEras",
            value: function getEras() {
                return [
                    "BCE",
                    "CE"
                ];
            }
        },
        {
            key: "getYearsInEra",
            value: function getYearsInEra(date) {
                // 9999-12-30 gregorian is 9716-02-20 coptic.
                // Round down to 9715 for the last full year.
                // BCE 9999-01-01 coptic is BC 9716-06-15 gregorian.
                return date.era === "BCE" ? 9999 : 9715;
            }
        }
    ]);
    return $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1;
}($b956b2d7a6cf451f$export$26ba6eab5e20cd7d);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $64244302c3013299$export$dd0bbc9b26defe37(name) {
    switch(name){
        case "buddhist":
            return new $8d73d47422ca7302$export$42d20a78301dee44();
        case "ethiopic":
            return new $b956b2d7a6cf451f$export$26ba6eab5e20cd7d();
        case "ethioaa":
            return new $b956b2d7a6cf451f$export$d72e0c37005a4914();
        case "coptic":
            return new $b956b2d7a6cf451f$export$fe6243cbe1a4b7c1();
        case "hebrew":
            return new $7c5f6fbf42389787$export$ca405048b8fb5af();
        case "indian":
            return new $82c358003bdda0a8$export$39f31c639fa15726();
        case "islamic-civil":
            return new $f2f3e0e3a817edbd$export$2066795aadd37bfc();
        case "islamic-tbla":
            return new $f2f3e0e3a817edbd$export$37f0887f2f9d22f7();
        case "islamic-umalqura":
            return new $f2f3e0e3a817edbd$export$5baab4758c231076();
        case "japanese":
            return new $62225008020f0a13$export$b746ab2b60cdffbf();
        case "persian":
            return new $f3ed2e4472ae7e25$export$37fccdbfd14c5939();
        case "roc":
            return new $5f31bd6f0c8940b2$export$65e01080afcb0799();
        case "gregory":
        default:
            return new $3b62074eb05584b2$export$80ee6245ec4f29ec();
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $fb18d541ea1ad717$var$formatterCache = new Map();
var $fb18d541ea1ad717$export$ad991b66133851cf = /*#__PURE__*/ function() {
    "use strict";
    function $fb18d541ea1ad717$export$ad991b66133851cf(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, $fb18d541ea1ad717$export$ad991b66133851cf);
        this.formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, options);
        this.options = options;
    }
    (0, _createClass._)($fb18d541ea1ad717$export$ad991b66133851cf, [
        {
            /** Formats a date as a string according to the locale and format options passed to the constructor. */ key: "format",
            value: function format(value) {
                return this.formatter.format(value);
            }
        },
        {
            /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                return this.formatter.formatToParts(value);
            }
        },
        {
            /** Formats a date range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRange === "function") return this.formatter.formatRange(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                // Very basic fallback for old browsers.
                return "".concat(this.formatter.format(start), " \u2013 ").concat(this.formatter.format(end));
            }
        },
        {
            /** Formats a date range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                // @ts-ignore
                if (typeof this.formatter.formatRangeToParts === "function") return this.formatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                var startParts = this.formatter.formatToParts(start);
                var endParts = this.formatter.formatToParts(end);
                return (0, _toConsumableArray._)(startParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "startRange"
                    });
                })).concat([
                    {
                        type: "literal",
                        value: " \u2013 ",
                        source: "shared"
                    }
                ], (0, _toConsumableArray._)(endParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "endRange"
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var resolvedOptions = this.formatter.resolvedOptions();
                if ($fb18d541ea1ad717$var$hasBuggyResolvedHourCycle()) {
                    if (!this.resolvedHourCycle) this.resolvedHourCycle = $fb18d541ea1ad717$var$getResolvedHourCycle(resolvedOptions.locale, this.options);
                    resolvedOptions.hourCycle = this.resolvedHourCycle;
                    resolvedOptions.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12";
                }
                // Safari uses a different name for the Ethiopic (Amete Alem) calendar.
                // https://bugs.webkit.org/show_bug.cgi?id=241564
                if (resolvedOptions.calendar === "ethiopic-amete-alem") resolvedOptions.calendar = "ethioaa";
                return resolvedOptions;
            }
        }
    ]);
    return $fb18d541ea1ad717$export$ad991b66133851cf;
}();
// There are multiple bugs involving the hour12 and hourCycle options in various browser engines.
//   - Chrome [1] (and the ECMA 402 spec [2]) resolve hour12: false in English and other locales to h24 (24:00 - 23:59)
//     rather than h23 (00:00 - 23:59). Same can happen with hour12: true in French, which Chrome resolves to h11 (00:00 - 11:59)
//     rather than h12 (12:00 - 11:59).
//   - WebKit returns an incorrect hourCycle resolved option in the French locale due to incorrect parsing of 'h' literal
//     in the resolved pattern. It also formats incorrectly when specifying the hourCycle option for the same reason. [3]
// [1] https://bugs.chromium.org/p/chromium/issues/detail?id=1045791
// [2] https://github.com/tc39/ecma402/issues/402
// [3] https://bugs.webkit.org/show_bug.cgi?id=229313
// https://github.com/unicode-org/cldr/blob/018b55eff7ceb389c7e3fc44e2f657eae3b10b38/common/supplemental/supplementalData.xml#L4774-L4802
var $fb18d541ea1ad717$var$hour12Preferences = {
    true: {
        // Only Japanese uses the h11 style for 12 hour time. All others use h12.
        ja: "h11"
    },
    false: {}
};
function $fb18d541ea1ad717$var$getCachedDateFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Work around buggy hour12 behavior in Chrome / ECMA 402 spec by using hourCycle instead.
    // Only apply the workaround if the issue is detected, because the hourCycle option is buggy in Safari.
    if (typeof options.hour12 === "boolean" && $fb18d541ea1ad717$var$hasBuggyHour12Behavior()) {
        options = (0, _objectSpread._)({}, options);
        var pref = $fb18d541ea1ad717$var$hour12Preferences[String(options.hour12)][locale.split("-")[0]];
        var defaultHourCycle = options.hour12 ? "h12" : "h23";
        options.hourCycle = pref !== null && pref !== void 0 ? pref : defaultHourCycle;
        delete options.hour12;
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if ($fb18d541ea1ad717$var$formatterCache.has(cacheKey)) return $fb18d541ea1ad717$var$formatterCache.get(cacheKey);
    var numberFormatter = new Intl.DateTimeFormat(locale, options);
    $fb18d541ea1ad717$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
var $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = null;
function $fb18d541ea1ad717$var$hasBuggyHour12Behavior() {
    if ($fb18d541ea1ad717$var$_hasBuggyHour12Behavior == null) $fb18d541ea1ad717$var$_hasBuggyHour12Behavior = new Intl.DateTimeFormat("en-US", {
        hour: "numeric",
        hour12: false
    }).format(new Date(2020, 2, 3, 0)) === "24";
    return $fb18d541ea1ad717$var$_hasBuggyHour12Behavior;
}
var $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = null;
function $fb18d541ea1ad717$var$hasBuggyResolvedHourCycle() {
    if ($fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle == null) $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle = new Intl.DateTimeFormat("fr", {
        hour: "numeric",
        hour12: false
    }).resolvedOptions().hourCycle === "h12";
    return $fb18d541ea1ad717$var$_hasBuggyResolvedHourCycle;
}
function $fb18d541ea1ad717$var$getResolvedHourCycle(locale, options) {
    if (!options.timeStyle && !options.hour) return undefined;
    // Work around buggy results in resolved hourCycle and hour12 options in WebKit.
    // Format the minimum possible hour and maximum possible hour in a day and parse the results.
    locale = locale.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
    locale += (locale.includes("-u-") ? "" : "-u") + "-nu-latn";
    var formatter = $fb18d541ea1ad717$var$getCachedDateFormatter(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        timeZone: undefined // use local timezone
    }));
    var min = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 0)).find(function(p) {
        return p.type === "hour";
    }).value, 10);
    var max = parseInt(formatter.formatToParts(new Date(2020, 2, 3, 23)).find(function(p) {
        return p.type === "hour";
    }).value, 10);
    if (min === 0 && max === 23) return "h23";
    if (min === 24 && max === 23) return "h24";
    if (min === 0 && max === 11) return "h11";
    if (min === 12 && max === 11) return "h12";
    throw new Error("Unexpected hour cycle result");
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_get":"dwBDP","@swc/helpers/_/_get_prototype_of":"6bloJ","@swc/helpers/_/_inherits":"j9BK3","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","@swc/helpers/_/_create_super":"cFmrg","@swc/helpers/_/_class_private_field_init":"f5jxq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kaxG1":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberFormatter", function() {
    return $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5;
});
parcelHelpers.export(exports, "NumberParser", function() {
    return $6c7bd7858deea686$export$cd11ab140839f11d;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var $488c6ddbf4ef74c2$var$formatterCache = new Map();
var $488c6ddbf4ef74c2$var$supportsSignDisplay = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsSignDisplay = new Intl.NumberFormat("de-DE", {
        signDisplay: "exceptZero"
    }).resolvedOptions().signDisplay === "exceptZero";
// eslint-disable-next-line no-empty
} catch (e) {}
var $488c6ddbf4ef74c2$var$supportsUnit = false;
try {
    // @ts-ignore
    $488c6ddbf4ef74c2$var$supportsUnit = new Intl.NumberFormat("de-DE", {
        style: "unit",
        unit: "degree"
    }).resolvedOptions().style === "unit";
// eslint-disable-next-line no-empty
} catch (e) {}
// Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.
var $488c6ddbf4ef74c2$var$UNITS = {
    degree: {
        narrow: {
            default: "\xb0",
            "ja-JP": " \u5EA6",
            "zh-TW": "\u5EA6",
            "sl-SI": " \xb0"
        }
    }
};
var $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5 = /*#__PURE__*/ function() {
    "use strict";
    function $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5);
        this.numberFormatter = $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale, options);
        this.options = options;
    }
    (0, _createClass._)($488c6ddbf4ef74c2$export$cc77c4ff7e8673c5, [
        {
            /** Formats a number value as a string, according to the locale and options provided to the constructor. */ key: "format",
            value: function format(value) {
                var res = "";
                if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) res = $488c6ddbf4ef74c2$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);
                else res = this.numberFormatter.format(value);
                if (this.options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
                    var _UNITS_unit;
                    var _this_resolvedOptions = this.resolvedOptions(), unit = _this_resolvedOptions.unit, tmp = _this_resolvedOptions.unitDisplay, unitDisplay = tmp === void 0 ? "short" : tmp, locale = _this_resolvedOptions.locale;
                    if (!unit) return res;
                    var values = (_UNITS_unit = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay];
                    res += values[locale] || values.default;
                }
                return res;
            }
        },
        {
            /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */ key: "formatToParts",
            value: function formatToParts(value) {
                // TODO: implement signDisplay for formatToParts
                // @ts-ignore
                return this.numberFormatter.formatToParts(value);
            }
        },
        {
            /** Formats a number range as a string. */ key: "formatRange",
            value: function formatRange(start, end) {
                // @ts-ignore
                if (typeof this.numberFormatter.formatRange === "function") return this.numberFormatter.formatRange(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                // Very basic fallback for old browsers.
                return "".concat(this.format(start), " \u2013 ").concat(this.format(end));
            }
        },
        {
            /** Formats a number range as an array of parts. */ key: "formatRangeToParts",
            value: function formatRangeToParts(start, end) {
                // @ts-ignore
                if (typeof this.numberFormatter.formatRangeToParts === "function") return this.numberFormatter.formatRangeToParts(start, end);
                if (end < start) throw new RangeError("End date must be >= start date");
                var startParts = this.numberFormatter.formatToParts(start);
                var endParts = this.numberFormatter.formatToParts(end);
                return (0, _toConsumableArray._)(startParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "startRange"
                    });
                })).concat([
                    {
                        type: "literal",
                        value: " \u2013 ",
                        source: "shared"
                    }
                ], (0, _toConsumableArray._)(endParts.map(function(p) {
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                        source: "endRange"
                    });
                })));
            }
        },
        {
            /** Returns the resolved formatting options based on the values passed to the constructor. */ key: "resolvedOptions",
            value: function resolvedOptions() {
                var options = this.numberFormatter.resolvedOptions();
                if (!$488c6ddbf4ef74c2$var$supportsSignDisplay && this.options.signDisplay != null) options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    signDisplay: this.options.signDisplay
                });
                if (!$488c6ddbf4ef74c2$var$supportsUnit && this.options.style === "unit") options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    style: "unit",
                    unit: this.options.unit,
                    unitDisplay: this.options.unitDisplay
                });
                return options;
            }
        }
    ]);
    return $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5;
}();
function $488c6ddbf4ef74c2$var$getCachedNumberFormatter(locale) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var numberingSystem = options.numberingSystem;
    if (numberingSystem && locale.includes("-nu-")) {
        if (!locale.includes("-u-")) locale += "-u-";
        locale += "-nu-".concat(numberingSystem);
    }
    if (options.style === "unit" && !$488c6ddbf4ef74c2$var$supportsUnit) {
        var _UNITS_unit;
        var unit = options.unit, tmp = options.unitDisplay, unitDisplay = tmp === void 0 ? "short" : tmp;
        if (!unit) throw new Error('unit option must be provided with style: "unit"');
        if (!((_UNITS_unit = $488c6ddbf4ef74c2$var$UNITS[unit]) === null || _UNITS_unit === void 0 ? void 0 : _UNITS_unit[unitDisplay])) throw new Error("Unsupported unit ".concat(unit, " with unitDisplay = ").concat(unitDisplay));
        options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            style: "decimal"
        });
    }
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    if ($488c6ddbf4ef74c2$var$formatterCache.has(cacheKey)) return $488c6ddbf4ef74c2$var$formatterCache.get(cacheKey);
    var numberFormatter = new Intl.NumberFormat(locale, options);
    $488c6ddbf4ef74c2$var$formatterCache.set(cacheKey, numberFormatter);
    return numberFormatter;
}
function $488c6ddbf4ef74c2$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
    if (signDisplay === "auto") return numberFormat.format(num);
    else if (signDisplay === "never") return numberFormat.format(Math.abs(num));
    else {
        var needsPositiveSign = false;
        if (signDisplay === "always") needsPositiveSign = num > 0 || Object.is(num, 0);
        else if (signDisplay === "exceptZero") {
            if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);
            else needsPositiveSign = num > 0;
        }
        if (needsPositiveSign) {
            var negative = numberFormat.format(-num);
            var noSign = numberFormat.format(num);
            // ignore RTL/LTR marker character
            var minus = negative.replace(noSign, "").replace(/\u200e|\u061C/, "");
            if ((0, _toConsumableArray._)(minus).length !== 1) console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case");
            var positive = negative.replace(noSign, "!!!").replace(minus, "+").replace("!!!", noSign);
            return positive;
        } else return numberFormat.format(num);
    }
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var $6c7bd7858deea686$var$CURRENCY_SIGN_REGEX = new RegExp("^.*\\(.*\\).*$");
var $6c7bd7858deea686$var$NUMBERING_SYSTEMS = [
    "latn",
    "arab",
    "hanidec"
];
var $6c7bd7858deea686$export$cd11ab140839f11d = /*#__PURE__*/ function() {
    "use strict";
    function $6c7bd7858deea686$export$cd11ab140839f11d(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, $6c7bd7858deea686$export$cd11ab140839f11d);
        this.locale = locale;
        this.options = options;
    }
    (0, _createClass._)($6c7bd7858deea686$export$cd11ab140839f11d, [
        {
            /**
   * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
   */ key: "parse",
            value: function parse(value) {
                return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
            }
        },
        {
            /**
   * Returns whether the given string could potentially be a valid number. This should be used to
   * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
   * of the minus/plus sign characters can be checked.
   */ key: "isValidPartialNumber",
            value: function isValidPartialNumber(value, minValue, maxValue) {
                return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
            }
        },
        {
            /**
   * Returns a numbering system for which the given string is valid in the current locale.
   * If no numbering system could be detected, the default numbering system for the current
   * locale is returned.
   */ key: "getNumberingSystem",
            value: function getNumberingSystem(value) {
                return $6c7bd7858deea686$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
            }
        }
    ]);
    return $6c7bd7858deea686$export$cd11ab140839f11d;
}();
var $6c7bd7858deea686$var$numberParserCache = new Map();
function $6c7bd7858deea686$var$getNumberParserImpl(locale, options, value) {
    // First try the default numbering system for the provided locale
    var defaultParser = $6c7bd7858deea686$var$getCachedNumberParser(locale, options);
    // If that doesn't match, and the locale doesn't include a hard coded numbering system,
    // try each of the other supported numbering systems until we find one that matches.
    if (!locale.includes("-nu-") && !defaultParser.isValidPartialNumber(value)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $6c7bd7858deea686$var$NUMBERING_SYSTEMS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var numberingSystem = _step.value;
                if (numberingSystem !== defaultParser.options.numberingSystem) {
                    var parser = $6c7bd7858deea686$var$getCachedNumberParser(locale + (locale.includes("-u-") ? "-nu-" : "-u-nu-") + numberingSystem, options);
                    if (parser.isValidPartialNumber(value)) return parser;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return defaultParser;
}
function $6c7bd7858deea686$var$getCachedNumberParser(locale, options) {
    var cacheKey = locale + (options ? Object.entries(options).sort(function(a, b) {
        return a[0] < b[0] ? -1 : 1;
    }).join() : "");
    var parser = $6c7bd7858deea686$var$numberParserCache.get(cacheKey);
    if (!parser) {
        parser = new $6c7bd7858deea686$var$NumberParserImpl(locale, options);
        $6c7bd7858deea686$var$numberParserCache.set(cacheKey, parser);
    }
    return parser;
}
// The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.
var $6c7bd7858deea686$var$NumberParserImpl = /*#__PURE__*/ function() {
    "use strict";
    function $6c7bd7858deea686$var$NumberParserImpl(locale) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, _classCallCheck._)(this, $6c7bd7858deea686$var$NumberParserImpl);
        this.locale = locale;
        this.formatter = new Intl.NumberFormat(locale, options);
        this.options = this.formatter.resolvedOptions();
        this.symbols = $6c7bd7858deea686$var$getSymbols(locale, this.formatter, this.options, options);
        var _this_options_minimumFractionDigits, _this_options_maximumFractionDigits;
        if (this.options.style === "percent" && (((_this_options_minimumFractionDigits = this.options.minimumFractionDigits) !== null && _this_options_minimumFractionDigits !== void 0 ? _this_options_minimumFractionDigits : 0) > 18 || ((_this_options_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _this_options_maximumFractionDigits !== void 0 ? _this_options_maximumFractionDigits : 0) > 18)) console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
    }
    (0, _createClass._)($6c7bd7858deea686$var$NumberParserImpl, [
        {
            key: "parse",
            value: function parse(value) {
                // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
                var fullySanitizedValue = this.sanitize(value);
                if (this.symbols.group) fullySanitizedValue = $6c7bd7858deea686$var$replaceAll(fullySanitizedValue, this.symbols.group, "");
                if (this.symbols.decimal) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.decimal, ".");
                if (this.symbols.minusSign) fullySanitizedValue = fullySanitizedValue.replace(this.symbols.minusSign, "-");
                fullySanitizedValue = fullySanitizedValue.replace(this.symbols.numeral, this.symbols.index);
                if (this.options.style === "percent") {
                    // javascript is bad at dividing by 100 and maintaining the same significant figures, so perform it on the string before parsing
                    var isNegative = fullySanitizedValue.indexOf("-");
                    fullySanitizedValue = fullySanitizedValue.replace("-", "");
                    var index = fullySanitizedValue.indexOf(".");
                    if (index === -1) index = fullySanitizedValue.length;
                    fullySanitizedValue = fullySanitizedValue.replace(".", "");
                    if (index - 2 === 0) fullySanitizedValue = "0.".concat(fullySanitizedValue);
                    else if (index - 2 === -1) fullySanitizedValue = "0.0".concat(fullySanitizedValue);
                    else if (index - 2 === -2) fullySanitizedValue = "0.00";
                    else fullySanitizedValue = "".concat(fullySanitizedValue.slice(0, index - 2), ".").concat(fullySanitizedValue.slice(index - 2));
                    if (isNegative > -1) fullySanitizedValue = "-".concat(fullySanitizedValue);
                }
                var newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
                if (isNaN(newValue)) return NaN;
                if (this.options.style === "percent") {
                    // extra step for rounding percents to what our formatter would output
                    var options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options), {
                        style: "decimal",
                        minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
                        maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
                    });
                    return new $6c7bd7858deea686$export$cd11ab140839f11d(this.locale, options).parse(new $488c6ddbf4ef74c2$export$cc77c4ff7e8673c5(this.locale, options).format(newValue));
                }
                // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again
                if (this.options.currencySign === "accounting" && $6c7bd7858deea686$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue;
                return newValue;
            }
        },
        {
            key: "sanitize",
            value: function sanitize(value) {
                // Remove literals and whitespace, which are allowed anywhere in the string
                value = value.replace(this.symbols.literals, "");
                // Replace the ASCII minus sign with the minus sign used in the current locale
                // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.
                if (this.symbols.minusSign) value = value.replace("-", this.symbols.minusSign);
                // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
                // instead they use the , (44) character or apparently the (1548) character.
                if (this.options.numberingSystem === "arab") {
                    if (this.symbols.decimal) {
                        value = value.replace(",", this.symbols.decimal);
                        value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
                    }
                    if (this.symbols.group) value = $6c7bd7858deea686$var$replaceAll(value, ".", this.symbols.group);
                }
                // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
                // so allow 'period' as a group char and replace it with a space
                if (this.options.locale === "fr-FR") value = $6c7bd7858deea686$var$replaceAll(value, ".", String.fromCharCode(8239));
                return value;
            }
        },
        {
            key: "isValidPartialNumber",
            value: function isValidPartialNumber(value) {
                var minValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -Infinity, maxValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
                value = this.sanitize(value);
                // Remove minus or plus sign, which must be at the start of the string.
                if (this.symbols.minusSign && value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);
                else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length);
                // Numbers cannot start with a group separator
                if (this.symbols.group && value.startsWith(this.symbols.group)) return false;
                // Numbers that can't have any decimal values fail if a decimal character is typed
                if (this.symbols.decimal && value.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0) return false;
                // Remove numerals, groups, and decimals
                if (this.symbols.group) value = $6c7bd7858deea686$var$replaceAll(value, this.symbols.group, "");
                value = value.replace(this.symbols.numeral, "");
                if (this.symbols.decimal) value = value.replace(this.symbols.decimal, "");
                // The number is valid if there are no remaining characters
                return value.length === 0;
            }
        }
    ]);
    return $6c7bd7858deea686$var$NumberParserImpl;
}();
var $6c7bd7858deea686$var$nonLiteralParts = new Set([
    "decimal",
    "fraction",
    "integer",
    "minusSign",
    "plusSign",
    "group"
]);
// This list is derived from https://www.unicode.org/cldr/charts/43/supplemental/language_plural_rules.html#comparison and includes
// all unique numbers which we need to check in order to determine all the plural forms for a given locale.
// See: https://github.com/adobe/react-spectrum/pull/5134/files#r1337037855 for used script
var $6c7bd7858deea686$var$pluralNumbers = [
    0,
    4,
    2,
    1,
    11,
    20,
    3,
    7,
    100,
    21,
    0.1,
    1.1
];
function $6c7bd7858deea686$var$getSymbols(locale, formatter, intlOptions, originalOptions) {
    var _allParts_find, _posAllParts_find, _decimalParts_find, _allParts_find1;
    // formatter needs access to all decimal places in order to generate the correct literal strings for the plural set
    var symbolFormatter = new Intl.NumberFormat(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, intlOptions), {
        minimumSignificantDigits: 1,
        maximumSignificantDigits: 21
    }));
    // Note: some locale's don't add a group symbol until there is a ten thousands place
    var allParts = symbolFormatter.formatToParts(-10000.111);
    var posAllParts = symbolFormatter.formatToParts(10000.111);
    var pluralParts = $6c7bd7858deea686$var$pluralNumbers.map(function(n) {
        return symbolFormatter.formatToParts(n);
    });
    var _allParts_find_value;
    var minusSign = (_allParts_find_value = (_allParts_find = allParts.find(function(p) {
        return p.type === "minusSign";
    })) === null || _allParts_find === void 0 ? void 0 : _allParts_find.value) !== null && _allParts_find_value !== void 0 ? _allParts_find_value : "-";
    var plusSign = (_posAllParts_find = posAllParts.find(function(p) {
        return p.type === "plusSign";
    })) === null || _posAllParts_find === void 0 ? void 0 : _posAllParts_find.value;
    // Safari does not support the signDisplay option, but our number parser polyfills it.
    // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
    // @ts-ignore
    if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "exceptZero" || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === "always")) plusSign = "+";
    // If maximumSignificantDigits is 1 (the minimum) then we won't get decimal characters out of the above formatters
    // Percent also defaults to 0 fractionDigits, so we need to make a new one that isn't percent to get an accurate decimal
    var decimalParts = new Intl.NumberFormat(locale, (0, _objectSpreadProps._)((0, _objectSpread._)({}, intlOptions), {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })).formatToParts(0.001);
    var decimal = (_decimalParts_find = decimalParts.find(function(p) {
        return p.type === "decimal";
    })) === null || _decimalParts_find === void 0 ? void 0 : _decimalParts_find.value;
    var group = (_allParts_find1 = allParts.find(function(p) {
        return p.type === "group";
    })) === null || _allParts_find1 === void 0 ? void 0 : _allParts_find1.value;
    // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
    // don't contribute to the numerical value
    var allPartsLiterals = allParts.filter(function(p) {
        return !$6c7bd7858deea686$var$nonLiteralParts.has(p.type);
    }).map(function(p) {
        return $6c7bd7858deea686$var$escapeRegex(p.value);
    });
    var pluralPartsLiterals = pluralParts.flatMap(function(p) {
        return p.filter(function(p) {
            return !$6c7bd7858deea686$var$nonLiteralParts.has(p.type);
        }).map(function(p) {
            return $6c7bd7858deea686$var$escapeRegex(p.value);
        });
    });
    var sortedLiterals = (0, _toConsumableArray._)(new Set((0, _toConsumableArray._)(allPartsLiterals).concat((0, _toConsumableArray._)(pluralPartsLiterals)))).sort(function(a, b) {
        return b.length - a.length;
    });
    var literals = sortedLiterals.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp("".concat(sortedLiterals.join("|"), "|[\\p{White_Space}]"), "gu");
    // These are for replacing non-latn characters with the latn equivalent
    var numerals = (0, _toConsumableArray._)(new Intl.NumberFormat(intlOptions.locale, {
        useGrouping: false
    }).format(9876543210)).reverse();
    var indexes = new Map(numerals.map(function(d, i) {
        return [
            d,
            i
        ];
    }));
    var numeral = new RegExp("[".concat(numerals.join(""), "]"), "g");
    var index = function(d) {
        return String(indexes.get(d));
    };
    return {
        minusSign: minusSign,
        plusSign: plusSign,
        decimal: decimal,
        group: group,
        literals: literals,
        numeral: numeral,
        index: index
    };
}
function $6c7bd7858deea686$var$replaceAll(str, find, replace) {
    // @ts-ignore
    if (str.replaceAll) return str.replaceAll(find, replace);
    return str.split(find).join(replace);
}
function $6c7bd7858deea686$var$escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

},{"@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_to_consumable_array":"94EyK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dx8KP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledRadioGroup", function() {
    return StyledRadioGroup;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.horizontal {\n    display: flex;\n\n    > * {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledRadioGroup = (0, _styledComponentsDefault.default).div(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1WGwM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Abstract/utility component which should **not** be used directly. Instead, use components:
 * - `TabNavigation` to navigate between URLs
 * - `TabbedContainer` to switch between blocks of content
 */ parcelHelpers.export(exports, "TabbedInterface", function() {
    return TabbedInterface;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _tabbedInterfaceStyles = require("./TabbedInterface.styles");
function TabbedInterface(props) {
    var children = props.children, className = props.className, currentTab = props.currentTab, fullWidthTabs = props.fullWidthTabs, id = props.id, onTabSelect = props.onTabSelect, tabs = props.tabs, tabType = props.tabType;
    // const [current, setCurrent] = useState<string>(currentTab || tabs[0].id);
    var handleTabSelect = function(id) {
        if (!!onTabSelect) onTabSelect(id);
    // setCurrent(id);
    };
    var navigationTab = function(props) {
        var id = props.id, name = props.name, route = props.route;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            className: "TabbedInterface__tablist-link",
            to: route,
            role: "tab",
            "aria-selected": id === currentTab,
            id: id,
            onClick: function() {
                return handleTabSelect(id);
            },
            children: name
        });
    };
    var sectionTab = function(props) {
        var id = props.id, name = props.name, disabled = props.disabled, tooltip = props.tooltip;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                disabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                    for: "".concat(id, "-tab"),
                    block: true,
                    children: tooltip
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                    "data-tip": true,
                    "data-for": "".concat(id, "-tab"),
                    disabled: disabled,
                    role: "tab",
                    variant: "no-style",
                    "aria-selected": id === currentTab,
                    id: id,
                    onClick: function() {
                        return handleTabSelect(id);
                    },
                    className: fullWidthTabs ? "fullWidthTabs" : "",
                    children: name
                })
            ]
        });
    };
    var tabStyle = function(tabQuantity) {
        return {
            flexBasis: "".concat(100 / tabQuantity, "%")
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnamesDefault.default)("tabbedInterface", className),
        "data-cy": props["data-cy"],
        id: id,
        style: {
            paddingBottom: "2em"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabbedInterfaceStyles.StyledTabs), {
                role: "tablist",
                children: tabs.map(function(tab) {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        role: "presentation",
                        style: fullWidthTabs ? tabStyle(tabs.length) : {},
                        children: tabType === "navigation" ? navigationTab(tab) : sectionTab(tab)
                    }, tab.id);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                role: "tabpanel",
                "aria-labelledby": currentTab,
                children: children
            })
        ]
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","classnames":"9xS9S","Permafrost/index":"iliLC","./TabbedInterface.styles":"elKMw","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"elKMw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTabs", function() {
    return StyledTabs;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  top: -2px;\n\n  display: flex;\n\n  color: ",
        ";\n\n  border-bottom: 2px solid currentColor;\n\n  li > [role='tab'] {\n    text-decoration: none;\n    display: block;\n    color: inherit;\n    line-height: 1.25;\n\n    position: relative;\n    top: 2px;\n\n    padding: 16px;\n    font-size: ",
        ";\n    text-transform: uppercase;\n    border-bottom: 2px solid currentColor;\n\n    transition: color ",
        " ",
        ";\n\n    &.fullWidthTabs {\n      width: 100%;\n      height: 100%;\n      white-space: normal;\n    }\n\n    &[aria-selected='true'] {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTabs = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _index.COLORS).midFontColor, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8x69h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableFilename", function() {
    return 0, _copyableFilename.CopyableFilename;
});
var _copyableFilename = require("./CopyableFilename");

},{"./CopyableFilename":"2paK8","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2paK8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableFilename", function() {
    return CopyableFilename;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _copyableFilenameStyles = require("./CopyableFilename.styles");
function CopyableFilename(props) {
    var className = props.className, filename = props.filename, id = props.id, _props_maxNameLength = props.maxNameLength, maxNameLength = _props_maxNameLength === void 0 ? 50 : _props_maxNameLength, downloadable = props.downloadable, isDownloading = props.isDownloading, onDownload = props.onDownload;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), displayCopySuccess = _useState[0], setDisplayCopySuccess = _useState[1];
    var copyHandler = function() {
        (0, _utils.clipboardUtils).copy(filename);
        setDisplayCopySuccess(true);
        setTimeout(function() {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _copyableFilenameStyles.StyledCopyableFilename), {
        className: className,
        "data-cy": props["data-cy"],
        children: [
            filename.length > maxNameLength ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        questionMark: false,
                        for: "shortened-name",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: filename
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "data-tip": true,
                        "data-for": "shortened-name",
                        id: id,
                        children: (0, _utils.stringUtils).maxLengthWithMiddleEllipsis(filename, maxNameLength)
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                id: id,
                children: filename
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _index.Button), {
                className: "copy-filename",
                variant: "link-style",
                onClick: function() {
                    return copyHandler();
                },
                "data-for": "copy-filename",
                "data-tip": true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        className: (0, _classnamesDefault.default)({
                            hidden: displayCopySuccess === true
                        }),
                        name: "fa-clipboard",
                        ariaLabel: "copy filename",
                        size: [
                            "16px"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                        className: (0, _classnamesDefault.default)("copy-success", {
                            hidden: displayCopySuccess === false
                        }),
                        name: "check",
                        size: [
                            "16px"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                className: "copy-success__tooltip",
                questionMark: false,
                place: "bottom",
                for: "copy-filename",
                children: displayCopySuccess ? "copied!" : "copy filename"
            }),
            downloadable && onDownload ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        className: "download-file__button",
                        variant: "link-style",
                        onClick: onDownload,
                        "data-for": "download-filename",
                        "data-tip": true,
                        disabled: isDownloading,
                        children: isDownloading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {
                            size: "16px"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "output",
                            ariaLabel: "download file",
                            size: [
                                "16px"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        className: "download-success__tooltip",
                        questionMark: false,
                        place: "bottom",
                        for: "download-filename",
                        children: "download file"
                    })
                ]
            }) : null
        ]
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./CopyableFilename.styles":"90F87","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"90F87":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCopyableFilename", function() {
    return StyledCopyableFilename;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  height: 38px; // Keep height the same as file select that replaces this component when more than 1 file included\n\n  span {\n    margin-right: ",
        ";\n  }\n\n  .hidden {\n    display: none;\n  }\n\n  svg {\n    margin-bottom: -1px;\n  }\n\n  .download-file__button {\n    margin-left: 5px;\n  }\n\n  .copy-success {\n    color: green;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var commonSpace = "10px";
var StyledCopyableFilename = (0, _styledComponentsDefault.default).div(_templateObject(), commonSpace);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1sJXR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableSelect", function() {
    return 0, _copyableSelect.CopyableSelect;
});
var _copyableSelect = require("./CopyableSelect");

},{"./CopyableSelect":"1sSn0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1sSn0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableSelect", function() {
    return CopyableSelect;
});
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _copyableSelectStyles = require("./CopyableSelect.styles");
function CopyableSelect(props) {
    var className = props.className, options = props.options, onChange = props.onChange, value = props.value, _props_noOptionsMessage = props.noOptionsMessage, noOptionsMessage = _props_noOptionsMessage === void 0 ? "No files found" : _props_noOptionsMessage, downloadable = props.downloadable, isDownloading = props.isDownloading, onDownload = props.onDownload;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), displayCopySuccess = _useState[0], setDisplayCopySuccess = _useState[1];
    var copyHandler = function() {
        (0, _utils.clipboardUtils).copy(value.label);
        setDisplayCopySuccess(true);
        setTimeout(function() {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    var ControlComponent = function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Control, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        id: "tempIDd",
                        for: "selectFile",
                        block: true,
                        children: props.getValue()[0].label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        "data-tip": true,
                        "data-for": "selectFile",
                        className: "combobox__flex-control",
                        children: props.children
                    })
                ]
            })
        }));
    };
    var OptionComponent = function(_param) {
        var _$props = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
        var _props_data = _$props.data, value = _props_data.value, label = _props_data.label;
        var id = "".concat(value, "-shortened-filename");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelect.components).Option, (0, _objectSpreadProps._)((0, _objectSpread._)({}, _$props), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "combobox__flex-option",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        "data-tip": true,
                        "data-for": id,
                        className: "combobox__ellipsis",
                        children: label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        for: id,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: label
                        })
                    })
                ]
            })
        }));
    };
    // By default react-select searches both the label and value, we only want to search the labels as the value is the fileId
    var customFilter = function(option, searchText) {
        return option.data.label.toLowerCase().includes(searchText.toLowerCase());
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _copyableSelectStyles.StyledSelectContainer), {
        className: className,
        "data-cy": props["data-cy"],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyableSelectStyles.StyledCopyableSelect), {
                classNamePrefix: "combobox",
                options: options,
                onChange: onChange,
                value: value,
                searchable: true,
                noOptionsMessage: function() {
                    return noOptionsMessage;
                },
                filterOption: customFilter,
                components: {
                    Option: OptionComponent,
                    Control: ControlComponent
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                className: "copy-filepath__button",
                variant: "link-style",
                onClick: copyHandler,
                "data-for": "copy-filename",
                "data-tip": true,
                children: displayCopySuccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "check",
                    size: [
                        "18px"
                    ],
                    className: "copy-filepath__check"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                    name: "fa-clipboard",
                    ariaLabel: "copy filename",
                    size: [
                        "18px"
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                className: "copy-success__tooltip",
                questionMark: false,
                place: "bottom",
                for: "copy-filename",
                children: displayCopySuccess ? "copied!" : "copy filename"
            }),
            downloadable && onDownload ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Button), {
                        className: "download-file__button",
                        variant: "link-style",
                        onClick: function() {
                            return onDownload({
                                variables: {
                                    id: value.value
                                }
                            });
                        },
                        disabled: isDownloading,
                        "data-for": "download-filename",
                        "data-tip": true,
                        children: isDownloading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.LoadingSpinner), {
                            size: "16px"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                            name: "output",
                            ariaLabel: "download file",
                            size: [
                                "16px"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Tooltip), {
                        className: "download-success__tooltip",
                        questionMark: false,
                        place: "bottom",
                        for: "download-filename",
                        children: "download file"
                    })
                ]
            }) : null
        ]
    });
}

},{"@swc/helpers/_/_extends":"fG7GO","@swc/helpers/_/_object_destructuring_empty":"7Cl0x","@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-select":"dRNnj","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./CopyableSelect.styles":"hrNCh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fG7GO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_extends", function() {
    return _extends;
});
parcelHelpers.export(exports, "_", function() {
    return _extends;
});
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7Cl0x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_object_destructuring_empty", function() {
    return _object_destructuring_empty;
});
parcelHelpers.export(exports, "_", function() {
    return _object_destructuring_empty;
});
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hrNCh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelectContainer", function() {
    return StyledSelectContainer;
});
parcelHelpers.export(exports, "StyledCopyableSelect", function() {
    return StyledCopyableSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  .copy-filepath__button {\n    margin-left: ",
        ";\n  }\n\n  .download-file__button {\n    margin-left: 5px;\n  }\n\n  .copy-filepath__check {\n    color: green;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  // overall component container\n  .combobox__control {\n    width: 250px;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    background: transparent;\n    border-radius: 4px;\n    font-size: ",
        ";\n    border: 1px solid ",
        ";\n    text-align: left;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__flex-control {\n    width: 100%;\n    display: inline-flex;\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    width: 400px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n    text-align: left;\n  }\n\n  .combobox__flex-option {\n    display: flex;\n  }\n\n  // the dropdown options\n  .combobox__option {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: small;\n    white-space: nowrap;\n  }\n\n  .combobox__ellipsis {\n    ",
        "\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  // selected item text inside input\n  .combobox__single-value {\n    color: ",
        ";\n  }\n\n  .combobox__indicator {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelectContainer = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.PADDINGS).xs);
var StyledCopyableSelect = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject1(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).midFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.TYPOGRAPHY).ellipsis, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"4YUJC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"afu0R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return 0, _dateTimeDisplay.DateTimeDisplay;
});
var _dateTimeDisplay = require("./DateTimeDisplay");

},{"./DateTimeDisplay":"2LtID","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2LtID":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return DateTimeDisplay;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var DateTimeDisplay = function(param) {
    var date = param.date;
    var dateParts = (0, _utils.dateUtils).getDateParts(date);
    if (!dateParts) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            dateParts.month,
            "-",
            dateParts.day,
            "-",
            dateParts.year,
            "\xa0",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("wbr", {}),
            dateParts.hour,
            ":",
            dateParts.minute,
            dateParts.dayPeriod
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kixGB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppTitle", function() {
    return AppTitle;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _appTitleStyles = require("./AppTitle.styles");
var AppTitle = function(props) {
    var actions = props.actions, className = props.className, icon = props.icon, id = props.id, title = props.title;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appTitleStyles.StyledAppTitle), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.Icon), {
                name: icon,
                className: "appIcon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: title
            }),
            actions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "ActionLinks",
                children: actions
            })
        ]
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./AppTitle.styles":"6p94L","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6p94L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAppTitle", function() {
    return StyledAppTitle;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: 10px;\n\n  > * {\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n\n  .appIcon {\n    height: 25px;\n    width: 25px;\n    color: var(",
        ");\n  }\n\n  h3 {\n    letter-spacing: 2px;\n    color: var(",
        ");\n    text-transform: uppercase;\n    margin-bottom: 0;\n    margin-left: 7px;\n  }\n\n  .ActionLinks {\n    float: right;\n\n    a {\n      color: ",
        ";\n      text-decoration: none;\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledAppTitle = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.colorProperties).logoPrimary, (0, _index.colorProperties).logoSecondary, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dZlUo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders a group of radio buttons.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "RadioGroup", function() {
    return RadioGroup;
});
/**
 * A single radio button and its label.
 */ parcelHelpers.export(exports, "Radio", function() {
    return Radio;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _radioButtonsStyles = require("./RadioButtons.styles");
function RadioGroup(props) {
    var children = props.children, restOfProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioButtonsStyles.StyledRadioGroup), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restOfProps), {
        "data-cy": props["data-cy"],
        children: children
    }));
}
function Radio(props) {
    var children = props.children, restOfProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _index.AbstractRadio), (0, _objectSpreadProps._)((0, _objectSpread._)({}, restOfProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                viewBox: "0 0 20 20",
                "aria-hidden": "true",
                focusable: "false",
                overflow: "visible",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 10,
                        cy: 10,
                        r: 9,
                        fill: "none",
                        stroke: "currentColor",
                        className: "radioCircle"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 10,
                        cy: 10,
                        r: 5,
                        fill: "currentColor",
                        stroke: "none",
                        className: "radioDot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 10,
                        cy: 10,
                        r: 12,
                        fill: "none",
                        className: "focusRing"
                    })
                ]
            }),
            children
        ]
    }));
}

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","Permafrost/index":"iliLC","./RadioButtons.styles":"nZQZp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"nZQZp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledRadioGroup", function() {
    return StyledRadioGroup;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .groupLabel {\n    margin-bottom: ",
        ";\n    font-size: 16px;\n    color: ",
        ";\n  }\n\n  // this is the Radio component; something gets cranky and styles end up\n  // not applied if we create a separate StyledComponent for Radio.\n  label {\n    display: flex;\n    align-items: center;\n\n    margin-bottom: ",
        ";\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n\n    &:not(.disabled) {\n      cursor: pointer;\n\n      &.selected,\n      &:hover {\n        color: ",
        ";\n      }\n    }\n\n    transition: color ",
        " ",
        ";\n\n    svg {\n      width: ",
        ";\n      height: ",
        ";\n\n      margin-top: 1px;\n      margin-right: ",
        ";\n    }\n\n    .radioCircle {\n      stroke-width: ",
        ";\n    }\n\n    .radioDot {\n      opacity: 0;\n    }\n\n    .focusRing {\n      opacity: 0;\n\n      stroke: ",
        ";\n      stroke-width: ",
        ";\n    }\n\n    &.selected {\n      .radioDot {\n        opacity: 1;\n      }\n    }\n\n    &.focused {\n      .focusRing {\n        opacity: 1;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var radioSize = "20px";
var strokeWidth = 2;
var StyledRadioGroup = (0, _styledComponentsDefault.default)((0, _index.AbstractRadioGroup))(_templateObject(), (0, _index.SPACING).sm, (0, _index.COLORS).lightGray, (0, _index.SPACING).sm, (0, _index.COLORS).white, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, radioSize, radioSize, (0, _index.SPACING).sm, strokeWidth, (0, _index.COLORS).curiousBlue, strokeWidth);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bTfuJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Allows a user to “flip” between modes of some sort.
 */ parcelHelpers.export(exports, "Flipper", function() {
    return Flipper;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _flipperStyles = require("./Flipper.styles");
function Flipper(props) {
    var className = props.className, currentMode = props.currentMode, groupLabel = props.groupLabel, id = props.id, onModeChange = props.onModeChange, modes = props.modes, small = props.small;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _flipperStyles.StyledFlipper), {
        "aria-label": groupLabel,
        "data-cy": props["data-cy"],
        value: currentMode,
        id: id,
        onChange: onModeChange,
        orientation: "horizontal",
        className: (0, _classnamesDefault.default)("switch-pair", className, {
            small: small
        }),
        children: modes.map(function(mode) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _index.AbstractRadio), {
                value: mode,
                children: mode
            }, mode);
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Flipper.styles":"kEzU0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kEzU0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFlipper", function() {
    return StyledFlipper;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  label {\n    display: inline-block;\n    font-size: ",
        ";\n    padding: 0.4em 1em 0.5em;\n    margin-bottom: 0;\n\n    border-radius: 1em;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    &.selected {\n      background-color: ",
        ";\n    }\n\n    &.selected,\n    &:hover {\n      color: ",
        ";\n    }\n\n    &.focused {\n      box-shadow: 0 0 0 1px ",
        ", 0 0 0 3px ",
        ";\n    }\n  }\n\n  &.small {\n    label {\n      font-size: 13px;\n      padding: 0.2em 0.8em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFlipper = (0, _styledComponentsDefault.default)((0, _index.AbstractRadioGroup))(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).white, (0, _index.COLORS).clay, (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j1Stv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledButton", function() {
    return StyledButton;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index"); // todo: move styling into common file
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 0;\n  display: inline-block;\n  cursor: pointer;\n  font-family: ",
        ";\n\n  &.default {\n    border-radius: 2px;\n    padding: 0.625em 1.25em;\n    box-shadow: 0 1px 1px 0 ",
        ";\n    transition: background-color ",
        " ",
        ";\n  }\n\n  &.primary,\n  &.cta {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      // todo: shouldn't have to override...\n      color: ",
        ";\n      // todo: store as constant\n      background-color: #1777c2;\n    }\n  }\n\n  &.cta {\n    font-size: ",
        ";\n  }\n\n  &.normal {\n    font-size: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n\n    &:hover,\n    &:focus {\n      // todo: store as constant\n      background-color: #bebebe;\n    }\n  }\n\n  &.outline {\n    color: ",
        ";\n    background: transparent;\n    border: 1px solid ",
        ";\n    transition: border ",
        " ",
        ",\n      color ",
        " ",
        ";\n\n    &:hover,\n    &:focus {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      background: transparent;\n    }\n\n    &:disabled {\n      border: 1px solid ",
        ";\n      color: ",
        ";\n      background: transparent;\n      opacity: 0.6;\n\n      &:hover {\n        background: transparent;\n        border: 1px solid ",
        ";\n        color: ",
        ";\n        opacity: 0.6;\n      }\n    }\n  }\n\n  &.no-style {\n    font-size: inherit;\n    color: inherit;\n    background-color: transparent;\n    box-shadow: none;\n    padding: 0;\n\n    &:hover,\n    &:focus {\n      color: inherit;\n      background-color: transparent;\n    }\n\n    &:not(.focus-visible) {\n      outline: none;\n    }\n  }\n\n  &.busy {\n    cursor: wait;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledButton = (0, _styledComponentsDefault.default).button(_templateObject(), (0, _index.TYPOGRAPHY).fontFamily.base, (0, _index.COLORS).black, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.COLORS).white, (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).iron, (0, _index.COLORS).darkFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kqxGP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlButton", function() {
    return 0, _controlButton.ControlButton;
});
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return 0, _controlButton.controlButtonSpacing;
});
var _controlButton = require("./ControlButton");

},{"./ControlButton":"lSFKZ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lSFKZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "controlButtonSpacing", function() {
    return controlButtonSpacing;
});
parcelHelpers.export(exports, "ControlButton", function() {
    return ControlButton;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _button = require("@react-aria/button");
var _focus = require("@react-aria/focus");
var _index = require("Permafrost/index");
var _controlButtonStyles = require("./ControlButton.styles");
var controlButtonSpacing = {
    normal: "16px"
};
var controlButton = {
    reject: {
        icon: "trash",
        label: "Reject"
    },
    submit: {
        icon: "check",
        label: "Submit"
    },
    restore: {
        icon: "upload",
        label: "Restore"
    },
    "step-forward": {
        icon: "step-forward",
        label: "Step Forward"
    }
}; /**
    * Small icon-only buttons used for UI controls.
    */ 
function ControlButton(props) {
    var busy = props.busy, buttonType = props.buttonType, className = props.className, id = props.id, tooltipDisabled = props.tooltipDisabled, tooltipText = props.tooltipText;
    var buttonEl = (0, _react.useRef)();
    var buttonProps = (0, _button.useButton)(props, buttonEl).buttonProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var iconSize = buttonType === "submit" ? "22px" : (0, _controlButtonStyles.iconSizeDefault);
    var tooltipId = (0, _uuid.v4)();
    var buttonTooltipProps = tooltipDisabled ? {
        "aria-label": controlButton[buttonType].label
    } : {
        "data-tip": true,
        "data-for": tooltipId,
        "aria-labelledby": tooltipId
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _controlButtonStyles.StyledControlButton), Object.assign({
        "$buttonType": buttonType,
        "$iconSize": iconSize,
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            "focus-visible": isFocusVisible
        }),
        "data-cy": props["data-cy"]
    }, buttonProps, focusProps, buttonTooltipProps), busy ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), {
        size: (0, _controlButtonStyles.iconSizeDefault)
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: controlButton[buttonType].icon,
        size: [
            iconSize
        ]
    })), !tooltipDisabled && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        for: tooltipId
    }, tooltipText || controlButton[buttonType].label));
}

},{"react":"ktQNc","uuid":"6ZyFu","classnames":"9xS9S","@react-aria/button":"3Kuyu","@react-aria/focus":"dmSXv","Permafrost/index":"iliLC","./ControlButton.styles":"fnGyu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fnGyu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconSizeDefault", function() {
    return iconSizeDefault;
});
parcelHelpers.export(exports, "StyledControlButton", function() {
    return StyledControlButton;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _commonStyles = require("Permafrost/components/ui-foundations/buttons/commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  height: calc(",
        " * 2);\n  width: ",
        ";\n\n  // todo: default override\n  &[type='button'] {\n    padding: 0;\n    ",
        "\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var buttonStyles = {
    reject: (0, _commonStyles.variantDestructive),
    submit: (0, _commonStyles.variantPrimary),
    restore: (0, _commonStyles.variantPrimary),
    "step-forward": (0, _commonStyles.variantDefault)
};
var iconSizeDefault = "16px";
var StyledControlButton = (0, _styledComponentsDefault.default).button(_templateObject(), (0, _commonStyles.basicDefaults), iconSizeDefault, function(props) {
    return "calc(".concat(props.$iconSize, " * 2)");
}, function(props) {
    return buttonStyles[props.$buttonType];
}, (0, _commonStyles.disabledOverrides));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/components/ui-foundations/buttons/commonStyles":"eg1Ne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9khdd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenerateReport", function() {
    return GenerateReport;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _generateReportStyles = require("./GenerateReport.styles");
var GenerateReport = function(props) {
    var actionHandler = props.actionHandler, className = props.className, disabled = props.disabled, downloadReady = props.downloadReady, id = props.id, isPolling = props.isPolling, tooLarge = props.tooLarge;
    if (tooLarge) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _generateReportStyles.StyledTooLarge), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "too-large-message"
    }, "There is too much data to generate a report. Please use our client libraries."), /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        href: "https://docs.indico.io",
        target: "_blank",
        rel: "noreferrer",
        className: "docs-link"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "LinkList-Text"
    }, "How to Generate a Large Report")));
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _generateReportStyles.StyledGenerateReport), {
        "aria-label": "Generate and Download Report",
        className: (0, _classnamesDefault.default)("generate-button", className, downloadReady ? "download normal" : "generate cta"),
        "data-cy": props["data-cy"],
        disabled: disabled || isPolling,
        id: id,
        onClick: function() {
            return actionHandler();
        }
    }, downloadReady ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-file-download",
        size: [
            14
        ]
    }), " Download Report") : isPolling ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), null), " Generating...") : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "plus",
        size: [
            14
        ]
    }), " Generate Report"));
};

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./GenerateReport.styles":"6MwZM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6MwZM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTooLarge", function() {
    return StyledTooLarge;
});
parcelHelpers.export(exports, "StyledGenerateReport", function() {
    return StyledGenerateReport;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-left: 15px;\n\n  .too-large-message {\n    color: ",
        ";\n  }\n\n  .docs-link {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 36px;\n  font-size: 14px !important;\n  margin-left: 15px;\n\n  svg {\n    vertical-align: top;\n    margin-right: 5px;\n  }\n\n  &:disabled {\n    opacity: 0.4;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTooLarge = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).red);
var StyledGenerateReport = (0, _styledComponentsDefault.default)((0, _index.Button))(_templateObject1());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9ht8K":[function(require,module,exports) {
// todo: styling from the mock does not fully match the current button style implementation.
//  will be updated during permafrost refactor tasks - 4/21 jm
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconButton", function() {
    return IconButton;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _button = require("@react-aria/button");
var _focus = require("@react-aria/focus");
var _index = require("Permafrost/index");
var _iconButtonStyles = require("./IconButton.styles"); /**
                                                                               * General utility “button with an icon” component. May also be used for links that _look_
                                                                               * like buttons, via the `isLink` property.
                                                                               *
                                                                               * The button handler must be passed in via the `onPress` property (replaces `onClick`).
                                                                               *
                                                                               * @see {@link https://react-spectrum.adobe.com/blog/building-a-button-part-1.html}
                                                                               */ 
var IconButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var _props_adjustAlignment = props.adjustAlignment, adjustAlignment = _props_adjustAlignment === void 0 ? 0 : _props_adjustAlignment, busy = props.busy, className = props.className, iconName = props.iconName, _props_iconSide = props.iconSide, iconSide = _props_iconSide === void 0 ? "start" : _props_iconSide, id = props.id, isDisabled = props.isDisabled, isLink = props.isLink, label = props.label, _props_size = props.size, size = _props_size === void 0 ? "normal" : _props_size, style = props.style, variant = props.variant;
    var buttonRef = (0, _react.useRef)(null);
    var anchorRef = (0, _react.useRef)(null);
    var elementRef = isLink ? anchorRef : buttonRef;
    var buttonProps = (0, _button.useButton)(Object.assign(Object.assign({}, props), {
        onPress: busy ? undefined : props.onPress
    }), elementRef).buttonProps; // Exposes select methods on the internal button ref to the parent component
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            // Timeout places the focus at the end of the event queue to ensure the button is focusable
            focus: function() {
                return setTimeout(function() {
                    var _a;
                    return (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }, 0);
            },
            contains: function(el) {
                var _a;
                return !!((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.contains(el));
            }
        };
    });
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var commonProps = Object.assign(Object.assign(Object.assign({
        "aria-disabled": busy,
        className: (0, _classnamesDefault.default)(iconSide, size, variant, className, {
            "focus-visible": isFocusVisible,
            busy: busy,
            disabled: isLink && isDisabled
        })
    }, buttonProps), focusProps), {
        "data-cy": props["data-cy"],
        id: id,
        style: style
    });
    var iconElement = busy ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), {
        size: "1em",
        style: {
            marginTop: "".concat(adjustAlignment, "px"),
            marginBottom: "".concat(Math.abs(adjustAlignment), "px")
        }
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        className: (0, _classnamesDefault.default)({
            "right-margin": label
        }),
        name: iconName
    });
    var labelElement = label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            marginTop: "".concat(adjustAlignment, "px")
        }
    }, label) : null;
    if (isLink && !isDisabled) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconButtonStyles.StyledIconButtonLink), Object.assign({}, commonProps, {
        ref: anchorRef,
        to: isLink
    }), iconElement, " ", labelElement);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconButtonStyles.StyledIconButton), Object.assign({}, commonProps, {
        ref: buttonRef
    }), iconElement, " ", labelElement);
});

},{"react":"ktQNc","classnames":"9xS9S","@react-aria/button":"3Kuyu","@react-aria/focus":"dmSXv","Permafrost/index":"iliLC","./IconButton.styles":"isZcI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"isZcI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iconButton", function() {
    return iconButton;
});
parcelHelpers.export(exports, "StyledIconButton", function() {
    return StyledIconButton;
});
parcelHelpers.export(exports, "StyledIconButtonLink", function() {
    return StyledIconButtonLink;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactRouterDom = require("react-router-dom");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n\n  ",
        ";\n\n  svg {\n    height: 16px;\n    width: 16px;\n  }\n\n  &.large {\n    ",
        ";\n\n    svg {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n  &.default {\n    ",
        ";\n  }\n\n  &.destructive {\n    ",
        ";\n  }\n\n  &.primary {\n    ",
        ";\n  }\n\n  // todo: use this rule/selector after global styling removed\n  //:not(:disabled):hover {\n  //  background-color: #bebebe;\n  //}\n  ",
        ";\n\n  &.start {\n    svg.right-margin {\n      margin-right: ",
        ";\n    }\n  }\n\n  &.end {\n    svg {\n      order: 1;\n      margin-left: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // todo: overrides the global button styling\n  display: flex !important;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // todo: overrides the global button styling\n  display: inline-flex !important;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var iconMargin = "0.5em";
var iconButton = (0, _styledComponents.css)(_templateObject(), (0, _commonStyles.defaults), (0, _commonStyles.sizeLarge), (0, _commonStyles.variantDefault), (0, _commonStyles.variantDestructive), (0, _commonStyles.variantPrimary), (0, _commonStyles.disabledOverrides), iconMargin, iconMargin);
var StyledIconButton = (0, _styledComponentsDefault.default).button(_templateObject1(), iconButton);
var StyledIconButtonLink = (0, _styledComponentsDefault.default)((0, _reactRouterDom.Link))(_templateObject2(), iconButton);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-router-dom":"6Au42","../commonStyles":"bPEKx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bPEKx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultHeight", function() {
    return defaultHeight;
});
parcelHelpers.export(exports, "largeHeight", function() {
    return largeHeight;
});
parcelHelpers.export(exports, "basicDefaults", function() {
    return basicDefaults;
});
parcelHelpers.export(exports, "defaults", function() {
    return defaults;
});
parcelHelpers.export(exports, "sizeLarge", function() {
    return sizeLarge;
});
parcelHelpers.export(exports, "variantDefault", function() {
    return variantDefault;
});
parcelHelpers.export(exports, "variantPrimary", function() {
    return variantPrimary;
});
parcelHelpers.export(exports, "variantDestructive", function() {
    return variantDestructive;
});
parcelHelpers.export(exports, "disabledOverrides", function() {
    return disabledOverrides;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 0;\n  display: inline-block;\n  cursor: pointer;\n\n  border-radius: 2px;\n  box-shadow: 0 1px 1px 0 ",
        ";\n\n  &.busy {\n    cursor: wait;\n  }\n\n  &:disabled,\n  &.disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &:not(.focus-visible) {\n    outline: none;\n  }\n\n  transition-property: opacity, background-color;\n  transition-duration: ",
        ";\n  transition-timing-function: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  height: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n\n  padding: 0 1em !important;\n\n  & + button {\n    margin-left: 14px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  background-color: ",
        ";\n\n  &:hover {\n    background-color: #bebebe;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: #1777c2;\n    color: ",
        ";\n\n    &:disabled {\n      background-color: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: #d4464b;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:disabled,\n  &.disabled {\n    &:hover {\n      // todo: override due to default global styling\n      background-color: ",
        " !important;\n\n      &.primary {\n        // todo: override due to default global styling\n        background-color: ",
        " !important;\n      }\n\n      &.destructive {\n        // todo: override due to default global styling\n        background-color: ",
        " !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
var defaultHeight = "36px";
var largeHeight = "50px";
var basicDefaults = (0, _styledComponents.css)(_templateObject(), (0, _index.COLORS).black, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing);
var defaults = (0, _styledComponents.css)(_templateObject1(), basicDefaults, defaultHeight, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.TYPOGRAPHY).fontFamily.base);
var sizeLarge = (0, _styledComponents.css)(_templateObject2(), largeHeight, (0, _index.TYPOGRAPHY).fontSize.subheadLarge);
var variantDefault = (0, _styledComponents.css)(_templateObject3(), (0, _index.COLORS).darkFontColor, (0, _index.COLORS).iron);
var variantPrimary = (0, _styledComponents.css)(_templateObject4(), (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.COLORS).white, (0, _index.COLORS).curiousBlue);
var variantDestructive = (0, _styledComponents.css)(_templateObject5(), (0, _index.COLORS).red, (0, _index.COLORS).white, (0, _index.COLORS).white);
var disabledOverrides = (0, _styledComponents.css)(_templateObject6(), (0, _index.COLORS).iron, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).red);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fbUkS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return 0, _segmentedControlButtons.SegmentedControlButtons;
});
var _segmentedControlButtons = require("./SegmentedControlButtons");

},{"./SegmentedControlButtons":"3cVAs","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3cVAs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SegmentedControlButtons", function() {
    return SegmentedControlButtons;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _values = require("Permafrost/styles/values");
var _controlButtonStyles = require("../ControlButton/ControlButton.styles"); /**
                                                                          * A styled component which groups two or more icon-only buttons, and displays them as a single entity.
                                                                          */ 
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  border-radius: ",
        ";\n  box-shadow: 0 1px 1px 0 #000;\n\n  button {\n    // todo: override global\n    padding: 0 !important;\n    box-shadow: 0 0 1px 0 #000 !important;\n\n    height: calc(",
        " * 2);\n    width: calc(",
        " * 2);\n\n    &:first-of-type {\n      border-radius: ",
        " 0 0 ",
        ";\n    }\n\n    &:last-of-type {\n      border-radius: 0 ",
        " ",
        " 0;\n    }\n\n    &:not(:first-of-type):not(:last-of-type) {\n      border-radius: 0;\n    }\n\n    &:disabled {\n      opacity: 0.7;\n    }\n\n    &:focus {\n      // ensures focus ring has no overlap with sibling buttons\n      transform: rotate(0);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SegmentedControlButtons = (0, _styledComponentsDefault.default).div.attrs(function() {
    return {
        role: "group"
    };
})(_templateObject(), (0, _values.buttonBorderRadius), (0, _controlButtonStyles.iconSizeDefault), (0, _controlButtonStyles.iconSizeDefault), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius), (0, _values.buttonBorderRadius));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/styles/values":"avAcu","../ControlButton/ControlButton.styles":"fnGyu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fjcVP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackToLink", function() {
    return 0, _backToLink.BackToLink;
});
var _backToLink = require("./BackToLink");

},{"./BackToLink":"lP5rp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lP5rp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BackToLink", function() {
    return BackToLink;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
var _button = require("Permafrost/components/ui-foundations/buttons/Button/Button"); /**
                                                                                      * Found on item detail pages; used to navigate to the current module’s list page.
                                                                                      * If an action needs to occur in addition to navigation, pass a handler into the
                                                                                      * `onClick` prop.
                                                                                      *
                                                                                      * If navigation is not needed and nothing is provided to the `to` prop, this
                                                                                      * component will be rendered as a button element.
                                                                                      */ 
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n  line-height: 20px !important;\n  font-size: ",
        " !important;\n  width: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BackToLink(props) {
    var className = props.className, id = props.id, onClick = props.onClick, text = props.text, to = props.to, style = props.style;
    var attributes = {
        // override the element’s innerText so AT ignores the left-angle quote character
        "aria-label": text ? text : "Back",
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style
    };
    if (to !== undefined) return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledBackToLink, Object.assign({
        to: to,
        onClick: onClick
    }, attributes), "\xab ", text ? text : "Back");
    else if (onClick !== undefined) return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledBackToLink, Object.assign({
        as: (0, _button.Button),
        onClick: onClick,
        variant: "link-style"
    }, attributes), "\xab ", text ? text : "Back");
    return null;
}
var StyledBackToLink = (0, _styledComponentsDefault.default)((0, _reactRouterDom.Link)).attrs(function(props) {
    return {
        as: props.as
    };
})(_templateObject(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react":"ktQNc","react-router-dom":"6Au42","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","Permafrost/components/ui-foundations/buttons/Button/Button":"gPP3j","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"46Vgf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiCombobox", function() {
    return 0, _multiCombobox.MultiCombobox;
});
parcelHelpers.export(exports, "SingleCombobox", function() {
    return 0, _singleCombobox.SingleCombobox;
});
parcelHelpers.export(exports, "CreateableSelect", function() {
    return 0, _createableSelect.CreateableSelect;
});
parcelHelpers.export(exports, "useCombobox", function() {
    return 0, _useCombobox.useCombobox;
});
parcelHelpers.export(exports, "BorderSelect", function() {
    return 0, _borderSelect.BorderSelect;
});
parcelHelpers.export(exports, "Select", function() {
    return 0, _select.Select;
});
parcelHelpers.export(exports, "Filter", function() {
    return 0, _filter.Filter;
});
parcelHelpers.export(exports, "FilterSelect", function() {
    return 0, _filterSelect.FilterSelect;
});
var _multiCombobox = require("./MultiCombobox/MultiCombobox");
var _singleCombobox = require("./SingleCombobox/SingleCombobox");
var _createableSelect = require("./CreateableSelect/CreateableSelect");
var _useCombobox = require("./useCombobox");
var _borderSelect = require("./BorderSelect/BorderSelect");
var _select = require("./Select/Select");
var _filter = require("./Filter/Filter");
var _filterSelect = require("./FilterSelect/FilterSelect");

},{"./MultiCombobox/MultiCombobox":"hS5OA","./SingleCombobox/SingleCombobox":"lb6Fh","./CreateableSelect/CreateableSelect":"710Ad","./useCombobox":"9HNtg","./BorderSelect/BorderSelect":"cnjqL","./Select/Select":"23kdA","./Filter/Filter":"1sI1R","./FilterSelect/FilterSelect":"kF8ys","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hS5OA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MultiCombobox", function() {
    return MultiCombobox;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("Permafrost/index");
var _utils = require("Permafrost/components/ui-foundations/dropdowns/utils");
var _multiComboboxStyles = require("./MultiCombobox.styles"); /**
                                                               * Multiselect combobox component. If selections are not bound to outside state
                                                               * via the `value` prop, you will need to import and use the `useCombobox` hook
                                                               * in order to clear its selected value .
                                                               *
                                                               * @see [useCombobox]{@link import('useCombobox').useCombobox}
                                                               */ 
var MultiCombobox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var className = props.className, closeMenuOnSelect = props.closeMenuOnSelect, customOption = props.customOption, customOptionLabel = props.customOptionLabel, customOptionValue = props.customOptionValue, defaultValue = props.defaultValue, disabled = props.disabled, id = props.id, loading = props.loading, menuIsOpen = props.menuIsOpen, _props_multiValueProps = props.multiValueProps, multiValueProps = _props_multiValueProps === void 0 ? {} : _props_multiValueProps, noOptionsMessage = props.noOptionsMessage, onChange = props.onChange, _props_optionProps = props.optionProps, optionProps = _props_optionProps === void 0 ? {} : _props_optionProps, options = props.options, placeholder = props.placeholder, validationErrors = props.validationErrors, values = props.values;
    var MultiValue = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).MultiValue, Object.assign({}, props));
    };
    var MultiValueRemove = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).MultiValueRemove, Object.assign({}, props), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "x-close",
            ariaLabel: "remove",
            size: [
                10
            ]
        }));
    }; // handles a custom option component generator, if passed in
    var Option = function(props) {
        if (customOption) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Option, Object.assign({}, props, optionProps), customOption(props));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Option, Object.assign({}, props, optionProps));
    };
    var ComboboxComponent = function() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _multiComboboxStyles.StyledMultiCombobox), {
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            ref: ref,
            className: className,
            classNamePrefix: "combobox",
            closeMenuOnSelect: closeMenuOnSelect,
            components: {
                MultiValue: (0, _utils.addCustomProps)(MultiValue, multiValueProps),
                MultiValueRemove: MultiValueRemove,
                Option: (0, _utils.addCustomProps)(Option, optionProps)
            },
            defaultValue: defaultValue,
            getOptionLabel: customOptionLabel,
            getOptionValue: customOptionValue,
            id: id,
            isClearable: false,
            isDisabled: disabled,
            isMulti: true,
            isLoading: loading,
            menuIsOpen: menuIsOpen,
            noOptionsMessage: function() {
                return noOptionsMessage;
            },
            onChange: onChange,
            options: options,
            placeholder: placeholder,
            validationErrors: validationErrors,
            value: values
        });
    };
    if (props["data-cy"]) return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-cy": props["data-cy"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboboxComponent, null));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboboxComponent, null);
});

},{"react":"ktQNc","react-select":"dRNnj","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/dropdowns/utils":"9zg6P","./MultiCombobox.styles":"gvkVh","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gvkVh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMultiCombobox", function() {
    return StyledMultiCombobox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  background-color: ",
        ";\n\n  .combobox__control,\n  .combobox__menu {\n    background-color: inherit;\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n  }\n\n  // overall component container\n  .combobox__control {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    margin-top: 3px;\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    margin-left: calc(",
        " + 2px); // ensures text doesn\u2019t overlap with input cursor\n    color: ",
        ";\n  }\n\n  // container component for the text input\n  .combobox__input-container {\n    margin-left: ",
        ";\n  }\n\n  // container for selected items (visually inside input)\n  .combobox__value-container {\n    padding: 0;\n    border-radius: inherit;\n  }\n\n  // each selected item (pill)\n  .combobox__multi-value {\n    height: 30px;\n\n    color: ",
        ";\n    background-color: ",
        ";\n    border-radius: 2px;\n\n    > * {\n      color: inherit;\n      margin-top: auto;\n      margin-bottom: auto;\n    }\n\n    &__remove {\n      padding-right: ",
        ";\n\n      &:hover {\n        cursor: pointer;\n        color: ",
        ";\n        background-color: transparent;\n      }\n    }\n\n    &__label {\n      padding-left: ",
        ";\n    }\n  }\n\n  // caret button to open/close menu\n  .combobox__dropdown-indicator {\n    border-radius: inherit;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var spacingCommon = "10px";
var StyledMultiCombobox = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).clay, (0, _index.COLORS).comet, (0, _index.COLORS).baliHai, (0, _index.COLORS).comet, spacingCommon, (0, _index.COLORS).lightFontColor, spacingCommon, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, spacingCommon, (0, _index.COLORS).white, spacingCommon);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"ad9HG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ad9HG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basicDefaults", function() {
    return basicDefaults;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n\n  &.combobox--is-disabled {\n    pointer-events: auto;\n    opacity: 0.6;\n  }\n\n  // overall component container\n  .combobox__control {\n    box-shadow: none;\n    min-height: unset;\n  }\n\n  .combobox__control--is-disabled {\n    cursor: not-allowed;\n  }\n\n  // container component for the text input\n  .combobox__input-container {\n    color: ",
        ";\n    cursor: text;\n\n    input {\n      margin-bottom: 0;\n      caret-color: ",
        ";\n    }\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  // each available item in the dropdown list\n  .combobox__option {\n    background-color: inherit;\n\n    :hover,\n    &--is-focused {\n      background-color: ",
        ";\n    }\n  }\n\n  // normally displays as a thin vertical line before the buttons on the far right\n  .combobox__indicator-separator {\n    display: none;\n  }\n\n  // caret button to open/close menu\n  .combobox__dropdown-indicator {\n    color: ",
        ";\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var basicDefaults = (0, _styledComponents.css)(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).white, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lb6Fh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SingleCombobox", function() {
    return SingleCombobox;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("Permafrost/index");
var _utils = require("Permafrost/components/ui-foundations/dropdowns/utils");
var _singleComboboxStyles = require("./SingleCombobox.styles"); /**
                                                                 * Combobox component to select a single option. If selections are not bound to
                                                                 * outside state via the `value` prop, you will need to import and use the
                                                                 * `useCombobox` hook in order to clear its selected value.
                                                                 *
                                                                 * @see [useCombobox]{@link import('useCombobox').useCombobox}
                                                                 */ 
var SingleCombobox = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var className = props.className, closeMenuOnSelect = props.closeMenuOnSelect, customOptionLabel = props.customOptionLabel, customOptionValue = props.customOptionValue, defaultValue = props.defaultValue, disabled = props.disabled, _props_dropdownIndicatorProps = props.dropdownIndicatorProps, dropdownIndicatorProps = _props_dropdownIndicatorProps === void 0 ? {} : _props_dropdownIndicatorProps, id = props.id, menuIsOpen = props.menuIsOpen, noOptionsMessage = props.noOptionsMessage, onChange = props.onChange, _props_optionProps = props.optionProps, optionProps = _props_optionProps === void 0 ? {} : _props_optionProps, options = props.options, placeholder = props.placeholder, validationErrors = props.validationErrors, value = props.value;
    var DropdownIndicator = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).DropdownIndicator, Object.assign({}, props), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "fa-caret-down",
            ariaLabel: "open dropdown",
            size: [
                14
            ]
        }));
    };
    var Option = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Option, Object.assign({}, props, optionProps));
    };
    var ComboboxComponent = function() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _singleComboboxStyles.StyledSingleCombobox), {
            "aria-label": props["aria-label"],
            "aria-labelledby": props["aria-labelledby"],
            ref: ref,
            className: className,
            classNamePrefix: "combobox",
            closeMenuOnSelect: closeMenuOnSelect,
            components: {
                DropdownIndicator: (0, _utils.addCustomProps)(DropdownIndicator, dropdownIndicatorProps),
                Option: (0, _utils.addCustomProps)(Option, optionProps)
            },
            defaultValue: defaultValue,
            getOptionLabel: customOptionLabel,
            getOptionValue: customOptionValue,
            id: id,
            isClearable: false,
            isDisabled: disabled,
            isMulti: false,
            menuIsOpen: menuIsOpen,
            noOptionsMessage: function() {
                return noOptionsMessage;
            },
            onChange: onChange,
            options: options,
            placeholder: placeholder,
            validationErrors: validationErrors,
            value: value
        });
    };
    if (props["data-cy"]) return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-cy": props["data-cy"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboboxComponent, null));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ComboboxComponent, null);
});

},{"react":"ktQNc","react-select":"dRNnj","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/dropdowns/utils":"9zg6P","./SingleCombobox.styles":"lXg0m","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lXg0m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSingleCombobox", function() {
    return StyledSingleCombobox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  // overall component container\n  .combobox__control {\n    border-radius: 0;\n\n    background-color: transparent;\n\n    border-top: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    border-left: none;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  // selected item text inside input\n  .combobox__single-value {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSingleCombobox = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"ad9HG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"710Ad":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateableSelect", function() {
    return CreateableSelect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _index = require("../../../../index");
var _utils = require("../../../../components/ui-foundations/dropdowns/utils");
var _createableSelectStyles = require("./CreateableSelect.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var DropdownIndicator = function(indicatorProps) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).DropdownIndicator, Object.assign({}, indicatorProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-down",
        ariaLabel: "open dropdown",
        size: [
            (0, _index.TYPOGRAPHY).fontSize.base
        ]
    }));
};
var CustomOption = function(optionProps) {
    var children = optionProps.children, data = optionProps.data, rest = __rest(optionProps, [
        "children",
        "data"
    ]);
    var iconString = (data === null || data === void 0 ? void 0 : data.icon) || "";
    var swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Option, Object.assign({}, rest), swatchColor ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "swatch",
        style: {
            backgroundColor: swatchColor
        }
    }) : null, iconString ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: iconString,
        className: "inline-icon",
        ariaLabel: "".concat(iconString, " icon"),
        size: [
            (0, _index.TYPOGRAPHY).fontSize.base
        ]
    }) : null, children);
};
var CustomSingleValue = function(optionProps) {
    var children = optionProps.children, data = optionProps.data, rest = __rest(optionProps, [
        "children",
        "data"
    ]);
    var iconString = (data === null || data === void 0 ? void 0 : data.icon) || "";
    var swatchColor = (data === null || data === void 0 ? void 0 : data.swatchColor) || "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).SingleValue, Object.assign({}, rest), swatchColor ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "swatch",
        style: {
            backgroundColor: swatchColor
        }
    }) : null, iconString ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: iconString,
        className: "inline-icon",
        ariaLabel: "".concat(iconString, " icon"),
        size: [
            (0, _index.TYPOGRAPHY).fontSize.base
        ]
    }) : null, children);
};
var CreateableSelect = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    var id = props.id, isDisabled = props.isDisabled, className = props.className, isClearable = props.isClearable, closeMenuOnSelect = props.closeMenuOnSelect, isLoading = props.isLoading, onChange = props.onChange, _props_dropdownIndicatorProps = props.dropdownIndicatorProps, dropdownIndicatorProps = _props_dropdownIndicatorProps === void 0 ? {} : _props_dropdownIndicatorProps, onCreateOption = props.onCreateOption, placeholder = props.placeholder, value = props.value, menuIsOpen = props.menuIsOpen, options = props.options, _props_hasWordBreak = props.hasWordBreak, hasWordBreak = _props_hasWordBreak === void 0 ? true : _props_hasWordBreak, defaultValue = props.defaultValue, labelText = props.labelText, _props_hasHiddenLabel = props.hasHiddenLabel, hasHiddenLabel = _props_hasHiddenLabel === void 0 ? false : _props_hasHiddenLabel;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(options), 2), localOptions = _useState[0], setLocalOptions = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(value), 2), localValue = _useState1[0], setLocalValue = _useState1[1];
    var filterConfig = {
        ignoreCase: true,
        ignoreAccents: true,
        trim: true,
        matchFrom: "start"
    };
    var handleCreate = function(inputValue) {
        var newOption = createOption(inputValue);
        setLocalOptions(function(prev) {
            return (0, _toConsumableArray._)(prev).concat([
                newOption
            ]);
        });
        setLocalValue(newOption);
        onCreateOption(inputValue);
    };
    var createOption = function(label) {
        return {
            label: label,
            value: label.toLowerCase()
        };
    };
    var handleSelectChange = function(newValue) {
        setLocalValue(newValue);
        onChange(newValue);
    };
    var breakWord = hasWordBreak ? "has-word-break" : "";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "combobox-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        "data-testid": "combobox-label",
        className: hasHiddenLabel ? "aria-invisible" : "",
        htmlFor: id
    }, labelText), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _createableSelectStyles.StyledCreateableSelect), {
        id: id,
        ref: ref,
        components: {
            DropdownIndicator: (0, _utils.addCustomProps)(DropdownIndicator, dropdownIndicatorProps),
            Option: CustomOption,
            SingleValue: CustomSingleValue
        },
        isDisabled: isLoading || isDisabled,
        isLoading: isLoading,
        closeMenuOnSelect: closeMenuOnSelect,
        menuIsOpen: menuIsOpen,
        isClearable: isClearable,
        hasWordBreak: hasWordBreak,
        options: localOptions,
        classNamePrefix: "combobox",
        className: "".concat(breakWord, " ").concat(className),
        placeholder: placeholder,
        onChange: handleSelectChange,
        onCreateOption: handleCreate,
        value: localValue,
        defaultValue: defaultValue,
        filterOption: (0, _reactSelect.createFilter)(filterConfig)
    }));
});

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","react-select":"dRNnj","../../../../index":"j9IVt","../../../../components/ui-foundations/dropdowns/utils":"4xsKX","./CreateableSelect.styles":"lKQrO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4xsKX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCustomProps", function() {
    return addCustomProps;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var addCustomProps = function(Component, customProps) {
    return function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, Object.assign({}, props, {
            innerProps: Object.assign({}, props.innerProps, Object.assign({}, customProps))
        }));
    };
};

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lKQrO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCreateableSelect", function() {
    return StyledCreateableSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
var _index = require("../../../../index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n      word-break: break-word;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  .combobox__control {\n    border-radius: 0;\n    background-color: transparent;\n    border-top: none;\n    border-right: none;\n    border-bottom: 1px solid ",
        ";\n    border-left: none;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__control--is-disabled {\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__menu {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  .combobox__single-value {\n    color: ",
        ";\n  }\n\n  .swatch {\n    display: inline-block;\n    vertical-align: top;\n    margin-right: ",
        ";\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n  }\n  .inline-icon {\n    margin-right: ",
        ";\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCreateableSelect = (0, _styledComponentsDefault.default)((0, _creatableDefault.default))(_templateObject1(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.SPACING).xs, (0, _index.SPACING).xs, function(props) {
    return props.hasWordBreak && (0, _styledComponents.css)(_templateObject());
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select/creatable":"88Lfg","../../../../index":"j9IVt","../commonStyles":"ad9HG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9HNtg":[function(require,module,exports) {
/**
 * @filename useCombobox.ts
 * Allows access to the internals of a MultiCombobox component. For example, a discrete
 * button to clear all selected values.
 *
 * In your component’s file, import this hook and create a `ref` to the component.
 * Then, pass the ref into this hook.
 *
 * @example
 * const comboboxEl = useRef(null);
 * const { clearValue } = useCombobox(comboboxEl);
 *
 * <MultiCombobox ref={comboboxEl} ... />
 *
 * const handleSubmit = () => {
 *   clearValue();
 * };
 *
 * @see {@link https://react-select.com/props}
 * @see {@link https://github.com/JedWatson/react-select/discussions/4352}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCombobox", function() {
    return useCombobox;
});
function useCombobox(comboboxEl) {
    var clearValue = function() {
        if (comboboxEl === null || comboboxEl === void 0 ? void 0 : comboboxEl.current) comboboxEl.current.clearValue();
    };
    return {
        clearValue: clearValue
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cnjqL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BorderSelect", function() {
    return BorderSelect;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _borderSelectStyles = require("./BorderSelect.styles");
var BorderSelect = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, disabled = props.disabled, horizontal = props.horizontal, id = props.id, initialText = props.initialText, label = props.label, onChange = props.onChange, options = props.options, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, value = props.value, validationErrors = props.validationErrors;
    var selectId = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _borderSelectStyles.StyledSelect), {
        className: (0, _classnamesDefault.default)("Select", {
            horizontal: horizontal
        }, className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, label && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: selectId
    }, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "select-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("select", {
        onChange: onChange,
        value: value,
        disabled: disabled,
        id: selectId
    }, initialText && /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
        disabled: true,
        value: ""
    }, initialText), options.map(function(o) {
        var key = (0, _uuid.v4)();
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
            key: key,
            value: o.value
        }, o.name);
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-down",
        className: "selectCaret"
    })), validationErrors ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _borderSelectStyles.StyledValidationError), null, validationErrors.map(function(err, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
            className: "error-".concat(err),
            key: i
        }, err);
    })) : null);
};

},{"react":"ktQNc","uuid":"6ZyFu","classnames":"9xS9S","Permafrost/index":"iliLC","./BorderSelect.styles":"cO4WQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cO4WQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelect", function() {
    return StyledSelect;
});
parcelHelpers.export(exports, "StyledValidationError", function() {
    return StyledValidationError;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.horizontal {\n    > * {\n      display: inline-block;\n    }\n\n    > label {\n      margin-right: 12px;\n    }\n  }\n\n  label {\n    line-height: 1.2;\n    margin-bottom: 14px;\n    color: ",
        ";\n  }\n\n  .select-container {\n    position: relative;\n    max-width: 300px;\n\n    select {\n      background: transparent;\n      border: 1px solid ",
        ";\n      width: 100%;\n      max-width: 300px;\n      color: ",
        ";\n      font-size: ",
        ";\n      border-radius: 4px;\n      padding: 7px 30px 8px 15px;\n      appearance: none;\n      position: relative;\n      z-index: 2;\n\n      &:focus {\n        outline: 0;\n      }\n\n      &::-ms-expand {\n        display: none;\n      }\n    }\n\n    option {\n      color: ",
        ";\n\n      &:not(:checked) {\n        color: ",
        ";\n      }\n    }\n\n    .selectCaret {\n      display: inline-block;\n      right: 12px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: 1;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-top: 13px;\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).lightFontColor, (0, _index.COLORS).baliHai, (0, _index.COLORS).lightFontColor, (0, _index.FONT_SIZE).base, (0, _index.COLORS).black, (0, _index.COLORS).black);
var StyledValidationError = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"23kdA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", function() {
    return Select;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _selectStyles = require("./Select.styles");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var Select = function(props) {
    var id = props.id, className = props.className, disabled = props.disabled, initialText = props.initialText, onChange = props.onChange, options = props.options, _props_size = props.size, size = _props_size === void 0 ? "medium" : _props_size, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, value = props.value, variant = props.variant, onClick = props.onClick;
    var selectId = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectStyles.StyledSelect), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _classnamesDefault.default)("Select__container", size, variant),
        onClick: function(e) {
            return onClick ? onClick(e) : null;
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("select", {
        onChange: onChange,
        value: value,
        disabled: disabled,
        id: selectId
    }, initialText && /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
        disabled: true,
        value: ""
    }, initialText), options.map(function(o) {
        var key = (0, _uuid.v4)();
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("option", {
            key: key,
            value: o.value
        }, o.name);
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        className: "chevron",
        name: "chevron-down",
        size: size === "small" ? [
            10
        ] : [
            12
        ]
    })));
};

},{"react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./Select.styles":"4ouCu","classnames":"9xS9S","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4ouCu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelect", function() {
    return StyledSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n\n  .Select__container {\n    position: relative;\n    z-index: 0;\n\n    select {\n      color: ",
        ";\n      appearance: none;\n      background: transparent;\n      border: none;\n      z-index: 1;\n\n      &:focus {\n        outline: 0;\n      }\n    }\n\n    option {\n      color: ",
        ";\n\n      &:not(:checked) {\n        color: ",
        ";\n      }\n    }\n\n    .chevron {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      z-index: -1;\n    }\n\n    &.light {\n      select {\n        color: ",
        ";\n      }\n\n      .chevron {\n        color: ",
        ";\n      }\n    }\n\n    &.small {\n      select {\n        font-size: ",
        ";\n        padding: 0;\n        padding-right: 15px;\n      }\n\n      .chevron {\n        right: 0px;\n      }\n    }\n\n    &.medium {\n      font-size: ",
        ";\n\n      select {\n        padding: 7px 35px 8px 15px;\n      }\n\n      .chevron {\n        right: 12px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.COLORS).black, (0, _index.FONT_SIZE).base, (0, _index.FONT_SIZE).subheadSmall);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1sI1R":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Filter", function() {
    return Filter;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _filterStyles = require("./Filter.styles");
var _lodash = require("lodash");
var Filter = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var filter = props.filter, onFilter = props.onFilter, optionsList = props.optionsList, _props_isMulti = props.isMulti, isMulti = _props_isMulti === void 0 ? false : _props_isMulti, _props_placement = props.placement, placement = _props_placement === void 0 ? "right" : _props_placement;
    var menuEl = (0, _react.useRef)();
    var hasFilter = !!filter.length;
    var handleToggleMultiFilter = function(option) {
        if (filter.some(function(filterOption) {
            return (0, _lodash.isEqual)(filterOption.value, option.value);
        })) onFilter(filter.filter(function(filterOption) {
            return !(0, _lodash.isEqual)(filterOption.value, option.value);
        }));
        else onFilter((0, _toConsumableArray._)(filter).concat([
            option
        ]));
    };
    var handleToggleSingleFilter = function(option) {
        (0, _lodash.isEqual)(filter[0], option) && hasFilter ? onFilter([]) : onFilter([
            option
        ]);
    };
    var handleOptionClick = function(option) {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    (0, _utils.hookUtils).useClickOutside(menuEl, function() {
        setIsOpen(false);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterStyles.StyledFilter), {
        ref: menuEl,
        "$placement": placement,
        className: "filter"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "outline",
        className: (0, _classnamesDefault.default)("filter__toggle", "square", {
            "filters-on": hasFilter
        }),
        "data-testid": "button-filter-toggle",
        onClick: function() {
            setIsOpen(!isOpen);
        }
    }, props.label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "filter-label"
    }, props.label) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "filter-outline"
    }), hasFilter ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "swatch-circle"
    }) : []), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "div-filter-options-container",
        className: (0, _classnamesDefault.default)("filter__container", {
            visible: isOpen
        })
    }, hasFilter ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "filter__clear-filter",
        onClick: function() {
            onFilter([]);
        }
    }, "Clear Filter") : [], /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "filter__options"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", {
        className: "filter__title"
    }, "FILTER ON"), /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", null, optionsList.map(function(filterOption) {
        var text = filterOption.text, value = filterOption.value, iconName = filterOption.iconName;
        var selected = filter.some(function(item) {
            return item.value === value;
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: "LabelFilter-".concat(value),
            "data-testid": "li--filter-list-".concat(value),
            className: (0, _classnamesDefault.default)("filter__option", {
                selected: selected
            }),
            onClick: function() {
                handleOptionClick(filterOption);
            }
        }, selected ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "check",
            className: "filter__check",
            "data-testid": "li--filter-list-icon-selected-indicator-for-".concat(value)
        }) : [], " ", text, iconName ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: iconName,
            className: "filter__icon",
            "data-testid": "li--filter-list-icon-for-".concat(value)
        }) : []);
    })))));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./Filter.styles":"8XtAI","lodash":"h75z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8XtAI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilter", function() {
    return StyledFilter;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  position: relative;\n  margin-right: 10px;\n\n  .filter__toggle {\n    display: flex;\n    height: 35px;\n\n    .filter-label {\n      margin-right: 10px;\n    }\n\n    &.filters-on {\n      background-color: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    }\n\n    .swatch-circle {\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      border-radius: 50%;\n      background-color: ",
        ";\n      top: -3px;\n      right: -3px;\n    }\n  }\n\n  .filter__container {\n    width: 275px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    position: absolute;\n    top: 45px;\n    ",
        "\n    display: none;\n    z-index: 100;\n\n    &:before {\n      content: '';\n      border-bottom: 10px solid ",
        ";\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      position: absolute;\n      top: -11px;\n      ",
        "\n    }\n\n    &:after {\n      content: '';\n      border-bottom: 9px solid ",
        ";\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      position: absolute;\n      top: -9px;\n      ",
        "\n    }\n  }\n\n  .visible {\n    display: block;\n  }\n\n  .filter__options {\n    padding: 10px 0 10px 15px;\n  }\n\n  .filter__title,\n  .filter__option:not(:last-child) {\n    margin-bottom: 8px;\n  }\n\n  .filter__option {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n\n    &.selected {\n      color: ",
        ";\n    }\n  }\n\n  .filter__clear-filter {\n    border-bottom: 1px solid ",
        ";\n    padding: 10px 10px 10px 15px;\n    font-size: ",
        ";\n    margin-right: ",
        ";\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .filter__icon {\n    margin-left: ",
        ";\n  }\n\n  .filter__check {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilter = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).ebony, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).midFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 0;" : "left: 0;";
}, (0, _constants.COLORS).midFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 7px;" : "left: 7px;";
}, (0, _constants.COLORS).ebony, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 8px;" : "left: 8px;";
}, (0, _constants.COLORS).lightFontColor, (0, _constants.COLORS).midFontColor, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.SPACING).xs, (0, _constants.SPACING).xs, (0, _constants.SPACING).xs);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kF8ys":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelect", function() {
    return FilterSelect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _filterSelectStyles = require("./FilterSelect.styles");
var _lodash = require("lodash");
var _components = require("./components");
var _helpers = require("./helpers");
var FilterSelect = function(param) {
    var _param_isMulti = param.isMulti, isMulti = _param_isMulti === void 0 ? false : _param_isMulti, label = param.label, optionsList = param.optionsList, _param_placement = param.placement, placement = _param_placement === void 0 ? "right" : _param_placement, selected = param.selected, onSave = param.onSave;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([]), 2), selectedFilters = _useState1[0], setSelectedFilters = _useState1[1];
    var menuEl = (0, _react.useRef)();
    var hasSelected = (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0;
    var handleToggleMultiFilter = function(option) {
        if (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some(function(filterOption) {
            return (0, _lodash.isEqual)(filterOption.value, option.value);
        })) setSelectedFilters(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.filter(function(filterOption) {
            return !(0, _lodash.isEqual)(filterOption.value, option.value);
        }));
        else setSelectedFilters((0, _toConsumableArray._)(selectedFilters).concat([
            option
        ]));
    };
    var handleToggleSingleFilter = function(option) {
        (0, _lodash.isEqual)(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters[0], option) && hasSelected ? setSelectedFilters([]) : setSelectedFilters([
            option
        ]);
    };
    var handleOptionClick = function(option) {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    (0, _utils.hookUtils).useClickOutside(menuEl, function() {
        if (isOpen) {
            setSelectedFilters(selected ? selected : []);
            setIsOpen(false);
        }
    }); // ensures local state of selectedFilters is updated when selected prop is changed
    (0, _react.useEffect)(function() {
        if (selected && selected !== selectedFilters) setSelectedFilters(selected);
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterSelectStyles.StyledFilterSelect), {
        ref: menuEl,
        "$placement": placement,
        className: "filter"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: (0, _classnamesDefault.default)("FilterSelect__toggle", "square", {
            "filters-on": hasSelected
        }),
        "data-testid": "toggle-btn",
        onClick: function() {
            setIsOpen(!isOpen);
        }
    }, label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "filter-label"
    }, label) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: label ? "fa-caret-down" : "filter"
    }), hasSelected ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "swatch-circle"
    }) : []), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-testid": "div-filter-options-container",
        className: (0, _classnamesDefault.default)("filter__container", {
            visible: isOpen
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "FilterSelect__options"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _components.FilterSelectOptions), {
        isMulti: isMulti,
        optionsList: (0, _helpers.sortOptionsList)(optionsList, selected),
        selectedFilters: selectedFilters,
        handleOptionClick: handleOptionClick
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _components.FilterSelectReset), {
        selectedFilterCount: selectedFilters.length,
        setSelectedFilters: setSelectedFilters
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _components.FilterSelectControls), {
        currentStoreFilters: selected,
        selectedFilters: selectedFilters,
        onSave: onSave,
        setIsOpen: setIsOpen,
        setSelectedFilters: setSelectedFilters
    })));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./FilterSelect.styles":"btG3f","lodash":"h75z0","./components":"iBOl1","./helpers":"cNJwm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"btG3f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelect", function() {
    return StyledFilterSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n  display: inline-block;\n  margin: 0 var(--pf-padding-2) var(--pf-padding-2) 0;\n  position: relative;\n\n  .FilterSelect__toggle {\n    display: flex;\n    align-items: center;\n    background-color: ",
        ";\n    color: ",
        ";\n    height: 35px;\n    padding: 5px 10px;\n    box-shadow: none;\n\n    .filter-label {\n      margin-right: var(--pf-padding-2);\n    }\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  .swatch-circle {\n    position: absolute;\n    top: -3px;\n    right: -3px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: var(--pf-secondary-color-400);\n  }\n\n  .filter__container {\n    position: absolute;\n    top: 36px;\n    ",
        "\n    width: 275px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 4px;\n    color: ",
        ";\n    display: none;\n    z-index: 100;\n  }\n\n  .visible {\n    display: block;\n  }\n\n  .FilterSelect__options {\n    padding: var(--pf-padding-3) 0;\n  }\n\n  .filter__title,\n  .option-container:not(:last-child) {\n    margin-bottom: var(--pf-padding-2);\n  }\n\n  .filter__icon {\n    margin-left: var(--pf-padding-2);\n  }\n\n  .filter__check {\n    margin-right: var(--pf-padding-2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelect = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).ebony, (0, _constants.COLORS).midFontColor, (0, _constants.COLORS).lightFontColor, function(param) {
    var $placement = param.$placement;
    return $placement === "left" ? "right: 0;" : "left: 0;";
}, (0, _constants.COLORS).midnight, (0, _constants.COLORS).comet, (0, _constants.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iBOl1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectControls", function() {
    return 0, _filterSelectControls.FilterSelectControls;
});
parcelHelpers.export(exports, "FilterSelectOptions", function() {
    return 0, _filterSelectOptions.FilterSelectOptions;
});
parcelHelpers.export(exports, "FilterSelectReset", function() {
    return 0, _filterSelectReset.FilterSelectReset;
});
var _filterSelectControls = require("./FilterSelectControls/FilterSelectControls");
var _filterSelectOptions = require("./FilterSelectOptions/FilterSelectOptions");
var _filterSelectReset = require("./FilterSelectReset/FilterSelectReset");

},{"./FilterSelectControls/FilterSelectControls":"5Yb5r","./FilterSelectOptions/FilterSelectOptions":"fiBjB","./FilterSelectReset/FilterSelectReset":"gx6P8","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Yb5r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectControls", function() {
    return FilterSelectControls;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("Permafrost/components/ui-foundations/buttons/Button/Button");
var _filterSelectControlsStyles = require("./FilterSelectControls.styles");
var FilterSelectControls = function(param) {
    var currentStoreFilters = param.currentStoreFilters, selectedFilters = param.selectedFilters, onSave = param.onSave, setIsOpen = param.setIsOpen, setSelectedFilters = param.setSelectedFilters;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterSelectControlsStyles.StyledFilterSelectControls), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        "aria-label": "Apply filter button",
        className: "apply-btn",
        onClick: function() {
            onSave(selectedFilters);
            setIsOpen(false);
        }
    }, "Apply"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        "aria-label": "Cancel filter button",
        className: "cancel-btn",
        onClick: function() {
            setSelectedFilters(currentStoreFilters);
            setIsOpen(false);
        }
    }, "Cancel"));
};

},{"react":"ktQNc","Permafrost/components/ui-foundations/buttons/Button/Button":"gPP3j","./FilterSelectControls.styles":"9X0qj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9X0qj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectControls", function() {
    return StyledFilterSelectControls;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin: 0 var(--pf-padding-3) var(--pf-padding-3) 0;\n\n  .apply-btn {\n    background-color: ",
        ";\n    border-radius: 10px;\n    color: ",
        ";\n  }\n\n  .cancel-btn {\n    background: none;\n    box-shadow: none;\n    color: ",
        ";\n    margin-right: var(--pf-padding-2);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectControls = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.COLORS).summerSky, (0, _constants.COLORS).white, (0, _constants.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fiBjB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectOptions", function() {
    return FilterSelectOptions;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _filterSelectOptionsStyles = require("./FilterSelectOptions.styles");
var FilterSelectOptions = function(param) {
    var isMulti = param.isMulti, optionsList = param.optionsList, selectedFilters = param.selectedFilters, handleOptionClick = param.handleOptionClick;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterSelectOptionsStyles.StyledFilterSelectOptions), null, optionsList === null || optionsList === void 0 ? void 0 : optionsList.map(function(filterOption) {
        var text = filterOption.text, value = filterOption.value, iconName = filterOption.iconName;
        var selected = selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some(function(item) {
            return item.value === value;
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: "LabelFilter-".concat(value),
            "data-testid": "li--filter-list-".concat(value),
            className: (0, _classnamesDefault.default)("option-container", {
                selected: selected
            }),
            onClick: function() {
                handleOptionClick(filterOption);
            }
        }, isMulti ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "multi-option"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Checkbox), {
            "aria-label": "Checkbox option ".concat(filterOption.value),
            className: "option-checkbox",
            isSelected: selected
        }), text) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "single-option"
        }, text, iconName ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: iconName,
            className: "filter__icon",
            "data-testid": "li--filter-list-icon-for-".concat(value)
        }) : null, selected ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "check",
            className: "selected-checkmark",
            "data-testid": "li--filter-list-icon-selected-indicator-for-".concat(value)
        }) : null));
    }));
};

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./FilterSelectOptions.styles":"lPkix","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lPkix":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectOptions", function() {
    return StyledFilterSelectOptions;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .option-container {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid ",
        ";\n    cursor: pointer;\n\n    .single-option,\n    .multi-option {\n      display: flex;\n      padding: 0 0 var(--pf-padding-2) var(--pf-padding-3);\n    }\n\n    .option-checkbox {\n      color: ",
        ";\n      margin-right: var(--pf-padding-2);\n\n      .checkboxSquare {\n        stroke-width: 1;\n      }\n\n      &.checked {\n        .checkboxSquare {\n          color: var(--pf-secondary-color-400);\n          fill: var(--pf-secondary-color-400);\n        }\n\n        .checkmark {\n          color: ",
        ";\n        }\n      }\n    }\n\n    .selected-checkmark {\n      color: var(--pf-secondary-color-400);\n      margin-left: var(--pf-padding-2);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectOptions = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.COLORS).baliHai, (0, _constants.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gx6P8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterSelectReset", function() {
    return FilterSelectReset;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _filterSelectStyles = require("./FilterSelect.styles");
var FilterSelectReset = function(param) {
    var selectedFilterCount = param.selectedFilterCount, setSelectedFilters = param.setSelectedFilters;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _filterSelectStyles.StyledFilterSelectReset), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "reset",
        onClick: function() {
            setSelectedFilters([]);
        }
    }, "Reset"), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, " ", selectedFilterCount, " Selected "));
};

},{"react":"ktQNc","./FilterSelect.styles":"1YT9r","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1YT9r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFilterSelectReset", function() {
    return StyledFilterSelectReset;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  background-color: ",
        ";\n  margin-top: var(--pf-padding-2);\n  padding: var(--pf-padding-2) var(--pf-padding-3);\n  font-size: ",
        ";\n\n  .reset:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFilterSelectReset = (0, _styledComponentsDefault.default).p(_templateObject(), (0, _constants.COLORS).oxfordBlue, (0, _constants.TYPOGRAPHY).fontSize.subheadSmall);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cNJwm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortOptionsList", function() {
    return sortOptionsList;
});
var sortOptionsList = function(optionsList, selected) {
    var selectedValues = new Set(selected.map(function(item) {
        return item.value;
    }));
    return optionsList.sort(function(a, b) {
        var aSelected = selectedValues.has(a.value) ? 0 : 1;
        var bSelected = selectedValues.has(b.value) ? 0 : 1;
        return aSelected - bSelected;
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9V0Ho":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableField", function() {
    return EditableField;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// todo: how to handle/inform user when length is too short?
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _editableFieldStyles = require("./EditableField.styles"); /**
                                                               * Wrapper component which enables text editing in place directly on a child component,
                                                               * element, or plain text.
                                                               */ 
function EditableField(props) {
    var children = props.children, className = props.className, _props_minLength = props.minLength, minLength = _props_minLength === void 0 ? 3 : _props_minLength, onUpdate = props.onUpdate;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), initialValue = _useState[0], setInitialValue = _useState[1]; // used as unique css class name
    var _useRef = (0, _react.useRef)((0, _utils.stringUtils).createRandomString()), id = _useRef.current;
    var editableEl = (0, _react.useRef)();
    var handleBlur = function() {
        var node = editableEl.current.children[0];
        var currentValue = node.innerText || editableEl.current.innerText;
        if (minLength && currentValue.length < minLength) {
            // revert to last good value
            if (node) node.textContent = initialValue;
            else editableEl.current.textContent = initialValue;
        } else if (currentValue !== initialValue) {
            // allow updated value
            setInitialValue(currentValue);
            if (onUpdate) onUpdate(currentValue);
        }
    };
    var handleKeypress = function(event) {
        if (event.key === "Enter") editableEl.current.blur();
    }; // Records the initial value for the text, in order to check length and compare to current text.
    // Also ensures the size of the icon is relative to the text inside the editable element (which
    // is the icon’s *sibling*, not ancestor).
    (0, _react.useEffect)(function() {
        var _a, _b;
        var style = document.createElement("style");
        var node = editableEl.current.children[0];
        document.head.appendChild(style);
        if (node) {
            var fontSize = getComputedStyle(node).fontSize;
            (_a = style === null || style === void 0 ? void 0 : style.sheet) === null || _a === void 0 || _a.insertRule(".".concat(id, " .pencil-icon { font-size: calc(").concat(fontSize, " * 0.8) }"));
            setInitialValue(node.innerText);
        } else {
            (_b = style === null || style === void 0 ? void 0 : style.sheet) === null || _b === void 0 || _b.insertRule(".".concat(id, " .pencil-icon { font-size: 0.8em }"));
            setInitialValue(editableEl.current.innerText);
        }
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _editableFieldStyles.StyledEditableField), {
        className: (0, _classnamesDefault.default)("EditableField-container", id, className),
        "data-cy": props["data-cy"],
        id: props.id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        role: "textbox",
        tabIndex: 0,
        contentEditable: true,
        suppressContentEditableWarning: true,
        ref: editableEl,
        onKeyDown: handleKeypress,
        onBlur: handleBlur
    }, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-pencil-alt",
        className: "pencil-icon"
    }));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./EditableField.styles":"jcT1D","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jcT1D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledEditableField", function() {
    return StyledEditableField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:hover .pencil-icon {\n    opacity: 1;\n  }\n\n  [role='textbox'] > * {\n    display: inline-block;\n  }\n\n  .pencil-icon {\n    margin-left: 0.25em;\n    margin-right: 3px;\n    opacity: 0;\n\n    transition: opacity ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var transitionDuration = "200ms";
var StyledEditableField = (0, _styledComponentsDefault.default).span(_templateObject(), transitionDuration);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"86byk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberField", function() {
    return NumberField;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _numberFieldStyles = require("./NumberField.styles"); /**
                                                           * Basic numeric input field. A label is required, but may be visually hidden
                                                           * using the `hiddenLabel` property.
                                                           */ 
function NumberField(props) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoFocus = props.autoFocus, className = props.className, disabled = props.disabled, hiddenLabel = props.hiddenLabel, id = props.id, label = props.label, max = props.max, min = props.min, onChange = props.onChange, placeholder = props.placeholder, required = props.required, step = props.step, tabIndex = props.tabIndex, value = props.value;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(value ? value : value === 0 ? 0 : ""), 2), currentValue = _useState[0], setCurrentValue = _useState[1];
    var inputEl = (0, _react.useRef)(null);
    var increment = function() {
        var input = inputEl.current;
        if (input) {
            input.stepUp(); // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.increment) props.increment();
    };
    var decrement = function() {
        var input = inputEl.current;
        if (input) {
            input.stepDown(); // convert string value to number
            setCurrentValue(+input.value);
        }
        if (props.decrement) props.decrement();
    };
    var handleChange = function(event) {
        var _a;
        var targetValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        setCurrentValue(targetValue === "" ? "" : +targetValue);
    }; // When external state changes, we update local state to match, if not already
    (0, _react.useEffect)(function() {
        if (currentValue === value) return;
        setCurrentValue(value);
    }, [
        value
    ]); // todo: this is problematic because it means on mount the onChange handler will always be fired
    // therefore - if the onChange is some heavy operation or call to the BE - that will automatically get called
    // without the user even doing anything
    (0, _react.useEffect)(function() {
        // We must debounce the min/max evaluation until after the user has finished typing
        var delayDebounceFn = setTimeout(function() {
            if ((min || min === 0) && +currentValue < min) {
                setCurrentValue("");
                onChange("");
            } else if ((max || max === 0) && +currentValue > max) {
                setCurrentValue("");
                onChange("");
            } else if (+currentValue < 0) {
                setCurrentValue("");
                onChange("");
            } else onChange(currentValue);
        }, 1000);
        return function() {
            return clearTimeout(delayDebounceFn);
        };
    }, [
        currentValue
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberFieldStyles.StyledNumberField), {
        className: (0, _classnamesDefault.default)(className, {
            hiddenLabel: hiddenLabel
        }),
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "data-testid": props["data-testid"],
        tabIndex: tabIndex,
        autoFocus: autoFocus,
        id: fieldId,
        type: "number",
        value: currentValue,
        disabled: disabled,
        max: max,
        min: min,
        onChange: handleChange,
        placeholder: placeholder,
        required: required,
        step: step,
        "aria-label": hiddenLabel ? label : "",
        ref: inputEl
    }), !hiddenLabel && /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: fieldId
    }, label), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "spin-buttons"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "no-style",
        onClick: increment,
        tabindex: -1
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-up",
        ariaLabel: "increase"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "no-style",
        onClick: decrement,
        tabindex: -1
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-down",
        ariaLabel: "decrease"
    }))));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","uuid":"6ZyFu","Permafrost/index":"iliLC","./NumberField.styles":"1C5cQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1C5cQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNumberField", function() {
    return StyledNumberField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  min-height: 40px;\n\n  &:not(.hiddenLabel) {\n    margin-top: 35px;\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    -moz-appearance: textfield;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      appearance: none;\n    }\n\n    &::placeholder {\n      opacity: 0.5;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      background-color: transparent;\n      opacity: 0.7;\n\n      pointer-events: none;\n\n      ~ .spin-buttons {\n        opacity: 0.7;\n\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  label {\n    ",
        ";\n\n    position: absolute;\n    top: -24px;\n  }\n\n  .spin-buttons {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    margin-bottom: 0.5em;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNumberField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _fieldsCommonStyles.inputCommon), (0, _index.COLORS).lightFontColor, (0, _fieldsCommonStyles.labelCommon));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"63pUg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"63pUg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputCommon", function() {
    return inputCommon;
});
parcelHelpers.export(exports, "labelCommon", function() {
    return labelCommon;
});
parcelHelpers.export(exports, "fieldInfoCommon", function() {
    return fieldInfoCommon;
});
parcelHelpers.export(exports, "placeholderCommon", function() {
    return placeholderCommon;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background-color: transparent;\n  color: ",
        ";\n\n  border-radius: 0;\n  border: 0 solid currentColor;\n  border-bottom-width: 1px;\n\n  &:focus,\n  &:hover,\n  &.filled {\n    border-color: ",
        ";\n  }\n\n  &:required {\n    border-bottom-color: ",
        ";\n\n    + label:after {\n      content: '*';\n      margin-left: 4px;\n    }\n  }\n\n  &:disabled {\n    border-style: dotted;\n    border-bottom-color: ",
        ";\n    cursor: not-allowed;\n\n    &:hover {\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  font-weight: bold;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  margin-top: 13px;\n  font-size: ",
        ";\n\n  .prompt {\n    color: ",
        ";\n  }\n\n  .error {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &::placeholder,\n  &::-webkit-input-placeholder {\n    opacity: 0.42;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
var inputCommon = (0, _styledComponents.css)(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).lightGray);
var labelCommon = (0, _styledComponents.css)(_templateObject1(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).lightFontColor);
var fieldInfoCommon = (0, _styledComponents.css)(_templateObject2(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).red);
var placeholderCommon = (0, _styledComponents.css)(_templateObject3());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lhEqK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NumberField", function() {
    return NumberField;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodash = require("lodash");
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _numberFieldStyles = require("./NumberField.styles"); /**
                                                           * Basic numeric input field. A label is required, but may be visually hidden
                                                           * using the `hiddenLabel` property.
                                                           */ 
function NumberField(props) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoFocus = props.autoFocus, className = props.className, disabled = props.disabled, hiddenLabel = props.hiddenLabel, id = props.id, label = props.label, max = props.max, min = props.min, placeholder = props.placeholder, _props_readOnly = props.readOnly, readOnly = _props_readOnly === void 0 ? false : _props_readOnly, required = props.required, step = props.step, tabIndex = props.tabIndex, value = props.value, onChange = props.onChange, onClick = props.onClick;
    var inputEl = (0, _react.useRef)(null);
    var increment = function() {
        var input = inputEl.current;
        if (input) {
            input.stepUp(); // if !value OR value < min, set value to min or 1 - else increment by step
            (0, _lodash.isNil)(value) || !(0, _lodash.isNil)(min) && value < min ? onChange(min || 1) : onChange(+input.value);
        }
    };
    var decrement = function() {
        var input = inputEl.current;
        if (input) {
            input.stepDown(); // if !value, set value to min or 0 - else if value > max, set value to max - else decrement by step
            (0, _lodash.isNil)(value) ? onChange(min || 0) : !(0, _lodash.isNil)(max) && value > max ? onChange(max) : onChange(+input.value);
        }
    };
    var handleChange = function(event) {
        var _a; // no validation for min or max - whatever value the user enters will be passed to onChange
        var targetValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        onChange(targetValue === "" ? null : +targetValue);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _numberFieldStyles.StyledNumberField), {
        className: (0, _classnamesDefault.default)(className, {
            hiddenLabel: hiddenLabel
        }),
        "data-cy": props["data-cy"],
        id: id,
        onClick: onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        id: fieldId,
        "aria-label": hiddenLabel ? label : "",
        autoFocus: autoFocus,
        "data-testid": props["data-testid"],
        readOnly: readOnly,
        disabled: disabled,
        max: max,
        min: min,
        onChange: handleChange,
        placeholder: placeholder,
        ref: inputEl,
        required: required,
        step: step,
        tabIndex: tabIndex,
        type: "number",
        value: !(0, _lodash.isNil)(value) ? value : ""
    }), !hiddenLabel ? /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: fieldId
    }, label) : null, readOnly ? null : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "spin-buttons"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "data-testid": "increment-button",
        disabled: !(0, _lodash.isNil)(value) && !(0, _lodash.isNil)(max) && value >= max ? true : false,
        onClick: increment,
        tabindex: -1,
        variant: "no-style"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-up",
        ariaLabel: "increase"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "data-testid": "decrement-button",
        disabled: !(0, _lodash.isNil)(value) && !(0, _lodash.isNil)(min) && value <= min ? true : false,
        onClick: decrement,
        tabindex: -1,
        variant: "no-style"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-down",
        ariaLabel: "decrease"
    }))));
}

},{"react":"ktQNc","classnames":"9xS9S","lodash":"h75z0","uuid":"6ZyFu","Permafrost/index":"iliLC","./NumberField.styles":"h4g6D","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"h4g6D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNumberField", function() {
    return StyledNumberField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  min-height: 40px;\n\n  &:not(.hiddenLabel) {\n    margin-top: 35px;\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    -moz-appearance: textfield;\n\n    &::-webkit-inner-spin-button,\n    &::-webkit-outer-spin-button {\n      appearance: none;\n    }\n\n    &::placeholder {\n      opacity: 0.5;\n      color: ",
        ";\n    }\n\n    &:disabled {\n      background-color: transparent;\n      opacity: 0.7;\n\n      pointer-events: none;\n\n      ~ .spin-buttons {\n        opacity: 0.7;\n\n        pointer-events: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  label {\n    ",
        ";\n\n    position: absolute;\n    top: -24px;\n  }\n\n  .spin-buttons {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n\n    margin-bottom: 0.5em;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNumberField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _fieldsCommonStyles.inputCommon), (0, _index.COLORS).lightFontColor, (0, _fieldsCommonStyles.labelCommon));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"63pUg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"SZt4o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SearchField", function() {
    return SearchField;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _searchFieldStyles = require("./SearchField.styles");
var SearchField = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, inputProps = props.inputProps, onChange = props.onChange, onKeyUp = props.onKeyUp, placeholder = props.placeholder, value = props.value;
    var id = (0, _uuid.v4)();
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _searchFieldStyles.StyledSearchField), {
        className: className,
        "data-cy": props["data-cy"],
        id: props.id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-search",
        ariaLabel: "search"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        type: "search",
        id: id,
        placeholder: placeholder,
        value: value,
        onChange: onChange,
        onKeyUp: onKeyUp
    }, inputProps)));
};
exports.default = SearchField;

},{"react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./SearchField.styles":"gCQmT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gCQmT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSearchField", function() {
    return StyledSearchField;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  background: transparent;\n\n  label {\n    position: absolute;\n    top: 4px;\n    left: 0;\n    font-size: ",
        ";\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 5px 5px 25px;\n    font-size: ",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSearchField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadSmall, (0, _fieldsCommonStyles.inputCommon), (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"63pUg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"b0cuG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", function() {
    return TextField;
});
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _textFieldStyles = require("./TextField.styles");
var TextField = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(props, ref) {
    // ensures unique value to associate label with input
    var fieldId = (0, _uuid.v4)();
    var autoComplete = props.autoComplete, autoFocus = props.autoFocus, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayErrors = props.displayErrors, id = props.id, inputProps = props.inputProps, label = props.label, maxLength = props.maxLength, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onKeyUp = props.onKeyUp, onClick = props.onClick, onFocus = props.onFocus, placeholder = props.placeholder, promptProps = props.promptProps, required = props.required, _props_type = props.type, type = _props_type === void 0 ? "text" : _props_type, validationErrors = props.validationErrors, value = props.value, readOnly = props.readOnly;
    var handleKeyUp = function(e) {
        if (!onKeyUp && e.key === "Enter") e.currentTarget.blur();
        onKeyUp === null || onKeyUp === void 0 || onKeyUp(e);
    };
    var errorClass = displayErrors ? "error" : "prompt";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldStyles.StyledTextField), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: (0, _classnamesDefault.default)("text-input__input-element", {
            filled: value && value.length > 0 || defaultValue
        }),
        disabled: disabled,
        defaultValue: defaultValue,
        id: fieldId,
        maxLength: maxLength,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onClick: onClick,
        onFocus: onFocus,
        onKeyUp: handleKeyUp,
        placeholder: placeholder,
        required: required,
        type: type,
        value: value,
        readOnly: readOnly,
        ref: ref
    }, inputProps)), label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        htmlFor: fieldId
    }, label) : null, (validationErrors || maxLength) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textFieldStyles.StyledFieldInfo), null, validationErrors && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, validationErrors.map(function(err, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("p", Object.assign({
            className: errorClass,
            key: i
        }, promptProps), err);
    })), maxLength && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _classnamesDefault.default)("count", {
            isMax: (value === null || value === void 0 ? void 0 : value.length) === maxLength
        })
    }, (value === null || value === void 0 ? void 0 : value.length) || 0, " / ", maxLength)));
});

},{"classnames":"9xS9S","react":"ktQNc","uuid":"6ZyFu","./TextField.styles":"5KAPp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5KAPp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTextField", function() {
    return StyledTextField;
});
parcelHelpers.export(exports, "StyledFieldInfo", function() {
    return StyledFieldInfo;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _fieldsCommonStyles = require("../fieldsCommon.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  color: ",
        ";\n  font-family: ",
        ";\n\n  min-height: 40px;\n  margin-top: 35px;\n\n  label {\n    pointer-events: none;\n\n    position: absolute;\n    top: 6px;\n\n    transition: transform ",
        " ",
        ";\n  }\n\n  input {\n    ",
        ";\n\n    padding: 5px 0 10px;\n    margin-top: 0;\n\n    border: 0 solid currentColor;\n    border-bottom-width: 1px;\n\n    &::placeholder,\n    &::-webkit-input-placeholder {\n      color: inherit;\n      opacity: 0;\n\n      transition: opacity ",
        " ",
        ";\n    }\n\n    &:focus,\n    &.filled {\n      ",
        "\n\n      + label {\n        ",
        ";\n\n        transform: translateY(-30px);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  display: flex;\n\n  p {\n    margin: 0;\n  }\n\n  .count {\n    margin-left: auto;\n  }\n\n  .isMax {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTextField = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.TYPOGRAPHY).fontFamily.base, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _fieldsCommonStyles.inputCommon), (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _fieldsCommonStyles.placeholderCommon), (0, _fieldsCommonStyles.labelCommon));
var StyledFieldInfo = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _fieldsCommonStyles.fieldInfoCommon), (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","../fieldsCommon.styles":"63pUg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"406kD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", function() {
    return Card;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodash = require("lodash");
var _index = require("Permafrost/index");
var _cardStyles = require("./Card.styles");
var Card = function(card) {
    var id = card.id, className = card.className, description = card.description, disabled = card.disabled, disabledTooltip = card.disabledTooltip, footer = card.footer, header = card.header, kabobMenuOptions = card.kabobMenuOptions, selectable = card.selectable, style = card.style, title = card.title;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardStyles.StyledCard), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            disabled: disabled === true,
            selectable: (0, _lodash.isFunction)(selectable === null || selectable === void 0 ? void 0 : selectable.onSelect) === true,
            selected: (selectable === null || selectable === void 0 ? void 0 : selectable.selected) === true
        }),
        "data-tip": true,
        "data-for": id,
        "data-tip-disable": !disabled,
        onClick: function() {
            if (!disabled) selectable === null || selectable === void 0 || selectable.onSelect();
        },
        style: style,
        "data-testid": card["data-testid"]
    }, disabledTooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        for: id
    }, disabledTooltip) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("header", {
        className: "Card--header-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "header"
    }, header), kabobMenuOptions ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.KabobMenu), {
        id: "".concat(id, "-kabob-menu"),
        className: "kabob",
        disabled: disabled,
        menuOptions: kabobMenuOptions
    }) : null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "Card--content-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "body-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("header", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "title"
    }, title)), description ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "desc"
    }, description) : null), footer ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "footer"
    }, footer) : null));
};

},{"react":"ktQNc","classnames":"9xS9S","lodash":"h75z0","Permafrost/index":"iliLC","./Card.styles":"dKaqH","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dKaqH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCard", function() {
    return StyledCard;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: solid 1px ",
        ";\n  border-radius: 4px;\n  box-sizing: content-box;\n\n  &,\n  .Card--header-container,\n  .Card--content-container,\n  .Card--header-container .header {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .Card--header-container {\n    align-items: center;\n    background: ",
        ";\n    border-radius: 2px 2px 0 0;\n    padding: 0 30px;\n    position: relative;\n    width: 100%;\n\n    .header {\n      color: ",
        ";\n      height: 80px;\n      width: 100%;\n      max-width: 150px;\n      margin: 0;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .kabob {\n      position: absolute;\n      right: 2px;\n      top: -2px;\n    }\n  }\n\n  .Card--content-container {\n    height: 100%;\n    justify-content: space-between;\n    padding: 10px;\n\n    .title {\n      color: ",
        ";\n      font-size: 18px;\n    }\n\n    .desc {\n      margin-top: 10px;\n      word-break: break-word;\n    }\n\n    .footer {\n      color: ",
        ";\n      display: flex;\n      font-size: 12px;\n      margin-top: 20px;\n    }\n  }\n\n  &.selectable {\n    cursor: pointer;\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n  }\n\n  &.selected {\n    border: solid 2px ",
        ";\n    margin: -1px;\n  }\n\n  &.disabled {\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCard = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).midFontColor, (0, _index.COLORS).white, (0, _index.COLORS).midFontColor, (0, _index.COLORS).fieldPromptInfo);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7RdtM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardContainer", function() {
    return 0, _cardContainer.CardContainer;
});
var _cardContainer = require("./CardContainer");

},{"./CardContainer":"wqbuf","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"wqbuf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardContainer", function() {
    return CardContainer;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _card = require("../Card/Card");
var _cardContainerStyles = require("./CardContainer.styles");
var CardContainer = function(props) {
    var cards = props.cards;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _cardContainerStyles.StyledCardContainer), null, cards === null || cards === void 0 ? void 0 : cards.map(function(card) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            key: card.id
        }, card.disabledTooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            className: "tooltip",
            for: card.id
        }, card.disabledTooltip) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _card.Card), {
            id: card.id,
            className: "CardContainer__Card ".concat(card === null || card === void 0 ? void 0 : card.className),
            description: (card === null || card === void 0 ? void 0 : card.description) || "",
            disabled: card === null || card === void 0 ? void 0 : card.disabled,
            footer: card === null || card === void 0 ? void 0 : card.footer,
            header: card === null || card === void 0 ? void 0 : card.header,
            kabobMenuOptions: card === null || card === void 0 ? void 0 : card.kabobMenuOptions,
            selectable: card === null || card === void 0 ? void 0 : card.selectable,
            style: card === null || card === void 0 ? void 0 : card.style,
            title: card.title,
            "data-testid": "card-".concat(card.id)
        }));
    }));
};

},{"react":"ktQNc","Permafrost/index":"iliLC","../Card/Card":"406kD","./CardContainer.styles":"hGrJ0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hGrJ0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCardContainer", function() {
    return StyledCardContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 16px;\n\n  .tooltip {\n    position: absolute;\n  }\n\n  .CardContainer__Card {\n    height: 100%;\n  }\n\n  .gallery-icon--base64ai,\n  .gallery-icon--huggingface-logo,\n  .gallery-icon--privateai-logo {\n    width: 100%;\n  }\n\n  .gallery-icon--img {\n    max-height: 60px;\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  @media ",
        " {\n    grid-template-columns: repeat(4, 1fr);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledCardContainer = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).largeScreen);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aNY4G":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", function() {
    return Checkbox;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _index = require("Permafrost/index");
var _checkboxStyles = require("./Checkbox.styles"); /**
                                                     * A single checkbox and its label.
                                                     */ 
function Checkbox(props) {
    var _props_checkmarkColor = props.checkmarkColor, checkmarkColor = _props_checkmarkColor === void 0 ? (0, _index.COLORS).black : _props_checkmarkColor, children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? (0, _index.COLORS).white : _props_color, id = props.id, isDisabled = props.isDisabled, _props_isLoading = props.isLoading, isLoading = _props_isLoading === void 0 ? false : _props_isLoading, _props_isSelected = props.isSelected, isSelected = _props_isSelected === void 0 ? false : _props_isSelected, _props_isInline = props.isInline, isInline = _props_isInline === void 0 ? false : _props_isInline, _props_onChange = props.onChange, onChange = _props_onChange === void 0 ? function() {} : _props_onChange;
    var inputRef = (0, _react.useRef)(null);
    var checkboxState = {
        isSelected: isSelected,
        setSelected: onChange,
        toggle: function() {
            return onChange(!isSelected);
        }
    };
    var inputProps = (0, _checkbox.useCheckbox)(props, checkboxState, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var checkboxMeasure = 18;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkboxStyles.StyledCheckbox), {
        "data-cy": props["data-cy"],
        "data-tip": props["data-tip"],
        "data-for": props["data-for"],
        className: (0, _classnamesDefault.default)({
            checked: isSelected,
            disabled: isDisabled || isLoading,
            inline: isInline
        }, className),
        id: id,
        "$color": color,
        "$checkmarkColor": checkmarkColor
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        type: "checkbox"
    }, inputProps, visuallyHiddenProps, focusProps, {
        ref: inputRef,
        disabled: isDisabled || isLoading
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        overflow: "visible",
        className: "checkbox"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: 1,
        y: 1,
        width: checkboxMeasure,
        height: checkboxMeasure,
        rx: 2,
        fill: "none",
        stroke: "currentColor",
        className: "checkboxSquare"
    }), isFocusVisible && /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: -2.5,
        y: -2.5,
        width: checkboxMeasure + 7,
        height: checkboxMeasure + 7,
        rx: 4,
        fill: "none",
        className: "focusRing"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(1, 1)"
    }, isSelected && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "check",
        className: "checkmark",
        size: [
            checkboxMeasure
        ]
    }))), children ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "checkbox__text"
    }, children) : null);
}

},{"react":"ktQNc","classnames":"9xS9S","@react-aria/checkbox":"aEPJn","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","Permafrost/index":"iliLC","./Checkbox.styles":"70u2z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"70u2z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCheckbox", function() {
    return StyledCheckbox;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  color: ",
        ";\n  display: flex;\n  position: relative;\n  width: fit-content;\n\n  &.disabled {\n    cursor: not-allowed;\n  }\n\n  &.inline {\n    display: inline-block;\n  }\n\n  &:not(.disabled) {\n    cursor: pointer;\n\n    &:hover,\n    &.checked .checkboxSquare {\n      color: ",
        ";\n    }\n  }\n\n  &.checked .checkboxSquare {\n    fill: ",
        ";\n  }\n\n  transition: color ",
        " ",
        ";\n\n  .checkbox {\n    width: ",
        ";\n    height: ",
        ";\n\n    margin-top: 2px;\n  }\n\n  .checkbox__text {\n    margin-left: ",
        ";\n  }\n  .checkboxSquare {\n    stroke-width: 2.5;\n  }\n\n  .checkmark {\n    color: ",
        ";\n    pointer-events: none;\n  }\n\n  .focusRing {\n    stroke: ",
        ";\n    stroke-width: 2;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var boxSize = "17px";
var StyledCheckbox = (0, _styledComponentsDefault.default).label(_templateObject(), function(props) {
    return props.$color;
}, function(props) {
    return props.$color;
}, function(props) {
    return props.$color;
}, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, boxSize, boxSize, (0, _index.SPACING).sm, function(props) {
    return props.$checkmarkColor;
}, (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"q3i4H":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", function() {
    return DatePicker;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dateFns = require("date-fns");
var _focusTrapReact = require("focus-trap-react");
var _focusTrapReactDefault = parcelHelpers.interopDefault(_focusTrapReact);
var _reactDayPicker = require("react-day-picker");
var _reactPopper = require("react-popper");
var _index = require("Permafrost/index");
var _datePickerStyles = require("./DatePicker.styles");
var DatePicker = function(props) {
    var ariaLabel = props.ariaLabel, className = props.className, disabled = props.disabled, disableBeforeDate = props.disableBeforeDate, disableAfterDate = props.disableAfterDate, id = props.id, label = props.label, onChange = props.onChange, placeholder = props.placeholder, value = props.value, selected = props.selected, _props_shouldShowDatePicker = props.shouldShowDatePicker, shouldShowDatePicker = _props_shouldShowDatePicker === void 0 ? true : _props_shouldShowDatePicker;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(selected || undefined), 2), localSelected = _useState[0], setLocalSelected = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(value) ? (0, _dateFns.format)(value, "y-MM-dd") : ""), 2), inputValue = _useState1[0], setInputValue = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPopperOpen = _useState2[0], setIsPopperOpen = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(null), 2), popperElement = _useState3[0], setPopperElement = _useState3[1];
    var popperRef = (0, _react.useRef)(null);
    var popper = (0, _reactPopper.usePopper)(popperRef.current, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        10
                    ]
                }
            }
        ]
    });
    var inputRef = (0, _react.useRef)(null);
    var closePopper = function() {
        setIsPopperOpen(false);
    }; // TODO -- After discussing with product, we determined handling invalid would happen at a later date.
    var handleInputChange = function(e) {
        setInputValue(e.currentTarget.value);
        var date = (0, _dateFns.parse)(e.currentTarget.value, "y-MM-dd", new Date());
        if ((0, _dateFns.isValid)(date)) {
            setLocalSelected(date);
            onChange(date);
        } else if (e.currentTarget.value === "") {
            setLocalSelected(undefined);
            setInputValue("");
            onChange(undefined);
        } else setLocalSelected(undefined);
    };
    var handleDaySelect = function(date) {
        setLocalSelected(date);
        if (date) {
            setInputValue((0, _dateFns.format)(date, "y-MM-dd"));
            onChange(date);
            closePopper();
        } else {
            setInputValue("");
            onChange(date);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerStyles.StyledDatePicker), {
        className: className,
        "aria-label": ariaLabel || "date select",
        "aria-describedby": "picker-label--".concat(id),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        id: id
    }, label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: "picker-label--".concat(id),
        className: "datepicker-label"
    }, label) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: popperRef,
        className: "datepicker--inputParent"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        ref: inputRef,
        "data-testid": "datepicker-input-".concat(id),
        disabled: disabled,
        type: "text",
        placeholder: placeholder || (0, _dateFns.format)(new Date(), "y-MM-dd"),
        value: inputValue,
        onChange: handleInputChange,
        className: "datepicker--input",
        onClick: function() {
            if (shouldShowDatePicker) setIsPopperOpen(!isPopperOpen);
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), {
        className: "remove-btn",
        "data-testid": "button-remove-date-value",
        iconName: "x-close",
        onPress: function() {
            closePopper();
            setInputValue("");
            setLocalSelected(undefined);
            onChange(undefined);
        }
    })), isPopperOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusTrapReactDefault.default), {
        active: true,
        focusTrapOptions: {
            initialFocus: false,
            allowOutsideClick: true,
            clickOutsideDeactivates: true,
            onDeactivate: closePopper,
            fallbackFocus: inputRef.current || undefined
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        tabIndex: -1,
        style: popper.styles.popper,
        className: "DayPickerInput-Overlay"
    }, popper.attributes.popper, {
        ref: setPopperElement,
        role: "dialog",
        "aria-label": "DayPicker calendar"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDayPicker.DayPicker), {
        disabled: disabled,
        mode: "single",
        defaultMonth: localSelected,
        selected: localSelected,
        onSelect: handleDaySelect,
        fromDate: disableBeforeDate,
        toDate: disableAfterDate
    }))));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","date-fns":"5C5dq","focus-trap-react":"2xNzg","react-day-picker":"iTJs9","react-popper":"k2Ltv","Permafrost/index":"iliLC","./DatePicker.styles":"9MDhW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9MDhW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDatePicker", function() {
    return StyledDatePicker;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  /************************************\n  *  Default react-day-picker styling - this needed to be added because we were unable to import styling as specified by the docs (most likely because we are not using webpack)\n  *************************************/\n\n  .rdp {\n    --rdp-cell-size: 40px;\n    --rdp-accent-color: #0000ff;\n    --rdp-background-color: #e7edff;\n    --rdp-accent-color-dark: #3003e1;\n    --rdp-background-color-dark: #180270;\n    --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */\n    --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */\n\n    margin: 1em;\n  }\n\n  /* Hide elements for devices that are not screen readers */\n  .rdp-vhidden {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    appearance: none;\n    position: absolute !important;\n    top: 0;\n    width: 1px !important;\n    height: 1px !important;\n    padding: 0 !important;\n    overflow: hidden !important;\n    clip: rect(1px, 1px, 1px, 1px) !important;\n    border: 0 !important;\n  }\n\n  /* Buttons */\n  .rdp-button_reset {\n    appearance: none;\n    position: relative;\n    margin: 0;\n    padding: 0;\n    cursor: default;\n    color: inherit;\n    background: none;\n    font: inherit;\n\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  .rdp-button_reset:focus-visible {\n    /* Make sure to reset outline only when :focus-visible is supported */\n    outline: none;\n  }\n\n  .rdp-button {\n    border: 2px solid transparent;\n  }\n\n  .rdp-button[disabled]:not(.rdp-day_selected) {\n    opacity: 0.25;\n  }\n\n  .rdp-button:not([disabled]) {\n    cursor: pointer;\n  }\n\n  .rdp-button:focus-visible:not([disabled]) {\n    color: inherit;\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n  }\n\n  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {\n    background-color: var(--rdp-background-color);\n  }\n\n  .rdp-months {\n    display: flex;\n  }\n\n  .rdp-month {\n    margin: 0 1em;\n  }\n\n  .rdp-month:first-child {\n    margin-left: 0;\n  }\n\n  .rdp-month:last-child {\n    margin-right: 0;\n  }\n\n  .rdp-table {\n    margin: 0;\n    max-width: calc(var(--rdp-cell-size) * 7);\n    border-collapse: collapse;\n  }\n\n  .rdp-with_weeknumber .rdp-table {\n    max-width: calc(var(--rdp-cell-size) * 8);\n    border-collapse: collapse;\n  }\n\n  .rdp-caption {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0;\n    text-align: left;\n  }\n\n  .rdp-multiple_months .rdp-caption {\n    position: relative;\n    display: block;\n    text-align: center;\n  }\n\n  .rdp-caption_dropdowns {\n    position: relative;\n    display: inline-flex;\n  }\n\n  .rdp-caption_label {\n    position: relative;\n    z-index: 1;\n    display: inline-flex;\n    align-items: center;\n    margin: 0;\n    padding: 0 0.25em;\n    white-space: nowrap;\n    color: currentColor;\n    border: 0;\n    border: 2px solid transparent;\n    font-family: inherit;\n    font-size: 140%;\n    font-weight: bold;\n  }\n\n  .rdp-nav {\n    white-space: nowrap;\n  }\n\n  .rdp-multiple_months .rdp-caption_start .rdp-nav {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  }\n\n  .rdp-multiple_months .rdp-caption_end .rdp-nav {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  }\n\n  .rdp-nav_button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    padding: 0.25em;\n    border-radius: 100%;\n  }\n\n  /* ---------- */\n  /* Dropdowns  */\n  /* ---------- */\n\n  .rdp-dropdown_year,\n  .rdp-dropdown_month {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  .rdp-dropdown {\n    appearance: none;\n    position: absolute;\n    z-index: 2;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    cursor: inherit;\n    opacity: 0;\n    border: none;\n    background-color: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n\n  .rdp-dropdown[disabled] {\n    opacity: unset;\n    color: unset;\n  }\n\n  .rdp-dropdown:focus-visible:not([disabled]) + .rdp-caption_label {\n    background-color: var(--rdp-background-color);\n    border: var(--rdp-outline);\n    border-radius: 6px;\n  }\n\n  .rdp-dropdown_icon {\n    margin: 0 0 0 5px;\n  }\n\n  .rdp-head {\n    border: 0;\n  }\n\n  .rdp-head_row,\n  .rdp-row {\n    height: 100%;\n  }\n\n  .rdp-head_cell {\n    vertical-align: middle;\n    font-size: 0.75em;\n    font-weight: 700;\n    text-align: center;\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n  }\n\n  .rdp-tbody {\n    border: 0;\n  }\n\n  .rdp-tfoot {\n    margin: 0.5em;\n  }\n\n  .rdp-cell {\n    width: var(--rdp-cell-size);\n    height: 100%;\n    height: var(--rdp-cell-size);\n    padding: 0;\n    text-align: center;\n  }\n\n  .rdp-weeknumber {\n    font-size: 0.75em;\n  }\n\n  .rdp-weeknumber,\n  .rdp-day {\n    display: flex;\n    overflow: hidden;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width: var(--rdp-cell-size);\n    max-width: var(--rdp-cell-size);\n    height: var(--rdp-cell-size);\n    margin: 0;\n    border: 2px solid transparent;\n    border-radius: 100%;\n  }\n\n  .rdp-day_today:not(.rdp-day_outside) {\n    font-weight: bold;\n  }\n\n  .rdp-day_selected,\n  .rdp-day_selected:focus-visible,\n  .rdp-day_selected:hover {\n    color: white;\n    opacity: 1;\n    background-color: var(--rdp-accent-color);\n  }\n\n  .rdp-day_outside {\n    opacity: 0.5;\n  }\n\n  .rdp-day_selected:focus-visible {\n    /* Since the background is the same use again the outline */\n    outline: var(--rdp-outline);\n    outline-offset: 2px;\n    z-index: 1;\n  }\n\n  .rdp:not([dir='rtl']) .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .rdp:not([dir='rtl']) .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rdp[dir='rtl'] .rdp-day_range_start:not(.rdp-day_range_end) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rdp[dir='rtl'] .rdp-day_range_end:not(.rdp-day_range_start) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .rdp-day_range_end.rdp-day_range_start {\n    border-radius: 100%;\n  }\n\n  .rdp-day_range_middle {\n    border-radius: 0;\n  }\n\n  /*# sourceMappingURL=style.css.map */\n\n  /******************************\n  *   Indico Custom Styling \n  *******************************/\n\n  .datepicker--inputParent {\n    position: relative;\n    width: 150px;\n  }\n\n  .datepicker-label {\n    padding: 10px 10px 10px 0;\n    color: ",
        ";\n    font-size: 14px;\n  }\n\n  .datepicker--input {\n    width: 150px;\n    border: solid ",
        " 1px;\n    border-radius: 4px;\n    text-align: center;\n    color: ",
        ";\n\n    &::placeholder {\n      opacity: 0.5;\n    }\n  }\n\n  .remove-btn {\n    position: absolute;\n    top: 0;\n    right: 0;\n  }\n\n  .remove-btn svg {\n    height: 8px;\n    margin-right: 10px;\n    width: 8px;\n  }\n\n  .remove-btn,\n  .remove-btn:hover,\n  .remove-btn:focus {\n    color: ",
        ";\n    background: transparent;\n    box-shadow: none;\n    font-size: 16px;\n    padding: 0 !important;\n  }\n\n  .DayPickerInput-Overlay {\n    background: ",
        ";\n    border-radius: 4px;\n    z-index: 999;\n    .rdp {\n      background: ",
        ";\n      z-index: 999;\n    }\n  }\n\n  .rdp-caption_label {\n    font-weight: 500;\n    font-size: 1.15em;\n  }\n\n  .rdp-button,\n  .rdp-day {\n    box-shadow: none;\n  }\n\n  .rdp-head_cell,\n  .rdp-cell {\n    border: none;\n  }\n\n  .rdp-head_cell {\n    color: ",
        ";\n  }\n\n  .rdp-day_today {\n    color: ",
        " !important;\n  }\n\n  //on hover font color\n  .rdp:not(.rdp-day_disabled)\n    .rdp-day:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_outside):hover {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n\n  .rdp-day_today:not(.rdp-day_disabled):not(.rdp-day_selected):not(.rdp-day_outside) {\n    color: ",
        " !important;\n  }\n\n  .rdp-day_selected:not(.rdp-day_disabled):not(.rdp-day_outside) {\n    position: relative;\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  .rdp-day_disabled:not(.rdp-day_today) {\n    opacity: 0.3;\n  }\n\n  .rdp-day_disabled {\n    background-color: inherit !important;\n    cursor: auto !important;\n  }\n\n  .rdp-day_disabled:hover {\n    color: inherit !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDatePicker = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).baliHai, (0, _index.COLORS).white, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).mediumGray, (0, _index.COLORS).ebony, (0, _index.COLORS).mirage, (0, _index.COLORS).white, (0, _index.COLORS).red, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4LkT8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateRangePicker", function() {
    return DateRangePicker;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _focusTrapReact = require("focus-trap-react");
var _focusTrapReactDefault = parcelHelpers.interopDefault(_focusTrapReact);
var _reactPopper = require("react-popper");
var _dateFns = require("date-fns");
var _reactDayPicker = require("react-day-picker");
var _dateRangePickerStyles = require("./DateRangePicker.styles");
var _datePickerStyles = require("../DatePicker/DatePicker.styles");
var DateRangePicker = function(props) {
    var dataCy = props.dataCy, id = props.id, className = props.className, disabled = props.disabled, label = props.label, fromOnChange = props.fromOnChange, toOnChange = props.toOnChange, fromValue = props.fromValue, toValue = props.toValue, fromPlaceholder = props.fromPlaceholder, toPlaceholder = props.toPlaceholder, vertical = props.vertical, disableBeforeDate = props.disableBeforeDate, disableAfterDate = props.disableAfterDate, defaultSelected = props.defaultSelected, minRange = props.minRange, maxRange = props.maxRange;
    var initSelectedRange = function() {
        if (fromValue || toValue) return {
            from: (0, _dateFns.isValid)(fromValue) ? fromValue : undefined,
            to: (0, _dateFns.isValid)(toValue) ? toValue : undefined
        };
        return {
            from: (0, _dateFns.isValid)(defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.from) ? defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.from : undefined,
            to: (0, _dateFns.isValid)(defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.to) ? defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.to : undefined
        };
    };
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initSelectedRange()), 2), selectedRange = _useState[0], setSelectedRange = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(fromValue) ? (0, _dateFns.format)(fromValue, "y-MM-dd") : ""), 2), fromInputValue = _useState1[0], setFromInputValue = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)((0, _dateFns.isValid)(toValue) ? (0, _dateFns.format)(toValue, "y-MM-dd") : ""), 2), toInputValue = _useState2[0], setToInputValue = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isPopperOpen = _useState3[0], setIsPopperOpen = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(null), 2), popperElement = _useState4[0], setPopperElement = _useState4[1];
    var popperRef = (0, _react.useRef)(null);
    var popper = (0, _reactPopper.usePopper)(popperRef.current, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        10
                    ]
                }
            }
        ]
    });
    (0, _react.useEffect)(function() {
        // todo: this is problematic because it means on mount the onChange handler will always be fired
        // therefore - if the onChange is some heavy operation or call to the BE - that will automatically get called
        // without the user even doing anything
        fromOnChange(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from);
        toOnChange(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to);
    }, [
        selectedRange
    ]);
    var closePopper = function() {
        setIsPopperOpen(false);
    };
    var handleFromChange = function(e) {
        setFromInputValue(e.target.value);
        var date = (0, _dateFns.parse)(e.target.value, "y-MM-dd", new Date());
        if (!(0, _dateFns.isValid)(date)) return setSelectedRange({
            from: undefined,
            to: undefined
        });
        if ((selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to) && (0, _dateFns.isAfter)(date, selectedRange.to)) setSelectedRange({
            from: selectedRange.to,
            to: date
        });
        else setSelectedRange({
            from: date,
            to: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.to
        });
    };
    var handleToChange = function(e) {
        setToInputValue(e.target.value);
        var date = (0, _dateFns.parse)(e.target.value, "y-MM-dd", new Date());
        if (!(0, _dateFns.isValid)(date)) return setSelectedRange({
            from: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from,
            to: undefined
        });
        if ((selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from) && (0, _dateFns.isBefore)(date, selectedRange.from)) setSelectedRange({
            from: date,
            to: selectedRange.from
        });
        else setSelectedRange({
            from: selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.from,
            to: date
        });
    };
    var handleRangeSelect = function(range) {
        setSelectedRange(range);
        if (range === null || range === void 0 ? void 0 : range.from) setFromInputValue((0, _dateFns.format)(range.from, "y-MM-dd"));
        else setFromInputValue("");
        if (range === null || range === void 0 ? void 0 : range.to) {
            setToInputValue((0, _dateFns.format)(range.to, "y-MM-dd"));
            closePopper();
        } else setToInputValue("");
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dateRangePickerStyles.StyledDateRangePicker), {
        id: id,
        className: className,
        "data-cy": dataCy
    }, label ? /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: "datepicker-label",
        htmlFor: "date-range-picker-inputs--".concat(id)
    }, label) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _datePickerStyles.StyledDatePicker), {
        className: (0, _classnamesDefault.default)({
            vertical: vertical
        }),
        ref: popperRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("form", {
        id: "date-range-picker-inputs--".concat(id),
        className: "date-range-picker-inputs",
        onClick: function() {
            return disabled ? null : setIsPopperOpen(!isPopperOpen);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        disabled: disabled,
        size: 10,
        placeholder: fromPlaceholder || "From Date",
        value: fromInputValue,
        onChange: handleFromChange,
        className: "datepicker--input"
    }), !vertical ? /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", {
        className: "spacer"
    }) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        disabled: disabled,
        size: 10,
        placeholder: toPlaceholder || "To Date",
        value: toInputValue,
        onChange: handleToChange,
        className: "datepicker--input"
    })), isPopperOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusTrapReactDefault.default), {
        active: true,
        focusTrapOptions: {
            initialFocus: false,
            allowOutsideClick: true,
            clickOutsideDeactivates: true,
            onDeactivate: closePopper
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        tabIndex: -1,
        style: popper.styles.popper,
        className: "DayPickerInput-Overlay"
    }, popper.attributes.popper, {
        ref: setPopperElement,
        role: "dialog"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDayPicker.DayPicker), {
        disabled: disabled,
        mode: "range",
        selected: selectedRange,
        onSelect: handleRangeSelect,
        fromDate: disableBeforeDate,
        toDate: disableAfterDate,
        min: minRange,
        max: maxRange
    })))));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","focus-trap-react":"2xNzg","react-popper":"k2Ltv","date-fns":"5C5dq","react-day-picker":"iTJs9","./DateRangePicker.styles":"dbK9x","../DatePicker/DatePicker.styles":"9MDhW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dbK9x":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDateRangePicker", function() {
    return StyledDateRangePicker;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  label {\n    padding: 10px 10px 10px 0;\n    color: ",
        ";\n    font-size: 14px;\n  }\n\n  .date-range-picker-inputs {\n    display: flex;\n\n    &.vertical {\n      &,\n      .from-picker,\n      .to-picker {\n        flex-direction: column;\n      }\n    }\n\n    .spacer {\n      position: relative;\n      bottom: 5px;\n      width: 12px;\n      margin: 10px;\n      align-self: center;\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n\n  .DayPicker-Day--selected {\n    border-radius: 0;\n    opacity: 0.3;\n  }\n\n  .from-picker .DayPicker-Day--from,\n  .to-picker .DayPicker-Day--to {\n    opacity: 1;\n  }\n\n  .from-picker .DayPicker-Day--to,\n  .to-picker .DayPicker-Day--from {\n    opacity: 0.6;\n  }\n\n  .to-picker .DayPicker-Day--from,\n  .from-picker .DayPicker-Day--from {\n    border-top-left-radius: 50%;\n    border-bottom-left-radius: 50%;\n  }\n\n  .from-picker .DayPicker-Day--to,\n  .to-picker .DayPicker-Day--to {\n    border-top-right-radius: 50%;\n    border-bottom-right-radius: 50%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDateRangePicker = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).lightGray);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hQNZ7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KabobMenu", function() {
    return KabobMenu;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _kabobMenuStyles = require("./KabobMenu.styles");
var KabobMenu = function(param) {
    var id = param.id, className = param.className, disabled = param.disabled, _param_leftAligned = param.leftAligned, leftAligned = _param_leftAligned === void 0 ? false : _param_leftAligned, menuOptions = param.menuOptions;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var menuRef = (0, _react.useRef)(null);
    var iconButtonRef = (0, _react.useRef)(null); // Close the menu when clicking outside of the menu or outside of the kabob icon button
    (0, _react.useEffect)(function() {
        var listener = function(e) {
            if (!menuRef.current || !iconButtonRef.current || menuRef.current.contains(e.target) || iconButtonRef.current.contains(e.target)) return;
            setIsOpen(false);
        };
        document.addEventListener("click", listener);
        return function() {
            document.removeEventListener("click", listener);
        };
    }, [
        menuRef,
        iconButtonRef
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _kabobMenuStyles.StyledKabobMenu), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            "left-aligned": leftAligned
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), {
        className: (0, _classnamesDefault.default)("KabobMenu--kabob-btn", {
            "no-background": !isOpen
        }),
        isDisabled: disabled,
        iconName: "kabob",
        label: "",
        onPress: function() {
            return setIsOpen(!isOpen);
        },
        "data-testid": "icon-button--kabob-menu",
        ref: iconButtonRef
    }), isOpen ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "KabobMenu--menu",
        ref: menuRef
    }, menuOptions.map(function(option) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: (0, _classnamesDefault.default)("menu-item", {
                disabled: option.disabled
            }),
            "data-tip": true,
            "data-for": option.id,
            key: option.id,
            "data-testid": "kabob-menu-item--".concat(option.id)
        }, option.iconName ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), {
            className: "menu-item-btn",
            isDisabled: option.disabled,
            iconName: option.iconName,
            label: option.label,
            onPress: function() {
                option.onClick();
                setIsOpen(false);
            }
        }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
            className: "menu-item-btn",
            disabled: option.disabled,
            onClick: function() {
                option.onClick();
                setIsOpen(false);
            }
        }, option.label), option.disabledText && option.disabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            for: option.id,
            questionMark: false
        }, option.disabledText) : null);
    })) : null);
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./KabobMenu.styles":"7h928","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7h928":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledKabobMenu", function() {
    return StyledKabobMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  margin-top: 5px;\n  position: relative;\n  z-index: 3;\n\n  .KabobMenu--kabob-btn {\n    box-shadow: none;\n    padding: 0 8px !important;\n    margin-bottom: 5px;\n\n    svg {\n      height: 20px;\n      margin: 0;\n      width: 20px;\n    }\n\n    &.no-background {\n      background: transparent !important;\n    }\n  }\n\n  .KabobMenu--menu {\n    border-radius: 2px;\n    display: inline-block;\n    min-width: 150px;\n    position: absolute;\n    top: 40px;\n    z-index: 4;\n\n    .menu-item {\n      height: 36px;\n\n      .menu-item-btn,\n      .menu-item-btn:disabled {\n        background: transparent !important;\n        box-shadow: none;\n        color: ",
        ";\n        margin: 0;\n        width: 100%;\n      }\n\n      &:first-child {\n        border-radius: 2px 2px 0 0;\n      }\n\n      &:last-child {\n        border-radius: 0 0 2px 2px;\n      }\n\n      .menu-item-btn:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .KabobMenu--kabob-btn,\n  .KabobMenu--kabob-btn:focus,\n  .KabobMenu--menu,\n  .KabobMenu--menu .menu-item.disabled {\n    background: ",
        ";\n    color: ",
        ";\n  }\n\n  .KabobMenu--kabob-btn:hover,\n  .KabobMenu--menu .menu-item:hover {\n    background: ",
        ";\n  }\n\n  &.left-aligned {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledKabobMenu = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).white, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).white, (0, _index.COLORS).comet);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ioQYm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuButton", function() {
    return MenuButton;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _keycodeJs = require("keycode-js");
var _index = require("Permafrost/index");
var _menuButtonStyles = require("./MenuButton.styles"); /**
                                                                                   * Technically a Menu and Menu Button, this component offers a list
                                                                                   * of actions for the user to choose from.
                                                                                   *
                                                                                   * This component should not be used for navigation.
                                                                                   *
                                                                                   * https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton
                                                                                   */ 
function MenuButton(props) {
    var className = props.className, disabled = props.disabled, id = props.id, open = props.open, options = props.options, processing = props.processing, _props_size = props.size, size = _props_size === void 0 ? "normal" : _props_size, title = props.title;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(open || false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var buttonEl = (0, _react.useRef)(null);
    var menuEl = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var menuItems;
        var handleKeyPress = function(ev) {
            if (!menuItems) return null;
            var activeElement = document.activeElement;
            var firstItem = menuItems[0];
            var lastItem = menuItems[menuItems.length - 1];
            var nextSibling = activeElement.nextElementSibling;
            var previousSibling = activeElement.previousElementSibling; // up and down arrow keys will cycle through the different options
            if (ev.key === _keycodeJs.VALUE_DOWN) {
                if (activeElement !== lastItem) nextSibling.focus();
                else firstItem.focus();
            } else if (ev.key === _keycodeJs.VALUE_UP) {
                if (activeElement !== firstItem) previousSibling.focus();
                else lastItem.focus();
            }
            if (ev.key === _keycodeJs.VALUE_ESCAPE) closeMenu();
        };
        // once the menu opens, any click should close it
        var handleMenuOpenClick = function() {
            closeMenu();
        };
        if (isOpen) {
            // add click event listener after the current event loop completes to avoid closing the menu immediately
            setTimeout(function() {
                window.addEventListener("click", handleMenuOpenClick);
            }, 0);
            window.addEventListener("keydown", handleKeyPress);
            if (menuEl.current) {
                menuItems = menuEl.current.querySelectorAll("button");
                menuItems[0].focus();
            }
        }
        return function() {
            var _a;
            window.removeEventListener("keydown", handleKeyPress);
            window.removeEventListener("click", handleMenuOpenClick);
            (_a = buttonEl.current) === null || _a === void 0 || _a.focus();
        };
    }, [
        isOpen
    ]);
    var openMenu = function() {
        setIsOpen(true);
    };
    var closeMenu = function() {
        setIsOpen(false);
    };
    var toggleMenu = function() {
        isOpen ? closeMenu() : openMenu();
    };
    var handleOptionClick = function(option) {
        props.handleSelection(option);
    };
    var processingText = typeof processing === "string" ? processing : "Processing";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuButtonStyles.StyledMenuButton), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuButtonStyles.StyledButton), {
        ref: buttonEl,
        type: "button",
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        className: (0, _classnamesDefault.default)(processing, size),
        disabled: disabled,
        onClick: toggleMenu
    }, processing && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), null), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-cy": "menuTitleSpan",
        className: "menuButtonTitle",
        "aria-live": "polite"
    }, !!processing ? processingText : title), !processing && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "caret"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-caret-down",
        size: [
            "1.2em"
        ]
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _menuButtonStyles.StyledMenu), {
        ref: menuEl,
        role: "menu",
        className: isOpen ? "open" : ""
    }, options.map(function(option) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
            "data-cy": "menuItemBtn",
            key: option.value,
            type: "button",
            role: "menuitem",
            tabIndex: -1,
            onClick: function() {
                return handleOptionClick(option.value);
            }
        }, option.text);
    })));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","keycode-js":"hBBfN","Permafrost/index":"iliLC","./MenuButton.styles":"euMLZ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"euMLZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMenuButton", function() {
    return StyledMenuButton;
});
parcelHelpers.export(exports, "StyledButton", function() {
    return StyledButton;
});
parcelHelpers.export(exports, "StyledMenu", function() {
    return StyledMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _commonStyles = require("Permafrost/components/ui-foundations/buttons/commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  position: relative;\n\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n  ",
        ";\n\n  padding: 0 !important;\n  margin-bottom: 0;\n\n  &.large {\n    --caret-size: ",
        ";\n\n    ",
        ";\n  }\n\n  &.normal {\n    --caret-size: ",
        ";\n  }\n\n  // adds addt'l specificity; without, the global button styles overrule this styling...\n  &[aria-haspopup='true'] {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    display: flex;\n    align-items: center;\n\n    .menuButtonTitle {\n      padding-left: 1em;\n      padding-right: 1.9em;\n    }\n\n    .caret {\n      width: var(--caret-size);\n      height: var(--caret-size);\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: rgba(255, 255, 255, 0);\n\n      transition: background-color ",
        " ",
        ";\n    }\n\n    svg[class='spin'] {\n      margin-top: -2px;\n      height: 1em;\n      width: 1em;\n    }\n\n    // necessary to override default button styling\n    &:hover,\n    &:focus {\n      color: ",
        ";\n      background-color: ",
        ";\n    }\n\n    &:not([disabled]):hover,\n    &[aria-expanded='true'] {\n      .caret {\n        background-color: rgba(255, 255, 255, 0.25);\n      }\n    }\n\n    &.processing {\n      color: ",
        ";\n      cursor: wait;\n      padding-left: calc(",
        " - 2px);\n\n      .menuButtonTitle {\n        padding-left: 0.75em;\n        padding-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: absolute;\n  width: 100%;\n\n  display: none;\n  flex-direction: column;\n\n  margin-top: 2px;\n\n  button {\n    border-radius: 0;\n    box-shadow: none;\n\n    margin-bottom: 1px;\n\n    // dark-on-light text looks thinner than light-on-dark; removing\n    // smoothing for that former case gives a more consistent appearance.\n    -webkit-font-smoothing: initial;\n    -moz-osx-font-smoothing: auto;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:first-of-type {\n      border-top-left-radius: 2px;\n      border-top-right-radius: 2px;\n    }\n\n    &:last-of-type {\n      border-bottom-left-radius: 2px;\n      border-bottom-right-radius: 2px;\n    }\n  }\n\n  &.open {\n    display: flex;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var commonPadding = "3.5em";
var StyledMenuButton = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledButton = (0, _styledComponentsDefault.default).button(_templateObject1(), (0, _commonStyles.defaults), (0, _commonStyles.variantPrimary), (0, _commonStyles.largeHeight), (0, _commonStyles.sizeLarge), (0, _commonStyles.defaultHeight), (0, _index.COLORS).curiousBlue, (0, _index.COLORS).white, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).white, (0, _index.COLORS).curiousBlue, (0, _index.COLORS).iron, commonPadding, commonPadding);
var StyledMenu = (0, _styledComponentsDefault.default).div(_templateObject2());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","Permafrost/components/ui-foundations/buttons/commonStyles":"eg1Ne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kLpCO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroup", function() {
    return 0, _pillCheckGroup.PillCheckGroup;
});
var _pillCheckGroup = require("./PillCheckGroup");

},{"./PillCheckGroup":"7CnWs","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7CnWs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders a group of 'pill checkboxes'.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "PillCheckGroup", function() {
    return PillCheckGroup;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pillCheckGroupBase = require("../PillCheckGroupBase");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function PillCheckGroup(props) {
    var ariaLabel = props.ariaLabel, enforceSingleValue = props.enforceSingleValue, disableGroup = props.disableGroup, label = props.label, onChangeHandler = props.onChangeHandler, pills = props.pills, values = props.values, verticalOrientation = props.verticalOrientation;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pillCheckGroupBase.PillCheckGroupBase), {
        "aria-label": ariaLabel,
        className: "PillCheckGroup",
        enforceSingleValue: enforceSingleValue,
        "data-testid": props["data-testid"],
        disableGroup: disableGroup,
        label: label,
        values: values,
        onChange: function(incomingValues) {
            return onChangeHandler(incomingValues);
        },
        verticalOrientation: verticalOrientation
    }, pills.map(function(pill) {
        var id = pill.id, pillText = pill.pillText, value = pill.value, rest = __rest(pill, [
            "id",
            "pillText",
            "value"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pillCheckGroupBase.Pill), Object.assign({
            id: id,
            key: id,
            "data-cy": pill["data-cy"],
            "data-testid": pill["data-testid"],
            isSelected: values.includes(value),
            value: value
        }, rest), pillText);
    }));
}

},{"react":"ktQNc","../PillCheckGroupBase":"7JWyj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7JWyj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroupBase", function() {
    return 0, _pillCheckGroupBase.PillCheckGroupBase;
});
parcelHelpers.export(exports, "Pill", function() {
    return 0, _pillCheckGroupBase.Pill;
});
var _pillCheckGroupBase = require("./PillCheckGroupBase");

},{"./PillCheckGroupBase":"f6grq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f6grq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PillCheckGroupContext", function() {
    return PillCheckGroupContext;
});
parcelHelpers.export(exports, "PillCheckGroupBase", function() {
    return PillCheckGroupBase;
});
parcelHelpers.export(exports, "Pill", function() {
    return Pill;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _checkbox = require("@react-aria/checkbox");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _index = require("Permafrost/index");
var _pillCheckGroupBaseStyles = require("./PillCheckGroupBase.styles");
var _pillStyles = require("./Pill.styles");
var _reactStately = require("react-stately");
var PillCheckGroupContext = /*#__PURE__*/ (0, _react.createContext)({}); /**
                                                         * Renders a group of 'pill checkboxes'.
                                                         *
                                                         * A group label must be included: either pass a string or markup into the
                                                         * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
                                                         */ 
function PillCheckGroupBase(props) {
    var id = props.id, children = props.children, className = props.className, _props_disableGroup = props.disableGroup, disableGroup = _props_disableGroup === void 0 ? false : _props_disableGroup, _props_isReadOnly = props.isReadOnly, isReadOnly = _props_isReadOnly === void 0 ? false : _props_isReadOnly, label = props.label, _props_enforceSingleValue = props.enforceSingleValue, enforceSingleValue = _props_enforceSingleValue === void 0 ? false : _props_enforceSingleValue, onChange = props.onChange, verticalOrientation = props.verticalOrientation, values = props.values;
    var checkboxGroupProps = {
        value: values,
        isDisabled: disableGroup,
        isReadOnly: isReadOnly,
        onChange: function(newValue) {
            if (isReadOnly || disableGroup) return;
            if (enforceSingleValue && newValue.length > 1) onChange([
                newValue[newValue.length - 1]
            ]);
            else onChange(newValue);
        }
    };
    var state = (0, _reactStately.useCheckboxGroupState)(checkboxGroupProps);
    var _useCheckboxGroup = (0, _checkbox.useCheckboxGroup)(props, state), groupProps = _useCheckboxGroup.groupProps, labelProps = _useCheckboxGroup.labelProps;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pillCheckGroupBaseStyles.StyledPillCheckGroupBase), Object.assign({
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            "PillCheckGroupBase--horizontal": verticalOrientation !== true,
            "PillCheckGroupBase--disabled": disableGroup
        }),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"]
    }, groupProps), label && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        className: "PillCheckGroup__group-label"
    }, labelProps), label), /*#__PURE__*/ (0, _reactDefault.default).createElement(PillCheckGroupContext.Provider, {
        value: state
    }, children));
}
function Pill(props) {
    var id = props.id, caption = props.caption, captionColor = props.captionColor, children = props.children, className = props.className, fixedWidth = props.fixedWidth, _props_isDisabled = props.isDisabled, isDisabled = _props_isDisabled === void 0 ? false : _props_isDisabled, isSelected = props.isSelected, pillTextColor = props.pillTextColor, tooltip = props.tooltip, _props_iconName = props.iconName, iconName = _props_iconName === void 0 ? "check-circle" : _props_iconName, _props_iconColor = props.iconColor, iconColor = _props_iconColor === void 0 ? (0, _index.COLORS).fieldPromptInfo : _props_iconColor;
    var state = (0, _reactDefault.default).useContext(PillCheckGroupContext);
    var inputRef = (0, _react.useRef)(null);
    var inputProps = (0, _checkbox.useCheckboxGroupItem)(props, state, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var checkMeasure = 12;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pillStyles.StyledPill), {
        id: id,
        "$captionColor": captionColor || "inherit",
        className: (0, _classnamesDefault.default)({
            "Pill__label--checked": isSelected,
            isDisabled: isDisabled
        }, className),
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        "data-for": id,
        "data-tip": true,
        "$fixedWidth": fixedWidth,
        "$pillTextColor": pillTextColor || "inherit"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        ref: inputRef,
        type: "checkbox"
    }, focusProps, inputProps, visuallyHiddenProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _classnamesDefault.default)(className, {
            "Pill__pill-ellipse--focusRing": isFocusVisible === true,
            "Pill__pill-ellipse--selected": isSelected === true
        }, "pill-ellipse")
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "pill-text"
    }, children), isSelected && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: iconName,
        className: "pill-icon",
        size: [
            checkMeasure
        ],
        fill: iconColor
    })), caption && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "caption"
    }, caption), tooltip ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        for: id
    }, tooltip) : null);
}

},{"react":"ktQNc","classnames":"9xS9S","@react-aria/checkbox":"aEPJn","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","Permafrost/index":"iliLC","./PillCheckGroupBase.styles":"e7TzC","./Pill.styles":"aChz6","react-stately":"l7DHI","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e7TzC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPillCheckGroupBase", function() {
    return StyledPillCheckGroupBase;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .PillCheckGroup__group-label {\n    flex: 0 0 100%;\n    margin-bottom: ",
        ";\n  }\n\n  > * {\n    margin-right: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  &.PillCheckGroupBase--horizontal {\n    display: flex;\n    flex-wrap: wrap;\n\n    .caption {\n      display: none;\n    }\n  }\n\n  &:not(.PillCheckGroupBase--disabled) label {\n    cursor: pointer;\n\n    &:hover,\n    &.Pill__label--checked .pill-ellipse {\n      color: currentColor;\n    }\n  }\n\n  &.PillCheckGroupBase--disabled label {\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPillCheckGroupBase = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.SPACING).sm, (0, _index.SPACING).sm, (0, _index.SPACING).sm);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aChz6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPill", function() {
    return StyledPill;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  position: relative;\n  transition: color ",
        " ",
        ";\n\n  .caption {\n    color: ",
        ";\n    margin-left: ",
        ";\n  }\n\n  .pill-ellipse {\n    align-items: center;\n    border: 1px solid ",
        ";\n    border-radius: 2em;\n    display: flex;\n    justify-content: center;\n    margin-top: 2px;\n    padding: 0.4em 0.8em 0.5em;\n    position: relative;\n    width: ",
        ";\n\n    .pill-text {\n      color: ",
        ";\n      ",
        ";\n    }\n\n    &.Pill__pill-ellipse--selected {\n      border: 2px solid ",
        ";\n      margin-top: 1px;\n      margin-bottom: -1px;\n    }\n\n    &.Pill__pill-ellipse--focusRing {\n      outline: 2px solid ",
        ";\n      outline-offset: 5px;\n    }\n  }\n\n  .pill-icon {\n    pointer-events: none;\n    ",
        ";\n  }\n\n  &.isDisabled {\n    cursor: not-allowed !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPill = (0, _styledComponentsDefault.default).label(_templateObject(), (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, function(props) {
    return props.$captionColor;
}, (0, _index.SPACING).sm, (0, _index.COLORS).mediumGray, function(props) {
    return props.$fixedWidth ? "".concat(props.$fixedWidth, "px") : "auto";
}, function(props) {
    return props.$pillTextColor;
}, function(props) {
    return props.$fixedWidth ? " \n        flex:1;\n        display: flex;\n        justify-content: center;" : "";
}, (0, _index.COLORS).fieldPromptInfo, (0, _index.COLORS).curiousBlue, function(props) {
    return props.$fixedWidth ? " \n          position: absolute; \n          right: 0.8em;\n        }" : "margin-left: 0.8em; ";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"i89pr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledToggle", function() {
    return StyledToggle;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: inline-block;\n  width: 28px;\n  height: 18px;\n  border: 2px solid ",
        ";\n  border-radius: 34px;\n  margin-bottom: 0;\n  cursor: pointer;\n\n  & input {\n    display: none;\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }\n\n  .slider {\n    position: absolute;\n    top: 0;\n    left: -1px;\n    right: 0;\n    bottom: 0;\n    transition: 0.4s;\n    border-radius: 34px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: '';\n    height: 17px;\n    width: 17px;\n    left: -1px;\n    bottom: -1px;\n    background-color: ",
        ";\n    transition: 0.4s;\n    border: 2px solid ",
        ";\n    border-radius: 50%;\n  }\n\n  input:checked + .slider {\n    background-color: ",
        ";\n    width: 100%;\n  }\n\n  input:checked + .slider:before {\n    transform: translateX(12px);\n  }\n\n  p {\n    position: relative;\n    left: 35px;\n    bottom: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledToggle = (0, _styledComponentsDefault.default).label(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aE1RJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toggle", function() {
    return Toggle;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _toggleStyles = require("./Toggle.styles"); // todo: convert to ts; resolve a11y concerns (e.g.g display: none)
var Toggle = function(props) {
    var className = props.className, disabled = props.disabled, id = props.id, onChange = props.onChange, value = props.value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toggleStyles.StyledToggle), {
        className: (0, _classnamesDefault.default)(className, {
            disabled: disabled
        }),
        "data-cy": props["data-cy"],
        "data-for": props["data-for"],
        "data-tip": props["data-tip"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        "aria-label": props["aria-label"],
        type: "checkbox",
        disabled: disabled,
        checked: value,
        onChange: onChange
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "slider round"
    }));
};

},{"react":"ktQNc","classnames":"9xS9S","./Toggle.styles":"i89pr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dxu7u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tag", function() {
    return Tag;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _tagStyles = require("./Tag.styles");
var Tag = function(props) {
    var disabled = props.disabled, selected = props.selected, value = props.value, onClick = props.onClick, onRemove = props.onRemove;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tagStyles.StyledTag), {
        className: (0, _classnamesDefault.default)("Tag--container", {
            selected: selected
        }),
        "data-testid": props["data-testid"]
    }, onClick ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "value-select",
        onClick: onClick
    }, value) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, value), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), {
        isDisabled: disabled,
        className: "remove-btn",
        iconName: "x-close",
        onPress: onRemove
    }));
};

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Tag.styles":"9aDXQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9aDXQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTag", function() {
    return StyledTag;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  display: inline-flex;\n  padding: 0 10px;\n\n  &.selected {\n    background: ",
        ";\n  }\n\n  &,\n  .value-select,\n  .remove-btn,\n  .value-select:hover,\n  .remove-btn:hover,\n  .value-select:focus,\n  .remove-btn:focus {\n    color: ",
        ";\n    background: transparent;\n    box-shadow: none;\n    font-size: 16px;\n  }\n\n  .value-select,\n  .remove-btn {\n    padding: 0 !important;\n  }\n\n  .remove-btn svg {\n    height: 12px;\n    margin-left: 15px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTag = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3HvRX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidationText", function() {
    return ValidationText;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _validationTextStyles = require("./ValidationText.styles"); /**
                                                                 * Minimal utility component designed to display text related to field validation, to act as a
                                                                 * helper prompt or an error message for a form control or fieldset. Optionally accepts an `id` to
                                                                 * allow this element to act as a description for a control using the `aria-describedby` attribute.
                                                                 *
                                                                 * @see {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-describedby_attribute}
                                                                 */ 
function ValidationText(props) {
    var className = props.className, id = props.id, isError = props.isError, message = props.message;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _validationTextStyles.StyledValidationText), {
        id: id,
        className: (0, _classnamesDefault.default)(className, {
            error: isError,
            prompt: !isError
        }),
        "data-cy": props["data-cy"],
        "data-testid": "validation-text"
    }, message);
}

},{"react":"ktQNc","classnames":"9xS9S","./ValidationText.styles":"5Y4zY","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Y4zY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledValidationText", function() {
    return StyledValidationText;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 17px;\n  margin-top: 10px;\n  font-size: ",
        ";\n\n  &.prompt {\n    color: ",
        ";\n  }\n\n  &.error {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledValidationText = (0, _styledComponentsDefault.default).p(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).fieldPromptInfo, (0, _index.COLORS).fieldPromptError);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bulCm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BarSpinner", function() {
    return BarSpinner;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _barSpinnerStyles = require("./BarSpinner.styles");
function BarSpinner(props) {
    var className = props.className, id = props.id, _props_width = props.width, width = _props_width === void 0 ? "100%" : _props_width;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _barSpinnerStyles.StyledBarSpinner), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: {
            width: width
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null));
}

},{"react":"ktQNc","./BarSpinner.styles":"f2aik","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"f2aik":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBarSpinner", function() {
    return StyledBarSpinner;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(46px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n  width: 200px;\n  height: 14px; /* Can be anything */\n  position: relative;\n  border-radius: 25px;\n\n  > span {\n    display: block;\n    height: 100%;\n    width: 100%;\n    border-radius: 25px;\n    position: relative;\n    overflow: hidden;\n    background-color: ",
        ";\n\n    &:after {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -46px;\n      bottom: 0;\n      right: 0;\n      background: repeating-linear-gradient(\n        -55deg,\n        transparent 1px,\n        rgba(255, 255, 255, 0.25) 2px,\n        rgba(255, 255, 255, 0.25) 11px,\n        transparent 12px,\n        transparent 20px\n      );\n      animation-name: ",
        ";\n      animation-duration: 1s;\n      animation-timing-function: linear;\n      animation-iteration-count: infinite;\n      border-radius: 20px;\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var moveBg = (0, _styledComponents.keyframes)(_templateObject());
var StyledBarSpinner = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).curiousBlue, moveBg);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7pZ91":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingIndicator", function() {
    return LoadingIndicator;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _loadingIndicatorStyles = require("./LoadingIndicator.styles");
function LoadingIndicator(props) {
    var className = props.className, color = props.color, id = props.id, _props_overallSize = props.overallSize, overallSize = _props_overallSize === void 0 ? "200px" : _props_overallSize, _props_rippleSize = props.rippleSize, rippleSize = _props_rippleSize === void 0 ? "76px" : _props_rippleSize, fixedMessage = props.fixedMessage, showRandomMessage = props.showRandomMessage;
    var loadingIndicator = function() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingIndicatorStyles.StyledLoadingIndicator), {
            "aria-hidden": true,
            className: className,
            "data-cy": props["data-cy"],
            id: id,
            "$overallSize": returnSizeString(overallSize),
            "$rippleSize": returnSizeString(rippleSize),
            style: color ? {
                color: color
            } : {
                color: (0, _index.COLORS).curiousBlue
            }
        });
    };
    var renderMessage = function() {
        if (fixedMessage) return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "message"
        }, fixedMessage);
        if (showRandomMessage) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.RandomLoadingMessage), null);
        return null;
    };
    if (fixedMessage || showRandomMessage) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingIndicatorStyles.StyledMessageLoadingIndicator), {
        "$overallSize": returnSizeString(overallSize)
    }, loadingIndicator(), renderMessage());
    return loadingIndicator();
}
function returnSizeString(size) {
    if (typeof size === "number") return "".concat(size, "px");
    return size;
}

},{"react":"ktQNc","Permafrost/index":"iliLC","./LoadingIndicator.styles":"4eZjV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4eZjV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLoadingIndicator", function() {
    return StyledLoadingIndicator;
});
parcelHelpers.export(exports, "StyledMessageLoadingIndicator", function() {
    return StyledMessageLoadingIndicator;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    width: 0;\n    height: 0;\n    opacity: 0;\n  }\n  \n  20% {\n    opacity: 1;\n  }\n  \n  100% {\n    width: ",
        ";\n    height: ",
        ";\n    opacity: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: grid;\n  place-items: center;\n\n  width: ",
        ";\n  height: ",
        ";\n\n  margin-left: auto;\n  margin-right: auto;\n\n  &:before,\n  &:after {\n    content: '';\n    border: 4px solid currentColor;\n    border-radius: 50%;\n\n    grid-area: 1 / 1;\n\n    animation: ",
        " ",
        "s\n      cubic-bezier(0, 0.2, 0.8, 1) infinite;\n\n    @media (prefers-reduced-motion) {\n      animation-duration: ",
        "s;\n    }\n  }\n\n  &:after {\n    animation-delay: -",
        "s;\n\n    @media (prefers-reduced-motion) {\n      animation-delay: -",
        "s;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n\n  > * {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .message {\n    text-align: center;\n    display: block;\n    width: ",
        ";\n    margin-top: -50px;\n\n    color: ",
        ";\n    font-size: ",
        ";\n    font-style: italic;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var ripple = function(size) {
    return (0, _styledComponents.keyframes)(_templateObject(), size, size);
};
var animationSpeed = 1.4;
var StyledLoadingIndicator = (0, _styledComponentsDefault.default).div(_templateObject1(), function(props) {
    return props.$overallSize;
}, function(props) {
    return props.$overallSize;
}, function(props) {
    return ripple(props.$rippleSize);
}, animationSpeed, animationSpeed * 2, animationSpeed / 2, animationSpeed);
var StyledMessageLoadingIndicator = (0, _styledComponentsDefault.default).div(_templateObject2(), function(props) {
    return props.$overallSize;
}, (0, _index.COLORS).lightFontColor, (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jnVwv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingList", function() {
    return LoadingList;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingListStyles = require("./LoadingList.styles");
var LoadingList = function() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingListStyles.StyledLoadingList), null);
};

},{"react":"ktQNc","./LoadingList.styles":"8ovAg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8ovAg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLoadingList", function() {
    return StyledLoadingList;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  height: 40vh;\n\n  background-image: repeating-linear-gradient(\n    to bottom,\n    ",
        " 0px,\n    ",
        " 60px,\n    ",
        " 60px,\n    ",
        " 65px\n  );\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n\n    opacity: 0.75;\n\n    background-image: linear-gradient(to right, transparent, ",
        ", transparent);\n    background-size: 400% 100%;\n    animation: ",
        " 2s ease infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var loadingAnimation = (0, _styledComponents.keyframes)(_templateObject());
var StyledLoadingList = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).ebony, (0, _index.COLORS).ebony, (0, _index.COLORS).clay, (0, _index.COLORS).clay, (0, _index.COLORS).clay, loadingAnimation);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g838E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingSpinner", function() {
    return LoadingSpinner;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
function LoadingSpinner(props) {
    var className = props.className, fill = props.fill, id = props.id, size = props.size, style = props.style, _props_ariaLabel = props.ariaLabel, ariaLabel = _props_ariaLabel === void 0 ? "Loading..." : _props_ariaLabel;
    var loaderSize = size || "12px";
    var loaderStyle = Object.assign({
        position: "relative",
        top: "1px"
    }, style);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-circle-notch",
        className: "spin ".concat(className || ""),
        "data-cy": props["data-cy"],
        id: id,
        size: [
            loaderSize
        ],
        style: loaderStyle,
        fill: fill || "currentColor",
        ariaLabel: ariaLabel
    });
}

},{"react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hY5JT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PercentageRing", function() {
    return PercentageRing;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _percentageRingStyles = require("./PercentageRing.styles");
function PercentageRing(props) {
    var _props_backgroundColor = props.backgroundColor, backgroundColor = _props_backgroundColor === void 0 ? (0, _index.COLORS).clay : _props_backgroundColor, className = props.className, _props_foregroundColor = props.foregroundColor, foregroundColor = _props_foregroundColor === void 0 ? (0, _index.COLORS).baliHai : _props_foregroundColor, id = props.id, _props_ringRadius = props.ringRadius, ringRadius = _props_ringRadius === void 0 ? 35 : _props_ringRadius, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 5 : _props_strokeWidth, _props_value = props.value, value = _props_value === void 0 ? 0 : _props_value, _props_valueFontSize = props.valueFontSize, valueFontSize = _props_valueFontSize === void 0 ? 20 : _props_valueFontSize;
    var ringCircumference = 2 * Math.PI * (ringRadius - strokeWidth / 2);
    var valueCircumference = ringCircumference - value * ringCircumference;
    var diameter = ringRadius * 2;
    var circleRadius = ringRadius - strokeWidth / 2; // ensure we don’t display a value greater than 100% to the user
    var displayValue = Math.round(Math.min(value, 1) * 100);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _percentageRingStyles.StyledPercentageRing), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            fontSize: valueFontSize,
            width: diameter,
            height: diameter
        }
    }, displayValue, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, "%")), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        height: diameter,
        width: diameter,
        fill: "none",
        strokeWidth: strokeWidth,
        "aria-hidden": "true",
        focusable: "false"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("g", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        r: circleRadius,
        cx: ringRadius,
        cy: ringRadius,
        stroke: backgroundColor
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        r: circleRadius,
        cx: ringRadius,
        cy: ringRadius,
        stroke: foregroundColor,
        strokeDasharray: ringCircumference,
        strokeDashoffset: valueCircumference
    }))));
}

},{"react":"ktQNc","Permafrost/index":"iliLC","./PercentageRing.styles":"lv5aN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lv5aN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPercentageRing", function() {
    return StyledPercentageRing;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  svg {\n    transform: rotate(-90deg);\n  }\n\n  div {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    margin-top: -0.05em;\n    margin-left: 0.1em;\n\n    span {\n      font-size: 0.6em;\n      margin-top: -0.5em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPercentageRing = (0, _styledComponentsDefault.default).div(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"c8T3M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressBar", function() {
    return ProgressBar;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _progressBarStyles = require("./ProgressBar.styles");
var ProgressBar = function(props) {
    var primary = props.primary, secondary = props.secondary, className = props.className, id = props.id, style = props.style, _props_onHoverDetails = props.onHoverDetails, onHoverDetails = _props_onHoverDetails === void 0 ? null : _props_onHoverDetails, _props_primaryColor = props.primaryColor, primaryColor = _props_primaryColor === void 0 ? (0, _index.COLORS).robinsEggBlue : _props_primaryColor, _props_secondaryColor = props.secondaryColor, secondaryColor = _props_secondaryColor === void 0 ? (0, _index.COLORS).red : _props_secondaryColor;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), tooltipData = _useState[0], setTooltipData = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), mouseCoordinates = _useState1[0], setMouseCoordinates = _useState1[1];
    var primaryWidth = function(primary, primaryColor) {
        if (primary === 100) return {
            width: "calc(100% + 2px)",
            borderRadius: "5px",
            background: primaryColor
        };
        else if (primary === 0) return {
            width: "0px"
        };
        else return {
            width: "calc(".concat(primary, "% + 1px)"),
            background: primaryColor
        };
    };
    var secondaryWidth = function(primary, secondary, secondaryColor) {
        if ((0, _index.MATH).round10(primary + secondary, -2) >= 100) {
            var reducedSecondary = 100 - primary;
            return {
                width: "calc(".concat(reducedSecondary, "% + 2px)"),
                borderRadius: "0 5px 5px 0",
                background: secondaryColor
            };
        } else if (secondary === 0) return {
            width: "0px"
        };
        else return {
            width: "calc(".concat(secondary, "% + 1px)"),
            background: secondaryColor
        };
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _progressBarStyles.StyledProgressBar), {
        className: "ProgressBar ".concat(className || ""),
        "data-cy": props["data-cy"],
        id: id,
        style: style,
        onMouseLeave: function() {
            setTooltipData(null);
            setMouseCoordinates([
                -1,
                -1
            ]);
        },
        onMouseEnter: function(e) {
            setTooltipData(onHoverDetails);
            setMouseCoordinates([
                e.clientX,
                e.clientY
            ]);
        },
        onMouseMove: function(e) {
            e.persist();
            requestAnimationFrame(function() {
                return setMouseCoordinates([
                    e.clientX,
                    e.clientY
                ]);
            });
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        className: "progress-container"
    }, props === null || props === void 0 ? void 0 : props.progressBarRowProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "primary-progress",
        style: primaryWidth(primary, primaryColor)
    }), secondary ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "secondary-progress",
        style: secondaryWidth(primary, secondary, secondaryColor)
    }) : null), tooltipData && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "progress-bar-tooltip",
        style: {
            top: mouseCoordinates[1],
            left: mouseCoordinates[0]
        }
    }, tooltipData));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","Permafrost/index":"iliLC","./ProgressBar.styles":"lDTHQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lDTHQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledProgressBar", function() {
    return StyledProgressBar;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  height: 9px;\n  overflow: hidden;\n  border-radius: 5px;\n  width: 100%;\n\n  .progress-container {\n    display: flex;\n    border-radius: 5px;\n    border: 1px solid ",
        ";\n    height: 9px;\n    width: 100%;\n    background: ",
        ";\n  }\n\n  .primary-progress {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n\n  .progress-bar-tooltip {\n    white-space: pre-wrap;\n    left: -999em;\n    top: -999em;\n    position: fixed;\n    z-index: 800;\n    background-color: ",
        ";\n    color: ",
        ";\n    border: ",
        ";\n    border-radius: 5px;\n    transform: translate(-50%, 50%);\n    padding: 5px;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledProgressBar = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).comet, (0, _index.COLORS).ebony, (0, _index.COLORS).ebony, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).mirage, (0, _index.TYPOGRAPHY).fontSize.base);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eVkf8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RandomLoadingMessage", function() {
    return RandomLoadingMessage;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _randomMessages = require("./random-messages");
var _randomMessagesDefault = parcelHelpers.interopDefault(_randomMessages);
var RandomLoadingMessage = function() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _randomMessagesDefault.default)[Math.floor(Math.random() * (0, _randomMessagesDefault.default).length)]), 2), randomMessage = _useState[0], changeRandomMessage = _useState[1];
    (0, _react.useEffect)(function() {
        var timer = setTimeout(function() {
            changeRandomMessage((0, _randomMessagesDefault.default)[Math.floor(Math.random() * (0, _randomMessagesDefault.default).length)]);
        }, 3000);
        return function() {
            return clearTimeout(timer);
        };
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "message"
    }, randomMessage, "...");
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","./random-messages":"eBa5t","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eBa5t":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MESSAGES = [
    "Charging the flux capacitor",
    "Spinning up the hamster wheel",
    "Flushing the pipes",
    "Counting all the beans",
    "Take a deep breath and enjoy this beautiful moment",
    "Counting digits in pi (almost done)",
    "Folding time and space",
    "Oiling the gears",
    "Peeling the data fruits",
    "Activating the oscillation overthruster",
    "Gleaming the cube",
    "Reticulating splines",
    "Playing a quick game of squash",
    "Making the sausage",
    "Building the matrix",
    "Drawing fractals",
    "Testing memory (what did you have for breakfast?)",
    "Priming data pumps",
    "Whacking datamoles",
    "Finding Nemo",
    "Running spin cycle",
    "Chasing down a dream",
    "Twiddling the knobs",
    "Assembling lines",
    "Making the donuts",
    "Gathering magic",
    "Rolling stones",
    "Busting all the moves",
    "Augmenting reality",
    "Leveling up",
    "Obviating frequencies",
    "Declaring variables",
    "Boosting thrusters",
    "Blazing the saddles",
    "Flipping some bits",
    "Unclogging the internet",
    "Turning it off and back on again",
    "Entering the ThunderDome",
    "Rolling logs",
    "Dangling particles",
    "Catching moonbeams",
    "Digging for treasure",
    "Reconbulating the conbulator",
    "Machine learning",
    "Magicing",
    "Tuning the forks",
    "Fiddling widgets",
    "Feeding the data monkeys",
    "Regularizing expressions",
    "Ramping up the synergy",
    "Inflating point flotations",
    "Entering orbit around alpha centuri",
    "Squeezing data tubes",
    "Making a list and checking it twice",
    "Unkinking the data tubes",
    "Turning on the data hose",
    "Preparing for liftoff",
    "Replacing the hamsters",
    "Changing the batteries",
    "Waking up our engineers",
    "Contemplating the meaning of life",
    "Downloading fresh dog memes",
    "Springing the chickens"
];
exports.default = MESSAGES;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7E1rB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppCrash", function() {
    return AppCrash;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var AppCrash = function(props) {
    var className = props.className, id = props.id, style = props.style;
    var message = props.message || "Unfortunately the app has encountered a fatal error.";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.FailSnail), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        message: message,
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "cta",
        onClick: function() {
            window.location.reload();
        }
    }, "Refresh"));
};

},{"react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kK4OR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmModal", function() {
    return ConfirmModal;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _confirmModalStyles = require("./ConfirmModal.styles");
function ConfirmModal(props) {
    var id = (0, _uuid.v4)();
    var className = props.className, clickOutsideHandler = props.clickOutsideHandler, confirmText = props.confirmText, describedBy = props.describedBy, message = props.message, modalNode = props.modalNode, open = props.open, processing = props.processing, rejectText = props.rejectText, responseHandler = props.responseHandler, title = props.title, width = props.width;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.ModalBase), {
        className: className,
        clickToDismiss: clickOutsideHandler,
        "data-cy": props["data-cy"],
        describedBy: describedBy,
        id: props.id,
        labelElement: id,
        node: modalNode,
        open: open
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _confirmModalStyles.StyledConfirmModal), {
        style: {
            width: width || 555
        }
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id,
        className: "title"
    }, title || "Please confirm"), message && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "message"
    }, message), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingAwareContainer), {
        isLoading: processing,
        className: "actions"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "cta",
        className: "confirm",
        onClick: function(event) {
            return responseHandler(true, event);
        }
    }, confirmText || "Yes"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        variant: "normal",
        className: "reject",
        onClick: function(event) {
            return responseHandler(false, event);
        }
    }, rejectText || "No"))));
}

},{"react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./ConfirmModal.styles":"2kzCr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2kzCr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledConfirmModal", function() {
    return StyledConfirmModal;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 20px;\n\n  .title {\n    margin: 30px 16px;\n    font-size: ",
        ";\n    text-align: center;\n    color: ",
        ";\n  }\n\n  .message {\n    text-align: center;\n    padding-bottom: 16px;\n  }\n\n  .actions {\n    text-align: center;\n    padding-bottom: 40px;\n\n    button {\n      min-width: 300px;\n      display: block;\n      margin: 16px auto 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledConfirmModal = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.display, (0, _index.COLORS).lightFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jv0OH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContentModal", function() {
    return ContentModal;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _contentModalStyles = require("./ContentModal.styles");
function ContentModal(props) {
    var id = (0, _uuid.v4)();
    var labelText = "labelText" in props && props.labelText;
    var title = "title" in props && props.title;
    var children = props.children, className = props.className, closeModal = props.closeModal, describedBy = props.describedBy, modalNode = props.modalNode, open = props.open, width = props.width;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.ModalBase), {
        className: className,
        clickToDismiss: closeModal,
        "data-cy": props["data-cy"],
        describedBy: describedBy,
        id: props.id,
        labelElement: title ? id : "",
        labelText: labelText || "",
        node: modalNode,
        open: open
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contentModalStyles.StyledContentModal), {
        style: {
            width: width || 555
        }
    }, title && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        id: id,
        className: "title"
    }, title), children));
}

},{"react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./ContentModal.styles":"a1HaS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a1HaS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContentModal", function() {
    return StyledContentModal;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 20px;\n\n  .title {\n    margin: 30px 16px;\n    font-size: ",
        ";\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContentModal = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.display);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dqTW8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FailSnail", function() {
    return FailSnail;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _failSnailStyles = require("./FailSnail.styles");
function FailSnail(props) {
    var children = props.children, className = props.className, id = props.id, message = props.message, style = props.style;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _failSnailStyles.StyledFailSnail), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 463.47 341.73",
        "aria-hidden": true,
        focusable: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M253.01 143.75c10.94 65.49-28 124-83.27 129.12S64.59 228.61 58.42 162.5 76.58 44.42 143.91 37.75c55.29-5.47 96.28 29.26 109.1 106zM148.19 61.88c-41.24 3.84-70.88 47.91-66.13 98.42s41.12 91.09 82.52 90.12c56.58-1.33 71.51-53.53 66.8-104s-41.96-88.39-83.19-84.54z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("ellipse", {
        cx: "158.55",
        cy: "163.57",
        rx: "34.88",
        ry: "47.14",
        transform: "rotate(-11.61 115.421 207.313)"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M291.25 259.92a109.73 109.73 0 01-17.75 9.12 130 130 0 01-19.06 6.08 146.67 146.67 0 01-19.73 3.21 131.32 131.32 0 01-19.93.37c6.54-1.26 13-2.29 19.51-3.46s12.86-2.52 19.23-4 12.67-3.19 18.93-5.12 12.47-4.13 18.8-6.2zM264.25 94.42a103.46 103.46 0 019.37 17.22 132 132 0 016.52 18.58 138.23 138.23 0 013.83 19.37 145 145 0 01.93 19.77 132.66 132.66 0 01-2 19.68l-1 4.85-1.2 4.81c-.36 1.6-.84 3.18-1.33 4.75s-1 3.16-1.51 4.71a136 136 0 01-18.11 34.76 188.12 188.12 0 0015.14-35.7 152.48 152.48 0 004.23-18.81 136.63 136.63 0 001.78-19.19 154.24 154.24 0 00-3.77-38.28 163.87 163.87 0 00-5.33-18.62 139.78 139.78 0 00-7.55-17.9z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("ellipse", {
        cx: "400.45",
        cy: "194.7",
        rx: "7.63",
        ry: "6.39"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M444.31 202.47c.55-.17 3.69 2.43 6.41 5.6s.31 7.53-2 8.27-6.81-1.6-6.4-5.6c.45-4.31 1.46-8.09 2-8.27M448.12 225.75c.46-.14 3.13 2.07 5.44 4.77s.28 6.4-1.7 7-5.79-1.36-5.44-4.76c.37-3.67 1.23-6.89 1.7-7M454.42 216.64c.46-.14 3.13 2.07 5.44 4.77s.27 6.4-1.7 7-5.79-1.36-5.44-4.76c.37-3.67 1.23-6.89 1.7-7"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("ellipse", {
        cx: "434.11",
        cy: "195.43",
        rx: "7.63",
        ry: "6.71"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M388.57 206.57c.62.28 1.31 5.06 1.19 10-.13 4.76-5.7 6.88-8.33 5.69s-4.72-6.82-1.18-10c3.81-3.45 7.71-6 8.32-5.69M374.8 219.14c.51.23 1.08 4.18 1 8.27-.1 3.93-4.71 5.68-6.88 4.69s-3.9-5.63-1-8.27c3.16-2.84 6.37-4.92 6.88-4.69"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M99.01 280.05l-.23-.27a3.71 3.71 0 00-.36-.36l-3.11-2.63c-2.07-1.69-4.05-3.61-6-5.49s-3.85-3.88-5.77-5.83a156.66 156.66 0 01-19.78-26.08 165.42 165.42 0 01-22.08-61 167.41 167.41 0 012.72-64.56 155.68 155.68 0 0118.29-44.82l2.08-3.46c.73-1.13 1.54-2.24 2.24-3.33s1.47-2.26 2.27-3.34l2.4-3.24c1.55-2.2 3.34-4.22 5-6.32s3.63-4.1 5.35-6.1 3.74-3.87 5.69-5.72l3-2.73 1.49-1.36 1.55-1.29a138.89 138.89 0 0126.76-17.9A132.92 132.92 0 01150.9 3.31 127.3 127.3 0 01183.13.03a135.31 135.31 0 0162.36 17.19 147.55 147.55 0 0148.37 43.33l2.37 3.33c.76 1.13 1.48 2.29 2.22 3.43s1.49 2.28 2.2 3.45l2 3.53c1.4 2.34 2.6 4.79 3.83 7.22s2.31 4.92 3.45 7.39a156.91 156.91 0 019.85 31l1.44 8 1 8c.53 5.36.94 10.72 1.11 16.09.08 2.69.19 5.37.15 8.06v4c0 1.35-.09 2.69-.13 4l-.13 4-.26 4c-.1 1.33-.15 2.67-.29 4l-.41 4a161.33 161.33 0 01-6.31 31.47c-3.25 10.18-7.79 20.08-14.45 28.53a24.35 24.35 0 00-3.95 6.75 8.6 8.6 0 00.35 7.34 11.42 11.42 0 006 4.57 19.2 19.2 0 003.75 1c.63.11 1.27.13 2 .24a12.68 12.68 0 012 .45 14.14 14.14 0 013.78 1.76 9 9 0 013 3.07 5.33 5.33 0 01.39 4.45 8.68 8.68 0 01-1.74 2.67 17.93 17.93 0 013.23-.64 39 39 0 015.9-.37 97.56 97.56 0 0111.73.88l1.46.19c.49.07 1 .14 1.39.18a11.56 11.56 0 002.63-.05 11.7 11.7 0 004.87-1.75c.36-.23.72-.48 1.06-.74l1.06-.9c.76-.64 1.52-1.26 2.3-1.88 1.54-1.22 3.13-2.4 4.74-3.54a96.08 96.08 0 0120.9-11.25 80.05 80.05 0 0113.82-4c.15-.72.29-1.43.43-2.15a173.93 173.93 0 002.53-19.11c.14-3.23.39-6.46.36-9.7 0-1.61.06-3.23.05-4.85l-.15-4.84-.08-2.43-.19-2.41-.33-4.72a23.73 23.73 0 01-15.27-6.54 24.12 24.12 0 01-7.29-16.89 24.63 24.63 0 016.81-17.37 23.53 23.53 0 0117.37-7.25 23.1 23.1 0 019.28 2.19 25.09 25.09 0 017.73 5.94 24 24 0 018.11-5.32 23.74 23.74 0 019.44-1.8 22.59 22.59 0 0116.72 7.86 25 25 0 016.06 16.72 24.41 24.41 0 01-6.52 16.27 23.28 23.28 0 01-7.33 5.29c-.58.26-1.17.5-1.78.72.23 4.61.28 9.15.17 13.74-.19 5-.47 10.09-1.13 15.1a110.85 110.85 0 01-2.82 14.9 69.68 69.68 0 01-3.55 10.18 67.74 67.74 0 016.33 2.76 59 59 0 0110.43 6.56 45.46 45.46 0 018.71 9 39.27 39.27 0 015.71 11.41 34.5 34.5 0 01-2.05 25.33 37.15 37.15 0 01-7.61 10.39c-.75.76-1.58 1.42-2.37 2.14s-1.68 1.32-2.51 1.93c-1.66 1.13-3.25 2.32-5 3.39s-3.38 2.18-5.19 3.13l-2.66 1.47-2.76 1.32c-1.81.93-3.76 1.6-5.66 2.35-.94.4-1.94.65-2.91 1l-2.94.9a88.9 88.9 0 01-24 2.66 160.16 160.16 0 01-23.65-2.33c-1.94-.34-3.88-.64-5.81-1l-5.79-1.2c-1.93-.37-3.84-.8-5.74-1.26l-5.72-1.34c-7.49-1.76-15-3.5-22.52-4.52-3.76-.51-7.54-.91-11.31-1.06-.95-.07-1.89-.07-2.83-.07h-2.83c-.94 0-1.87.09-2.81.14s-1.88.07-2.81.21a86.83 86.83 0 00-11.18 1.9c-3.72.89-7.47 1.9-11.27 2.85-1.91.44-3.81.93-5.75 1.3l-2.9.58-2.92.46c-1.93.37-3.94.47-5.91.69a26.79 26.79 0 01-3 .15l-3 .07a76 76 0 01-23.18-4.53c-7.38-2.52-14.59-5.35-22.14-6.41a47.62 47.62 0 00-11.38-.24 57.27 57.27 0 00-11.19 2.08c-3.68 1.05-7.29 2.45-11 3.67-1.85.64-3.74 1.19-5.63 1.74s-3.81 1-5.74 1.39a121.86 121.86 0 01-23.44 2.54c-2 .09-3.92.06-5.88 0s-3.93 0-5.88-.09l-5.87-.22-5.89-.41c-2-.14-3.94-.42-5.91-.63-1-.11-2-.32-3-.47s-2-.28-3-.53a49 49 0 01-11.66-3.78c-1.85-.88-3.49-1.72-5.07-2.31l-1.18-.41c-.4-.11-.81-.18-1.21-.28a20.38 20.38 0 00-2.52-.39c-.86-.1-1.78-.08-2.66-.13s-1.84 0-2.75 0c-1.82 0-3.76.18-5.65.32-7.63.62-15.33 1.61-23.09 2.34a232.13 232.13 0 01-23.56 1.37 75.06 75.06 0 01-12.06-1 39.8 39.8 0 01-6.08-1.53 25.34 25.34 0 01-5.83-2.89 15.27 15.27 0 01-4.9-5 10.26 10.26 0 01-1.23-3.73 10 10 0 01.36-3.88 14.73 14.73 0 013.61-5.93 28.19 28.19 0 014.91-4c6.92-4.54 14.8-6.8 22.4-8.42 3.79-.86 7.6-1.72 11.44-2.45s7.78-1.29 11.61-1.89l18.07-2.56a8.13 8.13 0 01.39-2.61 9.76 9.76 0 014.38-5.37 11.66 11.66 0 016-1.64 13.83 13.83 0 011.57.12l1 .14 1.91.28c1.27.17 2.54.32 3.79.44a36 36 0 007.08.09c.22.02.36-.03.51-.06zm331.15-24.26a87.73 87.73 0 002.25-10.36c.82-4.89 1.3-9.83 1.64-14.77s.48-9.91.45-14.87c0-4.22-.07-8.48-.3-12.68a23.38 23.38 0 01-3.23.31 23.12 23.12 0 01-3.33-.09c-.07 1.47-.2 3-.4 4.48a65.91 65.91 0 01-1.19 6.88 73.57 73.57 0 01-4.38 13.18 81.52 81.52 0 01-6.61 12.11c-.74 1.11-1.5 2.21-2.29 3.28.32 1.71.64 3.41 1 5.11l.76 3.54a66 66 0 0111.29 2.42c1.49.45 2.9.89 4.34 1.46zm-115.27 22.54a42.12 42.12 0 01-5.8 3c-2.46 1.12-5 2.09-7.48 3-5 1.85-10.15 3.47-15.3 5s-10.32 2.89-15.53 4.16c-10.42 2.55-20.94 4.57-31.47 6.47s-21.12 3.58-31.77 4.87c-2.66.34-5.32.66-8 .94s-5.34.57-8 .82q-8 .72-16.09 1.13c-5.38.28-10.77.45-16.17.46-2.71 0-5.42-.09-8.12-.13l-8-.29c-10.71-.46-21.44-1.11-32.2-2.32-5.39-.62-10.77-1.45-16.17-2.58-2.7-.6-5.4-1.22-8.11-2.07-.67-.18-1.35-.43-2-.65s-1.35-.45-2-.72a25.81 25.81 0 01-4.31-2 13.09 13.09 0 01-4.34-3.92 10.2 10.2 0 01-1.55-3.63c-5.9 1.34-11.73 2.54-17.64 3.76-7.61 1.51-15 3.48-22.51 5.56-1.86.53-3.74 1.05-5.53 1.6s-3.59 1.19-5.33 1.91a47.12 47.12 0 00-9.79 5.18 23.37 23.37 0 00-3.95 3.48 14 14 0 00-1.46 2 8 8 0 00-.84 2 4.59 4.59 0 00.53 3.62 10.09 10.09 0 003.29 3.11 19.33 19.33 0 004.55 2.13 32.39 32.39 0 005.23 1.19 73.18 73.18 0 0011.15.66 222.35 222.35 0 0022.9-1.59c7.68-.85 15.39-1.79 23.25-2.39 2-.13 3.91-.29 6-.3a43.75 43.75 0 016.23.23 26.11 26.11 0 013.21.58c.54.14 1.08.26 1.61.42l1.57.57c2 .82 3.83 1.82 5.46 2.64 6.46 3.32 13.92 4.71 21.49 5.72a217.47 217.47 0 0023 1.7 118.24 118.24 0 0022.84-1.43c7.57-1.2 14.73-4 22.32-6.17a60.6 60.6 0 0111.66-2.05 55.28 55.28 0 0111.85.29 69.82 69.82 0 0111.5 2.66c3.75 1.15 7.4 2.46 11.09 3.6a85.62 85.62 0 0011.15 2.85 61.47 61.47 0 0011.32.92c7.57-.19 15.07-1.87 22.45-3.94 3.7-1.08 7.4-2.25 11.19-3.32a90.74 90.74 0 0111.68-2.49 95.19 95.19 0 0123.85-.06 216.8 216.8 0 0123.25 4.07c7.53 1.6 15.06 3.24 22.63 4.29a152.91 152.91 0 0022.7 1.9 81.57 81.57 0 0022.06-2.76 74.73 74.73 0 0020-9.35c1.59-1 3.1-2.13 4.65-3.19.73-.54 1.41-1.07 2.1-1.62s1.35-1.14 1.95-1.77a31.2 31.2 0 006.15-8.29 27.21 27.21 0 001.85-20 35.78 35.78 0 00-11.83-17.17 59.2 59.2 0 00-19.34-10.34 62.92 62.92 0 00-8-2.19 64.85 64.85 0 003.07 9.33l-1.18-2.2-.59-1.1-.49-1.15c-.62-1.53-1.32-3.06-1.83-4.64-1.15-3.13-2.06-6.33-3-9.52-1.75-6.41-3.27-12.88-4.61-19.39s-2.51-13-3.61-19.57c-.51-3-.88-5.34-1.32-8.36a23.36 23.36 0 01-3.7.76c.17 3.16.47 6.31.41 9.47v4.95c0 1.65-.12 3.3-.18 5l-.11 2.48c-.05.82-.14 1.64-.21 2.46l-.47 4.93a138.43 138.43 0 01-3.69 19.41 90 90 0 01-6.94 18.41 98.62 98.62 0 003.45-11.21 78 78 0 00-11 2.86 92.1 92.1 0 00-10.51 4.32 99.31 99.31 0 00-10 5.55c-1.61 1-3.2 2.08-4.75 3.19-.78.56-1.55 1.13-2.31 1.7l-1.22.9a14.57 14.57 0 01-7.5 2.65 14.71 14.71 0 01-3.18-.14c-.54-.09-1-.19-1.48-.29l-1.42-.27a93.82 93.82 0 00-11.42-1.56 42.16 42.16 0 00-5.73-.05 14.36 14.36 0 00-5.56 1.32zm91.19-78.3c.42 3.09.86 6.17 1.29 9.25.91 6.54 1.93 13.07 2.93 19.59.69 4.16 1.38 8.32 2.12 12.47.42-.73.82-1.47 1.22-2.21a98.91 98.91 0 005.46-12.29 81.63 81.63 0 003.55-12.85 67.23 67.23 0 001.17-11.56 23.71 23.71 0 01-9.74-5.71c-.52-.5-1-1.05-1.44-1.59a19 19 0 01-6.56 4.9zm12.35-17.05a34.1 34.1 0 00-4.83-3.35 28.23 28.23 0 00-5.48-2.36 26.12 26.12 0 00-11.82-.71 33.16 33.16 0 00-11.22 4 32.2 32.2 0 00-8.19 6.39 21.31 21.31 0 0019.52 13.49 22.42 22.42 0 0015.67-5.91 21 21 0 005-7.11 20.43 20.43 0 001.34-4.41m.74-4.06c-.08 5.93-1.55 10.21-4.83 14.22a18.51 18.51 0 001.58 1.74 21.52 21.52 0 0015.05 6.54 22.38 22.38 0 0015.67-5.92 19.14 19.14 0 006-10.53 37.22 37.22 0 00-7.58-4.84 34 34 0 00-4.13-1.62 35.75 35.75 0 00-4.34-1 34.66 34.66 0 00-8.87-.36l-2.21.25c-.73.13-1.47.23-2.2.39a31.7 31.7 0 00-4.13 1.1zm-118.23 64.72a86.75 86.75 0 0014-28.35c.73-2.56 1.35-5.14 2-7.71s1.1-5.19 1.52-7.82a155.25 155.25 0 001.8-15.8 206.7 206.7 0 00-.37-31.77 189.38 189.38 0 00-5-31.19 165 165 0 00-10.69-29.51c-1.17-2.33-2.23-4.73-3.53-7s-2.47-4.6-3.87-6.81l-2-3.36c-.69-1.1-1.43-2.18-2.15-3.27s-1.42-2.18-2.17-3.25l-2.3-3.16c-3.05-4.23-6.43-8.2-9.87-12.11-1.71-2-3.56-3.79-5.34-5.7s-3.74-3.64-5.65-5.38a153 153 0 00-25.12-18.47c-2.21-1.38-4.55-2.53-6.84-3.78-1.13-.64-2.32-1.18-3.5-1.74l-3.54-1.67c-2.39-1-4.8-2-7.23-3l-3.67-1.3-1.85-.66c-.61-.22-1.24-.39-1.86-.58a129.06 129.06 0 00-30.76-5.78 122.17 122.17 0 00-61.26 12.06 131.17 131.17 0 00-47.82 40.66 149 149 0 00-25.19 57.52 162.23 162.23 0 00-3.31 31.28 171.41 171.41 0 002.65 31.27 164.43 164.43 0 0022.15 58.15 148.53 148.53 0 0019.15 24.57c1.84 1.83 3.59 3.75 5.54 5.46s3.79 3.54 5.86 5.2l3 2.53a13.43 13.43 0 011.06 1c.3.32.59.66.87 1a13.06 13.06 0 011.57 2.51 7.67 7.67 0 01.72 4.19 6.59 6.59 0 01-1.75 3.64 5.79 5.79 0 01-.86.76l-.44.32a4.5 4.5 0 01-.41.25c-.26.14-.55.3-.81.42a14 14 0 01-1.46.54 16.54 16.54 0 01-2.6.54 42.71 42.71 0 01-8.89.05c-1.4-.11-2.78-.26-4.16-.42l-2-.29-1-.13h-.42a3.06 3.06 0 00-1.6.43 1.58 1.58 0 00-.64.62v-.06a1 1 0 00.11.22 5.17 5.17 0 001.61 1.32 17.26 17.26 0 003 1.32c.56.23 1.15.43 1.74.62s1.17.41 1.78.57c2.39.75 4.89 1.32 7.39 1.87 5 1.07 10.22 1.8 15.42 2.47 10.42 1.29 21 2 31.57 2.61l8 .37c2.62.07 5.24.17 7.87.2 5.26 0 10.53.05 15.81-.12 21.11-.69 42.29-2.6 63.37-5.26 10.55-1.36 21.08-2.84 31.5-4.85a261.72 261.72 0 0030.89-7.61c2.51-.82 5-1.67 7.46-2.66a28.1 28.1 0 006.83-3.6 7.28 7.28 0 002.23-2.78 3.85 3.85 0 00-.21-3.26 7.66 7.66 0 00-2.48-2.66 12.48 12.48 0 00-3.41-1.69 11.69 11.69 0 00-1.85-.48c-.61-.11-1.3-.15-2-.27a20 20 0 01-3.95-1.11 12.34 12.34 0 01-6.42-5.06 8.12 8.12 0 01-1.09-4 11.93 11.93 0 01.75-4.07 25.19 25.19 0 014.12-6.99z"
    })), typeof message === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "message",
        "data-testid": "str-message-display"
    }, message) : /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "message",
        "data-testid": "node-message-display"
    }, message), children && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, children));
}

},{"react":"ktQNc","./FailSnail.styles":"g73Rp","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"g73Rp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFailSnail", function() {
    return StyledFailSnail;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  text-align: center;\n\n  svg {\n    display: block;\n    width: 300px;\n    margin: 150px auto 25px;\n\n    opacity: 0.5;\n  }\n\n  path,\n  ellipse {\n    fill: ",
        ";\n  }\n\n  .message {\n    margin-bottom: 25px;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFailSnail = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).iron, (0, _index.TYPOGRAPHY).fontSize.display, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eZbVg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Shrug", function() {
    return Shrug;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _index = require("Permafrost/index");
var _shrugStyles = require("./Shrug.styles");
function Shrug(props) {
    var actionLink = props.actionLink, actionText = props.actionText, buttonAction = props.buttonAction, buttonText = props.buttonText, className = props.className, id = props.id, message = props.message;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _shrugStyles.StyledShrug), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "shrug",
        size: [
            "260px",
            "84px"
        ]
    }), typeof message === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", Object.assign({
        className: "t-subhead-large"
    }, props === null || props === void 0 ? void 0 : props.messageProps), message) : message, actionLink && actionText && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Link), {
        to: actionLink,
        className: "button blue cta",
        style: {
            marginTop: "20px"
        }
    }, actionText), buttonAction && buttonText && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        onClick: buttonAction,
        style: {
            marginTop: "20px"
        },
        variant: "cta"
    }, buttonText));
}

},{"react":"ktQNc","react-router-dom":"6Au42","Permafrost/index":"iliLC","./Shrug.styles":"caydy","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"caydy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledShrug", function() {
    return StyledShrug;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  padding: 2em;\n\n  font-size: ",
        ";\n\n  p {\n    font-size: inherit;\n    margin-top: 2em;\n  }\n\n  svg {\n    fill: ",
        ";\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledShrug = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).iron);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fHUif":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toast", function() {
    return Toast;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toastStyles = require("./Toast.styles");
var Toast = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _toastStyles.StyledToast), {
        className: "Toast ".concat(className, " ").concat(props.toast.style, " ").concat(props.toast.display ? "show" : "hide"),
        style: style || {}
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-cy": "toast--".concat(props.toast.style)
    }, props.toast.message));
};

},{"react":"ktQNc","./Toast.styles":"j5ZyW","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j5ZyW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledToast", function() {
    return StyledToast;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("@indico-data/utils");
var _colors = require("Permafrost/constants/colors");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 50px;\n  width: 100%;\n  position: fixed;\n  top: 0;\n  transition: transform 250ms, background 250ms;\n  transform: translateY(-100%);\n  background: transparent;\n  z-index: 1000;\n  text-align: center;\n  display: table;\n\n  span {\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  &.sidebarOpen {\n    padding-left: ",
        ";\n  }\n\n  &.sidebarClosed {\n    padding-left: ",
        ";\n  }\n\n  &.show {\n    transition: transform 250ms, background 250ms;\n    transform: translateY(0);\n\n    span {\n      transition: opacity 250ms;\n      opacity: 1;\n    }\n  }\n\n  &.general {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.success {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.error {\n    color: ",
        ";\n    background: ",
        ";\n  }\n\n  &.hide {\n    background: transparent;\n\n    span {\n      transition: opacity 250ms;\n      opacity: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var navWidthOpen = "240px";
var navWidthClosed = "50px";
var StyledToast = (0, _styledComponentsDefault.default).div(_templateObject(), navWidthOpen, navWidthClosed, (0, _colors.allColors).darkFontColor, (0, _colors.allColors).lightGray, (0, _colors.allColors).pakistanGreen, (0, _utils.colorUtils).tint((0, _colors.allColors).green, 75), (0, _colors.allColors).fireEngineRed, (0, _utils.colorUtils).tint((0, _colors.allColors).red, 75));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","Permafrost/constants/colors":"eHGMX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"frFr7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", function() {
    return Tooltip;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTooltip = require("react-tooltip");
var _reactTooltipDefault = parcelHelpers.interopDefault(_reactTooltip);
var _index = require("Permafrost/index");
var _tooltipStyles = require("./Tooltip.styles");
var Tooltip = function(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tooltipStyles.StyledTooltip), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id,
        // this was done in a hurry, consider refactor on next pass.
        style: {
            display: props.block ? "block" : "inline-block"
        }
    }, props.questionMark && /*#__PURE__*/ (0, _reactDefault.default).createElement("i", {
        style: {
            color: (0, _index.COLORS).curiousBlue
        },
        className: props.questionMarkClassName,
        "data-tip": props.clickToShow ? "custom show" : "",
        "data-event": props.clickToShow ? "click focus" : "",
        "data-for": props.for
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-question-circle"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactTooltipDefault.default), {
        className: "tool",
        globalEventOff: props.clickToShow ? "click" : "",
        place: props.place || "top",
        id: props.for,
        delayShow: props.delayShow,
        delayHide: props.delayHide
    }, props.children));
};

},{"react":"ktQNc","react-tooltip":"dnSWJ","Permafrost/index":"iliLC","./Tooltip.styles":"4BFgR","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4BFgR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTooltip", function() {
    return StyledTooltip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: inline-block;\n\n  i:hover {\n    cursor: pointer;\n  }\n\n  p {\n    line-height: 1.4;\n    font-size: 13px;\n  }\n\n  .tool {\n    background: ",
        " !important;\n    border: 1px solid ",
        " !important;\n    border-radius: 2px !important;\n    padding: 8px 11px !important;\n    opacity: 1 !important;\n\n    &.place-left:after {\n      border-left-color: ",
        " !important;\n      border-top: 5px solid transparent !important;\n      border-bottom: 5px solid transparent !important;\n      right: -6px !important;\n      top: 50% !important;\n      margin-top: -9px !important;\n    }\n\n    &.place-left:before {\n      border-left-color: ",
        " !important;\n      border-left-width: 8px !important;\n      border-left-style: solid !important;\n      margin-top: -10px !important;\n    }\n\n    &.place-right:after {\n      border-right-color: ",
        " !important;\n      border-top: 5px solid transparent !important;\n      border-bottom: 5px solid transparent !important;\n      left: -6px !important;\n      top: 50% !important;\n      margin-top: -9px !important;\n    }\n\n    &.place-right:before {\n      border-right-color: ",
        " !important;\n      border-right-width: 8px !important;\n      border-right-style: solid !important;\n      margin-top: -10px !important;\n    }\n\n    &.place-top:after {\n      border-top-color: ",
        " !important;\n    }\n\n    &.place-top:before {\n      border-top-color: ",
        " !important;\n      border-top-width: 8px !important;\n      border-top-style: solid !important;\n    }\n\n    &.place-bottom:after {\n      border-bottom-color: ",
        " !important;\n    }\n\n    &.place-bottom:before {\n      border-bottom-color: ",
        " !important;\n      border-bottom-width: 8px !important;\n      border-bottom-style: solid !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTooltip = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j07ab":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flag", function() {
    return Flag;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _flagStyles = require("./Flag.styles");
var Flag = function(props) {
    var id = props.id, className = props.className, text = props.text, _props_flagColor = props.flagColor, flagColor = _props_flagColor === void 0 ? (0, _index.COLORS).yellowOrange : _props_flagColor, _props_fontColor = props.fontColor, fontColor = _props_fontColor === void 0 ? (0, _index.COLORS).black : _props_fontColor;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flagStyles.StyledFlag), {
        id: id,
        className: className,
        "data-cy": props["data-cy"],
        "data-testid": "flag-component",
        "$flagColor": flagColor,
        "$fontColor": fontColor
    }, text);
};

},{"react":"ktQNc","Permafrost/index":"iliLC","./Flag.styles":"enUJJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"enUJJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFlag", function() {
    return StyledFlag;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  clip-path: polygon(0% 0%, 100% 0%, 85% 50%, 100% 100%, 0% 100%);\n  padding: 1px 12px 1px 4px;\n  border-radius: 3px 0 0 3px;\n  background-color: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: bold;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFlag = (0, _styledComponentsDefault.default).span(_templateObject(), function(props) {
    return props.$flagColor;
}, (0, _index.TYPOGRAPHY).fontSize.base, function(props) {
    return props.$fontColor;
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"60q8g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Section", function() {
    return Section;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionStyles = require("./Section.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var Section = function(props) {
    var className = props.className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = __rest(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionStyles.StyledSection), Object.assign({
        className: (0, _classnamesDefault.default)("Section", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), children);
};

},{"react":"ktQNc","classnames":"9xS9S","./Section.styles":"9R7N0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9R7N0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSection", function() {
    return StyledSection;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  float: left;\n  margin-bottom: 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSection = (0, _styledComponentsDefault.default).article(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6KdzU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionBody", function() {
    return SectionBody;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionBodyStyles = require("./SectionBody.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var SectionBody = function(props) {
    var className = props.className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = __rest(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionBodyStyles.StyledSectionBody), Object.assign({
        className: (0, _classnamesDefault.default)("SectionBody", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), children);
};

},{"react":"ktQNc","classnames":"9xS9S","./SectionBody.styles":"5lELj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5lELj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionBody", function() {
    return StyledSectionBody;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  border: 1px solid #333d4c;\n  padding: 0 ",
        ";\n\n  .SectionBody:last-of-type {\n    .section-bottom-border {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var sectionSidePadding = "19px";
var StyledSectionBody = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).clay, sectionSidePadding);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"deeNM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionHeader", function() {
    return SectionHeader;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _sectionHeaderStyles = require("./SectionHeader.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var SectionHeader = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, children = props.children, id = props.id, restOfProps = __rest(props, [
        "className",
        "style",
        "children",
        "id"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionHeaderStyles.StyledSectionHeader), Object.assign({
        className: (0, _classnamesDefault.default)("SectionHeader", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), children);
};

},{"react":"ktQNc","classnames":"9xS9S","./SectionHeader.styles":"9hVnN","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9hVnN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionHeader", function() {
    return StyledSectionHeader;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 23px 0 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSectionHeader = (0, _styledComponentsDefault.default).header(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cYfyY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionBlock", function() {
    return SectionBlock;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _sectionBlockStyles = require("./SectionBlock.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var SectionBlock = function(props) {
    var title = props.title, className = props.className, children = props.children, id = props.id, _props_style = props.style, style = _props_style === void 0 ? {} : _props_style, flagText = props.flagText, flagMessage = props.flagMessage, restOfProps = __rest(props, [
        "title",
        "className",
        "children",
        "id",
        "style",
        "flagText",
        "flagMessage"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionBlockStyles.StyledSectionBlock), Object.assign({
        className: (0, _classnamesDefault.default)("SectionBlock", className),
        "data-cy": props["data-cy"],
        id: id,
        style: style
    }, restOfProps), title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("header", {
        className: "SectionBlock--header",
        style: {
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "header-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, title), flagText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Flag), {
        text: flagText
    }) : null), flagMessage ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "SectionBlock__flag-message"
    }, flagMessage) : null) : null, children, /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", {
        className: "section-bottom-border"
    }));
};

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./SectionBlock.styles":"zsFsx","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"zsFsx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionBlock", function() {
    return StyledSectionBlock;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .SectionBlock--header {\n    flex-direction: column;\n    align-items: flex-start !important;\n\n    .header-container {\n      display: flex;\n      align-items: center;\n\n      h3 {\n        display: flex;\n        align-items: center;\n        margin: 24px 10px 20px 0;\n      }\n    }\n\n    .SectionBlock__flag-message {\n      color: ",
        ";\n      margin: 0 0 10px 20px;\n    }\n  }\n\n  hr {\n    width: 100%;\n    border-bottom: 1px solid ",
        ";\n    margin: 27px 0 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSectionBlock = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).yellowOrange, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1C3yO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SectionTable", function() {
    return SectionTable;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _sectionTableStyles = require("./SectionTable.styles");
var createTitle = function(item) {
    return typeof item === "string" || typeof item === "number" ? item : null;
};
var SectionTable = function(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), openRowOptions = _useState[0], changeOpenRowOptions = _useState[1];
    var handleRowClick = function(link) {
        if (!link) return null;
        return function(e) {
            e.stopPropagation();
            props.history.push(link);
        };
    };
    var handleRowOptionToggleClick = function(id) {
        if (openRowOptions.indexOf(id) === -1) changeOpenRowOptions([].concat(openRowOptions, id));
        else changeOpenRowOptions(openRowOptions.filter(function(option) {
            return option !== id;
        }));
        if (props.openRowOptionHandler) props.openRowOptionHandler(id);
    };
    var headers = Object.keys(props.tableObjects[0].content);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sectionTableStyles.StyledSectionTable), {
        className: (0, _classnamesDefault.default)("SectionTable", props.className, {
            loading: props.loading
        }),
        "data-cy": props["data-cy"],
        id: props.id
    }, props.sortColumnHandler && props.sortedColumn && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "mobile-sort"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.BorderSelect), {
        onChange: function(e) {
            return props.sortColumnHandler(e.target.value);
        },
        value: props.sortedColumn,
        options: [].concat({
            name: "Choose Sorting Option",
            value: ""
        }, headers.map(function(item) {
            return {
                name: item,
                value: item
            };
        }))
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("table", Object.assign({}, props.tableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, props.tableObjects[0].rowAccordionContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        className: "action-column"
    }) : null, headers.map(function(header, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            className: (0, _classnamesDefault.default)({
                "not-sortable": props.sortableHeaders && props.sortableHeaders.indexOf(header) === -1
            }),
            onClick: function() {
                if (props.sortColumnHandler) {
                    if (props.sortableHeaders) {
                        if (props.sortableHeaders.indexOf(header) !== -1) props.sortColumnHandler(header);
                    } else props.sortColumnHandler(header);
                }
            },
            key: i
        }, props.headersContent ? props.headersContent[header] : header, " ", props.sortedColumn === header && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "fa-caret-".concat(props.sortDirection)
        }));
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", {
        className: (0, _classnamesDefault.default)({
            "SectionTable--tbody-loading": props.loading
        })
    }, props.loading ? Array.from({
        length: 5
    }, function(x, i) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            key: i
        }, props.tableObjects[0].rowAccordionContent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
            colSpan: headers.length + 1
        }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
            colSpan: headers.length
        }));
    }) : props.tableObjects.map(function(obj, i) {
        var rowStyle = obj.rowStyleCondition;
        if (rowStyle) rowStyle = (0, _defineProperty._)({}, rowStyle.className, rowStyle.condition);
        if (obj.rowAccordionContent) return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", Object.assign({
            key: i,
            className: (0, _classnamesDefault.default)(rowStyle)
        }, props.rowProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
            colSpan: headers.length + 1,
            style: {
                padding: "0"
            },
            className: "outer-hover"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("table", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("thead", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            className: "action-column",
            style: {
                padding: "0",
                height: "1px",
                border: "none"
            }
        }), headers.map(function(e, i) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
                key: i,
                style: {
                    padding: "0",
                    height: "1px",
                    border: "none"
                }
            });
        }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            onClick: function() {
                return handleRowOptionToggleClick(obj.id);
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
            style: {
                borderBottom: "none"
            },
            className: "action-column"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "chevron-down",
            style: {
                transform: openRowOptions.indexOf(obj.id) !== -1 ? "rotate(180deg)" : ""
            }
        })), Object.keys(obj.content).map(function(key, i) {
            var _a;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", Object.assign({
                key: i,
                style: {
                    borderBottom: "none"
                },
                "data-heading": headers[i],
                title: createTitle(obj.content[key])
            }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]);
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            className: (0, _classnamesDefault.default)("row-option", {
                open: openRowOptions.indexOf(obj.id) !== -1
            })
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
            className: "inner-table-cell",
            colSpan: headers.length + 1
        }, obj.rowAccordionContent))))));
        else if (obj.lineItemLink) return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", Object.assign({
            key: i,
            onClick: handleRowClick(obj.lineItemLink),
            className: (0, _classnamesDefault.default)("hover", rowStyle)
        }, props.rowProps), Object.keys(obj.content).map(function(key, i) {
            var _a;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", Object.assign({
                key: i,
                "data-heading": headers[i],
                title: createTitle(obj.content[key])
            }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]);
        }));
        else return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", Object.assign({
            key: i,
            className: (0, _classnamesDefault.default)(rowStyle)
        }, props.rowProps), Object.keys(obj.content).map(function(key, i) {
            var _a;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", Object.assign({
                key: i,
                "data-heading": headers[i],
                title: createTitle(obj.content[key])
            }, (_a = props === null || props === void 0 ? void 0 : props.headingProps) === null || _a === void 0 ? void 0 : _a[headers === null || headers === void 0 ? void 0 : headers[i]]), obj.content[key]);
        }));
    }))));
};

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./SectionTable.styles":"vg2Aa","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"vg2Aa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSectionTable", function() {
    return StyledSectionTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  25% {\n    left: -50px;\n  }\n  50% {\n    left: calc(100% + 50px);\n  }\n  75% {\n    left: calc(100% + 50px);\n  }\n  100% {\n    left: calc(100% + 50px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .mobile-sort {\n    @media ",
        " {\n      display: none;\n    }\n\n    select {\n      max-width: none;\n    }\n  }\n\n  .outer-hover {\n    @media ",
        " {\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  &.loading {\n    margin-top: 50px;\n\n    table {\n      overflow: hidden;\n    }\n  }\n\n  .SectionTable--tbody-loading {\n    tr {\n      margin: 10px 0;\n      border-bottom: 10px solid transparent;\n    }\n\n    td {\n      position: relative;\n      border-bottom: none;\n      height: 73px;\n      background: ",
        ";\n\n      &:before {\n        position: absolute;\n        display: block;\n        top: 0;\n        left: -50px;\n        content: '';\n        height: 100%;\n        width: 50px;\n        background: linear-gradient(90deg, ",
        ", #232e3d, ",
        ");\n        animation: ",
        " 2s infinite;\n        animation-timing-function: linear;\n      }\n    }\n  }\n\n  tbody > tr {\n    @media ",
        " {\n      &.hover:hover {\n        background: ",
        ";\n        cursor: pointer;\n      }\n    }\n  }\n\n  .action-column {\n    display: none;\n    text-align: center;\n    width: 20px;\n    padding: 20px 5px;\n\n    @media ",
        " {\n      display: table-cell;\n    }\n  }\n\n  table,\n  thead,\n  tbody,\n  th,\n  td,\n  tr {\n    display: block;\n\n    @media ",
        " {\n      display: table;\n    }\n\n    .no-link {\n      cursor: default;\n    }\n  }\n\n  thead {\n    display: block;\n\n    @media ",
        " {\n      display: table-header-group;\n    }\n  }\n\n  th {\n    padding-bottom: 10px;\n    border-bottom: 1px solid #535d6d;\n  }\n\n  th:hover {\n    cursor: pointer;\n  }\n\n  th.not-sortable:hover {\n    cursor: default;\n  }\n\n  tbody {\n    display: block;\n\n    @media ",
        " {\n      display: table-row-group;\n    }\n  }\n\n  th,\n  td {\n    display: block;\n\n    @media ",
        " {\n      display: table-cell;\n    }\n  }\n\n  tr {\n    display: block;\n    padding-bottom: 10px;\n\n    @media ",
        " {\n      display: table-row;\n\n      border-bottom: 0.5px solid ",
        ";\n    }\n  }\n\n  /* Hide table headers (but not display: none;, for accessibility) */\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n\n    @media ",
        " {\n      position: static;\n    }\n  }\n\n  tr:nth-child(odd) {\n    background: ",
        ";\n\n    @media ",
        ' {\n      background: transparent;\n    }\n  }\n\n  td {\n    /* Behave  like a "row" */\n    border: none;\n    position: relative;\n    padding-left: 50%;\n    padding-top: 10px;\n    padding-bottom: 5px;\n\n    @media ',
        " {\n      position: static;\n      // border-bottom: 0.5px solid ",
        ";\n      padding: 20px 15px;\n    }\n  }\n\n  td:before {\n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    left: 6px;\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    content: attr(data-heading);\n\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  td.inner-table-cell {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 5px;\n    border: none;\n\n    &:before {\n      display: none;\n    }\n  }\n\n  tr.row-option {\n    display: none;\n\n    &.open {\n      display: table-row;\n    }\n  }\n\n  .outer-hover tr {\n    border: none;\n  }\n\n  .outer-hover .hover {\n    border-bottom: 0.5px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var cardTableLoading = (0, _styledComponents.keyframes)(_templateObject());
var StyledSectionTable = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).mirage, (0, _index.COLORS).mirage, (0, _index.COLORS).mirage, cardTableLoading, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).oxfordBlue, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.COLORS).oxfordBlue, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1), (0, _index.MEDIA_QUERIES).mediumScreen, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).defaultFontColor, 0.1));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cxXo5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WidgetCard", function() {
    return WidgetCard;
});
parcelHelpers.export(exports, "WidgetCardHeader", function() {
    return WidgetCardHeader;
});
parcelHelpers.export(exports, "WidgetCardContent", function() {
    return WidgetCardContent;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index"); /**
                                            * Simple StyledComponent, used alongside `<WidgetCardHeader>`, and `<WidgetCardContent>`.
                                            * If header is not used, include an `aria-label` prop, or include an `id` for the element
                                            * that labels this component, and include that `id` in the `aria-labelledby` prop.
                                            *
                                            * `<WidgetCard>`, `<WidgetCardHeader>`, and `<WidgetCardContent>` are all StyledComponents.
                                            *
                                            * @example
                                            * <WidgetCard aria-labelledby="headerText">
                                            *   <WidgetCardHeader>
                                            *     <header>Time on Task</header>
                                            *     <span><Icon name="fa-cog" ariaLabel="settings" /></span>
                                            *   </WidgetCardHeader>
                                            *
                                            *   <WidgetCardContent>
                                            *     [[ child elements ]]
                                            *   </WidgetCardContent>
                                            * </WidgetCard>
                                            */ 
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 1px 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n\n  width: 100%;\n  height: 45px;\n\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  padding: 5px 15px;\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 18px 20px;\n\n  header {\n    margin-bottom: 26px;\n    font-size: 22px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var WidgetCard = (0, _styledComponentsDefault.default).article(_templateObject(), (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony); /**
    * StyledComponent to be used inside `<WidgetCard>`
    */ 
var WidgetCardHeader = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).ebony); /**
    * StyledComponent to be used inside `<WidgetCard>`
    */ 
var WidgetCardContent = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gxv2p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartContextMenu", function() {
    return ChartContextMenu;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _chartContextMenuStyles = require("./ChartContextMenu.styles");
function ChartContextMenu(props) {
    var closeMenuHandler = props.closeMenuHandler, xPos = props.xPos, yPos = props.yPos, options = props.options, currentDatum = props.currentDatum;
    var menuEl = (0, _react.useRef)();
    (0, _utils.hookUtils).useClickOutside(menuEl, closeMenuHandler);
    var onItemClicked = function(itemHandler) {
        itemHandler(currentDatum);
        props.closeMenuHandler();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartContextMenuStyles.StyledContextMenu), {
        style: {
            top: yPos,
            left: xPos
        },
        ref: menuEl
    }, options.map(function(option, index) {
        var disabled = option.filter && !option.filter(currentDatum);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: index,
            className: (0, _classnamesDefault.default)({
                disabled: disabled
            })
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
            href: "/",
            onClick: function(e) {
                e.preventDefault();
                return !disabled && onItemClicked(option.handler);
            }
        }, option.icon ? option.icon : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "fa-square"
        }), " ", option.name));
    }));
}

},{"react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./ChartContextMenu.styles":"eQ5lE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eQ5lE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContextMenu", function() {
    return StyledContextMenu;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  font-size: 12px;\n\n  li {\n    padding: 5px 7px;\n\n    a {\n      text-decoration: none;\n      color: ",
        ";\n    }\n\n    &.disabled {\n      opacity: 0.5;\n    }\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContextMenu = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j4UCH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartToolTip", function() {
    return ChartToolTip;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// import PropTypes from 'prop-types';
var _chartToolTipStyles = require("./ChartToolTip.styles");
var ChartToolTip = function(props) {
    var children = props.children, className = props.className, id = props.id, xPos = props.xPos, yPos = props.yPos;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _chartToolTipStyles.StyledChartToolTip), {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        style: {
            top: yPos,
            left: xPos
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "Tooltip-Contents"
    }, children));
}; // ChartToolTip.propTypes = {
 //     xPos: PropTypes.number.isRequired,
 //     yPos: PropTypes.number.isRequired
 // };

},{"react":"ktQNc","./ChartToolTip.styles":"51kwv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"51kwv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledChartToolTip", function() {
    return StyledChartToolTip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: 13px;\n  left: -999em;\n  top: -999em;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  z-index: 800;\n  color: ",
        ";\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: 8px 11px;\n  transform: translate(-50%, -100%);\n  margin-top: -14px;\n\n  &:before,\n  &:after {\n    content: '';\n    width: 0;\n    height: 0;\n    position: absolute;\n    left: 50%;\n  }\n\n  &:before {\n    border-top: 8px solid ",
        ";\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    bottom: -8px;\n    margin-left: -10px;\n  }\n\n  &:after {\n    border-left: 8px solid transparent;\n    border-right: 8px solid transparent;\n    bottom: -6px;\n    margin-left: -8px;\n    border-top: 6px solid ",
        ";\n  }\n\n  p {\n    font-size: 12px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledChartToolTip = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).baliHai, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9dhwA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Matrix", function() {
    return Matrix;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _d3ScaleChromatic = require("d3-scale-chromatic");
var _index = require("Permafrost/index");
var _matrixStyles = require("./Matrix.styles");
function Matrix(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), selectedPos = _useState[0], setSelectedPos = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)([
        -1,
        -1
    ]), 2), hovered = _useState1[0], setHovered = _useState1[1];
    var handleCellClick = function(row, col) {
        setSelectedPos([
            row,
            col
        ]);
        props.selectionHandler(row, col);
    };
    var onCellHover = function(row, col) {
        setHovered([
            row,
            col
        ]);
    };
    var className = props.className, data = props.data, id = props.id, tooltipPlacement = props.tooltipPlacement, xAxisLabel = props.xAxisLabel, yAxisLabel = props.yAxisLabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _matrixStyles.StyledMatrix), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("table", {
        className: "Matrix-Frame",
        onMouseLeave: function() {
            return setHovered([
                -1,
                -1
            ]);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("tbody", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        className: "Matrix-Row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        className: "Matrix-Label-Row"
    }, "\xa0"), /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        className: "Matrix-Axis-X",
        colSpan: data.labels.length
    }, xAxisLabel), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null)), data.matrix.map(function(row, index) {
        var ttKey = "rowLabel".concat(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            className: "Matrix-Row",
            key: ttKey
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            className: "Matrix-Label-Row"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "data-tip": true,
            "data-for": ttKey,
            style: {
                color: "".concat(hovered[0] === index ? "#fff" : "")
            }
        }, data.labels[index]), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            for: ttKey,
            place: tooltipPlacement
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, data.labels[index]))), row.map(function(cell, rowIndex) {
            var cellStyles = {
                backgroundColor: (0, _d3ScaleChromatic.interpolateYlGnBu)(cell)
            };
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("td", {
                className: (0, _classnamesDefault.default)("Matrix-Cell", {
                    selected: index === selectedPos[0] && rowIndex === selectedPos[1]
                }),
                style: cellStyles,
                key: rowIndex,
                onClick: function() {
                    return handleCellClick(index, rowIndex);
                },
                title: cell,
                onMouseEnter: function() {
                    return onCellHover(index, rowIndex);
                }
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: "Contents"
            }, cell));
        }), index === 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            className: "Matrix-Axis-Y",
            rowSpan: data.labels.length
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, yAxisLabel)));
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
        className: "Matrix-Row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
        className: "Matrix-Label-Row"
    }, "\xa0"), data.labels.map(function(label, index) {
        var ttKey = "colLabel".concat(index);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("th", {
            className: "Matrix-Label-Col",
            key: ttKey
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "rotate",
            "data-tip": true,
            "data-for": ttKey,
            style: {
                color: "".concat(hovered[1] === index ? "#fff" : "")
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, label)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            for: ttKey,
            place: tooltipPlacement
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, label)));
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("td", null)))));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","d3-scale-chromatic":"6MEXx","Permafrost/index":"iliLC","./Matrix.styles":"e3F7T","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e3F7T":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledMatrix", function() {
    return StyledMatrix;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  .Matrix-Frame {\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 2px;\n\n    td,\n    tr,\n    th,\n    td {\n      border: 0;\n      padding: 0;\n      margin: 0;\n    }\n\n    .Matrix-Cell {\n      position: relative;\n\n      &:after {\n        content: '';\n        display: block;\n        margin-top: 100%;\n      }\n\n      &:hover {\n        border: 2px solid ",
        ";\n        cursor: pointer;\n      }\n\n      &.selected {\n        border: 2px solid ",
        ";\n      }\n\n      .Contents {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: none;\n      }\n    }\n\n    .Matrix-Label-Row,\n    .Matrix-Label-Col {\n      font-size: 12px;\n      color: ",
        ";\n    }\n\n    .Matrix-Label-Row {\n      width: ",
        ";\n      padding-right: 8px;\n\n      span {\n        display: inline-block;\n        overflow: hidden;\n        white-space: nowrap;\n        max-width: 100%;\n        text-overflow: ellipsis;\n      }\n    }\n\n    .Matrix-Label-Col {\n      height: ",
        ";\n      position: relative;\n      vertical-align: bottom;\n\n      .rotate {\n        transform-origin: 0 50%;\n        transform: rotate(-90deg);\n        white-space: nowrap;\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 50%;\n\n        span {\n          display: inline-block;\n          width: ",
        " - 15px;\n          overflow: hidden;\n          white-space: nowrap;\n          text-align: right;\n          text-overflow: ellipsis;\n        }\n      }\n    }\n\n    .Matrix-Axis-X,\n    .Matrix-Axis-Y {\n      font-size: 14px;\n      color: ",
        ";\n    }\n\n    .Matrix-Axis-X {\n      text-align: center;\n      padding-bottom: 10px;\n    }\n\n    .Matrix-Axis-Y {\n      width: 25px;\n      span {\n        position: relative;\n        display: block;\n        top: 50%;\n        transform: rotate(90deg) translateX(-50%);\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var MatrixXLabelSize = "100px";
var MatrixYLabelSize = "120px";
var StyledMatrix = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).magenta, (0, _index.COLORS).magenta, (0, _index.COLORS).midFontColor, MatrixXLabelSize, MatrixYLabelSize, MatrixYLabelSize, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fz2Lw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Bar = function(props) {
    var _props_className = props.className, className = _props_className === void 0 ? "" : _props_className, xPos = props.xPos, yPos = props.yPos, width = props.width, height = props.height, id = props.id, _props_toolTipKey = props.toolTipKey, toolTipKey = _props_toolTipKey === void 0 ? null : _props_toolTipKey, _props_mouseEnterHandler = props.mouseEnterHandler, mouseEnterHandler = _props_mouseEnterHandler === void 0 ? function() {
        return null;
    } : _props_mouseEnterHandler, _props_mouseLeaveHandler = props.mouseLeaveHandler, mouseLeaveHandler = _props_mouseLeaveHandler === void 0 ? function() {
        return null;
    } : _props_mouseLeaveHandler, _props_mouseMoveHandler = props.mouseMoveHandler, mouseMoveHandler = _props_mouseMoveHandler === void 0 ? function() {
        return null;
    } : _props_mouseMoveHandler, _props_contextMenuHandler = props.contextMenuHandler, contextMenuHandler = _props_contextMenuHandler === void 0 ? function() {
        return null;
    } : _props_contextMenuHandler;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        className: "Bar ".concat(className),
        fill: "currentColor",
        x: xPos,
        y: yPos,
        width: width,
        height: height,
        id: id,
        "data-cy": props["data-cy"],
        "data-tip": toolTipKey !== null,
        "data-for": toolTipKey,
        onMouseEnter: mouseEnterHandler,
        onMouseLeave: mouseLeaveHandler,
        onMouseMove: mouseMoveHandler,
        onContextMenu: contextMenuHandler
    });
};
exports.default = Bar;

},{"react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6PIUy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", function() {
    return Circle;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Circle(props) {
    var className = props.className, cx = props.cx, cy = props.cy, _props_fill = props.fill, fill = _props_fill === void 0 ? "white" : _props_fill, _props_fillOpacity = props.fillOpacity, fillOpacity = _props_fillOpacity === void 0 ? 1 : _props_fillOpacity, id = props.id, onClick = props.onClick, _props_radius = props.radius, radius = _props_radius === void 0 ? 10 : _props_radius, showOnHover = props.showOnHover, _props_stroke = props.stroke, stroke = _props_stroke === void 0 ? "white" : _props_stroke, _props_strokeOpacity = props.strokeOpacity, strokeOpacity = _props_strokeOpacity === void 0 ? 0 : _props_strokeOpacity, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 1 : _props_strokeWidth, toolTipKey = props.toolTipKey;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hovered = _useState[0], setHovered = _useState[1];
    var effectiveFillOpacity = !showOnHover || hovered ? fillOpacity : 0;
    var effectiveStokeOpacity = !showOnHover || hovered ? strokeOpacity : 0;
    var mouseEnterHandler = function() {
        setHovered(true);
    };
    var mouseLeaveHandler = function() {
        setHovered(false);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        className: className,
        style: {
            cursor: "pointer"
        },
        r: radius,
        cx: cx,
        cy: cy,
        fill: fill,
        fillOpacity: effectiveFillOpacity,
        id: id,
        stroke: stroke,
        strokeWidth: strokeWidth,
        strokeOpacity: effectiveStokeOpacity,
        "data-cy": props["data-cy"],
        "data-tip": toolTipKey !== null,
        "data-for": toolTipKey,
        onClick: onClick,
        onMouseEnter: mouseEnterHandler,
        onMouseLeave: mouseLeaveHandler
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e1f0D":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Line", function() {
    return Line;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Line(props) {
    var className = props.className, _props_fill = props.fill, fill = _props_fill === void 0 ? "none" : _props_fill, _props_hoverEffect = props.hoverEffect, hoverEffect = _props_hoverEffect === void 0 ? true : _props_hoverEffect, id = props.id, onClick = props.onClick, path = props.path, _props_stroke = props.stroke, stroke = _props_stroke === void 0 ? "white" : _props_stroke, _props_strokeWidth = props.strokeWidth, strokeWidth = _props_strokeWidth === void 0 ? 1 : _props_strokeWidth;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hovered = _useState[0], setHovered = _useState[1];
    var mouseOverHandler = function() {
        setHovered(true);
    };
    var mouseOutHandler = function() {
        setHovered(false);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: path,
        fill: fill,
        stroke: stroke,
        style: {
            cursor: onClick ? "pointer" : "default"
        },
        strokeWidth: hovered && hoverEffect && onClick ? strokeWidth + 2 : strokeWidth,
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        onClick: onClick,
        onMouseEnter: mouseOverHandler,
        onMouseLeave: mouseOutHandler
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hfWTr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HorizontalBarChart", function() {
    return HorizontalBarChart;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axis = require("@visx/axis");
var _shape = require("@visx/shape");
var _tooltip = require("@visx/tooltip");
var _scale = require("@visx/scale");
var _event = require("@visx/event");
var _utils = require("@indico-data/utils");
var _measurementRows = require("./MeasurementRows");
var _horizontalBarChartStyles = require("./HorizontalBarChart.styles");
var BAR_HEIGHT = 16;
var BAR_PADDING = 20;
var CHART_MARGIN_RIGHT = 40;
function HorizontalBarChart(props) {
    var _Math;
    var className = props.className, fontSize = props.fontSize, graphColor = props.graphColor, graphData = props.graphData, id = props.id, numTicks = props.numTicks, xAxisKey = props.xAxisKey, yAxisKey = props.yAxisKey;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), labelsWidth = _useState[0], setLabelsWidth = _useState[1];
    var _hookUtils_useMeasure = (0, _slicedToArray._)((0, _utils.hookUtils).useMeasure(), 2), chartSvgRef = _hookUtils_useMeasure[0], _hookUtils_useMeasure_ = _hookUtils_useMeasure[1], chartWidth = _hookUtils_useMeasure_.width; // accessors
    var getYAxisValue = function(d) {
        return d[yAxisKey];
    };
    var getXAxisValue = function(d) {
        return d[xAxisKey];
    }; // ensure we never have a negative value
    var xMax = (0, _react.useMemo)(function() {
        return Math.abs(chartWidth - labelsWidth - CHART_MARGIN_RIGHT);
    }, [
        chartWidth
    ]);
    var yMax = (0, _react.useMemo)(function() {
        return (BAR_HEIGHT + BAR_PADDING) * graphData.length + BAR_PADDING;
    }, [
        graphData
    ]);
    var maxCount = (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(graphData.map(getXAxisValue))); // limit # of lines to show so they don’t get out of control
    var verticalLinesToShow = numTicks || Math.floor(maxCount / 10);
    var _useTooltip = (0, _tooltip.useTooltip)(), tooltipData = _useTooltip.tooltipData, tooltipTop = _useTooltip.tooltipTop, tooltipLeft = _useTooltip.tooltipLeft, tooltipOpen = _useTooltip.tooltipOpen, hideTooltip = _useTooltip.hideTooltip, showTooltip = _useTooltip.showTooltip;
    var xAxisScale = (0, _react.useMemo)(function() {
        return (0, _scale.scaleLinear)({
            range: [
                0,
                xMax
            ],
            domain: [
                0,
                maxCount
            ]
        });
    }, [
        xMax
    ]);
    var yAxisScale = (0, _react.useMemo)(function() {
        return (0, _scale.scaleBand)({
            range: [
                yMax,
                0
            ],
            domain: graphData.map(getYAxisValue),
            padding: 0.1
        });
    }, [
        yMax
    ]); // textAnchor must be explicitly set in the component, because typescript
    // thinks it’s a string if declared here...
    var tickLabelProps = {
        fill: "currentColor",
        fontSize: fontSize
    };
    var commonAxisProps = {
        stroke: "currentColor",
        strokeWidth: 1
    };
    var horizontalAxis = function() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
            width: xMax,
            height: 16,
            style: {
                paddingLeft: labelsWidth,
                color: graphColor
            },
            overflow: "visible"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _axis.Axis), Object.assign({}, commonAxisProps, {
            top: -8,
            scale: xAxisScale,
            hideAxisLine: true,
            hideTicks: true,
            numTicks: verticalLinesToShow,
            tickLabelProps: function() {
                return Object.assign(Object.assign({}, tickLabelProps), {
                    textAnchor: "middle"
                });
            }
        })));
    };
    var handleTooltip = function(event, count, yPos) {
        var x = ((0, _event.localPoint)(event) || {
            x: 0
        }).x;
        var tooltipTop = yPos;
        var tooltipLeft = x + labelsWidth;
        showTooltip({
            tooltipData: count || 0,
            tooltipLeft: tooltipLeft,
            tooltipTop: tooltipTop
        });
    }; // measure the width of the Axis element so we can accommodate for it
    (0, _react.useLayoutEffect)(function() {
        var leftAxisElement = document.querySelector(".left-axis-container");
        var width = (leftAxisElement === null || leftAxisElement === void 0 ? void 0 : leftAxisElement.getBoundingClientRect().width) || 0;
        if (width > labelsWidth) setLabelsWidth(Math.max(width, 120));
    }, [
        labelsWidth
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        ref: chartSvgRef
    }, horizontalAxis(), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalBarChartStyles.StyledHorizontalBarChart), {
        className: "scrollable-vertical"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        width: xMax,
        height: yMax,
        overflow: "visible",
        style: {
            paddingLeft: labelsWidth,
            paddingRight: 40
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _measurementRows.MeasurementRows), {
        axisProps: commonAxisProps,
        color: graphColor,
        data: graphData,
        tickProps: tickLabelProps,
        verticalLinesToShow: verticalLinesToShow,
        xScale: xAxisScale,
        yAxisKey: yAxisKey,
        yMax: yMax,
        yScale: yAxisScale
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        transform: "translate(0, ".concat(BAR_HEIGHT / 2, ")")
    }, graphData.map(function(datum) {
        var count = getXAxisValue(datum);
        var barWidth = xAxisScale(count) || 0;
        var x = 0;
        var y = yAxisScale(getYAxisValue(datum)) || 0;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _shape.Bar), {
            key: "".concat(getYAxisValue(datum), "-").concat(count),
            x: x,
            y: y,
            width: barWidth,
            height: BAR_HEIGHT,
            fill: graphColor,
            onMouseMove: function(e) {
                return handleTooltip(e, count, y);
            },
            onMouseOut: function() {
                return hideTooltip();
            }
        });
    }))), tooltipOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _horizontalBarChartStyles.StyledTooltip), {
        top: tooltipTop,
        left: tooltipLeft,
        unstyled: true
    }, tooltipData)), horizontalAxis());
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","@visx/axis":"gF8iV","@visx/shape":"5XPpo","@visx/tooltip":"hiwzN","@visx/scale":"6Owz5","@visx/event":"N20PK","@indico-data/utils":"47VRj","./MeasurementRows":"hiBbE","./HorizontalBarChart.styles":"5WxjC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hiBbE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeasurementRows", function() {
    return MeasurementRows;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _axis = require("@visx/axis");
var _text = require("@visx/text");
var _tooltip = require("@visx/tooltip");
var _grid = require("@visx/grid");
var _horizontalBarChartStyles = require("./HorizontalBarChart.styles"); /**
                                                              * Provides left axis and vertical lines for the `HorizontalBarChart` component.
                                                              */ 
function MeasurementRows(param) {
    var axisProps = param.axisProps, color = param.color, data = param.data, tickProps = param.tickProps, verticalLinesToShow = param.verticalLinesToShow, xScale = param.xScale, yAxisKey = param.yAxisKey, yMax = param.yMax, yScale = param.yScale;
    var _useTooltipInPortal = (0, _tooltip.useTooltipInPortal)(), containerBounds = _useTooltipInPortal.containerBounds, TooltipInPortal = _useTooltipInPortal.TooltipInPortal;
    var _useTooltip = (0, _tooltip.useTooltip)(), showTooltip = _useTooltip.showTooltip, hideTooltip = _useTooltip.hideTooltip, tooltipData = _useTooltip.tooltipData, _useTooltip_tooltipLeft = _useTooltip.tooltipLeft, tooltipLeft = _useTooltip_tooltipLeft === void 0 ? 0 : _useTooltip_tooltipLeft, _useTooltip_tooltipTop = _useTooltip.tooltipTop, tooltipTop = _useTooltip_tooltipTop === void 0 ? 0 : _useTooltip_tooltipTop; // https://airbnb.io/visx/tooltip
    var handlePointerMove = (0, _react.useCallback)(function(event, value) {
        var containerX = ("clientX" in event ? event.clientX : 0) - containerBounds.left;
        var containerY = ("clientY" in event ? event.clientY : 0) - containerBounds.top;
        showTooltip({
            tooltipLeft: containerX,
            tooltipTop: containerY - 10,
            tooltipData: value
        });
    }, [
        showTooltip,
        containerBounds
    ]);
    var customTick = function() {
        var formattedValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", x = arguments.length > 1 ? arguments[1] : void 0, y = arguments.length > 2 ? arguments[2] : void 0;
        var className = data.find(function(datum) {
            return datum[yAxisKey] === formattedValue;
        }).className;
        var maxChars = 20;
        var trimmedValue = formattedValue.length <= maxChars ? formattedValue : formattedValue.substr(0, maxChars).concat("...");
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), Object.assign({}, tickProps, {
            className: className || "",
            x: x,
            y: y,
            dx: "-0.65em",
            dy: -1,
            textAnchor: "end",
            verticalAnchor: "middle",
            onPointerMove: function(e) {
                return handlePointerMove(e, formattedValue);
            },
            onPointerLeave: function() {
                return hideTooltip();
            }
        }), trimmedValue);
    };
    var tickLength = 7;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("g", {
        style: {
            color: color
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("line", Object.assign({
        x1: 0,
        y1: 1,
        x2: -tickLength,
        y2: 1
    }, axisProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement("line", Object.assign({
        x1: 0,
        y1: yMax,
        x2: -tickLength,
        y2: yMax
    }, axisProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement(TooltipInPortal, {
        style: (0, _horizontalBarChartStyles.tooltipStyles),
        left: tooltipLeft,
        top: tooltipTop
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "tooltip"
    }, tooltipData)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _axis.Axis), Object.assign({}, axisProps, {
        axisClassName: "left-axis-container",
        orientation: "left",
        left: 0,
        scale: yScale,
        numTicks: data.length,
        tickLength: tickLength,
        tickStroke: "currentColor",
        tickComponent: function(tickValues) {
            return customTick(tickValues.formattedValue, tickValues.x, tickValues.y);
        }
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _grid.GridColumns), {
        scale: xScale,
        height: yMax,
        numTicks: verticalLinesToShow,
        stroke: "currentColor",
        strokeOpacity: 0.4,
        pointerEvents: "none"
    }));
}

},{"react":"ktQNc","@visx/axis":"gF8iV","@visx/text":"jlEhs","@visx/tooltip":"hiwzN","@visx/grid":"5w0HZ","./HorizontalBarChart.styles":"5WxjC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5WxjC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHorizontalBarChart", function() {
    return StyledHorizontalBarChart;
});
parcelHelpers.export(exports, "tooltipStyles", function() {
    return tooltipStyles;
});
parcelHelpers.export(exports, "StyledTooltip", function() {
    return StyledTooltip;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _tooltip = require("@visx/tooltip");
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n\n  &.scrollable-vertical {\n    max-height: 330px;\n  }\n\n  .left-axis-container {\n    margin-left: 40px;\n\n    cursor: default;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledHorizontalBarChart = (0, _styledComponentsDefault.default).div(_templateObject());
var tooltipStyles = {
    pointerEvents: "none",
    position: "absolute",
    padding: "5px",
    fontSize: (0, _index.TYPOGRAPHY).fontSize.base,
    borderRadius: "5px",
    opacity: 0.9,
    backgroundColor: (0, _index.COLORS).ebony,
    color: (0, _index.COLORS).white
};
var StyledTooltip = (0, _styledComponentsDefault.default)((0, _tooltip.Tooltip))(_templateObject1(), tooltipStyles);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@visx/tooltip":"hiwzN","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ck1dH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordion", function() {
    return Accordion;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _accordionStyles = require("./Accordion.styles");
var Accordion = function(props) {
    var className = props.className, content = props.content, header = props.header, id = props.id, open = props.open, notes = props.notes;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _accordionStyles.StyledAccordion), {
        className: className,
        id: id,
        open: open,
        "data-cy": props["data-cy"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("summary", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "header-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        className: "toggle-icon",
        name: "chevron-up",
        size: [
            14
        ]
    }), header ? /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", null, header) : null, notes ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "header-container-notes"
    }, notes) : null)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "content"
    }, content));
};

},{"react":"ktQNc","Permafrost/index":"iliLC","./Accordion.styles":"7S4SE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7S4SE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAccordion", function() {
    return StyledAccordion;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  summary {\n    display: inherit;\n    padding: 0 12px;\n    cursor: pointer;\n  }\n\n  .header-container,\n  h2 {\n    display: flex;\n  }\n\n  .header-container-notes {\n    color: #8498b6;\n    font-size: 16px;\n    font-style: italic;\n    padding-top: 10px;\n    padding-left: 5px;\n  }\n\n  .header-container-notes:before {\n    content: ' - ';\n  }\n\n  .toggle-icon {\n    height: 24px;\n    margin: 6px 0;\n    border-radius: 50%;\n    transition: 0.3s transform ease-in-out;\n  }\n\n  h2 {\n    align-items: center;\n    margin: 0 0 0 8px;\n    font-size: 22px;\n  }\n\n  .content {\n    margin: 10px 0 10px 20px;\n  }\n\n  &[open] > summary .toggle-icon {\n    transform: rotate(180deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledAccordion = (0, _styledComponentsDefault.default).details(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Y9tlW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropList", function() {
    return DragDropList;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("@hello-pangea/dnd");
var _uuid = require("uuid");
var _dragDropListItem = require("./DragDropListItem");
var _dragDropListStyles = require("./DragDropList.styles");
var droppableId = (0, _uuid.v4)();
var DragDropList = function(param) {
    var items = param.items, onDragDropEnd = param.onDragDropEnd;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.DragDropContext), {
        onDragEnd: function(result) {
            var destination = result.destination, source = result.source;
            if (!destination || destination.index === source.index) return;
            else {
                var newItemsOrder = Array.from(items);
                var movedItem = newItemsOrder.splice(source.index, 1);
                newItemsOrder.splice(destination.index, 0, movedItem[0]);
                onDragDropEnd(newItemsOrder);
            }
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Droppable), {
        droppableId: droppableId
    }, function(provided) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragDropListStyles.StyledDragDropList), Object.assign({
            ref: provided.innerRef
        }, provided.droppableProps), items.map(function(item, index) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragDropListItem.DragDropListItem), {
                id: item.id,
                content: item.content,
                dragDisabled: item.dragDisabled,
                index: index,
                key: item.id
            });
        }), provided.placeholder);
    }));
};

},{"react":"ktQNc","@hello-pangea/dnd":"bhM3h","uuid":"6ZyFu","./DragDropListItem":"l1g4f","./DragDropList.styles":"bGzhr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"l1g4f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropListItem", function() {
    return DragDropListItem;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dnd = require("@hello-pangea/dnd");
var _index = require("Permafrost/index");
var _dragDropListStyles = require("./DragDropList.styles");
var DragDropListItem = function(param) {
    var id = param.id, content = param.content, dragDisabled = param.dragDisabled, index = param.index;
    var stringContent = typeof content === "string";
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Draggable), {
        draggableId: id,
        index: index,
        isDragDisabled: dragDisabled
    }, function(provided, snapshot) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragDropListStyles.StyledDragDropListItem), Object.assign({
            className: (0, _classnamesDefault.default)({
                "is-dragging": snapshot.isDragging,
                "drag-disabled": dragDisabled
            }),
            ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), !dragDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            className: "draggable-icon",
            name: "draggable",
            size: [
                20
            ]
        }) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _classnamesDefault.default)("draggable-content", {
                string: stringContent
            })
        }, content));
    });
};

},{"react":"ktQNc","classnames":"9xS9S","@hello-pangea/dnd":"bhM3h","Permafrost/index":"iliLC","./DragDropList.styles":"bGzhr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bGzhr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDragDropList", function() {
    return StyledDragDropList;
});
parcelHelpers.export(exports, "StyledDragDropListItem", function() {
    return StyledDragDropListItem;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  display: flex;\n  margin: 4px 0;\n\n  &.is-dragging {\n    background: ",
        ";\n  }\n\n  &.drag-disabled {\n    padding-left: 20px;\n  }\n\n  & .string {\n    padding: 20px 20px 20px 0;\n  }\n\n  .draggable-icon {\n    color: ",
        ";\n    margin: 20px;\n    overflow: visible;\n  }\n\n  .draggable-content {\n    width: 100%;\n  }\n\n  .draggable-content.string {\n    align-self: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledDragDropList = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledDragDropListItem = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).lightGray, (0, _index.COLORS).blueBayoux, (0, _index.COLORS).comet);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5u3cl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OldDragDropList", function() {
    return OldDragDropList;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _oldDragDropListItem = require("./OldDragDropListItem");
var _oldDragDropListStyles = require("./OldDragDropList.styles");
var OldDragDropList = function(props) {
    var id = props.id, _props_arrows = props.arrows, arrows = _props_arrows === void 0 ? true : _props_arrows, canDelete = props.canDelete, className = props.className, header = props.header, items = props.items, onAdd = props.onAdd, onDelete = props.onDelete, onEdit = props.onEdit, onMovedItem = props.onMovedItem, subHeader = props.subHeader, disabledDeleteTargets = props.disabledDeleteTargets;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), draggedItem = _useState[0], setDraggedItem = _useState[1]; // adding new items to the list
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), newItemOpen = _useState1[0], setNewItemOpen = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(""), 2), newValue = _useState2[0], setNewValue = _useState2[1]; // tracks whether a reordering arrow has been pressed, and which items are affected
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)([
        undefined,
        undefined
    ]), 2), swapItems = _useState3[0], setSwapItems = _useState3[1]; // updateItemOrder is called on arrow button up/down
    var updateItemOrder = function(param) {
        var destination = param.destination, source = param.source;
        if (destination === undefined || destination === source) return;
        setSwapItems([
            source,
            destination
        ]);
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items.map(function(item) {
            return item.name;
        }), source, destination);
        setTimeout(function() {
            onMovedItem(reorderedItems);
            setSwapItems([
                undefined,
                undefined
            ]);
        }, 300);
    };
    var addItem = function() {
        if (newValue !== "" && newValue.length >= 2) {
            var current = (0, _toConsumableArray._)(items.map(function(item) {
                return item.name;
            })).concat([
                newValue
            ]);
            onAdd && onAdd(current); // clear state and close “add item” input once added
            setNewValue("");
            setNewItemOpen(false);
        }
    };
    var editItem = function(itemToEdit, editedItem) {
        var current = (0, _toConsumableArray._)(items.map(function(item) {
            return item.name;
        }));
        var itemIndex = current.indexOf(itemToEdit);
        current[itemIndex] = editedItem;
        onEdit && onEdit(current);
    }; // determines reordering direction, and applies appropriate css class
    var animateDirection = function(itemIndex) {
        var sourceIndex = swapItems[0];
        var destIndex = swapItems[1];
        if (Number.isInteger(sourceIndex) && Number.isInteger(destIndex) && sourceIndex !== destIndex) {
            // @ts-ignore
            var direction = sourceIndex > destIndex ? "up" : "down";
            var itemIsSource = itemIndex === sourceIndex;
            var itemIsDest = itemIndex === destIndex;
            if (itemIsSource) return direction === "up" ? "animate-up" : "animate-down";
            if (itemIsDest) return direction === "up" ? "animate-down" : "animate-up";
        }
        return "";
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _oldDragDropListStyles.StyledOldDragDropList), {
        id: id,
        className: className,
        "data-cy": props["data-cy"],
        style: !header && !subHeader ? {
            borderLeft: "none"
        } : {}
    }, header && /*#__PURE__*/ (0, _reactDefault.default).createElement("h4", {
        className: "list-header t-bold",
        "data-testid": "main-header"
    }, header), subHeader && /*#__PURE__*/ (0, _reactDefault.default).createElement("h5", {
        className: "sub-header",
        "data-testid": "sub-header"
    }, subHeader), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.DragDropVerticalList), {
        itemIdList: items.map(function(item) {
            return item.name;
        }),
        items: items.map(function(item, i) {
            var _a;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _oldDragDropListItem.DragDropListItem), {
                key: item.id,
                arrows: arrows,
                canDelete: canDelete,
                className: (0, _classnamesDefault.default)(animateDirection(i)),
                disableDeleteTooltipText: (_a = disabledDeleteTargets === null || disabledDeleteTargets === void 0 ? void 0 : disabledDeleteTargets.find(function(disabledDeleteField) {
                    return disabledDeleteField.targetId === item.id;
                })) === null || _a === void 0 ? void 0 : _a.disableDeleteTooltipText,
                index: i,
                isDragging: item.name === draggedItem,
                item: item,
                listLength: items.length,
                onDelete: onDelete,
                onEdit: editItem,
                updateItemOrder: updateItemOrder
            });
        }),
        itemsVerticalGap: "3px",
        onDrop: onMovedItem,
        updateDraggedItem: setDraggedItem
    }), onAdd && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _oldDragDropListStyles.StyledAddItemContainer), {
        className: !newItemOpen ? "dash-border" : "solid-back"
    }, !newItemOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", Object.assign({
        className: "add-btn",
        onClick: function() {
            return setNewItemOpen(true);
        },
        "aria-label": "add list item"
    }, props === null || props === void 0 ? void 0 : props.addButtonProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "plus",
        size: [
            20
        ]
    })), newItemOpen && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({
        type: "text",
        autoFocus: true,
        className: "add-item-input",
        value: newValue,
        onChange: function(e) {
            return setNewValue(e.target.value);
        },
        onKeyDown: function(e) {
            if (e.key === "Enter" && !items.some(function(item) {
                return item.name === newValue;
            })) {
                e.preventDefault();
                addItem();
            }
        }
    }, props === null || props === void 0 ? void 0 : props.inputProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", Object.assign({
        "aria-label": "add new item",
        className: "confirm",
        onClick: function() {
            return addItem();
        },
        disabled: newValue === "" || newValue.length < 2 || items.some(function(item) {
            return item.name === newValue;
        })
    }, props === null || props === void 0 ? void 0 : props.confirmButtonProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "check",
        size: [
            18
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        "aria-label": "cancel new item",
        className: "cancel",
        onClick: function() {
            setNewItemOpen(false);
            setNewValue("");
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "x-close",
        size: [
            16
        ]
    })))));
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./OldDragDropListItem":"7FbMi","./OldDragDropList.styles":"4ez7y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7FbMi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropListItem", function() {
    return DragDropListItem;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _oldDragDropListStyles = require("./OldDragDropList.styles");
var DragDropListItem = function(param) {
    var arrows = param.arrows, canDelete = param.canDelete, className = param.className, index = param.index, isDragging = param.isDragging, item = param.item, listLength = param.listLength, disableDeleteTooltipText = param.disableDeleteTooltipText, onDelete = param.onDelete, // onEdit,
    updateItemOrder = param.updateItemOrder;
    // tracks whether an arrow has been pressed on this item
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), confirmDelete = _useState1[0], setConfirmDelete = _useState1[1];
    (0, _react.useEffect)(function() {
        setActive(false);
    }, [
        index
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _oldDragDropListStyles.StyledDragDropListItem), {
        className: (0, _classnamesDefault.default)(className, {
            dragging: isDragging,
            active: active
        }),
        style: {
            backgroundColor: confirmDelete ? "".concat((0, _index.COLORS).oxfordBlue, "80") : "".concat((0, _index.COLORS).oxfordBlue)
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "list-item-text",
        style: {
            color: confirmDelete ? "".concat((0, _index.COLORS).defaultFontColor, "80") : "".concat((0, _index.COLORS).defaultFontColor)
        }
    }, item.name), !confirmDelete && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "list-buttons"
    }, onDelete && canDelete ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, disableDeleteTooltipText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        for: "delete-container-".concat(item.id)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, disableDeleteTooltipText)) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        "data-for": "delete-container-".concat(item.id),
        "data-tip": true,
        "data-testid": "div--delete-btn-".concat(item.name)
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "delete",
        onClick: function() {
            return setConfirmDelete(true);
        },
        disabled: !!disableDeleteTooltipText
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "trash",
        size: [
            18
        ]
    })))) : null, arrows && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "aria-label": "move item up",
        className: "arrow-up",
        disabled: index === 0,
        onClick: function() {
            setActive(true);
            updateItemOrder({
                destination: index--,
                source: index
            });
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-arrow-up",
        size: [
            22
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "aria-label": "move item down",
        className: "arrow-down",
        disabled: index === listLength - 1,
        onClick: function() {
            setActive(true);
            updateItemOrder({
                destination: index++,
                source: index
            });
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-arrow-down",
        size: [
            22
        ]
    })))), confirmDelete && onDelete && canDelete ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "confirm-delete-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Are you sure?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "data-testid": "btn--confirm-delete-label",
        className: "confirm",
        onClick: function() {
            return onDelete(item.id);
        },
        style: {
            opacity: isDragging ? "0.5" : ""
        }
    }, "Yes, Delete It"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "data-testid": "btn--decline-delete-label",
        className: "cancel",
        onClick: function() {
            return setConfirmDelete(false);
        },
        style: {
            opacity: isDragging ? "0.5" : ""
        }
    }, "No, Keep It")) : null);
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./OldDragDropList.styles":"4ez7y","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4ez7y":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledOldDragDropList", function() {
    return StyledOldDragDropList;
});
parcelHelpers.export(exports, "StyledDragDropListItem", function() {
    return StyledDragDropListItem;
});
parcelHelpers.export(exports, "StyledAddItemContainer", function() {
    return StyledAddItemContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-left: solid 3px ",
        ";\n  padding: 8px;\n  margin-bottom: 20px;\n\n  .list-header {\n    margin-bottom: 15px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: flex;\n\n  align-items: center;\n  justify-content: space-between;\n\n  height: 36px;\n  transition: background-color 0.3s, transform 0.25s;\n\n  &.dragging,\n  &.active {\n    background-color: ",
        " !important;\n  }\n\n  // 39px = item height + vertical margin\n  &.animate-up {\n    transform: translate(0, -39px);\n  }\n\n  &.animate-down {\n    transform: translate(0, 39px);\n  }\n\n  &.animate-up,\n  &.animate-down {\n    &:not(.active) {\n      // ensures clicked item remains visually on top during movement\n      z-index: -1;\n    }\n  }\n\n  .list-item-text {\n    margin-left: 16px;\n    font-size: 14px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .confirm-delete-container {\n    display: flex;\n    align-items: center;\n\n    .confirm,\n    .cancel {\n      color: white;\n      box-shadow: none;\n      height: 36px;\n    }\n\n    .confirm {\n      margin-left: 16px;\n      background-color: ",
        ";\n    }\n\n    .cancel {\n      margin-left: 8px;\n      background-color: ",
        ";\n    }\n  }\n\n  .list-buttons {\n    display: flex;\n    margin-left: 10px;\n    justify-content: flex-end;\n\n    Button {\n      padding: 0;\n      background: none;\n      box-shadow: none;\n      color: ",
        ";\n\n      &:disabled {\n        opacity: 0.2;\n      }\n    }\n\n    .arrow-down {\n      margin-left: 8px;\n      margin-right: 12px;\n    }\n\n    .arrow-up {\n      margin-left: 12px;\n    }\n\n    .edit {\n      margin-left: 18px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  // visually 3px, but it abuts a negative margin, so...\n  margin-top: 6px;\n\n  .add-item-input {\n    background-color: ",
        ";\n    margin: 0;\n  }\n\n  .add-btn,\n  .confirm,\n  .cancel {\n    height: 30px;\n    margin-top: 2px;\n    padding: 0;\n  }\n\n  .confirm,\n  .cancel {\n    width: 33px;\n    border-radius: 50%;\n    margin-right: 6px;\n    color: ",
        ";\n  }\n\n  .confirm {\n    background-color: ",
        ";\n\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  .cancel {\n    background-color: ",
        ";\n  }\n\n  .add-btn {\n    width: 100%;\n    color: ",
        ";\n    background: none;\n    box-shadow: none;\n  }\n\n  &.dash-border {\n    border: 1px dashed ",
        ";\n    border-radius: 3px;\n  }\n\n  &.solid-back {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledOldDragDropList = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).defaultFontColor);
var StyledDragDropListItem = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _index.COLORS).mediumGray, (0, _index.COLORS).red, (0, _index.COLORS).green, (0, _index.COLORS).defaultFontColor);
var StyledAddItemContainer = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).white, (0, _index.COLORS).green, (0, _index.COLORS).red, (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.COLORS).oxfordBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ad563":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Icon", function() {
    return Icon;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _faIcons = require("./faIcons");
var _indicons = require("./indicons");
var _partnerIcons = require("./partnerIcons");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var allIcons = Object.assign(Object.assign(Object.assign({}, (0, _faIcons.faIcons)), (0, _indicons.indicons)), (0, _partnerIcons.partnerIcons)); /**
                                                                                                    * Generic icon component, hidden from Assistive Technology by default.
                                                                                                    * If icon should be available to AT, pass the desired name into the `ariaLabel` prop.
                                                                                                    */ 
function Icon(_a) {
    var _b;
    var _a_style = _a.style, style = _a_style === void 0 ? {} : _a_style, props = __rest(_a, [
        "style"
    ]);
    var ariaLabel = props.ariaLabel ? {
        "aria-label": props.ariaLabel
    } : {
        "aria-hidden": true,
        focusable: false
    };
    var iconComponentProps = ((_b = allIcons[props.name]) === null || _b === void 0 ? void 0 : _b.props) || null;
    var dimensions = props.size && props.size.length > 0 ? returnDimensions(props.size) : {
        width: "1em",
        height: "1em"
    };
    if (!iconComponentProps) {
        console.error("".concat(props.name, " is not a valid icon name."));
        return null;
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", Object.assign({}, iconComponentProps, ariaLabel, dimensions, {
        role: "img",
        className: props.className,
        "data-cy": props["data-cy"],
        "data-testid": props["data-testid"],
        fill: props.fill || "currentColor",
        id: props.id,
        style: style,
        onClick: props.onClick
    }));
}
function returnDimensions(sizeProp) {
    if (sizeProp.length > 1) return {
        width: sizeProp[0],
        height: sizeProp[1]
    };
    return {
        width: sizeProp[0],
        height: sizeProp[0]
    };
}

},{"react":"ktQNc","./faIcons":"2E3tr","./indicons":"i9WOp","./partnerIcons":"iKD0d","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9Y645":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderValues", function() {
    return 0, _headerValues.HeaderValues;
});
var _headerValues = require("./HeaderValues");

},{"./HeaderValues":"7WIwY","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7WIwY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeaderValues", function() {
    return HeaderValues;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _headerValuesStyles = require("./HeaderValues.styles"); /**
                                                                          * Found on item detail pages. Generates a styled list of ids and/or links
                                                                          * related to the current item.
                                                                          */ 
function HeaderValues(props) {
    var values = props.values, links = props.links, className = props.className, id = props.id;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerValuesStyles.StyledHeaderValues), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, values === null || values === void 0 ? void 0 : values.map(function(value) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerValuesStyles.StyledValue), {
            key: "".concat(value.text, "-").concat(value.value),
            "data-cy": value["data-cy"]
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "header-text"
        }, value.text, ": "), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: "header-value"
        }, " ", value.value));
    }), links === null || links === void 0 ? void 0 : links.map(function(link) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: "".concat(link.text, "-").concat(link.to),
            "data-cy": link["data-cy"]
        }, !link.isDisabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Link), {
            to: link.to
        }, link.text) : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, link.text));
    }));
}

},{"react":"ktQNc","react-router-dom":"6Au42","./HeaderValues.styles":"2Rj8d","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2Rj8d":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledValue", function() {
    return StyledValue;
});
parcelHelpers.export(exports, "StyledHeaderValues", function() {
    return StyledHeaderValues;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  align-items: center;\n  display: flex;\n\n  .header-text {\n    font-weight: bold;\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  li:not(:last-of-type) {\n    padding-right: 10px;\n    margin-right: 10px;\n    max-height: 22px;\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledValue = (0, _styledComponentsDefault.default).li(_templateObject());
var StyledHeaderValues = (0, _styledComponentsDefault.default).ul(_templateObject1(), (0, _index.COLORS).blueBayoux);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dVujS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListTable", function() {
    return 0, _listTable.ListTable;
});
var _listTable = require("./ListTable");

},{"./ListTable":"kOKNw","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kOKNw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListTable", function() {
    return ListTable;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _index = require("Permafrost/index");
var _header = require("./Header");
var _listTableStyles = require("./ListTable.styles");
var ListTable = function(props) {
    var _a, _b;
    var header = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _header.Header), {
        selectProps: {
            "data-cy": "dataset--sort-by-select"
        },
        title: props.title,
        headerComponent: props.headerComponent,
        sortBy: props.sortBy,
        aggregateCount: ((_b = (_a = props === null || props === void 0 ? void 0 : props.pagination) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.aggregateCount) || props.totalCount,
        flagText: props.flagText,
        hasFlagMessage: props.flagMessage ? true : false
    });
    var RenderList = function() {
        if (props.loading) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingList), null);
        if (props.error) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.SectionBody), {
            className: "error-shrug"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Shrug), {
            message: props.errorMessage || "Sorry, there was an error retrieving this data"
        }));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, props.listItems.length === 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.SectionBody), {
            className: "error-shrug"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Shrug), {
            message: props.emptyListMessage || "No results found"
        })) : /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", {
            className: "list-container"
        }, props.listItems.map(function(li) {
            var key = (0, _uuid.v4)();
            return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
                className: "list-item",
                key: key
            }, li);
        })), props.pagination ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Pagination), {
            limit: props.pagination.limit,
            pageInfo: props.pagination.pageInfo,
            currentPage: props.pagination.currentPage,
            getPage: props.pagination.getPage,
            getPreviousPage: props.pagination.getPreviousPage,
            getNextPage: props.pagination.getNextPage,
            quantity: props.listItems.length
        }) : null);
    };
    var list = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listTableStyles.StyledListTable), null, props.flagMessage ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        className: "ListTable__flag-message"
    }, props.flagMessage) : null, props.subTitle ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "sub-title"
    }, typeof props.subTitle === "string" ? /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        style: {
            maxWidth: "75%"
        }
    }, props.subTitle) : props.subTitle) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "list"
    }, !props.error ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "list-header-container"
    }, props.listHeader) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement(RenderList, null)));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listTableStyles.StyledListTable), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id
    }, props.accordion ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Accordion), {
        header: header,
        content: list,
        open: props.accordionDefaultOpen
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, header, list));
};
exports.default = ListTable;

},{"react":"ktQNc","uuid":"6ZyFu","Permafrost/index":"iliLC","./Header":"lMdtJ","./ListTable.styles":"boFho","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lMdtJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", function() {
    return 0, _header.Header;
});
var _header = require("./Header");

},{"./Header":"9K6HB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9K6HB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", function() {
    return Header;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _headerStyles = require("./Header.styles");
var Header = function(props) {
    var title = props.title, headerComponent = props.headerComponent, sortBy = props.sortBy, aggregateCount = props.aggregateCount, flagText = props.flagText, hasFlagMessage = props.hasFlagMessage;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headerStyles.StyledHeader), {
        className: (0, _classnamesDefault.default)({
            "flag-message": hasFlagMessage
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "title-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("h2", {
        className: "title"
    }, title), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "count"
    }, aggregateCount ? (0, _utils.numberUtils).numberWithCommas(aggregateCount) : null), flagText ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Flag), {
        className: "Header__flag",
        text: flagText
    }) : null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "controls-container"
    }, headerComponent ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "header-component"
    }, headerComponent) : null, sortBy ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "sort-by"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.BorderSelect), Object.assign({
        label: "Sort By",
        value: sortBy.value,
        options: sortBy.items,
        onChange: function(e) {
            sortBy.onSort(e.target.value);
        },
        horizontal: true
    }, props.selectProps)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        "data-cy": "dataset--sort-by-btn",
        onClick: function() {
            return sortBy.updateDescending();
        },
        variant: "no-style",
        className: "button-sort-direction"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-arrow-down",
        ariaLabel: "descending",
        size: [
            16
        ],
        style: {
            transform: sortBy.descending ? "" : "rotate(180deg)"
        }
    }))) : null));
};

},{"react":"ktQNc","@indico-data/utils":"47VRj","classnames":"9xS9S","Permafrost/index":"iliLC","./Header.styles":"b8Q9h","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"b8Q9h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHeader", function() {
    return StyledHeader;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 42px;\n  margin-bottom: 12px;\n\n  .title {\n    font-size: 22px;\n    margin: 0;\n  }\n\n  .count {\n    font-size: 18px;\n    margin: 4px 0 0 10px;\n  }\n\n  .title-container,\n  .controls-container,\n  .sort-by {\n    display: inherit;\n  }\n\n  .sort-by {\n    margin-left: 10px;\n\n    label,\n    .button-sort-direction,\n    .button-sort-direction:focus {\n      color: ",
        ";\n    }\n\n    label {\n      font-weight: normal;\n    }\n\n    .button-sort-direction {\n      margin-left: 10px;\n\n      svg {\n        position: relative;\n        bottom: 3px;\n        transition: 0.3s transform ease-in-out;\n      }\n    }\n  }\n\n  .select-container {\n    box-sizing: border-box;\n\n    .selectCaret {\n      color: ",
        ";\n      height: 16px;\n      width: 16px;\n      margin: 0;\n    }\n  }\n\n  .Header__flag {\n    margin: 3px 0 0 10px;\n  }\n\n  &.flag-message {\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledHeader = (0, _styledComponentsDefault.default).header(_templateObject(), (0, _index.COLORS).lightFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"boFho":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListTable", function() {
    return StyledListTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .list {\n    .list-header-container,\n    .list-container .list-item {\n      border-bottom: solid ",
        " 1px;\n      padding: 0 20px 10px 20px;\n      margin-bottom: 10px;\n    }\n\n    .list-header-container {\n      border-bottom-color: ",
        ";\n    }\n\n    .list-container .list-item {\n      font-size: 14px;\n\n      & > * div {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .sub-title {\n    margin-bottom: 20px;\n  }\n\n  summary,\n  summary h2 {\n    width: 100%;\n  }\n\n  summary .header-container {\n    svg {\n      margin-top: 2px;\n    }\n\n    .header-component div {\n      padding: 0;\n    }\n  }\n\n  summary .title-container {\n    margin-bottom: 2px;\n\n    .title {\n      align-items: flex-start;\n\n      h2 {\n        margin-left: 0;\n      }\n    }\n\n    .count {\n      color: ",
        ";\n    }\n  }\n\n  summary .sort-by .button-sort-direction svg {\n    bottom: 5px;\n  }\n\n  .content {\n    margin-top: 0 !important;\n  }\n\n  .error-shrug {\n    margin: 0 20px;\n    background-color: ",
        ";\n  }\n\n  .ListTable__flag-message {\n    color: ",
        ";\n    margin-bottom: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListTable = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).blueBayoux, (0, _index.COLORS).baliHai, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).yellowOrange);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fva6N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadingAwareContainer", function() {
    return LoadingAwareContainer;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _loadingAwareContainerStyles = require("./LoadingAwareContainer.styles"); /**
                                                                                                      * A functional container for content that is yet to load or will change; displays a loading indicator and announces
                                                                                                      * to Assistive Technology as needed.
                                                                                                      *
                                                                                                      * todo: this is an extremely simple version of this component; as I get more familiar with LoadingIndicator use cases, this will be refactored. - jm 9/1/2020
                                                                                                      */ 
function LoadingAwareContainer(props) {
    var children = props.children, className = props.className, isLoading = props.isLoading, style = props.style;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingAwareContainerStyles.StyledLoadingAwareContainer), {
        className: (0, _classnamesDefault.default)({
            loading: isLoading
        }, className),
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingAwareContainerStyles.StyledStatusContainer), {
        role: "status"
    }, isLoading && "Loading"), isLoading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingIndicator), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children));
}

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./LoadingAwareContainer.styles":"6Syyz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6Syyz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledStatusContainer", function() {
    return StyledStatusContainer;
});
parcelHelpers.export(exports, "StyledLoadingAwareContainer", function() {
    return StyledLoadingAwareContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: absolute;\n  height: 0;\n  width: 0;\n  opacity: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledStatusContainer = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledLoadingAwareContainer = (0, _styledComponentsDefault.default).div(_templateObject1());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iGXXw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logo", function() {
    return Logo;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _logoStyles = require("./Logo.styles"); /**
                                             * Displays the Indico logo treatment, either the logotype or logomark.
                                             *
                                             * The logotype is shown by default, unless the `logomark` property is true.
                                             */ 
function Logo(props) {
    var logomark = props.logomark, width = props.width;
    var logoWidth = width ? width : logomark ? 25 : 120;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _logoStyles.StyledLogo), {
        viewBox: logomark ? "0 0 102 102" : "0 0 202 73",
        height: logomark ? logoWidth : logoWidth * 0.35833333,
        width: logoWidth
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("title", null, "Indico Data"), logomark ? /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M58.5 43.6H43.7v14.8h14.8V43.6zm-36.9 0C25 30.6 36.8 20.9 51 20.9s26 9.7 29.4 22.8h20.3C97.1 19.6 76.2 1 51 1 25.8 1 4.9 19.6 1.3 43.6h20.3zm58.7 14.8C77 71.4 65.1 81.1 51 81.1c-14.1 0-26-9.7-29.3-22.7H1.3C5 82.5 25.8 101 51 101c25.2 0 46-18.5 49.7-42.6H80.3z",
        className: "logomark"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M115 71.5h-8.7V50.3h8.7c5.9 0 10.6 4.8 10.6 10.6s-4.7 10.6-10.6 10.6zm-3.9-4.8h3.9c3.2 0 5.8-2.6 5.8-5.8s-2.6-5.8-5.8-5.8h-3.9v11.6zM173 50.3h-16.5v4.5h5.8v16.8h4.8V54.7h5.8l.1-4.4zm-34.3 0L131 71.5h5.1l1.3-3.5h8.3l1.3 3.5h5.1l-7.7-21.2h-5.7zm.3 13.2l2.5-7 2.5 7h-5zm46.6-13.2l-7.7 21.2h5.1l1.3-3.5h8.3l1.3 3.5h5.1l-7.7-21.2h-5.7zm.3 13.2l2.5-7 2.5 7h-5z",
        className: "data"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        d: "M9.3 1.4v41.3H1V1.4h8.3zm133.2 41.5c5.6 0 10.9-2.2 14.8-6.2l-5.9-5.9c-2.4 2.4-5.6 3.7-9 3.7s-6.5-1.3-8.9-3.7-3.7-5.5-3.7-8.9 1.3-6.6 3.7-9c4.9-4.9 13-5 17.9-.1l5.9-5.9c-8-8-21.3-7.9-29.5.3-4 4-6.2 9.2-6.2 14.8s2.2 10.9 6.1 14.8c3.9 4 9.2 6.1 14.8 6.1zM100.3 22c0-11.4-9.3-20.6-20.7-20.6H62.9v41.2h16.8c11.3 0 20.6-9.3 20.6-20.6zM71.2 9.7h8.4C86.4 9.7 92 15.2 92 22s-5.5 12.3-12.3 12.3h-8.4l-.1-24.6zm112.1 9.2h-6.2v6.2h6.2v-6.2zm-77 6.2v17.5h8.3V25.1h-8.3zm8.4-6.2V1.4h-8.3V19h8.3v-.1zm53.2 0c1.4-5.5 6.4-9.5 12.3-9.5s10.9 4.1 12.3 9.5h8.5C199.5 8.8 190.7 1 180.2 1s-19.3 7.8-20.8 17.9h8.5zm24.6 6.2c-1.4 5.4-6.4 9.5-12.3 9.5s-10.9-4-12.3-9.5h-8.5c1.5 10.1 10.3 17.8 20.8 17.8s19.3-7.8 20.8-17.8h-8.5zM46.3 1.4v28.1L26.7 1.4h-9.2v41.3h8.3v-28l19.5 28h9.3V1.4h-8.3z",
        className: "indico"
    })));
}

},{"react":"ktQNc","./Logo.styles":"1v5OK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1v5OK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLogo", function() {
    return StyledLogo;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .indico,\n  .logomark {\n    transition: fill 0.2s;\n  }\n\n  .indico {\n    fill: var(",
        ");\n  }\n\n  .logomark,\n  .data {\n    fill: var(",
        ");\n  }\n\n  &:hover {\n    //  .indico {\n    //    fill: var(--logo-color-secondary);\n    //  }\n    //\n    .logomark {\n      fill: var(",
        ");\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLogo = (0, _styledComponentsDefault.default).svg(_templateObject(), (0, _index.colorProperties).logoPrimary, (0, _index.colorProperties).logoSecondary, (0, _index.colorProperties).logoPrimary);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iZ9bE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return Pagination;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var _paginationStyles = require("./Pagination.styles");
function Pagination(props) {
    //   renderPreviousPages = (currentPage, lastPage) => {
    //     if (currentPage === lastPage - 2) {
    //       return null
    //     }
    //     // this.props.getPage(endCursor, 1)
    //     if (currentPage === lastPage - 1) {
    //       return <>{lastPage - 2 >= 1 && <button onClick={() => this.props.getBeforePage(startCursor, )}>{lastPage - 2}</button>}</>
    //     }
    //     if (currentPage === lastPage) {
    //       return (
    //         <>
    //           {lastPage - 2 >= 1 && <button>{lastPage - 2}</button>}
    //           {lastPage - 1 >= 1 && <button>{lastPage - 1}</button>}
    //         </>
    //       )
    //     }
    //   }
    var _props_pageInfo = props.pageInfo, aggregateCount = _props_pageInfo.aggregateCount, hasNextPage = _props_pageInfo.hasNextPage, endCursor = _props_pageInfo.endCursor, startCursor = _props_pageInfo.startCursor;
    var currentPage = props.currentPage, limit = props.limit, quantity = props.quantity;
    var lastPage = Math.ceil(aggregateCount / limit);
    var currentItemNumber = (currentPage - 1) * limit + 1;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledPagination), {
        className: props.className,
        "data-cy": props["data-cy"],
        id: props.id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "Pagination--stats"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Showing", " ", aggregateCount === 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, currentItemNumber, " - ", currentItemNumber + quantity - 1, " of", " "), (0, _utils.numberUtils).numberWithCommas(aggregateCount), " entries")), aggregateCount > limit && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "Pagination--button-group",
        "data-cy": "Pagination--button-group"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        "data-cy": "pagination--label"
    }, "Page:\xa0"), currentPage > 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPreviousPage(startCursor);
        }
    }, "Prev"), /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
        "data-cy": "pagination--current-page"
    }, currentPage), lastPage > currentPage + 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPage(endCursor, 1);
        },
        "data-cy": "pagination--second-page-number"
    }, currentPage + 1), lastPage > currentPage + 2 && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPage(endCursor, 2);
        },
        "data-cy": "pagination--third-page-number"
    }, currentPage + 2), lastPage > currentPage + 3 && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPage(endCursor, 3);
        }
    }, currentPage + 3), lastPage - (currentPage + 2) === 3 && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPage(endCursor, 4);
        }
    }, currentPage + 4), lastPage - (currentPage + 2) > 2 && lastPage - (currentPage + 2) !== 3 && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "..."), lastPage !== currentPage && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getPage(endCursor, lastPage - currentPage);
        },
        "data-cy": "pagination--last-page"
    }, lastPage), hasNextPage && /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        onClick: function() {
            return props.getNextPage(endCursor);
        },
        "data-cy": "pagination--next-page-number"
    }, "Next")));
}

},{"react":"ktQNc","@indico-data/utils":"47VRj","./Pagination.styles":"dXzMB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dXzMB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPagination", function() {
    return StyledPagination;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  position: relative;\n\n  .Pagination--stats {\n    display: inline-block;\n    padding: 10px 0;\n    line-height: 1.6;\n  }\n\n  .Pagination--button-group {\n    display: flex;\n    justify-content: flex-end;\n    width: calc(25% + ",
        ");\n    padding: 10px ",
        " 10px 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    > * {\n      display: inline-block;\n      font-size: 18px;\n      vertical-align: middle;\n      margin-right: 8px;\n    }\n\n    button {\n      width: auto;\n      padding: 0;\n      display: inline-block;\n      background: none;\n      box-shadow: none;\n      text-decoration: underline;\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &.Pagination--non-click {\n        text-decoration: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var paddingRight = "30px";
var StyledPagination = (0, _styledComponentsDefault.default).div(_templateObject(), paddingRight, paddingRight, (0, _index.COLORS).midFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jjBSG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaginationWithoutQuery", function() {
    return PaginationWithoutQuery;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _pagination = require("../Pagination/Pagination");
var PaginationWithoutQuery = function(param) {
    var limit = param.limit, resetPaginationOnChange = param.resetPaginationOnChange, values = param.values, onChange = param.onChange;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(1), 2), currentPage = _useState[0], setCurrentPage = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({
        start: 0,
        end: limit
    }), 2), cursors = _useState1[0], setCursors = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(0), 2), paginatedValuesLength = _useState2[0], setPaginatedValuesLength = _useState2[1]; // Passes back the updated paginated list when currentPage or master values is changed, also sets length of current paginated list to render correct controls
    (0, _react.useEffect)(function() {
        var updatedPaginatedValues = values === null || values === void 0 ? void 0 : values.slice(cursors.start, cursors.end);
        setPaginatedValuesLength(updatedPaginatedValues === null || updatedPaginatedValues === void 0 ? void 0 : updatedPaginatedValues.length);
        onChange(updatedPaginatedValues);
    }, [
        cursors,
        currentPage,
        values
    ]); // Resets pagination to page1 when resetPaginationOnChange is updated - intended to be used for filters/sorting on the master list
    (0, _react.useEffect)(function() {
        if (!(resetPaginationOnChange === null || resetPaginationOnChange === void 0 ? void 0 : resetPaginationOnChange.length)) return;
        setCurrentPage(1);
        setCursors({
            start: 0,
            end: limit
        });
    }, resetPaginationOnChange);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pagination.Pagination), {
        currentPage: currentPage,
        limit: limit,
        pageInfo: {
            aggregateCount: values === null || values === void 0 ? void 0 : values.length,
            endCursor: cursors.end,
            hasNextPage: cursors.end < (values === null || values === void 0 ? void 0 : values.length),
            startCursor: cursors.start
        },
        quantity: paginatedValuesLength,
        getPage: function(startCursor, endCursor) {
            setCurrentPage(currentPage + endCursor);
            setCursors({
                start: startCursor + limit * (endCursor - 1),
                end: startCursor + limit * endCursor
            });
        },
        getNextPage: function(cursor) {
            setCurrentPage(currentPage + 1);
            setCursors({
                start: cursor,
                end: cursor + limit
            });
        },
        getPreviousPage: function(cursor) {
            setCurrentPage(currentPage - 1);
            setCursors({
                start: cursor - limit,
                end: cursor
            });
        }
    });
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","../Pagination/Pagination":"iZ9bE","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1vfn9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReorderableList", function() {
    return 0, _reorderableList.ReorderableList;
});
parcelHelpers.export(exports, "ListItem", function() {
    return 0, _listItem.ListItem;
});
parcelHelpers.export(exports, "useListItem", function() {
    return 0, _listItem.useListItem;
});
parcelHelpers.export(exports, "useListControls", function() {
    return 0, _reorderableList.useListControls;
});
parcelHelpers.export(exports, "ListControls", function() {
    return 0, _listControls.ListControls;
});
var _reorderableList = require("./ReorderableList");
var _listItem = require("./ListItem/ListItem");
var _listControls = require("./ListControls/ListControls");

},{"./ReorderableList":"cOSUs","./ListItem/ListItem":"43bEU","./ListControls/ListControls":"eZFIa","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cOSUs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReorderableList", function() {
    return ReorderableList;
});
parcelHelpers.export(exports, "useListControls", function() {
    return useListControls;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _uuid = require("uuid");
var _dnd = require("@hello-pangea/dnd");
var _utils = require("@indico-data/utils");
var _index = require("./index");
var _useItemSwap = require("./useItemSwap");
var droppableId = (0, _uuid.v4)();
var ListControlsContext = /*#__PURE__*/ (0, _react.createContext)({});
ListControlsContext.displayName = "ReorderableListControls"; /**
                                                              * Vertical list that may be reordered by drag-and-drop action, or programmatically by either
                                                              * including `<ListControls>` in the custom component to be passed in (`ListItemComponent`), or
                                                              * by using the `useListItem` Context hook directly - see `ListItemContextType` at the bottom
                                                              * of this file for a list of the props available from the hook.
                                                              *
                                                              * @see {@link https://reactjs.org/docs/context.html}
                                                              */ 
function ReorderableList(props) {
    var className = props.className, id = props.id, items = props.items, _props_itemsVerticalGap = props.itemsVerticalGap, itemsVerticalGap = _props_itemsVerticalGap === void 0 ? 0 : _props_itemsVerticalGap, listControls = props.listControls, onDelete = props.onDelete, onReorder = props.onReorder, _props_swapDuration = props.swapDuration, swapDuration = _props_swapDuration === void 0 ? 250 : _props_swapDuration, ListItemComponent = props.ListItemComponent;
    var _useItemSwap1 = (0, _useItemSwap.useItemSwap)(), addItemHeight = _useItemSwap1.addItemHeight, clearSwapAnimations = _useItemSwap1.clearSwapAnimations, setSwapAnimations = _useItemSwap1.setSwapAnimations, swapAnimations = _useItemSwap1.swapAnimations;
    var handleDelete = function(itemId) {
        var itemIndex = items.findIndex(function(item) {
            return itemId === item.id;
        });
        var updatedItems = (0, _utils.arrayUtils).deleteItem(items, itemIndex);
        onReorder(updatedItems);
        onDelete && onDelete(updatedItems);
    }; // only ever called as a result of a Drop action
    var handleDragEnd = function(result) {
        if (!result.destination || result.destination.index === result.source.index) return;
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items, result.source.index, result.destination.index);
        onReorder(reorderedItems);
    }; // called when programmatically changing order, e.g. pressing an up/down arrow button in `ListControls`
    var handleMoveItem = function(sourceId, direction) {
        var sourceIndex = items.findIndex(function(item) {
            return item.id === sourceId;
        });
        if (sourceIndex === 0 && direction === "up" || sourceIndex === items.length && direction === "down") return;
        var destinationIndex = direction === "up" ? sourceIndex - 1 : sourceIndex + 1;
        var destinationId = items[destinationIndex].id;
        setSwapAnimations(sourceId, destinationId, direction);
        var reorderedItems = (0, _utils.arrayUtils).reorderItem(items, sourceIndex, destinationIndex);
        setTimeout(function() {
            onReorder(reorderedItems);
            clearSwapAnimations();
        }, swapDuration + 100); // jank protection: wait an extra 100ms before the css classes are removed
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.DragDropContext), {
        onDragEnd: handleDragEnd
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Droppable), {
        droppableId: droppableId
    }, function(provided) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", Object.assign({
            ref: provided.innerRef,
            className: className,
            "data-cy": props["data-cy"],
            id: id
        }, provided.droppableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement(ListControlsContext.Provider, {
            value: Object.assign({}, listControls)
        }, items.map(function(item, i) {
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.ListItem), {
                animating: swapAnimations.has(item.id) ? swapAnimations.get(item.id) : null,
                addItemHeight: addItemHeight,
                key: item.id,
                deleteItem: handleDelete,
                item: item,
                index: i,
                itemsVerticalGap: itemsVerticalGap,
                listLength: items.length,
                moveItem: function(direction) {
                    return handleMoveItem(item.id, direction);
                },
                swapDuration: swapDuration,
                InnerComponent: ListItemComponent
            });
        })), provided.placeholder);
    }));
}
function useListControls() {
    return (0, _react.useContext)(ListControlsContext);
}

},{"react":"ktQNc","uuid":"6ZyFu","@hello-pangea/dnd":"bhM3h","@indico-data/utils":"47VRj","./index":"1vfn9","./useItemSwap":"5oJk9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5oJk9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Stores item heights, and returns necessary values for swap animations. When two items of
 * different heights are exchanging position (i.e. “swapping”), each item needs to move the distance
 * equal to the height of the item it is replacing.
 */ parcelHelpers.export(exports, "useItemSwap", function() {
    return useItemSwap;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
function useItemSwap() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(new Map()), 2), itemHeights = _useState[0], setItemHeights = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(new Map()), 2), swapAnimations = _useState1[0], setSwapAnimations = _useState1[1];
    var handleSetSwapAnimations = function(sourceId, destinationId, direction) {
        var destinationHeight = itemHeights.get(destinationId);
        var sourceHeight = itemHeights.get(sourceId);
        var destinationDirection = direction === "up" ? "down" : "up";
        setSwapAnimations(new Map([
            [
                sourceId,
                {
                    distance: destinationHeight,
                    direction: direction
                }
            ],
            [
                destinationId,
                {
                    distance: sourceHeight,
                    direction: destinationDirection
                }
            ]
        ]));
    };
    var clearSwapAnimations = function() {
        setSwapAnimations(new Map());
    };
    var addItemHeight = function(height, id) {
        if (height && !Number.isNaN(height)) setItemHeights(function(prevState) {
            return new Map(prevState.set(id, height));
        });
    };
    return {
        itemHeights: itemHeights,
        addItemHeight: addItemHeight,
        clearSwapAnimations: clearSwapAnimations,
        setSwapAnimations: handleSetSwapAnimations,
        swapAnimations: swapAnimations
    };
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"43bEU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListItem", function() {
    return ListItem;
});
/**
 * Tracks status for a particular item in the list.
 */ parcelHelpers.export(exports, "useListItem", function() {
    return useListItem;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dnd = require("@hello-pangea/dnd");
var _listItemStyles = require("./ListItem.styles");
var ListItemContext = /*#__PURE__*/ (0, _react.createContext)({});
ListItemContext.displayName = "ReorderableListItem"; /**
                                                      * When this component has rendered it will measure its own height, which will be used by the
                                                      * parent component to determine its animation if this item has been programmatically reordered
                                                      * (e.g. `ListControls` up/down arrow button has been pressed); item heights currently have no
                                                      * other purpose.
                                                      *
                                                      * `itemsVerticalGap` should be used in place of margins to separate the items in the list;
                                                      * it is applied to the container `<div>` below as padding-bottom.
                                                      */ 
function ListItem(props) {
    var listItemEl = (0, _react.useRef)(null);
    var animating = props.animating, moveItem = props.moveItem, addItemHeight = props.addItemHeight, deleteItem = props.deleteItem, item = props.item, index = props.index, itemsVerticalGap = props.itemsVerticalGap, listLength = props.listLength, swapDuration = props.swapDuration, InnerComponent = props.InnerComponent;
    var id = item.id; // tracks whether an arrow has been pressed on this item
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), confirmDelete = _useState1[0], setConfirmDelete = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), editing = _useState2[0], setEditing = _useState2[1]; // handler for a “move up/down” action - this is not used by drag/drop.
    var handleMoveItem = function(direction) {
        setActive(true);
        moveItem(direction);
    };
    var measureSelf = function() {
        if (listItemEl && listItemEl.current) {
            var box = listItemEl.current.getBoundingClientRect();
            addItemHeight(box.height, id);
        }
    }; // see this component’s style file for what this class is doing
    var animationClassName = animating ? "animate-".concat(animating.direction) : ""; // remove “active” state after the item has been reordered
    (0, _react.useEffect)(function() {
        setActive(false);
    }, [
        index
    ]); // measure and store the height of this rendered component
    (0, _react.useLayoutEffect)(function() {
        measureSelf();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Draggable), {
        draggableId: item.id,
        index: index
    }, function(provided, snapshot) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listItemStyles.StyledListItem), Object.assign({
            ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps, {
            className: (0, _classnamesDefault.default)("list-item-container", animationClassName, {
                active: active,
                dragging: snapshot.isDragging
            }),
            "$animationDistance": animating ? animating.distance : 0,
            "$animationDuration": swapDuration,
            style: Object.assign(Object.assign({}, provided.draggableProps.style), {
                paddingBottom: "".concat(itemsVerticalGap, "px")
            })
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement(ListItemContext.Provider, {
            value: {
                active: active,
                confirmDelete: confirmDelete,
                deleteItem: function() {
                    return deleteItem && deleteItem(id);
                },
                dragging: snapshot.isDragging,
                editing: editing,
                index: index,
                item: item,
                isFirstItem: index === 0,
                isLastItem: index === listLength - 1,
                moveItemDown: function() {
                    return handleMoveItem("down");
                },
                moveItemUp: function() {
                    return handleMoveItem("up");
                },
                setConfirmDelete: setConfirmDelete,
                setEditing: setEditing
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: listItemEl,
            style: {
                width: "100%"
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(InnerComponent, null))));
    });
}
function useListItem() {
    return (0, _react.useContext)(ListItemContext);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","@hello-pangea/dnd":"bhM3h","./ListItem.styles":"dG0Me","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dG0Me":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListItem", function() {
    return StyledListItem;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &:active {\n    cursor: grabbing;\n  }\n\n  &.dragging > * {\n    box-shadow: rgba(0, 0, 0, 0.5) 0 3px 8px 0;\n  }\n\n  // animation gets weird if common style rules are moved into a shared declaration...\n  &.animate-up {\n    animation: ",
        "\n      ",
        "ms ease-in;\n    animation-fill-mode: forwards;\n  }\n\n  &.animate-down {\n    animation: ",
        "\n      ",
        "ms ease-in;\n    animation-fill-mode: forwards;\n  }\n\n  &.animate-up,\n  &.animate-down {\n    transition: opacity 120ms;\n\n    &.active {\n      // ensures clicked item remains visually on top during movement\n      z-index: 10000;\n    }\n\n    &:not(.active) {\n      opacity: 0.8;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  0% {\n    transform: translate(0, 0);\n  }\n\n  100% {\n    transform: translate(0, ",
        "",
        "px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListItem = (0, _styledComponentsDefault.default).li(_templateObject(), function(props) {
    return slideKeyframes(props.$animationDistance, "up");
}, function(props) {
    return props.$animationDuration;
}, function(props) {
    return slideKeyframes(props.$animationDistance, "down");
}, function(props) {
    return props.$animationDuration;
});
var slideKeyframes = function(distance, direction) {
    return (0, _styledComponents.keyframes)(_templateObject1(), direction === "up" ? "-" : "", distance);
};

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eZFIa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListControls", function() {
    return ListControls;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ = require("../");
var _index = require("../index");
var _index1 = require("Permafrost/index");
var _listControlsStyles = require("./ListControls.styles"); /**
                                                             * This component **must** be used inside your custom list component. It uses methods from the
                                                             * `useListItem` Context hook, found at the bottom of the `ListItem` file.
                                                             *
                                                             * Unless `promptBeforeDelete` has been disabled in the parent `ReorderableList` component (from
                                                             * the `listControls` prop), pressing the initial “delete” button is not a destructive action.
                                                             */ 
function ListControls() {
    var _useListControls = (0, _.useListControls)(), hideArrows = _useListControls.hideArrows, hideDelete = _useListControls.hideDelete, hideEdit = _useListControls.hideEdit, promptBeforeDelete = _useListControls.promptBeforeDelete;
    var _useListItem = (0, _index.useListItem)(), confirmDelete = _useListItem.confirmDelete, deleteItem = _useListItem.deleteItem, dragging = _useListItem.dragging, editing = _useListItem.editing, isFirstItem = _useListItem.isFirstItem, isLastItem = _useListItem.isLastItem, moveItemDown = _useListItem.moveItemDown, moveItemUp = _useListItem.moveItemUp, setConfirmDelete = _useListItem.setConfirmDelete, setEditing = _useListItem.setEditing;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _listControlsStyles.StyledListControls), null, !confirmDelete ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "list-buttons"
    }, !hideDelete && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        variant: "no-style",
        "aria-label": "delete item",
        className: "delete",
        onClick: promptBeforeDelete ? function() {
            return setConfirmDelete(true);
        } : deleteItem
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Icon), {
        name: "trash",
        size: [
            18
        ]
    })), !hideEdit && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        variant: "no-style",
        "aria-label": "edit item",
        className: "edit",
        onClick: function() {
            return setEditing(true);
        },
        disabled: editing
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Icon), {
        name: "edit",
        size: [
            18
        ]
    })), !hideArrows && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "move-buttons-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        variant: "no-style",
        "aria-label": "move item up",
        className: "button-move-up",
        disabled: isFirstItem,
        onClick: moveItemUp
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Icon), {
        name: "fa-arrow-up",
        size: [
            22
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        variant: "no-style",
        "aria-label": "move item down",
        className: "button-move-down",
        disabled: isLastItem,
        onClick: moveItemDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Icon), {
        name: "fa-arrow-down",
        size: [
            22
        ]
    })))) : // only shows if `promptBeforeDelete` has NOT been disabled
    /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "confirm-delete-container"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, "Are you sure?"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        className: "button-confirm-delete",
        onClick: deleteItem,
        style: {
            opacity: dragging ? "0.5" : ""
        }
    }, "Yes, Delete It"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index1.Button), {
        className: "button-cancel-delete",
        onClick: function() {
            return setConfirmDelete(false);
        },
        style: {
            opacity: dragging ? "0.5" : ""
        }
    }, "No, Keep It")));
}

},{"react":"ktQNc","../":"1vfn9","../index":"1vfn9","Permafrost/index":"iliLC","./ListControls.styles":"jzPbl","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jzPbl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledListControls", function() {
    return StyledListControls;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 36px;\n\n  display: flex;\n\n  .confirm-delete-container {\n    height: inherit;\n    display: inherit;\n    align-items: center;\n\n    .button-confirm-delete,\n    .button-cancel-delete {\n      color: white;\n      box-shadow: none;\n    }\n\n    .button-confirm-delete {\n      margin-left: 16px;\n      background-color: ",
        ";\n    }\n\n    .button-cancel-delete {\n      margin-left: 8px;\n      background-color: ",
        ";\n    }\n  }\n\n  .move-buttons-container {\n    display: flex;\n  }\n\n  .list-buttons {\n    display: inherit;\n    margin-left: 10px;\n\n    Button {\n      padding: 0;\n      background: none;\n      box-shadow: none;\n      color: ",
        ";\n\n      &:disabled {\n        opacity: 0.2;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n    }\n  }\n\n  .button-move-down {\n    margin-left: 8px;\n  }\n\n  .button-move-up {\n    margin-left: 12px;\n  }\n\n  .edit {\n    margin-left: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledListControls = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).red, (0, _index.COLORS).green, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ewBkF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SaveCancel", function() {
    return SaveCancel;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _saveCancelStyles = require("./SaveCancel.styles");
function SaveCancel(props) {
    var className = props.className, id = props.id, disableSave = props.disableSave, handleCancel = props.handleCancel, handleSave = props.handleSave;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _saveCancelStyles.StyledSaveCancel), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("hr", null), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        onClick: handleSave,
        variant: "cta",
        className: "saveButton",
        disabled: disableSave
    }, "Save"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        onClick: handleCancel,
        variant: "link-style",
        className: "cancelButton"
    }, "Cancel")));
}

},{"react":"ktQNc","Permafrost/index":"iliLC","./SaveCancel.styles":"6L5DB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6L5DB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSaveCancel", function() {
    return StyledSaveCancel;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  button {\n    &:not(.focus-visible) {\n      outline: none !important;\n    }\n  }\n\n  .saveButton {\n    padding: 0.75em 2em;\n  }\n\n  button.cancelButton {\n    font-size: ",
        ";\n    margin-left: 2em;\n\n    padding-top: 0.75em;\n    padding-right: 0.75em;\n    padding-bottom: 0.75em;\n  }\n\n  hr {\n    margin: 1.25em 0;\n    border: 1px solid transparent;\n    border-bottom-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSaveCancel = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4rHF0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabbedContainer", function() {
    return TabbedContainer;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index"); /**
                                                     * An a11y-friendly tabbed interface; allows the user to tab between different sections
                                                     * of a container.
                                                     *
                                                     * If the URL will change as the user moves from section to section, the `TabNavigation` component
                                                     * should be used instead.
                                                     */ 
function TabbedContainer(props) {
    var className = props.className, defaultSection = props.defaultSection, fullWidthTabs = props.fullWidthTabs, id = props.id, sections = props.sections, current = props.current, setCurrent = props.setCurrent;
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), tabs = _useState[0], setTabs = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({}), 2), sectionContent = _useState1[0], setSectionContent = _useState1[1]; // If the sections (aka tabs) we passed in change,
    // then update our local state and,
    // if the tab we were on no longer exists,
    // then return to the default selection
    (0, _react.useEffect)(function() {
        setTabs(sections.map(function(section) {
            return {
                id: section.id,
                name: section.name,
                disabled: section.disabled,
                tooltip: section.tooltip ? section.tooltip : undefined
            };
        }));
        setSectionContent(sections.reduce(function(acc, section) {
            return Object.assign(Object.assign({}, acc), (0, _defineProperty._)({}, section.id, section.content));
        }, {}));
        if (!sections.some(function(section) {
            return section.id === current;
        })) setCurrent(defaultSection || sections[0].id);
    }, [
        sections
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.TabbedInterface), {
        tabType: "section",
        tabs: tabs,
        className: className,
        currentTab: current,
        "data-cy": props["data-cy"],
        id: id,
        fullWidthTabs: fullWidthTabs,
        onTabSelect: function(id) {
            return setCurrent(id);
        }
    }, sectionContent[current]);
}

},{"@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hMYpZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabNavigation", function() {
    return TabNavigation;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index"); /**
                                                     * An a11y-friendly tabbed interface; allows the user to navigate between URLs.
                                                     *
                                                     * If the URL does **not** need to change between sections, the `TabbedContainer` component
                                                     * should be used instead.
                                                     */ 
function TabNavigation(props) {
    var children = props.children, className = props.className, currentTab = props.currentTab, fullWidthTabs = props.fullWidthTabs, id = props.id, tabs = props.tabs;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.TabbedInterface), {
        tabType: "navigation",
        tabs: tabs,
        className: className,
        currentTab: currentTab,
        "data-cy": props["data-cy"],
        fullWidthTabs: fullWidthTabs,
        id: id
    }, children);
}

},{"react":"ktQNc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fv8Kb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", function() {
    return Table;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTable = require("@tanstack/react-table");
var _tableStyles = require("./table.styles");
var _actionBar = require("./components/ActionBar");
var _pagination = require("./components/Pagination");
var _noResults = require("./components/NoResults");
var _loadingSpinner = require("../status-indicators/LoadingSpinner/LoadingSpinner");
var _lodash = require("lodash");
function Table(param) {
    var defaultColumns = param.columns, data = param.data, className = param.className, _param_isFixed = param.isFixed, isFixed = _param_isFixed === void 0 ? false : _param_isFixed, currentPage = param.currentPage, totalPageCount = param.totalPageCount, totalRowCount = param.totalRowCount, _param_paginationLimit = param.paginationLimit, paginationLimit = _param_paginationLimit === void 0 ? 1000 : _param_paginationLimit, nextPage = param.nextPage, previousPage = param.previousPage, TableActions = param.TableActions, error = param.error, _param_enableRowSelection = param.enableRowSelection, enableRowSelection = _param_enableRowSelection === void 0 ? true : _param_enableRowSelection, clearFilters = param.clearFilters, hasFiltersApplied = param.hasFiltersApplied, _param_showPagination = param.showPagination, showPagination = _param_showPagination === void 0 ? true : _param_showPagination, _param_loading = param.loading, loading = _param_loading === void 0 ? false : _param_loading, defaultPinnedColumns = param.defaultPinnedColumns;
    var _a;
    var columns = (0, _react.useMemo)(function() {
        return defaultColumns;
    }, []);
    var defaultData = (0, _react.useMemo)(function() {
        return [];
    }, []);
    var _useState = (0, _slicedToArray._)((0, _react.useState)({}), 2), rowSelection = _useState[0], setRowSelection = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(window.innerWidth), 2), windowWidth = _useState1[0], setWindowWidth = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(columns), 2), formattedColumns = _useState2[0], setFormattedColumns = _useState2[1];
    var thRefs = (0, _react.useRef)({}); // Tracks changes to browser width to allow for updating of column widths
    (0, _react.useEffect)(function() {
        var handleResize = function() {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Sets formattedColumns with correct column widths
    (0, _react.useEffect)(function() {
        var updatedColumns = [];
        formattedColumns.forEach(function(column) {
            updatedColumns.push(Object.assign(Object.assign({}, column), {
                size: thRefs.current[column.id].offsetWidth
            }));
        });
        setFormattedColumns(updatedColumns);
    }, [
        data,
        columns,
        windowWidth
    ]);
    var table = (0, _reactTable.useReactTable)({
        data: data !== null && data !== void 0 ? data : defaultData,
        columns: formattedColumns,
        state: {
            rowSelection: rowSelection
        },
        enableRowSelection: enableRowSelection,
        onRowSelectionChange: setRowSelection,
        getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
        manualPagination: true,
        debugTable: true,
        initialState: {
            columnPinning: {
                left: defaultPinnedColumns
            }
        }
    });
    var totalRowsOnPage = table.getRowModel().rows.length;
    var hasPaginationProps = !(0, _lodash.isNil)(currentPage) && !(0, _lodash.isNil)(totalPageCount) && !(0, _lodash.isNil)(totalRowsOnPage) && !(0, _lodash.isNil)(totalRowCount) && nextPage && previousPage; // Sets style attributes for pinned columns
    var getCommonPinningStyles = function(column) {
        var isPinned = column.getIsPinned();
        var isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
        return {
            boxShadow: isLastLeftPinnedColumn ? "-4px 0 4px -4px gray inset" : undefined,
            left: isPinned === "left" ? "".concat(column.getStart("left"), "px") : undefined,
            opacity: isPinned ? 0.95 : 1,
            position: isPinned ? "sticky" : "initial",
            zIndex: isPinned ? 1 : 0
        };
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledContainer), {
        "$isFixed": isFixed
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledTableContainer), {
        "$isFixed": isFixed
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledTable), {
        "$isFixed": isFixed,
        className: className,
        "$isLoading": loading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledThead), null, table.getHeaderGroups().map(function(headerGroup) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("tr", {
            key: headerGroup.id
        }, headerGroup.headers.map(function(header) {
            var _a, _b, _c, _d, _e;
            var column = header.column;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledTh), {
                key: header.id,
                ref: function(el) {
                    if (el) thRefs.current[column.id] = el;
                },
                colSpan: header.colSpan,
                "$noPadding": !!((_c = (_b = (_a = header.column.columnDef.meta) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.noPadding),
                "$hasDefinedColumnSize": !!((_e = (_d = header.column.columnDef.meta) === null || _d === void 0 ? void 0 : _d.styles) === null || _e === void 0 ? void 0 : _e.definedColumnSize),
                "$width": header.column.getSize(),
                style: Object.assign({}, getCommonPinningStyles(column))
            }, (0, _reactTable.flexRender)(header.column.columnDef.header, header.getContext()));
        }));
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledTbody), null, (error === null || error === void 0 ? void 0 : error.hasError) && !loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledBodyTr), {
        "$isSelected": false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.CenteredRow), {
        colSpan: columns.length
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noResults.NoResults), {
        clearFilters: clearFilters,
        hasFiltersApplied: hasFiltersApplied,
        message: (_a = error.errorMessage) !== null && _a !== void 0 ? _a : "There was an error loading the data."
    }))) : data.length === 0 && !loading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledBodyTr), {
        "$isSelected": false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.CenteredRow), {
        colSpan: columns.length
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noResults.NoResults), {
        clearFilters: clearFilters,
        hasFiltersApplied: hasFiltersApplied,
        message: "No results found."
    }))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, table.getRowModel().rows.map(function(row) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledBodyTr), {
            key: row.id,
            "$isSelected": row.getIsSelected()
        }, row.getVisibleCells().map(function(cell) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var columnDef = cell.column.columnDef;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledTd), {
                key: cell.id,
                "$noPadding": !!((_c = (_b = (_a = columnDef.meta) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.cell) === null || _c === void 0 ? void 0 : _c.noPadding),
                "$textAlign": (_f = (_e = (_d = columnDef.meta) === null || _d === void 0 ? void 0 : _d.styles) === null || _e === void 0 ? void 0 : _e.cell) === null || _f === void 0 ? void 0 : _f.textAlign,
                "$hasDefinedColumnSize": !!((_h = (_g = columnDef.meta) === null || _g === void 0 ? void 0 : _g.styles) === null || _h === void 0 ? void 0 : _h.definedColumnSize),
                "$width": cell.column.getSize(),
                style: Object.assign({}, getCommonPinningStyles(cell.column))
            }, (0, _reactTable.flexRender)(columnDef.cell, cell.getContext()));
        }));
    }), loading && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.StyledBodyTr), {
        "$isSelected": false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tableStyles.CenteredRow), {
        colSpan: columns.length,
        "$isLoading": loading
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingSpinner.LoadingSpinner), {
        size: "36px"
    })))))), Object.keys(rowSelection).length > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionBar.ActionBar), {
        table: table,
        isFixed: isFixed,
        TableActions: TableActions
    })), showPagination && hasPaginationProps ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pagination.Pagination), {
        currentPage: currentPage,
        totalPageCount: totalPageCount,
        totalRowCount: totalRowCount,
        paginationLimit: paginationLimit,
        totalRowsOnPage: totalRowsOnPage,
        nextPage: nextPage,
        previousPage: previousPage
    }) : null);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","@tanstack/react-table":"1A22E","./table.styles":"5hd3n","./components/ActionBar":"dBSoS","./components/Pagination":"1MQ66","./components/NoResults":"aJZlp","../status-indicators/LoadingSpinner/LoadingSpinner":"g838E","lodash":"h75z0","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5hd3n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContainer", function() {
    return StyledContainer;
});
parcelHelpers.export(exports, "StyledTableContainer", function() {
    return StyledTableContainer;
});
parcelHelpers.export(exports, "StyledTable", function() {
    return StyledTable;
});
parcelHelpers.export(exports, "StyledThead", function() {
    return StyledThead;
});
parcelHelpers.export(exports, "StyledTh", function() {
    return StyledTh;
});
parcelHelpers.export(exports, "StyledTbody", function() {
    return StyledTbody;
});
parcelHelpers.export(exports, "StyledBodyTr", function() {
    return StyledBodyTr;
});
parcelHelpers.export(exports, "StyledTd", function() {
    return StyledTd;
});
parcelHelpers.export(exports, "CenteredRow", function() {
    return CenteredRow;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  flex-direction: column;\n\n  width: ",
        ";\n  height: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  display: ",
        ";\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n  height: 100%;\n\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: ",
        ";\n    transition: background-color 0.2s;\n\n    border-radius: 10px;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n\n  &::-webkit-scrollbar-track,\n  &::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-collapse: separate;\n  margin: 0;\n  table-layout: auto;\n  border-spacing: 0;\n  border-radius: var(--pf-rounded-lg);\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: sticky;\n  top: 0;\n  z-index: 100;\n\n  background-color: ",
        ";\n\n  tr:first-child {\n    th {\n      &:first-child {\n        border-top-left-radius: var(--pf-rounded-lg);\n      }\n\n      &:last-child {\n        border-top-right-radius: var(--pf-rounded-lg);\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  max-width: ",
        ";\n  width: ",
        ";\n  padding: ",
        ";\n  color: #7488a4;\n  background: ",
        ";\n  font-size: ",
        ";\n\n  border-top: 1px solid #92a8c24d;\n  border-bottom: 1px solid #92a8c24d;\n  border-right: 1px solid #92a8c24d;\n\n  user-select: none;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &:first-child {\n    border-left: 1px solid #92a8c24d;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  tr:last-child {\n    td {\n      &:first-child {\n        border-bottom-left-radius: var(--pf-rounded-lg);\n      }\n\n      &:last-child {\n        border-bottom-right-radius: var(--pf-rounded-lg);\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: ",
        ";\n  font-size: ",
        ";\n  font-weight: 500;\n  line-height: 18px;\n  color: ",
        ";\n  background: ",
        ";\n  max-width: ",
        ";\n  width: ",
        ";\n\n  border-right: 1px solid #92a8c24d;\n  border-bottom: 1px solid #92a8c24d;\n\n  text-align: ",
        ";\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n\n  &:first-child {\n    border-left: 1px solid #92a8c24d;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 5px 8px;\n  text-align: center;\n  vertical-align: middle;\n  height: 100%;\n  border: 1px solid var(--pf-border-color);\n\n  @keyframes shimmer {\n    0% {\n      background-color: var(--pf-primary-color-700) 40;\n    }\n    50% {\n      background-color: var(--pf-primary-color-700);\n    }\n    100% {\n      background-color: var(--pf-primary-color-700) 40;\n    }\n  }\n\n  animation: ",
        ";\n\n  svg {\n    margin: 0 auto;\n    display: block;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledContainer = (0, _styledComponentsDefault.default).div(_templateObject(), function(props) {
    return props.$isFixed ? "100%" : "fit-content";
});
var StyledTableContainer = (0, _styledComponentsDefault.default).div(_templateObject1(), function(props) {
    return props.$isFixed ? "block" : "flex";
}, (0, _constants.COLORS).regalBlue, (0, _constants.COLORS).chatamsBlue);
var StyledTable = (0, _styledComponentsDefault.default).table(_templateObject2(), function(props) {
    return props.$isLoading && " \n    border: var(--pf-border-thin) solid var(--pf-border-color);\n    height: 100%;\n    width: 100%;\n  ";
});
var StyledThead = (0, _styledComponentsDefault.default).thead(_templateObject3(), (0, _constants.COLORS).blackPearl);
var StyledTh = (0, _styledComponentsDefault.default).th(_templateObject4(), function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "300px";
}, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "auto";
}, function(props) {
    return props.$noPadding ? 0 : "0 8px";
}, (0, _constants.COLORS).ebony, (0, _constants.TYPOGRAPHY).fontSize.base);
var StyledTbody = (0, _styledComponentsDefault.default).tbody(_templateObject5());
var StyledBodyTr = (0, _styledComponentsDefault.default).tr(_templateObject6(), function(props) {
    return props.$isSelected ? "#112341" : "transparent";
});
var StyledTd = (0, _styledComponentsDefault.default).td(_templateObject7(), function(props) {
    return props.$noPadding ? 0 : "5px 8px";
}, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).white, (0, _constants.COLORS).mirage, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "300px";
}, function(props) {
    return props.$hasDefinedColumnSize ? "".concat(props.$width, "px") : "auto";
}, function(props) {
    var _a;
    return (_a = props.$textAlign) !== null && _a !== void 0 ? _a : "left";
});
var CenteredRow = (0, _styledComponentsDefault.default).td(_templateObject8(), function(props) {
    return props.$isLoading ? "shimmer 3s ease-in-out infinite" : "none";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dBSoS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", function() {
    return 0, _actionBar.ActionBar;
});
var _actionBar = require("./ActionBar");

},{"./ActionBar":"IRiUV","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"IRiUV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", function() {
    return ActionBar;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionBarStyles = require("./ActionBar.styles");
function ActionBar(param) {
    var table = param.table, isFixed = param.isFixed, TableActions = param.TableActions;
    var selectedItems = table.getRowModel().rows.filter(function(row) {
        return row.getIsSelected();
    });
    var unselectRows = function() {
        table.getRowModel().rows.forEach(function(row) {
            row.toggleSelected(false);
        });
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionBarStyles.StyledActionBar), {
        isFixed: isFixed
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionBarStyles.StyledTextContainer), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, selectedItems.length, " ", selectedItems.length > 1 ? "items" : "item", " selected")), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionBarStyles.StyledButtonContainer), null, TableActions && /*#__PURE__*/ (0, _reactDefault.default).createElement(TableActions, {
        selectedItems: selectedItems,
        unselectRows: unselectRows
    })));
}

},{"react":"ktQNc","./ActionBar.styles":"kZF17","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kZF17":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledActionBar", function() {
    return StyledActionBar;
});
parcelHelpers.export(exports, "StyledTextContainer", function() {
    return StyledTextContainer;
});
parcelHelpers.export(exports, "StyledButtonContainer", function() {
    return StyledButtonContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  position: fixed;\n  bottom: 100px;\n  left: ",
        ";\n\n  border-radius: 8px;\n  border: 3px solid ",
        ";\n\n  background-color: ",
        ";\n  padding: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 10px 8px;\n\n  span {\n    font-size: ",
        ";\n    font-weight: 500;\n    line-height: 24px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 16px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledActionBar = (0, _styledComponentsDefault.default).div(_templateObject(), function(props) {
    return props.isFixed ? "50%" : 0;
}, (0, _constants.COLORS).portGore, (0, _constants.COLORS).midnight);
var StyledTextContainer = (0, _styledComponentsDefault.default).div(_templateObject1(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).white);
var StyledButtonContainer = (0, _styledComponentsDefault.default).div(_templateObject2());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1MQ66":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _pagination.Pagination;
});
var _pagination = require("./Pagination");

},{"./Pagination":"hb7Qg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hb7Qg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return Pagination;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paginationStyles = require("./Pagination.styles");
function Pagination(param) {
    var currentPage = param.currentPage, totalPageCount = param.totalPageCount, totalRowCount = param.totalRowCount, totalRowsOnPage = param.totalRowsOnPage, paginationLimit = param.paginationLimit, nextPage = param.nextPage, previousPage = param.previousPage;
    var isLastPage = currentPage === totalPageCount - 1;
    var isFirstPage = currentPage === 0;
    var firstRowPosition = currentPage * paginationLimit;
    var handlePreviousPage = function() {
        if (currentPage > 0) previousPage();
    };
    var handleNextPage = function() {
        if (currentPage < totalPageCount - 1) nextPage();
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledPagination), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledPaginationInfo), null, "Showing ", firstRowPosition + 1, " - ", firstRowPosition + totalRowsOnPage, " of ", totalRowCount, " ", "entries"), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledPaginationControls), null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledIcon), {
        name: "chevron-left",
        onClick: handlePreviousPage,
        isDisabled: isFirstPage
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledText), null, "Page", " ", /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledPageNumber), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, currentPage + 1)), "of ", totalPageCount === 0 || !totalPageCount ? 1 : totalPageCount), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paginationStyles.StyledIcon), {
        name: "chevron-right",
        onClick: handleNextPage,
        isDisabled: isLastPage
    })));
}

},{"react":"ktQNc","./Pagination.styles":"jaPne","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jaPne":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPagination", function() {
    return StyledPagination;
});
parcelHelpers.export(exports, "StyledPaginationInfo", function() {
    return StyledPaginationInfo;
});
parcelHelpers.export(exports, "StyledPaginationControls", function() {
    return StyledPaginationControls;
});
parcelHelpers.export(exports, "StyledText", function() {
    return StyledText;
});
parcelHelpers.export(exports, "StyledPageNumber", function() {
    return StyledPageNumber;
});
parcelHelpers.export(exports, "StyledIcon", function() {
    return StyledIcon;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _icon = require("Permafrost/components/ui-foundations/Icon/Icon");
var _constants = require("Permafrost/constants");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-top: 10px;\n  margin-right: 24px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  font-size: ",
        ";\n  line-height: 20px;\n  color: #8593b3;\n  user-select: none;\n\n  display: flex;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border: 1px solid #198bdc;\n  border-radius: 2px;\n\n  height: 24px;\n  width: 24px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n\n  span {\n    font-size: ",
        ";\n\n    font-size: ",
        ";\n    font-weight: 700;\n    line-height: 20px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 14px;\n  width: 14px;\n  cursor: ",
        ";\n\n  &:hover {\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPagination = (0, _styledComponentsDefault.default).div(_templateObject());
var StyledPaginationInfo = (0, _styledComponentsDefault.default).div(_templateObject1());
var StyledPaginationControls = (0, _styledComponentsDefault.default).div(_templateObject2());
var StyledText = (0, _styledComponentsDefault.default).span(_templateObject3(), (0, _constants.TYPOGRAPHY).fontSize.base);
var StyledPageNumber = (0, _styledComponentsDefault.default).span(_templateObject4(), (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.TYPOGRAPHY).fontSize.base, (0, _constants.COLORS).white);
var StyledIcon = (0, _styledComponentsDefault.default)((0, _icon.Icon))(_templateObject5(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "normal" : "pointer";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "1" : "0.5";
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","Permafrost/components/ui-foundations/Icon/Icon":"cld9p","Permafrost/constants":"hYHjJ","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aJZlp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResults", function() {
    return 0, _noResults.NoResults;
});
var _noResults = require("./NoResults");

},{"./NoResults":"fFoPD","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fFoPD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NoResults", function() {
    return NoResults;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _noResultsStyles = require("./NoResults.styles");
function NoResults(param) {
    var clearFilters = param.clearFilters, hasFiltersApplied = param.hasFiltersApplied, message = param.message;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noResultsStyles.StyledNoResults), null, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, message), hasFiltersApplied && /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        onClick: clearFilters
    }, "Click here"), " to reset the filters."));
}

},{"react":"ktQNc","./NoResults.styles":"75xmn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"75xmn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledNoResults", function() {
    return StyledNoResults;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _constants = require("Permafrost/constants");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n\n  position: sticky;\n  left: 0;\n  margin: 30px auto;\n\n  p {\n    font-size: ",
        ";\n    font-weight: 500;\n    color: ",
        ";\n\n    span {\n      color: ",
        ";\n      cursor: pointer;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNoResults = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _constants.TYPOGRAPHY).fontSize.subheadSmall, (0, _constants.COLORS).white, (0, _constants.COLORS).summerSky);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/constants":"hYHjJ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lS52L":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TeamTable", function() {
    return TeamTable;
}) // ensures Role is nicely formatted in the UI
;
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _teamTableStyles = require("./TeamTable.styles"); /**
                                                       * List of users of a Dataset or Workflow. If an owner is specified, they will appear
                                                       * first in the list, and will not be deletable.
                                                       */ 
function TeamTable(props) {
    var className = props.className, id = props.id, labelledby = props.labelledby, owner = props.owner, removeUser = props.removeUser, users = props.users;
    var listItems = [];
    if (owner) listItems.push(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        key: owner.userId,
        className: "table-row"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, owner.email), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, returnFormattedRole(owner.role))));
    users.forEach(function(user) {
        return listItems.push(/*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            key: user.userId,
            className: (0, _classnamesDefault.default)("table-row", user.rowClassName)
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, user.email), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, returnFormattedRole(user.role)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            title: "remove team member"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
            onClick: function() {
                return removeUser(user.userId);
            },
            variant: "no-style",
            "aria-label": "remove team member"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
            name: "trash",
            size: [
                "18px"
            ]
        })))));
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _teamTableStyles.StyledTeamTable), {
        "aria-labelledby": labelledby,
        className: className,
        "data-cy": props["data-cy"],
        id: id,
        title: "",
        listHeader: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "table-row heading"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Email"), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, "Role")),
        listItems: listItems
    });
}
function returnFormattedRole(role) {
    if (!role) return "";
    return role === "LABELER_AND_REVIEWER" ? "Labeler & Reviewer" : (0, _utils.stringUtils).capitalize(role);
}

},{"react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./TeamTable.styles":"1IVZ6","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1IVZ6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTeamTable", function() {
    return StyledTeamTable;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .table-row {\n    display: grid;\n    grid-template-columns: 1fr 1.2fr 30px;\n    padding-top: 10px;\n\n    &:not(.heading) {\n      padding-bottom: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTeamTable = (0, _styledComponentsDefault.default)((0, _index.ListTable))(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6GeRo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wizard", function() {
    return 0, _wizard.Wizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return 0, _wizardStyles.WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return 0, _wizardStyles.WizardSection;
});
parcelHelpers.export(exports, "StyledWizard", function() {
    return 0, _wizardStyles.StyledWizard;
});
var _wizard = require("./Wizard");
var _wizardStyles = require("./Wizard.styles");

},{"./Wizard":"iDeMh","./Wizard.styles":"cxFlc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iDeMh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Wizard", function() {
    return Wizard;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _wizardStyles = require("./Wizard.styles");
var commonButtonProps = {
    adjustAlignment: -2,
    size: "large"
};
function Wizard(props) {
    var children = props.children, className = props.className, confirmCancel = props.confirmCancel, disableNextStep = props.disableNextStep, disablePrevStep = props.disablePrevStep, disableSubmit = props.disableSubmit, id = props.id, isLastStep = props.isLastStep, onCancel = props.onCancel, onNextPress = props.onNextPress, onStepChange = props.onStepChange, onSubmit = props.onSubmit, startingStep = props.startingStep, steps = props.steps, submitButtonLabel = props.submitButtonLabel, _props_submitProcessing = props.submitProcessing, submitProcessing = _props_submitProcessing === void 0 ? "" : _props_submitProcessing, wizardTitle = props.wizardTitle, nextButtonProps = props.nextButtonProps;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(startingStep || steps[0]), 2), currentStep = _useState[0], setCurrentStep = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), openCancelConfirm = _useState1[0], setOpenCancelConfirm = _useState1[1];
    var onLastStep = (0, _react.useMemo)(function() {
        if (isLastStep !== undefined) return isLastStep;
        return steps.indexOf(currentStep) === steps.length - 1;
    }, [
        isLastStep,
        steps,
        currentStep
    ]);
    var isBusy = !!(submitProcessing && submitProcessing.length > 0);
    var nextStep = function() {
        if (!onLastStep) {
            var currentIndex = steps.indexOf(currentStep);
            setCurrentStep(steps[currentIndex + 1]);
        }
    };
    var prevStep = function() {
        var currentIndex = steps.indexOf(currentStep);
        if (currentIndex !== 0) setCurrentStep(steps[currentIndex - 1]);
    }; // handles the user's selection in the cancel confirmation modal
    var handleCancelRequest = function(confirmCancel) {
        if (confirmCancel && onCancel) onCancel();
        setOpenCancelConfirm(false);
    };
    var handleNextPress = function() {
        var allowNext = onNextPress ? onNextPress() : true;
        if (!allowNext) return;
        if (onLastStep) handleSubmit();
        else nextStep();
    };
    var handleSubmit = function() {
        onSubmit();
    }; // report current step to the consuming component
    (0, _react.useEffect)(function() {
        onStepChange(currentStep);
    }, [
        currentStep
    ]); // ensures `currentStep` is reset on unmount, just in case
    (0, _react.useEffect)(function() {
        return function() {
            return setCurrentStep(steps[0] || "");
        };
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _wizardStyles.StyledWizard), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("nav", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("h1", null, wizardTitle, ": ", currentStep), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "wizard-buttons"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        onClick: function() {
            return setOpenCancelConfirm(true);
        },
        variant: "link-style"
    }, "Cancel"), steps.indexOf(currentStep) !== 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), Object.assign({}, commonButtonProps, {
        iconName: "fa-arrow-left",
        label: "Previous Step",
        onPress: prevStep,
        isDisabled: disablePrevStep
    })), onLastStep ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), Object.assign({}, commonButtonProps, {
        variant: "primary",
        iconName: "check",
        busy: isBusy,
        label: isBusy ? submitProcessing : submitButtonLabel,
        onPress: handleNextPress,
        isDisabled: disableSubmit
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.IconButton), Object.assign({}, commonButtonProps, {
        variant: "primary",
        iconSide: "end",
        iconName: "fa-arrow-right",
        label: "Next Step",
        onPress: handleNextPress,
        isDisabled: disableNextStep
    }, nextButtonProps)))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.ConfirmModal), {
        title: confirmCancel.title,
        message: confirmCancel.message,
        confirmText: confirmCancel.confirmText,
        rejectText: confirmCancel.rejectText,
        open: openCancelConfirm,
        clickOutsideHandler: function() {
            return setOpenCancelConfirm(false);
        },
        responseHandler: handleCancelRequest
    }));
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","Permafrost/index":"iliLC","./Wizard.styles":"cxFlc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cxFlc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledWizard", function() {
    return StyledWizard;
});
parcelHelpers.export(exports, "WizardCard", function() {
    return WizardCard;
});
parcelHelpers.export(exports, "WizardSection", function() {
    return WizardSection;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    margin-bottom: 24px;\n\n    // override for some styling in AppChrome IPA component\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  h1 {\n    margin-bottom: 0;\n  }\n\n  .wizard-buttons {\n    display: flex;\n    align-items: center;\n\n    font-size: ",
        ";\n\n    button.link-style {\n      font-size: inherit;\n      margin-right: 1em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  padding: 14px ",
        ";\n\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 1px 1px 1px 0 ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .section-heading {\n    margin-bottom: 0;\n    // todo: store value elsewhere\n    font-size: 22px;\n    color: ",
        ";\n\n    .supporting-text {\n      font-size: ",
        ";\n      color: ",
        ";\n    }\n  }\n\n  .section-content {\n    padding: ",
        ";\n  }\n\n  &:not(:last-of-type) {\n    margin-bottom: ",
        ";\n\n    .section-content {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledWizard = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.subheadLarge);
var commonPadding = "20px"; // todo: permafrost: move into css fragment at top level
var WizardCard = (0, _styledComponentsDefault.default).div(_templateObject1(), commonPadding, (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).ebony);
var WizardSection = (0, _styledComponentsDefault.default).div(_templateObject2(), (0, _index.COLORS).lightFontColor, (0, _index.TYPOGRAPHY).fontSize.subheadLarge, (0, _index.COLORS).defaultFontColor, commonPadding, commonPadding, (0, _index.COLORS).ebony);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"knQD3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropVerticalList", function() {
    return DragDropVerticalList;
}) /**
   * Patches `react-beautiful-dnd` styles to optionally incorporate a horizontal axis lock for the
   * dragged element, and/or add a bottom margin to list items (if specified)
   *
   * ref: https://github.com/atlassian/react-beautiful-dnd/issues/538#issuecomment-741848961
   */ ;
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dnd = require("@hello-pangea/dnd");
var _uuid = require("uuid");
var _utils = require("@indico-data/utils");
var _dragDropVerticalListStyles = require("./DragDropVerticalList.styles");
var droppableId = (0, _uuid.v4)(); /**
                             * General-purpose drag-and-drop list component. Pass in an array of React components along with
                             * an array of id strings associated with each component, and an `<ul>` containing re-sortable
                             * `<li>`s is created.
                             *
                             * Avoid margin styling in the components passed into `items`, otherwise the drag/drop motion can
                             * get janky. Instead, use the `itemsVerticalGap` prop to add a margin-bottom to each item.
                             *
                             * Want to target your item while it’s being dragged? Pass a SetStateAction down from the parent;
                             * see Storybook stories for an example implementation.
                             */ 
function DragDropVerticalList(props) {
    var itemIdList = props.itemIdList, items = props.items, itemsVerticalGap = props.itemsVerticalGap, listStyleClass = props.listStyleClass, lockAxis = props.lockAxis, onDrop = props.onDrop, updateDraggedItem = props.updateDraggedItem;
    var handleDragEnd = function(result) {
        if (result.destination) {
            updateDraggedItem && updateDraggedItem("");
            var items = (0, _utils.arrayUtils).reorderItem(itemIdList, result.source.index, result.destination.index);
            onDrop(items);
        }
    };
    var handleDragStart = function(initial) {
        updateDraggedItem && updateDraggedItem(itemIdList[initial.source.index]);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.DragDropContext), {
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Droppable), {
        droppableId: droppableId
    }, function(provided) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("ul", Object.assign({
            ref: provided.innerRef
        }, provided.droppableProps, {
            className: listStyleClass,
            style: {
                marginBottom: itemsVerticalGap && "-".concat(itemsVerticalGap)
            }
        }), items.map(function(item, i) {
            var id = "".concat(droppableId, "-").concat(i);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dnd.Draggable), {
                key: id,
                draggableId: id,
                index: i
            }, function(provided) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dragDropVerticalListStyles.StyledLi), Object.assign({
                    ref: provided.innerRef
                }, provided.draggableProps, provided.dragHandleProps, {
                    style: getStyle(provided.draggableProps.style, itemsVerticalGap, lockAxis),
                    "$lockAxis": lockAxis
                }), item);
            });
        }), provided.placeholder);
    }));
}
function getStyle(style, itemsMargin, lockAxis) {
    var styleProps = Object.assign(Object.assign({}, style), {
        marginBottom: itemsMargin
    });
    if (lockAxis && (styleProps === null || styleProps === void 0 ? void 0 : styleProps.transform)) {
        var axisLock = "translate(0px, ".concat(styleProps.transform.split(",").pop());
        return Object.assign(Object.assign({}, styleProps), {
            transform: axisLock
        });
    }
    return styleProps;
}

},{"react":"ktQNc","@hello-pangea/dnd":"bhM3h","uuid":"6ZyFu","@indico-data/utils":"47VRj","./DragDropVerticalList.styles":"jnIvQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jnIvQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLi", function() {
    return StyledLi;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  // note that scale and shadow are being applied to the passed-in child component, not\n  // the parent draggable li.\n  > * {\n    transition: transform 0.2s;\n  }\n\n  &:active {\n    cursor: grabbing;\n\n    > * {\n      transform: scale(",
        ");\n      box-shadow: rgba(0, 0, 0, 0.5) 0 4px 8px 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLi = (0, _styledComponentsDefault.default).li(_templateObject(), function(props) {
    return props.$lockAxis ? 1.05 : 1;
});

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"guZ18":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalBase", function() {
    return ModalBase;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modalBaseStyles = require("./ModalBase.styles"); /**
                                                       * Base modal component, powered by [react-modal](http://reactcommunity.org/react-modal/#usage)
                                                       *
                                                       * (Also see `ModalAdapter` in the styles file)
                                                       *
                                                       * Accessible element label must be included either as a string passed to `labelText`, or
                                                       * the id of one of the children passed to `labelElement`. If a description is available,
                                                       * pass that element’s id to the `describedBy` prop.
                                                       */ 
function ModalBase(props) {
    var children = props.children, className = props.className, clickToDismiss = props.clickToDismiss, describedBy = props.describedBy, id = props.id, node = props.node, open = props.open, preventEscDismiss = props.preventEscDismiss, preventReturnFocus = props.preventReturnFocus, maxWidth = props.maxWidth;
    var ariaProps = {};
    if ("labelElement" in props) ariaProps["labelledby"] = props.labelElement;
    if (describedBy) ariaProps["describedby"] = describedBy;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _modalBaseStyles.StyledModalBase), {
        ariaHideApp: false,
        "data-cy": props["data-cy"],
        aria: ariaProps,
        className: className || "baseModal",
        contentLabel: "labelText" in props ? props.labelText : null,
        id: id,
        isOpen: open,
        node: node,
        onRequestClose: clickToDismiss,
        shouldCloseOnEsc: !preventEscDismiss,
        shouldReturnFocusAfterClose: !preventReturnFocus,
        maxWidth: maxWidth
    }, children);
}

},{"react":"ktQNc","./ModalBase.styles":"8LuVQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8LuVQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledModalBase", function() {
    return StyledModalBase;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
var _utils = require("@indico-data/utils"); // see: https://github.com/reactjs/react-modal/issues/603
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .",
        "__content {\n    position: absolute;\n    top: 70px;\n    left: 50%;\n    transform: translateX(-50%);\n\n    overflow: visible;\n    padding: 0;\n\n    border-radius: 4px;\n    background-color: ",
        ";\n    border: solid 1px ",
        ";\n    outline: none;\n\n    width: ",
        ";\n    max-width: ",
        ";\n  }\n\n  .",
        "__overlay {\n    z-index: 900;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n\n    background-color: ",
        ";\n  }\n\n  .ReactModal__Overlay {\n    opacity: 0;\n\n    transition: opacity 120ms ease-in-out;\n  }\n\n  .ReactModal__Overlay--after-open {\n    opacity: 1;\n    position: fixed;\n  }\n\n  .ReactModal__Overlay--before-close {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalAdapter(props) {
    (0, _react.useEffect)(function() {
        (0, _reactModalDefault.default).setAppElement(props.node || "#root");
    }, [
        props.node
    ]);
    var className = props.className;
    var contentClassName = "".concat(className, "__content");
    var overlayClassName = "".concat(className, "__overlay");
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactModalDefault.default), Object.assign({}, props, {
        portalClassName: className,
        className: contentClassName,
        overlayClassName: overlayClassName,
        closeTimeoutMS: 120
    }), props.children);
}
var StyledModalBase = (0, _styledComponentsDefault.default)(ModalAdapter)(_templateObject(), function(props) {
    return props.className;
}, (0, _index.COLORS).clay, (0, _index.COLORS).oxfordBlue, function(props) {
    return props.maxWidth ? "100%" : "auto";
}, function(props) {
    return props.maxWidth || "none";
}, function(props) {
    return props.className;
}, (0, _utils.colorUtils).hexToRgb((0, _index.COLORS).mirage, 0.95));

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","react":"ktQNc","react-modal":"4ySdL","styled-components":"6Gjjc","Permafrost/index":"iliLC","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ekzIh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioContext", function() {
    return RadioContext;
});
parcelHelpers.export(exports, "RadioGroup", function() {
    return RadioGroup;
}) /**
   * A single radio button and its label; no styling is applied, and the native
   * radio button is visually hidden.
   */ ;
parcelHelpers.export(exports, "Radio", function() {
    return Radio;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _radio = require("@react-aria/radio");
var _focus = require("@react-aria/focus");
var _visuallyHidden = require("@react-aria/visually-hidden");
var _reactStately = require("react-stately");
var _radioGroupStyles = require("./RadioGroup.styles");
var RadioContext = /*#__PURE__*/ (0, _react.createContext)(null); /**
                                                  * Renders a group of radio buttons with no styling. This component is not
                                                  * designed to be user-facing, and should only be used to provide functionality.
                                                  *
                                                  * A group label must be included: either pass a string or markup into the
                                                  * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
                                                  */ 
function RadioGroup(props) {
    var children = props.children, className = props.className, value = props.value, id = props.id, isDisabled = props.isDisabled, isReadOnly = props.isReadOnly, label = props.label, name = props.name, onChange = props.onChange, orientation = props.orientation;
    var radioGroupStateProps = {
        isDisabled: isDisabled || false,
        isReadOnly: isReadOnly || false,
        name: name || "",
        value: value,
        onChange: onChange,
        children: children
    };
    var state = (0, _reactStately.useRadioGroupState)(radioGroupStateProps);
    var _useRadioGroup = (0, _radio.useRadioGroup)(props, state), radioGroupProps = _useRadioGroup.radioGroupProps, labelProps = _useRadioGroup.labelProps;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radioGroupStyles.StyledRadioGroup), Object.assign({}, radioGroupProps, {
        className: (0, _classnamesDefault.default)(className, {
            horizontal: orientation === "horizontal"
        }),
        "data-cy": props["data-cy"],
        id: id
    }), label && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", Object.assign({
        className: "groupLabel"
    }, labelProps), label), /*#__PURE__*/ (0, _reactDefault.default).createElement(RadioContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children)));
}
function Radio(props) {
    var children = props.children, className = props.className, isDisabled = props.isDisabled, isVisuallySelected = props.isVisuallySelected;
    var state = (0, _react.useContext)(RadioContext);
    var inputRef = (0, _react.useRef)(null);
    var visuallyHiddenProps = (0, _visuallyHidden.useVisuallyHidden)().visuallyHiddenProps;
    var inputProps = (0, _radio.useRadio)(props, state, inputRef).inputProps;
    var _useFocusRing = (0, _focus.useFocusRing)(), isFocusVisible = _useFocusRing.isFocusVisible, focusProps = _useFocusRing.focusProps;
    var isSelected;
    if (isVisuallySelected) isSelected = isVisuallySelected(state === null || state === void 0 ? void 0 : state.selectedValue);
    else isSelected = (state === null || state === void 0 ? void 0 : state.selectedValue) === props.value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("label", {
        className: (0, _classnamesDefault.default)(className, {
            disabled: isDisabled || (state === null || state === void 0 ? void 0 : state.isDisabled),
            selected: isSelected,
            focused: isFocusVisible
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("input", Object.assign({}, inputProps, visuallyHiddenProps, focusProps, {
        ref: inputRef
    })), children);
}

},{"react":"ktQNc","classnames":"9xS9S","@react-aria/radio":"fHWyH","@react-aria/focus":"dmSXv","@react-aria/visually-hidden":"bs06L","react-stately":"l7DHI","./RadioGroup.styles":"jiOaq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jiOaq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledRadioGroup", function() {
    return StyledRadioGroup;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  &.horizontal {\n    display: flex;\n\n    > * {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledRadioGroup = (0, _styledComponentsDefault.default).div(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"GkAW8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabbedInterface", function() {
    return TabbedInterface;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _tabbedInterfaceStyles = require("./TabbedInterface.styles"); /**
                                                        * Abstract/utility component which should **not** be used directly. Instead, use components:
                                                        * - `TabNavigation` to navigate between URLs
                                                        * - `TabbedContainer` to switch between blocks of content
                                                        */ 
function TabbedInterface(props) {
    var children = props.children, className = props.className, currentTab = props.currentTab, fullWidthTabs = props.fullWidthTabs, id = props.id, onTabSelect = props.onTabSelect, tabs = props.tabs, tabType = props.tabType; // const [current, setCurrent] = useState<string>(currentTab || tabs[0].id);
    var handleTabSelect = function(id) {
        if (!!onTabSelect) onTabSelect(id);
         // setCurrent(id);
    };
    var navigationTab = function(props) {
        var id = props.id, name = props.name, route = props.route;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouterDom.Link), {
            className: "TabbedInterface__tablist-link",
            to: route,
            role: "tab",
            "aria-selected": id === currentTab,
            id: id,
            onClick: function() {
                return handleTabSelect(id);
            }
        }, name);
    };
    var sectionTab = function(props) {
        var id = props.id, name = props.name, disabled = props.disabled, tooltip = props.tooltip;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, disabled ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            for: "".concat(id, "-tab"),
            block: true
        }, tooltip) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
            "data-tip": true,
            "data-for": "".concat(id, "-tab"),
            disabled: disabled,
            role: "tab",
            variant: "no-style",
            "aria-selected": id === currentTab,
            id: id,
            onClick: function() {
                return handleTabSelect(id);
            },
            className: fullWidthTabs ? "fullWidthTabs" : ""
        }, name));
    };
    var tabStyle = function(tabQuantity) {
        return {
            flexBasis: "".concat(100 / tabQuantity, "%")
        };
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _classnamesDefault.default)("tabbedInterface", className),
        "data-cy": props["data-cy"],
        id: id,
        style: {
            paddingBottom: "2em"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tabbedInterfaceStyles.StyledTabs), {
        role: "tablist"
    }, tabs.map(function(tab) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: tab.id,
            role: "presentation",
            style: fullWidthTabs ? tabStyle(tabs.length) : {}
        }, tabType === "navigation" ? navigationTab(tab) : sectionTab(tab));
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        role: "tabpanel",
        "aria-labelledby": currentTab
    }, children));
}

},{"react":"ktQNc","react-router-dom":"6Au42","classnames":"9xS9S","Permafrost/index":"iliLC","./TabbedInterface.styles":"1gjlm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1gjlm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTabs", function() {
    return StyledTabs;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  position: relative;\n  top: -2px;\n\n  display: flex;\n\n  color: ",
        ";\n\n  border-bottom: 2px solid currentColor;\n\n  li > [role='tab'] {\n    text-decoration: none;\n    display: block;\n    color: inherit;\n    line-height: 1.25;\n\n    position: relative;\n    top: 2px;\n\n    padding: 16px;\n    font-size: ",
        ";\n    text-transform: uppercase;\n    border-bottom: 2px solid currentColor;\n\n    transition: color ",
        " ",
        ";\n\n    &.fullWidthTabs {\n      width: 100%;\n      height: 100%;\n      white-space: normal;\n    }\n\n    &[aria-selected='true'] {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledTabs = (0, _styledComponentsDefault.default).ul(_templateObject(), (0, _index.COLORS).midFontColor, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, (0, _index.COLORS).white);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3IxgU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableFilename", function() {
    return 0, _copyableFilename.CopyableFilename;
});
var _copyableFilename = require("./CopyableFilename");

},{"./CopyableFilename":"9UJUn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9UJUn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableFilename", function() {
    return CopyableFilename;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _copyableFilenameStyles = require("./CopyableFilename.styles");
function CopyableFilename(props) {
    var className = props.className, filename = props.filename, id = props.id, _props_maxNameLength = props.maxNameLength, maxNameLength = _props_maxNameLength === void 0 ? 50 : _props_maxNameLength, downloadable = props.downloadable, isDownloading = props.isDownloading, onDownload = props.onDownload;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), displayCopySuccess = _useState[0], setDisplayCopySuccess = _useState[1];
    var copyHandler = function() {
        (0, _utils.clipboardUtils).copy(filename);
        setDisplayCopySuccess(true);
        setTimeout(function() {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyableFilenameStyles.StyledCopyableFilename), {
        className: className,
        "data-cy": props["data-cy"]
    }, filename.length > maxNameLength ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        questionMark: false,
        for: "shortened-name"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, filename)), /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        "data-tip": true,
        "data-for": "shortened-name",
        id: id
    }, (0, _utils.stringUtils).maxLengthWithMiddleEllipsis(filename, maxNameLength))) : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        id: id
    }, filename), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "copy-filename",
        variant: "link-style",
        onClick: function() {
            return copyHandler();
        },
        "data-for": "copy-filename",
        "data-tip": true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        className: (0, _classnamesDefault.default)({
            hidden: displayCopySuccess === true
        }),
        name: "fa-clipboard",
        ariaLabel: "copy filename",
        size: [
            "16px"
        ]
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        className: (0, _classnamesDefault.default)("copy-success", {
            hidden: displayCopySuccess === false
        }),
        name: "check",
        size: [
            "16px"
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        className: "copy-success__tooltip",
        questionMark: false,
        place: "bottom",
        for: "copy-filename"
    }, displayCopySuccess ? "copied!" : "copy filename"), downloadable && onDownload ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "download-file__button",
        variant: "link-style",
        onClick: onDownload,
        "data-for": "download-filename",
        "data-tip": true,
        disabled: isDownloading
    }, isDownloading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), {
        size: "16px"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "output",
        ariaLabel: "download file",
        size: [
            "16px"
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        className: "download-success__tooltip",
        questionMark: false,
        place: "bottom",
        for: "download-filename"
    }, "download file")) : null);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","classnames":"9xS9S","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./CopyableFilename.styles":"cbO3z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cbO3z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCopyableFilename", function() {
    return StyledCopyableFilename;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n  align-items: center;\n  height: 38px; // Keep height the same as file select that replaces this component when more than 1 file included\n\n  span {\n    margin-right: ",
        ";\n  }\n\n  .hidden {\n    display: none;\n  }\n\n  svg {\n    margin-bottom: -1px;\n  }\n\n  .download-file__button {\n    margin-left: 5px;\n  }\n\n  .copy-success {\n    color: green;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var commonSpace = "10px";
var StyledCopyableFilename = (0, _styledComponentsDefault.default).div(_templateObject(), commonSpace);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7ecpr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableSelect", function() {
    return 0, _copyableSelect.CopyableSelect;
});
var _copyableSelect = require("./CopyableSelect");

},{"./CopyableSelect":"54iJH","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"54iJH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyableSelect", function() {
    return CopyableSelect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _utils = require("@indico-data/utils");
var _index = require("Permafrost/index");
var _copyableSelectStyles = require("./CopyableSelect.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function CopyableSelect(props) {
    var className = props.className, options = props.options, onChange = props.onChange, value = props.value, _props_noOptionsMessage = props.noOptionsMessage, noOptionsMessage = _props_noOptionsMessage === void 0 ? "No files found" : _props_noOptionsMessage, downloadable = props.downloadable, isDownloading = props.isDownloading, onDownload = props.onDownload;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), displayCopySuccess = _useState[0], setDisplayCopySuccess = _useState[1];
    var copyHandler = function() {
        (0, _utils.clipboardUtils).copy(value.label);
        setDisplayCopySuccess(true);
        setTimeout(function() {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    var ControlComponent = function(props) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Control, Object.assign({}, props), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            id: "tempIDd",
            for: "selectFile",
            block: true
        }, props.getValue()[0].label), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            "data-tip": true,
            "data-for": "selectFile",
            className: "combobox__flex-control"
        }, props.children)));
    };
    var OptionComponent = function(_a) {
        var _$props = __rest(_a, []);
        var _props_data = _$props.data, value = _props_data.value, label = _props_data.label;
        var id = "".concat(value, "-shortened-filename");
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactSelect.components).Option, Object.assign({}, _$props), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: "combobox__flex-option"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", {
            "data-tip": true,
            "data-for": id,
            className: "combobox__ellipsis"
        }, label), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
            for: id
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement("p", null, label))));
    }; // By default react-select searches both the label and value, we only want to search the labels as the value is the fileId
    var customFilter = function(option, searchText) {
        return option.data.label.toLowerCase().includes(searchText.toLowerCase());
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyableSelectStyles.StyledSelectContainer), {
        className: className,
        "data-cy": props["data-cy"]
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyableSelectStyles.StyledCopyableSelect), {
        classNamePrefix: "combobox",
        options: options,
        onChange: onChange,
        value: value,
        searchable: true,
        noOptionsMessage: function() {
            return noOptionsMessage;
        },
        filterOption: customFilter,
        components: {
            Option: OptionComponent,
            Control: ControlComponent
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "copy-filepath__button",
        variant: "link-style",
        onClick: copyHandler,
        "data-for": "copy-filename",
        "data-tip": true
    }, displayCopySuccess ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "check",
        size: [
            "18px"
        ],
        className: "copy-filepath__check"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "fa-clipboard",
        ariaLabel: "copy filename",
        size: [
            "18px"
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        className: "copy-success__tooltip",
        questionMark: false,
        place: "bottom",
        for: "copy-filename"
    }, displayCopySuccess ? "copied!" : "copy filename"), downloadable && onDownload ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Button), {
        className: "download-file__button",
        variant: "link-style",
        onClick: function() {
            return onDownload({
                variables: {
                    id: value.value
                }
            });
        },
        disabled: isDownloading,
        "data-for": "download-filename",
        "data-tip": true
    }, isDownloading ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.LoadingSpinner), {
        size: "16px"
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: "output",
        ariaLabel: "download file",
        size: [
            "16px"
        ]
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Tooltip), {
        className: "download-success__tooltip",
        questionMark: false,
        place: "bottom",
        for: "download-filename"
    }, "download file")) : null);
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","react-select":"dRNnj","@indico-data/utils":"47VRj","Permafrost/index":"iliLC","./CopyableSelect.styles":"klRi9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"klRi9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSelectContainer", function() {
    return StyledSelectContainer;
});
parcelHelpers.export(exports, "StyledCopyableSelect", function() {
    return StyledCopyableSelect;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _index = require("Permafrost/index");
var _commonStyles = require("../commonStyles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  display: flex;\n\n  .copy-filepath__button {\n    margin-left: ",
        ";\n  }\n\n  .download-file__button {\n    margin-left: 5px;\n  }\n\n  .copy-filepath__check {\n    color: green;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  ",
        ";\n\n  // overall component container\n  .combobox__control {\n    width: 250px;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n    background: transparent;\n    border-radius: 4px;\n    font-size: ",
        ";\n    border: 1px solid ",
        ";\n    text-align: left;\n\n    &:hover {\n      border-color: ",
        ";\n    }\n  }\n\n  .combobox__flex-control {\n    width: 100%;\n    display: inline-flex;\n  }\n\n  // the dropdown list container\n  .combobox__menu {\n    width: 400px;\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  // the dropdown list\n  .combobox__menu-list {\n    border-radius: inherit;\n    padding-top: 0;\n    padding-bottom: 0;\n    text-align: left;\n  }\n\n  .combobox__flex-option {\n    display: flex;\n  }\n\n  // the dropdown options\n  .combobox__option {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: small;\n    white-space: nowrap;\n  }\n\n  .combobox__ellipsis {\n    ",
        "\n  }\n\n  // text input placeholder text\n  .combobox__placeholder {\n    color: ",
        ";\n  }\n\n  // selected item text inside input\n  .combobox__single-value {\n    color: ",
        ";\n  }\n\n  .combobox__indicator {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledSelectContainer = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.PADDINGS).xs);
var StyledCopyableSelect = (0, _styledComponentsDefault.default)((0, _reactSelectDefault.default))(_templateObject1(), (0, _commonStyles.basicDefaults), (0, _index.COLORS).midFontColor, (0, _index.COLORS).midFontColor, (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).midFontColor, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).clay, (0, _index.COLORS).mediumGray, (0, _index.TYPOGRAPHY).ellipsis, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor, (0, _index.COLORS).defaultFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","react-select":"dRNnj","Permafrost/index":"iliLC","../commonStyles":"ad9HG","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8gV0Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return 0, _dateTimeDisplay.DateTimeDisplay;
});
var _dateTimeDisplay = require("./DateTimeDisplay");

},{"./DateTimeDisplay":"gKc1C","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gKc1C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateTimeDisplay", function() {
    return DateTimeDisplay;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("@indico-data/utils");
var DateTimeDisplay = function(param) {
    var date = param.date;
    var dateParts = (0, _utils.dateUtils).getDateParts(date);
    if (!dateParts) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", null, dateParts.month, "-", dateParts.day, "-", dateParts.year, "\xa0", /*#__PURE__*/ (0, _reactDefault.default).createElement("wbr", null), dateParts.hour, ":", dateParts.minute, dateParts.dayPeriod);
};

},{"react":"ktQNc","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Wpyp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppTitle", function() {
    return AppTitle;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _appTitleStyles = require("./AppTitle.styles");
var AppTitle = function(props) {
    var actions = props.actions, className = props.className, icon = props.icon, id = props.id, title = props.title;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _appTitleStyles.StyledAppTitle), {
        className: className,
        "data-cy": props["data-cy"],
        id: id
    }, icon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.Icon), {
        name: icon,
        className: "appIcon"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("h3", null, title), actions && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: "ActionLinks"
    }, actions));
};

},{"react":"ktQNc","Permafrost/index":"iliLC","./AppTitle.styles":"4LNpi","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"4LNpi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAppTitle", function() {
    return StyledAppTitle;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding-bottom: 10px;\n\n  > * {\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n\n  .appIcon {\n    height: 25px;\n    width: 25px;\n    color: var(",
        ");\n  }\n\n  h3 {\n    letter-spacing: 2px;\n    color: var(",
        ");\n    text-transform: uppercase;\n    margin-bottom: 0;\n    margin-left: 7px;\n  }\n\n  .ActionLinks {\n    float: right;\n\n    a {\n      color: ",
        ";\n      text-decoration: none;\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledAppTitle = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _index.COLORS).oxfordBlue, (0, _index.colorProperties).logoPrimary, (0, _index.colorProperties).logoSecondary, (0, _index.COLORS).lightFontColor, (0, _index.COLORS).midFontColor);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bsvMl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Renders a group of radio buttons.
 *
 * A group label must be included: either pass a string or markup into the
 * `label` prop, or include an `aria-label` or `aria-labelledby` attribute.
 */ parcelHelpers.export(exports, "RadioGroup", function() {
    return RadioGroup;
});
/**
 * A single radio button and its label.
 */ parcelHelpers.export(exports, "Radio", function() {
    return Radio;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _index = require("Permafrost/index");
var _radioButtonsStyles = require("./RadioButtons.styles");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function RadioGroup(props) {
    var children = props.children, restOfProps = __rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radioButtonsStyles.StyledRadioGroup), Object.assign({}, restOfProps, {
        "data-cy": props["data-cy"]
    }), children);
}
function Radio(props) {
    var children = props.children, restOfProps = __rest(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.AbstractRadio), Object.assign({}, restOfProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        overflow: "visible"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: 10,
        cy: 10,
        r: 9,
        fill: "none",
        stroke: "currentColor",
        className: "radioCircle"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: 10,
        cy: 10,
        r: 5,
        fill: "currentColor",
        stroke: "none",
        className: "radioDot"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: 10,
        cy: 10,
        r: 12,
        fill: "none",
        className: "focusRing"
    })), children);
}

},{"react":"ktQNc","Permafrost/index":"iliLC","./RadioButtons.styles":"2wsMT","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2wsMT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledRadioGroup", function() {
    return StyledRadioGroup;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .groupLabel {\n    margin-bottom: ",
        ";\n    font-size: 16px;\n    color: ",
        ";\n  }\n\n  // this is the Radio component; something gets cranky and styles end up\n  // not applied if we create a separate StyledComponent for Radio.\n  label {\n    display: flex;\n    align-items: center;\n\n    margin-bottom: ",
        ";\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n\n    &:not(.disabled) {\n      cursor: pointer;\n\n      &.selected,\n      &:hover {\n        color: ",
        ";\n      }\n    }\n\n    transition: color ",
        " ",
        ";\n\n    svg {\n      width: ",
        ";\n      height: ",
        ";\n\n      margin-top: 1px;\n      margin-right: ",
        ";\n    }\n\n    .radioCircle {\n      stroke-width: ",
        ";\n    }\n\n    .radioDot {\n      opacity: 0;\n    }\n\n    .focusRing {\n      opacity: 0;\n\n      stroke: ",
        ";\n      stroke-width: ",
        ";\n    }\n\n    &.selected {\n      .radioDot {\n        opacity: 1;\n      }\n    }\n\n    &.focused {\n      .focusRing {\n        opacity: 1;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var radioSize = "20px";
var strokeWidth = 2;
var StyledRadioGroup = (0, _styledComponentsDefault.default)((0, _index.AbstractRadioGroup))(_templateObject(), (0, _index.SPACING).sm, (0, _index.COLORS).lightGray, (0, _index.SPACING).sm, (0, _index.COLORS).white, (0, _index.ANIMATION).duration, (0, _index.ANIMATION).timing, radioSize, radioSize, (0, _index.SPACING).sm, strokeWidth, (0, _index.COLORS).curiousBlue, strokeWidth);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3OYyz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Flipper", function() {
    return Flipper;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _index = require("Permafrost/index");
var _flipperStyles = require("./Flipper.styles"); /**
                                                   * Allows a user to “flip” between modes of some sort.
                                                   */ 
function Flipper(props) {
    var className = props.className, currentMode = props.currentMode, groupLabel = props.groupLabel, id = props.id, onModeChange = props.onModeChange, modes = props.modes, small = props.small;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _flipperStyles.StyledFlipper), {
        "aria-label": groupLabel,
        "data-cy": props["data-cy"],
        value: currentMode,
        id: id,
        onChange: onModeChange,
        orientation: "horizontal",
        className: (0, _classnamesDefault.default)("switch-pair", className, {
            small: small
        })
    }, modes.map(function(mode) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _index.AbstractRadio), {
            key: mode,
            value: mode
        }, mode);
    }));
}

},{"react":"ktQNc","classnames":"9xS9S","Permafrost/index":"iliLC","./Flipper.styles":"bBoOF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bBoOF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledFlipper", function() {
    return StyledFlipper;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _index = require("Permafrost/index");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  label {\n    display: inline-block;\n    font-size: ",
        ";\n    padding: 0.4em 1em 0.5em;\n    margin-bottom: 0;\n\n    border-radius: 1em;\n    color: ",
        ";\n\n    cursor: pointer;\n\n    &.selected {\n      background-color: ",
        ";\n    }\n\n    &.selected,\n    &:hover {\n      color: ",
        ";\n    }\n\n    &.focused {\n      box-shadow: 0 0 0 1px ",
        ", 0 0 0 3px ",
        ";\n    }\n  }\n\n  &.small {\n    label {\n      font-size: 13px;\n      padding: 0.2em 0.8em;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledFlipper = (0, _styledComponentsDefault.default)((0, _index.AbstractRadioGroup))(_templateObject(), (0, _index.TYPOGRAPHY).fontSize.base, (0, _index.COLORS).baliHai, (0, _index.COLORS).oxfordBlue, (0, _index.COLORS).white, (0, _index.COLORS).clay, (0, _index.COLORS).curiousBlue);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","Permafrost/index":"iliLC","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8y6h4":[function() {},{}],"lgvsE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloClient", function() {
    return ApolloClient;
});
parcelHelpers.export(exports, "ApolloError", function() {
    return ApolloError;
});
parcelHelpers.export(exports, "FetchType", function() {
    return FetchType;
});
parcelHelpers.export(exports, "NetworkStatus", function() {
    return NetworkStatus;
});
parcelHelpers.export(exports, "ObservableQuery", function() {
    return ObservableQuery;
});
parcelHelpers.export(exports, "isApolloError", function() {
    return isApolloError;
});
var _tslib = require("tslib");
var _apolloUtilities = require("apollo-utilities");
var _apolloLink = require("apollo-link");
var _symbolObservable = require("symbol-observable");
var _symbolObservableDefault = parcelHelpers.interopDefault(_symbolObservable);
var _tsInvariant = require("ts-invariant");
var _visitor = require("graphql/language/visitor");
var NetworkStatus;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var Observable = function(_super) {
    (0, _tslib.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, _symbolObservableDefault.default] = function() {
        return this;
    };
    Observable.prototype["@@observable"] = function() {
        return this;
    };
    return Observable;
}((0, _apolloLink.Observable));
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function isApolloError(err) {
    return err.hasOwnProperty("graphQLErrors");
}
var generateErrorMessage = function generateErrorMessage(err) {
    var message = "";
    if (isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : "Error message not found.";
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += "Network error: " + err.networkError.message + "\n";
    message = message.replace(/\n$/, "");
    return message;
};
var ApolloError = function(_super) {
    (0, _tslib.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var FetchType;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));
var hasError = function hasError(storeValue, policy) {
    if (policy === void 0) policy = "none";
    return storeValue && (storeValue.networkError || policy === "none" && isNonEmptyArray(storeValue.graphQLErrors));
};
var ObservableQuery = function(_super) {
    (0, _tslib.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, _apolloUtilities.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function next(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if (hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === "all") result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== "cache-only";
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready
            };
        }
        if (!partial) this.updateLastResult((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
            stale: false
        }));
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, _apolloUtilities.isEqual)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-only") return Promise.reject(new (0, _tsInvariant.InvariantError)(1));
        if (fetchPolicy !== "no-cache" && fetchPolicy !== "cache-and-network") fetchPolicy = "network-only";
        if (!(0, _apolloUtilities.isEqual)(this.variables, variables)) this.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.variables), variables);
        if (!(0, _apolloUtilities.isEqual)(this.options.variables, this.variables)) this.options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), FetchType.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, _tsInvariant.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, _tslib.__assign)((0, _tslib.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: "network-only"
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function next(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function error(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === "cache-only" || oldFetchPolicy === "standby" || fetchPolicy === "network-only"), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, _apolloUtilities.isEqual)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, _apolloUtilities.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, _apolloUtilities.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function onError(error) {
            _this.updateLastResult((0, _tslib.__assign)((0, _tslib.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: NetworkStatus.error,
                loading: false
            }));
            iterateObserversSafely(_this.observers, "error", _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function next(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== "cache-only" && queryManager.transform(query_1).serverQuery && !(0, _apolloUtilities.isEqual)(previousVariables, variables)) _this.refetch();
                        else iterateObserversSafely(_this.observers, "next", result);
                    });
                    else iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}(Observable);
function defaultSubscriptionObserverErrorCallback(error) {}
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, _tsInvariant.invariant)(fetchPolicy !== "cache-first" && fetchPolicy !== "cache-only", 3);
}
var MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, _tsInvariant.invariant)(!previousQuery || previousQuery.document === query.document || (0, _apolloUtilities.isEqual)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!(0, _apolloUtilities.isEqual)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = NetworkStatus.setVariables;
        else if (query.isPoll) networkStatus = NetworkStatus.poll;
        else if (query.isRefetch) networkStatus = NetworkStatus.refetch;
        else networkStatus = NetworkStatus.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === "string" && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = NetworkStatus.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === "string" && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === "string") this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = NetworkStatus.loading;
        });
    };
    return QueryStore;
}();
function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, _apolloUtilities.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, _apolloUtilities.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, _apolloUtilities.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, _apolloUtilities.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
            cache: cache,
            getCacheKey: function getCacheKey(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, _tsInvariant.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, _tslib.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, _visitor.visit)(document, {
            Directive: {
                enter: function enter(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, _visitor.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, _apolloUtilities.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function fragmentMatcher() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, _tslib.__generator)(this, function(_b) {
                mainDefinition = (0, _apolloUtilities.getMainDefinition)(document);
                fragments = (0, _apolloUtilities.getFragmentDefinitions)(document);
                fragmentMap = (0, _apolloUtilities.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? capitalizeFirstLetter(definitionOperation) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function execute(selection) {
                    return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, _tslib.__generator)(this, function(_a) {
                            if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, _apolloUtilities.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, _apolloUtilities.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, _apolloUtilities.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, _tsInvariant.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, _apolloUtilities.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, _apolloUtilities.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, _apolloUtilities.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function next(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function error(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function complete() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function asyncMap(observable, mapFn) {
    return new Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function next1(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function error1(e) {
                error && error.call(observer, e);
            },
            complete: function complete1() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function onBroadcast() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, _apolloUtilities.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, _tsInvariant.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? "none" : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, _tsInvariant.invariant)(mutation, 9);
                        (0, _tsInvariant.invariant)(!fetchPolicy || fetchPolicy === "no-cache", 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function generateUpdateQueriesInfo() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function next(result) {
                                        if ((0, _apolloUtilities.graphQLResultHasError)(result) && errorPolicy === "none") {
                                            error = new ApolloError({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== "no-cache") self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function error(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new ApolloError({
                                            networkError: err
                                        }));
                                    },
                                    complete: function complete() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if (isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === "string") self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: "network-only"
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === "ignore" && storeResult && (0, _apolloUtilities.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? "cache-first" : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === "cache-and-network";
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== "cache-only" && fetchPolicy !== "standby";
                        if ((0, _apolloUtilities.hasDirectives)([
                            "live"
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== "no-cache" ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if (isApolloError(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== "cache-and-network") return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === "no-cache") this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === "ignore" || errorPolicy === "all");
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === "standby") return;
            var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === "cache-only" || fetchPolicy === "cache-and-network";
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || "none";
            if (errorPolicy === "none" && hasGraphQLErrors || queryStoreValue.networkError) return invoke("error", new ApolloError({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== "no-cache" && fetchPolicy !== "network-only") _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== "none" && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === "cache-only");
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === "all" && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke("next", resultFromStore);
            } catch (networkError) {
                invoke("error", new ApolloError({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, _apolloUtilities.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, _apolloUtilities.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, _apolloUtilities.getDefaultValues)((0, _apolloUtilities.getOperationDefinition)(transformed))
            };
            var add = function add(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, _tsInvariant.invariant)(options.fetchPolicy !== "standby", 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, _tslib.__assign)({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, _tsInvariant.invariant)(options.query, 12);
        (0, _tsInvariant.invariant)(options.query.kind === "Document", 13);
        (0, _tsInvariant.invariant)(!options.returnPartialData, 14);
        (0, _tsInvariant.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function previousResult() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function callback(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, _tsInvariant.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== "cache-only" && (includeStandby || fetchPolicy !== "standby")) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function makeObservable(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== "no-cache") {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, _apolloUtilities.graphQLResultHasError)(result)) throw new ApolloError({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === "no-cache" || fetchPolicy === "network-only") return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === "string") {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, _tsInvariant.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, _apolloUtilities.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = multiplex((0, _apolloLink.execute)(link, operation)));
                    var cleanup = function cleanup() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = multiplex((0, _apolloLink.execute)(link, operation));
        } else {
            observable = Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function cleanup() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === "none" && isNonEmptyArray(result.errors)) return reject(new ApolloError({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === "all") errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === "no-cache") resultFromStore = result.data;
                else {
                    var _$_a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _$_a.result, complete = _$_a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function error(error) {
                    cleanup();
                    reject(error);
                },
                complete: function complete() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, _tslib.__assign)((0, _tslib.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== NetworkStatus.ready && query.networkStatus !== NetworkStatus.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, _tsInvariant.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                fetchPolicy: "network-only"
            });
            var maybeFetch_1 = function maybeFetch_1() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function poll_1() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, _apolloUtilities.graphQLResultHasError)(result);
        if (ignoreErrors && (0, _apolloUtilities.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: "ROOT_QUERY",
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, _apolloUtilities.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: "ROOT_SUBSCRIPTION",
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === "function") optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, _apolloUtilities.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: "ROOT_MUTATION",
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, _apolloUtilities.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, _apolloUtilities.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, _apolloUtilities.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: "ROOT_QUERY",
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var version = "2.6.10";
var hasSuggestedDevtools = false;
var ApolloClient = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, _apolloLink.ApolloLink).empty();
        if (!link || !cache) throw new (0, _tsInvariant.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === "undefined" ? defaultConnectToDevTools : connectToDevTools && typeof window !== "undefined") window.__APOLLO_CLIENT__ = this;
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function onBroadcast() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.query), options);
        (0, _tsInvariant.invariant)(options.fetchPolicy !== "cache-and-network", 5);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, _apolloLink.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
exports.default = ApolloClient;

},{"tslib":"1r1sc","apollo-utilities":"7oVQU","apollo-link":"hbph2","symbol-observable":"bSI8y","ts-invariant":"hgBT9","graphql/language/visitor":"2YdUO","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1r1sc":[function(require,module,exports) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7oVQU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEqual", function() {
    return 0, _equality.equal;
});
parcelHelpers.export(exports, "addTypenameToDocument", function() {
    return addTypenameToDocument;
});
parcelHelpers.export(exports, "argumentsObjectFromField", function() {
    return argumentsObjectFromField;
});
parcelHelpers.export(exports, "assign", function() {
    return assign;
});
parcelHelpers.export(exports, "buildQueryFromSelectionSet", function() {
    return buildQueryFromSelectionSet;
});
parcelHelpers.export(exports, "canUseWeakMap", function() {
    return canUseWeakMap;
});
parcelHelpers.export(exports, "checkDocument", function() {
    return checkDocument;
});
parcelHelpers.export(exports, "cloneDeep", function() {
    return cloneDeep;
});
parcelHelpers.export(exports, "createFragmentMap", function() {
    return createFragmentMap;
});
parcelHelpers.export(exports, "getDefaultValues", function() {
    return getDefaultValues;
});
parcelHelpers.export(exports, "getDirectiveInfoFromField", function() {
    return getDirectiveInfoFromField;
});
parcelHelpers.export(exports, "getDirectiveNames", function() {
    return getDirectiveNames;
});
parcelHelpers.export(exports, "getDirectivesFromDocument", function() {
    return getDirectivesFromDocument;
});
parcelHelpers.export(exports, "getEnv", function() {
    return getEnv;
});
parcelHelpers.export(exports, "getFragmentDefinition", function() {
    return getFragmentDefinition;
});
parcelHelpers.export(exports, "getFragmentDefinitions", function() {
    return getFragmentDefinitions;
});
parcelHelpers.export(exports, "getFragmentQueryDocument", function() {
    return getFragmentQueryDocument;
});
parcelHelpers.export(exports, "getInclusionDirectives", function() {
    return getInclusionDirectives;
});
parcelHelpers.export(exports, "getMainDefinition", function() {
    return getMainDefinition;
});
parcelHelpers.export(exports, "getMutationDefinition", function() {
    return getMutationDefinition;
});
parcelHelpers.export(exports, "getOperationDefinition", function() {
    return getOperationDefinition;
});
parcelHelpers.export(exports, "getOperationDefinitionOrDie", function() {
    return getOperationDefinitionOrDie;
});
parcelHelpers.export(exports, "getOperationName", function() {
    return getOperationName;
});
parcelHelpers.export(exports, "getQueryDefinition", function() {
    return getQueryDefinition;
});
parcelHelpers.export(exports, "getStoreKeyName", function() {
    return getStoreKeyName;
});
parcelHelpers.export(exports, "graphQLResultHasError", function() {
    return graphQLResultHasError;
});
parcelHelpers.export(exports, "hasClientExports", function() {
    return hasClientExports;
});
parcelHelpers.export(exports, "hasDirectives", function() {
    return hasDirectives;
});
parcelHelpers.export(exports, "isDevelopment", function() {
    return isDevelopment;
});
parcelHelpers.export(exports, "isEnv", function() {
    return isEnv;
});
parcelHelpers.export(exports, "isField", function() {
    return isField;
});
parcelHelpers.export(exports, "isIdValue", function() {
    return isIdValue;
});
parcelHelpers.export(exports, "isInlineFragment", function() {
    return isInlineFragment;
});
parcelHelpers.export(exports, "isJsonValue", function() {
    return isJsonValue;
});
parcelHelpers.export(exports, "isNumberValue", function() {
    return isNumberValue;
});
parcelHelpers.export(exports, "isProduction", function() {
    return isProduction;
});
parcelHelpers.export(exports, "isScalarValue", function() {
    return isScalarValue;
});
parcelHelpers.export(exports, "isTest", function() {
    return isTest;
});
parcelHelpers.export(exports, "maybeDeepFreeze", function() {
    return maybeDeepFreeze;
});
parcelHelpers.export(exports, "mergeDeep", function() {
    return mergeDeep;
});
parcelHelpers.export(exports, "mergeDeepArray", function() {
    return mergeDeepArray;
});
parcelHelpers.export(exports, "removeArgumentsFromDocument", function() {
    return removeArgumentsFromDocument;
});
parcelHelpers.export(exports, "removeClientSetsFromDocument", function() {
    return removeClientSetsFromDocument;
});
parcelHelpers.export(exports, "removeConnectionDirectiveFromDocument", function() {
    return removeConnectionDirectiveFromDocument;
});
parcelHelpers.export(exports, "removeDirectivesFromDocument", function() {
    return removeDirectivesFromDocument;
});
parcelHelpers.export(exports, "removeFragmentSpreadFromDocument", function() {
    return removeFragmentSpreadFromDocument;
});
parcelHelpers.export(exports, "resultKeyNameFromField", function() {
    return resultKeyNameFromField;
});
parcelHelpers.export(exports, "shouldInclude", function() {
    return shouldInclude;
});
parcelHelpers.export(exports, "storeKeyNameFromField", function() {
    return storeKeyNameFromField;
});
parcelHelpers.export(exports, "stripSymbols", function() {
    return stripSymbols;
});
parcelHelpers.export(exports, "toIdValue", function() {
    return toIdValue;
});
parcelHelpers.export(exports, "tryFunctionOrLogError", function() {
    return tryFunctionOrLogError;
});
parcelHelpers.export(exports, "valueFromNode", function() {
    return valueFromNode;
});
parcelHelpers.export(exports, "valueToObjectRepresentation", function() {
    return valueToObjectRepresentation;
});
parcelHelpers.export(exports, "variablesInOperation", function() {
    return variablesInOperation;
});
parcelHelpers.export(exports, "warnOnceInDevelopment", function() {
    return warnOnceInDevelopment;
});
var _visitor = require("graphql/language/visitor");
var _tsInvariant = require("ts-invariant");
var _tslib = require("tslib");
var _fastJsonStableStringify = require("fast-json-stable-stringify");
var _fastJsonStableStringifyDefault = parcelHelpers.interopDefault(_fastJsonStableStringify);
var _equality = require("@wry/equality");
var process = require("7725227b564c5a2b");
function isScalarValue(value) {
    return [
        "StringValue",
        "BooleanValue",
        "EnumValue"
    ].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return [
        "IntValue",
        "FloatValue"
    ].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === "StringValue";
}
function isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function isIntValue(value) {
    return value.kind === "IntValue";
}
function isFloatValue(value) {
    return value.kind === "FloatValue";
}
function isVariable(value) {
    return value.kind === "Variable";
}
function isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function isListValue(value) {
    return value.kind === "ListValue";
}
function isEnumValue(value) {
    return value.kind === "EnumValue";
}
function isNullValue(value) {
    return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if (isBooleanValue(value) || isStringValue(value)) argObj[name.value] = value.value;
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if (isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if (isEnumValue(value)) argObj[name.value] = value.value;
    else if (isNullValue(value)) argObj[name.value] = null;
    else throw new (0, _tsInvariant.InvariantError)(17);
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export"
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, _fastJsonStableStringifyDefault.default)(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if (KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === "Field";
}
function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
}
function isIdValue(idObject) {
    return idObject && idObject.type === "id" && typeof idObject.generated === "boolean";
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, _tslib.__assign)({
        type: "id",
        generated: generated
    }, typeof idConfig === "string" ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function isJsonValue(jsonObject) {
    return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
}
function defaultValueFromVariable(node) {
    throw new (0, _tsInvariant.InvariantError)(18);
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) onVariable = defaultValueFromVariable;
    switch(node.kind){
        case "Variable":
            return onVariable(node);
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(node.value, 10);
        case "FloatValue":
            return parseFloat(node.value);
        case "ListValue":
            return node.values.map(function(v) {
                return valueFromNode(v, onVariable);
            });
        case "ObjectValue":
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) variables = {};
    return getInclusionDirectives(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables[ifArgument.value.name.value];
            (0, _tsInvariant.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    (0, _visitor.visit)(doc, {
        Directive: function Directive(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function hasClientExports(document) {
    return document && hasDirectives([
        "client"
    ], document) && hasDirectives([
        "export"
    ], document);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, _tsInvariant.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, _tsInvariant.invariant)(ifArgument.name && ifArgument.name.value === "if", 15);
        var ifValue = ifArgument.value;
        (0, _tsInvariant.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === "OperationDefinition") throw new (0, _tsInvariant.InvariantError)(11);
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    if (typeof actualFragmentName === "undefined") {
        (0, _tsInvariant.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, _tslib.__assign)((0, _tslib.__assign)({}, document), {
        definitions: (0, _tslib.__spreadArrays)([
            {
                kind: "OperationDefinition",
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function assign(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === "undefined" || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.operation === "mutation";
    })[0];
    (0, _tsInvariant.invariant)(mutationDef, 1);
    return mutationDef;
}
function checkDocument(doc) {
    (0, _tsInvariant.invariant)(doc && doc.kind === "Document", 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw new (0, _tsInvariant.InvariantError)(3);
        return definition;
    });
    (0, _tsInvariant.invariant)(operations.length <= 1, 4);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
    (0, _tsInvariant.invariant)(def, 5);
    return def;
}
function getOperationName(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    (0, _tsInvariant.invariant)(queryDef && queryDef.operation === "query", 6);
    return queryDef;
}
function getFragmentDefinition(doc) {
    (0, _tsInvariant.invariant)(doc.kind === "Document", 7);
    (0, _tsInvariant.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, _tsInvariant.invariant)(fragmentDef.kind === "FragmentDefinition", 9);
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, _tsInvariant.InvariantError)(10);
}
function createFragmentMap(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, (0, _tslib.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var TYPENAME_FIELD = {
    kind: "Field",
    name: {
        kind: "Name",
        value: "__typename"
    }
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === "FragmentSpread" && isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc))) ? null : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty((0, _visitor.visit)(doc, {
        Variable: {
            enter: function enter(node, _key, parent) {
                if (parent.kind !== "VariableDefinition") variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function enter(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === "Variable") variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function enter(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function enter(node) {
                if (getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    if (modifiedDoc && filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return (0, _visitor.visit)(checkDocument(doc), {
        SelectionSet: {
            enter: function enter(node, _key, parent) {
                if (parent && parent.kind === "OperationDefinition") return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return isField(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if (isField(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    selections: (0, _tslib.__spreadArrays)(selections, [
                        TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var connectionRemoveConfig = {
    test: function test(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === "key";
        });
        return willRemove;
    }
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([
        connectionRemoveConfig
    ], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!isField(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some(getDirectiveMatcher(directives)) || nestedCheck && hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
        SelectionSet: {
            enter: function enter(node, _key, _parent, path) {
                var currentPath = path.join("-");
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return hasDirectivesInSelection(directives, selection);
                        });
                        if (hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === "Variable" && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
        OperationDefinition: {
            enter: function enter(node) {
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function enter(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function enter(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if ((isField(selection) || isInlineFragment(selection)) && selection.selectionSet) getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === "FragmentSpread") allFragments.push(selection);
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") return document;
    var modifiedDoc = (0, _visitor.visit)(document, {
        OperationDefinition: {
            enter: function enter(node) {
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function test(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, _visitor.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function enter(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return isField(selection) && selection.name.value === "__typename";
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var canUseWeakMap = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch(toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function getEnv() {
    if (typeof process !== "undefined" && "production") return "production";
    return "development";
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv("production") === true;
}
function isDevelopment() {
    return isEnv("development") === true;
}
function isTest() {
    return isEnv("test") === true;
}
function tryFunctionOrLogError(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}
function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === "object" || typeof o[prop] === "function") && !Object.isFrozen(o[prop])) deepFreeze(o[prop]);
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === "function" && typeof Symbol("") === "string";
        if (!symbolIsPolyfilled) return deepFreeze(obj);
    }
    return obj;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === "object";
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === "object" && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, _tslib.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) type = "warn";
    if (!isProduction() && !haveWarned[msg]) {
        if (!isTest()) haveWarned[msg] = true;
        if (type === "error") console.error(msg);
        else console.warn(msg);
    }
}
function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}

},{"7725227b564c5a2b":"58KR9","graphql/language/visitor":"2YdUO","ts-invariant":"hgBT9","tslib":"1r1sc","fast-json-stable-stringify":"bE4iI","@wry/equality":"cnuZS","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2YdUO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.visitWithTypeInfo = visitWithTypeInfo;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;
var _inspect = _interopRequireDefault(require("d3a7de940b7961eb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var QueryDocumentKeys = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        // or removed in the future.
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */ exports.BREAK = BREAK;
function visit(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i = 0, _Object$keys = Object.keys(node); _i < _Object$keys.length; _i++){
                        var k = _Object$keys[_i];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!isNode(node)) throw new Error("Invalid AST Node: " + (0, _inspect.default)(node));
            var visitFn = getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === BREAK) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if (isNode(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function isNode(maybeNode) {
    return Boolean(maybeNode && typeof maybeNode.kind === "string");
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */ function visitInParallel(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (!skipping[i]) {
                var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === BREAK) skipping[i] = BREAK;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (!skipping[i]) {
                    var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === BREAK) skipping[i] = BREAK;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */ function visitWithTypeInfo(typeInfo, visitor) {
    return {
        enter: function enter(node) {
            typeInfo.enter(node);
            var fn = getVisitFn(visitor, node.kind, /* isLeaving */ false);
            if (fn) {
                var result = fn.apply(visitor, arguments);
                if (result !== undefined) {
                    typeInfo.leave(node);
                    if (isNode(result)) typeInfo.enter(result);
                }
                return result;
            }
        },
        leave: function leave(node) {
            var fn = getVisitFn(visitor, node.kind, /* isLeaving */ true);
            var result;
            if (fn) result = fn.apply(visitor, arguments);
            typeInfo.leave(node);
            return result;
        }
    };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */ function getVisitFn(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === "function") // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === "function") // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === "function") // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

},{"d3a7de940b7961eb":"fj0Be"}],"fj0Be":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = inspect;
var _nodejsCustomInspectSymbol = _interopRequireDefault(require("2fb0e6b1abf95c99"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _typeof(obj) {
    if (typeof Symbol === "function" && (0, _typeOf._)(Symbol.iterator) === "symbol") _typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    return _typeof(obj);
}
var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */ function inspect(value) {
    return formatValue(value, []);
}
function formatValue(value, seenValues) {
    switch(_typeof(value)){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? "[function ".concat(value.name, "]") : "[function]";
        case "object":
            return formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return "[Circular]";
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    if (value) {
        var customInspectFn = getCustomFn(value);
        if (customInspectFn !== undefined) {
            // $FlowFixMe(>=0.90.0)
            var customValue = customInspectFn.call(value); // check for infinite recursion
            if (customValue !== value) return typeof customValue === "string" ? customValue : formatValue(customValue, seenValues);
        } else if (Array.isArray(value)) return formatArray(value, seenValues);
        return formatObject(value, seenValues);
    }
    return String(value);
}
function formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "{}";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[" + getObjectTag(object) + "]";
    var properties = keys.map(function(key) {
        var value = formatValue(object[key], seenValues);
        return key + ": " + value;
    });
    return "{ " + properties.join(", ") + " }";
}
function formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > MAX_RECURSIVE_DEPTH) return "[Array]";
    var len = Math.min(MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push(formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return "[" + items.join(", ") + "]";
}
function getCustomFn(object) {
    var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];
    if (typeof customInspectFn === "function") return customInspectFn;
    if (typeof object.inspect === "function") return object.inspect;
}
function getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        var name = object.constructor.name;
        if (typeof name === "string") return name;
    }
    return tag;
}

},{"@swc/helpers/_/_type_of":"6Gp9n","2fb0e6b1abf95c99":"dXuT7"}],"dXuT7":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var nodejsCustomInspectSymbol = typeof Symbol === "function" ? Symbol.for("nodejs.util.inspect.custom") : undefined;
var _default = nodejsCustomInspectSymbol;
exports.default = _default;

},{}],"hgBT9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InvariantError", function() {
    return InvariantError;
});
parcelHelpers.export(exports, "invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "process", function() {
    return processStub;
});
var _tslib = require("tslib");
var process = require("e733452b553e5876");
var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function setPrototypeOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ function(_super) {
    (0, _tslib.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = genericMessage;
        var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function invariant(condition, message) {
    if (!condition) throw new InvariantError(message);
}
function wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = {
    env: {}
};
if (typeof process === "object") processStub = process;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")(processStub);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var invariant$1 = invariant;
exports.default = invariant$1;

},{"e733452b553e5876":"58KR9","tslib":"1r1sc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bE4iI":[function(require,module,exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

},{}],"cnuZS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equal", function() {
    return equal;
});
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function equal(a, b) {
    try {
        return check(a, b);
    } finally{
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            if (previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!check(a[key], b[key])) return false;
            }
            return true;
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == "" + b;
        case "[object Map]":
        case "[object Set]":
            if (a.size !== b.size) return false;
            if (previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === "[object Map]";
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
exports.default = equal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hbph2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", function() {
    return 0, _zenObservableTsDefault.default;
});
parcelHelpers.export(exports, "getOperationName", function() {
    return 0, _apolloUtilities.getOperationName;
});
parcelHelpers.export(exports, "ApolloLink", function() {
    return ApolloLink;
});
parcelHelpers.export(exports, "concat", function() {
    return concat;
});
parcelHelpers.export(exports, "createOperation", function() {
    return createOperation;
});
parcelHelpers.export(exports, "empty", function() {
    return empty;
});
parcelHelpers.export(exports, "execute", function() {
    return execute;
});
parcelHelpers.export(exports, "from", function() {
    return from;
});
parcelHelpers.export(exports, "fromError", function() {
    return fromError;
});
parcelHelpers.export(exports, "fromPromise", function() {
    return fromPromise;
});
parcelHelpers.export(exports, "makePromise", function() {
    return makePromise;
});
parcelHelpers.export(exports, "split", function() {
    return split;
});
parcelHelpers.export(exports, "toPromise", function() {
    return toPromise;
});
var _zenObservableTs = require("zen-observable-ts");
var _zenObservableTsDefault = parcelHelpers.interopDefault(_zenObservableTs);
var _tsInvariant = require("ts-invariant");
var _tslib = require("tslib");
var _apolloUtilities = require("apollo-utilities");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, _tsInvariant.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, _tslib.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function next(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, _zenObservableTsDefault.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, _zenObservableTsDefault.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, _apolloUtilities.getOperationName)(transformedOperation.query) : "";
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, _tslib.__assign)({}, starting);
    var setContext = function setContext(next) {
        if (typeof next === "function") context = (0, _tslib.__assign)({}, context, next(context));
        else context = (0, _tslib.__assign)({}, context, next);
    };
    var getContext = function getContext() {
        return (0, _tslib.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, "toKey", {
        enumerable: false,
        value: function value() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, _zenObservableTsDefault.default).of();
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, _zenObservableTsDefault.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, _zenObservableTsDefault.default).of() : rightLink.request(operation) || (0, _zenObservableTsDefault.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, _zenObservableTsDefault.default).of() : rightLink.request(operation, forward) || (0, _zenObservableTsDefault.default).of();
    });
}
var concat = function concat(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, _zenObservableTsDefault.default).of();
        }) || (0, _zenObservableTsDefault.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, _zenObservableTsDefault.default).of();
        }) || (0, _zenObservableTsDefault.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, _tsInvariant.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, _zenObservableTsDefault.default).of();
}

},{"zen-observable-ts":"bjOcA","ts-invariant":"hgBT9","tslib":"1r1sc","apollo-utilities":"7oVQU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bjOcA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", function() {
    return Observable;
});
var _zenObservable = require("zen-observable");
var _zenObservableDefault = parcelHelpers.interopDefault(_zenObservable);
var Observable = (0, _zenObservableDefault.default);
exports.default = Observable;

},{"zen-observable":"j9vxu","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j9vxu":[function(require,module,exports) {
module.exports = require("fe6bb7da9da67ed3").Observable;

},{"fe6bb7da9da67ed3":"bqwdu"}],"bqwdu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Observable = void 0;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var hasSymbols = function hasSymbols() {
    return typeof Symbol === "function";
};
var hasSymbol = function hasSymbol(name) {
    return hasSymbols() && Boolean(Symbol[name]);
};
var getSymbol = function getSymbol(name) {
    return hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if (hasSymbols() && !hasSymbol("observable")) Symbol.observable = Symbol("observable");
var SymbolIterator = getSymbol("iterator");
var SymbolObservable = getSymbol("observable");
var SymbolSpecies = getSymbol("species"); // === Abstract Operations ===
function getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : Observable;
}
function isObservable(x) {
    return x instanceof Observable; // SPEC: Brand check
}
function hostReportError(e) {
    if (hostReportError.log) hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            hostReportError(e);
        }
    });
}
function cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        hostReportError(e);
    }
}
function closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        hostReportError(e);
    }
    if (subscription._state === "closed") cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        enqueue(function() {
            return flushSubscription(subscription);
        });
        return;
    }
    notifySubscription(subscription, type, value);
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        _classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    _createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== "closed") {
                    closeSubscription(this);
                    cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function get() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        _classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    _createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                onNotify(this._subscription, "next", value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                onNotify(this._subscription, "error", value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                onNotify(this._subscription, "complete");
            }
        },
        {
            key: "closed",
            get: function get() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        _classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    _createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== "function") {
                        reject(new TypeError(fn + " is not a function"));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function next(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function next(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function next(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function next(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function next(v) {
                                observer.next(v);
                            },
                            error: function error(e) {
                                observer.error(e);
                            },
                            complete: function complete() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
                var C = getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function next(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function next(value) {
                                    observer.next(value);
                                },
                                error: function error(e) {
                                    observer.error(e);
                                },
                                complete: function complete() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function error(e) {
                            observer.error(e);
                        },
                        complete: function complete() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: SymbolObservable,
            value: function value() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === "function" ? this : Observable;
                if (x == null) throw new TypeError(x + " is not an object");
                var method = getMethod(x, SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
                    if (isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if (hasSymbol("iterator")) {
                    method = getMethod(x, SymbolIterator);
                    if (method) return new C(function(observer) {
                        enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + " is not observable");
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === "function" ? this : Observable;
                return new C(function(observer) {
                    enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: SymbolSpecies,
            get: function get() {
                return this;
            }
        }
    ]);
    return Observable;
}();
exports.Observable = Observable;
if (hasSymbols()) Object.defineProperty(Observable, Symbol("extensions"), {
    value: {
        symbol: SymbolObservable,
        hostReportError: hostReportError
    },
    configurable: true
});

},{}],"bSI8y":[function(require,module,exports) {
/* global window */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ponyfillJs = require("./ponyfill.js");
var _ponyfillJsDefault = parcelHelpers.interopDefault(_ponyfillJs);
var global = arguments[3];
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof global !== "undefined") root = global;
else root = module;
var result = (0, _ponyfillJsDefault.default)(root);
exports.default = result;

},{"./ponyfill.js":"dQpka","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dQpka":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return symbolObservablePonyfill;
});
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fOSWr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", function() {
    return 0, _reactCommon.ApolloConsumer;
});
parcelHelpers.export(exports, "ApolloProvider", function() {
    return 0, _reactCommon.ApolloProvider;
});
parcelHelpers.export(exports, "getApolloContext", function() {
    return 0, _reactCommon.getApolloContext;
});
parcelHelpers.export(exports, "resetApolloContext", function() {
    return 0, _reactCommon.resetApolloContext;
});
parcelHelpers.export(exports, "Mutation", function() {
    return 0, _reactComponents.Mutation;
});
parcelHelpers.export(exports, "Query", function() {
    return 0, _reactComponents.Query;
});
parcelHelpers.export(exports, "Subscription", function() {
    return 0, _reactComponents.Subscription;
});
parcelHelpers.export(exports, "graphql", function() {
    return 0, _reactHoc.graphql;
});
parcelHelpers.export(exports, "withApollo", function() {
    return 0, _reactHoc.withApollo;
});
parcelHelpers.export(exports, "withMutation", function() {
    return 0, _reactHoc.withMutation;
});
parcelHelpers.export(exports, "withQuery", function() {
    return 0, _reactHoc.withQuery;
});
parcelHelpers.export(exports, "withSubscription", function() {
    return 0, _reactHoc.withSubscription;
});
parcelHelpers.export(exports, "useApolloClient", function() {
    return 0, _reactHooks.useApolloClient;
});
parcelHelpers.export(exports, "useLazyQuery", function() {
    return 0, _reactHooks.useLazyQuery;
});
parcelHelpers.export(exports, "useMutation", function() {
    return 0, _reactHooks.useMutation;
});
parcelHelpers.export(exports, "useQuery", function() {
    return 0, _reactHooks.useQuery;
});
parcelHelpers.export(exports, "useSubscription", function() {
    return 0, _reactHooks.useSubscription;
});
parcelHelpers.export(exports, "getDataFromTree", function() {
    return 0, _reactSsr.getDataFromTree;
});
parcelHelpers.export(exports, "getMarkupFromTree", function() {
    return 0, _reactSsr.getMarkupFromTree;
});
parcelHelpers.export(exports, "renderToStringWithData", function() {
    return 0, _reactSsr.renderToStringWithData;
});
var _reactCommon = require("@apollo/react-common");
var _reactComponents = require("@apollo/react-components");
var _reactHoc = require("@apollo/react-hoc");
var _reactHooks = require("@apollo/react-hooks");
var _reactSsr = require("@apollo/react-ssr");

},{"@apollo/react-common":"gOXGD","@apollo/react-components":"cbhCo","@apollo/react-hoc":false,"@apollo/react-hooks":"1y5Yi","@apollo/react-ssr":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gOXGD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", function() {
    return ApolloConsumer;
});
parcelHelpers.export(exports, "ApolloProvider", function() {
    return ApolloProvider;
});
parcelHelpers.export(exports, "DocumentType", function() {
    return DocumentType;
});
parcelHelpers.export(exports, "getApolloContext", function() {
    return getApolloContext;
});
parcelHelpers.export(exports, "operationName", function() {
    return operationName;
});
parcelHelpers.export(exports, "parser", function() {
    return parser;
});
parcelHelpers.export(exports, "resetApolloContext", function() {
    return resetApolloContext;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tsInvariant = require("ts-invariant");
var apolloContext;
function getApolloContext() {
    if (!apolloContext) apolloContext = (0, _reactDefault.default).createContext({});
    return apolloContext;
}
function resetApolloContext() {
    apolloContext = (0, _reactDefault.default).createContext({});
}
var ApolloProvider = function ApolloProvider(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = getApolloContext();
    return (0, _reactDefault.default).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, _tsInvariant.invariant)(context.client, 5);
        return (0, _reactDefault.default).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var ApolloConsumer = function ApolloConsumer(props) {
    var ApolloContext = getApolloContext();
    return (0, _reactDefault.default).createElement(ApolloContext.Consumer, null, function(context) {
        (0, _tsInvariant.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var DocumentType;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch(type){
        case DocumentType.Query:
            name = "Query";
            break;
        case DocumentType.Mutation:
            name = "Mutation";
            break;
        case DocumentType.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function parser(document) {
    var cached = cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, _tsInvariant.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === "FragmentDefinition";
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "query";
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "mutation";
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === "OperationDefinition" && x.operation === "subscription";
    });
    (0, _tsInvariant.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, _tsInvariant.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length) type = DocumentType.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, _tsInvariant.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data";
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    cache.set(document, payload);
    return payload;
}

},{"react":"ktQNc","ts-invariant":"hgBT9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cbhCo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", function() {
    return 0, _reactCommon.ApolloConsumer;
});
parcelHelpers.export(exports, "ApolloProvider", function() {
    return 0, _reactCommon.ApolloProvider;
});
parcelHelpers.export(exports, "getApolloContext", function() {
    return 0, _reactCommon.getApolloContext;
});
parcelHelpers.export(exports, "resetApolloContext", function() {
    return 0, _reactCommon.resetApolloContext;
});
parcelHelpers.export(exports, "Mutation", function() {
    return Mutation;
});
parcelHelpers.export(exports, "Query", function() {
    return Query;
});
parcelHelpers.export(exports, "Subscription", function() {
    return Subscription;
});
var _reactCommon = require("@apollo/react-common");
var _tslib = require("tslib");
var _reactHooks = require("@apollo/react-hooks");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function Query(props) {
    var children = props.children, query = props.query, options = (0, _tslib.__rest)(props, [
        "children",
        "query"
    ]);
    var result = (0, _reactHooks.useQuery)(query, options);
    return children && result ? children(result) : null;
}
(function(Query) {
    Query.propTypes = {
        client: (0, _propTypesDefault.default).object,
        children: (0, _propTypesDefault.default).func.isRequired,
        fetchPolicy: (0, _propTypesDefault.default).string,
        notifyOnNetworkStatusChange: (0, _propTypesDefault.default).bool,
        onCompleted: (0, _propTypesDefault.default).func,
        onError: (0, _propTypesDefault.default).func,
        pollInterval: (0, _propTypesDefault.default).number,
        query: (0, _propTypesDefault.default).object.isRequired,
        variables: (0, _propTypesDefault.default).object,
        ssr: (0, _propTypesDefault.default).bool,
        partialRefetch: (0, _propTypesDefault.default).bool,
        returnPartialData: (0, _propTypesDefault.default).bool
    };
})(Query || (Query = {}));
function Mutation(props) {
    var _a = (0, _reactHooks.useMutation)(props.mutation, props), runMutation = _a[0], result = _a[1];
    return props.children ? props.children(runMutation, result) : null;
}
(function(Mutation) {
    Mutation.propTypes = {
        mutation: (0, _propTypesDefault.default).object.isRequired,
        variables: (0, _propTypesDefault.default).object,
        optimisticResponse: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).object,
            (0, _propTypesDefault.default).func
        ]),
        refetchQueries: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
                (0, _propTypesDefault.default).string,
                (0, _propTypesDefault.default).object
            ])),
            (0, _propTypesDefault.default).func
        ]),
        awaitRefetchQueries: (0, _propTypesDefault.default).bool,
        update: (0, _propTypesDefault.default).func,
        children: (0, _propTypesDefault.default).func.isRequired,
        onCompleted: (0, _propTypesDefault.default).func,
        onError: (0, _propTypesDefault.default).func,
        fetchPolicy: (0, _propTypesDefault.default).string
    };
})(Mutation || (Mutation = {}));
function Subscription(props) {
    var result = (0, _reactHooks.useSubscription)(props.subscription, props);
    return props.children && result ? props.children(result) : null;
}
(function(Subscription) {
    Subscription.propTypes = {
        subscription: (0, _propTypesDefault.default).object.isRequired,
        variables: (0, _propTypesDefault.default).object,
        children: (0, _propTypesDefault.default).func,
        onSubscriptionData: (0, _propTypesDefault.default).func,
        onSubscriptionComplete: (0, _propTypesDefault.default).func,
        shouldResubscribe: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).func,
            (0, _propTypesDefault.default).bool
        ])
    };
})(Subscription || (Subscription = {}));

},{"@apollo/react-common":false,"tslib":"1r1sc","@apollo/react-hooks":"1y5Yi","prop-types":"8INHm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1y5Yi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloConsumer", function() {
    return 0, _reactCommon.ApolloConsumer;
});
parcelHelpers.export(exports, "ApolloProvider", function() {
    return 0, _reactCommon.ApolloProvider;
});
parcelHelpers.export(exports, "getApolloContext", function() {
    return 0, _reactCommon.getApolloContext;
});
parcelHelpers.export(exports, "resetApolloContext", function() {
    return 0, _reactCommon.resetApolloContext;
});
parcelHelpers.export(exports, "RenderPromises", function() {
    return RenderPromises;
});
parcelHelpers.export(exports, "useApolloClient", function() {
    return useApolloClient;
});
parcelHelpers.export(exports, "useLazyQuery", function() {
    return useLazyQuery;
});
parcelHelpers.export(exports, "useMutation", function() {
    return useMutation;
});
parcelHelpers.export(exports, "useQuery", function() {
    return useQuery;
});
parcelHelpers.export(exports, "useSubscription", function() {
    return useSubscription;
});
var _reactCommon = require("@apollo/react-common");
var _tslib = require("tslib");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _apolloClient = require("apollo-client");
var _equality = require("@wry/equality");
var _tsInvariant = require("ts-invariant");
var OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, _equality.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, _tsInvariant.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, _reactCommon.parser)(document);
        var requiredOperationName = (0, _reactCommon.operationName)(type);
        var usedOperationName = (0, _reactCommon.operationName)(operation.type);
        (0, _tsInvariant.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var QueryData = function(_super) {
    (0, _tslib.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, onNewData = _a.onNewData;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.onNewData();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.onNewData = onNewData;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, _apolloClient.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) this.handleErrorOrCompleted();
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, _tslib.__assign)((0, _tslib.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.ssrInitiated = function() {
        return this.context && this.context.renderPromises;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = (0, _tslib.__assign)({
            loading: true,
            networkStatus: (0, _apolloClient.NetworkStatus).loading,
            called: true,
            data: undefined,
            stale: false,
            client: this.client
        }, this.observableQueryFields());
        if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
            this.previousData.result = ssrLoading;
            return ssrLoading;
        }
        var result;
        if (this.ssrInitiated()) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, _reactCommon.DocumentType).Query);
        var displayName = options.displayName || "Query";
        if (this.ssrInitiated() && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options.fetchPolicy = "cache-first";
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        var _a, _b;
        if (this.ssrInitiated()) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, _tslib.__assign)({}, observableQueryOptions));
            if (this.ssrInitiated()) (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 || _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, _equality.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function next(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, _equality.equal)(previousResult.data, data)) return;
                _this.onNewData();
            },
            error: function error(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty("graphQLErrors")) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, _equality.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.onNewData();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, _apolloClient.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, _tslib.__assign)((0, _tslib.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== "cache-only") {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, _apolloClient.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery || !this.previousData.result) return;
        var _a = this.previousData.result, data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, _equality.equal)(this.previousOptions.query, query) && (0, _equality.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}(OperationData);
function useDeepMemo(memoFn, key) {
    var ref = (0, _react.useRef)();
    if (!ref.current || !(0, _equality.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
    var _a = (0, _react.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, _react.useRef)();
    var queryData = queryDataRef.current || new QueryData({
        options: updatedOptions,
        context: context,
        onNewData: function onNewData() {
            if (!queryData.ssrInitiated()) Promise.resolve().then(forceUpdate);
            else forceUpdate();
        }
    });
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    if (queryData.ssrInitiated() && !queryDataRef.current) queryDataRef.current = queryData;
    var memo = {
        options: (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, _react.useEffect)(function() {
        if (!queryDataRef.current) queryDataRef.current = queryData;
        return function() {
            return queryData.cleanup();
        };
    }, []);
    (0, _react.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    return result;
}
function useQuery(query, options) {
    return useBaseQuery(query, options, false);
}
function useLazyQuery(query, options) {
    return useBaseQuery(query, options, true);
}
var MutationData = function(_super) {
    (0, _tslib.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, _reactCommon.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, _reactCommon.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, _tslib.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, _tslib.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, _apolloClient.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function callOncomplete() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, _equality.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}(OperationData);
function useMutation(mutation, options) {
    var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
    var _a = (0, _react.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, _react.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, _react.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var SubscriptionData = function(_super) {
    (0, _tslib.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === "function") shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, _equality.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}(OperationData);
function useSubscription(subscription, options) {
    var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
    var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, _react.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, _react.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, _react.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, _react.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function useApolloClient() {
    var client = (0, _reactDefault.default).useContext((0, _reactCommon.getApolloContext)()).client;
    (0, _tsInvariant.invariant)(client, 1);
    return client;
}
function makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var RenderPromises = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

},{"@apollo/react-common":"gOXGD","tslib":"1r1sc","react":"ktQNc","apollo-client":"lgvsE","@wry/equality":"cnuZS","ts-invariant":"hgBT9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bpqm8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpLink", function() {
    return HttpLink;
});
parcelHelpers.export(exports, "createHttpLink", function() {
    return createHttpLink;
});
var _tslib = require("tslib");
var _apolloLink = require("apollo-link");
var _apolloLinkHttpCommon = require("apollo-link-http-common");
var createHttpLink = function createHttpLink(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = (0, _tslib.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries"
    ]);
    (0, _apolloLinkHttpCommon.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, _apolloLink.ApolloLink)(function(operation) {
        var chosenURI = (0, _apolloLinkHttpCommon.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, _tslib.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, _apolloLinkHttpCommon.selectHttpOptionsAndBody)(operation, (0, _apolloLinkHttpCommon.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, _apolloLinkHttpCommon.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function definitionIsMutation(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (options.method === "GET") {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, _$parseError = _d.parseError;
            if (_$parseError) return (0, _apolloLink.fromError)(_$parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, _apolloLinkHttpCommon.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, _apolloLink.fromError)(parseError);
        }
        return new (0, _apolloLink.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, _apolloLinkHttpCommon.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === "AbortError") return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function addQueryParam(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, _apolloLinkHttpCommon.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, _apolloLinkHttpCommon.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}
var HttpLink = function(_super) {
    (0, _tslib.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}((0, _apolloLink.ApolloLink));

},{"tslib":"1r1sc","apollo-link":"hbph2","apollo-link-http-common":"k3OHn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"k3OHn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkFetcher", function() {
    return checkFetcher;
});
parcelHelpers.export(exports, "createSignalIfSupported", function() {
    return createSignalIfSupported;
});
parcelHelpers.export(exports, "fallbackHttpConfig", function() {
    return fallbackHttpConfig;
});
parcelHelpers.export(exports, "parseAndCheckHttpResponse", function() {
    return parseAndCheckHttpResponse;
});
parcelHelpers.export(exports, "selectHttpOptionsAndBody", function() {
    return selectHttpOptionsAndBody;
});
parcelHelpers.export(exports, "selectURI", function() {
    return selectURI;
});
parcelHelpers.export(exports, "serializeFetchParameter", function() {
    return serializeFetchParameter;
});
parcelHelpers.export(exports, "throwServerError", function() {
    return throwServerError;
});
var _tslib = require("tslib");
var _printer = require("graphql/language/printer");
var _tsInvariant = require("ts-invariant");
var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var defaultHeaders = {
    accept: "*/*",
    "content-type": "application/json"
};
var defaultOptions = {
    method: "POST"
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions
};
var throwServerError = function throwServerError(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function parseAndCheckHttpResponse(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = "ServerParseError";
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) throwServerError(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty("data") && !result.hasOwnProperty("errors")) throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var checkFetcher = function checkFetcher(fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        var library = "unfetch";
        if (typeof window === "undefined") library = "node-fetch";
        throw new (0, _tsInvariant.InvariantError)(1);
    }
};
var createSignalIfSupported = function createSignalIfSupported() {
    if (typeof AbortController === "undefined") return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var selectHttpOptionsAndBody = function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, _tslib.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, _tslib.__assign)({}, options, config.options, {
            headers: (0, _tslib.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, _tslib.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, _printer.print)(query);
    return {
        options: options,
        body: body
    };
};
var serializeFetchParameter = function serializeFetchParameter(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, _tsInvariant.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function selectURI(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

},{"tslib":"1r1sc","graphql/language/printer":"iyzwT","ts-invariant":"hgBT9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iyzwT":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.print = print;
var _visitor = require("a6ba14fa1deb3f50");
var _blockString = require("53f46639256d2e3d");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */ function print(ast) {
    return (0, _visitor.visit)(ast, {
        leave: printDocASTReducer
    });
} // TODO: provide better type coverage in future
var printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return "$" + node.name;
    },
    // Document
    Document: function Document(node) {
        return join(node.definitions, "\n\n") + "\n";
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = wrap("(", join(node.variableDefinitions, ", "), ")");
        var directives = join(node.directives, " ");
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === "query" ? selectionSet : join([
            op,
            join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], " ");
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ": " + type + wrap(" = ", defaultValue) + wrap(" ", join(directives, " "));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        return join([
            wrap("", alias, ": ") + name + wrap("(", join(args, ", "), ")"),
            join(directives, " "),
            selectionSet
        ], " ");
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ": " + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return "..." + name + wrap(" ", join(directives, " "));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return join([
            "...",
            wrap("on ", typeCondition),
            join(directives, " "),
            selectionSet
        ], " ");
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat(wrap("(", join(variableDefinitions, ", "), ")"), " ") + "on ".concat(typeCondition, " ").concat(wrap("", join(directives, " "), " ")) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, _blockString.printBlockString)(value, key === "description" ? "" : "  ") : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? "true" : "false";
    },
    NullValue: function NullValue() {
        return "null";
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return "[" + join(values, ", ") + "]";
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return "{" + join(fields, ", ") + "}";
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ": " + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return "@" + name + wrap("(", join(args, ", "), ")");
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return "[" + type + "]";
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + "!";
    },
    // Type System Definitions
    SchemaDefinition: function SchemaDefinition(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return join([
            "schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    },
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ": " + type;
    },
    ScalarTypeDefinition: addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return join([
            "scalar",
            name,
            join(directives, " ")
        ], " ");
    }),
    ObjectTypeDefinition: addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return join([
            "type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    FieldDefinition: addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + ": " + type + wrap(" ", join(directives, " "));
    }),
    InputValueDefinition: addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return join([
            name + ": " + type,
            wrap("= ", defaultValue),
            join(directives, " ")
        ], " ");
    }),
    InterfaceTypeDefinition: addDescription(function(_ref26) {
        var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
        return join([
            "interface",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    UnionTypeDefinition: addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return join([
            "union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    }),
    EnumTypeDefinition: addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return join([
            "enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    }),
    EnumValueDefinition: addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return join([
            name,
            join(directives, " ")
        ], " ");
    }),
    InputObjectTypeDefinition: addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return join([
            "input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }),
    DirectiveDefinition: addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, locations = _ref31.locations;
        return "directive @" + name + (hasMultilineItems(args) ? wrap("(\n", indent(join(args, "\n")), "\n)") : wrap("(", join(args, ", "), ")")) + " on " + join(locations, " | ");
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return join([
            "extend schema",
            join(directives, " "),
            block(operationTypes)
        ], " ");
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return join([
            "extend scalar",
            name,
            join(directives, " ")
        ], " ");
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return join([
            "extend type",
            name,
            wrap("implements ", join(interfaces, " & ")),
            join(directives, " "),
            block(fields)
        ], " ");
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, directives = _ref35.directives, fields = _ref35.fields;
        return join([
            "extend interface",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return join([
            "extend union",
            name,
            join(directives, " "),
            types && types.length !== 0 ? "= " + join(types, " | ") : ""
        ], " ");
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return join([
            "extend enum",
            name,
            join(directives, " "),
            block(values)
        ], " ");
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return join([
            "extend input",
            name,
            join(directives, " "),
            block(fields)
        ], " ");
    }
};
function addDescription(cb) {
    return function(node) {
        return join([
            node.description,
            cb(node)
        ], "\n");
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function join(maybeArray, separator) {
    return maybeArray ? maybeArray.filter(function(x) {
        return x;
    }).join(separator || "") : "";
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function block(array) {
    return array && array.length !== 0 ? "{\n" + indent(join(array, "\n")) + "\n}" : "";
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */ function wrap(start, maybeString, end) {
    return maybeString ? start + maybeString + (end || "") : "";
}
function indent(maybeString) {
    return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
}
function isMultiline(string) {
    return string.indexOf("\n") !== -1;
}
function hasMultilineItems(maybeArray) {
    return maybeArray && maybeArray.some(isMultiline);
}

},{"a6ba14fa1deb3f50":"2YdUO","53f46639256d2e3d":"7PbQ1"}],"7PbQ1":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dedentBlockStringValue = dedentBlockStringValue;
exports.getBlockStringIndentation = getBlockStringIndentation;
exports.printBlockString = printBlockString;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */ function dedentBlockStringValue(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = getBlockStringIndentation(lines);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    while(lines.length > 0 && isBlank(lines[0]))lines.shift();
    while(lines.length > 0 && isBlank(lines[lines.length - 1]))lines.pop();
     // Return a string of the lines joined with U+000A.
    return lines.join("\n");
} // @internal
function getBlockStringIndentation(lines) {
    var commonIndent = null;
    for(var i = 1; i < lines.length; i++){
        var line = lines[i];
        var indent = leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        if (commonIndent === null || indent < commonIndent) {
            commonIndent = indent;
            if (commonIndent === 0) break;
        }
    }
    return commonIndent === null ? 0 : commonIndent;
}
function leadingWhitespace(str) {
    var i = 0;
    while(i < str.length && (str[i] === " " || str[i] === "	"))i++;
    return i;
}
function isBlank(str) {
    return leadingWhitespace(str) === str.length;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */ function printBlockString(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf("\n") === -1;
    var hasLeadingSpace = value[0] === " " || value[0] === "	";
    var hasTrailingQuote = value[value.length - 1] === '"';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
    var result = ""; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += "\n" + indentation;
    result += indentation ? value.replace(/\n/g, "\n" + indentation) : value;
    if (printAsMultipleLines) result += "\n";
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

},{}],"7nx77":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RetryLink", function() {
    return RetryLink;
});
var _tslib = require("tslib");
var _apolloLink = require("apollo-link");
function buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, _tslib.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var RetryLink = function(_super) {
    (0, _tslib.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === "function" ? delay : buildDelayFunction(delay);
        _this.retryIf = typeof attempts === "function" ? attempts : buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, _apolloLink.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, _apolloLink.ApolloLink));

},{"tslib":"1r1sc","apollo-link":"hbph2","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"jJw1o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeuristicFragmentMatcher", function() {
    return HeuristicFragmentMatcher;
});
parcelHelpers.export(exports, "InMemoryCache", function() {
    return InMemoryCache;
});
parcelHelpers.export(exports, "IntrospectionFragmentMatcher", function() {
    return IntrospectionFragmentMatcher;
});
parcelHelpers.export(exports, "ObjectCache", function() {
    return ObjectCache;
});
parcelHelpers.export(exports, "StoreReader", function() {
    return StoreReader;
});
parcelHelpers.export(exports, "StoreWriter", function() {
    return StoreWriter;
});
parcelHelpers.export(exports, "WriteError", function() {
    return WriteError;
});
parcelHelpers.export(exports, "assertIdValue", function() {
    return assertIdValue;
});
parcelHelpers.export(exports, "defaultDataIdFromObject", function() {
    return defaultDataIdFromObject;
});
parcelHelpers.export(exports, "defaultNormalizedCacheFactory", function() {
    return defaultNormalizedCacheFactory$1;
});
parcelHelpers.export(exports, "enhanceErrorWithDocument", function() {
    return enhanceErrorWithDocument;
});
var _tslib = require("tslib");
var _apolloCache = require("apollo-cache");
var _apolloUtilities = require("apollo-utilities");
var _optimism = require("optimism");
var _tsInvariant = require("ts-invariant");
var haveWarned = false;
function shouldWarn() {
    var answer = !haveWarned;
    if (!(0, _apolloUtilities.isTest)()) haveWarned = true;
    return answer;
}
var HeuristicFragmentMatcher = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === "ROOT_QUERY";
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && "Query" : _a;
        if (!__typename) {
            shouldWarn();
            return "heuristic";
        }
        if (__typename === typeCondition) return true;
        shouldWarn();
        return "heuristic";
    };
    return HeuristicFragmentMatcher;
}();
var IntrospectionFragmentMatcher = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, _tsInvariant.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === "ROOT_QUERY";
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && "Query" : _a;
        (0, _tsInvariant.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === "UNION" || type.kind === "INTERFACE") typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, _optimism.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function makeCacheKey(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}
var StoreReader = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, _optimism.KeyTrie)((0, _apolloUtilities.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, _optimism.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function makeCacheKey(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, _optimism.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function makeCacheKey(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, _optimism.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function makeCacheKey(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? "ROOT_QUERY" : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, _apolloUtilities.getQueryDefinition)(query);
        variables = (0, _apolloUtilities.assign)({}, (0, _apolloUtilities.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: "id",
                id: rootId,
                generated: true,
                typename: "Query"
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, _tsInvariant.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, _apolloUtilities.isEqual)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = (0, _apolloUtilities.getMainDefinition)(query);
        var fragments = (0, _apolloUtilities.getFragmentDefinitions)(query);
        var fragmentMap = (0, _apolloUtilities.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === "ROOT_QUERY" && "Query" || void 0;
        function handleMissing(result) {
            var _$_a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_$_a = finalResult.missing).push.apply(_$_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _$_a;
            if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) return;
            if ((0, _apolloUtilities.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== "undefined") objectsToMerge.push((_$_a = {}, _$_a[(0, _apolloUtilities.resultKeyNameFromField)(selection)] = fieldResult, _$_a));
            } else {
                var fragment = void 0;
                if ((0, _apolloUtilities.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, _tsInvariant.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === "heuristic" && fragmentExecResult.missing) fragmentExecResult = (0, _tslib.__assign)((0, _tslib.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, _tslib.__assign)((0, _tslib.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, _apolloUtilities.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, _apolloUtilities.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, _apolloUtilities.resultKeyNameFromField)(field),
            directives: (0, _apolloUtilities.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, _apolloUtilities.isIdValue)(value)) throw new (0, _tsInvariant.InvariantError)(10);
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
    (0, _tsInvariant.invariant)((0, _apolloUtilities.isIdValue)(idValue), 11);
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, _apolloUtilities.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === "undefined" && context.cacheRedirects && typeof typename === "string") {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function getCacheKey(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, _apolloUtilities.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === "undefined") return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, _apolloUtilities.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var ObjectCache = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function defaultNormalizedCacheFactory$1(seed) {
    return new ObjectCache(seed);
}
var WriteError = function(_super) {
    (0, _tslib.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "WriteError";
        return _this;
    }
    return WriteError;
}(Error);
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += "\n" + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var StoreWriter = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: "ROOT_QUERY",
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, _apolloUtilities.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, _apolloUtilities.assign)({}, (0, _apolloUtilities.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, _apolloUtilities.createFragmentMap)((0, _apolloUtilities.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _$_a;
            if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) return;
            if ((0, _apolloUtilities.isField)(selection)) {
                var resultFieldKey = (0, _apolloUtilities.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== "undefined") _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === "defer";
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === "client";
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, _apolloUtilities.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, _tsInvariant.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || "self";
                    var idValue = (0, _apolloUtilities.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new ObjectCache((_$_a = {}, _$_a[id] = result, _$_a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, _apolloUtilities.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, _apolloUtilities.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === "object" ? {
            type: "json",
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) valueDataId = "$" + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, _tsInvariant.invariant)(!semanticId || !isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === "number" && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, _apolloUtilities.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, _apolloUtilities.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, _tsInvariant.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, _tsInvariant.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, _apolloUtilities.isEqual)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, _tslib.__assign)((0, _tslib.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, _apolloUtilities.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function isGeneratedId(id) {
    return id[0] === "$";
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, _apolloUtilities.isIdValue)(value) && isGeneratedId(value.id) && (0, _apolloUtilities.isIdValue)(realValue) && !(0, _apolloUtilities.isEqual)(value, realValue) && mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, _tslib.__assign)((0, _tslib.__assign)({}, generated), real);
    if ((0, _apolloUtilities.isEqual)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var defaultConfig = {
    fragmentMatcher: new HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var hasOwn$1 = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = function(_super) {
    (0, _tslib.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(ObjectCache);
var InMemoryCache = function(_super) {
    (0, _tslib.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, _optimism.KeyTrie)((0, _apolloUtilities.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new DepTrackingCache() : new ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeWriter = new StoreWriter();
        _this.storeReader = new StoreReader({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, _optimism.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function makeCacheKey(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === "string" && typeof this.data.get(options.rootId) === "undefined") return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, _tsInvariant.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === "string") this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, _apolloUtilities.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, _apolloCache.ApolloCache));

},{"tslib":"1r1sc","apollo-cache":"csr8Q","apollo-utilities":"7oVQU","optimism":"eYxfk","ts-invariant":"hgBT9","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"csr8Q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ApolloCache", function() {
    return ApolloCache;
});
parcelHelpers.export(exports, "Cache", function() {
    return Cache;
});
var _apolloUtilities = require("apollo-utilities");
function queryFromPojo(obj) {
    var op = {
        kind: "OperationDefinition",
        operation: "query",
        name: {
            kind: "Name",
            value: "GeneratedClientQuery"
        },
        selectionSet: selectionSetFromObj(obj)
    };
    var out = {
        kind: "Document",
        definitions: [
            op
        ]
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: "FragmentDefinition",
        typeCondition: {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: typename || "__FakeType"
            }
        },
        name: {
            kind: "Name",
            value: "GeneratedClientQuery"
        },
        selectionSet: selectionSetFromObj(obj)
    };
    var out = {
        kind: "Document",
        definitions: [
            frag
        ]
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === "number" || typeof obj === "boolean" || typeof obj === "string" || typeof obj === "undefined" || obj === null) return null;
    if (Array.isArray(obj)) return selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: "Field",
            name: {
                kind: "Name",
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: "SelectionSet",
        selections: selections
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: null,
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var ApolloCache = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, _apolloUtilities.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: "ROOT_QUERY",
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, _apolloUtilities.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== "undefined") {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || "__ClientData";
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var Cache;
Cache || (Cache = {});

},{"apollo-utilities":"7oVQU","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"eYxfk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncFromGen", function() {
    return 0, _context.asyncFromGen;
});
parcelHelpers.export(exports, "bindContext", function() {
    return 0, _context.bind;
});
parcelHelpers.export(exports, "noContext", function() {
    return 0, _context.noContext;
});
parcelHelpers.export(exports, "setTimeout", function() {
    return 0, _context.setTimeout;
});
parcelHelpers.export(exports, "KeyTrie", function() {
    return KeyTrie;
});
parcelHelpers.export(exports, "defaultMakeCacheKey", function() {
    return defaultMakeCacheKey;
});
parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _context = require("@wry/context");
function defaultDispose() {}
var Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var parentEntrySlot = new (0, _context.Slot)();
var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        assert(!this.recomputing, "already recomputing");
        if (!rememberParent(this) && maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return mightBeDirty(this) ? reallyRecompute(this) : valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        forgetChildren(this).forEach(maybeReportOrphan);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if (mightBeDirty(child)) reportDirtyChild(parent, child);
        else reportCleanChild(parent, child);
        return parent;
    }
}
function reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [
        entry
    ]);
    if (maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach(maybeReportOrphan);
    return valueGet(entry.value);
}
function recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function(parent) {
        return reportDirtyChild(parent, child);
    });
}
function reportClean(child) {
    child.parents.forEach(function(parent) {
        return reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, valueCopy(child.value));
    else if (!valueIs(childValue, child.value)) parent.setDirty();
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) return;
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    var children = reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
    return children;
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var KeyTrie = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function isObjRef(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        if (disposable && !parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function(cache) {
                return cache.clean();
            });
            caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

},{"@swc/helpers/_/_type_of":"6Gp9n","@wry/context":"frlPw","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"frlPw":[function(require,module,exports) {
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slot", function() {
    return Slot;
});
parcelHelpers.export(exports, "asyncFromGen", function() {
    return asyncFromGen;
});
parcelHelpers.export(exports, "bind", function() {
    return bind;
});
parcelHelpers.export(exports, "noContext", function() {
    return noContext;
});
parcelHelpers.export(exports, "setTimeout", function() {
    return setTimeoutWithContext;
});
parcelHelpers.export(exports, "wrapYieldingFiberMethods", function() {
    return wrapYieldingFiberMethods;
});
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function makeSlotClass() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE) break;
                if (context_1 !== currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                currentContext.slots[this.id] = value;
                return true;
            }
            if (currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = currentContext;
            currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = currentContext;
            return function() {
                var saved = currentContext;
                try {
                    currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if (currentContext) {
                var saved = currentContext;
                try {
                    currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function() {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function invokeNext(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function invokeThrow(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = [];
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function wrap(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fgLOo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserContextState", function() {
    return UserContextState;
});
parcelHelpers.export(exports, "UserReducer", function() {
    return UserReducer;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var UserContext = /*#__PURE__*/ (0, _react.createContext)();
var UserContextState = {
    user: null,
    loading: true
};
var UserReducer = function(state, action) {
    switch(action.type){
        case "SET_USER":
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                user: action.user || false,
                loading: action.loading
            });
        case "SET_LOADING":
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                loading: action.loading
            });
        default:
            return state;
    }
};
exports.default = UserContext;

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react":"ktQNc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cY0Es":[function(require,module,exports) {
module.exports = JSON.parse('{"__schema":{"types":[{"kind":"UNION","name":"Evaluation","possibleTypes":[{"name":"ClassificationSingleEvaluation"},{"name":"ClassificationMultipleEvaluation"},{"name":"AnnotationEvaluation"},{"name":"ObjectDetectionEvaluation"},{"name":"RationalizedClassificationEvaluation"},{"name":"UnbundlingEvaluation"}]},{"kind":"INTERFACE","name":"LabelInterface","possibleTypes":[{"name":"SimpleLabel"},{"name":"ClassLabel"},{"name":"MultiClassLabel"},{"name":"ExtractLabel"}]},{"kind":"INTERFACE","name":"PredictionInterface","possibleTypes":[{"name":"SimplePrediction"},{"name":"ClassPrediction"},{"name":"MultiClassPrediction"},{"name":"ExtractPrediction"}]},{"kind":"UNION","name":"Prediction","possibleTypes":[{"name":"AnnotationPrediction"},{"name":"ClassificationPrediction"},{"name":"ClassificationMultiplePrediction"},{"name":"RationalizedClassificationPrediction"}]},{"kind":"INTERFACE","name":"OCROptions","possibleTypes":[{"name":"OmnipageOcrOptions"},{"name":"ReadapiOcrOptions"}]},{"kind":"INTERFACE","name":"ComponentInterface","possibleTypes":[{"name":"Component"},{"name":"ModelGroupComponent"},{"name":"ContentLengthComponent"},{"name":"BlueprintComponent"},{"name":"LinkLabelComponent"},{"name":"LinkClassificationModelComponent"}]}]}}');

},{}],"bEw7j":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppContainer", function() {
    return AppContainer;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _userContext = require("./store/userContext");
var _userContextDefault = parcelHelpers.interopDefault(_userContext);
var _authActions = require("./modules/auth/actions/auth-actions");
var _mainRouterWrapper = require("./MainRouterWrapper");
var AppContainer = function() {
    var dispatch = (0, _react.useContext)((0, _userContextDefault.default))[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainRouterWrapper.MainRouterWrapper), {
        updateUserContext: dispatch,
        verifyUser: (0, _authActions.verifyUser)
    });
};

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","./store/userContext":"fgLOo","./modules/auth/actions/auth-actions":"Ykv2h","./MainRouterWrapper":"96R9n","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"Ykv2h":[function(require,module,exports) {
// App Deps
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getXSRFToken", function() {
    return getXSRFToken;
});
parcelHelpers.export(exports, "verifyUser", function() {
    return verifyUser;
});
parcelHelpers.export(exports, "authenticateUser", function() {
    return authenticateUser;
});
parcelHelpers.export(exports, "logoutUser", function() {
    return logoutUser;
});
var _storageProvider = require("root/providers/storage-provider");
var _app = require("root/constants/app");
// Auth Deps
var _errorCodes = require("Auth/constants/error-codes");
var _messages = require("Auth/constants/messages");
var _authProvider = require("Auth/providers/auth-provider");
var getXSRFToken = function(signal) {
    return (0, _authProvider.getXSRFTokenAPI)(signal).then(function(token) {
        return token;
    });
};
var verifyUser = function() {
    return (0, _authProvider.verifyUserAPI)().then(function(user) {
        return user;
    }).catch(function(err) {
        return Promise.reject(err);
    });
};
var authenticateUser = function(user, dispatch, addToast, captchaToken) {
    if (user.rememberMe) _storageProvider.storeValue((0, _app.STORAGE_VALUE_EMAIL), user.email);
    else _storageProvider.clearValue((0, _app.STORAGE_VALUE_EMAIL));
    var email = user.email, password = user.password;
    dispatch({
        type: "SET_LOADING",
        loading: true
    });
    return (0, _authProvider.postUserLoginAPI)({
        email: email,
        password: password
    }, (user === null || user === void 0 ? void 0 : user.xsrfToken) || "", captchaToken).then(function() {
        addToast(_messages.LOGIN_SUCCESS, "success");
        return verifyUser().then(function(user) {
            dispatch({
                type: "SET_USER",
                user: user,
                loading: false
            });
        });
    }).catch(function(err) {
        if (err.error_type === _errorCodes.LOGIN_REQUIRED) addToast(_messages.LOGIN_FAILED, "error");
        else if (err.error_type === _errorCodes.ACCOUNT_LOCKED) addToast(_messages.ACCOUNT_LOCKED, "error");
        else if (err.error_type === _errorCodes.SESSION_LIMIT) addToast(_messages.SESSION_LIMIT, "error");
        else if (err.error_type === _errorCodes.EXPIRED_ACCOUNT) ;
        else if (err.error_type === _errorCodes.CONFIRMATION_REQUIRED) addToast(_messages.LOGIN_ERROR_CONFIRMATION_REQUIRED, "error");
        else addToast(_messages.LOGIN_ERROR, "error");
        dispatch({
            type: "SET_LOADING",
            loading: false
        });
        return Promise.reject({
            type: err.error_type
        });
    });
};
var logoutUser = function(dispatch, xsrfToken, addToast) {
    return (0, _authProvider.userLogoutAPI)(xsrfToken).then(function() {
        addToast(_messages.LOGOUT_SUCCESS, "success");
        dispatch({
            type: "SET_USER",
            user: null,
            loading: false
        });
    }).catch(function() {
        addToast(_messages.LOGOUT_FAILED, "error");
    });
};

},{"root/providers/storage-provider":"63siG","root/constants/app":"644BQ","Auth/constants/error-codes":"kNqCK","Auth/constants/messages":"kPJ7S","Auth/providers/auth-provider":"gTNsy","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"63siG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "storeValue", function() {
    return storeValue;
});
parcelHelpers.export(exports, "retrieveValue", function() {
    return retrieveValue;
});
parcelHelpers.export(exports, "clearValue", function() {
    return clearValue;
});
parcelHelpers.export(exports, "clearAll", function() {
    return clearAll;
});
var _app = require("root/constants/app");
var storeValue = function(key, value) {
    return new Promise(function(resolve, reject) {
        try {
            var rawContents = localStorage.getItem((0, _app.STORAGE_KEY));
            var contents = rawContents ? JSON.parse(rawContents) : {};
            contents[key] = value;
            localStorage.setItem((0, _app.STORAGE_KEY), JSON.stringify(contents));
            resolve(contents);
        } catch (e) {
            reject();
        }
    });
};
var retrieveValue = function(key) {
    return new Promise(function(resolve, reject) {
        try {
            var rawContents = localStorage.getItem((0, _app.STORAGE_KEY));
            var contents = rawContents ? JSON.parse(rawContents) : {};
            if (contents.hasOwnProperty(key)) resolve(contents[key]);
            else reject();
        } catch (e) {
            reject();
        }
    });
};
var clearValue = function(key) {
    return new Promise(function(resolve, reject) {
        try {
            var rawContents = localStorage.getItem((0, _app.STORAGE_KEY));
            var contents = rawContents ? JSON.parse(rawContents) : {};
            if (contents.hasOwnProperty(key)) delete contents[key];
            localStorage.setItem((0, _app.STORAGE_KEY), JSON.stringify(contents));
            resolve(contents);
        } catch (e) {
            reject();
        }
    });
};
var clearAll = function() {
    return new Promise(function(resolve, reject) {
        try {
            localStorage.removeItem((0, _app.STORAGE_KEY));
        } catch (e) {
            reject();
        }
    });
};

},{"root/constants/app":"644BQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"644BQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STORAGE_KEY", function() {
    return STORAGE_KEY;
});
parcelHelpers.export(exports, "STORAGE_VALUE_EMAIL", function() {
    return STORAGE_VALUE_EMAIL;
});
parcelHelpers.export(exports, "PARAM_AUTH_REDIRECT_KEY", function() {
    return PARAM_AUTH_REDIRECT_KEY;
});
parcelHelpers.export(exports, "PARAM_TOKEN_KEY", function() {
    return PARAM_TOKEN_KEY;
});
parcelHelpers.export(exports, "TOAST_TIMEOUT", function() {
    return TOAST_TIMEOUT;
});
var STORAGE_KEY = "INDICO_USER";
var STORAGE_VALUE_EMAIL = "USER_EMAIL";
var PARAM_AUTH_REDIRECT_KEY = "redirect_url";
var PARAM_TOKEN_KEY = "token";
var TOAST_TIMEOUT = 5000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kNqCK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSPECIFIED", function() {
    return UNSPECIFIED;
});
parcelHelpers.export(exports, "LOGIN_REQUIRED", function() {
    return LOGIN_REQUIRED;
});
parcelHelpers.export(exports, "EXPIRED_TOKEN", function() {
    return EXPIRED_TOKEN;
});
parcelHelpers.export(exports, "INVALID_TOKEN", function() {
    return INVALID_TOKEN;
});
parcelHelpers.export(exports, "INVALID_REQUEST", function() {
    return INVALID_REQUEST;
});
parcelHelpers.export(exports, "BLACKLIST", function() {
    return BLACKLIST;
});
parcelHelpers.export(exports, "ACCOUNT_LOCKED", function() {
    return ACCOUNT_LOCKED;
});
parcelHelpers.export(exports, "SESSION_LIMIT", function() {
    return SESSION_LIMIT;
});
parcelHelpers.export(exports, "CONFIRMATION_REQUIRED", function() {
    return CONFIRMATION_REQUIRED;
});
parcelHelpers.export(exports, "EXPIRED_ACCOUNT", function() {
    return EXPIRED_ACCOUNT;
});
var UNSPECIFIED = "Unspecified Error"; // Catch all error type
var LOGIN_REQUIRED = "LoginRequired";
var EXPIRED_TOKEN = "ExpiredTokenException";
var INVALID_TOKEN = "InvalidTokenException";
var INVALID_REQUEST = "InvalidRequestException";
var BLACKLIST = "InvalidEmail";
var ACCOUNT_LOCKED = "AccountLocked";
var SESSION_LIMIT = "SessionLimit";
var CONFIRMATION_REQUIRED = "ConfirmationRequired";
var EXPIRED_ACCOUNT = "ExpiredAccount";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kPJ7S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LOGIN_SUCCESS", function() {
    return LOGIN_SUCCESS;
});
parcelHelpers.export(exports, "LOGIN_FAILED", function() {
    return LOGIN_FAILED;
});
parcelHelpers.export(exports, "LOGIN_ERROR", function() {
    return LOGIN_ERROR;
});
parcelHelpers.export(exports, "LOGIN_ERROR_CONFIRMATION_REQUIRED", function() {
    return LOGIN_ERROR_CONFIRMATION_REQUIRED;
});
parcelHelpers.export(exports, "LOGOUT_SUCCESS", function() {
    return LOGOUT_SUCCESS;
});
parcelHelpers.export(exports, "LOGOUT_FAILED", function() {
    return LOGOUT_FAILED;
});
parcelHelpers.export(exports, "PASSWORD_FORGOT_SUCCESS", function() {
    return PASSWORD_FORGOT_SUCCESS;
});
parcelHelpers.export(exports, "PASSWORD_FORGOT_FAILED", function() {
    return PASSWORD_FORGOT_FAILED;
});
parcelHelpers.export(exports, "PASSWORD_RESET_SUCCESS", function() {
    return PASSWORD_RESET_SUCCESS;
});
parcelHelpers.export(exports, "PASSWORD_RESET_EXPIRED", function() {
    return PASSWORD_RESET_EXPIRED;
});
parcelHelpers.export(exports, "ACCOUNT_ACTIVATION_EXPIRED", function() {
    return ACCOUNT_ACTIVATION_EXPIRED;
});
parcelHelpers.export(exports, "PASSWORD_RESET_FAILED", function() {
    return PASSWORD_RESET_FAILED;
});
parcelHelpers.export(exports, "REGISTRATION_SUCCESS", function() {
    return REGISTRATION_SUCCESS;
});
parcelHelpers.export(exports, "DUPLICATE_REGISTRATION", function() {
    return DUPLICATE_REGISTRATION;
});
parcelHelpers.export(exports, "REGISTRATION_FAILED", function() {
    return REGISTRATION_FAILED;
});
parcelHelpers.export(exports, "ACCOUNT_LOCKED", function() {
    return ACCOUNT_LOCKED;
});
parcelHelpers.export(exports, "SESSION_LIMIT", function() {
    return SESSION_LIMIT;
});
parcelHelpers.export(exports, "BLACKLIST_EMAIL", function() {
    return BLACKLIST_EMAIL;
});
var LOGIN_SUCCESS = "You are now logged into your indico account.";
var LOGIN_FAILED = "Invalid Email or Password";
var LOGIN_ERROR = "An error occurred while attempting to log you in. Please try again.";
var LOGIN_ERROR_CONFIRMATION_REQUIRED = "There was an error attempting to access your account. Please make sure your account is active by using the link in the registration email.";
var LOGOUT_SUCCESS = "You are now logged out from your indico account.";
var LOGOUT_FAILED = "We were unable to complete the log out";
var PASSWORD_FORGOT_SUCCESS = "Success! Check your email to complete resetting your password.";
var PASSWORD_FORGOT_FAILED = "Sorry, We were unable to find that account.";
var PASSWORD_RESET_SUCCESS = "Your password has been updated.";
var PASSWORD_RESET_EXPIRED = "Your password reset link has expired. You will need to request a new link.";
var ACCOUNT_ACTIVATION_EXPIRED = "Your account activation link has expired. You will need register again.";
var PASSWORD_RESET_FAILED = "Unable to reset your password.";
var REGISTRATION_SUCCESS = "Congrats! Your indico account is almost good to go. Just check your email for your confirmation email.";
var DUPLICATE_REGISTRATION = "An account with this email address already exists.";
var REGISTRATION_FAILED = "An error occurred while attempting to register your account. Please try again.";
var ACCOUNT_LOCKED = "You have been locked out of your account due to unsuccessful login attempts. Please contact your site administrator or wait until your lockout expires.";
var SESSION_LIMIT = "You currently have another session open. Please log out before attempting to log in.";
var BLACKLIST_EMAIL = "Business email address is required.";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gTNsy":[function(require,module,exports) {
// App
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getXSRFTokenAPI", function() {
    return getXSRFTokenAPI;
});
parcelHelpers.export(exports, "verifyUserAPI", function() {
    return verifyUserAPI;
});
parcelHelpers.export(exports, "postUserLoginAPI", function() {
    return postUserLoginAPI;
});
parcelHelpers.export(exports, "userLogoutAPI", function() {
    return userLogoutAPI;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@indico-data/utils");
// Auth
var _endpoints = require("Auth/constants/endpoints");
var getXSRFTokenAPI = function(signal) {
    return (0, _utils.fetchUtils).getAuthJSON("/api/xsrf", signal).then(function(json) {
        return json._xsrf;
    }).catch(function(err) {
        return Promise.reject(err);
    });
};
var verifyUserAPI = function() {
    return (0, _utils.fetchUtils).getCurrentUser().then(function(json) {
        return json;
    }).catch(function(err) {
        if (err === 401) return Promise.reject(401);
        else return Promise.reject(err);
    });
};
var postUserLoginAPI = function(authModel, xsrfToken, captcha_token) {
    return (0, _utils.fetchUtils).postAuthJSON("".concat(_endpoints.USERS_ENDPOINT, "/authenticate"), xsrfToken, (0, _objectSpreadProps._)((0, _objectSpread._)({}, authModel), {
        email: authModel.email.toLowerCase().trim(),
        captcha_token: captcha_token
    })).then(function(json) {
        return json;
    }).catch(function(err) {
        return Promise.reject(err);
    });
};
var userLogoutAPI = function(xsrfToken) {
    return (0, _utils.fetchUtils).postAuthJSON("".concat(_endpoints.USERS_ENDPOINT, "/logout"), xsrfToken).then(function(json) {
        return json;
    }).catch(function(err) {
        return Promise.reject(err);
    });
};

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@indico-data/utils":"47VRj","Auth/constants/endpoints":"lgang","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lgang":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USERS_ENDPOINT", function() {
    return USERS_ENDPOINT;
});
var USERS_ENDPOINT = "/users";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"96R9n":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainRouterWrapper", function() {
    return MainRouterWrapper;
});
var _assertThisInitialized = require("@swc/helpers/_/_assert_this_initialized");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _createSuper = require("@swc/helpers/_/_create_super");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _browser = require("@sentry/browser");
// App
var _toastsList = require("root/components/messaging/ToastsList/ToastsList");
var _mainRouter = require("./MainRouter");
var Router = /*#__PURE__*/ function(Component) {
    "use strict";
    (0, _inherits._)(Router, Component);
    var _super = (0, _createSuper._)(Router);
    function Router() {
        (0, _classCallCheck._)(this, Router);
        var _this;
        _this = _super.apply(this, arguments);
        (0, _defineProperty._)((0, _assertThisInitialized._)(_this), "state", {
            error: null,
            loginError: false,
            redirect: {
                pathname: "",
                search: ""
            }
        });
        return _this;
    }
    (0, _createClass._)(Router, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                this.props.verifyUser().then(function(user) {
                    if (user) _this.props.updateUserContext({
                        type: "SET_USER",
                        user: user,
                        loading: false
                    });
                }).catch(function(err) {
                    _this.props.updateUserContext({
                        type: "SET_LOADING",
                        loading: false
                    });
                    if (err.status !== 401) _this.setState({
                        loginError: true
                    });
                });
            }
        },
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                this.setState({
                    error: error
                });
                (0, _browser.captureException)(error);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "MainRouter",
                        style: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toastsList.ToastsList), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainRouter.MainRouterWithToast), {
                                error: this.state.error,
                                loginError: this.state.loginError
                            })
                        })
                    })
                });
            }
        }
    ]);
    return Router;
}((0, _react.Component));
var MainRouterWrapper = Router;

},{"@swc/helpers/_/_assert_this_initialized":"6z9ZW","@swc/helpers/_/_class_call_check":"1b19W","@swc/helpers/_/_create_class":"k0x0i","@swc/helpers/_/_define_property":"gSu9o","@swc/helpers/_/_inherits":"j9BK3","@swc/helpers/_/_create_super":"cFmrg","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","@sentry/browser":"8FICV","root/components/messaging/ToastsList/ToastsList":"hGEPF","./MainRouter":"lc9hr","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8FICV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Integrations", function() {
    return INTEGRATIONS;
});
parcelHelpers.export(exports, "Transports", function() {
    return _transports;
});
var _tslib = require("tslib");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _integrations = require("./integrations");
var _transports = require("./transports");
var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var _window = (0, _utils.getGlobalObject)();
if (_window.Sentry && _window.Sentry.Integrations) windowIntegrations = _window.Sentry.Integrations;
var INTEGRATIONS = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, windowIntegrations), (0, _core.Integrations)), _integrations);

},{"tslib":"1r1sc","./exports":"6TqNk","@sentry/core":"cb2Iu","@sentry/utils":"ciI6z","./integrations":"7zv0r","./transports":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6TqNk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", function() {
    return 0, _types.Severity;
});
parcelHelpers.export(exports, "Status", function() {
    return 0, _types.Status;
});
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return 0, _core.addGlobalEventProcessor;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _core.addBreadcrumb;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _core.captureException;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _core.captureEvent;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _core.captureMessage;
});
parcelHelpers.export(exports, "configureScope", function() {
    return 0, _core.configureScope;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return 0, _core.getHubFromCarrier;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return 0, _core.getCurrentHub;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _core.Hub;
});
parcelHelpers.export(exports, "makeMain", function() {
    return 0, _core.makeMain;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _core.Scope;
});
parcelHelpers.export(exports, "startTransaction", function() {
    return 0, _core.startTransaction;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _core.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _core.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _core.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _core.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _core.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _core.setUser;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _core.withScope;
});
parcelHelpers.export(exports, "BrowserClient", function() {
    return 0, _client.BrowserClient;
});
parcelHelpers.export(exports, "injectReportDialog", function() {
    return 0, _helpers.injectReportDialog;
});
parcelHelpers.export(exports, "eventFromException", function() {
    return 0, _eventbuilder.eventFromException;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilder.eventFromMessage;
});
parcelHelpers.export(exports, "defaultIntegrations", function() {
    return 0, _sdk.defaultIntegrations;
});
parcelHelpers.export(exports, "forceLoad", function() {
    return 0, _sdk.forceLoad;
});
parcelHelpers.export(exports, "init", function() {
    return 0, _sdk.init;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _sdk.lastEventId;
});
parcelHelpers.export(exports, "onLoad", function() {
    return 0, _sdk.onLoad;
});
parcelHelpers.export(exports, "showReportDialog", function() {
    return 0, _sdk.showReportDialog;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _sdk.flush;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _sdk.close;
});
parcelHelpers.export(exports, "wrap", function() {
    return 0, _sdk.wrap;
});
parcelHelpers.export(exports, "SDK_NAME", function() {
    return 0, _version.SDK_NAME;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _version.SDK_VERSION;
});
var _types = require("@sentry/types");
var _core = require("@sentry/core");
var _client = require("./client");
var _helpers = require("./helpers");
var _eventbuilder = require("./eventbuilder");
var _sdk = require("./sdk");
var _version = require("./version");

},{"@sentry/types":false,"@sentry/core":"cb2Iu","./client":false,"./helpers":false,"./eventbuilder":false,"./sdk":false,"./version":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"bndjz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", function() {
    return 0, _loglevel.LogLevel;
});
parcelHelpers.export(exports, "Severity", function() {
    return 0, _severity.Severity;
});
parcelHelpers.export(exports, "Status", function() {
    return 0, _status.Status;
});
var _loglevel = require("./loglevel");
var _severity = require("./severity");
var _status = require("./status");

},{"./loglevel":false,"./severity":"dFg7H","./status":false,"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dFg7H":[function(require,module,exports) {
/** JSDoc */ // eslint-disable-next-line import/export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Severity", function() {
    return Severity;
});
var Severity;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function(Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */ function fromString(level) {
        switch(level){
            case "debug":
                return Severity.Debug;
            case "info":
                return Severity.Info;
            case "warn":
            case "warning":
                return Severity.Warning;
            case "error":
                return Severity.Error;
            case "fatal":
                return Severity.Fatal;
            case "critical":
                return Severity.Critical;
            case "log":
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cb2Iu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _minimal.addBreadcrumb;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _minimal.captureException;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _minimal.captureEvent;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _minimal.captureMessage;
});
parcelHelpers.export(exports, "configureScope", function() {
    return 0, _minimal.configureScope;
});
parcelHelpers.export(exports, "startTransaction", function() {
    return 0, _minimal.startTransaction;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _minimal.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _minimal.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _minimal.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _minimal.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _minimal.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _minimal.setUser;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _minimal.withScope;
});
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return 0, _hub.addGlobalEventProcessor;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return 0, _hub.getCurrentHub;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return 0, _hub.getHubFromCarrier;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _hub.Hub;
});
parcelHelpers.export(exports, "makeMain", function() {
    return 0, _hub.makeMain;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _hub.Scope;
});
parcelHelpers.export(exports, "API", function() {
    return 0, _api.API;
});
parcelHelpers.export(exports, "BaseClient", function() {
    return 0, _baseclient.BaseClient;
});
parcelHelpers.export(exports, "BaseBackend", function() {
    return 0, _basebackend.BaseBackend;
});
parcelHelpers.export(exports, "eventToSentryRequest", function() {
    return 0, _request.eventToSentryRequest;
});
parcelHelpers.export(exports, "initAndBind", function() {
    return 0, _sdk.initAndBind;
});
parcelHelpers.export(exports, "NoopTransport", function() {
    return 0, _noop.NoopTransport;
});
parcelHelpers.export(exports, "Integrations", function() {
    return _integrations;
});
var _minimal = require("@sentry/minimal");
var _hub = require("@sentry/hub");
var _api = require("./api");
var _baseclient = require("./baseclient");
var _basebackend = require("./basebackend");
var _request = require("./request");
var _sdk = require("./sdk");
var _noop = require("./transports/noop");
var _integrations = require("./integrations");

},{"@sentry/minimal":"8OlF5","@sentry/hub":"W6xEk","./api":"2BHh9","./baseclient":false,"./basebackend":false,"./request":false,"./sdk":false,"./transports/noop":false,"./integrations":"5Rsvg","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"8OlF5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "captureException", function() {
    return captureException;
});
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */ parcelHelpers.export(exports, "captureMessage", function() {
    return captureMessage;
});
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ parcelHelpers.export(exports, "captureEvent", function() {
    return captureEvent;
});
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ parcelHelpers.export(exports, "configureScope", function() {
    return configureScope;
});
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ parcelHelpers.export(exports, "addBreadcrumb", function() {
    return addBreadcrumb;
});
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "setContext", function() {
    return setContext;
});
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ parcelHelpers.export(exports, "setExtras", function() {
    return setExtras;
});
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ parcelHelpers.export(exports, "setTags", function() {
    return setTags;
});
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ parcelHelpers.export(exports, "setExtra", function() {
    return setExtra;
});
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */ parcelHelpers.export(exports, "setTag", function() {
    return setTag;
});
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ parcelHelpers.export(exports, "setUser", function() {
    return setUser;
});
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ parcelHelpers.export(exports, "withScope", function() {
    return withScope;
});
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "_callOnClient", function() {
    return _callOnClient;
});
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual
 * tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and
 * child spans to other spans. To start a new child span within the transaction
 * or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished,
 * otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at
 * which point the transaction with all its finished child spans will be sent to
 * Sentry.
 *
 * @param context Properties of the new `Transaction`.
 */ parcelHelpers.export(exports, "startTransaction", function() {
    return startTransaction;
});
var _tslib = require("tslib");
var _hub = require("@sentry/hub");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, _hub.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, _tslib.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error("Sentry syntheticException");
    } catch (exception) {
        syntheticException = exception;
    }
    return callOnHub("captureException", exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    } catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arrity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return callOnHub("captureMessage", message, level, (0, _tslib.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function captureEvent(event) {
    return callOnHub("captureEvent", event);
}
function configureScope(callback) {
    callOnHub("configureScope", callback);
}
function addBreadcrumb(breadcrumb) {
    callOnHub("addBreadcrumb", breadcrumb);
}
function setContext(name, context) {
    callOnHub("setContext", name, context);
}
function setExtras(extras) {
    callOnHub("setExtras", extras);
}
function setTags(tags) {
    callOnHub("setTags", tags);
}
function setExtra(key, extra) {
    callOnHub("setExtra", key, extra);
}
function setTag(key, value) {
    callOnHub("setTag", key, value);
}
function setUser(user) {
    callOnHub("setUser", user);
}
function withScope(callback) {
    callOnHub("withScope", callback);
}
function _callOnClient(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    callOnHub.apply(void 0, (0, _tslib.__spread)([
        "_invokeClient",
        method
    ], args));
}
function startTransaction(context) {
    return callOnHub("startTransaction", (0, _tslib.__assign)({}, context));
}

},{"tslib":"1r1sc","@sentry/hub":"W6xEk","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"W6xEk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return 0, _scope.addGlobalEventProcessor;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _scope.Scope;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return 0, _hub.getCurrentHub;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return 0, _hub.getHubFromCarrier;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return 0, _hub.getMainCarrier;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _hub.Hub;
});
parcelHelpers.export(exports, "makeMain", function() {
    return 0, _hub.makeMain;
});
parcelHelpers.export(exports, "setHubOnCarrier", function() {
    return 0, _hub.setHubOnCarrier;
});
var _scope = require("./scope");
var _hub = require("./hub");

},{"./scope":"lYAfZ","./hub":"gu7mA","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lYAfZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", function() {
    return Scope;
});
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return addGlobalEventProcessor;
});
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var Scope = /** @class */ function() {
    function Scope() {
        /** Flag if notifiying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._extra = {};
        /** Contexts */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, _tslib.__spread)(scope._breadcrumbs);
            newScope._tags = (0, _tslib.__assign)({}, scope._tags);
            newScope._extra = (0, _tslib.__assign)({}, scope._extra);
            newScope._contexts = (0, _tslib.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, _tslib.__spread)(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Scope.prototype.setContext = function(key, context) {
        var _a;
        this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        var span = this.getSpan();
        if (span && span.spanRecorder && span.spanRecorder.spans[0]) return span.spanRecorder.spans[0];
        return undefined;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
        } else if ((0, _utils.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = (0, _tslib.__assign)({
            timestamp: (0, _utils.timestampWithMs)()
        }, breadcrumb);
        this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? (0, _tslib.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxBreadcrumbs) : (0, _tslib.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, _tslib.__assign)((0, _tslib.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) event.contexts = (0, _tslib.__assign)({
            trace: this._span.getTraceContext()
        }, event.contexts);
        this._applyFingerprint(event);
        event.breadcrumbs = (0, _tslib.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors((0, _tslib.__spread)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, _utils.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor((0, _tslib.__assign)({}, event), hint);
                if ((0, _utils.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function() {
                _this._scopeListeners.forEach(function(callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Retruns the global event processors.
 */ function getGlobalEventProcessors() {
    var global = (0, _utils.getGlobalObject)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}

},{"tslib":"1r1sc","@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"ciI6z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _async = require("./async");
parcelHelpers.exportAll(_async, exports);
var _error = require("./error");
parcelHelpers.exportAll(_error, exports);
var _is = require("./is");
parcelHelpers.exportAll(_is, exports);
var _logger = require("./logger");
parcelHelpers.exportAll(_logger, exports);
var _memo = require("./memo");
parcelHelpers.exportAll(_memo, exports);
var _misc = require("./misc");
parcelHelpers.exportAll(_misc, exports);
var _object = require("./object");
parcelHelpers.exportAll(_object, exports);
var _path = require("./path");
parcelHelpers.exportAll(_path, exports);
var _promisebuffer = require("./promisebuffer");
parcelHelpers.exportAll(_promisebuffer, exports);
var _string = require("./string");
parcelHelpers.exportAll(_string, exports);
var _supports = require("./supports");
parcelHelpers.exportAll(_supports, exports);
var _syncpromise = require("./syncpromise");
parcelHelpers.exportAll(_syncpromise, exports);
var _instrument = require("./instrument");
parcelHelpers.exportAll(_instrument, exports);
var _dsn = require("./dsn");
parcelHelpers.exportAll(_dsn, exports);

},{"./async":false,"./error":false,"./is":"1gzGQ","./logger":"afDWk","./memo":false,"./misc":"23Et3","./object":"5w6e9","./path":false,"./promisebuffer":false,"./string":"gKfSM","./supports":false,"./syncpromise":"kLgbv","./instrument":"1id9C","./dsn":"2d1nn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aEFhM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryError", function() {
    return SentryError;
});
var _tslib = require("tslib");
var _polyfill = require("./polyfill");
/** An error emitted by Sentry SDKs and related utilities. */ var SentryError = /** @class */ function(_super) {
    (0, _tslib.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, _polyfill.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

},{"tslib":"1r1sc","./polyfill":"e833m","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"e833m":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPrototypeOf", function() {
    return setPrototypeOf;
});
var setPrototypeOf = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for(var prop in proto)// eslint-disable-next-line no-prototype-builtins
    if (!obj.hasOwnProperty(prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1gzGQ":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isError", function() {
    return isError;
});
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isErrorEvent", function() {
    return isErrorEvent;
});
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMError", function() {
    return isDOMError;
});
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isDOMException", function() {
    return isDOMException;
});
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isString", function() {
    return isString;
});
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPrimitive", function() {
    return isPrimitive;
});
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isPlainObject", function() {
    return isPlainObject;
});
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isRegExp", function() {
    return isRegExp;
});
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ parcelHelpers.export(exports, "isThenable", function() {
    return isThenable;
});
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return isSyntheticEvent;
});
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ parcelHelpers.export(exports, "isInstanceOf", function() {
    return isInstanceOf;
});
function isError(wat) {
    switch(Object.prototype.toString.call(wat)){
        case "[object Error]":
            return true;
        case "[object Exception]":
            return true;
        case "[object DOMException]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === "[object ErrorEvent]";
}
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMError]";
}
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMException]";
}
function isString(wat) {
    return Object.prototype.toString.call(wat) === "[object String]";
}
function isPrimitive(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === "[object Object]";
}
function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === "[object RegExp]";
}
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"afDWk":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
var _misc = require("./misc");
// TODO: Implement different loggers for different environments
var global = (0, _misc.getGlobalObject)();
/** Prefix for logging strings */ var PREFIX = "Sentry Logger ";
/** JSDoc */ var Logger = /** @class */ function() {
    /** JSDoc */ function Logger() {
        this._enabled = false;
    }
    /** JSDoc */ Logger.prototype.disable = function() {
        this._enabled = false;
    };
    /** JSDoc */ Logger.prototype.enable = function() {
        this._enabled = true;
    };
    /** JSDoc */ Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, _misc.consoleSandbox)(function() {
            global.console.log(PREFIX + "[Log]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, _misc.consoleSandbox)(function() {
            global.console.warn(PREFIX + "[Warn]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, _misc.consoleSandbox)(function() {
            global.console.error(PREFIX + "[Error]: " + args.join(" "));
        });
    };
    return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

},{"./misc":"23Et3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"23Et3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "dynamicRequire", function() {
    return dynamicRequire;
});
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ parcelHelpers.export(exports, "isNodeEnv", function() {
    return isNodeEnv;
});
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */ parcelHelpers.export(exports, "getGlobalObject", function() {
    return getGlobalObject;
});
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ parcelHelpers.export(exports, "uuid4", function() {
    return uuid4;
});
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ parcelHelpers.export(exports, "getEventDescription", function() {
    return getEventDescription;
});
/** JSDoc */ parcelHelpers.export(exports, "consoleSandbox", function() {
    return consoleSandbox;
});
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return addExceptionTypeValue;
});
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */ parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return addExceptionMechanism;
});
/**
 * A safe form of location.href
 */ parcelHelpers.export(exports, "getLocationHref", function() {
    return getLocationHref;
});
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return htmlTreeAsString;
});
parcelHelpers.export(exports, "crossPlatformPerformance", function() {
    return crossPlatformPerformance;
});
/**
 * Returns a timestamp in seconds with milliseconds precision since the UNIX epoch calculated with the monotonic clock.
 */ parcelHelpers.export(exports, "timestampWithMs", function() {
    return timestampWithMs;
});
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ parcelHelpers.export(exports, "parseSemver", function() {
    return parseSemver;
});
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */ parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return parseRetryAfterHeader;
});
/**
 * Safely extract function name from itself
 */ parcelHelpers.export(exports, "getFunctionName", function() {
    return getFunctionName;
});
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ parcelHelpers.export(exports, "addContextToFrame", function() {
    return addContextToFrame;
});
var _is = require("./is");
var _string = require("./string");
var process = require("3141e98da8602815");
var global = arguments[3];
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function isNodeEnv() {
    return Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
var fallbackGlobalObject = {};
function getGlobalObject() {
    return isNodeEnv() ? global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : fallbackGlobalObject;
}
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function pad(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getEventDescription(event) {
    if (event.message) return event.message;
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) return exception.type + ": " + exception.value;
        return exception.type || exception.value || event.event_id || "<unknown>";
    }
    return event.event_id || "<unknown>";
}
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ];
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function(level) {
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function(level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || "";
    event.exception.values[0].type = event.exception.values[0].type || type || "Error";
}
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) mechanism = {};
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function(key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    } catch (_oO) {
    // no-empty
    }
}
function getLocationHref() {
    try {
        return document.location.href;
    } catch (oO) {
        return "";
    }
}
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    if (elem.id) out.push("#" + elem.id);
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0, _is.isString)(className)) {
        classes = className.split(/\s+/);
        for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
var INITIAL_TIME = Date.now();
var prevNow = 0;
var performanceFallback = {
    now: function now() {
        var now = Date.now() - INITIAL_TIME;
        if (now < prevNow) now = prevNow;
        prevNow = now;
        return now;
    },
    timeOrigin: INITIAL_TIME
};
var crossPlatformPerformance = function() {
    if (isNodeEnv()) try {
        var perfHooks = dynamicRequire(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return performanceFallback;
    }
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) return performanceFallback;
    // Polyfill for performance.timeOrigin.
    //
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    if (performance.timeOrigin === undefined) // As of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always a
    // valid fallback. In the absence of a initial time provided by the browser, fallback to INITIAL_TIME.
    // @ts-ignore ignored because timeOrigin is a readonly property but we want to override
    // eslint-disable-next-line deprecation/deprecation
    performance.timeOrigin = performance.timing && performance.timing.navigationStart || INITIAL_TIME;
    return performance;
}();
function timestampWithMs() {
    return (crossPlatformPerformance.timeOrigin + crossPlatformPerformance.now()) / 1000;
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
var defaultRetryAfter = 60000; // 60 seconds
function parseRetryAfterHeader(now, header) {
    if (!header) return defaultRetryAfter;
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return defaultRetryAfter;
}
var defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
    frame.context_line = (0, _string.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _string.snipLine)(line, 0);
    });
}

},{"3141e98da8602815":"58KR9","./is":"1gzGQ","./string":"gKfSM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gKfSM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ parcelHelpers.export(exports, "truncate", function() {
    return truncate;
});
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ parcelHelpers.export(exports, "snipLine", function() {
    return snipLine;
});
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
parcelHelpers.export(exports, "safeJoin", function() {
    return safeJoin;
});
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */ parcelHelpers.export(exports, "isMatchingPattern", function() {
    return isMatchingPattern;
});
var _is = require("./is");
function truncate(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) return newLine;
    if (colno > ll) // eslint-disable-next-line no-param-reassign
    colno = ll;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) end = ll;
    if (end === ll) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < ll) newLine += " {snip}";
    return newLine;
}
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function isMatchingPattern(value, pattern) {
    if (!(0, _is.isString)(value)) return false;
    if ((0, _is.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}

},{"./is":"1gzGQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"89Ulx":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Memo", function() {
    return Memo;
});
var Memo = /** @class */ function() {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === "function";
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */ Memo.prototype.memoize = function(obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) return true;
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < this._inner.length; i++){
            var value = this._inner[i];
            if (value === obj) return true;
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */ Memo.prototype.unmemoize = function(obj) {
        if (this._hasWeakSet) this._inner.delete(obj);
        else {
            for(var i = 0; i < this._inner.length; i++)if (this._inner[i] === obj) {
                this._inner.splice(i, 1);
                break;
            }
        }
    };
    return Memo;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5w6e9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */ parcelHelpers.export(exports, "fill", function() {
    return fill;
});
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ parcelHelpers.export(exports, "urlEncode", function() {
    return urlEncode;
});
/** JSDoc */ parcelHelpers.export(exports, "normalizeToSize", function() {
    return normalizeToSize;
});
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "walk", function() {
    return walk;
});
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "normalize", function() {
    return normalize;
});
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return extractExceptionKeysForMessage;
});
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */ parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return dropUndefinedKeys;
});
var _tslib = require("tslib");
var _is = require("./is");
var _memo = require("./memo");
var _misc = require("./misc");
var _string = require("./string");
var global = arguments[3];
function fill(source, name, replacement) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        wrapped.prototype = wrapped.prototype || {};
        Object.defineProperties(wrapped, {
            __sentry_original__: {
                enumerable: false,
                value: original
            }
        });
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */ function getWalkSource(value) {
    if ((0, _is.isError)(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack
        };
        for(var i in error)if (Object.prototype.hasOwnProperty.call(error, i)) err[i] = error[i];
        return err;
    }
    if ((0, _is.isEvent)(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = (0, _is.isElement)(event_1.target) ? (0, _misc.htmlTreeAsString)(event_1.target) : Object.prototype.toString.call(event_1.target);
        } catch (_oO) {
            source.target = "<unknown>";
        }
        try {
            source.currentTarget = (0, _is.isElement)(event_1.currentTarget) ? (0, _misc.htmlTreeAsString)(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
        } catch (_oO) {
            source.currentTarget = "<unknown>";
        }
        if (typeof CustomEvent !== "undefined" && (0, _is.isInstanceOf)(value, CustomEvent)) source.detail = event_1.detail;
        for(var i in event_1)if (Object.prototype.hasOwnProperty.call(event_1, i)) source[i] = event_1;
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
function normalizeToSize(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */ function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === "string") return value;
    if (type === "[object Object]") return "[Object]";
    if (type === "[object Array]") return "[Array]";
    var normalized = normalizeValue(value);
    return (0, _is.isPrimitive)(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */ function normalizeValue(value, key) {
    if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
    if (key === "domainEmitter") return "[DomainEmitter]";
    if (typeof global !== "undefined" && value === global) return "[Global]";
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    // React's SyntheticEvent thingy
    if ((0, _is.isSyntheticEvent)(value)) return "[SyntheticEvent]";
    if (typeof value === "number" && value !== value) return "[NaN]";
    if (value === void 0) return "[undefined]";
    if (typeof value === "function") return "[Function: " + (0, _misc.getFunctionName)(value) + "]";
    return value;
}
function walk(key, value, depth, memo) {
    if (depth === void 0) depth = Infinity;
    if (memo === void 0) memo = new (0, _memo.Memo)();
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) return serializeValue(value);
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === "function") return value.toJSON();
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if ((0, _is.isPrimitive)(normalized)) return normalized;
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) return "[Circular ~]";
    // Walk all keys of the source
    for(var innerKey in source){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) continue;
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function(key, value) {
            return walk(key, value, depth);
        }));
    } catch (_oO) {
        return "**non-serializable**";
    }
}
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, _string.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _string.truncate)(serialized, maxLength);
    }
    return "";
}
function dropUndefinedKeys(val) {
    var e_1, _a;
    if ((0, _is.isPlainObject)(val)) {
        var obj = val;
        var rv = {};
        try {
            for(var _b = (0, _tslib.__values)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof obj[key] !== "undefined") rv[key] = dropUndefinedKeys(obj[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map(dropUndefinedKeys);
    return val;
}

},{"tslib":"1r1sc","./is":"1gzGQ","./memo":"89Ulx","./misc":"23Et3","./string":"gKfSM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2x4qL":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return supportsErrorEvent;
});
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMError", function() {
    return supportsDOMError;
});
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsDOMException", function() {
    return supportsDOMException;
});
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsFetch", function() {
    return supportsFetch;
});
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return supportsNativeFetch;
});
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return supportsReportingObserver;
});
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return supportsReferrerPolicy;
});
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ parcelHelpers.export(exports, "supportsHistory", function() {
    return supportsHistory;
});
var _logger = require("./logger");
var _misc = require("./misc");
function supportsErrorEvent() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function supportsDOMException() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function supportsFetch() {
    if (!("fetch" in (0, _misc.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
    if (!supportsFetch()) return false;
    var global = (0, _misc.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _logger.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function supportsReportingObserver() {
    return "ReportingObserver" in (0, _misc.getGlobalObject)();
}
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, _misc.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

},{"./logger":"afDWk","./misc":"23Et3","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kLgbv":[function(require,module,exports) {
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", function() {
    return SyncPromise;
});
var _is = require("./is");
/** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ States["PENDING"] = "PENDING";
    /** Resolved / OK */ States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */ States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== States.PENDING) return;
            if ((0, _is.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */ this._attachHandler = function(handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === States.PENDING) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler.done) return;
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler.onfulfilled(_this._value);
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) handler.onrejected(_this._value);
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.resolve = function(value) {
        return new SyncPromise(function(resolve) {
            resolve(value);
        });
    };
    /** JSDoc */ SyncPromise.reject = function(reason) {
        return new SyncPromise(function(_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */ SyncPromise.all = function(collection) {
        return new SyncPromise(function(resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function(item, index) {
                SyncPromise.resolve(item).then(function(value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) return;
                    resolve(resolvedCollection);
                }).then(null, reject);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function onfulfilled1(result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function onrejected1(reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                }
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.toString = function() {
        return "[object SyncPromise]";
    };
    return SyncPromise;
}();

},{"./is":"1gzGQ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1id9C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ parcelHelpers.export(exports, "addInstrumentationHandler", function() {
    return addInstrumentationHandler;
});
var _tslib = require("tslib");
var _is = require("./is");
var _logger = require("./logger");
var _misc = require("./misc");
var _object = require("./object");
var _supports = require("./supports");
var global = (0, _misc.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var handlers = {};
var instrumented = {};
/** Instruments given API */ function instrument(type) {
    if (instrumented[type]) return;
    instrumented[type] = true;
    switch(type){
        case "console":
            instrumentConsole();
            break;
        case "dom":
            instrumentDOM();
            break;
        case "xhr":
            instrumentXHR();
            break;
        case "fetch":
            instrumentFetch();
            break;
        case "history":
            instrumentHistory();
            break;
        case "error":
            instrumentError();
            break;
        case "unhandledrejection":
            instrumentUnhandledRejection();
            break;
        default:
            (0, _logger.logger).warn("unknown instrumentation type:", type);
    }
}
function addInstrumentationHandler(handler) {
    if (!handler || typeof handler.type !== "string" || typeof handler.callback !== "function") return;
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */ function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) return;
    try {
        for(var _b = (0, _tslib.__values)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, _logger.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, _misc.getFunctionName)(handler) + "\nError: " + e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function instrumentConsole() {
    if (!("console" in global)) return;
    [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ].forEach(function(level) {
        if (!(level in global.console)) return;
        (0, _object.fill)(global.console, level, function(originalConsoleLevel) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleLevel) Function.prototype.apply.call(originalConsoleLevel, global.console, args);
            };
        });
    });
}
/** JSDoc */ function instrumentFetch() {
    if (!(0, _supports.supportsNativeFetch)()) return;
    (0, _object.fill)(global, "fetch", function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            triggerHandlers("fetch", (0, _tslib.__assign)({}, commonHandlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global, args).then(function(response) {
                triggerHandlers("fetch", (0, _tslib.__assign)((0, _tslib.__assign)({}, commonHandlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                triggerHandlers("fetch", (0, _tslib.__assign)((0, _tslib.__assign)({}, commonHandlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ("Request" in global && (0, _is.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in global && (0, _is.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function instrumentXHR() {
    if (!("XMLHttpRequest" in global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, _object.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, _is.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, _is.isString)(url) && xhr.__sentry_xhr__.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function onreadystatechangeHandler() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) xhr.__sentry_xhr__.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, _object.fill)(xhr, "onreadystatechange", function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, _object.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */ function instrumentHistory() {
    if (!(0, _supports.supportsHistory)()) return;
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) return oldOnPopState.apply(this, args);
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, _object.fill)(global.history, "pushState", historyReplacementFunction);
    (0, _object.fill)(global.history, "replaceState", historyReplacementFunction);
}
/** JSDoc */ function instrumentDOM() {
    if (!("document" in global)) return;
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener("click", domEventHandler("click", triggerHandlers.bind(null, "dom")), false);
    global.document.addEventListener("keypress", keypressEventHandler(triggerHandlers.bind(null, "dom")), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */ var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */ (0, _object.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === "click") (0, _object.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            domEventHandler("click", triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                    if (eventName === "keypress") (0, _object.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            keypressEventHandler(triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                } else {
                    if (eventName === "click") domEventHandler("click", triggerHandlers.bind(null, "dom"), true)(this);
                    if (eventName === "keypress") keypressEventHandler(triggerHandlers.bind(null, "dom"))(this);
                }
                return original.call(this, eventName, fn, options);
            };
        });
        (0, _object.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) debounce = false;
    return function(event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) return;
        lastCapturedEvent = event;
        if (debounceTimer) clearTimeout(debounceTimer);
        if (debounce) debounceTimer = setTimeout(function() {
            handler({
                event: event,
                name: name
            });
        });
        else handler({
            event: event,
            name: name
        });
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */ function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(event) {
        var target;
        try {
            target = event.target;
        } catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || tagName !== "INPUT" && tagName !== "TEXTAREA" && !target.isContentEditable) return;
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) domEventHandler("input", handler)(event);
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function() {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
var _oldOnErrorHandler = null;
/** JSDoc */ function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function(msg, url, line, column, error) {
        triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if (_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function(e) {
        triggerHandlers("unhandledrejection", e);
        if (_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

},{"tslib":"1r1sc","./is":"1gzGQ","./logger":"afDWk","./misc":"23Et3","./object":"5w6e9","./supports":"2x4qL","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2d1nn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dsn", function() {
    return Dsn;
});
var _tslib = require("tslib");
var _error = require("./error");
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */ var ERROR_MESSAGE = "Invalid Dsn";
/** The Sentry Dsn, identifying a Sentry instance and project. */ var Dsn = /** @class */ function() {
    /** Creates a new Dsn component */ function Dsn(from) {
        if (typeof from === "string") this._fromString(from);
        else this._fromComponents(from);
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */ Dsn.prototype.toString = function(withPassword) {
        if (withPassword === void 0) withPassword = false;
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return protocol + "://" + user + (withPassword && pass ? ":" + pass : "") + ("@" + host + (port ? ":" + port : "") + "/" + (path ? path + "/" : path) + projectId);
    };
    /** Parses a string into this Dsn. */ Dsn.prototype._fromString = function(str) {
        var match = DSN_REGEX.exec(str);
        if (!match) throw new (0, _error.SentryError)(ERROR_MESSAGE);
        var _a = (0, _tslib.__read)(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? "" : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? "" : _c, lastPath = _a[5];
        var path = "";
        var projectId = lastPath;
        var split = projectId.split("/");
        if (split.length > 1) {
            path = split.slice(0, -1).join("/");
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) projectId = projectMatch[0];
        }
        this._fromComponents({
            host: host,
            pass: pass,
            path: path,
            projectId: projectId,
            port: port,
            protocol: protocol,
            user: user
        });
    };
    /** Maps Dsn components into this instance. */ Dsn.prototype._fromComponents = function(components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || "";
        this.host = components.host;
        this.port = components.port || "";
        this.path = components.path || "";
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */ Dsn.prototype._validate = function() {
        var _this = this;
        [
            "protocol",
            "user",
            "host",
            "projectId"
        ].forEach(function(component) {
            if (!_this[component]) throw new (0, _error.SentryError)(ERROR_MESSAGE + ": " + component + " missing");
        });
        if (!this.projectId.match(/^\d+$/)) throw new (0, _error.SentryError)(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        if (this.protocol !== "http" && this.protocol !== "https") throw new (0, _error.SentryError)(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        if (this.port && isNaN(parseInt(this.port, 10))) throw new (0, _error.SentryError)(ERROR_MESSAGE + ": Invalid port " + this.port);
    };
    return Dsn;
}();

},{"tslib":"1r1sc","./error":"aEFhM","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gu7mA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_VERSION", function() {
    return API_VERSION;
});
parcelHelpers.export(exports, "Hub", function() {
    return Hub;
});
/** Returns the global shim registry. */ parcelHelpers.export(exports, "getMainCarrier", function() {
    return getMainCarrier;
});
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ parcelHelpers.export(exports, "makeMain", function() {
    return makeMain;
});
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ parcelHelpers.export(exports, "getCurrentHub", function() {
    return getCurrentHub;
});
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return getHubFromCarrier;
});
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */ parcelHelpers.export(exports, "setHubOnCarrier", function() {
    return setHubOnCarrier;
});
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _scope = require("./scope");
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */ var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var Hub = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, _scope.Scope)();
        if (_version === void 0) _version = API_VERSION;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [];
        this._stack.push({
            client: client,
            scope: scope
        });
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = (0, _scope.Scope).clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = (0, _utils.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, (0, _tslib.__assign)((0, _tslib.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = (0, _utils.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, (0, _tslib.__assign)((0, _tslib.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = this._lastEventId = (0, _utils.uuid4)();
        this._invokeClient("captureEvent", event, (0, _tslib.__assign)((0, _tslib.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = top.client.getOptions && top.client.getOptions() || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, _utils.timestampWithMs)();
        var mergedBreadcrumb = (0, _tslib.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, _utils.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var top = this.getStackTop();
        if (!top.scope) return;
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) callback(top.scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        } finally{
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, _utils.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context) {
        return this._callExtensionMethod("startTransaction", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = top.client)[method].apply(_a, (0, _tslib.__spread)(args, [
            top.scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, _utils.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function getMainCarrier() {
    var carrier = (0, _utils.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) setHubOnCarrier(registry, new Hub());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, _utils.isNodeEnv)()) return getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */ function getHubFromActiveDomain(registry) {
    try {
        var property = "domain";
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (!sentry || !sentry.extensions || !sentry.extensions[property]) return getHubFromCarrier(registry);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var domain = sentry.extensions[property];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) return getHubFromCarrier(registry);
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, (0, _scope.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return true;
    return false;
}
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}

},{"tslib":"1r1sc","@sentry/utils":"ciI6z","./scope":"lYAfZ","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2BHh9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API", function() {
    return API;
});
var _utils = require("@sentry/utils");
var SENTRY_API_VERSION = "7";
/** Helper class to provide urls to different Sentry endpoints. */ var API = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new (0, _utils.Dsn)(dsn);
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : "";
        var port = dsn.port ? ":" + dsn.port : "";
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : "") + "/api/";
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return this._getIngestEndpoint("store");
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */ API.prototype.getStoreEndpointPath = function() {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : "") + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */ API.prototype.getRequestHeaders = function(clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = [
            "Sentry sentry_version=" + SENTRY_API_VERSION
        ];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
        return {
            "Content-Type": "application/json",
            "X-Sentry-Auth": header.join(", ")
        };
    };
    /** Returns the url to the report dialog endpoint. */ API.prototype.getReportDialogEndpoint = function(dialogOptions) {
        if (dialogOptions === void 0) dialogOptions = {};
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for(var key in dialogOptions)if (key === "user") {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
            if (dialogOptions.user.email) encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
        } else encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
        if (encodedOptions.length) return endpoint + "?" + encodedOptions.join("&");
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */ API.prototype._getEnvelopeEndpoint = function() {
        return this._getIngestEndpoint("envelope");
    };
    /** Returns the ingest API endpoint for target. */ API.prototype._getIngestEndpoint = function(target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */ API.prototype._encodedAuth = function() {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION
        };
        return (0, _utils.urlEncode)(auth);
    };
    return API;
}();

},{"@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"5Rsvg":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", function() {
    return 0, _functiontostring.FunctionToString;
});
parcelHelpers.export(exports, "InboundFilters", function() {
    return 0, _inboundfilters.InboundFilters;
});
var _functiontostring = require("./functiontostring");
var _inboundfilters = require("./inboundfilters");

},{"./functiontostring":"1iWaN","./inboundfilters":"3glnn","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"1iWaN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", function() {
    return FunctionToString;
});
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var FunctionToString = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = this.__sentry_original__ || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = "FunctionToString";
    return FunctionToString;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"3glnn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboundFilters", function() {
    return InboundFilters;
});
var _tslib = require("tslib");
var _hub = require("@sentry/hub");
var _utils = require("@sentry/utils");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var InboundFilters = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function() {
        (0, _hub.addGlobalEventProcessor)(function(event) {
            var hub = (0, _hub.getCurrentHub)();
            if (!hub) return event;
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) return null;
            }
            return event;
        });
    };
    /** JSDoc */ InboundFilters.prototype._shouldDropEvent = function(event, options) {
        if (this._isSentryError(event, options)) {
            (0, _utils.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, _utils.getEventDescription)(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            (0, _utils.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, _utils.getEventDescription)(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            (0, _utils.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, _utils.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            (0, _utils.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, _utils.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */ InboundFilters.prototype._isSentryError = function(event, options) {
        if (!options.ignoreInternal) return false;
        try {
            return event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].type === "SentryError" || false;
        } catch (_oO) {
            return false;
        }
    };
    /** JSDoc */ InboundFilters.prototype._isIgnoredError = function(event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) return false;
        return this._getPossibleEventMessages(event).some(function(message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function(pattern) {
                return (0, _utils.isMatchingPattern)(message, pattern);
            });
        });
    };
    /** JSDoc */ InboundFilters.prototype._isDeniedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) return false;
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function(pattern) {
            return (0, _utils.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._isAllowedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) return true;
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function(pattern) {
            return (0, _utils.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._mergeOptions = function(clientOptions) {
        if (clientOptions === void 0) clientOptions = {};
        return {
            allowUrls: (0, _tslib.__spread)(this._options.whitelistUrls || [], this._options.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
            denyUrls: (0, _tslib.__spread)(this._options.blacklistUrls || [], this._options.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
            ignoreErrors: (0, _tslib.__spread)(this._options.ignoreErrors || [], clientOptions.ignoreErrors || [], DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== "undefined" ? this._options.ignoreInternal : true
        };
    };
    /** JSDoc */ InboundFilters.prototype._getPossibleEventMessages = function(event) {
        if (event.message) return [
            event.message
        ];
        if (event.exception) try {
            var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? "" : _b, _c = _a.value, value = _c === void 0 ? "" : _c;
            return [
                "" + value,
                type + ": " + value
            ];
        } catch (oO) {
            (0, _utils.logger).error("Cannot extract message for event " + (0, _utils.getEventDescription)(event));
            return [];
        }
        return [];
    };
    /** JSDoc */ InboundFilters.prototype._getEventFilterUrl = function(event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return frames_1 && frames_1[frames_1.length - 1].filename || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return frames_2 && frames_2[frames_2.length - 1].filename || null;
            }
            return null;
        } catch (oO) {
            (0, _utils.logger).error("Cannot extract url for event " + (0, _utils.getEventDescription)(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = "InboundFilters";
    return InboundFilters;
}();

},{"tslib":"1r1sc","@sentry/hub":"W6xEk","@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"cQtSz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @hidden
 */ parcelHelpers.export(exports, "shouldIgnoreOnError", function() {
    return shouldIgnoreOnError;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "ignoreNextOnError", function() {
    return ignoreNextOnError;
});
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */ parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
/**
 * Injects the Report Dialog script
 * @hidden
 */ parcelHelpers.export(exports, "injectReportDialog", function() {
    return injectReportDialog;
});
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var ignoreOnError = 0;
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function() {
        ignoreOnError -= 1;
    });
}
function wrap(fn, options, before) {
    if (options === void 0) options = {};
    if (typeof fn !== "function") return fn;
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) return fn;
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) return fn.__sentry_wrapped__;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            if (fn.handleEvent) // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return fn.handleEvent.apply(this, wrappedArguments);
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0, _core.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    var processedEvent = (0, _tslib.__assign)({}, event);
                    if (options.mechanism) {
                        (0, _utils.addExceptionTypeValue)(processedEvent, undefined, undefined);
                        (0, _utils.addExceptionMechanism)(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = (0, _tslib.__assign)((0, _tslib.__assign)({}, processedEvent.extra), {
                        arguments: args
                    });
                    return processedEvent;
                });
                (0, _core.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, "__sentry_wrapped__", {
        enumerable: false,
        value: sentryWrapped
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true
        },
        __sentry_original__: {
            enumerable: false,
            value: fn
        }
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function get() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function injectReportDialog(options) {
    if (options === void 0) options = {};
    if (!options.eventId) {
        (0, _utils.logger).error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        (0, _utils.logger).error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement("script");
    script.async = true;
    script.src = new (0, _core.API)(options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    (document.head || document.body).appendChild(script);
}

},{"tslib":"1r1sc","@sentry/core":"cb2Iu","@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6OUf5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Builds and Event from a Exception
 * @hidden
 */ parcelHelpers.export(exports, "eventFromException", function() {
    return eventFromException;
});
/**
 * Builds and Event from a Message
 * @hidden
 */ parcelHelpers.export(exports, "eventFromMessage", function() {
    return eventFromMessage;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return eventFromUnknownInput;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromString", function() {
    return eventFromString;
});
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
var _parsers = require("./parsers");
var _tracekit = require("./tracekit");
function eventFromException(options, exception, hint) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace
    });
    (0, _utils.addExceptionMechanism)(event, {
        handled: true,
        type: "generic"
    });
    event.level = (0, _types.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.SyncPromise).resolve(event);
}
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) level = (0, _types.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace
    });
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.SyncPromise).resolve(event);
}
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) options = {};
    var event;
    if ((0, _utils.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = (0, _parsers.eventFromStacktrace)((0, _tracekit.computeStackTrace)(exception));
        return event;
    }
    if ((0, _utils.isDOMError)(exception) || (0, _utils.isDOMException)(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || ((0, _utils.isDOMError)(domException) ? "DOMError" : "DOMException");
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        (0, _utils.addExceptionTypeValue)(event, message);
        return event;
    }
    if ((0, _utils.isError)(exception)) {
        // we have a real Error object, do nothing
        event = (0, _parsers.eventFromStacktrace)((0, _tracekit.computeStackTrace)(exception));
        return event;
    }
    if ((0, _utils.isPlainObject)(exception) || (0, _utils.isEvent)(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = (0, _parsers.eventFromPlainObject)(objectException, syntheticException, options.rejection);
        (0, _utils.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    (0, _utils.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, _utils.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function eventFromString(input, syntheticException, options) {
    if (options === void 0) options = {};
    var event = {
        message: input
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = (0, _tracekit.computeStackTrace)(syntheticException);
        var frames_1 = (0, _parsers.prepareFramesForEvent)(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}

},{"@sentry/types":"bndjz","@sentry/utils":"ciI6z","./parsers":"7rDOQ","./tracekit":"iHqpK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7rDOQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ parcelHelpers.export(exports, "exceptionFromStacktrace", function() {
    return exceptionFromStacktrace;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromPlainObject", function() {
    return eventFromPlainObject;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "eventFromStacktrace", function() {
    return eventFromStacktrace;
});
/**
 * @hidden
 */ parcelHelpers.export(exports, "prepareFramesForEvent", function() {
    return prepareFramesForEvent;
});
var _utils = require("@sentry/utils");
var _tracekit = require("./tracekit");
var STACKTRACE_LIMIT = 50;
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message
    };
    if (frames && frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, _utils.isEvent)(exception) ? exception.constructor.name : rejection ? "UnhandledRejection" : "Error",
                    value: "Non-Error " + (rejection ? "promise rejection" : "exception") + " captured with keys: " + (0, _utils.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, _utils.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var stacktrace = (0, _tracekit.computeStackTrace)(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [
                exception
            ]
        }
    };
}
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || "";
    var lastFrameFunction = localStack[localStack.length - 1].func || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, STACKTRACE_LIMIT).map(function(frame) {
        return {
            colno: frame.column === null ? undefined : frame.column,
            filename: frame.url || localStack[0].url,
            function: frame.func || "?",
            in_app: true,
            lineno: frame.line === null ? undefined : frame.line
        };
    }).reverse();
}

},{"@sentry/utils":"ciI6z","./tracekit":"iHqpK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iHqpK":[function(require,module,exports) {
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
parcelHelpers.export(exports, "computeStackTrace", function() {
    return computeStackTrace;
});
var _tslib = require("tslib");
// global reference to slice
var UNKNOWN_FUNCTION = "?";
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function computeStackTrace(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === "number") popSize = ex.framesToPop;
        else if (reactMinifiedRegexp.test(ex.message)) popSize = 1;
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) return popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) return popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) return null;
    var stack = [];
    var lines = ex.stack.split("\n");
    var isEval;
    var submatch;
    var parts;
    var element;
    for(var i = 0; i < lines.length; ++i){
        if (parts = chrome.exec(lines[i])) {
            var isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
            isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf("address at ") === 0 ? parts[2].substr(11) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [
                    parts[2]
                ] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null
            };
        } else if (parts = winjs.exec(lines[i])) element = {
            url: parts[2],
            func: parts[1] || UNKNOWN_FUNCTION,
            args: [],
            line: +parts[3],
            column: parts[4] ? +parts[4] : null
        };
        else if (parts = gecko.exec(lines[i])) {
            isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ""; // no column when eval
            } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) // FireFox uses this awesome columnNumber property for its top frame
            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
            // so adding 1
            // NOTE: this hack doesn't work if top-most frame is eval
            stack[0].column = ex.columnNumber + 1;
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(",") : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null
            };
        } else continue;
        if (!element.func && element.line) element.func = UNKNOWN_FUNCTION;
        stack.push(element);
    }
    if (!stack.length) return null;
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) return null;
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split("\n");
    var stack = [];
    var parts;
    for(var line = 0; line < lines.length; line += 2){
        var element = null;
        if (parts = opera10Regex.exec(lines[line])) element = {
            url: parts[2],
            func: parts[3],
            args: [],
            line: +parts[1],
            column: null
        };
        else if (parts = opera11Regex.exec(lines[line])) element = {
            url: parts[6],
            func: parts[3] || parts[4],
            args: parts[5] ? parts[5].split(",") : [],
            line: +parts[1],
            column: +parts[2]
        };
        if (element) {
            if (!element.func && element.line) element.func = UNKNOWN_FUNCTION;
            stack.push(element);
        }
    }
    if (!stack.length) return null;
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** Remove N number of frames from the stack */ function popFrames(stacktrace, popSize) {
    try {
        return (0, _tslib.__assign)((0, _tslib.__assign)({}, stacktrace), {
            stack: stacktrace.stack.slice(popSize)
        });
    } catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}

},{"tslib":"1r1sc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7zv0r":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", function() {
    return 0, _globalhandlers.GlobalHandlers;
});
parcelHelpers.export(exports, "TryCatch", function() {
    return 0, _trycatch.TryCatch;
});
parcelHelpers.export(exports, "Breadcrumbs", function() {
    return 0, _breadcrumbs.Breadcrumbs;
});
parcelHelpers.export(exports, "LinkedErrors", function() {
    return 0, _linkederrors.LinkedErrors;
});
parcelHelpers.export(exports, "UserAgent", function() {
    return 0, _useragent.UserAgent;
});
var _globalhandlers = require("./globalhandlers");
var _trycatch = require("./trycatch");
var _breadcrumbs = require("./breadcrumbs");
var _linkederrors = require("./linkederrors");
var _useragent = require("./useragent");

},{"./globalhandlers":"9A7Zu","./trycatch":"gDbAQ","./breadcrumbs":"iG1UT","./linkederrors":"uSOT7","./useragent":"6aHS6","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9A7Zu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", function() {
    return GlobalHandlers;
});
var _tslib = require("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var _core = require("@sentry/core");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
var _eventbuilder = require("../eventbuilder");
var _helpers = require("../helpers");
/** Global handlers */ var GlobalHandlers = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /** JSDoc */ this._onErrorHandlerInstalled = false;
        /** JSDoc */ this._onUnhandledRejectionHandlerInstalled = false;
        this._options = (0, _tslib.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            (0, _utils.logger).log("Global Handler attached: onerror");
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            (0, _utils.logger).log("Global Handler attached: onunhandledrejection");
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnErrorHandler = function() {
        var _this = this;
        if (this._onErrorHandlerInstalled) return;
        (0, _utils.addInstrumentationHandler)({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function callback(data) {
                var error = data.error;
                var currentHub = (0, _core.getCurrentHub)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, _helpers.shouldIgnoreOnError)() || isFailedOwnDelivery) return;
                var client = currentHub.getClient();
                var event = (0, _utils.isPrimitive)(error) ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column) : _this._enhanceEventWithInitialFrame((0, _eventbuilder.eventFromUnknownInput)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: false
                }), data.url, data.line, data.column);
                (0, _utils.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onerror"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
            },
            type: "error"
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function() {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) return;
        (0, _utils.addInstrumentationHandler)({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function callback(e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ("reason" in e) error = e.reason;
                    else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
                } catch (_oO) {
                // no-empty
                }
                var currentHub = (0, _core.getCurrentHub)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, _helpers.shouldIgnoreOnError)() || isFailedOwnDelivery) return true;
                var client = currentHub.getClient();
                var event = (0, _utils.isPrimitive)(error) ? _this._eventFromIncompleteRejection(error) : (0, _eventbuilder.eventFromUnknownInput)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: true
                });
                event.level = (0, _types.Severity).Error;
                (0, _utils.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onunhandledrejection"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
                return;
            },
            type: "unhandledrejection"
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function(msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = (0, _utils.isErrorEvent)(msg) ? msg.message : msg;
        var name;
        if ((0, _utils.isString)(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || "Error",
                        value: message
                    }
                ]
            }
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteRejection = function(error) {
        return {
            exception: {
                values: [
                    {
                        type: "UnhandledRejection",
                        value: "Non-Error promise rejection captured with value: " + error
                    }
                ]
            }
        };
    };
    /** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function(event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = (0, _utils.isString)(url) && url.length > 0 ? url : (0, _utils.getLocationHref)();
        if (event.exception.values[0].stacktrace.frames.length === 0) event.exception.values[0].stacktrace.frames.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
        return event;
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = "GlobalHandlers";
    return GlobalHandlers;
}();

},{"tslib":"1r1sc","@sentry/core":"cb2Iu","@sentry/types":"bndjz","@sentry/utils":"ciI6z","../eventbuilder":"6OUf5","../helpers":"cQtSz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gDbAQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TryCatch", function() {
    return TryCatch;
});
var _tslib = require("tslib");
var _utils = require("@sentry/utils");
var _helpers = require("../helpers");
var DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var TryCatch = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, _tslib.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, _utils.getGlobalObject)();
        if (this._options.setTimeout) (0, _utils.fill)(global, "setTimeout", this._wrapTimeFunction.bind(this));
        if (this._options.setInterval) (0, _utils.fill)(global, "setInterval", this._wrapTimeFunction.bind(this));
        if (this._options.requestAnimationFrame) (0, _utils.fill)(global, "requestAnimationFrame", this._wrapRAF.bind(this));
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in global) (0, _utils.fill)(XMLHttpRequest.prototype, "send", this._wrapXHR.bind(this));
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */ TryCatch.prototype._wrapTimeFunction = function(original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var originalCallback = args[0];
            args[0] = (0, _helpers.wrap)(originalCallback, {
                mechanism: {
                    data: {
                        function: (0, _utils.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function(original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function(callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, (0, _helpers.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, _utils.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            }));
        };
    };
    /** JSDoc */ TryCatch.prototype._wrapEventTarget = function(target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = (0, _utils.getGlobalObject)();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, _utils.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === "function") fn.handleEvent = (0, _helpers.wrap)(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: (0, _utils.getFunctionName)(fn),
                                target: target
                            },
                            handled: true,
                            type: "instrument"
                        }
                    });
                } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, _helpers.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, _utils.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }), options);
            };
        });
        (0, _utils.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */ try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    };
    /** JSDoc */ TryCatch.prototype._wrapXHR = function(originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = [
                "onload",
                "onerror",
                "onprogress",
                "onreadystatechange"
            ];
            xmlHttpRequestProps.forEach(function(prop) {
                if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, _utils.fill)(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0, _utils.getFunctionName)(original)
                            },
                            handled: true,
                            type: "instrument"
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    if (original.__sentry_original__) wrapOptions.mechanism.data.handler = (0, _utils.getFunctionName)(original.__sentry_original__);
                    // Otherwise wrap directly
                    return (0, _helpers.wrap)(original, wrapOptions);
                });
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */ TryCatch.id = "TryCatch";
    return TryCatch;
}();

},{"tslib":"1r1sc","@sentry/utils":"ciI6z","../helpers":"cQtSz","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iG1UT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", function() {
    return Breadcrumbs;
});
var _tslib = require("tslib");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable max-lines */ var _core = require("@sentry/core");
var _types = require("@sentry/types");
var _utils = require("@sentry/utils");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var Breadcrumbs = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, _tslib.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0, _utils.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        var _this = this;
        if (this._options.console) (0, _utils.addInstrumentationHandler)({
            callback: function callback() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._consoleBreadcrumb.apply(_this, (0, _tslib.__spread)(args));
            },
            type: "console"
        });
        if (this._options.dom) (0, _utils.addInstrumentationHandler)({
            callback: function callback() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._domBreadcrumb.apply(_this, (0, _tslib.__spread)(args));
            },
            type: "dom"
        });
        if (this._options.xhr) (0, _utils.addInstrumentationHandler)({
            callback: function callback() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._xhrBreadcrumb.apply(_this, (0, _tslib.__spread)(args));
            },
            type: "xhr"
        });
        if (this._options.fetch) (0, _utils.addInstrumentationHandler)({
            callback: function callback() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._fetchBreadcrumb.apply(_this, (0, _tslib.__spread)(args));
            },
            type: "fetch"
        });
        if (this._options.history) (0, _utils.addInstrumentationHandler)({
            callback: function callback() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._historyBreadcrumb.apply(_this, (0, _tslib.__spread)(args));
            },
            type: "history"
        });
    };
    /**
     * Creates breadcrumbs from console API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function(handlerData) {
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, _types.Severity).fromString(handlerData.level),
            message: (0, _utils.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + ((0, _utils.safeJoin)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, _core.getCurrentHub)().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function(handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, _utils.htmlTreeAsString)(handlerData.event.target) : (0, _utils.htmlTreeAsString)(handlerData.event);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function(handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) return;
            (0, _core.getCurrentHub)().addBreadcrumb({
                category: "xhr",
                data: handlerData.xhr.__sentry_xhr__,
                type: "http"
            }, {
                xhr: handlerData.xhr
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function(handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) (0, _core.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: handlerData.fetchData,
            level: (0, _types.Severity).Error,
            type: "http"
        }, {
            data: handlerData.error,
            input: handlerData.args
        });
        else (0, _core.getCurrentHub)().addBreadcrumb({
            category: "fetch",
            data: (0, _tslib.__assign)((0, _tslib.__assign)({}, handlerData.fetchData), {
                status_code: handlerData.response.status
            }),
            type: "http"
        }, {
            input: handlerData.args,
            response: handlerData.response
        });
    };
    /**
     * Creates breadcrumbs from history API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function(handlerData) {
        var global = (0, _utils.getGlobalObject)();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, _utils.parseUrl)(global.location.href);
        var parsedFrom = (0, _utils.parseUrl)(from);
        var parsedTo = (0, _utils.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, _core.getCurrentHub)().addBreadcrumb({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = "Breadcrumbs";
    return Breadcrumbs;
}();

},{"tslib":"1r1sc","@sentry/core":"cb2Iu","@sentry/types":"bndjz","@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"uSOT7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", function() {
    return LinkedErrors;
});
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _parsers = require("../parsers");
var _tracekit = require("../tracekit");
var DEFAULT_KEY = "cause";
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var LinkedErrors = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, _core.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, _core.getCurrentHub)().getIntegration(LinkedErrors);
            if (self) return self._handler(event, hint);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._handler = function(event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(0, _utils.isInstanceOf)(hint.originalException, Error)) return event;
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = (0, _tslib.__spread)(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._walkErrorTree = function(error, key, stack) {
        if (stack === void 0) stack = [];
        if (!(0, _utils.isInstanceOf)(error[key], Error) || stack.length + 1 >= this._limit) return stack;
        var stacktrace = (0, _tracekit.computeStackTrace)(error[key]);
        var exception = (0, _parsers.exceptionFromStacktrace)(stacktrace);
        return this._walkErrorTree(error[key], key, (0, _tslib.__spread)([
            exception
        ], stack));
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = "LinkedErrors";
    return LinkedErrors;
}();

},{"tslib":"1r1sc","@sentry/core":"cb2Iu","@sentry/utils":"ciI6z","../parsers":"7rDOQ","../tracekit":"iHqpK","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6aHS6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserAgent", function() {
    return UserAgent;
});
var _tslib = require("tslib");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var global = (0, _utils.getGlobalObject)();
/** UserAgent */ var UserAgent = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, _core.addGlobalEventProcessor)(function(event) {
            if ((0, _core.getCurrentHub)().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) return event;
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers["User-Agent"] = global.navigator.userAgent;
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = "UserAgent";
    return UserAgent;
}();

},{"tslib":"1r1sc","@sentry/core":"cb2Iu","@sentry/utils":"ciI6z","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hGEPF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToastsContext", function() {
    return ToastsContext;
});
parcelHelpers.export(exports, "ToastsList", function() {
    return ToastsList;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _permafrost = require("@indico-data/permafrost");
var _app = require("root/constants/app");
var _toastsListStyles = require("./ToastsList.styles");
var ToastsContext = /*#__PURE__*/ (0, _react.createContext)({
    toasts: [],
    addToast: function() {}
});
function ToastsList(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)([]), 2), toasts = _useState[0], setToasts = _useState[1];
    var addToast = function(message, type) {
        if (toasts.length === 5) return;
        setToasts(function(prevToasts) {
            return (0, _toConsumableArray._)(prevToasts).concat([
                {
                    display: true,
                    message: message,
                    style: type
                }
            ]);
        });
    };
    // removes toast after timeout
    (0, _react.useEffect)(function() {
        if (toasts.length) setTimeout(function() {
            return setToasts(function(prevToasts) {
                return prevToasts.slice(1);
            });
        }, (0, _app.TOAST_TIMEOUT));
    }, [
        toasts
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToastsContext.Provider, {
        value: {
            toasts: toasts,
            addToast: addToast
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toastsListStyles.StyledToastsList), {
                    children: toasts.map(function(toast, index) {
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Toast), {
                            toast: toast
                        }, "toast".concat(index));
                    })
                }),
                props.children
            ]
        })
    });
}

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/permafrost":"j9IVt","root/constants/app":"644BQ","./ToastsList.styles":"aydrF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"aydrF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledToastsList", function() {
    return StyledToastsList;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  & > :nth-of-type(0) {\n    margin-top: -55px;\n  }\n\n  & > :nth-of-type(1) {\n    margin-top: 0px;\n  }\n\n  & > :nth-of-type(2) {\n    margin-top: 55px;\n  }\n\n  & > :nth-of-type(3) {\n    margin-top: 110px;\n  }\n\n  & > :nth-of-type(4) {\n    margin-top: 165px;\n  }\n\n  & > :nth-of-type(5) {\n    margin-top: 220px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledToastsList = (0, _styledComponentsDefault.default).div(_templateObject());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lc9hr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MainRouterWithToast", function() {
    return MainRouterWithToast;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _isNull = require("lodash/isNull");
var _isNullDefault = parcelHelpers.interopDefault(_isNull);
var _permafrost = require("@indico-data/permafrost");
// App
var _pageContainer = require("root/components/PageContainer");
var _router = require("root/constants/router");
var _appStore = require("./store/appStore");
var _withToast = require("root/components/messaging/ToastsList/withToast");
var _withToastDefault = parcelHelpers.interopDefault(_withToast);
// Routing
var _privateRoute = require("root/components/routing/PrivateRoute/PrivateRoute");
var _privateRouteDefault = parcelHelpers.interopDefault(_privateRoute);
var _appRoute = require("root/components/routing/AppRoute/AppRoute");
var _appRouteDefault = parcelHelpers.interopDefault(_appRoute);
// Retry Route Import When Initial Attempt Fails
var retry = function(fn) {
    var retriesLeft = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, interval = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    return new Promise(function(resolve, reject) {
        fn().then(resolve).catch(function(error) {
            setTimeout(function() {
                if (retriesLeft === 1) {
                    reject(error);
                    return;
                }
                retry(fn, retriesLeft - 1, interval).then(resolve, reject);
            }, interval);
        });
    });
};
// // Authentication Routes
var LoginView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("e48eae45d26cb57c");
    });
});
var FourOhFour = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("3e39e9031ae41a59");
    });
});
var NoAccess = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("128a79b2897756cd");
    });
});
var ProfileView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("374a121f96ec44ba");
    });
});
var UpdatePasswordView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("ab7a6e482bbd258b");
    });
});
var ConfirmAccountView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("b543a4df78d94e8c");
    });
});
var ForgotView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("9cde57c2c821c26b");
    });
});
var RegisterView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("1f51be14662a1b46");
    });
});
var LogoutView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("67bb3844dd898b3e");
    });
});
var AdminView = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("acb8231123775d0c");
    });
});
// Datasets Routes
var Datasets = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("b4066412746e0571");
    });
});
var DatasetDetails = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("323b7e6358f50666");
    });
});
var NewDataset = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("6925ee41efe07eab");
    });
});
var ExamplesList = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("5aa876bd0c53fb33");
    });
});
// Crowdlabel Routes
var Questionnaires = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("28e77e21e73a9c9a");
    });
});
var QuestionnaireDetails = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("7178e8dbbd996165");
    });
});
var LabelingInterface = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("2123814df8c0d049");
    });
});
var SingleExampleLabeling = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("cbba5349a13cd4f3");
    });
});
var SummarizationStudio = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("30feb803d74d9944");
    });
});
var ExtractionStudio = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("ccfcd66a3a66d02a");
    });
});
var ClassificationStudio = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("ead9e95529104d53");
    });
});
// Moonbow Routes
var DatasetsAndModels = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("eff986ad9c4094f9");
    });
});
var ModelDetails = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("1ed33a8a463f247e");
    });
});
// Sunbow Routes
var SunbowList = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("f798267c4b3d003c");
    });
});
var ReviewQueue = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("cd51cd2bb0426493");
    });
});
var ExceptionsQueue = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("584fa880dab3c93c");
    });
});
var SingleReviewQueue = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("7ad56627cb3ed06");
    });
});
var SingleExceptionsQueue = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("42fc057cb05f446e");
    });
});
var SingleQueueSuccess = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("2b6e6e4d94cffce1");
    });
});
// Cloudburst Routes
var WorkflowsList = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("d9016e69204bda88");
    });
});
var WorkflowDetails = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("db8f6c08cae714d7");
    });
});
var WorkflowNew = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("4337e302fa931911");
    });
});
var WorkflowSubmissionsList = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("bd61e7bf00a31c35");
    });
});
// Zephyr Routes
var GalleryPage = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require("fac0169b528edf8c");
    });
});
var GalleryNew = /*#__PURE__*/ (0, _react.lazy)(function() {
    return retry(function() {
        return require(// TODO: probably want to move this file into pages dir like the above...
        "47a51fdfee4fbb7e");
    });
});
var routeMap = [
    {
        path: _router.AUTH_ACCOUNT,
        component: ProfileView,
        type: "PRIVATE"
    },
    {
        path: _router.AUTH_CHANGE_PASSWORD,
        component: UpdatePasswordView,
        type: "REGULAR"
    },
    {
        path: _router.AUTH_CONFIRM_ACCOUNT,
        component: ConfirmAccountView,
        type: "REGULAR"
    },
    {
        path: _router.AUTH_FORGOT,
        component: ForgotView,
        type: "REGULAR"
    },
    {
        path: _router.AUTH_REGISTER,
        component: RegisterView,
        type: "REGULAR"
    },
    {
        path: _router.AUTH_LOGOUT,
        component: LogoutView,
        type: "REGULAR"
    },
    {
        path: _router.BASE_ADMIN,
        component: AdminView,
        type: "PRIVATE"
    },
    {
        path: _router.ADMIN_REPORTS,
        component: AdminView,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_DATASETS,
        component: Datasets,
        type: "PRIVATE"
    },
    {
        path: _router.DATASET_NEW,
        component: NewDataset,
        type: "PRIVATE"
    },
    {
        path: _router.DATASETS_DETAILS,
        component: DatasetDetails,
        type: "PRIVATE"
    },
    {
        path: _router.DATASETS_EXAMPLES_LIST,
        component: ExamplesList,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_CROWDLABEL,
        component: Questionnaires,
        type: "PRIVATE"
    },
    {
        path: _router.CROWDLABEL_TASKS_DETAILS,
        component: QuestionnaireDetails,
        type: "PRIVATE"
    },
    {
        path: _router.CROWDLABEL_LABELING,
        component: LabelingInterface,
        type: "PRIVATE"
    },
    {
        path: _router.CROWDLABEL_LABELING_SINGLE,
        component: SingleExampleLabeling,
        type: "PRIVATE"
    },
    {
        path: _router.CROWDLABEL_SUMMARIZATION_STUDIO,
        component: SummarizationStudio,
        type: "PRIVATE",
        featureFlag: "summarizationStudio"
    },
    {
        path: _router.CROWDLABEL_EXTRACTION_STUDIO,
        component: ExtractionStudio,
        type: "PRIVATE"
    },
    {
        path: _router.CROWDLABEL_CLASSIFICATION_STUDIO,
        component: ClassificationStudio,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_MOONBOW,
        component: DatasetsAndModels,
        type: "PRIVATE"
    },
    {
        path: _router.MOONBOW_DETAILS,
        component: ModelDetails,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_SUNBOW,
        component: SunbowList,
        type: "PRIVATE"
    },
    {
        path: _router.REVIEW_QUEUE,
        component: ReviewQueue,
        type: "PRIVATE"
    },
    {
        path: _router.EXCEPTIONS_QUEUE,
        component: ExceptionsQueue,
        type: "PRIVATE"
    },
    {
        path: _router.SINGLE_REVIEW_QUEUE,
        component: SingleReviewQueue,
        type: "PRIVATE"
    },
    {
        path: _router.SINGLE_EXCEPTIONS_QUEUE,
        component: SingleExceptionsQueue,
        type: "PRIVATE"
    },
    {
        path: _router.SINGLE_SUNBOW_QUEUE_SUCCESS,
        component: SingleQueueSuccess,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_CLOUDBURST,
        component: WorkflowsList,
        type: "PRIVATE"
    },
    {
        path: _router.WORKFLOW_DETAILS,
        component: WorkflowDetails,
        type: "PRIVATE"
    },
    {
        path: _router.WORKFLOW_SUBMISSIONS_LIST,
        component: WorkflowSubmissionsList,
        type: "PRIVATE"
    },
    {
        path: _router.GALLERY_DETAILS,
        component: GalleryPage,
        type: "PRIVATE"
    },
    {
        path: _router.GALLERY_ADD_NEW,
        component: GalleryNew,
        type: "PRIVATE"
    },
    {
        path: _router.WORKFLOW_ADD_NEW,
        component: WorkflowNew,
        type: "PRIVATE"
    },
    {
        path: _router.BASE_NO_ACCESS,
        component: NoAccess,
        type: "REGULAR"
    },
    {
        path: "*",
        component: FourOhFour,
        type: "REGULAR"
    }
];
var appStoreSelector = function(state) {
    return {
        currentLocation: state.currentLocation,
        setLocation: state.setLocation,
        routeError: state.routeError,
        setRouteError: state.setRouteError
    };
};
var MainRouter = function(props) {
    var error = props.error, loginError = props.loginError, addToast = props.addToast;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({
        pathname: "",
        search: ""
    }), 2), redirect = _useState[0], setRedirect = _useState[1];
    var location = (0, _reactRouterDom.useLocation)();
    var _useAppStore = (0, _appStore.useAppStore)(appStoreSelector), currentLocation = _useAppStore.currentLocation, setLocation = _useAppStore.setLocation, routeError = _useAppStore.routeError, setRouteError = _useAppStore.setRouteError;
    // Update zustand store with current and previous locations.
    // If routeError then display toast and clear the routeError state.
    (0, _react.useEffect)(function() {
        if ((location === null || location === void 0 ? void 0 : location.pathname) !== (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.pathname)) setLocation(currentLocation, location); // sets previous to current and current to new
        if (routeError) {
            addToast(routeError, "error");
            setRouteError("");
        }
    }, [
        location
    ]);
    var resetRedirect = function(location) {
        if (location) setRedirect({
            pathname: location.pathname,
            search: location.search
        });
        else setRedirect({
            pathname: "",
            search: ""
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "main-content",
        style: {
            height: "100%"
        },
        children: !(0, _isNullDefault.default)(error) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.AppCrash), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
            fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageContainer.PageContainer), {}),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appRouteDefault.default), {
                        exact: true,
                        path: "/",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginView, {
                            redirect: redirect
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appRouteDefault.default), {
                        exact: true,
                        path: _router.BASE_AUTH,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginView, {
                            redirect: redirect
                        })
                    }),
                    routeMap.filter(function(route) {
                        return !(route.featureFlag && !window.indico.featuresConfig[route.featureFlag]);
                    }).map(function(route, i) {
                        if (route.type === "PRIVATE") return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateRouteDefault.default), {
                            exact: true,
                            path: route.path,
                            component: route.component,
                            loginError: loginError,
                            redirect: redirect,
                            resetRedirect: resetRedirect
                        }, i);
                        else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appRouteDefault.default), {
                            exact: true,
                            path: route.path,
                            component: route.component
                        }, i);
                    })
                ]
            })
        })
    });
};
var MainRouterWithToast = (0, _withToastDefault.default)(MainRouter);

},{"@swc/helpers/_/_sliced_to_array":"gML59","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","lodash/isNull":"fNCEJ","@indico-data/permafrost":"j9IVt","root/components/PageContainer":"1105M","root/constants/router":"kIAPq","./store/appStore":"iLlB2","root/components/messaging/ToastsList/withToast":"a6xMC","root/components/routing/PrivateRoute/PrivateRoute":"j6AFZ","root/components/routing/AppRoute/AppRoute":"kLuzQ","e48eae45d26cb57c":"gBmt8","3e39e9031ae41a59":"dBydK","128a79b2897756cd":"j1vQe","374a121f96ec44ba":"fQALY","ab7a6e482bbd258b":"fZYtY","b543a4df78d94e8c":"3Q43k","9cde57c2c821c26b":"jjsOU","1f51be14662a1b46":"eLzAO","67bb3844dd898b3e":"9idVM","acb8231123775d0c":"eBNJK","b4066412746e0571":"jFpF1","323b7e6358f50666":"aMH8r","6925ee41efe07eab":"f4uAX","5aa876bd0c53fb33":"lh7MN","28e77e21e73a9c9a":"g7rOv","7178e8dbbd996165":"ewoNv","2123814df8c0d049":"1hxnx","cbba5349a13cd4f3":"3suU0","30feb803d74d9944":"lTNDg","ccfcd66a3a66d02a":"hoK5v","ead9e95529104d53":"9crnz","eff986ad9c4094f9":"2p4O0","1ed33a8a463f247e":"r6scZ","f798267c4b3d003c":"7G7F0","cd51cd2bb0426493":"9bTTB","584fa880dab3c93c":"e5OjE","7ad56627cb3ed06":"l0fIy","42fc057cb05f446e":"5JL78","2b6e6e4d94cffce1":"aXBZ8","d9016e69204bda88":"bFiFu","db8f6c08cae714d7":"ljRvW","4337e302fa931911":"ZXImQ","bd61e7bf00a31c35":"8EZt5","fac0169b528edf8c":"b4rDH","47a51fdfee4fbb7e":"bunXd","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"fNCEJ":[function(require,module,exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function isNull(value) {
    return value === null;
}
module.exports = isNull;

},{}],"1105M":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageContainer", function() {
    return 0, _pageContainer.PageContainer;
});
var _pageContainer = require("./PageContainer");

},{"./PageContainer":"MSdD7","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"MSdD7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageContainer", function() {
    return PageContainer;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactApollo = require("react-apollo");
var _graphqlTag = require("graphql-tag");
var _graphqlTagDefault = parcelHelpers.interopDefault(_graphqlTag);
var _appChrome = require("root/components/AppChrome");
var _authentication = require("root/hooks/authentication");
var _pageContainerStyles = require("./PageContainer.styles");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  query getIPAVersion {\n    ipaVersion\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var PageContainer = function(param) {
    var module = param.module, children = param.children, _param_variant = param.variant, variant = _param_variant === void 0 ? "default" : _param_variant;
    var _version_split_, _version_split;
    var _useLazyQuery = (0, _slicedToArray._)((0, _reactApollo.useLazyQuery)(GET_IPA_VERSION), 2), loadIPAVersion = _useLazyQuery[0], data = _useLazyQuery[1].data;
    var currentUser = (0, _authentication.useCurrentUser)();
    (0, _react.useEffect)(function() {
        if (currentUser) loadIPAVersion();
    }, [
        currentUser
    ]);
    var version = data === null || data === void 0 ? void 0 : data.ipaVersion;
    // Convert IPA-4.9.0.rc1 => 4.9.0 --- needs to also work for... IPA-4.10.47.rc23 => 4.10.47
    var abbreviatedVersion = version === null || version === void 0 ? void 0 : (_version_split = version.split("IPA-")) === null || _version_split === void 0 ? void 0 : (_version_split_ = _version_split[1]) === null || _version_split_ === void 0 ? void 0 : _version_split_.split(".").filter(function(num, i, a) {
        return i !== a.length - 1;
    }).join(".");
    var Container = variant === "detail" ? (0, _pageContainerStyles.StyledDetailPageContainer) : (0, _pageContainerStyles.StyledPageContainer);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appChrome.AppChrome), {
            "data-cy": "pageContainer",
            selectedModule: module,
            version: {
                full: version,
                abbr: abbreviatedVersion
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "data-cy": "pageContainerSelector",
                className: "container",
                children: children
            })
        })
    });
};
var GET_IPA_VERSION = (0, _graphqlTagDefault.default)(_templateObject());

},{"@swc/helpers/_/_sliced_to_array":"gML59","@swc/helpers/_/_tagged_template_literal":"9gf6S","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-apollo":"fOSWr","graphql-tag":"7waZp","root/components/AppChrome":"ht1HK","root/hooks/authentication":"9ykWB","./PageContainer.styles":"lvKkv","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"7waZp":[function(require,module,exports) {
var parser = require("1b0a8834e8b8406a");
var parse = parser.parse;
// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
// A map docString -> graphql document
var docCache = {};
// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
// For testing.
function resetCaches() {
    docCache = {};
    fragmentSourceMap = {};
}
// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
    var astFragmentMap = {};
    var definitions = [];
    for(var i = 0; i < ast.definitions.length; i++){
        var fragmentDefinition = ast.definitions[i];
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            // We know something about this fragment
            if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {
                // this is a problem because the app developer is trying to register another fragment with
                // the same name as one previously registered. So, we tell them about it.
                if (printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                fragmentSourceMap[fragmentName][sourceKey] = true;
            } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
                fragmentSourceMap[fragmentName] = {};
                fragmentSourceMap[fragmentName][sourceKey] = true;
            }
            if (!astFragmentMap[sourceKey]) {
                astFragmentMap[sourceKey] = true;
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    }
    ast.definitions = definitions;
    return ast;
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function stripLoc(doc, removeLocAtThisLevel) {
    var docType = Object.prototype.toString.call(doc);
    if (docType === "[object Array]") return doc.map(function(d) {
        return stripLoc(d, removeLocAtThisLevel);
    });
    if (docType !== "[object Object]") throw new Error("Unexpected input.");
    // We don't want to remove the root loc field so we can use it
    // for fragment substitution (see below)
    if (removeLocAtThisLevel && doc.loc) delete doc.loc;
    // https://github.com/apollographql/graphql-tag/issues/40
    if (doc.loc) {
        delete doc.loc.startToken;
        delete doc.loc.endToken;
    }
    var keys = Object.keys(doc);
    var key;
    var value;
    var valueType;
    for(key in keys)if (keys.hasOwnProperty(key)) {
        value = doc[keys[key]];
        valueType = Object.prototype.toString.call(value);
        if (valueType === "[object Object]" || valueType === "[object Array]") doc[keys[key]] = stripLoc(value, true);
    }
    return doc;
}
var experimentalFragmentVariables = false;
function parseDocument(doc) {
    var cacheKey = normalize(doc);
    if (docCache[cacheKey]) return docCache[cacheKey];
    var parsed = parse(doc, {
        experimentalFragmentVariables: experimentalFragmentVariables
    });
    if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
    // check that all "new" fragments inside the documents are consistent with
    // existing fragments of the same name
    parsed = processFragments(parsed);
    parsed = stripLoc(parsed, false);
    docCache[cacheKey] = parsed;
    return parsed;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql() {
    var args = Array.prototype.slice.call(arguments);
    var literals = args[0];
    // We always get literals[0] and then matching post literals for each arg given
    var result = typeof literals === "string" ? literals : literals[0];
    for(var i = 1; i < args.length; i++){
        if (args[i] && args[i].kind && args[i].kind === "Document") result += args[i].loc.source.body;
        else result += args[i];
        result += literals[i];
    }
    return parseDocument(result);
}
// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;
module.exports = gql;

},{"1b0a8834e8b8406a":"45PZs"}],"45PZs":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.parseConstValue = parseConstValue;
exports.parseTypeReference = parseTypeReference;
exports.parseNamedType = parseNamedType;
var _inspect = _interopRequireDefault(require("d82898aff918f5ae"));
var _defineToJSON = _interopRequireDefault(require("cdc32cb450690a10"));
var _source = require("3ff2b85dd7ef3be5");
var _error = require("d9f6eda48e1fef97");
var _lexer = require("1f2d1ab99204d461");
var _kinds = require("670694eb59dd422f");
var _directiveLocation = require("1dfdb08972c4c491");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */ function parse(source, options) {
    var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
    if (!(sourceObj instanceof _source.Source)) throw new TypeError("Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
    var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
    return parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */ function parseValue(source, options) {
    var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
    var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
    expectToken(lexer, _lexer.TokenKind.SOF);
    var value = parseValueLiteral(lexer, false);
    expectToken(lexer, _lexer.TokenKind.EOF);
    return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */ function parseType(source, options) {
    var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
    var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
    expectToken(lexer, _lexer.TokenKind.SOF);
    var type = parseTypeReference(lexer);
    expectToken(lexer, _lexer.TokenKind.EOF);
    return type;
}
/**
 * Converts a name lex token into a name parse node.
 */ function parseName(lexer) {
    var token = expectToken(lexer, _lexer.TokenKind.NAME);
    return {
        kind: _kinds.Kind.NAME,
        value: token.value,
        loc: loc(lexer, token)
    };
} // Implements the parsing rules in the Document section.
/**
 * Document : Definition+
 */ function parseDocument(lexer) {
    var start = lexer.token;
    return {
        kind: _kinds.Kind.DOCUMENT,
        definitions: many(lexer, _lexer.TokenKind.SOF, parseDefinition, _lexer.TokenKind.EOF),
        loc: loc(lexer, start)
    };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */ function parseDefinition(lexer) {
    if (peek(lexer, _lexer.TokenKind.NAME)) switch(lexer.token.value){
        case "query":
        case "mutation":
        case "subscription":
        case "fragment":
            return parseExecutableDefinition(lexer);
        case "schema":
        case "scalar":
        case "type":
        case "interface":
        case "union":
        case "enum":
        case "input":
        case "directive":
            return parseTypeSystemDefinition(lexer);
        case "extend":
            return parseTypeSystemExtension(lexer);
    }
    else if (peek(lexer, _lexer.TokenKind.BRACE_L)) return parseExecutableDefinition(lexer);
    else if (peekDescription(lexer)) return parseTypeSystemDefinition(lexer);
    throw unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */ function parseExecutableDefinition(lexer) {
    if (peek(lexer, _lexer.TokenKind.NAME)) switch(lexer.token.value){
        case "query":
        case "mutation":
        case "subscription":
            return parseOperationDefinition(lexer);
        case "fragment":
            return parseFragmentDefinition(lexer);
    }
    else if (peek(lexer, _lexer.TokenKind.BRACE_L)) return parseOperationDefinition(lexer);
    throw unexpected(lexer);
} // Implements the parsing rules in the Operations section.
/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */ function parseOperationDefinition(lexer) {
    var start = lexer.token;
    if (peek(lexer, _lexer.TokenKind.BRACE_L)) return {
        kind: _kinds.Kind.OPERATION_DEFINITION,
        operation: "query",
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: parseSelectionSet(lexer),
        loc: loc(lexer, start)
    };
    var operation = parseOperationType(lexer);
    var name;
    if (peek(lexer, _lexer.TokenKind.NAME)) name = parseName(lexer);
    return {
        kind: _kinds.Kind.OPERATION_DEFINITION,
        operation: operation,
        name: name,
        variableDefinitions: parseVariableDefinitions(lexer),
        directives: parseDirectives(lexer, false),
        selectionSet: parseSelectionSet(lexer),
        loc: loc(lexer, start)
    };
}
/**
 * OperationType : one of query mutation subscription
 */ function parseOperationType(lexer) {
    var operationToken = expectToken(lexer, _lexer.TokenKind.NAME);
    switch(operationToken.value){
        case "query":
            return "query";
        case "mutation":
            return "mutation";
        case "subscription":
            return "subscription";
    }
    throw unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */ function parseVariableDefinitions(lexer) {
    return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */ function parseVariableDefinition(lexer) {
    var start = lexer.token;
    return {
        kind: _kinds.Kind.VARIABLE_DEFINITION,
        variable: parseVariable(lexer),
        type: (expectToken(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
        defaultValue: expectOptionalToken(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
        directives: parseDirectives(lexer, true),
        loc: loc(lexer, start)
    };
}
/**
 * Variable : $ Name
 */ function parseVariable(lexer) {
    var start = lexer.token;
    expectToken(lexer, _lexer.TokenKind.DOLLAR);
    return {
        kind: _kinds.Kind.VARIABLE,
        name: parseName(lexer),
        loc: loc(lexer, start)
    };
}
/**
 * SelectionSet : { Selection+ }
 */ function parseSelectionSet(lexer) {
    var start = lexer.token;
    return {
        kind: _kinds.Kind.SELECTION_SET,
        selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
        loc: loc(lexer, start)
    };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */ function parseSelection(lexer) {
    return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */ function parseField(lexer) {
    var start = lexer.token;
    var nameOrAlias = parseName(lexer);
    var alias;
    var name;
    if (expectOptionalToken(lexer, _lexer.TokenKind.COLON)) {
        alias = nameOrAlias;
        name = parseName(lexer);
    } else name = nameOrAlias;
    return {
        kind: _kinds.Kind.FIELD,
        alias: alias,
        name: name,
        arguments: parseArguments(lexer, false),
        directives: parseDirectives(lexer, false),
        selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : undefined,
        loc: loc(lexer, start)
    };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */ function parseArguments(lexer, isConst) {
    var item = isConst ? parseConstArgument : parseArgument;
    return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */ function parseArgument(lexer) {
    var start = lexer.token;
    var name = parseName(lexer);
    expectToken(lexer, _lexer.TokenKind.COLON);
    return {
        kind: _kinds.Kind.ARGUMENT,
        name: name,
        value: parseValueLiteral(lexer, false),
        loc: loc(lexer, start)
    };
}
function parseConstArgument(lexer) {
    var start = lexer.token;
    return {
        kind: _kinds.Kind.ARGUMENT,
        name: parseName(lexer),
        value: (expectToken(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
        loc: loc(lexer, start)
    };
} // Implements the parsing rules in the Fragments section.
/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */ function parseFragment(lexer) {
    var start = lexer.token;
    expectToken(lexer, _lexer.TokenKind.SPREAD);
    var hasTypeCondition = expectOptionalKeyword(lexer, "on");
    if (!hasTypeCondition && peek(lexer, _lexer.TokenKind.NAME)) return {
        kind: _kinds.Kind.FRAGMENT_SPREAD,
        name: parseFragmentName(lexer),
        directives: parseDirectives(lexer, false),
        loc: loc(lexer, start)
    };
    return {
        kind: _kinds.Kind.INLINE_FRAGMENT,
        typeCondition: hasTypeCondition ? parseNamedType(lexer) : undefined,
        directives: parseDirectives(lexer, false),
        selectionSet: parseSelectionSet(lexer),
        loc: loc(lexer, start)
    };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */ function parseFragmentDefinition(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "fragment"); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
    if (lexer.options.experimentalFragmentVariables) return {
        kind: _kinds.Kind.FRAGMENT_DEFINITION,
        name: parseFragmentName(lexer),
        variableDefinitions: parseVariableDefinitions(lexer),
        typeCondition: (expectKeyword(lexer, "on"), parseNamedType(lexer)),
        directives: parseDirectives(lexer, false),
        selectionSet: parseSelectionSet(lexer),
        loc: loc(lexer, start)
    };
    return {
        kind: _kinds.Kind.FRAGMENT_DEFINITION,
        name: parseFragmentName(lexer),
        typeCondition: (expectKeyword(lexer, "on"), parseNamedType(lexer)),
        directives: parseDirectives(lexer, false),
        selectionSet: parseSelectionSet(lexer),
        loc: loc(lexer, start)
    };
}
/**
 * FragmentName : Name but not `on`
 */ function parseFragmentName(lexer) {
    if (lexer.token.value === "on") throw unexpected(lexer);
    return parseName(lexer);
} // Implements the parsing rules in the Values section.
/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */ function parseValueLiteral(lexer, isConst) {
    var token = lexer.token;
    switch(token.kind){
        case _lexer.TokenKind.BRACKET_L:
            return parseList(lexer, isConst);
        case _lexer.TokenKind.BRACE_L:
            return parseObject(lexer, isConst);
        case _lexer.TokenKind.INT:
            lexer.advance();
            return {
                kind: _kinds.Kind.INT,
                value: token.value,
                loc: loc(lexer, token)
            };
        case _lexer.TokenKind.FLOAT:
            lexer.advance();
            return {
                kind: _kinds.Kind.FLOAT,
                value: token.value,
                loc: loc(lexer, token)
            };
        case _lexer.TokenKind.STRING:
        case _lexer.TokenKind.BLOCK_STRING:
            return parseStringLiteral(lexer);
        case _lexer.TokenKind.NAME:
            if (token.value === "true" || token.value === "false") {
                lexer.advance();
                return {
                    kind: _kinds.Kind.BOOLEAN,
                    value: token.value === "true",
                    loc: loc(lexer, token)
                };
            } else if (token.value === "null") {
                lexer.advance();
                return {
                    kind: _kinds.Kind.NULL,
                    loc: loc(lexer, token)
                };
            }
            lexer.advance();
            return {
                kind: _kinds.Kind.ENUM,
                value: token.value,
                loc: loc(lexer, token)
            };
        case _lexer.TokenKind.DOLLAR:
            if (!isConst) return parseVariable(lexer);
            break;
    }
    throw unexpected(lexer);
}
function parseStringLiteral(lexer) {
    var token = lexer.token;
    lexer.advance();
    return {
        kind: _kinds.Kind.STRING,
        value: token.value,
        block: token.kind === _lexer.TokenKind.BLOCK_STRING,
        loc: loc(lexer, token)
    };
}
function parseConstValue(lexer) {
    return parseValueLiteral(lexer, true);
}
function parseValueValue(lexer) {
    return parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */ function parseList(lexer, isConst) {
    var start = lexer.token;
    var item = isConst ? parseConstValue : parseValueValue;
    return {
        kind: _kinds.Kind.LIST,
        values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
        loc: loc(lexer, start)
    };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */ function parseObject(lexer, isConst) {
    var start = lexer.token;
    var item = function item() {
        return parseObjectField(lexer, isConst);
    };
    return {
        kind: _kinds.Kind.OBJECT,
        fields: any(lexer, _lexer.TokenKind.BRACE_L, item, _lexer.TokenKind.BRACE_R),
        loc: loc(lexer, start)
    };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */ function parseObjectField(lexer, isConst) {
    var start = lexer.token;
    var name = parseName(lexer);
    expectToken(lexer, _lexer.TokenKind.COLON);
    return {
        kind: _kinds.Kind.OBJECT_FIELD,
        name: name,
        value: parseValueLiteral(lexer, isConst),
        loc: loc(lexer, start)
    };
} // Implements the parsing rules in the Directives section.
/**
 * Directives[Const] : Directive[?Const]+
 */ function parseDirectives(lexer, isConst) {
    var directives = [];
    while(peek(lexer, _lexer.TokenKind.AT))directives.push(parseDirective(lexer, isConst));
    return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */ function parseDirective(lexer, isConst) {
    var start = lexer.token;
    expectToken(lexer, _lexer.TokenKind.AT);
    return {
        kind: _kinds.Kind.DIRECTIVE,
        name: parseName(lexer),
        arguments: parseArguments(lexer, isConst),
        loc: loc(lexer, start)
    };
} // Implements the parsing rules in the Types section.
/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */ function parseTypeReference(lexer) {
    var start = lexer.token;
    var type;
    if (expectOptionalToken(lexer, _lexer.TokenKind.BRACKET_L)) {
        type = parseTypeReference(lexer);
        expectToken(lexer, _lexer.TokenKind.BRACKET_R);
        type = {
            kind: _kinds.Kind.LIST_TYPE,
            type: type,
            loc: loc(lexer, start)
        };
    } else type = parseNamedType(lexer);
    if (expectOptionalToken(lexer, _lexer.TokenKind.BANG)) return {
        kind: _kinds.Kind.NON_NULL_TYPE,
        type: type,
        loc: loc(lexer, start)
    };
    return type;
}
/**
 * NamedType : Name
 */ function parseNamedType(lexer) {
    var start = lexer.token;
    return {
        kind: _kinds.Kind.NAMED_TYPE,
        name: parseName(lexer),
        loc: loc(lexer, start)
    };
} // Implements the parsing rules in the Type Definition section.
/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */ function parseTypeSystemDefinition(lexer) {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;
    if (keywordToken.kind === _lexer.TokenKind.NAME) switch(keywordToken.value){
        case "schema":
            return parseSchemaDefinition(lexer);
        case "scalar":
            return parseScalarTypeDefinition(lexer);
        case "type":
            return parseObjectTypeDefinition(lexer);
        case "interface":
            return parseInterfaceTypeDefinition(lexer);
        case "union":
            return parseUnionTypeDefinition(lexer);
        case "enum":
            return parseEnumTypeDefinition(lexer);
        case "input":
            return parseInputObjectTypeDefinition(lexer);
        case "directive":
            return parseDirectiveDefinition(lexer);
    }
    throw unexpected(lexer, keywordToken);
}
function peekDescription(lexer) {
    return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */ function parseDescription(lexer) {
    if (peekDescription(lexer)) return parseStringLiteral(lexer);
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */ function parseSchemaDefinition(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "schema");
    var directives = parseDirectives(lexer, true);
    var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
    return {
        kind: _kinds.Kind.SCHEMA_DEFINITION,
        directives: directives,
        operationTypes: operationTypes,
        loc: loc(lexer, start)
    };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */ function parseOperationTypeDefinition(lexer) {
    var start = lexer.token;
    var operation = parseOperationType(lexer);
    expectToken(lexer, _lexer.TokenKind.COLON);
    var type = parseNamedType(lexer);
    return {
        kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
        operation: operation,
        type: type,
        loc: loc(lexer, start)
    };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */ function parseScalarTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "scalar");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    return {
        kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: loc(lexer, start)
    };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */ function parseObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "type");
    var name = parseName(lexer);
    var interfaces = parseImplementsInterfaces(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseFieldsDefinition(lexer);
    return {
        kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */ function parseImplementsInterfaces(lexer) {
    var types = [];
    if (expectOptionalKeyword(lexer, "implements")) {
        // Optional leading ampersand
        expectOptionalToken(lexer, _lexer.TokenKind.AMP);
        do types.push(parseNamedType(lexer));
        while (expectOptionalToken(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
        lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
    }
    return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */ function parseFieldsDefinition(lexer) {
    // Legacy support for the SDL?
    if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
        lexer.advance();
        lexer.advance();
        return [];
    }
    return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */ function parseFieldDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    var name = parseName(lexer);
    var args = parseArgumentDefs(lexer);
    expectToken(lexer, _lexer.TokenKind.COLON);
    var type = parseTypeReference(lexer);
    var directives = parseDirectives(lexer, true);
    return {
        kind: _kinds.Kind.FIELD_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        type: type,
        directives: directives,
        loc: loc(lexer, start)
    };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */ function parseArgumentDefs(lexer) {
    if (!peek(lexer, _lexer.TokenKind.PAREN_L)) return [];
    return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */ function parseInputValueDef(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    var name = parseName(lexer);
    expectToken(lexer, _lexer.TokenKind.COLON);
    var type = parseTypeReference(lexer);
    var defaultValue;
    if (expectOptionalToken(lexer, _lexer.TokenKind.EQUALS)) defaultValue = parseConstValue(lexer);
    var directives = parseDirectives(lexer, true);
    return {
        kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
        description: description,
        name: name,
        type: type,
        defaultValue: defaultValue,
        directives: directives,
        loc: loc(lexer, start)
    };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */ function parseInterfaceTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "interface");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseFieldsDefinition(lexer);
    return {
        kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */ function parseUnionTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "union");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var types = parseUnionMemberTypes(lexer);
    return {
        kind: _kinds.Kind.UNION_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        types: types,
        loc: loc(lexer, start)
    };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */ function parseUnionMemberTypes(lexer) {
    var types = [];
    if (expectOptionalToken(lexer, _lexer.TokenKind.EQUALS)) {
        // Optional leading pipe
        expectOptionalToken(lexer, _lexer.TokenKind.PIPE);
        do types.push(parseNamedType(lexer));
        while (expectOptionalToken(lexer, _lexer.TokenKind.PIPE));
    }
    return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */ function parseEnumTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "enum");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var values = parseEnumValuesDefinition(lexer);
    return {
        kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        values: values,
        loc: loc(lexer, start)
    };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */ function parseEnumValuesDefinition(lexer) {
    return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */ function parseEnumValueDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    return {
        kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        loc: loc(lexer, start)
    };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */ function parseInputObjectTypeDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "input");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseInputFieldsDefinition(lexer);
    return {
        kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
        description: description,
        name: name,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */ function parseInputFieldsDefinition(lexer) {
    return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */ function parseTypeSystemExtension(lexer) {
    var keywordToken = lexer.lookahead();
    if (keywordToken.kind === _lexer.TokenKind.NAME) switch(keywordToken.value){
        case "schema":
            return parseSchemaExtension(lexer);
        case "scalar":
            return parseScalarTypeExtension(lexer);
        case "type":
            return parseObjectTypeExtension(lexer);
        case "interface":
            return parseInterfaceTypeExtension(lexer);
        case "union":
            return parseUnionTypeExtension(lexer);
        case "enum":
            return parseEnumTypeExtension(lexer);
        case "input":
            return parseInputObjectTypeExtension(lexer);
    }
    throw unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */ function parseSchemaExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "schema");
    var directives = parseDirectives(lexer, true);
    var operationTypes = peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R) : [];
    if (directives.length === 0 && operationTypes.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.SCHEMA_EXTENSION,
        directives: directives,
        operationTypes: operationTypes,
        loc: loc(lexer, start)
    };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */ function parseScalarTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "scalar");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    if (directives.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
        name: name,
        directives: directives,
        loc: loc(lexer, start)
    };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */ function parseObjectTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "type");
    var name = parseName(lexer);
    var interfaces = parseImplementsInterfaces(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseFieldsDefinition(lexer);
    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
        name: name,
        interfaces: interfaces,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */ function parseInterfaceTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "interface");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */ function parseUnionTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "union");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var types = parseUnionMemberTypes(lexer);
    if (directives.length === 0 && types.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.UNION_TYPE_EXTENSION,
        name: name,
        directives: directives,
        types: types,
        loc: loc(lexer, start)
    };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */ function parseEnumTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "enum");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var values = parseEnumValuesDefinition(lexer);
    if (directives.length === 0 && values.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
        name: name,
        directives: directives,
        values: values,
        loc: loc(lexer, start)
    };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */ function parseInputObjectTypeExtension(lexer) {
    var start = lexer.token;
    expectKeyword(lexer, "extend");
    expectKeyword(lexer, "input");
    var name = parseName(lexer);
    var directives = parseDirectives(lexer, true);
    var fields = parseInputFieldsDefinition(lexer);
    if (directives.length === 0 && fields.length === 0) throw unexpected(lexer);
    return {
        kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
        name: name,
        directives: directives,
        fields: fields,
        loc: loc(lexer, start)
    };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */ function parseDirectiveDefinition(lexer) {
    var start = lexer.token;
    var description = parseDescription(lexer);
    expectKeyword(lexer, "directive");
    expectToken(lexer, _lexer.TokenKind.AT);
    var name = parseName(lexer);
    var args = parseArgumentDefs(lexer);
    expectKeyword(lexer, "on");
    var locations = parseDirectiveLocations(lexer);
    return {
        kind: _kinds.Kind.DIRECTIVE_DEFINITION,
        description: description,
        name: name,
        arguments: args,
        locations: locations,
        loc: loc(lexer, start)
    };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */ function parseDirectiveLocations(lexer) {
    // Optional leading pipe
    expectOptionalToken(lexer, _lexer.TokenKind.PIPE);
    var locations = [];
    do locations.push(parseDirectiveLocation(lexer));
    while (expectOptionalToken(lexer, _lexer.TokenKind.PIPE));
    return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */ function parseDirectiveLocation(lexer) {
    var start = lexer.token;
    var name = parseName(lexer);
    if (_directiveLocation.DirectiveLocation[name.value] !== undefined) return name;
    throw unexpected(lexer, start);
} // Core parsing utility functions
/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */ function loc(lexer, startToken) {
    if (!lexer.options.noLocation) return new Loc(startToken, lexer.lastToken, lexer.source);
}
function Loc(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, _defineToJSON.default)(Loc, function() {
    return {
        start: this.start,
        end: this.end
    };
});
/**
 * Determines if the next token is of a given kind
 */ function peek(lexer, kind) {
    return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */ function expectToken(lexer, kind) {
    var token = lexer.token;
    if (token.kind === kind) {
        lexer.advance();
        return token;
    }
    throw (0, _error.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and return undefined.
 */ function expectOptionalToken(lexer, kind) {
    var token = lexer.token;
    if (token.kind === kind) {
        lexer.advance();
        return token;
    }
    return undefined;
}
/**
 * If the next token is a given keyword, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */ function expectKeyword(lexer, value) {
    var token = lexer.token;
    if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
        lexer.advance();
        return token;
    }
    throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected "'.concat(value, '", found ').concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * If the next token is a given keyword, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and return undefined.
 */ function expectOptionalKeyword(lexer, value) {
    var token = lexer.token;
    if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
        lexer.advance();
        return token;
    }
    return undefined;
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */ function unexpected(lexer, atToken) {
    var token = atToken || lexer.token;
    return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function any(lexer, openKind, parseFn, closeKind) {
    expectToken(lexer, openKind);
    var nodes = [];
    while(!expectOptionalToken(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */ function many(lexer, openKind, parseFn, closeKind) {
    expectToken(lexer, openKind);
    var nodes = [
        parseFn(lexer)
    ];
    while(!expectOptionalToken(lexer, closeKind))nodes.push(parseFn(lexer));
    return nodes;
}

},{"d82898aff918f5ae":"fj0Be","cdc32cb450690a10":"94LBc","3ff2b85dd7ef3be5":"eE0uu","d9f6eda48e1fef97":"jCbLK","1f2d1ab99204d461":"58wyO","670694eb59dd422f":"hOhrq","1dfdb08972c4c491":"8Hkqv"}],"94LBc":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defineToJSON;
var _nodejsCustomInspectSymbol = _interopRequireDefault(require("8956bdd95133c3d7"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */ function defineToJSON(classObject) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
    classObject.prototype.toJSON = fn;
    classObject.prototype.inspect = fn;
    if (_nodejsCustomInspectSymbol.default) classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
}

},{"8956bdd95133c3d7":"dXuT7"}],"eE0uu":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Source = void 0;
var _invariant = _interopRequireDefault(require("ac1ccec6cb9c2da2"));
var _defineToStringTag = _interopRequireDefault(require("6c322a48651cb3c2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */ var Source = function Source(body, name, locationOffset) {
    this.body = body;
    this.name = name || "GraphQL request";
    this.locationOffset = locationOffset || {
        line: 1,
        column: 1
    };
    !(this.locationOffset.line > 0) && (0, _invariant.default)(0, "line in locationOffset is 1-indexed and must be positive");
    !(this.locationOffset.column > 0) && (0, _invariant.default)(0, "column in locationOffset is 1-indexed and must be positive");
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
exports.Source = Source;
(0, _defineToStringTag.default)(Source);

},{"ac1ccec6cb9c2da2":"j3DNd","6c322a48651cb3c2":"dCpSi"}],"j3DNd":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = invariant;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function invariant(condition, message) {
    var booleanCondition = Boolean(condition);
    /* istanbul ignore else */ if (!booleanCondition) throw new Error(message);
}

},{}],"dCpSi":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defineToStringTag;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */ function defineToStringTag(classObject) {
    if (typeof Symbol === "function" && Symbol.toStringTag) Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
        get: function get() {
            return this.constructor.name;
        }
    });
}

},{}],"jCbLK":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GraphQLError", {
    enumerable: true,
    get: function get() {
        return _GraphQLError.GraphQLError;
    }
});
Object.defineProperty(exports, "syntaxError", {
    enumerable: true,
    get: function get() {
        return _syntaxError.syntaxError;
    }
});
Object.defineProperty(exports, "locatedError", {
    enumerable: true,
    get: function get() {
        return _locatedError.locatedError;
    }
});
Object.defineProperty(exports, "printError", {
    enumerable: true,
    get: function get() {
        return _printError.printError;
    }
});
Object.defineProperty(exports, "formatError", {
    enumerable: true,
    get: function get() {
        return _formatError.formatError;
    }
});
var _GraphQLError = require("298cf87415351a32");
var _syntaxError = require("1b79bb710c5f32a");
var _locatedError = require("a0d5a4ff7b052408");
var _printError = require("2bec24d921bd5f22");
var _formatError = require("7fb9e75673356db8");

},{"298cf87415351a32":"hfZH8","1b79bb710c5f32a":"rfk64","a0d5a4ff7b052408":"bA5kG","2bec24d921bd5f22":"6smnR","7fb9e75673356db8":"l3Ebx"}],"hfZH8":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GraphQLError = GraphQLError;
var _printError = require("27f61a5b1ff08401");
var _location = require("da64d225d9ea741a");
function _typeof(obj) {
    if (typeof Symbol === "function" && (0, _typeOf._)(Symbol.iterator) === "symbol") _typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, _typeOf._)(obj);
    };
    return _typeof(obj);
}
function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    // Compute list of blame nodes.
    var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [
        nodes
    ] : undefined; // Compute locations in the source for the given nodes/positions.
    var _source = source;
    if (!_source && _nodes) {
        var node = _nodes[0];
        _source = node && node.loc && node.loc.source;
    }
    var _positions = positions;
    if (!_positions && _nodes) _positions = _nodes.reduce(function(list, node) {
        if (node.loc) list.push(node.loc.start);
        return list;
    }, []);
    if (_positions && _positions.length === 0) _positions = undefined;
    var _locations;
    if (positions && source) _locations = positions.map(function(pos) {
        return (0, _location.getLocation)(source, pos);
    });
    else if (_nodes) _locations = _nodes.reduce(function(list, node) {
        if (node.loc) list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
        return list;
    }, []);
    var _extensions = extensions;
    if (_extensions == null && originalError != null) {
        var originalExtensions = originalError.extensions;
        if (originalExtensions != null && _typeof(originalExtensions) === "object") _extensions = originalExtensions;
    }
    Object.defineProperties(this, {
        message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
        },
        locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || undefined,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_locations)
        },
        path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(path)
        },
        nodes: {
            value: _nodes || undefined
        },
        source: {
            value: _source || undefined
        },
        positions: {
            value: _positions || undefined
        },
        originalError: {
            value: originalError
        },
        extensions: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _extensions || undefined,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: Boolean(_extensions)
        }
    }); // Include (non-enumerable) stack trace.
    if (originalError && originalError.stack) Object.defineProperty(this, "stack", {
        value: originalError.stack,
        writable: true,
        configurable: true
    });
    else if (Error.captureStackTrace) Error.captureStackTrace(this, GraphQLError);
    else Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: true,
        configurable: true
    });
}
GraphQLError.prototype = Object.create(Error.prototype, {
    constructor: {
        value: GraphQLError
    },
    name: {
        value: "GraphQLError"
    },
    toString: {
        value: function toString() {
            return (0, _printError.printError)(this);
        }
    }
});

},{"@swc/helpers/_/_type_of":"6Gp9n","27f61a5b1ff08401":"6smnR","da64d225d9ea741a":"1Ov4Z"}],"6smnR":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.printError = printError;
var _location = require("f9661c153585560");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */ function printError(error) {
    var printedLocations = [];
    if (error.nodes) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var node = _step.value;
                if (node.loc) printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    } else if (error.source && error.locations) {
        var source = error.source;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;
        try {
            for(var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var location = _step2.value;
                printedLocations.push(highlightSourceAtLocation(source, location));
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) _iterator2.return();
            } finally{
                if (_didIteratorError2) throw _iteratorError2;
            }
        }
    }
    return printedLocations.length === 0 ? error.message : [
        error.message
    ].concat(printedLocations).join("\n\n") + "\n";
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */ function highlightSourceAtLocation(source, location) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = location.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = location.line + lineOffset;
    var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = location.column + columnOffset;
    var lines = body.split(/\r\n|[\n\r]/g);
    return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + printPrefixedLines([
        [
            "".concat(lineNum - 1, ": "),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum, ": "),
            lines[lineIndex]
        ],
        [
            "",
            whitespace(columnNum - 1) + "^"
        ],
        [
            "".concat(lineNum + 1, ": "),
            lines[lineIndex + 1]
        ]
    ]);
}
function printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = 0;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;
    try {
        for(var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var _ref4 = _step3.value;
            var prefix = _ref4[0];
            padLen = Math.max(padLen, prefix.length);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) _iterator3.return();
        } finally{
            if (_didIteratorError3) throw _iteratorError3;
        }
    }
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return lpad(padLen, prefix) + line;
    }).join("\n");
}
function whitespace(len) {
    return Array(len + 1).join(" ");
}
function lpad(len, str) {
    return whitespace(len - str.length) + str;
}

},{"f9661c153585560":"1Ov4Z"}],"1Ov4Z":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocation = getLocation;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function getLocation(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

},{}],"rfk64":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.syntaxError = syntaxError;
var _GraphQLError = require("a193202cdc787c6b");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */ function syntaxError(source, position, description) {
    return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

},{"a193202cdc787c6b":"hfZH8"}],"bA5kG":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.locatedError = locatedError;
var _GraphQLError = require("4d73475b7be1abad");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */ function locatedError(originalError, nodes, path) {
    // Note: this uses a brand-check to support GraphQL errors originating from
    // other contexts.
    if (originalError && Array.isArray(originalError.path)) return originalError;
    return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

},{"4d73475b7be1abad":"hfZH8"}],"l3Ebx":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatError = formatError;
var _invariant = _interopRequireDefault(require("b117900debbc7566"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */ function formatError(error) {
    !error && (0, _invariant.default)(0, "Received null or undefined error.");
    var message = error.message || "An unknown error occurred.";
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
}

},{"b117900debbc7566":"j3DNd"}],"58wyO":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createLexer = createLexer;
exports.isPunctuatorToken = isPunctuatorToken;
exports.getTokenDesc = getTokenDesc;
exports.TokenKind = void 0;
var _defineToJSON = _interopRequireDefault(require("fab2214a7e444cd9"));
var _error = require("55a2f5840fd75635");
var _blockString = require("f300a0fd5d1671b0");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */ function createLexer(source, options) {
    var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
    var lexer = {
        source: source,
        options: options,
        lastToken: startOfFileToken,
        token: startOfFileToken,
        line: 1,
        lineStart: 0,
        advance: advanceLexer,
        lookahead: lookahead
    };
    return lexer;
}
function advanceLexer() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
}
function lookahead() {
    var token = this.token;
    if (token.kind !== TokenKind.EOF) do // Note: next is only mutable during parsing, so we cast to allow this.
    token = token.next || (token.next = readToken(this, token));
    while (token.kind === TokenKind.COMMENT);
    return token;
}
/**
 * The return type of createLexer.
 */ /**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var TokenKind = Object.freeze({
    SOF: "<SOF>",
    EOF: "<EOF>",
    BANG: "!",
    DOLLAR: "$",
    AMP: "&",
    PAREN_L: "(",
    PAREN_R: ")",
    SPREAD: "...",
    COLON: ":",
    EQUALS: "=",
    AT: "@",
    BRACKET_L: "[",
    BRACKET_R: "]",
    BRACE_L: "{",
    PIPE: "|",
    BRACE_R: "}",
    NAME: "Name",
    INT: "Int",
    FLOAT: "Float",
    STRING: "String",
    BLOCK_STRING: "BlockString",
    COMMENT: "Comment"
});
/**
 * The enum type representing the token kinds values.
 */ exports.TokenKind = TokenKind;
// @internal
function isPunctuatorToken(token) {
    var kind = token.kind;
    return kind === TokenKind.BANG || kind === TokenKind.DOLLAR || kind === TokenKind.AMP || kind === TokenKind.PAREN_L || kind === TokenKind.PAREN_R || kind === TokenKind.SPREAD || kind === TokenKind.COLON || kind === TokenKind.EQUALS || kind === TokenKind.AT || kind === TokenKind.BRACKET_L || kind === TokenKind.BRACKET_R || kind === TokenKind.BRACE_L || kind === TokenKind.PIPE || kind === TokenKind.BRACE_R;
}
/**
 * A helper function to describe a token as a string for debugging
 */ function getTokenDesc(token) {
    var value = token.value;
    return value ? "".concat(token.kind, ' "').concat(value, '"') : token.kind;
}
/**
 * Helper function for constructing the Token object.
 */ function Tok(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.
(0, _defineToJSON.default)(Tok, function() {
    return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
    };
});
function printCharCode(code) {
    return isNaN(code) ? TokenKind.EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : '"\\u'.concat(("00" + code.toString(16).toUpperCase()).slice(-4), '"');
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = positionAfterWhitespace(body, prev.end, lexer);
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    if (pos >= bodyLength) return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
    var code = body.charCodeAt(pos); // SourceCharacter
    switch(code){
        // !
        case 33:
            return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
        // #
        case 35:
            return readComment(source, pos, line, col, prev);
        // $
        case 36:
            return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
        // &
        case 38:
            return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
        // (
        case 40:
            return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
        // )
        case 41:
            return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
        // .
        case 46:
            if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
            break;
        // :
        case 58:
            return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
        // =
        case 61:
            return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
        // @
        case 64:
            return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
        // [
        case 91:
            return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
        // ]
        case 93:
            return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
        // {
        case 123:
            return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
        // |
        case 124:
            return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
        // }
        case 125:
            return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
        // A-Z _ a-z
        case 65:
        case 66:
        case 67:
        case 68:
        case 69:
        case 70:
        case 71:
        case 72:
        case 73:
        case 74:
        case 75:
        case 76:
        case 77:
        case 78:
        case 79:
        case 80:
        case 81:
        case 82:
        case 83:
        case 84:
        case 85:
        case 86:
        case 87:
        case 88:
        case 89:
        case 90:
        case 95:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 106:
        case 107:
        case 108:
        case 109:
        case 110:
        case 111:
        case 112:
        case 113:
        case 114:
        case 115:
        case 116:
        case 117:
        case 118:
        case 119:
        case 120:
        case 121:
        case 122:
            return readName(source, pos, line, col, prev);
        // - 0-9
        case 45:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
            return readNumber(source, pos, code, line, col, prev);
        // "
        case 34:
            if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return readBlockString(source, pos, line, col, prev, lexer);
            return readString(source, pos, line, col, prev);
    }
    throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */ function unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
    if (code === 39) // '
    return "Unexpected single quote character ('), did you mean to use a double quote (\")?";
    return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */ function positionAfterWhitespace(body, startPosition, lexer) {
    var bodyLength = body.length;
    var position = startPosition;
    while(position < bodyLength){
        var code = body.charCodeAt(position); // tab | space | comma | BOM
        if (code === 9 || code === 32 || code === 44 || code === 0xfeff) ++position;
        else if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else break;
    }
    return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new Tok(TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    } else {
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = readDigits(source, position, code);
    }
    return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += "/";
                    break;
                case 92:
                    value += "\\";
                    break;
                case 98:
                    value += "\b";
                    break;
                case 102:
                    value += "\f";
                    break;
                case 110:
                    value += "\n";
                    break;
                case 114:
                    value += "\r";
                    break;
                case 116:
                    value += "	";
                    break;
                case 117:
                    // uXXXX
                    var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: " + "\\u".concat(body.slice(position + 1, position + 5), "."));
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, _error.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = "";
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, _error.syntaxError)(source, position, "Unterminated string.");
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function uniCharCode(a, b, c, d) {
    return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new Tok(TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
}

},{"fab2214a7e444cd9":"94LBc","55a2f5840fd75635":"jCbLK","f300a0fd5d1671b0":"7PbQ1"}],"hOhrq":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Kind = void 0;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * The set of allowed kind values for AST nodes.
 */ var Kind = Object.freeze({
    // Name
    NAME: "Name",
    // Document
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    // Fragments
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    // Values
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    // Directives
    DIRECTIVE: "Directive",
    // Types
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType",
    // Type System Definitions
    SCHEMA_DEFINITION: "SchemaDefinition",
    OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
    // Type Definitions
    SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
    OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
    FIELD_DEFINITION: "FieldDefinition",
    INPUT_VALUE_DEFINITION: "InputValueDefinition",
    INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
    UNION_TYPE_DEFINITION: "UnionTypeDefinition",
    ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
    ENUM_VALUE_DEFINITION: "EnumValueDefinition",
    INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
    // Directive Definitions
    DIRECTIVE_DEFINITION: "DirectiveDefinition",
    // Type System Extensions
    SCHEMA_EXTENSION: "SchemaExtension",
    // Type Extensions
    SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
    OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
    INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
    UNION_TYPE_EXTENSION: "UnionTypeExtension",
    ENUM_TYPE_EXTENSION: "EnumTypeExtension",
    INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */ exports.Kind = Kind;

},{}],"8Hkqv":[function(require,module,exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DirectiveLocation = void 0;
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ /**
 * The set of allowed directive location values.
 */ var DirectiveLocation = Object.freeze({
    // Request Definitions
    QUERY: "QUERY",
    MUTATION: "MUTATION",
    SUBSCRIPTION: "SUBSCRIPTION",
    FIELD: "FIELD",
    FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
    FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
    INLINE_FRAGMENT: "INLINE_FRAGMENT",
    VARIABLE_DEFINITION: "VARIABLE_DEFINITION",
    // Type System Definitions
    SCHEMA: "SCHEMA",
    SCALAR: "SCALAR",
    OBJECT: "OBJECT",
    FIELD_DEFINITION: "FIELD_DEFINITION",
    ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
    INTERFACE: "INTERFACE",
    UNION: "UNION",
    ENUM: "ENUM",
    ENUM_VALUE: "ENUM_VALUE",
    INPUT_OBJECT: "INPUT_OBJECT",
    INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
});
/**
 * The enum type representing the directive location values.
 */ exports.DirectiveLocation = DirectiveLocation;

},{}],"ht1HK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppChrome", function() {
    return 0, _appChrome.AppChrome;
});
var _appChrome = require("./AppChrome");

},{"./AppChrome":"hBG1E","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hBG1E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppChrome", function() {
    return AppChrome;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _permafrost = require("@indico-data/permafrost");
var _router = require("root/constants/router");
var _appStore = require("root/store/appStore");
var _authentication = require("root/hooks/authentication");
var _menu = require("./menu");
var _appChromeStyles = require("./AppChrome.styles");
var appStoreSelector = function(state) {
    return {
        sidebarOpen: state.sidebarOpen,
        toggleSidebar: state.toggleSidebar
    };
};
var AppChrome = function(props) {
    var _window_indico_features, _window_indico, _currentUser_scopes, _currentUser_scopes1, _currentUser_scopes2, _window_indico_featuresConfig, _window_indico1;
    var trialEdition = (_window_indico = window.indico) === null || _window_indico === void 0 ? void 0 : (_window_indico_features = _window_indico.features) === null || _window_indico_features === void 0 ? void 0 : _window_indico_features.trialEdition;
    var _useAppStore = (0, _appStore.useAppStore)(appStoreSelector), sidebarOpen = _useAppStore.sidebarOpen, toggleSidebar = _useAppStore.toggleSidebar;
    var currentUser = (0, _authentication.useCurrentUser)();
    var angle = !sidebarOpen ? "chevron-right" : "chevron-left";
    var menu = [
        (0, _toConsumableArray._)((0, _menu.APP_CHROME_MENU)[0]),
        (0, _toConsumableArray._)((0, _menu.APP_CHROME_MENU)[1])
    ];
    var isAdmin = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_scopes = currentUser.scopes) === null || _currentUser_scopes === void 0 ? void 0 : _currentUser_scopes.map(function(s) {
        return s.scope;
    }).includes("manage_users");
    var isTeam = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_scopes1 = currentUser.scopes) === null || _currentUser_scopes1 === void 0 ? void 0 : _currentUser_scopes1.map(function(s) {
        return s.scope;
    }).includes("manage_dataset");
    var isDeveloper = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser_scopes2 = currentUser.scopes) === null || _currentUser_scopes2 === void 0 ? void 0 : _currentUser_scopes2.map(function(s) {
        return s.scope;
    }).includes("graphiql"); // Product
    var isOpenapiEnabled = (_window_indico1 = window.indico) === null || _window_indico1 === void 0 ? void 0 : (_window_indico_featuresConfig = _window_indico1.featuresConfig) === null || _window_indico_featuresConfig === void 0 ? void 0 : _window_indico_featuresConfig.openapi;
    var adminItem = {
        id: "ADMIN_APP",
        text: "Admin",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
            name: "recruiter"
        }),
        destination: _router.BASE_ADMIN,
        anchor: false
    };
    var galleryItem = {
        id: "ZEPHYR_APP",
        text: "Gallery",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
            name: "gallery"
        }),
        destination: _router.GET_GALLERY_DETAIL({
            detail: "workflows"
        }),
        anchor: false
    };
    var graphiqlItem = {
        id: "GRAPHIQL_APP",
        text: "GraphiQL",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
            name: "graphiql"
        }),
        destination: "".concat((0, _getDefault.default)(window, "indico.appURLs.FogURL"), "/api/graphql"),
        anchor: true
    };
    var openapiItem = {
        id: "OPENAPI_APP",
        text: "OpenAPI",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
            name: "swagger"
        }),
        destination: "".concat((0, _getDefault.default)(window, "indico.appURLs.OpenApiURL"), "/docs"),
        anchor: true
    };
    if (isAdmin) {
        menu[1].splice(1, 0, adminItem);
        menu[1].splice(2, 0, galleryItem);
    }
    if (!isAdmin && isTeam) menu[1].splice(1, 0, galleryItem);
    if (isDeveloper) menu[1].push(graphiqlItem);
    if (isDeveloper && isOpenapiEnabled) menu[1].push(openapiItem);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _appChromeStyles.StyledAppChrome), {
        className: (0, _classnamesDefault.default)({
            closed: sidebarOpen === false
        }),
        "data-cy": "appChromeSidebar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "AppNavigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "AppBranding",
                        children: [
                            sidebarOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "AppLogo AppLogo--Full",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Logo), {})
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Button), {
                                className: "AppLogo AppLogo--Small",
                                "data-cy": "appChromeSidebar--openBtn",
                                onClick: toggleSidebar,
                                variant: "no-style",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Logo), {
                                    logomark: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Button), {
                                "data-cy": "appChromeSidebar--closeBtn",
                                className: "AppChrome--Toggle",
                                "aria-label": "Toggle Sidebar",
                                onClick: toggleSidebar,
                                variant: "no-style",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                                    name: angle,
                                    size: [
                                        "17px"
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        children: menu.map(function(s, i) {
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                        className: "LinkList",
                                        children: s.map(function(m, j) {
                                            if (!m.destination || m.destination === "undefined") return null;
                                            if (m.anchor) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    href: m.destination,
                                                    title: m.text,
                                                    "data-cy": "appChromeLink--".concat(m.text),
                                                    className: (0, _classnamesDefault.default)("AppChrome--link", {
                                                        current: m.id === props.selectedModule
                                                    }),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "LinkList-Icon",
                                                            children: m.icon
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "LinkList-Text",
                                                            children: m.text
                                                        })
                                                    ]
                                                })
                                            }, j);
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                                    to: m.destination,
                                                    title: m.text,
                                                    "data-cy": "appChromeLink--".concat(m.text),
                                                    className: (0, _classnamesDefault.default)("AppChrome--link", {
                                                        current: m.id === props.selectedModule
                                                    }),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "LinkList-Icon",
                                                            children: m.icon
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "LinkList-Text",
                                                            children: m.text
                                                        })
                                                    ]
                                                })
                                            }, j);
                                        })
                                    }),
                                    i < menu.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {})
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ipa-version",
                        children: [
                            trialEdition && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "trial",
                                children: sidebarOpen ? "Trial Edition" : "Trial"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "version",
                                children: sidebarOpen ? props.version.full : props.version.abbr
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                className: "AppContents",
                children: props.children
            })
        ]
    });
};

},{"@swc/helpers/_/_to_consumable_array":"94EyK","react/jsx-runtime":"gJK5Y","react":"ktQNc","lodash/get":"03MxF","react-router-dom":"6Au42","classnames":"aMKnv","@indico-data/permafrost":"j9IVt","root/constants/router":"kIAPq","root/store/appStore":"iLlB2","root/hooks/authentication":"9ykWB","./menu":"2J1OI","./AppChrome.styles":"dmYca","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"03MxF":[function(require,module,exports) {
var baseGet = require("33e599b9f2e71a0f");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"33e599b9f2e71a0f":"4UeAw"}],"4UeAw":[function(require,module,exports) {
var castPath = require("ddb71966fa763934"), toKey = require("6071cf58a0166c0a");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"ddb71966fa763934":"jOwzT","6071cf58a0166c0a":"gN21m"}],"jOwzT":[function(require,module,exports) {
var isArray = require("ffb9429eb688412a"), isKey = require("63aa7dac9451c9bf"), stringToPath = require("8a70880283f75bef"), toString = require("e53570dd8a8146a7");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"ffb9429eb688412a":"dEj2n","63aa7dac9451c9bf":"aRz9P","8a70880283f75bef":"dBKzn","e53570dd8a8146a7":"j7yh5"}],"dEj2n":[function(require,module,exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"aRz9P":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var isArray = require("87f8481b86e2b3a4"), isSymbol = require("db679fdd80b0ced7");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"@swc/helpers/_/_type_of":"6Gp9n","87f8481b86e2b3a4":"dEj2n","db679fdd80b0ced7":"6Qguj"}],"6Qguj":[function(require,module,exports) {
var _typeOf = require("@swc/helpers/_/_type_of");
var baseGetTag = require("12c08f38f900359"), isObjectLike = require("b746ac91e08f67ab");
/** `Object#toString` result references. */ var symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value)) == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"@swc/helpers/_/_type_of":"6Gp9n","12c08f38f900359":"cjPCl","b746ac91e08f67ab":"1q1NA"}],"cjPCl":[function(require,module,exports) {
var Symbol = require("38fda4fb8529b0bb"), getRawTag = require("f2dcb70fe4695da6"), objectToString = require("cd219cde05817c85");
/** `Object#toString` result references. */ var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"38fda4fb8529b0bb":"f2UzE","f2dcb70fe4695da6":"8rLSz","cd219cde05817c85":"lFPWS"}],"f2UzE":[function(require,module,exports) {
var root = require("585542d73c2492d7");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"585542d73c2492d7":"4T1TL"}],"4T1TL":[function(require,module,exports) {
var freeGlobal = require("76062ed8a14bd655");
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
module.exports = root;

},{"76062ed8a14bd655":"c93SP"}],"c93SP":[function(require,module,exports) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"8rLSz":[function(require,module,exports) {
var Symbol = require("40627eb2528feee6");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"40627eb2528feee6":"f2UzE"}],"lFPWS":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"1q1NA":[function(require,module,exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = isObjectLike;

},{}],"dBKzn":[function(require,module,exports) {
var memoizeCapped = require("ab0042d029090967");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"ab0042d029090967":"819xt"}],"819xt":[function(require,module,exports) {
var memoize = require("69b4c7fcc0e993cd");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"69b4c7fcc0e993cd":"edJKa"}],"edJKa":[function(require,module,exports) {
var MapCache = require("de9a1c85d40234d5");
/** Error message constants. */ var FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"de9a1c85d40234d5":"ewv4l"}],"ewv4l":[function(require,module,exports) {
var mapCacheClear = require("77bbd365e831ebf7"), mapCacheDelete = require("1fc1fe59228ba659"), mapCacheGet = require("eb3f9c28cd8dbd81"), mapCacheHas = require("20ce10900a21222a"), mapCacheSet = require("85c78bea2dc95e1c");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"77bbd365e831ebf7":"39EMJ","1fc1fe59228ba659":"jX9gL","eb3f9c28cd8dbd81":"8iXzR","20ce10900a21222a":"e8OUW","85c78bea2dc95e1c":"7u8xa"}],"39EMJ":[function(require,module,exports) {
var Hash = require("dbaa266c7412dd4f"), ListCache = require("19400a28364e461c"), Map = require("e92c24e204425f68");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
module.exports = mapCacheClear;

},{"dbaa266c7412dd4f":"8KZfy","19400a28364e461c":"20ESx","e92c24e204425f68":"ikfmi"}],"8KZfy":[function(require,module,exports) {
var hashClear = require("e1181db6ea2a45cd"), hashDelete = require("cc357e16bcd2b5b4"), hashGet = require("fbda7c4f4a9f5730"), hashHas = require("563818c4c6ef88f4"), hashSet = require("66038d6fca7c198a");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"e1181db6ea2a45cd":"ix6vn","cc357e16bcd2b5b4":"7TI13","fbda7c4f4a9f5730":"ceUs2","563818c4c6ef88f4":"2tzLv","66038d6fca7c198a":"bMFBL"}],"ix6vn":[function(require,module,exports) {
var nativeCreate = require("db5d21e5265a1fe");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"db5d21e5265a1fe":"lTOck"}],"lTOck":[function(require,module,exports) {
var getNative = require("c7bf494e4dad5f00");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, "create");
module.exports = nativeCreate;

},{"c7bf494e4dad5f00":"2zfcw"}],"2zfcw":[function(require,module,exports) {
var baseIsNative = require("c7ee418b5facdcbb"), getValue = require("a69b034648d1dc7b");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"c7ee418b5facdcbb":"aeqeD","a69b034648d1dc7b":"gaJJg"}],"aeqeD":[function(require,module,exports) {
var isFunction = require("d51b9bd97c0820ce"), isMasked = require("a408723f425efc3f"), isObject = require("35988de9282dcc95"), toSource = require("ecd775e8707622d2");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"d51b9bd97c0820ce":"hzAmZ","a408723f425efc3f":"jijpB","35988de9282dcc95":"642M8","ecd775e8707622d2":"b1Cbj"}],"hzAmZ":[function(require,module,exports) {
var baseGetTag = require("50cb95bcd654b770"), isObject = require("81629408dc237da8");
/** `Object#toString` result references. */ var asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"50cb95bcd654b770":"cjPCl","81629408dc237da8":"642M8"}],"642M8":[function(require,module,exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return value != null && (type == "object" || type == "function");
}
module.exports = isObject;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"jijpB":[function(require,module,exports) {
var coreJsData = require("5c5980f5be2602bb");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"5c5980f5be2602bb":"4aZfr"}],"4aZfr":[function(require,module,exports) {
var root = require("9c39087d076a3e22");
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
module.exports = coreJsData;

},{"9c39087d076a3e22":"4T1TL"}],"b1Cbj":[function(require,module,exports) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = toSource;

},{}],"gaJJg":[function(require,module,exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"7TI13":[function(require,module,exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"ceUs2":[function(require,module,exports) {
var nativeCreate = require("a95205c1a260d641");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"a95205c1a260d641":"lTOck"}],"2tzLv":[function(require,module,exports) {
var nativeCreate = require("25d3d3593a72153f");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"25d3d3593a72153f":"lTOck"}],"bMFBL":[function(require,module,exports) {
var nativeCreate = require("830e54f364d01d5c");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"830e54f364d01d5c":"lTOck"}],"20ESx":[function(require,module,exports) {
var listCacheClear = require("564359be2656a993"), listCacheDelete = require("132c01521016e9fd"), listCacheGet = require("7fa5e9b5caf884e4"), listCacheHas = require("3a0a014bb0ed218c"), listCacheSet = require("ee657ee7382c99f6");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"564359be2656a993":"c2FeO","132c01521016e9fd":"6fqv3","7fa5e9b5caf884e4":"a6O3v","3a0a014bb0ed218c":"k3S1F","ee657ee7382c99f6":"hm6p7"}],"c2FeO":[function(require,module,exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"6fqv3":[function(require,module,exports) {
var assocIndexOf = require("373dec427be8f765");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"373dec427be8f765":"h92Xx"}],"h92Xx":[function(require,module,exports) {
var eq = require("89ff81611810f54a");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"89ff81611810f54a":"bMmNN"}],"bMmNN":[function(require,module,exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"a6O3v":[function(require,module,exports) {
var assocIndexOf = require("8a4a8f18c04a6e79");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"8a4a8f18c04a6e79":"h92Xx"}],"k3S1F":[function(require,module,exports) {
var assocIndexOf = require("15624a2b848ab5c0");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"15624a2b848ab5c0":"h92Xx"}],"hm6p7":[function(require,module,exports) {
var assocIndexOf = require("64bf34673eb3fd42");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"64bf34673eb3fd42":"h92Xx"}],"ikfmi":[function(require,module,exports) {
var getNative = require("9ba708f7b4cd7ebe"), root = require("878a3ab360ac519c");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map");
module.exports = Map;

},{"9ba708f7b4cd7ebe":"2zfcw","878a3ab360ac519c":"4T1TL"}],"jX9gL":[function(require,module,exports) {
var getMapData = require("c1b53e459d5bbf1");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"c1b53e459d5bbf1":"hdMJX"}],"hdMJX":[function(require,module,exports) {
var isKeyable = require("d9e1e2165fa0a2dc");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = getMapData;

},{"d9e1e2165fa0a2dc":"bzYyZ"}],"bzYyZ":[function(require,module,exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, _typeOf._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = isKeyable;

},{"@swc/helpers/_/_type_of":"6Gp9n"}],"8iXzR":[function(require,module,exports) {
var getMapData = require("acfffcce552ab1b7");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"acfffcce552ab1b7":"hdMJX"}],"e8OUW":[function(require,module,exports) {
var getMapData = require("f99c8521555c7102");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"f99c8521555c7102":"hdMJX"}],"7u8xa":[function(require,module,exports) {
var getMapData = require("8d35910af1aea6af");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"8d35910af1aea6af":"hdMJX"}],"j7yh5":[function(require,module,exports) {
var baseToString = require("232a3645740da3cf");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
module.exports = toString;

},{"232a3645740da3cf":"fvQbg"}],"fvQbg":[function(require,module,exports) {
var Symbol = require("533b51ad0cc51789"), arrayMap = require("d569333368fbc28e"), isArray = require("1ad54c9c2d5bf784"), isSymbol = require("ac021c0546090d5a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + "";
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = baseToString;

},{"533b51ad0cc51789":"f2UzE","d569333368fbc28e":"asbbC","1ad54c9c2d5bf784":"dEj2n","ac021c0546090d5a":"6Qguj"}],"asbbC":[function(require,module,exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"gN21m":[function(require,module,exports) {
var isSymbol = require("11c37106c9c565d5");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
module.exports = toKey;

},{"11c37106c9c565d5":"6Qguj"}],"kIAPq":[function(require,module,exports) {
// Base
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_AUTH", function() {
    return BASE_AUTH;
});
parcelHelpers.export(exports, "BASE_CROWDLABEL", function() {
    return BASE_CROWDLABEL;
});
parcelHelpers.export(exports, "BASE_DATASETS", function() {
    return BASE_DATASETS;
});
parcelHelpers.export(exports, "BASE_MOONBOW", function() {
    return BASE_MOONBOW;
});
parcelHelpers.export(exports, "BASE_SUNBOW", function() {
    return BASE_SUNBOW;
});
parcelHelpers.export(exports, "BASE_CLOUDBURST", function() {
    return BASE_CLOUDBURST;
});
parcelHelpers.export(exports, "BASE_ADMIN", function() {
    return BASE_ADMIN;
});
parcelHelpers.export(exports, "BASE_NO_ACCESS", function() {
    return BASE_NO_ACCESS;
});
parcelHelpers.export(exports, "BASE_ZEPHYR", function() {
    return BASE_ZEPHYR;
});
parcelHelpers.export(exports, "BASE_PROMPT_STUDIO", function() {
    return BASE_PROMPT_STUDIO;
});
parcelHelpers.export(exports, "AUTH_CHANGE_PASSWORD", function() {
    return AUTH_CHANGE_PASSWORD;
});
parcelHelpers.export(exports, "AUTH_CONFIRM_ACCOUNT", function() {
    return AUTH_CONFIRM_ACCOUNT;
});
parcelHelpers.export(exports, "AUTH_FORGOT", function() {
    return AUTH_FORGOT;
});
parcelHelpers.export(exports, "AUTH_REGISTER", function() {
    return AUTH_REGISTER;
});
parcelHelpers.export(exports, "AUTH_ACCOUNT", function() {
    return AUTH_ACCOUNT;
});
parcelHelpers.export(exports, "AUTH_LOGOUT", function() {
    return AUTH_LOGOUT;
});
parcelHelpers.export(exports, "AUTH_SSO_LOGIN", function() {
    return AUTH_SSO_LOGIN;
});
parcelHelpers.export(exports, "ADMIN_REPORTS", function() {
    return ADMIN_REPORTS;
});
parcelHelpers.export(exports, "DATASETS_DETAILS", function() {
    return DATASETS_DETAILS;
});
parcelHelpers.export(exports, "DATASET_NEW", function() {
    return DATASET_NEW;
});
parcelHelpers.export(exports, "DATASETS_EXAMPLES_LIST", function() {
    return DATASETS_EXAMPLES_LIST;
});
parcelHelpers.export(exports, "GET_DATASET_TEAM", function() {
    return GET_DATASET_TEAM;
});
parcelHelpers.export(exports, "GET_DATASET_FILES", function() {
    return GET_DATASET_FILES;
});
parcelHelpers.export(exports, "GET_DATASET_SETTINGS", function() {
    return GET_DATASET_SETTINGS;
});
parcelHelpers.export(exports, "GET_DATASET_EXAMPLES", function() {
    return GET_DATASET_EXAMPLES;
});
parcelHelpers.export(exports, "GALLERY_DETAILS", function() {
    return GALLERY_DETAILS;
});
parcelHelpers.export(exports, "GALLERY_ADD_NEW", function() {
    return GALLERY_ADD_NEW;
});
parcelHelpers.export(exports, "GET_GALLERY_DETAIL", function() {
    return GET_GALLERY_DETAIL;
});
parcelHelpers.export(exports, "GET_GALLERY_DETAIL_ADD_NEW", function() {
    return GET_GALLERY_DETAIL_ADD_NEW;
});
parcelHelpers.export(exports, "CROWDLABEL_TASKS_DETAILS", function() {
    return CROWDLABEL_TASKS_DETAILS;
});
parcelHelpers.export(exports, "CROWDLABEL_LABELING", function() {
    return CROWDLABEL_LABELING;
});
parcelHelpers.export(exports, "CROWDLABEL_LABELING_SINGLE", function() {
    return CROWDLABEL_LABELING_SINGLE;
});
parcelHelpers.export(exports, "CROWDLABEL_SUMMARIZATION_STUDIO", function() {
    return CROWDLABEL_SUMMARIZATION_STUDIO;
});
parcelHelpers.export(exports, "CROWDLABEL_EXTRACTION_STUDIO", function() {
    return CROWDLABEL_EXTRACTION_STUDIO;
});
parcelHelpers.export(exports, "CROWDLABEL_CLASSIFICATION_STUDIO", function() {
    return CROWDLABEL_CLASSIFICATION_STUDIO;
});
parcelHelpers.export(exports, "GET_CROWDLABEL_DETAILS", function() {
    return GET_CROWDLABEL_DETAILS;
});
parcelHelpers.export(exports, "GET_CROWDLABEL_LABELING", function() {
    return GET_CROWDLABEL_LABELING;
});
parcelHelpers.export(exports, "GET_CROWDLABEL_LABELING_SINGLE", function() {
    return GET_CROWDLABEL_LABELING_SINGLE;
});
parcelHelpers.export(exports, "GET_SUMMARIZATION_STUDIO", function() {
    return GET_SUMMARIZATION_STUDIO;
});
parcelHelpers.export(exports, "GET_EXTRACTION_STUDIO", function() {
    return GET_EXTRACTION_STUDIO;
});
parcelHelpers.export(exports, "GET_CLASSIFICATION_STUDIO", function() {
    return GET_CLASSIFICATION_STUDIO;
});
parcelHelpers.export(exports, "GET_PROMPT_STUDIO", function() {
    return GET_PROMPT_STUDIO;
});
parcelHelpers.export(exports, "MOONBOW_DETAILS", function() {
    return MOONBOW_DETAILS;
});
parcelHelpers.export(exports, "GET_MOONBOW_NEW", function() {
    return GET_MOONBOW_NEW;
});
parcelHelpers.export(exports, "GET_MOONBOW_DETAILS", function() {
    return GET_MOONBOW_DETAILS;
});
parcelHelpers.export(exports, "GET_MOONBOW_PERFORMANCE", function() {
    return GET_MOONBOW_PERFORMANCE;
});
parcelHelpers.export(exports, "GET_MOONBOW_BALANCE", function() {
    return GET_MOONBOW_BALANCE;
});
parcelHelpers.export(exports, "GET_MOONBOW_TRAINING", function() {
    return GET_MOONBOW_TRAINING;
});
parcelHelpers.export(exports, "REVIEW_QUEUE", function() {
    return REVIEW_QUEUE;
});
parcelHelpers.export(exports, "EXCEPTIONS_QUEUE", function() {
    return EXCEPTIONS_QUEUE;
});
parcelHelpers.export(exports, "SINGLE_REVIEW_QUEUE", function() {
    return SINGLE_REVIEW_QUEUE;
});
parcelHelpers.export(exports, "SINGLE_EXCEPTIONS_QUEUE", function() {
    return SINGLE_EXCEPTIONS_QUEUE;
});
parcelHelpers.export(exports, "SINGLE_SUNBOW_QUEUE_SUCCESS", function() {
    return SINGLE_SUNBOW_QUEUE_SUCCESS;
});
parcelHelpers.export(exports, "GET_REVIEW_QUEUE", function() {
    return GET_REVIEW_QUEUE;
});
parcelHelpers.export(exports, "GET_EXCEPTIONS_QUEUE", function() {
    return GET_EXCEPTIONS_QUEUE;
});
parcelHelpers.export(exports, "GET_SINGLE_EXCEPTIONS_QUEUE", function() {
    return GET_SINGLE_EXCEPTIONS_QUEUE;
});
parcelHelpers.export(exports, "GET_SINGLE_REVIEW_QUEUE", function() {
    return GET_SINGLE_REVIEW_QUEUE;
});
parcelHelpers.export(exports, "GET_SINGLE_SUNBOW_QUEUE_SUCCESS", function() {
    return GET_SINGLE_SUNBOW_QUEUE_SUCCESS;
});
parcelHelpers.export(exports, "WORKFLOW_ADD_NEW", function() {
    return WORKFLOW_ADD_NEW;
});
parcelHelpers.export(exports, "WORKFLOW_DETAILS", function() {
    return WORKFLOW_DETAILS;
});
parcelHelpers.export(exports, "WORKFLOW_SUBMISSIONS_LIST", function() {
    return WORKFLOW_SUBMISSIONS_LIST;
});
parcelHelpers.export(exports, "GET_WORKFLOW_CANVAS", function() {
    return GET_WORKFLOW_CANVAS;
});
parcelHelpers.export(exports, "GET_WORKFLOW_SETTINGS", function() {
    return GET_WORKFLOW_SETTINGS;
});
parcelHelpers.export(exports, "GET_WORKFLOW_METRICS", function() {
    return GET_WORKFLOW_METRICS;
});
parcelHelpers.export(exports, "GET_WORKFLOW_SUBMISSIONS", function() {
    return GET_WORKFLOW_SUBMISSIONS;
});
parcelHelpers.export(exports, "SORT", function() {
    return SORT;
});
parcelHelpers.export(exports, "SORT_DIRECTION", function() {
    return SORT_DIRECTION;
});
parcelHelpers.export(exports, "ASCENDING", function() {
    return ASCENDING;
});
parcelHelpers.export(exports, "DESCENDING", function() {
    return DESCENDING;
});
parcelHelpers.export(exports, "FILTER", function() {
    return FILTER;
});
parcelHelpers.export(exports, "FIELD_FILTER", function() {
    return FIELD_FILTER;
});
parcelHelpers.export(exports, "CLASSIFICATION", function() {
    return CLASSIFICATION;
});
parcelHelpers.export(exports, "FIELD_ID", function() {
    return FIELD_ID;
});
parcelHelpers.export(exports, "TARGET_ID", function() {
    return TARGET_ID;
});
parcelHelpers.export(exports, "urlParams", function() {
    return urlParams;
});
var BASE_AUTH = "/auth";
var BASE_CROWDLABEL = "/teach";
var BASE_DATASETS = "/datasets";
var BASE_MOONBOW = "/explain";
var BASE_SUNBOW = "/review";
var BASE_CLOUDBURST = "/workflows";
var BASE_ADMIN = "/admin";
var BASE_NO_ACCESS = "/no_access";
var BASE_ZEPHYR = "/gallery";
var BASE_PROMPT_STUDIO = "/prompt-studio";
var AUTH_CHANGE_PASSWORD = "".concat(BASE_AUTH, "/change_password");
var AUTH_CONFIRM_ACCOUNT = "".concat(BASE_AUTH, "/confirm_account");
var AUTH_FORGOT = "".concat(BASE_AUTH, "/forgot");
var AUTH_REGISTER = "".concat(BASE_AUTH, "/register");
var AUTH_ACCOUNT = "".concat(BASE_AUTH, "/account");
var AUTH_LOGOUT = "".concat(BASE_AUTH, "/logout");
var AUTH_SSO_LOGIN = "".concat(BASE_AUTH, "/users/saml/sso");
var ADMIN_REPORTS = "/reports";
var DATASETS_DETAILS = "".concat(BASE_DATASETS, "/:datasetId/:detail");
var DATASET_NEW = "".concat(BASE_DATASETS, "/new");
var DATASETS_EXAMPLES_LIST = "".concat(BASE_DATASETS, "/:datasetId/models/:modelGroupId/examples");
var GET_DATASET_TEAM = function(datasetId) {
    return "".concat(BASE_DATASETS, "/").concat(datasetId, "/team");
};
var GET_DATASET_FILES = function(datasetId) {
    return "".concat(BASE_DATASETS, "/").concat(datasetId, "/files");
};
var GET_DATASET_SETTINGS = function(datasetId) {
    return "".concat(BASE_DATASETS, "/").concat(datasetId, "/settings");
};
var GET_DATASET_EXAMPLES = function(datasetId, modelGroupId) {
    return "".concat(BASE_DATASETS, "/").concat(datasetId, "/models/").concat(modelGroupId, "/examples");
};
var GALLERY_DETAILS = "".concat(BASE_ZEPHYR, "/:detail");
var GALLERY_ADD_NEW = "".concat(BASE_ZEPHYR, "/:detail/new");
var GET_GALLERY_DETAIL = function(param) {
    var detail = param.detail;
    return "".concat(BASE_ZEPHYR, "/").concat(detail);
};
var GET_GALLERY_DETAIL_ADD_NEW = function(param) {
    var detail = param.detail;
    return "".concat(BASE_ZEPHYR, "/").concat(detail, "/new");
};
var CROWDLABEL_TASKS_DETAILS = "".concat(BASE_CROWDLABEL, "/:questionnaireId");
var CROWDLABEL_LABELING = "".concat(BASE_CROWDLABEL, "/labeling/:questionnaireId");
var CROWDLABEL_LABELING_SINGLE = "".concat(BASE_CROWDLABEL, "/example/:modelId/:exampleId/:datafileId?");
var CROWDLABEL_SUMMARIZATION_STUDIO = "".concat(BASE_CROWDLABEL, "/summarization/:questionnaireId");
var CROWDLABEL_EXTRACTION_STUDIO = "".concat(BASE_CROWDLABEL, "/extraction-studio/:questionnaireId");
var CROWDLABEL_CLASSIFICATION_STUDIO = "".concat(BASE_CROWDLABEL, "/classification-studio/:questionnaireId");
var GET_CROWDLABEL_DETAILS = function(param) {
    var questionnaireId = param.questionnaireId;
    return "".concat(BASE_CROWDLABEL, "/").concat(questionnaireId);
};
var GET_CROWDLABEL_LABELING = function(param) {
    var questionnaireId = param.questionnaireId;
    return "".concat(BASE_CROWDLABEL, "/labeling/").concat(questionnaireId);
};
var GET_CROWDLABEL_LABELING_SINGLE = function(param) {
    var modelGroupId = param.modelGroupId, exampleId = param.exampleId, datafileId = param.datafileId;
    return "".concat(BASE_CROWDLABEL, "/example/").concat(modelGroupId, "/").concat(exampleId).concat(datafileId ? "/".concat(datafileId) : "");
};
var GET_SUMMARIZATION_STUDIO = function(param) {
    var questionnaireId = param.questionnaireId;
    return "".concat(BASE_CROWDLABEL, "/summarization/").concat(questionnaireId);
};
var GET_EXTRACTION_STUDIO = function(param) {
    var questionnaireId = param.questionnaireId;
    return "".concat(BASE_CROWDLABEL, "/extraction-studio/").concat(questionnaireId);
};
var GET_CLASSIFICATION_STUDIO = function(param) {
    var questionnaireId = param.questionnaireId;
    return "".concat(BASE_CROWDLABEL, "/classification-studio/").concat(questionnaireId);
};
var GET_PROMPT_STUDIO = function(param) {
    var modelGroupId = param.modelGroupId;
    return "".concat(BASE_PROMPT_STUDIO, "/").concat(modelGroupId);
};
var MOONBOW_DETAILS = "".concat(BASE_MOONBOW, "/datasets/:datasetId/models/:modelGroupId/:detail");
var GET_MOONBOW_NEW = function(param) {
    var datasetId = param.datasetId;
    return "".concat(BASE_MOONBOW, "/datasets/").concat(datasetId, "/models/new");
};
var GET_MOONBOW_DETAILS = function(param) {
    var datasetId = param.datasetId, modelGroupId = param.modelGroupId, detail = param.detail;
    return "".concat(BASE_MOONBOW, "/datasets/").concat(datasetId, "/models/").concat(modelGroupId, "/").concat(detail);
};
var GET_MOONBOW_PERFORMANCE = function(param) {
    var datasetId = param.datasetId, modelGroupId = param.modelGroupId;
    return "".concat(BASE_MOONBOW, "/datasets/").concat(datasetId, "/models/").concat(modelGroupId, "/performance");
};
var GET_MOONBOW_BALANCE = function(param) {
    var datasetId = param.datasetId, modelGroupId = param.modelGroupId;
    return "".concat(BASE_MOONBOW, "/datasets/").concat(datasetId, "/models/").concat(modelGroupId, "/balance");
};
var GET_MOONBOW_TRAINING = function(param) {
    var datasetId = param.datasetId, modelGroupId = param.modelGroupId;
    return "".concat(BASE_MOONBOW, "/datasets/").concat(datasetId, "/models/").concat(modelGroupId, "/training");
};
var REVIEW_QUEUE = "".concat(BASE_SUNBOW, "/queues/:workflowId");
var EXCEPTIONS_QUEUE = "".concat(BASE_SUNBOW, "/exceptions/:workflowId");
var SINGLE_REVIEW_QUEUE = "".concat(BASE_SUNBOW, "/queues/:workflowId/submission/:submissionId/:inputFileId?");
var SINGLE_EXCEPTIONS_QUEUE = "".concat(BASE_SUNBOW, "/exceptions/:workflowId/submission/:submissionId");
var SINGLE_SUNBOW_QUEUE_SUCCESS = "".concat(BASE_SUNBOW, "/queues/:workflowId/submission/:submissionId/success");
var GET_REVIEW_QUEUE = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_SUNBOW, "/queues/").concat(workflowId);
};
var GET_EXCEPTIONS_QUEUE = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_SUNBOW, "/exceptions/").concat(workflowId);
};
var GET_SINGLE_EXCEPTIONS_QUEUE = function(param) {
    var workflowId = param.workflowId, submissionId = param.submissionId;
    return "".concat(BASE_SUNBOW, "/exceptions/").concat(workflowId, "/submission/").concat(submissionId);
};
var GET_SINGLE_REVIEW_QUEUE = function(param) {
    var workflowId = param.workflowId, submissionId = param.submissionId, inputFileId = param.inputFileId;
    return "".concat(BASE_SUNBOW, "/queues/").concat(workflowId, "/submission/").concat(submissionId).concat(inputFileId ? "/".concat(inputFileId) : "");
};
var GET_SINGLE_SUNBOW_QUEUE_SUCCESS = function(param) {
    var workflowId = param.workflowId, submissionId = param.submissionId;
    return "".concat(BASE_SUNBOW, "/queues/").concat(workflowId, "/submission/").concat(submissionId, "/success");
};
var WORKFLOW_ADD_NEW = "".concat(BASE_CLOUDBURST, "/new");
var WORKFLOW_DETAILS = "".concat(BASE_CLOUDBURST, "/:workflowId/details/:detail");
var WORKFLOW_SUBMISSIONS_LIST = "".concat(BASE_CLOUDBURST, "/:workflowId/submissions");
var GET_WORKFLOW_CANVAS = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_CLOUDBURST, "/").concat(workflowId, "/details/canvas");
};
var GET_WORKFLOW_SETTINGS = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_CLOUDBURST, "/").concat(workflowId, "/details/settings");
};
var GET_WORKFLOW_METRICS = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_CLOUDBURST, "/").concat(workflowId, "/details/analytics");
};
var GET_WORKFLOW_SUBMISSIONS = function(param) {
    var workflowId = param.workflowId;
    return "".concat(BASE_CLOUDBURST, "/").concat(workflowId, "/submissions");
};
var SORT = "sort";
var SORT_DIRECTION = "sortDirection";
var ASCENDING = "asc";
var DESCENDING = "desc";
var FILTER = "filter";
var FIELD_FILTER = "fieldFilter";
var CLASSIFICATION = "classification";
var FIELD_ID = "fieldId";
var TARGET_ID = "targetId";
var urlParams = {
    sort: SORT,
    sortDirection: SORT_DIRECTION,
    filters: FILTER,
    fieldFilters: FIELD_FILTER,
    classifications: CLASSIFICATION,
    fieldId: FIELD_ID,
    targetId: TARGET_ID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"iLlB2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "store", function() {
    return store;
});
parcelHelpers.export(exports, "useAppStore", function() {
    return useAppStore;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@indico-data/utils");
var initialState = {
    currentLocation: null,
    previousLocation: null,
    routeError: "",
    sidebarOpen: true
};
var store = function(set, get) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, initialState), {
        setLocation: function(previousLocation, currentLocation) {
            return set(function() {
                return {
                    previousLocation: previousLocation,
                    currentLocation: currentLocation
                };
            });
        },
        setRouteError: function(value) {
            return set(function() {
                return {
                    routeError: value
                };
            });
        },
        toggleSidebar: function() {
            var current = get().sidebarOpen;
            set(function() {
                return {
                    sidebarOpen: !current
                };
            });
        },
        closeSidebar: function() {
            return set(function() {
                return {
                    sidebarOpen: false
                };
            });
        },
        resetAppStoreState: function() {
            return set(function() {
                return initialState;
            });
        }
    });
};
var useAppStore = (0, _utils.zustandUtils).createStore(store);

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@indico-data/utils":"47VRj","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"9ykWB":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCurrentUser", function() {
    return useCurrentUser;
});
parcelHelpers.export(exports, "useAuthLoading", function() {
    return useAuthLoading;
});
parcelHelpers.export(exports, "useXSRFToken", function() {
    return useXSRFToken;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _authActions = require("Auth/actions/auth-actions");
var _userContext = require("root/store/userContext");
var _userContextDefault = parcelHelpers.interopDefault(_userContext);
var useCurrentUser = function() {
    var _useContext;
    return ((_useContext = (0, _react.useContext)((0, _userContextDefault.default))) === null || _useContext === void 0 ? void 0 : _useContext[0].user) || null;
};
var useAuthLoading = function() {
    var _useContext;
    return (_useContext = (0, _react.useContext)((0, _userContextDefault.default))) === null || _useContext === void 0 ? void 0 : _useContext[0].loading;
};
var useXSRFToken = function(callback) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(""), 2), token = _useState[0], setToken = _useState[1];
    // On component mount, a request is made for the XSRFToken
    (0, _react.useEffect)(function() {
        var abortController = new AbortController();
        var signal = abortController.signal;
        (0, _authActions.getXSRFToken)(signal).then(function(token) {
            setToken(token);
            if (callback) callback(token);
        });
        return function() {
            abortController.abort();
        };
    }, []);
    return token;
};

},{"@swc/helpers/_/_sliced_to_array":"gML59","react":"ktQNc","Auth/actions/auth-actions":"Ykv2h","root/store/userContext":"fgLOo","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"2J1OI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APP_CHROME_MENU", function() {
    return APP_CHROME_MENU;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _get = require("lodash/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _permafrost = require("@indico-data/permafrost");
var _router = require("root/constants/router");
var APP_CHROME_MENU = [
    [
        {
            id: "DATASETS_APP",
            text: "Datasets",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "data-and-access"
            }),
            destination: _router.BASE_DATASETS,
            anchor: false
        },
        {
            id: "CLOUDBURST_APP",
            text: "Workflows",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "workflows"
            }),
            destination: _router.BASE_CLOUDBURST,
            anchor: false
        },
        {
            id: "CROWDLABEL_APP",
            text: "Agents",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "crowdlabel"
            }),
            destination: _router.BASE_CROWDLABEL,
            anchor: false
        },
        // {
        //   id: 'MOONBOW_APP',
        //   text: 'Explain',
        //   icon: <Icon name="moonbow" />,
        //   destination: ROUTES.BASE_MOONBOW,
        //   anchor: false,
        // },
        {
            id: "SUNBOW_APP",
            text: "Queues",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "repair"
            }),
            destination: _router.BASE_SUNBOW,
            anchor: false
        }
    ],
    [
        {
            id: "NOCT_APP",
            text: "Account",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "account"
            }),
            destination: _router.AUTH_ACCOUNT,
            anchor: false
        },
        {
            id: "API_DOCS_APP",
            text: "API Documentation",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "api-doc"
            }),
            destination: (0, _getDefault.default)(window, "indico.appURLs.DocsURL"),
            anchor: true
        },
        {
            id: "HELP_APP",
            text: "Knowledge Base",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Icon), {
                name: "help"
            }),
            destination: (0, _getDefault.default)(window, "indico.appURLs.HelpURL"),
            anchor: true
        }
    ]
];

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","lodash/get":"03MxF","@indico-data/permafrost":"j9IVt","root/constants/router":"kIAPq","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"dmYca":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAppChrome", function() {
    return StyledAppChrome;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _permafrost = require("@indico-data/permafrost");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  width: 100%;\n  height: 100%;\n  .AppNavigation {\n    background-color: var(",
        ");\n\n    width: ",
        ";\n    overflow: hidden;\n    transition: width ",
        " ease-out, padding ",
        " ease-out;\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    padding-top: 20px;\n    z-index: 500;\n\n    .AppBranding {\n      display: flex;\n      align-items: start;\n      justify-content: space-between;\n\n      padding-left: ",
        ";\n      padding-bottom: ",
        ";\n\n      .AppChrome--Toggle svg {\n        margin-top: 2px;\n        color: ",
        ";\n      }\n    }\n\n    .AppBranding,\n    nav {\n      padding-right: ",
        ";\n      padding-left: ",
        ";\n    }\n\n    hr {\n      border-bottom: 1px solid ",
        ";\n    }\n\n    .LinkList {\n      li {\n        margin-bottom: 20px;\n        line-height: 0; // tightens up the space at the bottom of the container\n      }\n\n      .LinkList-Icon svg {\n        width: ",
        ";\n        height: ",
        ";\n\n        path {\n          fill: ",
        ";\n        }\n      }\n\n      .LinkList-Text {\n        display: inline-block;\n        font-size: 14px;\n        margin-left: 10px;\n        color: ",
        ";\n        opacity: 1;\n        transition: width ",
        " ease-out, opacity ",
        " ease-out;\n        vertical-align: top;\n        padding-top: 5px;\n        line-height: 1;\n      }\n\n      .AppChrome--link {\n        display: inline-block;\n        text-transform: uppercase;\n        white-space: nowrap;\n      }\n\n      .AppChrome--link:hover,\n      .AppChrome--link.current {\n        .LinkList-Icon {\n          path {\n            fill: var(",
        ");\n          }\n        }\n\n        .LinkList-Text {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n\n  .AppContents {\n    display: block;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding-left: ",
        ";\n    transition: padding ",
        " ease-out;\n\n    @media ",
        " {\n      padding-left: ",
        ";\n    }\n  }\n\n  .ipa-version {\n    position: absolute;\n    bottom: 20px;\n    margin-left: ",
        ";\n\n    font-size: ",
        ";\n    text-transform: uppercase;\n\n    .trial {\n      margin-right: 6px;\n\n      color: var(",
        ");\n    }\n\n    .version {\n      color: ",
        ";\n    }\n  }\n\n  &.closed {\n    .AppNavigation {\n      width: ",
        ";\n\n      .AppLogo {\n        margin-left: -1px;\n      }\n\n      .AppLogoCollapsed {\n        display: inline-block;\n      }\n\n      .LinkList .LinkList-Text {\n        opacity: 0;\n      }\n    }\n\n    .AppChrome--Toggle svg {\n      opacity: 0;\n    }\n\n    .ipa-version {\n      margin-left: 8px;\n      font-size: 11px;\n      text-align: center;\n\n      .trial {\n        display: block;\n        margin-right: initial;\n      }\n    }\n\n    .AppBranding,\n    nav {\n      padding-left: 13px;\n      padding-right: 13px;\n    }\n\n    .AppContents {\n      padding-left: ",
        " !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var navWidthOpen = "240px";
var navWidthClosed = "50px";
var navPadding = "30px";
var navTextColor = (0, _permafrost.COLORS).baliHai;
var navActiveTextColor = (0, _permafrost.COLORS).hiliteFontColor;
var navActiveIconColor = (0, _permafrost.colorProperties).logoPrimary;
var hrColor = "#2b3c4c";
var navDuration = "250ms";
var navIconSize = "25px";
var StyledAppChrome = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _permafrost.colorProperties).menuBackground, navWidthOpen, navDuration, navDuration, navPadding, navPadding, navTextColor, navPadding, navPadding, hrColor, navIconSize, navIconSize, navTextColor, navTextColor, navDuration, navDuration, navActiveIconColor, navActiveTextColor, navWidthClosed, navDuration, (0, _permafrost.MEDIA_QUERIES).largeScreen, navWidthOpen, navPadding, (0, _permafrost.TYPOGRAPHY).fontSize.base, (0, _permafrost.colorProperties).textHighlight, (0, _permafrost.COLORS).blueBayoux, navWidthClosed, navWidthClosed);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/permafrost":"j9IVt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"lvKkv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledPageContainer", function() {
    return StyledPageContainer;
});
parcelHelpers.export(exports, "StyledDetailPageContainer", function() {
    return StyledDetailPageContainer;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _permafrost = require("@indico-data/permafrost");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  .container {\n    margin: 0 10px;\n\n    @media ",
        " {\n      margin: 20px 50px;\n      padding-bottom: 20px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  height: 100%;\n  box-sizing: border-box;\n\n  .container {\n    box-sizing: border-box;\n    margin: 20px;\n    height: calc(100% - 20px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPageContainer = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _permafrost.MEDIA_QUERIES).mediumScreen);
var StyledDetailPageContainer = (0, _styledComponentsDefault.default).div(_templateObject1());

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/permafrost":"j9IVt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"a6xMC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withToast", function() {
    return withToast;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _toastsList = require("./ToastsList");
var withToast = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toastsList.ToastsContext).Consumer, {
            children: function(param) {
                var addToast = param.addToast;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedComponent, (0, _objectSpread._)({
                    addToast: addToast
                }, props));
            }
        });
    };
};
exports.default = withToast;

},{"@swc/helpers/_/_object_spread":"6U9Ts","react/jsx-runtime":"gJK5Y","react":"ktQNc","./ToastsList":"hGEPF","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"j6AFZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _isNull = require("lodash/isNull");
var _isNullDefault = parcelHelpers.interopDefault(_isNull);
var _reactIdleTimer = require("react-idle-timer");
var _reactIdleTimerDefault = parcelHelpers.interopDefault(_reactIdleTimer);
var _router = require("root/constants/router");
var _loginFailed = require("Auth/pages/LoginFailed/LoginFailed");
var _loginFailedDefault = parcelHelpers.interopDefault(_loginFailed);
var _pageContainer = require("root/components/PageContainer");
var _appStore = require("root/store/appStore");
var _authentication = require("root/hooks/authentication");
var appStoreSelector = function(state) {
    return {
        previousLocation: state.previousLocation,
        currentLocation: state.currentLocation
    };
};
var PrivateRoute = function(props) {
    var _window_indico;
    var redirect = props.redirect, Component = props.component, loginError = props.loginError, rest = (0, _objectWithoutProperties._)(props, [
        "redirect",
        "component",
        "loginError"
    ]);
    var _useAppStore = (0, _appStore.useAppStore)(appStoreSelector), previousLocation = _useAppStore.previousLocation, currentLocation = _useAppStore.currentLocation;
    var idleTimer = (0, _react.useRef)();
    var currentUser = (0, _authentication.useCurrentUser)();
    var authLoading = (0, _authentication.useAuthLoading)();
    (0, _react.useEffect)(function() {
        if ((0, _isNullDefault.default)(currentUser)) props.resetRedirect(props.location);
    }, []);
    var handleOnIdle = function() {
        props.history.push(_router.AUTH_LOGOUT);
    };
    var scope = currentUser && currentUser.scopes.map(function(s) {
        return s.scope.toUpperCase();
    });
    var appAccess = scope && scope.includes("APP_ACCESS");
    if ((currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.pathname) && (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname) && (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.pathname) !== (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname) && ((_window_indico = window.indico) === null || _window_indico === void 0 ? void 0 : _window_indico.appcuesAccountId)) {
        var _window_Appcues, _window_Appcues1;
        (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.page();
        if (currentUser) (_window_Appcues1 = window.Appcues) === null || _window_Appcues1 === void 0 ? void 0 : _window_Appcues1.identify("".concat(currentUser.uuid), {
            id: currentUser.id,
            email: currentUser.email,
            name: currentUser.name
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        render: function(props) {
            if (loginError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageContainer.PageContainer), {
                module: "",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginFailedDefault.default), {})
            });
            else if (redirect.pathname && (0, _isNullDefault.default)(currentUser)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: "/"
            });
            else if (authLoading || !currentUser) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageContainer.PageContainer), {
                module: ""
            });
            else if (!(0, _isNullDefault.default)(currentUser) && !appAccess) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: _router.BASE_NO_ACCESS
            });
            else return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    window.indico.features.inactivityTimeout && currentUser && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactIdleTimerDefault.default), {
                        ref: idleTimer,
                        timeout: window.indico.featuresConfig.inactivityTimeout || 600000,
                        onIdle: handleOnIdle,
                        debounce: 250
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpread._)({}, props))
                ]
            });
        }
    }));
};
exports.default = (0, _reactRouterDom.withRouter)(PrivateRoute);

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","@swc/helpers/_/_object_without_properties":"ghPIz","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","lodash/isNull":"fNCEJ","react-idle-timer":"594fI","root/constants/router":"kIAPq","Auth/pages/LoginFailed/LoginFailed":"hr8si","root/components/PageContainer":"1105M","root/store/appStore":"iLlB2","root/hooks/authentication":"9ykWB","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"594fI":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIdleTimer", function() {
    return b;
});
var _typeOf = require("@swc/helpers/_/_type_of");
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
function r(e) {
    return (r = "function" == typeof Symbol && "symbol" == (0, _typeOf._)(Symbol.iterator) ? function r(e) {
        return typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e);
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : (0, _typeOf._)(e);
    })(e);
}
function i(e, t) {
    for(var n = 0; n < t.length; n++){
        var _$o = t[n];
        _$o.enumerable = _$o.enumerable || !1, _$o.configurable = !0, "value" in _$o && (_$o.writable = !0), Object.defineProperty(e, _$o.key, _$o);
    }
}
function u(e) {
    return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function u(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
}
function c(e, t) {
    return (c = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function s(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function a(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? s(e) : t;
}
function l(e) {
    var t = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
        } catch (e) {
            return !1;
        }
    }();
    return function() {
        var n, _$o = u(e);
        if (t) {
            var _$r = u(this).constructor;
            n = Reflect.construct(_$o, arguments, _$r);
        } else n = _$o.apply(this, arguments);
        return a(this, n);
    };
}
var d = "object" === ("undefined" == typeof window || "undefined" == typeof window ? "undefined" : r(window)), f = d ? document : {}, v = [
    "mousemove",
    "keydown",
    "wheel",
    "DOMMouseScroll",
    "mouseWheel",
    "mousedown",
    "touchstart",
    "touchmove",
    "MSPointerDown",
    "MSPointerMove",
    "visibilitychange"
];
function p(e, t) {
    var n;
    return function() {
        for(var _$o = arguments.length, _$r = new Array(_$o), i = 0; i < _$o; i++)_$r[i] = arguments[i];
        n && clearTimeout(n), n = setTimeout(function() {
            e.apply(void 0, _$r), n = null;
        }, t);
    };
}
function h(e, t) {
    var n = 0;
    return function() {
        var _$o = (new Date).getTime();
        if (!(_$o - n < t)) return n = _$o, e.apply(void 0, arguments);
    };
}
var m = function(t) {
    !function(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), t && c(e, t);
    }(a, (0, _react.Component));
    var n, _$o, _$r, u = l(a);
    function a(e) {
        var t;
        if (function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), (t = u.call(this, e)).state = {
            idle: !1,
            oldDate: +new Date,
            lastActive: +new Date,
            remaining: null,
            pageX: null,
            pageY: null
        }, t.tId = null, t.eventsBound = !1, e.debounce > 0 && e.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
        return e.debounce > 0 ? t._onAction = p(e.onAction, e.debounce) : e.throttle > 0 ? t._onAction = h(e.onAction, e.throttle) : e.onAction ? t._onAction = e.onAction : t._onAction = function() {}, e.eventsThrottle > 0 ? t._handleEvent = h(t._handleEvent.bind(s(t)), e.eventsThrottle) : t._handleEvent = t._handleEvent.bind(s(t)), e.startOnMount || (t.state.idle = !0), t._toggleIdleState = t._toggleIdleState.bind(s(t)), t.reset = t.reset.bind(s(t)), t.pause = t.pause.bind(s(t)), t.resume = t.resume.bind(s(t)), t.getRemainingTime = t.getRemainingTime.bind(s(t)), t.getElapsedTime = t.getElapsedTime.bind(s(t)), t.getLastActiveTime = t.getLastActiveTime.bind(s(t)), t.isIdle = t.isIdle.bind(s(t)), t;
    }
    return n = a, _$o = [
        {
            key: "componentDidMount",
            value: function value() {
                this._bindEvents(), this.props.startOnMount && this.reset();
            }
        },
        {
            key: "componentDidUpdate",
            value: function value(e) {
                e.debounce !== this.props.debounce && (this._onAction = p(this._onAction, this.props.debounce)), e.throttle !== this.props.throttle && (this._onAction = h(this._onAction, this.props.throttle)), e.eventsThrottle !== this.props.eventsThrottle && (this._handleEvent = h(this._handleEvent, this.props.eventsThrottle));
            }
        },
        {
            key: "componentWillUnmount",
            value: function value() {
                clearTimeout(this.tId), this._unbindEvents(!0);
            }
        },
        {
            key: "render",
            value: function value() {
                return this.props.children || null;
            }
        },
        {
            key: "_bindEvents",
            value: function value() {
                var _$e = this;
                if (d) {
                    var t = this.props, n = t.element, _$o = t.events, _$r = t.passive, _$i = t.capture;
                    this.eventsBound || (_$o.forEach(function(t) {
                        n.addEventListener(t, _$e._handleEvent, {
                            capture: _$i,
                            passive: _$r
                        });
                    }), this.eventsBound = !0);
                }
            }
        },
        {
            key: "_unbindEvents",
            value: function value() {
                var _$e = this, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (d) {
                    var n = this.props, _$o = n.element, _$r = n.events, _$i = n.passive, u = n.capture;
                    (this.eventsBound || t) && (_$r.forEach(function(t) {
                        _$o.removeEventListener(t, _$e._handleEvent, {
                            capture: u,
                            passive: _$i
                        });
                    }), this.eventsBound = !1);
                }
            }
        },
        {
            key: "_toggleIdleState",
            value: function value(e) {
                var t = this;
                this.setState(function(e) {
                    return {
                        idle: !e.idle
                    };
                }, function() {
                    var n = t.props, _$o = n.onActive, _$r = n.onIdle, _$i = n.stopOnIdle;
                    t.state.idle ? (_$i && (clearTimeout(t.tId), t.tId = null, t._unbindEvents()), _$r(e)) : _$i || (t._bindEvents(), _$o(e));
                });
            }
        },
        {
            key: "_handleEvent",
            value: function value(e) {
                var t = this.state, n = t.remaining, _$o = t.pageX, _$r = t.pageY, _$i = t.idle, u = this.props, c = u.timeout, s = u.stopOnIdle;
                if (this._onAction(e), !n) {
                    if ("mousemove" === e.type) {
                        if (e.pageX === _$o && e.pageY === _$r) return;
                        if (void 0 === e.pageX && void 0 === e.pageY) return;
                        if (this.getElapsedTime() < 200) return;
                    }
                    clearTimeout(this.tId), this.tId = null;
                    var _$a = +new Date - this.getLastActiveTime();
                    (_$i && !s || !_$i && _$a > c) && this._toggleIdleState(e), this.setState({
                        lastActive: +new Date,
                        pageX: e.pageX,
                        pageY: e.pageY
                    }), _$i && s || (this.tId = setTimeout(this._toggleIdleState, c));
                }
            }
        },
        {
            key: "reset",
            value: function value() {
                clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
                    idle: !1,
                    oldDate: +new Date,
                    lastActive: +new Date,
                    remaining: null
                });
                var _$e = this.props.timeout;
                this.tId = setTimeout(this._toggleIdleState, _$e);
            }
        },
        {
            key: "pause",
            value: function value() {
                null === this.state.remaining && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.setState({
                    remaining: this.getRemainingTime()
                }));
            }
        },
        {
            key: "resume",
            value: function value() {
                var _$e = this.state, t = _$e.remaining, n = _$e.idle;
                null !== t && (this._bindEvents(), n || (this.tId = setTimeout(this._toggleIdleState, t), this.setState({
                    remaining: null,
                    lastActive: +new Date
                })));
            }
        },
        {
            key: "getRemainingTime",
            value: function value() {
                var _$e = this.state, t = _$e.remaining, n = _$e.lastActive, _$o = this.props.timeout;
                if (null !== t) return t < 0 ? 0 : t;
                var _$r = _$o - (+new Date - n);
                return _$r < 0 ? 0 : _$r;
            }
        },
        {
            key: "getElapsedTime",
            value: function value() {
                var _$e = this.state.oldDate;
                return +new Date - _$e;
            }
        },
        {
            key: "getLastActiveTime",
            value: function value() {
                return this.state.lastActive;
            }
        },
        {
            key: "isIdle",
            value: function value() {
                return this.state.idle;
            }
        }
    ], i(n.prototype, _$o), _$r && i(n, _$r), a;
}();
function b() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$o = e.timeout, _$r = void 0 === _$o ? 12e5 : _$o, i = e.element, u = void 0 === i ? f : i, c = e.events, s = void 0 === c ? v : c, a = e.onIdle, l = void 0 === a ? function l() {} : a, m = e.onActive, _$b = void 0 === m ? function b() {} : m, g = e.onAction, y = void 0 === g ? function y() {} : g, T = e.debounce, w = void 0 === T ? 0 : T, _ = e.throttle, A = void 0 === _ ? 0 : _, I = e.eventsThrottle, E = void 0 === I ? 200 : I, O = e.startOnMount, D = void 0 === O || O, S = e.stopOnIdle, k = void 0 !== S && S, M = e.capture, R = void 0 === M || M, j = e.passive, P = void 0 === j || j, L = (0, _react.useRef)(!1), X = (0, _react.useRef)(!0), Y = (0, _react.useRef)(+new Date), B = (0, _react.useRef)(+new Date), x = (0, _react.useRef)(null), U = (0, _react.useRef)(null), W = (0, _react.useRef)(null), C = (0, _react.useRef)(null), q = (0, _react.useRef)(l), z = (0, _react.useRef)(_$b), F = (0, _react.useRef)(y), G = function G(e) {
        var _$t = !X.current;
        X.current = _$t, _$t ? (k && (clearTimeout(C.current), C.current = null, K()), q.current(e)) : k || (J(), z.current(e));
    }, H = function H(e) {
        if (F.current(e), !x.current) {
            if ("mousemove" === e.type) {
                if (e.pageX === U && e.pageY === W) return;
                if (void 0 === e.pageX && void 0 === e.pageY) return;
                if (Q() < 200) return;
            }
            clearTimeout(C.current), C.current = null;
            var _$t = +new Date - V();
            (X.current && !k || !X.current && _$t > _$r) && G(e), B.current = +new Date, U.current = e.pageX, W.current = e.pageY, X.current && k || (C.current = setTimeout(G, _$r));
        }
    }, J = function J() {
        d && (L.current || (s.forEach(function(e) {
            u.addEventListener(e, H, {
                capture: R,
                passive: P
            });
        }), L.current = !0));
    }, K = function K() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        d && (L.current || e) && (s.forEach(function(e) {
            u.removeEventListener(e, H, {
                capture: R,
                passive: P
            });
        }), L.current = !1);
    }, N = function N() {
        if (null !== x.current) return x.current < 0 ? 0 : x.current;
        var e = _$r - (+new Date - B.current);
        return e < 0 ? 0 : e;
    }, Q = function Q() {
        return +new Date - Y.current;
    }, V = function V() {
        return B.current;
    }, Z = function Z() {
        return X.current;
    }, $ = function $() {
        clearTimeout(C.current), C.current = null, J(), X.current = !1, Y.current = +new Date, B.current = +new Date, x.current = null, C.current = setTimeout(G, _$r);
    }, ee = function ee() {
        null === x.current && (K(), clearTimeout(C.current), C.current = null, x.current = N());
    }, te = function te() {
        null !== x.current && (J(), X.current || (C.current = setTimeout(G, x.current), x.current = null, B.current = +new Date));
    };
    return (0, _react.useEffect)(function() {
        if (w > 0 && A > 0) throw new Error("onAction can either be throttled or debounced (not both)");
        return E > 0 && (H = h(H, E)), J(), D && $(), function() {
            clearTimeout(C.current), K(!0);
        };
    }, []), (0, _react.useEffect)(function() {
        q.current = l;
    }, [
        l
    ]), (0, _react.useEffect)(function() {
        z.current = _$b;
    }, [
        _$b
    ]), (0, _react.useEffect)(function() {
        F.current = w > 0 ? p(y, w) : A > 0 ? h(y, A) : y;
    }, [
        y
    ]), {
        isIdle: Z,
        pause: ee,
        reset: $,
        resume: te,
        getLastActiveTime: V,
        getElapsedTime: Q,
        getRemainingTime: N
    };
}
m.propTypes = {
    timeout: (0, _propTypesDefault.default).number,
    events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    onIdle: (0, _propTypesDefault.default).func,
    onActive: (0, _propTypesDefault.default).func,
    onAction: (0, _propTypesDefault.default).func,
    debounce: (0, _propTypesDefault.default).number,
    throttle: (0, _propTypesDefault.default).number,
    eventsThrottle: (0, _propTypesDefault.default).number,
    element: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).element
    ]),
    startOnMount: (0, _propTypesDefault.default).bool,
    stopOnIdle: (0, _propTypesDefault.default).bool,
    passive: (0, _propTypesDefault.default).bool,
    capture: (0, _propTypesDefault.default).bool
}, m.defaultProps = {
    timeout: 12e5,
    element: f,
    events: v,
    onIdle: function onIdle() {},
    onActive: function onActive() {},
    onAction: function onAction() {},
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    startOnMount: !0,
    stopOnIdle: !1,
    capture: !0,
    passive: !0
}, b.propTypes = {
    timeout: (0, _propTypesDefault.default).number,
    events: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    onIdle: (0, _propTypesDefault.default).func,
    onActive: (0, _propTypesDefault.default).func,
    onAction: (0, _propTypesDefault.default).func,
    debounce: (0, _propTypesDefault.default).number,
    throttle: (0, _propTypesDefault.default).number,
    eventsThrottle: (0, _propTypesDefault.default).number,
    element: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).element
    ]),
    startOnMount: (0, _propTypesDefault.default).bool,
    stopOnIdle: (0, _propTypesDefault.default).bool,
    passive: (0, _propTypesDefault.default).bool,
    capture: (0, _propTypesDefault.default).bool
}, b.defaultProps = {
    timeout: 12e5,
    element: f,
    events: v,
    onIdle: function onIdle() {},
    onActive: function onActive() {},
    onAction: function onAction() {},
    debounce: 0,
    throttle: 0,
    eventsThrottle: 200,
    startOnMount: !0,
    stopOnIdle: !1,
    capture: !0,
    passive: !0
};
exports.default = m;

},{"@swc/helpers/_/_type_of":"6Gp9n","react":"ktQNc","prop-types":"8INHm","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"hr8si":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return LoginFailed;
});
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _permafrost = require("@indico-data/permafrost");
var _loginFailedStyles = require("./LoginFailed.styles");
function LoginFailed() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginFailedStyles.StyledLoginFailed), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Section), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.SectionBody), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _permafrost.Shrug), {
                    message: "Looks like our system failed to verify you.",
                    buttonAction: function() {
                        return window.location.reload();
                    },
                    buttonText: "Refresh"
                })
            })
        })
    });
}

},{"react/jsx-runtime":"gJK5Y","react":"ktQNc","@indico-data/permafrost":"j9IVt","./LoginFailed.styles":"6DqWX","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"6DqWX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledLoginFailed", function() {
    return StyledLoginFailed;
});
var _taggedTemplateLiteral = require("@swc/helpers/_/_tagged_template_literal");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _permafrost = require("@indico-data/permafrost");
function _templateObject() {
    var data = (0, _taggedTemplateLiteral._)([
        "\n  padding: 20px 10px;\n\n  @media ",
        " {\n    padding: 60px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLoginFailed = (0, _styledComponentsDefault.default).div(_templateObject(), (0, _permafrost.MEDIA_QUERIES).mediumScreen);

},{"@swc/helpers/_/_tagged_template_literal":"9gf6S","styled-components":"6Gjjc","@indico-data/permafrost":"j9IVt","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"kLuzQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _appStore = require("root/store/appStore");
var appStoreSelector = function(state) {
    return {
        previousLocation: state.previousLocation,
        currentLocation: state.currentLocation
    };
};
var AppRoute = function(props) {
    var _window_indico;
    var Component = props.component;
    var _useAppStore = (0, _appStore.useAppStore)(appStoreSelector), previousLocation = _useAppStore.previousLocation, currentLocation = _useAppStore.currentLocation;
    if (!(currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.pathname) && !(previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname) || //initial render of login page
    (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.pathname) !== (previousLocation === null || previousLocation === void 0 ? void 0 : previousLocation.pathname) && ((_window_indico = window.indico) === null || _window_indico === void 0 ? void 0 : _window_indico.appcuesAccountId)) {
        var _window_Appcues, _window_Appcues1;
        (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.page();
        (_window_Appcues1 = window.Appcues) === null || _window_Appcues1 === void 0 ? void 0 : _window_Appcues1.identify("unknownUser", {
            id: 0
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        render: function(props) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _objectSpread._)({}, props));
        }
    }));
};
exports.default = (0, _reactRouterDom.withRouter)(AppRoute);

},{"@swc/helpers/_/_object_spread":"6U9Ts","@swc/helpers/_/_object_spread_props":"1YBoU","react/jsx-runtime":"gJK5Y","react":"ktQNc","react-router-dom":"6Au42","root/store/appStore":"iLlB2","@parcel/transformer-js/src/esmodule-helpers.js":"lOeCi"}],"gBmt8":[function(require,module,exports) {
module.exports = require("c5593c7adfc47025")(require("4b34cbecc071c9e4").resolve("7toSX")).then(function() {
    return module.bundle.root("85FC8");
});

},{"c5593c7adfc47025":"fa1vK","4b34cbecc071c9e4":"2yiuB"}],"fa1vK":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"9FbxK"}],"9FbxK":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"dBydK":[function(require,module,exports) {
module.exports = require("97628eafbb8770ec")(require("afbb872472d9dfd7").resolve("7ypJH")).then(function() {
    return module.bundle.root("7N6IS");
});

},{"97628eafbb8770ec":"fa1vK","afbb872472d9dfd7":"2yiuB"}],"j1vQe":[function(require,module,exports) {
module.exports = require("dad5d12e843d0641")(require("6da4ff2561d1f65f").resolve("d59zn")).then(function() {
    return module.bundle.root("2VXC1");
});

},{"dad5d12e843d0641":"fa1vK","6da4ff2561d1f65f":"2yiuB"}],"fQALY":[function(require,module,exports) {
module.exports = Promise.all([
    require("e06d29d09b8c0fee")(require("fb3710c1d41972f2").resolve("4ArSj")),
    require("e06d29d09b8c0fee")(require("fb3710c1d41972f2").resolve("9LmwR"))
]).then(function() {
    return module.bundle.root("5At0V");
});

},{"e06d29d09b8c0fee":"fa1vK","fb3710c1d41972f2":"2yiuB"}],"fZYtY":[function(require,module,exports) {
module.exports = require("45ce2ac00683be86")(require("424efe6e4032f678").resolve("faPhe")).then(function() {
    return module.bundle.root("Q4893");
});

},{"45ce2ac00683be86":"fa1vK","424efe6e4032f678":"2yiuB"}],"3Q43k":[function(require,module,exports) {
module.exports = require("4d176cd08a3e1d6d")(require("d7ca2cc289b8eb04").resolve("4TXql")).then(function() {
    return module.bundle.root("eur87");
});

},{"4d176cd08a3e1d6d":"fa1vK","d7ca2cc289b8eb04":"2yiuB"}],"jjsOU":[function(require,module,exports) {
module.exports = require("568881f97a1c373c")(require("85e637d71a8fa756").resolve("gZvrp")).then(function() {
    return module.bundle.root("3x4Bl");
});

},{"568881f97a1c373c":"fa1vK","85e637d71a8fa756":"2yiuB"}],"eLzAO":[function(require,module,exports) {
module.exports = require("ec89823d0708f5c7")(require("563ce7e4e23dc1a9").resolve("arEOJ")).then(function() {
    return module.bundle.root("409e3");
});

},{"ec89823d0708f5c7":"fa1vK","563ce7e4e23dc1a9":"2yiuB"}],"9idVM":[function(require,module,exports) {
module.exports = require("3eb7331af350474f")(require("a3d3023b31dd677").resolve("1GtTv")).then(function() {
    return module.bundle.root("kjnuo");
});

},{"3eb7331af350474f":"fa1vK","a3d3023b31dd677":"2yiuB"}],"eBNJK":[function(require,module,exports) {
module.exports = Promise.all([
    require("7d07ac3643ebf6e8")(require("6826ac927730637c").resolve("7MLCI")),
    require("7d07ac3643ebf6e8")(require("6826ac927730637c").resolve("4ArSj")),
    require("7d07ac3643ebf6e8")(require("6826ac927730637c").resolve("5wZjF"))
]).then(function() {
    return module.bundle.root("gnv0L");
});

},{"7d07ac3643ebf6e8":"fa1vK","6826ac927730637c":"2yiuB"}],"jFpF1":[function(require,module,exports) {
module.exports = Promise.all([
    require("34c030aa555e2a50")(require("25971cf4117b6fc4").resolve("cyX69")),
    require("34c030aa555e2a50")(require("25971cf4117b6fc4").resolve("3YNlu")),
    require("34c030aa555e2a50")(require("25971cf4117b6fc4").resolve("015Rs"))
]).then(function() {
    return module.bundle.root("h3FhW");
});

},{"34c030aa555e2a50":"fa1vK","25971cf4117b6fc4":"2yiuB"}],"aMH8r":[function(require,module,exports) {
module.exports = Promise.all([
    require("cb519635e812adeb")(require("aa70507f485cd0d6").resolve("aWsl6")),
    require("cb519635e812adeb")(require("aa70507f485cd0d6").resolve("cyX69")),
    require("cb519635e812adeb")(require("aa70507f485cd0d6").resolve("1EMmz"))
]).then(function() {
    return module.bundle.root("4dBWt");
});

},{"cb519635e812adeb":"fa1vK","aa70507f485cd0d6":"2yiuB"}],"f4uAX":[function(require,module,exports) {
module.exports = Promise.all([
    require("b009dc2b2fe6ea4f")(require("4ee4bab7a4ac920a").resolve("aWsl6")),
    require("b009dc2b2fe6ea4f")(require("4ee4bab7a4ac920a").resolve("cAMQi"))
]).then(function() {
    return module.bundle.root("dJOeV");
});

},{"b009dc2b2fe6ea4f":"fa1vK","4ee4bab7a4ac920a":"2yiuB"}],"lh7MN":[function(require,module,exports) {
module.exports = require("ec8414f0ec9b83a6")(require("d34905a2f5f96f72").resolve("l4xBs")).then(function() {
    return module.bundle.root("9gC5S");
});

},{"ec8414f0ec9b83a6":"fa1vK","d34905a2f5f96f72":"2yiuB"}],"g7rOv":[function(require,module,exports) {
module.exports = require("ed359d61da0e72b4")(require("cb556634cd32f5e0").resolve("iIiw4")).then(function() {
    return module.bundle.root("jkPaM");
});

},{"ed359d61da0e72b4":"fa1vK","cb556634cd32f5e0":"2yiuB"}],"ewoNv":[function(require,module,exports) {
module.exports = Promise.all([
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("2HWCT")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("gvUqt")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("6erLm")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("aWsl6")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("cyX69")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("7MLCI")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("4ArSj")),
    require("3e7db70ff53f6d37")(require("4512302c7a602e37").resolve("1Rk1O"))
]).then(function() {
    return module.bundle.root("3cXIg");
});

},{"3e7db70ff53f6d37":"fa1vK","4512302c7a602e37":"2yiuB"}],"1hxnx":[function(require,module,exports) {
module.exports = Promise.all([
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("7FZdG")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("jvJEO")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("dv5TK")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("3AmuR")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("dc5JR")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("2HWCT")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("gvUqt")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("6erLm")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("aWsl6")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("cyX69")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("7MLCI")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("4ArSj")),
    require("86d3b20d9f22d9b")(require("791674e47fe4c587").resolve("kWPXJ"))
]).then(function() {
    return module.bundle.root("3LkfJ");
});

},{"86d3b20d9f22d9b":"fa1vK","791674e47fe4c587":"2yiuB"}],"3suU0":[function(require,module,exports) {
module.exports = Promise.all([
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("7FZdG")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("jvJEO")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("dv5TK")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("3AmuR")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("dc5JR")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("2HWCT")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("gvUqt")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("6erLm")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("aWsl6")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("cyX69")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("7MLCI")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("4ArSj")),
    require("6d58f39530ca9a8f")(require("2e34078092569e48").resolve("emyFz"))
]).then(function() {
    return module.bundle.root("baGgh");
});

},{"6d58f39530ca9a8f":"fa1vK","2e34078092569e48":"2yiuB"}],"lTNDg":[function(require,module,exports) {
module.exports = Promise.all([
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("4UDB2")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("jvJEO")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("dv5TK")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("2HWCT")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("gvUqt")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("6erLm")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("aWsl6")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("cyX69")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("7MLCI")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("4ArSj")),
    require("d41a6c7b78a94645")(require("2028fa7450cf4dd0").resolve("cNumd"))
]).then(function() {
    return module.bundle.root("9wZQN");
});

},{"d41a6c7b78a94645":"fa1vK","2028fa7450cf4dd0":"2yiuB"}],"hoK5v":[function(require,module,exports) {
module.exports = Promise.all([
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("iSsDA")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("3YW4J")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("4UDB2")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("7FZdG")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("jvJEO")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("dv5TK")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("2HWCT")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("gvUqt")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("6erLm")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("aWsl6")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("cyX69")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("7MLCI")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("4ArSj")),
    require("877ccd3bf772928f")(require("f1d1ba054e4a8a56").resolve("eDtjD"))
]).then(function() {
    return module.bundle.root("crkAO");
});

},{"877ccd3bf772928f":"fa1vK","f1d1ba054e4a8a56":"2yiuB"}],"9crnz":[function(require,module,exports) {
module.exports = Promise.all([
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("iSsDA")),
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("3YW4J")),
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("4UDB2")),
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("6erLm")),
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("cyX69")),
    require("697ca12744c73b25")(require("688f65af79b90def").resolve("fynPD"))
]).then(function() {
    return module.bundle.root("1HQQd");
});

},{"697ca12744c73b25":"fa1vK","688f65af79b90def":"2yiuB"}],"2p4O0":[function(require,module,exports) {
module.exports = Promise.all([
    require("ca002be9f8318689")(require("be33e4502e23730c").resolve("cyX69")),
    require("ca002be9f8318689")(require("be33e4502e23730c").resolve("3YNlu")),
    require("ca002be9f8318689")(require("be33e4502e23730c").resolve("eWEOq"))
]).then(function() {
    return module.bundle.root("7M6DU");
});

},{"ca002be9f8318689":"fa1vK","be33e4502e23730c":"2yiuB"}],"r6scZ":[function(require,module,exports) {
module.exports = Promise.all([
    require("8684fd5ad7e0e17b")(require("50dbf07ceea70801").resolve("3YW4J")),
    require("8684fd5ad7e0e17b")(require("50dbf07ceea70801").resolve("aWsl6")),
    require("8684fd5ad7e0e17b")(require("50dbf07ceea70801").resolve("4ArSj")),
    require("8684fd5ad7e0e17b")(require("50dbf07ceea70801").resolve("9R9NG"))
]).then(function() {
    return module.bundle.root("hmzZ4");
});

},{"8684fd5ad7e0e17b":"fa1vK","50dbf07ceea70801":"2yiuB"}],"7G7F0":[function(require,module,exports) {
module.exports = require("ac21bcf0e4826928")(require("fc9a7229d2118e3f").resolve("72L0Q")).then(function() {
    return module.bundle.root("4f1HN");
});

},{"ac21bcf0e4826928":"fa1vK","fc9a7229d2118e3f":"2yiuB"}],"9bTTB":[function(require,module,exports) {
module.exports = Promise.all([
    require("2adfc58238d055d2")(require("75250798715fe92b").resolve("8OA2V")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("jTMf2")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("jvJEO")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("3AmuR")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("6erLm")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("aWsl6")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("cyX69")),
    require("d1749543641559a4")(require("75250798715fe92b").resolve("jrw8h"))
]).then(function() {
    return module.bundle.root("8zycQ");
});

},{"2adfc58238d055d2":"fQP04","75250798715fe92b":"2yiuB","d1749543641559a4":"fa1vK"}],"fQP04":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"9FbxK"}],"e5OjE":[function(require,module,exports) {
module.exports = Promise.all([
    require("989aca8a2da8a1a9")(require("ffa1f0f31e531e78").resolve("8OA2V")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("jTMf2")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("jvJEO")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("3AmuR")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("6erLm")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("aWsl6")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("cyX69")),
    require("58e5e2d9520a6e09")(require("ffa1f0f31e531e78").resolve("cjBhy"))
]).then(function() {
    return module.bundle.root("04WlB");
});

},{"989aca8a2da8a1a9":"fQP04","ffa1f0f31e531e78":"2yiuB","58e5e2d9520a6e09":"fa1vK"}],"l0fIy":[function(require,module,exports) {
module.exports = Promise.all([
    require("1d2ab5d8799b24c5")(require("6efe7d7f804e05d2").resolve("8OA2V")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("jTMf2")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("jvJEO")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("3AmuR")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("6erLm")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("aWsl6")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("cyX69")),
    require("c676238d2786a627")(require("6efe7d7f804e05d2").resolve("2Z3Z9"))
]).then(function() {
    return module.bundle.root("8tJ15");
});

},{"1d2ab5d8799b24c5":"fQP04","6efe7d7f804e05d2":"2yiuB","c676238d2786a627":"fa1vK"}],"5JL78":[function(require,module,exports) {
module.exports = Promise.all([
    require("78abb775171a97e4")(require("971da1932c5878e6").resolve("8OA2V")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("jTMf2")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("jvJEO")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("3AmuR")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("6erLm")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("aWsl6")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("cyX69")),
    require("2d84b497345abca0")(require("971da1932c5878e6").resolve("kJ0sc"))
]).then(function() {
    return module.bundle.root("19tik");
});

},{"78abb775171a97e4":"fQP04","971da1932c5878e6":"2yiuB","2d84b497345abca0":"fa1vK"}],"aXBZ8":[function(require,module,exports) {
module.exports = require("4fe711cb5c967302")(require("feeb9e931ee9da66").resolve("5anOP")).then(function() {
    return module.bundle.root("jNflj");
});

},{"4fe711cb5c967302":"fa1vK","feeb9e931ee9da66":"2yiuB"}],"bFiFu":[function(require,module,exports) {
module.exports = Promise.all([
    require("a3a15d50665aa4fc")(require("985ad700d636528c").resolve("2HWCT")),
    require("a3a15d50665aa4fc")(require("985ad700d636528c").resolve("7JbLF"))
]).then(function() {
    return module.bundle.root("gyUdW");
});

},{"a3a15d50665aa4fc":"fa1vK","985ad700d636528c":"2yiuB"}],"ljRvW":[function(require,module,exports) {
module.exports = Promise.all([
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("h2Rtl")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("iSsDA")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("2HWCT")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("gvUqt")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("6erLm")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("aWsl6")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("cyX69")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("7MLCI")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("4ArSj")),
    require("157928237f787e37")(require("ecd94c7c65ca2f89").resolve("a6sen"))
]).then(function() {
    return module.bundle.root("dmszA");
});

},{"157928237f787e37":"fa1vK","ecd94c7c65ca2f89":"2yiuB"}],"ZXImQ":[function(require,module,exports) {
module.exports = require("d0c87050d51b3ed3")(require("31845adb44b28985").resolve("35Qrf")).then(function() {
    return module.bundle.root("jM41V");
});

},{"d0c87050d51b3ed3":"fa1vK","31845adb44b28985":"2yiuB"}],"8EZt5":[function(require,module,exports) {
module.exports = Promise.all([
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("iSsDA")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("2HWCT")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("6erLm")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("cyX69")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("7MLCI")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("4ArSj")),
    require("4a0ac01e90a9287e")(require("c44fef09c0283940").resolve("gSeeH"))
]).then(function() {
    return module.bundle.root("jzxDJ");
});

},{"4a0ac01e90a9287e":"fa1vK","c44fef09c0283940":"2yiuB"}],"b4rDH":[function(require,module,exports) {
module.exports = Promise.all([
    require("fda3efee118a26a4")(require("3ad11298173bb86e").resolve("h2Rtl")),
    require("fda3efee118a26a4")(require("3ad11298173bb86e").resolve("bHZfw"))
]).then(function() {
    return module.bundle.root("c5Nu1");
});

},{"fda3efee118a26a4":"fa1vK","3ad11298173bb86e":"2yiuB"}],"bunXd":[function(require,module,exports) {
module.exports = require("c7bcf88d9c5e76a4")(require("dcb0847b8c22b1be").resolve("aeRor")).then(function() {
    return module.bundle.root("gr9sK");
});

},{"c7bcf88d9c5e76a4":"fa1vK","dcb0847b8c22b1be":"2yiuB"}]},["klemY"], "klemY", "parcelRequiredc43")

//# sourceMappingURL=index.4bf6fd5f.js.map
